function ih(s) {
  return s && s.__esModule && Object.prototype.hasOwnProperty.call(s, "default") ? s.default : s;
}
var jn = {}, Cl;
function dg() {
  return Cl || (Cl = 1, function(s) {
    var t = /* @__PURE__ */ function() {
      var o = /* @__PURE__ */ new Date(), c = 4, d = 3, _ = 2, y = 1, v = c, b = {
        setLogLevel: function(w) {
          w == this.debug ? v = y : w == this.info ? v = _ : w == this.warn ? v = d : (w == this.error, v = c);
        },
        debug: function(w, S) {
          console.debug === void 0 && (console.debug = console.log), y >= v && console.debug("[" + t.getDurationString(/* @__PURE__ */ new Date() - o, 1e3) + "]", "[" + w + "]", S);
        },
        log: function(w, S) {
          this.debug(w.msg);
        },
        info: function(w, S) {
          _ >= v && console.info("[" + t.getDurationString(/* @__PURE__ */ new Date() - o, 1e3) + "]", "[" + w + "]", S);
        },
        warn: function(w, S) {
          d >= v && console.warn("[" + t.getDurationString(/* @__PURE__ */ new Date() - o, 1e3) + "]", "[" + w + "]", S);
        },
        error: function(w, S) {
          c >= v && console.error("[" + t.getDurationString(/* @__PURE__ */ new Date() - o, 1e3) + "]", "[" + w + "]", S);
        }
      };
      return b;
    }();
    t.getDurationString = function(o, c) {
      var d;
      function _(T, E) {
        for (var C = "" + T, M = C.split("."); M[0].length < E; )
          M[0] = "0" + M[0];
        return M.join(".");
      }
      o < 0 ? (d = !0, o = -o) : d = !1;
      var y = c || 1, v = o / y, b = Math.floor(v / 3600);
      v -= b * 3600;
      var w = Math.floor(v / 60);
      v -= w * 60;
      var S = v * 1e3;
      return v = Math.floor(v), S -= v * 1e3, S = Math.floor(S), (d ? "-" : "") + b + ":" + _(w, 2) + ":" + _(v, 2) + "." + _(S, 3);
    }, t.printRanges = function(o) {
      var c = o.length;
      if (c > 0) {
        for (var d = "", _ = 0; _ < c; _++)
          _ > 0 && (d += ","), d += "[" + t.getDurationString(o.start(_)) + "," + t.getDurationString(o.end(_)) + "]";
        return d;
      } else
        return "(empty)";
    }, s.Log = t;
    var e = function(o) {
      if (o instanceof ArrayBuffer)
        this.buffer = o, this.dataview = new DataView(o);
      else
        throw "Needs an array buffer";
      this.position = 0;
    };
    e.prototype.getPosition = function() {
      return this.position;
    }, e.prototype.getEndPosition = function() {
      return this.buffer.byteLength;
    }, e.prototype.getLength = function() {
      return this.buffer.byteLength;
    }, e.prototype.seek = function(o) {
      var c = Math.max(0, Math.min(this.buffer.byteLength, o));
      return this.position = isNaN(c) || !isFinite(c) ? 0 : c, !0;
    }, e.prototype.isEos = function() {
      return this.getPosition() >= this.getEndPosition();
    }, e.prototype.readAnyInt = function(o, c) {
      var d = 0;
      if (this.position + o <= this.buffer.byteLength) {
        switch (o) {
          case 1:
            c ? d = this.dataview.getInt8(this.position) : d = this.dataview.getUint8(this.position);
            break;
          case 2:
            c ? d = this.dataview.getInt16(this.position) : d = this.dataview.getUint16(this.position);
            break;
          case 3:
            if (c)
              throw "No method for reading signed 24 bits values";
            d = this.dataview.getUint8(this.position) << 16, d |= this.dataview.getUint8(this.position + 1) << 8, d |= this.dataview.getUint8(this.position + 2);
            break;
          case 4:
            c ? d = this.dataview.getInt32(this.position) : d = this.dataview.getUint32(this.position);
            break;
          case 8:
            if (c)
              throw "No method for reading signed 64 bits values";
            d = this.dataview.getUint32(this.position) << 32, d |= this.dataview.getUint32(this.position + 4);
            break;
          default:
            throw "readInt method not implemented for size: " + o;
        }
        return this.position += o, d;
      } else
        throw "Not enough bytes in buffer";
    }, e.prototype.readUint8 = function() {
      return this.readAnyInt(1, !1);
    }, e.prototype.readUint16 = function() {
      return this.readAnyInt(2, !1);
    }, e.prototype.readUint24 = function() {
      return this.readAnyInt(3, !1);
    }, e.prototype.readUint32 = function() {
      return this.readAnyInt(4, !1);
    }, e.prototype.readUint64 = function() {
      return this.readAnyInt(8, !1);
    }, e.prototype.readString = function(o) {
      if (this.position + o <= this.buffer.byteLength) {
        for (var c = "", d = 0; d < o; d++)
          c += String.fromCharCode(this.readUint8());
        return c;
      } else
        throw "Not enough bytes in buffer";
    }, e.prototype.readCString = function() {
      for (var o = []; ; ) {
        var c = this.readUint8();
        if (c !== 0)
          o.push(c);
        else
          break;
      }
      return String.fromCharCode.apply(null, o);
    }, e.prototype.readInt8 = function() {
      return this.readAnyInt(1, !0);
    }, e.prototype.readInt16 = function() {
      return this.readAnyInt(2, !0);
    }, e.prototype.readInt32 = function() {
      return this.readAnyInt(4, !0);
    }, e.prototype.readInt64 = function() {
      return this.readAnyInt(8, !1);
    }, e.prototype.readUint8Array = function(o) {
      for (var c = new Uint8Array(o), d = 0; d < o; d++)
        c[d] = this.readUint8();
      return c;
    }, e.prototype.readInt16Array = function(o) {
      for (var c = new Int16Array(o), d = 0; d < o; d++)
        c[d] = this.readInt16();
      return c;
    }, e.prototype.readUint16Array = function(o) {
      for (var c = new Int16Array(o), d = 0; d < o; d++)
        c[d] = this.readUint16();
      return c;
    }, e.prototype.readUint32Array = function(o) {
      for (var c = new Uint32Array(o), d = 0; d < o; d++)
        c[d] = this.readUint32();
      return c;
    }, e.prototype.readInt32Array = function(o) {
      for (var c = new Int32Array(o), d = 0; d < o; d++)
        c[d] = this.readInt32();
      return c;
    }, s.MP4BoxStream = e;
    var r = function(o, c, d) {
      this._byteOffset = c || 0, o instanceof ArrayBuffer ? this.buffer = o : typeof o == "object" ? (this.dataView = o, c && (this._byteOffset += c)) : this.buffer = new ArrayBuffer(o || 0), this.position = 0, this.endianness = d ?? r.LITTLE_ENDIAN;
    };
    r.prototype = {}, r.prototype.getPosition = function() {
      return this.position;
    }, r.prototype._realloc = function(o) {
      if (this._dynamicSize) {
        var c = this._byteOffset + this.position + o, d = this._buffer.byteLength;
        if (c <= d) {
          c > this._byteLength && (this._byteLength = c);
          return;
        }
        for (d < 1 && (d = 1); c > d; )
          d *= 2;
        var _ = new ArrayBuffer(d), y = new Uint8Array(this._buffer), v = new Uint8Array(_, 0, y.length);
        v.set(y), this.buffer = _, this._byteLength = c;
      }
    }, r.prototype._trimAlloc = function() {
      if (this._byteLength != this._buffer.byteLength) {
        var o = new ArrayBuffer(this._byteLength), c = new Uint8Array(o), d = new Uint8Array(this._buffer, 0, c.length);
        c.set(d), this.buffer = o;
      }
    }, r.BIG_ENDIAN = !1, r.LITTLE_ENDIAN = !0, r.prototype._byteLength = 0, Object.defineProperty(
      r.prototype,
      "byteLength",
      { get: function() {
        return this._byteLength - this._byteOffset;
      } }
    ), Object.defineProperty(
      r.prototype,
      "buffer",
      {
        get: function() {
          return this._trimAlloc(), this._buffer;
        },
        set: function(o) {
          this._buffer = o, this._dataView = new DataView(this._buffer, this._byteOffset), this._byteLength = this._buffer.byteLength;
        }
      }
    ), Object.defineProperty(
      r.prototype,
      "byteOffset",
      {
        get: function() {
          return this._byteOffset;
        },
        set: function(o) {
          this._byteOffset = o, this._dataView = new DataView(this._buffer, this._byteOffset), this._byteLength = this._buffer.byteLength;
        }
      }
    ), Object.defineProperty(
      r.prototype,
      "dataView",
      {
        get: function() {
          return this._dataView;
        },
        set: function(o) {
          this._byteOffset = o.byteOffset, this._buffer = o.buffer, this._dataView = new DataView(this._buffer, this._byteOffset), this._byteLength = this._byteOffset + o.byteLength;
        }
      }
    ), r.prototype.seek = function(o) {
      var c = Math.max(0, Math.min(this.byteLength, o));
      this.position = isNaN(c) || !isFinite(c) ? 0 : c;
    }, r.prototype.isEof = function() {
      return this.position >= this._byteLength;
    }, r.prototype.mapUint8Array = function(o) {
      this._realloc(o * 1);
      var c = new Uint8Array(this._buffer, this.byteOffset + this.position, o);
      return this.position += o * 1, c;
    }, r.prototype.readInt32Array = function(o, c) {
      o = o ?? this.byteLength - this.position / 4;
      var d = new Int32Array(o);
      return r.memcpy(
        d.buffer,
        0,
        this.buffer,
        this.byteOffset + this.position,
        o * d.BYTES_PER_ELEMENT
      ), r.arrayToNative(d, c ?? this.endianness), this.position += d.byteLength, d;
    }, r.prototype.readInt16Array = function(o, c) {
      o = o ?? this.byteLength - this.position / 2;
      var d = new Int16Array(o);
      return r.memcpy(
        d.buffer,
        0,
        this.buffer,
        this.byteOffset + this.position,
        o * d.BYTES_PER_ELEMENT
      ), r.arrayToNative(d, c ?? this.endianness), this.position += d.byteLength, d;
    }, r.prototype.readInt8Array = function(o) {
      o = o ?? this.byteLength - this.position;
      var c = new Int8Array(o);
      return r.memcpy(
        c.buffer,
        0,
        this.buffer,
        this.byteOffset + this.position,
        o * c.BYTES_PER_ELEMENT
      ), this.position += c.byteLength, c;
    }, r.prototype.readUint32Array = function(o, c) {
      o = o ?? this.byteLength - this.position / 4;
      var d = new Uint32Array(o);
      return r.memcpy(
        d.buffer,
        0,
        this.buffer,
        this.byteOffset + this.position,
        o * d.BYTES_PER_ELEMENT
      ), r.arrayToNative(d, c ?? this.endianness), this.position += d.byteLength, d;
    }, r.prototype.readUint16Array = function(o, c) {
      o = o ?? this.byteLength - this.position / 2;
      var d = new Uint16Array(o);
      return r.memcpy(
        d.buffer,
        0,
        this.buffer,
        this.byteOffset + this.position,
        o * d.BYTES_PER_ELEMENT
      ), r.arrayToNative(d, c ?? this.endianness), this.position += d.byteLength, d;
    }, r.prototype.readUint8Array = function(o) {
      o = o ?? this.byteLength - this.position;
      var c = new Uint8Array(o);
      return r.memcpy(
        c.buffer,
        0,
        this.buffer,
        this.byteOffset + this.position,
        o * c.BYTES_PER_ELEMENT
      ), this.position += c.byteLength, c;
    }, r.prototype.readFloat64Array = function(o, c) {
      o = o ?? this.byteLength - this.position / 8;
      var d = new Float64Array(o);
      return r.memcpy(
        d.buffer,
        0,
        this.buffer,
        this.byteOffset + this.position,
        o * d.BYTES_PER_ELEMENT
      ), r.arrayToNative(d, c ?? this.endianness), this.position += d.byteLength, d;
    }, r.prototype.readFloat32Array = function(o, c) {
      o = o ?? this.byteLength - this.position / 4;
      var d = new Float32Array(o);
      return r.memcpy(
        d.buffer,
        0,
        this.buffer,
        this.byteOffset + this.position,
        o * d.BYTES_PER_ELEMENT
      ), r.arrayToNative(d, c ?? this.endianness), this.position += d.byteLength, d;
    }, r.prototype.readInt32 = function(o) {
      var c = this._dataView.getInt32(this.position, o ?? this.endianness);
      return this.position += 4, c;
    }, r.prototype.readInt16 = function(o) {
      var c = this._dataView.getInt16(this.position, o ?? this.endianness);
      return this.position += 2, c;
    }, r.prototype.readInt8 = function() {
      var o = this._dataView.getInt8(this.position);
      return this.position += 1, o;
    }, r.prototype.readUint32 = function(o) {
      var c = this._dataView.getUint32(this.position, o ?? this.endianness);
      return this.position += 4, c;
    }, r.prototype.readUint16 = function(o) {
      var c = this._dataView.getUint16(this.position, o ?? this.endianness);
      return this.position += 2, c;
    }, r.prototype.readUint8 = function() {
      var o = this._dataView.getUint8(this.position);
      return this.position += 1, o;
    }, r.prototype.readFloat32 = function(o) {
      var c = this._dataView.getFloat32(this.position, o ?? this.endianness);
      return this.position += 4, c;
    }, r.prototype.readFloat64 = function(o) {
      var c = this._dataView.getFloat64(this.position, o ?? this.endianness);
      return this.position += 8, c;
    }, r.endianness = new Int8Array(new Int16Array([1]).buffer)[0] > 0, r.memcpy = function(o, c, d, _, y) {
      var v = new Uint8Array(o, c, y), b = new Uint8Array(d, _, y);
      v.set(b);
    }, r.arrayToNative = function(o, c) {
      return c == this.endianness ? o : this.flipArrayEndianness(o);
    }, r.nativeToEndian = function(o, c) {
      return this.endianness == c ? o : this.flipArrayEndianness(o);
    }, r.flipArrayEndianness = function(o) {
      for (var c = new Uint8Array(o.buffer, o.byteOffset, o.byteLength), d = 0; d < o.byteLength; d += o.BYTES_PER_ELEMENT)
        for (var _ = d + o.BYTES_PER_ELEMENT - 1, y = d; _ > y; _--, y++) {
          var v = c[y];
          c[y] = c[_], c[_] = v;
        }
      return o;
    }, r.prototype.failurePosition = 0, String.fromCharCodeUint8 = function(o) {
      for (var c = [], d = 0; d < o.length; d++)
        c[d] = o[d];
      return String.fromCharCode.apply(null, c);
    }, r.prototype.readString = function(o, c) {
      return c == null || c == "ASCII" ? String.fromCharCodeUint8.apply(null, [this.mapUint8Array(o ?? this.byteLength - this.position)]) : new TextDecoder(c).decode(this.mapUint8Array(o));
    }, r.prototype.readCString = function(o) {
      var c = this.byteLength - this.position, d = new Uint8Array(this._buffer, this._byteOffset + this.position), _ = c;
      o != null && (_ = Math.min(o, c));
      for (var y = 0; y < _ && d[y] !== 0; y++) ;
      var v = String.fromCharCodeUint8.apply(null, [this.mapUint8Array(y)]);
      return o != null ? this.position += _ - y : y != c && (this.position += 1), v;
    };
    var n = Math.pow(2, 32);
    r.prototype.readInt64 = function() {
      return this.readInt32() * n + this.readUint32();
    }, r.prototype.readUint64 = function() {
      return this.readUint32() * n + this.readUint32();
    }, r.prototype.readInt64 = function() {
      return this.readUint32() * n + this.readUint32();
    }, r.prototype.readUint24 = function() {
      return (this.readUint8() << 16) + (this.readUint8() << 8) + this.readUint8();
    }, s.DataStream = r, r.prototype.save = function(o) {
      var c = new Blob([this.buffer]);
      if (window.URL && URL.createObjectURL) {
        var d = window.URL.createObjectURL(c), _ = document.createElement("a");
        document.body.appendChild(_), _.setAttribute("href", d), _.setAttribute("download", o), _.setAttribute("target", "_self"), _.click(), window.URL.revokeObjectURL(d);
      } else
        throw "DataStream.save: Can't create object URL.";
    }, r.prototype._dynamicSize = !0, Object.defineProperty(
      r.prototype,
      "dynamicSize",
      {
        get: function() {
          return this._dynamicSize;
        },
        set: function(o) {
          o || this._trimAlloc(), this._dynamicSize = o;
        }
      }
    ), r.prototype.shift = function(o) {
      var c = new ArrayBuffer(this._byteLength - o), d = new Uint8Array(c), _ = new Uint8Array(this._buffer, o, d.length);
      d.set(_), this.buffer = c, this.position -= o;
    }, r.prototype.writeInt32Array = function(o, c) {
      if (this._realloc(o.length * 4), o instanceof Int32Array && this.byteOffset + this.position % o.BYTES_PER_ELEMENT === 0)
        r.memcpy(
          this._buffer,
          this.byteOffset + this.position,
          o.buffer,
          0,
          o.byteLength
        ), this.mapInt32Array(o.length, c);
      else
        for (var d = 0; d < o.length; d++)
          this.writeInt32(o[d], c);
    }, r.prototype.writeInt16Array = function(o, c) {
      if (this._realloc(o.length * 2), o instanceof Int16Array && this.byteOffset + this.position % o.BYTES_PER_ELEMENT === 0)
        r.memcpy(
          this._buffer,
          this.byteOffset + this.position,
          o.buffer,
          0,
          o.byteLength
        ), this.mapInt16Array(o.length, c);
      else
        for (var d = 0; d < o.length; d++)
          this.writeInt16(o[d], c);
    }, r.prototype.writeInt8Array = function(o) {
      if (this._realloc(o.length * 1), o instanceof Int8Array && this.byteOffset + this.position % o.BYTES_PER_ELEMENT === 0)
        r.memcpy(
          this._buffer,
          this.byteOffset + this.position,
          o.buffer,
          0,
          o.byteLength
        ), this.mapInt8Array(o.length);
      else
        for (var c = 0; c < o.length; c++)
          this.writeInt8(o[c]);
    }, r.prototype.writeUint32Array = function(o, c) {
      if (this._realloc(o.length * 4), o instanceof Uint32Array && this.byteOffset + this.position % o.BYTES_PER_ELEMENT === 0)
        r.memcpy(
          this._buffer,
          this.byteOffset + this.position,
          o.buffer,
          0,
          o.byteLength
        ), this.mapUint32Array(o.length, c);
      else
        for (var d = 0; d < o.length; d++)
          this.writeUint32(o[d], c);
    }, r.prototype.writeUint16Array = function(o, c) {
      if (this._realloc(o.length * 2), o instanceof Uint16Array && this.byteOffset + this.position % o.BYTES_PER_ELEMENT === 0)
        r.memcpy(
          this._buffer,
          this.byteOffset + this.position,
          o.buffer,
          0,
          o.byteLength
        ), this.mapUint16Array(o.length, c);
      else
        for (var d = 0; d < o.length; d++)
          this.writeUint16(o[d], c);
    }, r.prototype.writeUint8Array = function(o) {
      if (this._realloc(o.length * 1), o instanceof Uint8Array && this.byteOffset + this.position % o.BYTES_PER_ELEMENT === 0)
        r.memcpy(
          this._buffer,
          this.byteOffset + this.position,
          o.buffer,
          0,
          o.byteLength
        ), this.mapUint8Array(o.length);
      else
        for (var c = 0; c < o.length; c++)
          this.writeUint8(o[c]);
    }, r.prototype.writeFloat64Array = function(o, c) {
      if (this._realloc(o.length * 8), o instanceof Float64Array && this.byteOffset + this.position % o.BYTES_PER_ELEMENT === 0)
        r.memcpy(
          this._buffer,
          this.byteOffset + this.position,
          o.buffer,
          0,
          o.byteLength
        ), this.mapFloat64Array(o.length, c);
      else
        for (var d = 0; d < o.length; d++)
          this.writeFloat64(o[d], c);
    }, r.prototype.writeFloat32Array = function(o, c) {
      if (this._realloc(o.length * 4), o instanceof Float32Array && this.byteOffset + this.position % o.BYTES_PER_ELEMENT === 0)
        r.memcpy(
          this._buffer,
          this.byteOffset + this.position,
          o.buffer,
          0,
          o.byteLength
        ), this.mapFloat32Array(o.length, c);
      else
        for (var d = 0; d < o.length; d++)
          this.writeFloat32(o[d], c);
    }, r.prototype.writeInt32 = function(o, c) {
      this._realloc(4), this._dataView.setInt32(this.position, o, c ?? this.endianness), this.position += 4;
    }, r.prototype.writeInt16 = function(o, c) {
      this._realloc(2), this._dataView.setInt16(this.position, o, c ?? this.endianness), this.position += 2;
    }, r.prototype.writeInt8 = function(o) {
      this._realloc(1), this._dataView.setInt8(this.position, o), this.position += 1;
    }, r.prototype.writeUint32 = function(o, c) {
      this._realloc(4), this._dataView.setUint32(this.position, o, c ?? this.endianness), this.position += 4;
    }, r.prototype.writeUint16 = function(o, c) {
      this._realloc(2), this._dataView.setUint16(this.position, o, c ?? this.endianness), this.position += 2;
    }, r.prototype.writeUint8 = function(o) {
      this._realloc(1), this._dataView.setUint8(this.position, o), this.position += 1;
    }, r.prototype.writeFloat32 = function(o, c) {
      this._realloc(4), this._dataView.setFloat32(this.position, o, c ?? this.endianness), this.position += 4;
    }, r.prototype.writeFloat64 = function(o, c) {
      this._realloc(8), this._dataView.setFloat64(this.position, o, c ?? this.endianness), this.position += 8;
    }, r.prototype.writeUCS2String = function(o, c, d) {
      d == null && (d = o.length);
      for (var _ = 0; _ < o.length && _ < d; _++)
        this.writeUint16(o.charCodeAt(_), c);
      for (; _ < d; _++)
        this.writeUint16(0);
    }, r.prototype.writeString = function(o, c, d) {
      var _ = 0;
      if (c == null || c == "ASCII")
        if (d != null) {
          var y = Math.min(o.length, d);
          for (_ = 0; _ < y; _++)
            this.writeUint8(o.charCodeAt(_));
          for (; _ < d; _++)
            this.writeUint8(0);
        } else
          for (_ = 0; _ < o.length; _++)
            this.writeUint8(o.charCodeAt(_));
      else
        this.writeUint8Array(new TextEncoder(c).encode(o.substring(0, d)));
    }, r.prototype.writeCString = function(o, c) {
      var d = 0;
      if (c != null) {
        var _ = Math.min(o.length, c);
        for (d = 0; d < _; d++)
          this.writeUint8(o.charCodeAt(d));
        for (; d < c; d++)
          this.writeUint8(0);
      } else {
        for (d = 0; d < o.length; d++)
          this.writeUint8(o.charCodeAt(d));
        this.writeUint8(0);
      }
    }, r.prototype.writeStruct = function(o, c) {
      for (var d = 0; d < o.length; d += 2) {
        var _ = o[d + 1];
        this.writeType(_, c[o[d]], c);
      }
    }, r.prototype.writeType = function(o, c, d) {
      var _;
      if (typeof o == "function")
        return o(this, c);
      if (typeof o == "object" && !(o instanceof Array))
        return o.set(this, c, d);
      var y = null, v = "ASCII", b = this.position;
      switch (typeof o == "string" && /:/.test(o) && (_ = o.split(":"), o = _[0], y = parseInt(_[1])), typeof o == "string" && /,/.test(o) && (_ = o.split(","), o = _[0], v = parseInt(_[1])), o) {
        case "uint8":
          this.writeUint8(c);
          break;
        case "int8":
          this.writeInt8(c);
          break;
        case "uint16":
          this.writeUint16(c, this.endianness);
          break;
        case "int16":
          this.writeInt16(c, this.endianness);
          break;
        case "uint32":
          this.writeUint32(c, this.endianness);
          break;
        case "int32":
          this.writeInt32(c, this.endianness);
          break;
        case "float32":
          this.writeFloat32(c, this.endianness);
          break;
        case "float64":
          this.writeFloat64(c, this.endianness);
          break;
        case "uint16be":
          this.writeUint16(c, r.BIG_ENDIAN);
          break;
        case "int16be":
          this.writeInt16(c, r.BIG_ENDIAN);
          break;
        case "uint32be":
          this.writeUint32(c, r.BIG_ENDIAN);
          break;
        case "int32be":
          this.writeInt32(c, r.BIG_ENDIAN);
          break;
        case "float32be":
          this.writeFloat32(c, r.BIG_ENDIAN);
          break;
        case "float64be":
          this.writeFloat64(c, r.BIG_ENDIAN);
          break;
        case "uint16le":
          this.writeUint16(c, r.LITTLE_ENDIAN);
          break;
        case "int16le":
          this.writeInt16(c, r.LITTLE_ENDIAN);
          break;
        case "uint32le":
          this.writeUint32(c, r.LITTLE_ENDIAN);
          break;
        case "int32le":
          this.writeInt32(c, r.LITTLE_ENDIAN);
          break;
        case "float32le":
          this.writeFloat32(c, r.LITTLE_ENDIAN);
          break;
        case "float64le":
          this.writeFloat64(c, r.LITTLE_ENDIAN);
          break;
        case "cstring":
          this.writeCString(c, y);
          break;
        case "string":
          this.writeString(c, v, y);
          break;
        case "u16string":
          this.writeUCS2String(c, this.endianness, y);
          break;
        case "u16stringle":
          this.writeUCS2String(c, r.LITTLE_ENDIAN, y);
          break;
        case "u16stringbe":
          this.writeUCS2String(c, r.BIG_ENDIAN, y);
          break;
        default:
          if (o.length == 3) {
            for (var w = o[1], S = 0; S < c.length; S++)
              this.writeType(w, c[S]);
            break;
          } else {
            this.writeStruct(o, c);
            break;
          }
      }
      y != null && (this.position = b, this._realloc(y), this.position = b + y);
    }, r.prototype.writeUint64 = function(o) {
      var c = Math.floor(o / n);
      this.writeUint32(c), this.writeUint32(o & 4294967295);
    }, r.prototype.writeUint24 = function(o) {
      this.writeUint8((o & 16711680) >> 16), this.writeUint8((o & 65280) >> 8), this.writeUint8(o & 255);
    }, r.prototype.adjustUint32 = function(o, c) {
      var d = this.position;
      this.seek(o), this.writeUint32(c), this.seek(d);
    }, r.prototype.mapInt32Array = function(o, c) {
      this._realloc(o * 4);
      var d = new Int32Array(this._buffer, this.byteOffset + this.position, o);
      return r.arrayToNative(d, c ?? this.endianness), this.position += o * 4, d;
    }, r.prototype.mapInt16Array = function(o, c) {
      this._realloc(o * 2);
      var d = new Int16Array(this._buffer, this.byteOffset + this.position, o);
      return r.arrayToNative(d, c ?? this.endianness), this.position += o * 2, d;
    }, r.prototype.mapInt8Array = function(o) {
      this._realloc(o * 1);
      var c = new Int8Array(this._buffer, this.byteOffset + this.position, o);
      return this.position += o * 1, c;
    }, r.prototype.mapUint32Array = function(o, c) {
      this._realloc(o * 4);
      var d = new Uint32Array(this._buffer, this.byteOffset + this.position, o);
      return r.arrayToNative(d, c ?? this.endianness), this.position += o * 4, d;
    }, r.prototype.mapUint16Array = function(o, c) {
      this._realloc(o * 2);
      var d = new Uint16Array(this._buffer, this.byteOffset + this.position, o);
      return r.arrayToNative(d, c ?? this.endianness), this.position += o * 2, d;
    }, r.prototype.mapFloat64Array = function(o, c) {
      this._realloc(o * 8);
      var d = new Float64Array(this._buffer, this.byteOffset + this.position, o);
      return r.arrayToNative(d, c ?? this.endianness), this.position += o * 8, d;
    }, r.prototype.mapFloat32Array = function(o, c) {
      this._realloc(o * 4);
      var d = new Float32Array(this._buffer, this.byteOffset + this.position, o);
      return r.arrayToNative(d, c ?? this.endianness), this.position += o * 4, d;
    };
    var a = function(o) {
      this.buffers = [], this.bufferIndex = -1, o && (this.insertBuffer(o), this.bufferIndex = 0);
    };
    a.prototype = new r(new ArrayBuffer(), 0, r.BIG_ENDIAN), a.prototype.initialized = function() {
      var o;
      return this.bufferIndex > -1 ? !0 : this.buffers.length > 0 ? (o = this.buffers[0], o.fileStart === 0 ? (this.buffer = o, this.bufferIndex = 0, t.debug("MultiBufferStream", "Stream ready for parsing"), !0) : (t.warn("MultiBufferStream", "The first buffer should have a fileStart of 0"), this.logBufferLevel(), !1)) : (t.warn("MultiBufferStream", "No buffer to start parsing from"), this.logBufferLevel(), !1);
    }, ArrayBuffer.concat = function(o, c) {
      t.debug("ArrayBuffer", "Trying to create a new buffer of size: " + (o.byteLength + c.byteLength));
      var d = new Uint8Array(o.byteLength + c.byteLength);
      return d.set(new Uint8Array(o), 0), d.set(new Uint8Array(c), o.byteLength), d.buffer;
    }, a.prototype.reduceBuffer = function(o, c, d) {
      var _;
      return _ = new Uint8Array(d), _.set(new Uint8Array(o, c, d)), _.buffer.fileStart = o.fileStart + c, _.buffer.usedBytes = 0, _.buffer;
    }, a.prototype.insertBuffer = function(o) {
      for (var c = !0, d = 0; d < this.buffers.length; d++) {
        var _ = this.buffers[d];
        if (o.fileStart <= _.fileStart) {
          if (o.fileStart === _.fileStart)
            if (o.byteLength > _.byteLength) {
              this.buffers.splice(d, 1), d--;
              continue;
            } else
              t.warn("MultiBufferStream", "Buffer (fileStart: " + o.fileStart + " - Length: " + o.byteLength + ") already appended, ignoring");
          else
            o.fileStart + o.byteLength <= _.fileStart || (o = this.reduceBuffer(o, 0, _.fileStart - o.fileStart)), t.debug("MultiBufferStream", "Appending new buffer (fileStart: " + o.fileStart + " - Length: " + o.byteLength + ")"), this.buffers.splice(d, 0, o), d === 0 && (this.buffer = o);
          c = !1;
          break;
        } else if (o.fileStart < _.fileStart + _.byteLength) {
          var y = _.fileStart + _.byteLength - o.fileStart, v = o.byteLength - y;
          if (v > 0)
            o = this.reduceBuffer(o, y, v);
          else {
            c = !1;
            break;
          }
        }
      }
      c && (t.debug("MultiBufferStream", "Appending new buffer (fileStart: " + o.fileStart + " - Length: " + o.byteLength + ")"), this.buffers.push(o), d === 0 && (this.buffer = o));
    }, a.prototype.logBufferLevel = function(o) {
      var c, d, _, y, v = [], b, w = "";
      for (_ = 0, y = 0, c = 0; c < this.buffers.length; c++)
        d = this.buffers[c], c === 0 ? (b = {}, v.push(b), b.start = d.fileStart, b.end = d.fileStart + d.byteLength, w += "[" + b.start + "-") : b.end === d.fileStart ? b.end = d.fileStart + d.byteLength : (b = {}, b.start = d.fileStart, w += v[v.length - 1].end - 1 + "], [" + b.start + "-", b.end = d.fileStart + d.byteLength, v.push(b)), _ += d.usedBytes, y += d.byteLength;
      v.length > 0 && (w += b.end - 1 + "]");
      var S = o ? t.info : t.debug;
      this.buffers.length === 0 ? S("MultiBufferStream", "No more buffer in memory") : S("MultiBufferStream", "" + this.buffers.length + " stored buffer(s) (" + _ + "/" + y + " bytes), continuous ranges: " + w);
    }, a.prototype.cleanBuffers = function() {
      var o, c;
      for (o = 0; o < this.buffers.length; o++)
        c = this.buffers[o], c.usedBytes === c.byteLength && (t.debug("MultiBufferStream", "Removing buffer #" + o), this.buffers.splice(o, 1), o--);
    }, a.prototype.mergeNextBuffer = function() {
      var o;
      if (this.bufferIndex + 1 < this.buffers.length)
        if (o = this.buffers[this.bufferIndex + 1], o.fileStart === this.buffer.fileStart + this.buffer.byteLength) {
          var c = this.buffer.byteLength, d = this.buffer.usedBytes, _ = this.buffer.fileStart;
          return this.buffers[this.bufferIndex] = ArrayBuffer.concat(this.buffer, o), this.buffer = this.buffers[this.bufferIndex], this.buffers.splice(this.bufferIndex + 1, 1), this.buffer.usedBytes = d, this.buffer.fileStart = _, t.debug("ISOFile", "Concatenating buffer for box parsing (length: " + c + "->" + this.buffer.byteLength + ")"), !0;
        } else
          return !1;
      else
        return !1;
    }, a.prototype.findPosition = function(o, c, d) {
      var _, y = null, v = -1;
      for (o === !0 ? _ = 0 : _ = this.bufferIndex; _ < this.buffers.length && (y = this.buffers[_], y.fileStart <= c); ) {
        v = _, d && (y.fileStart + y.byteLength <= c ? y.usedBytes = y.byteLength : y.usedBytes = c - y.fileStart, this.logBufferLevel());
        _++;
      }
      return v !== -1 ? (y = this.buffers[v], y.fileStart + y.byteLength >= c ? (t.debug("MultiBufferStream", "Found position in existing buffer #" + v), v) : -1) : -1;
    }, a.prototype.findEndContiguousBuf = function(o) {
      var c, d, _, y = o !== void 0 ? o : this.bufferIndex;
      if (d = this.buffers[y], this.buffers.length > y + 1)
        for (c = y + 1; c < this.buffers.length && (_ = this.buffers[c], _.fileStart === d.fileStart + d.byteLength); c++)
          d = _;
      return d.fileStart + d.byteLength;
    }, a.prototype.getEndFilePositionAfter = function(o) {
      var c = this.findPosition(!0, o, !1);
      return c !== -1 ? this.findEndContiguousBuf(c) : o;
    }, a.prototype.addUsedBytes = function(o) {
      this.buffer.usedBytes += o, this.logBufferLevel();
    }, a.prototype.setAllUsedBytes = function() {
      this.buffer.usedBytes = this.buffer.byteLength, this.logBufferLevel();
    }, a.prototype.seek = function(o, c, d) {
      var _;
      return _ = this.findPosition(c, o, d), _ !== -1 ? (this.buffer = this.buffers[_], this.bufferIndex = _, this.position = o - this.buffer.fileStart, t.debug("MultiBufferStream", "Repositioning parser at buffer position: " + this.position), !0) : (t.debug("MultiBufferStream", "Position " + o + " not found in buffered data"), !1);
    }, a.prototype.getPosition = function() {
      if (this.bufferIndex === -1 || this.buffers[this.bufferIndex] === null)
        throw "Error accessing position in the MultiBufferStream";
      return this.buffers[this.bufferIndex].fileStart + this.position;
    }, a.prototype.getLength = function() {
      return this.byteLength;
    }, a.prototype.getEndPosition = function() {
      if (this.bufferIndex === -1 || this.buffers[this.bufferIndex] === null)
        throw "Error accessing position in the MultiBufferStream";
      return this.buffers[this.bufferIndex].fileStart + this.byteLength;
    }, s.MultiBufferStream = a;
    var l = function() {
      var o = 3, c = 4, d = 5, _ = 6, y = [];
      y[o] = "ES_Descriptor", y[c] = "DecoderConfigDescriptor", y[d] = "DecoderSpecificInfo", y[_] = "SLConfigDescriptor", this.getDescriptorName = function(w) {
        return y[w];
      };
      var v = this, b = {};
      return this.parseOneDescriptor = function(w) {
        var S = 0, T, E, C;
        for (T = w.readUint8(), C = w.readUint8(); C & 128; )
          S = (C & 127) << 7, C = w.readUint8();
        return S += C & 127, t.debug("MPEG4DescriptorParser", "Found " + (y[T] || "Descriptor " + T) + ", size " + S + " at position " + w.getPosition()), y[T] ? E = new b[y[T]](S) : E = new b.Descriptor(S), E.parse(w), E;
      }, b.Descriptor = function(w, S) {
        this.tag = w, this.size = S, this.descs = [];
      }, b.Descriptor.prototype.parse = function(w) {
        this.data = w.readUint8Array(this.size);
      }, b.Descriptor.prototype.findDescriptor = function(w) {
        for (var S = 0; S < this.descs.length; S++)
          if (this.descs[S].tag == w)
            return this.descs[S];
        return null;
      }, b.Descriptor.prototype.parseRemainingDescriptors = function(w) {
        for (var S = w.position; w.position < S + this.size; ) {
          var T = v.parseOneDescriptor(w);
          this.descs.push(T);
        }
      }, b.ES_Descriptor = function(w) {
        b.Descriptor.call(this, o, w);
      }, b.ES_Descriptor.prototype = new b.Descriptor(), b.ES_Descriptor.prototype.parse = function(w) {
        if (this.ES_ID = w.readUint16(), this.flags = w.readUint8(), this.size -= 3, this.flags & 128 ? (this.dependsOn_ES_ID = w.readUint16(), this.size -= 2) : this.dependsOn_ES_ID = 0, this.flags & 64) {
          var S = w.readUint8();
          this.URL = w.readString(S), this.size -= S + 1;
        } else
          this.URL = "";
        this.flags & 32 ? (this.OCR_ES_ID = w.readUint16(), this.size -= 2) : this.OCR_ES_ID = 0, this.parseRemainingDescriptors(w);
      }, b.ES_Descriptor.prototype.getOTI = function(w) {
        var S = this.findDescriptor(c);
        return S ? S.oti : 0;
      }, b.ES_Descriptor.prototype.getAudioConfig = function(w) {
        var S = this.findDescriptor(c);
        if (!S) return null;
        var T = S.findDescriptor(d);
        if (T && T.data) {
          var E = (T.data[0] & 248) >> 3;
          return E === 31 && T.data.length >= 2 && (E = 32 + ((T.data[0] & 7) << 3) + ((T.data[1] & 224) >> 5)), E;
        } else
          return null;
      }, b.DecoderConfigDescriptor = function(w) {
        b.Descriptor.call(this, c, w);
      }, b.DecoderConfigDescriptor.prototype = new b.Descriptor(), b.DecoderConfigDescriptor.prototype.parse = function(w) {
        this.oti = w.readUint8(), this.streamType = w.readUint8(), this.upStream = (this.streamType >> 1 & 1) !== 0, this.streamType = this.streamType >>> 2, this.bufferSize = w.readUint24(), this.maxBitrate = w.readUint32(), this.avgBitrate = w.readUint32(), this.size -= 13, this.parseRemainingDescriptors(w);
      }, b.DecoderSpecificInfo = function(w) {
        b.Descriptor.call(this, d, w);
      }, b.DecoderSpecificInfo.prototype = new b.Descriptor(), b.SLConfigDescriptor = function(w) {
        b.Descriptor.call(this, _, w);
      }, b.SLConfigDescriptor.prototype = new b.Descriptor(), this;
    };
    s.MPEG4DescriptorParser = l;
    var h = {
      ERR_INVALID_DATA: -1,
      ERR_NOT_ENOUGH_DATA: 0,
      OK: 1,
      // Boxes to be created with default parsing
      BASIC_BOXES: ["mdat", "idat", "free", "skip", "meco", "strk"],
      FULL_BOXES: ["hmhd", "nmhd", "iods", "xml ", "bxml", "ipro", "mere"],
      CONTAINER_BOXES: [
        ["moov", ["trak", "pssh"]],
        ["trak"],
        ["edts"],
        ["mdia"],
        ["minf"],
        ["dinf"],
        ["stbl", ["sgpd", "sbgp"]],
        ["mvex", ["trex"]],
        ["moof", ["traf"]],
        ["traf", ["trun", "sgpd", "sbgp"]],
        ["vttc"],
        ["tref"],
        ["iref"],
        ["mfra", ["tfra"]],
        ["meco"],
        ["hnti"],
        ["hinf"],
        ["strk"],
        ["strd"],
        ["sinf"],
        ["rinf"],
        ["schi"],
        ["trgr"],
        ["udta", ["kind"]],
        ["iprp", ["ipma"]],
        ["ipco"],
        ["grpl"],
        ["j2kH"],
        ["etyp", ["tyco"]]
      ],
      // Boxes effectively created
      boxCodes: [],
      fullBoxCodes: [],
      containerBoxCodes: [],
      sampleEntryCodes: {},
      sampleGroupEntryCodes: [],
      trackGroupTypes: [],
      UUIDBoxes: {},
      UUIDs: [],
      initialize: function() {
        h.FullBox.prototype = new h.Box(), h.ContainerBox.prototype = new h.Box(), h.SampleEntry.prototype = new h.Box(), h.TrackGroupTypeBox.prototype = new h.FullBox(), h.BASIC_BOXES.forEach(function(o) {
          h.createBoxCtor(o);
        }), h.FULL_BOXES.forEach(function(o) {
          h.createFullBoxCtor(o);
        }), h.CONTAINER_BOXES.forEach(function(o) {
          h.createContainerBoxCtor(o[0], null, o[1]);
        });
      },
      Box: function(o, c, d) {
        this.type = o, this.size = c, this.uuid = d;
      },
      FullBox: function(o, c, d) {
        h.Box.call(this, o, c, d), this.flags = 0, this.version = 0;
      },
      ContainerBox: function(o, c, d) {
        h.Box.call(this, o, c, d), this.boxes = [];
      },
      SampleEntry: function(o, c, d, _) {
        h.ContainerBox.call(this, o, c), this.hdr_size = d, this.start = _;
      },
      SampleGroupEntry: function(o) {
        this.grouping_type = o;
      },
      TrackGroupTypeBox: function(o, c) {
        h.FullBox.call(this, o, c);
      },
      createBoxCtor: function(o, c) {
        h.boxCodes.push(o), h[o + "Box"] = function(d) {
          h.Box.call(this, o, d);
        }, h[o + "Box"].prototype = new h.Box(), c && (h[o + "Box"].prototype.parse = c);
      },
      createFullBoxCtor: function(o, c) {
        h[o + "Box"] = function(d) {
          h.FullBox.call(this, o, d);
        }, h[o + "Box"].prototype = new h.FullBox(), h[o + "Box"].prototype.parse = function(d) {
          this.parseFullHeader(d), c && c.call(this, d);
        };
      },
      addSubBoxArrays: function(o) {
        if (o) {
          this.subBoxNames = o;
          for (var c = o.length, d = 0; d < c; d++)
            this[o[d] + "s"] = [];
        }
      },
      createContainerBoxCtor: function(o, c, d) {
        h[o + "Box"] = function(_) {
          h.ContainerBox.call(this, o, _), h.addSubBoxArrays.call(this, d);
        }, h[o + "Box"].prototype = new h.ContainerBox(), c && (h[o + "Box"].prototype.parse = c);
      },
      createMediaSampleEntryCtor: function(o, c, d) {
        h.sampleEntryCodes[o] = [], h[o + "SampleEntry"] = function(_, y) {
          h.SampleEntry.call(this, _, y), h.addSubBoxArrays.call(this, d);
        }, h[o + "SampleEntry"].prototype = new h.SampleEntry(), c && (h[o + "SampleEntry"].prototype.parse = c);
      },
      createSampleEntryCtor: function(o, c, d, _) {
        h.sampleEntryCodes[o].push(c), h[c + "SampleEntry"] = function(y) {
          h[o + "SampleEntry"].call(this, c, y), h.addSubBoxArrays.call(this, _);
        }, h[c + "SampleEntry"].prototype = new h[o + "SampleEntry"](), d && (h[c + "SampleEntry"].prototype.parse = d);
      },
      createEncryptedSampleEntryCtor: function(o, c, d) {
        h.createSampleEntryCtor.call(this, o, c, d, ["sinf"]);
      },
      createSampleGroupCtor: function(o, c) {
        h[o + "SampleGroupEntry"] = function(d) {
          h.SampleGroupEntry.call(this, o, d);
        }, h[o + "SampleGroupEntry"].prototype = new h.SampleGroupEntry(), c && (h[o + "SampleGroupEntry"].prototype.parse = c);
      },
      createTrackGroupCtor: function(o, c) {
        h[o + "TrackGroupTypeBox"] = function(d) {
          h.TrackGroupTypeBox.call(this, o, d);
        }, h[o + "TrackGroupTypeBox"].prototype = new h.TrackGroupTypeBox(), c && (h[o + "TrackGroupTypeBox"].prototype.parse = c);
      },
      createUUIDBox: function(o, c, d, _) {
        h.UUIDs.push(o), h.UUIDBoxes[o] = function(y) {
          c ? h.FullBox.call(this, "uuid", y, o) : d ? h.ContainerBox.call(this, "uuid", y, o) : h.Box.call(this, "uuid", y, o);
        }, h.UUIDBoxes[o].prototype = c ? new h.FullBox() : d ? new h.ContainerBox() : new h.Box(), _ && (c ? h.UUIDBoxes[o].prototype.parse = function(y) {
          this.parseFullHeader(y), _ && _.call(this, y);
        } : h.UUIDBoxes[o].prototype.parse = _);
      }
    };
    h.initialize(), h.TKHD_FLAG_ENABLED = 1, h.TKHD_FLAG_IN_MOVIE = 2, h.TKHD_FLAG_IN_PREVIEW = 4, h.TFHD_FLAG_BASE_DATA_OFFSET = 1, h.TFHD_FLAG_SAMPLE_DESC = 2, h.TFHD_FLAG_SAMPLE_DUR = 8, h.TFHD_FLAG_SAMPLE_SIZE = 16, h.TFHD_FLAG_SAMPLE_FLAGS = 32, h.TFHD_FLAG_DUR_EMPTY = 65536, h.TFHD_FLAG_DEFAULT_BASE_IS_MOOF = 131072, h.TRUN_FLAGS_DATA_OFFSET = 1, h.TRUN_FLAGS_FIRST_FLAG = 4, h.TRUN_FLAGS_DURATION = 256, h.TRUN_FLAGS_SIZE = 512, h.TRUN_FLAGS_FLAGS = 1024, h.TRUN_FLAGS_CTS_OFFSET = 2048, h.Box.prototype.add = function(o) {
      return this.addBox(new h[o + "Box"]());
    }, h.Box.prototype.addBox = function(o) {
      return this.boxes.push(o), this[o.type + "s"] ? this[o.type + "s"].push(o) : this[o.type] = o, o;
    }, h.Box.prototype.set = function(o, c) {
      return this[o] = c, this;
    }, h.Box.prototype.addEntry = function(o, c) {
      var d = c || "entries";
      return this[d] || (this[d] = []), this[d].push(o), this;
    }, s.BoxParser = h, h.parseUUID = function(o) {
      return h.parseHex16(o);
    }, h.parseHex16 = function(o) {
      for (var c = "", d = 0; d < 16; d++) {
        var _ = o.readUint8().toString(16);
        c += _.length === 1 ? "0" + _ : _;
      }
      return c;
    }, h.parseOneBox = function(o, c, d) {
      var _, y = o.getPosition(), v = 0, b, w;
      if (o.getEndPosition() - y < 8)
        return t.debug("BoxParser", "Not enough data in stream to parse the type and size of the box"), { code: h.ERR_NOT_ENOUGH_DATA };
      if (d && d < 8)
        return t.debug("BoxParser", "Not enough bytes left in the parent box to parse a new box"), { code: h.ERR_NOT_ENOUGH_DATA };
      var S = o.readUint32(), T = o.readString(4), E = T;
      if (t.debug("BoxParser", "Found box of type '" + T + "' and size " + S + " at position " + y), v = 8, T == "uuid") {
        if (o.getEndPosition() - o.getPosition() < 16 || d - v < 16)
          return o.seek(y), t.debug("BoxParser", "Not enough bytes left in the parent box to parse a UUID box"), { code: h.ERR_NOT_ENOUGH_DATA };
        w = h.parseUUID(o), v += 16, E = w;
      }
      if (S == 1) {
        if (o.getEndPosition() - o.getPosition() < 8 || d && d - v < 8)
          return o.seek(y), t.warn("BoxParser", 'Not enough data in stream to parse the extended size of the "' + T + '" box'), { code: h.ERR_NOT_ENOUGH_DATA };
        S = o.readUint64(), v += 8;
      } else if (S === 0) {
        if (d)
          S = d;
        else if (T !== "mdat")
          return t.error("BoxParser", "Unlimited box size not supported for type: '" + T + "'"), _ = new h.Box(T, S), { code: h.OK, box: _, size: _.size };
      }
      return S !== 0 && S < v ? (t.error("BoxParser", "Box of type " + T + " has an invalid size " + S + " (too small to be a box)"), { code: h.ERR_NOT_ENOUGH_DATA, type: T, size: S, hdr_size: v, start: y }) : S !== 0 && d && S > d ? (t.error("BoxParser", "Box of type '" + T + "' has a size " + S + " greater than its container size " + d), { code: h.ERR_NOT_ENOUGH_DATA, type: T, size: S, hdr_size: v, start: y }) : S !== 0 && y + S > o.getEndPosition() ? (o.seek(y), t.info("BoxParser", "Not enough data in stream to parse the entire '" + T + "' box"), { code: h.ERR_NOT_ENOUGH_DATA, type: T, size: S, hdr_size: v, start: y }) : c ? { code: h.OK, type: T, size: S, hdr_size: v, start: y } : (h[T + "Box"] ? _ = new h[T + "Box"](S) : T !== "uuid" ? (t.warn("BoxParser", "Unknown box type: '" + T + "'"), _ = new h.Box(T, S), _.has_unparsed_data = !0) : h.UUIDBoxes[w] ? _ = new h.UUIDBoxes[w](S) : (t.warn("BoxParser", "Unknown uuid type: '" + w + "'"), _ = new h.Box(T, S), _.uuid = w, _.has_unparsed_data = !0), _.hdr_size = v, _.start = y, _.write === h.Box.prototype.write && _.type !== "mdat" && (t.info("BoxParser", "'" + E + "' box writing not yet implemented, keeping unparsed data in memory for later write"), _.parseDataAndRewind(o)), _.parse(o), b = o.getPosition() - (_.start + _.size), b < 0 ? (t.warn("BoxParser", "Parsing of box '" + E + "' did not read the entire indicated box data size (missing " + -b + " bytes), seeking forward"), o.seek(_.start + _.size)) : b > 0 && (t.error("BoxParser", "Parsing of box '" + E + "' read " + b + " more bytes than the indicated box data size, seeking backwards"), _.size !== 0 && o.seek(_.start + _.size)), { code: h.OK, box: _, size: _.size });
    }, h.Box.prototype.parse = function(o) {
      this.type != "mdat" ? this.data = o.readUint8Array(this.size - this.hdr_size) : this.size === 0 ? o.seek(o.getEndPosition()) : o.seek(this.start + this.size);
    }, h.Box.prototype.parseDataAndRewind = function(o) {
      this.data = o.readUint8Array(this.size - this.hdr_size), o.position -= this.size - this.hdr_size;
    }, h.FullBox.prototype.parseDataAndRewind = function(o) {
      this.parseFullHeader(o), this.data = o.readUint8Array(this.size - this.hdr_size), this.hdr_size -= 4, o.position -= this.size - this.hdr_size;
    }, h.FullBox.prototype.parseFullHeader = function(o) {
      this.version = o.readUint8(), this.flags = o.readUint24(), this.hdr_size += 4;
    }, h.FullBox.prototype.parse = function(o) {
      this.parseFullHeader(o), this.data = o.readUint8Array(this.size - this.hdr_size);
    }, h.ContainerBox.prototype.parse = function(o) {
      for (var c, d; o.getPosition() < this.start + this.size; )
        if (c = h.parseOneBox(o, !1, this.size - (o.getPosition() - this.start)), c.code === h.OK)
          if (d = c.box, this.boxes.push(d), this.subBoxNames && this.subBoxNames.indexOf(d.type) != -1)
            this[this.subBoxNames[this.subBoxNames.indexOf(d.type)] + "s"].push(d);
          else {
            var _ = d.type !== "uuid" ? d.type : d.uuid;
            this[_] ? t.warn("Box of type " + _ + " already stored in field of this type") : this[_] = d;
          }
        else
          return;
    }, h.Box.prototype.parseLanguage = function(o) {
      this.language = o.readUint16();
      var c = [];
      c[0] = this.language >> 10 & 31, c[1] = this.language >> 5 & 31, c[2] = this.language & 31, this.languageString = String.fromCharCode(c[0] + 96, c[1] + 96, c[2] + 96);
    }, h.SAMPLE_ENTRY_TYPE_VISUAL = "Visual", h.SAMPLE_ENTRY_TYPE_AUDIO = "Audio", h.SAMPLE_ENTRY_TYPE_HINT = "Hint", h.SAMPLE_ENTRY_TYPE_METADATA = "Metadata", h.SAMPLE_ENTRY_TYPE_SUBTITLE = "Subtitle", h.SAMPLE_ENTRY_TYPE_SYSTEM = "System", h.SAMPLE_ENTRY_TYPE_TEXT = "Text", h.SampleEntry.prototype.parseHeader = function(o) {
      o.readUint8Array(6), this.data_reference_index = o.readUint16(), this.hdr_size += 8;
    }, h.SampleEntry.prototype.parse = function(o) {
      this.parseHeader(o), this.data = o.readUint8Array(this.size - this.hdr_size);
    }, h.SampleEntry.prototype.parseDataAndRewind = function(o) {
      this.parseHeader(o), this.data = o.readUint8Array(this.size - this.hdr_size), this.hdr_size -= 8, o.position -= this.size - this.hdr_size;
    }, h.SampleEntry.prototype.parseFooter = function(o) {
      h.ContainerBox.prototype.parse.call(this, o);
    }, h.createMediaSampleEntryCtor(h.SAMPLE_ENTRY_TYPE_HINT), h.createMediaSampleEntryCtor(h.SAMPLE_ENTRY_TYPE_METADATA), h.createMediaSampleEntryCtor(h.SAMPLE_ENTRY_TYPE_SUBTITLE), h.createMediaSampleEntryCtor(h.SAMPLE_ENTRY_TYPE_SYSTEM), h.createMediaSampleEntryCtor(h.SAMPLE_ENTRY_TYPE_TEXT), h.createMediaSampleEntryCtor(h.SAMPLE_ENTRY_TYPE_VISUAL, function(o) {
      var c;
      this.parseHeader(o), o.readUint16(), o.readUint16(), o.readUint32Array(3), this.width = o.readUint16(), this.height = o.readUint16(), this.horizresolution = o.readUint32(), this.vertresolution = o.readUint32(), o.readUint32(), this.frame_count = o.readUint16(), c = Math.min(31, o.readUint8()), this.compressorname = o.readString(c), c < 31 && o.readString(31 - c), this.depth = o.readUint16(), o.readUint16(), this.parseFooter(o);
    }), h.createMediaSampleEntryCtor(h.SAMPLE_ENTRY_TYPE_AUDIO, function(o) {
      this.parseHeader(o), o.readUint32Array(2), this.channel_count = o.readUint16(), this.samplesize = o.readUint16(), o.readUint16(), o.readUint16(), this.samplerate = o.readUint32() / 65536, this.parseFooter(o);
    }), h.createSampleEntryCtor(h.SAMPLE_ENTRY_TYPE_VISUAL, "avc1"), h.createSampleEntryCtor(h.SAMPLE_ENTRY_TYPE_VISUAL, "avc2"), h.createSampleEntryCtor(h.SAMPLE_ENTRY_TYPE_VISUAL, "avc3"), h.createSampleEntryCtor(h.SAMPLE_ENTRY_TYPE_VISUAL, "avc4"), h.createSampleEntryCtor(h.SAMPLE_ENTRY_TYPE_VISUAL, "av01"), h.createSampleEntryCtor(h.SAMPLE_ENTRY_TYPE_VISUAL, "dav1"), h.createSampleEntryCtor(h.SAMPLE_ENTRY_TYPE_VISUAL, "hvc1"), h.createSampleEntryCtor(h.SAMPLE_ENTRY_TYPE_VISUAL, "hev1"), h.createSampleEntryCtor(h.SAMPLE_ENTRY_TYPE_VISUAL, "hvt1"), h.createSampleEntryCtor(h.SAMPLE_ENTRY_TYPE_VISUAL, "lhe1"), h.createSampleEntryCtor(h.SAMPLE_ENTRY_TYPE_VISUAL, "dvh1"), h.createSampleEntryCtor(h.SAMPLE_ENTRY_TYPE_VISUAL, "dvhe"), h.createSampleEntryCtor(h.SAMPLE_ENTRY_TYPE_VISUAL, "vvc1"), h.createSampleEntryCtor(h.SAMPLE_ENTRY_TYPE_VISUAL, "vvi1"), h.createSampleEntryCtor(h.SAMPLE_ENTRY_TYPE_VISUAL, "vvs1"), h.createSampleEntryCtor(h.SAMPLE_ENTRY_TYPE_VISUAL, "vvcN"), h.createSampleEntryCtor(h.SAMPLE_ENTRY_TYPE_VISUAL, "vp08"), h.createSampleEntryCtor(h.SAMPLE_ENTRY_TYPE_VISUAL, "vp09"), h.createSampleEntryCtor(h.SAMPLE_ENTRY_TYPE_VISUAL, "avs3"), h.createSampleEntryCtor(h.SAMPLE_ENTRY_TYPE_VISUAL, "j2ki"), h.createSampleEntryCtor(h.SAMPLE_ENTRY_TYPE_VISUAL, "mjp2"), h.createSampleEntryCtor(h.SAMPLE_ENTRY_TYPE_VISUAL, "mjpg"), h.createSampleEntryCtor(h.SAMPLE_ENTRY_TYPE_VISUAL, "uncv"), h.createSampleEntryCtor(h.SAMPLE_ENTRY_TYPE_AUDIO, "mp4a"), h.createSampleEntryCtor(h.SAMPLE_ENTRY_TYPE_AUDIO, "ac-3"), h.createSampleEntryCtor(h.SAMPLE_ENTRY_TYPE_AUDIO, "ac-4"), h.createSampleEntryCtor(h.SAMPLE_ENTRY_TYPE_AUDIO, "ec-3"), h.createSampleEntryCtor(h.SAMPLE_ENTRY_TYPE_AUDIO, "Opus"), h.createSampleEntryCtor(h.SAMPLE_ENTRY_TYPE_AUDIO, "mha1"), h.createSampleEntryCtor(h.SAMPLE_ENTRY_TYPE_AUDIO, "mha2"), h.createSampleEntryCtor(h.SAMPLE_ENTRY_TYPE_AUDIO, "mhm1"), h.createSampleEntryCtor(h.SAMPLE_ENTRY_TYPE_AUDIO, "mhm2"), h.createSampleEntryCtor(h.SAMPLE_ENTRY_TYPE_AUDIO, "fLaC"), h.createEncryptedSampleEntryCtor(h.SAMPLE_ENTRY_TYPE_VISUAL, "encv"), h.createEncryptedSampleEntryCtor(h.SAMPLE_ENTRY_TYPE_AUDIO, "enca"), h.createEncryptedSampleEntryCtor(h.SAMPLE_ENTRY_TYPE_SUBTITLE, "encu"), h.createEncryptedSampleEntryCtor(h.SAMPLE_ENTRY_TYPE_SYSTEM, "encs"), h.createEncryptedSampleEntryCtor(h.SAMPLE_ENTRY_TYPE_TEXT, "enct"), h.createEncryptedSampleEntryCtor(h.SAMPLE_ENTRY_TYPE_METADATA, "encm"), h.createBoxCtor("a1lx", function(o) {
      var c = o.readUint8() & 1, d = ((c & 1) + 1) * 16;
      this.layer_size = [];
      for (var _ = 0; _ < 3; _++)
        d == 16 ? this.layer_size[_] = o.readUint16() : this.layer_size[_] = o.readUint32();
    }), h.createBoxCtor("a1op", function(o) {
      this.op_index = o.readUint8();
    }), h.createFullBoxCtor("auxC", function(o) {
      this.aux_type = o.readCString();
      var c = this.size - this.hdr_size - (this.aux_type.length + 1);
      this.aux_subtype = o.readUint8Array(c);
    }), h.createBoxCtor("av1C", function(o) {
      var c = o.readUint8();
      if (c >> 7 & !1) {
        t.error("av1C marker problem");
        return;
      }
      if (this.version = c & 127, this.version !== 1) {
        t.error("av1C version " + this.version + " not supported");
        return;
      }
      if (c = o.readUint8(), this.seq_profile = c >> 5 & 7, this.seq_level_idx_0 = c & 31, c = o.readUint8(), this.seq_tier_0 = c >> 7 & 1, this.high_bitdepth = c >> 6 & 1, this.twelve_bit = c >> 5 & 1, this.monochrome = c >> 4 & 1, this.chroma_subsampling_x = c >> 3 & 1, this.chroma_subsampling_y = c >> 2 & 1, this.chroma_sample_position = c & 3, c = o.readUint8(), this.reserved_1 = c >> 5 & 7, this.reserved_1 !== 0) {
        t.error("av1C reserved_1 parsing problem");
        return;
      }
      if (this.initial_presentation_delay_present = c >> 4 & 1, this.initial_presentation_delay_present === 1)
        this.initial_presentation_delay_minus_one = c & 15;
      else if (this.reserved_2 = c & 15, this.reserved_2 !== 0) {
        t.error("av1C reserved_2 parsing problem");
        return;
      }
      var d = this.size - this.hdr_size - 4;
      this.configOBUs = o.readUint8Array(d);
    }), h.createBoxCtor("avcC", function(o) {
      var c, d;
      for (this.configurationVersion = o.readUint8(), this.AVCProfileIndication = o.readUint8(), this.profile_compatibility = o.readUint8(), this.AVCLevelIndication = o.readUint8(), this.lengthSizeMinusOne = o.readUint8() & 3, this.nb_SPS_nalus = o.readUint8() & 31, d = this.size - this.hdr_size - 6, this.SPS = [], c = 0; c < this.nb_SPS_nalus; c++)
        this.SPS[c] = {}, this.SPS[c].length = o.readUint16(), this.SPS[c].nalu = o.readUint8Array(this.SPS[c].length), d -= 2 + this.SPS[c].length;
      for (this.nb_PPS_nalus = o.readUint8(), d--, this.PPS = [], c = 0; c < this.nb_PPS_nalus; c++)
        this.PPS[c] = {}, this.PPS[c].length = o.readUint16(), this.PPS[c].nalu = o.readUint8Array(this.PPS[c].length), d -= 2 + this.PPS[c].length;
      d > 0 && (this.ext = o.readUint8Array(d));
    }), h.createBoxCtor("btrt", function(o) {
      this.bufferSizeDB = o.readUint32(), this.maxBitrate = o.readUint32(), this.avgBitrate = o.readUint32();
    }), h.createFullBoxCtor("ccst", function(o) {
      var c = o.readUint8();
      this.all_ref_pics_intra = (c & 128) == 128, this.intra_pred_used = (c & 64) == 64, this.max_ref_per_pic = (c & 63) >> 2, o.readUint24();
    }), h.createBoxCtor("cdef", function(o) {
      var c;
      for (this.channel_count = o.readUint16(), this.channel_indexes = [], this.channel_types = [], this.channel_associations = [], c = 0; c < this.channel_count; c++)
        this.channel_indexes.push(o.readUint16()), this.channel_types.push(o.readUint16()), this.channel_associations.push(o.readUint16());
    }), h.createBoxCtor("clap", function(o) {
      this.cleanApertureWidthN = o.readUint32(), this.cleanApertureWidthD = o.readUint32(), this.cleanApertureHeightN = o.readUint32(), this.cleanApertureHeightD = o.readUint32(), this.horizOffN = o.readUint32(), this.horizOffD = o.readUint32(), this.vertOffN = o.readUint32(), this.vertOffD = o.readUint32();
    }), h.createBoxCtor("clli", function(o) {
      this.max_content_light_level = o.readUint16(), this.max_pic_average_light_level = o.readUint16();
    }), h.createFullBoxCtor("cmex", function(o) {
      this.flags & 1 && (this.pos_x = o.readInt32()), this.flags & 2 && (this.pos_y = o.readInt32()), this.flags & 4 && (this.pos_z = o.readInt32()), this.flags & 8 && (this.version == 0 ? this.flags & 16 ? (this.quat_x = o.readInt32(), this.quat_y = o.readInt32(), this.quat_z = o.readInt32()) : (this.quat_x = o.readInt16(), this.quat_y = o.readInt16(), this.quat_z = o.readInt16()) : this.version == 1), this.flags & 32 && (this.id = o.readUint32());
    }), h.createFullBoxCtor("cmin", function(o) {
      this.focal_length_x = o.readInt32(), this.principal_point_x = o.readInt32(), this.principal_point_y = o.readInt32(), this.flags & 1 && (this.focal_length_y = o.readInt32(), this.skew_factor = o.readInt32());
    }), h.createBoxCtor("cmpd", function(o) {
      for (this.component_count = o.readUint32(), this.component_types = [], this.component_type_urls = [], i = 0; i < this.component_count; i++) {
        var c = o.readUint16();
        this.component_types.push(c), c >= 32768 && this.component_type_urls.push(o.readCString());
      }
    }), h.createFullBoxCtor("co64", function(o) {
      var c, d;
      if (c = o.readUint32(), this.chunk_offsets = [], this.version === 0)
        for (d = 0; d < c; d++)
          this.chunk_offsets.push(o.readUint64());
    }), h.createFullBoxCtor("CoLL", function(o) {
      this.maxCLL = o.readUint16(), this.maxFALL = o.readUint16();
    }), h.createBoxCtor("colr", function(o) {
      if (this.colour_type = o.readString(4), this.colour_type === "nclx") {
        this.colour_primaries = o.readUint16(), this.transfer_characteristics = o.readUint16(), this.matrix_coefficients = o.readUint16();
        var c = o.readUint8();
        this.full_range_flag = c >> 7;
      } else this.colour_type === "rICC" ? this.ICC_profile = o.readUint8Array(this.size - 4) : this.colour_type === "prof" && (this.ICC_profile = o.readUint8Array(this.size - 4));
    }), h.createFullBoxCtor("cprt", function(o) {
      this.parseLanguage(o), this.notice = o.readCString();
    }), h.createFullBoxCtor("cslg", function(o) {
      this.version === 0 && (this.compositionToDTSShift = o.readInt32(), this.leastDecodeToDisplayDelta = o.readInt32(), this.greatestDecodeToDisplayDelta = o.readInt32(), this.compositionStartTime = o.readInt32(), this.compositionEndTime = o.readInt32());
    }), h.createFullBoxCtor("ctts", function(o) {
      var c, d;
      if (c = o.readUint32(), this.sample_counts = [], this.sample_offsets = [], this.version === 0)
        for (d = 0; d < c; d++) {
          this.sample_counts.push(o.readUint32());
          var _ = o.readInt32();
          _ < 0 && t.warn("BoxParser", "ctts box uses negative values without using version 1"), this.sample_offsets.push(_);
        }
      else if (this.version == 1)
        for (d = 0; d < c; d++)
          this.sample_counts.push(o.readUint32()), this.sample_offsets.push(o.readInt32());
    }), h.createBoxCtor("dac3", function(o) {
      var c = o.readUint8(), d = o.readUint8(), _ = o.readUint8();
      this.fscod = c >> 6, this.bsid = c >> 1 & 31, this.bsmod = (c & 1) << 2 | d >> 6 & 3, this.acmod = d >> 3 & 7, this.lfeon = d >> 2 & 1, this.bit_rate_code = d & 3 | _ >> 5 & 7;
    }), h.createBoxCtor("dec3", function(o) {
      var c = o.readUint16();
      this.data_rate = c >> 3, this.num_ind_sub = c & 7, this.ind_subs = [];
      for (var d = 0; d < this.num_ind_sub + 1; d++) {
        var _ = {};
        this.ind_subs.push(_);
        var y = o.readUint8(), v = o.readUint8(), b = o.readUint8();
        _.fscod = y >> 6, _.bsid = y >> 1 & 31, _.bsmod = (y & 1) << 4 | v >> 4 & 15, _.acmod = v >> 1 & 7, _.lfeon = v & 1, _.num_dep_sub = b >> 1 & 15, _.num_dep_sub > 0 && (_.chan_loc = (b & 1) << 8 | o.readUint8());
      }
    }), h.createFullBoxCtor("dfLa", function(o) {
      var c = 127, d = 128, _ = [], y = [
        "STREAMINFO",
        "PADDING",
        "APPLICATION",
        "SEEKTABLE",
        "VORBIS_COMMENT",
        "CUESHEET",
        "PICTURE",
        "RESERVED"
      ];
      do {
        var v = o.readUint8(), b = Math.min(
          v & c,
          y.length - 1
        );
        if (b ? o.readUint8Array(o.readUint24()) : (o.readUint8Array(13), this.samplerate = o.readUint32() >> 12, o.readUint8Array(20)), _.push(y[b]), v & d)
          break;
      } while (!0);
      this.numMetadataBlocks = _.length + " (" + _.join(", ") + ")";
    }), h.createBoxCtor("dimm", function(o) {
      this.bytessent = o.readUint64();
    }), h.createBoxCtor("dmax", function(o) {
      this.time = o.readUint32();
    }), h.createBoxCtor("dmed", function(o) {
      this.bytessent = o.readUint64();
    }), h.createBoxCtor("dOps", function(o) {
      if (this.Version = o.readUint8(), this.OutputChannelCount = o.readUint8(), this.PreSkip = o.readUint16(), this.InputSampleRate = o.readUint32(), this.OutputGain = o.readInt16(), this.ChannelMappingFamily = o.readUint8(), this.ChannelMappingFamily !== 0) {
        this.StreamCount = o.readUint8(), this.CoupledCount = o.readUint8(), this.ChannelMapping = [];
        for (var c = 0; c < this.OutputChannelCount; c++)
          this.ChannelMapping[c] = o.readUint8();
      }
    }), h.createFullBoxCtor("dref", function(o) {
      var c, d;
      this.entries = [];
      for (var _ = o.readUint32(), y = 0; y < _; y++)
        if (c = h.parseOneBox(o, !1, this.size - (o.getPosition() - this.start)), c.code === h.OK)
          d = c.box, this.entries.push(d);
        else
          return;
    }), h.createBoxCtor("drep", function(o) {
      this.bytessent = o.readUint64();
    }), h.createFullBoxCtor("elng", function(o) {
      this.extended_language = o.readString(this.size - this.hdr_size);
    }), h.createFullBoxCtor("elst", function(o) {
      this.entries = [];
      for (var c = o.readUint32(), d = 0; d < c; d++) {
        var _ = {};
        this.entries.push(_), this.version === 1 ? (_.segment_duration = o.readUint64(), _.media_time = o.readInt64()) : (_.segment_duration = o.readUint32(), _.media_time = o.readInt32()), _.media_rate_integer = o.readInt16(), _.media_rate_fraction = o.readInt16();
      }
    }), h.createFullBoxCtor("emsg", function(o) {
      this.version == 1 ? (this.timescale = o.readUint32(), this.presentation_time = o.readUint64(), this.event_duration = o.readUint32(), this.id = o.readUint32(), this.scheme_id_uri = o.readCString(), this.value = o.readCString()) : (this.scheme_id_uri = o.readCString(), this.value = o.readCString(), this.timescale = o.readUint32(), this.presentation_time_delta = o.readUint32(), this.event_duration = o.readUint32(), this.id = o.readUint32());
      var c = this.size - this.hdr_size - (4 * 4 + (this.scheme_id_uri.length + 1) + (this.value.length + 1));
      this.version == 1 && (c -= 4), this.message_data = o.readUint8Array(c);
    }), h.createEntityToGroupCtor = function(o, c) {
      h[o + "Box"] = function(d) {
        h.FullBox.call(this, o, d);
      }, h[o + "Box"].prototype = new h.FullBox(), h[o + "Box"].prototype.parse = function(d) {
        if (this.parseFullHeader(d), c)
          c.call(this, d);
        else
          for (this.group_id = d.readUint32(), this.num_entities_in_group = d.readUint32(), this.entity_ids = [], i = 0; i < this.num_entities_in_group; i++) {
            var _ = d.readUint32();
            this.entity_ids.push(_);
          }
      };
    }, h.createEntityToGroupCtor("aebr"), h.createEntityToGroupCtor("afbr"), h.createEntityToGroupCtor("albc"), h.createEntityToGroupCtor("altr"), h.createEntityToGroupCtor("brst"), h.createEntityToGroupCtor("dobr"), h.createEntityToGroupCtor("eqiv"), h.createEntityToGroupCtor("favc"), h.createEntityToGroupCtor("fobr"), h.createEntityToGroupCtor("iaug"), h.createEntityToGroupCtor("pano"), h.createEntityToGroupCtor("slid"), h.createEntityToGroupCtor("ster"), h.createEntityToGroupCtor("tsyn"), h.createEntityToGroupCtor("wbbr"), h.createEntityToGroupCtor("prgr"), h.createEntityToGroupCtor("pymd", function(o) {
      this.group_id = o.readUint32(), this.num_entities_in_group = o.readUint32(), this.entity_ids = [];
      for (var c = 0; c < this.num_entities_in_group; c++) {
        var d = o.readUint32();
        this.entity_ids.push(d);
      }
      for (this.tile_size_x = o.readUint16(), this.tile_size_y = o.readUint16(), this.layer_binning = [], this.tiles_in_layer_column_minus1 = [], this.tiles_in_layer_row_minus1 = [], c = 0; c < this.num_entities_in_group; c++)
        this.layer_binning[c] = o.readUint16(), this.tiles_in_layer_row_minus1[c] = o.readUint16(), this.tiles_in_layer_column_minus1[c] = o.readUint16();
    }), h.createFullBoxCtor("esds", function(o) {
      var c = o.readUint8Array(this.size - this.hdr_size);
      if (this.data = c, typeof l < "u") {
        var d = new l();
        this.esd = d.parseOneDescriptor(new r(c.buffer, 0, r.BIG_ENDIAN));
      }
    }), h.createBoxCtor("fiel", function(o) {
      this.fieldCount = o.readUint8(), this.fieldOrdering = o.readUint8();
    }), h.createBoxCtor("frma", function(o) {
      this.data_format = o.readString(4);
    }), h.createBoxCtor("ftyp", function(o) {
      var c = this.size - this.hdr_size;
      this.major_brand = o.readString(4), this.minor_version = o.readUint32(), c -= 8, this.compatible_brands = [];
      for (var d = 0; c >= 4; )
        this.compatible_brands[d] = o.readString(4), c -= 4, d++;
    }), h.createFullBoxCtor("hdlr", function(o) {
      this.version === 0 && (o.readUint32(), this.handler = o.readString(4), o.readUint32Array(3), this.name = o.readString(this.size - this.hdr_size - 20), this.name[this.name.length - 1] === "\0" && (this.name = this.name.slice(0, -1)));
    }), h.createBoxCtor("hvcC", function(o) {
      var c, d, _, y;
      this.configurationVersion = o.readUint8(), y = o.readUint8(), this.general_profile_space = y >> 6, this.general_tier_flag = (y & 32) >> 5, this.general_profile_idc = y & 31, this.general_profile_compatibility = o.readUint32(), this.general_constraint_indicator = o.readUint8Array(6), this.general_level_idc = o.readUint8(), this.min_spatial_segmentation_idc = o.readUint16() & 4095, this.parallelismType = o.readUint8() & 3, this.chroma_format_idc = o.readUint8() & 3, this.bit_depth_luma_minus8 = o.readUint8() & 7, this.bit_depth_chroma_minus8 = o.readUint8() & 7, this.avgFrameRate = o.readUint16(), y = o.readUint8(), this.constantFrameRate = y >> 6, this.numTemporalLayers = (y & 13) >> 3, this.temporalIdNested = (y & 4) >> 2, this.lengthSizeMinusOne = y & 3, this.nalu_arrays = [];
      var v = o.readUint8();
      for (c = 0; c < v; c++) {
        var b = [];
        this.nalu_arrays.push(b), y = o.readUint8(), b.completeness = (y & 128) >> 7, b.nalu_type = y & 63;
        var w = o.readUint16();
        for (d = 0; d < w; d++) {
          var S = {};
          b.push(S), _ = o.readUint16(), S.data = o.readUint8Array(_);
        }
      }
    }), h.createFullBoxCtor("iinf", function(o) {
      var c;
      this.version === 0 ? this.entry_count = o.readUint16() : this.entry_count = o.readUint32(), this.item_infos = [];
      for (var d = 0; d < this.entry_count; d++)
        if (c = h.parseOneBox(o, !1, this.size - (o.getPosition() - this.start)), c.code === h.OK)
          c.box.type !== "infe" && t.error("BoxParser", "Expected 'infe' box, got " + c.box.type), this.item_infos[d] = c.box;
        else
          return;
    }), h.createFullBoxCtor("iloc", function(o) {
      var c;
      c = o.readUint8(), this.offset_size = c >> 4 & 15, this.length_size = c & 15, c = o.readUint8(), this.base_offset_size = c >> 4 & 15, this.version === 1 || this.version === 2 ? this.index_size = c & 15 : this.index_size = 0, this.items = [];
      var d = 0;
      if (this.version < 2)
        d = o.readUint16();
      else if (this.version === 2)
        d = o.readUint32();
      else
        throw "version of iloc box not supported";
      for (var _ = 0; _ < d; _++) {
        var y = {};
        if (this.items.push(y), this.version < 2)
          y.item_ID = o.readUint16();
        else if (this.version === 2)
          y.item_ID = o.readUint32();
        else
          throw "version of iloc box not supported";
        switch (this.version === 1 || this.version === 2 ? y.construction_method = o.readUint16() & 15 : y.construction_method = 0, y.data_reference_index = o.readUint16(), this.base_offset_size) {
          case 0:
            y.base_offset = 0;
            break;
          case 4:
            y.base_offset = o.readUint32();
            break;
          case 8:
            y.base_offset = o.readUint64();
            break;
          default:
            throw "Error reading base offset size";
        }
        var v = o.readUint16();
        y.extents = [];
        for (var b = 0; b < v; b++) {
          var w = {};
          if (y.extents.push(w), this.version === 1 || this.version === 2)
            switch (this.index_size) {
              case 0:
                w.extent_index = 0;
                break;
              case 4:
                w.extent_index = o.readUint32();
                break;
              case 8:
                w.extent_index = o.readUint64();
                break;
              default:
                throw "Error reading extent index";
            }
          switch (this.offset_size) {
            case 0:
              w.extent_offset = 0;
              break;
            case 4:
              w.extent_offset = o.readUint32();
              break;
            case 8:
              w.extent_offset = o.readUint64();
              break;
            default:
              throw "Error reading extent index";
          }
          switch (this.length_size) {
            case 0:
              w.extent_length = 0;
              break;
            case 4:
              w.extent_length = o.readUint32();
              break;
            case 8:
              w.extent_length = o.readUint64();
              break;
            default:
              throw "Error reading extent index";
          }
        }
      }
    }), h.createBoxCtor("imir", function(o) {
      var c = o.readUint8();
      this.reserved = c >> 7, this.axis = c & 1;
    }), h.createFullBoxCtor("infe", function(o) {
      if ((this.version === 0 || this.version === 1) && (this.item_ID = o.readUint16(), this.item_protection_index = o.readUint16(), this.item_name = o.readCString(), this.content_type = o.readCString(), this.content_encoding = o.readCString()), this.version === 1) {
        this.extension_type = o.readString(4), t.warn("BoxParser", "Cannot parse extension type"), o.seek(this.start + this.size);
        return;
      }
      this.version >= 2 && (this.version === 2 ? this.item_ID = o.readUint16() : this.version === 3 && (this.item_ID = o.readUint32()), this.item_protection_index = o.readUint16(), this.item_type = o.readString(4), this.item_name = o.readCString(), this.item_type === "mime" ? (this.content_type = o.readCString(), this.content_encoding = o.readCString()) : this.item_type === "uri " && (this.item_uri_type = o.readCString()));
    }), h.createFullBoxCtor("ipma", function(o) {
      var c, d;
      for (entry_count = o.readUint32(), this.associations = [], c = 0; c < entry_count; c++) {
        var _ = {};
        this.associations.push(_), this.version < 1 ? _.id = o.readUint16() : _.id = o.readUint32();
        var y = o.readUint8();
        for (_.props = [], d = 0; d < y; d++) {
          var v = o.readUint8(), b = {};
          _.props.push(b), b.essential = (v & 128) >> 7 === 1, this.flags & 1 ? b.property_index = (v & 127) << 8 | o.readUint8() : b.property_index = v & 127;
        }
      }
    }), h.createFullBoxCtor("iref", function(o) {
      var c, d;
      for (this.references = []; o.getPosition() < this.start + this.size; )
        if (c = h.parseOneBox(o, !0, this.size - (o.getPosition() - this.start)), c.code === h.OK)
          this.version === 0 ? d = new h.SingleItemTypeReferenceBox(c.type, c.size, c.hdr_size, c.start) : d = new h.SingleItemTypeReferenceBoxLarge(c.type, c.size, c.hdr_size, c.start), d.write === h.Box.prototype.write && d.type !== "mdat" && (t.warn("BoxParser", d.type + " box writing not yet implemented, keeping unparsed data in memory for later write"), d.parseDataAndRewind(o)), d.parse(o), this.references.push(d);
        else
          return;
    }), h.createBoxCtor("irot", function(o) {
      this.angle = o.readUint8() & 3;
    }), h.createFullBoxCtor("ispe", function(o) {
      this.image_width = o.readUint32(), this.image_height = o.readUint32();
    }), h.createFullBoxCtor("kind", function(o) {
      this.schemeURI = o.readCString(), this.value = o.readCString();
    }), h.createFullBoxCtor("leva", function(o) {
      var c = o.readUint8();
      this.levels = [];
      for (var d = 0; d < c; d++) {
        var _ = {};
        this.levels[d] = _, _.track_ID = o.readUint32();
        var y = o.readUint8();
        switch (_.padding_flag = y >> 7, _.assignment_type = y & 127, _.assignment_type) {
          case 0:
            _.grouping_type = o.readString(4);
            break;
          case 1:
            _.grouping_type = o.readString(4), _.grouping_type_parameter = o.readUint32();
            break;
          case 2:
            break;
          case 3:
            break;
          case 4:
            _.sub_track_id = o.readUint32();
            break;
          default:
            t.warn("BoxParser", "Unknown leva assignement type");
        }
      }
    }), h.createBoxCtor("lhvC", function(o) {
      var c, d, _;
      this.configurationVersion = o.readUint8(), this.min_spatial_segmentation_idc = o.readUint16() & 4095, this.parallelismType = o.readUint8() & 3, _ = o.readUint8(), this.numTemporalLayers = (_ & 13) >> 3, this.temporalIdNested = (_ & 4) >> 2, this.lengthSizeMinusOne = _ & 3, this.nalu_arrays = [];
      var y = o.readUint8();
      for (c = 0; c < y; c++) {
        var v = [];
        this.nalu_arrays.push(v), _ = o.readUint8(), v.completeness = (_ & 128) >> 7, v.nalu_type = _ & 63;
        var b = o.readUint16();
        for (d = 0; d < b; d++) {
          var w = {};
          v.push(w);
          var S = o.readUint16();
          w.data = o.readUint8Array(S);
        }
      }
    }), h.createBoxCtor("lsel", function(o) {
      this.layer_id = o.readUint16();
    }), h.createBoxCtor("maxr", function(o) {
      this.period = o.readUint32(), this.bytes = o.readUint32();
    });
    function u(o, c) {
      this.x = o, this.y = c;
    }
    u.prototype.toString = function() {
      return "(" + this.x + "," + this.y + ")";
    }, h.createBoxCtor("mdcv", function(o) {
      this.display_primaries = [], this.display_primaries[0] = new u(o.readUint16(), o.readUint16()), this.display_primaries[1] = new u(o.readUint16(), o.readUint16()), this.display_primaries[2] = new u(o.readUint16(), o.readUint16()), this.white_point = new u(o.readUint16(), o.readUint16()), this.max_display_mastering_luminance = o.readUint32(), this.min_display_mastering_luminance = o.readUint32();
    }), h.createFullBoxCtor("mdhd", function(o) {
      this.version == 1 ? (this.creation_time = o.readUint64(), this.modification_time = o.readUint64(), this.timescale = o.readUint32(), this.duration = o.readUint64()) : (this.creation_time = o.readUint32(), this.modification_time = o.readUint32(), this.timescale = o.readUint32(), this.duration = o.readUint32()), this.parseLanguage(o), o.readUint16();
    }), h.createFullBoxCtor("mehd", function(o) {
      this.flags & 1 && (t.warn("BoxParser", "mehd box incorrectly uses flags set to 1, converting version to 1"), this.version = 1), this.version == 1 ? this.fragment_duration = o.readUint64() : this.fragment_duration = o.readUint32();
    }), h.createFullBoxCtor("meta", function(o) {
      this.boxes = [], h.ContainerBox.prototype.parse.call(this, o);
    }), h.createFullBoxCtor("mfhd", function(o) {
      this.sequence_number = o.readUint32();
    }), h.createFullBoxCtor("mfro", function(o) {
      this._size = o.readUint32();
    }), h.createFullBoxCtor("mskC", function(o) {
      this.bits_per_pixel = o.readUint8();
    }), h.createFullBoxCtor("mvhd", function(o) {
      this.version == 1 ? (this.creation_time = o.readUint64(), this.modification_time = o.readUint64(), this.timescale = o.readUint32(), this.duration = o.readUint64()) : (this.creation_time = o.readUint32(), this.modification_time = o.readUint32(), this.timescale = o.readUint32(), this.duration = o.readUint32()), this.rate = o.readUint32(), this.volume = o.readUint16() >> 8, o.readUint16(), o.readUint32Array(2), this.matrix = o.readUint32Array(9), o.readUint32Array(6), this.next_track_id = o.readUint32();
    }), h.createBoxCtor("npck", function(o) {
      this.packetssent = o.readUint32();
    }), h.createBoxCtor("nump", function(o) {
      this.packetssent = o.readUint64();
    }), h.createFullBoxCtor("padb", function(o) {
      var c = o.readUint32();
      this.padbits = [];
      for (var d = 0; d < Math.floor((c + 1) / 2); d++)
        this.padbits = o.readUint8();
    }), h.createBoxCtor("pasp", function(o) {
      this.hSpacing = o.readUint32(), this.vSpacing = o.readUint32();
    }), h.createBoxCtor("payl", function(o) {
      this.text = o.readString(this.size - this.hdr_size);
    }), h.createBoxCtor("payt", function(o) {
      this.payloadID = o.readUint32();
      var c = o.readUint8();
      this.rtpmap_string = o.readString(c);
    }), h.createFullBoxCtor("pdin", function(o) {
      var c = (this.size - this.hdr_size) / 8;
      this.rate = [], this.initial_delay = [];
      for (var d = 0; d < c; d++)
        this.rate[d] = o.readUint32(), this.initial_delay[d] = o.readUint32();
    }), h.createFullBoxCtor("pitm", function(o) {
      this.version === 0 ? this.item_id = o.readUint16() : this.item_id = o.readUint32();
    }), h.createFullBoxCtor("pixi", function(o) {
      var c;
      for (this.num_channels = o.readUint8(), this.bits_per_channels = [], c = 0; c < this.num_channels; c++)
        this.bits_per_channels[c] = o.readUint8();
    }), h.createBoxCtor("pmax", function(o) {
      this.bytes = o.readUint32();
    }), h.createFullBoxCtor("prdi", function(o) {
      if (this.step_count = o.readUint16(), this.item_count = [], this.flags & 2)
        for (var c = 0; c < this.step_count; c++)
          this.item_count[c] = o.readUint16();
    }), h.createFullBoxCtor("prft", function(o) {
      this.ref_track_id = o.readUint32(), this.ntp_timestamp = o.readUint64(), this.version === 0 ? this.media_time = o.readUint32() : this.media_time = o.readUint64();
    }), h.createFullBoxCtor("pssh", function(o) {
      if (this.system_id = h.parseHex16(o), this.version > 0) {
        var c = o.readUint32();
        this.kid = [];
        for (var d = 0; d < c; d++)
          this.kid[d] = h.parseHex16(o);
      }
      var _ = o.readUint32();
      _ > 0 && (this.data = o.readUint8Array(_));
    }), h.createFullBoxCtor("clef", function(o) {
      this.width = o.readUint32(), this.height = o.readUint32();
    }), h.createFullBoxCtor("enof", function(o) {
      this.width = o.readUint32(), this.height = o.readUint32();
    }), h.createFullBoxCtor("prof", function(o) {
      this.width = o.readUint32(), this.height = o.readUint32();
    }), h.createContainerBoxCtor("tapt", null, ["clef", "prof", "enof"]), h.createBoxCtor("rtp ", function(o) {
      this.descriptionformat = o.readString(4), this.sdptext = o.readString(this.size - this.hdr_size - 4);
    }), h.createFullBoxCtor("saio", function(o) {
      this.flags & 1 && (this.aux_info_type = o.readUint32(), this.aux_info_type_parameter = o.readUint32());
      var c = o.readUint32();
      this.offset = [];
      for (var d = 0; d < c; d++)
        this.version === 0 ? this.offset[d] = o.readUint32() : this.offset[d] = o.readUint64();
    }), h.createFullBoxCtor("saiz", function(o) {
      this.flags & 1 && (this.aux_info_type = o.readUint32(), this.aux_info_type_parameter = o.readUint32()), this.default_sample_info_size = o.readUint8();
      var c = o.readUint32();
      if (this.sample_info_size = [], this.default_sample_info_size === 0)
        for (var d = 0; d < c; d++)
          this.sample_info_size[d] = o.readUint8();
    }), h.createSampleEntryCtor(h.SAMPLE_ENTRY_TYPE_METADATA, "mett", function(o) {
      this.parseHeader(o), this.content_encoding = o.readCString(), this.mime_format = o.readCString(), this.parseFooter(o);
    }), h.createSampleEntryCtor(h.SAMPLE_ENTRY_TYPE_METADATA, "metx", function(o) {
      this.parseHeader(o), this.content_encoding = o.readCString(), this.namespace = o.readCString(), this.schema_location = o.readCString(), this.parseFooter(o);
    }), h.createSampleEntryCtor(h.SAMPLE_ENTRY_TYPE_SUBTITLE, "sbtt", function(o) {
      this.parseHeader(o), this.content_encoding = o.readCString(), this.mime_format = o.readCString(), this.parseFooter(o);
    }), h.createSampleEntryCtor(h.SAMPLE_ENTRY_TYPE_SUBTITLE, "stpp", function(o) {
      this.parseHeader(o), this.namespace = o.readCString(), this.schema_location = o.readCString(), this.auxiliary_mime_types = o.readCString(), this.parseFooter(o);
    }), h.createSampleEntryCtor(h.SAMPLE_ENTRY_TYPE_SUBTITLE, "stxt", function(o) {
      this.parseHeader(o), this.content_encoding = o.readCString(), this.mime_format = o.readCString(), this.parseFooter(o);
    }), h.createSampleEntryCtor(h.SAMPLE_ENTRY_TYPE_SUBTITLE, "tx3g", function(o) {
      this.parseHeader(o), this.displayFlags = o.readUint32(), this.horizontal_justification = o.readInt8(), this.vertical_justification = o.readInt8(), this.bg_color_rgba = o.readUint8Array(4), this.box_record = o.readInt16Array(4), this.style_record = o.readUint8Array(12), this.parseFooter(o);
    }), h.createSampleEntryCtor(h.SAMPLE_ENTRY_TYPE_METADATA, "wvtt", function(o) {
      this.parseHeader(o), this.parseFooter(o);
    }), h.createSampleGroupCtor("alst", function(o) {
      var c, d = o.readUint16();
      for (this.first_output_sample = o.readUint16(), this.sample_offset = [], c = 0; c < d; c++)
        this.sample_offset[c] = o.readUint32();
      var _ = this.description_length - 4 - 4 * d;
      for (this.num_output_samples = [], this.num_total_samples = [], c = 0; c < _ / 4; c++)
        this.num_output_samples[c] = o.readUint16(), this.num_total_samples[c] = o.readUint16();
    }), h.createSampleGroupCtor("avll", function(o) {
      this.layerNumber = o.readUint8(), this.accurateStatisticsFlag = o.readUint8(), this.avgBitRate = o.readUint16(), this.avgFrameRate = o.readUint16();
    }), h.createSampleGroupCtor("avss", function(o) {
      this.subSequenceIdentifier = o.readUint16(), this.layerNumber = o.readUint8();
      var c = o.readUint8();
      this.durationFlag = c >> 7, this.avgRateFlag = c >> 6 & 1, this.durationFlag && (this.duration = o.readUint32()), this.avgRateFlag && (this.accurateStatisticsFlag = o.readUint8(), this.avgBitRate = o.readUint16(), this.avgFrameRate = o.readUint16()), this.dependency = [];
      for (var d = o.readUint8(), _ = 0; _ < d; _++) {
        var y = {};
        this.dependency.push(y), y.subSeqDirectionFlag = o.readUint8(), y.layerNumber = o.readUint8(), y.subSequenceIdentifier = o.readUint16();
      }
    }), h.createSampleGroupCtor("dtrt", function(o) {
      t.warn("BoxParser", "Sample Group type: " + this.grouping_type + " not fully parsed");
    }), h.createSampleGroupCtor("mvif", function(o) {
      t.warn("BoxParser", "Sample Group type: " + this.grouping_type + " not fully parsed");
    }), h.createSampleGroupCtor("prol", function(o) {
      this.roll_distance = o.readInt16();
    }), h.createSampleGroupCtor("rap ", function(o) {
      var c = o.readUint8();
      this.num_leading_samples_known = c >> 7, this.num_leading_samples = c & 127;
    }), h.createSampleGroupCtor("rash", function(o) {
      if (this.operation_point_count = o.readUint16(), this.description_length !== 2 + (this.operation_point_count === 1 ? 2 : this.operation_point_count * 6) + 9)
        t.warn("BoxParser", "Mismatch in " + this.grouping_type + " sample group length"), this.data = o.readUint8Array(this.description_length - 2);
      else {
        if (this.operation_point_count === 1)
          this.target_rate_share = o.readUint16();
        else {
          this.target_rate_share = [], this.available_bitrate = [];
          for (var c = 0; c < this.operation_point_count; c++)
            this.available_bitrate[c] = o.readUint32(), this.target_rate_share[c] = o.readUint16();
        }
        this.maximum_bitrate = o.readUint32(), this.minimum_bitrate = o.readUint32(), this.discard_priority = o.readUint8();
      }
    }), h.createSampleGroupCtor("roll", function(o) {
      this.roll_distance = o.readInt16();
    }), h.SampleGroupEntry.prototype.parse = function(o) {
      t.warn("BoxParser", "Unknown Sample Group type: " + this.grouping_type), this.data = o.readUint8Array(this.description_length);
    }, h.createSampleGroupCtor("scif", function(o) {
      t.warn("BoxParser", "Sample Group type: " + this.grouping_type + " not fully parsed");
    }), h.createSampleGroupCtor("scnm", function(o) {
      t.warn("BoxParser", "Sample Group type: " + this.grouping_type + " not fully parsed");
    }), h.createSampleGroupCtor("seig", function(o) {
      this.reserved = o.readUint8();
      var c = o.readUint8();
      this.crypt_byte_block = c >> 4, this.skip_byte_block = c & 15, this.isProtected = o.readUint8(), this.Per_Sample_IV_Size = o.readUint8(), this.KID = h.parseHex16(o), this.constant_IV_size = 0, this.constant_IV = 0, this.isProtected === 1 && this.Per_Sample_IV_Size === 0 && (this.constant_IV_size = o.readUint8(), this.constant_IV = o.readUint8Array(this.constant_IV_size));
    }), h.createSampleGroupCtor("stsa", function(o) {
      t.warn("BoxParser", "Sample Group type: " + this.grouping_type + " not fully parsed");
    }), h.createSampleGroupCtor("sync", function(o) {
      var c = o.readUint8();
      this.NAL_unit_type = c & 63;
    }), h.createSampleGroupCtor("tele", function(o) {
      var c = o.readUint8();
      this.level_independently_decodable = c >> 7;
    }), h.createSampleGroupCtor("tsas", function(o) {
      t.warn("BoxParser", "Sample Group type: " + this.grouping_type + " not fully parsed");
    }), h.createSampleGroupCtor("tscl", function(o) {
      t.warn("BoxParser", "Sample Group type: " + this.grouping_type + " not fully parsed");
    }), h.createSampleGroupCtor("vipr", function(o) {
      t.warn("BoxParser", "Sample Group type: " + this.grouping_type + " not fully parsed");
    }), h.createFullBoxCtor("sbgp", function(o) {
      this.grouping_type = o.readString(4), this.version === 1 ? this.grouping_type_parameter = o.readUint32() : this.grouping_type_parameter = 0, this.entries = [];
      for (var c = o.readUint32(), d = 0; d < c; d++) {
        var _ = {};
        this.entries.push(_), _.sample_count = o.readInt32(), _.group_description_index = o.readInt32();
      }
    });
    function f(o, c) {
      this.bad_pixel_row = o, this.bad_pixel_column = c;
    }
    f.prototype.toString = function() {
      return "[row: " + this.bad_pixel_row + ", column: " + this.bad_pixel_column + "]";
    }, h.createFullBoxCtor("sbpm", function(o) {
      var c;
      for (this.component_count = o.readUint16(), this.component_index = [], c = 0; c < this.component_count; c++)
        this.component_index.push(o.readUint16());
      var d = o.readUint8();
      for (this.correction_applied = (d & 128) == 128, this.num_bad_rows = o.readUint32(), this.num_bad_cols = o.readUint32(), this.num_bad_pixels = o.readUint32(), this.bad_rows = [], this.bad_columns = [], this.bad_pixels = [], c = 0; c < this.num_bad_rows; c++)
        this.bad_rows.push(o.readUint32());
      for (c = 0; c < this.num_bad_cols; c++)
        this.bad_columns.push(o.readUint32());
      for (c = 0; c < this.num_bad_pixels; c++) {
        var _ = o.readUint32(), y = o.readUint32();
        this.bad_pixels.push(new f(_, y));
      }
    }), h.createFullBoxCtor("schm", function(o) {
      this.scheme_type = o.readString(4), this.scheme_version = o.readUint32(), this.flags & 1 && (this.scheme_uri = o.readString(this.size - this.hdr_size - 8));
    }), h.createBoxCtor("sdp ", function(o) {
      this.sdptext = o.readString(this.size - this.hdr_size);
    }), h.createFullBoxCtor("sdtp", function(o) {
      var c, d = this.size - this.hdr_size;
      this.is_leading = [], this.sample_depends_on = [], this.sample_is_depended_on = [], this.sample_has_redundancy = [];
      for (var _ = 0; _ < d; _++)
        c = o.readUint8(), this.is_leading[_] = c >> 6, this.sample_depends_on[_] = c >> 4 & 3, this.sample_is_depended_on[_] = c >> 2 & 3, this.sample_has_redundancy[_] = c & 3;
    }), h.createFullBoxCtor(
      "senc"
      /*, function(stream) {
      	this.parseFullHeader(stream);
      	var sample_count = stream.readUint32();
      	this.samples = [];
      	for (var i = 0; i < sample_count; i++) {
      		var sample = {};
      		// tenc.default_Per_Sample_IV_Size or seig.Per_Sample_IV_Size
      		sample.InitializationVector = this.readUint8Array(Per_Sample_IV_Size*8);
      		if (this.flags & 0x2) {
      			sample.subsamples = [];
      			subsample_count = stream.readUint16();
      			for (var j = 0; j < subsample_count; j++) {
      				var subsample = {};
      				subsample.BytesOfClearData = stream.readUint16();
      				subsample.BytesOfProtectedData = stream.readUint32();
      				sample.subsamples.push(subsample);
      			}
      		}
      		// TODO
      		this.samples.push(sample);
      	}
      }*/
    ), h.createFullBoxCtor("sgpd", function(o) {
      this.grouping_type = o.readString(4), t.debug("BoxParser", "Found Sample Groups of type " + this.grouping_type), this.version === 1 ? this.default_length = o.readUint32() : this.default_length = 0, this.version >= 2 && (this.default_group_description_index = o.readUint32()), this.entries = [];
      for (var c = o.readUint32(), d = 0; d < c; d++) {
        var _;
        h[this.grouping_type + "SampleGroupEntry"] ? _ = new h[this.grouping_type + "SampleGroupEntry"](this.grouping_type) : _ = new h.SampleGroupEntry(this.grouping_type), this.entries.push(_), this.version === 1 ? this.default_length === 0 ? _.description_length = o.readUint32() : _.description_length = this.default_length : _.description_length = this.default_length, _.write === h.SampleGroupEntry.prototype.write && (t.info("BoxParser", "SampleGroup for type " + this.grouping_type + " writing not yet implemented, keeping unparsed data in memory for later write"), _.data = o.readUint8Array(_.description_length), o.position -= _.description_length), _.parse(o);
      }
    }), h.createFullBoxCtor("sidx", function(o) {
      this.reference_ID = o.readUint32(), this.timescale = o.readUint32(), this.version === 0 ? (this.earliest_presentation_time = o.readUint32(), this.first_offset = o.readUint32()) : (this.earliest_presentation_time = o.readUint64(), this.first_offset = o.readUint64()), o.readUint16(), this.references = [];
      for (var c = o.readUint16(), d = 0; d < c; d++) {
        var _ = {};
        this.references.push(_);
        var y = o.readUint32();
        _.reference_type = y >> 31 & 1, _.referenced_size = y & 2147483647, _.subsegment_duration = o.readUint32(), y = o.readUint32(), _.starts_with_SAP = y >> 31 & 1, _.SAP_type = y >> 28 & 7, _.SAP_delta_time = y & 268435455;
      }
    }), h.SingleItemTypeReferenceBox = function(o, c, d, _) {
      h.Box.call(this, o, c), this.hdr_size = d, this.start = _;
    }, h.SingleItemTypeReferenceBox.prototype = new h.Box(), h.SingleItemTypeReferenceBox.prototype.parse = function(o) {
      this.from_item_ID = o.readUint16();
      var c = o.readUint16();
      this.references = [];
      for (var d = 0; d < c; d++)
        this.references[d] = {}, this.references[d].to_item_ID = o.readUint16();
    }, h.SingleItemTypeReferenceBoxLarge = function(o, c, d, _) {
      h.Box.call(this, o, c), this.hdr_size = d, this.start = _;
    }, h.SingleItemTypeReferenceBoxLarge.prototype = new h.Box(), h.SingleItemTypeReferenceBoxLarge.prototype.parse = function(o) {
      this.from_item_ID = o.readUint32();
      var c = o.readUint16();
      this.references = [];
      for (var d = 0; d < c; d++)
        this.references[d] = {}, this.references[d].to_item_ID = o.readUint32();
    }, h.createFullBoxCtor("SmDm", function(o) {
      this.primaryRChromaticity_x = o.readUint16(), this.primaryRChromaticity_y = o.readUint16(), this.primaryGChromaticity_x = o.readUint16(), this.primaryGChromaticity_y = o.readUint16(), this.primaryBChromaticity_x = o.readUint16(), this.primaryBChromaticity_y = o.readUint16(), this.whitePointChromaticity_x = o.readUint16(), this.whitePointChromaticity_y = o.readUint16(), this.luminanceMax = o.readUint32(), this.luminanceMin = o.readUint32();
    }), h.createFullBoxCtor("smhd", function(o) {
      this.balance = o.readUint16(), o.readUint16();
    }), h.createFullBoxCtor("ssix", function(o) {
      this.subsegments = [];
      for (var c = o.readUint32(), d = 0; d < c; d++) {
        var _ = {};
        this.subsegments.push(_), _.ranges = [];
        for (var y = o.readUint32(), v = 0; v < y; v++) {
          var b = {};
          _.ranges.push(b), b.level = o.readUint8(), b.range_size = o.readUint24();
        }
      }
    }), h.createFullBoxCtor("stco", function(o) {
      var c;
      if (c = o.readUint32(), this.chunk_offsets = [], this.version === 0)
        for (var d = 0; d < c; d++)
          this.chunk_offsets.push(o.readUint32());
    }), h.createFullBoxCtor("stdp", function(o) {
      var c = (this.size - this.hdr_size) / 2;
      this.priority = [];
      for (var d = 0; d < c; d++)
        this.priority[d] = o.readUint16();
    }), h.createFullBoxCtor("sthd"), h.createFullBoxCtor("stri", function(o) {
      this.switch_group = o.readUint16(), this.alternate_group = o.readUint16(), this.sub_track_id = o.readUint32();
      var c = (this.size - this.hdr_size - 8) / 4;
      this.attribute_list = [];
      for (var d = 0; d < c; d++)
        this.attribute_list[d] = o.readUint32();
    }), h.createFullBoxCtor("stsc", function(o) {
      var c, d;
      if (c = o.readUint32(), this.first_chunk = [], this.samples_per_chunk = [], this.sample_description_index = [], this.version === 0)
        for (d = 0; d < c; d++)
          this.first_chunk.push(o.readUint32()), this.samples_per_chunk.push(o.readUint32()), this.sample_description_index.push(o.readUint32());
    }), h.createFullBoxCtor("stsd", function(o) {
      var c, d, _, y;
      for (this.entries = [], _ = o.readUint32(), c = 1; c <= _; c++)
        if (d = h.parseOneBox(o, !0, this.size - (o.getPosition() - this.start)), d.code === h.OK)
          h[d.type + "SampleEntry"] ? (y = new h[d.type + "SampleEntry"](d.size), y.hdr_size = d.hdr_size, y.start = d.start) : (t.warn("BoxParser", "Unknown sample entry type: " + d.type), y = new h.SampleEntry(d.type, d.size, d.hdr_size, d.start)), y.write === h.SampleEntry.prototype.write && (t.info("BoxParser", "SampleEntry " + y.type + " box writing not yet implemented, keeping unparsed data in memory for later write"), y.parseDataAndRewind(o)), y.parse(o), this.entries.push(y);
        else
          return;
    }), h.createFullBoxCtor("stsg", function(o) {
      this.grouping_type = o.readUint32();
      var c = o.readUint16();
      this.group_description_index = [];
      for (var d = 0; d < c; d++)
        this.group_description_index[d] = o.readUint32();
    }), h.createFullBoxCtor("stsh", function(o) {
      var c, d;
      if (c = o.readUint32(), this.shadowed_sample_numbers = [], this.sync_sample_numbers = [], this.version === 0)
        for (d = 0; d < c; d++)
          this.shadowed_sample_numbers.push(o.readUint32()), this.sync_sample_numbers.push(o.readUint32());
    }), h.createFullBoxCtor("stss", function(o) {
      var c, d;
      if (d = o.readUint32(), this.version === 0)
        for (this.sample_numbers = [], c = 0; c < d; c++)
          this.sample_numbers.push(o.readUint32());
    }), h.createFullBoxCtor("stsz", function(o) {
      var c;
      if (this.sample_sizes = [], this.version === 0)
        for (this.sample_size = o.readUint32(), this.sample_count = o.readUint32(), c = 0; c < this.sample_count; c++)
          this.sample_size === 0 ? this.sample_sizes.push(o.readUint32()) : this.sample_sizes[c] = this.sample_size;
    }), h.createFullBoxCtor("stts", function(o) {
      var c, d, _;
      if (c = o.readUint32(), this.sample_counts = [], this.sample_deltas = [], this.version === 0)
        for (d = 0; d < c; d++)
          this.sample_counts.push(o.readUint32()), _ = o.readInt32(), _ < 0 && (t.warn("BoxParser", "File uses negative stts sample delta, using value 1 instead, sync may be lost!"), _ = 1), this.sample_deltas.push(_);
    }), h.createFullBoxCtor("stvi", function(o) {
      var c = o.readUint32();
      this.single_view_allowed = c & 3, this.stereo_scheme = o.readUint32();
      var d = o.readUint32();
      this.stereo_indication_type = o.readString(d);
      var _, y;
      for (this.boxes = []; o.getPosition() < this.start + this.size; )
        if (_ = h.parseOneBox(o, !1, this.size - (o.getPosition() - this.start)), _.code === h.OK)
          y = _.box, this.boxes.push(y), this[y.type] = y;
        else
          return;
    }), h.createBoxCtor("styp", function(o) {
      h.ftypBox.prototype.parse.call(this, o);
    }), h.createFullBoxCtor("stz2", function(o) {
      var c, d;
      if (this.sample_sizes = [], this.version === 0)
        if (this.reserved = o.readUint24(), this.field_size = o.readUint8(), d = o.readUint32(), this.field_size === 4)
          for (c = 0; c < d; c += 2) {
            var _ = o.readUint8();
            this.sample_sizes[c] = _ >> 4 & 15, this.sample_sizes[c + 1] = _ & 15;
          }
        else if (this.field_size === 8)
          for (c = 0; c < d; c++)
            this.sample_sizes[c] = o.readUint8();
        else if (this.field_size === 16)
          for (c = 0; c < d; c++)
            this.sample_sizes[c] = o.readUint16();
        else
          t.error("BoxParser", "Error in length field in stz2 box");
    }), h.createFullBoxCtor("subs", function(o) {
      var c, d, _, y;
      for (_ = o.readUint32(), this.entries = [], c = 0; c < _; c++) {
        var v = {};
        if (this.entries[c] = v, v.sample_delta = o.readUint32(), v.subsamples = [], y = o.readUint16(), y > 0)
          for (d = 0; d < y; d++) {
            var b = {};
            v.subsamples.push(b), this.version == 1 ? b.size = o.readUint32() : b.size = o.readUint16(), b.priority = o.readUint8(), b.discardable = o.readUint8(), b.codec_specific_parameters = o.readUint32();
          }
      }
    }), h.createFullBoxCtor("tenc", function(o) {
      if (o.readUint8(), this.version === 0)
        o.readUint8();
      else {
        var c = o.readUint8();
        this.default_crypt_byte_block = c >> 4 & 15, this.default_skip_byte_block = c & 15;
      }
      this.default_isProtected = o.readUint8(), this.default_Per_Sample_IV_Size = o.readUint8(), this.default_KID = h.parseHex16(o), this.default_isProtected === 1 && this.default_Per_Sample_IV_Size === 0 && (this.default_constant_IV_size = o.readUint8(), this.default_constant_IV = o.readUint8Array(this.default_constant_IV_size));
    }), h.createFullBoxCtor("tfdt", function(o) {
      this.version == 1 ? this.baseMediaDecodeTime = o.readUint64() : this.baseMediaDecodeTime = o.readUint32();
    }), h.createFullBoxCtor("tfhd", function(o) {
      var c = 0;
      this.track_id = o.readUint32(), this.size - this.hdr_size > c && this.flags & h.TFHD_FLAG_BASE_DATA_OFFSET ? (this.base_data_offset = o.readUint64(), c += 8) : this.base_data_offset = 0, this.size - this.hdr_size > c && this.flags & h.TFHD_FLAG_SAMPLE_DESC ? (this.default_sample_description_index = o.readUint32(), c += 4) : this.default_sample_description_index = 0, this.size - this.hdr_size > c && this.flags & h.TFHD_FLAG_SAMPLE_DUR ? (this.default_sample_duration = o.readUint32(), c += 4) : this.default_sample_duration = 0, this.size - this.hdr_size > c && this.flags & h.TFHD_FLAG_SAMPLE_SIZE ? (this.default_sample_size = o.readUint32(), c += 4) : this.default_sample_size = 0, this.size - this.hdr_size > c && this.flags & h.TFHD_FLAG_SAMPLE_FLAGS ? (this.default_sample_flags = o.readUint32(), c += 4) : this.default_sample_flags = 0;
    }), h.createFullBoxCtor("tfra", function(o) {
      this.track_ID = o.readUint32(), o.readUint24();
      var c = o.readUint8();
      this.length_size_of_traf_num = c >> 4 & 3, this.length_size_of_trun_num = c >> 2 & 3, this.length_size_of_sample_num = c & 3, this.entries = [];
      for (var d = o.readUint32(), _ = 0; _ < d; _++)
        this.version === 1 ? (this.time = o.readUint64(), this.moof_offset = o.readUint64()) : (this.time = o.readUint32(), this.moof_offset = o.readUint32()), this.traf_number = o["readUint" + 8 * (this.length_size_of_traf_num + 1)](), this.trun_number = o["readUint" + 8 * (this.length_size_of_trun_num + 1)](), this.sample_number = o["readUint" + 8 * (this.length_size_of_sample_num + 1)]();
    }), h.createFullBoxCtor("tkhd", function(o) {
      this.version == 1 ? (this.creation_time = o.readUint64(), this.modification_time = o.readUint64(), this.track_id = o.readUint32(), o.readUint32(), this.duration = o.readUint64()) : (this.creation_time = o.readUint32(), this.modification_time = o.readUint32(), this.track_id = o.readUint32(), o.readUint32(), this.duration = o.readUint32()), o.readUint32Array(2), this.layer = o.readInt16(), this.alternate_group = o.readInt16(), this.volume = o.readInt16() >> 8, o.readUint16(), this.matrix = o.readInt32Array(9), this.width = o.readUint32(), this.height = o.readUint32();
    }), h.createBoxCtor("tmax", function(o) {
      this.time = o.readUint32();
    }), h.createBoxCtor("tmin", function(o) {
      this.time = o.readUint32();
    }), h.createBoxCtor("totl", function(o) {
      this.bytessent = o.readUint32();
    }), h.createBoxCtor("tpay", function(o) {
      this.bytessent = o.readUint32();
    }), h.createBoxCtor("tpyl", function(o) {
      this.bytessent = o.readUint64();
    }), h.TrackGroupTypeBox.prototype.parse = function(o) {
      this.parseFullHeader(o), this.track_group_id = o.readUint32();
    }, h.createTrackGroupCtor("msrc"), h.TrackReferenceTypeBox = function(o, c, d, _) {
      h.Box.call(this, o, c), this.hdr_size = d, this.start = _;
    }, h.TrackReferenceTypeBox.prototype = new h.Box(), h.TrackReferenceTypeBox.prototype.parse = function(o) {
      this.track_ids = o.readUint32Array((this.size - this.hdr_size) / 4);
    }, h.trefBox.prototype.parse = function(o) {
      for (var c, d; o.getPosition() < this.start + this.size; )
        if (c = h.parseOneBox(o, !0, this.size - (o.getPosition() - this.start)), c.code === h.OK)
          d = new h.TrackReferenceTypeBox(c.type, c.size, c.hdr_size, c.start), d.write === h.Box.prototype.write && d.type !== "mdat" && (t.info("BoxParser", "TrackReference " + d.type + " box writing not yet implemented, keeping unparsed data in memory for later write"), d.parseDataAndRewind(o)), d.parse(o), this.boxes.push(d);
        else
          return;
    }, h.createFullBoxCtor("trep", function(o) {
      for (this.track_ID = o.readUint32(), this.boxes = []; o.getPosition() < this.start + this.size; )
        if (ret = h.parseOneBox(o, !1, this.size - (o.getPosition() - this.start)), ret.code === h.OK)
          box = ret.box, this.boxes.push(box);
        else
          return;
    }), h.createFullBoxCtor("trex", function(o) {
      this.track_id = o.readUint32(), this.default_sample_description_index = o.readUint32(), this.default_sample_duration = o.readUint32(), this.default_sample_size = o.readUint32(), this.default_sample_flags = o.readUint32();
    }), h.createBoxCtor("trpy", function(o) {
      this.bytessent = o.readUint64();
    }), h.createFullBoxCtor("trun", function(o) {
      var c = 0;
      if (this.sample_count = o.readUint32(), c += 4, this.size - this.hdr_size > c && this.flags & h.TRUN_FLAGS_DATA_OFFSET ? (this.data_offset = o.readInt32(), c += 4) : this.data_offset = 0, this.size - this.hdr_size > c && this.flags & h.TRUN_FLAGS_FIRST_FLAG ? (this.first_sample_flags = o.readUint32(), c += 4) : this.first_sample_flags = 0, this.sample_duration = [], this.sample_size = [], this.sample_flags = [], this.sample_composition_time_offset = [], this.size - this.hdr_size > c)
        for (var d = 0; d < this.sample_count; d++)
          this.flags & h.TRUN_FLAGS_DURATION && (this.sample_duration[d] = o.readUint32()), this.flags & h.TRUN_FLAGS_SIZE && (this.sample_size[d] = o.readUint32()), this.flags & h.TRUN_FLAGS_FLAGS && (this.sample_flags[d] = o.readUint32()), this.flags & h.TRUN_FLAGS_CTS_OFFSET && (this.version === 0 ? this.sample_composition_time_offset[d] = o.readUint32() : this.sample_composition_time_offset[d] = o.readInt32());
    }), h.createFullBoxCtor("tsel", function(o) {
      this.switch_group = o.readUint32();
      var c = (this.size - this.hdr_size - 4) / 4;
      this.attribute_list = [];
      for (var d = 0; d < c; d++)
        this.attribute_list[d] = o.readUint32();
    }), h.createFullBoxCtor("txtC", function(o) {
      this.config = o.readCString();
    }), h.createBoxCtor("tyco", function(o) {
      var c = (this.size - this.hdr_size) / 4;
      this.compatible_brands = [];
      for (var d = 0; d < c; d++)
        this.compatible_brands[d] = o.readString(4);
    }), h.createFullBoxCtor("udes", function(o) {
      this.lang = o.readCString(), this.name = o.readCString(), this.description = o.readCString(), this.tags = o.readCString();
    }), h.createFullBoxCtor("uncC", function(o) {
      var c;
      if (this.profile = o.readUint32(), this.version != 1) {
        if (this.version == 0) {
          for (this.component_count = o.readUint32(), this.component_index = [], this.component_bit_depth_minus_one = [], this.component_format = [], this.component_align_size = [], c = 0; c < this.component_count; c++)
            this.component_index.push(o.readUint16()), this.component_bit_depth_minus_one.push(o.readUint8()), this.component_format.push(o.readUint8()), this.component_align_size.push(o.readUint8());
          this.sampling_type = o.readUint8(), this.interleave_type = o.readUint8(), this.block_size = o.readUint8();
          var d = o.readUint8();
          this.component_little_endian = d >> 7 & 1, this.block_pad_lsb = d >> 6 & 1, this.block_little_endian = d >> 5 & 1, this.block_reversed = d >> 4 & 1, this.pad_unknown = d >> 3 & 1, this.pixel_size = o.readUint32(), this.row_align_size = o.readUint32(), this.tile_align_size = o.readUint32(), this.num_tile_cols_minus_one = o.readUint32(), this.num_tile_rows_minus_one = o.readUint32();
        }
      }
    }), h.createFullBoxCtor("url ", function(o) {
      this.flags !== 1 && (this.location = o.readCString());
    }), h.createFullBoxCtor("urn ", function(o) {
      this.name = o.readCString(), this.size - this.hdr_size - this.name.length - 1 > 0 && (this.location = o.readCString());
    }), h.createUUIDBox("a5d40b30e81411ddba2f0800200c9a66", !0, !1, function(o) {
      this.LiveServerManifest = o.readString(this.size - this.hdr_size).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
    }), h.createUUIDBox("d08a4f1810f34a82b6c832d8aba183d3", !0, !1, function(o) {
      this.system_id = h.parseHex16(o);
      var c = o.readUint32();
      c > 0 && (this.data = o.readUint8Array(c));
    }), h.createUUIDBox(
      "a2394f525a9b4f14a2446c427c648df4",
      !0,
      !1
      /*, function(stream) {
      	if (this.flags & 0x1) {
      		this.AlgorithmID = stream.readUint24();
      		this.IV_size = stream.readUint8();
      		this.KID = BoxParser.parseHex16(stream);
      	}
      	var sample_count = stream.readUint32();
      	this.samples = [];
      	for (var i = 0; i < sample_count; i++) {
      		var sample = {};
      		sample.InitializationVector = this.readUint8Array(this.IV_size*8);
      		if (this.flags & 0x2) {
      			sample.subsamples = [];
      			sample.NumberOfEntries = stream.readUint16();
      			for (var j = 0; j < sample.NumberOfEntries; j++) {
      				var subsample = {};
      				subsample.BytesOfClearData = stream.readUint16();
      				subsample.BytesOfProtectedData = stream.readUint32();
      				sample.subsamples.push(subsample);
      			}
      		}
      		this.samples.push(sample);
      	}
      }*/
    ), h.createUUIDBox("8974dbce7be74c5184f97148f9882554", !0, !1, function(o) {
      this.default_AlgorithmID = o.readUint24(), this.default_IV_size = o.readUint8(), this.default_KID = h.parseHex16(o);
    }), h.createUUIDBox("d4807ef2ca3946958e5426cb9e46a79f", !0, !1, function(o) {
      this.fragment_count = o.readUint8(), this.entries = [];
      for (var c = 0; c < this.fragment_count; c++) {
        var d = {}, _ = 0, y = 0;
        this.version === 1 ? (_ = o.readUint64(), y = o.readUint64()) : (_ = o.readUint32(), y = o.readUint32()), d.absolute_time = _, d.absolute_duration = y, this.entries.push(d);
      }
    }), h.createUUIDBox("6d1d9b0542d544e680e2141daff757b2", !0, !1, function(o) {
      this.version === 1 ? (this.absolute_time = o.readUint64(), this.duration = o.readUint64()) : (this.absolute_time = o.readUint32(), this.duration = o.readUint32());
    }), h.createFullBoxCtor("vmhd", function(o) {
      this.graphicsmode = o.readUint16(), this.opcolor = o.readUint16Array(3);
    }), h.createFullBoxCtor("vpcC", function(o) {
      var c;
      this.version === 1 ? (this.profile = o.readUint8(), this.level = o.readUint8(), c = o.readUint8(), this.bitDepth = c >> 4, this.chromaSubsampling = c >> 1 & 7, this.videoFullRangeFlag = c & 1, this.colourPrimaries = o.readUint8(), this.transferCharacteristics = o.readUint8(), this.matrixCoefficients = o.readUint8(), this.codecIntializationDataSize = o.readUint16(), this.codecIntializationData = o.readUint8Array(this.codecIntializationDataSize)) : (this.profile = o.readUint8(), this.level = o.readUint8(), c = o.readUint8(), this.bitDepth = c >> 4 & 15, this.colorSpace = c & 15, c = o.readUint8(), this.chromaSubsampling = c >> 4 & 15, this.transferFunction = c >> 1 & 7, this.videoFullRangeFlag = c & 1, this.codecIntializationDataSize = o.readUint16(), this.codecIntializationData = o.readUint8Array(this.codecIntializationDataSize));
    }), h.createBoxCtor("vttC", function(o) {
      this.text = o.readString(this.size - this.hdr_size);
    }), h.createFullBoxCtor("vvcC", function(o) {
      var c, d, _ = {
        held_bits: void 0,
        num_held_bits: 0,
        stream_read_1_bytes: function(P) {
          this.held_bits = P.readUint8(), this.num_held_bits = 8;
        },
        stream_read_2_bytes: function(P) {
          this.held_bits = P.readUint16(), this.num_held_bits = 16;
        },
        extract_bits: function(P) {
          var B = this.held_bits >> this.num_held_bits - P & (1 << P) - 1;
          return this.num_held_bits -= P, B;
        }
      };
      if (_.stream_read_1_bytes(o), _.extract_bits(5), this.lengthSizeMinusOne = _.extract_bits(2), this.ptl_present_flag = _.extract_bits(1), this.ptl_present_flag) {
        _.stream_read_2_bytes(o), this.ols_idx = _.extract_bits(9), this.num_sublayers = _.extract_bits(3), this.constant_frame_rate = _.extract_bits(2), this.chroma_format_idc = _.extract_bits(2), _.stream_read_1_bytes(o), this.bit_depth_minus8 = _.extract_bits(3), _.extract_bits(5);
        {
          if (_.stream_read_2_bytes(o), _.extract_bits(2), this.num_bytes_constraint_info = _.extract_bits(6), this.general_profile_idc = _.extract_bits(7), this.general_tier_flag = _.extract_bits(1), this.general_level_idc = o.readUint8(), _.stream_read_1_bytes(o), this.ptl_frame_only_constraint_flag = _.extract_bits(1), this.ptl_multilayer_enabled_flag = _.extract_bits(1), this.general_constraint_info = new Uint8Array(this.num_bytes_constraint_info), this.num_bytes_constraint_info) {
            for (c = 0; c < this.num_bytes_constraint_info - 1; c++) {
              var y = _.extract_bits(6);
              _.stream_read_1_bytes(o);
              var v = _.extract_bits(2);
              this.general_constraint_info[c] = y << 2 | v;
            }
            this.general_constraint_info[this.num_bytes_constraint_info - 1] = _.extract_bits(6);
          } else
            _.extract_bits(6);
          if (this.num_sublayers > 1) {
            for (_.stream_read_1_bytes(o), this.ptl_sublayer_present_mask = 0, d = this.num_sublayers - 2; d >= 0; --d) {
              var b = _.extract_bits(1);
              this.ptl_sublayer_present_mask |= b << d;
            }
            for (d = this.num_sublayers; d <= 8 && this.num_sublayers > 1; ++d)
              _.extract_bits(1);
            for (this.sublayer_level_idc = [], d = this.num_sublayers - 2; d >= 0; --d)
              this.ptl_sublayer_present_mask & 1 << d && (this.sublayer_level_idc[d] = o.readUint8());
          }
          if (this.ptl_num_sub_profiles = o.readUint8(), this.general_sub_profile_idc = [], this.ptl_num_sub_profiles)
            for (c = 0; c < this.ptl_num_sub_profiles; c++)
              this.general_sub_profile_idc.push(o.readUint32());
        }
        this.max_picture_width = o.readUint16(), this.max_picture_height = o.readUint16(), this.avg_frame_rate = o.readUint16();
      }
      var w = 12, S = 13;
      this.nalu_arrays = [];
      var T = o.readUint8();
      for (c = 0; c < T; c++) {
        var E = [];
        this.nalu_arrays.push(E), _.stream_read_1_bytes(o), E.completeness = _.extract_bits(1), _.extract_bits(2), E.nalu_type = _.extract_bits(5);
        var C = 1;
        for (E.nalu_type != S && E.nalu_type != w && (C = o.readUint16()), d = 0; d < C; d++) {
          var M = o.readUint16();
          E.push({
            data: o.readUint8Array(M),
            length: M
          });
        }
      }
    }), h.createFullBoxCtor("vvnC", function(o) {
      var c = strm.readUint8();
      this.lengthSizeMinusOne = c & 3;
    }), h.SampleEntry.prototype.isVideo = function() {
      return !1;
    }, h.SampleEntry.prototype.isAudio = function() {
      return !1;
    }, h.SampleEntry.prototype.isSubtitle = function() {
      return !1;
    }, h.SampleEntry.prototype.isMetadata = function() {
      return !1;
    }, h.SampleEntry.prototype.isHint = function() {
      return !1;
    }, h.SampleEntry.prototype.getCodec = function() {
      return this.type.replace(".", "");
    }, h.SampleEntry.prototype.getWidth = function() {
      return "";
    }, h.SampleEntry.prototype.getHeight = function() {
      return "";
    }, h.SampleEntry.prototype.getChannelCount = function() {
      return "";
    }, h.SampleEntry.prototype.getSampleRate = function() {
      return "";
    }, h.SampleEntry.prototype.getSampleSize = function() {
      return "";
    }, h.VisualSampleEntry.prototype.isVideo = function() {
      return !0;
    }, h.VisualSampleEntry.prototype.getWidth = function() {
      return this.width;
    }, h.VisualSampleEntry.prototype.getHeight = function() {
      return this.height;
    }, h.AudioSampleEntry.prototype.isAudio = function() {
      return !0;
    }, h.AudioSampleEntry.prototype.getChannelCount = function() {
      return this.channel_count;
    }, h.AudioSampleEntry.prototype.getSampleRate = function() {
      return this.samplerate;
    }, h.AudioSampleEntry.prototype.getSampleSize = function() {
      return this.samplesize;
    }, h.SubtitleSampleEntry.prototype.isSubtitle = function() {
      return !0;
    }, h.MetadataSampleEntry.prototype.isMetadata = function() {
      return !0;
    }, h.decimalToHex = function(o, c) {
      var d = Number(o).toString(16);
      for (c = typeof c > "u" || c === null ? c = 2 : c; d.length < c; )
        d = "0" + d;
      return d;
    }, h.avc1SampleEntry.prototype.getCodec = h.avc2SampleEntry.prototype.getCodec = h.avc3SampleEntry.prototype.getCodec = h.avc4SampleEntry.prototype.getCodec = function() {
      var o = h.SampleEntry.prototype.getCodec.call(this);
      return this.avcC ? o + "." + h.decimalToHex(this.avcC.AVCProfileIndication) + h.decimalToHex(this.avcC.profile_compatibility) + h.decimalToHex(this.avcC.AVCLevelIndication) : o;
    }, h.hev1SampleEntry.prototype.getCodec = h.hvc1SampleEntry.prototype.getCodec = function() {
      var o, c = h.SampleEntry.prototype.getCodec.call(this);
      if (this.hvcC) {
        switch (c += ".", this.hvcC.general_profile_space) {
          case 0:
            c += "";
            break;
          case 1:
            c += "A";
            break;
          case 2:
            c += "B";
            break;
          case 3:
            c += "C";
            break;
        }
        c += this.hvcC.general_profile_idc, c += ".";
        var d = this.hvcC.general_profile_compatibility, _ = 0;
        for (o = 0; o < 32 && (_ |= d & 1, o != 31); o++)
          _ <<= 1, d >>= 1;
        c += h.decimalToHex(_, 0), c += ".", this.hvcC.general_tier_flag === 0 ? c += "L" : c += "H", c += this.hvcC.general_level_idc;
        var y = !1, v = "";
        for (o = 5; o >= 0; o--)
          (this.hvcC.general_constraint_indicator[o] || y) && (v = "." + h.decimalToHex(this.hvcC.general_constraint_indicator[o], 0) + v, y = !0);
        c += v;
      }
      return c;
    }, h.vvc1SampleEntry.prototype.getCodec = h.vvi1SampleEntry.prototype.getCodec = function() {
      var o, c = h.SampleEntry.prototype.getCodec.call(this);
      if (this.vvcC) {
        c += "." + this.vvcC.general_profile_idc, this.vvcC.general_tier_flag ? c += ".H" : c += ".L", c += this.vvcC.general_level_idc;
        var d = "";
        if (this.vvcC.general_constraint_info) {
          var _ = [], y = 0;
          y |= this.vvcC.ptl_frame_only_constraint << 7, y |= this.vvcC.ptl_multilayer_enabled << 6;
          var v;
          for (o = 0; o < this.vvcC.general_constraint_info.length; ++o)
            y |= this.vvcC.general_constraint_info[o] >> 2 & 63, _.push(y), y && (v = o), y = this.vvcC.general_constraint_info[o] >> 2 & 3;
          if (v === void 0)
            d = ".CA";
          else {
            d = ".C";
            var b = "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567", w = 0, S = 0;
            for (o = 0; o <= v; ++o)
              for (w = w << 8 | _[o], S += 8; S >= 5; ) {
                var T = w >> S - 5 & 31;
                d += b[T], S -= 5, w &= (1 << S) - 1;
              }
            S && (w <<= 5 - S, d += b[w & 31]);
          }
        }
        c += d;
      }
      return c;
    }, h.mp4aSampleEntry.prototype.getCodec = function() {
      var o = h.SampleEntry.prototype.getCodec.call(this);
      if (this.esds && this.esds.esd) {
        var c = this.esds.esd.getOTI(), d = this.esds.esd.getAudioConfig();
        return o + "." + h.decimalToHex(c) + (d ? "." + d : "");
      } else
        return o;
    }, h.stxtSampleEntry.prototype.getCodec = function() {
      var o = h.SampleEntry.prototype.getCodec.call(this);
      return this.mime_format ? o + "." + this.mime_format : o;
    }, h.vp08SampleEntry.prototype.getCodec = h.vp09SampleEntry.prototype.getCodec = function() {
      var o = h.SampleEntry.prototype.getCodec.call(this), c = this.vpcC.level;
      c == 0 && (c = "00");
      var d = this.vpcC.bitDepth;
      return d == 8 && (d = "08"), o + ".0" + this.vpcC.profile + "." + c + "." + d;
    }, h.av01SampleEntry.prototype.getCodec = function() {
      var o = h.SampleEntry.prototype.getCodec.call(this), c = this.av1C.seq_level_idx_0;
      c < 10 && (c = "0" + c);
      var d;
      return this.av1C.seq_profile === 2 && this.av1C.high_bitdepth === 1 ? d = this.av1C.twelve_bit === 1 ? "12" : "10" : this.av1C.seq_profile <= 2 && (d = this.av1C.high_bitdepth === 1 ? "10" : "08"), o + "." + this.av1C.seq_profile + "." + c + (this.av1C.seq_tier_0 ? "H" : "M") + "." + d;
    }, h.Box.prototype.writeHeader = function(o, c) {
      this.size += 8, this.size > n && (this.size += 8), this.type === "uuid" && (this.size += 16), t.debug("BoxWriter", "Writing box " + this.type + " of size: " + this.size + " at position " + o.getPosition() + (c || "")), this.size > n ? o.writeUint32(1) : (this.sizePosition = o.getPosition(), o.writeUint32(this.size)), o.writeString(this.type, null, 4), this.type === "uuid" && o.writeUint8Array(this.uuid), this.size > n && o.writeUint64(this.size);
    }, h.FullBox.prototype.writeHeader = function(o) {
      this.size += 4, h.Box.prototype.writeHeader.call(this, o, " v=" + this.version + " f=" + this.flags), o.writeUint8(this.version), o.writeUint24(this.flags);
    }, h.Box.prototype.write = function(o) {
      this.type === "mdat" ? this.data && (this.size = this.data.length, this.writeHeader(o), o.writeUint8Array(this.data)) : (this.size = this.data ? this.data.length : 0, this.writeHeader(o), this.data && o.writeUint8Array(this.data));
    }, h.ContainerBox.prototype.write = function(o) {
      this.size = 0, this.writeHeader(o);
      for (var c = 0; c < this.boxes.length; c++)
        this.boxes[c] && (this.boxes[c].write(o), this.size += this.boxes[c].size);
      t.debug("BoxWriter", "Adjusting box " + this.type + " with new size " + this.size), o.adjustUint32(this.sizePosition, this.size);
    }, h.TrackReferenceTypeBox.prototype.write = function(o) {
      this.size = this.track_ids.length * 4, this.writeHeader(o), o.writeUint32Array(this.track_ids);
    }, h.avcCBox.prototype.write = function(o) {
      var c;
      for (this.size = 7, c = 0; c < this.SPS.length; c++)
        this.size += 2 + this.SPS[c].length;
      for (c = 0; c < this.PPS.length; c++)
        this.size += 2 + this.PPS[c].length;
      for (this.ext && (this.size += this.ext.length), this.writeHeader(o), o.writeUint8(this.configurationVersion), o.writeUint8(this.AVCProfileIndication), o.writeUint8(this.profile_compatibility), o.writeUint8(this.AVCLevelIndication), o.writeUint8(this.lengthSizeMinusOne + 252), o.writeUint8(this.SPS.length + 224), c = 0; c < this.SPS.length; c++)
        o.writeUint16(this.SPS[c].length), o.writeUint8Array(this.SPS[c].nalu);
      for (o.writeUint8(this.PPS.length), c = 0; c < this.PPS.length; c++)
        o.writeUint16(this.PPS[c].length), o.writeUint8Array(this.PPS[c].nalu);
      this.ext && o.writeUint8Array(this.ext);
    }, h.co64Box.prototype.write = function(o) {
      var c;
      for (this.version = 0, this.flags = 0, this.size = 4 + 8 * this.chunk_offsets.length, this.writeHeader(o), o.writeUint32(this.chunk_offsets.length), c = 0; c < this.chunk_offsets.length; c++)
        o.writeUint64(this.chunk_offsets[c]);
    }, h.cslgBox.prototype.write = function(o) {
      this.version = 0, this.flags = 0, this.size = 4 * 5, this.writeHeader(o), o.writeInt32(this.compositionToDTSShift), o.writeInt32(this.leastDecodeToDisplayDelta), o.writeInt32(this.greatestDecodeToDisplayDelta), o.writeInt32(this.compositionStartTime), o.writeInt32(this.compositionEndTime);
    }, h.cttsBox.prototype.write = function(o) {
      var c;
      for (this.version = 0, this.flags = 0, this.size = 4 + 8 * this.sample_counts.length, this.writeHeader(o), o.writeUint32(this.sample_counts.length), c = 0; c < this.sample_counts.length; c++)
        o.writeUint32(this.sample_counts[c]), this.version === 1 ? o.writeInt32(this.sample_offsets[c]) : o.writeUint32(this.sample_offsets[c]);
    }, h.drefBox.prototype.write = function(o) {
      this.version = 0, this.flags = 0, this.size = 4, this.writeHeader(o), o.writeUint32(this.entries.length);
      for (var c = 0; c < this.entries.length; c++)
        this.entries[c].write(o), this.size += this.entries[c].size;
      t.debug("BoxWriter", "Adjusting box " + this.type + " with new size " + this.size), o.adjustUint32(this.sizePosition, this.size);
    }, h.elngBox.prototype.write = function(o) {
      this.version = 0, this.flags = 0, this.size = this.extended_language.length, this.writeHeader(o), o.writeString(this.extended_language);
    }, h.elstBox.prototype.write = function(o) {
      this.version = 0, this.flags = 0, this.size = 4 + 12 * this.entries.length, this.writeHeader(o), o.writeUint32(this.entries.length);
      for (var c = 0; c < this.entries.length; c++) {
        var d = this.entries[c];
        o.writeUint32(d.segment_duration), o.writeInt32(d.media_time), o.writeInt16(d.media_rate_integer), o.writeInt16(d.media_rate_fraction);
      }
    }, h.emsgBox.prototype.write = function(o) {
      this.version = 0, this.flags = 0, this.size = 4 * 4 + this.message_data.length + (this.scheme_id_uri.length + 1) + (this.value.length + 1), this.writeHeader(o), o.writeCString(this.scheme_id_uri), o.writeCString(this.value), o.writeUint32(this.timescale), o.writeUint32(this.presentation_time_delta), o.writeUint32(this.event_duration), o.writeUint32(this.id), o.writeUint8Array(this.message_data);
    }, h.ftypBox.prototype.write = function(o) {
      this.size = 8 + 4 * this.compatible_brands.length, this.writeHeader(o), o.writeString(this.major_brand, null, 4), o.writeUint32(this.minor_version);
      for (var c = 0; c < this.compatible_brands.length; c++)
        o.writeString(this.compatible_brands[c], null, 4);
    }, h.hdlrBox.prototype.write = function(o) {
      this.size = 5 * 4 + this.name.length + 1, this.version = 0, this.flags = 0, this.writeHeader(o), o.writeUint32(0), o.writeString(this.handler, null, 4), o.writeUint32(0), o.writeUint32(0), o.writeUint32(0), o.writeCString(this.name);
    }, h.hvcCBox.prototype.write = function(o) {
      var c, d;
      for (this.size = 23, c = 0; c < this.nalu_arrays.length; c++)
        for (this.size += 3, d = 0; d < this.nalu_arrays[c].length; d++)
          this.size += 2 + this.nalu_arrays[c][d].data.length;
      for (this.writeHeader(o), o.writeUint8(this.configurationVersion), o.writeUint8((this.general_profile_space << 6) + (this.general_tier_flag << 5) + this.general_profile_idc), o.writeUint32(this.general_profile_compatibility), o.writeUint8Array(this.general_constraint_indicator), o.writeUint8(this.general_level_idc), o.writeUint16(this.min_spatial_segmentation_idc + (15 << 24)), o.writeUint8(this.parallelismType + 252), o.writeUint8(this.chroma_format_idc + 252), o.writeUint8(this.bit_depth_luma_minus8 + 248), o.writeUint8(this.bit_depth_chroma_minus8 + 248), o.writeUint16(this.avgFrameRate), o.writeUint8((this.constantFrameRate << 6) + (this.numTemporalLayers << 3) + (this.temporalIdNested << 2) + this.lengthSizeMinusOne), o.writeUint8(this.nalu_arrays.length), c = 0; c < this.nalu_arrays.length; c++)
        for (o.writeUint8((this.nalu_arrays[c].completeness << 7) + this.nalu_arrays[c].nalu_type), o.writeUint16(this.nalu_arrays[c].length), d = 0; d < this.nalu_arrays[c].length; d++)
          o.writeUint16(this.nalu_arrays[c][d].data.length), o.writeUint8Array(this.nalu_arrays[c][d].data);
    }, h.kindBox.prototype.write = function(o) {
      this.version = 0, this.flags = 0, this.size = this.schemeURI.length + 1 + (this.value.length + 1), this.writeHeader(o), o.writeCString(this.schemeURI), o.writeCString(this.value);
    }, h.mdhdBox.prototype.write = function(o) {
      this.size = 4 * 4 + 2 * 2, this.flags = 0, this.version = 0, this.writeHeader(o), o.writeUint32(this.creation_time), o.writeUint32(this.modification_time), o.writeUint32(this.timescale), o.writeUint32(this.duration), o.writeUint16(this.language), o.writeUint16(0);
    }, h.mehdBox.prototype.write = function(o) {
      this.version = 0, this.flags = 0, this.size = 4, this.writeHeader(o), o.writeUint32(this.fragment_duration);
    }, h.mfhdBox.prototype.write = function(o) {
      this.version = 0, this.flags = 0, this.size = 4, this.writeHeader(o), o.writeUint32(this.sequence_number);
    }, h.mvhdBox.prototype.write = function(o) {
      this.version = 0, this.flags = 0, this.size = 23 * 4 + 2 * 2, this.writeHeader(o), o.writeUint32(this.creation_time), o.writeUint32(this.modification_time), o.writeUint32(this.timescale), o.writeUint32(this.duration), o.writeUint32(this.rate), o.writeUint16(this.volume << 8), o.writeUint16(0), o.writeUint32(0), o.writeUint32(0), o.writeUint32Array(this.matrix), o.writeUint32(0), o.writeUint32(0), o.writeUint32(0), o.writeUint32(0), o.writeUint32(0), o.writeUint32(0), o.writeUint32(this.next_track_id);
    }, h.SampleEntry.prototype.writeHeader = function(o) {
      this.size = 8, h.Box.prototype.writeHeader.call(this, o), o.writeUint8(0), o.writeUint8(0), o.writeUint8(0), o.writeUint8(0), o.writeUint8(0), o.writeUint8(0), o.writeUint16(this.data_reference_index);
    }, h.SampleEntry.prototype.writeFooter = function(o) {
      for (var c = 0; c < this.boxes.length; c++)
        this.boxes[c].write(o), this.size += this.boxes[c].size;
      t.debug("BoxWriter", "Adjusting box " + this.type + " with new size " + this.size), o.adjustUint32(this.sizePosition, this.size);
    }, h.SampleEntry.prototype.write = function(o) {
      this.writeHeader(o), o.writeUint8Array(this.data), this.size += this.data.length, t.debug("BoxWriter", "Adjusting box " + this.type + " with new size " + this.size), o.adjustUint32(this.sizePosition, this.size);
    }, h.VisualSampleEntry.prototype.write = function(o) {
      this.writeHeader(o), this.size += 2 * 7 + 6 * 4 + 32, o.writeUint16(0), o.writeUint16(0), o.writeUint32(0), o.writeUint32(0), o.writeUint32(0), o.writeUint16(this.width), o.writeUint16(this.height), o.writeUint32(this.horizresolution), o.writeUint32(this.vertresolution), o.writeUint32(0), o.writeUint16(this.frame_count), o.writeUint8(Math.min(31, this.compressorname.length)), o.writeString(this.compressorname, null, 31), o.writeUint16(this.depth), o.writeInt16(-1), this.writeFooter(o);
    }, h.AudioSampleEntry.prototype.write = function(o) {
      this.writeHeader(o), this.size += 2 * 4 + 3 * 4, o.writeUint32(0), o.writeUint32(0), o.writeUint16(this.channel_count), o.writeUint16(this.samplesize), o.writeUint16(0), o.writeUint16(0), o.writeUint32(this.samplerate << 16), this.writeFooter(o);
    }, h.stppSampleEntry.prototype.write = function(o) {
      this.writeHeader(o), this.size += this.namespace.length + 1 + this.schema_location.length + 1 + this.auxiliary_mime_types.length + 1, o.writeCString(this.namespace), o.writeCString(this.schema_location), o.writeCString(this.auxiliary_mime_types), this.writeFooter(o);
    }, h.SampleGroupEntry.prototype.write = function(o) {
      o.writeUint8Array(this.data);
    }, h.sbgpBox.prototype.write = function(o) {
      this.version = 1, this.flags = 0, this.size = 12 + 8 * this.entries.length, this.writeHeader(o), o.writeString(this.grouping_type, null, 4), o.writeUint32(this.grouping_type_parameter), o.writeUint32(this.entries.length);
      for (var c = 0; c < this.entries.length; c++) {
        var d = this.entries[c];
        o.writeInt32(d.sample_count), o.writeInt32(d.group_description_index);
      }
    }, h.sgpdBox.prototype.write = function(o) {
      var c, d;
      for (this.flags = 0, this.size = 12, c = 0; c < this.entries.length; c++)
        d = this.entries[c], this.version === 1 && (this.default_length === 0 && (this.size += 4), this.size += d.data.length);
      for (this.writeHeader(o), o.writeString(this.grouping_type, null, 4), this.version === 1 && o.writeUint32(this.default_length), this.version >= 2 && o.writeUint32(this.default_sample_description_index), o.writeUint32(this.entries.length), c = 0; c < this.entries.length; c++)
        d = this.entries[c], this.version === 1 && this.default_length === 0 && o.writeUint32(d.description_length), d.write(o);
    }, h.sidxBox.prototype.write = function(o) {
      this.version = 0, this.flags = 0, this.size = 4 * 4 + 2 + 2 + 12 * this.references.length, this.writeHeader(o), o.writeUint32(this.reference_ID), o.writeUint32(this.timescale), o.writeUint32(this.earliest_presentation_time), o.writeUint32(this.first_offset), o.writeUint16(0), o.writeUint16(this.references.length);
      for (var c = 0; c < this.references.length; c++) {
        var d = this.references[c];
        o.writeUint32(d.reference_type << 31 | d.referenced_size), o.writeUint32(d.subsegment_duration), o.writeUint32(d.starts_with_SAP << 31 | d.SAP_type << 28 | d.SAP_delta_time);
      }
    }, h.smhdBox.prototype.write = function(o) {
      this.version = 0, this.flags = 1, this.size = 4, this.writeHeader(o), o.writeUint16(this.balance), o.writeUint16(0);
    }, h.stcoBox.prototype.write = function(o) {
      this.version = 0, this.flags = 0, this.size = 4 + 4 * this.chunk_offsets.length, this.writeHeader(o), o.writeUint32(this.chunk_offsets.length), o.writeUint32Array(this.chunk_offsets);
    }, h.stscBox.prototype.write = function(o) {
      var c;
      for (this.version = 0, this.flags = 0, this.size = 4 + 12 * this.first_chunk.length, this.writeHeader(o), o.writeUint32(this.first_chunk.length), c = 0; c < this.first_chunk.length; c++)
        o.writeUint32(this.first_chunk[c]), o.writeUint32(this.samples_per_chunk[c]), o.writeUint32(this.sample_description_index[c]);
    }, h.stsdBox.prototype.write = function(o) {
      var c;
      for (this.version = 0, this.flags = 0, this.size = 0, this.writeHeader(o), o.writeUint32(this.entries.length), this.size += 4, c = 0; c < this.entries.length; c++)
        this.entries[c].write(o), this.size += this.entries[c].size;
      t.debug("BoxWriter", "Adjusting box " + this.type + " with new size " + this.size), o.adjustUint32(this.sizePosition, this.size);
    }, h.stshBox.prototype.write = function(o) {
      var c;
      for (this.version = 0, this.flags = 0, this.size = 4 + 8 * this.shadowed_sample_numbers.length, this.writeHeader(o), o.writeUint32(this.shadowed_sample_numbers.length), c = 0; c < this.shadowed_sample_numbers.length; c++)
        o.writeUint32(this.shadowed_sample_numbers[c]), o.writeUint32(this.sync_sample_numbers[c]);
    }, h.stssBox.prototype.write = function(o) {
      this.version = 0, this.flags = 0, this.size = 4 + 4 * this.sample_numbers.length, this.writeHeader(o), o.writeUint32(this.sample_numbers.length), o.writeUint32Array(this.sample_numbers);
    }, h.stszBox.prototype.write = function(o) {
      var c, d = !0;
      if (this.version = 0, this.flags = 0, this.sample_sizes.length > 0)
        for (c = 0; c + 1 < this.sample_sizes.length; )
          if (this.sample_sizes[c + 1] !== this.sample_sizes[0]) {
            d = !1;
            break;
          } else
            c++;
      else
        d = !1;
      this.size = 8, d || (this.size += 4 * this.sample_sizes.length), this.writeHeader(o), d ? o.writeUint32(this.sample_sizes[0]) : o.writeUint32(0), o.writeUint32(this.sample_sizes.length), d || o.writeUint32Array(this.sample_sizes);
    }, h.sttsBox.prototype.write = function(o) {
      var c;
      for (this.version = 0, this.flags = 0, this.size = 4 + 8 * this.sample_counts.length, this.writeHeader(o), o.writeUint32(this.sample_counts.length), c = 0; c < this.sample_counts.length; c++)
        o.writeUint32(this.sample_counts[c]), o.writeUint32(this.sample_deltas[c]);
    }, h.tfdtBox.prototype.write = function(o) {
      var c = Math.pow(2, 32) - 1;
      this.version = this.baseMediaDecodeTime > c ? 1 : 0, this.flags = 0, this.size = 4, this.version === 1 && (this.size += 4), this.writeHeader(o), this.version === 1 ? o.writeUint64(this.baseMediaDecodeTime) : o.writeUint32(this.baseMediaDecodeTime);
    }, h.tfhdBox.prototype.write = function(o) {
      this.version = 0, this.size = 4, this.flags & h.TFHD_FLAG_BASE_DATA_OFFSET && (this.size += 8), this.flags & h.TFHD_FLAG_SAMPLE_DESC && (this.size += 4), this.flags & h.TFHD_FLAG_SAMPLE_DUR && (this.size += 4), this.flags & h.TFHD_FLAG_SAMPLE_SIZE && (this.size += 4), this.flags & h.TFHD_FLAG_SAMPLE_FLAGS && (this.size += 4), this.writeHeader(o), o.writeUint32(this.track_id), this.flags & h.TFHD_FLAG_BASE_DATA_OFFSET && o.writeUint64(this.base_data_offset), this.flags & h.TFHD_FLAG_SAMPLE_DESC && o.writeUint32(this.default_sample_description_index), this.flags & h.TFHD_FLAG_SAMPLE_DUR && o.writeUint32(this.default_sample_duration), this.flags & h.TFHD_FLAG_SAMPLE_SIZE && o.writeUint32(this.default_sample_size), this.flags & h.TFHD_FLAG_SAMPLE_FLAGS && o.writeUint32(this.default_sample_flags);
    }, h.tkhdBox.prototype.write = function(o) {
      this.version = 0, this.size = 4 * 18 + 2 * 4, this.writeHeader(o), o.writeUint32(this.creation_time), o.writeUint32(this.modification_time), o.writeUint32(this.track_id), o.writeUint32(0), o.writeUint32(this.duration), o.writeUint32(0), o.writeUint32(0), o.writeInt16(this.layer), o.writeInt16(this.alternate_group), o.writeInt16(this.volume << 8), o.writeUint16(0), o.writeInt32Array(this.matrix), o.writeUint32(this.width), o.writeUint32(this.height);
    }, h.trexBox.prototype.write = function(o) {
      this.version = 0, this.flags = 0, this.size = 4 * 5, this.writeHeader(o), o.writeUint32(this.track_id), o.writeUint32(this.default_sample_description_index), o.writeUint32(this.default_sample_duration), o.writeUint32(this.default_sample_size), o.writeUint32(this.default_sample_flags);
    }, h.trunBox.prototype.write = function(o) {
      this.version = 0, this.size = 4, this.flags & h.TRUN_FLAGS_DATA_OFFSET && (this.size += 4), this.flags & h.TRUN_FLAGS_FIRST_FLAG && (this.size += 4), this.flags & h.TRUN_FLAGS_DURATION && (this.size += 4 * this.sample_duration.length), this.flags & h.TRUN_FLAGS_SIZE && (this.size += 4 * this.sample_size.length), this.flags & h.TRUN_FLAGS_FLAGS && (this.size += 4 * this.sample_flags.length), this.flags & h.TRUN_FLAGS_CTS_OFFSET && (this.size += 4 * this.sample_composition_time_offset.length), this.writeHeader(o), o.writeUint32(this.sample_count), this.flags & h.TRUN_FLAGS_DATA_OFFSET && (this.data_offset_position = o.getPosition(), o.writeInt32(this.data_offset)), this.flags & h.TRUN_FLAGS_FIRST_FLAG && o.writeUint32(this.first_sample_flags);
      for (var c = 0; c < this.sample_count; c++)
        this.flags & h.TRUN_FLAGS_DURATION && o.writeUint32(this.sample_duration[c]), this.flags & h.TRUN_FLAGS_SIZE && o.writeUint32(this.sample_size[c]), this.flags & h.TRUN_FLAGS_FLAGS && o.writeUint32(this.sample_flags[c]), this.flags & h.TRUN_FLAGS_CTS_OFFSET && (this.version === 0 ? o.writeUint32(this.sample_composition_time_offset[c]) : o.writeInt32(this.sample_composition_time_offset[c]));
    }, h["url Box"].prototype.write = function(o) {
      this.version = 0, this.location ? (this.flags = 0, this.size = this.location.length + 1) : (this.flags = 1, this.size = 0), this.writeHeader(o), this.location && o.writeCString(this.location);
    }, h["urn Box"].prototype.write = function(o) {
      this.version = 0, this.flags = 0, this.size = this.name.length + 1 + (this.location ? this.location.length + 1 : 0), this.writeHeader(o), o.writeCString(this.name), this.location && o.writeCString(this.location);
    }, h.vmhdBox.prototype.write = function(o) {
      this.version = 0, this.flags = 1, this.size = 8, this.writeHeader(o), o.writeUint16(this.graphicsmode), o.writeUint16Array(this.opcolor);
    }, h.vpcCBox.prototype.write = function(o) {
      this.version = 1;
      const c = 8 + this.codecIntializationDataSize;
      this.size = c, this.writeHeader(o), o.writeUint8(this.profile), o.writeUint8(this.level);
      let d = this.bitDepth << 4 | (this.chromaSubsampling & 7) << 1 | this.videoFullRangeFlag & 1;
      o.writeUint8(d), o.writeUint8(this.colourPrimaries), o.writeUint8(this.transferCharacteristics), o.writeUint8(this.matrixCoefficients), o.writeUint16(this.codecIntializationDataSize), this.codecIntializationDataSize > 0 && o.writeUint8Array(this.codecIntializationData);
    }, h.cttsBox.prototype.unpack = function(o) {
      var c, d, _;
      for (_ = 0, c = 0; c < this.sample_counts.length; c++)
        for (d = 0; d < this.sample_counts[c]; d++)
          o[_].pts = o[_].dts + this.sample_offsets[c], _++;
    }, h.sttsBox.prototype.unpack = function(o) {
      var c, d, _;
      for (_ = 0, c = 0; c < this.sample_counts.length; c++)
        for (d = 0; d < this.sample_counts[c]; d++)
          _ === 0 ? o[_].dts = 0 : o[_].dts = o[_ - 1].dts + this.sample_deltas[c], _++;
    }, h.stcoBox.prototype.unpack = function(o) {
      var c;
      for (c = 0; c < this.chunk_offsets.length; c++)
        o[c].offset = this.chunk_offsets[c];
    }, h.stscBox.prototype.unpack = function(o) {
      var c, d, _, y, v;
      for (y = 0, v = 0, c = 0; c < this.first_chunk.length; c++)
        for (d = 0; d < (c + 1 < this.first_chunk.length ? this.first_chunk[c + 1] : 1 / 0); d++)
          for (v++, _ = 0; _ < this.samples_per_chunk[c]; _++) {
            if (o[y])
              o[y].description_index = this.sample_description_index[c], o[y].chunk_index = v;
            else
              return;
            y++;
          }
    }, h.stszBox.prototype.unpack = function(o) {
      var c;
      for (c = 0; c < this.sample_sizes.length; c++)
        o[c].size = this.sample_sizes[c];
    }, h.DIFF_BOXES_PROP_NAMES = [
      "boxes",
      "entries",
      "references",
      "subsamples",
      "items",
      "item_infos",
      "extents",
      "associations",
      "subsegments",
      "ranges",
      "seekLists",
      "seekPoints",
      "esd",
      "levels"
    ], h.DIFF_PRIMITIVE_ARRAY_PROP_NAMES = [
      "compatible_brands",
      "matrix",
      "opcolor",
      "sample_counts",
      "sample_counts",
      "sample_deltas",
      "first_chunk",
      "samples_per_chunk",
      "sample_sizes",
      "chunk_offsets",
      "sample_offsets",
      "sample_description_index",
      "sample_duration"
    ], h.boxEqualFields = function(o, c) {
      if (o && !c) return !1;
      var d;
      for (d in o)
        if (!(h.DIFF_BOXES_PROP_NAMES.indexOf(d) > -1)) {
          if (o[d] instanceof h.Box || c[d] instanceof h.Box)
            continue;
          if (typeof o[d] > "u" || typeof c[d] > "u")
            continue;
          if (typeof o[d] == "function" || typeof c[d] == "function")
            continue;
          if (o.subBoxNames && o.subBoxNames.indexOf(d.slice(0, 4)) > -1 || c.subBoxNames && c.subBoxNames.indexOf(d.slice(0, 4)) > -1)
            continue;
          if (d === "data" || d === "start" || d === "size" || d === "creation_time" || d === "modification_time")
            continue;
          if (h.DIFF_PRIMITIVE_ARRAY_PROP_NAMES.indexOf(d) > -1)
            continue;
          if (o[d] !== c[d])
            return !1;
        }
      return !0;
    }, h.boxEqual = function(o, c) {
      if (!h.boxEqualFields(o, c))
        return !1;
      for (var d = 0; d < h.DIFF_BOXES_PROP_NAMES.length; d++) {
        var _ = h.DIFF_BOXES_PROP_NAMES[d];
        if (o[_] && c[_] && !h.boxEqual(o[_], c[_]))
          return !1;
      }
      return !0;
    };
    var p = function() {
    };
    p.prototype.parseSample = function(o) {
      var c = {}, d;
      c.resources = [];
      var _ = new e(o.data.buffer);
      if (!o.subsamples || o.subsamples.length === 0)
        c.documentString = _.readString(o.data.length);
      else if (c.documentString = _.readString(o.subsamples[0].size), o.subsamples.length > 1)
        for (d = 1; d < o.subsamples.length; d++)
          c.resources[d] = _.readUint8Array(o.subsamples[d].size);
      return typeof DOMParser < "u" && (c.document = new DOMParser().parseFromString(c.documentString, "application/xml")), c;
    };
    var m = function() {
    };
    m.prototype.parseSample = function(o) {
      var c, d = new e(o.data.buffer);
      return c = d.readString(o.data.length), c;
    }, m.prototype.parseConfig = function(o) {
      var c, d = new e(o.buffer);
      return d.readUint32(), c = d.readCString(), c;
    }, s.XMLSubtitlein4Parser = p, s.Textin4Parser = m;
    var g = function(o) {
      this.stream = o || new a(), this.boxes = [], this.mdats = [], this.moofs = [], this.isProgressive = !1, this.moovStartFound = !1, this.onMoovStart = null, this.moovStartSent = !1, this.onReady = null, this.readySent = !1, this.onSegment = null, this.onSamples = null, this.onError = null, this.sampleListBuilt = !1, this.fragmentedTracks = [], this.extractedTracks = [], this.isFragmentationInitialized = !1, this.sampleProcessingStarted = !1, this.nextMoofNumber = 0, this.itemListBuilt = !1, this.onSidx = null, this.sidxSent = !1;
    };
    g.prototype.setSegmentOptions = function(o, c, d) {
      var _ = this.getTrackById(o);
      if (_) {
        var y = {};
        this.fragmentedTracks.push(y), y.id = o, y.user = c, y.trak = _, _.nextSample = 0, y.segmentStream = null, y.nb_samples = 1e3, y.rapAlignement = !0, d && (d.nbSamples && (y.nb_samples = d.nbSamples), d.rapAlignement && (y.rapAlignement = d.rapAlignement));
      }
    }, g.prototype.unsetSegmentOptions = function(o) {
      for (var c = -1, d = 0; d < this.fragmentedTracks.length; d++) {
        var _ = this.fragmentedTracks[d];
        _.id == o && (c = d);
      }
      c > -1 && this.fragmentedTracks.splice(c, 1);
    }, g.prototype.setExtractionOptions = function(o, c, d) {
      var _ = this.getTrackById(o);
      if (_) {
        var y = {};
        this.extractedTracks.push(y), y.id = o, y.user = c, y.trak = _, _.nextSample = 0, y.nb_samples = 1e3, y.samples = [], d && d.nbSamples && (y.nb_samples = d.nbSamples);
      }
    }, g.prototype.unsetExtractionOptions = function(o) {
      for (var c = -1, d = 0; d < this.extractedTracks.length; d++) {
        var _ = this.extractedTracks[d];
        _.id == o && (c = d);
      }
      c > -1 && this.extractedTracks.splice(c, 1);
    }, g.prototype.parse = function() {
      var o, c, d = !1;
      if (!(this.restoreParsePosition && !this.restoreParsePosition()))
        for (; ; )
          if (this.hasIncompleteMdat && this.hasIncompleteMdat()) {
            if (this.processIncompleteMdat())
              continue;
            return;
          } else if (this.saveParsePosition && this.saveParsePosition(), o = h.parseOneBox(this.stream, d), o.code === h.ERR_NOT_ENOUGH_DATA)
            if (this.processIncompleteBox) {
              if (this.processIncompleteBox(o))
                continue;
              return;
            } else
              return;
          else {
            var _;
            switch (c = o.box, _ = c.type !== "uuid" ? c.type : c.uuid, this.boxes.push(c), _) {
              case "mdat":
                this.mdats.push(c);
                break;
              case "moof":
                this.moofs.push(c);
                break;
              case "moov":
                this.moovStartFound = !0, this.mdats.length === 0 && (this.isProgressive = !0);
              /* no break */
              /* falls through */
              default:
                this[_] !== void 0 && t.warn("ISOFile", "Duplicate Box of type: " + _ + ", overriding previous occurrence"), this[_] = c;
                break;
            }
            this.updateUsedBytes && this.updateUsedBytes(c, o);
          }
    }, g.prototype.checkBuffer = function(o) {
      if (o == null)
        throw "Buffer must be defined and non empty";
      if (o.fileStart === void 0)
        throw "Buffer must have a fileStart property";
      return o.byteLength === 0 ? (t.warn("ISOFile", "Ignoring empty buffer (fileStart: " + o.fileStart + ")"), this.stream.logBufferLevel(), !1) : (t.info("ISOFile", "Processing buffer (fileStart: " + o.fileStart + ")"), o.usedBytes = 0, this.stream.insertBuffer(o), this.stream.logBufferLevel(), this.stream.initialized() ? !0 : (t.warn("ISOFile", "Not ready to start parsing"), !1));
    }, g.prototype.appendBuffer = function(o, c) {
      var d;
      if (this.checkBuffer(o))
        return this.parse(), this.moovStartFound && !this.moovStartSent && (this.moovStartSent = !0, this.onMoovStart && this.onMoovStart()), this.moov ? (this.sampleListBuilt || (this.buildSampleLists(), this.sampleListBuilt = !0), this.updateSampleLists(), this.onReady && !this.readySent && (this.readySent = !0, this.onReady(this.getInfo())), this.processSamples(c), this.nextSeekPosition ? (d = this.nextSeekPosition, this.nextSeekPosition = void 0) : d = this.nextParsePosition, this.stream.getEndFilePositionAfter && (d = this.stream.getEndFilePositionAfter(d))) : this.nextParsePosition ? d = this.nextParsePosition : d = 0, this.sidx && this.onSidx && !this.sidxSent && (this.onSidx(this.sidx), this.sidxSent = !0), this.meta && (this.flattenItemInfo && !this.itemListBuilt && (this.flattenItemInfo(), this.itemListBuilt = !0), this.processItems && this.processItems(this.onItem)), this.stream.cleanBuffers && (t.info("ISOFile", "Done processing buffer (fileStart: " + o.fileStart + ") - next buffer to fetch should have a fileStart position of " + d), this.stream.logBufferLevel(), this.stream.cleanBuffers(), this.stream.logBufferLevel(!0), t.info("ISOFile", "Sample data size in memory: " + this.getAllocatedSampleDataSize())), d;
    }, g.prototype.getInfo = function() {
      var o, c, d = {}, _, y, v, b, w = (/* @__PURE__ */ new Date("1904-01-01T00:00:00Z")).getTime();
      if (this.moov)
        for (d.hasMoov = !0, d.duration = this.moov.mvhd.duration, d.timescale = this.moov.mvhd.timescale, d.isFragmented = this.moov.mvex != null, d.isFragmented && this.moov.mvex.mehd && (d.fragment_duration = this.moov.mvex.mehd.fragment_duration), d.isProgressive = this.isProgressive, d.hasIOD = this.moov.iods != null, d.brands = [], d.brands.push(this.ftyp.major_brand), d.brands = d.brands.concat(this.ftyp.compatible_brands), d.created = new Date(w + this.moov.mvhd.creation_time * 1e3), d.modified = new Date(w + this.moov.mvhd.modification_time * 1e3), d.tracks = [], d.audioTracks = [], d.videoTracks = [], d.subtitleTracks = [], d.metadataTracks = [], d.hintTracks = [], d.otherTracks = [], o = 0; o < this.moov.traks.length; o++) {
          if (_ = this.moov.traks[o], b = _.mdia.minf.stbl.stsd.entries[0], y = {}, d.tracks.push(y), y.id = _.tkhd.track_id, y.name = _.mdia.hdlr.name, y.references = [], _.tref)
            for (c = 0; c < _.tref.boxes.length; c++)
              v = {}, y.references.push(v), v.type = _.tref.boxes[c].type, v.track_ids = _.tref.boxes[c].track_ids;
          _.edts && (y.edits = _.edts.elst.entries), y.created = new Date(w + _.tkhd.creation_time * 1e3), y.modified = new Date(w + _.tkhd.modification_time * 1e3), y.movie_duration = _.tkhd.duration, y.movie_timescale = d.timescale, y.layer = _.tkhd.layer, y.alternate_group = _.tkhd.alternate_group, y.volume = _.tkhd.volume, y.matrix = _.tkhd.matrix, y.track_width = _.tkhd.width / 65536, y.track_height = _.tkhd.height / 65536, y.timescale = _.mdia.mdhd.timescale, y.cts_shift = _.mdia.minf.stbl.cslg, y.duration = _.mdia.mdhd.duration, y.samples_duration = _.samples_duration, y.codec = b.getCodec(), y.kind = _.udta && _.udta.kinds.length ? _.udta.kinds[0] : { schemeURI: "", value: "" }, y.language = _.mdia.elng ? _.mdia.elng.extended_language : _.mdia.mdhd.languageString, y.nb_samples = _.samples.length, y.size = _.samples_size, y.bitrate = y.size * 8 * y.timescale / y.samples_duration, b.isAudio() ? (y.type = "audio", d.audioTracks.push(y), y.audio = {}, y.audio.sample_rate = b.getSampleRate(), y.audio.channel_count = b.getChannelCount(), y.audio.sample_size = b.getSampleSize()) : b.isVideo() ? (y.type = "video", d.videoTracks.push(y), y.video = {}, y.video.width = b.getWidth(), y.video.height = b.getHeight()) : b.isSubtitle() ? (y.type = "subtitles", d.subtitleTracks.push(y)) : b.isHint() ? (y.type = "metadata", d.hintTracks.push(y)) : b.isMetadata() ? (y.type = "metadata", d.metadataTracks.push(y)) : (y.type = "metadata", d.otherTracks.push(y));
        }
      else
        d.hasMoov = !1;
      if (d.mime = "", d.hasMoov && d.tracks) {
        for (d.videoTracks && d.videoTracks.length > 0 ? d.mime += 'video/mp4; codecs="' : d.audioTracks && d.audioTracks.length > 0 ? d.mime += 'audio/mp4; codecs="' : d.mime += 'application/mp4; codecs="', o = 0; o < d.tracks.length; o++)
          o !== 0 && (d.mime += ","), d.mime += d.tracks[o].codec;
        d.mime += '"; profiles="', d.mime += this.ftyp.compatible_brands.join(), d.mime += '"';
      }
      return d;
    }, g.prototype.setNextSeekPositionFromSample = function(o) {
      o && (this.nextSeekPosition ? this.nextSeekPosition = Math.min(o.offset + o.alreadyRead, this.nextSeekPosition) : this.nextSeekPosition = o.offset + o.alreadyRead);
    }, g.prototype.processSamples = function(o) {
      var c, d;
      if (this.sampleProcessingStarted) {
        if (this.isFragmentationInitialized && this.onSegment !== null)
          for (c = 0; c < this.fragmentedTracks.length; c++) {
            var _ = this.fragmentedTracks[c];
            for (d = _.trak; d.nextSample < d.samples.length && this.sampleProcessingStarted; ) {
              t.debug("ISOFile", "Creating media fragment on track #" + _.id + " for sample " + d.nextSample);
              var y = this.createFragment(_.id, d.nextSample, _.segmentStream);
              if (y)
                _.segmentStream = y, d.nextSample++;
              else
                break;
              if ((d.nextSample % _.nb_samples === 0 || o || d.nextSample >= d.samples.length) && (t.info("ISOFile", "Sending fragmented data on track #" + _.id + " for samples [" + Math.max(0, d.nextSample - _.nb_samples) + "," + (d.nextSample - 1) + "]"), t.info("ISOFile", "Sample data size in memory: " + this.getAllocatedSampleDataSize()), this.onSegment && this.onSegment(_.id, _.user, _.segmentStream.buffer, d.nextSample, o || d.nextSample >= d.samples.length), _.segmentStream = null, _ !== this.fragmentedTracks[c]))
                break;
            }
          }
        if (this.onSamples !== null)
          for (c = 0; c < this.extractedTracks.length; c++) {
            var v = this.extractedTracks[c];
            for (d = v.trak; d.nextSample < d.samples.length && this.sampleProcessingStarted; ) {
              t.debug("ISOFile", "Exporting on track #" + v.id + " sample #" + d.nextSample);
              var b = this.getSample(d, d.nextSample);
              if (b)
                d.nextSample++, v.samples.push(b);
              else {
                this.setNextSeekPositionFromSample(d.samples[d.nextSample]);
                break;
              }
              if ((d.nextSample % v.nb_samples === 0 || d.nextSample >= d.samples.length) && (t.debug("ISOFile", "Sending samples on track #" + v.id + " for sample " + d.nextSample), this.onSamples && this.onSamples(v.id, v.user, v.samples), v.samples = [], v !== this.extractedTracks[c]))
                break;
            }
          }
      }
    }, g.prototype.getBox = function(o) {
      var c = this.getBoxes(o, !0);
      return c.length ? c[0] : null;
    }, g.prototype.getBoxes = function(o, c) {
      var d = [];
      return g._sweep.call(this, o, d, c), d;
    }, g._sweep = function(o, c, d) {
      this.type && this.type == o && c.push(this);
      for (var _ in this.boxes) {
        if (c.length && d) return;
        g._sweep.call(this.boxes[_], o, c, d);
      }
    }, g.prototype.getTrackSamplesInfo = function(o) {
      var c = this.getTrackById(o);
      if (c)
        return c.samples;
    }, g.prototype.getTrackSample = function(o, c) {
      var d = this.getTrackById(o), _ = this.getSample(d, c);
      return _;
    }, g.prototype.releaseUsedSamples = function(o, c) {
      var d = 0, _ = this.getTrackById(o);
      _.lastValidSample || (_.lastValidSample = 0);
      for (var y = _.lastValidSample; y < c; y++)
        d += this.releaseSample(_, y);
      t.info("ISOFile", "Track #" + o + " released samples up to " + c + " (released size: " + d + ", remaining: " + this.samplesDataSize + ")"), _.lastValidSample = c;
    }, g.prototype.start = function() {
      this.sampleProcessingStarted = !0, this.processSamples(!1);
    }, g.prototype.stop = function() {
      this.sampleProcessingStarted = !1;
    }, g.prototype.flush = function() {
      t.info("ISOFile", "Flushing remaining samples"), this.updateSampleLists(), this.processSamples(!0), this.stream.cleanBuffers(), this.stream.logBufferLevel(!0);
    }, g.prototype.seekTrack = function(o, c, d) {
      var _, y, v = 1 / 0, b = 0, w = 0, S;
      if (d.samples.length === 0)
        return t.info("ISOFile", "No sample in track, cannot seek! Using time " + t.getDurationString(0, 1) + " and offset: 0"), { offset: 0, time: 0 };
      for (_ = 0; _ < d.samples.length; _++) {
        if (y = d.samples[_], _ === 0)
          w = 0, S = y.timescale;
        else if (y.cts > o * y.timescale) {
          w = _ - 1;
          break;
        }
        c && y.is_sync && (b = _);
      }
      for (c && (w = b), o = d.samples[w].cts, d.nextSample = w; d.samples[w].alreadyRead === d.samples[w].size && d.samples[w + 1]; )
        w++;
      return v = d.samples[w].offset + d.samples[w].alreadyRead, t.info("ISOFile", "Seeking to " + (c ? "RAP" : "") + " sample #" + d.nextSample + " on track " + d.tkhd.track_id + ", time " + t.getDurationString(o, S) + " and offset: " + v), { offset: v, time: o / S };
    }, g.prototype.getTrackDuration = function(o) {
      var c;
      return o.samples ? (c = o.samples[o.samples.length - 1], (c.cts + c.duration) / c.timescale) : 1 / 0;
    }, g.prototype.seek = function(o, c) {
      var d = this.moov, _, y, v, b = { offset: 1 / 0, time: 1 / 0 };
      if (this.moov) {
        for (v = 0; v < d.traks.length; v++)
          _ = d.traks[v], !(o > this.getTrackDuration(_)) && (y = this.seekTrack(o, c, _), y.offset < b.offset && (b.offset = y.offset), y.time < b.time && (b.time = y.time));
        return t.info("ISOFile", "Seeking at time " + t.getDurationString(b.time, 1) + " needs a buffer with a fileStart position of " + b.offset), b.offset === 1 / 0 ? b = { offset: this.nextParsePosition, time: 0 } : b.offset = this.stream.getEndFilePositionAfter(b.offset), t.info("ISOFile", "Adjusted seek position (after checking data already in buffer): " + b.offset), b;
      } else
        throw "Cannot seek: moov not received!";
    }, g.prototype.equal = function(o) {
      for (var c = 0; c < this.boxes.length && c < o.boxes.length; ) {
        var d = this.boxes[c], _ = o.boxes[c];
        if (!h.boxEqual(d, _))
          return !1;
        c++;
      }
      return !0;
    }, s.ISOFile = g, g.prototype.lastBoxStartPosition = 0, g.prototype.parsingMdat = null, g.prototype.nextParsePosition = 0, g.prototype.discardMdatData = !1, g.prototype.processIncompleteBox = function(o) {
      var c, d, _;
      return o.type === "mdat" ? (c = new h[o.type + "Box"](o.size), this.parsingMdat = c, this.boxes.push(c), this.mdats.push(c), c.start = o.start, c.hdr_size = o.hdr_size, this.stream.addUsedBytes(c.hdr_size), this.lastBoxStartPosition = c.start + c.size, _ = this.stream.seek(c.start + c.size, !1, this.discardMdatData), _ ? (this.parsingMdat = null, !0) : (this.moovStartFound ? this.nextParsePosition = this.stream.findEndContiguousBuf() : this.nextParsePosition = c.start + c.size, !1)) : (o.type === "moov" && (this.moovStartFound = !0, this.mdats.length === 0 && (this.isProgressive = !0)), d = this.stream.mergeNextBuffer ? this.stream.mergeNextBuffer() : !1, d ? (this.nextParsePosition = this.stream.getEndPosition(), !0) : (o.type ? this.moovStartFound ? this.nextParsePosition = this.stream.getEndPosition() : this.nextParsePosition = this.stream.getPosition() + o.size : this.nextParsePosition = this.stream.getEndPosition(), !1));
    }, g.prototype.hasIncompleteMdat = function() {
      return this.parsingMdat !== null;
    }, g.prototype.processIncompleteMdat = function() {
      var o, c;
      return o = this.parsingMdat, c = this.stream.seek(o.start + o.size, !1, this.discardMdatData), c ? (t.debug("ISOFile", "Found 'mdat' end in buffered data"), this.parsingMdat = null, !0) : (this.nextParsePosition = this.stream.findEndContiguousBuf(), !1);
    }, g.prototype.restoreParsePosition = function() {
      return this.stream.seek(this.lastBoxStartPosition, !0, this.discardMdatData);
    }, g.prototype.saveParsePosition = function() {
      this.lastBoxStartPosition = this.stream.getPosition();
    }, g.prototype.updateUsedBytes = function(o, c) {
      this.stream.addUsedBytes && (o.type === "mdat" ? (this.stream.addUsedBytes(o.hdr_size), this.discardMdatData && this.stream.addUsedBytes(o.size - o.hdr_size)) : this.stream.addUsedBytes(o.size));
    }, g.prototype.add = h.Box.prototype.add, g.prototype.addBox = h.Box.prototype.addBox, g.prototype.init = function(o) {
      var c = o || {};
      this.add("ftyp").set("major_brand", c.brands && c.brands[0] || "iso4").set("minor_version", 0).set("compatible_brands", c.brands || ["iso4"]);
      var d = this.add("moov");
      return d.add("mvhd").set("timescale", c.timescale || 600).set("rate", c.rate || 65536).set("creation_time", 0).set("modification_time", 0).set("duration", c.duration || 0).set("volume", c.width ? 0 : 256).set("matrix", [65536, 0, 0, 0, 65536, 0, 0, 0, 1073741824]).set("next_track_id", 1), d.add("mvex"), this;
    }, g.prototype.addTrack = function(o) {
      this.moov || this.init(o);
      var c = o || {};
      c.width = c.width || 320, c.height = c.height || 320, c.id = c.id || this.moov.mvhd.next_track_id, c.type = c.type || "avc1";
      var d = this.moov.add("trak");
      this.moov.mvhd.next_track_id = c.id + 1, d.add("tkhd").set("flags", h.TKHD_FLAG_ENABLED | h.TKHD_FLAG_IN_MOVIE | h.TKHD_FLAG_IN_PREVIEW).set("creation_time", 0).set("modification_time", 0).set("track_id", c.id).set("duration", c.duration || 0).set("layer", c.layer || 0).set("alternate_group", 0).set("volume", 1).set("matrix", [65536, 0, 0, 0, 65536, 0, 0, 0, 1073741824]).set("width", c.width << 16).set("height", c.height << 16);
      var _ = d.add("mdia");
      _.add("mdhd").set("creation_time", 0).set("modification_time", 0).set("timescale", c.timescale || 1).set("duration", c.media_duration || 0).set("language", c.language || "und"), _.add("hdlr").set("handler", c.hdlr || "vide").set("name", c.name || "Track created with MP4Box.js"), _.add("elng").set("extended_language", c.language || "fr-FR");
      var y = _.add("minf");
      if (h[c.type + "SampleEntry"] !== void 0) {
        var v = new h[c.type + "SampleEntry"]();
        v.data_reference_index = 1;
        var b = "";
        for (var w in h.sampleEntryCodes)
          for (var S = h.sampleEntryCodes[w], T = 0; T < S.length; T++)
            if (S.indexOf(c.type) > -1) {
              b = w;
              break;
            }
        switch (b) {
          case "Visual":
            if (y.add("vmhd").set("graphicsmode", 0).set("opcolor", [0, 0, 0]), v.set("width", c.width).set("height", c.height).set("horizresolution", 72 << 16).set("vertresolution", 72 << 16).set("frame_count", 1).set("compressorname", c.type + " Compressor").set("depth", 24), c.avcDecoderConfigRecord) {
              var E = new h.avcCBox();
              E.parse(new e(c.avcDecoderConfigRecord)), v.addBox(E);
            } else if (c.hevcDecoderConfigRecord) {
              var C = new h.hvcCBox();
              C.parse(new e(c.hevcDecoderConfigRecord)), v.addBox(C);
            } else if (c.vpcDecoderConfigRecord) {
              var M = new h.vpcCBox();
              M.parse(new e(c.vpcDecoderConfigRecord)), v.addBox(M);
            }
            break;
          case "Audio":
            y.add("smhd").set("balance", c.balance || 0), v.set("channel_count", c.channel_count || 2).set("samplesize", c.samplesize || 16).set("samplerate", c.samplerate || 65536);
            break;
          case "Hint":
            y.add("hmhd");
            break;
          case "Subtitle":
            switch (y.add("sthd"), c.type) {
              case "stpp":
                v.set("namespace", c.namespace || "nonamespace").set("schema_location", c.schema_location || "").set("auxiliary_mime_types", c.auxiliary_mime_types || "");
                break;
            }
            break;
          case "Metadata":
            y.add("nmhd");
            break;
          case "System":
            y.add("nmhd");
            break;
          default:
            y.add("nmhd");
            break;
        }
        c.description && v.addBox(c.description), c.description_boxes && c.description_boxes.forEach(function(B) {
          v.addBox(B);
        }), y.add("dinf").add("dref").addEntry(new h["url Box"]().set("flags", 1));
        var P = y.add("stbl");
        return P.add("stsd").addEntry(v), P.add("stts").set("sample_counts", []).set("sample_deltas", []), P.add("stsc").set("first_chunk", []).set("samples_per_chunk", []).set("sample_description_index", []), P.add("stco").set("chunk_offsets", []), P.add("stsz").set("sample_sizes", []), this.moov.mvex.add("trex").set("track_id", c.id).set("default_sample_description_index", c.default_sample_description_index || 1).set("default_sample_duration", c.default_sample_duration || 0).set("default_sample_size", c.default_sample_size || 0).set("default_sample_flags", c.default_sample_flags || 0), this.buildTrakSampleLists(d), c.id;
      }
    }, h.Box.prototype.computeSize = function(o) {
      var c = o || new r();
      c.endianness = r.BIG_ENDIAN, this.write(c);
    }, g.prototype.addSample = function(o, c, d) {
      var _ = d || {}, y = {}, v = this.getTrackById(o);
      if (v !== null) {
        y.number = v.samples.length, y.track_id = v.tkhd.track_id, y.timescale = v.mdia.mdhd.timescale, y.description_index = _.sample_description_index ? _.sample_description_index - 1 : 0, y.description = v.mdia.minf.stbl.stsd.entries[y.description_index], y.data = c, y.size = c.byteLength, y.alreadyRead = y.size, y.duration = _.duration || 1, y.cts = _.cts || 0, y.dts = _.dts || 0, y.is_sync = _.is_sync || !1, y.is_leading = _.is_leading || 0, y.depends_on = _.depends_on || 0, y.is_depended_on = _.is_depended_on || 0, y.has_redundancy = _.has_redundancy || 0, y.degradation_priority = _.degradation_priority || 0, y.offset = 0, y.subsamples = _.subsamples, v.samples.push(y), v.samples_size += y.size, v.samples_duration += y.duration, v.first_dts === void 0 && (v.first_dts = _.dts), this.processSamples();
        var b = this.createSingleSampleMoof(y);
        return this.addBox(b), b.computeSize(), b.trafs[0].truns[0].data_offset = b.size + 8, this.add("mdat").data = new Uint8Array(c), y;
      }
    }, g.prototype.createSingleSampleMoof = function(o) {
      var c = 0;
      o.is_sync ? c = 1 << 25 : c = 65536;
      var d = new h.moofBox();
      d.add("mfhd").set("sequence_number", this.nextMoofNumber), this.nextMoofNumber++;
      var _ = d.add("traf"), y = this.getTrackById(o.track_id);
      return _.add("tfhd").set("track_id", o.track_id).set("flags", h.TFHD_FLAG_DEFAULT_BASE_IS_MOOF), _.add("tfdt").set("baseMediaDecodeTime", o.dts - (y.first_dts || 0)), _.add("trun").set("flags", h.TRUN_FLAGS_DATA_OFFSET | h.TRUN_FLAGS_DURATION | h.TRUN_FLAGS_SIZE | h.TRUN_FLAGS_FLAGS | h.TRUN_FLAGS_CTS_OFFSET).set("data_offset", 0).set("first_sample_flags", 0).set("sample_count", 1).set("sample_duration", [o.duration]).set("sample_size", [o.size]).set("sample_flags", [c]).set("sample_composition_time_offset", [o.cts - o.dts]), d;
    }, g.prototype.lastMoofIndex = 0, g.prototype.samplesDataSize = 0, g.prototype.resetTables = function() {
      var o, c, d, _, y, v, b, w;
      for (this.initial_duration = this.moov.mvhd.duration, this.moov.mvhd.duration = 0, o = 0; o < this.moov.traks.length; o++) {
        c = this.moov.traks[o], c.tkhd.duration = 0, c.mdia.mdhd.duration = 0, d = c.mdia.minf.stbl.stco || c.mdia.minf.stbl.co64, d.chunk_offsets = [], _ = c.mdia.minf.stbl.stsc, _.first_chunk = [], _.samples_per_chunk = [], _.sample_description_index = [], y = c.mdia.minf.stbl.stsz || c.mdia.minf.stbl.stz2, y.sample_sizes = [], v = c.mdia.minf.stbl.stts, v.sample_counts = [], v.sample_deltas = [], b = c.mdia.minf.stbl.ctts, b && (b.sample_counts = [], b.sample_offsets = []), w = c.mdia.minf.stbl.stss;
        var S = c.mdia.minf.stbl.boxes.indexOf(w);
        S != -1 && (c.mdia.minf.stbl.boxes[S] = null);
      }
    }, g.initSampleGroups = function(o, c, d, _, y) {
      var v, b, w, S;
      function T(E, C, M) {
        this.grouping_type = E, this.grouping_type_parameter = C, this.sbgp = M, this.last_sample_in_run = -1, this.entry_index = -1;
      }
      for (c && (c.sample_groups_info = []), o.sample_groups_info || (o.sample_groups_info = []), b = 0; b < d.length; b++) {
        for (S = d[b].grouping_type + "/" + d[b].grouping_type_parameter, w = new T(d[b].grouping_type, d[b].grouping_type_parameter, d[b]), c && (c.sample_groups_info[S] = w), o.sample_groups_info[S] || (o.sample_groups_info[S] = w), v = 0; v < _.length; v++)
          _[v].grouping_type === d[b].grouping_type && (w.description = _[v], w.description.used = !0);
        if (y)
          for (v = 0; v < y.length; v++)
            y[v].grouping_type === d[b].grouping_type && (w.fragment_description = y[v], w.fragment_description.used = !0, w.is_fragment = !0);
      }
      if (c) {
        if (y)
          for (b = 0; b < y.length; b++)
            !y[b].used && y[b].version >= 2 && (S = y[b].grouping_type + "/0", w = new T(y[b].grouping_type, 0), w.is_fragment = !0, c.sample_groups_info[S] || (c.sample_groups_info[S] = w));
      } else
        for (b = 0; b < _.length; b++)
          !_[b].used && _[b].version >= 2 && (S = _[b].grouping_type + "/0", w = new T(_[b].grouping_type, 0), o.sample_groups_info[S] || (o.sample_groups_info[S] = w));
    }, g.setSampleGroupProperties = function(o, c, d, _) {
      var y, v;
      c.sample_groups = [];
      for (y in _)
        if (c.sample_groups[y] = {}, c.sample_groups[y].grouping_type = _[y].grouping_type, c.sample_groups[y].grouping_type_parameter = _[y].grouping_type_parameter, d >= _[y].last_sample_in_run && (_[y].last_sample_in_run < 0 && (_[y].last_sample_in_run = 0), _[y].entry_index++, _[y].entry_index <= _[y].sbgp.entries.length - 1 && (_[y].last_sample_in_run += _[y].sbgp.entries[_[y].entry_index].sample_count)), _[y].entry_index <= _[y].sbgp.entries.length - 1 ? c.sample_groups[y].group_description_index = _[y].sbgp.entries[_[y].entry_index].group_description_index : c.sample_groups[y].group_description_index = -1, c.sample_groups[y].group_description_index !== 0) {
          var b;
          _[y].fragment_description ? b = _[y].fragment_description : b = _[y].description, c.sample_groups[y].group_description_index > 0 ? (c.sample_groups[y].group_description_index > 65535 ? v = (c.sample_groups[y].group_description_index >> 16) - 1 : v = c.sample_groups[y].group_description_index - 1, b && v >= 0 && (c.sample_groups[y].description = b.entries[v])) : b && b.version >= 2 && b.default_group_description_index > 0 && (c.sample_groups[y].description = b.entries[b.default_group_description_index - 1]);
        }
    }, g.process_sdtp = function(o, c, d) {
      c && (o ? (c.is_leading = o.is_leading[d], c.depends_on = o.sample_depends_on[d], c.is_depended_on = o.sample_is_depended_on[d], c.has_redundancy = o.sample_has_redundancy[d]) : (c.is_leading = 0, c.depends_on = 0, c.is_depended_on = 0, c.has_redundancy = 0));
    }, g.prototype.buildSampleLists = function() {
      var o, c;
      for (o = 0; o < this.moov.traks.length; o++)
        c = this.moov.traks[o], this.buildTrakSampleLists(c);
    }, g.prototype.buildTrakSampleLists = function(o) {
      var c, d, _, y, v, b, w, S, T, E, C, M, P, B, U, G, O, R, I, st, V, xt, pt, gt;
      if (o.samples = [], o.samples_duration = 0, o.samples_size = 0, d = o.mdia.minf.stbl.stco || o.mdia.minf.stbl.co64, _ = o.mdia.minf.stbl.stsc, y = o.mdia.minf.stbl.stsz || o.mdia.minf.stbl.stz2, v = o.mdia.minf.stbl.stts, b = o.mdia.minf.stbl.ctts, w = o.mdia.minf.stbl.stss, S = o.mdia.minf.stbl.stsd, T = o.mdia.minf.stbl.subs, M = o.mdia.minf.stbl.stdp, E = o.mdia.minf.stbl.sbgps, C = o.mdia.minf.stbl.sgpds, R = -1, I = -1, st = -1, V = -1, xt = 0, pt = 0, gt = 0, g.initSampleGroups(o, null, E, C), !(typeof y > "u")) {
        for (c = 0; c < y.sample_sizes.length; c++) {
          var H = {};
          H.number = c, H.track_id = o.tkhd.track_id, H.timescale = o.mdia.mdhd.timescale, H.alreadyRead = 0, o.samples[c] = H, H.size = y.sample_sizes[c], o.samples_size += H.size, c === 0 ? (B = 1, P = 0, H.chunk_index = B, H.chunk_run_index = P, O = _.samples_per_chunk[P], G = 0, P + 1 < _.first_chunk.length ? U = _.first_chunk[P + 1] - 1 : U = 1 / 0) : c < O ? (H.chunk_index = B, H.chunk_run_index = P) : (B++, H.chunk_index = B, G = 0, B <= U || (P++, P + 1 < _.first_chunk.length ? U = _.first_chunk[P + 1] - 1 : U = 1 / 0), H.chunk_run_index = P, O += _.samples_per_chunk[P]), H.description_index = _.sample_description_index[H.chunk_run_index] - 1, H.description = S.entries[H.description_index], H.offset = d.chunk_offsets[H.chunk_index - 1] + G, G += H.size, c > R && (I++, R < 0 && (R = 0), R += v.sample_counts[I]), c > 0 ? (o.samples[c - 1].duration = v.sample_deltas[I], o.samples_duration += o.samples[c - 1].duration, H.dts = o.samples[c - 1].dts + o.samples[c - 1].duration) : H.dts = 0, b ? (c >= st && (V++, st < 0 && (st = 0), st += b.sample_counts[V]), H.cts = o.samples[c].dts + b.sample_offsets[V]) : H.cts = H.dts, w ? (c == w.sample_numbers[xt] - 1 ? (H.is_sync = !0, xt++) : (H.is_sync = !1, H.degradation_priority = 0), T && T.entries[pt].sample_delta + gt == c + 1 && (H.subsamples = T.entries[pt].subsamples, gt += T.entries[pt].sample_delta, pt++)) : H.is_sync = !0, g.process_sdtp(o.mdia.minf.stbl.sdtp, H, H.number), M ? H.degradation_priority = M.priority[c] : H.degradation_priority = 0, T && T.entries[pt].sample_delta + gt == c && (H.subsamples = T.entries[pt].subsamples, gt += T.entries[pt].sample_delta), (E.length > 0 || C.length > 0) && g.setSampleGroupProperties(o, H, c, o.sample_groups_info);
        }
        c > 0 && (o.samples[c - 1].duration = Math.max(o.mdia.mdhd.duration - o.samples[c - 1].dts, 0), o.samples_duration += o.samples[c - 1].duration);
      }
    }, g.prototype.updateSampleLists = function() {
      var o, c, d, _, y, v, b, w, S, T, E, C, M, P, B;
      if (this.moov !== void 0) {
        for (; this.lastMoofIndex < this.moofs.length; )
          if (S = this.moofs[this.lastMoofIndex], this.lastMoofIndex++, S.type == "moof")
            for (T = S, o = 0; o < T.trafs.length; o++) {
              for (E = T.trafs[o], C = this.getTrackById(E.tfhd.track_id), C.samples == null && (C.samples = []), M = this.getTrexById(E.tfhd.track_id), E.tfhd.flags & h.TFHD_FLAG_SAMPLE_DESC ? _ = E.tfhd.default_sample_description_index : _ = M ? M.default_sample_description_index : 1, E.tfhd.flags & h.TFHD_FLAG_SAMPLE_DUR ? y = E.tfhd.default_sample_duration : y = M ? M.default_sample_duration : 0, E.tfhd.flags & h.TFHD_FLAG_SAMPLE_SIZE ? v = E.tfhd.default_sample_size : v = M ? M.default_sample_size : 0, E.tfhd.flags & h.TFHD_FLAG_SAMPLE_FLAGS ? b = E.tfhd.default_sample_flags : b = M ? M.default_sample_flags : 0, E.sample_number = 0, E.sbgps.length > 0 && g.initSampleGroups(C, E, E.sbgps, C.mdia.minf.stbl.sgpds, E.sgpds), c = 0; c < E.truns.length; c++) {
                var U = E.truns[c];
                for (d = 0; d < U.sample_count; d++) {
                  P = {}, P.moof_number = this.lastMoofIndex, P.number_in_traf = E.sample_number, E.sample_number++, P.number = C.samples.length, E.first_sample_index = C.samples.length, C.samples.push(P), P.track_id = C.tkhd.track_id, P.timescale = C.mdia.mdhd.timescale, P.description_index = _ - 1, P.description = C.mdia.minf.stbl.stsd.entries[P.description_index], P.size = v, U.flags & h.TRUN_FLAGS_SIZE && (P.size = U.sample_size[d]), C.samples_size += P.size, P.duration = y, U.flags & h.TRUN_FLAGS_DURATION && (P.duration = U.sample_duration[d]), C.samples_duration += P.duration, C.first_traf_merged || d > 0 ? P.dts = C.samples[C.samples.length - 2].dts + C.samples[C.samples.length - 2].duration : (E.tfdt ? P.dts = E.tfdt.baseMediaDecodeTime : P.dts = 0, C.first_traf_merged = !0), P.cts = P.dts, U.flags & h.TRUN_FLAGS_CTS_OFFSET && (P.cts = P.dts + U.sample_composition_time_offset[d]), B = b, U.flags & h.TRUN_FLAGS_FLAGS ? B = U.sample_flags[d] : d === 0 && U.flags & h.TRUN_FLAGS_FIRST_FLAG && (B = U.first_sample_flags), P.is_sync = !(B >> 16 & 1), P.is_leading = B >> 26 & 3, P.depends_on = B >> 24 & 3, P.is_depended_on = B >> 22 & 3, P.has_redundancy = B >> 20 & 3, P.degradation_priority = B & 65535;
                  var G = !!(E.tfhd.flags & h.TFHD_FLAG_BASE_DATA_OFFSET), O = !!(E.tfhd.flags & h.TFHD_FLAG_DEFAULT_BASE_IS_MOOF), R = !!(U.flags & h.TRUN_FLAGS_DATA_OFFSET), I = 0;
                  G ? I = E.tfhd.base_data_offset : O || c === 0 ? I = T.start : I = w, c === 0 && d === 0 ? R ? P.offset = I + U.data_offset : P.offset = I : P.offset = w, w = P.offset + P.size, (E.sbgps.length > 0 || E.sgpds.length > 0 || C.mdia.minf.stbl.sbgps.length > 0 || C.mdia.minf.stbl.sgpds.length > 0) && g.setSampleGroupProperties(C, P, P.number_in_traf, E.sample_groups_info);
                }
              }
              if (E.subs) {
                C.has_fragment_subsamples = !0;
                var st = E.first_sample_index;
                for (c = 0; c < E.subs.entries.length; c++)
                  st += E.subs.entries[c].sample_delta, P = C.samples[st - 1], P.subsamples = E.subs.entries[c].subsamples;
              }
            }
      }
    }, g.prototype.getSample = function(o, c) {
      var d, _ = o.samples[c];
      if (!this.moov)
        return null;
      if (!_.data)
        _.data = new Uint8Array(_.size), _.alreadyRead = 0, this.samplesDataSize += _.size, t.debug("ISOFile", "Allocating sample #" + c + " on track #" + o.tkhd.track_id + " of size " + _.size + " (total: " + this.samplesDataSize + ")");
      else if (_.alreadyRead == _.size)
        return _;
      for (; ; ) {
        var y = this.stream.findPosition(!0, _.offset + _.alreadyRead, !1);
        if (y > -1) {
          d = this.stream.buffers[y];
          var v = d.byteLength - (_.offset + _.alreadyRead - d.fileStart);
          if (_.size - _.alreadyRead <= v)
            return t.debug("ISOFile", "Getting sample #" + c + " data (alreadyRead: " + _.alreadyRead + " offset: " + (_.offset + _.alreadyRead - d.fileStart) + " read size: " + (_.size - _.alreadyRead) + " full size: " + _.size + ")"), r.memcpy(
              _.data.buffer,
              _.alreadyRead,
              d,
              _.offset + _.alreadyRead - d.fileStart,
              _.size - _.alreadyRead
            ), d.usedBytes += _.size - _.alreadyRead, this.stream.logBufferLevel(), _.alreadyRead = _.size, _;
          if (v === 0) return null;
          t.debug("ISOFile", "Getting sample #" + c + " partial data (alreadyRead: " + _.alreadyRead + " offset: " + (_.offset + _.alreadyRead - d.fileStart) + " read size: " + v + " full size: " + _.size + ")"), r.memcpy(
            _.data.buffer,
            _.alreadyRead,
            d,
            _.offset + _.alreadyRead - d.fileStart,
            v
          ), _.alreadyRead += v, d.usedBytes += v, this.stream.logBufferLevel();
        } else
          return null;
      }
    }, g.prototype.releaseSample = function(o, c) {
      var d = o.samples[c];
      return d.data ? (this.samplesDataSize -= d.size, d.data = null, d.alreadyRead = 0, d.size) : 0;
    }, g.prototype.getAllocatedSampleDataSize = function() {
      return this.samplesDataSize;
    }, g.prototype.getCodecs = function() {
      var o, c = "";
      for (o = 0; o < this.moov.traks.length; o++) {
        var d = this.moov.traks[o];
        o > 0 && (c += ","), c += d.mdia.minf.stbl.stsd.entries[0].getCodec();
      }
      return c;
    }, g.prototype.getTrexById = function(o) {
      var c;
      if (!this.moov || !this.moov.mvex) return null;
      for (c = 0; c < this.moov.mvex.trexs.length; c++) {
        var d = this.moov.mvex.trexs[c];
        if (d.track_id == o) return d;
      }
      return null;
    }, g.prototype.getTrackById = function(o) {
      if (this.moov === void 0)
        return null;
      for (var c = 0; c < this.moov.traks.length; c++) {
        var d = this.moov.traks[c];
        if (d.tkhd.track_id == o) return d;
      }
      return null;
    }, g.prototype.items = [], g.prototype.entity_groups = [], g.prototype.itemsDataSize = 0, g.prototype.flattenItemInfo = function() {
      var o = this.items, c = this.entity_groups, d, _, y, v = this.meta;
      if (v != null && v.hdlr !== void 0 && v.iinf !== void 0) {
        for (d = 0; d < v.iinf.item_infos.length; d++)
          y = {}, y.id = v.iinf.item_infos[d].item_ID, o[y.id] = y, y.ref_to = [], y.name = v.iinf.item_infos[d].item_name, v.iinf.item_infos[d].protection_index > 0 && (y.protection = v.ipro.protections[v.iinf.item_infos[d].protection_index - 1]), v.iinf.item_infos[d].item_type ? y.type = v.iinf.item_infos[d].item_type : y.type = "mime", y.content_type = v.iinf.item_infos[d].content_type, y.content_encoding = v.iinf.item_infos[d].content_encoding;
        if (v.grpl)
          for (d = 0; d < v.grpl.boxes.length; d++)
            entity_group = {}, entity_group.id = v.grpl.boxes[d].group_id, entity_group.entity_ids = v.grpl.boxes[d].entity_ids, entity_group.type = v.grpl.boxes[d].type, c[entity_group.id] = entity_group;
        if (v.iloc)
          for (d = 0; d < v.iloc.items.length; d++) {
            var b = v.iloc.items[d];
            switch (y = o[b.item_ID], b.data_reference_index !== 0 && (t.warn("Item storage with reference to other files: not supported"), y.source = v.dinf.boxes[b.data_reference_index - 1]), b.construction_method) {
              case 0:
                break;
              case 1:
                t.warn("Item storage with construction_method : not supported");
                break;
              case 2:
                t.warn("Item storage with construction_method : not supported");
                break;
            }
            for (y.extents = [], y.size = 0, _ = 0; _ < b.extents.length; _++)
              y.extents[_] = {}, y.extents[_].offset = b.extents[_].extent_offset + b.base_offset, y.extents[_].length = b.extents[_].extent_length, y.extents[_].alreadyRead = 0, y.size += y.extents[_].length;
          }
        if (v.pitm && (o[v.pitm.item_id].primary = !0), v.iref)
          for (d = 0; d < v.iref.references.length; d++) {
            var w = v.iref.references[d];
            for (_ = 0; _ < w.references.length; _++)
              o[w.from_item_ID].ref_to.push({ type: w.type, id: w.references[_] });
          }
        if (v.iprp)
          for (var S = 0; S < v.iprp.ipmas.length; S++) {
            var T = v.iprp.ipmas[S];
            for (d = 0; d < T.associations.length; d++) {
              var E = T.associations[d];
              if (y = o[E.id], y || (y = c[E.id]), y)
                for (y.properties === void 0 && (y.properties = {}, y.properties.boxes = []), _ = 0; _ < E.props.length; _++) {
                  var C = E.props[_];
                  if (C.property_index > 0 && C.property_index - 1 < v.iprp.ipco.boxes.length) {
                    var M = v.iprp.ipco.boxes[C.property_index - 1];
                    y.properties[M.type] = M, y.properties.boxes.push(M);
                  }
                }
            }
          }
      }
    }, g.prototype.getItem = function(o) {
      var c, d;
      if (!this.meta)
        return null;
      if (d = this.items[o], !d.data && d.size)
        d.data = new Uint8Array(d.size), d.alreadyRead = 0, this.itemsDataSize += d.size, t.debug("ISOFile", "Allocating item #" + o + " of size " + d.size + " (total: " + this.itemsDataSize + ")");
      else if (d.alreadyRead === d.size)
        return d;
      for (var _ = 0; _ < d.extents.length; _++) {
        var y = d.extents[_];
        if (y.alreadyRead !== y.length) {
          var v = this.stream.findPosition(!0, y.offset + y.alreadyRead, !1);
          if (v > -1) {
            c = this.stream.buffers[v];
            var b = c.byteLength - (y.offset + y.alreadyRead - c.fileStart);
            if (y.length - y.alreadyRead <= b)
              t.debug("ISOFile", "Getting item #" + o + " extent #" + _ + " data (alreadyRead: " + y.alreadyRead + " offset: " + (y.offset + y.alreadyRead - c.fileStart) + " read size: " + (y.length - y.alreadyRead) + " full extent size: " + y.length + " full item size: " + d.size + ")"), r.memcpy(
                d.data.buffer,
                d.alreadyRead,
                c,
                y.offset + y.alreadyRead - c.fileStart,
                y.length - y.alreadyRead
              ), c.usedBytes += y.length - y.alreadyRead, this.stream.logBufferLevel(), d.alreadyRead += y.length - y.alreadyRead, y.alreadyRead = y.length;
            else
              return t.debug("ISOFile", "Getting item #" + o + " extent #" + _ + " partial data (alreadyRead: " + y.alreadyRead + " offset: " + (y.offset + y.alreadyRead - c.fileStart) + " read size: " + b + " full extent size: " + y.length + " full item size: " + d.size + ")"), r.memcpy(
                d.data.buffer,
                d.alreadyRead,
                c,
                y.offset + y.alreadyRead - c.fileStart,
                b
              ), y.alreadyRead += b, d.alreadyRead += b, c.usedBytes += b, this.stream.logBufferLevel(), null;
          } else
            return null;
        }
      }
      return d.alreadyRead === d.size ? d : null;
    }, g.prototype.releaseItem = function(o) {
      var c = this.items[o];
      if (c.data) {
        this.itemsDataSize -= c.size, c.data = null, c.alreadyRead = 0;
        for (var d = 0; d < c.extents.length; d++) {
          var _ = c.extents[d];
          _.alreadyRead = 0;
        }
        return c.size;
      } else
        return 0;
    }, g.prototype.processItems = function(o) {
      for (var c in this.items) {
        var d = this.items[c];
        this.getItem(d.id), o && !d.sent && (o(d), d.sent = !0, d.data = null);
      }
    }, g.prototype.hasItem = function(o) {
      for (var c in this.items) {
        var d = this.items[c];
        if (d.name === o)
          return d.id;
      }
      return -1;
    }, g.prototype.getMetaHandler = function() {
      return this.meta ? this.meta.hdlr.handler : null;
    }, g.prototype.getPrimaryItem = function() {
      return !this.meta || !this.meta.pitm ? null : this.getItem(this.meta.pitm.item_id);
    }, g.prototype.itemToFragmentedTrackFile = function(o) {
      var c = o || {}, d = null;
      if (c.itemId ? d = this.getItem(c.itemId) : d = this.getPrimaryItem(), d == null) return null;
      var _ = new g();
      _.discardMdatData = !1;
      var y = { type: d.type, description_boxes: d.properties.boxes };
      d.properties.ispe && (y.width = d.properties.ispe.image_width, y.height = d.properties.ispe.image_height);
      var v = _.addTrack(y);
      return v ? (_.addSample(v, d.data), _) : null;
    }, g.prototype.write = function(o) {
      for (var c = 0; c < this.boxes.length; c++)
        this.boxes[c].write(o);
    }, g.prototype.createFragment = function(o, c, d) {
      var _ = this.getTrackById(o), y = this.getSample(_, c);
      if (y == null)
        return this.setNextSeekPositionFromSample(_.samples[c]), null;
      var v = d || new r();
      v.endianness = r.BIG_ENDIAN;
      var b = this.createSingleSampleMoof(y);
      b.write(v), b.trafs[0].truns[0].data_offset = b.size + 8, t.debug("MP4Box", "Adjusting data_offset with new value " + b.trafs[0].truns[0].data_offset), v.adjustUint32(b.trafs[0].truns[0].data_offset_position, b.trafs[0].truns[0].data_offset);
      var w = new h.mdatBox();
      return w.data = y.data, w.write(v), v;
    }, g.writeInitializationSegment = function(o, c, d, _) {
      var y;
      t.debug("ISOFile", "Generating initialization segment");
      var v = new r();
      v.endianness = r.BIG_ENDIAN, o.write(v);
      var b = c.add("mvex");
      for (d && b.add("mehd").set("fragment_duration", d), y = 0; y < c.traks.length; y++)
        b.add("trex").set("track_id", c.traks[y].tkhd.track_id).set("default_sample_description_index", 1).set("default_sample_duration", _).set("default_sample_size", 0).set("default_sample_flags", 65536);
      return c.write(v), v.buffer;
    }, g.prototype.save = function(o) {
      var c = new r();
      c.endianness = r.BIG_ENDIAN, this.write(c), c.save(o);
    }, g.prototype.getBuffer = function() {
      var o = new r();
      return o.endianness = r.BIG_ENDIAN, this.write(o), o.buffer;
    }, g.prototype.initializeSegmentation = function() {
      var o, c, d, _;
      for (this.onSegment === null && t.warn("MP4Box", "No segmentation callback set!"), this.isFragmentationInitialized || (this.isFragmentationInitialized = !0, this.nextMoofNumber = 0, this.resetTables()), c = [], o = 0; o < this.fragmentedTracks.length; o++) {
        var y = new h.moovBox();
        y.mvhd = this.moov.mvhd, y.boxes.push(y.mvhd), d = this.getTrackById(this.fragmentedTracks[o].id), y.boxes.push(d), y.traks.push(d), _ = {}, _.id = d.tkhd.track_id, _.user = this.fragmentedTracks[o].user, _.buffer = g.writeInitializationSegment(this.ftyp, y, this.moov.mvex && this.moov.mvex.mehd ? this.moov.mvex.mehd.fragment_duration : void 0, this.moov.traks[o].samples.length > 0 ? this.moov.traks[o].samples[0].duration : 0), c.push(_);
      }
      return c;
    }, h.Box.prototype.printHeader = function(o) {
      this.size += 8, this.size > n && (this.size += 8), this.type === "uuid" && (this.size += 16), o.log(o.indent + "size:" + this.size), o.log(o.indent + "type:" + this.type);
    }, h.FullBox.prototype.printHeader = function(o) {
      this.size += 4, h.Box.prototype.printHeader.call(this, o), o.log(o.indent + "version:" + this.version), o.log(o.indent + "flags:" + this.flags);
    }, h.Box.prototype.print = function(o) {
      this.printHeader(o);
    }, h.ContainerBox.prototype.print = function(o) {
      this.printHeader(o);
      for (var c = 0; c < this.boxes.length; c++)
        if (this.boxes[c]) {
          var d = o.indent;
          o.indent += " ", this.boxes[c].print(o), o.indent = d;
        }
    }, g.prototype.print = function(o) {
      o.indent = "";
      for (var c = 0; c < this.boxes.length; c++)
        this.boxes[c] && this.boxes[c].print(o);
    }, h.mvhdBox.prototype.print = function(o) {
      h.FullBox.prototype.printHeader.call(this, o), o.log(o.indent + "creation_time: " + this.creation_time), o.log(o.indent + "modification_time: " + this.modification_time), o.log(o.indent + "timescale: " + this.timescale), o.log(o.indent + "duration: " + this.duration), o.log(o.indent + "rate: " + this.rate), o.log(o.indent + "volume: " + (this.volume >> 8)), o.log(o.indent + "matrix: " + this.matrix.join(", ")), o.log(o.indent + "next_track_id: " + this.next_track_id);
    }, h.tkhdBox.prototype.print = function(o) {
      h.FullBox.prototype.printHeader.call(this, o), o.log(o.indent + "creation_time: " + this.creation_time), o.log(o.indent + "modification_time: " + this.modification_time), o.log(o.indent + "track_id: " + this.track_id), o.log(o.indent + "duration: " + this.duration), o.log(o.indent + "volume: " + (this.volume >> 8)), o.log(o.indent + "matrix: " + this.matrix.join(", ")), o.log(o.indent + "layer: " + this.layer), o.log(o.indent + "alternate_group: " + this.alternate_group), o.log(o.indent + "width: " + this.width), o.log(o.indent + "height: " + this.height);
    };
    var x = {};
    x.createFile = function(o, c) {
      var d = o !== void 0 ? o : !0, _ = new g(c);
      return _.discardMdatData = !d, _;
    }, s.createFile = x.createFile;
  }(jn)), jn;
}
var fg = dg();
const Dt = /* @__PURE__ */ ih(fg);
let Ui = class {
  /**
   * 在两个 EventTool 实例间转发消息
   * @param from
   * @param to
   * @param evtTypes 需转发的消息类型
   *
   * @example
   * EventTool.forwardEvent(from, to, ['evtName']),
   */
  static forwardEvent(t, e, r) {
    const n = r.map((a) => {
      const [l, h] = Array.isArray(a) ? a : [a, a];
      return t.on(l, (...u) => {
        e.emit(h, ...u);
      });
    });
    return () => {
      n.forEach((a) => a());
    };
  }
  #t = /* @__PURE__ */ new Map();
  /**
   * 监听 EventType 中定义的事件
   */
  on = (t, e) => {
    const r = this.#t.get(t) ?? /* @__PURE__ */ new Set();
    return r.add(e), this.#t.has(t) || this.#t.set(t, r), () => {
      r.delete(e), r.size === 0 && this.#t.delete(t);
    };
  };
  /**
   * 监听事件，首次触发后自动移除监听
   *
   * 期望回调一次的事件，使用 once; 期望多次回调使用 on
   */
  once = (t, e) => {
    const r = this.on(t, (...n) => {
      r(), e(...n);
    });
    return r;
  };
  /**
   * 触发事件
   * @param type
   * @param args
   * @returns
   */
  emit = (t, ...e) => {
    this.#t.get(t)?.forEach((n) => n(...e));
  };
  destroy() {
    this.#t.clear();
  }
};
function pg(s) {
  return s instanceof Error ? String(s) : typeof s == "object" ? JSON.stringify(s, (t, e) => e instanceof Error ? String(e) : e) : String(s);
}
function _g() {
  const s = /* @__PURE__ */ new Date();
  return `${s.getHours()}:${s.getMinutes()}:${s.getSeconds()}.${s.getMilliseconds()}`;
}
let td = 1;
const ed = [], El = ["debug", "info", "warn", "error"].reduce(
  (s, t, e) => Object.assign(s, {
    [t]: (...r) => {
      td <= e && (console[t](...r), ed.push({
        lvName: t,
        timeStr: _g(),
        args: r
      }));
    }
  }),
  {}
), ps = /* @__PURE__ */ new Map(), z = {
  /**
   * 设置记录日志的级别
   *
   * @example
   * Log.setLogLevel(Log.warn) // 记录 warn，error 日志
   */
  setLogLevel: (s) => {
    td = ps.get(s) ?? 1;
  },
  ...El,
  /**
   * 生成一个 log 实例，所有输出前都会附加 tag
   *
   * @example
   * const log = Log.create('<prefix>')
   * log.info('xxx') // '<prefix> xxx'
   */
  create: (s) => Object.fromEntries(
    Object.entries(El).map(([t, e]) => [
      t,
      (...r) => e(s, ...r)
    ])
  ),
  /**
   * 将所有日志导出为一个字符串
   *
   * @example
   * Log.dump() // => [level][time]  内容...
   *
   */
  async dump() {
    return ed.reduce(
      (s, { lvName: t, timeStr: e, args: r }) => s + `[${t}][${e}]  ${r.map((n) => pg(n)).join(" ")}
`,
      ""
    );
  }
};
ps.set(z.debug, 0);
ps.set(z.info, 1);
ps.set(z.warn, 2);
ps.set(z.error, 3);
(async function() {
  if (await Promise.resolve(), !(globalThis.navigator == null || globalThis.document == null) && (z.info(
    `@webav version: 1.2.6, date: ${(/* @__PURE__ */ new Date()).toLocaleDateString()}`
  ), z.info(globalThis.navigator.userAgent), document.addEventListener("visibilitychange", () => {
    z.info(`visibilitychange: ${document.visibilityState}`);
  }), "PressureObserver" in globalThis)) {
    let s = "";
    new PressureObserver((t) => {
      const e = JSON.stringify(t.map((r) => r.state));
      e !== s && (z.info(`cpu state change: ${e}`), s = e);
    }).observe("cpu");
  }
})();
const rh = (s, t) => {
  const e = new Uint8Array(8);
  new DataView(e.buffer).setUint32(0, t);
  for (let r = 0; r < 4; r++)
    e[4 + r] = s.charCodeAt(r);
  return e;
}, mg = () => {
  const s = new TextEncoder(), t = s.encode("mdta"), e = s.encode("mp4 handler"), r = 32 + e.byteLength + 1, n = new Uint8Array(r), a = new DataView(n.buffer);
  return n.set(rh("hdlr", r), 0), a.setUint32(8, 0), n.set(t, 16), n.set(e, 32), n;
}, gg = (s) => {
  const t = new TextEncoder(), e = t.encode("mdta"), r = s.map((u) => {
    const f = t.encode(u), p = 8 + f.byteLength, m = new Uint8Array(p);
    return new DataView(m.buffer).setUint32(0, p), m.set(e, 4), m.set(f, 4 + e.byteLength), m;
  }), n = 16 + r.reduce((u, f) => u + f.byteLength, 0), a = new Uint8Array(n), l = new DataView(a.buffer);
  a.set(rh("keys", n), 0), l.setUint32(8, 0), l.setUint32(12, s.length);
  let h = 16;
  for (const u of r)
    a.set(u, h), h += u.byteLength;
  return a;
}, yg = (s) => {
  const t = new TextEncoder(), e = t.encode("data"), r = Object.entries(s).map(([h, u], f) => {
    const p = f + 1, m = t.encode(u), g = 24 + m.byteLength, x = new Uint8Array(g), o = new DataView(x.buffer);
    return o.setUint32(0, g), o.setUint32(4, p), o.setUint32(8, 16 + m.byteLength), x.set(e, 12), o.setUint32(16, 1), x.set(m, 24), x;
  }), n = 8 + r.reduce((h, u) => h + u.byteLength, 0), a = new Uint8Array(n);
  a.set(rh("ilst", n), 0);
  let l = 8;
  for (const h of r)
    a.set(h, l), l += h.byteLength;
  return a;
}, xg = (s) => {
  const t = mg(), e = gg(Object.keys(s)), r = yg(s), n = t.length + e.length + r.length, a = new Uint8Array(n);
  return a.set(t, 0), a.set(e, t.length), a.set(r, t.length + e.length), a;
}, bg = () => {
  let s, t = 16.6;
  self.onmessage = (e) => {
    e.data.event === "start" && (self.clearInterval(s), s = self.setInterval(() => {
      self.postMessage({});
    }, t)), e.data.event === "stop" && self.clearInterval(s);
  };
}, vg = () => {
  const s = new Blob([`(${bg.toString()})()`]), t = URL.createObjectURL(s);
  return new Worker(t);
}, Ni = /* @__PURE__ */ new Map();
let Ja = 1, un = null;
globalThis.Worker != null && (un = vg(), un.onmessage = () => {
  Ja += 1;
  for (const [s, t] of Ni)
    if (Ja % s === 0) for (const e of t) e();
});
const sh = (s, t) => {
  const e = Math.round(t / 16.6), r = Ni.get(e) ?? /* @__PURE__ */ new Set();
  return r.add(s), Ni.set(e, r), Ni.size === 1 && r.size === 1 && un?.postMessage({ event: "start" }), () => {
    r.delete(s), r.size === 0 && Ni.delete(e), Ni.size === 0 && (Ja = 0, un?.postMessage({ event: "stop" }));
  };
};
function wg(s) {
  z.info("recodemux opts:", s);
  const t = Dt.createFile(), e = new Ui(), r = (u, f) => {
    const p = u.add("udta").add("meta");
    p.data = xg(f), p.size = p.data.byteLength;
  };
  let n = !1;
  const a = () => {
    t.moov == null || n || (n = !0, s.metaDataTags != null && r(t.moov, s.metaDataTags), s.duration != null && (t.moov.mvhd.duration = s.duration));
  };
  e.once("VideoReady", a), e.once("AudioReady", a);
  let l = s.video != null ? Sg(s.video, t, e) : null, h = s.audio != null ? Cg(s.audio, t, e) : null;
  return s.video == null && e.emit("VideoReady"), s.audio == null && e.emit("AudioReady"), {
    encodeVideo: (u, f) => {
      l?.encode(u, f), u.close();
    },
    encodeAudio: (u) => {
      if (h != null)
        try {
          h.encode(u), u.close();
        } catch (f) {
          const p = `encode audio chunk error: ${f.message}, state: ${JSON.stringify(
            {
              qSize: h.encodeQueueSize,
              state: h.state
            }
          )}`;
          throw z.error(p), Error(p);
        }
    },
    getEncodeQueueSize: () => l?.encodeQueueSize ?? h?.encodeQueueSize ?? 0,
    flush: async () => {
      await Promise.all([
        l?.flush(),
        h?.state === "configured" ? h.flush() : null
      ]);
    },
    close: () => {
      e.destroy(), l?.close(), h?.state === "configured" && h.close();
    },
    mp4file: t
  };
}
function Sg(s, t, e) {
  const r = {
    // 微秒
    timescale: 1e6,
    width: s.width,
    height: s.height,
    brands: ["isom", "iso2", "avc1", "mp42", "mp41"],
    avcDecoderConfigRecord: null,
    hevcDecoderConfigRecord: null,
    vpcDecoderConfigRecord: null,
    type: "avc1",
    name: "Track created with WebAV"
  };
  let n = -1, a = !1;
  e.once("AudioReady", () => {
    a = !0;
  });
  const l = {
    encoder0: [],
    encoder1: []
  }, h = (_, y, v) => {
    if (n === -1 && v != null) {
      let b = v.decoderConfig?.description;
      s.codec.startsWith("avc1") ? Tg(b) : s.codec.startsWith("vp09") && v.decoderConfig && (r.type = "vp09", b = Ag(v.decoderConfig));
      const w = [
        ["avc1", "avcDecoderConfigRecord"],
        ["hvc1", "hevcDecoderConfigRecord"],
        ["vp09", "vpcDecoderConfigRecord"]
      ].find(([S]) => s.codec.startsWith(S))?.[1];
      w != null && b != null && (r[w] = b), n = t.addTrack(r), e.emit("VideoReady"), z.info("VideoEncoder, video track ready, trackId:", n);
    }
    l[_].push(to(y));
  };
  let u = "encoder1", f = 0;
  const p = Math.floor(1e3 / s.expectFPS * 1e3);
  function m() {
    if (!a) return;
    const _ = u === "encoder1" ? "encoder0" : "encoder1", y = l[u], v = l[_];
    if (y.length === 0 && v.length === 0) return;
    let b = y[0];
    if (b != null && (!b.is_sync || b.cts - f < p)) {
      const S = g(y);
      S > f && (f = S);
    }
    const w = v[0];
    if (w?.is_sync && w.cts - f < p) {
      u = _, m();
      return;
    }
    if (b?.is_sync && w?.is_sync)
      if (b.cts <= w.cts) {
        const S = g(y);
        S > f && (f = S);
      } else {
        u = _, m();
        return;
      }
  }
  function g(_) {
    let y = -1, v = 0;
    for (; v < _.length; v++) {
      const b = _[v];
      if (v > 0 && b.is_sync) break;
      t.addSample(n, b.data, b), y = b.cts + b.duration;
    }
    return _.splice(0, v), y;
  }
  const x = sh(m, 15), o = Al(
    s,
    (_, y) => h("encoder0", _, y)
  ), c = Al(
    s,
    (_, y) => h("encoder1", _, y)
  );
  let d = 0;
  return {
    get encodeQueueSize() {
      return o.encodeQueueSize + c.encodeQueueSize;
    },
    encode: (_, y) => {
      try {
        y.keyFrame && (d += 1), (d % 2 === 0 ? o : c).encode(_, y);
      } catch (v) {
        const b = `encode video frame error: ${v.message}, state: ${JSON.stringify(
          {
            ts: _.timestamp,
            keyFrame: y.keyFrame,
            duration: _.duration,
            gopId: d
          }
        )}`;
        throw z.error(b), Error(b);
      }
    },
    flush: async () => {
      await Promise.all([
        o.state === "configured" ? await o.flush() : null,
        c.state === "configured" ? await c.flush() : null
      ]), x(), m();
    },
    close: () => {
      o.state === "configured" && o.close(), c.state === "configured" && c.close();
    }
  };
}
function Tg(s) {
  const t = new Uint8Array(s);
  t[2].toString(2).slice(-2).includes("1") && (t[2] = 0);
}
function Al(s, t) {
  const e = {
    codec: s.codec,
    framerate: s.expectFPS,
    hardwareAcceleration: s.__unsafe_hardwareAcceleration__,
    // 码率
    bitrate: s.bitrate,
    width: s.width,
    height: s.height,
    // H264 不支持背景透明度
    alpha: "discard",
    // macos 自带播放器只支持avc
    avc: { format: "avc" }
    // mp4box.js 无法解析 annexb 的 mimeCodec ，只会显示 avc1
    // avc: { format: 'annexb' }
  }, r = new VideoEncoder({
    error: (n) => {
      const a = `VideoEncoder error: ${n.message}, config: ${JSON.stringify(e)}, state: ${JSON.stringify(
        {
          qSize: r.encodeQueueSize,
          state: r.state
        }
      )}`;
      throw z.error(a), Error(a);
    },
    output: t
  });
  return r.configure(e), r;
}
function Cg(s, t, e) {
  const r = {
    timescale: 1e6,
    samplerate: s.sampleRate,
    channel_count: s.channelCount,
    hdlr: "soun",
    type: s.codec === "aac" ? "mp4a" : "Opus",
    name: "Track created with WebAV"
  };
  let n = -1, a = [], l = !1;
  e.once("VideoReady", () => {
    l = !0, a.forEach((f) => {
      const p = to(f);
      t.addSample(n, p.data, p);
    }), a = [];
  });
  const h = {
    codec: s.codec === "aac" ? "mp4a.40.2" : "opus",
    sampleRate: s.sampleRate,
    numberOfChannels: s.channelCount,
    bitrate: 128e3
  }, u = new AudioEncoder({
    error: (f) => {
      const p = `AudioEncoder error: ${f.message}, config: ${JSON.stringify(
        h
      )}, state: ${JSON.stringify({
        qSize: u.encodeQueueSize,
        state: u.state
      })}`;
      throw z.error(p), Error(p);
    },
    output: (f, p) => {
      if (n === -1) {
        const m = p?.decoderConfig?.description;
        n = t.addTrack({
          ...r,
          description: m == null ? void 0 : Eg(m)
        }), e.emit("AudioReady"), z.info("AudioEncoder, audio track ready, trackId:", n);
      }
      if (l) {
        const m = to(f);
        t.addSample(n, m.data, m);
      } else
        a.push(f);
    }
  });
  return u.configure(h), u;
}
function Eg(s) {
  const t = s.byteLength, e = new Uint8Array([
    0,
    // version 0
    0,
    0,
    0,
    // flags
    3,
    // descriptor_type
    23 + t,
    // length
    0,
    // 0x01, // es_id
    2,
    // es_id
    0,
    // stream_priority
    4,
    // descriptor_type
    18 + t,
    // length
    64,
    // codec : mpeg4_audio
    21,
    // stream_type
    0,
    0,
    0,
    // buffer_size
    0,
    0,
    0,
    0,
    // maxBitrate
    0,
    0,
    0,
    0,
    // avgBitrate
    5,
    // descriptor_type
    t,
    ...new Uint8Array(s instanceof ArrayBuffer ? s : s.buffer),
    6,
    1,
    2
  ]), r = new Dt.BoxParser.esdsBox(e.byteLength);
  return r.hdr_size = 0, r.parse(new Dt.DataStream(e, 0, Dt.DataStream.BIG_ENDIAN)), r;
}
function to(s) {
  const t = new ArrayBuffer(s.byteLength);
  s.copyTo(t);
  const e = s.timestamp;
  return {
    duration: s.duration ?? 0,
    dts: e,
    cts: e,
    is_sync: s.type === "key",
    data: t
  };
}
function Ag(s) {
  const t = s.codec.split("."), e = parseInt(t[1] || "0", 10), r = parseInt(t[2] || "40", 10), n = parseInt(t[3] || "08", 10), a = {
    bt709: 1,
    bt601: 5,
    bt2020: 9
  }, l = {
    bt709: 1,
    srgb: 13,
    pq: 16,
    hlg: 18
  }, h = {
    bt709: 1,
    bt601: 5,
    bt2020: 9
  }, u = a[s.colorSpace?.primaries || "bt709"] || 1, f = l[s.colorSpace?.transfer || "bt709"] || 1, p = h[s.colorSpace?.matrix || "bt709"] || 1, m = s.colorSpace?.fullRange ? 1 : 0, g = 1, x = 0, o = new ArrayBuffer(12), c = new DataView(o);
  let d = 0;
  return c.setUint32(d, 1 << 24), d += 4, c.setUint8(d++, e), c.setUint8(d++, r), c.setUint8(
    d++,
    n << 4 | g << 1 | m
  ), c.setUint8(d++, u), c.setUint8(d++, f), c.setUint8(d++, p), c.setUint16(d, x), o;
}
function nh(s, t) {
  let e = !1;
  async function r() {
    const n = s.getReader();
    for (; !e; ) {
      const { value: a, done: l } = await n.read();
      if (l) {
        t.onDone();
        return;
      }
      await t.onChunk(a);
    }
    n.releaseLock(), await s.cancel();
  }
  return r().catch(console.error), () => {
    e = !0;
  };
}
function id(s, t, e) {
  let r = 0, n = 0;
  const a = s.boxes;
  let l = !1;
  const h = () => {
    if (!l)
      if (a.find((x) => x.type === "moof") != null)
        l = !0;
      else
        return null;
    if (n >= a.length) return null;
    const m = new Dt.DataStream();
    m.endianness = Dt.DataStream.BIG_ENDIAN;
    let g = n;
    try {
      for (; g < a.length; )
        a[g].write(m), delete a[g], g += 1;
    } catch (x) {
      const o = a[g];
      throw x instanceof Error && o != null ? Error(
        `${x.message} | deltaBuf( boxType: ${o.type}, boxSize: ${o.size}, boxDataLen: ${o.data?.length ?? -1})`
      ) : x;
    }
    return Pg(s), n = a.length, new Uint8Array(m.buffer);
  };
  let u = !1, f = !1, p = null;
  return {
    stream: new ReadableStream({
      start(m) {
        r = self.setInterval(() => {
          const g = h();
          g != null && !f && m.enqueue(g);
        }, t), p = (g) => {
          if (clearInterval(r), s.flush(), g != null) {
            m.error(g);
            return;
          }
          const x = h();
          x != null && !f && m.enqueue(x), f || m.close();
        }, u && p();
      },
      cancel() {
        f = !0, clearInterval(r), e?.();
      }
    }),
    stop: (m) => {
      u || (u = !0, p?.(m));
    }
  };
}
function Pg(s) {
  if (s.moov != null) {
    for (var t = 0; t < s.moov.traks.length; t++)
      s.moov.traks[t].samples = [];
    s.mdats = [], s.moofs = [];
  }
}
function Mg(s, t) {
  let e;
  return function(...r) {
    if (e == null || performance.now() - e > t)
      return e = performance.now(), s.apply(this, r);
  };
}
function Bg(s, t) {
  let e = 0;
  return function(...r) {
    e !== 0 && clearTimeout(e), e = setTimeout(() => {
      s.apply(this, r);
    }, t);
  };
}
var rd = (s) => {
  throw TypeError(s);
}, sd = (s, t, e) => t.has(s) || rd("Cannot " + e), q = (s, t, e) => (sd(s, t, "read from private field"), e ? e.call(s) : t.get(s)), pe = (s, t, e) => t.has(s) ? rd("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(s) : t.set(s, e), se = (s, t, e, r) => (sd(s, t, "write to private field"), t.set(s, e), e);
const nd = "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", Ug = (s) => Uint8Array.from(atob(s), (t) => t.charCodeAt(0)), Pl = typeof self < "u" && self.Blob && new Blob([Ug(nd)], { type: "text/javascript;charset=utf-8" });
function Rg(s) {
  let t;
  try {
    if (t = Pl && (self.URL || self.webkitURL).createObjectURL(Pl), !t) throw "";
    const e = new Worker(t, {
      name: s?.name
    });
    return e.addEventListener("error", () => {
      (self.URL || self.webkitURL).revokeObjectURL(t);
    }), e;
  } catch {
    return new Worker(
      "data:text/javascript;base64," + nd,
      {
        name: s?.name
      }
    );
  } finally {
    t && (self.URL || self.webkitURL).revokeObjectURL(t);
  }
}
async function Ig(s, t, e) {
  const r = kg();
  return await r("register", { fileId: s, filePath: t, mode: e }), {
    read: async (n, a) => await r("read", {
      fileId: s,
      offset: n,
      size: a
    }),
    write: async (n, a) => await r(
      "write",
      {
        fileId: s,
        data: n,
        opts: a
      },
      [ArrayBuffer.isView(n) ? n.buffer : n]
    ),
    close: async () => await r("close", {
      fileId: s
    }),
    truncate: async (n) => await r("truncate", {
      fileId: s,
      newSize: n
    }),
    getSize: async () => await r("getSize", {
      fileId: s
    }),
    flush: async () => await r("flush", {
      fileId: s
    })
  };
}
const As = [];
let Kn = 0;
function kg() {
  if (As.length < 3) {
    const t = s();
    return As.push(t), t;
  } else {
    const t = As[Kn];
    return Kn = (Kn + 1) % As.length, t;
  }
  function s() {
    const t = new Rg();
    let e = 0, r = {};
    return t.onmessage = ({
      data: n
    }) => {
      var a, l;
      n.evtType === "callback" ? (a = r[n.cbId]) == null || a.resolve(n.returnVal) : n.evtType === "throwError" && ((l = r[n.cbId]) == null || l.reject(Error(n.errMsg))), delete r[n.cbId];
    }, async function(n, a, l = []) {
      e += 1;
      const h = new Promise((u, f) => {
        r[e] = { resolve: u, reject: f };
      });
      return t.postMessage(
        {
          cbId: e,
          evtType: n,
          args: a
        },
        l
      ), h;
    };
  }
}
function Fn(s) {
  if (s === "/") return { parent: null, name: "" };
  const t = s.split("/").filter((n) => n.length > 0);
  if (t.length === 0) throw Error("Invalid path");
  const e = t[t.length - 1], r = "/" + t.slice(0, -1).join("/");
  return { name: e, parent: r };
}
async function Ke(s, t) {
  const { parent: e, name: r } = Fn(s);
  if (e == null) return await navigator.storage.getDirectory();
  const n = e.split("/").filter((a) => a.length > 0);
  try {
    let a = await navigator.storage.getDirectory();
    for (const l of n)
      a = await a.getDirectoryHandle(l, {
        create: t.create
      });
    return t.isFile ? await a.getFileHandle(r, {
      create: t.create
    }) : await a.getDirectoryHandle(r, {
      create: t.create
    });
  } catch (a) {
    if (a.name === "NotFoundError")
      return null;
    throw a;
  }
}
async function ad(s) {
  const { parent: t, name: e } = Fn(s);
  if (t == null) {
    const n = await navigator.storage.getDirectory();
    for await (const a of n.keys())
      await n.removeEntry(a, { recursive: !0 });
    return;
  }
  const r = await Ke(t, {
    create: !1,
    isFile: !1
  });
  if (r != null)
    try {
      await r.removeEntry(e, { recursive: !0 });
    } catch (n) {
      if (n.name === "NotFoundError") return;
      throw n;
    }
}
function eo(s, t) {
  return `${s}/${t}`.replace("//", "/");
}
function $i(s) {
  return new hd(s);
}
var xe, Zs, Br;
const Fg = class od {
  constructor(t) {
    pe(this, xe), pe(this, Zs), pe(this, Br), se(this, xe, t);
    const { parent: e, name: r } = Fn(t);
    se(this, Zs, r), se(this, Br, e);
  }
  get kind() {
    return "dir";
  }
  get name() {
    return q(this, Zs);
  }
  get path() {
    return q(this, xe);
  }
  get parent() {
    return q(this, Br) == null ? null : $i(q(this, Br));
  }
  /**
   * Creates the directory.
   * return A promise that resolves when the directory is created.
   */
  async create() {
    return await Ke(q(this, xe), {
      create: !0,
      isFile: !1
    }), $i(q(this, xe));
  }
  /**
   * Checks if the directory exists.
   * return A promise that resolves to true if the directory exists, otherwise false.
   */
  async exists() {
    return await Ke(q(this, xe), {
      create: !1,
      isFile: !1
    }) instanceof FileSystemDirectoryHandle;
  }
  /**
   * Removes the directory.
   * return A promise that resolves when the directory is removed.
   */
  async remove() {
    for (const t of await this.children())
      try {
        await t.remove();
      } catch (e) {
        console.warn(e);
      }
    try {
      await ad(q(this, xe));
    } catch (t) {
      console.warn(t);
    }
  }
  /**
   * Retrieves the children of the directory.
   * return A promise that resolves to an array of objects representing the children.
   */
  async children() {
    const t = await Ke(q(this, xe), {
      create: !1,
      isFile: !1
    });
    if (t == null) return [];
    const e = [];
    for await (const r of t.values())
      e.push((r.kind === "file" ? er : $i)(eo(q(this, xe), r.name)));
    return e;
  }
  async copyTo(t) {
    if (!await this.exists())
      throw Error(`dir ${this.path} not exists`);
    if (t instanceof od) {
      const e = await t.exists() ? $i(eo(t.path, this.name)) : t;
      return await e.create(), await Promise.all((await this.children()).map((r) => r.copyTo(e))), e;
    } else if (t instanceof FileSystemDirectoryHandle)
      return await Promise.all(
        (await this.children()).map(async (e) => {
          e.kind === "file" ? await e.copyTo(
            await t.getFileHandle(e.name, { create: !0 })
          ) : await e.copyTo(
            await t.getDirectoryHandle(e.name, { create: !0 })
          );
        })
      ), null;
    throw Error("Illegal target type");
  }
  /**
   * move directory, copy then remove current
   */
  async moveTo(t) {
    const e = await this.copyTo(t);
    return await this.remove(), e;
  }
};
xe = /* @__PURE__ */ new WeakMap(), Zs = /* @__PURE__ */ new WeakMap(), Br = /* @__PURE__ */ new WeakMap();
let hd = Fg;
const Ml = /* @__PURE__ */ new Map();
function er(s, t = "rw") {
  if (t === "rw") {
    const e = Ml.get(s) ?? new dn(s, t);
    return Ml.set(s, e), e;
  }
  return new dn(s, t);
}
async function Qr(s, t, e = { overwrite: !0 }) {
  if (t instanceof dn) {
    await Qr(s, await t.stream(), e);
    return;
  }
  const r = await (s instanceof dn ? s : er(s, "rw")).createWriter();
  try {
    if (e.overwrite && await r.truncate(0), t instanceof ReadableStream) {
      const n = t.getReader();
      for (; ; ) {
        const { done: a, value: l } = await n.read();
        if (a) break;
        await r.write(l);
      }
    } else
      await r.write(t);
  } catch (n) {
    throw n;
  } finally {
    await r.close();
  }
}
let Dg = 0;
const Og = () => ++Dg;
var be, Ur, Qs, Rr, Js, Xe, tn, Ir;
const Lg = class ld {
  constructor(t, e) {
    pe(this, be), pe(this, Ur), pe(this, Qs), pe(this, Rr), pe(this, Js), pe(this, Xe, 0), pe(this, tn, /* @__PURE__ */ (() => {
      let a = null;
      return () => (se(this, Xe, q(this, Xe) + 1), a ?? (a = new Promise(async (l, h) => {
        try {
          const u = await Ig(
            q(this, Js),
            q(this, be),
            q(this, Rr)
          );
          l([
            u,
            async () => {
              se(this, Xe, q(this, Xe) - 1), !(q(this, Xe) > 0) && (a = null, await u.close());
            }
          ]);
        } catch (u) {
          h(u);
        }
      })));
    })()), pe(this, Ir, !1), se(this, Js, Og()), se(this, be, t), se(this, Rr, {
      r: "read-only",
      rw: "readwrite",
      "rw-unsafe": "readwrite-unsafe"
    }[e]);
    const { parent: r, name: n } = Fn(t);
    if (r == null) throw Error("Invalid path");
    se(this, Qs, n), se(this, Ur, r);
  }
  get kind() {
    return "file";
  }
  get path() {
    return q(this, be);
  }
  get name() {
    return q(this, Qs);
  }
  get parent() {
    return q(this, Ur) == null ? null : $i(q(this, Ur));
  }
  /**
   * Random write to file
   */
  async createWriter() {
    if (q(this, Rr) === "read-only") throw Error("file is read-only");
    if (q(this, Ir)) throw Error("Other writer have not been closed");
    se(this, Ir, !0);
    const t = new TextEncoder(), [e, r] = await q(this, tn).call(this);
    let n = await e.getSize(), a = !1;
    return {
      write: async (l, h = {}) => {
        if (a) throw Error("Writer is closed");
        const u = typeof l == "string" ? t.encode(l) : l, f = h.at ?? n, p = u.byteLength;
        return n = f + p, await e.write(u, { at: f });
      },
      truncate: async (l) => {
        if (a) throw Error("Writer is closed");
        await e.truncate(l), n > l && (n = l);
      },
      flush: async () => {
        if (a) throw Error("Writer is closed");
        await e.flush();
      },
      close: async () => {
        if (a) throw Error("Writer is closed");
        a = !0, se(this, Ir, !1), await r();
      }
    };
  }
  /**
   * Random access to file
   */
  async createReader() {
    const [t, e] = await q(this, tn).call(this);
    let r = !1, n = 0;
    return {
      read: async (a, l = {}) => {
        if (r) throw Error("Reader is closed");
        const h = l.at ?? n, u = await t.read(h, a);
        return n = h + u.byteLength, u;
      },
      getSize: async () => {
        if (r) throw Error("Reader is closed");
        return await t.getSize();
      },
      close: async () => {
        r || (r = !0, await e());
      }
    };
  }
  async text() {
    return new TextDecoder().decode(await this.arrayBuffer());
  }
  async arrayBuffer() {
    const t = await Ke(q(this, be), { create: !1, isFile: !0 });
    return t == null ? new ArrayBuffer(0) : (await t.getFile()).arrayBuffer();
  }
  async stream() {
    const t = await this.getOriginFile();
    return t == null ? new ReadableStream({
      pull: (e) => {
        e.close();
      }
    }) : t.stream();
  }
  async getOriginFile() {
    var t;
    return (t = await Ke(q(this, be), { create: !1, isFile: !0 })) == null ? void 0 : t.getFile();
  }
  async getSize() {
    const t = await Ke(q(this, be), { create: !1, isFile: !0 });
    return t == null ? 0 : (await t.getFile()).size;
  }
  async exists() {
    return await Ke(q(this, be), {
      create: !1,
      isFile: !0
    }) instanceof FileSystemFileHandle;
  }
  async remove() {
    if (q(this, Xe)) throw Error("exists unclosed reader/writer");
    await ad(q(this, be));
  }
  async copyTo(t) {
    if (t instanceof ld)
      return t.path === this.path ? this : (await Qr(t.path, this), er(t.path));
    if (t instanceof hd) {
      if (!await this.exists())
        throw Error(`file ${this.path} not exists`);
      return await this.copyTo(er(eo(t.path, this.name)));
    } else if (t instanceof FileSystemFileHandle)
      return await (await this.stream()).pipeTo(await t.createWritable()), null;
    throw Error("Illegal target type");
  }
  /**
   * move file, copy then remove current
   */
  async moveTo(t) {
    const e = await this.copyTo(t);
    return await this.remove(), e;
  }
};
be = /* @__PURE__ */ new WeakMap(), Ur = /* @__PURE__ */ new WeakMap(), Qs = /* @__PURE__ */ new WeakMap(), Rr = /* @__PURE__ */ new WeakMap(), Js = /* @__PURE__ */ new WeakMap(), Xe = /* @__PURE__ */ new WeakMap(), tn = /* @__PURE__ */ new WeakMap(), Ir = /* @__PURE__ */ new WeakMap();
let dn = Lg;
const ah = "/.opfs-tools-temp-dir";
async function cd(s) {
  try {
    if (s.kind === "file") {
      if (!await s.exists()) return !0;
      const t = await s.createWriter();
      await t.truncate(0), await t.close(), await s.remove();
    } else
      await s.remove();
    return !0;
  } catch (t) {
    return console.warn(t), !1;
  }
}
function Gg() {
  setInterval(async () => {
    for (const s of await $i(ah).children()) {
      const t = /^\d+-(\d+)$/.exec(s.name);
      (t == null || Date.now() - Number(t[1]) > 2592e5) && await cd(s);
    }
  }, 60 * 1e3);
}
const io = [];
let Bl = !1;
async function zg() {
  if (globalThis.localStorage == null) return;
  const s = "OPFS_TOOLS_EXPIRES_TMP_FILES";
  Bl || (Bl = !0, globalThis.addEventListener("unload", () => {
    io.length !== 0 && localStorage.setItem(
      s,
      `${localStorage.getItem(s) ?? ""},${io.join(",")}`
    );
  }));
  let t = localStorage.getItem(s) ?? "";
  for (const e of t.split(","))
    e.length !== 0 && await cd(er(`${ah}/${e}`)) && (t = t.replace(e, ""));
  localStorage.setItem(s, t.replace(/,{2,}/g, ","));
}
(async function() {
  var s;
  globalThis.__opfs_tools_tmpfile_init__ !== !0 && (globalThis.__opfs_tools_tmpfile_init__ = !0, !(globalThis.FileSystemDirectoryHandle == null || globalThis.FileSystemFileHandle == null || ((s = globalThis.navigator) == null ? void 0 : s.storage.getDirectory) == null) && (Gg(), await zg()));
})();
function ro() {
  const s = `${Math.random().toString().slice(2)}-${Date.now()}`;
  return io.push(s), er(`${ah}/${s}`);
}
class Ng {
  /**
   * @param {number} scaleFrom the length of the original array.
   * @param {number} scaleTo The length of the new array.
   * @param {?Object} details The extra configuration, if needed.
   */
  constructor(t, e, r) {
    this.length_ = t, this.scaleFactor_ = (t - 1) / e, this.interpolate = this.cubic, r.method === "point" ? this.interpolate = this.point : r.method === "linear" ? this.interpolate = this.linear : r.method === "sinc" && (this.interpolate = this.sinc), this.tangentFactor_ = 1 - Math.max(0, Math.min(1, r.tension || 0)), this.sincFilterSize_ = r.sincFilterSize || 1, this.kernel_ = Wg(r.sincWindow || Hg);
  }
  /**
   * @param {number} t The index to interpolate.
   * @param {Array|TypedArray} samples the original array.
   * @return {number} The interpolated value.
   */
  point(t, e) {
    return this.getClippedInput_(Math.round(this.scaleFactor_ * t), e);
  }
  /**
   * @param {number} t The index to interpolate.
   * @param {Array|TypedArray} samples the original array.
   * @return {number} The interpolated value.
   */
  linear(t, e) {
    t = this.scaleFactor_ * t;
    let r = Math.floor(t);
    return t -= r, (1 - t) * this.getClippedInput_(r, e) + t * this.getClippedInput_(r + 1, e);
  }
  /**
   * @param {number} t The index to interpolate.
   * @param {Array|TypedArray} samples the original array.
   * @return {number} The interpolated value.
   */
  cubic(t, e) {
    t = this.scaleFactor_ * t;
    let r = Math.floor(t), n = [this.getTangent_(r, e), this.getTangent_(r + 1, e)], a = [
      this.getClippedInput_(r, e),
      this.getClippedInput_(r + 1, e)
    ];
    t -= r;
    let l = t * t, h = t * l;
    return (2 * h - 3 * l + 1) * a[0] + (h - 2 * l + t) * n[0] + (-2 * h + 3 * l) * a[1] + (h - l) * n[1];
  }
  /**
   * @param {number} t The index to interpolate.
   * @param {Array|TypedArray} samples the original array.
   * @return {number} The interpolated value.
   */
  sinc(t, e) {
    t = this.scaleFactor_ * t;
    let r = Math.floor(t), n = r - this.sincFilterSize_ + 1, a = r + this.sincFilterSize_, l = 0;
    for (let h = n; h <= a; h++)
      l += this.kernel_(t - h) * this.getClippedInput_(h, e);
    return l;
  }
  /**
   * @param {number} k The scaled index to interpolate.
   * @param {Array|TypedArray} samples the original array.
   * @return {number} The tangent.
   * @private
   */
  getTangent_(t, e) {
    return this.tangentFactor_ * (this.getClippedInput_(t + 1, e) - this.getClippedInput_(t - 1, e)) / 2;
  }
  /**
   * @param {number} t The scaled index to interpolate.
   * @param {Array|TypedArray} samples the original array.
   * @return {number} The interpolated value.
   * @private
   */
  getClippedInput_(t, e) {
    return 0 <= t && t < this.length_ ? e[t] : 0;
  }
}
function Hg(s) {
  return Math.exp(-s / 2 * s / 2);
}
function Wg(s) {
  return function(t) {
    return Vg(t) * s(t);
  };
}
function Vg(s) {
  return s === 0 ? 1 : Math.sin(Math.PI * s) / (Math.PI * s);
}
class $g {
  /**
   * @param {number} order The order of the filter.
   * @param {number} sampleRate The sample rate.
   * @param {number} cutOff The cut off frequency.
   */
  constructor(t, e, r) {
    let n = 2 * Math.PI * r / e, a = 0;
    this.filters = [];
    for (let l = 0; l <= t; l++)
      l - t / 2 === 0 ? this.filters[l] = n : (this.filters[l] = Math.sin(n * (l - t / 2)) / (l - t / 2), this.filters[l] *= 0.54 - 0.46 * Math.cos(2 * Math.PI * l / t)), a = a + this.filters[l];
    for (let l = 0; l <= t; l++)
      this.filters[l] /= a;
    this.z = this.initZ_();
  }
  /**
   * @param {number} sample A sample of a sequence.
   * @return {number}
   */
  filter(t) {
    this.z.buf[this.z.pointer] = t;
    let e = 0;
    for (let r = 0, n = this.z.buf.length; r < n; r++)
      e += this.filters[r] * this.z.buf[(this.z.pointer + r) % this.z.buf.length];
    return this.z.pointer = (this.z.pointer + 1) % this.z.buf.length, e;
  }
  /**
   * Reset the filter.
   */
  reset() {
    this.z = this.initZ_();
  }
  /**
   * Return the default value for z.
   * @private
   */
  initZ_() {
    let t = [];
    for (let e = 0; e < this.filters.length - 1; e++)
      t.push(0);
    return {
      buf: t,
      pointer: 0
    };
  }
}
class Yg {
  /**
   * @param {number} order The order of the filter.
   * @param {number} sampleRate The sample rate.
   * @param {number} cutOff The cut off frequency.
   */
  constructor(t, e, r) {
    let n = [];
    for (let a = 0; a < t; a++)
      n.push(this.getCoeffs_({
        Fs: e,
        Fc: r,
        Q: 0.5 / Math.sin(Math.PI / (t * 2) * (a + 0.5))
      }));
    this.stages = [];
    for (let a = 0; a < n.length; a++)
      this.stages[a] = {
        b0: n[a].b[0],
        b1: n[a].b[1],
        b2: n[a].b[2],
        a1: n[a].a[0],
        a2: n[a].a[1],
        k: n[a].k,
        z: [0, 0]
      };
  }
  /**
   * @param {number} sample A sample of a sequence.
   * @return {number}
   */
  filter(t) {
    let e = t;
    for (let r = 0, n = this.stages.length; r < n; r++)
      e = this.runStage_(r, e);
    return e;
  }
  getCoeffs_(t) {
    let e = {};
    e.z = [0, 0], e.a = [], e.b = [];
    let r = this.preCalc_(t, e);
    return e.k = 1, e.b.push((1 - r.cw) / (2 * r.a0)), e.b.push(2 * e.b[0]), e.b.push(e.b[0]), e;
  }
  preCalc_(t, e) {
    let r = {}, n = 2 * Math.PI * t.Fc / t.Fs;
    return r.alpha = Math.sin(n) / (2 * t.Q), r.cw = Math.cos(n), r.a0 = 1 + r.alpha, e.a0 = r.a0, e.a.push(-2 * r.cw / r.a0), e.k = 1, e.a.push((1 - r.alpha) / r.a0), r;
  }
  runStage_(t, e) {
    let r = e * this.stages[t].k - this.stages[t].a1 * this.stages[t].z[0] - this.stages[t].a2 * this.stages[t].z[1], n = this.stages[t].b0 * r + this.stages[t].b1 * this.stages[t].z[0] + this.stages[t].b2 * this.stages[t].z[1];
    return this.stages[t].z[1] = this.stages[t].z[0], this.stages[t].z[0] = r, n;
  }
  /**
   * Reset the filter.
   */
  reset() {
    for (let t = 0; t < this.stages.length; t++)
      this.stages[t].z = [0, 0];
  }
}
const Xg = {
  point: !1,
  linear: !1,
  cubic: !0,
  sinc: !0
}, Ul = {
  IIR: 16,
  FIR: 71
}, jg = {
  IIR: Yg,
  FIR: $g
};
function Kg(s, t, e, r = {}) {
  let n = (e - t) / t + 1, a = new Float64Array(s.length * n);
  r.method = r.method || "cubic";
  let l = new Ng(
    s.length,
    a.length,
    {
      method: r.method,
      tension: r.tension || 0,
      sincFilterSize: r.sincFilterSize || 6,
      sincWindow: r.sincWindow || void 0
    }
  );
  if (r.LPF === void 0 && (r.LPF = Xg[r.method]), r.LPF) {
    r.LPFType = r.LPFType || "IIR";
    const h = jg[r.LPFType];
    if (e > t) {
      let u = new h(
        r.LPFOrder || Ul[r.LPFType],
        e,
        t / 2
      );
      qg(
        s,
        a,
        l,
        u
      );
    } else {
      let u = new h(
        r.LPFOrder || Ul[r.LPFType],
        t,
        e / 2
      );
      Zg(
        s,
        a,
        l,
        u
      );
    }
  } else
    ud(s, a, l);
  return a;
}
function ud(s, t, e) {
  for (let r = 0, n = t.length; r < n; r++)
    t[r] = e.interpolate(r, s);
}
function qg(s, t, e, r) {
  for (let n = 0, a = t.length; n < a; n++)
    t[n] = r.filter(e.interpolate(n, s));
  r.reset();
  for (let n = t.length - 1; n >= 0; n--)
    t[n] = r.filter(t[n]);
}
function Zg(s, t, e, r) {
  for (let n = 0, a = s.length; n < a; n++)
    s[n] = r.filter(s[n]);
  r.reset();
  for (let n = s.length - 1; n >= 0; n--)
    s[n] = r.filter(s[n]);
  ud(s, t, e);
}
function Fe(s) {
  if (s === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return s;
}
function dd(s, t) {
  s.prototype = Object.create(t.prototype), s.prototype.constructor = s, s.__proto__ = t;
}
/*!
 * GSAP 3.13.0
 * https://gsap.com
 *
 * @license Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/
var Kt = {
  autoSleep: 120,
  force3D: "auto",
  nullTargetWarn: 1,
  units: {
    lineHeight: ""
  }
}, ir = {
  duration: 0.5,
  overwrite: !1,
  delay: 0
}, oh, Tt, nt, Pe = 1e8, Mt = 1 / Pe, so = Math.PI * 2, Qg = so / 4, Jg = 0, fd = Math.sqrt, ty = Math.cos, ey = Math.sin, wt = function(t) {
  return typeof t == "string";
}, ut = function(t) {
  return typeof t == "function";
}, We = function(t) {
  return typeof t == "number";
}, hh = function(t) {
  return typeof t > "u";
}, Me = function(t) {
  return typeof t == "object";
}, Ot = function(t) {
  return t !== !1;
}, lh = function() {
  return typeof window < "u";
}, Ps = function(t) {
  return ut(t) || wt(t);
}, pd = typeof ArrayBuffer == "function" && ArrayBuffer.isView || function() {
}, Bt = Array.isArray, no = /(?:-?\.?\d|\.)+/gi, _d = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, Yi = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, qn = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, md = /[+-]=-?[.\d]+/, gd = /[^,'"\[\]\s]+/gi, iy = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i, ot, Se, ao, ch, Qt = {}, fn = {}, yd, xd = function(t) {
  return (fn = rr(t, Qt)) && Nt;
}, uh = function(t, e) {
  return console.warn("Invalid property", t, "set to", e, "Missing plugin? gsap.registerPlugin()");
}, Jr = function(t, e) {
  return !e && console.warn(t);
}, bd = function(t, e) {
  return t && (Qt[t] = e) && fn && (fn[t] = e) || Qt;
}, ts = function() {
  return 0;
}, ry = {
  suppressEvents: !0,
  isStart: !0,
  kill: !1
}, en = {
  suppressEvents: !0,
  kill: !1
}, sy = {
  suppressEvents: !0
}, dh = {}, ii = [], oo = {}, vd, $t = {}, Zn = {}, Rl = 30, rn = [], fh = "", ph = function(t) {
  var e = t[0], r, n;
  if (Me(e) || ut(e) || (t = [t]), !(r = (e._gsap || {}).harness)) {
    for (n = rn.length; n-- && !rn[n].targetTest(e); )
      ;
    r = rn[n];
  }
  for (n = t.length; n--; )
    t[n] && (t[n]._gsap || (t[n]._gsap = new $d(t[n], r))) || t.splice(n, 1);
  return t;
}, Ai = function(t) {
  return t._gsap || ph(oe(t))[0]._gsap;
}, wd = function(t, e, r) {
  return (r = t[e]) && ut(r) ? t[e]() : hh(r) && t.getAttribute && t.getAttribute(e) || r;
}, Lt = function(t, e) {
  return (t = t.split(",")).forEach(e) || t;
}, dt = function(t) {
  return Math.round(t * 1e5) / 1e5 || 0;
}, mt = function(t) {
  return Math.round(t * 1e7) / 1e7 || 0;
}, qi = function(t, e) {
  var r = e.charAt(0), n = parseFloat(e.substr(2));
  return t = parseFloat(t), r === "+" ? t + n : r === "-" ? t - n : r === "*" ? t * n : t / n;
}, ny = function(t, e) {
  for (var r = e.length, n = 0; t.indexOf(e[n]) < 0 && ++n < r; )
    ;
  return n < r;
}, pn = function() {
  var t = ii.length, e = ii.slice(0), r, n;
  for (oo = {}, ii.length = 0, r = 0; r < t; r++)
    n = e[r], n && n._lazy && (n.render(n._lazy[0], n._lazy[1], !0)._lazy = 0);
}, _h = function(t) {
  return !!(t._initted || t._startAt || t.add);
}, Sd = function(t, e, r, n) {
  ii.length && !Tt && pn(), t.render(e, r, !!(Tt && e < 0 && _h(t))), ii.length && !Tt && pn();
}, Td = function(t) {
  var e = parseFloat(t);
  return (e || e === 0) && (t + "").match(gd).length < 2 ? e : wt(t) ? t.trim() : t;
}, Cd = function(t) {
  return t;
}, Jt = function(t, e) {
  for (var r in e)
    r in t || (t[r] = e[r]);
  return t;
}, ay = function(t) {
  return function(e, r) {
    for (var n in r)
      n in e || n === "duration" && t || n === "ease" || (e[n] = r[n]);
  };
}, rr = function(t, e) {
  for (var r in e)
    t[r] = e[r];
  return t;
}, Il = function s(t, e) {
  for (var r in e)
    r !== "__proto__" && r !== "constructor" && r !== "prototype" && (t[r] = Me(e[r]) ? s(t[r] || (t[r] = {}), e[r]) : e[r]);
  return t;
}, _n = function(t, e) {
  var r = {}, n;
  for (n in t)
    n in e || (r[n] = t[n]);
  return r;
}, zr = function(t) {
  var e = t.parent || ot, r = t.keyframes ? ay(Bt(t.keyframes)) : Jt;
  if (Ot(t.inherit))
    for (; e; )
      r(t, e.vars.defaults), e = e.parent || e._dp;
  return t;
}, oy = function(t, e) {
  for (var r = t.length, n = r === e.length; n && r-- && t[r] === e[r]; )
    ;
  return r < 0;
}, Ed = function(t, e, r, n, a) {
  var l = t[n], h;
  if (a)
    for (h = e[a]; l && l[a] > h; )
      l = l._prev;
  return l ? (e._next = l._next, l._next = e) : (e._next = t[r], t[r] = e), e._next ? e._next._prev = e : t[n] = e, e._prev = l, e.parent = e._dp = t, e;
}, Dn = function(t, e, r, n) {
  r === void 0 && (r = "_first"), n === void 0 && (n = "_last");
  var a = e._prev, l = e._next;
  a ? a._next = l : t[r] === e && (t[r] = l), l ? l._prev = a : t[n] === e && (t[n] = a), e._next = e._prev = e.parent = null;
}, si = function(t, e) {
  t.parent && (!e || t.parent.autoRemoveChildren) && t.parent.remove && t.parent.remove(t), t._act = 0;
}, Pi = function(t, e) {
  if (t && (!e || e._end > t._dur || e._start < 0))
    for (var r = t; r; )
      r._dirty = 1, r = r.parent;
  return t;
}, hy = function(t) {
  for (var e = t.parent; e && e.parent; )
    e._dirty = 1, e.totalDuration(), e = e.parent;
  return t;
}, ho = function(t, e, r, n) {
  return t._startAt && (Tt ? t._startAt.revert(en) : t.vars.immediateRender && !t.vars.autoRevert || t._startAt.render(e, !0, n));
}, ly = function s(t) {
  return !t || t._ts && s(t.parent);
}, kl = function(t) {
  return t._repeat ? sr(t._tTime, t = t.duration() + t._rDelay) * t : 0;
}, sr = function(t, e) {
  var r = Math.floor(t = mt(t / e));
  return t && r === t ? r - 1 : r;
}, mn = function(t, e) {
  return (t - e._start) * e._ts + (e._ts >= 0 ? 0 : e._dirty ? e.totalDuration() : e._tDur);
}, On = function(t) {
  return t._end = mt(t._start + (t._tDur / Math.abs(t._ts || t._rts || Mt) || 0));
}, Ln = function(t, e) {
  var r = t._dp;
  return r && r.smoothChildTiming && t._ts && (t._start = mt(r._time - (t._ts > 0 ? e / t._ts : ((t._dirty ? t.totalDuration() : t._tDur) - e) / -t._ts)), On(t), r._dirty || Pi(r, t)), t;
}, Ad = function(t, e) {
  var r;
  if ((e._time || !e._dur && e._initted || e._start < t._time && (e._dur || !e.add)) && (r = mn(t.rawTime(), e), (!e._dur || _s(0, e.totalDuration(), r) - e._tTime > Mt) && e.render(r, !0)), Pi(t, e)._dp && t._initted && t._time >= t._dur && t._ts) {
    if (t._dur < t.duration())
      for (r = t; r._dp; )
        r.rawTime() >= 0 && r.totalTime(r._tTime), r = r._dp;
    t._zTime = -1e-8;
  }
}, Ce = function(t, e, r, n) {
  return e.parent && si(e), e._start = mt((We(r) ? r : r || t !== ot ? re(t, r, e) : t._time) + e._delay), e._end = mt(e._start + (e.totalDuration() / Math.abs(e.timeScale()) || 0)), Ed(t, e, "_first", "_last", t._sort ? "_start" : 0), lo(e) || (t._recent = e), n || Ad(t, e), t._ts < 0 && Ln(t, t._tTime), t;
}, Pd = function(t, e) {
  return (Qt.ScrollTrigger || uh("scrollTrigger", e)) && Qt.ScrollTrigger.create(e, t);
}, Md = function(t, e, r, n, a) {
  if (gh(t, e, a), !t._initted)
    return 1;
  if (!r && t._pt && !Tt && (t._dur && t.vars.lazy !== !1 || !t._dur && t.vars.lazy) && vd !== Yt.frame)
    return ii.push(t), t._lazy = [a, n], 1;
}, cy = function s(t) {
  var e = t.parent;
  return e && e._ts && e._initted && !e._lock && (e.rawTime() < 0 || s(e));
}, lo = function(t) {
  var e = t.data;
  return e === "isFromStart" || e === "isStart";
}, uy = function(t, e, r, n) {
  var a = t.ratio, l = e < 0 || !e && (!t._start && cy(t) && !(!t._initted && lo(t)) || (t._ts < 0 || t._dp._ts < 0) && !lo(t)) ? 0 : 1, h = t._rDelay, u = 0, f, p, m;
  if (h && t._repeat && (u = _s(0, t._tDur, e), p = sr(u, h), t._yoyo && p & 1 && (l = 1 - l), p !== sr(t._tTime, h) && (a = 1 - l, t.vars.repeatRefresh && t._initted && t.invalidate())), l !== a || Tt || n || t._zTime === Mt || !e && t._zTime) {
    if (!t._initted && Md(t, e, n, r, u))
      return;
    for (m = t._zTime, t._zTime = e || (r ? Mt : 0), r || (r = e && !m), t.ratio = l, t._from && (l = 1 - l), t._time = 0, t._tTime = u, f = t._pt; f; )
      f.r(l, f.d), f = f._next;
    e < 0 && ho(t, e, r, !0), t._onUpdate && !r && jt(t, "onUpdate"), u && t._repeat && !r && t.parent && jt(t, "onRepeat"), (e >= t._tDur || e < 0) && t.ratio === l && (l && si(t, 1), !r && !Tt && (jt(t, l ? "onComplete" : "onReverseComplete", !0), t._prom && t._prom()));
  } else t._zTime || (t._zTime = e);
}, dy = function(t, e, r) {
  var n;
  if (r > e)
    for (n = t._first; n && n._start <= r; ) {
      if (n.data === "isPause" && n._start > e)
        return n;
      n = n._next;
    }
  else
    for (n = t._last; n && n._start >= r; ) {
      if (n.data === "isPause" && n._start < e)
        return n;
      n = n._prev;
    }
}, nr = function(t, e, r, n) {
  var a = t._repeat, l = mt(e) || 0, h = t._tTime / t._tDur;
  return h && !n && (t._time *= l / t._dur), t._dur = l, t._tDur = a ? a < 0 ? 1e10 : mt(l * (a + 1) + t._rDelay * a) : l, h > 0 && !n && Ln(t, t._tTime = t._tDur * h), t.parent && On(t), r || Pi(t.parent, t), t;
}, Fl = function(t) {
  return t instanceof Rt ? Pi(t) : nr(t, t._dur);
}, fy = {
  _start: 0,
  endTime: ts,
  totalDuration: ts
}, re = function s(t, e, r) {
  var n = t.labels, a = t._recent || fy, l = t.duration() >= Pe ? a.endTime(!1) : t._dur, h, u, f;
  return wt(e) && (isNaN(e) || e in n) ? (u = e.charAt(0), f = e.substr(-1) === "%", h = e.indexOf("="), u === "<" || u === ">" ? (h >= 0 && (e = e.replace(/=/, "")), (u === "<" ? a._start : a.endTime(a._repeat >= 0)) + (parseFloat(e.substr(1)) || 0) * (f ? (h < 0 ? a : r).totalDuration() / 100 : 1)) : h < 0 ? (e in n || (n[e] = l), n[e]) : (u = parseFloat(e.charAt(h - 1) + e.substr(h + 1)), f && r && (u = u / 100 * (Bt(r) ? r[0] : r).totalDuration()), h > 1 ? s(t, e.substr(0, h - 1), r) + u : l + u)) : e == null ? l : +e;
}, Nr = function(t, e, r) {
  var n = We(e[1]), a = (n ? 2 : 1) + (t < 2 ? 0 : 1), l = e[a], h, u;
  if (n && (l.duration = e[1]), l.parent = r, t) {
    for (h = l, u = r; u && !("immediateRender" in h); )
      h = u.vars.defaults || {}, u = Ot(u.vars.inherit) && u.parent;
    l.immediateRender = Ot(h.immediateRender), t < 2 ? l.runBackwards = 1 : l.startAt = e[a - 1];
  }
  return new _t(e[0], l, e[a + 1]);
}, hi = function(t, e) {
  return t || t === 0 ? e(t) : e;
}, _s = function(t, e, r) {
  return r < t ? t : r > e ? e : r;
}, Pt = function(t, e) {
  return !wt(t) || !(e = iy.exec(t)) ? "" : e[1];
}, py = function(t, e, r) {
  return hi(r, function(n) {
    return _s(t, e, n);
  });
}, co = [].slice, Bd = function(t, e) {
  return t && Me(t) && "length" in t && (!e && !t.length || t.length - 1 in t && Me(t[0])) && !t.nodeType && t !== Se;
}, _y = function(t, e, r) {
  return r === void 0 && (r = []), t.forEach(function(n) {
    var a;
    return wt(n) && !e || Bd(n, 1) ? (a = r).push.apply(a, oe(n)) : r.push(n);
  }) || r;
}, oe = function(t, e, r) {
  return nt && !e && nt.selector ? nt.selector(t) : wt(t) && !r && (ao || !ar()) ? co.call((e || ch).querySelectorAll(t), 0) : Bt(t) ? _y(t, r) : Bd(t) ? co.call(t, 0) : t ? [t] : [];
}, uo = function(t) {
  return t = oe(t)[0] || Jr("Invalid scope") || {}, function(e) {
    var r = t.current || t.nativeElement || t;
    return oe(e, r.querySelectorAll ? r : r === t ? Jr("Invalid scope") || ch.createElement("div") : t);
  };
}, Ud = function(t) {
  return t.sort(function() {
    return 0.5 - Math.random();
  });
}, Rd = function(t) {
  if (ut(t))
    return t;
  var e = Me(t) ? t : {
    each: t
  }, r = Mi(e.ease), n = e.from || 0, a = parseFloat(e.base) || 0, l = {}, h = n > 0 && n < 1, u = isNaN(n) || h, f = e.axis, p = n, m = n;
  return wt(n) ? p = m = {
    center: 0.5,
    edges: 0.5,
    end: 1
  }[n] || 0 : !h && u && (p = n[0], m = n[1]), function(g, x, o) {
    var c = (o || e).length, d = l[c], _, y, v, b, w, S, T, E, C;
    if (!d) {
      if (C = e.grid === "auto" ? 0 : (e.grid || [1, Pe])[1], !C) {
        for (T = -1e8; T < (T = o[C++].getBoundingClientRect().left) && C < c; )
          ;
        C < c && C--;
      }
      for (d = l[c] = [], _ = u ? Math.min(C, c) * p - 0.5 : n % C, y = C === Pe ? 0 : u ? c * m / C - 0.5 : n / C | 0, T = 0, E = Pe, S = 0; S < c; S++)
        v = S % C - _, b = y - (S / C | 0), d[S] = w = f ? Math.abs(f === "y" ? b : v) : fd(v * v + b * b), w > T && (T = w), w < E && (E = w);
      n === "random" && Ud(d), d.max = T - E, d.min = E, d.v = c = (parseFloat(e.amount) || parseFloat(e.each) * (C > c ? c - 1 : f ? f === "y" ? c / C : C : Math.max(C, c / C)) || 0) * (n === "edges" ? -1 : 1), d.b = c < 0 ? a - c : a, d.u = Pt(e.amount || e.each) || 0, r = r && c < 0 ? Hd(r) : r;
    }
    return c = (d[g] - d.min) / d.max || 0, mt(d.b + (r ? r(c) : c) * d.v) + d.u;
  };
}, fo = function(t) {
  var e = Math.pow(10, ((t + "").split(".")[1] || "").length);
  return function(r) {
    var n = mt(Math.round(parseFloat(r) / t) * t * e);
    return (n - n % 1) / e + (We(r) ? 0 : Pt(r));
  };
}, Id = function(t, e) {
  var r = Bt(t), n, a;
  return !r && Me(t) && (n = r = t.radius || Pe, t.values ? (t = oe(t.values), (a = !We(t[0])) && (n *= n)) : t = fo(t.increment)), hi(e, r ? ut(t) ? function(l) {
    return a = t(l), Math.abs(a - l) <= n ? a : l;
  } : function(l) {
    for (var h = parseFloat(a ? l.x : l), u = parseFloat(a ? l.y : 0), f = Pe, p = 0, m = t.length, g, x; m--; )
      a ? (g = t[m].x - h, x = t[m].y - u, g = g * g + x * x) : g = Math.abs(t[m] - h), g < f && (f = g, p = m);
    return p = !n || f <= n ? t[p] : l, a || p === l || We(l) ? p : p + Pt(l);
  } : fo(t));
}, kd = function(t, e, r, n) {
  return hi(Bt(t) ? !e : r === !0 ? !!(r = 0) : !n, function() {
    return Bt(t) ? t[~~(Math.random() * t.length)] : (r = r || 1e-5) && (n = r < 1 ? Math.pow(10, (r + "").length - 2) : 1) && Math.floor(Math.round((t - r / 2 + Math.random() * (e - t + r * 0.99)) / r) * r * n) / n;
  });
}, my = function() {
  for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++)
    e[r] = arguments[r];
  return function(n) {
    return e.reduce(function(a, l) {
      return l(a);
    }, n);
  };
}, gy = function(t, e) {
  return function(r) {
    return t(parseFloat(r)) + (e || Pt(r));
  };
}, yy = function(t, e, r) {
  return Dd(t, e, 0, 1, r);
}, Fd = function(t, e, r) {
  return hi(r, function(n) {
    return t[~~e(n)];
  });
}, xy = function s(t, e, r) {
  var n = e - t;
  return Bt(t) ? Fd(t, s(0, t.length), e) : hi(r, function(a) {
    return (n + (a - t) % n) % n + t;
  });
}, by = function s(t, e, r) {
  var n = e - t, a = n * 2;
  return Bt(t) ? Fd(t, s(0, t.length - 1), e) : hi(r, function(l) {
    return l = (a + (l - t) % a) % a || 0, t + (l > n ? a - l : l);
  });
}, es = function(t) {
  for (var e = 0, r = "", n, a, l, h; ~(n = t.indexOf("random(", e)); )
    l = t.indexOf(")", n), h = t.charAt(n + 7) === "[", a = t.substr(n + 7, l - n - 7).match(h ? gd : no), r += t.substr(e, n - e) + kd(h ? a : +a[0], h ? 0 : +a[1], +a[2] || 1e-5), e = l + 1;
  return r + t.substr(e, t.length - e);
}, Dd = function(t, e, r, n, a) {
  var l = e - t, h = n - r;
  return hi(a, function(u) {
    return r + ((u - t) / l * h || 0);
  });
}, vy = function s(t, e, r, n) {
  var a = isNaN(t + e) ? 0 : function(x) {
    return (1 - x) * t + x * e;
  };
  if (!a) {
    var l = wt(t), h = {}, u, f, p, m, g;
    if (r === !0 && (n = 1) && (r = null), l)
      t = {
        p: t
      }, e = {
        p: e
      };
    else if (Bt(t) && !Bt(e)) {
      for (p = [], m = t.length, g = m - 2, f = 1; f < m; f++)
        p.push(s(t[f - 1], t[f]));
      m--, a = function(o) {
        o *= m;
        var c = Math.min(g, ~~o);
        return p[c](o - c);
      }, r = e;
    } else n || (t = rr(Bt(t) ? [] : {}, t));
    if (!p) {
      for (u in e)
        mh.call(h, t, u, "get", e[u]);
      a = function(o) {
        return bh(o, h) || (l ? t.p : t);
      };
    }
  }
  return hi(r, a);
}, Dl = function(t, e, r) {
  var n = t.labels, a = Pe, l, h, u;
  for (l in n)
    h = n[l] - e, h < 0 == !!r && h && a > (h = Math.abs(h)) && (u = l, a = h);
  return u;
}, jt = function(t, e, r) {
  var n = t.vars, a = n[e], l = nt, h = t._ctx, u, f, p;
  if (a)
    return u = n[e + "Params"], f = n.callbackScope || t, r && ii.length && pn(), h && (nt = h), p = u ? a.apply(f, u) : a.call(f), nt = l, p;
}, kr = function(t) {
  return si(t), t.scrollTrigger && t.scrollTrigger.kill(!!Tt), t.progress() < 1 && jt(t, "onInterrupt"), t;
}, Xi, Od = [], Ld = function(t) {
  if (t)
    if (t = !t.name && t.default || t, lh() || t.headless) {
      var e = t.name, r = ut(t), n = e && !r && t.init ? function() {
        this._props = [];
      } : t, a = {
        init: ts,
        render: bh,
        add: mh,
        kill: Oy,
        modifier: Dy,
        rawVars: 0
      }, l = {
        targetTest: 0,
        get: 0,
        getSetter: xh,
        aliases: {},
        register: 0
      };
      if (ar(), t !== n) {
        if ($t[e])
          return;
        Jt(n, Jt(_n(t, a), l)), rr(n.prototype, rr(a, _n(t, l))), $t[n.prop = e] = n, t.targetTest && (rn.push(n), dh[e] = 1), e = (e === "css" ? "CSS" : e.charAt(0).toUpperCase() + e.substr(1)) + "Plugin";
      }
      bd(e, n), t.register && t.register(Nt, n, Gt);
    } else
      Od.push(t);
}, J = 255, Fr = {
  aqua: [0, J, J],
  lime: [0, J, 0],
  silver: [192, 192, 192],
  black: [0, 0, 0],
  maroon: [128, 0, 0],
  teal: [0, 128, 128],
  blue: [0, 0, J],
  navy: [0, 0, 128],
  white: [J, J, J],
  olive: [128, 128, 0],
  yellow: [J, J, 0],
  orange: [J, 165, 0],
  gray: [128, 128, 128],
  purple: [128, 0, 128],
  green: [0, 128, 0],
  red: [J, 0, 0],
  pink: [J, 192, 203],
  cyan: [0, J, J],
  transparent: [J, J, J, 0]
}, Qn = function(t, e, r) {
  return t += t < 0 ? 1 : t > 1 ? -1 : 0, (t * 6 < 1 ? e + (r - e) * t * 6 : t < 0.5 ? r : t * 3 < 2 ? e + (r - e) * (2 / 3 - t) * 6 : e) * J + 0.5 | 0;
}, Gd = function(t, e, r) {
  var n = t ? We(t) ? [t >> 16, t >> 8 & J, t & J] : 0 : Fr.black, a, l, h, u, f, p, m, g, x, o;
  if (!n) {
    if (t.substr(-1) === "," && (t = t.substr(0, t.length - 1)), Fr[t])
      n = Fr[t];
    else if (t.charAt(0) === "#") {
      if (t.length < 6 && (a = t.charAt(1), l = t.charAt(2), h = t.charAt(3), t = "#" + a + a + l + l + h + h + (t.length === 5 ? t.charAt(4) + t.charAt(4) : "")), t.length === 9)
        return n = parseInt(t.substr(1, 6), 16), [n >> 16, n >> 8 & J, n & J, parseInt(t.substr(7), 16) / 255];
      t = parseInt(t.substr(1), 16), n = [t >> 16, t >> 8 & J, t & J];
    } else if (t.substr(0, 3) === "hsl") {
      if (n = o = t.match(no), !e)
        u = +n[0] % 360 / 360, f = +n[1] / 100, p = +n[2] / 100, l = p <= 0.5 ? p * (f + 1) : p + f - p * f, a = p * 2 - l, n.length > 3 && (n[3] *= 1), n[0] = Qn(u + 1 / 3, a, l), n[1] = Qn(u, a, l), n[2] = Qn(u - 1 / 3, a, l);
      else if (~t.indexOf("="))
        return n = t.match(_d), r && n.length < 4 && (n[3] = 1), n;
    } else
      n = t.match(no) || Fr.transparent;
    n = n.map(Number);
  }
  return e && !o && (a = n[0] / J, l = n[1] / J, h = n[2] / J, m = Math.max(a, l, h), g = Math.min(a, l, h), p = (m + g) / 2, m === g ? u = f = 0 : (x = m - g, f = p > 0.5 ? x / (2 - m - g) : x / (m + g), u = m === a ? (l - h) / x + (l < h ? 6 : 0) : m === l ? (h - a) / x + 2 : (a - l) / x + 4, u *= 60), n[0] = ~~(u + 0.5), n[1] = ~~(f * 100 + 0.5), n[2] = ~~(p * 100 + 0.5)), r && n.length < 4 && (n[3] = 1), n;
}, zd = function(t) {
  var e = [], r = [], n = -1;
  return t.split(ri).forEach(function(a) {
    var l = a.match(Yi) || [];
    e.push.apply(e, l), r.push(n += l.length + 1);
  }), e.c = r, e;
}, Ol = function(t, e, r) {
  var n = "", a = (t + n).match(ri), l = e ? "hsla(" : "rgba(", h = 0, u, f, p, m;
  if (!a)
    return t;
  if (a = a.map(function(g) {
    return (g = Gd(g, e, 1)) && l + (e ? g[0] + "," + g[1] + "%," + g[2] + "%," + g[3] : g.join(",")) + ")";
  }), r && (p = zd(t), u = r.c, u.join(n) !== p.c.join(n)))
    for (f = t.replace(ri, "1").split(Yi), m = f.length - 1; h < m; h++)
      n += f[h] + (~u.indexOf(h) ? a.shift() || l + "0,0,0,0)" : (p.length ? p : a.length ? a : r).shift());
  if (!f)
    for (f = t.split(ri), m = f.length - 1; h < m; h++)
      n += f[h] + a[h];
  return n + f[m];
}, ri = function() {
  var s = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b", t;
  for (t in Fr)
    s += "|" + t + "\\b";
  return new RegExp(s + ")", "gi");
}(), wy = /hsl[a]?\(/, Nd = function(t) {
  var e = t.join(" "), r;
  if (ri.lastIndex = 0, ri.test(e))
    return r = wy.test(e), t[1] = Ol(t[1], r), t[0] = Ol(t[0], r, zd(t[1])), !0;
}, is, Yt = function() {
  var s = Date.now, t = 500, e = 33, r = s(), n = r, a = 1e3 / 240, l = a, h = [], u, f, p, m, g, x, o = function c(d) {
    var _ = s() - n, y = d === !0, v, b, w, S;
    if ((_ > t || _ < 0) && (r += _ - e), n += _, w = n - r, v = w - l, (v > 0 || y) && (S = ++m.frame, g = w - m.time * 1e3, m.time = w = w / 1e3, l += v + (v >= a ? 4 : a - v), b = 1), y || (u = f(c)), b)
      for (x = 0; x < h.length; x++)
        h[x](w, g, S, d);
  };
  return m = {
    time: 0,
    frame: 0,
    tick: function() {
      o(!0);
    },
    deltaRatio: function(d) {
      return g / (1e3 / (d || 60));
    },
    wake: function() {
      yd && (!ao && lh() && (Se = ao = window, ch = Se.document || {}, Qt.gsap = Nt, (Se.gsapVersions || (Se.gsapVersions = [])).push(Nt.version), xd(fn || Se.GreenSockGlobals || !Se.gsap && Se || {}), Od.forEach(Ld)), p = typeof requestAnimationFrame < "u" && requestAnimationFrame, u && m.sleep(), f = p || function(d) {
        return setTimeout(d, l - m.time * 1e3 + 1 | 0);
      }, is = 1, o(2));
    },
    sleep: function() {
      (p ? cancelAnimationFrame : clearTimeout)(u), is = 0, f = ts;
    },
    lagSmoothing: function(d, _) {
      t = d || 1 / 0, e = Math.min(_ || 33, t);
    },
    fps: function(d) {
      a = 1e3 / (d || 240), l = m.time * 1e3 + a;
    },
    add: function(d, _, y) {
      var v = _ ? function(b, w, S, T) {
        d(b, w, S, T), m.remove(v);
      } : d;
      return m.remove(d), h[y ? "unshift" : "push"](v), ar(), v;
    },
    remove: function(d, _) {
      ~(_ = h.indexOf(d)) && h.splice(_, 1) && x >= _ && x--;
    },
    _listeners: h
  }, m;
}(), ar = function() {
  return !is && Yt.wake();
}, $ = {}, Sy = /^[\d.\-M][\d.\-,\s]/, Ty = /["']/g, Cy = function(t) {
  for (var e = {}, r = t.substr(1, t.length - 3).split(":"), n = r[0], a = 1, l = r.length, h, u, f; a < l; a++)
    u = r[a], h = a !== l - 1 ? u.lastIndexOf(",") : u.length, f = u.substr(0, h), e[n] = isNaN(f) ? f.replace(Ty, "").trim() : +f, n = u.substr(h + 1).trim();
  return e;
}, Ey = function(t) {
  var e = t.indexOf("(") + 1, r = t.indexOf(")"), n = t.indexOf("(", e);
  return t.substring(e, ~n && n < r ? t.indexOf(")", r + 1) : r);
}, Ay = function(t) {
  var e = (t + "").split("("), r = $[e[0]];
  return r && e.length > 1 && r.config ? r.config.apply(null, ~t.indexOf("{") ? [Cy(e[1])] : Ey(t).split(",").map(Td)) : $._CE && Sy.test(t) ? $._CE("", t) : r;
}, Hd = function(t) {
  return function(e) {
    return 1 - t(1 - e);
  };
}, Wd = function s(t, e) {
  for (var r = t._first, n; r; )
    r instanceof Rt ? s(r, e) : r.vars.yoyoEase && (!r._yoyo || !r._repeat) && r._yoyo !== e && (r.timeline ? s(r.timeline, e) : (n = r._ease, r._ease = r._yEase, r._yEase = n, r._yoyo = e)), r = r._next;
}, Mi = function(t, e) {
  return t && (ut(t) ? t : $[t] || Ay(t)) || e;
}, Fi = function(t, e, r, n) {
  r === void 0 && (r = function(u) {
    return 1 - e(1 - u);
  }), n === void 0 && (n = function(u) {
    return u < 0.5 ? e(u * 2) / 2 : 1 - e((1 - u) * 2) / 2;
  });
  var a = {
    easeIn: e,
    easeOut: r,
    easeInOut: n
  }, l;
  return Lt(t, function(h) {
    $[h] = Qt[h] = a, $[l = h.toLowerCase()] = r;
    for (var u in a)
      $[l + (u === "easeIn" ? ".in" : u === "easeOut" ? ".out" : ".inOut")] = $[h + "." + u] = a[u];
  }), a;
}, Vd = function(t) {
  return function(e) {
    return e < 0.5 ? (1 - t(1 - e * 2)) / 2 : 0.5 + t((e - 0.5) * 2) / 2;
  };
}, Jn = function s(t, e, r) {
  var n = e >= 1 ? e : 1, a = (r || (t ? 0.3 : 0.45)) / (e < 1 ? e : 1), l = a / so * (Math.asin(1 / n) || 0), h = function(p) {
    return p === 1 ? 1 : n * Math.pow(2, -10 * p) * ey((p - l) * a) + 1;
  }, u = t === "out" ? h : t === "in" ? function(f) {
    return 1 - h(1 - f);
  } : Vd(h);
  return a = so / a, u.config = function(f, p) {
    return s(t, f, p);
  }, u;
}, ta = function s(t, e) {
  e === void 0 && (e = 1.70158);
  var r = function(l) {
    return l ? --l * l * ((e + 1) * l + e) + 1 : 0;
  }, n = t === "out" ? r : t === "in" ? function(a) {
    return 1 - r(1 - a);
  } : Vd(r);
  return n.config = function(a) {
    return s(t, a);
  }, n;
};
Lt("Linear,Quad,Cubic,Quart,Quint,Strong", function(s, t) {
  var e = t < 5 ? t + 1 : t;
  Fi(s + ",Power" + (e - 1), t ? function(r) {
    return Math.pow(r, e);
  } : function(r) {
    return r;
  }, function(r) {
    return 1 - Math.pow(1 - r, e);
  }, function(r) {
    return r < 0.5 ? Math.pow(r * 2, e) / 2 : 1 - Math.pow((1 - r) * 2, e) / 2;
  });
});
$.Linear.easeNone = $.none = $.Linear.easeIn;
Fi("Elastic", Jn("in"), Jn("out"), Jn());
(function(s, t) {
  var e = 1 / t, r = 2 * e, n = 2.5 * e, a = function(h) {
    return h < e ? s * h * h : h < r ? s * Math.pow(h - 1.5 / t, 2) + 0.75 : h < n ? s * (h -= 2.25 / t) * h + 0.9375 : s * Math.pow(h - 2.625 / t, 2) + 0.984375;
  };
  Fi("Bounce", function(l) {
    return 1 - a(1 - l);
  }, a);
})(7.5625, 2.75);
Fi("Expo", function(s) {
  return Math.pow(2, 10 * (s - 1)) * s + s * s * s * s * s * s * (1 - s);
});
Fi("Circ", function(s) {
  return -(fd(1 - s * s) - 1);
});
Fi("Sine", function(s) {
  return s === 1 ? 1 : -ty(s * Qg) + 1;
});
Fi("Back", ta("in"), ta("out"), ta());
$.SteppedEase = $.steps = Qt.SteppedEase = {
  config: function(t, e) {
    t === void 0 && (t = 1);
    var r = 1 / t, n = t + (e ? 0 : 1), a = e ? 1 : 0, l = 1 - Mt;
    return function(h) {
      return ((n * _s(0, l, h) | 0) + a) * r;
    };
  }
};
ir.ease = $["quad.out"];
Lt("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function(s) {
  return fh += s + "," + s + "Params,";
});
var $d = function(t, e) {
  this.id = Jg++, t._gsap = this, this.target = t, this.harness = e, this.get = e ? e.get : wd, this.set = e ? e.getSetter : xh;
}, rs = /* @__PURE__ */ function() {
  function s(e) {
    this.vars = e, this._delay = +e.delay || 0, (this._repeat = e.repeat === 1 / 0 ? -2 : e.repeat || 0) && (this._rDelay = e.repeatDelay || 0, this._yoyo = !!e.yoyo || !!e.yoyoEase), this._ts = 1, nr(this, +e.duration, 1, 1), this.data = e.data, nt && (this._ctx = nt, nt.data.push(this)), is || Yt.wake();
  }
  var t = s.prototype;
  return t.delay = function(r) {
    return r || r === 0 ? (this.parent && this.parent.smoothChildTiming && this.startTime(this._start + r - this._delay), this._delay = r, this) : this._delay;
  }, t.duration = function(r) {
    return arguments.length ? this.totalDuration(this._repeat > 0 ? r + (r + this._rDelay) * this._repeat : r) : this.totalDuration() && this._dur;
  }, t.totalDuration = function(r) {
    return arguments.length ? (this._dirty = 0, nr(this, this._repeat < 0 ? r : (r - this._repeat * this._rDelay) / (this._repeat + 1))) : this._tDur;
  }, t.totalTime = function(r, n) {
    if (ar(), !arguments.length)
      return this._tTime;
    var a = this._dp;
    if (a && a.smoothChildTiming && this._ts) {
      for (Ln(this, r), !a._dp || a.parent || Ad(a, this); a && a.parent; )
        a.parent._time !== a._start + (a._ts >= 0 ? a._tTime / a._ts : (a.totalDuration() - a._tTime) / -a._ts) && a.totalTime(a._tTime, !0), a = a.parent;
      !this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && r < this._tDur || this._ts < 0 && r > 0 || !this._tDur && !r) && Ce(this._dp, this, this._start - this._delay);
    }
    return (this._tTime !== r || !this._dur && !n || this._initted && Math.abs(this._zTime) === Mt || !r && !this._initted && (this.add || this._ptLookup)) && (this._ts || (this._pTime = r), Sd(this, r, n)), this;
  }, t.time = function(r, n) {
    return arguments.length ? this.totalTime(Math.min(this.totalDuration(), r + kl(this)) % (this._dur + this._rDelay) || (r ? this._dur : 0), n) : this._time;
  }, t.totalProgress = function(r, n) {
    return arguments.length ? this.totalTime(this.totalDuration() * r, n) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.rawTime() >= 0 && this._initted ? 1 : 0;
  }, t.progress = function(r, n) {
    return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - r : r) + kl(this), n) : this.duration() ? Math.min(1, this._time / this._dur) : this.rawTime() > 0 ? 1 : 0;
  }, t.iteration = function(r, n) {
    var a = this.duration() + this._rDelay;
    return arguments.length ? this.totalTime(this._time + (r - 1) * a, n) : this._repeat ? sr(this._tTime, a) + 1 : 1;
  }, t.timeScale = function(r, n) {
    if (!arguments.length)
      return this._rts === -1e-8 ? 0 : this._rts;
    if (this._rts === r)
      return this;
    var a = this.parent && this._ts ? mn(this.parent._time, this) : this._tTime;
    return this._rts = +r || 0, this._ts = this._ps || r === -1e-8 ? 0 : this._rts, this.totalTime(_s(-Math.abs(this._delay), this.totalDuration(), a), n !== !1), On(this), hy(this);
  }, t.paused = function(r) {
    return arguments.length ? (this._ps !== r && (this._ps = r, r ? (this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()), this._ts = this._act = 0) : (ar(), this._ts = this._rts, this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== Mt && (this._tTime -= Mt)))), this) : this._ps;
  }, t.startTime = function(r) {
    if (arguments.length) {
      this._start = r;
      var n = this.parent || this._dp;
      return n && (n._sort || !this.parent) && Ce(n, this, r - this._delay), this;
    }
    return this._start;
  }, t.endTime = function(r) {
    return this._start + (Ot(r) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
  }, t.rawTime = function(r) {
    var n = this.parent || this._dp;
    return n ? r && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : this._ts ? mn(n.rawTime(r), this) : this._tTime : this._tTime;
  }, t.revert = function(r) {
    r === void 0 && (r = sy);
    var n = Tt;
    return Tt = r, _h(this) && (this.timeline && this.timeline.revert(r), this.totalTime(-0.01, r.suppressEvents)), this.data !== "nested" && r.kill !== !1 && this.kill(), Tt = n, this;
  }, t.globalTime = function(r) {
    for (var n = this, a = arguments.length ? r : n.rawTime(); n; )
      a = n._start + a / (Math.abs(n._ts) || 1), n = n._dp;
    return !this.parent && this._sat ? this._sat.globalTime(r) : a;
  }, t.repeat = function(r) {
    return arguments.length ? (this._repeat = r === 1 / 0 ? -2 : r, Fl(this)) : this._repeat === -2 ? 1 / 0 : this._repeat;
  }, t.repeatDelay = function(r) {
    if (arguments.length) {
      var n = this._time;
      return this._rDelay = r, Fl(this), n ? this.time(n) : this;
    }
    return this._rDelay;
  }, t.yoyo = function(r) {
    return arguments.length ? (this._yoyo = r, this) : this._yoyo;
  }, t.seek = function(r, n) {
    return this.totalTime(re(this, r), Ot(n));
  }, t.restart = function(r, n) {
    return this.play().totalTime(r ? -this._delay : 0, Ot(n)), this._dur || (this._zTime = -1e-8), this;
  }, t.play = function(r, n) {
    return r != null && this.seek(r, n), this.reversed(!1).paused(!1);
  }, t.reverse = function(r, n) {
    return r != null && this.seek(r || this.totalDuration(), n), this.reversed(!0).paused(!1);
  }, t.pause = function(r, n) {
    return r != null && this.seek(r, n), this.paused(!0);
  }, t.resume = function() {
    return this.paused(!1);
  }, t.reversed = function(r) {
    return arguments.length ? (!!r !== this.reversed() && this.timeScale(-this._rts || (r ? -1e-8 : 0)), this) : this._rts < 0;
  }, t.invalidate = function() {
    return this._initted = this._act = 0, this._zTime = -1e-8, this;
  }, t.isActive = function() {
    var r = this.parent || this._dp, n = this._start, a;
    return !!(!r || this._ts && this._initted && r.isActive() && (a = r.rawTime(!0)) >= n && a < this.endTime(!0) - Mt);
  }, t.eventCallback = function(r, n, a) {
    var l = this.vars;
    return arguments.length > 1 ? (n ? (l[r] = n, a && (l[r + "Params"] = a), r === "onUpdate" && (this._onUpdate = n)) : delete l[r], this) : l[r];
  }, t.then = function(r) {
    var n = this;
    return new Promise(function(a) {
      var l = ut(r) ? r : Cd, h = function() {
        var f = n.then;
        n.then = null, ut(l) && (l = l(n)) && (l.then || l === n) && (n.then = f), a(l), n.then = f;
      };
      n._initted && n.totalProgress() === 1 && n._ts >= 0 || !n._tTime && n._ts < 0 ? h() : n._prom = h;
    });
  }, t.kill = function() {
    kr(this);
  }, s;
}();
Jt(rs.prototype, {
  _time: 0,
  _start: 0,
  _end: 0,
  _tTime: 0,
  _tDur: 0,
  _dirty: 0,
  _repeat: 0,
  _yoyo: !1,
  parent: null,
  _initted: !1,
  _rDelay: 0,
  _ts: 1,
  _dp: 0,
  ratio: 0,
  _zTime: -1e-8,
  _prom: 0,
  _ps: !1,
  _rts: 1
});
var Rt = /* @__PURE__ */ function(s) {
  dd(t, s);
  function t(r, n) {
    var a;
    return r === void 0 && (r = {}), a = s.call(this, r) || this, a.labels = {}, a.smoothChildTiming = !!r.smoothChildTiming, a.autoRemoveChildren = !!r.autoRemoveChildren, a._sort = Ot(r.sortChildren), ot && Ce(r.parent || ot, Fe(a), n), r.reversed && a.reverse(), r.paused && a.paused(!0), r.scrollTrigger && Pd(Fe(a), r.scrollTrigger), a;
  }
  var e = t.prototype;
  return e.to = function(n, a, l) {
    return Nr(0, arguments, this), this;
  }, e.from = function(n, a, l) {
    return Nr(1, arguments, this), this;
  }, e.fromTo = function(n, a, l, h) {
    return Nr(2, arguments, this), this;
  }, e.set = function(n, a, l) {
    return a.duration = 0, a.parent = this, zr(a).repeatDelay || (a.repeat = 0), a.immediateRender = !!a.immediateRender, new _t(n, a, re(this, l), 1), this;
  }, e.call = function(n, a, l) {
    return Ce(this, _t.delayedCall(0, n, a), l);
  }, e.staggerTo = function(n, a, l, h, u, f, p) {
    return l.duration = a, l.stagger = l.stagger || h, l.onComplete = f, l.onCompleteParams = p, l.parent = this, new _t(n, l, re(this, u)), this;
  }, e.staggerFrom = function(n, a, l, h, u, f, p) {
    return l.runBackwards = 1, zr(l).immediateRender = Ot(l.immediateRender), this.staggerTo(n, a, l, h, u, f, p);
  }, e.staggerFromTo = function(n, a, l, h, u, f, p, m) {
    return h.startAt = l, zr(h).immediateRender = Ot(h.immediateRender), this.staggerTo(n, a, h, u, f, p, m);
  }, e.render = function(n, a, l) {
    var h = this._time, u = this._dirty ? this.totalDuration() : this._tDur, f = this._dur, p = n <= 0 ? 0 : mt(n), m = this._zTime < 0 != n < 0 && (this._initted || !f), g, x, o, c, d, _, y, v, b, w, S, T;
    if (this !== ot && p > u && n >= 0 && (p = u), p !== this._tTime || l || m) {
      if (h !== this._time && f && (p += this._time - h, n += this._time - h), g = p, b = this._start, v = this._ts, _ = !v, m && (f || (h = this._zTime), (n || !a) && (this._zTime = n)), this._repeat) {
        if (S = this._yoyo, d = f + this._rDelay, this._repeat < -1 && n < 0)
          return this.totalTime(d * 100 + n, a, l);
        if (g = mt(p % d), p === u ? (c = this._repeat, g = f) : (w = mt(p / d), c = ~~w, c && c === w && (g = f, c--), g > f && (g = f)), w = sr(this._tTime, d), !h && this._tTime && w !== c && this._tTime - w * d - this._dur <= 0 && (w = c), S && c & 1 && (g = f - g, T = 1), c !== w && !this._lock) {
          var E = S && w & 1, C = E === (S && c & 1);
          if (c < w && (E = !E), h = E ? 0 : p % f ? f : p, this._lock = 1, this.render(h || (T ? 0 : mt(c * d)), a, !f)._lock = 0, this._tTime = p, !a && this.parent && jt(this, "onRepeat"), this.vars.repeatRefresh && !T && (this.invalidate()._lock = 1), h && h !== this._time || _ !== !this._ts || this.vars.onRepeat && !this.parent && !this._act)
            return this;
          if (f = this._dur, u = this._tDur, C && (this._lock = 2, h = E ? f : -1e-4, this.render(h, !0), this.vars.repeatRefresh && !T && this.invalidate()), this._lock = 0, !this._ts && !_)
            return this;
          Wd(this, T);
        }
      }
      if (this._hasPause && !this._forcing && this._lock < 2 && (y = dy(this, mt(h), mt(g)), y && (p -= g - (g = y._start))), this._tTime = p, this._time = g, this._act = !v, this._initted || (this._onUpdate = this.vars.onUpdate, this._initted = 1, this._zTime = n, h = 0), !h && p && !a && !w && (jt(this, "onStart"), this._tTime !== p))
        return this;
      if (g >= h && n >= 0)
        for (x = this._first; x; ) {
          if (o = x._next, (x._act || g >= x._start) && x._ts && y !== x) {
            if (x.parent !== this)
              return this.render(n, a, l);
            if (x.render(x._ts > 0 ? (g - x._start) * x._ts : (x._dirty ? x.totalDuration() : x._tDur) + (g - x._start) * x._ts, a, l), g !== this._time || !this._ts && !_) {
              y = 0, o && (p += this._zTime = -1e-8);
              break;
            }
          }
          x = o;
        }
      else {
        x = this._last;
        for (var M = n < 0 ? n : g; x; ) {
          if (o = x._prev, (x._act || M <= x._end) && x._ts && y !== x) {
            if (x.parent !== this)
              return this.render(n, a, l);
            if (x.render(x._ts > 0 ? (M - x._start) * x._ts : (x._dirty ? x.totalDuration() : x._tDur) + (M - x._start) * x._ts, a, l || Tt && _h(x)), g !== this._time || !this._ts && !_) {
              y = 0, o && (p += this._zTime = M ? -1e-8 : Mt);
              break;
            }
          }
          x = o;
        }
      }
      if (y && !a && (this.pause(), y.render(g >= h ? 0 : -1e-8)._zTime = g >= h ? 1 : -1, this._ts))
        return this._start = b, On(this), this.render(n, a, l);
      this._onUpdate && !a && jt(this, "onUpdate", !0), (p === u && this._tTime >= this.totalDuration() || !p && h) && (b === this._start || Math.abs(v) !== Math.abs(this._ts)) && (this._lock || ((n || !f) && (p === u && this._ts > 0 || !p && this._ts < 0) && si(this, 1), !a && !(n < 0 && !h) && (p || h || !u) && (jt(this, p === u && n >= 0 ? "onComplete" : "onReverseComplete", !0), this._prom && !(p < u && this.timeScale() > 0) && this._prom())));
    }
    return this;
  }, e.add = function(n, a) {
    var l = this;
    if (We(a) || (a = re(this, a, n)), !(n instanceof rs)) {
      if (Bt(n))
        return n.forEach(function(h) {
          return l.add(h, a);
        }), this;
      if (wt(n))
        return this.addLabel(n, a);
      if (ut(n))
        n = _t.delayedCall(0, n);
      else
        return this;
    }
    return this !== n ? Ce(this, n, a) : this;
  }, e.getChildren = function(n, a, l, h) {
    n === void 0 && (n = !0), a === void 0 && (a = !0), l === void 0 && (l = !0), h === void 0 && (h = -1e8);
    for (var u = [], f = this._first; f; )
      f._start >= h && (f instanceof _t ? a && u.push(f) : (l && u.push(f), n && u.push.apply(u, f.getChildren(!0, a, l)))), f = f._next;
    return u;
  }, e.getById = function(n) {
    for (var a = this.getChildren(1, 1, 1), l = a.length; l--; )
      if (a[l].vars.id === n)
        return a[l];
  }, e.remove = function(n) {
    return wt(n) ? this.removeLabel(n) : ut(n) ? this.killTweensOf(n) : (n.parent === this && Dn(this, n), n === this._recent && (this._recent = this._last), Pi(this));
  }, e.totalTime = function(n, a) {
    return arguments.length ? (this._forcing = 1, !this._dp && this._ts && (this._start = mt(Yt.time - (this._ts > 0 ? n / this._ts : (this.totalDuration() - n) / -this._ts))), s.prototype.totalTime.call(this, n, a), this._forcing = 0, this) : this._tTime;
  }, e.addLabel = function(n, a) {
    return this.labels[n] = re(this, a), this;
  }, e.removeLabel = function(n) {
    return delete this.labels[n], this;
  }, e.addPause = function(n, a, l) {
    var h = _t.delayedCall(0, a || ts, l);
    return h.data = "isPause", this._hasPause = 1, Ce(this, h, re(this, n));
  }, e.removePause = function(n) {
    var a = this._first;
    for (n = re(this, n); a; )
      a._start === n && a.data === "isPause" && si(a), a = a._next;
  }, e.killTweensOf = function(n, a, l) {
    for (var h = this.getTweensOf(n, l), u = h.length; u--; )
      qe !== h[u] && h[u].kill(n, a);
    return this;
  }, e.getTweensOf = function(n, a) {
    for (var l = [], h = oe(n), u = this._first, f = We(a), p; u; )
      u instanceof _t ? ny(u._targets, h) && (f ? (!qe || u._initted && u._ts) && u.globalTime(0) <= a && u.globalTime(u.totalDuration()) > a : !a || u.isActive()) && l.push(u) : (p = u.getTweensOf(h, a)).length && l.push.apply(l, p), u = u._next;
    return l;
  }, e.tweenTo = function(n, a) {
    a = a || {};
    var l = this, h = re(l, n), u = a, f = u.startAt, p = u.onStart, m = u.onStartParams, g = u.immediateRender, x, o = _t.to(l, Jt({
      ease: a.ease || "none",
      lazy: !1,
      immediateRender: !1,
      time: h,
      overwrite: "auto",
      duration: a.duration || Math.abs((h - (f && "time" in f ? f.time : l._time)) / l.timeScale()) || Mt,
      onStart: function() {
        if (l.pause(), !x) {
          var d = a.duration || Math.abs((h - (f && "time" in f ? f.time : l._time)) / l.timeScale());
          o._dur !== d && nr(o, d, 0, 1).render(o._time, !0, !0), x = 1;
        }
        p && p.apply(o, m || []);
      }
    }, a));
    return g ? o.render(0) : o;
  }, e.tweenFromTo = function(n, a, l) {
    return this.tweenTo(a, Jt({
      startAt: {
        time: re(this, n)
      }
    }, l));
  }, e.recent = function() {
    return this._recent;
  }, e.nextLabel = function(n) {
    return n === void 0 && (n = this._time), Dl(this, re(this, n));
  }, e.previousLabel = function(n) {
    return n === void 0 && (n = this._time), Dl(this, re(this, n), 1);
  }, e.currentLabel = function(n) {
    return arguments.length ? this.seek(n, !0) : this.previousLabel(this._time + Mt);
  }, e.shiftChildren = function(n, a, l) {
    l === void 0 && (l = 0);
    for (var h = this._first, u = this.labels, f; h; )
      h._start >= l && (h._start += n, h._end += n), h = h._next;
    if (a)
      for (f in u)
        u[f] >= l && (u[f] += n);
    return Pi(this);
  }, e.invalidate = function(n) {
    var a = this._first;
    for (this._lock = 0; a; )
      a.invalidate(n), a = a._next;
    return s.prototype.invalidate.call(this, n);
  }, e.clear = function(n) {
    n === void 0 && (n = !0);
    for (var a = this._first, l; a; )
      l = a._next, this.remove(a), a = l;
    return this._dp && (this._time = this._tTime = this._pTime = 0), n && (this.labels = {}), Pi(this);
  }, e.totalDuration = function(n) {
    var a = 0, l = this, h = l._last, u = Pe, f, p, m;
    if (arguments.length)
      return l.timeScale((l._repeat < 0 ? l.duration() : l.totalDuration()) / (l.reversed() ? -n : n));
    if (l._dirty) {
      for (m = l.parent; h; )
        f = h._prev, h._dirty && h.totalDuration(), p = h._start, p > u && l._sort && h._ts && !l._lock ? (l._lock = 1, Ce(l, h, p - h._delay, 1)._lock = 0) : u = p, p < 0 && h._ts && (a -= p, (!m && !l._dp || m && m.smoothChildTiming) && (l._start += p / l._ts, l._time -= p, l._tTime -= p), l.shiftChildren(-p, !1, -1 / 0), u = 0), h._end > a && h._ts && (a = h._end), h = f;
      nr(l, l === ot && l._time > a ? l._time : a, 1, 1), l._dirty = 0;
    }
    return l._tDur;
  }, t.updateRoot = function(n) {
    if (ot._ts && (Sd(ot, mn(n, ot)), vd = Yt.frame), Yt.frame >= Rl) {
      Rl += Kt.autoSleep || 120;
      var a = ot._first;
      if ((!a || !a._ts) && Kt.autoSleep && Yt._listeners.length < 2) {
        for (; a && !a._ts; )
          a = a._next;
        a || Yt.sleep();
      }
    }
  }, t;
}(rs);
Jt(Rt.prototype, {
  _lock: 0,
  _hasPause: 0,
  _forcing: 0
});
var Py = function(t, e, r, n, a, l, h) {
  var u = new Gt(this._pt, t, e, 0, 1, Zd, null, a), f = 0, p = 0, m, g, x, o, c, d, _, y;
  for (u.b = r, u.e = n, r += "", n += "", (_ = ~n.indexOf("random(")) && (n = es(n)), l && (y = [r, n], l(y, t, e), r = y[0], n = y[1]), g = r.match(qn) || []; m = qn.exec(n); )
    o = m[0], c = n.substring(f, m.index), x ? x = (x + 1) % 5 : c.substr(-5) === "rgba(" && (x = 1), o !== g[p++] && (d = parseFloat(g[p - 1]) || 0, u._pt = {
      _next: u._pt,
      p: c || p === 1 ? c : ",",
      //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
      s: d,
      c: o.charAt(1) === "=" ? qi(d, o) - d : parseFloat(o) - d,
      m: x && x < 4 ? Math.round : 0
    }, f = qn.lastIndex);
  return u.c = f < n.length ? n.substring(f, n.length) : "", u.fp = h, (md.test(n) || _) && (u.e = 0), this._pt = u, u;
}, mh = function(t, e, r, n, a, l, h, u, f, p) {
  ut(n) && (n = n(a || 0, t, l));
  var m = t[e], g = r !== "get" ? r : ut(m) ? f ? t[e.indexOf("set") || !ut(t["get" + e.substr(3)]) ? e : "get" + e.substr(3)](f) : t[e]() : m, x = ut(m) ? f ? Iy : Kd : yh, o;
  if (wt(n) && (~n.indexOf("random(") && (n = es(n)), n.charAt(1) === "=" && (o = qi(g, n) + (Pt(g) || 0), (o || o === 0) && (n = o))), !p || g !== n || po)
    return !isNaN(g * n) && n !== "" ? (o = new Gt(this._pt, t, e, +g || 0, n - (g || 0), typeof m == "boolean" ? Fy : qd, 0, x), f && (o.fp = f), h && o.modifier(h, this, t), this._pt = o) : (!m && !(e in t) && uh(e, n), Py.call(this, t, e, g, n, x, u || Kt.stringFilter, f));
}, My = function(t, e, r, n, a) {
  if (ut(t) && (t = Hr(t, a, e, r, n)), !Me(t) || t.style && t.nodeType || Bt(t) || pd(t))
    return wt(t) ? Hr(t, a, e, r, n) : t;
  var l = {}, h;
  for (h in t)
    l[h] = Hr(t[h], a, e, r, n);
  return l;
}, Yd = function(t, e, r, n, a, l) {
  var h, u, f, p;
  if ($t[t] && (h = new $t[t]()).init(a, h.rawVars ? e[t] : My(e[t], n, a, l, r), r, n, l) !== !1 && (r._pt = u = new Gt(r._pt, a, t, 0, 1, h.render, h, 0, h.priority), r !== Xi))
    for (f = r._ptLookup[r._targets.indexOf(a)], p = h._props.length; p--; )
      f[h._props[p]] = u;
  return h;
}, qe, po, gh = function s(t, e, r) {
  var n = t.vars, a = n.ease, l = n.startAt, h = n.immediateRender, u = n.lazy, f = n.onUpdate, p = n.runBackwards, m = n.yoyoEase, g = n.keyframes, x = n.autoRevert, o = t._dur, c = t._startAt, d = t._targets, _ = t.parent, y = _ && _.data === "nested" ? _.vars.targets : d, v = t._overwrite === "auto" && !oh, b = t.timeline, w, S, T, E, C, M, P, B, U, G, O, R, I;
  if (b && (!g || !a) && (a = "none"), t._ease = Mi(a, ir.ease), t._yEase = m ? Hd(Mi(m === !0 ? a : m, ir.ease)) : 0, m && t._yoyo && !t._repeat && (m = t._yEase, t._yEase = t._ease, t._ease = m), t._from = !b && !!n.runBackwards, !b || g && !n.stagger) {
    if (B = d[0] ? Ai(d[0]).harness : 0, R = B && n[B.prop], w = _n(n, dh), c && (c._zTime < 0 && c.progress(1), e < 0 && p && h && !x ? c.render(-1, !0) : c.revert(p && o ? en : ry), c._lazy = 0), l) {
      if (si(t._startAt = _t.set(d, Jt({
        data: "isStart",
        overwrite: !1,
        parent: _,
        immediateRender: !0,
        lazy: !c && Ot(u),
        startAt: null,
        delay: 0,
        onUpdate: f && function() {
          return jt(t, "onUpdate");
        },
        stagger: 0
      }, l))), t._startAt._dp = 0, t._startAt._sat = t, e < 0 && (Tt || !h && !x) && t._startAt.revert(en), h && o && e <= 0 && r <= 0) {
        e && (t._zTime = e);
        return;
      }
    } else if (p && o && !c) {
      if (e && (h = !1), T = Jt({
        overwrite: !1,
        data: "isFromStart",
        //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
        lazy: h && !c && Ot(u),
        immediateRender: h,
        //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
        stagger: 0,
        parent: _
        //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y: gsap.utils.wrap([-100,100]), stagger: 0.5})
      }, w), R && (T[B.prop] = R), si(t._startAt = _t.set(d, T)), t._startAt._dp = 0, t._startAt._sat = t, e < 0 && (Tt ? t._startAt.revert(en) : t._startAt.render(-1, !0)), t._zTime = e, !h)
        s(t._startAt, Mt, Mt);
      else if (!e)
        return;
    }
    for (t._pt = t._ptCache = 0, u = o && Ot(u) || u && !o, S = 0; S < d.length; S++) {
      if (C = d[S], P = C._gsap || ph(d)[S]._gsap, t._ptLookup[S] = G = {}, oo[P.id] && ii.length && pn(), O = y === d ? S : y.indexOf(C), B && (U = new B()).init(C, R || w, t, O, y) !== !1 && (t._pt = E = new Gt(t._pt, C, U.name, 0, 1, U.render, U, 0, U.priority), U._props.forEach(function(st) {
        G[st] = E;
      }), U.priority && (M = 1)), !B || R)
        for (T in w)
          $t[T] && (U = Yd(T, w, t, O, C, y)) ? U.priority && (M = 1) : G[T] = E = mh.call(t, C, T, "get", w[T], O, y, 0, n.stringFilter);
      t._op && t._op[S] && t.kill(C, t._op[S]), v && t._pt && (qe = t, ot.killTweensOf(C, G, t.globalTime(e)), I = !t.parent, qe = 0), t._pt && u && (oo[P.id] = 1);
    }
    M && Qd(t), t._onInit && t._onInit(t);
  }
  t._onUpdate = f, t._initted = (!t._op || t._pt) && !I, g && e <= 0 && b.render(Pe, !0, !0);
}, By = function(t, e, r, n, a, l, h, u) {
  var f = (t._pt && t._ptCache || (t._ptCache = {}))[e], p, m, g, x;
  if (!f)
    for (f = t._ptCache[e] = [], g = t._ptLookup, x = t._targets.length; x--; ) {
      if (p = g[x][e], p && p.d && p.d._pt)
        for (p = p.d._pt; p && p.p !== e && p.fp !== e; )
          p = p._next;
      if (!p)
        return po = 1, t.vars[e] = "+=0", gh(t, h), po = 0, u ? Jr(e + " not eligible for reset") : 1;
      f.push(p);
    }
  for (x = f.length; x--; )
    m = f[x], p = m._pt || m, p.s = (n || n === 0) && !a ? n : p.s + (n || 0) + l * p.c, p.c = r - p.s, m.e && (m.e = dt(r) + Pt(m.e)), m.b && (m.b = p.s + Pt(m.b));
}, Uy = function(t, e) {
  var r = t[0] ? Ai(t[0]).harness : 0, n = r && r.aliases, a, l, h, u;
  if (!n)
    return e;
  a = rr({}, e);
  for (l in n)
    if (l in a)
      for (u = n[l].split(","), h = u.length; h--; )
        a[u[h]] = a[l];
  return a;
}, Ry = function(t, e, r, n) {
  var a = e.ease || n || "power1.inOut", l, h;
  if (Bt(e))
    h = r[t] || (r[t] = []), e.forEach(function(u, f) {
      return h.push({
        t: f / (e.length - 1) * 100,
        v: u,
        e: a
      });
    });
  else
    for (l in e)
      h = r[l] || (r[l] = []), l === "ease" || h.push({
        t: parseFloat(t),
        v: e[l],
        e: a
      });
}, Hr = function(t, e, r, n, a) {
  return ut(t) ? t.call(e, r, n, a) : wt(t) && ~t.indexOf("random(") ? es(t) : t;
}, Xd = fh + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert", jd = {};
Lt(Xd + ",id,stagger,delay,duration,paused,scrollTrigger", function(s) {
  return jd[s] = 1;
});
var _t = /* @__PURE__ */ function(s) {
  dd(t, s);
  function t(r, n, a, l) {
    var h;
    typeof n == "number" && (a.duration = n, n = a, a = null), h = s.call(this, l ? n : zr(n)) || this;
    var u = h.vars, f = u.duration, p = u.delay, m = u.immediateRender, g = u.stagger, x = u.overwrite, o = u.keyframes, c = u.defaults, d = u.scrollTrigger, _ = u.yoyoEase, y = n.parent || ot, v = (Bt(r) || pd(r) ? We(r[0]) : "length" in n) ? [r] : oe(r), b, w, S, T, E, C, M, P;
    if (h._targets = v.length ? ph(v) : Jr("GSAP target " + r + " not found. https://gsap.com", !Kt.nullTargetWarn) || [], h._ptLookup = [], h._overwrite = x, o || g || Ps(f) || Ps(p)) {
      if (n = h.vars, b = h.timeline = new Rt({
        data: "nested",
        defaults: c || {},
        targets: y && y.data === "nested" ? y.vars.targets : v
      }), b.kill(), b.parent = b._dp = Fe(h), b._start = 0, g || Ps(f) || Ps(p)) {
        if (T = v.length, M = g && Rd(g), Me(g))
          for (E in g)
            ~Xd.indexOf(E) && (P || (P = {}), P[E] = g[E]);
        for (w = 0; w < T; w++)
          S = _n(n, jd), S.stagger = 0, _ && (S.yoyoEase = _), P && rr(S, P), C = v[w], S.duration = +Hr(f, Fe(h), w, C, v), S.delay = (+Hr(p, Fe(h), w, C, v) || 0) - h._delay, !g && T === 1 && S.delay && (h._delay = p = S.delay, h._start += p, S.delay = 0), b.to(C, S, M ? M(w, C, v) : 0), b._ease = $.none;
        b.duration() ? f = p = 0 : h.timeline = 0;
      } else if (o) {
        zr(Jt(b.vars.defaults, {
          ease: "none"
        })), b._ease = Mi(o.ease || n.ease || "none");
        var B = 0, U, G, O;
        if (Bt(o))
          o.forEach(function(R) {
            return b.to(v, R, ">");
          }), b.duration();
        else {
          S = {};
          for (E in o)
            E === "ease" || E === "easeEach" || Ry(E, o[E], S, o.easeEach);
          for (E in S)
            for (U = S[E].sort(function(R, I) {
              return R.t - I.t;
            }), B = 0, w = 0; w < U.length; w++)
              G = U[w], O = {
                ease: G.e,
                duration: (G.t - (w ? U[w - 1].t : 0)) / 100 * f
              }, O[E] = G.v, b.to(v, O, B), B += O.duration;
          b.duration() < f && b.to({}, {
            duration: f - b.duration()
          });
        }
      }
      f || h.duration(f = b.duration());
    } else
      h.timeline = 0;
    return x === !0 && !oh && (qe = Fe(h), ot.killTweensOf(v), qe = 0), Ce(y, Fe(h), a), n.reversed && h.reverse(), n.paused && h.paused(!0), (m || !f && !o && h._start === mt(y._time) && Ot(m) && ly(Fe(h)) && y.data !== "nested") && (h._tTime = -1e-8, h.render(Math.max(0, -p) || 0)), d && Pd(Fe(h), d), h;
  }
  var e = t.prototype;
  return e.render = function(n, a, l) {
    var h = this._time, u = this._tDur, f = this._dur, p = n < 0, m = n > u - Mt && !p ? u : n < Mt ? 0 : n, g, x, o, c, d, _, y, v, b;
    if (!f)
      uy(this, n, a, l);
    else if (m !== this._tTime || !n || l || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== p || this._lazy) {
      if (g = m, v = this.timeline, this._repeat) {
        if (c = f + this._rDelay, this._repeat < -1 && p)
          return this.totalTime(c * 100 + n, a, l);
        if (g = mt(m % c), m === u ? (o = this._repeat, g = f) : (d = mt(m / c), o = ~~d, o && o === d ? (g = f, o--) : g > f && (g = f)), _ = this._yoyo && o & 1, _ && (b = this._yEase, g = f - g), d = sr(this._tTime, c), g === h && !l && this._initted && o === d)
          return this._tTime = m, this;
        o !== d && (v && this._yEase && Wd(v, _), this.vars.repeatRefresh && !_ && !this._lock && g !== c && this._initted && (this._lock = l = 1, this.render(mt(c * o), !0).invalidate()._lock = 0));
      }
      if (!this._initted) {
        if (Md(this, p ? n : g, l, a, m))
          return this._tTime = 0, this;
        if (h !== this._time && !(l && this.vars.repeatRefresh && o !== d))
          return this;
        if (f !== this._dur)
          return this.render(n, a, l);
      }
      if (this._tTime = m, this._time = g, !this._act && this._ts && (this._act = 1, this._lazy = 0), this.ratio = y = (b || this._ease)(g / f), this._from && (this.ratio = y = 1 - y), !h && m && !a && !d && (jt(this, "onStart"), this._tTime !== m))
        return this;
      for (x = this._pt; x; )
        x.r(y, x.d), x = x._next;
      v && v.render(n < 0 ? n : v._dur * v._ease(g / this._dur), a, l) || this._startAt && (this._zTime = n), this._onUpdate && !a && (p && ho(this, n, a, l), jt(this, "onUpdate")), this._repeat && o !== d && this.vars.onRepeat && !a && this.parent && jt(this, "onRepeat"), (m === this._tDur || !m) && this._tTime === m && (p && !this._onUpdate && ho(this, n, !0, !0), (n || !f) && (m === this._tDur && this._ts > 0 || !m && this._ts < 0) && si(this, 1), !a && !(p && !h) && (m || h || _) && (jt(this, m === u ? "onComplete" : "onReverseComplete", !0), this._prom && !(m < u && this.timeScale() > 0) && this._prom()));
    }
    return this;
  }, e.targets = function() {
    return this._targets;
  }, e.invalidate = function(n) {
    return (!n || !this.vars.runBackwards) && (this._startAt = 0), this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0, this._ptLookup = [], this.timeline && this.timeline.invalidate(n), s.prototype.invalidate.call(this, n);
  }, e.resetTo = function(n, a, l, h, u) {
    is || Yt.wake(), this._ts || this.play();
    var f = Math.min(this._dur, (this._dp._time - this._start) * this._ts), p;
    return this._initted || gh(this, f), p = this._ease(f / this._dur), By(this, n, a, l, h, p, f, u) ? this.resetTo(n, a, l, h, 1) : (Ln(this, 0), this.parent || Ed(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0), this.render(0));
  }, e.kill = function(n, a) {
    if (a === void 0 && (a = "all"), !n && (!a || a === "all"))
      return this._lazy = this._pt = 0, this.parent ? kr(this) : this.scrollTrigger && this.scrollTrigger.kill(!!Tt), this;
    if (this.timeline) {
      var l = this.timeline.totalDuration();
      return this.timeline.killTweensOf(n, a, qe && qe.vars.overwrite !== !0)._first || kr(this), this.parent && l !== this.timeline.totalDuration() && nr(this, this._dur * this.timeline._tDur / l, 0, 1), this;
    }
    var h = this._targets, u = n ? oe(n) : h, f = this._ptLookup, p = this._pt, m, g, x, o, c, d, _;
    if ((!a || a === "all") && oy(h, u))
      return a === "all" && (this._pt = 0), kr(this);
    for (m = this._op = this._op || [], a !== "all" && (wt(a) && (c = {}, Lt(a, function(y) {
      return c[y] = 1;
    }), a = c), a = Uy(h, a)), _ = h.length; _--; )
      if (~u.indexOf(h[_])) {
        g = f[_], a === "all" ? (m[_] = a, o = g, x = {}) : (x = m[_] = m[_] || {}, o = a);
        for (c in o)
          d = g && g[c], d && ((!("kill" in d.d) || d.d.kill(c) === !0) && Dn(this, d, "_pt"), delete g[c]), x !== "all" && (x[c] = 1);
      }
    return this._initted && !this._pt && p && kr(this), this;
  }, t.to = function(n, a) {
    return new t(n, a, arguments[2]);
  }, t.from = function(n, a) {
    return Nr(1, arguments);
  }, t.delayedCall = function(n, a, l, h) {
    return new t(a, 0, {
      immediateRender: !1,
      lazy: !1,
      overwrite: !1,
      delay: n,
      onComplete: a,
      onReverseComplete: a,
      onCompleteParams: l,
      onReverseCompleteParams: l,
      callbackScope: h
    });
  }, t.fromTo = function(n, a, l) {
    return Nr(2, arguments);
  }, t.set = function(n, a) {
    return a.duration = 0, a.repeatDelay || (a.repeat = 0), new t(n, a);
  }, t.killTweensOf = function(n, a, l) {
    return ot.killTweensOf(n, a, l);
  }, t;
}(rs);
Jt(_t.prototype, {
  _targets: [],
  _lazy: 0,
  _startAt: 0,
  _op: 0,
  _onInit: 0
});
Lt("staggerTo,staggerFrom,staggerFromTo", function(s) {
  _t[s] = function() {
    var t = new Rt(), e = co.call(arguments, 0);
    return e.splice(s === "staggerFromTo" ? 5 : 4, 0, 0), t[s].apply(t, e);
  };
});
var yh = function(t, e, r) {
  return t[e] = r;
}, Kd = function(t, e, r) {
  return t[e](r);
}, Iy = function(t, e, r, n) {
  return t[e](n.fp, r);
}, ky = function(t, e, r) {
  return t.setAttribute(e, r);
}, xh = function(t, e) {
  return ut(t[e]) ? Kd : hh(t[e]) && t.setAttribute ? ky : yh;
}, qd = function(t, e) {
  return e.set(e.t, e.p, Math.round((e.s + e.c * t) * 1e6) / 1e6, e);
}, Fy = function(t, e) {
  return e.set(e.t, e.p, !!(e.s + e.c * t), e);
}, Zd = function(t, e) {
  var r = e._pt, n = "";
  if (!t && e.b)
    n = e.b;
  else if (t === 1 && e.e)
    n = e.e;
  else {
    for (; r; )
      n = r.p + (r.m ? r.m(r.s + r.c * t) : Math.round((r.s + r.c * t) * 1e4) / 1e4) + n, r = r._next;
    n += e.c;
  }
  e.set(e.t, e.p, n, e);
}, bh = function(t, e) {
  for (var r = e._pt; r; )
    r.r(t, r.d), r = r._next;
}, Dy = function(t, e, r, n) {
  for (var a = this._pt, l; a; )
    l = a._next, a.p === n && a.modifier(t, e, r), a = l;
}, Oy = function(t) {
  for (var e = this._pt, r, n; e; )
    n = e._next, e.p === t && !e.op || e.op === t ? Dn(this, e, "_pt") : e.dep || (r = 1), e = n;
  return !r;
}, Ly = function(t, e, r, n) {
  n.mSet(t, e, n.m.call(n.tween, r, n.mt), n);
}, Qd = function(t) {
  for (var e = t._pt, r, n, a, l; e; ) {
    for (r = e._next, n = a; n && n.pr > e.pr; )
      n = n._next;
    (e._prev = n ? n._prev : l) ? e._prev._next = e : a = e, (e._next = n) ? n._prev = e : l = e, e = r;
  }
  t._pt = a;
}, Gt = /* @__PURE__ */ function() {
  function s(e, r, n, a, l, h, u, f, p) {
    this.t = r, this.s = a, this.c = l, this.p = n, this.r = h || qd, this.d = u || this, this.set = f || yh, this.pr = p || 0, this._next = e, e && (e._prev = this);
  }
  var t = s.prototype;
  return t.modifier = function(r, n, a) {
    this.mSet = this.mSet || this.set, this.set = Ly, this.m = r, this.mt = a, this.tween = n;
  }, s;
}();
Lt(fh + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function(s) {
  return dh[s] = 1;
});
Qt.TweenMax = Qt.TweenLite = _t;
Qt.TimelineLite = Qt.TimelineMax = Rt;
ot = new Rt({
  sortChildren: !1,
  defaults: ir,
  autoRemoveChildren: !0,
  id: "root",
  smoothChildTiming: !0
});
Kt.stringFilter = Nd;
var Bi = [], sn = {}, Gy = [], Ll = 0, zy = 0, ea = function(t) {
  return (sn[t] || Gy).map(function(e) {
    return e();
  });
}, _o = function() {
  var t = Date.now(), e = [];
  t - Ll > 2 && (ea("matchMediaInit"), Bi.forEach(function(r) {
    var n = r.queries, a = r.conditions, l, h, u, f;
    for (h in n)
      l = Se.matchMedia(n[h]).matches, l && (u = 1), l !== a[h] && (a[h] = l, f = 1);
    f && (r.revert(), u && e.push(r));
  }), ea("matchMediaRevert"), e.forEach(function(r) {
    return r.onMatch(r, function(n) {
      return r.add(null, n);
    });
  }), Ll = t, ea("matchMedia"));
}, Jd = /* @__PURE__ */ function() {
  function s(e, r) {
    this.selector = r && uo(r), this.data = [], this._r = [], this.isReverted = !1, this.id = zy++, e && this.add(e);
  }
  var t = s.prototype;
  return t.add = function(r, n, a) {
    ut(r) && (a = n, n = r, r = ut);
    var l = this, h = function() {
      var f = nt, p = l.selector, m;
      return f && f !== l && f.data.push(l), a && (l.selector = uo(a)), nt = l, m = n.apply(l, arguments), ut(m) && l._r.push(m), nt = f, l.selector = p, l.isReverted = !1, m;
    };
    return l.last = h, r === ut ? h(l, function(u) {
      return l.add(null, u);
    }) : r ? l[r] = h : h;
  }, t.ignore = function(r) {
    var n = nt;
    nt = null, r(this), nt = n;
  }, t.getTweens = function() {
    var r = [];
    return this.data.forEach(function(n) {
      return n instanceof s ? r.push.apply(r, n.getTweens()) : n instanceof _t && !(n.parent && n.parent.data === "nested") && r.push(n);
    }), r;
  }, t.clear = function() {
    this._r.length = this.data.length = 0;
  }, t.kill = function(r, n) {
    var a = this;
    if (r ? function() {
      for (var h = a.getTweens(), u = a.data.length, f; u--; )
        f = a.data[u], f.data === "isFlip" && (f.revert(), f.getChildren(!0, !0, !1).forEach(function(p) {
          return h.splice(h.indexOf(p), 1);
        }));
      for (h.map(function(p) {
        return {
          g: p._dur || p._delay || p._sat && !p._sat.vars.immediateRender ? p.globalTime(0) : -1 / 0,
          t: p
        };
      }).sort(function(p, m) {
        return m.g - p.g || -1 / 0;
      }).forEach(function(p) {
        return p.t.revert(r);
      }), u = a.data.length; u--; )
        f = a.data[u], f instanceof Rt ? f.data !== "nested" && (f.scrollTrigger && f.scrollTrigger.revert(), f.kill()) : !(f instanceof _t) && f.revert && f.revert(r);
      a._r.forEach(function(p) {
        return p(r, a);
      }), a.isReverted = !0;
    }() : this.data.forEach(function(h) {
      return h.kill && h.kill();
    }), this.clear(), n)
      for (var l = Bi.length; l--; )
        Bi[l].id === this.id && Bi.splice(l, 1);
  }, t.revert = function(r) {
    this.kill(r || {});
  }, s;
}(), Ny = /* @__PURE__ */ function() {
  function s(e) {
    this.contexts = [], this.scope = e, nt && nt.data.push(this);
  }
  var t = s.prototype;
  return t.add = function(r, n, a) {
    Me(r) || (r = {
      matches: r
    });
    var l = new Jd(0, a || this.scope), h = l.conditions = {}, u, f, p;
    nt && !l.selector && (l.selector = nt.selector), this.contexts.push(l), n = l.add("onMatch", n), l.queries = r;
    for (f in r)
      f === "all" ? p = 1 : (u = Se.matchMedia(r[f]), u && (Bi.indexOf(l) < 0 && Bi.push(l), (h[f] = u.matches) && (p = 1), u.addListener ? u.addListener(_o) : u.addEventListener("change", _o)));
    return p && n(l, function(m) {
      return l.add(null, m);
    }), this;
  }, t.revert = function(r) {
    this.kill(r || {});
  }, t.kill = function(r) {
    this.contexts.forEach(function(n) {
      return n.kill(r, !0);
    });
  }, s;
}(), gn = {
  registerPlugin: function() {
    for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++)
      e[r] = arguments[r];
    e.forEach(function(n) {
      return Ld(n);
    });
  },
  timeline: function(t) {
    return new Rt(t);
  },
  getTweensOf: function(t, e) {
    return ot.getTweensOf(t, e);
  },
  getProperty: function(t, e, r, n) {
    wt(t) && (t = oe(t)[0]);
    var a = Ai(t || {}).get, l = r ? Cd : Td;
    return r === "native" && (r = ""), t && (e ? l(($t[e] && $t[e].get || a)(t, e, r, n)) : function(h, u, f) {
      return l(($t[h] && $t[h].get || a)(t, h, u, f));
    });
  },
  quickSetter: function(t, e, r) {
    if (t = oe(t), t.length > 1) {
      var n = t.map(function(p) {
        return Nt.quickSetter(p, e, r);
      }), a = n.length;
      return function(p) {
        for (var m = a; m--; )
          n[m](p);
      };
    }
    t = t[0] || {};
    var l = $t[e], h = Ai(t), u = h.harness && (h.harness.aliases || {})[e] || e, f = l ? function(p) {
      var m = new l();
      Xi._pt = 0, m.init(t, r ? p + r : p, Xi, 0, [t]), m.render(1, m), Xi._pt && bh(1, Xi);
    } : h.set(t, u);
    return l ? f : function(p) {
      return f(t, u, r ? p + r : p, h, 1);
    };
  },
  quickTo: function(t, e, r) {
    var n, a = Nt.to(t, Jt((n = {}, n[e] = "+=0.1", n.paused = !0, n.stagger = 0, n), r || {})), l = function(u, f, p) {
      return a.resetTo(e, u, f, p);
    };
    return l.tween = a, l;
  },
  isTweening: function(t) {
    return ot.getTweensOf(t, !0).length > 0;
  },
  defaults: function(t) {
    return t && t.ease && (t.ease = Mi(t.ease, ir.ease)), Il(ir, t || {});
  },
  config: function(t) {
    return Il(Kt, t || {});
  },
  registerEffect: function(t) {
    var e = t.name, r = t.effect, n = t.plugins, a = t.defaults, l = t.extendTimeline;
    (n || "").split(",").forEach(function(h) {
      return h && !$t[h] && !Qt[h] && Jr(e + " effect requires " + h + " plugin.");
    }), Zn[e] = function(h, u, f) {
      return r(oe(h), Jt(u || {}, a), f);
    }, l && (Rt.prototype[e] = function(h, u, f) {
      return this.add(Zn[e](h, Me(u) ? u : (f = u) && {}, this), f);
    });
  },
  registerEase: function(t, e) {
    $[t] = Mi(e);
  },
  parseEase: function(t, e) {
    return arguments.length ? Mi(t, e) : $;
  },
  getById: function(t) {
    return ot.getById(t);
  },
  exportRoot: function(t, e) {
    t === void 0 && (t = {});
    var r = new Rt(t), n, a;
    for (r.smoothChildTiming = Ot(t.smoothChildTiming), ot.remove(r), r._dp = 0, r._time = r._tTime = ot._time, n = ot._first; n; )
      a = n._next, (e || !(!n._dur && n instanceof _t && n.vars.onComplete === n._targets[0])) && Ce(r, n, n._start - n._delay), n = a;
    return Ce(ot, r, 0), r;
  },
  context: function(t, e) {
    return t ? new Jd(t, e) : nt;
  },
  matchMedia: function(t) {
    return new Ny(t);
  },
  matchMediaRefresh: function() {
    return Bi.forEach(function(t) {
      var e = t.conditions, r, n;
      for (n in e)
        e[n] && (e[n] = !1, r = 1);
      r && t.revert();
    }) || _o();
  },
  addEventListener: function(t, e) {
    var r = sn[t] || (sn[t] = []);
    ~r.indexOf(e) || r.push(e);
  },
  removeEventListener: function(t, e) {
    var r = sn[t], n = r && r.indexOf(e);
    n >= 0 && r.splice(n, 1);
  },
  utils: {
    wrap: xy,
    wrapYoyo: by,
    distribute: Rd,
    random: kd,
    snap: Id,
    normalize: yy,
    getUnit: Pt,
    clamp: py,
    splitColor: Gd,
    toArray: oe,
    selector: uo,
    mapRange: Dd,
    pipe: my,
    unitize: gy,
    interpolate: vy,
    shuffle: Ud
  },
  install: xd,
  effects: Zn,
  ticker: Yt,
  updateRoot: Rt.updateRoot,
  plugins: $t,
  globalTimeline: ot,
  core: {
    PropTween: Gt,
    globals: bd,
    Tween: _t,
    Timeline: Rt,
    Animation: rs,
    getCache: Ai,
    _removeLinkedListItem: Dn,
    reverting: function() {
      return Tt;
    },
    context: function(t) {
      return t && nt && (nt.data.push(t), t._ctx = nt), nt;
    },
    suppressOverwrites: function(t) {
      return oh = t;
    }
  }
};
Lt("to,from,fromTo,delayedCall,set,killTweensOf", function(s) {
  return gn[s] = _t[s];
});
Yt.add(Rt.updateRoot);
Xi = gn.to({}, {
  duration: 0
});
var Hy = function(t, e) {
  for (var r = t._pt; r && r.p !== e && r.op !== e && r.fp !== e; )
    r = r._next;
  return r;
}, Wy = function(t, e) {
  var r = t._targets, n, a, l;
  for (n in e)
    for (a = r.length; a--; )
      l = t._ptLookup[a][n], l && (l = l.d) && (l._pt && (l = Hy(l, n)), l && l.modifier && l.modifier(e[n], t, r[a], n));
}, ia = function(t, e) {
  return {
    name: t,
    headless: 1,
    rawVars: 1,
    //don't pre-process function-based values or "random()" strings.
    init: function(n, a, l) {
      l._onInit = function(h) {
        var u, f;
        if (wt(a) && (u = {}, Lt(a, function(p) {
          return u[p] = 1;
        }), a = u), e) {
          u = {};
          for (f in a)
            u[f] = e(a[f]);
          a = u;
        }
        Wy(h, a);
      };
    }
  };
}, Nt = gn.registerPlugin({
  name: "attr",
  init: function(t, e, r, n, a) {
    var l, h, u;
    this.tween = r;
    for (l in e)
      u = t.getAttribute(l) || "", h = this.add(t, "setAttribute", (u || 0) + "", e[l], n, a, 0, 0, l), h.op = l, h.b = u, this._props.push(l);
  },
  render: function(t, e) {
    for (var r = e._pt; r; )
      Tt ? r.set(r.t, r.p, r.b, r) : r.r(t, r.d), r = r._next;
  }
}, {
  name: "endArray",
  headless: 1,
  init: function(t, e) {
    for (var r = e.length; r--; )
      this.add(t, r, t[r] || 0, e[r], 0, 0, 0, 0, 0, 1);
  }
}, ia("roundProps", fo), ia("modifiers"), ia("snap", Id)) || gn;
_t.version = Rt.version = Nt.version = "3.13.0";
yd = 1;
lh() && ar();
$.Power0;
$.Power1;
$.Power2;
$.Power3;
$.Power4;
$.Linear;
$.Quad;
$.Cubic;
$.Quart;
$.Quint;
$.Strong;
$.Elastic;
$.Back;
$.SteppedEase;
$.Bounce;
$.Sine;
$.Expo;
$.Circ;
/*!
 * CSSPlugin 3.13.0
 * https://gsap.com
 *
 * Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/
var Gl, Ze, Zi, vh, Ti, zl, wh, Vy = function() {
  return typeof window < "u";
}, Ve = {}, xi = 180 / Math.PI, Qi = Math.PI / 180, Oi = Math.atan2, Nl = 1e8, Sh = /([A-Z])/g, $y = /(left|right|width|margin|padding|x)/i, Yy = /[\s,\(]\S/, Ee = {
  autoAlpha: "opacity,visibility",
  scale: "scaleX,scaleY",
  alpha: "opacity"
}, mo = function(t, e) {
  return e.set(e.t, e.p, Math.round((e.s + e.c * t) * 1e4) / 1e4 + e.u, e);
}, Xy = function(t, e) {
  return e.set(e.t, e.p, t === 1 ? e.e : Math.round((e.s + e.c * t) * 1e4) / 1e4 + e.u, e);
}, jy = function(t, e) {
  return e.set(e.t, e.p, t ? Math.round((e.s + e.c * t) * 1e4) / 1e4 + e.u : e.b, e);
}, Ky = function(t, e) {
  var r = e.s + e.c * t;
  e.set(e.t, e.p, ~~(r + (r < 0 ? -0.5 : 0.5)) + e.u, e);
}, tf = function(t, e) {
  return e.set(e.t, e.p, t ? e.e : e.b, e);
}, ef = function(t, e) {
  return e.set(e.t, e.p, t !== 1 ? e.b : e.e, e);
}, qy = function(t, e, r) {
  return t.style[e] = r;
}, Zy = function(t, e, r) {
  return t.style.setProperty(e, r);
}, Qy = function(t, e, r) {
  return t._gsap[e] = r;
}, Jy = function(t, e, r) {
  return t._gsap.scaleX = t._gsap.scaleY = r;
}, tx = function(t, e, r, n, a) {
  var l = t._gsap;
  l.scaleX = l.scaleY = r, l.renderTransform(a, l);
}, ex = function(t, e, r, n, a) {
  var l = t._gsap;
  l[e] = r, l.renderTransform(a, l);
}, ht = "transform", zt = ht + "Origin", ix = function s(t, e) {
  var r = this, n = this.target, a = n.style, l = n._gsap;
  if (t in Ve && a) {
    if (this.tfm = this.tfm || {}, t !== "transform")
      t = Ee[t] || t, ~t.indexOf(",") ? t.split(",").forEach(function(h) {
        return r.tfm[h] = De(n, h);
      }) : this.tfm[t] = l.x ? l[t] : De(n, t), t === zt && (this.tfm.zOrigin = l.zOrigin);
    else
      return Ee.transform.split(",").forEach(function(h) {
        return s.call(r, h, e);
      });
    if (this.props.indexOf(ht) >= 0)
      return;
    l.svg && (this.svgo = n.getAttribute("data-svg-origin"), this.props.push(zt, e, "")), t = ht;
  }
  (a || e) && this.props.push(t, e, a[t]);
}, rf = function(t) {
  t.translate && (t.removeProperty("translate"), t.removeProperty("scale"), t.removeProperty("rotate"));
}, rx = function() {
  var t = this.props, e = this.target, r = e.style, n = e._gsap, a, l;
  for (a = 0; a < t.length; a += 3)
    t[a + 1] ? t[a + 1] === 2 ? e[t[a]](t[a + 2]) : e[t[a]] = t[a + 2] : t[a + 2] ? r[t[a]] = t[a + 2] : r.removeProperty(t[a].substr(0, 2) === "--" ? t[a] : t[a].replace(Sh, "-$1").toLowerCase());
  if (this.tfm) {
    for (l in this.tfm)
      n[l] = this.tfm[l];
    n.svg && (n.renderTransform(), e.setAttribute("data-svg-origin", this.svgo || "")), a = wh(), (!a || !a.isStart) && !r[ht] && (rf(r), n.zOrigin && r[zt] && (r[zt] += " " + n.zOrigin + "px", n.zOrigin = 0, n.renderTransform()), n.uncache = 1);
  }
}, sf = function(t, e) {
  var r = {
    target: t,
    props: [],
    revert: rx,
    save: ix
  };
  return t._gsap || Nt.core.getCache(t), e && t.style && t.nodeType && e.split(",").forEach(function(n) {
    return r.save(n);
  }), r;
}, nf, go = function(t, e) {
  var r = Ze.createElementNS ? Ze.createElementNS((e || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), t) : Ze.createElement(t);
  return r && r.style ? r : Ze.createElement(t);
}, he = function s(t, e, r) {
  var n = getComputedStyle(t);
  return n[e] || n.getPropertyValue(e.replace(Sh, "-$1").toLowerCase()) || n.getPropertyValue(e) || !r && s(t, or(e) || e, 1) || "";
}, Hl = "O,Moz,ms,Ms,Webkit".split(","), or = function(t, e, r) {
  var n = e || Ti, a = n.style, l = 5;
  if (t in a && !r)
    return t;
  for (t = t.charAt(0).toUpperCase() + t.substr(1); l-- && !(Hl[l] + t in a); )
    ;
  return l < 0 ? null : (l === 3 ? "ms" : l >= 0 ? Hl[l] : "") + t;
}, yo = function() {
  Vy() && window.document && (Gl = window, Ze = Gl.document, Zi = Ze.documentElement, Ti = go("div") || {
    style: {}
  }, go("div"), ht = or(ht), zt = ht + "Origin", Ti.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0", nf = !!or("perspective"), wh = Nt.core.reverting, vh = 1);
}, Wl = function(t) {
  var e = t.ownerSVGElement, r = go("svg", e && e.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), n = t.cloneNode(!0), a;
  n.style.display = "block", r.appendChild(n), Zi.appendChild(r);
  try {
    a = n.getBBox();
  } catch {
  }
  return r.removeChild(n), Zi.removeChild(r), a;
}, Vl = function(t, e) {
  for (var r = e.length; r--; )
    if (t.hasAttribute(e[r]))
      return t.getAttribute(e[r]);
}, af = function(t) {
  var e, r;
  try {
    e = t.getBBox();
  } catch {
    e = Wl(t), r = 1;
  }
  return e && (e.width || e.height) || r || (e = Wl(t)), e && !e.width && !e.x && !e.y ? {
    x: +Vl(t, ["x", "cx", "x1"]) || 0,
    y: +Vl(t, ["y", "cy", "y1"]) || 0,
    width: 0,
    height: 0
  } : e;
}, of = function(t) {
  return !!(t.getCTM && (!t.parentNode || t.ownerSVGElement) && af(t));
}, Ri = function(t, e) {
  if (e) {
    var r = t.style, n;
    e in Ve && e !== zt && (e = ht), r.removeProperty ? (n = e.substr(0, 2), (n === "ms" || e.substr(0, 6) === "webkit") && (e = "-" + e), r.removeProperty(n === "--" ? e : e.replace(Sh, "-$1").toLowerCase())) : r.removeAttribute(e);
  }
}, Qe = function(t, e, r, n, a, l) {
  var h = new Gt(t._pt, e, r, 0, 1, l ? ef : tf);
  return t._pt = h, h.b = n, h.e = a, t._props.push(r), h;
}, $l = {
  deg: 1,
  rad: 1,
  turn: 1
}, sx = {
  grid: 1,
  flex: 1
}, ni = function s(t, e, r, n) {
  var a = parseFloat(r) || 0, l = (r + "").trim().substr((a + "").length) || "px", h = Ti.style, u = $y.test(e), f = t.tagName.toLowerCase() === "svg", p = (f ? "client" : "offset") + (u ? "Width" : "Height"), m = 100, g = n === "px", x = n === "%", o, c, d, _;
  if (n === l || !a || $l[n] || $l[l])
    return a;
  if (l !== "px" && !g && (a = s(t, e, r, "px")), _ = t.getCTM && of(t), (x || l === "%") && (Ve[e] || ~e.indexOf("adius")))
    return o = _ ? t.getBBox()[u ? "width" : "height"] : t[p], dt(x ? a / o * m : a / 100 * o);
  if (h[u ? "width" : "height"] = m + (g ? l : n), c = n !== "rem" && ~e.indexOf("adius") || n === "em" && t.appendChild && !f ? t : t.parentNode, _ && (c = (t.ownerSVGElement || {}).parentNode), (!c || c === Ze || !c.appendChild) && (c = Ze.body), d = c._gsap, d && x && d.width && u && d.time === Yt.time && !d.uncache)
    return dt(a / d.width * m);
  if (x && (e === "height" || e === "width")) {
    var y = t.style[e];
    t.style[e] = m + n, o = t[p], y ? t.style[e] = y : Ri(t, e);
  } else
    (x || l === "%") && !sx[he(c, "display")] && (h.position = he(t, "position")), c === t && (h.position = "static"), c.appendChild(Ti), o = Ti[p], c.removeChild(Ti), h.position = "absolute";
  return u && x && (d = Ai(c), d.time = Yt.time, d.width = c[p]), dt(g ? o * a / m : o && a ? m / o * a : 0);
}, De = function(t, e, r, n) {
  var a;
  return vh || yo(), e in Ee && e !== "transform" && (e = Ee[e], ~e.indexOf(",") && (e = e.split(",")[0])), Ve[e] && e !== "transform" ? (a = ns(t, n), a = e !== "transformOrigin" ? a[e] : a.svg ? a.origin : xn(he(t, zt)) + " " + a.zOrigin + "px") : (a = t.style[e], (!a || a === "auto" || n || ~(a + "").indexOf("calc(")) && (a = yn[e] && yn[e](t, e, r) || he(t, e) || wd(t, e) || (e === "opacity" ? 1 : 0))), r && !~(a + "").trim().indexOf(" ") ? ni(t, e, a, r) + r : a;
}, nx = function(t, e, r, n) {
  if (!r || r === "none") {
    var a = or(e, t, 1), l = a && he(t, a, 1);
    l && l !== r ? (e = a, r = l) : e === "borderColor" && (r = he(t, "borderTopColor"));
  }
  var h = new Gt(this._pt, t.style, e, 0, 1, Zd), u = 0, f = 0, p, m, g, x, o, c, d, _, y, v, b, w;
  if (h.b = r, h.e = n, r += "", n += "", n.substring(0, 6) === "var(--" && (n = he(t, n.substring(4, n.indexOf(")")))), n === "auto" && (c = t.style[e], t.style[e] = n, n = he(t, e) || n, c ? t.style[e] = c : Ri(t, e)), p = [r, n], Nd(p), r = p[0], n = p[1], g = r.match(Yi) || [], w = n.match(Yi) || [], w.length) {
    for (; m = Yi.exec(n); )
      d = m[0], y = n.substring(u, m.index), o ? o = (o + 1) % 5 : (y.substr(-5) === "rgba(" || y.substr(-5) === "hsla(") && (o = 1), d !== (c = g[f++] || "") && (x = parseFloat(c) || 0, b = c.substr((x + "").length), d.charAt(1) === "=" && (d = qi(x, d) + b), _ = parseFloat(d), v = d.substr((_ + "").length), u = Yi.lastIndex - v.length, v || (v = v || Kt.units[e] || b, u === n.length && (n += v, h.e += v)), b !== v && (x = ni(t, e, c, v) || 0), h._pt = {
        _next: h._pt,
        p: y || f === 1 ? y : ",",
        //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
        s: x,
        c: _ - x,
        m: o && o < 4 || e === "zIndex" ? Math.round : 0
      });
    h.c = u < n.length ? n.substring(u, n.length) : "";
  } else
    h.r = e === "display" && n === "none" ? ef : tf;
  return md.test(n) && (h.e = 0), this._pt = h, h;
}, Yl = {
  top: "0%",
  bottom: "100%",
  left: "0%",
  right: "100%",
  center: "50%"
}, ax = function(t) {
  var e = t.split(" "), r = e[0], n = e[1] || "50%";
  return (r === "top" || r === "bottom" || n === "left" || n === "right") && (t = r, r = n, n = t), e[0] = Yl[r] || r, e[1] = Yl[n] || n, e.join(" ");
}, ox = function(t, e) {
  if (e.tween && e.tween._time === e.tween._dur) {
    var r = e.t, n = r.style, a = e.u, l = r._gsap, h, u, f;
    if (a === "all" || a === !0)
      n.cssText = "", u = 1;
    else
      for (a = a.split(","), f = a.length; --f > -1; )
        h = a[f], Ve[h] && (u = 1, h = h === "transformOrigin" ? zt : ht), Ri(r, h);
    u && (Ri(r, ht), l && (l.svg && r.removeAttribute("transform"), n.scale = n.rotate = n.translate = "none", ns(r, 1), l.uncache = 1, rf(n)));
  }
}, yn = {
  clearProps: function(t, e, r, n, a) {
    if (a.data !== "isFromStart") {
      var l = t._pt = new Gt(t._pt, e, r, 0, 0, ox);
      return l.u = n, l.pr = -10, l.tween = a, t._props.push(r), 1;
    }
  }
  /* className feature (about 0.4kb gzipped).
  , className(plugin, target, property, endValue, tween) {
  	let _renderClassName = (ratio, data) => {
  			data.css.render(ratio, data.css);
  			if (!ratio || ratio === 1) {
  				let inline = data.rmv,
  					target = data.t,
  					p;
  				target.setAttribute("class", ratio ? data.e : data.b);
  				for (p in inline) {
  					_removeProperty(target, p);
  				}
  			}
  		},
  		_getAllStyles = (target) => {
  			let styles = {},
  				computed = getComputedStyle(target),
  				p;
  			for (p in computed) {
  				if (isNaN(p) && p !== "cssText" && p !== "length") {
  					styles[p] = computed[p];
  				}
  			}
  			_setDefaults(styles, _parseTransform(target, 1));
  			return styles;
  		},
  		startClassList = target.getAttribute("class"),
  		style = target.style,
  		cssText = style.cssText,
  		cache = target._gsap,
  		classPT = cache.classPT,
  		inlineToRemoveAtEnd = {},
  		data = {t:target, plugin:plugin, rmv:inlineToRemoveAtEnd, b:startClassList, e:(endValue.charAt(1) !== "=") ? endValue : startClassList.replace(new RegExp("(?:\\s|^)" + endValue.substr(2) + "(?![\\w-])"), "") + ((endValue.charAt(0) === "+") ? " " + endValue.substr(2) : "")},
  		changingVars = {},
  		startVars = _getAllStyles(target),
  		transformRelated = /(transform|perspective)/i,
  		endVars, p;
  	if (classPT) {
  		classPT.r(1, classPT.d);
  		_removeLinkedListItem(classPT.d.plugin, classPT, "_pt");
  	}
  	target.setAttribute("class", data.e);
  	endVars = _getAllStyles(target, true);
  	target.setAttribute("class", startClassList);
  	for (p in endVars) {
  		if (endVars[p] !== startVars[p] && !transformRelated.test(p)) {
  			changingVars[p] = endVars[p];
  			if (!style[p] && style[p] !== "0") {
  				inlineToRemoveAtEnd[p] = 1;
  			}
  		}
  	}
  	cache.classPT = plugin._pt = new PropTween(plugin._pt, target, "className", 0, 0, _renderClassName, data, 0, -11);
  	if (style.cssText !== cssText) { //only apply if things change. Otherwise, in cases like a background-image that's pulled dynamically, it could cause a refresh. See https://gsap.com/forums/topic/20368-possible-gsap-bug-switching-classnames-in-chrome/.
  		style.cssText = cssText; //we recorded cssText before we swapped classes and ran _getAllStyles() because in cases when a className tween is overwritten, we remove all the related tweening properties from that class change (otherwise class-specific stuff can't override properties we've directly set on the target's style object due to specificity).
  	}
  	_parseTransform(target, true); //to clear the caching of transforms
  	data.css = new gsap.plugins.css();
  	data.css.init(target, changingVars, tween);
  	plugin._props.push(...data.css._props);
  	return 1;
  }
  */
}, ss = [1, 0, 0, 1, 0, 0], hf = {}, lf = function(t) {
  return t === "matrix(1, 0, 0, 1, 0, 0)" || t === "none" || !t;
}, Xl = function(t) {
  var e = he(t, ht);
  return lf(e) ? ss : e.substr(7).match(_d).map(dt);
}, Th = function(t, e) {
  var r = t._gsap || Ai(t), n = t.style, a = Xl(t), l, h, u, f;
  return r.svg && t.getAttribute("transform") ? (u = t.transform.baseVal.consolidate().matrix, a = [u.a, u.b, u.c, u.d, u.e, u.f], a.join(",") === "1,0,0,1,0,0" ? ss : a) : (a === ss && !t.offsetParent && t !== Zi && !r.svg && (u = n.display, n.display = "block", l = t.parentNode, (!l || !t.offsetParent && !t.getBoundingClientRect().width) && (f = 1, h = t.nextElementSibling, Zi.appendChild(t)), a = Xl(t), u ? n.display = u : Ri(t, "display"), f && (h ? l.insertBefore(t, h) : l ? l.appendChild(t) : Zi.removeChild(t))), e && a.length > 6 ? [a[0], a[1], a[4], a[5], a[12], a[13]] : a);
}, xo = function(t, e, r, n, a, l) {
  var h = t._gsap, u = a || Th(t, !0), f = h.xOrigin || 0, p = h.yOrigin || 0, m = h.xOffset || 0, g = h.yOffset || 0, x = u[0], o = u[1], c = u[2], d = u[3], _ = u[4], y = u[5], v = e.split(" "), b = parseFloat(v[0]) || 0, w = parseFloat(v[1]) || 0, S, T, E, C;
  r ? u !== ss && (T = x * d - o * c) && (E = b * (d / T) + w * (-c / T) + (c * y - d * _) / T, C = b * (-o / T) + w * (x / T) - (x * y - o * _) / T, b = E, w = C) : (S = af(t), b = S.x + (~v[0].indexOf("%") ? b / 100 * S.width : b), w = S.y + (~(v[1] || v[0]).indexOf("%") ? w / 100 * S.height : w)), n || n !== !1 && h.smooth ? (_ = b - f, y = w - p, h.xOffset = m + (_ * x + y * c) - _, h.yOffset = g + (_ * o + y * d) - y) : h.xOffset = h.yOffset = 0, h.xOrigin = b, h.yOrigin = w, h.smooth = !!n, h.origin = e, h.originIsAbsolute = !!r, t.style[zt] = "0px 0px", l && (Qe(l, h, "xOrigin", f, b), Qe(l, h, "yOrigin", p, w), Qe(l, h, "xOffset", m, h.xOffset), Qe(l, h, "yOffset", g, h.yOffset)), t.setAttribute("data-svg-origin", b + " " + w);
}, ns = function(t, e) {
  var r = t._gsap || new $d(t);
  if ("x" in r && !e && !r.uncache)
    return r;
  var n = t.style, a = r.scaleX < 0, l = "px", h = "deg", u = getComputedStyle(t), f = he(t, zt) || "0", p, m, g, x, o, c, d, _, y, v, b, w, S, T, E, C, M, P, B, U, G, O, R, I, st, V, xt, pt, gt, H, ee, ie;
  return p = m = g = c = d = _ = y = v = b = 0, x = o = 1, r.svg = !!(t.getCTM && of(t)), u.translate && ((u.translate !== "none" || u.scale !== "none" || u.rotate !== "none") && (n[ht] = (u.translate !== "none" ? "translate3d(" + (u.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + (u.rotate !== "none" ? "rotate(" + u.rotate + ") " : "") + (u.scale !== "none" ? "scale(" + u.scale.split(" ").join(",") + ") " : "") + (u[ht] !== "none" ? u[ht] : "")), n.scale = n.rotate = n.translate = "none"), T = Th(t, r.svg), r.svg && (r.uncache ? (st = t.getBBox(), f = r.xOrigin - st.x + "px " + (r.yOrigin - st.y) + "px", I = "") : I = !e && t.getAttribute("data-svg-origin"), xo(t, I || f, !!I || r.originIsAbsolute, r.smooth !== !1, T)), w = r.xOrigin || 0, S = r.yOrigin || 0, T !== ss && (P = T[0], B = T[1], U = T[2], G = T[3], p = O = T[4], m = R = T[5], T.length === 6 ? (x = Math.sqrt(P * P + B * B), o = Math.sqrt(G * G + U * U), c = P || B ? Oi(B, P) * xi : 0, y = U || G ? Oi(U, G) * xi + c : 0, y && (o *= Math.abs(Math.cos(y * Qi))), r.svg && (p -= w - (w * P + S * U), m -= S - (w * B + S * G))) : (ie = T[6], H = T[7], xt = T[8], pt = T[9], gt = T[10], ee = T[11], p = T[12], m = T[13], g = T[14], E = Oi(ie, gt), d = E * xi, E && (C = Math.cos(-E), M = Math.sin(-E), I = O * C + xt * M, st = R * C + pt * M, V = ie * C + gt * M, xt = O * -M + xt * C, pt = R * -M + pt * C, gt = ie * -M + gt * C, ee = H * -M + ee * C, O = I, R = st, ie = V), E = Oi(-U, gt), _ = E * xi, E && (C = Math.cos(-E), M = Math.sin(-E), I = P * C - xt * M, st = B * C - pt * M, V = U * C - gt * M, ee = G * M + ee * C, P = I, B = st, U = V), E = Oi(B, P), c = E * xi, E && (C = Math.cos(E), M = Math.sin(E), I = P * C + B * M, st = O * C + R * M, B = B * C - P * M, R = R * C - O * M, P = I, O = st), d && Math.abs(d) + Math.abs(c) > 359.9 && (d = c = 0, _ = 180 - _), x = dt(Math.sqrt(P * P + B * B + U * U)), o = dt(Math.sqrt(R * R + ie * ie)), E = Oi(O, R), y = Math.abs(E) > 2e-4 ? E * xi : 0, b = ee ? 1 / (ee < 0 ? -ee : ee) : 0), r.svg && (I = t.getAttribute("transform"), r.forceCSS = t.setAttribute("transform", "") || !lf(he(t, ht)), I && t.setAttribute("transform", I))), Math.abs(y) > 90 && Math.abs(y) < 270 && (a ? (x *= -1, y += c <= 0 ? 180 : -180, c += c <= 0 ? 180 : -180) : (o *= -1, y += y <= 0 ? 180 : -180)), e = e || r.uncache, r.x = p - ((r.xPercent = p && (!e && r.xPercent || (Math.round(t.offsetWidth / 2) === Math.round(-p) ? -50 : 0))) ? t.offsetWidth * r.xPercent / 100 : 0) + l, r.y = m - ((r.yPercent = m && (!e && r.yPercent || (Math.round(t.offsetHeight / 2) === Math.round(-m) ? -50 : 0))) ? t.offsetHeight * r.yPercent / 100 : 0) + l, r.z = g + l, r.scaleX = dt(x), r.scaleY = dt(o), r.rotation = dt(c) + h, r.rotationX = dt(d) + h, r.rotationY = dt(_) + h, r.skewX = y + h, r.skewY = v + h, r.transformPerspective = b + l, (r.zOrigin = parseFloat(f.split(" ")[2]) || !e && r.zOrigin || 0) && (n[zt] = xn(f)), r.xOffset = r.yOffset = 0, r.force3D = Kt.force3D, r.renderTransform = r.svg ? lx : nf ? cf : hx, r.uncache = 0, r;
}, xn = function(t) {
  return (t = t.split(" "))[0] + " " + t[1];
}, ra = function(t, e, r) {
  var n = Pt(e);
  return dt(parseFloat(e) + parseFloat(ni(t, "x", r + "px", n))) + n;
}, hx = function(t, e) {
  e.z = "0px", e.rotationY = e.rotationX = "0deg", e.force3D = 0, cf(t, e);
}, _i = "0deg", wr = "0px", mi = ") ", cf = function(t, e) {
  var r = e || this, n = r.xPercent, a = r.yPercent, l = r.x, h = r.y, u = r.z, f = r.rotation, p = r.rotationY, m = r.rotationX, g = r.skewX, x = r.skewY, o = r.scaleX, c = r.scaleY, d = r.transformPerspective, _ = r.force3D, y = r.target, v = r.zOrigin, b = "", w = _ === "auto" && t && t !== 1 || _ === !0;
  if (v && (m !== _i || p !== _i)) {
    var S = parseFloat(p) * Qi, T = Math.sin(S), E = Math.cos(S), C;
    S = parseFloat(m) * Qi, C = Math.cos(S), l = ra(y, l, T * C * -v), h = ra(y, h, -Math.sin(S) * -v), u = ra(y, u, E * C * -v + v);
  }
  d !== wr && (b += "perspective(" + d + mi), (n || a) && (b += "translate(" + n + "%, " + a + "%) "), (w || l !== wr || h !== wr || u !== wr) && (b += u !== wr || w ? "translate3d(" + l + ", " + h + ", " + u + ") " : "translate(" + l + ", " + h + mi), f !== _i && (b += "rotate(" + f + mi), p !== _i && (b += "rotateY(" + p + mi), m !== _i && (b += "rotateX(" + m + mi), (g !== _i || x !== _i) && (b += "skew(" + g + ", " + x + mi), (o !== 1 || c !== 1) && (b += "scale(" + o + ", " + c + mi), y.style[ht] = b || "translate(0, 0)";
}, lx = function(t, e) {
  var r = e || this, n = r.xPercent, a = r.yPercent, l = r.x, h = r.y, u = r.rotation, f = r.skewX, p = r.skewY, m = r.scaleX, g = r.scaleY, x = r.target, o = r.xOrigin, c = r.yOrigin, d = r.xOffset, _ = r.yOffset, y = r.forceCSS, v = parseFloat(l), b = parseFloat(h), w, S, T, E, C;
  u = parseFloat(u), f = parseFloat(f), p = parseFloat(p), p && (p = parseFloat(p), f += p, u += p), u || f ? (u *= Qi, f *= Qi, w = Math.cos(u) * m, S = Math.sin(u) * m, T = Math.sin(u - f) * -g, E = Math.cos(u - f) * g, f && (p *= Qi, C = Math.tan(f - p), C = Math.sqrt(1 + C * C), T *= C, E *= C, p && (C = Math.tan(p), C = Math.sqrt(1 + C * C), w *= C, S *= C)), w = dt(w), S = dt(S), T = dt(T), E = dt(E)) : (w = m, E = g, S = T = 0), (v && !~(l + "").indexOf("px") || b && !~(h + "").indexOf("px")) && (v = ni(x, "x", l, "px"), b = ni(x, "y", h, "px")), (o || c || d || _) && (v = dt(v + o - (o * w + c * T) + d), b = dt(b + c - (o * S + c * E) + _)), (n || a) && (C = x.getBBox(), v = dt(v + n / 100 * C.width), b = dt(b + a / 100 * C.height)), C = "matrix(" + w + "," + S + "," + T + "," + E + "," + v + "," + b + ")", x.setAttribute("transform", C), y && (x.style[ht] = C);
}, cx = function(t, e, r, n, a) {
  var l = 360, h = wt(a), u = parseFloat(a) * (h && ~a.indexOf("rad") ? xi : 1), f = u - n, p = n + f + "deg", m, g;
  return h && (m = a.split("_")[1], m === "short" && (f %= l, f !== f % (l / 2) && (f += f < 0 ? l : -360)), m === "cw" && f < 0 ? f = (f + l * Nl) % l - ~~(f / l) * l : m === "ccw" && f > 0 && (f = (f - l * Nl) % l - ~~(f / l) * l)), t._pt = g = new Gt(t._pt, e, r, n, f, Xy), g.e = p, g.u = "deg", t._props.push(r), g;
}, jl = function(t, e) {
  for (var r in e)
    t[r] = e[r];
  return t;
}, ux = function(t, e, r) {
  var n = jl({}, r._gsap), a = "perspective,force3D,transformOrigin,svgOrigin", l = r.style, h, u, f, p, m, g, x, o;
  n.svg ? (f = r.getAttribute("transform"), r.setAttribute("transform", ""), l[ht] = e, h = ns(r, 1), Ri(r, ht), r.setAttribute("transform", f)) : (f = getComputedStyle(r)[ht], l[ht] = e, h = ns(r, 1), l[ht] = f);
  for (u in Ve)
    f = n[u], p = h[u], f !== p && a.indexOf(u) < 0 && (x = Pt(f), o = Pt(p), m = x !== o ? ni(r, u, f, o) : parseFloat(f), g = parseFloat(p), t._pt = new Gt(t._pt, h, u, m, g - m, mo), t._pt.u = o || 0, t._props.push(u));
  jl(h, n);
};
Lt("padding,margin,Width,Radius", function(s, t) {
  var e = "Top", r = "Right", n = "Bottom", a = "Left", l = (t < 3 ? [e, r, n, a] : [e + a, e + r, n + r, n + a]).map(function(h) {
    return t < 2 ? s + h : "border" + h + s;
  });
  yn[t > 1 ? "border" + s : s] = function(h, u, f, p, m) {
    var g, x;
    if (arguments.length < 4)
      return g = l.map(function(o) {
        return De(h, o, f);
      }), x = g.join(" "), x.split(g[0]).length === 5 ? g[0] : x;
    g = (p + "").split(" "), x = {}, l.forEach(function(o, c) {
      return x[o] = g[c] = g[c] || g[(c - 1) / 2 | 0];
    }), h.init(u, x, m);
  };
});
var uf = {
  name: "css",
  register: yo,
  targetTest: function(t) {
    return t.style && t.nodeType;
  },
  init: function(t, e, r, n, a) {
    var l = this._props, h = t.style, u = r.vars.startAt, f, p, m, g, x, o, c, d, _, y, v, b, w, S, T, E;
    vh || yo(), this.styles = this.styles || sf(t), E = this.styles.props, this.tween = r;
    for (c in e)
      if (c !== "autoRound" && (p = e[c], !($t[c] && Yd(c, e, r, n, t, a)))) {
        if (x = typeof p, o = yn[c], x === "function" && (p = p.call(r, n, t, a), x = typeof p), x === "string" && ~p.indexOf("random(") && (p = es(p)), o)
          o(this, t, c, p, r) && (T = 1);
        else if (c.substr(0, 2) === "--")
          f = (getComputedStyle(t).getPropertyValue(c) + "").trim(), p += "", ri.lastIndex = 0, ri.test(f) || (d = Pt(f), _ = Pt(p)), _ ? d !== _ && (f = ni(t, c, f, _) + _) : d && (p += d), this.add(h, "setProperty", f, p, n, a, 0, 0, c), l.push(c), E.push(c, 0, h[c]);
        else if (x !== "undefined") {
          if (u && c in u ? (f = typeof u[c] == "function" ? u[c].call(r, n, t, a) : u[c], wt(f) && ~f.indexOf("random(") && (f = es(f)), Pt(f + "") || f === "auto" || (f += Kt.units[c] || Pt(De(t, c)) || ""), (f + "").charAt(1) === "=" && (f = De(t, c))) : f = De(t, c), g = parseFloat(f), y = x === "string" && p.charAt(1) === "=" && p.substr(0, 2), y && (p = p.substr(2)), m = parseFloat(p), c in Ee && (c === "autoAlpha" && (g === 1 && De(t, "visibility") === "hidden" && m && (g = 0), E.push("visibility", 0, h.visibility), Qe(this, h, "visibility", g ? "inherit" : "hidden", m ? "inherit" : "hidden", !m)), c !== "scale" && c !== "transform" && (c = Ee[c], ~c.indexOf(",") && (c = c.split(",")[0]))), v = c in Ve, v) {
            if (this.styles.save(c), x === "string" && p.substring(0, 6) === "var(--" && (p = he(t, p.substring(4, p.indexOf(")"))), m = parseFloat(p)), b || (w = t._gsap, w.renderTransform && !e.parseTransform || ns(t, e.parseTransform), S = e.smoothOrigin !== !1 && w.smooth, b = this._pt = new Gt(this._pt, h, ht, 0, 1, w.renderTransform, w, 0, -1), b.dep = 1), c === "scale")
              this._pt = new Gt(this._pt, w, "scaleY", w.scaleY, (y ? qi(w.scaleY, y + m) : m) - w.scaleY || 0, mo), this._pt.u = 0, l.push("scaleY", c), c += "X";
            else if (c === "transformOrigin") {
              E.push(zt, 0, h[zt]), p = ax(p), w.svg ? xo(t, p, 0, S, 0, this) : (_ = parseFloat(p.split(" ")[2]) || 0, _ !== w.zOrigin && Qe(this, w, "zOrigin", w.zOrigin, _), Qe(this, h, c, xn(f), xn(p)));
              continue;
            } else if (c === "svgOrigin") {
              xo(t, p, 1, S, 0, this);
              continue;
            } else if (c in hf) {
              cx(this, w, c, g, y ? qi(g, y + p) : p);
              continue;
            } else if (c === "smoothOrigin") {
              Qe(this, w, "smooth", w.smooth, p);
              continue;
            } else if (c === "force3D") {
              w[c] = p;
              continue;
            } else if (c === "transform") {
              ux(this, p, t);
              continue;
            }
          } else c in h || (c = or(c) || c);
          if (v || (m || m === 0) && (g || g === 0) && !Yy.test(p) && c in h)
            d = (f + "").substr((g + "").length), m || (m = 0), _ = Pt(p) || (c in Kt.units ? Kt.units[c] : d), d !== _ && (g = ni(t, c, f, _)), this._pt = new Gt(this._pt, v ? w : h, c, g, (y ? qi(g, y + m) : m) - g, !v && (_ === "px" || c === "zIndex") && e.autoRound !== !1 ? Ky : mo), this._pt.u = _ || 0, d !== _ && _ !== "%" && (this._pt.b = f, this._pt.r = jy);
          else if (c in h)
            nx.call(this, t, c, f, y ? y + p : p);
          else if (c in t)
            this.add(t, c, f || t[c], y ? y + p : p, n, a);
          else if (c !== "parseTransform") {
            uh(c, p);
            continue;
          }
          v || (c in h ? E.push(c, 0, h[c]) : typeof t[c] == "function" ? E.push(c, 2, t[c]()) : E.push(c, 1, f || t[c])), l.push(c);
        }
      }
    T && Qd(this);
  },
  render: function(t, e) {
    if (e.tween._time || !wh())
      for (var r = e._pt; r; )
        r.r(t, r.d), r = r._next;
    else
      e.styles.revert();
  },
  get: De,
  aliases: Ee,
  getSetter: function(t, e, r) {
    var n = Ee[e];
    return n && n.indexOf(",") < 0 && (e = n), e in Ve && e !== zt && (t._gsap.x || De(t, "x")) ? r && zl === r ? e === "scale" ? Jy : Qy : (zl = r || {}) && (e === "scale" ? tx : ex) : t.style && !hh(t.style[e]) ? qy : ~e.indexOf("-") ? Zy : xh(t, e);
  },
  core: {
    _removeProperty: Ri,
    _getMatrix: Th
  }
};
Nt.utils.checkPrefix = or;
Nt.core.getStyleSaver = sf;
(function(s, t, e, r) {
  var n = Lt(s + "," + t + "," + e, function(a) {
    Ve[a] = 1;
  });
  Lt(t, function(a) {
    Kt.units[a] = "deg", hf[a] = 1;
  }), Ee[n[13]] = s + "," + t, Lt(r, function(a) {
    var l = a.split(":");
    Ee[l[1]] = n[l[0]];
  });
})("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");
Lt("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function(s) {
  Kt.units[s] = "px";
});
Nt.registerPlugin(uf);
var _r = Nt.registerPlugin(uf) || Nt;
_r.core.Tween;
const dx = `#version 300 es
  layout (location = 0) in vec4 a_position;
  layout (location = 1) in vec2 a_texCoord;
  out vec2 v_texCoord;
  void main () {
    gl_Position = a_position;
    v_texCoord = a_texCoord;
  }
`, fx = `#version 300 es
precision mediump float;
out vec4 FragColor;
in vec2 v_texCoord;

uniform sampler2D frameTexture;
uniform vec3 keyColor;

// 色度的相似度计算
uniform float similarity;
// 透明度的平滑度计算
uniform float smoothness;
// 降低绿幕饱和度，提高抠图准确度
uniform float spill;

vec2 RGBtoUV(vec3 rgb) {
  return vec2(
    rgb.r * -0.169 + rgb.g * -0.331 + rgb.b *  0.5    + 0.5,
    rgb.r *  0.5   + rgb.g * -0.419 + rgb.b * -0.081  + 0.5
  );
}

void main() {
  // 获取当前像素的rgba值
  vec4 rgba = texture(frameTexture, v_texCoord);
  // 计算当前像素与绿幕像素的色度差值
  vec2 chromaVec = RGBtoUV(rgba.rgb) - RGBtoUV(keyColor);
  // 计算当前像素与绿幕像素的色度距离（向量长度）, 越相像则色度距离越小
  float chromaDist = sqrt(dot(chromaVec, chromaVec));
  // 设置了一个相似度阈值，baseMask为负，则表明是绿幕，为正则表明不是绿幕
  float baseMask = chromaDist - similarity;
  // 如果baseMask为负数，fullMask等于0；baseMask为正数，越大，则透明度越低
  float fullMask = pow(clamp(baseMask / smoothness, 0., 1.), 1.5);
  rgba.a = fullMask; // 设置透明度
  // 如果baseMask为负数，spillVal等于0；baseMask为整数，越小，饱和度越低
  float spillVal = pow(clamp(baseMask / spill, 0., 1.), 1.5);
  float desat = clamp(rgba.r * 0.2126 + rgba.g * 0.7152 + rgba.b * 0.0722, 0., 1.); // 计算当前像素的灰度值
  rgba.rgb = mix(vec3(desat, desat, desat), rgba.rgb, spillVal);
  FragColor = rgba;
}
`, px = [-1, 1, -1, -1, 1, -1, 1, -1, 1, 1, -1, 1], _x = [0, 1, 0, 0, 1, 0, 1, 0, 1, 1, 0, 1];
function mx(s, t, e) {
  const r = Kl(s, s.VERTEX_SHADER, t), n = Kl(s, s.FRAGMENT_SHADER, e), a = s.createProgram();
  if (s.attachShader(a, r), s.attachShader(a, n), s.linkProgram(a), !s.getProgramParameter(a, s.LINK_STATUS))
    throw Error(
      s.getProgramInfoLog(a) ?? "Unable to initialize the shader program"
    );
  return a;
}
function Kl(s, t, e) {
  const r = s.createShader(t);
  if (s.shaderSource(r, e), s.compileShader(r), !s.getShaderParameter(r, s.COMPILE_STATUS)) {
    const n = s.getShaderInfoLog(r);
    throw s.deleteShader(r), Error(n ?? "An error occurred compiling the shaders");
  }
  return r;
}
function gx(s, t, e) {
  s.bindTexture(s.TEXTURE_2D, e), s.texImage2D(s.TEXTURE_2D, 0, s.RGBA, s.RGBA, s.UNSIGNED_BYTE, t), s.drawArrays(s.TRIANGLES, 0, 6);
}
function yx(s) {
  const t = s.createTexture();
  if (t == null) throw Error("Create WebGL texture error");
  s.bindTexture(s.TEXTURE_2D, t);
  const e = 0, r = s.RGBA, n = 1, a = 1, l = 0, h = s.RGBA, u = s.UNSIGNED_BYTE, f = new Uint8Array([0, 0, 255, 255]);
  return s.texImage2D(
    s.TEXTURE_2D,
    e,
    r,
    n,
    a,
    l,
    h,
    u,
    f
  ), s.texParameteri(s.TEXTURE_2D, s.TEXTURE_MAG_FILTER, s.LINEAR), s.texParameteri(s.TEXTURE_2D, s.TEXTURE_MIN_FILTER, s.LINEAR), s.texParameteri(s.TEXTURE_2D, s.TEXTURE_WRAP_S, s.CLAMP_TO_EDGE), s.texParameteri(s.TEXTURE_2D, s.TEXTURE_WRAP_T, s.CLAMP_TO_EDGE), t;
}
function xx(s) {
  const t = "document" in globalThis ? globalThis.document.createElement("canvas") : new OffscreenCanvas(s.width, s.height);
  t.width = s.width, t.height = s.height;
  const e = t.getContext("webgl2", {
    premultipliedAlpha: !1,
    alpha: !0
  });
  if (e == null) throw Error("Cant create gl context");
  const r = mx(e, dx, fx);
  e.useProgram(r), e.uniform3fv(
    e.getUniformLocation(r, "keyColor"),
    s.keyColor.map((u) => u / 255)
  ), e.uniform1f(
    e.getUniformLocation(r, "similarity"),
    s.similarity
  ), e.uniform1f(
    e.getUniformLocation(r, "smoothness"),
    s.smoothness
  ), e.uniform1f(e.getUniformLocation(r, "spill"), s.spill);
  const n = e.createBuffer();
  e.bindBuffer(e.ARRAY_BUFFER, n), e.bufferData(e.ARRAY_BUFFER, new Float32Array(px), e.STATIC_DRAW);
  const a = e.getAttribLocation(r, "a_position");
  e.vertexAttribPointer(
    a,
    2,
    e.FLOAT,
    !1,
    Float32Array.BYTES_PER_ELEMENT * 2,
    0
  ), e.enableVertexAttribArray(a);
  const l = e.createBuffer();
  e.bindBuffer(e.ARRAY_BUFFER, l), e.bufferData(
    e.ARRAY_BUFFER,
    new Float32Array(_x),
    e.STATIC_DRAW
  );
  const h = e.getAttribLocation(r, "a_texCoord");
  return e.vertexAttribPointer(
    h,
    2,
    e.FLOAT,
    !1,
    Float32Array.BYTES_PER_ELEMENT * 2,
    0
  ), e.enableVertexAttribArray(h), e.pixelStorei(e.UNPACK_FLIP_Y_WEBGL, 1), { cvs: t, gl: e };
}
function bx(s) {
  return s instanceof VideoFrame ? { width: s.codedWidth, height: s.codedHeight } : { width: s.width, height: s.height };
}
function vx(s) {
  const t = new OffscreenCanvas(1, 1).getContext("2d");
  t.drawImage(s, 0, 0);
  const {
    data: [e, r, n]
  } = t.getImageData(0, 0, 1, 1);
  return [e, r, n];
}
const wx = (s) => {
  let t = null, e = null, r = s.keyColor, n = null;
  return async (a) => {
    if ((t == null || e == null || n == null) && (r == null && (r = vx(a)), { cvs: t, gl: e } = xx({
      ...bx(a),
      keyColor: r,
      ...s
    }), n = yx(e)), gx(e, a, n), globalThis.VideoFrame != null && a instanceof globalThis.VideoFrame) {
      const l = new VideoFrame(t, {
        alpha: "keep",
        timestamp: a.timestamp,
        duration: a.duration ?? void 0
      });
      return a.close(), l;
    }
    return createImageBitmap(t, {
      imageOrientation: a instanceof ImageBitmap ? "flipY" : "none"
    });
  };
};
function Sx(s) {
  return document.createElement(s);
}
function Tx(s) {
  var t = "", e = new Uint8Array(s), r = e.byteLength;
  for (let n = 0; n < r; n++)
    t += String.fromCharCode(e[n]);
  return window.btoa(t);
}
async function Cx(s, t, e = {}) {
  const r = Sx("pre");
  r.style.cssText = `margin: 0; ${t}; position: fixed;`, r.textContent = s, document.body.appendChild(r), e.onCreated?.(r);
  const { width: n, height: a } = r.getBoundingClientRect();
  r.remove();
  const l = new Image();
  l.width = n, l.height = a;
  const h = e.font == null ? "" : `
    @font-face {
      font-family: '${e.font.name}';
      src: url('data:font/woff2;base64,${Tx(await (await fetch(e.font.url)).arrayBuffer())}') format('woff2');
    }
  `, u = `
    <svg xmlns="http://www.w3.org/2000/svg" width="${n}" height="${a}">
      <style>
        ${h}
      </style>
      <foreignObject width="100%" height="100%">
        <div xmlns="http://www.w3.org/1999/xhtml">${r.outerHTML}</div>
      </foreignObject>
    </svg>
  `.replace(/\t/g, "").replace(/#/g, "%23");
  return l.src = `data:image/svg+xml;charset=utf-8,${u}`, await new Promise((f) => {
    l.onload = f;
  }), l;
}
async function Ex(s, t, e = {}) {
  const r = await Cx(s, t, e), n = new OffscreenCanvas(r.width, r.height);
  return n.getContext("2d")?.drawImage(r, 0, 0, r.width, r.height), await createImageBitmap(n);
}
function Ax(s) {
  const t = new Float32Array(
    s.map((r) => r.length).reduce((r, n) => r + n)
  );
  let e = 0;
  for (const r of s)
    t.set(r, e), e += r.length;
  return t;
}
function df(s) {
  const t = [];
  for (let e = 0; e < s.length; e += 1)
    for (let r = 0; r < s[e].length; r += 1)
      t[r] == null && (t[r] = []), t[r].push(s[e][r]);
  return t.map(Ax);
}
function ff(s) {
  if (s.format === "f32-planar") {
    const t = [];
    for (let e = 0; e < s.numberOfChannels; e += 1) {
      const r = s.allocationSize({ planeIndex: e }), n = new ArrayBuffer(r);
      s.copyTo(n, { planeIndex: e }), t.push(new Float32Array(n));
    }
    return t;
  } else if (s.format === "f32") {
    const t = new ArrayBuffer(s.allocationSize({ planeIndex: 0 }));
    return s.copyTo(t, { planeIndex: 0 }), Mx(new Float32Array(t), s.numberOfChannels);
  } else if (s.format === "s16") {
    const t = new ArrayBuffer(s.allocationSize({ planeIndex: 0 }));
    return s.copyTo(t, { planeIndex: 0 }), Px(new Int16Array(t), s.numberOfChannels);
  }
  throw Error("Unsupported audio data format");
}
function Px(s, t) {
  const e = s.length / t, r = Array.from(
    { length: t },
    () => new Float32Array(e)
  );
  for (let n = 0; n < e; n++)
    for (let a = 0; a < t; a++) {
      const l = s[n * t + a];
      r[a][n] = l / 32768;
    }
  return r;
}
function Mx(s, t) {
  const e = s.length / t, r = Array.from(
    { length: t },
    () => new Float32Array(e)
  );
  for (let n = 0; n < e; n++)
    for (let a = 0; a < t; a++)
      r[a][n] = s[n * t + a];
  return r;
}
function Ch(s) {
  return Array(s.numberOfChannels).fill(0).map((t, e) => s.getChannelData(e));
}
async function Bx(s, t) {
  const e = {
    type: t,
    data: s
  }, r = new ImageDecoder(e);
  await Promise.all([r.completed, r.tracks.ready]);
  let n = r.tracks.selectedTrack?.frameCount ?? 1;
  const a = [];
  for (let l = 0; l < n; l += 1)
    a.push((await r.decode({ frameIndex: l })).image);
  return a;
}
function ql(s) {
  const t = Math.max(...s.map((r) => r[0]?.length ?? 0)), e = new Float32Array(t * 2);
  for (let r = 0; r < t; r++) {
    let n = 0, a = 0;
    for (let l = 0; l < s.length; l++) {
      const h = s[l][0]?.[r] ?? 0, u = s[l][1]?.[r] ?? h;
      n += h, a += u;
    }
    e[r] = n, e[r + t] = a;
  }
  return e;
}
async function Ux(s, t, e) {
  const r = s.length, n = Array(e.chanCount).fill(0).map(() => new Float32Array(0));
  if (r === 0) return n;
  const a = Math.max(...s.map((f) => f.length));
  if (a === 0) return n;
  if (globalThis.OfflineAudioContext == null)
    return s.map(
      (f) => new Float32Array(
        Kg(f, t, e.rate, {
          method: "sinc",
          LPF: !1
        })
      )
    );
  const l = new globalThis.OfflineAudioContext(
    e.chanCount,
    a * e.rate / t,
    e.rate
  ), h = l.createBufferSource(), u = l.createBuffer(r, a, t);
  return s.forEach((f, p) => u.copyToChannel(f, p)), h.buffer = u, h.connect(l.destination), h.start(), Ch(await l.startRendering());
}
function Eh(s) {
  return new Promise((t) => {
    const e = sh(() => {
      e(), t();
    }, s);
  });
}
function bo(s, t, e) {
  const r = e - t, n = new Float32Array(r);
  let a = 0;
  for (; a < r; )
    n[a] = s[(t + a) % s.length], a += 1;
  return n;
}
function pf(s, t) {
  const e = Math.floor(s.length / t), r = new Float32Array(e);
  for (let n = 0; n < e; n++) {
    const a = n * t, l = Math.floor(a), h = a - l;
    l + 1 < s.length ? r[n] = s[l] * (1 - h) + s[l + 1] * h : r[n] = s[l];
  }
  return r;
}
const tt = {
  sampleRate: 48e3,
  channelCount: 2,
  codec: "mp4a.40.2"
};
function Ah(s, t) {
  const e = t.videoTracks[0], r = {};
  if (e != null) {
    const a = Rx(s.getTrackById(e.id))?.buffer, { descKey: l, type: h } = e.codec.startsWith("avc1") ? { descKey: "avcDecoderConfigRecord", type: "avc1" } : e.codec.startsWith("hvc1") ? { descKey: "hevcDecoderConfigRecord", type: "hvc1" } : { descKey: "", type: "" };
    l !== "" && (r.videoTrackConf = {
      timescale: e.timescale,
      duration: e.duration,
      width: e.video.width,
      height: e.video.height,
      brands: t.brands,
      type: h,
      [l]: a
    }), r.videoDecoderConf = {
      codec: e.codec,
      codedHeight: e.video.height,
      codedWidth: e.video.width,
      description: a
    };
  }
  const n = t.audioTracks[0];
  if (n != null) {
    const a = Ix(s), l = a == null ? {} : kx(a);
    r.audioTrackConf = {
      timescale: n.timescale,
      samplerate: l.sampleRate ?? n.audio.sample_rate,
      channel_count: l.numberOfChannels ?? n.audio.channel_count,
      hdlr: "soun",
      type: n.codec.startsWith("mp4a") ? "mp4a" : n.codec,
      description: a
    }, r.audioDecoderConf = {
      codec: l.codec ?? tt.codec,
      numberOfChannels: l.numberOfChannels ?? n.audio.channel_count,
      sampleRate: l.sampleRate ?? n.audio.sample_rate
    };
  }
  return r;
}
function Rx(s) {
  for (const t of s.mdia.minf.stbl.stsd.entries) {
    const e = t.avcC ?? t.hvcC ?? t.av1C ?? t.vpcC;
    if (e != null) {
      const r = new Dt.DataStream(
        void 0,
        0,
        Dt.DataStream.BIG_ENDIAN
      );
      return e.write(r), new Uint8Array(r.buffer.slice(8));
    }
  }
}
function Ix(s, t = "mp4a") {
  return s.moov?.traks.map((e) => e.mdia.minf.stbl.stsd.entries).flat().find(({ type: e }) => e === t)?.esds;
}
function kx(s) {
  let t = "mp4a";
  const e = s.esd.descs[0];
  if (e == null) return {};
  t += "." + e.oti.toString(16);
  const r = e.descs[0];
  if (r == null)
    return t.endsWith("40") && (t += ".2"), { codec: t };
  const n = (r.data[0] & 248) >> 3;
  t += "." + n;
  const [a, l] = r.data, h = ((a & 7) << 1) + (l >> 7), u = (l & 127) >> 3;
  return {
    codec: t,
    sampleRate: [
      96e3,
      88200,
      64e3,
      48e3,
      44100,
      32e3,
      24e3,
      22050,
      16e3,
      12e3,
      11025,
      8e3,
      7350
    ][h],
    numberOfChannels: u
  };
}
async function Fx(s, t, e) {
  const r = Dt.createFile(!1);
  r.onReady = (a) => {
    t({ mp4boxFile: r, info: a });
    const l = a.videoTracks[0]?.id;
    l != null && r.setExtractionOptions(l, "video", { nbSamples: 100 });
    const h = a.audioTracks[0]?.id;
    h != null && r.setExtractionOptions(h, "audio", { nbSamples: 100 }), r.start();
  }, r.onSamples = e, await n();
  async function n() {
    let a = 0;
    const l = 30 * 1024 * 1024;
    for (; ; ) {
      const h = await s.read(l, {
        at: a
      });
      if (h.byteLength === 0) break;
      h.fileStart = a;
      const u = r.appendBuffer(h);
      if (u == null) break;
      a = u;
    }
    r.stop();
  }
}
function Dx(s) {
  if (s?.length !== 9) return {};
  const t = new Int32Array(s.buffer), e = t[0] / 65536, r = t[1] / 65536, n = t[3] / 65536, a = t[4] / 65536, l = t[6] / 65536, h = t[7] / 65536, u = t[8] / (1 << 30), f = Math.sqrt(e * e + n * n), p = Math.sqrt(r * r + a * a), m = Math.atan2(n, e), g = m * 180 / Math.PI;
  return {
    scaleX: f,
    scaleY: p,
    rotationRad: m,
    rotationDeg: g,
    translateX: l,
    translateY: h,
    perspective: u
  };
}
function Ox(s, t, e) {
  const r = (Math.round(e / 90) * 90 + 360) % 360;
  if (r === 0) return (u) => u;
  const n = r === 90 || r === 270 ? t : s, a = r === 90 || r === 270 ? s : t, l = new OffscreenCanvas(n, a), h = l.getContext("2d");
  return h.translate(n / 2, a / 2), h.rotate(-r * Math.PI / 180), h.translate(-s / 2, -t / 2), (u) => {
    if (u == null) return null;
    h.drawImage(u, 0, 0);
    const f = new VideoFrame(l, {
      timestamp: u.timestamp,
      duration: u.duration ?? void 0
    });
    return u.close(), f;
  };
}
let Ph = 0;
function sa(s) {
  return s.kind === "file" && s.createReader instanceof Function;
}
let _f = class Hi {
  #t = Ph++;
  #i = z.create(`MP4Clip id:${this.#t},`);
  ready;
  #e = !1;
  #s = {
    // 微秒
    duration: 0,
    width: 0,
    height: 0,
    audioSampleRate: 0,
    audioChanCount: 0
  };
  get meta() {
    return { ...this.#s };
  }
  #r;
  /** 存储视频头（box: ftyp, moov）的二进制数据 */
  #n = [];
  /**
   * 提供视频头（box: ftyp, moov）的二进制数据
   * 使用任意 mp4 demxer 解析即可获得详细的视频信息
   * 单元测试包含使用 mp4box.js 解析示例代码
   */
  async getFileHeaderBinData() {
    await this.ready;
    const t = await this.#r.getOriginFile();
    if (t == null) throw Error("MP4Clip localFile is not origin file");
    return await new Blob(
      this.#n.map(
        ({ start: e, size: r }) => t.slice(e, e + r)
      )
    ).arrayBuffer();
  }
  /**存储视频平移旋转信息，目前只还原旋转 */
  #a = {
    perspective: 1,
    rotationRad: 0,
    rotationDeg: 0,
    scaleX: 1,
    scaleY: 1,
    translateX: 0,
    translateY: 0
  };
  #o = (t) => t;
  #c = 1;
  #h = [];
  #d = [];
  #p = null;
  #l = null;
  #f = {
    video: null,
    audio: null
  };
  #u = { audio: !0 };
  constructor(t, e = {}) {
    if (!(t instanceof ReadableStream) && !sa(t) && !Array.isArray(t.videoSamples))
      throw Error("Illegal argument");
    this.#u = { audio: !0, ...e }, this.#c = typeof e.audio == "object" && "volume" in e.audio ? e.audio.volume : 1;
    const r = async (n) => (await Qr(this.#r, n), this.#r);
    this.#r = sa(t) ? t : "localFile" in t ? t.localFile : ro(), this.ready = (t instanceof ReadableStream ? r(t).then(
      (n) => Zl(n, this.#u)
    ) : sa(t) ? Zl(t, this.#u) : Promise.resolve(t)).then(
      async ({
        videoSamples: n,
        audioSamples: a,
        decoderConf: l,
        headerBoxPos: h,
        parsedMatrix: u
      }) => {
        this.#h = n, this.#d = a, this.#f = l, this.#n = h, this.#a = u;
        const { videoFrameFinder: f, audioFrameFinder: p } = Gx(
          {
            video: l.video == null ? null : {
              ...l.video,
              hardwareAcceleration: this.#u.__unsafe_hardwareAcceleration__
            },
            audio: l.audio
          },
          await this.#r.createReader(),
          n,
          a,
          this.#u.audio !== !1 ? this.#c : 0
        );
        this.#p = f, this.#l = p;
        const { codedWidth: m, codedHeight: g } = l.video ?? {};
        return m && g && (this.#o = Ox(
          m,
          g,
          u.rotationDeg
        )), this.#s = Lx(
          l,
          n,
          a,
          u.rotationDeg
        ), this.#i.info("MP4Clip meta:", this.#s), { ...this.#s };
      }
    );
  }
  /**
   * 拦截 {@link MP4Clip.tick} 方法返回的数据，用于对图像、音频数据二次处理
   * @param time 调用 tick 的时间
   * @param tickRet tick 返回的数据
   *
   * @see [移除视频绿幕背景](https://webav-tech.github.io/WebAV/demo/3_2-chromakey-video)
   */
  tickInterceptor = async (t, e) => e;
  /**
   * 获取素材指定时刻的图像帧、音频数据
   * @param time 微秒
   */
  async tick(t) {
    if (t >= this.#s.duration)
      return await this.tickInterceptor(t, {
        audio: await this.#l?.find(t) ?? [],
        state: "done"
      });
    const [e, r] = await Promise.all([
      this.#l?.find(t) ?? [],
      this.#p?.find(t).then(this.#o)
    ]);
    return r == null ? await this.tickInterceptor(t, {
      audio: e,
      state: "success"
    }) : await this.tickInterceptor(t, {
      video: r,
      audio: e,
      state: "success"
    });
  }
  #m = new AbortController();
  /**
   * 生成缩略图，默认每个关键帧生成一个 100px 宽度的缩略图。
   *
   * @param imgWidth 缩略图宽度，默认 100
   * @param opts Partial<ThumbnailOpts>
   * @returns Promise<Array<{ ts: number; img: Blob }>>
   */
  async thumbnails(t = 100, e) {
    this.#m.abort(), this.#m = new AbortController();
    const r = this.#m.signal;
    await this.ready;
    const n = "generate thumbnails aborted";
    if (r.aborted) throw Error(n);
    const { width: a, height: l } = this.#s, h = Vx(
      t,
      Math.round(l * (t / a)),
      { quality: 0.1, type: "image/png" }
    );
    return new Promise(
      async (u, f) => {
        let p = [];
        const m = this.#f.video;
        if (m == null || this.#h.length === 0) {
          g();
          return;
        }
        r.addEventListener("abort", () => {
          f(Error(n));
        });
        async function g() {
          r.aborted || u(
            await Promise.all(
              p.map(async (_) => ({
                ts: _.ts,
                img: await _.img
              }))
            )
          );
        }
        function x(_) {
          p.push({
            ts: _.timestamp,
            img: h(_)
          });
        }
        const { start: o = 0, end: c = this.#s.duration, step: d } = e ?? {};
        if (d) {
          let _ = o;
          const y = new mf(
            await this.#r.createReader(),
            this.#h,
            {
              ...m,
              hardwareAcceleration: this.#u.__unsafe_hardwareAcceleration__
            }
          );
          for (; _ <= c && !r.aborted; ) {
            const v = await y.find(_);
            v && x(v), _ += d;
          }
          y.destroy(), g();
        } else
          await jx(
            this.#h,
            this.#r,
            m,
            r,
            { start: o, end: c },
            (_, y) => {
              _ != null && x(_), y && g();
            }
          );
      }
    );
  }
  async split(t) {
    if (await this.ready, t <= 0 || t >= this.#s.duration)
      throw Error('"time" out of bounds');
    const [e, r] = $x(
      this.#h,
      t
    ), [n, a] = Yx(
      this.#d,
      t
    ), l = new Hi(
      {
        localFile: this.#r,
        videoSamples: e ?? [],
        audioSamples: n ?? [],
        decoderConf: this.#f,
        headerBoxPos: this.#n,
        parsedMatrix: this.#a
      },
      this.#u
    ), h = new Hi(
      {
        localFile: this.#r,
        videoSamples: r ?? [],
        audioSamples: a ?? [],
        decoderConf: this.#f,
        headerBoxPos: this.#n,
        parsedMatrix: this.#a
      },
      this.#u
    );
    return await Promise.all([l.ready, h.ready]), [l, h];
  }
  async clone() {
    await this.ready;
    const t = new Hi(
      {
        localFile: this.#r,
        videoSamples: [...this.#h],
        audioSamples: [...this.#d],
        decoderConf: this.#f,
        headerBoxPos: this.#n,
        parsedMatrix: this.#a
      },
      this.#u
    );
    return await t.ready, t.tickInterceptor = this.tickInterceptor, t;
  }
  /**
   * 拆分 MP4Clip 为仅包含视频轨道和音频轨道的 MP4Clip
   * @returns Mp4CLip[]
   */
  async splitTrack() {
    await this.ready;
    const t = [];
    if (this.#h.length > 0) {
      const e = new Hi(
        {
          localFile: this.#r,
          videoSamples: [...this.#h],
          audioSamples: [],
          decoderConf: {
            video: this.#f.video,
            audio: null
          },
          headerBoxPos: this.#n,
          parsedMatrix: this.#a
        },
        this.#u
      );
      await e.ready, e.tickInterceptor = this.tickInterceptor, t.push(e);
    }
    if (this.#d.length > 0) {
      const e = new Hi(
        {
          localFile: this.#r,
          videoSamples: [],
          audioSamples: [...this.#d],
          decoderConf: {
            audio: this.#f.audio,
            video: null
          },
          headerBoxPos: this.#n,
          parsedMatrix: this.#a
        },
        this.#u
      );
      await e.ready, e.tickInterceptor = this.tickInterceptor, t.push(e);
    }
    return t;
  }
  destroy() {
    this.#e || (this.#i.info("MP4Clip destroy"), this.#e = !0, this.#p?.destroy(), this.#l?.destroy());
  }
};
function Lx(s, t, e, r) {
  const n = {
    duration: 0,
    width: 0,
    height: 0,
    audioSampleRate: 0,
    audioChanCount: 0
  };
  if (s.video != null && t.length > 0) {
    n.width = s.video.codedWidth ?? 0, n.height = s.video.codedHeight ?? 0;
    const h = (Math.round(r / 90) * 90 + 360) % 360;
    (h === 90 || h === 270) && ([n.width, n.height] = [n.height, n.width]);
  }
  s.audio != null && e.length > 0 && (n.audioSampleRate = tt.sampleRate, n.audioChanCount = tt.channelCount);
  let a = 0, l = 0;
  if (t.length > 0)
    for (let h = t.length - 1; h >= 0; h--) {
      const u = t[h];
      if (!u.deleted) {
        a = u.cts + u.duration;
        break;
      }
    }
  if (e.length > 0) {
    const h = e.at(-1);
    l = h.cts + h.duration;
  }
  return n.duration = Math.max(a, l), n;
}
function Gx(s, t, e, r, n) {
  return {
    audioFrameFinder: n === 0 || s.audio == null || r.length === 0 ? null : new Nx(
      t,
      r,
      s.audio,
      {
        volume: n,
        targetSampleRate: tt.sampleRate
      }
    ),
    videoFrameFinder: s.video == null || e.length === 0 ? null : new mf(
      t,
      e,
      s.video
    )
  };
}
async function Zl(s, t = {}) {
  let e = null;
  const r = { video: null, audio: null };
  let n = [], a = [], l = [];
  const h = {
    perspective: 1,
    rotationRad: 0,
    rotationDeg: 0,
    scaleX: 1,
    scaleY: 1,
    translateX: 0,
    translateY: 0
  };
  let u = -1, f = -1;
  const p = await s.createReader();
  await Fx(
    p,
    async (g) => {
      e = g.info;
      const x = g.mp4boxFile.ftyp;
      l.push({ start: x.start, size: x.size });
      const o = g.mp4boxFile.moov;
      l.push({ start: o.start, size: o.size }), Object.assign(h, Dx(e.videoTracks[0]?.matrix));
      let { videoDecoderConf: c, audioDecoderConf: d } = Ah(
        g.mp4boxFile,
        g.info
      );
      if (r.video = c ?? null, r.audio = d ?? null, c == null && d == null && z.error("MP4Clip no video and audio track"), d != null) {
        const { supported: _ } = await AudioDecoder.isConfigSupported(d);
        _ || z.error(`MP4Clip audio codec is not supported: ${d.codec}`);
      }
      if (c != null) {
        const { supported: _ } = await VideoDecoder.isConfigSupported(c);
        _ || z.error(`MP4Clip video codec is not supported: ${c.codec}`);
      }
      z.info(
        "mp4BoxFile moov ready",
        {
          ...g.info,
          tracks: null,
          videoTracks: null,
          audioTracks: null
        },
        r
      );
    },
    (g, x, o) => {
      if (x === "video") {
        u === -1 && (u = o[0].dts);
        for (const c of o)
          n.push(Ql(c, u, "video"));
      } else if (x === "audio" && t.audio) {
        f === -1 && (f = o[0].dts);
        for (const c of o)
          a.push(Ql(c, f, "audio"));
      }
    }
  ), await p.close();
  const m = n.at(-1) ?? a.at(-1);
  if (e == null)
    throw Error("MP4Clip stream is done, but not emit ready");
  if (m == null)
    throw Error("MP4Clip stream not contain any sample");
  return wo(n), z.info("mp4 stream parsed"), {
    videoSamples: n,
    audioSamples: a,
    decoderConf: r,
    headerBoxPos: l,
    parsedMatrix: h
  };
}
function Ql(s, t = 0, e) {
  let r = s.offset;
  const n = e === "video" && s.is_sync ? Xx(s.data, s.description.type) : -1;
  let a = s.size;
  return n > 0 && (r += n, a -= n), {
    ...s,
    is_idr: n >= 0,
    offset: r,
    size: a,
    cts: (s.cts - t) / s.timescale * 1e6,
    dts: (s.dts - t) / s.timescale * 1e6,
    duration: s.duration / s.timescale * 1e6,
    timescale: 1e6,
    // 音频数据量可控，直接保存在内存中
    data: e === "video" ? null : s.data
  };
}
let mf = class {
  constructor(t, e, r) {
    this.localFileReader = t, this.samples = e, this.conf = r;
  }
  #t = null;
  #i = 0;
  #e = { abort: !1, st: performance.now() };
  find = async (t) => {
    (this.#t == null || this.#t.state === "closed" || t <= this.#i || t - this.#i > 3e6) && this.#u(t), this.#e.abort = !0, this.#i = t, this.#e = { abort: !1, st: performance.now() };
    const e = await this.#p(t, this.#t, this.#e);
    return this.#h = 0, e;
  };
  // fix VideoFrame duration is null
  #s = 0;
  #r = !1;
  #n = 0;
  #a = [];
  #o = 0;
  #c = 0;
  #h = 0;
  #d = !1;
  #p = async (t, e, r) => {
    if (e == null || e.state === "closed" || r.abort) return null;
    if (this.#a.length > 0) {
      const n = this.#a[0];
      return t < n.timestamp ? null : (this.#a.shift(), t > n.timestamp + (n.duration ?? 0) ? (n.close(), await this.#p(t, e, r)) : (!this.#d && this.#a.length < 10 && this.#f(e).catch((a) => {
        throw this.#d = !0, this.#u(t), a;
      }), n));
    }
    if (this.#l || this.#o < this.#c && e.decodeQueueSize > 0) {
      if (performance.now() - r.st > 6e3)
        throw Error(
          `MP4Clip.tick video timeout, ${JSON.stringify(this.#m())}`
        );
      this.#h += 1, await Eh(15);
    } else {
      if (this.#n >= this.samples.length)
        return null;
      try {
        await this.#f(e);
      } catch (n) {
        throw this.#u(t), n;
      }
    }
    return await this.#p(t, e, r);
  };
  #l = !1;
  #f = async (t) => {
    if (this.#l || t.decodeQueueSize > 600) return;
    let e = this.#n + 1;
    if (e > this.samples.length) return;
    this.#l = !0;
    let r = !1;
    for (; e < this.samples.length; e++) {
      const n = this.samples[e];
      if (!r && !n.deleted && (r = !0), n.is_idr) break;
    }
    if (r) {
      const n = this.samples.slice(this.#n, e);
      if (n[0]?.is_idr !== !0)
        z.warn("First sample not idr frame");
      else {
        const a = performance.now(), l = await gf(n, this.localFileReader), h = performance.now() - a;
        if (h > 1e3) {
          const u = n[0], f = n.at(-1), p = f.offset + f.size - u.offset;
          z.warn(
            `Read video samples time cost: ${Math.round(h)}ms, file chunk size: ${p}`
          );
        }
        if (t.state === "closed") return;
        this.#s = l[0]?.duration ?? 0, vo(t, l, {
          onDecodingError: (u) => {
            if (this.#r)
              throw u;
            this.#o === 0 && (this.#r = !0, z.warn("Downgrade to software decode"), this.#u());
          }
        }), this.#c += l.length;
      }
    }
    this.#n = e, this.#l = !1;
  };
  #u = (t) => {
    if (this.#l = !1, this.#a.forEach((r) => r.close()), this.#a = [], t == null || t === 0)
      this.#n = 0;
    else {
      let r = 0;
      for (let n = 0; n < this.samples.length; n++) {
        const a = this.samples[n];
        if (a.is_idr && (r = n), !(a.cts < t)) {
          this.#n = r;
          break;
        }
      }
    }
    this.#c = 0, this.#o = 0, this.#t?.state !== "closed" && this.#t?.close();
    const e = {
      ...this.conf,
      ...this.#r ? { hardwareAcceleration: "prefer-software" } : {}
    };
    this.#t = new VideoDecoder({
      output: (r) => {
        if (this.#o += 1, r.timestamp === -1) {
          r.close();
          return;
        }
        let n = r;
        r.duration == null && (n = new VideoFrame(r, {
          duration: this.#s
        }), r.close()), this.#a.push(n);
      },
      error: (r) => {
        if (r.message.includes("Codec reclaimed due to inactivity")) {
          this.#t = null, z.warn(r.message);
          return;
        }
        const n = `VideoFinder VideoDecoder err: ${r.message}, config: ${JSON.stringify(e)}, state: ${JSON.stringify(this.#m())}`;
        throw z.error(n), Error(n);
      }
    }), this.#t.configure(e);
  };
  #m = () => ({
    time: this.#i,
    decState: this.#t?.state,
    decQSize: this.#t?.decodeQueueSize,
    decCusorIdx: this.#n,
    sampleLen: this.samples.length,
    inputCnt: this.#c,
    outputCnt: this.#o,
    cacheFrameLen: this.#a.length,
    softDeocde: this.#r,
    clipIdCnt: Ph,
    sleepCnt: this.#h,
    memInfo: yf()
  });
  destroy = () => {
    this.#t?.state !== "closed" && this.#t?.close(), this.#t = null, this.#e.abort = !0, this.#a.forEach((t) => t.close()), this.#a = [], this.localFileReader.close();
  };
};
function zx(s, t) {
  for (let e = 0; e < t.length; e++) {
    const r = t[e];
    if (s >= r.cts && s < r.cts + r.duration)
      return e;
    if (r.cts > s) break;
  }
  return 0;
}
class Nx {
  constructor(t, e, r, n) {
    this.localFileReader = t, this.samples = e, this.conf = r, this.#t = n.volume, this.#i = n.targetSampleRate;
  }
  #t = 1;
  #i;
  #e = null;
  #s = { abort: !1, st: performance.now() };
  find = async (t) => {
    const e = t <= this.#r || t - this.#r > 1e5;
    (this.#e == null || this.#e.state === "closed" || e) && this.#d(), e && (this.#r = t, this.#n = zx(t, this.samples)), this.#s.abort = !0;
    const r = t - this.#r;
    this.#r = t, this.#s = { abort: !1, st: performance.now() };
    const n = await this.#c(
      Math.ceil(r * (this.#i / 1e6)),
      this.#e,
      this.#s
    );
    return this.#o = 0, n;
  };
  #r = 0;
  #n = 0;
  #a = {
    frameCnt: 0,
    data: []
  };
  #o = 0;
  #c = async (t, e = null, r) => {
    if (e == null || r.abort || e.state === "closed" || t === 0)
      return [];
    const n = this.#a.frameCnt - t;
    if (n > 0)
      return n < tt.sampleRate / 10 && this.#h(e), Jl(this.#a, t);
    if (e.decoding) {
      if (performance.now() - r.st > 3e3)
        throw r.abort = !0, Error(
          `MP4Clip.tick audio timeout, ${JSON.stringify(this.#p())}`
        );
      this.#o += 1, await Eh(15);
    } else {
      if (this.#n >= this.samples.length - 1)
        return Jl(this.#a, this.#a.frameCnt);
      this.#h(e);
    }
    return this.#c(t, e, r);
  };
  #h = (t) => {
    if (t.decodeQueueSize > 10) return;
    const e = [];
    let r = this.#n;
    for (; r < this.samples.length; ) {
      const n = this.samples[r];
      if (r += 1, !n.deleted && (e.push(n), e.length >= 10))
        break;
    }
    this.#n = r, t.decode(
      e.map(
        (n) => new EncodedAudioChunk({
          type: "key",
          timestamp: n.cts,
          duration: n.duration,
          data: n.data
        })
      )
    );
  };
  #d = () => {
    this.#r = 0, this.#n = 0, this.#a = {
      frameCnt: 0,
      data: []
    }, this.#e?.close(), this.#e = Hx(
      this.conf,
      {
        resampleRate: tt.sampleRate,
        volume: this.#t
      },
      (t) => {
        this.#a.data.push(t), this.#a.frameCnt += t[0].length;
      }
    );
  };
  #p = () => ({
    time: this.#r,
    decState: this.#e?.state,
    decQSize: this.#e?.decodeQueueSize,
    decCusorIdx: this.#n,
    sampleLen: this.samples.length,
    pcmLen: this.#a.frameCnt,
    clipIdCnt: Ph,
    sleepCnt: this.#o,
    memInfo: yf()
  });
  destroy = () => {
    this.#e = null, this.#s.abort = !0, this.#a = {
      frameCnt: 0,
      data: []
    }, this.localFileReader.close();
  };
}
function Hx(s, t, e) {
  let r = 0, n = 0;
  const a = (p) => {
    if (n += 1, p.length !== 0) {
      if (t.volume !== 1)
        for (const m of p)
          for (let g = 0; g < m.length; g++) m[g] *= t.volume;
      p.length === 1 && (p = [p[0], p[0]]), e(p);
    }
  }, l = Wx(a), h = t.resampleRate !== s.sampleRate;
  let u = new AudioDecoder({
    output: (p) => {
      const m = ff(p);
      h ? l(
        () => Ux(m, p.sampleRate, {
          rate: t.resampleRate,
          chanCount: p.numberOfChannels
        })
      ) : a(m), p.close();
    },
    error: (p) => {
      p.message.includes("Codec reclaimed due to inactivity") || f("MP4Clip AudioDecoder err", p);
    }
  });
  u.configure(s);
  function f(p, m) {
    const g = `${p}: ${m.message}, state: ${JSON.stringify(
      {
        qSize: u.decodeQueueSize,
        state: u.state,
        inputCnt: r,
        outputCnt: n
      }
    )}`;
    throw z.error(g), Error(g);
  }
  return {
    decode(p) {
      r += p.length;
      try {
        for (const m of p) u.decode(m);
      } catch (m) {
        f("decode audio chunk error", m);
      }
    },
    close() {
      u.state !== "closed" && u.close();
    },
    get decoding() {
      return r > n && u.decodeQueueSize > 0;
    },
    get state() {
      return u.state;
    },
    get decodeQueueSize() {
      return u.decodeQueueSize;
    }
  };
}
function Wx(s) {
  const t = [];
  let e = 0;
  function r(l, h) {
    t[h] = l, n();
  }
  function n() {
    const l = t[e];
    l != null && (s(l), e += 1, n());
  }
  let a = 0;
  return (l) => {
    const h = a;
    a += 1, l().then((u) => r(u, h)).catch((u) => r(u, h));
  };
}
function Jl(s, t) {
  const e = [new Float32Array(t), new Float32Array(t)];
  let r = 0, n = 0;
  for (; n < s.data.length; ) {
    const [a, l] = s.data[n];
    if (r + a.length > t) {
      const h = t - r;
      e[0].set(a.subarray(0, h), r), e[1].set(l.subarray(0, h), r), s.data[n][0] = a.subarray(h, a.length), s.data[n][1] = l.subarray(h, l.length);
      break;
    } else
      e[0].set(a, r), e[1].set(l, r), r += a.length, n++;
  }
  return s.data = s.data.slice(n), s.frameCnt -= t, e;
}
async function gf(s, t) {
  const e = s[0], r = s.at(-1);
  if (r == null) return [];
  const n = r.offset + r.size - e.offset;
  if (n < 3e7) {
    const a = new Uint8Array(
      await t.read(n, { at: e.offset })
    );
    return s.map((l) => {
      const h = l.offset - e.offset;
      return new EncodedVideoChunk({
        type: l.is_sync ? "key" : "delta",
        timestamp: l.cts,
        duration: l.duration,
        data: a.subarray(h, h + l.size)
      });
    });
  }
  return await Promise.all(
    s.map(async (a) => new EncodedVideoChunk({
      type: a.is_sync ? "key" : "delta",
      timestamp: a.cts,
      duration: a.duration,
      data: await t.read(a.size, {
        at: a.offset
      })
    }))
  );
}
function Vx(s, t, e) {
  const r = new OffscreenCanvas(s, t), n = r.getContext("2d");
  return async (a) => (n.drawImage(a, 0, 0, s, t), a.close(), await r.convertToBlob(e));
}
function $x(s, t) {
  if (s.length === 0) return [];
  let e = 0, r = 0, n = -1;
  for (let u = 0; u < s.length; u++) {
    const f = s[u];
    if (n === -1 && t < f.cts && (n = u - 1), f.is_idr)
      if (n === -1)
        e = u;
      else {
        r = u;
        break;
      }
  }
  const a = s[n];
  if (a == null) throw Error("Not found video sample by time");
  const l = s.slice(0, r === 0 ? s.length : r).map((u) => ({ ...u }));
  for (let u = e; u < l.length; u++) {
    const f = l[u];
    t < f.cts && (f.deleted = !0, f.cts = -1);
  }
  wo(l);
  const h = s.slice(a.is_idr ? n : e).map((u) => ({ ...u, cts: u.cts - t }));
  for (const u of h)
    u.cts < 0 && (u.deleted = !0, u.cts = -1);
  return wo(h), [l, h];
}
function Yx(s, t) {
  if (s.length === 0) return [];
  let e = -1;
  for (let a = 0; a < s.length; a++) {
    const l = s[a];
    if (!(t > l.cts)) {
      e = a;
      break;
    }
  }
  if (e === -1) throw Error("Not found audio sample by time");
  const r = s.slice(0, e).map((a) => ({ ...a })), n = s.slice(e).map((a) => ({ ...a, cts: a.cts - t }));
  return [r, n];
}
function vo(s, t, e) {
  if (s.state === "configured") {
    for (let r = 0; r < t.length; r++) s.decode(t[r]);
    s.flush().catch((r) => {
      if (!(r instanceof Error)) throw r;
      if (r.message.includes("Decoding error") && e.onDecodingError != null) {
        e.onDecodingError(r);
        return;
      }
      if (!r.message.includes("Aborted due to close"))
        throw r;
    });
  }
}
function Xx(s, t) {
  if (t !== "avc1" && t !== "hvc1") return 0;
  const e = new DataView(s.buffer);
  for (let r = 0; r < s.byteLength - 4; ) {
    if (t === "avc1") {
      const n = e.getUint8(r + 4) & 31;
      if (n === 5 || n === 7 || n === 8) return r;
    } else if (t === "hvc1") {
      const n = e.getUint8(r + 4) >> 1 & 63;
      if (n === 19 || n === 20 || n === 32 || n === 33 || n === 34)
        return r;
    }
    r += e.getUint32(r) + 4;
  }
  return -1;
}
async function jx(s, t, e, r, n, a) {
  const l = await t.createReader(), h = await gf(
    s.filter(
      (p) => !p.deleted && p.is_sync && p.cts >= n.start && p.cts <= n.end
    ),
    l
  );
  if (h.length === 0 || r.aborted) {
    a(null, !0);
    return;
  }
  let u = 0;
  vo(f(), h, {
    onDecodingError: (p) => {
      z.warn("thumbnailsByKeyFrame", p), u === 0 ? vo(f(!0), h, {
        onDecodingError: (m) => {
          l.close(), z.error("thumbnailsByKeyFrame retry soft deocde", m);
        }
      }) : (a(null, !0), l.close());
    }
  });
  function f(p = !1) {
    const m = {
      ...e,
      ...p ? { hardwareAcceleration: "prefer-software" } : {}
    }, g = new VideoDecoder({
      output: (x) => {
        u += 1;
        const o = u === h.length;
        a(x, o), o && (l.close(), g.state !== "closed" && g.close());
      },
      error: (x) => {
        const o = `thumbnails decoder error: ${x.message}, config: ${JSON.stringify(m)}, state: ${JSON.stringify(
          {
            qSize: g.decodeQueueSize,
            state: g.state,
            outputCnt: u,
            inputCnt: h.length
          }
        )}`;
        throw z.error(o), Error(o);
      }
    });
    return r.addEventListener("abort", () => {
      l.close(), g.state !== "closed" && g.close();
    }), g.configure(m), g;
  }
}
function wo(s) {
  let t = 0, e = null;
  for (const r of s)
    if (!r.deleted) {
      if (r.is_sync && (t += 1), t >= 2) break;
      (e == null || r.cts < e.cts) && (e = r);
    }
  e != null && e.cts < 2e5 && (e.duration += e.cts, e.cts = 0);
}
function yf() {
  try {
    const s = performance.memory;
    return {
      jsHeapSizeLimit: s.jsHeapSizeLimit,
      totalJSHeapSize: s.totalJSHeapSize,
      usedJSHeapSize: s.usedJSHeapSize,
      percentUsed: (s.usedJSHeapSize / s.jsHeapSizeLimit).toFixed(3),
      percentTotal: (s.totalJSHeapSize / s.jsHeapSizeLimit).toFixed(3)
    };
  } catch {
    return {};
  }
}
let Kx = class Wi {
  ready;
  #t = {
    // 微秒
    duration: 0,
    width: 0,
    height: 0
  };
  /**
   * ⚠️ 静态图片的 duration 为 Infinity
   *
   * 使用 Sprite 包装时需要将它的 duration 设置为有限数
   *
   */
  get meta() {
    return { ...this.#t };
  }
  #i = null;
  #e = [];
  /**
   * 静态图片可使用流、ImageBitmap 初始化
   *
   * 动图需要使用 VideoFrame[] 或提供图片类型
   */
  constructor(t) {
    const e = (r) => (this.#i = r, this.#t.width = r.width, this.#t.height = r.height, this.#t.duration = 1 / 0, { ...this.#t });
    if (t instanceof ReadableStream)
      this.ready = new Response(t).blob().then((r) => createImageBitmap(r)).then(e);
    else if (t instanceof ImageBitmap)
      this.ready = Promise.resolve(e(t));
    else if (Array.isArray(t) && t.every((r) => r instanceof VideoFrame)) {
      this.#e = t;
      const r = this.#e[0];
      if (r == null) throw Error("The frame count must be greater than 0");
      this.#t = {
        width: r.displayWidth,
        height: r.displayHeight,
        duration: this.#e.reduce(
          (n, a) => n + (a.duration ?? 0),
          0
        )
      }, this.ready = Promise.resolve({ ...this.#t, duration: 1 / 0 });
    } else if ("type" in t)
      this.ready = this.#s(
        t.stream,
        t.type
      ).then(() => ({
        width: this.#t.width,
        height: this.#t.height,
        duration: 1 / 0
      }));
    else
      throw Error("Illegal arguments");
  }
  async #s(t, e) {
    this.#e = await Bx(t, e);
    const r = this.#e[0];
    if (r == null) throw Error("No frame available in gif");
    this.#t = {
      duration: this.#e.reduce((n, a) => n + (a.duration ?? 0), 0),
      width: r.codedWidth,
      height: r.codedHeight
    }, z.info("ImgClip ready:", this.#t);
  }
  tickInterceptor = async (t, e) => e;
  async tick(t) {
    if (this.#i != null)
      return await this.tickInterceptor(t, {
        video: await createImageBitmap(this.#i),
        state: "success"
      });
    const e = t % this.#t.duration;
    return await this.tickInterceptor(t, {
      video: (this.#e.find(
        (r) => e >= r.timestamp && e <= r.timestamp + (r.duration ?? 0)
      ) ?? this.#e[0]).clone(),
      state: "success"
    });
  }
  async split(t) {
    if (await this.ready, this.#i != null)
      return [
        new Wi(await createImageBitmap(this.#i)),
        new Wi(await createImageBitmap(this.#i))
      ];
    let e = -1;
    for (let a = 0; a < this.#e.length; a++) {
      const l = this.#e[a];
      if (!(t > l.timestamp)) {
        e = a;
        break;
      }
    }
    if (e === -1) throw Error("Not found frame by time");
    const r = this.#e.slice(0, e).map((a) => new VideoFrame(a)), n = this.#e.slice(e).map(
      (a) => new VideoFrame(a, {
        timestamp: a.timestamp - t
      })
    );
    return [new Wi(r), new Wi(n)];
  }
  async clone() {
    await this.ready;
    const t = this.#i == null ? this.#e.map((r) => r.clone()) : await createImageBitmap(this.#i), e = new Wi(t);
    return e.tickInterceptor = this.tickInterceptor, e;
  }
  destroy() {
    z.info("ImgClip destroy"), this.#i?.close(), this.#e.forEach((t) => t.close());
  }
};
class Oe {
  static ctx = null;
  ready;
  #t = {
    // 微秒
    duration: 0,
    width: 0,
    height: 0
  };
  /**
   * 音频元信息
   *
   * ⚠️ 注意，这里是转换后（标准化）的元信息，非原始音频元信息
   */
  get meta() {
    return {
      ...this.#t,
      sampleRate: tt.sampleRate,
      chanCount: 2
    };
  }
  // 使用类型断言来避免 ArrayBufferLike 和 ArrayBuffer 的类型兼容性问题
  #i = new Float32Array();
  #e = new Float32Array();
  /**
   * 获取音频素材完整的 PCM 数据
   */
  getPCMData() {
    return [this.#i, this.#e];
  }
  #s;
  /**
   *
   * @param dataSource 音频文件流
   * @param opts 音频配置，控制音量、是否循环
   */
  constructor(t, e = {}) {
    this.#s = {
      loop: !1,
      volume: 1,
      ...e
    }, this.ready = this.#r(t).then(() => ({
      // audio 没有宽高，无需绘制
      width: 0,
      height: 0,
      duration: e.loop ? 1 / 0 : this.#t.duration
    }));
  }
  async #r(t) {
    Oe.ctx == null && (Oe.ctx = new AudioContext({
      sampleRate: tt.sampleRate
    }));
    const e = performance.now(), r = t instanceof ReadableStream ? await Zx(t, Oe.ctx) : t;
    z.info("Audio clip decoded complete:", performance.now() - e);
    const n = this.#s.volume;
    if (n !== 1)
      for (const a of r)
        for (let l = 0; l < a.length; l += 1) a[l] *= n;
    this.#t.duration = r[0].length / tt.sampleRate * 1e6, this.#i = r[0], this.#e = r[1] ?? this.#i, z.info(
      "Audio clip convert to AudioData, time:",
      performance.now() - e
    );
  }
  /**
   * 拦截 {@link AudioClip.tick} 方法返回的数据，用于对音频数据二次处理
   * @param time 调用 tick 的时间
   * @param tickRet tick 返回的数据
   *
   * @see [移除视频绿幕背景](https://webav-tech.github.io/WebAV/demo/3_2-chromakey-video)
   */
  tickInterceptor = async (t, e) => e;
  // 微秒
  #n = 0;
  #a = 0;
  /**
   * 返回上次与当前时刻差对应的音频 PCM 数据；
   *
   * 若差值超过 3s 或当前时间小于上次时间，则重置状态
   * @example
   * tick(0) // => []
   * tick(1e6) // => [leftChanPCM(1s), rightChanPCM(1s)]
   *
   */
  async tick(t) {
    if (!this.#s.loop && t >= this.#t.duration)
      return await this.tickInterceptor(t, { audio: [], state: "done" });
    const e = t - this.#n;
    if (t < this.#n || e > 3e6)
      return this.#n = t, this.#a = Math.ceil(
        this.#n / 1e6 * tt.sampleRate
      ), await this.tickInterceptor(t, {
        audio: [new Float32Array(0), new Float32Array(0)],
        state: "success"
      });
    this.#n = t;
    const r = Math.ceil(
      e / 1e6 * tt.sampleRate
    ), n = this.#a + r, a = this.#s.loop ? [
      bo(this.#i, this.#a, n),
      bo(this.#e, this.#a, n)
    ] : [
      this.#i.slice(this.#a, n),
      this.#e.slice(this.#a, n)
    ];
    return this.#a = n, await this.tickInterceptor(t, { audio: a, state: "success" });
  }
  /**
   * 按指定时间切割，返回前后两个音频素材
   * @param time 时间，单位微秒
   */
  async split(t) {
    await this.ready;
    const e = Math.ceil(t / 1e6 * tt.sampleRate), r = new Oe(
      this.getPCMData().map((a) => a.slice(0, e)),
      this.#s
    ), n = new Oe(
      this.getPCMData().map((a) => a.slice(e)),
      this.#s
    );
    return [r, n];
  }
  async clone() {
    await this.ready;
    const t = new Oe(this.getPCMData(), this.#s);
    return await t.ready, t;
  }
  /**
   * 销毁实例，释放资源
   */
  destroy() {
    this.#i = new Float32Array(0), this.#e = new Float32Array(0), z.info("---- audioclip destroy ----");
  }
  static concatAudioClip = qx;
}
async function qx(s, t) {
  const e = [];
  for (const r of s)
    await r.ready, e.push(r.getPCMData());
  return new Oe(df(e), t);
}
async function Zx(s, t) {
  const e = await new Response(s).arrayBuffer();
  return Ch(await t.decodeAudioData(e));
}
let xf = class bf {
  static ctx = null;
  ready;
  #t = {
    // 微秒
    duration: 0,
    width: 0,
    height: 0
  };
  get meta() {
    return {
      ...this.#t
    };
  }
  #i = () => {
  };
  /**
   * 实时流的音轨
   */
  audioTrack;
  #e = null;
  #s;
  constructor(t) {
    this.#s = t, this.audioTrack = t.getAudioTracks()[0] ?? null, this.#t.duration = 1 / 0;
    const e = t.getVideoTracks()[0];
    e != null ? (e.contentHint = "motion", this.ready = new Promise((r) => {
      this.#i = Qx(e, (n) => {
        this.#t.width = n.width, this.#t.height = n.height, this.#e = n, r(this.meta);
      });
    })) : this.ready = Promise.resolve(this.meta);
  }
  async tick() {
    return {
      video: this.#e == null ? null : await createImageBitmap(this.#e),
      audio: [],
      state: "success"
    };
  }
  async split() {
    return [await this.clone(), await this.clone()];
  }
  async clone() {
    return new bf(this.#s.clone());
  }
  destroy() {
    this.#s.getTracks().forEach((t) => t.stop()), this.#i();
  }
};
function Qx(s, t) {
  let e = !1, r;
  return nh(
    new MediaStreamTrackProcessor({
      track: s
    }).readable,
    {
      onChunk: async (n) => {
        if (!e) {
          const { displayHeight: a, displayWidth: l } = n, h = l ?? 0, u = a ?? 0, f = new OffscreenCanvas(h, u);
          r = f.getContext("2d"), t(f), e = !0;
        }
        r.drawImage(n, 0, 0), n.close();
      },
      onDone: async () => {
      }
    }
  );
}
class Wr {
  ready;
  #t = [];
  #i = {
    width: 0,
    height: 0,
    duration: 0
  };
  get meta() {
    return { ...this.#i };
  }
  #e = {
    color: "#FFF",
    textBgColor: null,
    type: "srt",
    fontSize: 30,
    letterSpacing: null,
    bottomOffset: 30,
    fontFamily: "Noto Sans SC",
    strokeStyle: "#000",
    lineWidth: null,
    lineCap: null,
    lineJoin: null,
    textShadow: {
      offsetX: 2,
      offsetY: 2,
      blur: 4,
      color: "#000"
    },
    videoWidth: 1280,
    videoHeight: 720,
    fontWeight: "normal",
    fontStyle: "normal"
  };
  #s;
  #r;
  #n = null;
  #a = 0;
  #o = 0;
  constructor(t, e) {
    if (this.#t = Array.isArray(t) ? t : Jx(t).map(({ start: p, end: m, text: g }) => ({
      start: p * 1e6,
      end: m * 1e6,
      text: g
    })), this.#t.length === 0) throw Error("No subtitles content");
    this.#e = Object.assign(this.#e, e), this.#o = e.textBgColor == null ? 0 : (e.fontSize ?? 50) * 0.2;
    const {
      fontSize: r,
      fontFamily: n,
      fontWeight: a,
      fontStyle: l,
      videoWidth: h,
      videoHeight: u,
      letterSpacing: f
    } = this.#e;
    this.#a = r + this.#o * 2, this.#s = new OffscreenCanvas(h, u), this.#r = this.#s.getContext("2d"), this.#r.font = `${l} ${a} ${r}px ${n}`, this.#r.textAlign = "center", this.#r.textBaseline = "top", this.#r.letterSpacing = f ?? "0px", this.#i = {
      width: h,
      height: u,
      duration: this.#t.at(-1)?.end ?? 0
    }, this.ready = Promise.resolve(this.meta);
  }
  #c(t, e) {
    const r = [];
    let n = "";
    if (/[\u4e00-\u9fff]/.test(t)) {
      for (let a = 0; a < t.length; a++) {
        const l = t[a], h = n + l;
        this.#r.measureText(h).width <= e ? n = h : n ? (r.push(n), n = l) : (r.push(l), n = "");
      }
      n && r.push(n);
    } else {
      const a = t.split(" ");
      for (const l of a) {
        const h = n ? `${n} ${l}` : l;
        this.#r.measureText(h).width <= e ? n = h : n ? (r.push(n), n = l) : r.push(l);
      }
      n && r.push(n);
    }
    return r;
  }
  #h(t) {
    const { width: e, height: r } = this.#s, n = e * 0.9, a = t.split(`
`).flatMap((_) => this.#c(_.trim(), n)).reverse(), {
      color: l,
      fontSize: h,
      textBgColor: u,
      textShadow: f,
      strokeStyle: p,
      lineWidth: m,
      lineCap: g,
      lineJoin: x,
      bottomOffset: o
    } = this.#e, c = this.#r;
    c.clearRect(0, 0, e, r), c.globalAlpha = 0.6;
    let d = o;
    for (const _ of a) {
      const y = c.measureText(_), v = e / 2;
      u != null && (c.shadowOffsetX = 0, c.shadowOffsetY = 0, c.shadowBlur = 0, c.fillStyle = u, c.globalAlpha = 0.5, c.fillRect(
        v - y.actualBoundingBoxLeft - this.#o,
        r - d - this.#a,
        y.width + this.#o * 2,
        this.#a
      )), c.shadowColor = f.color, c.shadowOffsetX = f.offsetX, c.shadowOffsetY = f.offsetY, c.shadowBlur = f.blur, c.globalAlpha = 1, p != null && (c.lineWidth = m ?? h / 6, g != null && (c.lineCap = g), x != null && (c.lineJoin = x), c.strokeStyle = p, c.strokeText(
        _,
        v,
        r - d - this.#a + this.#o
      )), c.fillStyle = l, c.fillText(
        _,
        v,
        r - d - this.#a + this.#o
      ), d += this.#a + h * 0.2;
    }
  }
  /**
   * @see {@link IClip.tick}
   */
  async tick(t) {
    if (this.#n != null && t >= this.#n.timestamp && t <= this.#n.timestamp + (this.#n.duration ?? 0))
      return { video: this.#n.clone(), state: "success" };
    let e = 0;
    for (; e < this.#t.length && !(t <= this.#t[e].end); e += 1)
      ;
    const r = this.#t[e] ?? this.#t.at(-1);
    if (t > r.end) return { state: "done" };
    if (t < r.start) {
      this.#r.clearRect(0, 0, this.#s.width, this.#s.height);
      const a = new VideoFrame(this.#s, {
        timestamp: t,
        // 直到下个字幕出现的时机
        duration: r.start - t
      });
      return this.#n?.close(), this.#n = a, { video: a.clone(), state: "success" };
    }
    this.#h(r.text);
    const n = new VideoFrame(this.#s, {
      timestamp: t,
      duration: r.end - t
    });
    return this.#n?.close(), this.#n = n, { video: n.clone(), state: "success" };
  }
  /**
   * @see {@link IClip.split}
   */
  async split(t) {
    await this.ready;
    let e = -1;
    for (let h = 0; h < this.#t.length; h++) {
      const u = this.#t[h];
      if (!(t > u.start)) {
        e = h;
        break;
      }
    }
    if (e === -1) throw Error("Not found subtitle by time");
    const r = this.#t.slice(0, e).map((h) => ({ ...h }));
    let n = r.at(-1), a = null;
    n != null && n.end > t && (a = {
      start: 0,
      end: n.end - t,
      text: n.text
    }, n.end = t);
    const l = this.#t.slice(e).map((h) => ({ ...h, start: h.start - t, end: h.end - t }));
    return a != null && l.unshift(a), [
      new Wr(r, this.#e),
      new Wr(l, this.#e)
    ];
  }
  /**
   * @see {@link IClip.clone}
   */
  async clone() {
    return new Wr(this.#t.slice(0), this.#e);
  }
  /**
   * @see {@link IClip.destroy}
   */
  destroy() {
    this.#n?.close();
  }
}
function tc(s) {
  const t = s.match(/(\d{2}):(\d{2}):(\d{2}),(\d{3})/);
  if (t == null) throw Error(`time format error: ${s}`);
  const e = Number(t[1]), r = Number(t[2]), n = Number(t[3]), a = Number(t[4]);
  return e * 60 * 60 + r * 60 + n + a / 1e3;
}
function Jx(s) {
  return s.split(/\r|\n/).map((t) => t.trim()).filter((t) => t.length > 0).map((t) => ({
    lineStr: t,
    match: t.match(
      /(\d{2}:\d{2}:\d{2},\d{3}) --> (\d{2}:\d{2}:\d{2},\d{3})/
    )
  })).filter(
    ({ lineStr: t }, e, r) => !(/^\d+$/.test(t) && r[e + 1]?.match != null)
  ).reduce(
    (t, { lineStr: e, match: r }) => {
      if (r == null) {
        const n = t.at(-1);
        if (n == null) return t;
        n.text += n.text.length === 0 ? e : `
${e}`;
      } else
        t.push({
          start: tc(r[1]),
          end: tc(r[2]),
          text: ""
        });
      return t;
    },
    []
  );
}
let vf = class {
  readable;
  writable;
  #t = 0;
  constructor() {
    const t = Dt.createFile();
    let e = !1;
    this.readable = new ReadableStream(
      {
        start: (r) => {
          t.onReady = (a) => {
            const l = a.videoTracks[0]?.id;
            l != null && t.setExtractionOptions(l, "video", { nbSamples: 100 });
            const h = a.audioTracks[0]?.id;
            h != null && t.setExtractionOptions(h, "audio", { nbSamples: 100 }), r.enqueue({ chunkType: "ready", data: { info: a, file: t } }), t.start();
          };
          const n = {};
          t.onSamples = (a, l, h) => {
            r.enqueue({
              chunkType: "samples",
              data: { id: a, type: l, samples: h.map((u) => ({ ...u })) }
            }), n[a] = (n[a] ?? 0) + h.length, t.releaseUsedSamples(a, n[a]);
          }, t.onFlush = () => {
            r.close();
          };
        },
        cancel: () => {
          t.stop(), e = !0;
        }
      },
      {
        // 每条消息 100 个 samples
        highWaterMark: 50
      }
    ), this.writable = new WritableStream({
      write: async (r) => {
        if (e) {
          this.writable.abort();
          return;
        }
        const n = r.buffer;
        n.fileStart = this.#t, this.#t += n.byteLength, t.appendBuffer(n);
      },
      close: () => {
        t.flush(), t.stop(), t.onFlush?.();
      }
    });
  }
};
function t0(s) {
  let t = 0;
  const e = s.boxes, r = [];
  let n = 0;
  async function a() {
    const o = x(e, t);
    t = e.length, r.forEach(({ track: c, id: d }) => {
      const _ = c.samples.at(-1);
      _ != null && (n = Math.max(n, _.cts + _.duration)), s.releaseUsedSamples(d, c.samples.length), c.samples = [];
    }), s.mdats = [], s.moofs = [], o != null && await p?.write(o);
  }
  let l = [];
  function h() {
    if (l.length > 0) return !0;
    const o = e.findIndex((c) => c.type === "moov");
    if (o === -1) return !1;
    if (l = e.slice(0, o + 1), t = o + 1, r.length === 0)
      for (let c = 1; ; c += 1) {
        const d = s.getTrackById(c);
        if (d == null) break;
        r.push({ track: d, id: c });
      }
    return !0;
  }
  let u = 0;
  const f = ro();
  let p = null;
  const m = (async () => {
    p = await f.createWriter(), u = self.setInterval(() => {
      h() && a();
    }, 100);
  })();
  let g = !1;
  return async () => {
    if (g) throw Error("File exported");
    if (g = !0, await m, clearInterval(u), !h() || p == null) return null;
    s.flush(), await a(), await p?.close();
    const o = l.find((_) => _.type === "moov");
    if (o == null) return null;
    o.mvhd.duration = n;
    const c = ro(), d = x(l, 0);
    return await Qr(c, d), await Qr(c, f, { overwrite: !1 }), await c.stream();
  };
  function x(o, c) {
    if (c >= o.length) return null;
    const d = new Dt.DataStream();
    d.endianness = Dt.DataStream.BIG_ENDIAN;
    for (let _ = c; _ < o.length; _++)
      o[_] !== null && (o[_].write(d), delete o[_]);
    return new Uint8Array(d.buffer);
  }
}
function e0(s) {
  const t = new ArrayBuffer(s.byteLength);
  s.copyTo(t);
  const e = s.timestamp;
  return {
    duration: s.duration ?? 0,
    dts: e,
    cts: e,
    is_sync: s.type === "key",
    data: t
  };
}
async function wf(s) {
  const t = Dt.createFile(), e = t0(t);
  await i0(s, t);
  const r = await e();
  if (r == null) throw Error("Can not generate file from streams");
  return r;
}
async function i0(s, t) {
  let e = 0, r = 0, n = 0, a = 0, l = 0, h = 0, u = null, f = null;
  for (const p of s) {
    let m = null, g = null, x = null, o = null;
    if (await new Promise(async (c) => {
      nh(p.pipeThrough(new vf()), {
        onDone: c,
        onChunk: async ({ chunkType: d, data: _ }) => {
          if (d === "ready") {
            const { videoTrackConf: y, audioTrackConf: v } = Ah(
              _.file,
              _.info
            );
            e === 0 && y != null && (e = t.addTrack(y)), a === 0 && v != null && (a = t.addTrack(v));
          } else if (d === "samples") {
            const { type: y, samples: v } = _, b = y === "video" ? e : a, w = y === "video" ? r : l, S = y === "video" ? n : h;
            v.forEach((E) => {
              let C, M;
              y === "video" ? (m === null && (m = E.dts, g = E.cts), C = E.dts - m, M = E.cts - (g ?? 0)) : (x === null && (x = E.dts, o = E.cts), C = E.dts - x, M = E.cts - (o ?? 0)), t.addSample(b, E.data, {
                duration: E.duration,
                dts: C + w,
                cts: M + S,
                is_sync: E.is_sync
              });
            });
            const T = v.at(-1);
            if (T == null) return;
            y === "video" ? u = T : y === "audio" && (f = T);
          }
        }
      });
    }), u != null && m !== null && g !== null) {
      const c = u.dts - m + u.duration, d = u.cts - g + u.duration;
      r += c, n += d;
    }
    if (f != null && u != null) {
      const c = f.timescale / u.timescale;
      l = Math.round(r * c), h = Math.round(n * c);
    }
  }
}
async function r0(s) {
  return await wf([s]);
}
function s0(s) {
  let t = [];
  const e = new AudioDecoder({
    output: (r) => {
      t.push(r);
    },
    error: z.error
  });
  return e.configure(s), {
    decode: async (r) => {
      r.forEach((a) => {
        e.decode(
          new EncodedAudioChunk({
            type: a.is_sync ? "key" : "delta",
            timestamp: 1e6 * a.cts / a.timescale,
            duration: 1e6 * a.duration / a.timescale,
            data: a.data
          })
        );
      }), await e.flush();
      const n = t;
      return t = [], n;
    },
    close: () => {
      e.close();
    }
  };
}
function n0(s, t) {
  const e = {
    codec: s.codec,
    sampleRate: s.sampleRate,
    numberOfChannels: s.numberOfChannels
  }, r = new AudioEncoder({
    output: (l) => {
      t(e0(l));
    },
    error: (l) => {
      z.error("AudioEncoder error:", l, ", config:", e);
    }
  });
  r.configure(e);
  let n = null;
  function a(l, h) {
    return new AudioData({
      timestamp: h,
      numberOfChannels: s.numberOfChannels,
      numberOfFrames: l.length / s.numberOfChannels,
      sampleRate: s.sampleRate,
      format: "f32-planar",
      data: l
    });
  }
  return {
    encode: async (l, h) => {
      n != null && r.encode(a(n.data, n.ts)), n = { data: l, ts: h };
    },
    stop: async () => {
      n != null && (a0(n.data, s.numberOfChannels, s.sampleRate), r.encode(a(n.data, n.ts)), n = null), await r.flush(), r.close();
    }
  };
}
function a0(s, t, e) {
  const r = s.length - 1, n = Math.min(e / 2, r);
  for (let a = 0; a < n; a++)
    for (let l = 1; l <= t; l++)
      s[Math.floor(r / l) - a] *= a / n;
}
function o0(s, t) {
  z.info("mixinMP4AndAudio, opts:", {
    volume: t.volume,
    loop: t.loop
  });
  const e = Dt.createFile(), { stream: r, stop: n } = id(e, 500);
  let a = null, l = null, h = [], u = 0, f = 0, p = 0, m = !0, g = tt.sampleRate;
  nh(s.pipeThrough(new vf()), {
    onDone: async () => {
      await l?.stop(), a?.close(), n();
    },
    onChunk: async ({ chunkType: d, data: _ }) => {
      if (d === "ready") {
        const { videoTrackConf: y, audioTrackConf: v, audioDecoderConf: b } = Ah(_.file, _.info);
        u === 0 && y != null && (u = e.addTrack(y));
        const w = v ?? {
          timescale: 1e6,
          samplerate: g,
          channel_count: tt.channelCount,
          hdlr: "soun",
          name: "SoundHandler",
          type: "mp4a"
        };
        f === 0 && (f = e.addTrack(w), g = v?.samplerate ?? g, m = v != null);
        const S = new AudioContext({ sampleRate: g });
        h = Ch(
          await S.decodeAudioData(
            await new Response(t.stream).arrayBuffer()
          )
        ), b != null && (a = s0(b)), l = n0(
          b ?? {
            codec: w.type === "mp4a" ? tt.codec : w.type,
            numberOfChannels: w.channel_count,
            sampleRate: w.samplerate
          },
          (T) => e.addSample(f, T.data, T)
        );
      } else if (d === "samples") {
        const { id: y, type: v, samples: b } = _;
        if (v === "video") {
          b.forEach((w) => e.addSample(y, w.data, w)), m || await o(b);
          return;
        }
        v === "audio" && await c(b);
      }
    }
  });
  function x(d) {
    const _ = h.map(
      (y) => t.loop ? bo(y, p, p + d) : y.slice(p, p + d)
    );
    if (p += d, t.volume !== 1)
      for (const y of _)
        for (let v = 0; v < y.length; v++) y[v] *= t.volume;
    return _;
  }
  async function o(d) {
    const _ = d[0], y = d[d.length - 1], v = Math.floor(
      (y.cts + y.duration - _.cts) / y.timescale * g
    ), b = ql([x(v)]);
    b.length !== 0 && l?.encode(
      b,
      _.cts / _.timescale * 1e6
    );
  }
  async function c(d) {
    if (a == null) return;
    const _ = (await a.decode(d)).map(
      ff
    ), y = df(_), v = x(y[0].length), b = d[0];
    l?.encode(
      // 2. 混合输入的音频
      ql([y, v]),
      b.cts / b.timescale * 1e6
    );
  }
  return r;
}
let h0 = 0;
async function Sf(s) {
  s() > 50 && (await Eh(15), await Sf(s));
}
class Tf {
  /**
   * 检测当前环境的兼容性
   * @param args.videoCodec 指定视频编码格式，默认 avc1.42E032
   * @param args.width 指定视频宽度，默认 1920
   * @param args.height 指定视频高度，默认 1080
   * @param args.bitrate 指定视频比特率，默认 5e6
   */
  static async isSupported(t = {}) {
    return (self.OffscreenCanvas != null && self.VideoEncoder != null && self.VideoDecoder != null && self.VideoFrame != null && self.AudioEncoder != null && self.AudioDecoder != null && self.AudioData != null && ((await self.VideoEncoder.isConfigSupported({
      codec: t.videoCodec ?? "avc1.42E032",
      width: t.width ?? 1920,
      height: t.height ?? 1080,
      bitrate: t.bitrate ?? 7e6
    })).supported ?? !1) && (await self.AudioEncoder.isConfigSupported({
      codec: tt.codec,
      sampleRate: tt.sampleRate,
      numberOfChannels: tt.channelCount
    })).supported) ?? !1;
  }
  #t = z.create(`id:${h0++},`);
  #i = !1;
  #e = [];
  #s;
  #r;
  // 中断输出
  #n = null;
  #a;
  #o;
  #c = new Ui();
  on = this.#c.on;
  /**
   * 根据配置创建合成器实例
   * @param opts ICombinatorOpts
   */
  constructor(t = {}) {
    const { width: e = 0, height: r = 0 } = t;
    this.#s = new OffscreenCanvas(e, r);
    const n = this.#s.getContext("2d", { alpha: !1 });
    if (n == null) throw Error("Can not create 2d offscreen context");
    this.#r = n, this.#a = Object.assign(
      {
        bgColor: "#000",
        width: 0,
        height: 0,
        videoCodec: "avc1.42E032",
        audio: !0,
        bitrate: 5e6,
        fps: 30,
        metaDataTags: null
      },
      t
    ), this.#o = e * r > 0;
  }
  /**
   * 添加用于合成视频的 Sprite，视频时长默认取所有素材 duration 字段的最大值
   * @param os Sprite
   * @param opts.main 如果 main 为 true，视频时长为该素材的 duration 值
   */
  async addSprite(t, e = {}) {
    const r = {
      rect: d0(["x", "y", "w", "h"], t.rect),
      time: { ...t.time },
      zIndex: t.zIndex
    };
    this.#t.info("Combinator add sprite", r);
    const n = await t.clone();
    this.#t.info("Combinator add sprite ready"), this.#e.push(
      Object.assign(n, {
        main: e.main ?? !1,
        expired: !1
      })
    ), this.#e.sort((a, l) => a.zIndex - l.zIndex);
  }
  #h(t) {
    const { fps: e, width: r, height: n, videoCodec: a, bitrate: l, audio: h, metaDataTags: u } = this.#a;
    return wg({
      video: this.#o ? {
        width: r,
        height: n,
        expectFPS: e,
        codec: a,
        bitrate: l,
        __unsafe_hardwareAcceleration__: this.#a.__unsafe_hardwareAcceleration__
      } : null,
      audio: h === !1 ? null : {
        codec: "aac",
        sampleRate: tt.sampleRate,
        channelCount: tt.channelCount
      },
      duration: t,
      metaDataTags: u
    });
  }
  /**
   * 输出视频文件二进制流
   * @param opts.maxTime 允许输出视频的最大时长，超过时长的素材内容会被忽略
   */
  output(t = {}) {
    if (this.#e.length === 0) throw Error("No sprite added");
    const e = this.#e.find((f) => f.main), r = t.maxTime ?? (e != null ? e.time.offset + e.time.duration : Math.max(
      ...this.#e.map((f) => f.time.offset + f.time.duration)
    ));
    if (r === 1 / 0)
      throw Error(
        "Unable to determine the end time, please specify a main sprite, or limit the duration of ImgClip, AudioCli"
      );
    r === -1 && this.#t.warn(
      "Unable to determine the end time, process value don't update"
    ), this.#t.info(`start combinate video, maxTime:${r}`);
    const n = this.#h(r);
    let a = performance.now();
    const l = this.#d(n, r, {
      onProgress: (f) => {
        this.#t.debug("OutputProgress:", f), this.#c.emit("OutputProgress", f);
      },
      onEnded: async () => {
        await n.flush(), this.#t.info(
          "===== output ended =====, cost:",
          performance.now() - a
        ), this.#c.emit("OutputProgress", 1), this.destroy();
      },
      onError: (f) => {
        this.#c.emit("error", f), u(f), this.destroy();
      }
    });
    this.#n = () => {
      l(), n.close(), u();
    };
    const { stream: h, stop: u } = id(
      n.mp4file,
      500,
      this.destroy
    );
    return h;
  }
  /**
   * 销毁实例，释放资源
   */
  destroy() {
    this.#i || (this.#i = !0, this.#n?.(), this.#c.destroy());
  }
  #d(t, e, {
    onProgress: r,
    onEnded: n,
    onError: a
  }) {
    let l = 0;
    const h = { aborted: !1 };
    let u = null;
    (async () => {
      const { fps: m, bgColor: g, audio: x } = this.#a, o = Math.round(1e6 / m), c = this.#r, d = l0({
        ctx: c,
        bgColor: g,
        sprites: this.#e,
        aborter: h
      }), _ = c0({
        remux: t,
        ctx: c,
        cvs: this.#s,
        outputAudio: x,
        hasVideoTrack: this.#o,
        timeSlice: o,
        fps: m
      });
      let y = 0;
      for (; ; ) {
        if (u != null) return;
        if (h.aborted || e !== -1 && y > e || this.#e.length === 0) {
          p(), await n();
          return;
        }
        l = y / e;
        const { audios: v, mainSprDone: b } = await d(y);
        if (b) {
          p(), await n();
          return;
        }
        if (h.aborted) return;
        _(y, v), y += o, await Sf(t.getEncodeQueueSize);
      }
    })().catch((m) => {
      u = m, this.#t.error(m), p(), a(m);
    });
    const f = setInterval(() => {
      r(l);
    }, 500), p = () => {
      h.aborted || (h.aborted = !0, clearInterval(f), this.#e.forEach((m) => m.destroy()));
    };
    return p;
  }
}
function l0(s) {
  const { ctx: t, bgColor: e, sprites: r, aborter: n } = s, { width: a, height: l } = t.canvas;
  return async (h) => {
    t.fillStyle = e, t.fillRect(0, 0, a, l);
    const u = [];
    let f = !1;
    for (const p of r) {
      if (n.aborted) break;
      if (h < p.time.offset || p.expired) continue;
      t.save();
      const { audio: m, done: g } = await p.offscreenRender(t, h - p.time.offset);
      u.push(m), t.restore(), (p.time.duration > 0 && h > p.time.offset + p.time.duration || g) && (p.main && (f = !0), p.destroy(), p.expired = !0);
    }
    return {
      audios: u,
      mainSprDone: f
    };
  };
}
function c0(s) {
  const { ctx: t, cvs: e, outputAudio: r, remux: n, hasVideoTrack: a, timeSlice: l } = s, { width: h, height: u } = e;
  let f = 0;
  const p = Math.floor(3 * s.fps), m = u0(1024);
  return (g, x) => {
    if (r !== !1)
      for (const o of m(g, x)) n.encodeAudio(o);
    if (a) {
      const o = new VideoFrame(e, {
        duration: l,
        timestamp: g
      });
      n.encodeVideo(o, {
        keyFrame: f % p === 0
      }), t.resetTransform(), t.clearRect(0, 0, h, u), f += 1;
    }
  };
}
function u0(s) {
  const t = s * tt.channelCount, e = new Float32Array(t * 3);
  let r = 0, n = 0;
  const a = s / tt.sampleRate * 1e6, l = new Float32Array(t), h = (u) => {
    let f = 0;
    const p = Math.floor(r / t), m = [];
    for (let g = 0; g < p; g++)
      m.push(
        new AudioData({
          timestamp: n,
          numberOfChannels: tt.channelCount,
          numberOfFrames: s,
          sampleRate: tt.sampleRate,
          format: "f32",
          data: e.subarray(f, f + t)
        })
      ), f += t, n += a;
    for (e.set(e.subarray(f, r), 0), r -= f; u - n > a; )
      m.push(
        new AudioData({
          timestamp: n,
          numberOfChannels: tt.channelCount,
          numberOfFrames: s,
          sampleRate: tt.sampleRate,
          format: "f32",
          data: l
        })
      ), n += a;
    return m;
  };
  return (u, f) => {
    const p = Math.max(...f.map((m) => m[0]?.length ?? 0));
    for (let m = 0; m < p; m++) {
      let g = 0, x = 0;
      for (let o = 0; o < f.length; o++) {
        const c = f[o][0]?.[m] ?? 0, d = f[o][1]?.[m] ?? c;
        g += c, x += d;
      }
      e[r] = g, e[r + 1] = x, r += 2;
    }
    return h(u);
  };
}
function d0(s, t) {
  return s.reduce(
    (e, r) => (e[r] = t[r], e),
    {}
  );
}
class Et {
  #t = new Ui();
  /**
   * 监听属性变更事件
   * @example
   * rect.on('propsChange', (changedProps) => {})
   */
  on = this.#t.on;
  #i = 0;
  /**
   * x 坐标
   */
  get x() {
    return this.#i;
  }
  set x(t) {
    this.#a("x", t);
  }
  #e = 0;
  get y() {
    return this.#e;
  }
  /**
   * y 坐标
   */
  set y(t) {
    this.#a("y", t);
  }
  #s = 0;
  /**
   * 宽
   */
  get w() {
    return this.#s;
  }
  set w(t) {
    this.#a("w", t);
  }
  #r = 0;
  /**
   * 高
   */
  get h() {
    return this.#r;
  }
  set h(t) {
    this.#a("h", t);
  }
  #n = 0;
  /**
   * 旋转角度
   * @see [MDN Canvas rotate](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/rotate)
   */
  get angle() {
    return this.#n;
  }
  set angle(t) {
    this.#a("angle", t);
  }
  #a(t, e) {
    const r = this[t] !== e;
    switch (t) {
      case "x":
        this.#i = e;
        break;
      case "y":
        this.#e = e;
        break;
      case "w":
        this.#s = e;
        break;
      case "h":
        this.#r = e;
        break;
      case "angle":
        this.#n = e;
        break;
    }
    r && this.#t.emit("propsChange", { [t]: e });
  }
  /**
   * 如果当前实例是 Rect 控制点之一，`master` 将指向该 Rect
   *
   * 控制点的坐标是相对于它的 `master` 定位
   */
  #o = null;
  constructor(t, e, r, n, a) {
    this.x = t ?? 0, this.y = e ?? 0, this.w = r ?? 0, this.h = n ?? 0, this.#o = a ?? null;
  }
  /**
   * 根据坐标、宽高计算出来的矩形中心点
   */
  get center() {
    const { x: t, y: e, w: r, h: n } = this;
    return { x: t + r / 2, y: e + n / 2 };
  }
  /**
   * 是否保持固定宽高比例，禁止变形缩放
   *
   * 值为 true 时，将缺少上下左右四个控制点
   */
  fixedAspectRatio = !1;
  /**
   * 是否固定中心点进行缩放
   * 值为 true 时，固定中心点不变进行缩放
   * 值为 false 时，固定对角点不变进行缩放
   */
  fixedScaleCenter = !1;
  clone() {
    const { x: t, y: e, w: r, h: n } = this, a = new Et(t, e, r, n, this.#o);
    return a.angle = this.angle, a.fixedAspectRatio = this.fixedAspectRatio, a.fixedScaleCenter = this.fixedScaleCenter, a;
  }
  /**
   * 检测目标坐标是否命中当前实例
   * @param tx 目标点 x 坐标
   * @param ty 目标点 y 坐标
   */
  checkHit(t, e) {
    let { angle: r, center: n, x: a, y: l, w: h, h: u } = this;
    const f = this.#o?.center ?? n, p = this.#o?.angle ?? r;
    this.#o == null && (a = a - f.x, l = l - f.y);
    const m = t - f.x, g = e - f.y;
    let x = m, o = g;
    return p !== 0 && (x = m * Math.cos(p) + g * Math.sin(p), o = g * Math.cos(p) - m * Math.sin(p)), !(x < a || x > a + h || o < l || o > l + u);
  }
}
const f0 = {
  fadeIn: (s, t, { duration: e }) => {
    const r = structuredClone(t);
    return r.opacity = 0.1, s.to(r, {
      duration: e,
      opacity: t.opacity,
      ease: "power1.inOut"
    }), r;
  },
  zoomFadeInGrow: (s, t, { duration: e }) => {
    const r = structuredClone(t);
    r.opacity = 0.1;
    const n = t.rect.w - t.rect.w * 0.5, a = t.rect.h - t.rect.h * 0.5;
    return r.rect.w = t.rect.w * 0.5, r.rect.h = t.rect.h * 0.5, r.rect.x = t.rect.x + n / 2, r.rect.y = t.rect.y + a / 2, s.to(r, {
      duration: e,
      opacity: t.opacity,
      ease: "power1.inOut"
    }), s.to(
      r.rect,
      {
        duration: e,
        w: t.rect.w,
        h: t.rect.h,
        x: t.rect.x,
        y: t.rect.y,
        ease: "power1.inOut"
      },
      0
    ), r;
  },
  zoomFadeInShrink: (s, t, { duration: e }) => {
    const r = structuredClone(t);
    r.opacity = 0.1;
    const n = t.rect.w * 1.5 - t.rect.w, a = t.rect.h * 1.5 - t.rect.h;
    return r.rect.w = t.rect.w * 1.5, r.rect.h = t.rect.h * 1.5, r.rect.x = t.rect.x - n / 2, r.rect.y = t.rect.y - a / 2, s.to(r, {
      duration: e,
      opacity: t.opacity,
      ease: "power1.inOut"
    }), s.to(
      r.rect,
      {
        duration: e,
        w: t.rect.w,
        h: t.rect.h,
        x: t.rect.x,
        y: t.rect.y,
        ease: "power1.inOut"
      },
      0
    ), r;
  },
  slideFadeInUp: (s, t, { duration: e }) => {
    const r = structuredClone(t);
    return r.opacity = 0.1, r.rect.y = t.rect.y + t.rect.h, s.to(r, {
      duration: e,
      opacity: t.opacity,
      ease: "power1.inOut"
    }), s.to(
      r.rect,
      {
        duration: e,
        y: t.rect.y,
        ease: "power1.inOut"
      },
      0
    ), r;
  },
  slideFadeInDown: (s, t, { duration: e }) => {
    const r = structuredClone(t);
    return r.opacity = 0.1, r.rect.y = t.rect.y - t.rect.h, s.to(r, {
      duration: e,
      opacity: t.opacity,
      ease: "power1.inOut"
    }), s.to(
      r.rect,
      {
        duration: e,
        y: t.rect.y,
        ease: "power1.inOut"
      },
      0
    ), r;
  },
  slideInLeft: (s, t, { duration: e }) => {
    const r = structuredClone(t);
    return r.rect.x = t.rect.x - t.rect.w, s.to(r.rect, {
      duration: e,
      x: t.rect.x,
      ease: "power1.inOut"
    }), r;
  },
  slideInRight: (s, t, { duration: e }) => {
    const r = structuredClone(t);
    return r.rect.x = t.rect.x + t.rect.w, s.to(r.rect, {
      duration: e,
      x: t.rect.x,
      ease: "power1.inOut"
    }), r;
  }
}, p0 = {
  fadeOut: (s, t, { duration: e, delay: r }) => {
    const n = structuredClone(t);
    return s.to(
      n,
      {
        duration: e,
        opacity: 0.1,
        ease: "power1.inOut"
      },
      r
    ), n;
  },
  zoomFadeOutGrow: (s, t, { duration: e, delay: r }) => {
    const n = structuredClone(t);
    s.to(
      n,
      {
        duration: e,
        opacity: 0.1,
        ease: "power1.inOut"
      },
      r
    );
    const a = t.rect.w * 1.2 - t.rect.w, l = t.rect.h * 1.2 - t.rect.h;
    return s.to(
      n.rect,
      {
        duration: e,
        w: t.rect.w * 1.2,
        h: t.rect.h * 1.2,
        x: t.rect.x - a / 2,
        y: t.rect.y - l / 2,
        ease: "power1.inOut"
      },
      r
    ), n;
  },
  zoomFadeOutShrink: (s, t, { duration: e, delay: r }) => {
    const n = structuredClone(t);
    s.to(
      n,
      {
        duration: e,
        opacity: 0.1,
        ease: "power1.inOut"
      },
      r
    );
    const a = t.rect.w - t.rect.w * 0.8, l = t.rect.h - t.rect.h * 0.8;
    return s.to(
      n.rect,
      {
        duration: e,
        w: t.rect.w * 0.8,
        h: t.rect.h * 0.8,
        x: t.rect.x + a / 2,
        y: t.rect.y + l / 2,
        ease: "power1.inOut"
      },
      r
    ), n;
  },
  slideFadeOutUp: (s, t, { duration: e, delay: r }) => {
    const n = structuredClone(t);
    return s.to(
      n,
      {
        duration: e,
        opacity: 0.1,
        ease: "power1.inOut"
      },
      r
    ), s.to(
      n.rect,
      {
        duration: e,
        y: t.rect.y - t.rect.h,
        ease: "power1.inOut"
      },
      r
    ), n;
  },
  slideFadeOutDown: (s, t, { duration: e, delay: r }) => {
    const n = structuredClone(t);
    return s.to(
      n,
      {
        duration: e,
        opacity: 0.1,
        ease: "power1.inOut"
      },
      r
    ), s.to(
      n.rect,
      {
        duration: e,
        y: t.rect.y + t.rect.h,
        ease: "power1.inOut"
      },
      r
    ), n;
  },
  slideOutLeft: (s, t, { duration: e, delay: r }) => {
    const n = structuredClone(t);
    return s.to(
      n.rect,
      {
        duration: e,
        x: t.rect.x - t.rect.w,
        ease: "power1.inOut"
      },
      r
    ), n;
  },
  slideOutRight: (s, t, { duration: e, delay: r }) => {
    const n = structuredClone(t);
    return s.to(
      n.rect,
      {
        duration: e,
        x: t.rect.x + t.rect.w,
        ease: "power1.inOut"
      },
      r
    ), n;
  }
};
function ec(s) {
  const { x: t, y: e, w: r, h: n, angle: a } = s.rect;
  return {
    rect: { x: t, y: e, w: r, h: n, angle: a },
    opacity: s.opacity,
    time: s.time
  };
}
function _0(s, t, e) {
  const r = t / 1e6, n = s.time.duration / 1e6;
  if (r < 0 || r > n)
    return ec(s);
  const a = _r.timeline({ paused: !0 });
  let l = ec(s);
  if (e.in) {
    const h = (e.in.duration ?? 1e6) / 1e6, u = f0[e.in.type];
    r <= h && (l = u(a, l, { duration: h }));
  }
  if (e.out) {
    const h = (e.out.duration ?? 1e6) / 1e6, u = n - h;
    if (r >= u) {
      const f = p0[e.out.type];
      l = f(a, l, { duration: h, delay: u });
    }
  }
  return a.to({}, { duration: n }, 0), a.progress(Math.min(r / n, 1)), l;
}
let Cf = class {
  /**
   * 控制素材在视频中的空间属性（坐标、旋转、缩放）
   */
  rect = new Et();
  /**
   * 控制素材在的时间偏移、时长、播放速率，常用于剪辑场景时间轴（轨道）模块
   * duration 不能大于引用 {@link IClip} 的时长，单位 微秒
   *
   * playbackRate 控制当前素材的播放速率，1 表示正常播放；
   * **注意**
   *    1. 设置 playbackRate 时需要主动修正 duration
   *    2. 音频使用最简单的插值算法来改变速率，所以改变速率后音调会产生变化，自定义算法请使用 {@link MP4Clip.tickInterceptor} 配合实现
   *
   */
  #t = {
    offset: 0,
    duration: 0,
    playbackRate: 1
  };
  get time() {
    return this.#t;
  }
  set time(t) {
    Object.assign(this.#t, t);
  }
  #i = new Ui();
  /**
   * 监听属性变更事件
   * @example
   * sprite.on('propsChange', (changedProps) => {})
   */
  on = this.#i.on;
  #e = 0;
  get zIndex() {
    return this.#e;
  }
  /**
   * 控制素材间的层级关系，zIndex 值较小的素材会被遮挡
   */
  set zIndex(t) {
    const e = this.#e !== t;
    this.#e = t, e && this.#i.emit("propsChange", { zIndex: t });
  }
  /**
   * 不透明度
   */
  opacity = 1;
  /**
   * 水平或垂直方向翻转素材
   */
  flip = null;
  #s = [];
  #r = null;
  /**
   * @see {@link IClip.ready}
   */
  ready = Promise.resolve();
  constructor() {
    this.rect.on("propsChange", (t) => {
      this.#i.emit("propsChange", { rect: t });
    });
  }
  _render(t, { rect: e, opacity: r }) {
    const { center: n, angle: a } = e;
    t.setTransform(
      // 水平 缩放、倾斜
      this.flip === "horizontal" ? -1 : 1,
      0,
      // 垂直 倾斜、缩放
      0,
      this.flip === "vertical" ? -1 : 1,
      // 坐标原点偏移 x y
      n.x,
      n.y
    ), t.rotate((this.flip == null ? 1 : -1) * a), t.globalAlpha = r;
  }
  setAnimation(t, e) {
    if (e === void 0) {
      t == null ? this.#r = null : ("in" in t || "out" in t) && (this.#r = t);
      return;
    }
    const r = t, n = e;
    this.#s.push({
      keyFrame: Object.entries(r).map(([a, l]) => {
        const h = { from: 0, to: 100 }[a] ?? Number(a.slice(0, -1));
        if (isNaN(h) || h > 100 || h < 0)
          throw Error("keyFrame must between 0~100");
        return [h / 100, l];
      }),
      conf: {
        duration: n.duration,
        delay: n.delay ?? 0,
        iterCount: n.iterCount ?? 1 / 0,
        totalDuration: n.duration * (n.iterCount ?? 1 / 0)
      }
    });
  }
  /**
   * 如果当前 sprite 已被设置动画，将 sprite 的动画属性设定到指定时间的状态
   */
  animate(t) {
    const e = { rect: this.rect.clone(), opacity: this.opacity };
    if (this.#r && ("in" in this.#r || "out" in this.#r)) {
      const r = _0(this, t, this.#r);
      return Object.assign(e.rect, r.rect), e.opacity = r.opacity, e;
    }
    if (this.#s.length === 0) return e;
    for (const { keyFrame: r, conf: n } of this.#s) {
      if (t < n.delay || t > n.delay + n.totalDuration) continue;
      const a = m0(t, r, n);
      for (const l in a)
        switch (l) {
          case "opacity":
            e.opacity = a[l];
            break;
          case "x":
          case "y":
          case "w":
          case "h":
          case "angle":
            e.rect[l] = a[l];
            break;
        }
      return e;
    }
    return e;
  }
  /**
   * 将当前 sprite 的属性赋值到目标
   *
   * 用于 clone，或 {@link VisibleSprite} 与 {@link OffscreenSprite} 实例间的类型转换
   */
  copyStateTo(t) {
    t.#s = [...this.#s], t.#r = this.#r == null ? null : { ...this.#r }, t.zIndex = this.zIndex, t.opacity = this.opacity, t.flip = this.flip, t.rect = this.rect.clone(), t.time = { ...this.time };
  }
  destroy() {
    this.#i.destroy();
  }
};
function m0(s, t, e) {
  const r = s - e.delay, n = r % e.duration, a = r / e.duration >= e.iterCount || r === e.duration ? 1 : n / e.duration, l = t.findIndex((x) => x[0] >= a);
  if (l === -1) return {};
  const h = t[l - 1], u = t[l], f = u[1];
  if (h == null) return f;
  const p = h[1], m = {}, g = (a - h[0]) / (u[0] - h[0]);
  for (const x in f) {
    const o = x;
    p[o] != null && (m[o] = (f[o] - p[o]) * g + p[o]);
  }
  return m;
}
let Ef = class Af extends Cf {
  #t;
  getClip() {
    return this.#t;
  }
  // 保持最近一帧，若 clip 在当前帧无数据，则绘制最近一帧
  #i = null;
  #e = !1;
  constructor(t) {
    super(), this.#t = t, this.ready = t.ready.then(({ width: e, height: r, duration: n }) => {
      this.rect.w = this.rect.w === 0 ? e : this.rect.w, this.rect.h = this.rect.h === 0 ? r : this.rect.h, this.time.duration = this.time.duration === 0 ? n : this.time.duration;
    });
  }
  /**
   * 绘制素材指定时刻的图像到 canvas 上下文，并返回对应的音频数据
   * @param time 指定时刻，微秒
   */
  async offscreenRender(t, e) {
    const r = e * this.time.playbackRate, n = this.animate(r);
    super._render(t, n);
    const { w: a, h: l } = n.rect, { video: h, audio: u, state: f } = await this.#t.tick(r);
    let p = u ?? [];
    if (u != null && this.time.playbackRate !== 1 && (p = u.map(
      (g) => pf(g, this.time.playbackRate)
    )), f === "done" || r > this.time.duration)
      return {
        audio: p,
        done: !0
      };
    const m = h ?? this.#i;
    return m != null && t.drawImage(m, -a / 2, -l / 2, a, l), h != null && (this.#i?.close(), this.#i = h), {
      audio: p,
      done: !1
    };
  }
  async clone() {
    const t = new Af(await this.#t.clone());
    return await t.ready, this.copyStateTo(t), t;
  }
  destroy() {
    this.#e || (this.#e = !0, z.info("OffscreenSprite destroy"), super.destroy(), this.#i?.close(), this.#i = null, this.#t.destroy());
  }
}, g0 = class Pf extends Cf {
  #t;
  getClip() {
    return this.#t;
  }
  /**
   * 元素是否可见，用于不想删除，期望临时隐藏 Sprite 的场景
   */
  visible = !0;
  /**
   * 控制 Sprite 的交互状态
   * - 'interactive': 可选中，可进行移动、缩放、旋转等所有交互
   * - 'selectable': 仅可选中，但不可进行移动、缩放、旋转等交互
   * - 'disabled': 不可选中，也不可交互
   * @default 'interactive'
   */
  interactable = "interactive";
  constructor(t) {
    super(), this.#t = t, this.ready = t.ready.then(({ width: e, height: r, duration: n }) => {
      this.rect.w = this.rect.w === 0 ? e : this.rect.w, this.rect.h = this.rect.h === 0 ? r : this.rect.h, this.time.duration = this.time.duration === 0 ? n : this.time.duration;
    });
  }
  // 保持最近一帧，若 clip 在当前帧无数据，则绘制最近一帧
  #i = null;
  #e = [];
  #s = !1;
  async #r(t) {
    if (!this.#s) {
      this.#s = !0;
      try {
        const { video: e, audio: r } = await this.#t.tick(
          t * this.time.playbackRate
        );
        if (this.#a) {
          e?.close();
          return;
        }
        e != null && (this.#i?.close(), this.#i = e ?? null), this.#e = r ?? [], r != null && this.time.playbackRate !== 1 && (this.#e = r.map(
          (n) => pf(n, this.time.playbackRate)
        ));
      } finally {
        this.#s = !1;
      }
    }
  }
  /**
   * 提前准备指定 time 的帧
   */
  async preFrame(t) {
    this.#n !== t && (await this.#r(t), this.#n = t);
  }
  #n = -1;
  /**
   * 绘制素材指定时刻的图像到 canvas 上下文，并返回对应的音频数据
   * @param time 指定时刻，微秒
   */
  render(t, e) {
    const r = this.animate(e);
    super._render(t, r);
    const { w: n, h: a } = r.rect;
    this.#n !== e && this.#r(e), this.#n = e;
    const l = this.#e;
    this.#e = [];
    const h = this.#i;
    return h != null && t.drawImage(h, -n / 2, -a / 2, n, a), { audio: l };
  }
  copyStateTo(t) {
    super.copyStateTo(t), t instanceof Pf && (t.visible = this.visible, t.interactable = this.interactable);
  }
  #a = !1;
  destroy() {
    this.#a || (this.#a = !0, z.info("VisibleSprite destroy"), super.destroy(), this.#i?.close(), this.#i = null, this.#t.destroy());
  }
};
const WE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AudioClip: Oe,
  Combinator: Tf,
  EmbedSubtitlesClip: Wr,
  ImgClip: Kx,
  Log: z,
  MP4Clip: _f,
  MediaStreamClip: xf,
  OffscreenSprite: Ef,
  Rect: Et,
  VisibleSprite: g0,
  createChromakey: wx,
  fastConcatMP4: wf,
  fixFMP4Duration: r0,
  mixinMP4AndAudio: o0,
  renderTxt2ImgBitmap: Ex
}, Symbol.toStringTag, { value: "Module" }));
function y0(s) {
  let t = null, e = null;
  return (r) => {
    (t == null || e == null) && ({ cvs: t, ctx: e } = x0(r.displayWidth, r.displayHeight)), e.clearRect(0, 0, t.width, t.height), e.filter = s, e.drawImage(r, 0, 0);
    const n = new VideoFrame(t, {
      timestamp: r.timestamp,
      duration: r.duration ?? 0
    });
    return r.close(), n;
  };
}
function x0(s, t) {
  const e = new OffscreenCanvas(s, t);
  e.width = s, e.height = t;
  const r = e.getContext("2d", { alpha: !0 });
  return { cvs: e, ctx: r };
}
async function b0(s, t) {
  const { width: e, height: r, duration: n } = await s.ready;
  let a = 0, l = 0, h = 0, u = 0;
  if (typeof t != "number") {
    const p = t;
    if (p.x < 0 || p.y < 0 || p.w <= 0 || p.h <= 0)
      throw new Error(
        "Invalid crop area parameters: coordinates cannot be negative, width and height must be greater than 0"
      );
    if (p.x + p.w > e || p.y + p.h > r)
      throw new Error(
        `Crop area exceeds original dimensions: original size(${e}x${r}), crop area(${p.x},${p.y},${p.w},${p.h})`
      );
    a = Math.floor(p.x / 2) * 2, l = Math.floor(p.y / 2) * 2, h = Math.floor(p.w / 2) * 2, u = Math.floor(p.h / 2) * 2;
  } else
    e / r > t ? (u = Math.floor(r / 2) * 2, h = Math.floor(u * t / 2) * 2, h = Math.min(h, e), a = Math.floor((e - h) / 2 / 2) * 2) : (h = Math.floor(e / 2) * 2, u = Math.floor(h / t / 2) * 2, u = Math.min(u, r), l = Math.floor((r - u) / 2 / 2) * 2), a = Math.max(0, Math.min(a, e - h)), l = Math.max(0, Math.min(l, r - u)), h = Math.min(h, e - a), u = Math.min(u, r - l);
  const f = s.tickInterceptor;
  return s.tickInterceptor = async (p, m) => {
    const g = await f(p, m);
    if (!g.video) return g;
    const x = g.video instanceof VideoFrame ? new VideoFrame(g.video, {
      timestamp: g.video.timestamp,
      duration: g.video.duration ?? 0,
      visibleRect: {
        x: a,
        y: l,
        width: h,
        height: u
      }
    }) : await createImageBitmap(g.video, a, l, h, u);
    return g.video.close(), { ...g, video: x };
  }, s.ready = Promise.resolve({
    width: h,
    height: u,
    duration: n
  }), s;
}
/*!
 * PixiPlugin 3.13.0
 * https://gsap.com
 *
 * @license Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/
var Je, bn, ic, ae, Vr, Mf, So, Gn, Bf = function() {
  return typeof window < "u";
}, Uf = function() {
  return Je || Bf() && (Je = window.gsap) && Je.registerPlugin && Je;
}, To = function(t) {
  return typeof t == "function";
}, Rf = function(t) {
  return console.warn(t);
}, v0 = [1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0], ti = 0.212671, Ge = 0.71516, Te = 0.072169, If = function(t) {
  return To(ae[t]) ? ae[t] : ae.filters[t];
}, zn = function(t, e) {
  var r = [], n = 0, a = 0, l, h;
  for (l = 0; l < 4; l++) {
    for (h = 0; h < 5; h++)
      a = h === 4 ? t[n + 4] : 0, r[n + h] = t[n] * e[h] + t[n + 1] * e[h + 5] + t[n + 2] * e[h + 10] + t[n + 3] * e[h + 15] + a;
    n += 5;
  }
  return r;
}, rc = function(t, e) {
  var r = 1 - e, n = r * ti, a = r * Ge, l = r * Te;
  return zn([n + e, a, l, 0, 0, n, a + e, l, 0, 0, n, a, l + e, 0, 0, 0, 0, 0, 1, 0], t);
}, sc = function(t, e, r) {
  var n = bn(e), a = n[0] / 255, l = n[1] / 255, h = n[2] / 255, u = 1 - r;
  return zn([u + r * a * ti, r * a * Ge, r * a * Te, 0, 0, r * l * ti, u + r * l * Ge, r * l * Te, 0, 0, r * h * ti, r * h * Ge, u + r * h * Te, 0, 0, 0, 0, 0, 1, 0], t);
}, nc = function(t, e) {
  e *= Math.PI / 180;
  var r = Math.cos(e), n = Math.sin(e);
  return zn([ti + r * (1 - ti) + n * -0.212671, Ge + r * -0.71516 + n * -0.71516, Te + r * -0.072169 + n * (1 - Te), 0, 0, ti + r * -0.212671 + n * 0.143, Ge + r * (1 - Ge) + n * 0.14, Te + r * -0.072169 + n * -0.283, 0, 0, ti + r * -0.212671 + n * -0.787329, Ge + r * -0.71516 + n * Ge, Te + r * (1 - Te) + n * Te, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1], t);
}, ac = function(t, e) {
  return zn([e, 0, 0, 0, 0.5 * (1 - e), 0, e, 0, 0, 0.5 * (1 - e), 0, 0, e, 0, 0.5 * (1 - e), 0, 0, 0, 1, 0], t);
}, kf = function(t, e) {
  var r = If(e), n = t.filters || [], a = n.length, l;
  for (r || Rf(e + " not found. PixiPlugin.registerPIXI(PIXI)"); --a > -1; )
    if (n[a] instanceof r)
      return n[a];
  return l = new r(), e === "BlurFilter" && (Gn ? l.strength = 0 : l.blur = 0), t.filters = [].concat(n, [l]), l;
}, bt = function(t, e, r, n) {
  e.add(r, t, r[t], n[t]), e._props.push(t);
}, oc = function(t, e) {
  var r = If("ColorMatrixFilter"), n = new r();
  return n.matrix = e, n.brightness(t, !0), n.matrix;
}, w0 = function(t) {
  var e = {}, r;
  for (r in t)
    e[r] = t[r];
  return e;
}, Wt = {
  contrast: 1,
  saturation: 1,
  colorizeAmount: 0,
  colorize: "rgb(255,255,255)",
  hue: 0,
  brightness: 1
}, S0 = function(t, e, r) {
  var n = kf(t, "ColorMatrixFilter"), a = t._gsColorMatrixFilter = t._gsColorMatrixFilter || w0(Wt), l = e.combineCMF && !("colorMatrixFilter" in e && !e.colorMatrixFilter), h, u, f;
  for (f = n.matrix, e.resolution && (n.resolution = e.resolution), e.matrix && e.matrix.length === f.length ? (u = e.matrix, a.contrast !== 1 && bt("contrast", r, a, Wt), a.hue && bt("hue", r, a, Wt), a.brightness !== 1 && bt("brightness", r, a, Wt), a.colorizeAmount && (bt("colorize", r, a, Wt), bt("colorizeAmount", r, a, Wt)), a.saturation !== 1 && bt("saturation", r, a, Wt)) : (u = v0.slice(), e.contrast != null ? (u = ac(u, +e.contrast), bt("contrast", r, a, e)) : a.contrast !== 1 && (l ? u = ac(u, a.contrast) : bt("contrast", r, a, Wt)), e.hue != null ? (u = nc(u, +e.hue), bt("hue", r, a, e)) : a.hue && (l ? u = nc(u, a.hue) : bt("hue", r, a, Wt)), e.brightness != null ? (u = oc(+e.brightness, u), bt("brightness", r, a, e)) : a.brightness !== 1 && (l ? u = oc(a.brightness, u) : bt("brightness", r, a, Wt)), e.colorize != null ? (e.colorizeAmount = "colorizeAmount" in e ? +e.colorizeAmount : 1, u = sc(u, e.colorize, e.colorizeAmount), bt("colorize", r, a, e), bt("colorizeAmount", r, a, e)) : a.colorizeAmount && (l ? u = sc(u, a.colorize, a.colorizeAmount) : (bt("colorize", r, a, Wt), bt("colorizeAmount", r, a, Wt))), e.saturation != null ? (u = rc(u, +e.saturation), bt("saturation", r, a, e)) : a.saturation !== 1 && (l ? u = rc(u, a.saturation) : bt("saturation", r, a, Wt))), h = u.length; --h > -1; )
    u[h] !== f[h] && r.add(f, h, f[h], u[h], "colorMatrixFilter");
  r._props.push("colorMatrixFilter");
}, T0 = function(t, e) {
  var r = e.t, n = e.p, a = e.color, l = e.set;
  l(r, n, a[0] << 16 | a[1] << 8 | a[2]);
}, C0 = function(t, e) {
  var r = e.g;
  Gn ? (r.fill(), r.stroke()) : r && (r.dirty++, r.clearDirty++);
}, E0 = function(t, e) {
  e.t.visible = !!e.t.alpha;
}, hc = function(t, e, r, n) {
  var a = t[e], l = bn(To(a) ? t[e.indexOf("set") || !To(t["get" + e.substr(3)]) ? e : "get" + e.substr(3)]() : a), h = bn(r);
  n._pt = new Vr(n._pt, t, e, 0, 0, T0, {
    t,
    p: e,
    color: l,
    set: Mf(t, e)
  }), n.add(l, 0, l[0], h[0]), n.add(l, 1, l[1], h[1]), n.add(l, 2, l[2], h[2]);
}, A0 = {
  tint: 1,
  lineColor: 1,
  fillColor: 1,
  strokeColor: 1
}, lc = "position,scale,skew,pivot,anchor,tilePosition,tileScale".split(","), Co = {
  x: "position",
  y: "position",
  tileX: "tilePosition",
  tileY: "tilePosition"
}, P0 = {
  colorMatrixFilter: 1,
  saturation: 1,
  contrast: 1,
  hue: 1,
  colorize: 1,
  colorizeAmount: 1,
  brightness: 1,
  combineCMF: 1
}, vn = Math.PI / 180, Ff = function(t) {
  return typeof t == "string";
}, M0 = function(t) {
  return Ff(t) && t.charAt(1) === "=" ? t.substr(0, 2) + parseFloat(t.substr(2)) * vn : t * vn;
}, B0 = function(t, e) {
  return e.set(e.t, e.p, t === 1 ? e.e : Math.round((e.s + e.c * t) * 1e5) / 1e5, e);
}, U0 = function(t, e, r, n, a, l) {
  var h = 360 * (l ? vn : 1), u = Ff(a), f = u && a.charAt(1) === "=" ? +(a.charAt(0) + "1") : 0, p = parseFloat(f ? a.substr(2) : a) * (l ? vn : 1), m = f ? p * f : p - n, g = n + m, x, o;
  return u && (x = a.split("_")[1], x === "short" && (m %= h, m !== m % (h / 2) && (m += m < 0 ? h : -h)), x === "cw" && m < 0 ? m = (m + h * 1e10) % h - ~~(m / h) * h : x === "ccw" && m > 0 && (m = (m - h * 1e10) % h - ~~(m / h) * h)), t._pt = o = new Vr(t._pt, e, r, n, m, B0), o.e = g, o;
}, cc = function() {
  if (!ic) {
    Je = Uf(), ae = ic = ae || Bf() && window.PIXI;
    var t = ae && ae.VERSION && parseFloat(ae.VERSION.split(".")[0]) || 0;
    So = t === 4, Gn = t >= 8, bn = function(r) {
      return Je.utils.splitColor((r + "").substr(0, 2) === "0x" ? "#" + r.substr(2) : r);
    };
  }
}, Ms, Sr;
for (Ms = 0; Ms < lc.length; Ms++)
  Sr = lc[Ms], Co[Sr + "X"] = Sr, Co[Sr + "Y"] = Sr;
var ms = {
  version: "3.13.0",
  name: "pixi",
  register: function(t, e, r) {
    Je = t, Vr = r, Mf = e.getSetter, cc();
  },
  headless: !0,
  // doesn't need window
  registerPIXI: function(t) {
    ae = t;
  },
  init: function(t, e, r, n, a) {
    if (ae || cc(), !ae)
      return Rf("PIXI was not found. PixiPlugin.registerPIXI(PIXI);"), !1;
    var l, h, u, f, p, m, g, x, o, c;
    for (m in e) {
      if (l = Co[m], u = e[m], l)
        h = ~m.charAt(m.length - 1).toLowerCase().indexOf("x") ? "x" : "y", this.add(t[l], h, t[l][h], l === "skew" ? M0(u) : u, 0, 0, 0, 0, 0, 1);
      else if (m === "scale" || m === "anchor" || m === "pivot" || m === "tileScale")
        this.add(t[m], "x", t[m].x, u), this.add(t[m], "y", t[m].y, u);
      else if (m === "rotation" || m === "angle")
        U0(this, t, m, t[m], u, m === "rotation");
      else if (P0[m])
        f || (S0(t, e.colorMatrixFilter || e, this), f = !0);
      else if (m === "blur" || m === "blurX" || m === "blurY" || m === "blurPadding") {
        if (p = kf(t, "BlurFilter"), this.add(p, m, p[m], u), e.blurPadding !== 0)
          for (g = e.blurPadding || Math.max(p[m], u) * 2, x = t.filters.length; --x > -1; )
            t.filters[x].padding = Math.max(t.filters[x].padding, g);
      } else if (A0[m])
        if ((m === "lineColor" || m === "fillColor" || m === "strokeColor") && t instanceof ae.Graphics)
          for (o = ("fillStyle" in t) ? [t] : (t.geometry || t).graphicsData, c = m.substr(0, m.length - 5), Gn && c === "line" && (c = "stroke"), this._pt = new Vr(this._pt, t, m, 0, 0, C0, {
            g: t.geometry || t
          }), x = o.length; --x > -1; )
            hc(So ? o[x] : o[x][c + "Style"], So ? m : "color", u, this);
        else
          hc(t, m, u, this);
      else m === "autoAlpha" ? (this._pt = new Vr(this._pt, t, "visible", 0, 0, E0), this.add(t, "alpha", t.alpha, u), this._props.push("alpha", "visible")) : m !== "resolution" && this.add(t, m, "get", u);
      this._props.push(m);
    }
  }
};
Uf() && Je.registerPlugin(ms);
var A = /* @__PURE__ */ ((s) => (s.Application = "application", s.WebGLPipes = "webgl-pipes", s.WebGLPipesAdaptor = "webgl-pipes-adaptor", s.WebGLSystem = "webgl-system", s.WebGPUPipes = "webgpu-pipes", s.WebGPUPipesAdaptor = "webgpu-pipes-adaptor", s.WebGPUSystem = "webgpu-system", s.CanvasSystem = "canvas-system", s.CanvasPipesAdaptor = "canvas-pipes-adaptor", s.CanvasPipes = "canvas-pipes", s.Asset = "asset", s.LoadParser = "load-parser", s.ResolveParser = "resolve-parser", s.CacheParser = "cache-parser", s.DetectionParser = "detection-parser", s.MaskEffect = "mask-effect", s.BlendMode = "blend-mode", s.TextureSource = "texture-source", s.Environment = "environment", s.ShapeBuilder = "shape-builder", s.Batcher = "batcher", s))(A || {});
const Eo = (s) => {
  if (typeof s == "function" || typeof s == "object" && s.extension) {
    if (!s.extension)
      throw new Error("Extension class must have an extension object");
    s = { ...typeof s.extension != "object" ? { type: s.extension } : s.extension, ref: s };
  }
  if (typeof s == "object")
    s = { ...s };
  else
    throw new Error("Invalid extension type");
  return typeof s.type == "string" && (s.type = [s.type]), s;
}, Bs = (s, t) => Eo(s).priority ?? t, L = {
  /** @ignore */
  _addHandlers: {},
  /** @ignore */
  _removeHandlers: {},
  /** @ignore */
  _queue: {},
  /**
   * Remove extensions from PixiJS.
   * @param extensions - Extensions to be removed. Can be:
   * - Extension class with static `extension` property
   * - Extension format object with `type` and `ref`
   * - Multiple extensions as separate arguments
   * @returns {extensions} this for chaining
   * @example
   * ```ts
   * // Remove a single extension
   * extensions.remove(MyRendererPlugin);
   *
   * // Remove multiple extensions
   * extensions.remove(
   *     MyRendererPlugin,
   *     MySystemPlugin
   * );
   * ```
   * @see {@link ExtensionType} For available extension types
   * @see {@link ExtensionFormat} For extension format details
   */
  remove(...s) {
    return s.map(Eo).forEach((t) => {
      t.type.forEach((e) => this._removeHandlers[e]?.(t));
    }), this;
  },
  /**
   * Register new extensions with PixiJS. Extensions can be registered in multiple formats:
   * - As a class with a static `extension` property
   * - As an extension format object
   * - As multiple extensions passed as separate arguments
   * @param extensions - Extensions to add to PixiJS. Each can be:
   * - A class with static `extension` property
   * - An extension format object with `type` and `ref`
   * - Multiple extensions as separate arguments
   * @returns This extensions instance for chaining
   * @example
   * ```ts
   * // Register a simple extension
   * extensions.add(MyRendererPlugin);
   *
   * // Register multiple extensions
   * extensions.add(
   *     MyRendererPlugin,
   *     MySystemPlugin,
   * });
   * ```
   * @see {@link ExtensionType} For available extension types
   * @see {@link ExtensionFormat} For extension format details
   * @see {@link extensions.remove} For removing registered extensions
   */
  add(...s) {
    return s.map(Eo).forEach((t) => {
      t.type.forEach((e) => {
        const r = this._addHandlers, n = this._queue;
        r[e] ? r[e]?.(t) : (n[e] = n[e] || [], n[e]?.push(t));
      });
    }), this;
  },
  /**
   * Internal method to handle extensions by name.
   * @param type - The extension type.
   * @param onAdd  - Function handler when extensions are added/registered {@link StrictExtensionFormat}.
   * @param onRemove  - Function handler when extensions are removed/unregistered {@link StrictExtensionFormat}.
   * @returns this for chaining.
   * @internal
   * @ignore
   */
  handle(s, t, e) {
    const r = this._addHandlers, n = this._removeHandlers;
    if (r[s] || n[s])
      throw new Error(`Extension type ${s} already has a handler`);
    r[s] = t, n[s] = e;
    const a = this._queue;
    return a[s] && (a[s]?.forEach((l) => t(l)), delete a[s]), this;
  },
  /**
   * Handle a type, but using a map by `name` property.
   * @param type - Type of extension to handle.
   * @param map - The object map of named extensions.
   * @returns this for chaining.
   * @ignore
   */
  handleByMap(s, t) {
    return this.handle(
      s,
      (e) => {
        e.name && (t[e.name] = e.ref);
      },
      (e) => {
        e.name && delete t[e.name];
      }
    );
  },
  /**
   * Handle a type, but using a list of extensions with a `name` property.
   * @param type - Type of extension to handle.
   * @param map - The array of named extensions.
   * @param defaultPriority - Fallback priority if none is defined.
   * @returns this for chaining.
   * @ignore
   */
  handleByNamedList(s, t, e = -1) {
    return this.handle(
      s,
      (r) => {
        t.findIndex((a) => a.name === r.name) >= 0 || (t.push({ name: r.name, value: r.ref }), t.sort((a, l) => Bs(l.value, e) - Bs(a.value, e)));
      },
      (r) => {
        const n = t.findIndex((a) => a.name === r.name);
        n !== -1 && t.splice(n, 1);
      }
    );
  },
  /**
   * Handle a type, but using a list of extensions.
   * @param type - Type of extension to handle.
   * @param list - The list of extensions.
   * @param defaultPriority - The default priority to use if none is specified.
   * @returns this for chaining.
   * @ignore
   */
  handleByList(s, t, e = -1) {
    return this.handle(
      s,
      (r) => {
        t.includes(r.ref) || (t.push(r.ref), t.sort((n, a) => Bs(a, e) - Bs(n, e)));
      },
      (r) => {
        const n = t.indexOf(r.ref);
        n !== -1 && t.splice(n, 1);
      }
    );
  },
  /**
   * Mixin the source object(s) properties into the target class's prototype.
   * Copies all property descriptors from source objects to the target's prototype.
   * @param Target - The target class to mix properties into
   * @param sources - One or more source objects containing properties to mix in
   * @example
   * ```ts
   * // Create a mixin with shared properties
   * const moveable = {
   *     x: 0,
   *     y: 0,
   *     move(x: number, y: number) {
   *         this.x += x;
   *         this.y += y;
   *     }
   * };
   *
   * // Create a mixin with computed properties
   * const scalable = {
   *     scale: 1,
   *     get scaled() {
   *         return this.scale > 1;
   *     }
   * };
   *
   * // Apply mixins to a class
   * extensions.mixin(Sprite, moveable, scalable);
   *
   * // Use mixed-in properties
   * const sprite = new Sprite();
   * sprite.move(10, 20);
   * console.log(sprite.x, sprite.y); // 10, 20
   * ```
   * @remarks
   * - Copies all properties including getters/setters
   * - Does not modify source objects
   * - Preserves property descriptors
   * @see {@link Object.defineProperties} For details on property descriptors
   * @see {@link Object.getOwnPropertyDescriptors} For details on property copying
   */
  mixin(s, ...t) {
    for (const e of t)
      Object.defineProperties(s.prototype, Object.getOwnPropertyDescriptors(e));
  }
}, R0 = {
  extension: {
    type: A.Environment,
    name: "browser",
    priority: -1
  },
  test: () => !0,
  load: async () => {
    await Promise.resolve().then(() => DE);
  }
}, I0 = {
  extension: {
    type: A.Environment,
    name: "webworker",
    priority: 0
  },
  test: () => typeof self < "u" && self.WorkerGlobalScope !== void 0,
  load: async () => {
    await Promise.resolve().then(() => OE);
  }
};
class Ft {
  /**
   * Creates a new `ObservablePoint`
   * @param observer - Observer to pass to listen for change events.
   * @param {number} [x=0] - position of the point on the x axis
   * @param {number} [y=0] - position of the point on the y axis
   */
  constructor(t, e, r) {
    this._x = e || 0, this._y = r || 0, this._observer = t;
  }
  /**
   * Creates a clone of this point.
   * @example
   * ```ts
   * // Basic cloning
   * const point = new ObservablePoint(observer, 100, 200);
   * const copy = point.clone();
   *
   * // Clone with new observer
   * const newObserver = {
   *     _onUpdate: (p) => console.log(`Clone updated: (${p.x}, ${p.y})`)
   * };
   * const watched = point.clone(newObserver);
   *
   * // Verify independence
   * watched.set(300, 400); // Only triggers new observer
   * ```
   * @param observer - Optional observer to pass to the new observable point
   * @returns A copy of this observable point
   * @see {@link ObservablePoint.copyFrom} For copying into existing point
   * @see {@link Observer} For observer interface details
   */
  clone(t) {
    return new Ft(t ?? this._observer, this._x, this._y);
  }
  /**
   * Sets the point to a new x and y position.
   *
   * If y is omitted, both x and y will be set to x.
   * @example
   * ```ts
   * // Basic position setting
   * const point = new ObservablePoint(observer);
   * point.set(100, 200);
   *
   * // Set both x and y to same value
   * point.set(50); // x=50, y=50
   * ```
   * @param x - Position on the x axis
   * @param y - Position on the y axis, defaults to x
   * @returns The point instance itself
   * @see {@link ObservablePoint.copyFrom} For copying from another point
   * @see {@link ObservablePoint.equals} For comparing positions
   */
  set(t = 0, e = t) {
    return (this._x !== t || this._y !== e) && (this._x = t, this._y = e, this._observer._onUpdate(this)), this;
  }
  /**
   * Copies x and y from the given point into this point.
   * @example
   * ```ts
   * // Basic copying
   * const source = new ObservablePoint(observer, 100, 200);
   * const target = new ObservablePoint();
   * target.copyFrom(source);
   *
   * // Copy and chain operations
   * const point = new ObservablePoint()
   *     .copyFrom(source)
   *     .set(x + 50, y + 50);
   *
   * // Copy from any PointData
   * const data = { x: 10, y: 20 };
   * point.copyFrom(data);
   * ```
   * @param p - The point to copy from
   * @returns The point instance itself
   * @see {@link ObservablePoint.copyTo} For copying to another point
   * @see {@link ObservablePoint.clone} For creating new point copy
   */
  copyFrom(t) {
    return (this._x !== t.x || this._y !== t.y) && (this._x = t.x, this._y = t.y, this._observer._onUpdate(this)), this;
  }
  /**
   * Copies this point's x and y into the given point.
   * @example
   * ```ts
   * // Basic copying
   * const source = new ObservablePoint(100, 200);
   * const target = new ObservablePoint();
   * source.copyTo(target);
   * ```
   * @param p - The point to copy to. Can be any type that is or extends `PointLike`
   * @returns The point (`p`) with values updated
   * @see {@link ObservablePoint.copyFrom} For copying from another point
   * @see {@link ObservablePoint.clone} For creating new point copy
   */
  copyTo(t) {
    return t.set(this._x, this._y), t;
  }
  /**
   * Checks if another point is equal to this point.
   *
   * Compares x and y values using strict equality.
   * @example
   * ```ts
   * // Basic equality check
   * const p1 = new ObservablePoint(100, 200);
   * const p2 = new ObservablePoint(100, 200);
   * console.log(p1.equals(p2)); // true
   *
   * // Compare with PointData
   * const data = { x: 100, y: 200 };
   * console.log(p1.equals(data)); // true
   *
   * // Check different points
   * const p3 = new ObservablePoint(200, 300);
   * console.log(p1.equals(p3)); // false
   * ```
   * @param p - The point to check
   * @returns `true` if both `x` and `y` are equal
   * @see {@link ObservablePoint.copyFrom} For making points equal
   * @see {@link PointData} For point data interface
   */
  equals(t) {
    return t.x === this._x && t.y === this._y;
  }
  toString() {
    return `[pixi.js/math:ObservablePoint x=${this._x} y=${this._y} scope=${this._observer}]`;
  }
  /**
   * Position of the observable point on the x axis.
   * Triggers observer callback when value changes.
   * @example
   * ```ts
   * // Basic x position
   * const point = new ObservablePoint(observer);
   * point.x = 100; // Triggers observer
   *
   * // Use in calculations
   * const width = rightPoint.x - leftPoint.x;
   * ```
   * @default 0
   */
  get x() {
    return this._x;
  }
  set x(t) {
    this._x !== t && (this._x = t, this._observer._onUpdate(this));
  }
  /**
   * Position of the observable point on the y axis.
   * Triggers observer callback when value changes.
   * @example
   * ```ts
   * // Basic y position
   * const point = new ObservablePoint(observer);
   * point.y = 200; // Triggers observer
   *
   * // Use in calculations
   * const height = bottomPoint.y - topPoint.y;
   * ```
   * @default 0
   */
  get y() {
    return this._y;
  }
  set y(t) {
    this._y !== t && (this._y = t, this._observer._onUpdate(this));
  }
}
var na = { exports: {} }, uc;
function k0() {
  return uc || (uc = 1, function(s) {
    var t = Object.prototype.hasOwnProperty, e = "~";
    function r() {
    }
    Object.create && (r.prototype = /* @__PURE__ */ Object.create(null), new r().__proto__ || (e = !1));
    function n(u, f, p) {
      this.fn = u, this.context = f, this.once = p || !1;
    }
    function a(u, f, p, m, g) {
      if (typeof p != "function")
        throw new TypeError("The listener must be a function");
      var x = new n(p, m || u, g), o = e ? e + f : f;
      return u._events[o] ? u._events[o].fn ? u._events[o] = [u._events[o], x] : u._events[o].push(x) : (u._events[o] = x, u._eventsCount++), u;
    }
    function l(u, f) {
      --u._eventsCount === 0 ? u._events = new r() : delete u._events[f];
    }
    function h() {
      this._events = new r(), this._eventsCount = 0;
    }
    h.prototype.eventNames = function() {
      var f = [], p, m;
      if (this._eventsCount === 0) return f;
      for (m in p = this._events)
        t.call(p, m) && f.push(e ? m.slice(1) : m);
      return Object.getOwnPropertySymbols ? f.concat(Object.getOwnPropertySymbols(p)) : f;
    }, h.prototype.listeners = function(f) {
      var p = e ? e + f : f, m = this._events[p];
      if (!m) return [];
      if (m.fn) return [m.fn];
      for (var g = 0, x = m.length, o = new Array(x); g < x; g++)
        o[g] = m[g].fn;
      return o;
    }, h.prototype.listenerCount = function(f) {
      var p = e ? e + f : f, m = this._events[p];
      return m ? m.fn ? 1 : m.length : 0;
    }, h.prototype.emit = function(f, p, m, g, x, o) {
      var c = e ? e + f : f;
      if (!this._events[c]) return !1;
      var d = this._events[c], _ = arguments.length, y, v;
      if (d.fn) {
        switch (d.once && this.removeListener(f, d.fn, void 0, !0), _) {
          case 1:
            return d.fn.call(d.context), !0;
          case 2:
            return d.fn.call(d.context, p), !0;
          case 3:
            return d.fn.call(d.context, p, m), !0;
          case 4:
            return d.fn.call(d.context, p, m, g), !0;
          case 5:
            return d.fn.call(d.context, p, m, g, x), !0;
          case 6:
            return d.fn.call(d.context, p, m, g, x, o), !0;
        }
        for (v = 1, y = new Array(_ - 1); v < _; v++)
          y[v - 1] = arguments[v];
        d.fn.apply(d.context, y);
      } else {
        var b = d.length, w;
        for (v = 0; v < b; v++)
          switch (d[v].once && this.removeListener(f, d[v].fn, void 0, !0), _) {
            case 1:
              d[v].fn.call(d[v].context);
              break;
            case 2:
              d[v].fn.call(d[v].context, p);
              break;
            case 3:
              d[v].fn.call(d[v].context, p, m);
              break;
            case 4:
              d[v].fn.call(d[v].context, p, m, g);
              break;
            default:
              if (!y) for (w = 1, y = new Array(_ - 1); w < _; w++)
                y[w - 1] = arguments[w];
              d[v].fn.apply(d[v].context, y);
          }
      }
      return !0;
    }, h.prototype.on = function(f, p, m) {
      return a(this, f, p, m, !1);
    }, h.prototype.once = function(f, p, m) {
      return a(this, f, p, m, !0);
    }, h.prototype.removeListener = function(f, p, m, g) {
      var x = e ? e + f : f;
      if (!this._events[x]) return this;
      if (!p)
        return l(this, x), this;
      var o = this._events[x];
      if (o.fn)
        o.fn === p && (!g || o.once) && (!m || o.context === m) && l(this, x);
      else {
        for (var c = 0, d = [], _ = o.length; c < _; c++)
          (o[c].fn !== p || g && !o[c].once || m && o[c].context !== m) && d.push(o[c]);
        d.length ? this._events[x] = d.length === 1 ? d[0] : d : l(this, x);
      }
      return this;
    }, h.prototype.removeAllListeners = function(f) {
      var p;
      return f ? (p = e ? e + f : f, this._events[p] && l(this, p)) : (this._events = new r(), this._eventsCount = 0), this;
    }, h.prototype.off = h.prototype.removeListener, h.prototype.addListener = h.prototype.on, h.prefixed = e, h.EventEmitter = h, s.exports = h;
  }(na)), na.exports;
}
var F0 = k0();
const te = /* @__PURE__ */ ih(F0), D0 = Math.PI * 2, O0 = 180 / Math.PI, L0 = Math.PI / 180;
class et {
  /**
   * Creates a new `Point`
   * @param {number} [x=0] - position of the point on the x axis
   * @param {number} [y=0] - position of the point on the y axis
   */
  constructor(t = 0, e = 0) {
    this.x = 0, this.y = 0, this.x = t, this.y = e;
  }
  /**
   * Creates a clone of this point, which is a new instance with the same `x` and `y` values.
   * @example
   * ```ts
   * // Basic point cloning
   * const original = new Point(100, 200);
   * const copy = original.clone();
   *
   * // Clone and modify
   * const modified = original.clone();
   * modified.set(300, 400);
   *
   * // Verify independence
   * console.log(original); // Point(100, 200)
   * console.log(modified); // Point(300, 400)
   * ```
   * @remarks
   * - Creates new Point instance
   * - Deep copies x and y values
   * - Independent from original
   * - Useful for preserving values
   * @returns A clone of this point
   * @see {@link Point.copyFrom} For copying into existing point
   * @see {@link Point.copyTo} For copying to existing point
   */
  clone() {
    return new et(this.x, this.y);
  }
  /**
   * Copies x and y from the given point into this point.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Point(100, 200);
   * const target = new Point();
   * target.copyFrom(source);
   *
   * // Copy and chain operations
   * const point = new Point()
   *     .copyFrom(source)
   *     .set(x + 50, y + 50);
   *
   * // Copy from any PointData
   * const data = { x: 10, y: 20 };
   * point.copyFrom(data);
   * ```
   * @param p - The point to copy from
   * @returns The point instance itself
   * @see {@link Point.copyTo} For copying to another point
   * @see {@link Point.clone} For creating new point copy
   */
  copyFrom(t) {
    return this.set(t.x, t.y), this;
  }
  /**
   * Copies this point's x and y into the given point.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Point(100, 200);
   * const target = new Point();
   * source.copyTo(target);
   * ```
   * @param p - The point to copy to. Can be any type that is or extends `PointLike`
   * @returns The point (`p`) with values updated
   * @see {@link Point.copyFrom} For copying from another point
   * @see {@link Point.clone} For creating new point copy
   */
  copyTo(t) {
    return t.set(this.x, this.y), t;
  }
  /**
   * Checks if another point is equal to this point.
   *
   * Compares x and y values using strict equality.
   * @example
   * ```ts
   * // Basic equality check
   * const p1 = new Point(100, 200);
   * const p2 = new Point(100, 200);
   * console.log(p1.equals(p2)); // true
   *
   * // Compare with PointData
   * const data = { x: 100, y: 200 };
   * console.log(p1.equals(data)); // true
   *
   * // Check different points
   * const p3 = new Point(200, 300);
   * console.log(p1.equals(p3)); // false
   * ```
   * @param p - The point to check
   * @returns `true` if both `x` and `y` are equal
   * @see {@link Point.copyFrom} For making points equal
   * @see {@link PointData} For point data interface
   */
  equals(t) {
    return t.x === this.x && t.y === this.y;
  }
  /**
   * Sets the point to a new x and y position.
   *
   * If y is omitted, both x and y will be set to x.
   * @example
   * ```ts
   * // Basic position setting
   * const point = new Point();
   * point.set(100, 200);
   *
   * // Set both x and y to same value
   * point.set(50); // x=50, y=50
   *
   * // Chain with other operations
   * point
   *     .set(10, 20)
   *     .copyTo(otherPoint);
   * ```
   * @param x - Position on the x axis
   * @param y - Position on the y axis, defaults to x
   * @returns The point instance itself
   * @see {@link Point.copyFrom} For copying from another point
   * @see {@link Point.equals} For comparing positions
   */
  set(t = 0, e = t) {
    return this.x = t, this.y = e, this;
  }
  toString() {
    return `[pixi.js/math:Point x=${this.x} y=${this.y}]`;
  }
  /**
   * A static Point object with `x` and `y` values of `0`.
   *
   * This shared instance is reset to zero values when accessed.
   *
   * > [!IMPORTANT] This point is shared and temporary. Do not store references to it.
   * @example
   * ```ts
   * // Use for temporary calculations
   * const tempPoint = Point.shared;
   * tempPoint.set(100, 200);
   * matrix.apply(tempPoint);
   *
   * // Will be reset to (0,0) on next access
   * const fresh = Point.shared; // x=0, y=0
   * ```
   * @readonly
   * @returns A fresh zeroed point for temporary use
   * @see {@link Point.constructor} For creating new points
   * @see {@link PointData} For basic point interface
   */
  static get shared() {
    return aa.x = 0, aa.y = 0, aa;
  }
}
const aa = new et();
class D {
  /**
   * @param a - x scale
   * @param b - y skew
   * @param c - x skew
   * @param d - y scale
   * @param tx - x translation
   * @param ty - y translation
   */
  constructor(t = 1, e = 0, r = 0, n = 1, a = 0, l = 0) {
    this.array = null, this.a = t, this.b = e, this.c = r, this.d = n, this.tx = a, this.ty = l;
  }
  /**
   * Creates a Matrix object based on the given array.
   * Populates matrix components from a flat array in column-major order.
   *
   * > [!NOTE] Array mapping order:
   * > ```
   * > array[0] = a  (x scale)
   * > array[1] = b  (y skew)
   * > array[2] = tx (x translation)
   * > array[3] = c  (x skew)
   * > array[4] = d  (y scale)
   * > array[5] = ty (y translation)
   * > ```
   * @example
   * ```ts
   * // Create matrix from array
   * const matrix = new Matrix();
   * matrix.fromArray([
   *     2, 0,  100,  // a, b, tx
   *     0, 2,  100   // c, d, ty
   * ]);
   *
   * // Create matrix from typed array
   * const float32Array = new Float32Array([
   *     1, 0, 0,     // Scale x1, no skew
   *     0, 1, 0      // No skew, scale x1
   * ]);
   * matrix.fromArray(float32Array);
   * ```
   * @param array - The array to populate the matrix from
   * @see {@link Matrix.toArray} For converting matrix to array
   * @see {@link Matrix.set} For setting values directly
   */
  fromArray(t) {
    this.a = t[0], this.b = t[1], this.c = t[3], this.d = t[4], this.tx = t[2], this.ty = t[5];
  }
  /**
   * Sets the matrix properties directly.
   * All matrix components can be set in one call.
   * @example
   * ```ts
   * // Set to identity matrix
   * matrix.set(1, 0, 0, 1, 0, 0);
   *
   * // Set to scale matrix
   * matrix.set(2, 0, 0, 2, 0, 0); // Scale 2x
   *
   * // Set to translation matrix
   * matrix.set(1, 0, 0, 1, 100, 50); // Move 100,50
   * ```
   * @param a - Scale on x axis
   * @param b - Shear on y axis
   * @param c - Shear on x axis
   * @param d - Scale on y axis
   * @param tx - Translation on x axis
   * @param ty - Translation on y axis
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.identity} For resetting to identity
   * @see {@link Matrix.fromArray} For setting from array
   */
  set(t, e, r, n, a, l) {
    return this.a = t, this.b = e, this.c = r, this.d = n, this.tx = a, this.ty = l, this;
  }
  /**
   * Creates an array from the current Matrix object.
   *
   * > [!NOTE] The array format is:
   * > ```
   * > Non-transposed:
   * > [a, c, tx,
   * > b, d, ty,
   * > 0, 0, 1]
   * >
   * > Transposed:
   * > [a, b, 0,
   * > c, d, 0,
   * > tx,ty,1]
   * > ```
   * @example
   * ```ts
   * // Basic array conversion
   * const matrix = new Matrix(2, 0, 0, 2, 100, 100);
   * const array = matrix.toArray();
   *
   * // Using existing array
   * const float32Array = new Float32Array(9);
   * matrix.toArray(false, float32Array);
   *
   * // Get transposed array
   * const transposed = matrix.toArray(true);
   * ```
   * @param transpose - Whether to transpose the matrix
   * @param out - Optional Float32Array to store the result
   * @returns The array containing the matrix values
   * @see {@link Matrix.fromArray} For creating matrix from array
   * @see {@link Matrix.array} For cached array storage
   */
  toArray(t, e) {
    this.array || (this.array = new Float32Array(9));
    const r = e || this.array;
    return t ? (r[0] = this.a, r[1] = this.b, r[2] = 0, r[3] = this.c, r[4] = this.d, r[5] = 0, r[6] = this.tx, r[7] = this.ty, r[8] = 1) : (r[0] = this.a, r[1] = this.c, r[2] = this.tx, r[3] = this.b, r[4] = this.d, r[5] = this.ty, r[6] = 0, r[7] = 0, r[8] = 1), r;
  }
  /**
   * Get a new position with the current transformation applied.
   *
   * Can be used to go from a child's coordinate space to the world coordinate space. (e.g. rendering)
   * @example
   * ```ts
   * // Basic point transformation
   * const matrix = new Matrix().translate(100, 50).rotate(Math.PI / 4);
   * const point = new Point(10, 20);
   * const transformed = matrix.apply(point);
   *
   * // Reuse existing point
   * const output = new Point();
   * matrix.apply(point, output);
   * ```
   * @param pos - The origin point to transform
   * @param newPos - Optional point to store the result
   * @returns The transformed point
   * @see {@link Matrix.applyInverse} For inverse transformation
   * @see {@link Point} For point operations
   */
  apply(t, e) {
    e = e || new et();
    const r = t.x, n = t.y;
    return e.x = this.a * r + this.c * n + this.tx, e.y = this.b * r + this.d * n + this.ty, e;
  }
  /**
   * Get a new position with the inverse of the current transformation applied.
   *
   * Can be used to go from the world coordinate space to a child's coordinate space. (e.g. input)
   * @example
   * ```ts
   * // Basic inverse transformation
   * const matrix = new Matrix().translate(100, 50).rotate(Math.PI / 4);
   * const worldPoint = new Point(150, 100);
   * const localPoint = matrix.applyInverse(worldPoint);
   *
   * // Reuse existing point
   * const output = new Point();
   * matrix.applyInverse(worldPoint, output);
   *
   * // Convert mouse position to local space
   * const mousePoint = new Point(mouseX, mouseY);
   * const localMouse = matrix.applyInverse(mousePoint);
   * ```
   * @param pos - The origin point to inverse-transform
   * @param newPos - Optional point to store the result
   * @returns The inverse-transformed point
   * @see {@link Matrix.apply} For forward transformation
   * @see {@link Matrix.invert} For getting inverse matrix
   */
  applyInverse(t, e) {
    e = e || new et();
    const r = this.a, n = this.b, a = this.c, l = this.d, h = this.tx, u = this.ty, f = 1 / (r * l + a * -n), p = t.x, m = t.y;
    return e.x = l * f * p + -a * f * m + (u * a - h * l) * f, e.y = r * f * m + -n * f * p + (-u * r + h * n) * f, e;
  }
  /**
   * Translates the matrix on the x and y axes.
   * Adds to the position values while preserving scale, rotation and skew.
   * @example
   * ```ts
   * // Basic translation
   * const matrix = new Matrix();
   * matrix.translate(100, 50); // Move right 100, down 50
   *
   * // Chain with other transformations
   * matrix
   *     .scale(2, 2)
   *     .translate(100, 0)
   *     .rotate(Math.PI / 4);
   * ```
   * @param x - How much to translate on the x axis
   * @param y - How much to translate on the y axis
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.set} For setting position directly
   * @see {@link Matrix.setTransform} For complete transform setup
   */
  translate(t, e) {
    return this.tx += t, this.ty += e, this;
  }
  /**
   * Applies a scale transformation to the matrix.
   * Multiplies the scale values with existing matrix components.
   * @example
   * ```ts
   * // Basic scaling
   * const matrix = new Matrix();
   * matrix.scale(2, 3); // Scale 2x horizontally, 3x vertically
   *
   * // Chain with other transformations
   * matrix
   *     .translate(100, 100)
   *     .scale(2, 2)     // Scales after translation
   *     .rotate(Math.PI / 4);
   * ```
   * @param x - The amount to scale horizontally
   * @param y - The amount to scale vertically
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.setTransform} For setting scale directly
   * @see {@link Matrix.append} For combining transformations
   */
  scale(t, e) {
    return this.a *= t, this.d *= e, this.c *= t, this.b *= e, this.tx *= t, this.ty *= e, this;
  }
  /**
   * Applies a rotation transformation to the matrix.
   *
   * Rotates around the origin (0,0) by the given angle in radians.
   * @example
   * ```ts
   * // Basic rotation
   * const matrix = new Matrix();
   * matrix.rotate(Math.PI / 4); // Rotate 45 degrees
   *
   * // Chain with other transformations
   * matrix
   *     .translate(100, 100) // Move to rotation center
   *     .rotate(Math.PI)     // Rotate 180 degrees
   *     .scale(2, 2);        // Scale after rotation
   *
   * // Common angles
   * matrix.rotate(Math.PI / 2);  // 90 degrees
   * matrix.rotate(Math.PI);      // 180 degrees
   * matrix.rotate(Math.PI * 2);  // 360 degrees
   * ```
   * @remarks
   * - Rotates around origin point (0,0)
   * - Affects position if translation was set
   * - Uses counter-clockwise rotation
   * - Order of operations matters when chaining
   * @param angle - The angle in radians
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.setTransform} For setting rotation directly
   * @see {@link Matrix.append} For combining transformations
   */
  rotate(t) {
    const e = Math.cos(t), r = Math.sin(t), n = this.a, a = this.c, l = this.tx;
    return this.a = n * e - this.b * r, this.b = n * r + this.b * e, this.c = a * e - this.d * r, this.d = a * r + this.d * e, this.tx = l * e - this.ty * r, this.ty = l * r + this.ty * e, this;
  }
  /**
   * Appends the given Matrix to this Matrix.
   * Combines two matrices by multiplying them together: this = this * matrix
   * @example
   * ```ts
   * // Basic matrix combination
   * const matrix = new Matrix();
   * const other = new Matrix().translate(100, 0).rotate(Math.PI / 4);
   * matrix.append(other);
   * ```
   * @remarks
   * - Order matters: A.append(B) !== B.append(A)
   * - Modifies current matrix
   * - Preserves transformation order
   * - Commonly used for combining transforms
   * @param matrix - The matrix to append
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.prepend} For prepending transformations
   * @see {@link Matrix.appendFrom} For appending two external matrices
   */
  append(t) {
    const e = this.a, r = this.b, n = this.c, a = this.d;
    return this.a = t.a * e + t.b * n, this.b = t.a * r + t.b * a, this.c = t.c * e + t.d * n, this.d = t.c * r + t.d * a, this.tx = t.tx * e + t.ty * n + this.tx, this.ty = t.tx * r + t.ty * a + this.ty, this;
  }
  /**
   * Appends two matrices and sets the result to this matrix.
   * Performs matrix multiplication: this = A * B
   * @example
   * ```ts
   * // Basic matrix multiplication
   * const result = new Matrix();
   * const matrixA = new Matrix().scale(2, 2);
   * const matrixB = new Matrix().rotate(Math.PI / 4);
   * result.appendFrom(matrixA, matrixB);
   * ```
   * @remarks
   * - Order matters: A * B !== B * A
   * - Creates a new transformation from two others
   * - More efficient than append() for multiple operations
   * - Does not modify input matrices
   * @param a - The first matrix to multiply
   * @param b - The second matrix to multiply
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.append} For single matrix combination
   * @see {@link Matrix.prepend} For reverse order multiplication
   */
  appendFrom(t, e) {
    const r = t.a, n = t.b, a = t.c, l = t.d, h = t.tx, u = t.ty, f = e.a, p = e.b, m = e.c, g = e.d;
    return this.a = r * f + n * m, this.b = r * p + n * g, this.c = a * f + l * m, this.d = a * p + l * g, this.tx = h * f + u * m + e.tx, this.ty = h * p + u * g + e.ty, this;
  }
  /**
   * Sets the matrix based on all the available properties.
   * Combines position, scale, rotation, skew and pivot in a single operation.
   * @example
   * ```ts
   * // Basic transform setup
   * const matrix = new Matrix();
   * matrix.setTransform(
   *     100, 100,    // position
   *     0, 0,        // pivot
   *     2, 2,        // scale
   *     Math.PI / 4, // rotation (45 degrees)
   *     0, 0         // skew
   * );
   * ```
   * @remarks
   * - Updates all matrix components at once
   * - More efficient than separate transform calls
   * - Uses radians for rotation and skew
   * - Pivot affects rotation center
   * @param x - Position on the x axis
   * @param y - Position on the y axis
   * @param pivotX - Pivot on the x axis
   * @param pivotY - Pivot on the y axis
   * @param scaleX - Scale on the x axis
   * @param scaleY - Scale on the y axis
   * @param rotation - Rotation in radians
   * @param skewX - Skew on the x axis
   * @param skewY - Skew on the y axis
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.decompose} For extracting transform properties
   * @see {@link TransformableObject} For transform data structure
   */
  setTransform(t, e, r, n, a, l, h, u, f) {
    return this.a = Math.cos(h + f) * a, this.b = Math.sin(h + f) * a, this.c = -Math.sin(h - u) * l, this.d = Math.cos(h - u) * l, this.tx = t - (r * this.a + n * this.c), this.ty = e - (r * this.b + n * this.d), this;
  }
  /**
   * Prepends the given Matrix to this Matrix.
   * Combines two matrices by multiplying them together: this = matrix * this
   * @example
   * ```ts
   * // Basic matrix prepend
   * const matrix = new Matrix().scale(2, 2);
   * const other = new Matrix().translate(100, 0);
   * matrix.prepend(other); // Translation happens before scaling
   * ```
   * @remarks
   * - Order matters: A.prepend(B) !== B.prepend(A)
   * - Modifies current matrix
   * - Reverses transformation order compared to append()
   * @param matrix - The matrix to prepend
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.append} For appending transformations
   * @see {@link Matrix.appendFrom} For combining external matrices
   */
  prepend(t) {
    const e = this.tx;
    if (t.a !== 1 || t.b !== 0 || t.c !== 0 || t.d !== 1) {
      const r = this.a, n = this.c;
      this.a = r * t.a + this.b * t.c, this.b = r * t.b + this.b * t.d, this.c = n * t.a + this.d * t.c, this.d = n * t.b + this.d * t.d;
    }
    return this.tx = e * t.a + this.ty * t.c + t.tx, this.ty = e * t.b + this.ty * t.d + t.ty, this;
  }
  /**
   * Decomposes the matrix into its individual transform components.
   * Extracts position, scale, rotation and skew values from the matrix.
   * @example
   * ```ts
   * // Basic decomposition
   * const matrix = new Matrix()
   *     .translate(100, 100)
   *     .rotate(Math.PI / 4)
   *     .scale(2, 2);
   *
   * const transform = {
   *     position: new Point(),
   *     scale: new Point(),
   *     pivot: new Point(),
   *     skew: new Point(),
   *     rotation: 0
   * };
   *
   * matrix.decompose(transform);
   * console.log(transform.position); // Point(100, 100)
   * console.log(transform.rotation); // ~0.785 (PI/4)
   * console.log(transform.scale); // Point(2, 2)
   * ```
   * @remarks
   * - Handles combined transformations
   * - Accounts for pivot points
   * - Chooses between rotation/skew based on transform type
   * - Uses radians for rotation and skew
   * @param transform - The transform object to store the decomposed values
   * @returns The transform with the newly applied properties
   * @see {@link Matrix.setTransform} For composing from components
   * @see {@link TransformableObject} For transform structure
   */
  decompose(t) {
    const e = this.a, r = this.b, n = this.c, a = this.d, l = t.pivot, h = -Math.atan2(-n, a), u = Math.atan2(r, e), f = Math.abs(h + u);
    return f < 1e-5 || Math.abs(D0 - f) < 1e-5 ? (t.rotation = u, t.skew.x = t.skew.y = 0) : (t.rotation = 0, t.skew.x = h, t.skew.y = u), t.scale.x = Math.sqrt(e * e + r * r), t.scale.y = Math.sqrt(n * n + a * a), t.position.x = this.tx + (l.x * e + l.y * n), t.position.y = this.ty + (l.x * r + l.y * a), t;
  }
  /**
   * Inverts this matrix.
   * Creates the matrix that when multiplied with this matrix results in an identity matrix.
   * @example
   * ```ts
   * // Basic matrix inversion
   * const matrix = new Matrix()
   *     .translate(100, 50)
   *     .scale(2, 2);
   *
   * matrix.invert(); // Now transforms in opposite direction
   *
   * // Verify inversion
   * const point = new Point(50, 50);
   * const transformed = matrix.apply(point);
   * const original = matrix.invert().apply(transformed);
   * // original ≈ point
   * ```
   * @remarks
   * - Modifies the current matrix
   * - Useful for reversing transformations
   * - Cannot invert matrices with zero determinant
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.identity} For resetting to identity
   * @see {@link Matrix.applyInverse} For inverse transformations
   */
  invert() {
    const t = this.a, e = this.b, r = this.c, n = this.d, a = this.tx, l = t * n - e * r;
    return this.a = n / l, this.b = -e / l, this.c = -r / l, this.d = t / l, this.tx = (r * this.ty - n * a) / l, this.ty = -(t * this.ty - e * a) / l, this;
  }
  /**
   * Checks if this matrix is an identity matrix.
   *
   * An identity matrix has no transformations applied (default state).
   * @example
   * ```ts
   * // Check if matrix is identity
   * const matrix = new Matrix();
   * console.log(matrix.isIdentity()); // true
   *
   * // Check after transformations
   * matrix.translate(100, 0);
   * console.log(matrix.isIdentity()); // false
   *
   * // Reset and verify
   * matrix.identity();
   * console.log(matrix.isIdentity()); // true
   * ```
   * @remarks
   * - Verifies a = 1, d = 1 (no scale)
   * - Verifies b = 0, c = 0 (no skew)
   * - Verifies tx = 0, ty = 0 (no translation)
   * @returns True if matrix has no transformations
   * @see {@link Matrix.identity} For resetting to identity
   * @see {@link Matrix.IDENTITY} For constant identity matrix
   */
  isIdentity() {
    return this.a === 1 && this.b === 0 && this.c === 0 && this.d === 1 && this.tx === 0 && this.ty === 0;
  }
  /**
   * Resets this Matrix to an identity (default) matrix.
   * Sets all components to their default values: scale=1, no skew, no translation.
   * @example
   * ```ts
   * // Reset transformed matrix
   * const matrix = new Matrix()
   *     .scale(2, 2)
   *     .rotate(Math.PI / 4);
   * matrix.identity(); // Back to default state
   *
   * // Chain after reset
   * matrix
   *     .identity()
   *     .translate(100, 100)
   *     .scale(2, 2);
   *
   * // Compare with identity constant
   * const isDefault = matrix.equals(Matrix.IDENTITY);
   * ```
   * @remarks
   * - Sets a=1, d=1 (default scale)
   * - Sets b=0, c=0 (no skew)
   * - Sets tx=0, ty=0 (no translation)
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.IDENTITY} For constant identity matrix
   * @see {@link Matrix.isIdentity} For checking identity state
   */
  identity() {
    return this.a = 1, this.b = 0, this.c = 0, this.d = 1, this.tx = 0, this.ty = 0, this;
  }
  /**
   * Creates a new Matrix object with the same values as this one.
   * @returns A copy of this matrix. Good for chaining method calls.
   */
  clone() {
    const t = new D();
    return t.a = this.a, t.b = this.b, t.c = this.c, t.d = this.d, t.tx = this.tx, t.ty = this.ty, t;
  }
  /**
   * Creates a new Matrix object with the same values as this one.
   * @param matrix
   * @example
   * ```ts
   * // Basic matrix cloning
   * const matrix = new Matrix()
   *     .translate(100, 100)
   *     .rotate(Math.PI / 4);
   * const copy = matrix.clone();
   *
   * // Clone and modify
   * const modified = matrix.clone()
   *     .scale(2, 2);
   *
   * // Compare matrices
   * console.log(matrix.equals(copy));     // true
   * console.log(matrix.equals(modified)); // false
   * ```
   * @returns A copy of this matrix. Good for chaining method calls.
   * @see {@link Matrix.copyTo} For copying to existing matrix
   * @see {@link Matrix.copyFrom} For copying from another matrix
   */
  copyTo(t) {
    return t.a = this.a, t.b = this.b, t.c = this.c, t.d = this.d, t.tx = this.tx, t.ty = this.ty, t;
  }
  /**
   * Changes the values of the matrix to be the same as the ones in given matrix.
   * @example
   * ```ts
   * // Basic matrix copying
   * const source = new Matrix()
   *     .translate(100, 100)
   *     .rotate(Math.PI / 4);
   * const target = new Matrix();
   * target.copyFrom(source);
   * ```
   * @param matrix - The matrix to copy from
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.clone} For creating new matrix copy
   * @see {@link Matrix.copyTo} For copying to another matrix
   */
  copyFrom(t) {
    return this.a = t.a, this.b = t.b, this.c = t.c, this.d = t.d, this.tx = t.tx, this.ty = t.ty, this;
  }
  /**
   * Checks if this matrix equals another matrix.
   * Compares all components for exact equality.
   * @example
   * ```ts
   * // Basic equality check
   * const m1 = new Matrix();
   * const m2 = new Matrix();
   * console.log(m1.equals(m2)); // true
   *
   * // Compare transformed matrices
   * const transform = new Matrix()
   *     .translate(100, 100)
   * const clone = new Matrix()
   *     .scale(2, 2);
   * console.log(transform.equals(clone)); // false
   * ```
   * @param matrix - The matrix to compare to
   * @returns True if matrices are identical
   * @see {@link Matrix.copyFrom} For copying matrix values
   * @see {@link Matrix.isIdentity} For identity comparison
   */
  equals(t) {
    return t.a === this.a && t.b === this.b && t.c === this.c && t.d === this.d && t.tx === this.tx && t.ty === this.ty;
  }
  toString() {
    return `[pixi.js:Matrix a=${this.a} b=${this.b} c=${this.c} d=${this.d} tx=${this.tx} ty=${this.ty}]`;
  }
  /**
   * A default (identity) matrix with no transformations applied.
   *
   * > [!IMPORTANT] This is a shared read-only object. Create a new Matrix if you need to modify it.
   * @example
   * ```ts
   * // Get identity matrix reference
   * const identity = Matrix.IDENTITY;
   * console.log(identity.isIdentity()); // true
   *
   * // Compare with identity
   * const matrix = new Matrix();
   * console.log(matrix.equals(Matrix.IDENTITY)); // true
   *
   * // Create new matrix instead of modifying IDENTITY
   * const transform = new Matrix()
   *     .copyFrom(Matrix.IDENTITY)
   *     .translate(100, 100);
   * ```
   * @readonly
   * @returns A read-only identity matrix
   * @see {@link Matrix.shared} For temporary calculations
   * @see {@link Matrix.identity} For resetting matrices
   */
  static get IDENTITY() {
    return z0.identity();
  }
  /**
   * A static Matrix that can be used to avoid creating new objects.
   * Will always ensure the matrix is reset to identity when requested.
   *
   * > [!IMPORTANT] This matrix is shared and temporary. Do not store references to it.
   * @example
   * ```ts
   * // Use for temporary calculations
   * const tempMatrix = Matrix.shared;
   * tempMatrix.translate(100, 100).rotate(Math.PI / 4);
   * const point = tempMatrix.apply({ x: 10, y: 20 });
   *
   * // Will be reset to identity on next access
   * const fresh = Matrix.shared; // Back to identity
   * ```
   * @remarks
   * - Always returns identity matrix
   * - Safe to modify temporarily
   * - Not safe to store references
   * - Useful for one-off calculations
   * @readonly
   * @returns A fresh identity matrix for temporary use
   * @see {@link Matrix.IDENTITY} For immutable identity matrix
   * @see {@link Matrix.identity} For resetting matrices
   */
  static get shared() {
    return G0.identity();
  }
}
const G0 = new D(), z0 = new D(), bi = [1, 1, 0, -1, -1, -1, 0, 1, 1, 1, 0, -1, -1, -1, 0, 1], vi = [0, 1, 1, 1, 0, -1, -1, -1, 0, 1, 1, 1, 0, -1, -1, -1], wi = [0, -1, -1, -1, 0, 1, 1, 1, 0, 1, 1, 1, 0, -1, -1, -1], Si = [1, 1, 0, -1, -1, -1, 0, 1, -1, -1, 0, 1, 1, 1, 0, -1], Ao = [], Df = [], Us = Math.sign;
function N0() {
  for (let s = 0; s < 16; s++) {
    const t = [];
    Ao.push(t);
    for (let e = 0; e < 16; e++) {
      const r = Us(bi[s] * bi[e] + wi[s] * vi[e]), n = Us(vi[s] * bi[e] + Si[s] * vi[e]), a = Us(bi[s] * wi[e] + wi[s] * Si[e]), l = Us(vi[s] * wi[e] + Si[s] * Si[e]);
      for (let h = 0; h < 16; h++)
        if (bi[h] === r && vi[h] === n && wi[h] === a && Si[h] === l) {
          t.push(h);
          break;
        }
    }
  }
  for (let s = 0; s < 16; s++) {
    const t = new D();
    t.set(bi[s], vi[s], wi[s], Si[s], 0, 0), Df.push(t);
  }
}
N0();
const at = {
  /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 0°       | East      |
   * @group groupD8
   * @type {GD8Symmetry}
   */
  E: 0,
  /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 45°↻     | Southeast |
   * @group groupD8
   * @type {GD8Symmetry}
   */
  SE: 1,
  /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 90°↻     | South     |
   * @group groupD8
   * @type {GD8Symmetry}
   */
  S: 2,
  /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 135°↻    | Southwest |
   * @group groupD8
   * @type {GD8Symmetry}
   */
  SW: 3,
  /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 180°     | West      |
   * @group groupD8
   * @type {GD8Symmetry}
   */
  W: 4,
  /**
   * | Rotation    | Direction    |
   * |-------------|--------------|
   * | -135°/225°↻ | Northwest    |
   * @group groupD8
   * @type {GD8Symmetry}
   */
  NW: 5,
  /**
   * | Rotation    | Direction    |
   * |-------------|--------------|
   * | -90°/270°↻  | North        |
   * @group groupD8
   * @type {GD8Symmetry}
   */
  N: 6,
  /**
   * | Rotation    | Direction    |
   * |-------------|--------------|
   * | -45°/315°↻  | Northeast    |
   * @group groupD8
   * @type {GD8Symmetry}
   */
  NE: 7,
  /**
   * Reflection about Y-axis.
   * @group groupD8
   * @type {GD8Symmetry}
   */
  MIRROR_VERTICAL: 8,
  /**
   * Reflection about the main diagonal.
   * @group groupD8
   * @type {GD8Symmetry}
   */
  MAIN_DIAGONAL: 10,
  /**
   * Reflection about X-axis.
   * @group groupD8
   * @type {GD8Symmetry}
   */
  MIRROR_HORIZONTAL: 12,
  /**
   * Reflection about reverse diagonal.
   * @group groupD8
   * @type {GD8Symmetry}
   */
  REVERSE_DIAGONAL: 14,
  /**
   * @group groupD8
   * @param {GD8Symmetry} ind - sprite rotation angle.
   * @returns {GD8Symmetry} The X-component of the U-axis
   *    after rotating the axes.
   */
  uX: (s) => bi[s],
  /**
   * @group groupD8
   * @param {GD8Symmetry} ind - sprite rotation angle.
   * @returns {GD8Symmetry} The Y-component of the U-axis
   *    after rotating the axes.
   */
  uY: (s) => vi[s],
  /**
   * @group groupD8
   * @param {GD8Symmetry} ind - sprite rotation angle.
   * @returns {GD8Symmetry} The X-component of the V-axis
   *    after rotating the axes.
   */
  vX: (s) => wi[s],
  /**
   * @group groupD8
   * @param {GD8Symmetry} ind - sprite rotation angle.
   * @returns {GD8Symmetry} The Y-component of the V-axis
   *    after rotating the axes.
   */
  vY: (s) => Si[s],
  /**
   * @group groupD8
   * @param {GD8Symmetry} rotation - symmetry whose opposite
   *   is needed. Only rotations have opposite symmetries while
   *   reflections don't.
   * @returns {GD8Symmetry} The opposite symmetry of `rotation`
   */
  inv: (s) => s & 8 ? s & 15 : -s & 7,
  /**
   * Composes the two D8 operations.
   *
   * Taking `^` as reflection:
   *
   * |       | E=0 | S=2 | W=4 | N=6 | E^=8 | S^=10 | W^=12 | N^=14 |
   * |-------|-----|-----|-----|-----|------|-------|-------|-------|
   * | E=0   | E   | S   | W   | N   | E^   | S^    | W^    | N^    |
   * | S=2   | S   | W   | N   | E   | S^   | W^    | N^    | E^    |
   * | W=4   | W   | N   | E   | S   | W^   | N^    | E^    | S^    |
   * | N=6   | N   | E   | S   | W   | N^   | E^    | S^    | W^    |
   * | E^=8  | E^  | N^  | W^  | S^  | E    | N     | W     | S     |
   * | S^=10 | S^  | E^  | N^  | W^  | S    | E     | N     | W     |
   * | W^=12 | W^  | S^  | E^  | N^  | W    | S     | E     | N     |
   * | N^=14 | N^  | W^  | S^  | E^  | N    | W     | S     | E     |
   *
   * [This is a Cayley table]{@link https://en.wikipedia.org/wiki/Cayley_table}
   * @group groupD8
   * @param {GD8Symmetry} rotationSecond - Second operation, which
   *   is the row in the above cayley table.
   * @param {GD8Symmetry} rotationFirst - First operation, which
   *   is the column in the above cayley table.
   * @returns {GD8Symmetry} Composed operation
   */
  add: (s, t) => Ao[s][t],
  /**
   * Reverse of `add`.
   * @group groupD8
   * @param {GD8Symmetry} rotationSecond - Second operation
   * @param {GD8Symmetry} rotationFirst - First operation
   * @returns {GD8Symmetry} Result
   */
  sub: (s, t) => Ao[s][at.inv(t)],
  /**
   * Adds 180 degrees to rotation, which is a commutative
   * operation.
   * @group groupD8
   * @param {number} rotation - The number to rotate.
   * @returns {number} Rotated number
   */
  rotate180: (s) => s ^ 4,
  /**
   * Checks if the rotation angle is vertical, i.e. south
   * or north. It doesn't work for reflections.
   * @group groupD8
   * @param {GD8Symmetry} rotation - The number to check.
   * @returns {boolean} Whether or not the direction is vertical
   */
  isVertical: (s) => (s & 3) === 2,
  // rotation % 4 === 2
  /**
   * Approximates the vector `V(dx,dy)` into one of the
   * eight directions provided by `groupD8`.
   * @group groupD8
   * @param {number} dx - X-component of the vector
   * @param {number} dy - Y-component of the vector
   * @returns {GD8Symmetry} Approximation of the vector into
   *  one of the eight symmetries.
   */
  byDirection: (s, t) => Math.abs(s) * 2 <= Math.abs(t) ? t >= 0 ? at.S : at.N : Math.abs(t) * 2 <= Math.abs(s) ? s > 0 ? at.E : at.W : t > 0 ? s > 0 ? at.SE : at.SW : s > 0 ? at.NE : at.NW,
  /**
   * Helps sprite to compensate texture packer rotation.
   * @group groupD8
   * @param {Matrix} matrix - sprite world matrix
   * @param {GD8Symmetry} rotation - The rotation factor to use.
   * @param {number} tx - sprite anchoring
   * @param {number} ty - sprite anchoring
   */
  matrixAppendRotationInv: (s, t, e = 0, r = 0) => {
    const n = Df[at.inv(t)];
    n.tx = e, n.ty = r, s.append(n);
  }
}, Rs = [new et(), new et(), new et(), new et()];
class Z {
  /**
   * @param x - The X coordinate of the upper-left corner of the rectangle
   * @param y - The Y coordinate of the upper-left corner of the rectangle
   * @param width - The overall width of the rectangle
   * @param height - The overall height of the rectangle
   */
  constructor(t = 0, e = 0, r = 0, n = 0) {
    this.type = "rectangle", this.x = Number(t), this.y = Number(e), this.width = Number(r), this.height = Number(n);
  }
  /**
   * Returns the left edge (x-coordinate) of the rectangle.
   * @example
   * ```ts
   * // Get left edge position
   * const rect = new Rectangle(100, 100, 200, 150);
   * console.log(rect.left); // 100
   *
   * // Use in alignment calculations
   * sprite.x = rect.left + padding;
   *
   * // Compare positions
   * if (point.x > rect.left) {
   *     console.log('Point is right of rectangle');
   * }
   * ```
   * @readonly
   * @returns The x-coordinate of the left edge
   * @see {@link Rectangle.right} For right edge position
   * @see {@link Rectangle.x} For direct x-coordinate access
   */
  get left() {
    return this.x;
  }
  /**
   * Returns the right edge (x + width) of the rectangle.
   * @example
   * ```ts
   * // Get right edge position
   * const rect = new Rectangle(100, 100, 200, 150);
   * console.log(rect.right); // 300
   *
   * // Align to right edge
   * sprite.x = rect.right - sprite.width;
   *
   * // Check boundaries
   * if (point.x < rect.right) {
   *     console.log('Point is inside right bound');
   * }
   * ```
   * @readonly
   * @returns The x-coordinate of the right edge
   * @see {@link Rectangle.left} For left edge position
   * @see {@link Rectangle.width} For width value
   */
  get right() {
    return this.x + this.width;
  }
  /**
   * Returns the top edge (y-coordinate) of the rectangle.
   * @example
   * ```ts
   * // Get top edge position
   * const rect = new Rectangle(100, 100, 200, 150);
   * console.log(rect.top); // 100
   *
   * // Position above rectangle
   * sprite.y = rect.top - sprite.height;
   *
   * // Check vertical position
   * if (point.y > rect.top) {
   *     console.log('Point is below top edge');
   * }
   * ```
   * @readonly
   * @returns The y-coordinate of the top edge
   * @see {@link Rectangle.bottom} For bottom edge position
   * @see {@link Rectangle.y} For direct y-coordinate access
   */
  get top() {
    return this.y;
  }
  /**
   * Returns the bottom edge (y + height) of the rectangle.
   * @example
   * ```ts
   * // Get bottom edge position
   * const rect = new Rectangle(100, 100, 200, 150);
   * console.log(rect.bottom); // 250
   *
   * // Stack below rectangle
   * sprite.y = rect.bottom + margin;
   *
   * // Check vertical bounds
   * if (point.y < rect.bottom) {
   *     console.log('Point is above bottom edge');
   * }
   * ```
   * @readonly
   * @returns The y-coordinate of the bottom edge
   * @see {@link Rectangle.top} For top edge position
   * @see {@link Rectangle.height} For height value
   */
  get bottom() {
    return this.y + this.height;
  }
  /**
   * Determines whether the Rectangle is empty (has no area).
   * @example
   * ```ts
   * // Check zero dimensions
   * const rect = new Rectangle(100, 100, 0, 50);
   * console.log(rect.isEmpty()); // true
   * ```
   * @returns True if the rectangle has no area
   * @see {@link Rectangle.width} For width value
   * @see {@link Rectangle.height} For height value
   */
  isEmpty() {
    return this.left === this.right || this.top === this.bottom;
  }
  /**
   * A constant empty rectangle. This is a new object every time the property is accessed.
   * @example
   * ```ts
   * // Get fresh empty rectangle
   * const empty = Rectangle.EMPTY;
   * console.log(empty.isEmpty()); // true
   * ```
   * @returns A new empty rectangle instance
   * @see {@link Rectangle.isEmpty} For empty state testing
   */
  static get EMPTY() {
    return new Z(0, 0, 0, 0);
  }
  /**
   * Creates a clone of this Rectangle
   * @example
   * ```ts
   * // Basic cloning
   * const original = new Rectangle(100, 100, 200, 150);
   * const copy = original.clone();
   *
   * // Clone and modify
   * const modified = original.clone();
   * modified.width *= 2;
   * modified.height += 50;
   *
   * // Verify independence
   * console.log(original.width);  // 200
   * console.log(modified.width);  // 400
   * ```
   * @returns A copy of the rectangle
   * @see {@link Rectangle.copyFrom} For copying into existing rectangle
   * @see {@link Rectangle.copyTo} For copying to another rectangle
   */
  clone() {
    return new Z(this.x, this.y, this.width, this.height);
  }
  /**
   * Converts a Bounds object to a Rectangle object.
   * @example
   * ```ts
   * // Convert bounds to rectangle
   * const bounds = container.getBounds();
   * const rect = new Rectangle().copyFromBounds(bounds);
   * ```
   * @param bounds - The bounds to copy and convert to a rectangle
   * @returns Returns itself
   * @see {@link Bounds} For bounds object structure
   * @see {@link Rectangle.getBounds} For getting rectangle bounds
   */
  copyFromBounds(t) {
    return this.x = t.minX, this.y = t.minY, this.width = t.maxX - t.minX, this.height = t.maxY - t.minY, this;
  }
  /**
   * Copies another rectangle to this one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Rectangle(100, 100, 200, 150);
   * const target = new Rectangle();
   * target.copyFrom(source);
   *
   * // Chain with other operations
   * const rect = new Rectangle()
   *     .copyFrom(source)
   *     .pad(10);
   * ```
   * @param rectangle - The rectangle to copy from
   * @returns Returns itself
   * @see {@link Rectangle.copyTo} For copying to another rectangle
   * @see {@link Rectangle.clone} For creating new rectangle copy
   */
  copyFrom(t) {
    return this.x = t.x, this.y = t.y, this.width = t.width, this.height = t.height, this;
  }
  /**
   * Copies this rectangle to another one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Rectangle(100, 100, 200, 150);
   * const target = new Rectangle();
   * source.copyTo(target);
   *
   * // Chain with other operations
   * const result = source
   *     .copyTo(new Rectangle())
   *     .getBounds();
   * ```
   * @param rectangle - The rectangle to copy to
   * @returns Returns given parameter
   * @see {@link Rectangle.copyFrom} For copying from another rectangle
   * @see {@link Rectangle.clone} For creating new rectangle copy
   */
  copyTo(t) {
    return t.copyFrom(this), t;
  }
  /**
   * Checks whether the x and y coordinates given are contained within this Rectangle
   * @example
   * ```ts
   * // Basic containment check
   * const rect = new Rectangle(100, 100, 200, 150);
   * const isInside = rect.contains(150, 125); // true
   * // Check edge cases
   * console.log(rect.contains(100, 100)); // true (on edge)
   * console.log(rect.contains(300, 250)); // false (outside)
   * ```
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coordinates are within this Rectangle
   * @see {@link Rectangle.containsRect} For rectangle containment
   * @see {@link Rectangle.strokeContains} For checking stroke intersection
   */
  contains(t, e) {
    return this.width <= 0 || this.height <= 0 ? !1 : t >= this.x && t < this.x + this.width && e >= this.y && e < this.y + this.height;
  }
  /**
   * Checks whether the x and y coordinates given are contained within this rectangle including the stroke.
   * @example
   * ```ts
   * // Basic stroke check
   * const rect = new Rectangle(100, 100, 200, 150);
   * const isOnStroke = rect.strokeContains(150, 100, 4); // 4px line width
   *
   * // Check with different alignments
   * const innerStroke = rect.strokeContains(150, 100, 4, 0);   // Inside
   * const centerStroke = rect.strokeContains(150, 100, 4, 0.5); // Centered
   * const outerStroke = rect.strokeContains(150, 100, 4, 1);   // Outside
   * ```
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @param strokeWidth - The width of the line to check
   * @param alignment - The alignment of the stroke (0 = inner, 0.5 = centered, 1 = outer)
   * @returns Whether the x/y coordinates are within this rectangle's stroke
   * @see {@link Rectangle.contains} For checking fill containment
   * @see {@link Rectangle.getBounds} For getting stroke bounds
   */
  strokeContains(t, e, r, n = 0.5) {
    const { width: a, height: l } = this;
    if (a <= 0 || l <= 0)
      return !1;
    const h = this.x, u = this.y, f = r * (1 - n), p = r - f, m = h - f, g = h + a + f, x = u - f, o = u + l + f, c = h + p, d = h + a - p, _ = u + p, y = u + l - p;
    return t >= m && t <= g && e >= x && e <= o && !(t > c && t < d && e > _ && e < y);
  }
  /**
   * Determines whether the `other` Rectangle transformed by `transform` intersects with `this` Rectangle object.
   * Returns true only if the area of the intersection is >0, this means that Rectangles
   * sharing a side are not overlapping. Another side effect is that an arealess rectangle
   * (width or height equal to zero) can't intersect any other rectangle.
   * @param {Rectangle} other - The Rectangle to intersect with `this`.
   * @param {Matrix} transform - The transformation matrix of `other`.
   * @returns {boolean} A value of `true` if the transformed `other` Rectangle intersects with `this`; otherwise `false`.
   */
  /**
   * Determines whether the `other` Rectangle transformed by `transform` intersects with `this` Rectangle object.
   *
   * Returns true only if the area of the intersection is greater than 0.
   * This means that rectangles sharing only a side are not considered intersecting.
   * @example
   * ```ts
   * // Basic intersection check
   * const rect1 = new Rectangle(0, 0, 100, 100);
   * const rect2 = new Rectangle(50, 50, 100, 100);
   * console.log(rect1.intersects(rect2)); // true
   *
   * // With transformation matrix
   * const matrix = new Matrix();
   * matrix.rotate(Math.PI / 4); // 45 degrees
   * console.log(rect1.intersects(rect2, matrix)); // Checks with rotation
   *
   * // Edge cases
   * const zeroWidth = new Rectangle(0, 0, 0, 100);
   * console.log(rect1.intersects(zeroWidth)); // false (no area)
   * ```
   * @remarks
   * - Returns true only if intersection area is > 0
   * - Rectangles sharing only a side are not intersecting
   * - Zero-area rectangles cannot intersect anything
   * - Supports optional transformation matrix
   * @param other - The Rectangle to intersect with `this`
   * @param transform - Optional transformation matrix of `other`
   * @returns True if the transformed `other` Rectangle intersects with `this`
   * @see {@link Rectangle.containsRect} For containment testing
   * @see {@link Rectangle.contains} For point testing
   */
  intersects(t, e) {
    if (!e) {
      const E = this.x < t.x ? t.x : this.x;
      if ((this.right > t.right ? t.right : this.right) <= E)
        return !1;
      const M = this.y < t.y ? t.y : this.y;
      return (this.bottom > t.bottom ? t.bottom : this.bottom) > M;
    }
    const r = this.left, n = this.right, a = this.top, l = this.bottom;
    if (n <= r || l <= a)
      return !1;
    const h = Rs[0].set(t.left, t.top), u = Rs[1].set(t.left, t.bottom), f = Rs[2].set(t.right, t.top), p = Rs[3].set(t.right, t.bottom);
    if (f.x <= h.x || u.y <= h.y)
      return !1;
    const m = Math.sign(e.a * e.d - e.b * e.c);
    if (m === 0 || (e.apply(h, h), e.apply(u, u), e.apply(f, f), e.apply(p, p), Math.max(h.x, u.x, f.x, p.x) <= r || Math.min(h.x, u.x, f.x, p.x) >= n || Math.max(h.y, u.y, f.y, p.y) <= a || Math.min(h.y, u.y, f.y, p.y) >= l))
      return !1;
    const g = m * (u.y - h.y), x = m * (h.x - u.x), o = g * r + x * a, c = g * n + x * a, d = g * r + x * l, _ = g * n + x * l;
    if (Math.max(o, c, d, _) <= g * h.x + x * h.y || Math.min(o, c, d, _) >= g * p.x + x * p.y)
      return !1;
    const y = m * (h.y - f.y), v = m * (f.x - h.x), b = y * r + v * a, w = y * n + v * a, S = y * r + v * l, T = y * n + v * l;
    return !(Math.max(b, w, S, T) <= y * h.x + v * h.y || Math.min(b, w, S, T) >= y * p.x + v * p.y);
  }
  /**
   * Pads the rectangle making it grow in all directions.
   *
   * If paddingY is omitted, both paddingX and paddingY will be set to paddingX.
   * @example
   * ```ts
   * // Basic padding
   * const rect = new Rectangle(100, 100, 200, 150);
   * rect.pad(10); // Adds 10px padding on all sides
   *
   * // Different horizontal and vertical padding
   * const uiRect = new Rectangle(0, 0, 100, 50);
   * uiRect.pad(20, 10); // 20px horizontal, 10px vertical
   * ```
   * @remarks
   * - Adjusts x/y by subtracting padding
   * - Increases width/height by padding * 2
   * - Common in UI layout calculations
   * - Chainable with other methods
   * @param paddingX - The horizontal padding amount
   * @param paddingY - The vertical padding amount
   * @returns Returns itself
   * @see {@link Rectangle.enlarge} For growing to include another rectangle
   * @see {@link Rectangle.fit} For shrinking to fit within another rectangle
   */
  pad(t = 0, e = t) {
    return this.x -= t, this.y -= e, this.width += t * 2, this.height += e * 2, this;
  }
  /**
   * Fits this rectangle around the passed one.
   * @example
   * ```ts
   * // Basic fitting
   * const container = new Rectangle(0, 0, 100, 100);
   * const content = new Rectangle(25, 25, 200, 200);
   * content.fit(container); // Clips to container bounds
   * ```
   * @param rectangle - The rectangle to fit around
   * @returns Returns itself
   * @see {@link Rectangle.enlarge} For growing to include another rectangle
   * @see {@link Rectangle.pad} For adding padding around the rectangle
   */
  fit(t) {
    const e = Math.max(this.x, t.x), r = Math.min(this.x + this.width, t.x + t.width), n = Math.max(this.y, t.y), a = Math.min(this.y + this.height, t.y + t.height);
    return this.x = e, this.width = Math.max(r - e, 0), this.y = n, this.height = Math.max(a - n, 0), this;
  }
  /**
   * Enlarges rectangle so that its corners lie on a grid defined by resolution.
   * @example
   * ```ts
   * // Basic grid alignment
   * const rect = new Rectangle(10.2, 10.6, 100.8, 100.4);
   * rect.ceil(); // Aligns to whole pixels
   *
   * // Custom resolution grid
   * const uiRect = new Rectangle(5.3, 5.7, 50.2, 50.8);
   * uiRect.ceil(0.5); // Aligns to half pixels
   *
   * // Use with precision value
   * const preciseRect = new Rectangle(20.001, 20.999, 100.001, 100.999);
   * preciseRect.ceil(1, 0.01); // Handles small decimal variations
   * ```
   * @param resolution - The grid size to align to (1 = whole pixels)
   * @param eps - Small number to prevent floating point errors
   * @returns Returns itself
   * @see {@link Rectangle.fit} For constraining to bounds
   * @see {@link Rectangle.enlarge} For growing dimensions
   */
  ceil(t = 1, e = 1e-3) {
    const r = Math.ceil((this.x + this.width - e) * t) / t, n = Math.ceil((this.y + this.height - e) * t) / t;
    return this.x = Math.floor((this.x + e) * t) / t, this.y = Math.floor((this.y + e) * t) / t, this.width = r - this.x, this.height = n - this.y, this;
  }
  /**
   * Enlarges this rectangle to include the passed rectangle.
   * @example
   * ```ts
   * // Basic enlargement
   * const rect = new Rectangle(50, 50, 100, 100);
   * const other = new Rectangle(0, 0, 200, 75);
   * rect.enlarge(other);
   * // rect is now: x=0, y=0, width=200, height=150
   *
   * // Use for bounding box calculation
   * const bounds = new Rectangle();
   * objects.forEach((obj) => {
   *     bounds.enlarge(obj.getBounds());
   * });
   * ```
   * @param rectangle - The rectangle to include
   * @returns Returns itself
   * @see {@link Rectangle.fit} For shrinking to fit within another rectangle
   * @see {@link Rectangle.pad} For adding padding around the rectangle
   */
  enlarge(t) {
    const e = Math.min(this.x, t.x), r = Math.max(this.x + this.width, t.x + t.width), n = Math.min(this.y, t.y), a = Math.max(this.y + this.height, t.y + t.height);
    return this.x = e, this.width = r - e, this.y = n, this.height = a - n, this;
  }
  /**
   * Returns the framing rectangle of the rectangle as a Rectangle object
   * @example
   * ```ts
   * // Basic bounds retrieval
   * const rect = new Rectangle(100, 100, 200, 150);
   * const bounds = rect.getBounds();
   *
   * // Reuse existing rectangle
   * const out = new Rectangle();
   * rect.getBounds(out);
   * ```
   * @param out - Optional rectangle to store the result
   * @returns The framing rectangle
   * @see {@link Rectangle.copyFrom} For direct copying
   * @see {@link Rectangle.clone} For creating new copy
   */
  getBounds(t) {
    return t || (t = new Z()), t.copyFrom(this), t;
  }
  /**
   * Determines whether another Rectangle is fully contained within this Rectangle.
   *
   * Rectangles that occupy the same space are considered to be containing each other.
   *
   * Rectangles without area (width or height equal to zero) can't contain anything,
   * not even other arealess rectangles.
   * @example
   * ```ts
   * // Check if one rectangle contains another
   * const container = new Rectangle(0, 0, 100, 100);
   * const inner = new Rectangle(25, 25, 50, 50);
   *
   * console.log(container.containsRect(inner)); // true
   *
   * // Check overlapping rectangles
   * const partial = new Rectangle(75, 75, 50, 50);
   * console.log(container.containsRect(partial)); // false
   *
   * // Zero-area rectangles
   * const empty = new Rectangle(0, 0, 0, 100);
   * console.log(container.containsRect(empty)); // false
   * ```
   * @param other - The Rectangle to check for containment
   * @returns True if other is fully contained within this Rectangle
   * @see {@link Rectangle.contains} For point containment
   * @see {@link Rectangle.intersects} For overlap testing
   */
  containsRect(t) {
    if (this.width <= 0 || this.height <= 0)
      return !1;
    const e = t.x, r = t.y, n = t.x + t.width, a = t.y + t.height;
    return e >= this.x && e < this.x + this.width && r >= this.y && r < this.y + this.height && n >= this.x && n < this.x + this.width && a >= this.y && a < this.y + this.height;
  }
  /**
   * Sets the position and dimensions of the rectangle.
   * @example
   * ```ts
   * // Basic usage
   * const rect = new Rectangle();
   * rect.set(100, 100, 200, 150);
   *
   * // Chain with other operations
   * const bounds = new Rectangle()
   *     .set(0, 0, 100, 100)
   *     .pad(10);
   * ```
   * @param x - The X coordinate of the upper-left corner of the rectangle
   * @param y - The Y coordinate of the upper-left corner of the rectangle
   * @param width - The overall width of the rectangle
   * @param height - The overall height of the rectangle
   * @returns Returns itself for method chaining
   * @see {@link Rectangle.copyFrom} For copying from another rectangle
   * @see {@link Rectangle.clone} For creating a new copy
   */
  set(t, e, r, n) {
    return this.x = t, this.y = e, this.width = r, this.height = n, this;
  }
  toString() {
    return `[pixi.js/math:Rectangle x=${this.x} y=${this.y} width=${this.width} height=${this.height}]`;
  }
}
const oa = {
  default: -1
};
function rt(s = "default") {
  return oa[s] === void 0 && (oa[s] = -1), ++oa[s];
}
const dc = {}, K = "8.0.0", H0 = "8.3.4";
function W(s, t, e = 3) {
  if (dc[t])
    return;
  let r = new Error().stack;
  typeof r > "u" ? console.warn("PixiJS Deprecation Warning: ", `${t}
Deprecated since v${s}`) : (r = r.split(`
`).splice(e).join(`
`), console.groupCollapsed ? (console.groupCollapsed(
    "%cPixiJS Deprecation Warning: %c%s",
    "color:#614108;background:#fffbe6",
    "font-weight:normal;color:#614108;background:#fffbe6",
    `${t}
Deprecated since v${s}`
  ), console.warn(r), console.groupEnd()) : (console.warn("PixiJS Deprecation Warning: ", `${t}
Deprecated since v${s}`), console.warn(r))), dc[t] = !0;
}
const Of = () => {
};
function hr(s) {
  return s += s === 0 ? 1 : 0, --s, s |= s >>> 1, s |= s >>> 2, s |= s >>> 4, s |= s >>> 8, s |= s >>> 16, s + 1;
}
function fc(s) {
  return !(s & s - 1) && !!s;
}
function Lf(s) {
  const t = {};
  for (const e in s)
    s[e] !== void 0 && (t[e] = s[e]);
  return t;
}
const pc = /* @__PURE__ */ Object.create(null);
function W0(s) {
  const t = pc[s];
  return t === void 0 && (pc[s] = rt("resource")), t;
}
const Gf = class zf extends te {
  /**
   * @param options - options for the style
   */
  constructor(t = {}) {
    super(), this._resourceType = "textureSampler", this._touched = 0, this._maxAnisotropy = 1, this.destroyed = !1, t = { ...zf.defaultOptions, ...t }, this.addressMode = t.addressMode, this.addressModeU = t.addressModeU ?? this.addressModeU, this.addressModeV = t.addressModeV ?? this.addressModeV, this.addressModeW = t.addressModeW ?? this.addressModeW, this.scaleMode = t.scaleMode, this.magFilter = t.magFilter ?? this.magFilter, this.minFilter = t.minFilter ?? this.minFilter, this.mipmapFilter = t.mipmapFilter ?? this.mipmapFilter, this.lodMinClamp = t.lodMinClamp, this.lodMaxClamp = t.lodMaxClamp, this.compare = t.compare, this.maxAnisotropy = t.maxAnisotropy ?? 1;
  }
  set addressMode(t) {
    this.addressModeU = t, this.addressModeV = t, this.addressModeW = t;
  }
  /** setting this will set wrapModeU,wrapModeV and wrapModeW all at once! */
  get addressMode() {
    return this.addressModeU;
  }
  set wrapMode(t) {
    W(K, "TextureStyle.wrapMode is now TextureStyle.addressMode"), this.addressMode = t;
  }
  get wrapMode() {
    return this.addressMode;
  }
  set scaleMode(t) {
    this.magFilter = t, this.minFilter = t, this.mipmapFilter = t;
  }
  /** setting this will set magFilter,minFilter and mipmapFilter all at once!  */
  get scaleMode() {
    return this.magFilter;
  }
  /** Specifies the maximum anisotropy value clamp used by the sampler. */
  set maxAnisotropy(t) {
    this._maxAnisotropy = Math.min(t, 16), this._maxAnisotropy > 1 && (this.scaleMode = "linear");
  }
  get maxAnisotropy() {
    return this._maxAnisotropy;
  }
  // TODO - move this to WebGL?
  get _resourceId() {
    return this._sharedResourceId || this._generateResourceId();
  }
  update() {
    this.emit("change", this), this._sharedResourceId = null;
  }
  _generateResourceId() {
    const t = `${this.addressModeU}-${this.addressModeV}-${this.addressModeW}-${this.magFilter}-${this.minFilter}-${this.mipmapFilter}-${this.lodMinClamp}-${this.lodMaxClamp}-${this.compare}-${this._maxAnisotropy}`;
    return this._sharedResourceId = W0(t), this._resourceId;
  }
  /** Destroys the style */
  destroy() {
    this.destroyed = !0, this.emit("destroy", this), this.emit("change", this), this.removeAllListeners();
  }
};
Gf.defaultOptions = {
  addressMode: "clamp-to-edge",
  scaleMode: "linear"
};
let $e = Gf;
const Nf = class Hf extends te {
  /**
   * @param options - options for creating a new TextureSource
   */
  constructor(t = {}) {
    super(), this.options = t, this.uid = rt("textureSource"), this._resourceType = "textureSource", this._resourceId = rt("resource"), this.uploadMethodId = "unknown", this._resolution = 1, this.pixelWidth = 1, this.pixelHeight = 1, this.width = 1, this.height = 1, this.sampleCount = 1, this.mipLevelCount = 1, this.autoGenerateMipmaps = !1, this.format = "rgba8unorm", this.dimension = "2d", this.antialias = !1, this._touched = 0, this._batchTick = -1, this._textureBindLocation = -1, t = { ...Hf.defaultOptions, ...t }, this.label = t.label ?? "", this.resource = t.resource, this.autoGarbageCollect = t.autoGarbageCollect, this._resolution = t.resolution, t.width ? this.pixelWidth = t.width * this._resolution : this.pixelWidth = this.resource ? this.resourceWidth ?? 1 : 1, t.height ? this.pixelHeight = t.height * this._resolution : this.pixelHeight = this.resource ? this.resourceHeight ?? 1 : 1, this.width = this.pixelWidth / this._resolution, this.height = this.pixelHeight / this._resolution, this.format = t.format, this.dimension = t.dimensions, this.mipLevelCount = t.mipLevelCount, this.autoGenerateMipmaps = t.autoGenerateMipmaps, this.sampleCount = t.sampleCount, this.antialias = t.antialias, this.alphaMode = t.alphaMode, this.style = new $e(Lf(t)), this.destroyed = !1, this._refreshPOT();
  }
  /** returns itself */
  get source() {
    return this;
  }
  /** the style of the texture */
  get style() {
    return this._style;
  }
  set style(t) {
    this.style !== t && (this._style?.off("change", this._onStyleChange, this), this._style = t, this._style?.on("change", this._onStyleChange, this), this._onStyleChange());
  }
  /** setting this will set wrapModeU,wrapModeV and wrapModeW all at once! */
  get addressMode() {
    return this._style.addressMode;
  }
  set addressMode(t) {
    this._style.addressMode = t;
  }
  /** setting this will set wrapModeU,wrapModeV and wrapModeW all at once! */
  get repeatMode() {
    return this._style.addressMode;
  }
  set repeatMode(t) {
    this._style.addressMode = t;
  }
  /** Specifies the sampling behavior when the sample footprint is smaller than or equal to one texel. */
  get magFilter() {
    return this._style.magFilter;
  }
  set magFilter(t) {
    this._style.magFilter = t;
  }
  /** Specifies the sampling behavior when the sample footprint is larger than one texel. */
  get minFilter() {
    return this._style.minFilter;
  }
  set minFilter(t) {
    this._style.minFilter = t;
  }
  /** Specifies behavior for sampling between mipmap levels. */
  get mipmapFilter() {
    return this._style.mipmapFilter;
  }
  set mipmapFilter(t) {
    this._style.mipmapFilter = t;
  }
  /** Specifies the minimum and maximum levels of detail, respectively, used internally when sampling a texture. */
  get lodMinClamp() {
    return this._style.lodMinClamp;
  }
  set lodMinClamp(t) {
    this._style.lodMinClamp = t;
  }
  /** Specifies the minimum and maximum levels of detail, respectively, used internally when sampling a texture. */
  get lodMaxClamp() {
    return this._style.lodMaxClamp;
  }
  set lodMaxClamp(t) {
    this._style.lodMaxClamp = t;
  }
  _onStyleChange() {
    this.emit("styleChange", this);
  }
  /** call this if you have modified the texture outside of the constructor */
  update() {
    if (this.resource) {
      const t = this._resolution;
      if (this.resize(this.resourceWidth / t, this.resourceHeight / t))
        return;
    }
    this.emit("update", this);
  }
  /** Destroys this texture source */
  destroy() {
    this.destroyed = !0, this.emit("destroy", this), this.emit("change", this), this._style && (this._style.destroy(), this._style = null), this.uploadMethodId = null, this.resource = null, this.removeAllListeners();
  }
  /**
   * This will unload the Texture source from the GPU. This will free up the GPU memory
   * As soon as it is required fore rendering, it will be re-uploaded.
   */
  unload() {
    this._resourceId = rt("resource"), this.emit("change", this), this.emit("unload", this);
  }
  /** the width of the resource. This is the REAL pure number, not accounting resolution   */
  get resourceWidth() {
    const { resource: t } = this;
    return t.naturalWidth || t.videoWidth || t.displayWidth || t.width;
  }
  /** the height of the resource. This is the REAL pure number, not accounting resolution */
  get resourceHeight() {
    const { resource: t } = this;
    return t.naturalHeight || t.videoHeight || t.displayHeight || t.height;
  }
  /**
   * the resolution of the texture. Changing this number, will not change the number of pixels in the actual texture
   * but will the size of the texture when rendered.
   *
   * changing the resolution of this texture to 2 for example will make it appear twice as small when rendered (as pixel
   * density will have increased)
   */
  get resolution() {
    return this._resolution;
  }
  set resolution(t) {
    this._resolution !== t && (this._resolution = t, this.width = this.pixelWidth / t, this.height = this.pixelHeight / t);
  }
  /**
   * Resize the texture, this is handy if you want to use the texture as a render texture
   * @param width - the new width of the texture
   * @param height - the new height of the texture
   * @param resolution - the new resolution of the texture
   * @returns - if the texture was resized
   */
  resize(t, e, r) {
    r || (r = this._resolution), t || (t = this.width), e || (e = this.height);
    const n = Math.round(t * r), a = Math.round(e * r);
    return this.width = n / r, this.height = a / r, this._resolution = r, this.pixelWidth === n && this.pixelHeight === a ? !1 : (this._refreshPOT(), this.pixelWidth = n, this.pixelHeight = a, this.emit("resize", this), this._resourceId = rt("resource"), this.emit("change", this), !0);
  }
  /**
   * Lets the renderer know that this texture has been updated and its mipmaps should be re-generated.
   * This is only important for RenderTexture instances, as standard Texture instances will have their
   * mipmaps generated on upload. You should call this method after you make any change to the texture
   *
   * The reason for this is is can be quite expensive to update mipmaps for a texture. So by default,
   * We want you, the developer to specify when this action should happen.
   *
   * Generally you don't want to have mipmaps generated on Render targets that are changed every frame,
   */
  updateMipmaps() {
    this.autoGenerateMipmaps && this.mipLevelCount > 1 && this.emit("updateMipmaps", this);
  }
  set wrapMode(t) {
    this._style.wrapMode = t;
  }
  get wrapMode() {
    return this._style.wrapMode;
  }
  set scaleMode(t) {
    this._style.scaleMode = t;
  }
  /** setting this will set magFilter,minFilter and mipmapFilter all at once!  */
  get scaleMode() {
    return this._style.scaleMode;
  }
  /**
   * Refresh check for isPowerOfTwo texture based on size
   * @private
   */
  _refreshPOT() {
    this.isPowerOfTwo = fc(this.pixelWidth) && fc(this.pixelHeight);
  }
  static test(t) {
    throw new Error("Unimplemented");
  }
};
Nf.defaultOptions = {
  resolution: 1,
  format: "bgra8unorm",
  alphaMode: "premultiply-alpha-on-upload",
  dimensions: "2d",
  mipLevelCount: 1,
  autoGenerateMipmaps: !1,
  sampleCount: 1,
  antialias: !1,
  autoGarbageCollect: !1
};
let yt = Nf;
class Mh extends yt {
  constructor(t) {
    const e = t.resource || new Float32Array(t.width * t.height * 4);
    let r = t.format;
    r || (e instanceof Float32Array ? r = "rgba32float" : e instanceof Int32Array || e instanceof Uint32Array ? r = "rgba32uint" : e instanceof Int16Array || e instanceof Uint16Array ? r = "rgba16uint" : (e instanceof Int8Array, r = "bgra8unorm")), super({
      ...t,
      resource: e,
      format: r
    }), this.uploadMethodId = "buffer";
  }
  static test(t) {
    return t instanceof Int8Array || t instanceof Uint8Array || t instanceof Uint8ClampedArray || t instanceof Int16Array || t instanceof Uint16Array || t instanceof Int32Array || t instanceof Uint32Array || t instanceof Float32Array;
  }
}
Mh.extension = A.TextureSource;
const _c = new D();
class Wf {
  /**
   * @param texture - observed texture
   * @param clampMargin - Changes frame clamping, 0.5 by default. Use -0.5 for extra border.
   */
  constructor(t, e) {
    this.mapCoord = new D(), this.uClampFrame = new Float32Array(4), this.uClampOffset = new Float32Array(2), this._textureID = -1, this._updateID = 0, this.clampOffset = 0, typeof e > "u" ? this.clampMargin = t.width < 10 ? 0 : 0.5 : this.clampMargin = e, this.isSimple = !1, this.texture = t;
  }
  /** Texture property. */
  get texture() {
    return this._texture;
  }
  set texture(t) {
    this.texture !== t && (this._texture?.removeListener("update", this.update, this), this._texture = t, this._texture.addListener("update", this.update, this), this.update());
  }
  /**
   * Multiplies uvs array to transform
   * @param uvs - mesh uvs
   * @param [out=uvs] - output
   * @returns - output
   */
  multiplyUvs(t, e) {
    e === void 0 && (e = t);
    const r = this.mapCoord;
    for (let n = 0; n < t.length; n += 2) {
      const a = t[n], l = t[n + 1];
      e[n] = a * r.a + l * r.c + r.tx, e[n + 1] = a * r.b + l * r.d + r.ty;
    }
    return e;
  }
  /**
   * Updates matrices if texture was changed
   * @returns - whether or not it was updated
   */
  update() {
    const t = this._texture;
    this._updateID++;
    const e = t.uvs;
    this.mapCoord.set(e.x1 - e.x0, e.y1 - e.y0, e.x3 - e.x0, e.y3 - e.y0, e.x0, e.y0);
    const r = t.orig, n = t.trim;
    n && (_c.set(
      r.width / n.width,
      0,
      0,
      r.height / n.height,
      -n.x / n.width,
      -n.y / n.height
    ), this.mapCoord.append(_c));
    const a = t.source, l = this.uClampFrame, h = this.clampMargin / a._resolution, u = this.clampOffset / a._resolution;
    return l[0] = (t.frame.x + h + u) / a.width, l[1] = (t.frame.y + h + u) / a.height, l[2] = (t.frame.x + t.frame.width - h + u) / a.width, l[3] = (t.frame.y + t.frame.height - h + u) / a.height, this.uClampOffset[0] = this.clampOffset / a.pixelWidth, this.uClampOffset[1] = this.clampOffset / a.pixelHeight, this.isSimple = t.frame.width === a.width && t.frame.height === a.height && t.rotate === 0, !0;
  }
}
class k extends te {
  /**
   * @param {TextureOptions} options - Options for the texture
   */
  constructor({
    source: t,
    label: e,
    frame: r,
    orig: n,
    trim: a,
    defaultAnchor: l,
    defaultBorders: h,
    rotate: u,
    dynamic: f
  } = {}) {
    if (super(), this.uid = rt("texture"), this.uvs = { x0: 0, y0: 0, x1: 0, y1: 0, x2: 0, y2: 0, x3: 0, y3: 0 }, this.frame = new Z(), this.noFrame = !1, this.dynamic = !1, this.isTexture = !0, this.label = e, this.source = t?.source ?? new yt(), this.noFrame = !r, r)
      this.frame.copyFrom(r);
    else {
      const { width: p, height: m } = this._source;
      this.frame.width = p, this.frame.height = m;
    }
    this.orig = n || this.frame, this.trim = a, this.rotate = u ?? 0, this.defaultAnchor = l, this.defaultBorders = h, this.destroyed = !1, this.dynamic = f || !1, this.updateUvs();
  }
  set source(t) {
    this._source && this._source.off("resize", this.update, this), this._source = t, t.on("resize", this.update, this), this.emit("update", this);
  }
  /** the underlying source of the texture (equivalent of baseTexture in v7) */
  get source() {
    return this._source;
  }
  /** returns a TextureMatrix instance for this texture. By default, that object is not created because its heavy. */
  get textureMatrix() {
    return this._textureMatrix || (this._textureMatrix = new Wf(this)), this._textureMatrix;
  }
  /** The width of the Texture in pixels. */
  get width() {
    return this.orig.width;
  }
  /** The height of the Texture in pixels. */
  get height() {
    return this.orig.height;
  }
  /** Call this function when you have modified the frame of this texture. */
  updateUvs() {
    const { uvs: t, frame: e } = this, { width: r, height: n } = this._source, a = e.x / r, l = e.y / n, h = e.width / r, u = e.height / n;
    let f = this.rotate;
    if (f) {
      const p = h / 2, m = u / 2, g = a + p, x = l + m;
      f = at.add(f, at.NW), t.x0 = g + p * at.uX(f), t.y0 = x + m * at.uY(f), f = at.add(f, 2), t.x1 = g + p * at.uX(f), t.y1 = x + m * at.uY(f), f = at.add(f, 2), t.x2 = g + p * at.uX(f), t.y2 = x + m * at.uY(f), f = at.add(f, 2), t.x3 = g + p * at.uX(f), t.y3 = x + m * at.uY(f);
    } else
      t.x0 = a, t.y0 = l, t.x1 = a + h, t.y1 = l, t.x2 = a + h, t.y2 = l + u, t.x3 = a, t.y3 = l + u;
  }
  /**
   * Destroys this texture
   * @param destroySource - Destroy the source when the texture is destroyed.
   */
  destroy(t = !1) {
    this._source && t && (this._source.destroy(), this._source = null), this._textureMatrix = null, this.destroyed = !0, this.emit("destroy", this), this.removeAllListeners();
  }
  /**
   * Call this if you have modified the `texture outside` of the constructor.
   *
   * If you have modified this texture's source, you must separately call `texture.source.update()` to see those changes.
   */
  update() {
    this.noFrame && (this.frame.width = this._source.width, this.frame.height = this._source.height), this.updateUvs(), this.emit("update", this);
  }
  /** @deprecated since 8.0.0 */
  get baseTexture() {
    return W(K, "Texture.baseTexture is now Texture.source"), this._source;
  }
}
k.EMPTY = new k({
  label: "EMPTY",
  source: new yt({
    label: "EMPTY"
  })
});
k.EMPTY.destroy = Of;
k.WHITE = new k({
  source: new Mh({
    resource: new Uint8Array([255, 255, 255, 255]),
    width: 1,
    height: 1,
    alphaMode: "premultiply-alpha-on-upload",
    label: "WHITE"
  }),
  label: "WHITE"
});
k.WHITE.destroy = Of;
function Vf(s, t, e) {
  const { width: r, height: n } = e.orig, a = e.trim;
  if (a) {
    const l = a.width, h = a.height;
    s.minX = a.x - t._x * r, s.maxX = s.minX + l, s.minY = a.y - t._y * n, s.maxY = s.minY + h;
  } else
    s.minX = -t._x * r, s.maxX = s.minX + r, s.minY = -t._y * n, s.maxY = s.minY + n;
}
const mc = new D();
class Ut {
  /**
   * Creates a new Bounds object.
   * @param minX - The minimum X coordinate of the bounds.
   * @param minY - The minimum Y coordinate of the bounds.
   * @param maxX - The maximum X coordinate of the bounds.
   * @param maxY - The maximum Y coordinate of the bounds.
   */
  constructor(t = 1 / 0, e = 1 / 0, r = -1 / 0, n = -1 / 0) {
    this.minX = 1 / 0, this.minY = 1 / 0, this.maxX = -1 / 0, this.maxY = -1 / 0, this.matrix = mc, this.minX = t, this.minY = e, this.maxX = r, this.maxY = n;
  }
  /**
   * Checks if bounds are empty, meaning either width or height is zero or negative.
   * Empty bounds occur when min values exceed max values on either axis.
   * @example
   * ```ts
   * const bounds = new Bounds();
   *
   * // Check if newly created bounds are empty
   * console.log(bounds.isEmpty()); // true, default bounds are empty
   *
   * // Add frame and check again
   * bounds.addFrame(0, 0, 100, 100);
   * console.log(bounds.isEmpty()); // false, bounds now have area
   *
   * // Clear bounds
   * bounds.clear();
   * console.log(bounds.isEmpty()); // true, bounds are empty again
   * ```
   * @returns True if bounds are empty (have no area)
   * @see {@link Bounds#clear} For resetting bounds
   * @see {@link Bounds#isValid} For checking validity
   */
  isEmpty() {
    return this.minX > this.maxX || this.minY > this.maxY;
  }
  /**
   * The bounding rectangle representation of these bounds.
   * Lazily creates and updates a Rectangle instance based on the current bounds.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   *
   * // Get rectangle representation
   * const rect = bounds.rectangle;
   * console.log(rect.x, rect.y, rect.width, rect.height);
   *
   * // Use for hit testing
   * if (bounds.rectangle.contains(mouseX, mouseY)) {
   *     console.log('Mouse is inside bounds!');
   * }
   * ```
   * @see {@link Rectangle} For rectangle methods
   * @see {@link Bounds.isEmpty} For bounds validation
   */
  get rectangle() {
    this._rectangle || (this._rectangle = new Z());
    const t = this._rectangle;
    return this.minX > this.maxX || this.minY > this.maxY ? (t.x = 0, t.y = 0, t.width = 0, t.height = 0) : t.copyFromBounds(this), t;
  }
  /**
   * Clears the bounds and resets all coordinates to their default values.
   * Resets the transformation matrix back to identity.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * console.log(bounds.isEmpty()); // false
   * // Clear the bounds
   * bounds.clear();
   * console.log(bounds.isEmpty()); // true
   * ```
   * @returns This bounds object for chaining
   */
  clear() {
    return this.minX = 1 / 0, this.minY = 1 / 0, this.maxX = -1 / 0, this.maxY = -1 / 0, this.matrix = mc, this;
  }
  /**
   * Sets the bounds directly using coordinate values.
   * Provides a way to set all bounds values at once.
   * @example
   * ```ts
   * const bounds = new Bounds();
   * bounds.set(0, 0, 100, 100);
   * ```
   * @param x0 - Left X coordinate of frame
   * @param y0 - Top Y coordinate of frame
   * @param x1 - Right X coordinate of frame
   * @param y1 - Bottom Y coordinate of frame
   * @see {@link Bounds#addFrame} For matrix-aware bounds setting
   * @see {@link Bounds#clear} For resetting bounds
   */
  set(t, e, r, n) {
    this.minX = t, this.minY = e, this.maxX = r, this.maxY = n;
  }
  /**
   * Adds a rectangular frame to the bounds, optionally transformed by a matrix.
   * Updates the bounds to encompass the new frame coordinates.
   * @example
   * ```ts
   * const bounds = new Bounds();
   * bounds.addFrame(0, 0, 100, 100);
   *
   * // Add transformed frame
   * const matrix = new Matrix()
   *     .translate(50, 50)
   *     .rotate(Math.PI / 4);
   * bounds.addFrame(0, 0, 100, 100, matrix);
   * ```
   * @param x0 - Left X coordinate of frame
   * @param y0 - Top Y coordinate of frame
   * @param x1 - Right X coordinate of frame
   * @param y1 - Bottom Y coordinate of frame
   * @param matrix - Optional transformation matrix
   * @see {@link Bounds#addRect} For adding Rectangle objects
   * @see {@link Bounds#addBounds} For adding other Bounds
   */
  addFrame(t, e, r, n, a) {
    a || (a = this.matrix);
    const l = a.a, h = a.b, u = a.c, f = a.d, p = a.tx, m = a.ty;
    let g = this.minX, x = this.minY, o = this.maxX, c = this.maxY, d = l * t + u * e + p, _ = h * t + f * e + m;
    d < g && (g = d), _ < x && (x = _), d > o && (o = d), _ > c && (c = _), d = l * r + u * e + p, _ = h * r + f * e + m, d < g && (g = d), _ < x && (x = _), d > o && (o = d), _ > c && (c = _), d = l * t + u * n + p, _ = h * t + f * n + m, d < g && (g = d), _ < x && (x = _), d > o && (o = d), _ > c && (c = _), d = l * r + u * n + p, _ = h * r + f * n + m, d < g && (g = d), _ < x && (x = _), d > o && (o = d), _ > c && (c = _), this.minX = g, this.minY = x, this.maxX = o, this.maxY = c;
  }
  /**
   * Adds a rectangle to the bounds, optionally transformed by a matrix.
   * Updates the bounds to encompass the given rectangle.
   * @example
   * ```ts
   * const bounds = new Bounds();
   * // Add simple rectangle
   * const rect = new Rectangle(0, 0, 100, 100);
   * bounds.addRect(rect);
   *
   * // Add transformed rectangle
   * const matrix = new Matrix()
   *     .translate(50, 50)
   *     .rotate(Math.PI / 4);
   * bounds.addRect(rect, matrix);
   * ```
   * @param rect - The rectangle to be added
   * @param matrix - Optional transformation matrix
   * @see {@link Bounds#addFrame} For adding raw coordinates
   * @see {@link Bounds#addBounds} For adding other bounds
   */
  addRect(t, e) {
    this.addFrame(t.x, t.y, t.x + t.width, t.y + t.height, e);
  }
  /**
   * Adds another bounds object to this one, optionally transformed by a matrix.
   * Expands the bounds to include the given bounds' area.
   * @example
   * ```ts
   * const bounds = new Bounds();
   *
   * // Add child bounds
   * const childBounds = sprite.getBounds();
   * bounds.addBounds(childBounds);
   *
   * // Add transformed bounds
   * const matrix = new Matrix()
   *     .scale(2, 2);
   * bounds.addBounds(childBounds, matrix);
   * ```
   * @param bounds - The bounds to be added
   * @param matrix - Optional transformation matrix
   * @see {@link Bounds#addFrame} For adding raw coordinates
   * @see {@link Bounds#addRect} For adding rectangles
   */
  addBounds(t, e) {
    this.addFrame(t.minX, t.minY, t.maxX, t.maxY, e);
  }
  /**
   * Adds other Bounds as a mask, creating an intersection of the two bounds.
   * Only keeps the overlapping region between current bounds and mask bounds.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Create mask bounds
   * const mask = new Bounds();
   * mask.addFrame(50, 50, 150, 150);
   * // Apply mask - results in bounds of (50,50,100,100)
   * bounds.addBoundsMask(mask);
   * ```
   * @param mask - The Bounds to use as a mask
   * @see {@link Bounds#addBounds} For union operation
   * @see {@link Bounds#fit} For fitting to rectangle
   */
  addBoundsMask(t) {
    this.minX = this.minX > t.minX ? this.minX : t.minX, this.minY = this.minY > t.minY ? this.minY : t.minY, this.maxX = this.maxX < t.maxX ? this.maxX : t.maxX, this.maxY = this.maxY < t.maxY ? this.maxY : t.maxY;
  }
  /**
   * Applies a transformation matrix to the bounds, updating its coordinates.
   * Transforms all corners of the bounds using the given matrix.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Apply translation
   * const translateMatrix = new Matrix()
   *     .translate(50, 50);
   * bounds.applyMatrix(translateMatrix);
   * ```
   * @param matrix - The matrix to apply to the bounds
   * @see {@link Matrix} For matrix operations
   * @see {@link Bounds#addFrame} For adding transformed frames
   */
  applyMatrix(t) {
    const e = this.minX, r = this.minY, n = this.maxX, a = this.maxY, { a: l, b: h, c: u, d: f, tx: p, ty: m } = t;
    let g = l * e + u * r + p, x = h * e + f * r + m;
    this.minX = g, this.minY = x, this.maxX = g, this.maxY = x, g = l * n + u * r + p, x = h * n + f * r + m, this.minX = g < this.minX ? g : this.minX, this.minY = x < this.minY ? x : this.minY, this.maxX = g > this.maxX ? g : this.maxX, this.maxY = x > this.maxY ? x : this.maxY, g = l * e + u * a + p, x = h * e + f * a + m, this.minX = g < this.minX ? g : this.minX, this.minY = x < this.minY ? x : this.minY, this.maxX = g > this.maxX ? g : this.maxX, this.maxY = x > this.maxY ? x : this.maxY, g = l * n + u * a + p, x = h * n + f * a + m, this.minX = g < this.minX ? g : this.minX, this.minY = x < this.minY ? x : this.minY, this.maxX = g > this.maxX ? g : this.maxX, this.maxY = x > this.maxY ? x : this.maxY;
  }
  /**
   * Resizes the bounds object to fit within the given rectangle.
   * Clips the bounds if they extend beyond the rectangle's edges.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 200, 200);
   * // Fit within viewport
   * const viewport = new Rectangle(50, 50, 100, 100);
   * bounds.fit(viewport);
   * // bounds are now (50, 50, 150, 150)
   * ```
   * @param rect - The rectangle to fit within
   * @returns This bounds object for chaining
   * @see {@link Bounds#addBoundsMask} For intersection
   * @see {@link Bounds#pad} For expanding bounds
   */
  fit(t) {
    return this.minX < t.left && (this.minX = t.left), this.maxX > t.right && (this.maxX = t.right), this.minY < t.top && (this.minY = t.top), this.maxY > t.bottom && (this.maxY = t.bottom), this;
  }
  /**
   * Resizes the bounds object to include the given bounds.
   * Similar to fit() but works with raw coordinate values instead of a Rectangle.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 200, 200);
   * // Fit to specific coordinates
   * bounds.fitBounds(50, 150, 50, 150);
   * // bounds are now (50, 50, 150, 150)
   * ```
   * @param left - The left value of the bounds
   * @param right - The right value of the bounds
   * @param top - The top value of the bounds
   * @param bottom - The bottom value of the bounds
   * @returns This bounds object for chaining
   * @see {@link Bounds#fit} For fitting to Rectangle
   * @see {@link Bounds#addBoundsMask} For intersection
   */
  fitBounds(t, e, r, n) {
    return this.minX < t && (this.minX = t), this.maxX > e && (this.maxX = e), this.minY < r && (this.minY = r), this.maxY > n && (this.maxY = n), this;
  }
  /**
   * Pads bounds object, making it grow in all directions.
   * If paddingY is omitted, both paddingX and paddingY will be set to paddingX.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   *
   * // Add equal padding
   * bounds.pad(10);
   * // bounds are now (-10, -10, 110, 110)
   *
   * // Add different padding for x and y
   * bounds.pad(20, 10);
   * // bounds are now (-30, -20, 130, 120)
   * ```
   * @param paddingX - The horizontal padding amount
   * @param paddingY - The vertical padding amount
   * @returns This bounds object for chaining
   * @see {@link Bounds#fit} For constraining bounds
   * @see {@link Bounds#scale} For uniform scaling
   */
  pad(t, e = t) {
    return this.minX -= t, this.maxX += t, this.minY -= e, this.maxY += e, this;
  }
  /**
   * Ceils the bounds by rounding up max values and rounding down min values.
   * Useful for pixel-perfect calculations and avoiding fractional pixels.
   * @example
   * ```ts
   * const bounds = new Bounds();
   * bounds.set(10.2, 10.9, 50.1, 50.8);
   *
   * // Round to whole pixels
   * bounds.ceil();
   * // bounds are now (10, 10, 51, 51)
   * ```
   * @returns This bounds object for chaining
   * @see {@link Bounds#scale} For size adjustments
   * @see {@link Bounds#fit} For constraining bounds
   */
  ceil() {
    return this.minX = Math.floor(this.minX), this.minY = Math.floor(this.minY), this.maxX = Math.ceil(this.maxX), this.maxY = Math.ceil(this.maxY), this;
  }
  /**
   * Creates a new Bounds instance with the same values.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   *
   * // Create a copy
   * const copy = bounds.clone();
   *
   * // Original and copy are independent
   * bounds.pad(10);
   * console.log(copy.width === bounds.width); // false
   * ```
   * @returns A new Bounds instance with the same values
   * @see {@link Bounds#copyFrom} For reusing existing bounds
   */
  clone() {
    return new Ut(this.minX, this.minY, this.maxX, this.maxY);
  }
  /**
   * Scales the bounds by the given values, adjusting all edges proportionally.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   *
   * // Scale uniformly
   * bounds.scale(2);
   * // bounds are now (0, 0, 200, 200)
   *
   * // Scale non-uniformly
   * bounds.scale(0.5, 2);
   * // bounds are now (0, 0, 100, 400)
   * ```
   * @param x - The X value to scale by
   * @param y - The Y value to scale by (defaults to x)
   * @returns This bounds object for chaining
   * @see {@link Bounds#pad} For adding padding
   * @see {@link Bounds#fit} For constraining size
   */
  scale(t, e = t) {
    return this.minX *= t, this.minY *= e, this.maxX *= t, this.maxY *= e, this;
  }
  /**
   * The x position of the bounds in local space.
   * Setting this value will move the bounds while maintaining its width.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Get x position
   * console.log(bounds.x); // 0
   *
   * // Move bounds horizontally
   * bounds.x = 50;
   * console.log(bounds.minX, bounds.maxX); // 50, 150
   *
   * // Width stays the same
   * console.log(bounds.width); // Still 100
   * ```
   */
  get x() {
    return this.minX;
  }
  set x(t) {
    const e = this.maxX - this.minX;
    this.minX = t, this.maxX = t + e;
  }
  /**
   * The y position of the bounds in local space.
   * Setting this value will move the bounds while maintaining its height.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Get y position
   * console.log(bounds.y); // 0
   *
   * // Move bounds vertically
   * bounds.y = 50;
   * console.log(bounds.minY, bounds.maxY); // 50, 150
   *
   * // Height stays the same
   * console.log(bounds.height); // Still 100
   * ```
   */
  get y() {
    return this.minY;
  }
  set y(t) {
    const e = this.maxY - this.minY;
    this.minY = t, this.maxY = t + e;
  }
  /**
   * The width value of the bounds.
   * Represents the distance between minX and maxX coordinates.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Get width
   * console.log(bounds.width); // 100
   * // Resize width
   * bounds.width = 200;
   * console.log(bounds.maxX - bounds.minX); // 200
   * ```
   */
  get width() {
    return this.maxX - this.minX;
  }
  set width(t) {
    this.maxX = this.minX + t;
  }
  /**
   * The height value of the bounds.
   * Represents the distance between minY and maxY coordinates.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Get height
   * console.log(bounds.height); // 100
   * // Resize height
   * bounds.height = 150;
   * console.log(bounds.maxY - bounds.minY); // 150
   * ```
   */
  get height() {
    return this.maxY - this.minY;
  }
  set height(t) {
    this.maxY = this.minY + t;
  }
  /**
   * The left edge coordinate of the bounds.
   * Alias for minX.
   * @example
   * ```ts
   * const bounds = new Bounds(50, 0, 150, 100);
   * console.log(bounds.left); // 50
   * console.log(bounds.left === bounds.minX); // true
   * ```
   * @readonly
   */
  get left() {
    return this.minX;
  }
  /**
   * The right edge coordinate of the bounds.
   * Alias for maxX.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * console.log(bounds.right); // 100
   * console.log(bounds.right === bounds.maxX); // true
   * ```
   * @readonly
   */
  get right() {
    return this.maxX;
  }
  /**
   * The top edge coordinate of the bounds.
   * Alias for minY.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 25, 100, 125);
   * console.log(bounds.top); // 25
   * console.log(bounds.top === bounds.minY); // true
   * ```
   * @readonly
   */
  get top() {
    return this.minY;
  }
  /**
   * The bottom edge coordinate of the bounds.
   * Alias for maxY.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 200);
   * console.log(bounds.bottom); // 200
   * console.log(bounds.bottom === bounds.maxY); // true
   * ```
   * @readonly
   */
  get bottom() {
    return this.maxY;
  }
  /**
   * Whether the bounds has positive width and height.
   * Checks if both dimensions are greater than zero.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Check if bounds are positive
   * console.log(bounds.isPositive); // true
   *
   * // Negative bounds
   * bounds.maxX = bounds.minX;
   * console.log(bounds.isPositive); // false, width is 0
   * ```
   * @readonly
   * @see {@link Bounds#isEmpty} For checking empty state
   * @see {@link Bounds#isValid} For checking validity
   */
  get isPositive() {
    return this.maxX - this.minX > 0 && this.maxY - this.minY > 0;
  }
  /**
   * Whether the bounds has valid coordinates.
   * Checks if the bounds has been initialized with real values.
   * @example
   * ```ts
   * const bounds = new Bounds();
   * console.log(bounds.isValid); // false, default state
   *
   * // Set valid bounds
   * bounds.addFrame(0, 0, 100, 100);
   * console.log(bounds.isValid); // true
   * ```
   * @readonly
   * @see {@link Bounds#isEmpty} For checking empty state
   * @see {@link Bounds#isPositive} For checking dimensions
   */
  get isValid() {
    return this.minX + this.minY !== 1 / 0;
  }
  /**
   * Adds vertices from a Float32Array to the bounds, optionally transformed by a matrix.
   * Used for efficiently updating bounds from raw vertex data.
   * @example
   * ```ts
   * const bounds = new Bounds();
   *
   * // Add vertices from geometry
   * const vertices = new Float32Array([
   *     0, 0,    // Vertex 1
   *     100, 0,  // Vertex 2
   *     100, 100 // Vertex 3
   * ]);
   * bounds.addVertexData(vertices, 0, 6);
   *
   * // Add transformed vertices
   * const matrix = new Matrix()
   *     .translate(50, 50)
   *     .rotate(Math.PI / 4);
   * bounds.addVertexData(vertices, 0, 6, matrix);
   *
   * // Add subset of vertices
   * bounds.addVertexData(vertices, 2, 4); // Only second vertex
   * ```
   * @param vertexData - The array of vertices to add
   * @param beginOffset - Starting index in the vertex array
   * @param endOffset - Ending index in the vertex array (excluded)
   * @param matrix - Optional transformation matrix
   * @see {@link Bounds#addFrame} For adding rectangular frames
   * @see {@link Matrix} For transformation details
   */
  addVertexData(t, e, r, n) {
    let a = this.minX, l = this.minY, h = this.maxX, u = this.maxY;
    n || (n = this.matrix);
    const f = n.a, p = n.b, m = n.c, g = n.d, x = n.tx, o = n.ty;
    for (let c = e; c < r; c += 2) {
      const d = t[c], _ = t[c + 1], y = f * d + m * _ + x, v = p * d + g * _ + o;
      a = y < a ? y : a, l = v < l ? v : l, h = y > h ? y : h, u = v > u ? v : u;
    }
    this.minX = a, this.minY = l, this.maxX = h, this.maxY = u;
  }
  /**
   * Checks if a point is contained within the bounds.
   * Returns true if the point's coordinates fall within the bounds' area.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Basic point check
   * console.log(bounds.containsPoint(50, 50)); // true
   * console.log(bounds.containsPoint(150, 150)); // false
   *
   * // Check edges
   * console.log(bounds.containsPoint(0, 0));   // true, includes edges
   * console.log(bounds.containsPoint(100, 100)); // true, includes edges
   * ```
   * @param x - x coordinate to check
   * @param y - y coordinate to check
   * @returns True if the point is inside the bounds
   * @see {@link Bounds#isPositive} For valid bounds check
   * @see {@link Bounds#rectangle} For Rectangle representation
   */
  containsPoint(t, e) {
    return this.minX <= t && this.minY <= e && this.maxX >= t && this.maxY >= e;
  }
  /**
   * Returns a string representation of the bounds.
   * Useful for debugging and logging bounds information.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * console.log(bounds.toString()); // "[pixi.js:Bounds minX=0 minY=0 maxX=100 maxY=100 width=100 height=100]"
   * ```
   * @returns A string describing the bounds
   * @see {@link Bounds#copyFrom} For copying bounds
   * @see {@link Bounds#clone} For creating a new instance
   */
  toString() {
    return `[pixi.js:Bounds minX=${this.minX} minY=${this.minY} maxX=${this.maxX} maxY=${this.maxY} width=${this.width} height=${this.height}]`;
  }
  /**
   * Copies the bounds from another bounds object.
   * Useful for reusing bounds objects and avoiding allocations.
   * @example
   * ```ts
   * const sourceBounds = new Bounds(0, 0, 100, 100);
   * // Copy bounds
   * const targetBounds = new Bounds();
   * targetBounds.copyFrom(sourceBounds);
   * ```
   * @param bounds - The bounds to copy from
   * @returns This bounds object for chaining
   * @see {@link Bounds#clone} For creating new instances
   */
  copyFrom(t) {
    return this.minX = t.minX, this.minY = t.minY, this.maxX = t.maxX, this.maxY = t.maxY, this;
  }
}
var V0 = { grad: 0.9, turn: 360, rad: 360 / (2 * Math.PI) }, Ie = function(s) {
  return typeof s == "string" ? s.length > 0 : typeof s == "number";
}, vt = function(s, t, e) {
  return t === void 0 && (t = 0), e === void 0 && (e = Math.pow(10, t)), Math.round(e * s) / e + 0;
}, le = function(s, t, e) {
  return t === void 0 && (t = 0), e === void 0 && (e = 1), s > e ? e : s > t ? s : t;
}, $f = function(s) {
  return (s = isFinite(s) ? s % 360 : 0) > 0 ? s : s + 360;
}, gc = function(s) {
  return { r: le(s.r, 0, 255), g: le(s.g, 0, 255), b: le(s.b, 0, 255), a: le(s.a) };
}, ha = function(s) {
  return { r: vt(s.r), g: vt(s.g), b: vt(s.b), a: vt(s.a, 3) };
}, $0 = /^#([0-9a-f]{3,8})$/i, Is = function(s) {
  var t = s.toString(16);
  return t.length < 2 ? "0" + t : t;
}, Yf = function(s) {
  var t = s.r, e = s.g, r = s.b, n = s.a, a = Math.max(t, e, r), l = a - Math.min(t, e, r), h = l ? a === t ? (e - r) / l : a === e ? 2 + (r - t) / l : 4 + (t - e) / l : 0;
  return { h: 60 * (h < 0 ? h + 6 : h), s: a ? l / a * 100 : 0, v: a / 255 * 100, a: n };
}, Xf = function(s) {
  var t = s.h, e = s.s, r = s.v, n = s.a;
  t = t / 360 * 6, e /= 100, r /= 100;
  var a = Math.floor(t), l = r * (1 - e), h = r * (1 - (t - a) * e), u = r * (1 - (1 - t + a) * e), f = a % 6;
  return { r: 255 * [r, h, l, l, u, r][f], g: 255 * [u, r, r, h, l, l][f], b: 255 * [l, l, u, r, r, h][f], a: n };
}, yc = function(s) {
  return { h: $f(s.h), s: le(s.s, 0, 100), l: le(s.l, 0, 100), a: le(s.a) };
}, xc = function(s) {
  return { h: vt(s.h), s: vt(s.s), l: vt(s.l), a: vt(s.a, 3) };
}, bc = function(s) {
  return Xf((e = (t = s).s, { h: t.h, s: (e *= ((r = t.l) < 50 ? r : 100 - r) / 100) > 0 ? 2 * e / (r + e) * 100 : 0, v: r + e, a: t.a }));
  var t, e, r;
}, $r = function(s) {
  return { h: (t = Yf(s)).h, s: (n = (200 - (e = t.s)) * (r = t.v) / 100) > 0 && n < 200 ? e * r / 100 / (n <= 100 ? n : 200 - n) * 100 : 0, l: n / 2, a: t.a };
  var t, e, r, n;
}, Y0 = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s*,\s*([+-]?\d*\.?\d+)%\s*,\s*([+-]?\d*\.?\d+)%\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, X0 = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s+([+-]?\d*\.?\d+)%\s+([+-]?\d*\.?\d+)%\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, j0 = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, K0 = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, Po = { string: [[function(s) {
  var t = $0.exec(s);
  return t ? (s = t[1]).length <= 4 ? { r: parseInt(s[0] + s[0], 16), g: parseInt(s[1] + s[1], 16), b: parseInt(s[2] + s[2], 16), a: s.length === 4 ? vt(parseInt(s[3] + s[3], 16) / 255, 2) : 1 } : s.length === 6 || s.length === 8 ? { r: parseInt(s.substr(0, 2), 16), g: parseInt(s.substr(2, 2), 16), b: parseInt(s.substr(4, 2), 16), a: s.length === 8 ? vt(parseInt(s.substr(6, 2), 16) / 255, 2) : 1 } : null : null;
}, "hex"], [function(s) {
  var t = j0.exec(s) || K0.exec(s);
  return t ? t[2] !== t[4] || t[4] !== t[6] ? null : gc({ r: Number(t[1]) / (t[2] ? 100 / 255 : 1), g: Number(t[3]) / (t[4] ? 100 / 255 : 1), b: Number(t[5]) / (t[6] ? 100 / 255 : 1), a: t[7] === void 0 ? 1 : Number(t[7]) / (t[8] ? 100 : 1) }) : null;
}, "rgb"], [function(s) {
  var t = Y0.exec(s) || X0.exec(s);
  if (!t) return null;
  var e, r, n = yc({ h: (e = t[1], r = t[2], r === void 0 && (r = "deg"), Number(e) * (V0[r] || 1)), s: Number(t[3]), l: Number(t[4]), a: t[5] === void 0 ? 1 : Number(t[5]) / (t[6] ? 100 : 1) });
  return bc(n);
}, "hsl"]], object: [[function(s) {
  var t = s.r, e = s.g, r = s.b, n = s.a, a = n === void 0 ? 1 : n;
  return Ie(t) && Ie(e) && Ie(r) ? gc({ r: Number(t), g: Number(e), b: Number(r), a: Number(a) }) : null;
}, "rgb"], [function(s) {
  var t = s.h, e = s.s, r = s.l, n = s.a, a = n === void 0 ? 1 : n;
  if (!Ie(t) || !Ie(e) || !Ie(r)) return null;
  var l = yc({ h: Number(t), s: Number(e), l: Number(r), a: Number(a) });
  return bc(l);
}, "hsl"], [function(s) {
  var t = s.h, e = s.s, r = s.v, n = s.a, a = n === void 0 ? 1 : n;
  if (!Ie(t) || !Ie(e) || !Ie(r)) return null;
  var l = function(h) {
    return { h: $f(h.h), s: le(h.s, 0, 100), v: le(h.v, 0, 100), a: le(h.a) };
  }({ h: Number(t), s: Number(e), v: Number(r), a: Number(a) });
  return Xf(l);
}, "hsv"]] }, vc = function(s, t) {
  for (var e = 0; e < t.length; e++) {
    var r = t[e][0](s);
    if (r) return [r, t[e][1]];
  }
  return [null, void 0];
}, q0 = function(s) {
  return typeof s == "string" ? vc(s.trim(), Po.string) : typeof s == "object" && s !== null ? vc(s, Po.object) : [null, void 0];
}, la = function(s, t) {
  var e = $r(s);
  return { h: e.h, s: le(e.s + 100 * t, 0, 100), l: e.l, a: e.a };
}, ca = function(s) {
  return (299 * s.r + 587 * s.g + 114 * s.b) / 1e3 / 255;
}, wc = function(s, t) {
  var e = $r(s);
  return { h: e.h, s: e.s, l: le(e.l + 100 * t, 0, 100), a: e.a };
}, Mo = function() {
  function s(t) {
    this.parsed = q0(t)[0], this.rgba = this.parsed || { r: 0, g: 0, b: 0, a: 1 };
  }
  return s.prototype.isValid = function() {
    return this.parsed !== null;
  }, s.prototype.brightness = function() {
    return vt(ca(this.rgba), 2);
  }, s.prototype.isDark = function() {
    return ca(this.rgba) < 0.5;
  }, s.prototype.isLight = function() {
    return ca(this.rgba) >= 0.5;
  }, s.prototype.toHex = function() {
    return t = ha(this.rgba), e = t.r, r = t.g, n = t.b, l = (a = t.a) < 1 ? Is(vt(255 * a)) : "", "#" + Is(e) + Is(r) + Is(n) + l;
    var t, e, r, n, a, l;
  }, s.prototype.toRgb = function() {
    return ha(this.rgba);
  }, s.prototype.toRgbString = function() {
    return t = ha(this.rgba), e = t.r, r = t.g, n = t.b, (a = t.a) < 1 ? "rgba(" + e + ", " + r + ", " + n + ", " + a + ")" : "rgb(" + e + ", " + r + ", " + n + ")";
    var t, e, r, n, a;
  }, s.prototype.toHsl = function() {
    return xc($r(this.rgba));
  }, s.prototype.toHslString = function() {
    return t = xc($r(this.rgba)), e = t.h, r = t.s, n = t.l, (a = t.a) < 1 ? "hsla(" + e + ", " + r + "%, " + n + "%, " + a + ")" : "hsl(" + e + ", " + r + "%, " + n + "%)";
    var t, e, r, n, a;
  }, s.prototype.toHsv = function() {
    return t = Yf(this.rgba), { h: vt(t.h), s: vt(t.s), v: vt(t.v), a: vt(t.a, 3) };
    var t;
  }, s.prototype.invert = function() {
    return ve({ r: 255 - (t = this.rgba).r, g: 255 - t.g, b: 255 - t.b, a: t.a });
    var t;
  }, s.prototype.saturate = function(t) {
    return t === void 0 && (t = 0.1), ve(la(this.rgba, t));
  }, s.prototype.desaturate = function(t) {
    return t === void 0 && (t = 0.1), ve(la(this.rgba, -t));
  }, s.prototype.grayscale = function() {
    return ve(la(this.rgba, -1));
  }, s.prototype.lighten = function(t) {
    return t === void 0 && (t = 0.1), ve(wc(this.rgba, t));
  }, s.prototype.darken = function(t) {
    return t === void 0 && (t = 0.1), ve(wc(this.rgba, -t));
  }, s.prototype.rotate = function(t) {
    return t === void 0 && (t = 15), this.hue(this.hue() + t);
  }, s.prototype.alpha = function(t) {
    return typeof t == "number" ? ve({ r: (e = this.rgba).r, g: e.g, b: e.b, a: t }) : vt(this.rgba.a, 3);
    var e;
  }, s.prototype.hue = function(t) {
    var e = $r(this.rgba);
    return typeof t == "number" ? ve({ h: t, s: e.s, l: e.l, a: e.a }) : vt(e.h);
  }, s.prototype.isEqual = function(t) {
    return this.toHex() === ve(t).toHex();
  }, s;
}(), ve = function(s) {
  return s instanceof Mo ? s : new Mo(s);
}, Sc = [], Z0 = function(s) {
  s.forEach(function(t) {
    Sc.indexOf(t) < 0 && (t(Mo, Po), Sc.push(t));
  });
};
function Q0(s, t) {
  var e = { white: "#ffffff", bisque: "#ffe4c4", blue: "#0000ff", cadetblue: "#5f9ea0", chartreuse: "#7fff00", chocolate: "#d2691e", coral: "#ff7f50", antiquewhite: "#faebd7", aqua: "#00ffff", azure: "#f0ffff", whitesmoke: "#f5f5f5", papayawhip: "#ffefd5", plum: "#dda0dd", blanchedalmond: "#ffebcd", black: "#000000", gold: "#ffd700", goldenrod: "#daa520", gainsboro: "#dcdcdc", cornsilk: "#fff8dc", cornflowerblue: "#6495ed", burlywood: "#deb887", aquamarine: "#7fffd4", beige: "#f5f5dc", crimson: "#dc143c", cyan: "#00ffff", darkblue: "#00008b", darkcyan: "#008b8b", darkgoldenrod: "#b8860b", darkkhaki: "#bdb76b", darkgray: "#a9a9a9", darkgreen: "#006400", darkgrey: "#a9a9a9", peachpuff: "#ffdab9", darkmagenta: "#8b008b", darkred: "#8b0000", darkorchid: "#9932cc", darkorange: "#ff8c00", darkslateblue: "#483d8b", gray: "#808080", darkslategray: "#2f4f4f", darkslategrey: "#2f4f4f", deeppink: "#ff1493", deepskyblue: "#00bfff", wheat: "#f5deb3", firebrick: "#b22222", floralwhite: "#fffaf0", ghostwhite: "#f8f8ff", darkviolet: "#9400d3", magenta: "#ff00ff", green: "#008000", dodgerblue: "#1e90ff", grey: "#808080", honeydew: "#f0fff0", hotpink: "#ff69b4", blueviolet: "#8a2be2", forestgreen: "#228b22", lawngreen: "#7cfc00", indianred: "#cd5c5c", indigo: "#4b0082", fuchsia: "#ff00ff", brown: "#a52a2a", maroon: "#800000", mediumblue: "#0000cd", lightcoral: "#f08080", darkturquoise: "#00ced1", lightcyan: "#e0ffff", ivory: "#fffff0", lightyellow: "#ffffe0", lightsalmon: "#ffa07a", lightseagreen: "#20b2aa", linen: "#faf0e6", mediumaquamarine: "#66cdaa", lemonchiffon: "#fffacd", lime: "#00ff00", khaki: "#f0e68c", mediumseagreen: "#3cb371", limegreen: "#32cd32", mediumspringgreen: "#00fa9a", lightskyblue: "#87cefa", lightblue: "#add8e6", midnightblue: "#191970", lightpink: "#ffb6c1", mistyrose: "#ffe4e1", moccasin: "#ffe4b5", mintcream: "#f5fffa", lightslategray: "#778899", lightslategrey: "#778899", navajowhite: "#ffdead", navy: "#000080", mediumvioletred: "#c71585", powderblue: "#b0e0e6", palegoldenrod: "#eee8aa", oldlace: "#fdf5e6", paleturquoise: "#afeeee", mediumturquoise: "#48d1cc", mediumorchid: "#ba55d3", rebeccapurple: "#663399", lightsteelblue: "#b0c4de", mediumslateblue: "#7b68ee", thistle: "#d8bfd8", tan: "#d2b48c", orchid: "#da70d6", mediumpurple: "#9370db", purple: "#800080", pink: "#ffc0cb", skyblue: "#87ceeb", springgreen: "#00ff7f", palegreen: "#98fb98", red: "#ff0000", yellow: "#ffff00", slateblue: "#6a5acd", lavenderblush: "#fff0f5", peru: "#cd853f", palevioletred: "#db7093", violet: "#ee82ee", teal: "#008080", slategray: "#708090", slategrey: "#708090", aliceblue: "#f0f8ff", darkseagreen: "#8fbc8f", darkolivegreen: "#556b2f", greenyellow: "#adff2f", seagreen: "#2e8b57", seashell: "#fff5ee", tomato: "#ff6347", silver: "#c0c0c0", sienna: "#a0522d", lavender: "#e6e6fa", lightgreen: "#90ee90", orange: "#ffa500", orangered: "#ff4500", steelblue: "#4682b4", royalblue: "#4169e1", turquoise: "#40e0d0", yellowgreen: "#9acd32", salmon: "#fa8072", saddlebrown: "#8b4513", sandybrown: "#f4a460", rosybrown: "#bc8f8f", darksalmon: "#e9967a", lightgoldenrodyellow: "#fafad2", snow: "#fffafa", lightgrey: "#d3d3d3", lightgray: "#d3d3d3", dimgray: "#696969", dimgrey: "#696969", olivedrab: "#6b8e23", olive: "#808000" }, r = {};
  for (var n in e) r[e[n]] = n;
  var a = {};
  s.prototype.toName = function(l) {
    if (!(this.rgba.a || this.rgba.r || this.rgba.g || this.rgba.b)) return "transparent";
    var h, u, f = r[this.toHex()];
    if (f) return f;
    if (l?.closest) {
      var p = this.toRgb(), m = 1 / 0, g = "black";
      if (!a.length) for (var x in e) a[x] = new s(e[x]).toRgb();
      for (var o in e) {
        var c = (h = p, u = a[o], Math.pow(h.r - u.r, 2) + Math.pow(h.g - u.g, 2) + Math.pow(h.b - u.b, 2));
        c < m && (m = c, g = o);
      }
      return g;
    }
  }, t.string.push([function(l) {
    var h = l.toLowerCase(), u = h === "transparent" ? "#0000" : e[h];
    return u ? new s(u).toRgb() : null;
  }, "name"]);
}
Z0([Q0]);
const lr = class Dr {
  /**
   * @param {ColorSource} value - Optional value to use, if not provided, white is used.
   */
  constructor(t = 16777215) {
    this._value = null, this._components = new Float32Array(4), this._components.fill(1), this._int = 16777215, this.value = t;
  }
  /**
   * Get the red component of the color, normalized between 0 and 1.
   * @example
   * ```ts
   * const color = new Color('red');
   * console.log(color.red); // 1
   *
   * const green = new Color('#00ff00');
   * console.log(green.red); // 0
   * ```
   */
  get red() {
    return this._components[0];
  }
  /**
   * Get the green component of the color, normalized between 0 and 1.
   * @example
   * ```ts
   * const color = new Color('lime');
   * console.log(color.green); // 1
   *
   * const red = new Color('#ff0000');
   * console.log(red.green); // 0
   * ```
   */
  get green() {
    return this._components[1];
  }
  /**
   * Get the blue component of the color, normalized between 0 and 1.
   * @example
   * ```ts
   * const color = new Color('blue');
   * console.log(color.blue); // 1
   *
   * const yellow = new Color('#ffff00');
   * console.log(yellow.blue); // 0
   * ```
   */
  get blue() {
    return this._components[2];
  }
  /**
   * Get the alpha component of the color, normalized between 0 and 1.
   * @example
   * ```ts
   * const color = new Color('red');
   * console.log(color.alpha); // 1 (fully opaque)
   *
   * const transparent = new Color('rgba(255, 0, 0, 0.5)');
   * console.log(transparent.alpha); // 0.5 (semi-transparent)
   * ```
   */
  get alpha() {
    return this._components[3];
  }
  /**
   * Sets the color value and returns the instance for chaining.
   *
   * This is a chainable version of setting the `value` property.
   * @param value - The color to set. Accepts various formats:
   * - Hex strings/numbers (e.g., '#ff0000', 0xff0000)
   * - RGB/RGBA values (arrays, objects)
   * - CSS color names
   * - HSL/HSLA values
   * - HSV/HSVA values
   * @returns The Color instance for chaining
   * @example
   * ```ts
   * // Basic usage
   * const color = new Color();
   * color.setValue('#ff0000')
   *     .setAlpha(0.5)
   *     .premultiply(0.8);
   *
   * // Different formats
   * color.setValue(0xff0000);          // Hex number
   * color.setValue('#ff0000');         // Hex string
   * color.setValue([1, 0, 0]);         // RGB array
   * color.setValue([1, 0, 0, 0.5]);    // RGBA array
   * color.setValue({ r: 1, g: 0, b: 0 }); // RGB object
   *
   * // Copy from another color
   * const red = new Color('red');
   * color.setValue(red);
   * ```
   * @throws {Error} If the color value is invalid or null
   * @see {@link Color.value} For the underlying value property
   */
  setValue(t) {
    return this.value = t, this;
  }
  /**
   * The current color source. This property allows getting and setting the color value
   * while preserving the original format where possible.
   * @remarks
   * When setting:
   * - Setting to a `Color` instance copies its source and components
   * - Setting to other valid sources normalizes and stores the value
   * - Setting to `null` throws an Error
   * - The color remains unchanged if normalization fails
   *
   * When getting:
   * - Returns `null` if color was modified by {@link Color.multiply} or {@link Color.premultiply}
   * - Otherwise returns the original color source
   * @example
   * ```ts
   * // Setting different color formats
   * const color = new Color();
   *
   * color.value = 0xff0000;         // Hex number
   * color.value = '#ff0000';        // Hex string
   * color.value = [1, 0, 0];        // RGB array
   * color.value = [1, 0, 0, 0.5];   // RGBA array
   * color.value = { r: 1, g: 0, b: 0 }; // RGB object
   *
   * // Copying from another color
   * const red = new Color('red');
   * color.value = red;  // Copies red's components
   *
   * // Getting the value
   * console.log(color.value);  // Returns original format
   *
   * // After modifications
   * color.multiply([0.5, 0.5, 0.5]);
   * console.log(color.value);  // Returns null
   * ```
   * @throws {Error} When attempting to set `null`
   */
  set value(t) {
    if (t instanceof Dr)
      this._value = this._cloneSource(t._value), this._int = t._int, this._components.set(t._components);
    else {
      if (t === null)
        throw new Error("Cannot set Color#value to null");
      (this._value === null || !this._isSourceEqual(this._value, t)) && (this._value = this._cloneSource(t), this._normalize(this._value));
    }
  }
  get value() {
    return this._value;
  }
  /**
   * Copy a color source internally.
   * @param value - Color source
   */
  _cloneSource(t) {
    return typeof t == "string" || typeof t == "number" || t instanceof Number || t === null ? t : Array.isArray(t) || ArrayBuffer.isView(t) ? t.slice(0) : typeof t == "object" && t !== null ? { ...t } : t;
  }
  /**
   * Equality check for color sources.
   * @param value1 - First color source
   * @param value2 - Second color source
   * @returns `true` if the color sources are equal, `false` otherwise.
   */
  _isSourceEqual(t, e) {
    const r = typeof t;
    if (r !== typeof e)
      return !1;
    if (r === "number" || r === "string" || t instanceof Number)
      return t === e;
    if (Array.isArray(t) && Array.isArray(e) || ArrayBuffer.isView(t) && ArrayBuffer.isView(e))
      return t.length !== e.length ? !1 : t.every((a, l) => a === e[l]);
    if (t !== null && e !== null) {
      const a = Object.keys(t), l = Object.keys(e);
      return a.length !== l.length ? !1 : a.every((h) => t[h] === e[h]);
    }
    return t === e;
  }
  /**
   * Convert to a RGBA color object with normalized components (0-1).
   * @example
   * ```ts
   * import { Color } from 'pixi.js';
   *
   * // Convert colors to RGBA objects
   * new Color('white').toRgba();     // returns { r: 1, g: 1, b: 1, a: 1 }
   * new Color('#ff0000').toRgba();   // returns { r: 1, g: 0, b: 0, a: 1 }
   *
   * // With transparency
   * new Color('rgba(255,0,0,0.5)').toRgba(); // returns { r: 1, g: 0, b: 0, a: 0.5 }
   * ```
   * @returns An RGBA object with normalized components
   */
  toRgba() {
    const [t, e, r, n] = this._components;
    return { r: t, g: e, b: r, a: n };
  }
  /**
   * Convert to a RGB color object with normalized components (0-1).
   *
   * Alpha component is omitted in the output.
   * @example
   * ```ts
   * import { Color } from 'pixi.js';
   *
   * // Convert colors to RGB objects
   * new Color('white').toRgb();     // returns { r: 1, g: 1, b: 1 }
   * new Color('#ff0000').toRgb();   // returns { r: 1, g: 0, b: 0 }
   *
   * // Alpha is ignored
   * new Color('rgba(255,0,0,0.5)').toRgb(); // returns { r: 1, g: 0, b: 0 }
   * ```
   * @returns An RGB object with normalized components
   */
  toRgb() {
    const [t, e, r] = this._components;
    return { r: t, g: e, b: r };
  }
  /**
   * Convert to a CSS-style rgba string representation.
   *
   * RGB components are scaled to 0-255 range, alpha remains 0-1.
   * @example
   * ```ts
   * import { Color } from 'pixi.js';
   *
   * // Convert colors to RGBA strings
   * new Color('white').toRgbaString();     // returns "rgba(255,255,255,1)"
   * new Color('#ff0000').toRgbaString();   // returns "rgba(255,0,0,1)"
   *
   * // With transparency
   * new Color([1, 0, 0, 0.5]).toRgbaString(); // returns "rgba(255,0,0,0.5)"
   * ```
   * @returns A CSS-compatible rgba string
   */
  toRgbaString() {
    const [t, e, r] = this.toUint8RgbArray();
    return `rgba(${t},${e},${r},${this.alpha})`;
  }
  /**
   * Convert to an [R, G, B] array of clamped uint8 values (0 to 255).
   * @param {number[]|Uint8Array|Uint8ClampedArray} [out] - Optional output array. If not provided,
   * a cached array will be used and returned.
   * @returns Array containing RGB components as integers between 0-255
   * @example
   * ```ts
   * // Basic usage
   * new Color('white').toUint8RgbArray(); // returns [255, 255, 255]
   * new Color('#ff0000').toUint8RgbArray(); // returns [255, 0, 0]
   *
   * // Using custom output array
   * const rgb = new Uint8Array(3);
   * new Color('blue').toUint8RgbArray(rgb); // rgb is now [0, 0, 255]
   *
   * // Using different array types
   * new Color('red').toUint8RgbArray(new Uint8ClampedArray(3)); // [255, 0, 0]
   * new Color('red').toUint8RgbArray([]); // [255, 0, 0]
   * ```
   * @remarks
   * - Output values are always clamped between 0-255
   * - Alpha component is not included in output
   * - Reuses internal cache array if no output array provided
   */
  toUint8RgbArray(t) {
    const [e, r, n] = this._components;
    return this._arrayRgb || (this._arrayRgb = []), t || (t = this._arrayRgb), t[0] = Math.round(e * 255), t[1] = Math.round(r * 255), t[2] = Math.round(n * 255), t;
  }
  /**
   * Convert to an [R, G, B, A] array of normalized floats (numbers from 0.0 to 1.0).
   * @param {number[]|Float32Array} [out] - Optional output array. If not provided,
   * a cached array will be used and returned.
   * @returns Array containing RGBA components as floats between 0-1
   * @example
   * ```ts
   * // Basic usage
   * new Color('white').toArray();  // returns [1, 1, 1, 1]
   * new Color('red').toArray();    // returns [1, 0, 0, 1]
   *
   * // With alpha
   * new Color('rgba(255,0,0,0.5)').toArray(); // returns [1, 0, 0, 0.5]
   *
   * // Using custom output array
   * const rgba = new Float32Array(4);
   * new Color('blue').toArray(rgba); // rgba is now [0, 0, 1, 1]
   * ```
   * @remarks
   * - Output values are normalized between 0-1
   * - Includes alpha component as the fourth value
   * - Reuses internal cache array if no output array provided
   */
  toArray(t) {
    this._arrayRgba || (this._arrayRgba = []), t || (t = this._arrayRgba);
    const [e, r, n, a] = this._components;
    return t[0] = e, t[1] = r, t[2] = n, t[3] = a, t;
  }
  /**
   * Convert to an [R, G, B] array of normalized floats (numbers from 0.0 to 1.0).
   * @param {number[]|Float32Array} [out] - Optional output array. If not provided,
   * a cached array will be used and returned.
   * @returns Array containing RGB components as floats between 0-1
   * @example
   * ```ts
   * // Basic usage
   * new Color('white').toRgbArray(); // returns [1, 1, 1]
   * new Color('red').toRgbArray();   // returns [1, 0, 0]
   *
   * // Using custom output array
   * const rgb = new Float32Array(3);
   * new Color('blue').toRgbArray(rgb); // rgb is now [0, 0, 1]
   * ```
   * @remarks
   * - Output values are normalized between 0-1
   * - Alpha component is omitted from output
   * - Reuses internal cache array if no output array provided
   */
  toRgbArray(t) {
    this._arrayRgb || (this._arrayRgb = []), t || (t = this._arrayRgb);
    const [e, r, n] = this._components;
    return t[0] = e, t[1] = r, t[2] = n, t;
  }
  /**
   * Convert to a hexadecimal number.
   * @returns The color as a 24-bit RGB integer
   * @example
   * ```ts
   * // Basic usage
   * new Color('white').toNumber(); // returns 0xffffff
   * new Color('red').toNumber();   // returns 0xff0000
   *
   * // Store as hex
   * const color = new Color('blue');
   * const hex = color.toNumber(); // 0x0000ff
   * ```
   */
  toNumber() {
    return this._int;
  }
  /**
   * Convert to a BGR number.
   *
   * Useful for platforms that expect colors in BGR format.
   * @returns The color as a 24-bit BGR integer
   * @example
   * ```ts
   * // Convert RGB to BGR
   * new Color(0xffcc99).toBgrNumber(); // returns 0x99ccff
   *
   * // Common use case: platform-specific color format
   * const color = new Color('orange');
   * const bgrColor = color.toBgrNumber(); // Color with swapped R/B channels
   * ```
   * @remarks
   * This swaps the red and blue channels compared to the normal RGB format:
   * - RGB 0xRRGGBB becomes BGR 0xBBGGRR
   */
  toBgrNumber() {
    const [t, e, r] = this.toUint8RgbArray();
    return (r << 16) + (e << 8) + t;
  }
  /**
   * Convert to a hexadecimal number in little endian format (e.g., BBGGRR).
   *
   * Useful for platforms that expect colors in little endian byte order.
   * @example
   * ```ts
   * import { Color } from 'pixi.js';
   *
   * // Convert RGB color to little endian format
   * new Color(0xffcc99).toLittleEndianNumber(); // returns 0x99ccff
   *
   * // Common use cases:
   * const color = new Color('orange');
   * const leColor = color.toLittleEndianNumber(); // Swaps byte order for LE systems
   *
   * // Multiple conversions
   * const colors = {
   *     normal: 0xffcc99,
   *     littleEndian: new Color(0xffcc99).toLittleEndianNumber(), // 0x99ccff
   *     backToNormal: new Color(0x99ccff).toLittleEndianNumber()  // 0xffcc99
   * };
   * ```
   * @remarks
   * - Swaps R and B channels in the color value
   * - RGB 0xRRGGBB becomes 0xBBGGRR
   * - Useful for systems that use little endian byte order
   * - Can be used to convert back and forth between formats
   * @returns The color as a number in little endian format (BBGGRR)
   * @see {@link Color.toBgrNumber} For BGR format without byte swapping
   */
  toLittleEndianNumber() {
    const t = this._int;
    return (t >> 16) + (t & 65280) + ((t & 255) << 16);
  }
  /**
   * Multiply with another color.
   *
   * This action is destructive and modifies the original color.
   * @param {ColorSource} value - The color to multiply by. Accepts any valid color format:
   * - Hex strings/numbers (e.g., '#ff0000', 0xff0000)
   * - RGB/RGBA arrays ([1, 0, 0], [1, 0, 0, 1])
   * - Color objects ({ r: 1, g: 0, b: 0 })
   * - CSS color names ('red', 'blue')
   * @returns this - The Color instance for chaining
   * @example
   * ```ts
   * // Basic multiplication
   * const color = new Color('#ff0000');
   * color.multiply(0x808080); // 50% darker red
   *
   * // With transparency
   * color.multiply([1, 1, 1, 0.5]); // 50% transparent
   *
   * // Chain operations
   * color
   *     .multiply('#808080')
   *     .multiply({ r: 1, g: 1, b: 1, a: 0.5 });
   * ```
   * @remarks
   * - Multiplies each RGB component and alpha separately
   * - Values are clamped between 0-1
   * - Original color format is lost (value becomes null)
   * - Operation cannot be undone
   */
  multiply(t) {
    const [e, r, n, a] = Dr._temp.setValue(t)._components;
    return this._components[0] *= e, this._components[1] *= r, this._components[2] *= n, this._components[3] *= a, this._refreshInt(), this._value = null, this;
  }
  /**
   * Converts color to a premultiplied alpha format.
   *
   * This action is destructive and modifies the original color.
   * @param alpha - The alpha value to multiply by (0-1)
   * @param {boolean} [applyToRGB=true] - Whether to premultiply RGB channels
   * @returns {Color} The Color instance for chaining
   * @example
   * ```ts
   * // Basic premultiplication
   * const color = new Color('red');
   * color.premultiply(0.5); // 50% transparent red with premultiplied RGB
   *
   * // Alpha only (RGB unchanged)
   * color.premultiply(0.5, false); // 50% transparent, original RGB
   *
   * // Chain with other operations
   * color
   *     .multiply(0x808080)
   *     .premultiply(0.5)
   *     .toNumber();
   * ```
   * @remarks
   * - RGB channels are multiplied by alpha when applyToRGB is true
   * - Alpha is always set to the provided value
   * - Values are clamped between 0-1
   * - Original color format is lost (value becomes null)
   * - Operation cannot be undone
   */
  premultiply(t, e = !0) {
    return e && (this._components[0] *= t, this._components[1] *= t, this._components[2] *= t), this._components[3] = t, this._refreshInt(), this._value = null, this;
  }
  /**
   * Returns the color as a 32-bit premultiplied alpha integer.
   *
   * Format: 0xAARRGGBB
   * @param {number} alpha - The alpha value to multiply by (0-1)
   * @param {boolean} [applyToRGB=true] - Whether to premultiply RGB channels
   * @returns {number} The premultiplied color as a 32-bit integer
   * @example
   * ```ts
   * // Convert to premultiplied format
   * const color = new Color('red');
   *
   * // Full opacity (0xFFRRGGBB)
   * color.toPremultiplied(1.0); // 0xFFFF0000
   *
   * // 50% transparency with premultiplied RGB
   * color.toPremultiplied(0.5); // 0x7F7F0000
   *
   * // 50% transparency without RGB premultiplication
   * color.toPremultiplied(0.5, false); // 0x7FFF0000
   * ```
   * @remarks
   * - Returns full opacity (0xFF000000) when alpha is 1.0
   * - Returns 0 when alpha is 0.0 and applyToRGB is true
   * - RGB values are rounded during premultiplication
   */
  toPremultiplied(t, e = !0) {
    if (t === 1)
      return (255 << 24) + this._int;
    if (t === 0)
      return e ? 0 : this._int;
    let r = this._int >> 16 & 255, n = this._int >> 8 & 255, a = this._int & 255;
    return e && (r = r * t + 0.5 | 0, n = n * t + 0.5 | 0, a = a * t + 0.5 | 0), (t * 255 << 24) + (r << 16) + (n << 8) + a;
  }
  /**
   * Convert to a hexadecimal string (6 characters).
   * @returns A CSS-compatible hex color string (e.g., "#ff0000")
   * @example
   * ```ts
   * import { Color } from 'pixi.js';
   *
   * // Basic colors
   * new Color('red').toHex();    // returns "#ff0000"
   * new Color('white').toHex();  // returns "#ffffff"
   * new Color('black').toHex();  // returns "#000000"
   *
   * // From different formats
   * new Color(0xff0000).toHex(); // returns "#ff0000"
   * new Color([1, 0, 0]).toHex(); // returns "#ff0000"
   * new Color({ r: 1, g: 0, b: 0 }).toHex(); // returns "#ff0000"
   * ```
   * @remarks
   * - Always returns a 6-character hex string
   * - Includes leading "#" character
   * - Alpha channel is ignored
   * - Values are rounded to nearest hex value
   */
  toHex() {
    const t = this._int.toString(16);
    return `#${"000000".substring(0, 6 - t.length) + t}`;
  }
  /**
   * Convert to a hexadecimal string with alpha (8 characters).
   * @returns A CSS-compatible hex color string with alpha (e.g., "#ff0000ff")
   * @example
   * ```ts
   * import { Color } from 'pixi.js';
   *
   * // Fully opaque colors
   * new Color('red').toHexa();   // returns "#ff0000ff"
   * new Color('white').toHexa(); // returns "#ffffffff"
   *
   * // With transparency
   * new Color('rgba(255, 0, 0, 0.5)').toHexa(); // returns "#ff00007f"
   * new Color([1, 0, 0, 0]).toHexa(); // returns "#ff000000"
   * ```
   * @remarks
   * - Returns an 8-character hex string
   * - Includes leading "#" character
   * - Alpha is encoded in last two characters
   * - Values are rounded to nearest hex value
   */
  toHexa() {
    const e = Math.round(this._components[3] * 255).toString(16);
    return this.toHex() + "00".substring(0, 2 - e.length) + e;
  }
  /**
   * Set alpha (transparency) value while preserving color components.
   *
   * Provides a chainable interface for setting alpha.
   * @param alpha - Alpha value between 0 (fully transparent) and 1 (fully opaque)
   * @returns The Color instance for chaining
   * @example
   * ```ts
   * // Basic alpha setting
   * const color = new Color('red');
   * color.setAlpha(0.5);  // 50% transparent red
   *
   * // Chain with other operations
   * color
   *     .setValue('#ff0000')
   *     .setAlpha(0.8)    // 80% opaque
   *     .premultiply(0.5); // Further modify alpha
   *
   * // Reset to fully opaque
   * color.setAlpha(1);
   * ```
   * @remarks
   * - Alpha value is clamped between 0-1
   * - Can be chained with other color operations
   */
  setAlpha(t) {
    return this._components[3] = this._clamp(t), this;
  }
  /**
   * Normalize the input value into rgba
   * @param value - Input value
   */
  _normalize(t) {
    let e, r, n, a;
    if ((typeof t == "number" || t instanceof Number) && t >= 0 && t <= 16777215) {
      const l = t;
      e = (l >> 16 & 255) / 255, r = (l >> 8 & 255) / 255, n = (l & 255) / 255, a = 1;
    } else if ((Array.isArray(t) || t instanceof Float32Array) && t.length >= 3 && t.length <= 4)
      t = this._clamp(t), [e, r, n, a = 1] = t;
    else if ((t instanceof Uint8Array || t instanceof Uint8ClampedArray) && t.length >= 3 && t.length <= 4)
      t = this._clamp(t, 0, 255), [e, r, n, a = 255] = t, e /= 255, r /= 255, n /= 255, a /= 255;
    else if (typeof t == "string" || typeof t == "object") {
      if (typeof t == "string") {
        const h = Dr.HEX_PATTERN.exec(t);
        h && (t = `#${h[2]}`);
      }
      const l = ve(t);
      l.isValid() && ({ r: e, g: r, b: n, a } = l.rgba, e /= 255, r /= 255, n /= 255);
    }
    if (e !== void 0)
      this._components[0] = e, this._components[1] = r, this._components[2] = n, this._components[3] = a, this._refreshInt();
    else
      throw new Error(`Unable to convert color ${t}`);
  }
  /** Refresh the internal color rgb number */
  _refreshInt() {
    this._clamp(this._components);
    const [t, e, r] = this._components;
    this._int = (t * 255 << 16) + (e * 255 << 8) + (r * 255 | 0);
  }
  /**
   * Clamps values to a range. Will override original values
   * @param value - Value(s) to clamp
   * @param min - Minimum value
   * @param max - Maximum value
   */
  _clamp(t, e = 0, r = 1) {
    return typeof t == "number" ? Math.min(Math.max(t, e), r) : (t.forEach((n, a) => {
      t[a] = Math.min(Math.max(n, e), r);
    }), t);
  }
  /**
   * Check if a value can be interpreted as a valid color format.
   * Supports all color formats that can be used with the Color class.
   * @param value - Value to check
   * @returns True if the value can be used as a color
   * @example
   * ```ts
   * import { Color } from 'pixi.js';
   *
   * // CSS colors and hex values
   * Color.isColorLike('red');          // true
   * Color.isColorLike('#ff0000');      // true
   * Color.isColorLike(0xff0000);       // true
   *
   * // Arrays (RGB/RGBA)
   * Color.isColorLike([1, 0, 0]);      // true
   * Color.isColorLike([1, 0, 0, 0.5]); // true
   *
   * // TypedArrays
   * Color.isColorLike(new Float32Array([1, 0, 0]));          // true
   * Color.isColorLike(new Uint8Array([255, 0, 0]));          // true
   * Color.isColorLike(new Uint8ClampedArray([255, 0, 0]));   // true
   *
   * // Object formats
   * Color.isColorLike({ r: 1, g: 0, b: 0 });            // true (RGB)
   * Color.isColorLike({ r: 1, g: 0, b: 0, a: 0.5 });    // true (RGBA)
   * Color.isColorLike({ h: 0, s: 100, l: 50 });         // true (HSL)
   * Color.isColorLike({ h: 0, s: 100, l: 50, a: 0.5 }); // true (HSLA)
   * Color.isColorLike({ h: 0, s: 100, v: 100 });        // true (HSV)
   * Color.isColorLike({ h: 0, s: 100, v: 100, a: 0.5 });// true (HSVA)
   *
   * // Color instances
   * Color.isColorLike(new Color('red')); // true
   *
   * // Invalid values
   * Color.isColorLike(null);           // false
   * Color.isColorLike(undefined);      // false
   * Color.isColorLike({});             // false
   * Color.isColorLike([]);             // false
   * Color.isColorLike('not-a-color');  // false
   * ```
   * @remarks
   * Checks for the following formats:
   * - Numbers (0x000000 to 0xffffff)
   * - CSS color strings
   * - RGB/RGBA arrays and objects
   * - HSL/HSLA objects
   * - HSV/HSVA objects
   * - TypedArrays (Float32Array, Uint8Array, Uint8ClampedArray)
   * - Color instances
   * @see {@link ColorSource} For supported color format types
   * @see {@link Color.setValue} For setting color values
   * @category utility
   */
  static isColorLike(t) {
    return typeof t == "number" || typeof t == "string" || t instanceof Number || t instanceof Dr || Array.isArray(t) || t instanceof Uint8Array || t instanceof Uint8ClampedArray || t instanceof Float32Array || t.r !== void 0 && t.g !== void 0 && t.b !== void 0 || t.r !== void 0 && t.g !== void 0 && t.b !== void 0 && t.a !== void 0 || t.h !== void 0 && t.s !== void 0 && t.l !== void 0 || t.h !== void 0 && t.s !== void 0 && t.l !== void 0 && t.a !== void 0 || t.h !== void 0 && t.s !== void 0 && t.v !== void 0 || t.h !== void 0 && t.s !== void 0 && t.v !== void 0 && t.a !== void 0;
  }
};
lr.shared = new lr();
lr._temp = new lr();
lr.HEX_PATTERN = /^(#|0x)?(([a-f0-9]{3}){1,2}([a-f0-9]{2})?)$/i;
let Q = lr;
const J0 = {
  cullArea: null,
  cullable: !1,
  cullableChildren: !0
};
class Bh {
  /**
   * Constructs a new Pool.
   * @param ClassType - The constructor of the items in the pool.
   * @param {number} [initialSize] - The initial size of the pool.
   */
  constructor(t, e) {
    this._pool = [], this._count = 0, this._index = 0, this._classType = t, e && this.prepopulate(e);
  }
  /**
   * Prepopulates the pool with a given number of items.
   * @param total - The number of items to add to the pool.
   */
  prepopulate(t) {
    for (let e = 0; e < t; e++)
      this._pool[this._index++] = new this._classType();
    this._count += t;
  }
  /**
   * Gets an item from the pool. Calls the item's `init` method if it exists.
   * If there are no items left in the pool, a new one will be created.
   * @param {unknown} [data] - Optional data to pass to the item's constructor.
   * @returns {T} The item from the pool.
   */
  get(t) {
    let e;
    return this._index > 0 ? e = this._pool[--this._index] : e = new this._classType(), e.init?.(t), e;
  }
  /**
   * Returns an item to the pool. Calls the item's `reset` method if it exists.
   * @param {T} item - The item to return to the pool.
   */
  return(t) {
    t.reset?.(), this._pool[this._index++] = t;
  }
  /**
   * Gets the number of items in the pool.
   * @readonly
   */
  get totalSize() {
    return this._count;
  }
  /**
   * Gets the number of items in the pool that are free to use without needing to create more.
   * @readonly
   */
  get totalFree() {
    return this._index;
  }
  /**
   * Gets the number of items in the pool that are currently in use.
   * @readonly
   */
  get totalUsed() {
    return this._count - this._index;
  }
  /** clears the pool - mainly used for debugging! */
  clear() {
    this._pool.length = 0, this._index = 0;
  }
}
class tb {
  constructor() {
    this._poolsByClass = /* @__PURE__ */ new Map();
  }
  /**
   * Prepopulates a specific pool with a given number of items.
   * @template T The type of items in the pool. Must extend PoolItem.
   * @param {PoolItemConstructor<T>} Class - The constructor of the items in the pool.
   * @param {number} total - The number of items to add to the pool.
   */
  prepopulate(t, e) {
    this.getPool(t).prepopulate(e);
  }
  /**
   * Gets an item from a specific pool.
   * @template T The type of items in the pool. Must extend PoolItem.
   * @param {PoolItemConstructor<T>} Class - The constructor of the items in the pool.
   * @param {unknown} [data] - Optional data to pass to the item's constructor.
   * @returns {T} The item from the pool.
   */
  get(t, e) {
    return this.getPool(t).get(e);
  }
  /**
   * Returns an item to its respective pool.
   * @param {PoolItem} item - The item to return to the pool.
   */
  return(t) {
    this.getPool(t.constructor).return(t);
  }
  /**
   * Gets a specific pool based on the class type.
   * @template T The type of items in the pool. Must extend PoolItem.
   * @param {PoolItemConstructor<T>} ClassType - The constructor of the items in the pool.
   * @returns {Pool<T>} The pool of the given class type.
   */
  getPool(t) {
    return this._poolsByClass.has(t) || this._poolsByClass.set(t, new Bh(t)), this._poolsByClass.get(t);
  }
  /** gets the usage stats of each pool in the system */
  stats() {
    const t = {};
    return this._poolsByClass.forEach((e) => {
      const r = t[e._classType.name] ? e._classType.name + e._classType.ID : e._classType.name;
      t[r] = {
        free: e.totalFree,
        used: e.totalUsed,
        size: e.totalSize
      };
    }), t;
  }
}
const Ct = new tb(), eb = {
  get isCachedAsTexture() {
    return !!this.renderGroup?.isCachedAsTexture;
  },
  cacheAsTexture(s) {
    typeof s == "boolean" && s === !1 ? this.disableRenderGroup() : (this.enableRenderGroup(), this.renderGroup.enableCacheAsTexture(s === !0 ? {} : s));
  },
  updateCacheTexture() {
    this.renderGroup?.updateCacheTexture();
  },
  get cacheAsBitmap() {
    return this.isCachedAsTexture;
  },
  set cacheAsBitmap(s) {
    W("v8.6.0", "cacheAsBitmap is deprecated, use cacheAsTexture instead."), this.cacheAsTexture(s);
  }
};
function jf(s, t, e) {
  const r = s.length;
  let n;
  if (t >= r || e === 0)
    return;
  e = t + e > r ? r - t : e;
  const a = r - e;
  for (n = t; n < a; ++n)
    s[n] = s[n + e];
  s.length = a;
}
const ib = {
  allowChildren: !0,
  removeChildren(s = 0, t) {
    const e = t ?? this.children.length, r = e - s, n = [];
    if (r > 0 && r <= e) {
      for (let l = e - 1; l >= s; l--) {
        const h = this.children[l];
        h && (n.push(h), h.parent = null);
      }
      jf(this.children, s, e);
      const a = this.renderGroup || this.parentRenderGroup;
      a && a.removeChildren(n);
      for (let l = 0; l < n.length; ++l) {
        const h = n[l];
        h.parentRenderLayer?.detach(h), this.emit("childRemoved", h, this, l), n[l].emit("removed", this);
      }
      return n.length > 0 && this._didViewChangeTick++, n;
    } else if (r === 0 && this.children.length === 0)
      return n;
    throw new RangeError("removeChildren: numeric values are outside the acceptable range.");
  },
  removeChildAt(s) {
    const t = this.getChildAt(s);
    return this.removeChild(t);
  },
  getChildAt(s) {
    if (s < 0 || s >= this.children.length)
      throw new Error(`getChildAt: Index (${s}) does not exist.`);
    return this.children[s];
  },
  setChildIndex(s, t) {
    if (t < 0 || t >= this.children.length)
      throw new Error(`The index ${t} supplied is out of bounds ${this.children.length}`);
    this.getChildIndex(s), this.addChildAt(s, t);
  },
  getChildIndex(s) {
    const t = this.children.indexOf(s);
    if (t === -1)
      throw new Error("The supplied Container must be a child of the caller");
    return t;
  },
  addChildAt(s, t) {
    this.allowChildren || W(K, "addChildAt: Only Containers will be allowed to add children in v8.0.0");
    const { children: e } = this;
    if (t < 0 || t > e.length)
      throw new Error(`${s}addChildAt: The index ${t} supplied is out of bounds ${e.length}`);
    if (s.parent) {
      const n = s.parent.children.indexOf(s);
      if (s.parent === this && n === t)
        return s;
      n !== -1 && s.parent.children.splice(n, 1);
    }
    t === e.length ? e.push(s) : e.splice(t, 0, s), s.parent = this, s.didChange = !0, s._updateFlags = 15;
    const r = this.renderGroup || this.parentRenderGroup;
    return r && r.addChild(s), this.sortableChildren && (this.sortDirty = !0), this.emit("childAdded", s, this, t), s.emit("added", this), s;
  },
  swapChildren(s, t) {
    if (s === t)
      return;
    const e = this.getChildIndex(s), r = this.getChildIndex(t);
    this.children[e] = t, this.children[r] = s;
    const n = this.renderGroup || this.parentRenderGroup;
    n && (n.structureDidChange = !0), this._didContainerChangeTick++;
  },
  removeFromParent() {
    this.parent?.removeChild(this);
  },
  reparentChild(...s) {
    return s.length === 1 ? this.reparentChildAt(s[0], this.children.length) : (s.forEach((t) => this.reparentChildAt(t, this.children.length)), s[0]);
  },
  reparentChildAt(s, t) {
    if (s.parent === this)
      return this.setChildIndex(s, t), s;
    const e = s.worldTransform.clone();
    s.removeFromParent(), this.addChildAt(s, t);
    const r = this.worldTransform.clone();
    return r.invert(), e.prepend(r), s.setFromMatrix(e), s;
  }
}, rb = {
  collectRenderables(s, t, e) {
    this.parentRenderLayer && this.parentRenderLayer !== e || this.globalDisplayStatus < 7 || !this.includeInBuild || (this.sortableChildren && this.sortChildren(), this.isSimple ? this.collectRenderablesSimple(s, t, e) : this.renderGroup ? t.renderPipes.renderGroup.addRenderGroup(this.renderGroup, s) : this.collectRenderablesWithEffects(s, t, e));
  },
  collectRenderablesSimple(s, t, e) {
    const r = this.children, n = r.length;
    for (let a = 0; a < n; a++)
      r[a].collectRenderables(s, t, e);
  },
  collectRenderablesWithEffects(s, t, e) {
    const { renderPipes: r } = t;
    for (let n = 0; n < this.effects.length; n++) {
      const a = this.effects[n];
      r[a.pipe].push(a, this, s);
    }
    this.collectRenderablesSimple(s, t, e);
    for (let n = this.effects.length - 1; n >= 0; n--) {
      const a = this.effects[n];
      r[a.pipe].pop(a, this, s);
    }
  }
};
class wn {
  constructor() {
    this.pipe = "filter", this.priority = 1;
  }
  destroy() {
    for (let t = 0; t < this.filters.length; t++)
      this.filters[t].destroy();
    this.filters = null, this.filterArea = null;
  }
}
class sb {
  constructor() {
    this._effectClasses = [], this._tests = [], this._initialized = !1;
  }
  init() {
    this._initialized || (this._initialized = !0, this._effectClasses.forEach((t) => {
      this.add({
        test: t.test,
        maskClass: t
      });
    }));
  }
  add(t) {
    this._tests.push(t);
  }
  getMaskEffect(t) {
    this._initialized || this.init();
    for (let e = 0; e < this._tests.length; e++) {
      const r = this._tests[e];
      if (r.test(t))
        return Ct.get(r.maskClass, t);
    }
    return t;
  }
  returnMaskEffect(t) {
    Ct.return(t);
  }
}
const Bo = new sb();
L.handleByList(A.MaskEffect, Bo._effectClasses);
const nb = {
  _maskEffect: null,
  _maskOptions: {
    inverse: !1
  },
  _filterEffect: null,
  effects: [],
  _markStructureAsChanged() {
    const s = this.renderGroup || this.parentRenderGroup;
    s && (s.structureDidChange = !0);
  },
  addEffect(s) {
    this.effects.indexOf(s) === -1 && (this.effects.push(s), this.effects.sort((e, r) => e.priority - r.priority), this._markStructureAsChanged(), this._updateIsSimple());
  },
  removeEffect(s) {
    const t = this.effects.indexOf(s);
    t !== -1 && (this.effects.splice(t, 1), this._markStructureAsChanged(), this._updateIsSimple());
  },
  set mask(s) {
    const t = this._maskEffect;
    t?.mask !== s && (t && (this.removeEffect(t), Bo.returnMaskEffect(t), this._maskEffect = null), s != null && (this._maskEffect = Bo.getMaskEffect(s), this.addEffect(this._maskEffect)));
  },
  get mask() {
    return this._maskEffect?.mask;
  },
  setMask(s) {
    this._maskOptions = {
      ...this._maskOptions,
      ...s
    }, s.mask && (this.mask = s.mask), this._markStructureAsChanged();
  },
  set filters(s) {
    !Array.isArray(s) && s && (s = [s]);
    const t = this._filterEffect || (this._filterEffect = new wn());
    s = s;
    const e = s?.length > 0, r = t.filters?.length > 0, n = e !== r;
    s = Array.isArray(s) ? s.slice(0) : s, t.filters = Object.freeze(s), n && (e ? this.addEffect(t) : (this.removeEffect(t), t.filters = s ?? null));
  },
  get filters() {
    return this._filterEffect?.filters;
  },
  set filterArea(s) {
    this._filterEffect || (this._filterEffect = new wn()), this._filterEffect.filterArea = s;
  },
  get filterArea() {
    return this._filterEffect?.filterArea;
  }
}, ab = {
  label: null,
  get name() {
    return W(K, "Container.name property has been removed, use Container.label instead"), this.label;
  },
  set name(s) {
    W(K, "Container.name property has been removed, use Container.label instead"), this.label = s;
  },
  getChildByName(s, t = !1) {
    return this.getChildByLabel(s, t);
  },
  getChildByLabel(s, t = !1) {
    const e = this.children;
    for (let r = 0; r < e.length; r++) {
      const n = e[r];
      if (n.label === s || s instanceof RegExp && s.test(n.label))
        return n;
    }
    if (t)
      for (let r = 0; r < e.length; r++) {
        const a = e[r].getChildByLabel(s, !0);
        if (a)
          return a;
      }
    return null;
  },
  getChildrenByLabel(s, t = !1, e = []) {
    const r = this.children;
    for (let n = 0; n < r.length; n++) {
      const a = r[n];
      (a.label === s || s instanceof RegExp && s.test(a.label)) && e.push(a);
    }
    if (t)
      for (let n = 0; n < r.length; n++)
        r[n].getChildrenByLabel(s, !0, e);
    return e;
  }
}, It = new Bh(D), ze = new Bh(Ut), ob = new D(), hb = {
  getFastGlobalBounds(s, t) {
    t || (t = new Ut()), t.clear(), this._getGlobalBoundsRecursive(!!s, t, this.parentRenderLayer), t.isValid || t.set(0, 0, 0, 0);
    const e = this.renderGroup || this.parentRenderGroup;
    return t.applyMatrix(e.worldTransform), t;
  },
  _getGlobalBoundsRecursive(s, t, e) {
    let r = t;
    if (s && this.parentRenderLayer && this.parentRenderLayer !== e || this.localDisplayStatus !== 7 || !this.measurable)
      return;
    const n = !!this.effects.length;
    if ((this.renderGroup || n) && (r = ze.get().clear()), this.boundsArea)
      t.addRect(this.boundsArea, this.worldTransform);
    else {
      if (this.renderPipeId) {
        const l = this.bounds;
        r.addFrame(
          l.minX,
          l.minY,
          l.maxX,
          l.maxY,
          this.groupTransform
        );
      }
      const a = this.children;
      for (let l = 0; l < a.length; l++)
        a[l]._getGlobalBoundsRecursive(s, r, e);
    }
    if (n) {
      let a = !1;
      const l = this.renderGroup || this.parentRenderGroup;
      for (let h = 0; h < this.effects.length; h++)
        this.effects[h].addBounds && (a || (a = !0, r.applyMatrix(l.worldTransform)), this.effects[h].addBounds(r, !0));
      a && (r.applyMatrix(l.worldTransform.copyTo(ob).invert()), t.addBounds(r, this.relativeGroupTransform)), t.addBounds(r), ze.return(r);
    } else this.renderGroup && (t.addBounds(r, this.relativeGroupTransform), ze.return(r));
  }
};
function Uh(s, t, e) {
  e.clear();
  let r, n;
  return s.parent ? t ? r = s.parent.worldTransform : (n = It.get().identity(), r = Rh(s, n)) : r = D.IDENTITY, Kf(s, e, r, t), n && It.return(n), e.isValid || e.set(0, 0, 0, 0), e;
}
function Kf(s, t, e, r) {
  if (!s.visible || !s.measurable)
    return;
  let n;
  r ? n = s.worldTransform : (s.updateLocalTransform(), n = It.get(), n.appendFrom(s.localTransform, e));
  const a = t, l = !!s.effects.length;
  if (l && (t = ze.get().clear()), s.boundsArea)
    t.addRect(s.boundsArea, n);
  else {
    s.bounds && (t.matrix = n, t.addBounds(s.bounds));
    for (let h = 0; h < s.children.length; h++)
      Kf(s.children[h], t, n, r);
  }
  if (l) {
    for (let h = 0; h < s.effects.length; h++)
      s.effects[h].addBounds?.(t);
    a.addBounds(t, D.IDENTITY), ze.return(t);
  }
  r || It.return(n);
}
function Rh(s, t) {
  const e = s.parent;
  return e && (Rh(e, t), e.updateLocalTransform(), t.append(e.localTransform)), t;
}
function qf(s, t) {
  if (s === 16777215 || !t)
    return t;
  if (t === 16777215 || !s)
    return s;
  const e = s >> 16 & 255, r = s >> 8 & 255, n = s & 255, a = t >> 16 & 255, l = t >> 8 & 255, h = t & 255, u = e * a / 255 | 0, f = r * l / 255 | 0, p = n * h / 255 | 0;
  return (u << 16) + (f << 8) + p;
}
const Tc = 16777215;
function Sn(s, t) {
  return s === Tc ? t : t === Tc ? s : qf(s, t);
}
function nn(s) {
  return ((s & 255) << 16) + (s & 65280) + (s >> 16 & 255);
}
const lb = {
  getGlobalAlpha(s) {
    if (s)
      return this.renderGroup ? this.renderGroup.worldAlpha : this.parentRenderGroup ? this.parentRenderGroup.worldAlpha * this.alpha : this.alpha;
    let t = this.alpha, e = this.parent;
    for (; e; )
      t *= e.alpha, e = e.parent;
    return t;
  },
  getGlobalTransform(s, t) {
    if (t)
      return s.copyFrom(this.worldTransform);
    this.updateLocalTransform();
    const e = Rh(this, It.get().identity());
    return s.appendFrom(this.localTransform, e), It.return(e), s;
  },
  getGlobalTint(s) {
    if (s)
      return this.renderGroup ? nn(this.renderGroup.worldColor) : this.parentRenderGroup ? nn(
        Sn(this.localColor, this.parentRenderGroup.worldColor)
      ) : this.tint;
    let t = this.localColor, e = this.parent;
    for (; e; )
      t = Sn(t, e.localColor), e = e.parent;
    return nn(t);
  }
};
function Ih(s, t, e) {
  return t.clear(), e || (e = D.IDENTITY), Zf(s, t, e, s, !0), t.isValid || t.set(0, 0, 0, 0), t;
}
function Zf(s, t, e, r, n) {
  let a;
  if (n)
    a = It.get(), a = e.copyTo(a);
  else {
    if (!s.visible || !s.measurable)
      return;
    s.updateLocalTransform();
    const u = s.localTransform;
    a = It.get(), a.appendFrom(u, e);
  }
  const l = t, h = !!s.effects.length;
  if (h && (t = ze.get().clear()), s.boundsArea)
    t.addRect(s.boundsArea, a);
  else {
    s.renderPipeId && (t.matrix = a, t.addBounds(s.bounds));
    const u = s.children;
    for (let f = 0; f < u.length; f++)
      Zf(u[f], t, a, r, !1);
  }
  if (h) {
    for (let u = 0; u < s.effects.length; u++)
      s.effects[u].addLocalBounds?.(t, r);
    l.addBounds(t, D.IDENTITY), ze.return(t);
  }
  It.return(a);
}
function Qf(s, t) {
  const e = s.children;
  for (let r = 0; r < e.length; r++) {
    const n = e[r], a = n.uid, l = (n._didViewChangeTick & 65535) << 16 | n._didContainerChangeTick & 65535, h = t.index;
    (t.data[h] !== a || t.data[h + 1] !== l) && (t.data[t.index] = a, t.data[t.index + 1] = l, t.didChange = !0), t.index = h + 2, n.children.length && Qf(n, t);
  }
  return t.didChange;
}
const cb = new D(), ub = {
  _localBoundsCacheId: -1,
  _localBoundsCacheData: null,
  _setWidth(s, t) {
    const e = Math.sign(this.scale.x) || 1;
    t !== 0 ? this.scale.x = s / t * e : this.scale.x = e;
  },
  _setHeight(s, t) {
    const e = Math.sign(this.scale.y) || 1;
    t !== 0 ? this.scale.y = s / t * e : this.scale.y = e;
  },
  getLocalBounds() {
    this._localBoundsCacheData || (this._localBoundsCacheData = {
      data: [],
      index: 1,
      didChange: !1,
      localBounds: new Ut()
    });
    const s = this._localBoundsCacheData;
    return s.index = 1, s.didChange = !1, s.data[0] !== this._didViewChangeTick && (s.didChange = !0, s.data[0] = this._didViewChangeTick), Qf(this, s), s.didChange && Ih(this, s.localBounds, cb), s.localBounds;
  },
  getBounds(s, t) {
    return Uh(this, s, t || new Ut());
  }
}, db = {
  _onRender: null,
  set onRender(s) {
    const t = this.renderGroup || this.parentRenderGroup;
    if (!s) {
      this._onRender && t?.removeOnRender(this), this._onRender = null;
      return;
    }
    this._onRender || t?.addOnRender(this), this._onRender = s;
  },
  get onRender() {
    return this._onRender;
  }
}, fb = {
  _zIndex: 0,
  sortDirty: !1,
  sortableChildren: !1,
  get zIndex() {
    return this._zIndex;
  },
  set zIndex(s) {
    this._zIndex !== s && (this._zIndex = s, this.depthOfChildModified());
  },
  depthOfChildModified() {
    this.parent && (this.parent.sortableChildren = !0, this.parent.sortDirty = !0), this.parentRenderGroup && (this.parentRenderGroup.structureDidChange = !0);
  },
  sortChildren() {
    this.sortDirty && (this.sortDirty = !1, this.children.sort(pb));
  }
};
function pb(s, t) {
  return s._zIndex - t._zIndex;
}
const _b = {
  getGlobalPosition(s = new et(), t = !1) {
    return this.parent ? this.parent.toGlobal(this._position, s, t) : (s.x = this._position.x, s.y = this._position.y), s;
  },
  toGlobal(s, t, e = !1) {
    const r = this.getGlobalTransform(It.get(), e);
    return t = r.apply(s, t), It.return(r), t;
  },
  toLocal(s, t, e, r) {
    t && (s = t.toGlobal(s, e, r));
    const n = this.getGlobalTransform(It.get(), r);
    return e = n.applyInverse(s, e), It.return(n), e;
  }
};
class Jf {
  constructor() {
    this.uid = rt("instructionSet"), this.instructions = [], this.instructionSize = 0, this.renderables = [], this.gcTick = 0;
  }
  /** reset the instruction set so it can be reused set size back to 0 */
  reset() {
    this.instructionSize = 0;
  }
  /**
   * Add an instruction to the set
   * @param instruction - add an instruction to the set
   */
  add(t) {
    this.instructions[this.instructionSize++] = t;
  }
  /**
   * Log the instructions to the console (for debugging)
   * @internal
   */
  log() {
    this.instructions.length = this.instructionSize, console.table(this.instructions, ["type", "action"]);
  }
}
let mb = 0;
class gb {
  /**
   * @param textureOptions - options that will be passed to BaseRenderTexture constructor
   * @param {SCALE_MODE} [textureOptions.scaleMode] - See {@link SCALE_MODE} for possible values.
   */
  constructor(t) {
    this._poolKeyHash = /* @__PURE__ */ Object.create(null), this._texturePool = {}, this.textureOptions = t || {}, this.enableFullScreen = !1, this.textureStyle = new $e(this.textureOptions);
  }
  /**
   * Creates texture with params that were specified in pool constructor.
   * @param pixelWidth - Width of texture in pixels.
   * @param pixelHeight - Height of texture in pixels.
   * @param antialias
   */
  createTexture(t, e, r) {
    const n = new yt({
      ...this.textureOptions,
      width: t,
      height: e,
      resolution: 1,
      antialias: r,
      autoGarbageCollect: !1
    });
    return new k({
      source: n,
      label: `texturePool_${mb++}`
    });
  }
  /**
   * Gets a Power-of-Two render texture or fullScreen texture
   * @param frameWidth - The minimum width of the render texture.
   * @param frameHeight - The minimum height of the render texture.
   * @param resolution - The resolution of the render texture.
   * @param antialias
   * @returns The new render texture.
   */
  getOptimalTexture(t, e, r = 1, n) {
    let a = Math.ceil(t * r - 1e-6), l = Math.ceil(e * r - 1e-6);
    a = hr(a), l = hr(l);
    const h = (a << 17) + (l << 1) + (n ? 1 : 0);
    this._texturePool[h] || (this._texturePool[h] = []);
    let u = this._texturePool[h].pop();
    return u || (u = this.createTexture(a, l, n)), u.source._resolution = r, u.source.width = a / r, u.source.height = l / r, u.source.pixelWidth = a, u.source.pixelHeight = l, u.frame.x = 0, u.frame.y = 0, u.frame.width = t, u.frame.height = e, u.updateUvs(), this._poolKeyHash[u.uid] = h, u;
  }
  /**
   * Gets extra texture of the same size as input renderTexture
   * @param texture - The texture to check what size it is.
   * @param antialias - Whether to use antialias.
   * @returns A texture that is a power of two
   */
  getSameSizeTexture(t, e = !1) {
    const r = t.source;
    return this.getOptimalTexture(t.width, t.height, r._resolution, e);
  }
  /**
   * Place a render texture back into the pool. Optionally reset the style of the texture to the default texture style.
   * useful if you modified the style of the texture after getting it from the pool.
   * @param renderTexture - The renderTexture to free
   * @param resetStyle - Whether to reset the style of the texture to the default texture style
   */
  returnTexture(t, e = !1) {
    const r = this._poolKeyHash[t.uid];
    e && (t.source.style = this.textureStyle), this._texturePool[r].push(t);
  }
  /**
   * Clears the pool.
   * @param destroyTextures - Destroy all stored textures.
   */
  clear(t) {
    if (t = t !== !1, t)
      for (const e in this._texturePool) {
        const r = this._texturePool[e];
        if (r)
          for (let n = 0; n < r.length; n++)
            r[n].destroy(!0);
      }
    this._texturePool = {};
  }
}
const At = new gb();
class yb {
  constructor() {
    this.renderPipeId = "renderGroup", this.root = null, this.canBundle = !1, this.renderGroupParent = null, this.renderGroupChildren = [], this.worldTransform = new D(), this.worldColorAlpha = 4294967295, this.worldColor = 16777215, this.worldAlpha = 1, this.childrenToUpdate = /* @__PURE__ */ Object.create(null), this.updateTick = 0, this.gcTick = 0, this.childrenRenderablesToUpdate = { list: [], index: 0 }, this.structureDidChange = !0, this.instructionSet = new Jf(), this._onRenderContainers = [], this.textureNeedsUpdate = !0, this.isCachedAsTexture = !1, this._matrixDirty = 7;
  }
  init(t) {
    this.root = t, t._onRender && this.addOnRender(t), t.didChange = !0;
    const e = t.children;
    for (let r = 0; r < e.length; r++) {
      const n = e[r];
      n._updateFlags = 15, this.addChild(n);
    }
  }
  enableCacheAsTexture(t = {}) {
    this.textureOptions = t, this.isCachedAsTexture = !0, this.textureNeedsUpdate = !0;
  }
  disableCacheAsTexture() {
    this.isCachedAsTexture = !1, this.texture && (At.returnTexture(this.texture), this.texture = null);
  }
  updateCacheTexture() {
    this.textureNeedsUpdate = !0;
  }
  reset() {
    this.renderGroupChildren.length = 0;
    for (const t in this.childrenToUpdate) {
      const e = this.childrenToUpdate[t];
      e.list.fill(null), e.index = 0;
    }
    this.childrenRenderablesToUpdate.index = 0, this.childrenRenderablesToUpdate.list.fill(null), this.root = null, this.updateTick = 0, this.structureDidChange = !0, this._onRenderContainers.length = 0, this.renderGroupParent = null, this.disableCacheAsTexture();
  }
  get localTransform() {
    return this.root.localTransform;
  }
  addRenderGroupChild(t) {
    t.renderGroupParent && t.renderGroupParent._removeRenderGroupChild(t), t.renderGroupParent = this, this.renderGroupChildren.push(t);
  }
  _removeRenderGroupChild(t) {
    const e = this.renderGroupChildren.indexOf(t);
    e > -1 && this.renderGroupChildren.splice(e, 1), t.renderGroupParent = null;
  }
  addChild(t) {
    if (this.structureDidChange = !0, t.parentRenderGroup = this, t.updateTick = -1, t.parent === this.root ? t.relativeRenderGroupDepth = 1 : t.relativeRenderGroupDepth = t.parent.relativeRenderGroupDepth + 1, t.didChange = !0, this.onChildUpdate(t), t.renderGroup) {
      this.addRenderGroupChild(t.renderGroup);
      return;
    }
    t._onRender && this.addOnRender(t);
    const e = t.children;
    for (let r = 0; r < e.length; r++)
      this.addChild(e[r]);
  }
  removeChild(t) {
    if (this.structureDidChange = !0, t._onRender && (t.renderGroup || this.removeOnRender(t)), t.parentRenderGroup = null, t.renderGroup) {
      this._removeRenderGroupChild(t.renderGroup);
      return;
    }
    const e = t.children;
    for (let r = 0; r < e.length; r++)
      this.removeChild(e[r]);
  }
  removeChildren(t) {
    for (let e = 0; e < t.length; e++)
      this.removeChild(t[e]);
  }
  onChildUpdate(t) {
    let e = this.childrenToUpdate[t.relativeRenderGroupDepth];
    e || (e = this.childrenToUpdate[t.relativeRenderGroupDepth] = {
      index: 0,
      list: []
    }), e.list[e.index++] = t;
  }
  updateRenderable(t) {
    t.globalDisplayStatus < 7 || (this.instructionSet.renderPipes[t.renderPipeId].updateRenderable(t), t.didViewUpdate = !1);
  }
  onChildViewUpdate(t) {
    this.childrenRenderablesToUpdate.list[this.childrenRenderablesToUpdate.index++] = t;
  }
  get isRenderable() {
    return this.root.localDisplayStatus === 7 && this.worldAlpha > 0;
  }
  /**
   * adding a container to the onRender list will make sure the user function
   * passed in to the user defined 'onRender` callBack
   * @param container - the container to add to the onRender list
   */
  addOnRender(t) {
    this._onRenderContainers.push(t);
  }
  removeOnRender(t) {
    this._onRenderContainers.splice(this._onRenderContainers.indexOf(t), 1);
  }
  runOnRender(t) {
    for (let e = 0; e < this._onRenderContainers.length; e++)
      this._onRenderContainers[e]._onRender(t);
  }
  destroy() {
    this.disableCacheAsTexture(), this.renderGroupParent = null, this.root = null, this.childrenRenderablesToUpdate = null, this.childrenToUpdate = null, this.renderGroupChildren = null, this._onRenderContainers = null, this.instructionSet = null;
  }
  getChildren(t = []) {
    const e = this.root.children;
    for (let r = 0; r < e.length; r++)
      this._getChildren(e[r], t);
    return t;
  }
  _getChildren(t, e = []) {
    if (e.push(t), t.renderGroup)
      return e;
    const r = t.children;
    for (let n = 0; n < r.length; n++)
      this._getChildren(r[n], e);
    return e;
  }
  invalidateMatrices() {
    this._matrixDirty = 7;
  }
  /**
   * Returns the inverse of the world transform matrix.
   * @returns {Matrix} The inverse of the world transform matrix.
   */
  get inverseWorldTransform() {
    return (this._matrixDirty & 1) === 0 ? this._inverseWorldTransform : (this._matrixDirty &= -2, this._inverseWorldTransform || (this._inverseWorldTransform = new D()), this._inverseWorldTransform.copyFrom(this.worldTransform).invert());
  }
  /**
   * Returns the inverse of the texture offset transform matrix.
   * @returns {Matrix} The inverse of the texture offset transform matrix.
   */
  get textureOffsetInverseTransform() {
    return (this._matrixDirty & 2) === 0 ? this._textureOffsetInverseTransform : (this._matrixDirty &= -3, this._textureOffsetInverseTransform || (this._textureOffsetInverseTransform = new D()), this._textureOffsetInverseTransform.copyFrom(this.inverseWorldTransform).translate(
      -this._textureBounds.x,
      -this._textureBounds.y
    ));
  }
  /**
   * Returns the inverse of the parent texture transform matrix.
   * This is used to properly transform coordinates when rendering into cached textures.
   * @returns {Matrix} The inverse of the parent texture transform matrix.
   */
  get inverseParentTextureTransform() {
    if ((this._matrixDirty & 4) === 0)
      return this._inverseParentTextureTransform;
    this._matrixDirty &= -5;
    const t = this._parentCacheAsTextureRenderGroup;
    return t ? (this._inverseParentTextureTransform || (this._inverseParentTextureTransform = new D()), this._inverseParentTextureTransform.copyFrom(this.worldTransform).prepend(t.inverseWorldTransform).translate(
      -t._textureBounds.x,
      -t._textureBounds.y
    )) : this.worldTransform;
  }
  /**
   * Returns a matrix that transforms coordinates to the correct coordinate space of the texture being rendered to.
   * This is the texture offset inverse transform of the closest parent RenderGroup that is cached as a texture.
   * @returns {Matrix | null} The transform matrix for the cached texture coordinate space,
   * or null if no parent is cached as texture.
   */
  get cacheToLocalTransform() {
    return this._parentCacheAsTextureRenderGroup ? this._parentCacheAsTextureRenderGroup.textureOffsetInverseTransform : null;
  }
}
function xb(s, t, e = {}) {
  for (const r in t)
    !e[r] && t[r] !== void 0 && (s[r] = t[r]);
}
const ua = new Ft(null), da = new Ft(null), fa = new Ft(null, 1, 1), Tn = 1, kh = 2, Yr = 4;
class St extends te {
  constructor(t = {}) {
    super(), this.uid = rt("renderable"), this._updateFlags = 15, this.renderGroup = null, this.parentRenderGroup = null, this.parentRenderGroupIndex = 0, this.didChange = !1, this.didViewUpdate = !1, this.relativeRenderGroupDepth = 0, this.children = [], this.parent = null, this.includeInBuild = !0, this.measurable = !0, this.isSimple = !0, this.updateTick = -1, this.localTransform = new D(), this.relativeGroupTransform = new D(), this.groupTransform = this.relativeGroupTransform, this.destroyed = !1, this._position = new Ft(this, 0, 0), this._scale = fa, this._pivot = da, this._skew = ua, this._cx = 1, this._sx = 0, this._cy = 0, this._sy = 1, this._rotation = 0, this.localColor = 16777215, this.localAlpha = 1, this.groupAlpha = 1, this.groupColor = 16777215, this.groupColorAlpha = 4294967295, this.localBlendMode = "inherit", this.groupBlendMode = "normal", this.localDisplayStatus = 7, this.globalDisplayStatus = 7, this._didContainerChangeTick = 0, this._didViewChangeTick = 0, this._didLocalTransformChangeId = -1, this.effects = [], xb(this, t, {
      children: !0,
      parent: !0,
      effects: !0
    }), t.children?.forEach((e) => this.addChild(e)), t.parent?.addChild(this);
  }
  /**
   * Mixes all enumerable properties and methods from a source object to Container.
   * @param source - The source of properties and methods to mix in.
   * @deprecated since 8.8.0
   */
  static mixin(t) {
    W("8.8.0", "Container.mixin is deprecated, please use extensions.mixin instead."), L.mixin(St, t);
  }
  // = 'default';
  /**
   * We now use the _didContainerChangeTick and _didViewChangeTick to track changes
   * @deprecated since 8.2.6
   * @ignore
   */
  set _didChangeId(t) {
    this._didViewChangeTick = t >> 12 & 4095, this._didContainerChangeTick = t & 4095;
  }
  /** @ignore */
  get _didChangeId() {
    return this._didContainerChangeTick & 4095 | (this._didViewChangeTick & 4095) << 12;
  }
  /**
   * Adds one or more children to the container.
   * The children will be rendered as part of this container's display list.
   * @example
   * ```ts
   * // Add a single child
   * container.addChild(sprite);
   *
   * // Add multiple children
   * container.addChild(background, player, foreground);
   *
   * // Add with type checking
   * const sprite = container.addChild<Sprite>(new Sprite(texture));
   * sprite.tint = 'red';
   * ```
   * @param children - The Container(s) to add to the container
   * @returns The first child that was added
   * @see {@link Container#removeChild} For removing children
   * @see {@link Container#addChildAt} For adding at specific index
   */
  addChild(...t) {
    if (this.allowChildren || W(K, "addChild: Only Containers will be allowed to add children in v8.0.0"), t.length > 1) {
      for (let n = 0; n < t.length; n++)
        this.addChild(t[n]);
      return t[0];
    }
    const e = t[0], r = this.renderGroup || this.parentRenderGroup;
    return e.parent === this ? (this.children.splice(this.children.indexOf(e), 1), this.children.push(e), r && (r.structureDidChange = !0), e) : (e.parent && e.parent.removeChild(e), this.children.push(e), this.sortableChildren && (this.sortDirty = !0), e.parent = this, e.didChange = !0, e._updateFlags = 15, r && r.addChild(e), this.emit("childAdded", e, this, this.children.length - 1), e.emit("added", this), this._didViewChangeTick++, e._zIndex !== 0 && e.depthOfChildModified(), e);
  }
  /**
   * Removes one or more children from the container.
   * When removing multiple children, events will be triggered for each child in sequence.
   * @example
   * ```ts
   * // Remove a single child
   * const removed = container.removeChild(sprite);
   *
   * // Remove multiple children
   * const bg = container.removeChild(background, player, userInterface);
   *
   * // Remove with type checking
   * const sprite = container.removeChild<Sprite>(childSprite);
   * sprite.texture = newTexture;
   * ```
   * @param children - The Container(s) to remove
   * @returns The first child that was removed
   * @see {@link Container#addChild} For adding children
   * @see {@link Container#removeChildren} For removing multiple children
   */
  removeChild(...t) {
    if (t.length > 1) {
      for (let n = 0; n < t.length; n++)
        this.removeChild(t[n]);
      return t[0];
    }
    const e = t[0], r = this.children.indexOf(e);
    return r > -1 && (this._didViewChangeTick++, this.children.splice(r, 1), this.renderGroup ? this.renderGroup.removeChild(e) : this.parentRenderGroup && this.parentRenderGroup.removeChild(e), e.parentRenderLayer && e.parentRenderLayer.detach(e), e.parent = null, this.emit("childRemoved", e, this, r), e.emit("removed", this)), e;
  }
  /** @ignore */
  _onUpdate(t) {
    t && t === this._skew && this._updateSkew(), this._didContainerChangeTick++, !this.didChange && (this.didChange = !0, this.parentRenderGroup && this.parentRenderGroup.onChildUpdate(this));
  }
  set isRenderGroup(t) {
    !!this.renderGroup !== t && (t ? this.enableRenderGroup() : this.disableRenderGroup());
  }
  /**
   * Returns true if this container is a render group.
   * This means that it will be rendered as a separate pass, with its own set of instructions
   * @advanced
   */
  get isRenderGroup() {
    return !!this.renderGroup;
  }
  /**
   * Calling this enables a render group for this container.
   * This means it will be rendered as a separate set of instructions.
   * The transform of the container will also be handled on the GPU rather than the CPU.
   * @advanced
   */
  enableRenderGroup() {
    if (this.renderGroup)
      return;
    const t = this.parentRenderGroup;
    t?.removeChild(this), this.renderGroup = Ct.get(yb, this), this.groupTransform = D.IDENTITY, t?.addChild(this), this._updateIsSimple();
  }
  /**
   * This will disable the render group for this container.
   * @advanced
   */
  disableRenderGroup() {
    if (!this.renderGroup)
      return;
    const t = this.parentRenderGroup;
    t?.removeChild(this), Ct.return(this.renderGroup), this.renderGroup = null, this.groupTransform = this.relativeGroupTransform, t?.addChild(this), this._updateIsSimple();
  }
  /** @ignore */
  _updateIsSimple() {
    this.isSimple = !this.renderGroup && this.effects.length === 0;
  }
  /**
   * Current transform of the object based on world (parent) factors.
   *
   * This matrix represents the absolute transformation in the scene graph.
   * @example
   * ```ts
   * // Get world position
   * const worldPos = container.worldTransform;
   * console.log(`World position: (${worldPos.tx}, ${worldPos.ty})`);
   * ```
   * @readonly
   * @see {@link Container#localTransform} For local space transform
   */
  get worldTransform() {
    return this._worldTransform || (this._worldTransform = new D()), this.renderGroup ? this._worldTransform.copyFrom(this.renderGroup.worldTransform) : this.parentRenderGroup && this._worldTransform.appendFrom(this.relativeGroupTransform, this.parentRenderGroup.worldTransform), this._worldTransform;
  }
  /**
   * The position of the container on the x axis relative to the local coordinates of the parent.
   *
   * An alias to position.x
   * @example
   * ```ts
   * // Basic position
   * container.x = 100;
   * ```
   */
  get x() {
    return this._position.x;
  }
  set x(t) {
    this._position.x = t;
  }
  /**
   * The position of the container on the y axis relative to the local coordinates of the parent.
   *
   * An alias to position.y
   * @example
   * ```ts
   * // Basic position
   * container.y = 200;
   * ```
   */
  get y() {
    return this._position.y;
  }
  set y(t) {
    this._position.y = t;
  }
  /**
   * The coordinate of the object relative to the local coordinates of the parent.
   * @example
   * ```ts
   * // Basic position setting
   * container.position.set(100, 200);
   * container.position.set(100); // Sets both x and y to 100
   * // Using point data
   * container.position = { x: 50, y: 75 };
   * ```
   * @since 4.0.0
   */
  get position() {
    return this._position;
  }
  set position(t) {
    this._position.copyFrom(t);
  }
  /**
   * The rotation of the object in radians.
   *
   * > [!NOTE] 'rotation' and 'angle' have the same effect on a display object;
   * > rotation is in radians, angle is in degrees.
   * @example
   * ```ts
   * // Basic rotation
   * container.rotation = Math.PI / 4; // 45 degrees
   *
   * // Convert from degrees
   * const degrees = 45;
   * container.rotation = degrees * Math.PI / 180;
   *
   * // Rotate around center
   * container.pivot.set(container.width / 2, container.height / 2);
   * container.rotation = Math.PI; // 180 degrees
   * ```
   */
  get rotation() {
    return this._rotation;
  }
  set rotation(t) {
    this._rotation !== t && (this._rotation = t, this._onUpdate(this._skew));
  }
  /**
   * The angle of the object in degrees.
   *
   * > [!NOTE] 'rotation' and 'angle' have the same effect on a display object;
   * > rotation is in radians, angle is in degrees.
   @example
   * ```ts
   * // Basic angle rotation
   * sprite.angle = 45; // 45 degrees
   *
   * // Rotate around center
   * sprite.pivot.set(sprite.width / 2, sprite.height / 2);
   * sprite.angle = 180; // Half rotation
   *
   * // Reset rotation
   * sprite.angle = 0;
   * ```
   */
  get angle() {
    return this.rotation * O0;
  }
  set angle(t) {
    this.rotation = t * L0;
  }
  /**
   * The center of rotation, scaling, and skewing for this display object in its local space.
   * The `position` is the projection of `pivot` in the parent's local space.
   *
   * By default, the pivot is the origin (0, 0).
   * @example
   * ```ts
   * // Rotate around center
   * container.pivot.set(container.width / 2, container.height / 2);
   * container.rotation = Math.PI; // Rotates around center
   * ```
   * @since 4.0.0
   */
  get pivot() {
    return this._pivot === da && (this._pivot = new Ft(this, 0, 0)), this._pivot;
  }
  set pivot(t) {
    this._pivot === da && (this._pivot = new Ft(this, 0, 0)), typeof t == "number" ? this._pivot.set(t) : this._pivot.copyFrom(t);
  }
  /**
   * The skew factor for the object in radians. Skewing is a transformation that distorts
   * the object by rotating it differently at each point, creating a non-uniform shape.
   * @example
   * ```ts
   * // Basic skewing
   * container.skew.set(0.5, 0); // Skew horizontally
   * container.skew.set(0, 0.5); // Skew vertically
   *
   * // Skew with point data
   * container.skew = { x: 0.3, y: 0.3 }; // Diagonal skew
   *
   * // Reset skew
   * container.skew.set(0, 0);
   *
   * // Animate skew
   * app.ticker.add(() => {
   *     // Create wave effect
   *     container.skew.x = Math.sin(Date.now() / 1000) * 0.3;
   * });
   *
   * // Combine with rotation
   * container.rotation = Math.PI / 4; // 45 degrees
   * container.skew.set(0.2, 0.2); // Skew the rotated object
   * ```
   * @since 4.0.0
   * @type {ObservablePoint} Point-like object with x/y properties in radians
   * @default {x: 0, y: 0}
   */
  get skew() {
    return this._skew === ua && (this._skew = new Ft(this, 0, 0)), this._skew;
  }
  set skew(t) {
    this._skew === ua && (this._skew = new Ft(this, 0, 0)), this._skew.copyFrom(t);
  }
  /**
   * The scale factors of this object along the local coordinate axes.
   *
   * The default scale is (1, 1).
   * @example
   * ```ts
   * // Basic scaling
   * container.scale.set(2, 2); // Scales to double size
   * container.scale.set(2); // Scales uniformly to double size
   * container.scale = 2; // Scales uniformly to double size
   * // Scale to a specific width and height
   * container.setSize(200, 100); // Sets width to 200 and height to 100
   * ```
   * @since 4.0.0
   */
  get scale() {
    return this._scale === fa && (this._scale = new Ft(this, 1, 1)), this._scale;
  }
  set scale(t) {
    this._scale === fa && (this._scale = new Ft(this, 0, 0)), typeof t == "number" ? this._scale.set(t) : this._scale.copyFrom(t);
  }
  /**
   * The width of the Container, setting this will actually modify the scale to achieve the value set.
   * > [!NOTE] Changing the width will adjust the scale.x property of the container while maintaining its aspect ratio.
   * > [!NOTE] If you want to set both width and height at the same time, use {@link Container#setSize}
   * as it is more optimized by not recalculating the local bounds twice.
   *  @example
   * ```ts
   * // Basic width setting
   * container.width = 100;
   * // Optimized width setting
   * container.setSize(100, 100);
   * ```
   */
  get width() {
    return Math.abs(this.scale.x * this.getLocalBounds().width);
  }
  set width(t) {
    const e = this.getLocalBounds().width;
    this._setWidth(t, e);
  }
  /**
   * The height of the Container,
   * > [!NOTE] Changing the height will adjust the scale.y property of the container while maintaining its aspect ratio.
   * > [!NOTE] If you want to set both width and height at the same time, use {@link Container#setSize}
   * as it is more optimized by not recalculating the local bounds twice.
   * @example
   * ```ts
   * // Basic height setting
   * container.height = 200;
   * // Optimized height setting
   * container.setSize(100, 200);
   * ```
   */
  get height() {
    return Math.abs(this.scale.y * this.getLocalBounds().height);
  }
  set height(t) {
    const e = this.getLocalBounds().height;
    this._setHeight(t, e);
  }
  /**
   * Retrieves the size of the container as a [Size]{@link Size} object.
   *
   * This is faster than get the width and height separately.
   * @example
   * ```ts
   * // Basic size retrieval
   * const size = container.getSize();
   * console.log(`Size: ${size.width}x${size.height}`);
   *
   * // Reuse existing size object
   * const reuseSize = { width: 0, height: 0 };
   * container.getSize(reuseSize);
   * ```
   * @param out - Optional object to store the size in.
   * @returns - The size of the container.
   */
  getSize(t) {
    t || (t = {});
    const e = this.getLocalBounds();
    return t.width = Math.abs(this.scale.x * e.width), t.height = Math.abs(this.scale.y * e.height), t;
  }
  /**
   * Sets the size of the container to the specified width and height.
   * This is more efficient than setting width and height separately as it only recalculates bounds once.
   * @example
   * ```ts
   * // Basic size setting
   * container.setSize(100, 200);
   *
   * // Set uniform size
   * container.setSize(100); // Sets both width and height to 100
   * ```
   * @param value - This can be either a number or a [Size]{@link Size} object.
   * @param height - The height to set. Defaults to the value of `width` if not provided.
   */
  setSize(t, e) {
    const r = this.getLocalBounds();
    typeof t == "object" ? (e = t.height ?? t.width, t = t.width) : e ?? (e = t), t !== void 0 && this._setWidth(t, r.width), e !== void 0 && this._setHeight(e, r.height);
  }
  /** Called when the skew or the rotation changes. */
  _updateSkew() {
    const t = this._rotation, e = this._skew;
    this._cx = Math.cos(t + e._y), this._sx = Math.sin(t + e._y), this._cy = -Math.sin(t - e._x), this._sy = Math.cos(t - e._x);
  }
  /**
   * Updates the transform properties of the container.
   * Allows partial updates of transform properties for optimized manipulation.
   * @example
   * ```ts
   * // Basic transform update
   * container.updateTransform({
   *     x: 100,
   *     y: 200,
   *     rotation: Math.PI / 4
   * });
   *
   * // Scale and rotate around center
   * sprite.updateTransform({
   *     pivotX: sprite.width / 2,
   *     pivotY: sprite.height / 2,
   *     scaleX: 2,
   *     scaleY: 2,
   *     rotation: Math.PI
   * });
   *
   * // Update position only
   * button.updateTransform({
   *     x: button.x + 10, // Move right
   *     y: button.y      // Keep same y
   * });
   * ```
   * @param opts - Transform options to update
   * @param opts.x - The x position
   * @param opts.y - The y position
   * @param opts.scaleX - The x-axis scale factor
   * @param opts.scaleY - The y-axis scale factor
   * @param opts.rotation - The rotation in radians
   * @param opts.skewX - The x-axis skew factor
   * @param opts.skewY - The y-axis skew factor
   * @param opts.pivotX - The x-axis pivot point
   * @param opts.pivotY - The y-axis pivot point
   * @returns This container, for chaining
   * @see {@link Container#setFromMatrix} For matrix-based transforms
   * @see {@link Container#position} For direct position access
   */
  updateTransform(t) {
    return this.position.set(
      typeof t.x == "number" ? t.x : this.position.x,
      typeof t.y == "number" ? t.y : this.position.y
    ), this.scale.set(
      typeof t.scaleX == "number" ? t.scaleX || 1 : this.scale.x,
      typeof t.scaleY == "number" ? t.scaleY || 1 : this.scale.y
    ), this.rotation = typeof t.rotation == "number" ? t.rotation : this.rotation, this.skew.set(
      typeof t.skewX == "number" ? t.skewX : this.skew.x,
      typeof t.skewY == "number" ? t.skewY : this.skew.y
    ), this.pivot.set(
      typeof t.pivotX == "number" ? t.pivotX : this.pivot.x,
      typeof t.pivotY == "number" ? t.pivotY : this.pivot.y
    ), this;
  }
  /**
   * Updates the local transform properties by decomposing the given matrix.
   * Extracts position, scale, rotation, and skew from a transformation matrix.
   * @example
   * ```ts
   * // Basic matrix transform
   * const matrix = new Matrix()
   *     .translate(100, 100)
   *     .rotate(Math.PI / 4)
   *     .scale(2, 2);
   *
   * container.setFromMatrix(matrix);
   *
   * // Copy transform from another container
   * const source = new Container();
   * source.position.set(100, 100);
   * source.rotation = Math.PI / 2;
   *
   * target.setFromMatrix(source.localTransform);
   *
   * // Reset transform
   * container.setFromMatrix(Matrix.IDENTITY);
   * ```
   * @param matrix - The matrix to use for updating the transform
   * @see {@link Container#updateTransform} For property-based updates
   * @see {@link Matrix#decompose} For matrix decomposition details
   */
  setFromMatrix(t) {
    t.decompose(this);
  }
  /** Updates the local transform. */
  updateLocalTransform() {
    const t = this._didContainerChangeTick;
    if (this._didLocalTransformChangeId === t)
      return;
    this._didLocalTransformChangeId = t;
    const e = this.localTransform, r = this._scale, n = this._pivot, a = this._position, l = r._x, h = r._y, u = n._x, f = n._y;
    e.a = this._cx * l, e.b = this._sx * l, e.c = this._cy * h, e.d = this._sy * h, e.tx = a._x - (u * e.a + f * e.c), e.ty = a._y - (u * e.b + f * e.d);
  }
  // / ///// color related stuff
  set alpha(t) {
    t !== this.localAlpha && (this.localAlpha = t, this._updateFlags |= Tn, this._onUpdate());
  }
  /**
   * The opacity of the object relative to its parent's opacity.
   * Value ranges from 0 (fully transparent) to 1 (fully opaque).
   * @example
   * ```ts
   * // Basic transparency
   * sprite.alpha = 0.5; // 50% opacity
   *
   * // Inherited opacity
   * container.alpha = 0.5;
   * const child = new Sprite(texture);
   * child.alpha = 0.5;
   * container.addChild(child);
   * // child's effective opacity is 0.25 (0.5 * 0.5)
   * ```
   * @default 1
   * @see {@link Container#visible} For toggling visibility
   * @see {@link Container#renderable} For render control
   */
  get alpha() {
    return this.localAlpha;
  }
  set tint(t) {
    const r = Q.shared.setValue(t ?? 16777215).toBgrNumber();
    r !== this.localColor && (this.localColor = r, this._updateFlags |= Tn, this._onUpdate());
  }
  /**
   * The tint applied to the sprite.
   *
   * This can be any valid {@link ColorSource}.
   * @example
   * ```ts
   * // Basic color tinting
   * container.tint = 0xff0000; // Red tint
   * container.tint = 'red';    // Same as above
   * container.tint = '#00ff00'; // Green
   * container.tint = 'rgb(0,0,255)'; // Blue
   *
   * // Remove tint
   * container.tint = 0xffffff; // White = no tint
   * container.tint = null;     // Also removes tint
   * ```
   * @default 0xFFFFFF
   * @see {@link Container#alpha} For transparency
   * @see {@link Container#visible} For visibility control
   */
  get tint() {
    return nn(this.localColor);
  }
  // / //////////////// blend related stuff
  set blendMode(t) {
    this.localBlendMode !== t && (this.parentRenderGroup && (this.parentRenderGroup.structureDidChange = !0), this._updateFlags |= kh, this.localBlendMode = t, this._onUpdate());
  }
  /**
   * The blend mode to be applied to the sprite. Controls how pixels are blended when rendering.
   *
   * Setting to 'normal' will reset to default blending.
   * > [!NOTE] More blend modes are available after importing the `pixi.js/advanced-blend-modes` sub-export.
   * @example
   * ```ts
   * // Basic blend modes
   * sprite.blendMode = 'add';        // Additive blending
   * sprite.blendMode = 'multiply';   // Multiply colors
   * sprite.blendMode = 'screen';     // Screen blend
   *
   * // Reset blend mode
   * sprite.blendMode = 'normal';     // Normal blending
   * ```
   * @default 'normal'
   * @see {@link Container#alpha} For transparency
   * @see {@link Container#tint} For color adjustments
   */
  get blendMode() {
    return this.localBlendMode;
  }
  // / ///////// VISIBILITY / RENDERABLE /////////////////
  /**
   * The visibility of the object. If false the object will not be drawn,
   * and the transform will not be updated.
   * @example
   * ```ts
   * // Basic visibility toggle
   * sprite.visible = false; // Hide sprite
   * sprite.visible = true;  // Show sprite
   * ```
   * @default true
   * @see {@link Container#renderable} For render-only control
   * @see {@link Container#alpha} For transparency
   */
  get visible() {
    return !!(this.localDisplayStatus & 2);
  }
  set visible(t) {
    const e = t ? 2 : 0;
    (this.localDisplayStatus & 2) !== e && (this.parentRenderGroup && (this.parentRenderGroup.structureDidChange = !0), this._updateFlags |= Yr, this.localDisplayStatus ^= 2, this._onUpdate());
  }
  /** @ignore */
  get culled() {
    return !(this.localDisplayStatus & 4);
  }
  /** @ignore */
  set culled(t) {
    const e = t ? 0 : 4;
    (this.localDisplayStatus & 4) !== e && (this.parentRenderGroup && (this.parentRenderGroup.structureDidChange = !0), this._updateFlags |= Yr, this.localDisplayStatus ^= 4, this._onUpdate());
  }
  /**
   * Controls whether this object can be rendered. If false the object will not be drawn,
   * but the transform will still be updated. This is different from visible, which skips
   * transform updates.
   * @example
   * ```ts
   * // Basic render control
   * sprite.renderable = false; // Skip rendering
   * sprite.renderable = true;  // Enable rendering
   * ```
   * @default true
   * @see {@link Container#visible} For skipping transform updates
   * @see {@link Container#alpha} For transparency
   */
  get renderable() {
    return !!(this.localDisplayStatus & 1);
  }
  set renderable(t) {
    const e = t ? 1 : 0;
    (this.localDisplayStatus & 1) !== e && (this._updateFlags |= Yr, this.localDisplayStatus ^= 1, this.parentRenderGroup && (this.parentRenderGroup.structureDidChange = !0), this._onUpdate());
  }
  /**
   * Whether or not the object should be rendered.
   * @advanced
   */
  get isRenderable() {
    return this.localDisplayStatus === 7 && this.groupAlpha > 0;
  }
  /**
   * Removes all internal references and listeners as well as removes children from the display list.
   * Do not use a Container after calling `destroy`.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @example
   * ```ts
   * container.destroy();
   * container.destroy(true);
   * container.destroy({ children: true });
   * container.destroy({ children: true, texture: true, textureSource: true });
   * ```
   */
  destroy(t = !1) {
    if (this.destroyed)
      return;
    this.destroyed = !0;
    let e;
    if (this.children.length && (e = this.removeChildren(0, this.children.length)), this.removeFromParent(), this.parent = null, this._maskEffect = null, this._filterEffect = null, this.effects = null, this._position = null, this._scale = null, this._pivot = null, this._skew = null, this.emit("destroyed", this), this.removeAllListeners(), (typeof t == "boolean" ? t : t?.children) && e)
      for (let n = 0; n < e.length; ++n)
        e[n].destroy(t);
    this.renderGroup?.destroy(), this.renderGroup = null;
  }
}
L.mixin(
  St,
  ib,
  hb,
  _b,
  db,
  ub,
  nb,
  ab,
  fb,
  J0,
  eb,
  lb,
  rb
);
class Fh extends St {
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(t) {
    super(t), this.canBundle = !0, this.allowChildren = !1, this._roundPixels = 0, this._lastUsed = -1, this._gpuData = /* @__PURE__ */ Object.create(null), this._bounds = new Ut(0, 1, 0, 0), this._boundsDirty = !0;
  }
  /**
   * The local bounds of the view in its own coordinate space.
   * Bounds are automatically updated when the view's content changes.
   * @example
   * ```ts
   * // Get bounds dimensions
   * const bounds = view.bounds;
   * console.log(`Width: ${bounds.maxX - bounds.minX}`);
   * console.log(`Height: ${bounds.maxY - bounds.minY}`);
   * ```
   * @returns The rectangular bounds of the view
   * @see {@link Bounds} For bounds operations
   */
  get bounds() {
    return this._boundsDirty ? (this.updateBounds(), this._boundsDirty = !1, this._bounds) : this._bounds;
  }
  /**
   * Whether or not to round the x/y position of the sprite.
   * @example
   * ```ts
   * // Enable pixel rounding for crisp rendering
   * view.roundPixels = true;
   * ```
   * @default false
   */
  get roundPixels() {
    return !!this._roundPixels;
  }
  set roundPixels(t) {
    this._roundPixels = t ? 1 : 0;
  }
  /**
   * Checks if the object contains the given point in local coordinates.
   * Uses the view's bounds for hit testing.
   * @example
   * ```ts
   * // Basic point check
   * const localPoint = { x: 50, y: 25 };
   * const contains = view.containsPoint(localPoint);
   * console.log('Point is inside:', contains);
   * ```
   * @param point - The point to check in local coordinates
   * @returns True if the point is within the view's bounds
   * @see {@link ViewContainer#bounds} For the bounds used in hit testing
   * @see {@link Container#toLocal} For converting global coordinates to local
   */
  containsPoint(t) {
    const e = this.bounds, { x: r, y: n } = t;
    return r >= e.minX && r <= e.maxX && n >= e.minY && n <= e.maxY;
  }
  /** @private */
  onViewUpdate() {
    if (this._didViewChangeTick++, this._boundsDirty = !0, this.didViewUpdate)
      return;
    this.didViewUpdate = !0;
    const t = this.renderGroup || this.parentRenderGroup;
    t && t.onChildViewUpdate(this);
  }
  destroy(t) {
    super.destroy(t), this._bounds = null;
    for (const e in this._gpuData)
      this._gpuData[e].destroy?.();
    this._gpuData = null;
  }
  /**
   * Collects renderables for the view container.
   * @param instructionSet - The instruction set to collect renderables for.
   * @param renderer - The renderer to collect renderables for.
   * @param currentLayer - The current render layer.
   * @internal
   */
  collectRenderablesSimple(t, e, r) {
    const { renderPipes: n } = e;
    n.blendMode.setBlendMode(this, this.groupBlendMode, t), n[this.renderPipeId].addRenderable(this, t), this.didViewUpdate = !1;
    const l = this.children, h = l.length;
    for (let u = 0; u < h; u++)
      l[u].collectRenderables(t, e, r);
  }
}
class Be extends Fh {
  /**
   * @param options - The options for creating the sprite.
   */
  constructor(t = k.EMPTY) {
    t instanceof k && (t = { texture: t });
    const { texture: e = k.EMPTY, anchor: r, roundPixels: n, width: a, height: l, ...h } = t;
    super({
      label: "Sprite",
      ...h
    }), this.renderPipeId = "sprite", this.batched = !0, this._visualBounds = { minX: 0, maxX: 1, minY: 0, maxY: 0 }, this._anchor = new Ft(
      {
        _onUpdate: () => {
          this.onViewUpdate();
        }
      }
    ), r ? this.anchor = r : e.defaultAnchor && (this.anchor = e.defaultAnchor), this.texture = e, this.allowChildren = !1, this.roundPixels = n ?? !1, a !== void 0 && (this.width = a), l !== void 0 && (this.height = l);
  }
  /**
   * Creates a new sprite based on a source texture, image, video, or canvas element.
   * This is a convenience method that automatically creates and manages textures.
   * @example
   * ```ts
   * // Create from path or URL
   * const sprite = Sprite.from('assets/image.png');
   *
   * // Create from existing texture
   * const sprite = Sprite.from(texture);
   *
   * // Create from canvas
   * const canvas = document.createElement('canvas');
   * const sprite = Sprite.from(canvas, true); // Skip caching new texture
   * ```
   * @param source - The source to create the sprite from. Can be a path to an image, a texture,
   * or any valid texture source (canvas, video, etc.)
   * @param skipCache - Whether to skip adding to the texture cache when creating a new texture
   * @returns A new sprite based on the source
   * @see {@link Texture.from} For texture creation details
   * @see {@link Assets} For asset loading and management
   */
  static from(t, e = !1) {
    return t instanceof k ? new Be(t) : new Be(k.from(t, e));
  }
  set texture(t) {
    t || (t = k.EMPTY);
    const e = this._texture;
    e !== t && (e && e.dynamic && e.off("update", this.onViewUpdate, this), t.dynamic && t.on("update", this.onViewUpdate, this), this._texture = t, this._width && this._setWidth(this._width, this._texture.orig.width), this._height && this._setHeight(this._height, this._texture.orig.height), this.onViewUpdate());
  }
  /**
   * The texture that is displayed by the sprite. When changed, automatically updates
   * the sprite dimensions and manages texture event listeners.
   * @example
   * ```ts
   * // Create sprite with texture
   * const sprite = new Sprite({
   *     texture: Texture.from('sprite.png')
   * });
   *
   * // Update texture
   * sprite.texture = Texture.from('newSprite.png');
   *
   * // Use texture from spritesheet
   * const sheet = await Assets.load('spritesheet.json');
   * sprite.texture = sheet.textures['frame1.png'];
   *
   * // Reset to empty texture
   * sprite.texture = Texture.EMPTY;
   * ```
   * @see {@link Texture} For texture creation and management
   * @see {@link Assets} For asset loading
   */
  get texture() {
    return this._texture;
  }
  /**
   * The bounds of the sprite, taking into account the texture's trim area.
   * @example
   * ```ts
   * const texture = new Texture({
   *     source: new TextureSource({ width: 300, height: 300 }),
   *     frame: new Rectangle(196, 66, 58, 56),
   *     trim: new Rectangle(4, 4, 58, 56),
   *     orig: new Rectangle(0, 0, 64, 64),
   *     rotate: 2,
   * });
   * const sprite = new Sprite(texture);
   * const visualBounds = sprite.visualBounds;
   * // console.log(visualBounds); // { minX: -4, maxX: 62, minY: -4, maxY: 60 }
   */
  get visualBounds() {
    return Vf(this._visualBounds, this._anchor, this._texture), this._visualBounds;
  }
  /**
   * @deprecated
   * @ignore
   */
  get sourceBounds() {
    return W("8.6.1", "Sprite.sourceBounds is deprecated, use visualBounds instead."), this.visualBounds;
  }
  /** @private */
  updateBounds() {
    const t = this._anchor, e = this._texture, r = this._bounds, { width: n, height: a } = e.orig;
    r.minX = -t._x * n, r.maxX = r.minX + n, r.minY = -t._y * a, r.maxY = r.minY + a;
  }
  /**
   * Destroys this sprite renderable and optionally its texture.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @example
   * sprite.destroy();
   * sprite.destroy(true);
   * sprite.destroy({ texture: true, textureSource: true });
   */
  destroy(t = !1) {
    if (super.destroy(t), typeof t == "boolean" ? t : t?.texture) {
      const r = typeof t == "boolean" ? t : t?.textureSource;
      this._texture.destroy(r);
    }
    this._texture = null, this._visualBounds = null, this._bounds = null, this._anchor = null, this._gpuData = null;
  }
  /**
   * The anchor sets the origin point of the sprite. The default value is taken from the {@link Texture}
   * and passed to the constructor.
   *
   * - The default is `(0,0)`, this means the sprite's origin is the top left.
   * - Setting the anchor to `(0.5,0.5)` means the sprite's origin is centered.
   * - Setting the anchor to `(1,1)` would mean the sprite's origin point will be the bottom right corner.
   *
   * If you pass only single parameter, it will set both x and y to the same value as shown in the example below.
   * @example
   * ```ts
   * // Center the anchor point
   * sprite.anchor = 0.5; // Sets both x and y to 0.5
   * sprite.position.set(400, 300); // Sprite will be centered at this position
   *
   * // Set specific x/y anchor points
   * sprite.anchor = {
   *     x: 1, // Right edge
   *     y: 0  // Top edge
   * };
   *
   * // Using individual coordinates
   * sprite.anchor.set(0.5, 1); // Center-bottom
   *
   * // For rotation around center
   * sprite.anchor.set(0.5);
   * sprite.rotation = Math.PI / 4; // 45 degrees around center
   *
   * // For scaling from center
   * sprite.anchor.set(0.5);
   * sprite.scale.set(2); // Scales from center point
   * ```
   */
  get anchor() {
    return this._anchor;
  }
  set anchor(t) {
    typeof t == "number" ? this._anchor.set(t) : this._anchor.copyFrom(t);
  }
  /**
   * The width of the sprite, setting this will actually modify the scale to achieve the value set.
   * @example
   * ```ts
   * // Set width directly
   * sprite.width = 200;
   * console.log(sprite.scale.x); // Scale adjusted to match width
   *
   * // Set width while preserving aspect ratio
   * const ratio = sprite.height / sprite.width;
   * sprite.width = 300;
   * sprite.height = 300 * ratio;
   *
   * // For better performance when setting both width and height
   * sprite.setSize(300, 400); // Avoids recalculating bounds twice
   *
   * // Reset to original texture size
   * sprite.width = sprite.texture.orig.width;
   * ```
   */
  get width() {
    return Math.abs(this.scale.x) * this._texture.orig.width;
  }
  set width(t) {
    this._setWidth(t, this._texture.orig.width), this._width = t;
  }
  /**
   * The height of the sprite, setting this will actually modify the scale to achieve the value set.
   * @example
   * ```ts
   * // Set height directly
   * sprite.height = 150;
   * console.log(sprite.scale.y); // Scale adjusted to match height
   *
   * // Set height while preserving aspect ratio
   * const ratio = sprite.width / sprite.height;
   * sprite.height = 200;
   * sprite.width = 200 * ratio;
   *
   * // For better performance when setting both width and height
   * sprite.setSize(300, 400); // Avoids recalculating bounds twice
   *
   * // Reset to original texture size
   * sprite.height = sprite.texture.orig.height;
   * ```
   */
  get height() {
    return Math.abs(this.scale.y) * this._texture.orig.height;
  }
  set height(t) {
    this._setHeight(t, this._texture.orig.height), this._height = t;
  }
  /**
   * Retrieves the size of the Sprite as a [Size]{@link Size} object based on the texture dimensions and scale.
   * This is faster than getting width and height separately as it only calculates the bounds once.
   * @example
   * ```ts
   * // Basic size retrieval
   * const sprite = new Sprite(Texture.from('sprite.png'));
   * const size = sprite.getSize();
   * console.log(`Size: ${size.width}x${size.height}`);
   *
   * // Reuse existing size object
   * const reuseSize = { width: 0, height: 0 };
   * sprite.getSize(reuseSize);
   * ```
   * @param out - Optional object to store the size in, to avoid allocating a new object
   * @returns The size of the Sprite
   * @see {@link Sprite#width} For getting just the width
   * @see {@link Sprite#height} For getting just the height
   * @see {@link Sprite#setSize} For setting both width and height
   */
  getSize(t) {
    return t || (t = {}), t.width = Math.abs(this.scale.x) * this._texture.orig.width, t.height = Math.abs(this.scale.y) * this._texture.orig.height, t;
  }
  /**
   * Sets the size of the Sprite to the specified width and height.
   * This is faster than setting width and height separately as it only recalculates bounds once.
   * @example
   * ```ts
   * // Basic size setting
   * const sprite = new Sprite(Texture.from('sprite.png'));
   * sprite.setSize(100, 200); // Width: 100, Height: 200
   *
   * // Set uniform size
   * sprite.setSize(100); // Sets both width and height to 100
   *
   * // Set size with object
   * sprite.setSize({
   *     width: 200,
   *     height: 300
   * });
   *
   * // Reset to texture size
   * sprite.setSize(
   *     sprite.texture.orig.width,
   *     sprite.texture.orig.height
   * );
   * ```
   * @param value - This can be either a number or a {@link Size} object
   * @param height - The height to set. Defaults to the value of `width` if not provided
   * @see {@link Sprite#width} For setting width only
   * @see {@link Sprite#height} For setting height only
   * @see {@link Sprite#texture} For the source dimensions
   */
  setSize(t, e) {
    typeof t == "object" ? (e = t.height ?? t.width, t = t.width) : e ?? (e = t), t !== void 0 && this._setWidth(t, this._texture.orig.width), e !== void 0 && this._setHeight(e, this._texture.orig.height);
  }
}
const bb = new Ut();
function tp(s, t, e) {
  const r = bb;
  s.measurable = !0, Uh(s, e, r), t.addBoundsMask(r), s.measurable = !1;
}
let pa = 0;
const Cc = 500;
function N(...s) {
  pa !== Cc && (pa++, pa === Cc ? console.warn("PixiJS Warning: too many warnings, no more warnings will be reported to the console by PixiJS.") : console.warn("PixiJS Warning: ", ...s));
}
function ep(s, t, e) {
  const r = ze.get();
  s.measurable = !0;
  const n = It.get().identity(), a = ip(s, e, n);
  Ih(s, r, a), s.measurable = !1, t.addBoundsMask(r), It.return(n), ze.return(r);
}
function ip(s, t, e) {
  return s ? (s !== t && (ip(s.parent, t, e), s.updateLocalTransform(), e.append(s.localTransform)), e) : (N("Mask bounds, renderable is not inside the root container"), e);
}
class rp {
  constructor(t) {
    this.priority = 0, this.inverse = !1, this.pipe = "alphaMask", t?.mask && this.init(t.mask);
  }
  init(t) {
    this.mask = t, this.renderMaskToTexture = !(t instanceof Be), this.mask.renderable = this.renderMaskToTexture, this.mask.includeInBuild = !this.renderMaskToTexture, this.mask.measurable = !1;
  }
  reset() {
    this.mask.measurable = !0, this.mask = null;
  }
  addBounds(t, e) {
    this.inverse || tp(this.mask, t, e);
  }
  addLocalBounds(t, e) {
    ep(this.mask, t, e);
  }
  containsPoint(t, e) {
    const r = this.mask;
    return e(r, t);
  }
  destroy() {
    this.reset();
  }
  static test(t) {
    return t instanceof Be;
  }
}
rp.extension = A.MaskEffect;
class sp {
  constructor(t) {
    this.priority = 0, this.pipe = "colorMask", t?.mask && this.init(t.mask);
  }
  init(t) {
    this.mask = t;
  }
  destroy() {
  }
  static test(t) {
    return typeof t == "number";
  }
}
sp.extension = A.MaskEffect;
class np {
  constructor(t) {
    this.priority = 0, this.pipe = "stencilMask", t?.mask && this.init(t.mask);
  }
  init(t) {
    this.mask = t, this.mask.includeInBuild = !1, this.mask.measurable = !1;
  }
  reset() {
    this.mask.measurable = !0, this.mask.includeInBuild = !0, this.mask = null;
  }
  addBounds(t, e) {
    tp(this.mask, t, e);
  }
  addLocalBounds(t, e) {
    ep(this.mask, t, e);
  }
  containsPoint(t, e) {
    const r = this.mask;
    return e(r, t);
  }
  destroy() {
    this.reset();
  }
  static test(t) {
    return t instanceof St;
  }
}
np.extension = A.MaskEffect;
const vb = {
  createCanvas: (s, t) => {
    const e = document.createElement("canvas");
    return e.width = s, e.height = t, e;
  },
  getCanvasRenderingContext2D: () => CanvasRenderingContext2D,
  getWebGLRenderingContext: () => WebGLRenderingContext,
  getNavigator: () => navigator,
  getBaseUrl: () => document.baseURI ?? window.location.href,
  getFontFaceSet: () => document.fonts,
  fetch: (s, t) => fetch(s, t),
  parseXML: (s) => new DOMParser().parseFromString(s, "text/xml")
};
let Ec = vb;
const Y = {
  /**
   * Returns the current adapter.
   * @returns {environment.Adapter} The current adapter.
   */
  get() {
    return Ec;
  },
  /**
   * Sets the current adapter.
   * @param adapter - The new adapter.
   */
  set(s) {
    Ec = s;
  }
};
class Ne extends yt {
  constructor(t) {
    t.resource || (t.resource = Y.get().createCanvas()), t.width || (t.width = t.resource.width, t.autoDensity || (t.width /= t.resolution)), t.height || (t.height = t.resource.height, t.autoDensity || (t.height /= t.resolution)), super(t), this.uploadMethodId = "image", this.autoDensity = t.autoDensity, this.resizeCanvas(), this.transparent = !!t.transparent;
  }
  resizeCanvas() {
    this.autoDensity && "style" in this.resource && (this.resource.style.width = `${this.width}px`, this.resource.style.height = `${this.height}px`), (this.resource.width !== this.pixelWidth || this.resource.height !== this.pixelHeight) && (this.resource.width = this.pixelWidth, this.resource.height = this.pixelHeight);
  }
  resize(t = this.width, e = this.height, r = this._resolution) {
    const n = super.resize(t, e, r);
    return n && this.resizeCanvas(), n;
  }
  static test(t) {
    return globalThis.HTMLCanvasElement && t instanceof HTMLCanvasElement || globalThis.OffscreenCanvas && t instanceof OffscreenCanvas;
  }
  /**
   * Returns the 2D rendering context for the canvas.
   * Caches the context after creating it.
   * @returns The 2D rendering context of the canvas.
   */
  get context2D() {
    return this._context2D || (this._context2D = this.resource.getContext("2d"));
  }
}
Ne.extension = A.TextureSource;
class Ii extends yt {
  constructor(t) {
    super(t), this.uploadMethodId = "image", this.autoGarbageCollect = !0;
  }
  static test(t) {
    return globalThis.HTMLImageElement && t instanceof HTMLImageElement || typeof ImageBitmap < "u" && t instanceof ImageBitmap || globalThis.VideoFrame && t instanceof VideoFrame;
  }
}
Ii.extension = A.TextureSource;
var as = /* @__PURE__ */ ((s) => (s[s.INTERACTION = 50] = "INTERACTION", s[s.HIGH = 25] = "HIGH", s[s.NORMAL = 0] = "NORMAL", s[s.LOW = -25] = "LOW", s[s.UTILITY = -50] = "UTILITY", s))(as || {});
class _a {
  /**
   * Constructor
   * @private
   * @param fn - The listener function to be added for one update
   * @param context - The listener context
   * @param priority - The priority for emitting
   * @param once - If the handler should fire once
   */
  constructor(t, e = null, r = 0, n = !1) {
    this.next = null, this.previous = null, this._destroyed = !1, this._fn = t, this._context = e, this.priority = r, this._once = n;
  }
  /**
   * Simple compare function to figure out if a function and context match.
   * @param fn - The listener function to be added for one update
   * @param context - The listener context
   * @returns `true` if the listener match the arguments
   */
  match(t, e = null) {
    return this._fn === t && this._context === e;
  }
  /**
   * Emit by calling the current function.
   * @param ticker - The ticker emitting.
   * @returns Next ticker
   */
  emit(t) {
    this._fn && (this._context ? this._fn.call(this._context, t) : this._fn(t));
    const e = this.next;
    return this._once && this.destroy(!0), this._destroyed && (this.next = null), e;
  }
  /**
   * Connect to the list.
   * @param previous - Input node, previous listener
   */
  connect(t) {
    this.previous = t, t.next && (t.next.previous = this), this.next = t.next, t.next = this;
  }
  /**
   * Destroy and don't use after this.
   * @param hard - `true` to remove the `next` reference, this
   *        is considered a hard destroy. Soft destroy maintains the next reference.
   * @returns The listener to redirect while emitting or removing.
   */
  destroy(t = !1) {
    this._destroyed = !0, this._fn = null, this._context = null, this.previous && (this.previous.next = this.next), this.next && (this.next.previous = this.previous);
    const e = this.next;
    return this.next = t ? null : e, this.previous = null, e;
  }
}
const ap = class Vt {
  constructor() {
    this.autoStart = !1, this.deltaTime = 1, this.lastTime = -1, this.speed = 1, this.started = !1, this._requestId = null, this._maxElapsedMS = 100, this._minElapsedMS = 0, this._protected = !1, this._lastFrame = -1, this._head = new _a(null, null, 1 / 0), this.deltaMS = 1 / Vt.targetFPMS, this.elapsedMS = 1 / Vt.targetFPMS, this._tick = (t) => {
      this._requestId = null, this.started && (this.update(t), this.started && this._requestId === null && this._head.next && (this._requestId = requestAnimationFrame(this._tick)));
    };
  }
  /**
   * Conditionally requests a new animation frame.
   * If a frame has not already been requested, and if the internal
   * emitter has listeners, a new frame is requested.
   */
  _requestIfNeeded() {
    this._requestId === null && this._head.next && (this.lastTime = performance.now(), this._lastFrame = this.lastTime, this._requestId = requestAnimationFrame(this._tick));
  }
  /** Conditionally cancels a pending animation frame. */
  _cancelIfNeeded() {
    this._requestId !== null && (cancelAnimationFrame(this._requestId), this._requestId = null);
  }
  /**
   * Conditionally requests a new animation frame.
   * If the ticker has been started it checks if a frame has not already
   * been requested, and if the internal emitter has listeners. If these
   * conditions are met, a new frame is requested. If the ticker has not
   * been started, but autoStart is `true`, then the ticker starts now,
   * and continues with the previous conditions to request a new frame.
   */
  _startIfPossible() {
    this.started ? this._requestIfNeeded() : this.autoStart && this.start();
  }
  /**
   * Register a handler for tick events. Calls continuously unless
   * it is removed or the ticker is stopped.
   * @example
   * ```ts
   * // Basic update handler
   * ticker.add((ticker) => {
   *     // Update every frame
   *     sprite.rotation += 0.1 * ticker.deltaTime;
   * });
   *
   * // With specific context
   * const game = {
   *     update(ticker) {
   *         this.physics.update(ticker.deltaTime);
   *     }
   * };
   * ticker.add(game.update, game);
   *
   * // With priority
   * ticker.add(
   *     (ticker) => {
   *         // Runs before normal priority updates
   *         physics.update(ticker.deltaTime);
   *     },
   *     undefined,
   *     UPDATE_PRIORITY.HIGH
   * );
   * ```
   * @param fn - The listener function to be added for updates
   * @param context - The listener context
   * @param priority - The priority for emitting (default: UPDATE_PRIORITY.NORMAL)
   * @returns This instance of a ticker
   * @see {@link Ticker#addOnce} For one-time handlers
   * @see {@link Ticker#remove} For removing handlers
   */
  add(t, e, r = as.NORMAL) {
    return this._addListener(new _a(t, e, r));
  }
  /**
   * Add a handler for the tick event which is only executed once on the next frame.
   * @example
   * ```ts
   * // Basic one-time update
   * ticker.addOnce(() => {
   *     console.log('Runs next frame only');
   * });
   *
   * // With specific context
   * const game = {
   *     init(ticker) {
   *         this.loadResources();
   *         console.log('Game initialized');
   *     }
   * };
   * ticker.addOnce(game.init, game);
   *
   * // With priority
   * ticker.addOnce(
   *     () => {
   *         // High priority one-time setup
   *         physics.init();
   *     },
   *     undefined,
   *     UPDATE_PRIORITY.HIGH
   * );
   * ```
   * @param fn - The listener function to be added for one update
   * @param context - The listener context
   * @param priority - The priority for emitting (default: UPDATE_PRIORITY.NORMAL)
   * @returns This instance of a ticker
   * @see {@link Ticker#add} For continuous updates
   * @see {@link Ticker#remove} For removing handlers
   */
  addOnce(t, e, r = as.NORMAL) {
    return this._addListener(new _a(t, e, r, !0));
  }
  /**
   * Internally adds the event handler so that it can be sorted by priority.
   * Priority allows certain handler (user, AnimatedSprite, Interaction) to be run
   * before the rendering.
   * @private
   * @param listener - Current listener being added.
   * @returns This instance of a ticker
   */
  _addListener(t) {
    let e = this._head.next, r = this._head;
    if (!e)
      t.connect(r);
    else {
      for (; e; ) {
        if (t.priority > e.priority) {
          t.connect(r);
          break;
        }
        r = e, e = e.next;
      }
      t.previous || t.connect(r);
    }
    return this._startIfPossible(), this;
  }
  /**
   * Removes any handlers matching the function and context parameters.
   * If no handlers are left after removing, then it cancels the animation frame.
   * @example
   * ```ts
   * // Basic removal
   * const onTick = () => {
   *     sprite.rotation += 0.1;
   * };
   * ticker.add(onTick);
   * ticker.remove(onTick);
   *
   * // Remove with context
   * const game = {
   *     update(ticker) {
   *         this.physics.update(ticker.deltaTime);
   *     }
   * };
   * ticker.add(game.update, game);
   * ticker.remove(game.update, game);
   *
   * // Remove all matching handlers
   * // (if same function was added multiple times)
   * ticker.add(onTick);
   * ticker.add(onTick);
   * ticker.remove(onTick); // Removes all instances
   * ```
   * @param fn - The listener function to be removed
   * @param context - The listener context to be removed
   * @returns This instance of a ticker
   * @see {@link Ticker#add} For adding handlers
   * @see {@link Ticker#addOnce} For one-time handlers
   */
  remove(t, e) {
    let r = this._head.next;
    for (; r; )
      r.match(t, e) ? r = r.destroy() : r = r.next;
    return this._head.next || this._cancelIfNeeded(), this;
  }
  /**
   * The number of listeners on this ticker, calculated by walking through linked list.
   * @example
   * ```ts
   * // Check number of active listeners
   * const ticker = new Ticker();
   * console.log(ticker.count); // 0
   *
   * // Add some listeners
   * ticker.add(() => {});
   * ticker.add(() => {});
   * console.log(ticker.count); // 2
   *
   * // Check after cleanup
   * ticker.destroy();
   * console.log(ticker.count); // 0
   * ```
   * @readonly
   * @see {@link Ticker#add} For adding listeners
   * @see {@link Ticker#remove} For removing listeners
   */
  get count() {
    if (!this._head)
      return 0;
    let t = 0, e = this._head;
    for (; e = e.next; )
      t++;
    return t;
  }
  /**
   * Starts the ticker. If the ticker has listeners a new animation frame is requested at this point.
   * @example
   * ```ts
   * // Basic manual start
   * const ticker = new Ticker();
   * ticker.add(() => {
   *     // Animation code here
   * });
   * ticker.start();
   * ```
   * @see {@link Ticker#stop} For stopping the ticker
   * @see {@link Ticker#autoStart} For automatic starting
   * @see {@link Ticker#started} For checking ticker state
   */
  start() {
    this.started || (this.started = !0, this._requestIfNeeded());
  }
  /**
   * Stops the ticker. If the ticker has requested an animation frame it is canceled at this point.
   * @example
   * ```ts
   * // Basic stop
   * const ticker = new Ticker();
   * ticker.stop();
   * ```
   * @see {@link Ticker#start} For starting the ticker
   * @see {@link Ticker#started} For checking ticker state
   * @see {@link Ticker#destroy} For cleaning up the ticker
   */
  stop() {
    this.started && (this.started = !1, this._cancelIfNeeded());
  }
  /**
   * Destroy the ticker and don't use after this. Calling this method removes all references to internal events.
   * @example
   * ```ts
   * // Clean up with active listeners
   * const ticker = new Ticker();
   * ticker.add(() => {});
   * ticker.destroy(); // Removes all listeners
   * ```
   * @see {@link Ticker#stop} For stopping without destroying
   * @see {@link Ticker#remove} For removing specific listeners
   */
  destroy() {
    if (!this._protected) {
      this.stop();
      let t = this._head.next;
      for (; t; )
        t = t.destroy(!0);
      this._head.destroy(), this._head = null;
    }
  }
  /**
   * Triggers an update.
   *
   * An update entails setting the
   * current {@link Ticker#elapsedMS|elapsedMS},
   * the current {@link Ticker#deltaTime|deltaTime},
   * invoking all listeners with current deltaTime,
   * and then finally setting {@link Ticker#lastTime|lastTime}
   * with the value of currentTime that was provided.
   *
   * This method will be called automatically by animation
   * frame callbacks if the ticker instance has been started
   * and listeners are added.
   * @example
   * ```ts
   * // Basic manual update
   * const ticker = new Ticker();
   * ticker.update(performance.now());
   * ```
   * @param currentTime - The current time of execution (defaults to performance.now())
   * @see {@link Ticker#deltaTime} For frame delta value
   * @see {@link Ticker#elapsedMS} For raw elapsed time
   */
  update(t = performance.now()) {
    let e;
    if (t > this.lastTime) {
      if (e = this.elapsedMS = t - this.lastTime, e > this._maxElapsedMS && (e = this._maxElapsedMS), e *= this.speed, this._minElapsedMS) {
        const a = t - this._lastFrame | 0;
        if (a < this._minElapsedMS)
          return;
        this._lastFrame = t - a % this._minElapsedMS;
      }
      this.deltaMS = e, this.deltaTime = this.deltaMS * Vt.targetFPMS;
      const r = this._head;
      let n = r.next;
      for (; n; )
        n = n.emit(this);
      r.next || this._cancelIfNeeded();
    } else
      this.deltaTime = this.deltaMS = this.elapsedMS = 0;
    this.lastTime = t;
  }
  /**
   * The frames per second at which this ticker is running.
   * The default is approximately 60 in most modern browsers.
   * > [!NOTE] This does not factor in the value of
   * > {@link Ticker#speed|speed}, which is specific
   * > to scaling {@link Ticker#deltaTime|deltaTime}.
   * @example
   * ```ts
   * // Basic FPS monitoring
   * ticker.add(() => {
   *     console.log(`Current FPS: ${Math.round(ticker.FPS)}`);
   * });
   * ```
   * @readonly
   */
  get FPS() {
    return 1e3 / this.elapsedMS;
  }
  /**
   * Manages the maximum amount of milliseconds allowed to
   * elapse between invoking {@link Ticker#update|update}.
   *
   * This value is used to cap {@link Ticker#deltaTime|deltaTime},
   * but does not effect the measured value of {@link Ticker#FPS|FPS}.
   *
   * When setting this property it is clamped to a value between
   * `0` and `Ticker.targetFPMS * 1000`.
   * @example
   * ```ts
   * // Set minimum acceptable frame rate
   * const ticker = new Ticker();
   * ticker.minFPS = 30; // Never go below 30 FPS
   *
   * // Use with maxFPS for frame rate clamping
   * ticker.minFPS = 30;
   * ticker.maxFPS = 60;
   *
   * // Monitor delta capping
   * ticker.add(() => {
   *     // Delta time will be capped based on minFPS
   *     console.log(`Delta time: ${ticker.deltaTime}`);
   * });
   * ```
   * @default 10
   */
  get minFPS() {
    return 1e3 / this._maxElapsedMS;
  }
  set minFPS(t) {
    const e = Math.min(this.maxFPS, t), r = Math.min(Math.max(0, e) / 1e3, Vt.targetFPMS);
    this._maxElapsedMS = 1 / r;
  }
  /**
   * Manages the minimum amount of milliseconds required to
   * elapse between invoking {@link Ticker#update|update}.
   *
   * This will effect the measured value of {@link Ticker#FPS|FPS}.
   *
   * If it is set to `0`, then there is no limit; PixiJS will render as many frames as it can.
   * Otherwise it will be at least `minFPS`
   * @example
   * ```ts
   * // Set minimum acceptable frame rate
   * const ticker = new Ticker();
   * ticker.maxFPS = 60; // Never go above 60 FPS
   *
   * // Use with maxFPS for frame rate clamping
   * ticker.minFPS = 30;
   * ticker.maxFPS = 60;
   *
   * // Monitor delta capping
   * ticker.add(() => {
   *     // Delta time will be capped based on maxFPS
   *     console.log(`Delta time: ${ticker.deltaTime}`);
   * });
   * ```
   * @default 0
   */
  get maxFPS() {
    return this._minElapsedMS ? Math.round(1e3 / this._minElapsedMS) : 0;
  }
  set maxFPS(t) {
    if (t === 0)
      this._minElapsedMS = 0;
    else {
      const e = Math.max(this.minFPS, t);
      this._minElapsedMS = 1 / (e / 1e3);
    }
  }
  /**
   * The shared ticker instance used by {@link AnimatedSprite} and by
   * {@link VideoSource} to update animation frames / video textures.
   *
   * It may also be used by {@link Application} if created with the `sharedTicker` option property set to true.
   *
   * The property {@link Ticker#autoStart|autoStart} is set to `true` for this instance.
   * Please follow the examples for usage, including how to opt-out of auto-starting the shared ticker.
   * @example
   * import { Ticker } from 'pixi.js';
   *
   * const ticker = Ticker.shared;
   * // Set this to prevent starting this ticker when listeners are added.
   * // By default this is true only for the Ticker.shared instance.
   * ticker.autoStart = false;
   *
   * // FYI, call this to ensure the ticker is stopped. It should be stopped
   * // if you have not attempted to render anything yet.
   * ticker.stop();
   *
   * // Call this when you are ready for a running shared ticker.
   * ticker.start();
   * @example
   * import { autoDetectRenderer, Container } from 'pixi.js';
   *
   * // You may use the shared ticker to render...
   * const renderer = autoDetectRenderer();
   * const stage = new Container();
   * document.body.appendChild(renderer.view);
   * ticker.add((time) => renderer.render(stage));
   *
   * // Or you can just update it manually.
   * ticker.autoStart = false;
   * ticker.stop();
   * const animate = (time) => {
   *     ticker.update(time);
   *     renderer.render(stage);
   *     requestAnimationFrame(animate);
   * };
   * animate(performance.now());
   * @type {Ticker}
   * @readonly
   */
  static get shared() {
    if (!Vt._shared) {
      const t = Vt._shared = new Vt();
      t.autoStart = !0, t._protected = !0;
    }
    return Vt._shared;
  }
  /**
   * The system ticker instance used by {@link PrepareBase} for core timing
   * functionality that shouldn't usually need to be paused, unlike the `shared`
   * ticker which drives visual animations and rendering which may want to be paused.
   *
   * The property {@link Ticker#autoStart|autoStart} is set to `true` for this instance.
   * @type {Ticker}
   * @readonly
   * @advanced
   */
  static get system() {
    if (!Vt._system) {
      const t = Vt._system = new Vt();
      t.autoStart = !0, t._protected = !0;
    }
    return Vt._system;
  }
};
ap.targetFPMS = 0.06;
let Ae = ap, ma;
async function op() {
  return ma ?? (ma = (async () => {
    const t = document.createElement("canvas").getContext("webgl");
    if (!t)
      return "premultiply-alpha-on-upload";
    const e = await new Promise((l) => {
      const h = document.createElement("video");
      h.onloadeddata = () => l(h), h.onerror = () => l(null), h.autoplay = !1, h.crossOrigin = "anonymous", h.preload = "auto", h.src = "data:video/webm;base64,GkXfo59ChoEBQveBAULygQRC84EIQoKEd2VibUKHgQJChYECGFOAZwEAAAAAAAHTEU2bdLpNu4tTq4QVSalmU6yBoU27i1OrhBZUrmtTrIHGTbuMU6uEElTDZ1OsggEXTbuMU6uEHFO7a1OsggG97AEAAAAAAABZAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVSalmoCrXsYMPQkBNgIRMYXZmV0GETGF2ZkSJiEBEAAAAAAAAFlSua8yuAQAAAAAAAEPXgQFzxYgAAAAAAAAAAZyBACK1nIN1bmSIgQCGhVZfVlA5g4EBI+ODhAJiWgDglLCBArqBApqBAlPAgQFVsIRVuYEBElTDZ9Vzc9JjwItjxYgAAAAAAAAAAWfInEWjh0VOQ09ERVJEh49MYXZjIGxpYnZweC12cDlnyKJFo4hEVVJBVElPTkSHlDAwOjAwOjAwLjA0MDAwMDAwMAAAH0O2dcfngQCgwqGggQAAAIJJg0IAABAAFgA4JBwYSgAAICAAEb///4r+AAB1oZ2mm+6BAaWWgkmDQgAAEAAWADgkHBhKAAAgIABIQBxTu2uRu4+zgQC3iveBAfGCAXHwgQM=", h.load();
    });
    if (!e)
      return "premultiply-alpha-on-upload";
    const r = t.createTexture();
    t.bindTexture(t.TEXTURE_2D, r);
    const n = t.createFramebuffer();
    t.bindFramebuffer(t.FRAMEBUFFER, n), t.framebufferTexture2D(
      t.FRAMEBUFFER,
      t.COLOR_ATTACHMENT0,
      t.TEXTURE_2D,
      r,
      0
    ), t.pixelStorei(t.UNPACK_PREMULTIPLY_ALPHA_WEBGL, !1), t.pixelStorei(t.UNPACK_COLORSPACE_CONVERSION_WEBGL, t.NONE), t.texImage2D(t.TEXTURE_2D, 0, t.RGBA, t.RGBA, t.UNSIGNED_BYTE, e);
    const a = new Uint8Array(4);
    return t.readPixels(0, 0, 1, 1, t.RGBA, t.UNSIGNED_BYTE, a), t.deleteFramebuffer(n), t.deleteTexture(r), t.getExtension("WEBGL_lose_context")?.loseContext(), a[0] <= a[3] ? "premultiplied-alpha" : "premultiply-alpha-on-upload";
  })()), ma;
}
const Nn = class hp extends yt {
  constructor(t) {
    super(t), this.isReady = !1, this.uploadMethodId = "video", t = {
      ...hp.defaultOptions,
      ...t
    }, this._autoUpdate = !0, this._isConnectedToTicker = !1, this._updateFPS = t.updateFPS || 0, this._msToNextUpdate = 0, this.autoPlay = t.autoPlay !== !1, this.alphaMode = t.alphaMode ?? "premultiply-alpha-on-upload", this._videoFrameRequestCallback = this._videoFrameRequestCallback.bind(this), this._videoFrameRequestCallbackHandle = null, this._load = null, this._resolve = null, this._reject = null, this._onCanPlay = this._onCanPlay.bind(this), this._onCanPlayThrough = this._onCanPlayThrough.bind(this), this._onError = this._onError.bind(this), this._onPlayStart = this._onPlayStart.bind(this), this._onPlayStop = this._onPlayStop.bind(this), this._onSeeked = this._onSeeked.bind(this), t.autoLoad !== !1 && this.load();
  }
  /** Update the video frame if the source is not destroyed and meets certain conditions. */
  updateFrame() {
    if (!this.destroyed) {
      if (this._updateFPS) {
        const t = Ae.shared.elapsedMS * this.resource.playbackRate;
        this._msToNextUpdate = Math.floor(this._msToNextUpdate - t);
      }
      (!this._updateFPS || this._msToNextUpdate <= 0) && (this._msToNextUpdate = this._updateFPS ? Math.floor(1e3 / this._updateFPS) : 0), this.isValid && this.update();
    }
  }
  /** Callback to update the video frame and potentially request the next frame update. */
  _videoFrameRequestCallback() {
    this.updateFrame(), this.destroyed ? this._videoFrameRequestCallbackHandle = null : this._videoFrameRequestCallbackHandle = this.resource.requestVideoFrameCallback(
      this._videoFrameRequestCallback
    );
  }
  /**
   * Checks if the resource has valid dimensions.
   * @returns {boolean} True if width and height are set, otherwise false.
   */
  get isValid() {
    return !!this.resource.videoWidth && !!this.resource.videoHeight;
  }
  /**
   * Start preloading the video resource.
   * @returns {Promise<this>} Handle the validate event
   */
  async load() {
    if (this._load)
      return this._load;
    const t = this.resource, e = this.options;
    return (t.readyState === t.HAVE_ENOUGH_DATA || t.readyState === t.HAVE_FUTURE_DATA) && t.width && t.height && (t.complete = !0), t.addEventListener("play", this._onPlayStart), t.addEventListener("pause", this._onPlayStop), t.addEventListener("seeked", this._onSeeked), this._isSourceReady() ? this._mediaReady() : (e.preload || t.addEventListener("canplay", this._onCanPlay), t.addEventListener("canplaythrough", this._onCanPlayThrough), t.addEventListener("error", this._onError, !0)), this.alphaMode = await op(), this._load = new Promise((r, n) => {
      this.isValid ? r(this) : (this._resolve = r, this._reject = n, e.preloadTimeoutMs !== void 0 && (this._preloadTimeout = setTimeout(() => {
        this._onError(new ErrorEvent(`Preload exceeded timeout of ${e.preloadTimeoutMs}ms`));
      })), t.load());
    }), this._load;
  }
  /**
   * Handle video error events.
   * @param event - The error event
   */
  _onError(t) {
    this.resource.removeEventListener("error", this._onError, !0), this.emit("error", t), this._reject && (this._reject(t), this._reject = null, this._resolve = null);
  }
  /**
   * Checks if the underlying source is playing.
   * @returns True if playing.
   */
  _isSourcePlaying() {
    const t = this.resource;
    return !t.paused && !t.ended;
  }
  /**
   * Checks if the underlying source is ready for playing.
   * @returns True if ready.
   */
  _isSourceReady() {
    return this.resource.readyState > 2;
  }
  /** Runs the update loop when the video is ready to play. */
  _onPlayStart() {
    this.isValid || this._mediaReady(), this._configureAutoUpdate();
  }
  /** Stops the update loop when a pause event is triggered. */
  _onPlayStop() {
    this._configureAutoUpdate();
  }
  /** Handles behavior when the video completes seeking to the current playback position. */
  _onSeeked() {
    this._autoUpdate && !this._isSourcePlaying() && (this._msToNextUpdate = 0, this.updateFrame(), this._msToNextUpdate = 0);
  }
  _onCanPlay() {
    this.resource.removeEventListener("canplay", this._onCanPlay), this._mediaReady();
  }
  _onCanPlayThrough() {
    this.resource.removeEventListener("canplaythrough", this._onCanPlay), this._preloadTimeout && (clearTimeout(this._preloadTimeout), this._preloadTimeout = void 0), this._mediaReady();
  }
  /** Fired when the video is loaded and ready to play. */
  _mediaReady() {
    const t = this.resource;
    this.isValid && (this.isReady = !0, this.resize(t.videoWidth, t.videoHeight)), this._msToNextUpdate = 0, this.updateFrame(), this._msToNextUpdate = 0, this._resolve && (this._resolve(this), this._resolve = null, this._reject = null), this._isSourcePlaying() ? this._onPlayStart() : this.autoPlay && this.resource.play();
  }
  /** Cleans up resources and event listeners associated with this texture. */
  destroy() {
    this._configureAutoUpdate();
    const t = this.resource;
    t && (t.removeEventListener("play", this._onPlayStart), t.removeEventListener("pause", this._onPlayStop), t.removeEventListener("seeked", this._onSeeked), t.removeEventListener("canplay", this._onCanPlay), t.removeEventListener("canplaythrough", this._onCanPlayThrough), t.removeEventListener("error", this._onError, !0), t.pause(), t.src = "", t.load()), super.destroy();
  }
  /** Should the base texture automatically update itself, set to true by default. */
  get autoUpdate() {
    return this._autoUpdate;
  }
  set autoUpdate(t) {
    t !== this._autoUpdate && (this._autoUpdate = t, this._configureAutoUpdate());
  }
  /**
   * How many times a second to update the texture from the video.
   * Leave at 0 to update at every render.
   * A lower fps can help performance, as updating the texture at 60fps on a 30ps video may not be efficient.
   */
  get updateFPS() {
    return this._updateFPS;
  }
  set updateFPS(t) {
    t !== this._updateFPS && (this._updateFPS = t, this._configureAutoUpdate());
  }
  /**
   * Configures the updating mechanism based on the current state and settings.
   *
   * This method decides between using the browser's native video frame callback or a custom ticker
   * for updating the video frame. It ensures optimal performance and responsiveness
   * based on the video's state, playback status, and the desired frames-per-second setting.
   *
   * - If `_autoUpdate` is enabled and the video source is playing:
   *   - It will prefer the native video frame callback if available and no specific FPS is set.
   *   - Otherwise, it will use a custom ticker for manual updates.
   * - If `_autoUpdate` is disabled or the video isn't playing, any active update mechanisms are halted.
   */
  _configureAutoUpdate() {
    this._autoUpdate && this._isSourcePlaying() ? !this._updateFPS && this.resource.requestVideoFrameCallback ? (this._isConnectedToTicker && (Ae.shared.remove(this.updateFrame, this), this._isConnectedToTicker = !1, this._msToNextUpdate = 0), this._videoFrameRequestCallbackHandle === null && (this._videoFrameRequestCallbackHandle = this.resource.requestVideoFrameCallback(
      this._videoFrameRequestCallback
    ))) : (this._videoFrameRequestCallbackHandle !== null && (this.resource.cancelVideoFrameCallback(this._videoFrameRequestCallbackHandle), this._videoFrameRequestCallbackHandle = null), this._isConnectedToTicker || (Ae.shared.add(this.updateFrame, this), this._isConnectedToTicker = !0, this._msToNextUpdate = 0)) : (this._videoFrameRequestCallbackHandle !== null && (this.resource.cancelVideoFrameCallback(this._videoFrameRequestCallbackHandle), this._videoFrameRequestCallbackHandle = null), this._isConnectedToTicker && (Ae.shared.remove(this.updateFrame, this), this._isConnectedToTicker = !1, this._msToNextUpdate = 0));
  }
  static test(t) {
    return globalThis.HTMLVideoElement && t instanceof HTMLVideoElement;
  }
};
Nn.extension = A.TextureSource;
Nn.defaultOptions = {
  ...yt.defaultOptions,
  /** If true, the video will start loading immediately. */
  autoLoad: !0,
  /** If true, the video will start playing as soon as it is loaded. */
  autoPlay: !0,
  /** The number of times a second to update the texture from the video. Leave at 0 to update at every render. */
  updateFPS: 0,
  /** If true, the video will be loaded with the `crossorigin` attribute. */
  crossorigin: !0,
  /** If true, the video will loop when it ends. */
  loop: !1,
  /** If true, the video will be muted. */
  muted: !0,
  /** If true, the video will play inline. */
  playsinline: !0,
  /** If true, the video will be preloaded. */
  preload: !1
};
Nn.MIME_TYPES = {
  ogv: "video/ogg",
  mov: "video/quicktime",
  m4v: "video/mp4"
};
let an = Nn;
const _e = (s, t, e = !1) => (Array.isArray(s) || (s = [s]), t ? s.map((r) => typeof r == "string" || e ? t(r) : r) : s);
class wb {
  constructor() {
    this._parsers = [], this._cache = /* @__PURE__ */ new Map(), this._cacheMap = /* @__PURE__ */ new Map();
  }
  /** Clear all entries. */
  reset() {
    this._cacheMap.clear(), this._cache.clear();
  }
  /**
   * Check if the key exists
   * @param key - The key to check
   */
  has(t) {
    return this._cache.has(t);
  }
  /**
   * Fetch entry by key
   * @param key - The key of the entry to get
   */
  get(t) {
    const e = this._cache.get(t);
    return e || N(`[Assets] Asset id ${t} was not found in the Cache`), e;
  }
  /**
   * Set a value by key or keys name
   * @param key - The key or keys to set
   * @param value - The value to store in the cache or from which cacheable assets will be derived.
   */
  set(t, e) {
    const r = _e(t);
    let n;
    for (let u = 0; u < this.parsers.length; u++) {
      const f = this.parsers[u];
      if (f.test(e)) {
        n = f.getCacheableAssets(r, e);
        break;
      }
    }
    const a = new Map(Object.entries(n || {}));
    n || r.forEach((u) => {
      a.set(u, e);
    });
    const l = [...a.keys()], h = {
      cacheKeys: l,
      keys: r
    };
    r.forEach((u) => {
      this._cacheMap.set(u, h);
    }), l.forEach((u) => {
      const f = n ? n[u] : e;
      this._cache.has(u) && this._cache.get(u) !== f && N("[Cache] already has key:", u), this._cache.set(u, a.get(u));
    });
  }
  /**
   * Remove entry by key
   *
   * This function will also remove any associated alias from the cache also.
   * @param key - The key of the entry to remove
   */
  remove(t) {
    if (!this._cacheMap.has(t)) {
      N(`[Assets] Asset id ${t} was not found in the Cache`);
      return;
    }
    const e = this._cacheMap.get(t);
    e.cacheKeys.forEach((n) => {
      this._cache.delete(n);
    }), e.keys.forEach((n) => {
      this._cacheMap.delete(n);
    });
  }
  /**
   * All loader parsers registered
   * @advanced
   */
  get parsers() {
    return this._parsers;
  }
}
const it = new wb(), Uo = [];
L.handleByList(A.TextureSource, Uo);
function lp(s = {}) {
  const t = s && s.resource, e = t ? s.resource : s, r = t ? s : { resource: s };
  for (let n = 0; n < Uo.length; n++) {
    const a = Uo[n];
    if (a.test(e))
      return new a(r);
  }
  throw new Error(`Could not find a source type for resource: ${r.resource}`);
}
function Sb(s = {}, t = !1) {
  const e = s && s.resource, r = e ? s.resource : s, n = e ? s : { resource: s };
  if (!t && it.has(r))
    return it.get(r);
  const a = new k({ source: lp(n) });
  return a.on("destroy", () => {
    it.has(r) && it.remove(r);
  }), t || it.set(r, a), a;
}
function Tb(s, t = !1) {
  return typeof s == "string" ? it.get(s) : s instanceof yt ? new k({ source: s }) : Sb(s, t);
}
k.from = Tb;
yt.from = lp;
L.add(rp, sp, np, an, Ii, Ne, Mh);
var li = /* @__PURE__ */ ((s) => (s[s.Low = 0] = "Low", s[s.Normal = 1] = "Normal", s[s.High = 2] = "High", s))(li || {});
function de(s) {
  if (typeof s != "string")
    throw new TypeError(`Path must be a string. Received ${JSON.stringify(s)}`);
}
function Tr(s) {
  return s.split("?")[0].split("#")[0];
}
function Cb(s) {
  return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function Eb(s, t, e) {
  return s.replace(new RegExp(Cb(t), "g"), e);
}
function Ab(s, t) {
  let e = "", r = 0, n = -1, a = 0, l = -1;
  for (let h = 0; h <= s.length; ++h) {
    if (h < s.length)
      l = s.charCodeAt(h);
    else {
      if (l === 47)
        break;
      l = 47;
    }
    if (l === 47) {
      if (!(n === h - 1 || a === 1)) if (n !== h - 1 && a === 2) {
        if (e.length < 2 || r !== 2 || e.charCodeAt(e.length - 1) !== 46 || e.charCodeAt(e.length - 2) !== 46) {
          if (e.length > 2) {
            const u = e.lastIndexOf("/");
            if (u !== e.length - 1) {
              u === -1 ? (e = "", r = 0) : (e = e.slice(0, u), r = e.length - 1 - e.lastIndexOf("/")), n = h, a = 0;
              continue;
            }
          } else if (e.length === 2 || e.length === 1) {
            e = "", r = 0, n = h, a = 0;
            continue;
          }
        }
      } else
        e.length > 0 ? e += `/${s.slice(n + 1, h)}` : e = s.slice(n + 1, h), r = h - n - 1;
      n = h, a = 0;
    } else l === 46 && a !== -1 ? ++a : a = -1;
  }
  return e;
}
const qt = {
  /**
   * Converts a path to posix format.
   * @param path - The path to convert to posix
   * @example
   * ```ts
   * // Convert a Windows path to POSIX format
   * path.toPosix('C:\\Users\\User\\Documents\\file.txt');
   * // -> 'C:/Users/User/Documents/file.txt'
   * ```
   */
  toPosix(s) {
    return Eb(s, "\\", "/");
  },
  /**
   * Checks if the path is a URL e.g. http://, https://
   * @param path - The path to check
   * @example
   * ```ts
   * // Check if a path is a URL
   * path.isUrl('http://www.example.com');
   * // -> true
   * path.isUrl('C:/Users/User/Documents/file.txt');
   * // -> false
   * ```
   */
  isUrl(s) {
    return /^https?:/.test(this.toPosix(s));
  },
  /**
   * Checks if the path is a data URL
   * @param path - The path to check
   * @example
   * ```ts
   * // Check if a path is a data URL
   * path.isDataUrl('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUA...');
   * // -> true
   * ```
   */
  isDataUrl(s) {
    return /^data:([a-z]+\/[a-z0-9-+.]+(;[a-z0-9-.!#$%*+.{}|~`]+=[a-z0-9-.!#$%*+.{}()_|~`]+)*)?(;base64)?,([a-z0-9!$&',()*+;=\-._~:@\/?%\s<>]*?)$/i.test(s);
  },
  /**
   * Checks if the path is a blob URL
   * @param path - The path to check
   * @example
   * ```ts
   * // Check if a path is a blob URL
   * path.isBlobUrl('blob:http://www.example.com/12345678-1234-1234-1234-123456789012');
   * // -> true
   * ```
   */
  isBlobUrl(s) {
    return s.startsWith("blob:");
  },
  /**
   * Checks if the path has a protocol e.g. http://, https://, file:///, data:, blob:, C:/
   * This will return true for windows file paths
   * @param path - The path to check
   * @example
   * ```ts
   * // Check if a path has a protocol
   * path.hasProtocol('http://www.example.com');
   * // -> true
   * path.hasProtocol('C:/Users/User/Documents/file.txt');
   * // -> true
   * ```
   */
  hasProtocol(s) {
    return /^[^/:]+:/.test(this.toPosix(s));
  },
  /**
   * Returns the protocol of the path e.g. http://, https://, file:///, data:, blob:, C:/
   * @param path - The path to get the protocol from
   * @example
   * ```ts
   * // Get the protocol from a URL
   * path.getProtocol('http://www.example.com/path/to/resource');
   * // -> 'http://'
   * // Get the protocol from a file path
   * path.getProtocol('C:/Users/User/Documents/file.txt');
   * // -> 'C:/'
   * ```
   */
  getProtocol(s) {
    de(s), s = this.toPosix(s);
    const t = /^file:\/\/\//.exec(s);
    if (t)
      return t[0];
    const e = /^[^/:]+:\/{0,2}/.exec(s);
    return e ? e[0] : "";
  },
  /**
   * Converts URL to an absolute path.
   * When loading from a Web Worker, we must use absolute paths.
   * If the URL is already absolute we return it as is
   * If it's not, we convert it
   * @param url - The URL to test
   * @param customBaseUrl - The base URL to use
   * @param customRootUrl - The root URL to use
   * @example
   * ```ts
   * // Convert a relative URL to an absolute path
   * path.toAbsolute('images/texture.png', 'http://example.com/assets/');
   * // -> 'http://example.com/assets/images/texture.png'
   * ```
   */
  toAbsolute(s, t, e) {
    if (de(s), this.isDataUrl(s) || this.isBlobUrl(s))
      return s;
    const r = Tr(this.toPosix(t ?? Y.get().getBaseUrl())), n = Tr(this.toPosix(e ?? this.rootname(r)));
    return s = this.toPosix(s), s.startsWith("/") ? qt.join(n, s.slice(1)) : this.isAbsolute(s) ? s : this.join(r, s);
  },
  /**
   * Normalizes the given path, resolving '..' and '.' segments
   * @param path - The path to normalize
   * @example
   * ```ts
   * // Normalize a path with relative segments
   * path.normalize('http://www.example.com/foo/bar/../baz');
   * // -> 'http://www.example.com/foo/baz'
   * // Normalize a file path with relative segments
   * path.normalize('C:\\Users\\User\\Documents\\..\\file.txt');
   * // -> 'C:/Users/User/file.txt'
   * ```
   */
  normalize(s) {
    if (de(s), s.length === 0)
      return ".";
    if (this.isDataUrl(s) || this.isBlobUrl(s))
      return s;
    s = this.toPosix(s);
    let t = "";
    const e = s.startsWith("/");
    this.hasProtocol(s) && (t = this.rootname(s), s = s.slice(t.length));
    const r = s.endsWith("/");
    return s = Ab(s), s.length > 0 && r && (s += "/"), e ? `/${s}` : t + s;
  },
  /**
   * Determines if path is an absolute path.
   * Absolute paths can be urls, data urls, or paths on disk
   * @param path - The path to test
   * @example
   * ```ts
   * // Check if a path is absolute
   * path.isAbsolute('http://www.example.com/foo/bar');
   * // -> true
   * path.isAbsolute('C:/Users/User/Documents/file.txt');
   * // -> true
   * ```
   */
  isAbsolute(s) {
    return de(s), s = this.toPosix(s), this.hasProtocol(s) ? !0 : s.startsWith("/");
  },
  /**
   * Joins all given path segments together using the platform-specific separator as a delimiter,
   * then normalizes the resulting path
   * @param segments - The segments of the path to join
   * @example
   * ```ts
   * // Join multiple path segments
   * path.join('assets', 'images', 'sprite.png');
   * // -> 'assets/images/sprite.png'
   * // Join with relative segments
   * path.join('assets', 'images', '../textures', 'sprite.png');
   * // -> 'assets/textures/sprite.png'
   * ```
   */
  join(...s) {
    if (s.length === 0)
      return ".";
    let t;
    for (let e = 0; e < s.length; ++e) {
      const r = s[e];
      if (de(r), r.length > 0)
        if (t === void 0)
          t = r;
        else {
          const n = s[e - 1] ?? "";
          this.joinExtensions.includes(this.extname(n).toLowerCase()) ? t += `/../${r}` : t += `/${r}`;
        }
    }
    return t === void 0 ? "." : this.normalize(t);
  },
  /**
   * Returns the directory name of a path
   * @param path - The path to parse
   * @example
   * ```ts
   * // Get the directory name of a path
   * path.dirname('http://www.example.com/foo/bar/baz.png');
   * // -> 'http://www.example.com/foo/bar'
   * // Get the directory name of a file path
   * path.dirname('C:/Users/User/Documents/file.txt');
   * // -> 'C:/Users/User/Documents'
   * ```
   */
  dirname(s) {
    if (de(s), s.length === 0)
      return ".";
    s = this.toPosix(s);
    let t = s.charCodeAt(0);
    const e = t === 47;
    let r = -1, n = !0;
    const a = this.getProtocol(s), l = s;
    s = s.slice(a.length);
    for (let h = s.length - 1; h >= 1; --h)
      if (t = s.charCodeAt(h), t === 47) {
        if (!n) {
          r = h;
          break;
        }
      } else
        n = !1;
    return r === -1 ? e ? "/" : this.isUrl(l) ? a + s : a : e && r === 1 ? "//" : a + s.slice(0, r);
  },
  /**
   * Returns the root of the path e.g. /, C:/, file:///, http://domain.com/
   * @param path - The path to parse
   * @example
   * ```ts
   * // Get the root of a URL
   * path.rootname('http://www.example.com/foo/bar/baz.png');
   * // -> 'http://www.example.com/'
   * // Get the root of a file path
   * path.rootname('C:/Users/User/Documents/file.txt');
   * // -> 'C:/'
   * ```
   */
  rootname(s) {
    de(s), s = this.toPosix(s);
    let t = "";
    if (s.startsWith("/") ? t = "/" : t = this.getProtocol(s), this.isUrl(s)) {
      const e = s.indexOf("/", t.length);
      e !== -1 ? t = s.slice(0, e) : t = s, t.endsWith("/") || (t += "/");
    }
    return t;
  },
  /**
   * Returns the last portion of a path
   * @param path - The path to test
   * @param ext - Optional extension to remove
   * @example
   * ```ts
   * // Get the basename of a URL
   * path.basename('http://www.example.com/foo/bar/baz.png');
   * // -> 'baz.png'
   * // Get the basename of a file path
   * path.basename('C:/Users/User/Documents/file.txt');
   * // -> 'file.txt'
   * ```
   */
  basename(s, t) {
    de(s), t && de(t), s = Tr(this.toPosix(s));
    let e = 0, r = -1, n = !0, a;
    if (t !== void 0 && t.length > 0 && t.length <= s.length) {
      if (t.length === s.length && t === s)
        return "";
      let l = t.length - 1, h = -1;
      for (a = s.length - 1; a >= 0; --a) {
        const u = s.charCodeAt(a);
        if (u === 47) {
          if (!n) {
            e = a + 1;
            break;
          }
        } else
          h === -1 && (n = !1, h = a + 1), l >= 0 && (u === t.charCodeAt(l) ? --l === -1 && (r = a) : (l = -1, r = h));
      }
      return e === r ? r = h : r === -1 && (r = s.length), s.slice(e, r);
    }
    for (a = s.length - 1; a >= 0; --a)
      if (s.charCodeAt(a) === 47) {
        if (!n) {
          e = a + 1;
          break;
        }
      } else r === -1 && (n = !1, r = a + 1);
    return r === -1 ? "" : s.slice(e, r);
  },
  /**
   * Returns the extension of the path, from the last occurrence of the . (period) character to end of string in the last
   * portion of the path. If there is no . in the last portion of the path, or if there are no . characters other than
   * the first character of the basename of path, an empty string is returned.
   * @param path - The path to parse
   * @example
   * ```ts
   * // Get the extension of a URL
   * path.extname('http://www.example.com/foo/bar/baz.png');
   * // -> '.png'
   * // Get the extension of a file path
   * path.extname('C:/Users/User/Documents/file.txt');
   * // -> '.txt'
   * ```
   */
  extname(s) {
    de(s), s = Tr(this.toPosix(s));
    let t = -1, e = 0, r = -1, n = !0, a = 0;
    for (let l = s.length - 1; l >= 0; --l) {
      const h = s.charCodeAt(l);
      if (h === 47) {
        if (!n) {
          e = l + 1;
          break;
        }
        continue;
      }
      r === -1 && (n = !1, r = l + 1), h === 46 ? t === -1 ? t = l : a !== 1 && (a = 1) : t !== -1 && (a = -1);
    }
    return t === -1 || r === -1 || a === 0 || a === 1 && t === r - 1 && t === e + 1 ? "" : s.slice(t, r);
  },
  /**
   * Parses a path into an object containing the 'root', `dir`, `base`, `ext`, and `name` properties.
   * @param path - The path to parse
   * @example
   * ```ts
   * // Parse a URL
   * const parsed = path.parse('http://www.example.com/foo/bar/baz.png');
   * // -> {
   * //   root: 'http://www.example.com/',
   * //   dir: 'http://www.example.com/foo/bar',
   * //   base: 'baz.png',
   * //   ext: '.png',
   * //   name: 'baz'
   * // }
   * // Parse a file path
   * const parsedFile = path.parse('C:/Users/User/Documents/file.txt');
   * // -> {
   * //   root: 'C:/',
   * //   dir: 'C:/Users/User/Documents',
   * //   base: 'file.txt',
   * //   ext: '.txt',
   * //   name: 'file'
   * // }
   * ```
   */
  parse(s) {
    de(s);
    const t = { root: "", dir: "", base: "", ext: "", name: "" };
    if (s.length === 0)
      return t;
    s = Tr(this.toPosix(s));
    let e = s.charCodeAt(0);
    const r = this.isAbsolute(s);
    let n;
    t.root = this.rootname(s), r || this.hasProtocol(s) ? n = 1 : n = 0;
    let a = -1, l = 0, h = -1, u = !0, f = s.length - 1, p = 0;
    for (; f >= n; --f) {
      if (e = s.charCodeAt(f), e === 47) {
        if (!u) {
          l = f + 1;
          break;
        }
        continue;
      }
      h === -1 && (u = !1, h = f + 1), e === 46 ? a === -1 ? a = f : p !== 1 && (p = 1) : a !== -1 && (p = -1);
    }
    return a === -1 || h === -1 || p === 0 || p === 1 && a === h - 1 && a === l + 1 ? h !== -1 && (l === 0 && r ? t.base = t.name = s.slice(1, h) : t.base = t.name = s.slice(l, h)) : (l === 0 && r ? (t.name = s.slice(1, a), t.base = s.slice(1, h)) : (t.name = s.slice(l, a), t.base = s.slice(l, h)), t.ext = s.slice(a, h)), t.dir = this.dirname(s), t;
  },
  sep: "/",
  delimiter: ":",
  joinExtensions: [".html"]
};
function cp(s, t, e, r, n) {
  const a = t[e];
  for (let l = 0; l < a.length; l++) {
    const h = a[l];
    e < t.length - 1 ? cp(s.replace(r[e], h), t, e + 1, r, n) : n.push(s.replace(r[e], h));
  }
}
function Pb(s) {
  const t = /\{(.*?)\}/g, e = s.match(t), r = [];
  if (e) {
    const n = [];
    e.forEach((a) => {
      const l = a.substring(1, a.length - 1).split(",");
      n.push(l);
    }), cp(s, n, 0, e, r);
  } else
    r.push(s);
  return r;
}
const Cn = (s) => !Array.isArray(s);
class mr {
  constructor() {
    this._defaultBundleIdentifierOptions = {
      connector: "-",
      createBundleAssetId: (t, e) => `${t}${this._bundleIdConnector}${e}`,
      extractAssetIdFromBundle: (t, e) => e.replace(`${t}${this._bundleIdConnector}`, "")
    }, this._bundleIdConnector = this._defaultBundleIdentifierOptions.connector, this._createBundleAssetId = this._defaultBundleIdentifierOptions.createBundleAssetId, this._extractAssetIdFromBundle = this._defaultBundleIdentifierOptions.extractAssetIdFromBundle, this._assetMap = {}, this._preferredOrder = [], this._parsers = [], this._resolverHash = {}, this._bundles = {};
  }
  /**
   * Override how the resolver deals with generating bundle ids.
   * must be called before any bundles are added
   * @param bundleIdentifier - the bundle identifier options
   */
  setBundleIdentifier(t) {
    if (this._bundleIdConnector = t.connector ?? this._bundleIdConnector, this._createBundleAssetId = t.createBundleAssetId ?? this._createBundleAssetId, this._extractAssetIdFromBundle = t.extractAssetIdFromBundle ?? this._extractAssetIdFromBundle, this._extractAssetIdFromBundle("foo", this._createBundleAssetId("foo", "bar")) !== "bar")
      throw new Error("[Resolver] GenerateBundleAssetId are not working correctly");
  }
  /**
   * Let the resolver know which assets you prefer to use when resolving assets.
   * Multiple prefer user defined rules can be added.
   * @example
   * resolver.prefer({
   *     // first look for something with the correct format, and then then correct resolution
   *     priority: ['format', 'resolution'],
   *     params:{
   *         format:'webp', // prefer webp images
   *         resolution: 2, // prefer a resolution of 2
   *     }
   * })
   * resolver.add('foo', ['bar@2x.webp', 'bar@2x.png', 'bar.webp', 'bar.png']);
   * resolver.resolveUrl('foo') // => 'bar@2x.webp'
   * @param preferOrders - the prefer options
   */
  prefer(...t) {
    t.forEach((e) => {
      this._preferredOrder.push(e), e.priority || (e.priority = Object.keys(e.params));
    }), this._resolverHash = {};
  }
  /**
   * Set the base path to prepend to all urls when resolving
   * @example
   * resolver.basePath = 'https://home.com/';
   * resolver.add('foo', 'bar.ong');
   * resolver.resolveUrl('foo', 'bar.png'); // => 'https://home.com/bar.png'
   * @param basePath - the base path to use
   */
  set basePath(t) {
    this._basePath = t;
  }
  get basePath() {
    return this._basePath;
  }
  /**
   * Set the root path for root-relative URLs. By default the `basePath`'s root is used. If no `basePath` is set, then the
   * default value for browsers is `window.location.origin`
   * @example
   * // Application hosted on https://home.com/some-path/index.html
   * resolver.basePath = 'https://home.com/some-path/';
   * resolver.rootPath = 'https://home.com/';
   * resolver.add('foo', '/bar.png');
   * resolver.resolveUrl('foo', '/bar.png'); // => 'https://home.com/bar.png'
   * @param rootPath - the root path to use
   */
  set rootPath(t) {
    this._rootPath = t;
  }
  get rootPath() {
    return this._rootPath;
  }
  /**
   * All the active URL parsers that help the parser to extract information and create
   * an asset object-based on parsing the URL itself.
   *
   * Can be added using the extensions API
   * @example
   * resolver.add('foo', [
   *     {
   *         resolution: 2,
   *         format: 'png',
   *         src: 'image@2x.png',
   *     },
   *     {
   *         resolution:1,
   *         format:'png',
   *         src: 'image.png',
   *     },
   * ]);
   *
   * // With a url parser the information such as resolution and file format could extracted from the url itself:
   * extensions.add({
   *     extension: ExtensionType.ResolveParser,
   *     test: loadTextures.test, // test if url ends in an image
   *     parse: (value: string) =>
   *     ({
   *         resolution: parseFloat(Resolver.RETINA_PREFIX.exec(value)?.[1] ?? '1'),
   *         format: value.split('.').pop(),
   *         src: value,
   *     }),
   * });
   *
   * // Now resolution and format can be extracted from the url
   * resolver.add('foo', [
   *     'image@2x.png',
   *     'image.png',
   * ]);
   */
  get parsers() {
    return this._parsers;
  }
  /** Used for testing, this resets the resolver to its initial state */
  reset() {
    this.setBundleIdentifier(this._defaultBundleIdentifierOptions), this._assetMap = {}, this._preferredOrder = [], this._resolverHash = {}, this._rootPath = null, this._basePath = null, this._manifest = null, this._bundles = {}, this._defaultSearchParams = null;
  }
  /**
   * Sets the default URL search parameters for the URL resolver. The urls can be specified as a string or an object.
   * @param searchParams - the default url parameters to append when resolving urls
   */
  setDefaultSearchParams(t) {
    if (typeof t == "string")
      this._defaultSearchParams = t;
    else {
      const e = t;
      this._defaultSearchParams = Object.keys(e).map((r) => `${encodeURIComponent(r)}=${encodeURIComponent(e[r])}`).join("&");
    }
  }
  /**
   * Returns the aliases for a given asset
   * @param asset - the asset to get the aliases for
   */
  getAlias(t) {
    const { alias: e, src: r } = t;
    return _e(
      e || r,
      (a) => typeof a == "string" ? a : Array.isArray(a) ? a.map((l) => l?.src ?? l) : a?.src ? a.src : a,
      !0
    );
  }
  /**
   * Add a manifest to the asset resolver. This is a nice way to add all the asset information in one go.
   * generally a manifest would be built using a tool.
   * @param manifest - the manifest to add to the resolver
   */
  addManifest(t) {
    this._manifest && N("[Resolver] Manifest already exists, this will be overwritten"), this._manifest = t, t.bundles.forEach((e) => {
      this.addBundle(e.name, e.assets);
    });
  }
  /**
   * This adds a bundle of assets in one go so that you can resolve them as a group.
   * For example you could add a bundle for each screen in you pixi app
   * @example
   * resolver.addBundle('animals', [
   *  { alias: 'bunny', src: 'bunny.png' },
   *  { alias: 'chicken', src: 'chicken.png' },
   *  { alias: 'thumper', src: 'thumper.png' },
   * ]);
   * // or
   * resolver.addBundle('animals', {
   *     bunny: 'bunny.png',
   *     chicken: 'chicken.png',
   *     thumper: 'thumper.png',
   * });
   *
   * const resolvedAssets = await resolver.resolveBundle('animals');
   * @param bundleId - The id of the bundle to add
   * @param assets - A record of the asset or assets that will be chosen from when loading via the specified key
   */
  addBundle(t, e) {
    const r = [];
    let n = e;
    Array.isArray(e) || (n = Object.entries(e).map(([a, l]) => typeof l == "string" || Array.isArray(l) ? { alias: a, src: l } : { alias: a, ...l })), n.forEach((a) => {
      const l = a.src, h = a.alias;
      let u;
      if (typeof h == "string") {
        const f = this._createBundleAssetId(t, h);
        r.push(f), u = [h, f];
      } else {
        const f = h.map((p) => this._createBundleAssetId(t, p));
        r.push(...f), u = [...h, ...f];
      }
      this.add({
        ...a,
        alias: u,
        src: l
      });
    }), this._bundles[t] = r;
  }
  /**
   * Tells the resolver what keys are associated with witch asset.
   * The most important thing the resolver does
   * @example
   * // Single key, single asset:
   * resolver.add({alias: 'foo', src: 'bar.png');
   * resolver.resolveUrl('foo') // => 'bar.png'
   *
   * // Multiple keys, single asset:
   * resolver.add({alias: ['foo', 'boo'], src: 'bar.png'});
   * resolver.resolveUrl('foo') // => 'bar.png'
   * resolver.resolveUrl('boo') // => 'bar.png'
   *
   * // Multiple keys, multiple assets:
   * resolver.add({alias: ['foo', 'boo'], src: ['bar.png', 'bar.webp']});
   * resolver.resolveUrl('foo') // => 'bar.png'
   *
   * // Add custom data attached to the resolver
   * Resolver.add({
   *     alias: 'bunnyBooBooSmooth',
   *     src: 'bunny{png,webp}',
   *     data: { scaleMode:SCALE_MODES.NEAREST }, // Base texture options
   * });
   *
   * resolver.resolve('bunnyBooBooSmooth') // => { src: 'bunny.png', data: { scaleMode: SCALE_MODES.NEAREST } }
   * @param aliases - the UnresolvedAsset or array of UnresolvedAssets to add to the resolver
   */
  add(t) {
    const e = [];
    Array.isArray(t) ? e.push(...t) : e.push(t);
    let r;
    r = (a) => {
      this.hasKey(a) && N(`[Resolver] already has key: ${a} overwriting`);
    }, _e(e).forEach((a) => {
      const { src: l } = a;
      let { data: h, format: u, loadParser: f } = a;
      const p = _e(l).map((x) => typeof x == "string" ? Pb(x) : Array.isArray(x) ? x : [x]), m = this.getAlias(a);
      Array.isArray(m) ? m.forEach(r) : r(m);
      const g = [];
      p.forEach((x) => {
        x.forEach((o) => {
          let c = {};
          if (typeof o != "object") {
            c.src = o;
            for (let d = 0; d < this._parsers.length; d++) {
              const _ = this._parsers[d];
              if (_.test(o)) {
                c = _.parse(o);
                break;
              }
            }
          } else
            h = o.data ?? h, u = o.format ?? u, f = o.loadParser ?? f, c = {
              ...c,
              ...o
            };
          if (!m)
            throw new Error(`[Resolver] alias is undefined for this asset: ${c.src}`);
          c = this._buildResolvedAsset(c, {
            aliases: m,
            data: h,
            format: u,
            loadParser: f
          }), g.push(c);
        });
      }), m.forEach((x) => {
        this._assetMap[x] = g;
      });
    });
  }
  // TODO: this needs an overload like load did in Assets
  /**
   * If the resolver has had a manifest set via setManifest, this will return the assets urls for
   * a given bundleId or bundleIds.
   * @example
   * // Manifest Example
   * const manifest = {
   *     bundles: [
   *         {
   *             name: 'load-screen',
   *             assets: [
   *                 {
   *                     alias: 'background',
   *                     src: 'sunset.png',
   *                 },
   *                 {
   *                     alias: 'bar',
   *                     src: 'load-bar.{png,webp}',
   *                 },
   *             ],
   *         },
   *         {
   *             name: 'game-screen',
   *             assets: [
   *                 {
   *                     alias: 'character',
   *                     src: 'robot.png',
   *                 },
   *                 {
   *                     alias: 'enemy',
   *                     src: 'bad-guy.png',
   *                 },
   *             ],
   *         },
   *     ]
   * };
   *
   * resolver.setManifest(manifest);
   * const resolved = resolver.resolveBundle('load-screen');
   * @param bundleIds - The bundle ids to resolve
   * @returns All the bundles assets or a hash of assets for each bundle specified
   */
  resolveBundle(t) {
    const e = Cn(t);
    t = _e(t);
    const r = {};
    return t.forEach((n) => {
      const a = this._bundles[n];
      if (a) {
        const l = this.resolve(a), h = {};
        for (const u in l) {
          const f = l[u];
          h[this._extractAssetIdFromBundle(n, u)] = f;
        }
        r[n] = h;
      }
    }), e ? r[t[0]] : r;
  }
  /**
   * Does exactly what resolve does, but returns just the URL rather than the whole asset object
   * @param key - The key or keys to resolve
   * @returns - The URLs associated with the key(s)
   */
  resolveUrl(t) {
    const e = this.resolve(t);
    if (typeof t != "string") {
      const r = {};
      for (const n in e)
        r[n] = e[n].src;
      return r;
    }
    return e.src;
  }
  resolve(t) {
    const e = Cn(t);
    t = _e(t);
    const r = {};
    return t.forEach((n) => {
      if (!this._resolverHash[n])
        if (this._assetMap[n]) {
          let a = this._assetMap[n];
          const l = this._getPreferredOrder(a);
          l?.priority.forEach((h) => {
            l.params[h].forEach((u) => {
              const f = a.filter((p) => p[h] ? p[h] === u : !1);
              f.length && (a = f);
            });
          }), this._resolverHash[n] = a[0];
        } else
          this._resolverHash[n] = this._buildResolvedAsset({
            alias: [n],
            src: n
          }, {});
      r[n] = this._resolverHash[n];
    }), e ? r[t[0]] : r;
  }
  /**
   * Checks if an asset with a given key exists in the resolver
   * @param key - The key of the asset
   */
  hasKey(t) {
    return !!this._assetMap[t];
  }
  /**
   * Checks if a bundle with the given key exists in the resolver
   * @param key - The key of the bundle
   */
  hasBundle(t) {
    return !!this._bundles[t];
  }
  /**
   * Internal function for figuring out what prefer criteria an asset should use.
   * @param assets
   */
  _getPreferredOrder(t) {
    for (let e = 0; e < t.length; e++) {
      const r = t[e], n = this._preferredOrder.find((a) => a.params.format.includes(r.format));
      if (n)
        return n;
    }
    return this._preferredOrder[0];
  }
  /**
   * Appends the default url parameters to the url
   * @param url - The url to append the default parameters to
   * @returns - The url with the default parameters appended
   */
  _appendDefaultSearchParams(t) {
    if (!this._defaultSearchParams)
      return t;
    const e = /\?/.test(t) ? "&" : "?";
    return `${t}${e}${this._defaultSearchParams}`;
  }
  _buildResolvedAsset(t, e) {
    const { aliases: r, data: n, loadParser: a, format: l } = e;
    return (this._basePath || this._rootPath) && (t.src = qt.toAbsolute(t.src, this._basePath, this._rootPath)), t.alias = r ?? t.alias ?? [t.src], t.src = this._appendDefaultSearchParams(t.src), t.data = { ...n || {}, ...t.data }, t.loadParser = a ?? t.loadParser, t.format = l ?? t.format ?? Mb(t.src), t;
  }
}
mr.RETINA_PREFIX = /@([0-9\.]+)x/;
function Mb(s) {
  return s.split(".").pop().split("?").shift().split("#").shift();
}
const Ro = (s, t) => {
  const e = t.split("?")[1];
  return e && (s += `?${e}`), s;
}, up = class Or {
  /** @ignore */
  constructor(t, e) {
    this.linkedSheets = [];
    let r = t;
    t?.source instanceof yt && (r = {
      texture: t,
      data: e
    });
    const { texture: n, data: a, cachePrefix: l = "" } = r;
    this.cachePrefix = l, this._texture = n instanceof k ? n : null, this.textureSource = n.source, this.textures = {}, this.animations = {}, this.data = a;
    const h = parseFloat(a.meta.scale);
    h ? (this.resolution = h, n.source.resolution = this.resolution) : this.resolution = n.source._resolution, this._frames = this.data.frames, this._frameKeys = Object.keys(this._frames), this._batchIndex = 0, this._callback = null;
  }
  /**
   * Parser spritesheet from loaded data. This is done asynchronously
   * to prevent creating too many Texture within a single process.
   */
  parse() {
    return new Promise((t) => {
      this._callback = t, this._batchIndex = 0, this._frameKeys.length <= Or.BATCH_SIZE ? (this._processFrames(0), this._processAnimations(), this._parseComplete()) : this._nextBatch();
    });
  }
  /**
   * Process a batch of frames
   * @param initialFrameIndex - The index of frame to start.
   */
  _processFrames(t) {
    let e = t;
    const r = Or.BATCH_SIZE;
    for (; e - t < r && e < this._frameKeys.length; ) {
      const n = this._frameKeys[e], a = this._frames[n], l = a.frame;
      if (l) {
        let h = null, u = null;
        const f = a.trimmed !== !1 && a.sourceSize ? a.sourceSize : a.frame, p = new Z(
          0,
          0,
          Math.floor(f.w) / this.resolution,
          Math.floor(f.h) / this.resolution
        );
        a.rotated ? h = new Z(
          Math.floor(l.x) / this.resolution,
          Math.floor(l.y) / this.resolution,
          Math.floor(l.h) / this.resolution,
          Math.floor(l.w) / this.resolution
        ) : h = new Z(
          Math.floor(l.x) / this.resolution,
          Math.floor(l.y) / this.resolution,
          Math.floor(l.w) / this.resolution,
          Math.floor(l.h) / this.resolution
        ), a.trimmed !== !1 && a.spriteSourceSize && (u = new Z(
          Math.floor(a.spriteSourceSize.x) / this.resolution,
          Math.floor(a.spriteSourceSize.y) / this.resolution,
          Math.floor(l.w) / this.resolution,
          Math.floor(l.h) / this.resolution
        )), this.textures[n] = new k({
          source: this.textureSource,
          frame: h,
          orig: p,
          trim: u,
          rotate: a.rotated ? 2 : 0,
          defaultAnchor: a.anchor,
          defaultBorders: a.borders,
          label: n.toString()
        });
      }
      e++;
    }
  }
  /** Parse animations config. */
  _processAnimations() {
    const t = this.data.animations || {};
    for (const e in t) {
      this.animations[e] = [];
      for (let r = 0; r < t[e].length; r++) {
        const n = t[e][r];
        this.animations[e].push(this.textures[n]);
      }
    }
  }
  /** The parse has completed. */
  _parseComplete() {
    const t = this._callback;
    this._callback = null, this._batchIndex = 0, t.call(this, this.textures);
  }
  /** Begin the next batch of textures. */
  _nextBatch() {
    this._processFrames(this._batchIndex * Or.BATCH_SIZE), this._batchIndex++, setTimeout(() => {
      this._batchIndex * Or.BATCH_SIZE < this._frameKeys.length ? this._nextBatch() : (this._processAnimations(), this._parseComplete());
    }, 0);
  }
  /**
   * Destroy Spritesheet and don't use after this.
   * @param {boolean} [destroyBase=false] - Whether to destroy the base texture as well
   */
  destroy(t = !1) {
    for (const e in this.textures)
      this.textures[e].destroy();
    this._frames = null, this._frameKeys = null, this.data = null, this.textures = null, t && (this._texture?.destroy(), this.textureSource.destroy()), this._texture = null, this.textureSource = null, this.linkedSheets = [];
  }
};
up.BATCH_SIZE = 1e3;
let Ac = up;
const Bb = [
  "jpg",
  "png",
  "jpeg",
  "avif",
  "webp",
  "basis",
  "etc2",
  "bc7",
  "bc6h",
  "bc5",
  "bc4",
  "bc3",
  "bc2",
  "bc1",
  "eac",
  "astc"
];
function dp(s, t, e) {
  const r = {};
  if (s.forEach((n) => {
    r[n] = t;
  }), Object.keys(t.textures).forEach((n) => {
    r[`${t.cachePrefix}${n}`] = t.textures[n];
  }), !e) {
    const n = qt.dirname(s[0]);
    t.linkedSheets.forEach((a, l) => {
      const h = dp([`${n}/${t.data.meta.related_multi_packs[l]}`], a, !0);
      Object.assign(r, h);
    });
  }
  return r;
}
const Ub = {
  extension: A.Asset,
  /** Handle the caching of the related Spritesheet Textures */
  cache: {
    test: (s) => s instanceof Ac,
    getCacheableAssets: (s, t) => dp(s, t, !1)
  },
  /** Resolve the resolution of the asset. */
  resolver: {
    extension: {
      type: A.ResolveParser,
      name: "resolveSpritesheet"
    },
    test: (s) => {
      const e = s.split("?")[0].split("."), r = e.pop(), n = e.pop();
      return r === "json" && Bb.includes(n);
    },
    parse: (s) => {
      const t = s.split(".");
      return {
        resolution: parseFloat(mr.RETINA_PREFIX.exec(s)?.[1] ?? "1"),
        format: t[t.length - 2],
        src: s
      };
    }
  },
  /**
   * Loader plugin that parses sprite sheets!
   * once the JSON has been loaded this checks to see if the JSON is spritesheet data.
   * If it is, we load the spritesheets image and parse the data into Spritesheet
   * All textures in the sprite sheet are then added to the cache
   */
  loader: {
    name: "spritesheetLoader",
    extension: {
      type: A.LoadParser,
      priority: li.Normal,
      name: "spritesheetLoader"
    },
    async testParse(s, t) {
      return qt.extname(t.src).toLowerCase() === ".json" && !!s.frames;
    },
    async parse(s, t, e) {
      const {
        texture: r,
        // if user need to use preloaded texture
        imageFilename: n,
        // if user need to use custom filename (not from jsonFile.meta.image)
        textureOptions: a,
        // if user need to set texture options on texture
        cachePrefix: l
        // if user need to use custom cache prefix
      } = t?.data ?? {};
      let h = qt.dirname(t.src);
      h && h.lastIndexOf("/") !== h.length - 1 && (h += "/");
      let u;
      if (r instanceof k)
        u = r;
      else {
        const m = Ro(h + (n ?? s.meta.image), t.src);
        u = (await e.load([{ src: m, data: a }]))[m];
      }
      const f = new Ac({
        texture: u.source,
        data: s,
        cachePrefix: l
      });
      await f.parse();
      const p = s?.meta?.related_multi_packs;
      if (Array.isArray(p)) {
        const m = [];
        for (const x of p) {
          if (typeof x != "string")
            continue;
          let o = h + x;
          t.data?.ignoreMultiPack || (o = Ro(o, t.src), m.push(e.load({
            src: o,
            data: {
              textureOptions: a,
              ignoreMultiPack: !0
            }
          })));
        }
        const g = await Promise.all(m);
        f.linkedSheets = g, g.forEach((x) => {
          x.linkedSheets = [f].concat(f.linkedSheets.filter((o) => o !== x));
        });
      }
      return f;
    },
    async unload(s, t, e) {
      await e.unload(s.textureSource._sourceOrigin), s.destroy(!1);
    }
  }
};
L.add(Ub);
class gs {
  /**
   * @param manager - The event boundary which manages this event. Propagation can only occur
   *  within the boundary's jurisdiction.
   */
  constructor(t) {
    this.bubbles = !0, this.cancelBubble = !0, this.cancelable = !1, this.composed = !1, this.defaultPrevented = !1, this.eventPhase = gs.prototype.NONE, this.propagationStopped = !1, this.propagationImmediatelyStopped = !1, this.layer = new et(), this.page = new et(), this.NONE = 0, this.CAPTURING_PHASE = 1, this.AT_TARGET = 2, this.BUBBLING_PHASE = 3, this.manager = t;
  }
  /** @readonly */
  get layerX() {
    return this.layer.x;
  }
  /** @readonly */
  get layerY() {
    return this.layer.y;
  }
  /** @readonly */
  get pageX() {
    return this.page.x;
  }
  /** @readonly */
  get pageY() {
    return this.page.y;
  }
  /**
   * Fallback for the deprecated `InteractionEvent.data`.
   * @deprecated since 7.0.0
   */
  get data() {
    return this;
  }
  /**
   * The propagation path for this event. Alias for {@link EventBoundary.propagationPath}.
   * @advanced
   */
  composedPath() {
    return this.manager && (!this.path || this.path[this.path.length - 1] !== this.target) && (this.path = this.target ? this.manager.propagationPath(this.target) : []), this.path;
  }
  /**
   * Unimplemented method included for implementing the DOM interface `Event`. It will throw an `Error`.
   * @deprecated
   * @ignore
   * @param _type
   * @param _bubbles
   * @param _cancelable
   */
  initEvent(t, e, r) {
    throw new Error("initEvent() is a legacy DOM API. It is not implemented in the Federated Events API.");
  }
  /**
   * Unimplemented method included for implementing the DOM interface `UIEvent`. It will throw an `Error`.
   * @ignore
   * @deprecated
   * @param _typeArg
   * @param _bubblesArg
   * @param _cancelableArg
   * @param _viewArg
   * @param _detailArg
   */
  initUIEvent(t, e, r, n, a) {
    throw new Error("initUIEvent() is a legacy DOM API. It is not implemented in the Federated Events API.");
  }
  /**
   * Prevent default behavior of both PixiJS and the user agent.
   * @example
   * ```ts
   * sprite.on('click', (event) => {
   *     // Prevent both browser's default click behavior
   *     // and PixiJS's default handling
   *     event.preventDefault();
   *
   *     // Custom handling
   *     customClickHandler();
   * });
   * ```
   * @remarks
   * - Only works if the native event is cancelable
   * - Does not stop event propagation
   */
  preventDefault() {
    this.nativeEvent instanceof Event && this.nativeEvent.cancelable && this.nativeEvent.preventDefault(), this.defaultPrevented = !0;
  }
  /**
   * Stop this event from propagating to any additional listeners, including those
   * on the current target and any following targets in the propagation path.
   * @example
   * ```ts
   * container.on('pointerdown', (event) => {
   *     // Stop all further event handling
   *     event.stopImmediatePropagation();
   *
   *     // These handlers won't be called:
   *     // - Other pointerdown listeners on this container
   *     // - Any pointerdown listeners on parent containers
   * });
   * ```
   * @remarks
   * - Immediately stops all event propagation
   * - Prevents other listeners on same target from being called
   * - More aggressive than stopPropagation()
   */
  stopImmediatePropagation() {
    this.propagationImmediatelyStopped = !0;
  }
  /**
   * Stop this event from propagating to the next target in the propagation path.
   * The rest of the listeners on the current target will still be notified.
   * @example
   * ```ts
   * child.on('pointermove', (event) => {
   *     // Handle event on child
   *     updateChild();
   *
   *     // Prevent parent handlers from being called
   *     event.stopPropagation();
   * });
   *
   * // This won't be called if child handles the event
   * parent.on('pointermove', (event) => {
   *     updateParent();
   * });
   * ```
   * @remarks
   * - Stops event bubbling to parent containers
   * - Does not prevent other listeners on same target
   * - Less aggressive than stopImmediatePropagation()
   */
  stopPropagation() {
    this.propagationStopped = !0;
  }
}
var ga = /iPhone/i, Pc = /iPod/i, Mc = /iPad/i, Bc = /\biOS-universal(?:.+)Mac\b/i, ya = /\bAndroid(?:.+)Mobile\b/i, Uc = /Android/i, Li = /(?:SD4930UR|\bSilk(?:.+)Mobile\b)/i, ks = /Silk/i, ke = /Windows Phone/i, Rc = /\bWindows(?:.+)ARM\b/i, Ic = /BlackBerry/i, kc = /BB10/i, Fc = /Opera Mini/i, Dc = /\b(CriOS|Chrome)(?:.+)Mobile/i, Oc = /Mobile(?:.+)Firefox\b/i, Lc = function(s) {
  return typeof s < "u" && s.platform === "MacIntel" && typeof s.maxTouchPoints == "number" && s.maxTouchPoints > 1 && typeof MSStream > "u";
};
function Rb(s) {
  return function(t) {
    return t.test(s);
  };
}
function Gc(s) {
  var t = {
    userAgent: "",
    platform: "",
    maxTouchPoints: 0
  };
  !s && typeof navigator < "u" ? t = {
    userAgent: navigator.userAgent,
    platform: navigator.platform,
    maxTouchPoints: navigator.maxTouchPoints || 0
  } : typeof s == "string" ? t.userAgent = s : s && s.userAgent && (t = {
    userAgent: s.userAgent,
    platform: s.platform,
    maxTouchPoints: s.maxTouchPoints || 0
  });
  var e = t.userAgent, r = e.split("[FBAN");
  typeof r[1] < "u" && (e = r[0]), r = e.split("Twitter"), typeof r[1] < "u" && (e = r[0]);
  var n = Rb(e), a = {
    apple: {
      phone: n(ga) && !n(ke),
      ipod: n(Pc),
      tablet: !n(ga) && (n(Mc) || Lc(t)) && !n(ke),
      universal: n(Bc),
      device: (n(ga) || n(Pc) || n(Mc) || n(Bc) || Lc(t)) && !n(ke)
    },
    amazon: {
      phone: n(Li),
      tablet: !n(Li) && n(ks),
      device: n(Li) || n(ks)
    },
    android: {
      phone: !n(ke) && n(Li) || !n(ke) && n(ya),
      tablet: !n(ke) && !n(Li) && !n(ya) && (n(ks) || n(Uc)),
      device: !n(ke) && (n(Li) || n(ks) || n(ya) || n(Uc)) || n(/\bokhttp\b/i)
    },
    windows: {
      phone: n(ke),
      tablet: n(Rc),
      device: n(ke) || n(Rc)
    },
    other: {
      blackberry: n(Ic),
      blackberry10: n(kc),
      opera: n(Fc),
      firefox: n(Oc),
      chrome: n(Dc),
      device: n(Ic) || n(kc) || n(Fc) || n(Oc) || n(Dc)
    },
    any: !1,
    phone: !1,
    tablet: !1
  };
  return a.any = a.apple.device || a.android.device || a.windows.device || a.other.device, a.phone = a.apple.phone || a.android.phone || a.windows.phone, a.tablet = a.apple.tablet || a.android.tablet || a.windows.tablet, a;
}
const Ib = Gc.default ?? Gc, kb = Ib(globalThis.navigator), Fb = 9, Fs = 100, Db = 0, Ob = 0, zc = 2, Nc = 1, Lb = -1e3, Gb = -1e3, zb = 2, Dh = class fp {
  // 2fps
  // eslint-disable-next-line jsdoc/require-param
  /**
   * @param {WebGLRenderer|WebGPURenderer} renderer - A reference to the current renderer
   */
  constructor(t, e = kb) {
    this._mobileInfo = e, this.debug = !1, this._activateOnTab = !0, this._deactivateOnMouseMove = !0, this._isActive = !1, this._isMobileAccessibility = !1, this._div = null, this._pool = [], this._renderId = 0, this._children = [], this._androidUpdateCount = 0, this._androidUpdateFrequency = 500, this._hookDiv = null, (e.tablet || e.phone) && this._createTouchHook(), this._renderer = t;
  }
  /**
   * Value of `true` if accessibility is currently active and accessibility layers are showing.
   * @type {boolean}
   * @readonly
   */
  get isActive() {
    return this._isActive;
  }
  /**
   * Value of `true` if accessibility is enabled for touch devices.
   * @type {boolean}
   * @readonly
   */
  get isMobileAccessibility() {
    return this._isMobileAccessibility;
  }
  /**
   * The DOM element that will sit over the PixiJS element. This is where the div overlays will go.
   * @readonly
   */
  get hookDiv() {
    return this._hookDiv;
  }
  /**
   * Creates the touch hooks.
   * @private
   */
  _createTouchHook() {
    const t = document.createElement("button");
    t.style.width = `${Nc}px`, t.style.height = `${Nc}px`, t.style.position = "absolute", t.style.top = `${Lb}px`, t.style.left = `${Gb}px`, t.style.zIndex = zb.toString(), t.style.backgroundColor = "#FF0000", t.title = "select to enable accessibility for this content", t.addEventListener("focus", () => {
      this._isMobileAccessibility = !0, this._activate(), this._destroyTouchHook();
    }), document.body.appendChild(t), this._hookDiv = t;
  }
  /**
   * Destroys the touch hooks.
   * @private
   */
  _destroyTouchHook() {
    this._hookDiv && (document.body.removeChild(this._hookDiv), this._hookDiv = null);
  }
  /**
   * Activating will cause the Accessibility layer to be shown.
   * This is called when a user presses the tab key.
   * @private
   */
  _activate() {
    if (this._isActive)
      return;
    this._isActive = !0, this._div || (this._div = document.createElement("div"), this._div.style.width = `${Fs}px`, this._div.style.height = `${Fs}px`, this._div.style.position = "absolute", this._div.style.top = `${Db}px`, this._div.style.left = `${Ob}px`, this._div.style.zIndex = zc.toString(), this._div.style.pointerEvents = "none"), this._activateOnTab && (this._onKeyDown = this._onKeyDown.bind(this), globalThis.addEventListener("keydown", this._onKeyDown, !1)), this._deactivateOnMouseMove && (this._onMouseMove = this._onMouseMove.bind(this), globalThis.document.addEventListener("mousemove", this._onMouseMove, !0));
    const t = this._renderer.view.canvas;
    if (t.parentNode)
      t.parentNode.appendChild(this._div), this._initAccessibilitySetup();
    else {
      const e = new MutationObserver(() => {
        t.parentNode && (t.parentNode.appendChild(this._div), e.disconnect(), this._initAccessibilitySetup());
      });
      e.observe(document.body, { childList: !0, subtree: !0 });
    }
  }
  // New method to handle initialization after div is ready
  _initAccessibilitySetup() {
    this._renderer.runners.postrender.add(this), this._renderer.lastObjectRendered && this._updateAccessibleObjects(this._renderer.lastObjectRendered);
  }
  /**
   * Deactivates the accessibility system. Removes listeners and accessibility elements.
   * @private
   */
  _deactivate() {
    if (!(!this._isActive || this._isMobileAccessibility)) {
      this._isActive = !1, globalThis.document.removeEventListener("mousemove", this._onMouseMove, !0), this._activateOnTab && globalThis.addEventListener("keydown", this._onKeyDown, !1), this._renderer.runners.postrender.remove(this);
      for (const t of this._children)
        t._accessibleDiv && t._accessibleDiv.parentNode && (t._accessibleDiv.parentNode.removeChild(t._accessibleDiv), t._accessibleDiv = null), t._accessibleActive = !1;
      this._pool.forEach((t) => {
        t.parentNode && t.parentNode.removeChild(t);
      }), this._div && this._div.parentNode && this._div.parentNode.removeChild(this._div), this._pool = [], this._children = [];
    }
  }
  /**
   * This recursive function will run through the scene graph and add any new accessible objects to the DOM layer.
   * @private
   * @param {Container} container - The Container to check.
   */
  _updateAccessibleObjects(t) {
    if (!t.visible || !t.accessibleChildren)
      return;
    t.accessible && (t._accessibleActive || this._addChild(t), t._renderId = this._renderId);
    const e = t.children;
    if (e)
      for (let r = 0; r < e.length; r++)
        this._updateAccessibleObjects(e[r]);
  }
  /**
   * Runner init called, view is available at this point.
   * @ignore
   */
  init(t) {
    const r = {
      accessibilityOptions: {
        ...fp.defaultOptions,
        ...t?.accessibilityOptions || {}
      }
    };
    this.debug = r.accessibilityOptions.debug, this._activateOnTab = r.accessibilityOptions.activateOnTab, this._deactivateOnMouseMove = r.accessibilityOptions.deactivateOnMouseMove, r.accessibilityOptions.enabledByDefault ? this._activate() : this._activateOnTab && (this._onKeyDown = this._onKeyDown.bind(this), globalThis.addEventListener("keydown", this._onKeyDown, !1)), this._renderer.runners.postrender.remove(this);
  }
  /**
   * Updates the accessibility layer during rendering.
   * - Removes divs for containers no longer in the scene
   * - Updates the position and dimensions of the root div
   * - Updates positions of active accessibility divs
   * Only fires while the accessibility system is active.
   * @ignore
   */
  postrender() {
    const t = performance.now();
    if (this._mobileInfo.android.device && t < this._androidUpdateCount || (this._androidUpdateCount = t + this._androidUpdateFrequency, !this._renderer.renderingToScreen || !this._renderer.view.canvas))
      return;
    const e = /* @__PURE__ */ new Set();
    if (this._renderer.lastObjectRendered) {
      this._updateAccessibleObjects(this._renderer.lastObjectRendered);
      for (const r of this._children)
        r._renderId === this._renderId && e.add(this._children.indexOf(r));
    }
    for (let r = this._children.length - 1; r >= 0; r--) {
      const n = this._children[r];
      e.has(r) || (n._accessibleDiv && n._accessibleDiv.parentNode && (n._accessibleDiv.parentNode.removeChild(n._accessibleDiv), this._pool.push(n._accessibleDiv), n._accessibleDiv = null), n._accessibleActive = !1, jf(this._children, r, 1));
    }
    if (this._renderer.renderingToScreen) {
      const { x: r, y: n, width: a, height: l } = this._renderer.screen, h = this._div;
      h.style.left = `${r}px`, h.style.top = `${n}px`, h.style.width = `${a}px`, h.style.height = `${l}px`;
    }
    for (let r = 0; r < this._children.length; r++) {
      const n = this._children[r];
      if (!n._accessibleActive || !n._accessibleDiv)
        continue;
      const a = n._accessibleDiv, l = n.hitArea || n.getBounds().rectangle;
      if (n.hitArea) {
        const h = n.worldTransform, u = this._renderer.resolution, f = this._renderer.resolution;
        a.style.left = `${(h.tx + l.x * h.a) * u}px`, a.style.top = `${(h.ty + l.y * h.d) * f}px`, a.style.width = `${l.width * h.a * u}px`, a.style.height = `${l.height * h.d * f}px`;
      } else {
        this._capHitArea(l);
        const h = this._renderer.resolution, u = this._renderer.resolution;
        a.style.left = `${l.x * h}px`, a.style.top = `${l.y * u}px`, a.style.width = `${l.width * h}px`, a.style.height = `${l.height * u}px`;
      }
    }
    this._renderId++;
  }
  /**
   * private function that will visually add the information to the
   * accessibility div
   * @param {HTMLElement} div -
   */
  _updateDebugHTML(t) {
    t.innerHTML = `type: ${t.type}</br> title : ${t.title}</br> tabIndex: ${t.tabIndex}`;
  }
  /**
   * Adjust the hit area based on the bounds of a display object
   * @param {Rectangle} hitArea - Bounds of the child
   */
  _capHitArea(t) {
    t.x < 0 && (t.width += t.x, t.x = 0), t.y < 0 && (t.height += t.y, t.y = 0);
    const { width: e, height: r } = this._renderer;
    t.x + t.width > e && (t.width = e - t.x), t.y + t.height > r && (t.height = r - t.y);
  }
  /**
   * Creates or reuses a div element for a Container and adds it to the accessibility layer.
   * Sets up ARIA attributes, event listeners, and positioning based on the container's properties.
   * @private
   * @param {Container} container - The child to make accessible.
   */
  _addChild(t) {
    let e = this._pool.pop();
    e || (t.accessibleType === "button" ? e = document.createElement("button") : (e = document.createElement(t.accessibleType), e.style.cssText = `
                        color: transparent;
                        pointer-events: none;
                        padding: 0;
                        margin: 0;
                        border: 0;
                        outline: 0;
                        background: transparent;
                        box-sizing: border-box;
                        user-select: none;
                        -webkit-user-select: none;
                        -moz-user-select: none;
                        -ms-user-select: none;
                    `, t.accessibleText && (e.innerText = t.accessibleText)), e.style.width = `${Fs}px`, e.style.height = `${Fs}px`, e.style.backgroundColor = this.debug ? "rgba(255,255,255,0.5)" : "transparent", e.style.position = "absolute", e.style.zIndex = zc.toString(), e.style.borderStyle = "none", navigator.userAgent.toLowerCase().includes("chrome") ? e.setAttribute("aria-live", "off") : e.setAttribute("aria-live", "polite"), navigator.userAgent.match(/rv:.*Gecko\//) ? e.setAttribute("aria-relevant", "additions") : e.setAttribute("aria-relevant", "text"), e.addEventListener("click", this._onClick.bind(this)), e.addEventListener("focus", this._onFocus.bind(this)), e.addEventListener("focusout", this._onFocusOut.bind(this))), e.style.pointerEvents = t.accessiblePointerEvents, e.type = t.accessibleType, t.accessibleTitle && t.accessibleTitle !== null ? e.title = t.accessibleTitle : (!t.accessibleHint || t.accessibleHint === null) && (e.title = `container ${t.tabIndex}`), t.accessibleHint && t.accessibleHint !== null && e.setAttribute("aria-label", t.accessibleHint), this.debug && this._updateDebugHTML(e), t._accessibleActive = !0, t._accessibleDiv = e, e.container = t, this._children.push(t), this._div.appendChild(t._accessibleDiv), t.interactive && (t._accessibleDiv.tabIndex = t.tabIndex);
  }
  /**
   * Dispatch events with the EventSystem.
   * @param e
   * @param type
   * @private
   */
  _dispatchEvent(t, e) {
    const { container: r } = t.target, n = this._renderer.events.rootBoundary, a = Object.assign(new gs(n), { target: r });
    n.rootTarget = this._renderer.lastObjectRendered, e.forEach((l) => n.dispatchEvent(a, l));
  }
  /**
   * Maps the div button press to pixi's EventSystem (click)
   * @private
   * @param {MouseEvent} e - The click event.
   */
  _onClick(t) {
    this._dispatchEvent(t, ["click", "pointertap", "tap"]);
  }
  /**
   * Maps the div focus events to pixi's EventSystem (mouseover)
   * @private
   * @param {FocusEvent} e - The focus event.
   */
  _onFocus(t) {
    t.target.getAttribute("aria-live") || t.target.setAttribute("aria-live", "assertive"), this._dispatchEvent(t, ["mouseover"]);
  }
  /**
   * Maps the div focus events to pixi's EventSystem (mouseout)
   * @private
   * @param {FocusEvent} e - The focusout event.
   */
  _onFocusOut(t) {
    t.target.getAttribute("aria-live") || t.target.setAttribute("aria-live", "polite"), this._dispatchEvent(t, ["mouseout"]);
  }
  /**
   * Is called when a key is pressed
   * @private
   * @param {KeyboardEvent} e - The keydown event.
   */
  _onKeyDown(t) {
    t.keyCode !== Fb || !this._activateOnTab || this._activate();
  }
  /**
   * Is called when the mouse moves across the renderer element
   * @private
   * @param {MouseEvent} e - The mouse event.
   */
  _onMouseMove(t) {
    t.movementX === 0 && t.movementY === 0 || this._deactivate();
  }
  /**
   * Destroys the accessibility system. Removes all elements and listeners.
   * > [!IMPORTANT] This is typically called automatically when the {@link Application} is destroyed.
   * > A typically user should not need to call this method directly.
   */
  destroy() {
    this._deactivate(), this._destroyTouchHook(), this._div = null, this._pool = null, this._children = null, this._renderer = null, this._activateOnTab && globalThis.removeEventListener("keydown", this._onKeyDown);
  }
  /**
   * Enables or disables the accessibility system.
   * @param enabled - Whether to enable or disable accessibility.
   * @example
   * ```js
   * app.renderer.accessibility.setAccessibilityEnabled(true); // Enable accessibility
   * app.renderer.accessibility.setAccessibilityEnabled(false); // Disable accessibility
   * ```
   */
  setAccessibilityEnabled(t) {
    t ? this._activate() : this._deactivate();
  }
};
Dh.extension = {
  type: [
    A.WebGLSystem,
    A.WebGPUSystem
  ],
  name: "accessibility"
};
Dh.defaultOptions = {
  /**
   * Whether to enable accessibility features on initialization
   * @default false
   */
  enabledByDefault: !1,
  /**
   * Whether to visually show the accessibility divs for debugging
   * @default false
   */
  debug: !1,
  /**
   * Whether to activate accessibility when tab key is pressed
   * @default true
   */
  activateOnTab: !0,
  /**
   * Whether to deactivate accessibility when mouse moves
   * @default true
   */
  deactivateOnMouseMove: !0
};
let Nb = Dh;
const Hb = {
  accessible: !1,
  accessibleTitle: null,
  accessibleHint: null,
  tabIndex: 0,
  accessibleType: "button",
  accessibleText: null,
  accessiblePointerEvents: "auto",
  accessibleChildren: !0,
  _accessibleActive: !1,
  _accessibleDiv: null,
  _renderId: -1
}, xa = /* @__PURE__ */ Object.create(null), Hc = /* @__PURE__ */ Object.create(null);
function os(s, t) {
  let e = Hc[s];
  return e === void 0 && (xa[t] === void 0 && (xa[t] = 1), Hc[s] = e = xa[t]++), e;
}
let Ds;
function pp() {
  return (!Ds || Ds?.isContextLost()) && (Ds = Y.get().createCanvas().getContext("webgl", {})), Ds;
}
let Os;
function Wb() {
  if (!Os) {
    Os = "mediump";
    const s = pp();
    s && s.getShaderPrecisionFormat && (Os = s.getShaderPrecisionFormat(s.FRAGMENT_SHADER, s.HIGH_FLOAT).precision ? "highp" : "mediump");
  }
  return Os;
}
function Vb(s, t, e) {
  return t ? s : e ? (s = s.replace("out vec4 finalColor;", ""), `

        #ifdef GL_ES // This checks if it is WebGL1
        #define in varying
        #define finalColor gl_FragColor
        #define texture texture2D
        #endif
        ${s}
        `) : `

        #ifdef GL_ES // This checks if it is WebGL1
        #define in attribute
        #define out varying
        #endif
        ${s}
        `;
}
function $b(s, t, e) {
  const r = e ? t.maxSupportedFragmentPrecision : t.maxSupportedVertexPrecision;
  if (s.substring(0, 9) !== "precision") {
    let n = e ? t.requestedFragmentPrecision : t.requestedVertexPrecision;
    return n === "highp" && r !== "highp" && (n = "mediump"), `precision ${n} float;
${s}`;
  } else if (r !== "highp" && s.substring(0, 15) === "precision highp")
    return s.replace("precision highp", "precision mediump");
  return s;
}
function Yb(s, t) {
  return t ? `#version 300 es
${s}` : s;
}
const Xb = {}, jb = {};
function Kb(s, { name: t = "pixi-program" }, e = !0) {
  t = t.replace(/\s+/g, "-"), t += e ? "-fragment" : "-vertex";
  const r = e ? Xb : jb;
  return r[t] ? (r[t]++, t += `-${r[t]}`) : r[t] = 1, s.indexOf("#define SHADER_NAME") !== -1 ? s : `${`#define SHADER_NAME ${t}`}
${s}`;
}
function qb(s, t) {
  return t ? s.replace("#version 300 es", "") : s;
}
const ba = {
  // strips any version headers..
  stripVersion: qb,
  // adds precision string if not already present
  ensurePrecision: $b,
  // add some defines if WebGL1 to make it more compatible with WebGL2 shaders
  addProgramDefines: Vb,
  // add the program name to the shader
  setProgramName: Kb,
  // add the version string to the shader header
  insertVersion: Yb
}, va = /* @__PURE__ */ Object.create(null), _p = class Io {
  /**
   * Creates a shiny new GlProgram. Used by WebGL renderer.
   * @param options - The options for the program.
   */
  constructor(t) {
    t = { ...Io.defaultOptions, ...t };
    const e = t.fragment.indexOf("#version 300 es") !== -1, r = {
      stripVersion: e,
      ensurePrecision: {
        requestedFragmentPrecision: t.preferredFragmentPrecision,
        requestedVertexPrecision: t.preferredVertexPrecision,
        maxSupportedVertexPrecision: "highp",
        maxSupportedFragmentPrecision: Wb()
      },
      setProgramName: {
        name: t.name
      },
      addProgramDefines: e,
      insertVersion: e
    };
    let n = t.fragment, a = t.vertex;
    Object.keys(ba).forEach((l) => {
      const h = r[l];
      n = ba[l](n, h, !0), a = ba[l](a, h, !1);
    }), this.fragment = n, this.vertex = a, this.transformFeedbackVaryings = t.transformFeedbackVaryings, this._key = os(`${this.vertex}:${this.fragment}`, "gl-program");
  }
  /** destroys the program */
  destroy() {
    this.fragment = null, this.vertex = null, this._attributeData = null, this._uniformData = null, this._uniformBlockData = null, this.transformFeedbackVaryings = null;
  }
  /**
   * Helper function that creates a program for a given source.
   * It will check the program cache if the program has already been created.
   * If it has that one will be returned, if not a new one will be created and cached.
   * @param options - The options for the program.
   * @returns A program using the same source
   */
  static from(t) {
    const e = `${t.vertex}:${t.fragment}`;
    return va[e] || (va[e] = new Io(t)), va[e];
  }
};
_p.defaultOptions = {
  preferredVertexPrecision: "highp",
  preferredFragmentPrecision: "mediump"
};
let gr = _p;
const Wc = {
  uint8x2: { size: 2, stride: 2, normalised: !1 },
  uint8x4: { size: 4, stride: 4, normalised: !1 },
  sint8x2: { size: 2, stride: 2, normalised: !1 },
  sint8x4: { size: 4, stride: 4, normalised: !1 },
  unorm8x2: { size: 2, stride: 2, normalised: !0 },
  unorm8x4: { size: 4, stride: 4, normalised: !0 },
  snorm8x2: { size: 2, stride: 2, normalised: !0 },
  snorm8x4: { size: 4, stride: 4, normalised: !0 },
  uint16x2: { size: 2, stride: 4, normalised: !1 },
  uint16x4: { size: 4, stride: 8, normalised: !1 },
  sint16x2: { size: 2, stride: 4, normalised: !1 },
  sint16x4: { size: 4, stride: 8, normalised: !1 },
  unorm16x2: { size: 2, stride: 4, normalised: !0 },
  unorm16x4: { size: 4, stride: 8, normalised: !0 },
  snorm16x2: { size: 2, stride: 4, normalised: !0 },
  snorm16x4: { size: 4, stride: 8, normalised: !0 },
  float16x2: { size: 2, stride: 4, normalised: !1 },
  float16x4: { size: 4, stride: 8, normalised: !1 },
  float32: { size: 1, stride: 4, normalised: !1 },
  float32x2: { size: 2, stride: 8, normalised: !1 },
  float32x3: { size: 3, stride: 12, normalised: !1 },
  float32x4: { size: 4, stride: 16, normalised: !1 },
  uint32: { size: 1, stride: 4, normalised: !1 },
  uint32x2: { size: 2, stride: 8, normalised: !1 },
  uint32x3: { size: 3, stride: 12, normalised: !1 },
  uint32x4: { size: 4, stride: 16, normalised: !1 },
  sint32: { size: 1, stride: 4, normalised: !1 },
  sint32x2: { size: 2, stride: 8, normalised: !1 },
  sint32x3: { size: 3, stride: 12, normalised: !1 },
  sint32x4: { size: 4, stride: 16, normalised: !1 }
};
function ai(s) {
  return Wc[s] ?? Wc.float32;
}
const Zb = {
  f32: "float32",
  "vec2<f32>": "float32x2",
  "vec3<f32>": "float32x3",
  "vec4<f32>": "float32x4",
  vec2f: "float32x2",
  vec3f: "float32x3",
  vec4f: "float32x4",
  i32: "sint32",
  "vec2<i32>": "sint32x2",
  "vec3<i32>": "sint32x3",
  "vec4<i32>": "sint32x4",
  u32: "uint32",
  "vec2<u32>": "uint32x2",
  "vec3<u32>": "uint32x3",
  "vec4<u32>": "uint32x4",
  bool: "uint32",
  "vec2<bool>": "uint32x2",
  "vec3<bool>": "uint32x3",
  "vec4<bool>": "uint32x4"
};
function Qb({ source: s, entryPoint: t }) {
  const e = {}, r = s.indexOf(`fn ${t}`);
  if (r !== -1) {
    const n = s.indexOf("->", r);
    if (n !== -1) {
      const a = s.substring(r, n), l = /@location\((\d+)\)\s+([a-zA-Z0-9_]+)\s*:\s*([a-zA-Z0-9_<>]+)(?:,|\s|$)/g;
      let h;
      for (; (h = l.exec(a)) !== null; ) {
        const u = Zb[h[3]] ?? "float32";
        e[h[2]] = {
          location: parseInt(h[1], 10),
          format: u,
          stride: ai(u).stride,
          offset: 0,
          instance: !1,
          start: 0
        };
      }
    }
  }
  return e;
}
function wa(s) {
  const t = /(^|[^/])@(group|binding)\(\d+\)[^;]+;/g, e = /@group\((\d+)\)/, r = /@binding\((\d+)\)/, n = /var(<[^>]+>)? (\w+)/, a = /:\s*(\w+)/, l = /struct\s+(\w+)\s*{([^}]+)}/g, h = /(\w+)\s*:\s*([\w\<\>]+)/g, u = /struct\s+(\w+)/, f = s.match(t)?.map((m) => ({
    group: parseInt(m.match(e)[1], 10),
    binding: parseInt(m.match(r)[1], 10),
    name: m.match(n)[2],
    isUniform: m.match(n)[1] === "<uniform>",
    type: m.match(a)[1]
  }));
  if (!f)
    return {
      groups: [],
      structs: []
    };
  const p = s.match(l)?.map((m) => {
    const g = m.match(u)[1], x = m.match(h).reduce((o, c) => {
      const [d, _] = c.split(":");
      return o[d.trim()] = _.trim(), o;
    }, {});
    return x ? { name: g, members: x } : null;
  }).filter(({ name: m }) => f.some((g) => g.type === m)) ?? [];
  return {
    groups: f,
    structs: p
  };
}
var Lr = /* @__PURE__ */ ((s) => (s[s.VERTEX = 1] = "VERTEX", s[s.FRAGMENT = 2] = "FRAGMENT", s[s.COMPUTE = 4] = "COMPUTE", s))(Lr || {});
function Jb({ groups: s }) {
  const t = [];
  for (let e = 0; e < s.length; e++) {
    const r = s[e];
    t[r.group] || (t[r.group] = []), r.isUniform ? t[r.group].push({
      binding: r.binding,
      visibility: Lr.VERTEX | Lr.FRAGMENT,
      buffer: {
        type: "uniform"
      }
    }) : r.type === "sampler" ? t[r.group].push({
      binding: r.binding,
      visibility: Lr.FRAGMENT,
      sampler: {
        type: "filtering"
      }
    }) : r.type === "texture_2d" && t[r.group].push({
      binding: r.binding,
      visibility: Lr.FRAGMENT,
      texture: {
        sampleType: "float",
        viewDimension: "2d",
        multisampled: !1
      }
    });
  }
  return t;
}
function tv({ groups: s }) {
  const t = [];
  for (let e = 0; e < s.length; e++) {
    const r = s[e];
    t[r.group] || (t[r.group] = {}), t[r.group][r.name] = r.binding;
  }
  return t;
}
function ev(s, t) {
  const e = /* @__PURE__ */ new Set(), r = /* @__PURE__ */ new Set(), n = [...s.structs, ...t.structs].filter((l) => e.has(l.name) ? !1 : (e.add(l.name), !0)), a = [...s.groups, ...t.groups].filter((l) => {
    const h = `${l.name}-${l.binding}`;
    return r.has(h) ? !1 : (r.add(h), !0);
  });
  return { structs: n, groups: a };
}
const Sa = /* @__PURE__ */ Object.create(null);
class Di {
  /**
   * Create a new GpuProgram
   * @param options - The options for the gpu program
   */
  constructor(t) {
    this._layoutKey = 0, this._attributeLocationsKey = 0;
    const { fragment: e, vertex: r, layout: n, gpuLayout: a, name: l } = t;
    if (this.name = l, this.fragment = e, this.vertex = r, e.source === r.source) {
      const h = wa(e.source);
      this.structsAndGroups = h;
    } else {
      const h = wa(r.source), u = wa(e.source);
      this.structsAndGroups = ev(h, u);
    }
    this.layout = n ?? tv(this.structsAndGroups), this.gpuLayout = a ?? Jb(this.structsAndGroups), this.autoAssignGlobalUniforms = this.layout[0]?.globalUniforms !== void 0, this.autoAssignLocalUniforms = this.layout[1]?.localUniforms !== void 0, this._generateProgramKey();
  }
  // TODO maker this pure
  _generateProgramKey() {
    const { vertex: t, fragment: e } = this, r = t.source + e.source + t.entryPoint + e.entryPoint;
    this._layoutKey = os(r, "program");
  }
  get attributeData() {
    return this._attributeData ?? (this._attributeData = Qb(this.vertex)), this._attributeData;
  }
  /** destroys the program */
  destroy() {
    this.gpuLayout = null, this.layout = null, this.structsAndGroups = null, this.fragment = null, this.vertex = null;
  }
  /**
   * Helper function that creates a program for a given source.
   * It will check the program cache if the program has already been created.
   * If it has that one will be returned, if not a new one will be created and cached.
   * @param options - The options for the program.
   * @returns A program using the same source
   */
  static from(t) {
    const e = `${t.vertex.source}:${t.fragment.source}:${t.fragment.entryPoint}:${t.vertex.entryPoint}`;
    return Sa[e] || (Sa[e] = new Di(t)), Sa[e];
  }
}
const mp = [
  "f32",
  "i32",
  "vec2<f32>",
  "vec3<f32>",
  "vec4<f32>",
  "mat2x2<f32>",
  "mat3x3<f32>",
  "mat4x4<f32>",
  "mat3x2<f32>",
  "mat4x2<f32>",
  "mat2x3<f32>",
  "mat4x3<f32>",
  "mat2x4<f32>",
  "mat3x4<f32>",
  "vec2<i32>",
  "vec3<i32>",
  "vec4<i32>"
], iv = mp.reduce((s, t) => (s[t] = !0, s), {});
function rv(s, t) {
  switch (s) {
    case "f32":
      return 0;
    case "vec2<f32>":
      return new Float32Array(2 * t);
    case "vec3<f32>":
      return new Float32Array(3 * t);
    case "vec4<f32>":
      return new Float32Array(4 * t);
    case "mat2x2<f32>":
      return new Float32Array([
        1,
        0,
        0,
        1
      ]);
    case "mat3x3<f32>":
      return new Float32Array([
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1
      ]);
    case "mat4x4<f32>":
      return new Float32Array([
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1
      ]);
  }
  return null;
}
const gp = class yp {
  /**
   * Create a new Uniform group
   * @param uniformStructures - The structures of the uniform group
   * @param options - The optional parameters of this uniform group
   */
  constructor(t, e) {
    this._touched = 0, this.uid = rt("uniform"), this._resourceType = "uniformGroup", this._resourceId = rt("resource"), this.isUniformGroup = !0, this._dirtyId = 0, this.destroyed = !1, e = { ...yp.defaultOptions, ...e }, this.uniformStructures = t;
    const r = {};
    for (const n in t) {
      const a = t[n];
      if (a.name = n, a.size = a.size ?? 1, !iv[a.type])
        throw new Error(`Uniform type ${a.type} is not supported. Supported uniform types are: ${mp.join(", ")}`);
      a.value ?? (a.value = rv(a.type, a.size)), r[n] = a.value;
    }
    this.uniforms = r, this._dirtyId = 1, this.ubo = e.ubo, this.isStatic = e.isStatic, this._signature = os(Object.keys(r).map(
      (n) => `${n}-${t[n].type}`
    ).join("-"), "uniform-group");
  }
  /** Call this if you want the uniform groups data to be uploaded to the GPU only useful if `isStatic` is true. */
  update() {
    this._dirtyId++;
  }
};
gp.defaultOptions = {
  /** if true the UniformGroup is handled as an Uniform buffer object. */
  ubo: !1,
  /** if true, then you are responsible for when the data is uploaded to the GPU by calling `update()` */
  isStatic: !1
};
let kt = gp;
class He {
  /**
   * Create a new instance eof the Bind Group.
   * @param resources - The resources that are bound together for use by a shader.
   */
  constructor(t) {
    this.resources = /* @__PURE__ */ Object.create(null), this._dirty = !0;
    let e = 0;
    for (const r in t) {
      const n = t[r];
      this.setResource(n, e++);
    }
    this._updateKey();
  }
  /**
   * Updates the key if its flagged as dirty. This is used internally to
   * match this bind group to a WebGPU BindGroup.
   * @internal
   */
  _updateKey() {
    if (!this._dirty)
      return;
    this._dirty = !1;
    const t = [];
    let e = 0;
    for (const r in this.resources)
      t[e++] = this.resources[r]._resourceId;
    this._key = t.join("|");
  }
  /**
   * Set a resource at a given index. this function will
   * ensure that listeners will be removed from the current resource
   * and added to the new resource.
   * @param resource - The resource to set.
   * @param index - The index to set the resource at.
   */
  setResource(t, e) {
    const r = this.resources[e];
    t !== r && (r && t.off?.("change", this.onResourceChange, this), t.on?.("change", this.onResourceChange, this), this.resources[e] = t, this._dirty = !0);
  }
  /**
   * Returns the resource at the current specified index.
   * @param index - The index of the resource to get.
   * @returns - The resource at the specified index.
   */
  getResource(t) {
    return this.resources[t];
  }
  /**
   * Used internally to 'touch' each resource, to ensure that the GC
   * knows that all resources in this bind group are still being used.
   * @param tick - The current tick.
   * @internal
   */
  _touch(t) {
    const e = this.resources;
    for (const r in e)
      e[r]._touched = t;
  }
  /** Destroys this bind group and removes all listeners. */
  destroy() {
    const t = this.resources;
    for (const e in t)
      t[e].off?.("change", this.onResourceChange, this);
    this.resources = null;
  }
  onResourceChange(t) {
    if (this._dirty = !0, t.destroyed) {
      const e = this.resources;
      for (const r in e)
        e[r] === t && (e[r] = null);
    } else
      this._updateKey();
  }
}
var ge = /* @__PURE__ */ ((s) => (s[s.WEBGL = 1] = "WEBGL", s[s.WEBGPU = 2] = "WEBGPU", s[s.BOTH = 3] = "BOTH", s))(ge || {});
class ue extends te {
  constructor(t) {
    super(), this.uid = rt("shader"), this._uniformBindMap = /* @__PURE__ */ Object.create(null), this._ownedBindGroups = [];
    let {
      gpuProgram: e,
      glProgram: r,
      groups: n,
      resources: a,
      compatibleRenderers: l,
      groupMap: h
    } = t;
    this.gpuProgram = e, this.glProgram = r, l === void 0 && (l = 0, e && (l |= ge.WEBGPU), r && (l |= ge.WEBGL)), this.compatibleRenderers = l;
    const u = {};
    if (!a && !n && (a = {}), a && n)
      throw new Error("[Shader] Cannot have both resources and groups");
    if (!e && n && !h)
      throw new Error("[Shader] No group map or WebGPU shader provided - consider using resources instead.");
    if (!e && n && h)
      for (const f in h)
        for (const p in h[f]) {
          const m = h[f][p];
          u[m] = {
            group: f,
            binding: p,
            name: m
          };
        }
    else if (e && n && !h) {
      const f = e.structsAndGroups.groups;
      h = {}, f.forEach((p) => {
        h[p.group] = h[p.group] || {}, h[p.group][p.binding] = p.name, u[p.name] = p;
      });
    } else if (a) {
      n = {}, h = {}, e && e.structsAndGroups.groups.forEach((m) => {
        h[m.group] = h[m.group] || {}, h[m.group][m.binding] = m.name, u[m.name] = m;
      });
      let f = 0;
      for (const p in a)
        u[p] || (n[99] || (n[99] = new He(), this._ownedBindGroups.push(n[99])), u[p] = { group: 99, binding: f, name: p }, h[99] = h[99] || {}, h[99][f] = p, f++);
      for (const p in a) {
        const m = p;
        let g = a[p];
        !g.source && !g._resourceType && (g = new kt(g));
        const x = u[m];
        x && (n[x.group] || (n[x.group] = new He(), this._ownedBindGroups.push(n[x.group])), n[x.group].setResource(g, x.binding));
      }
    }
    this.groups = n, this._uniformBindMap = h, this.resources = this._buildResourceAccessor(n, u);
  }
  /**
   * Sometimes a resource group will be provided later (for example global uniforms)
   * In such cases, this method can be used to let the shader know about the group.
   * @param name - the name of the resource group
   * @param groupIndex - the index of the group (should match the webGPU shader group location)
   * @param bindIndex - the index of the bind point (should match the webGPU shader bind point)
   */
  addResource(t, e, r) {
    var n, a;
    (n = this._uniformBindMap)[e] || (n[e] = {}), (a = this._uniformBindMap[e])[r] || (a[r] = t), this.groups[e] || (this.groups[e] = new He(), this._ownedBindGroups.push(this.groups[e]));
  }
  _buildResourceAccessor(t, e) {
    const r = {};
    for (const n in e) {
      const a = e[n];
      Object.defineProperty(r, a.name, {
        get() {
          return t[a.group].getResource(a.binding);
        },
        set(l) {
          t[a.group].setResource(l, a.binding);
        }
      });
    }
    return r;
  }
  /**
   * Use to destroy the shader when its not longer needed.
   * It will destroy the resources and remove listeners.
   * @param destroyPrograms - if the programs should be destroyed as well.
   * Make sure its not being used by other shaders!
   */
  destroy(t = !1) {
    this.emit("destroy", this), t && (this.gpuProgram?.destroy(), this.glProgram?.destroy()), this.gpuProgram = null, this.glProgram = null, this.removeAllListeners(), this._uniformBindMap = null, this._ownedBindGroups.forEach((e) => {
      e.destroy();
    }), this._ownedBindGroups = null, this.resources = null, this.groups = null;
  }
  static from(t) {
    const { gpu: e, gl: r, ...n } = t;
    let a, l;
    return e && (a = Di.from(e)), r && (l = gr.from(r)), new ue({
      gpuProgram: a,
      glProgram: l,
      ...n
    });
  }
}
const sv = {
  normal: 0,
  add: 1,
  multiply: 2,
  screen: 3,
  overlay: 4,
  erase: 5,
  "normal-npm": 6,
  "add-npm": 7,
  "screen-npm": 8,
  min: 9,
  max: 10
}, Ta = 0, Ca = 1, Ea = 2, Aa = 3, Pa = 4, Ma = 5, ko = class xp {
  constructor() {
    this.data = 0, this.blendMode = "normal", this.polygonOffset = 0, this.blend = !0, this.depthMask = !0;
  }
  /**
   * Activates blending of the computed fragment color values.
   * @default true
   */
  get blend() {
    return !!(this.data & 1 << Ta);
  }
  set blend(t) {
    !!(this.data & 1 << Ta) !== t && (this.data ^= 1 << Ta);
  }
  /**
   * Activates adding an offset to depth values of polygon's fragments
   * @default false
   */
  get offsets() {
    return !!(this.data & 1 << Ca);
  }
  set offsets(t) {
    !!(this.data & 1 << Ca) !== t && (this.data ^= 1 << Ca);
  }
  /** The culling settings for this state none - No culling back - Back face culling front - Front face culling */
  set cullMode(t) {
    if (t === "none") {
      this.culling = !1;
      return;
    }
    this.culling = !0, this.clockwiseFrontFace = t === "front";
  }
  get cullMode() {
    return this.culling ? this.clockwiseFrontFace ? "front" : "back" : "none";
  }
  /**
   * Activates culling of polygons.
   * @default false
   */
  get culling() {
    return !!(this.data & 1 << Ea);
  }
  set culling(t) {
    !!(this.data & 1 << Ea) !== t && (this.data ^= 1 << Ea);
  }
  /**
   * Activates depth comparisons and updates to the depth buffer.
   * @default false
   */
  get depthTest() {
    return !!(this.data & 1 << Aa);
  }
  set depthTest(t) {
    !!(this.data & 1 << Aa) !== t && (this.data ^= 1 << Aa);
  }
  /**
   * Enables or disables writing to the depth buffer.
   * @default true
   */
  get depthMask() {
    return !!(this.data & 1 << Ma);
  }
  set depthMask(t) {
    !!(this.data & 1 << Ma) !== t && (this.data ^= 1 << Ma);
  }
  /**
   * Specifies whether or not front or back-facing polygons can be culled.
   * @default false
   */
  get clockwiseFrontFace() {
    return !!(this.data & 1 << Pa);
  }
  set clockwiseFrontFace(t) {
    !!(this.data & 1 << Pa) !== t && (this.data ^= 1 << Pa);
  }
  /**
   * The blend mode to be applied when this state is set. Apply a value of `normal` to reset the blend mode.
   * Setting this mode to anything other than NO_BLEND will automatically switch blending on.
   * @default 'normal'
   */
  get blendMode() {
    return this._blendMode;
  }
  set blendMode(t) {
    this.blend = t !== "none", this._blendMode = t, this._blendModeId = sv[t] || 0;
  }
  /**
   * The polygon offset. Setting this property to anything other than 0 will automatically enable polygon offset fill.
   * @default 0
   */
  get polygonOffset() {
    return this._polygonOffset;
  }
  set polygonOffset(t) {
    this.offsets = !!t, this._polygonOffset = t;
  }
  toString() {
    return `[pixi.js/core:State blendMode=${this.blendMode} clockwiseFrontFace=${this.clockwiseFrontFace} culling=${this.culling} depthMask=${this.depthMask} polygonOffset=${this.polygonOffset}]`;
  }
  /**
   * A quickly getting an instance of a State that is configured for 2d rendering.
   * @returns a new State with values set for 2d rendering
   */
  static for2d() {
    const t = new xp();
    return t.depthTest = !1, t.blend = !0, t;
  }
};
ko.default2d = ko.for2d();
let ye = ko;
const bp = class Fo extends ue {
  /**
   * @param options - The optional parameters of this filter.
   */
  constructor(t) {
    t = { ...Fo.defaultOptions, ...t }, super(t), this.enabled = !0, this._state = ye.for2d(), this.blendMode = t.blendMode, this.padding = t.padding, typeof t.antialias == "boolean" ? this.antialias = t.antialias ? "on" : "off" : this.antialias = t.antialias, this.resolution = t.resolution, this.blendRequired = t.blendRequired, this.clipToViewport = t.clipToViewport, this.addResource("uTexture", 0, 1);
  }
  /**
   * Applies the filter
   * @param filterManager - The renderer to retrieve the filter from
   * @param input - The input render target.
   * @param output - The target to output to.
   * @param clearMode - Should the output be cleared before rendering to it
   */
  apply(t, e, r, n) {
    t.applyFilter(this, e, r, n);
  }
  /**
   * Get the blend mode of the filter.
   * @default "normal"
   */
  get blendMode() {
    return this._state.blendMode;
  }
  /** Sets the blend mode of the filter. */
  set blendMode(t) {
    this._state.blendMode = t;
  }
  /**
   * A short hand function to create a filter based of a vertex and fragment shader src.
   * @param options
   * @returns A shiny new PixiJS filter!
   */
  static from(t) {
    const { gpu: e, gl: r, ...n } = t;
    let a, l;
    return e && (a = Di.from(e)), r && (l = gr.from(r)), new Fo({
      gpuProgram: a,
      glProgram: l,
      ...n
    });
  }
};
bp.defaultOptions = {
  blendMode: "normal",
  resolution: 1,
  padding: 0,
  antialias: "off",
  blendRequired: !1,
  clipToViewport: !0
};
let nv = bp;
const Do = [];
L.handleByNamedList(A.Environment, Do);
async function av(s) {
  if (!s)
    for (let t = 0; t < Do.length; t++) {
      const e = Do[t];
      if (e.value.test()) {
        await e.value.load();
        return;
      }
    }
}
let Cr;
function vp() {
  if (typeof Cr == "boolean")
    return Cr;
  try {
    Cr = new Function("param1", "param2", "param3", "return param1[param2] === param3;")({ a: "b" }, "a", "b") === !0;
  } catch {
    Cr = !1;
  }
  return Cr;
}
function Vc(s, t, e = 2) {
  const r = t && t.length, n = r ? t[0] * e : s.length;
  let a = wp(s, 0, n, e, !0);
  const l = [];
  if (!a || a.next === a.prev) return l;
  let h, u, f;
  if (r && (a = uv(s, t, a, e)), s.length > 80 * e) {
    h = 1 / 0, u = 1 / 0;
    let p = -1 / 0, m = -1 / 0;
    for (let g = e; g < n; g += e) {
      const x = s[g], o = s[g + 1];
      x < h && (h = x), o < u && (u = o), x > p && (p = x), o > m && (m = o);
    }
    f = Math.max(p - h, m - u), f = f !== 0 ? 32767 / f : 0;
  }
  return hs(a, l, e, h, u, f, 0), l;
}
function wp(s, t, e, r, n) {
  let a;
  if (n === wv(s, t, e, r) > 0)
    for (let l = t; l < e; l += r) a = $c(l / r | 0, s[l], s[l + 1], a);
  else
    for (let l = e - r; l >= t; l -= r) a = $c(l / r | 0, s[l], s[l + 1], a);
  return a && cr(a, a.next) && (cs(a), a = a.next), a;
}
function ki(s, t) {
  if (!s) return s;
  t || (t = s);
  let e = s, r;
  do
    if (r = !1, !e.steiner && (cr(e, e.next) || lt(e.prev, e, e.next) === 0)) {
      if (cs(e), e = t = e.prev, e === e.next) break;
      r = !0;
    } else
      e = e.next;
  while (r || e !== t);
  return t;
}
function hs(s, t, e, r, n, a, l) {
  if (!s) return;
  !l && a && mv(s, r, n, a);
  let h = s;
  for (; s.prev !== s.next; ) {
    const u = s.prev, f = s.next;
    if (a ? hv(s, r, n, a) : ov(s)) {
      t.push(u.i, s.i, f.i), cs(s), s = f.next, h = f.next;
      continue;
    }
    if (s = f, s === h) {
      l ? l === 1 ? (s = lv(ki(s), t), hs(s, t, e, r, n, a, 2)) : l === 2 && cv(s, t, e, r, n, a) : hs(ki(s), t, e, r, n, a, 1);
      break;
    }
  }
}
function ov(s) {
  const t = s.prev, e = s, r = s.next;
  if (lt(t, e, r) >= 0) return !1;
  const n = t.x, a = e.x, l = r.x, h = t.y, u = e.y, f = r.y, p = Math.min(n, a, l), m = Math.min(h, u, f), g = Math.max(n, a, l), x = Math.max(h, u, f);
  let o = r.next;
  for (; o !== t; ) {
    if (o.x >= p && o.x <= g && o.y >= m && o.y <= x && Gr(n, h, a, u, l, f, o.x, o.y) && lt(o.prev, o, o.next) >= 0) return !1;
    o = o.next;
  }
  return !0;
}
function hv(s, t, e, r) {
  const n = s.prev, a = s, l = s.next;
  if (lt(n, a, l) >= 0) return !1;
  const h = n.x, u = a.x, f = l.x, p = n.y, m = a.y, g = l.y, x = Math.min(h, u, f), o = Math.min(p, m, g), c = Math.max(h, u, f), d = Math.max(p, m, g), _ = Oo(x, o, t, e, r), y = Oo(c, d, t, e, r);
  let v = s.prevZ, b = s.nextZ;
  for (; v && v.z >= _ && b && b.z <= y; ) {
    if (v.x >= x && v.x <= c && v.y >= o && v.y <= d && v !== n && v !== l && Gr(h, p, u, m, f, g, v.x, v.y) && lt(v.prev, v, v.next) >= 0 || (v = v.prevZ, b.x >= x && b.x <= c && b.y >= o && b.y <= d && b !== n && b !== l && Gr(h, p, u, m, f, g, b.x, b.y) && lt(b.prev, b, b.next) >= 0)) return !1;
    b = b.nextZ;
  }
  for (; v && v.z >= _; ) {
    if (v.x >= x && v.x <= c && v.y >= o && v.y <= d && v !== n && v !== l && Gr(h, p, u, m, f, g, v.x, v.y) && lt(v.prev, v, v.next) >= 0) return !1;
    v = v.prevZ;
  }
  for (; b && b.z <= y; ) {
    if (b.x >= x && b.x <= c && b.y >= o && b.y <= d && b !== n && b !== l && Gr(h, p, u, m, f, g, b.x, b.y) && lt(b.prev, b, b.next) >= 0) return !1;
    b = b.nextZ;
  }
  return !0;
}
function lv(s, t) {
  let e = s;
  do {
    const r = e.prev, n = e.next.next;
    !cr(r, n) && Tp(r, e, e.next, n) && ls(r, n) && ls(n, r) && (t.push(r.i, e.i, n.i), cs(e), cs(e.next), e = s = n), e = e.next;
  } while (e !== s);
  return ki(e);
}
function cv(s, t, e, r, n, a) {
  let l = s;
  do {
    let h = l.next.next;
    for (; h !== l.prev; ) {
      if (l.i !== h.i && xv(l, h)) {
        let u = Cp(l, h);
        l = ki(l, l.next), u = ki(u, u.next), hs(l, t, e, r, n, a, 0), hs(u, t, e, r, n, a, 0);
        return;
      }
      h = h.next;
    }
    l = l.next;
  } while (l !== s);
}
function uv(s, t, e, r) {
  const n = [];
  for (let a = 0, l = t.length; a < l; a++) {
    const h = t[a] * r, u = a < l - 1 ? t[a + 1] * r : s.length, f = wp(s, h, u, r, !1);
    f === f.next && (f.steiner = !0), n.push(yv(f));
  }
  n.sort(dv);
  for (let a = 0; a < n.length; a++)
    e = fv(n[a], e);
  return e;
}
function dv(s, t) {
  let e = s.x - t.x;
  if (e === 0 && (e = s.y - t.y, e === 0)) {
    const r = (s.next.y - s.y) / (s.next.x - s.x), n = (t.next.y - t.y) / (t.next.x - t.x);
    e = r - n;
  }
  return e;
}
function fv(s, t) {
  const e = pv(s, t);
  if (!e)
    return t;
  const r = Cp(e, s);
  return ki(r, r.next), ki(e, e.next);
}
function pv(s, t) {
  let e = t;
  const r = s.x, n = s.y;
  let a = -1 / 0, l;
  if (cr(s, e)) return e;
  do {
    if (cr(s, e.next)) return e.next;
    if (n <= e.y && n >= e.next.y && e.next.y !== e.y) {
      const m = e.x + (n - e.y) * (e.next.x - e.x) / (e.next.y - e.y);
      if (m <= r && m > a && (a = m, l = e.x < e.next.x ? e : e.next, m === r))
        return l;
    }
    e = e.next;
  } while (e !== t);
  if (!l) return null;
  const h = l, u = l.x, f = l.y;
  let p = 1 / 0;
  e = l;
  do {
    if (r >= e.x && e.x >= u && r !== e.x && Sp(n < f ? r : a, n, u, f, n < f ? a : r, n, e.x, e.y)) {
      const m = Math.abs(n - e.y) / (r - e.x);
      ls(e, s) && (m < p || m === p && (e.x > l.x || e.x === l.x && _v(l, e))) && (l = e, p = m);
    }
    e = e.next;
  } while (e !== h);
  return l;
}
function _v(s, t) {
  return lt(s.prev, s, t.prev) < 0 && lt(t.next, s, s.next) < 0;
}
function mv(s, t, e, r) {
  let n = s;
  do
    n.z === 0 && (n.z = Oo(n.x, n.y, t, e, r)), n.prevZ = n.prev, n.nextZ = n.next, n = n.next;
  while (n !== s);
  n.prevZ.nextZ = null, n.prevZ = null, gv(n);
}
function gv(s) {
  let t, e = 1;
  do {
    let r = s, n;
    s = null;
    let a = null;
    for (t = 0; r; ) {
      t++;
      let l = r, h = 0;
      for (let f = 0; f < e && (h++, l = l.nextZ, !!l); f++)
        ;
      let u = e;
      for (; h > 0 || u > 0 && l; )
        h !== 0 && (u === 0 || !l || r.z <= l.z) ? (n = r, r = r.nextZ, h--) : (n = l, l = l.nextZ, u--), a ? a.nextZ = n : s = n, n.prevZ = a, a = n;
      r = l;
    }
    a.nextZ = null, e *= 2;
  } while (t > 1);
  return s;
}
function Oo(s, t, e, r, n) {
  return s = (s - e) * n | 0, t = (t - r) * n | 0, s = (s | s << 8) & 16711935, s = (s | s << 4) & 252645135, s = (s | s << 2) & 858993459, s = (s | s << 1) & 1431655765, t = (t | t << 8) & 16711935, t = (t | t << 4) & 252645135, t = (t | t << 2) & 858993459, t = (t | t << 1) & 1431655765, s | t << 1;
}
function yv(s) {
  let t = s, e = s;
  do
    (t.x < e.x || t.x === e.x && t.y < e.y) && (e = t), t = t.next;
  while (t !== s);
  return e;
}
function Sp(s, t, e, r, n, a, l, h) {
  return (n - l) * (t - h) >= (s - l) * (a - h) && (s - l) * (r - h) >= (e - l) * (t - h) && (e - l) * (a - h) >= (n - l) * (r - h);
}
function Gr(s, t, e, r, n, a, l, h) {
  return !(s === l && t === h) && Sp(s, t, e, r, n, a, l, h);
}
function xv(s, t) {
  return s.next.i !== t.i && s.prev.i !== t.i && !bv(s, t) && // dones't intersect other edges
  (ls(s, t) && ls(t, s) && vv(s, t) && // locally visible
  (lt(s.prev, s, t.prev) || lt(s, t.prev, t)) || // does not create opposite-facing sectors
  cr(s, t) && lt(s.prev, s, s.next) > 0 && lt(t.prev, t, t.next) > 0);
}
function lt(s, t, e) {
  return (t.y - s.y) * (e.x - t.x) - (t.x - s.x) * (e.y - t.y);
}
function cr(s, t) {
  return s.x === t.x && s.y === t.y;
}
function Tp(s, t, e, r) {
  const n = Gs(lt(s, t, e)), a = Gs(lt(s, t, r)), l = Gs(lt(e, r, s)), h = Gs(lt(e, r, t));
  return !!(n !== a && l !== h || n === 0 && Ls(s, e, t) || a === 0 && Ls(s, r, t) || l === 0 && Ls(e, s, r) || h === 0 && Ls(e, t, r));
}
function Ls(s, t, e) {
  return t.x <= Math.max(s.x, e.x) && t.x >= Math.min(s.x, e.x) && t.y <= Math.max(s.y, e.y) && t.y >= Math.min(s.y, e.y);
}
function Gs(s) {
  return s > 0 ? 1 : s < 0 ? -1 : 0;
}
function bv(s, t) {
  let e = s;
  do {
    if (e.i !== s.i && e.next.i !== s.i && e.i !== t.i && e.next.i !== t.i && Tp(e, e.next, s, t)) return !0;
    e = e.next;
  } while (e !== s);
  return !1;
}
function ls(s, t) {
  return lt(s.prev, s, s.next) < 0 ? lt(s, t, s.next) >= 0 && lt(s, s.prev, t) >= 0 : lt(s, t, s.prev) < 0 || lt(s, s.next, t) < 0;
}
function vv(s, t) {
  let e = s, r = !1;
  const n = (s.x + t.x) / 2, a = (s.y + t.y) / 2;
  do
    e.y > a != e.next.y > a && e.next.y !== e.y && n < (e.next.x - e.x) * (a - e.y) / (e.next.y - e.y) + e.x && (r = !r), e = e.next;
  while (e !== s);
  return r;
}
function Cp(s, t) {
  const e = Lo(s.i, s.x, s.y), r = Lo(t.i, t.x, t.y), n = s.next, a = t.prev;
  return s.next = t, t.prev = s, e.next = n, n.prev = e, r.next = e, e.prev = r, a.next = r, r.prev = a, r;
}
function $c(s, t, e, r) {
  const n = Lo(s, t, e);
  return r ? (n.next = r.next, n.prev = r, r.next.prev = n, r.next = n) : (n.prev = n, n.next = n), n;
}
function cs(s) {
  s.next.prev = s.prev, s.prev.next = s.next, s.prevZ && (s.prevZ.nextZ = s.nextZ), s.nextZ && (s.nextZ.prevZ = s.prevZ);
}
function Lo(s, t, e) {
  return {
    i: s,
    // vertex index in coordinates array
    x: t,
    y: e,
    // vertex coordinates
    prev: null,
    // previous and next vertex nodes in a polygon ring
    next: null,
    z: 0,
    // z-order curve value
    prevZ: null,
    // previous and next nodes in z-order
    nextZ: null,
    steiner: !1
    // indicates whether this is a steiner point
  };
}
function wv(s, t, e, r) {
  let n = 0;
  for (let a = t, l = e - r; a < e; a += r)
    n += (s[l] - s[a]) * (s[a + 1] + s[l + 1]), l = a;
  return n;
}
const Sv = Vc.default || Vc;
var Xt = /* @__PURE__ */ ((s) => (s[s.NONE = 0] = "NONE", s[s.COLOR = 16384] = "COLOR", s[s.STENCIL = 1024] = "STENCIL", s[s.DEPTH = 256] = "DEPTH", s[s.COLOR_DEPTH = 16640] = "COLOR_DEPTH", s[s.COLOR_STENCIL = 17408] = "COLOR_STENCIL", s[s.DEPTH_STENCIL = 1280] = "DEPTH_STENCIL", s[s.ALL = 17664] = "ALL", s))(Xt || {});
class Ep {
  /**
   * @param name - The function name that will be executed on the listeners added to this Runner.
   */
  constructor(t) {
    this.items = [], this._name = t;
  }
  /* jsdoc/check-param-names */
  /**
   * Dispatch/Broadcast Runner to all listeners added to the queue.
   * @param {...any} params - (optional) parameters to pass to each listener
   */
  /* jsdoc/check-param-names */
  emit(t, e, r, n, a, l, h, u) {
    const { name: f, items: p } = this;
    for (let m = 0, g = p.length; m < g; m++)
      p[m][f](t, e, r, n, a, l, h, u);
    return this;
  }
  /**
   * Add a listener to the Runner
   *
   * Runners do not need to have scope or functions passed to them.
   * All that is required is to pass the listening object and ensure that it has contains a function that has the same name
   * as the name provided to the Runner when it was created.
   *
   * Eg A listener passed to this Runner will require a 'complete' function.
   *
   * ```ts
   * import { Runner } from 'pixi.js';
   *
   * const complete = new Runner('complete');
   * ```
   *
   * The scope used will be the object itself.
   * @param {any} item - The object that will be listening.
   */
  add(t) {
    return t[this._name] && (this.remove(t), this.items.push(t)), this;
  }
  /**
   * Remove a single listener from the dispatch queue.
   * @param {any} item - The listener that you would like to remove.
   */
  remove(t) {
    const e = this.items.indexOf(t);
    return e !== -1 && this.items.splice(e, 1), this;
  }
  /**
   * Check to see if the listener is already in the Runner
   * @param {any} item - The listener that you would like to check.
   */
  contains(t) {
    return this.items.indexOf(t) !== -1;
  }
  /** Remove all listeners from the Runner */
  removeAll() {
    return this.items.length = 0, this;
  }
  /** Remove all references, don't use after this. */
  destroy() {
    this.removeAll(), this.items = null, this._name = null;
  }
  /**
   * `true` if there are no this Runner contains no listeners
   * @readonly
   */
  get empty() {
    return this.items.length === 0;
  }
  /**
   * The name of the runner.
   * @readonly
   */
  get name() {
    return this._name;
  }
}
const Tv = [
  "init",
  "destroy",
  "contextChange",
  "resolutionChange",
  "resetState",
  "renderEnd",
  "renderStart",
  "render",
  "update",
  "postrender",
  "prerender"
], Ap = class Pp extends te {
  /**
   * Set up a system with a collection of SystemClasses and runners.
   * Systems are attached dynamically to this class when added.
   * @param config - the config for the system manager
   */
  constructor(t) {
    super(), this.uid = rt("renderer"), this.runners = /* @__PURE__ */ Object.create(null), this.renderPipes = /* @__PURE__ */ Object.create(null), this._initOptions = {}, this._systemsHash = /* @__PURE__ */ Object.create(null), this.type = t.type, this.name = t.name, this.config = t;
    const e = [...Tv, ...this.config.runners ?? []];
    this._addRunners(...e), this._unsafeEvalCheck();
  }
  /**
   * Initialize the renderer.
   * @param options - The options to use to create the renderer.
   */
  async init(t = {}) {
    const e = t.skipExtensionImports === !0 ? !0 : t.manageImports === !1;
    await av(e), this._addSystems(this.config.systems), this._addPipes(this.config.renderPipes, this.config.renderPipeAdaptors);
    for (const r in this._systemsHash)
      t = { ...this._systemsHash[r].constructor.defaultOptions, ...t };
    t = { ...Pp.defaultOptions, ...t }, this._roundPixels = t.roundPixels ? 1 : 0;
    for (let r = 0; r < this.runners.init.items.length; r++)
      await this.runners.init.items[r].init(t);
    this._initOptions = t;
  }
  render(t, e) {
    let r = t;
    if (r instanceof St && (r = { container: r }, e && (W(K, "passing a second argument is deprecated, please use render options instead"), r.target = e.renderTexture)), r.target || (r.target = this.view.renderTarget), r.target === this.view.renderTarget && (this._lastObjectRendered = r.container, r.clearColor ?? (r.clearColor = this.background.colorRgba), r.clear ?? (r.clear = this.background.clearBeforeRender)), r.clearColor) {
      const n = Array.isArray(r.clearColor) && r.clearColor.length === 4;
      r.clearColor = n ? r.clearColor : Q.shared.setValue(r.clearColor).toArray();
    }
    r.transform || (r.container.updateLocalTransform(), r.transform = r.container.localTransform), r.container.enableRenderGroup(), this.runners.prerender.emit(r), this.runners.renderStart.emit(r), this.runners.render.emit(r), this.runners.renderEnd.emit(r), this.runners.postrender.emit(r);
  }
  /**
   * Resizes the WebGL view to the specified width and height.
   * @param desiredScreenWidth - The desired width of the screen.
   * @param desiredScreenHeight - The desired height of the screen.
   * @param resolution - The resolution / device pixel ratio of the renderer.
   */
  resize(t, e, r) {
    const n = this.view.resolution;
    this.view.resize(t, e, r), this.emit("resize", this.view.screen.width, this.view.screen.height, this.view.resolution), r !== void 0 && r !== n && this.runners.resolutionChange.emit(r);
  }
  /**
   * Clears the render target.
   * @param options - The options to use when clearing the render target.
   * @param options.target - The render target to clear.
   * @param options.clearColor - The color to clear with.
   * @param options.clear - The clear mode to use.
   * @advanced
   */
  clear(t = {}) {
    const e = this;
    t.target || (t.target = e.renderTarget.renderTarget), t.clearColor || (t.clearColor = this.background.colorRgba), t.clear ?? (t.clear = Xt.ALL);
    const { clear: r, clearColor: n, target: a } = t;
    Q.shared.setValue(n ?? this.background.colorRgba), e.renderTarget.clear(a, r, Q.shared.toArray());
  }
  /** The resolution / device pixel ratio of the renderer. */
  get resolution() {
    return this.view.resolution;
  }
  set resolution(t) {
    this.view.resolution = t, this.runners.resolutionChange.emit(t);
  }
  /**
   * Same as view.width, actual number of pixels in the canvas by horizontal.
   * @type {number}
   * @readonly
   * @default 800
   */
  get width() {
    return this.view.texture.frame.width;
  }
  /**
   * Same as view.height, actual number of pixels in the canvas by vertical.
   * @default 600
   */
  get height() {
    return this.view.texture.frame.height;
  }
  // NOTE: this was `view` in v7
  /**
   * The canvas element that everything is drawn to.
   * @type {environment.ICanvas}
   */
  get canvas() {
    return this.view.canvas;
  }
  /**
   * the last object rendered by the renderer. Useful for other plugins like interaction managers
   * @readonly
   */
  get lastObjectRendered() {
    return this._lastObjectRendered;
  }
  /**
   * Flag if we are rendering to the screen vs renderTexture
   * @readonly
   * @default true
   */
  get renderingToScreen() {
    return this.renderTarget.renderingToScreen;
  }
  /**
   * Measurements of the screen. (0, 0, screenWidth, screenHeight).
   *
   * Its safe to use as filterArea or hitArea for the whole stage.
   */
  get screen() {
    return this.view.screen;
  }
  /**
   * Create a bunch of runners based of a collection of ids
   * @param runnerIds - the runner ids to add
   */
  _addRunners(...t) {
    t.forEach((e) => {
      this.runners[e] = new Ep(e);
    });
  }
  _addSystems(t) {
    let e;
    for (e in t) {
      const r = t[e];
      this._addSystem(r.value, r.name);
    }
  }
  /**
   * Add a new system to the renderer.
   * @param ClassRef - Class reference
   * @param name - Property name for system, if not specified
   *        will use a static `name` property on the class itself. This
   *        name will be assigned as s property on the Renderer so make
   *        sure it doesn't collide with properties on Renderer.
   * @returns Return instance of renderer
   */
  _addSystem(t, e) {
    const r = new t(this);
    if (this[e])
      throw new Error(`Whoops! The name "${e}" is already in use`);
    this[e] = r, this._systemsHash[e] = r;
    for (const n in this.runners)
      this.runners[n].add(r);
    return this;
  }
  _addPipes(t, e) {
    const r = e.reduce((n, a) => (n[a.name] = a.value, n), {});
    t.forEach((n) => {
      const a = n.value, l = n.name, h = r[l];
      this.renderPipes[l] = new a(
        this,
        h ? new h() : null
      );
    });
  }
  destroy(t = !1) {
    this.runners.destroy.items.reverse(), this.runners.destroy.emit(t), Object.values(this.runners).forEach((e) => {
      e.destroy();
    }), this._systemsHash = null, this.renderPipes = null;
  }
  /**
   * Generate a texture from a container.
   * @param options - options or container target to use when generating the texture
   * @returns a texture
   */
  generateTexture(t) {
    return this.textureGenerator.generateTexture(t);
  }
  /**
   * Whether the renderer will round coordinates to whole pixels when rendering.
   * Can be overridden on a per scene item basis.
   */
  get roundPixels() {
    return !!this._roundPixels;
  }
  /**
   * Overridable function by `pixi.js/unsafe-eval` to silence
   * throwing an error if platform doesn't support unsafe-evals.
   * @private
   * @ignore
   */
  _unsafeEvalCheck() {
    if (!vp())
      throw new Error("Current environment does not allow unsafe-eval, please use pixi.js/unsafe-eval module to enable support.");
  }
  /**
   * Resets the rendering state of the renderer.
   * This is useful when you want to use the WebGL context directly and need to ensure PixiJS's internal state
   * stays synchronized. When modifying the WebGL context state externally, calling this method before the next Pixi
   * render will reset all internal caches and ensure it executes correctly.
   *
   * This is particularly useful when combining PixiJS with other rendering engines like Three.js:
   * ```js
   * // Reset Three.js state
   * threeRenderer.resetState();
   *
   * // Render a Three.js scene
   * threeRenderer.render(threeScene, threeCamera);
   *
   * // Reset PixiJS state since Three.js modified the WebGL context
   * pixiRenderer.resetState();
   *
   * // Now render Pixi content
   * pixiRenderer.render(pixiScene);
   * ```
   * @advanced
   */
  resetState() {
    this.runners.resetState.emit();
  }
};
Ap.defaultOptions = {
  /**
   * Default resolution / device pixel ratio of the renderer.
   * @default 1
   */
  resolution: 1,
  /**
   * Should the `failIfMajorPerformanceCaveat` flag be enabled as a context option used in the `isWebGLSupported`
   * function. If set to true, a WebGL renderer can fail to be created if the browser thinks there could be
   * performance issues when using WebGL.
   *
   * In PixiJS v6 this has changed from true to false by default, to allow WebGL to work in as many
   * scenarios as possible. However, some users may have a poor experience, for example, if a user has a gpu or
   * driver version blacklisted by the
   * browser.
   *
   * If your application requires high performance rendering, you may wish to set this to false.
   * We recommend one of two options if you decide to set this flag to false:
   *
   * 1: Use the Canvas renderer as a fallback in case high performance WebGL is
   *    not supported.
   *
   * 2: Call `isWebGLSupported` (which if found in the utils package) in your code before attempting to create a
   *    PixiJS renderer, and show an error message to the user if the function returns false, explaining that their
   *    device & browser combination does not support high performance WebGL.
   *    This is a much better strategy than trying to create a PixiJS renderer and finding it then fails.
   * @default false
   */
  failIfMajorPerformanceCaveat: !1,
  /**
   * Should round pixels be forced when rendering?
   * @default false
   */
  roundPixels: !1
};
let Hn = Ap, zs;
function Cv(s) {
  return zs !== void 0 || (zs = (() => {
    const t = {
      stencil: !0,
      failIfMajorPerformanceCaveat: s ?? Hn.defaultOptions.failIfMajorPerformanceCaveat
    };
    try {
      if (!Y.get().getWebGLRenderingContext())
        return !1;
      let r = Y.get().createCanvas().getContext("webgl", t);
      const n = !!r?.getContextAttributes()?.stencil;
      if (r) {
        const a = r.getExtension("WEBGL_lose_context");
        a && a.loseContext();
      }
      return r = null, n;
    } catch {
      return !1;
    }
  })()), zs;
}
let Ns;
async function Ev(s = {}) {
  return Ns !== void 0 || (Ns = await (async () => {
    const t = Y.get().getNavigator().gpu;
    if (!t)
      return !1;
    try {
      return await (await t.requestAdapter(s)).requestDevice(), !0;
    } catch {
      return !1;
    }
  })()), Ns;
}
const Yc = ["webgl", "webgpu", "canvas"];
async function Av(s) {
  let t = [];
  s.preference ? (t.push(s.preference), Yc.forEach((a) => {
    a !== s.preference && t.push(a);
  })) : t = Yc.slice();
  let e, r = {};
  for (let a = 0; a < t.length; a++) {
    const l = t[a];
    if (l === "webgpu" && await Ev()) {
      const { WebGPURenderer: h } = await Promise.resolve().then(() => _C);
      e = h, r = { ...s, ...s.webgpu };
      break;
    } else if (l === "webgl" && Cv(
      s.failIfMajorPerformanceCaveat ?? Hn.defaultOptions.failIfMajorPerformanceCaveat
    )) {
      const { WebGLRenderer: h } = await Promise.resolve().then(() => qT);
      e = h, r = { ...s, ...s.webgl };
      break;
    } else if (l === "canvas")
      throw r = { ...s }, new Error("CanvasRenderer is not yet implemented");
  }
  if (delete r.webgpu, delete r.webgl, !e)
    throw new Error("No available renderer for the current environment");
  const n = new e();
  return await n.init(r), n;
}
const En = "8.10.2";
class Mp {
  static init() {
    globalThis.__PIXI_APP_INIT__?.(this, En);
  }
  static destroy() {
  }
}
Mp.extension = A.Application;
class Bp {
  constructor(t) {
    this._renderer = t;
  }
  init() {
    globalThis.__PIXI_RENDERER_INIT__?.(this._renderer, En);
  }
  destroy() {
    this._renderer = null;
  }
}
Bp.extension = {
  type: [
    A.WebGLSystem,
    A.WebGPUSystem
  ],
  name: "initHook",
  priority: -10
};
const Up = class Go {
  /** @ignore */
  constructor(...t) {
    this.stage = new St(), t[0] !== void 0 && W(K, "Application constructor options are deprecated, please use Application.init() instead.");
  }
  /**
   * Initializes the PixiJS application with the specified options.
   *
   * This method must be called after creating a new Application instance.
   * @param options - Configuration options for the application and renderer
   * @returns A promise that resolves when initialization is complete
   * @example
   * ```js
   * const app = new Application();
   *
   * // Initialize with custom options
   * await app.init({
   *     width: 800,
   *     height: 600,
   *     backgroundColor: 0x1099bb,
   *     preference: 'webgl', // or 'webgpu'
   * });
   * ```
   */
  async init(t) {
    t = { ...t }, this.renderer = await Av(t), Go._plugins.forEach((e) => {
      e.init.call(this, t);
    });
  }
  /**
   * Renders the current stage to the screen.
   *
   * When using the default setup with {@link TickerPlugin} (enabled by default), you typically don't need to call
   * this method directly as rendering is handled automatically.
   *
   * Only use this method if you've disabled the {@link TickerPlugin} or need custom
   * render timing control.
   * @example
   * ```js
   * // Example 1: Default setup (TickerPlugin handles rendering)
   * const app = new Application();
   * await app.init();
   * // No need to call render() - TickerPlugin handles it
   *
   * // Example 2: Custom rendering loop (if TickerPlugin is disabled)
   * const app = new Application();
   * await app.init({ autoStart: false }); // Disable automatic rendering
   *
   * function animate() {
   *     app.render();
   *     requestAnimationFrame(animate);
   * }
   * animate();
   * ```
   */
  render() {
    this.renderer.render({ container: this.stage });
  }
  /**
   * Reference to the renderer's canvas element. This is the HTML element
   * that displays your application's graphics.
   * @readonly
   * @type {HTMLCanvasElement}
   * @example
   * ```js
   * // Create a new application
   * const app = new Application();
   * // Initialize the application
   * await app.init({...});
   * // Add canvas to the page
   * document.body.appendChild(app.canvas);
   *
   * // Access the canvas directly
   * console.log(app.canvas); // HTMLCanvasElement
   * ```
   */
  get canvas() {
    return this.renderer.canvas;
  }
  /**
   * Reference to the renderer's canvas element.
   * @type {HTMLCanvasElement}
   * @deprecated since 8.0.0
   * @see {@link Application#canvas}
   */
  get view() {
    return W(K, "Application.view is deprecated, please use Application.canvas instead."), this.renderer.canvas;
  }
  /**
   * Reference to the renderer's screen rectangle. This represents the visible area of your application.
   *
   * It's commonly used for:
   * - Setting filter areas for full-screen effects
   * - Defining hit areas for screen-wide interaction
   * - Determining the visible bounds of your application
   * @readonly
   * @example
   * ```js
   * // Use as filter area for a full-screen effect
   * const blurFilter = new BlurFilter();
   * sprite.filterArea = app.screen;
   *
   * // Use as hit area for screen-wide interaction
   * const screenSprite = new Sprite();
   * screenSprite.hitArea = app.screen;
   *
   * // Get screen dimensions
   * console.log(app.screen.width, app.screen.height);
   * ```
   * @see {@link Rectangle} For all available properties and methods
   */
  get screen() {
    return this.renderer.screen;
  }
  /**
   * Destroys the application and all of its resources.
   *
   * This method should be called when you want to completely
   * clean up the application and free all associated memory.
   * @param rendererDestroyOptions - Options for destroying the renderer:
   *  - `false` or `undefined`: Preserves the canvas element (default)
   *  - `true`: Removes the canvas element
   *  - `{ removeView: boolean }`: Object with removeView property to control canvas removal
   * @param options - Options for destroying the application:
   *  - `false` or `undefined`: Basic cleanup (default)
   *  - `true`: Complete cleanup including children
   *  - Detailed options object:
   *    - `children`: Remove children
   *    - `texture`: Destroy textures
   *    - `textureSource`: Destroy texture sources
   *    - `context`: Destroy WebGL context
   * @example
   * ```js
   * // Basic cleanup
   * app.destroy();
   *
   * // Remove canvas and do complete cleanup
   * app.destroy(true, true);
   *
   * // Remove canvas with explicit options
   * app.destroy({ removeView: true }, true);
   *
   * // Detailed cleanup with specific options
   * app.destroy(
   *     { removeView: true },
   *     {
   *         children: true,
   *         texture: true,
   *         textureSource: true,
   *         context: true
   *     }
   * );
   * ```
   * > [!WARNING] After calling destroy, the application instance should no longer be used.
   * > All properties will be null and further operations will throw errors.
   */
  destroy(t = !1, e = !1) {
    const r = Go._plugins.slice(0);
    r.reverse(), r.forEach((n) => {
      n.destroy.call(this);
    }), this.stage.destroy(e), this.stage = null, this.renderer.destroy(t), this.renderer = null;
  }
};
Up._plugins = [];
let yr = Up;
L.handleByList(A.Application, yr._plugins);
L.add(Mp);
class Rp {
  /**
   * Initialize the plugin with scope of application instance
   * @private
   * @param {object} [options] - See application options
   */
  static init(t) {
    Object.defineProperty(
      this,
      "resizeTo",
      {
        set(e) {
          globalThis.removeEventListener("resize", this.queueResize), this._resizeTo = e, e && (globalThis.addEventListener("resize", this.queueResize), this.resize());
        },
        get() {
          return this._resizeTo;
        }
      }
    ), this.queueResize = () => {
      this._resizeTo && (this._cancelResize(), this._resizeId = requestAnimationFrame(() => this.resize()));
    }, this._cancelResize = () => {
      this._resizeId && (cancelAnimationFrame(this._resizeId), this._resizeId = null);
    }, this.resize = () => {
      if (!this._resizeTo)
        return;
      this._cancelResize();
      let e, r;
      if (this._resizeTo === globalThis.window)
        e = globalThis.innerWidth, r = globalThis.innerHeight;
      else {
        const { clientWidth: n, clientHeight: a } = this._resizeTo;
        e = n, r = a;
      }
      this.renderer.resize(e, r), this.render();
    }, this._resizeId = null, this._resizeTo = null, this.resizeTo = t.resizeTo || null;
  }
  /**
   * Clean up the ticker, scoped to application
   * @private
   */
  static destroy() {
    globalThis.removeEventListener("resize", this.queueResize), this._cancelResize(), this._cancelResize = null, this.queueResize = null, this.resizeTo = null, this.resize = null;
  }
}
Rp.extension = A.Application;
class Ip {
  /**
   * Initialize the plugin with scope of application instance
   * @private
   * @param {object} [options] - See application options
   */
  static init(t) {
    t = Object.assign({
      autoStart: !0,
      sharedTicker: !1
    }, t), Object.defineProperty(
      this,
      "ticker",
      {
        set(e) {
          this._ticker && this._ticker.remove(this.render, this), this._ticker = e, e && e.add(this.render, this, as.LOW);
        },
        get() {
          return this._ticker;
        }
      }
    ), this.stop = () => {
      this._ticker.stop();
    }, this.start = () => {
      this._ticker.start();
    }, this._ticker = null, this.ticker = t.sharedTicker ? Ae.shared : new Ae(), t.autoStart && this.start();
  }
  /**
   * Clean up the ticker, scoped to application.
   * @private
   */
  static destroy() {
    if (this._ticker) {
      const t = this._ticker;
      this.ticker = null, t.destroy();
    }
  }
}
Ip.extension = A.Application;
class kp extends te {
  constructor() {
    super(...arguments), this.chars = /* @__PURE__ */ Object.create(null), this.lineHeight = 0, this.fontFamily = "", this.fontMetrics = { fontSize: 0, ascent: 0, descent: 0 }, this.baseLineOffset = 0, this.distanceField = { type: "none", range: 0 }, this.pages = [], this.applyFillAsTint = !0, this.baseMeasurementFontSize = 100, this.baseRenderedFontSize = 100;
  }
  /**
   * The name of the font face.
   * @deprecated since 8.0.0 Use `fontFamily` instead.
   */
  get font() {
    return W(K, "BitmapFont.font is deprecated, please use BitmapFont.fontFamily instead."), this.fontFamily;
  }
  /**
   * The map of base page textures (i.e., sheets of glyphs).
   * @deprecated since 8.0.0 Use `pages` instead.
   */
  get pageTextures() {
    return W(K, "BitmapFont.pageTextures is deprecated, please use BitmapFont.pages instead."), this.pages;
  }
  /**
   * The size of the font face in pixels.
   * @deprecated since 8.0.0 Use `fontMetrics.fontSize` instead.
   */
  get size() {
    return W(K, "BitmapFont.size is deprecated, please use BitmapFont.fontMetrics.fontSize instead."), this.fontMetrics.fontSize;
  }
  /**
   * The kind of distance field for this font or "none".
   * @deprecated since 8.0.0 Use `distanceField.type` instead.
   */
  get distanceFieldRange() {
    return W(K, "BitmapFont.distanceFieldRange is deprecated, please use BitmapFont.distanceField.range instead."), this.distanceField.range;
  }
  /**
   * The range of the distance field in pixels.
   * @deprecated since 8.0.0 Use `distanceField.range` instead.
   */
  get distanceFieldType() {
    return W(K, "BitmapFont.distanceFieldType is deprecated, please use BitmapFont.distanceField.type instead."), this.distanceField.type;
  }
  destroy(t = !1) {
    this.emit("destroy", this), this.removeAllListeners();
    for (const e in this.chars)
      this.chars[e].texture?.destroy();
    this.chars = null, t && (this.pages.forEach((e) => e.texture.destroy(!0)), this.pages = null);
  }
}
const Pv = [
  "serif",
  "sans-serif",
  "monospace",
  "cursive",
  "fantasy",
  "system-ui"
];
function An(s) {
  const t = typeof s.fontSize == "number" ? `${s.fontSize}px` : s.fontSize;
  let e = s.fontFamily;
  Array.isArray(s.fontFamily) || (e = s.fontFamily.split(","));
  for (let r = e.length - 1; r >= 0; r--) {
    let n = e[r].trim();
    !/([\"\'])[^\'\"]+\1/.test(n) && !Pv.includes(n) && (n = `"${n}"`), e[r] = n;
  }
  return `${s.fontStyle} ${s.fontVariant} ${s.fontWeight} ${t} ${e.join(",")}`;
}
const Ba = {
  // TextMetrics requires getImageData readback for measuring fonts.
  willReadFrequently: !0
}, Re = class F {
  /**
   * Checking that we can use modern canvas 2D API.
   *
   * Note: This is an unstable API, Chrome < 94 use `textLetterSpacing`, later versions use `letterSpacing`.
   * @see TextMetrics.experimentalLetterSpacing
   * @see https://developer.mozilla.org/en-US/docs/Web/API/ICanvasRenderingContext2D/letterSpacing
   * @see https://developer.chrome.com/origintrials/#/view_trial/3585991203293757441
   */
  static get experimentalLetterSpacingSupported() {
    let t = F._experimentalLetterSpacingSupported;
    if (t === void 0) {
      const e = Y.get().getCanvasRenderingContext2D().prototype;
      t = F._experimentalLetterSpacingSupported = "letterSpacing" in e || "textLetterSpacing" in e;
    }
    return t;
  }
  /**
   * @param text - the text that was measured
   * @param style - the style that was measured
   * @param width - the measured width of the text
   * @param height - the measured height of the text
   * @param lines - an array of the lines of text broken by new lines and wrapping if specified in style
   * @param lineWidths - an array of the line widths for each line matched to `lines`
   * @param lineHeight - the measured line height for this style
   * @param maxLineWidth - the maximum line width for all measured lines
   * @param {FontMetrics} fontProperties - the font properties object from TextMetrics.measureFont
   */
  constructor(t, e, r, n, a, l, h, u, f) {
    this.text = t, this.style = e, this.width = r, this.height = n, this.lines = a, this.lineWidths = l, this.lineHeight = h, this.maxLineWidth = u, this.fontProperties = f;
  }
  /**
   * Measures the supplied string of text and returns a Rectangle.
   * @param text - The text to measure.
   * @param style - The text style to use for measuring
   * @param canvas - optional specification of the canvas to use for measuring.
   * @param wordWrap
   * @returns Measured width and height of the text.
   */
  static measureText(t = " ", e, r = F._canvas, n = e.wordWrap) {
    const a = An(e), l = F.measureFont(a);
    l.fontSize === 0 && (l.fontSize = e.fontSize, l.ascent = e.fontSize);
    const h = F.__context;
    h.font = a;
    const f = (n ? F._wordWrap(t, e, r) : t).split(/(?:\r\n|\r|\n)/), p = new Array(f.length);
    let m = 0;
    for (let _ = 0; _ < f.length; _++) {
      const y = F._measureText(f[_], e.letterSpacing, h);
      p[_] = y, m = Math.max(m, y);
    }
    const g = e._stroke?.width || 0;
    let x = m + g;
    e.dropShadow && (x += e.dropShadow.distance);
    const o = e.lineHeight || l.fontSize;
    let c = Math.max(o, l.fontSize + g) + (f.length - 1) * (o + e.leading);
    return e.dropShadow && (c += e.dropShadow.distance), new F(
      t,
      e,
      x,
      c,
      f,
      p,
      o + e.leading,
      m,
      l
    );
  }
  static _measureText(t, e, r) {
    let n = !1;
    F.experimentalLetterSpacingSupported && (F.experimentalLetterSpacing ? (r.letterSpacing = `${e}px`, r.textLetterSpacing = `${e}px`, n = !0) : (r.letterSpacing = "0px", r.textLetterSpacing = "0px"));
    const a = r.measureText(t);
    let l = a.width;
    const h = -a.actualBoundingBoxLeft;
    let f = a.actualBoundingBoxRight - h;
    if (l > 0)
      if (n)
        l -= e, f -= e;
      else {
        const p = (F.graphemeSegmenter(t).length - 1) * e;
        l += p, f += p;
      }
    return Math.max(l, f);
  }
  /**
   * Applies newlines to a string to have it optimally fit into the horizontal
   * bounds set by the Text object's wordWrapWidth property.
   * @param text - String to apply word wrapping to
   * @param style - the style to use when wrapping
   * @param canvas - optional specification of the canvas to use for measuring.
   * @returns New string with new lines applied where required
   */
  static _wordWrap(t, e, r = F._canvas) {
    const n = r.getContext("2d", Ba);
    let a = 0, l = "", h = "";
    const u = /* @__PURE__ */ Object.create(null), { letterSpacing: f, whiteSpace: p } = e, m = F._collapseSpaces(p), g = F._collapseNewlines(p);
    let x = !m;
    const o = e.wordWrapWidth + f, c = F._tokenize(t);
    for (let d = 0; d < c.length; d++) {
      let _ = c[d];
      if (F._isNewline(_)) {
        if (!g) {
          h += F._addLine(l), x = !m, l = "", a = 0;
          continue;
        }
        _ = " ";
      }
      if (m) {
        const v = F.isBreakingSpace(_), b = F.isBreakingSpace(l[l.length - 1]);
        if (v && b)
          continue;
      }
      const y = F._getFromCache(_, f, u, n);
      if (y > o)
        if (l !== "" && (h += F._addLine(l), l = "", a = 0), F.canBreakWords(_, e.breakWords)) {
          const v = F.wordWrapSplit(_);
          for (let b = 0; b < v.length; b++) {
            let w = v[b], S = w, T = 1;
            for (; v[b + T]; ) {
              const C = v[b + T];
              if (!F.canBreakChars(S, C, _, b, e.breakWords))
                w += C;
              else
                break;
              S = C, T++;
            }
            b += T - 1;
            const E = F._getFromCache(w, f, u, n);
            E + a > o && (h += F._addLine(l), x = !1, l = "", a = 0), l += w, a += E;
          }
        } else {
          l.length > 0 && (h += F._addLine(l), l = "", a = 0);
          const v = d === c.length - 1;
          h += F._addLine(_, !v), x = !1, l = "", a = 0;
        }
      else
        y + a > o && (x = !1, h += F._addLine(l), l = "", a = 0), (l.length > 0 || !F.isBreakingSpace(_) || x) && (l += _, a += y);
    }
    return h += F._addLine(l, !1), h;
  }
  /**
   * Convenience function for logging each line added during the wordWrap method.
   * @param line    - The line of text to add
   * @param newLine - Add new line character to end
   * @returns A formatted line
   */
  static _addLine(t, e = !0) {
    return t = F._trimRight(t), t = e ? `${t}
` : t, t;
  }
  /**
   * Gets & sets the widths of calculated characters in a cache object
   * @param key            - The key
   * @param letterSpacing  - The letter spacing
   * @param cache          - The cache
   * @param context        - The canvas context
   * @returns The from cache.
   */
  static _getFromCache(t, e, r, n) {
    let a = r[t];
    return typeof a != "number" && (a = F._measureText(t, e, n) + e, r[t] = a), a;
  }
  /**
   * Determines whether we should collapse breaking spaces.
   * @param whiteSpace - The TextStyle property whiteSpace
   * @returns Should collapse
   */
  static _collapseSpaces(t) {
    return t === "normal" || t === "pre-line";
  }
  /**
   * Determines whether we should collapse newLine chars.
   * @param whiteSpace - The white space
   * @returns should collapse
   */
  static _collapseNewlines(t) {
    return t === "normal";
  }
  /**
   * Trims breaking whitespaces from string.
   * @param text - The text
   * @returns Trimmed string
   */
  static _trimRight(t) {
    if (typeof t != "string")
      return "";
    for (let e = t.length - 1; e >= 0; e--) {
      const r = t[e];
      if (!F.isBreakingSpace(r))
        break;
      t = t.slice(0, -1);
    }
    return t;
  }
  /**
   * Determines if char is a newline.
   * @param char - The character
   * @returns True if newline, False otherwise.
   */
  static _isNewline(t) {
    return typeof t != "string" ? !1 : F._newlines.includes(t.charCodeAt(0));
  }
  /**
   * Determines if char is a breaking whitespace.
   *
   * It allows one to determine whether char should be a breaking whitespace
   * For example certain characters in CJK langs or numbers.
   * It must return a boolean.
   * @param char - The character
   * @param [_nextChar] - The next character
   * @returns True if whitespace, False otherwise.
   */
  static isBreakingSpace(t, e) {
    return typeof t != "string" ? !1 : F._breakingSpaces.includes(t.charCodeAt(0));
  }
  /**
   * Splits a string into words, breaking-spaces and newLine characters
   * @param text - The text
   * @returns A tokenized array
   */
  static _tokenize(t) {
    const e = [];
    let r = "";
    if (typeof t != "string")
      return e;
    for (let n = 0; n < t.length; n++) {
      const a = t[n], l = t[n + 1];
      if (F.isBreakingSpace(a, l) || F._isNewline(a)) {
        r !== "" && (e.push(r), r = ""), e.push(a);
        continue;
      }
      r += a;
    }
    return r !== "" && e.push(r), e;
  }
  /**
   * Overridable helper method used internally by TextMetrics, exposed to allow customizing the class's behavior.
   *
   * It allows one to customise which words should break
   * Examples are if the token is CJK or numbers.
   * It must return a boolean.
   * @param _token - The token
   * @param breakWords - The style attr break words
   * @returns Whether to break word or not
   */
  static canBreakWords(t, e) {
    return e;
  }
  /**
   * Overridable helper method used internally by TextMetrics, exposed to allow customizing the class's behavior.
   *
   * It allows one to determine whether a pair of characters
   * should be broken by newlines
   * For example certain characters in CJK langs or numbers.
   * It must return a boolean.
   * @param _char - The character
   * @param _nextChar - The next character
   * @param _token - The token/word the characters are from
   * @param _index - The index in the token of the char
   * @param _breakWords - The style attr break words
   * @returns whether to break word or not
   */
  static canBreakChars(t, e, r, n, a) {
    return !0;
  }
  /**
   * Overridable helper method used internally by TextMetrics, exposed to allow customizing the class's behavior.
   *
   * It is called when a token (usually a word) has to be split into separate pieces
   * in order to determine the point to break a word.
   * It must return an array of characters.
   * @param token - The token to split
   * @returns The characters of the token
   * @see CanvasTextMetrics.graphemeSegmenter
   */
  static wordWrapSplit(t) {
    return F.graphemeSegmenter(t);
  }
  /**
   * Calculates the ascent, descent and fontSize of a given font-style
   * @param font - String representing the style of the font
   * @returns Font properties object
   */
  static measureFont(t) {
    if (F._fonts[t])
      return F._fonts[t];
    const e = F._context;
    e.font = t;
    const r = e.measureText(F.METRICS_STRING + F.BASELINE_SYMBOL), n = {
      ascent: r.actualBoundingBoxAscent,
      descent: r.actualBoundingBoxDescent,
      fontSize: r.actualBoundingBoxAscent + r.actualBoundingBoxDescent
    };
    return F._fonts[t] = n, n;
  }
  /**
   * Clear font metrics in metrics cache.
   * @param {string} [font] - font name. If font name not set then clear cache for all fonts.
   */
  static clearMetrics(t = "") {
    t ? delete F._fonts[t] : F._fonts = {};
  }
  /**
   * Cached canvas element for measuring text
   * TODO: this should be private, but isn't because of backward compat, will fix later.
   * @ignore
   */
  static get _canvas() {
    if (!F.__canvas) {
      let t;
      try {
        const e = new OffscreenCanvas(0, 0);
        if (e.getContext("2d", Ba)?.measureText)
          return F.__canvas = e, e;
        t = Y.get().createCanvas();
      } catch {
        t = Y.get().createCanvas();
      }
      t.width = t.height = 10, F.__canvas = t;
    }
    return F.__canvas;
  }
  /**
   * TODO: this should be private, but isn't because of backward compat, will fix later.
   * @ignore
   */
  static get _context() {
    return F.__context || (F.__context = F._canvas.getContext("2d", Ba)), F.__context;
  }
};
Re.METRICS_STRING = "|ÉqÅ";
Re.BASELINE_SYMBOL = "M";
Re.BASELINE_MULTIPLIER = 1.4;
Re.HEIGHT_MULTIPLIER = 2;
Re.graphemeSegmenter = (() => {
  if (typeof Intl?.Segmenter == "function") {
    const s = new Intl.Segmenter();
    return (t) => {
      const e = s.segment(t), r = [];
      let n = 0;
      for (const a of e)
        r[n++] = a.segment;
      return r;
    };
  }
  return (s) => [...s];
})();
Re.experimentalLetterSpacing = !1;
Re._fonts = {};
Re._newlines = [
  10,
  // line feed
  13
  // carriage return
];
Re._breakingSpaces = [
  9,
  // character tabulation
  32,
  // space
  8192,
  // en quad
  8193,
  // em quad
  8194,
  // en space
  8195,
  // em space
  8196,
  // three-per-em space
  8197,
  // four-per-em space
  8198,
  // six-per-em space
  8200,
  // punctuation space
  8201,
  // thin space
  8202,
  // hair space
  8287,
  // medium mathematical space
  12288
  // ideographic space
];
let me = Re;
const Xc = [{ offset: 0, color: "white" }, { offset: 1, color: "black" }], Oh = class zo {
  constructor(...t) {
    this.uid = rt("fillGradient"), this.type = "linear", this.colorStops = [];
    let e = Mv(t);
    e = { ...e.type === "radial" ? zo.defaultRadialOptions : zo.defaultLinearOptions, ...Lf(e) }, this._textureSize = e.textureSize, this._wrapMode = e.wrapMode, e.type === "radial" ? (this.center = e.center, this.outerCenter = e.outerCenter ?? this.center, this.innerRadius = e.innerRadius, this.outerRadius = e.outerRadius, this.scale = e.scale, this.rotation = e.rotation) : (this.start = e.start, this.end = e.end), this.textureSpace = e.textureSpace, this.type = e.type, e.colorStops.forEach((n) => {
      this.addColorStop(n.offset, n.color);
    });
  }
  /**
   * Adds a color stop to the gradient
   * @param offset - Position of the stop (0-1)
   * @param color - Color of the stop
   * @returns This gradient instance for chaining
   */
  addColorStop(t, e) {
    return this.colorStops.push({ offset: t, color: Q.shared.setValue(e).toHexa() }), this;
  }
  /**
   * Builds the internal texture and transform for the gradient.
   * Called automatically when the gradient is first used.
   * @internal
   */
  buildLinearGradient() {
    if (this.texture)
      return;
    let { x: t, y: e } = this.start, { x: r, y: n } = this.end, a = r - t, l = n - e;
    const h = a < 0 || l < 0;
    if (this._wrapMode === "clamp-to-edge") {
      if (a < 0) {
        const d = t;
        t = r, r = d, a *= -1;
      }
      if (l < 0) {
        const d = e;
        e = n, n = d, l *= -1;
      }
    }
    const u = this.colorStops.length ? this.colorStops : Xc, f = this._textureSize, { canvas: p, context: m } = Kc(f, 1), g = h ? m.createLinearGradient(this._textureSize, 0, 0, 0) : m.createLinearGradient(0, 0, this._textureSize, 0);
    jc(g, u), m.fillStyle = g, m.fillRect(0, 0, f, 1), this.texture = new k({
      source: new Ii({
        resource: p,
        addressMode: this._wrapMode
      })
    });
    const x = Math.sqrt(a * a + l * l), o = Math.atan2(l, a), c = new D();
    c.scale(x / f, 1), c.rotate(o), c.translate(t, e), this.textureSpace === "local" && c.scale(f, f), this.transform = c;
  }
  /**
   * Builds the internal texture and transform for the gradient.
   * Called automatically when the gradient is first used.
   * @internal
   */
  buildGradient() {
    this.type === "linear" ? this.buildLinearGradient() : this.buildRadialGradient();
  }
  /**
   * Builds the internal texture and transform for the radial gradient.
   * Called automatically when the gradient is first used.
   * @internal
   */
  buildRadialGradient() {
    if (this.texture)
      return;
    const t = this.colorStops.length ? this.colorStops : Xc, e = this._textureSize, { canvas: r, context: n } = Kc(e, e), { x: a, y: l } = this.center, { x: h, y: u } = this.outerCenter, f = this.innerRadius, p = this.outerRadius, m = h - p, g = u - p, x = e / (p * 2), o = (a - m) * x, c = (l - g) * x, d = n.createRadialGradient(
      o,
      c,
      f * x,
      (h - m) * x,
      (u - g) * x,
      p * x
    );
    jc(d, t), n.fillStyle = t[t.length - 1].color, n.fillRect(0, 0, e, e), n.fillStyle = d, n.translate(o, c), n.rotate(this.rotation), n.scale(1, this.scale), n.translate(-o, -c), n.fillRect(0, 0, e, e), this.texture = new k({
      source: new Ii({
        resource: r,
        addressMode: this._wrapMode
      })
    });
    const _ = new D();
    _.scale(1 / x, 1 / x), _.translate(m, g), this.textureSpace === "local" && _.scale(e, e), this.transform = _;
  }
  /**
   * Gets a unique key representing the current state of the gradient.
   * Used internally for caching.
   * @returns Unique string key
   */
  get styleKey() {
    return this.uid;
  }
  destroy() {
    this.texture?.destroy(!0), this.texture = null;
  }
};
Oh.defaultLinearOptions = {
  start: { x: 0, y: 0 },
  end: { x: 0, y: 1 },
  colorStops: [],
  textureSpace: "local",
  type: "linear",
  textureSize: 256,
  wrapMode: "clamp-to-edge"
};
Oh.defaultRadialOptions = {
  center: { x: 0.5, y: 0.5 },
  innerRadius: 0,
  outerRadius: 0.5,
  colorStops: [],
  scale: 1,
  textureSpace: "local",
  type: "radial",
  textureSize: 256,
  wrapMode: "clamp-to-edge"
};
let Ue = Oh;
function jc(s, t) {
  for (let e = 0; e < t.length; e++) {
    const r = t[e];
    s.addColorStop(r.offset, r.color);
  }
}
function Kc(s, t) {
  const e = Y.get().createCanvas(s, t), r = e.getContext("2d");
  return { canvas: e, context: r };
}
function Mv(s) {
  let t = s[0] ?? {};
  return (typeof t == "number" || s[1]) && (W("8.5.2", "use options object instead"), t = {
    type: "linear",
    start: { x: s[0], y: s[1] },
    end: { x: s[2], y: s[3] },
    textureSpace: s[4],
    textureSize: s[5] ?? Ue.defaultLinearOptions.textureSize
  }), t;
}
const qc = {
  repeat: {
    addressModeU: "repeat",
    addressModeV: "repeat"
  },
  "repeat-x": {
    addressModeU: "repeat",
    addressModeV: "clamp-to-edge"
  },
  "repeat-y": {
    addressModeU: "clamp-to-edge",
    addressModeV: "repeat"
  },
  "no-repeat": {
    addressModeU: "clamp-to-edge",
    addressModeV: "clamp-to-edge"
  }
};
class Wn {
  constructor(t, e) {
    this.uid = rt("fillPattern"), this.transform = new D(), this._styleKey = null, this.texture = t, this.transform.scale(
      1 / t.frame.width,
      1 / t.frame.height
    ), e && (t.source.style.addressModeU = qc[e].addressModeU, t.source.style.addressModeV = qc[e].addressModeV);
  }
  /**
   * Sets the transform for the pattern
   * @param transform - The transform matrix to apply to the pattern.
   * If not provided, the pattern will use the default transform.
   */
  setTransform(t) {
    const e = this.texture;
    this.transform.copyFrom(t), this.transform.invert(), this.transform.scale(
      1 / e.frame.width,
      1 / e.frame.height
    ), this._styleKey = null;
  }
  /**
   * Gets a unique key representing the current state of the pattern.
   * Used internally for caching.
   * @returns Unique string key
   */
  get styleKey() {
    return this._styleKey ? this._styleKey : (this._styleKey = `fill-pattern-${this.uid}-${this.texture.uid}-${this.transform.toArray().join("-")}`, this._styleKey);
  }
}
var Ua, Zc;
function Bv() {
  if (Zc) return Ua;
  Zc = 1, Ua = e;
  var s = { a: 7, c: 6, h: 1, l: 2, m: 2, q: 4, s: 4, t: 2, v: 1, z: 0 }, t = /([astvzqmhlc])([^astvzqmhlc]*)/ig;
  function e(a) {
    var l = [];
    return a.replace(t, function(h, u, f) {
      var p = u.toLowerCase();
      for (f = n(f), p == "m" && f.length > 2 && (l.push([u].concat(f.splice(0, 2))), p = "l", u = u == "m" ? "l" : "L"); ; ) {
        if (f.length == s[p])
          return f.unshift(u), l.push(f);
        if (f.length < s[p]) throw new Error("malformed path data");
        l.push([u].concat(f.splice(0, s[p])));
      }
    }), l;
  }
  var r = /-?[0-9]*\.?[0-9]+(?:e[-+]?\d+)?/ig;
  function n(a) {
    var l = a.match(r);
    return l ? l.map(Number) : [];
  }
  return Ua;
}
var Uv = Bv();
const Rv = /* @__PURE__ */ ih(Uv);
function Iv(s, t) {
  const e = Rv(s), r = [];
  let n = null, a = 0, l = 0;
  for (let h = 0; h < e.length; h++) {
    const u = e[h], f = u[0], p = u;
    switch (f) {
      case "M":
        a = p[1], l = p[2], t.moveTo(a, l);
        break;
      case "m":
        a += p[1], l += p[2], t.moveTo(a, l);
        break;
      case "H":
        a = p[1], t.lineTo(a, l);
        break;
      case "h":
        a += p[1], t.lineTo(a, l);
        break;
      case "V":
        l = p[1], t.lineTo(a, l);
        break;
      case "v":
        l += p[1], t.lineTo(a, l);
        break;
      case "L":
        a = p[1], l = p[2], t.lineTo(a, l);
        break;
      case "l":
        a += p[1], l += p[2], t.lineTo(a, l);
        break;
      case "C":
        a = p[5], l = p[6], t.bezierCurveTo(
          p[1],
          p[2],
          // First control point
          p[3],
          p[4],
          // Second control point
          a,
          l
          // End point
        );
        break;
      case "c":
        t.bezierCurveTo(
          a + p[1],
          l + p[2],
          // First control point
          a + p[3],
          l + p[4],
          // Second control point
          a + p[5],
          l + p[6]
          // End point
        ), a += p[5], l += p[6];
        break;
      case "S":
        a = p[3], l = p[4], t.bezierCurveToShort(
          p[1],
          p[2],
          // Control point
          a,
          l
          // End point
        );
        break;
      case "s":
        t.bezierCurveToShort(
          a + p[1],
          l + p[2],
          // Control point
          a + p[3],
          l + p[4]
          // End point
        ), a += p[3], l += p[4];
        break;
      case "Q":
        a = p[3], l = p[4], t.quadraticCurveTo(
          p[1],
          p[2],
          // Control point
          a,
          l
          // End point
        );
        break;
      case "q":
        t.quadraticCurveTo(
          a + p[1],
          l + p[2],
          // Control point
          a + p[3],
          l + p[4]
          // End point
        ), a += p[3], l += p[4];
        break;
      case "T":
        a = p[1], l = p[2], t.quadraticCurveToShort(
          a,
          l
          // End point
        );
        break;
      case "t":
        a += p[1], l += p[2], t.quadraticCurveToShort(
          a,
          l
          // End point
        );
        break;
      case "A":
        a = p[6], l = p[7], t.arcToSvg(
          p[1],
          // rx
          p[2],
          // ry
          p[3],
          // x-axis-rotation
          p[4],
          // large-arc-flag
          p[5],
          // sweep-flag
          a,
          l
          // End point
        );
        break;
      case "a":
        a += p[6], l += p[7], t.arcToSvg(
          p[1],
          // rx
          p[2],
          // ry
          p[3],
          // x-axis-rotation
          p[4],
          // large-arc-flag
          p[5],
          // sweep-flag
          a,
          l
          // End point
        );
        break;
      case "Z":
      case "z":
        t.closePath(), r.length > 0 && (n = r.pop(), n ? (a = n.startX, l = n.startY) : (a = 0, l = 0)), n = null;
        break;
      default:
        N(`Unknown SVG path command: ${f}`);
    }
    f !== "Z" && f !== "z" && n === null && (n = { startX: a, startY: l }, r.push(n));
  }
  return t;
}
class Lh {
  /**
   * @param x - The X coordinate of the center of this circle
   * @param y - The Y coordinate of the center of this circle
   * @param radius - The radius of the circle
   */
  constructor(t = 0, e = 0, r = 0) {
    this.type = "circle", this.x = t, this.y = e, this.radius = r;
  }
  /**
   * Creates a clone of this Circle instance.
   * @example
   * ```ts
   * // Basic circle cloning
   * const original = new Circle(100, 100, 50);
   * const copy = original.clone();
   *
   * // Clone and modify
   * const modified = original.clone();
   * modified.radius = 75;
   *
   * // Verify independence
   * console.log(original.radius); // 50
   * console.log(modified.radius); // 75
   * ```
   * @returns A copy of the Circle
   * @see {@link Circle.copyFrom} For copying into existing circle
   * @see {@link Circle.copyTo} For copying to another circle
   */
  clone() {
    return new Lh(this.x, this.y, this.radius);
  }
  /**
   * Checks whether the x and y coordinates given are contained within this circle.
   *
   * Uses the distance formula to determine if a point is inside the circle's radius.
   *
   * Commonly used for hit testing in PixiJS events and graphics.
   * @example
   * ```ts
   * // Basic containment check
   * const circle = new Circle(100, 100, 50);
   * const isInside = circle.contains(120, 120);
   *
   * // Check mouse position
   * const circle = new Circle(0, 0, 100);
   * container.hitArea = circle;
   * container.on('pointermove', (e) => {
   *     // only called if pointer is within circle
   * });
   * ```
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coordinates are within this Circle
   * @see {@link Circle.strokeContains} For checking stroke intersection
   * @see {@link Circle.getBounds} For getting bounding box
   */
  contains(t, e) {
    if (this.radius <= 0)
      return !1;
    const r = this.radius * this.radius;
    let n = this.x - t, a = this.y - e;
    return n *= n, a *= a, n + a <= r;
  }
  /**
   * Checks whether the x and y coordinates given are contained within this circle including the stroke.
   * @example
   * ```ts
   * // Basic stroke check
   * const circle = new Circle(100, 100, 50);
   * const isOnStroke = circle.strokeContains(150, 100, 4); // 4px line width
   *
   * // Check with different alignments
   * const innerStroke = circle.strokeContains(150, 100, 4, 0);   // Inside
   * const centerStroke = circle.strokeContains(150, 100, 4, 0.5); // Centered
   * const outerStroke = circle.strokeContains(150, 100, 4, 1);   // Outside
   * ```
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @param width - The width of the line to check
   * @param alignment - The alignment of the stroke, 0.5 by default
   * @returns Whether the x/y coordinates are within this Circle's stroke
   * @see {@link Circle.contains} For checking fill containment
   * @see {@link Circle.getBounds} For getting stroke bounds
   */
  strokeContains(t, e, r, n = 0.5) {
    if (this.radius === 0)
      return !1;
    const a = this.x - t, l = this.y - e, h = this.radius, u = (1 - n) * r, f = Math.sqrt(a * a + l * l);
    return f <= h + u && f > h - (r - u);
  }
  /**
   * Returns the framing rectangle of the circle as a Rectangle object.
   * @example
   * ```ts
   * // Basic bounds calculation
   * const circle = new Circle(100, 100, 50);
   * const bounds = circle.getBounds();
   * // bounds: x=50, y=50, width=100, height=100
   *
   * // Reuse existing rectangle
   * const rect = new Rectangle();
   * circle.getBounds(rect);
   * ```
   * @param out - Optional Rectangle object to store the result
   * @returns The framing rectangle
   * @see {@link Rectangle} For rectangle properties
   * @see {@link Circle.contains} For point containment
   */
  getBounds(t) {
    return t || (t = new Z()), t.x = this.x - this.radius, t.y = this.y - this.radius, t.width = this.radius * 2, t.height = this.radius * 2, t;
  }
  /**
   * Copies another circle to this one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Circle(100, 100, 50);
   * const target = new Circle();
   * target.copyFrom(source);
   * ```
   * @param circle - The circle to copy from
   * @returns Returns itself
   * @see {@link Circle.copyTo} For copying to another circle
   * @see {@link Circle.clone} For creating new circle copy
   */
  copyFrom(t) {
    return this.x = t.x, this.y = t.y, this.radius = t.radius, this;
  }
  /**
   * Copies this circle to another one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Circle(100, 100, 50);
   * const target = new Circle();
   * source.copyTo(target);
   * ```
   * @param circle - The circle to copy to
   * @returns Returns given parameter
   * @see {@link Circle.copyFrom} For copying from another circle
   * @see {@link Circle.clone} For creating new circle copy
   */
  copyTo(t) {
    return t.copyFrom(this), t;
  }
  toString() {
    return `[pixi.js/math:Circle x=${this.x} y=${this.y} radius=${this.radius}]`;
  }
}
class Gh {
  /**
   * @param x - The X coordinate of the center of this ellipse
   * @param y - The Y coordinate of the center of this ellipse
   * @param halfWidth - The half width of this ellipse
   * @param halfHeight - The half height of this ellipse
   */
  constructor(t = 0, e = 0, r = 0, n = 0) {
    this.type = "ellipse", this.x = t, this.y = e, this.halfWidth = r, this.halfHeight = n;
  }
  /**
   * Creates a clone of this Ellipse instance.
   * @example
   * ```ts
   * // Basic cloning
   * const original = new Ellipse(100, 100, 50, 25);
   * const copy = original.clone();
   *
   * // Clone and modify
   * const modified = original.clone();
   * modified.halfWidth *= 2;
   * modified.halfHeight *= 2;
   *
   * // Verify independence
   * console.log(original.halfWidth);  // 50
   * console.log(modified.halfWidth);  // 100
   * ```
   * @returns A copy of the ellipse
   * @see {@link Ellipse.copyFrom} For copying into existing ellipse
   * @see {@link Ellipse.copyTo} For copying to another ellipse
   */
  clone() {
    return new Gh(this.x, this.y, this.halfWidth, this.halfHeight);
  }
  /**
   * Checks whether the x and y coordinates given are contained within this ellipse.
   * Uses normalized coordinates and the ellipse equation to determine containment.
   * @example
   * ```ts
   * // Basic containment check
   * const ellipse = new Ellipse(100, 100, 50, 25);
   * const isInside = ellipse.contains(120, 110);
   * ```
   * @remarks
   * - Uses ellipse equation (x²/a² + y²/b² ≤ 1)
   * - Returns false if dimensions are 0 or negative
   * - Normalized to center (0,0) for calculation
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coords are within this ellipse
   * @see {@link Ellipse.strokeContains} For checking stroke intersection
   * @see {@link Ellipse.getBounds} For getting containing rectangle
   */
  contains(t, e) {
    if (this.halfWidth <= 0 || this.halfHeight <= 0)
      return !1;
    let r = (t - this.x) / this.halfWidth, n = (e - this.y) / this.halfHeight;
    return r *= r, n *= n, r + n <= 1;
  }
  /**
   * Checks whether the x and y coordinates given are contained within this ellipse including stroke.
   * @example
   * ```ts
   * // Basic stroke check
   * const ellipse = new Ellipse(100, 100, 50, 25);
   * const isOnStroke = ellipse.strokeContains(150, 100, 4); // 4px line width
   *
   * // Check with different alignments
   * const innerStroke = ellipse.strokeContains(150, 100, 4, 0);   // Inside
   * const centerStroke = ellipse.strokeContains(150, 100, 4, 0.5); // Centered
   * const outerStroke = ellipse.strokeContains(150, 100, 4, 1);   // Outside
   * ```
   * @remarks
   * - Uses normalized ellipse equations
   * - Considers stroke alignment
   * - Returns false if dimensions are 0
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @param strokeWidth - The width of the line to check
   * @param alignment - The alignment of the stroke (0 = inner, 0.5 = centered, 1 = outer)
   * @returns Whether the x/y coords are within this ellipse's stroke
   * @see {@link Ellipse.contains} For checking fill containment
   * @see {@link Ellipse.getBounds} For getting stroke bounds
   */
  strokeContains(t, e, r, n = 0.5) {
    const { halfWidth: a, halfHeight: l } = this;
    if (a <= 0 || l <= 0)
      return !1;
    const h = r * (1 - n), u = r - h, f = a - u, p = l - u, m = a + h, g = l + h, x = t - this.x, o = e - this.y, c = x * x / (f * f) + o * o / (p * p), d = x * x / (m * m) + o * o / (g * g);
    return c > 1 && d <= 1;
  }
  /**
   * Returns the framing rectangle of the ellipse as a Rectangle object.
   * @example
   * ```ts
   * // Basic bounds calculation
   * const ellipse = new Ellipse(100, 100, 50, 25);
   * const bounds = ellipse.getBounds();
   * // bounds: x=50, y=75, width=100, height=50
   *
   * // Reuse existing rectangle
   * const rect = new Rectangle();
   * ellipse.getBounds(rect);
   * ```
   * @remarks
   * - Creates Rectangle if none provided
   * - Top-left is (x-halfWidth, y-halfHeight)
   * - Width is halfWidth * 2
   * - Height is halfHeight * 2
   * @param out - Optional Rectangle object to store the result
   * @returns The framing rectangle
   * @see {@link Rectangle} For rectangle properties
   * @see {@link Ellipse.contains} For checking if a point is inside
   */
  getBounds(t) {
    return t || (t = new Z()), t.x = this.x - this.halfWidth, t.y = this.y - this.halfHeight, t.width = this.halfWidth * 2, t.height = this.halfHeight * 2, t;
  }
  /**
   * Copies another ellipse to this one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Ellipse(100, 100, 50, 25);
   * const target = new Ellipse();
   * target.copyFrom(source);
   * ```
   * @param ellipse - The ellipse to copy from
   * @returns Returns itself
   * @see {@link Ellipse.copyTo} For copying to another ellipse
   * @see {@link Ellipse.clone} For creating new ellipse copy
   */
  copyFrom(t) {
    return this.x = t.x, this.y = t.y, this.halfWidth = t.halfWidth, this.halfHeight = t.halfHeight, this;
  }
  /**
   * Copies this ellipse to another one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Ellipse(100, 100, 50, 25);
   * const target = new Ellipse();
   * source.copyTo(target);
   * ```
   * @param ellipse - The ellipse to copy to
   * @returns Returns given parameter
   * @see {@link Ellipse.copyFrom} For copying from another ellipse
   * @see {@link Ellipse.clone} For creating new ellipse copy
   */
  copyTo(t) {
    return t.copyFrom(this), t;
  }
  toString() {
    return `[pixi.js/math:Ellipse x=${this.x} y=${this.y} halfWidth=${this.halfWidth} halfHeight=${this.halfHeight}]`;
  }
}
function kv(s, t, e, r, n, a) {
  const l = s - e, h = t - r, u = n - e, f = a - r, p = l * u + h * f, m = u * u + f * f;
  let g = -1;
  m !== 0 && (g = p / m);
  let x, o;
  g < 0 ? (x = e, o = r) : g > 1 ? (x = n, o = a) : (x = e + g * u, o = r + g * f);
  const c = s - x, d = t - o;
  return c * c + d * d;
}
let Fv, Dv;
class Xr {
  /**
   * @param points - This can be an array of Points
   *  that form the polygon, a flat array of numbers that will be interpreted as [x,y, x,y, ...], or
   *  the arguments passed can be all the points of the polygon e.g.
   *  `new Polygon(new Point(), new Point(), ...)`, or the arguments passed can be flat
   *  x,y values e.g. `new Polygon(x,y, x,y, x,y, ...)` where `x` and `y` are Numbers.
   */
  constructor(...t) {
    this.type = "polygon";
    let e = Array.isArray(t[0]) ? t[0] : t;
    if (typeof e[0] != "number") {
      const r = [];
      for (let n = 0, a = e.length; n < a; n++)
        r.push(e[n].x, e[n].y);
      e = r;
    }
    this.points = e, this.closePath = !0;
  }
  /**
   * Determines whether the polygon's points are arranged in a clockwise direction.
   * Uses the shoelace formula (surveyor's formula) to calculate the signed area.
   *
   * A positive area indicates clockwise winding, while negative indicates counter-clockwise.
   *
   * The formula sums up the cross products of adjacent vertices:
   * For each pair of adjacent points (x1,y1) and (x2,y2), we calculate (x1*y2 - x2*y1)
   * The final sum divided by 2 gives the signed area - positive for clockwise.
   * @example
   * ```ts
   * // Check polygon winding
   * const polygon = new Polygon([0, 0, 100, 0, 50, 100]);
   * console.log(polygon.isClockwise()); // Check direction
   *
   * // Use in path construction
   * const hole = new Polygon([25, 25, 75, 25, 75, 75, 25, 75]);
   * if (hole.isClockwise() === shape.isClockwise()) {
   *     hole.points.reverse(); // Reverse for proper hole winding
   * }
   * ```
   * @returns `true` if the polygon's points are arranged clockwise, `false` if counter-clockwise
   */
  isClockwise() {
    let t = 0;
    const e = this.points, r = e.length;
    for (let n = 0; n < r; n += 2) {
      const a = e[n], l = e[n + 1], h = e[(n + 2) % r], u = e[(n + 3) % r];
      t += (h - a) * (u + l);
    }
    return t < 0;
  }
  /**
   * Checks if this polygon completely contains another polygon.
   * Used for detecting holes in shapes, like when parsing SVG paths.
   * @example
   * ```ts
   * // Basic containment check
   * const outerSquare = new Polygon([0,0, 100,0, 100,100, 0,100]); // A square
   * const innerSquare = new Polygon([25,25, 75,25, 75,75, 25,75]); // A smaller square inside
   *
   * outerSquare.containsPolygon(innerSquare); // Returns true
   * innerSquare.containsPolygon(outerSquare); // Returns false
   * ```
   * @remarks
   * - Uses bounds check for quick rejection
   * - Tests all points for containment
   * @param polygon - The polygon to test for containment
   * @returns True if this polygon completely contains the other polygon
   * @see {@link Polygon.contains} For single point testing
   * @see {@link Polygon.getBounds} For bounds calculation
   */
  containsPolygon(t) {
    const e = this.getBounds(Fv), r = t.getBounds(Dv);
    if (!e.containsRect(r))
      return !1;
    const n = t.points;
    for (let a = 0; a < n.length; a += 2) {
      const l = n[a], h = n[a + 1];
      if (!this.contains(l, h))
        return !1;
    }
    return !0;
  }
  /**
   * Creates a clone of this polygon.
   * @example
   * ```ts
   * // Basic cloning
   * const original = new Polygon([0, 0, 100, 0, 50, 100]);
   * const copy = original.clone();
   *
   * // Clone and modify
   * const modified = original.clone();
   * modified.points[0] = 10; // Modify first x coordinate
   * ```
   * @returns A copy of the polygon
   * @see {@link Polygon.copyFrom} For copying into existing polygon
   * @see {@link Polygon.copyTo} For copying to another polygon
   */
  clone() {
    const t = this.points.slice(), e = new Xr(t);
    return e.closePath = this.closePath, e;
  }
  /**
   * Checks whether the x and y coordinates passed to this function are contained within this polygon.
   * Uses raycasting algorithm for point-in-polygon testing.
   * @example
   * ```ts
   * // Basic containment check
   * const polygon = new Polygon([0, 0, 100, 0, 50, 100]);
   * const isInside = polygon.contains(25, 25); // true
   * ```
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coordinates are within this polygon
   * @see {@link Polygon.strokeContains} For checking stroke intersection
   * @see {@link Polygon.containsPolygon} For polygon-in-polygon testing
   */
  contains(t, e) {
    let r = !1;
    const n = this.points.length / 2;
    for (let a = 0, l = n - 1; a < n; l = a++) {
      const h = this.points[a * 2], u = this.points[a * 2 + 1], f = this.points[l * 2], p = this.points[l * 2 + 1];
      u > e != p > e && t < (f - h) * ((e - u) / (p - u)) + h && (r = !r);
    }
    return r;
  }
  /**
   * Checks whether the x and y coordinates given are contained within this polygon including the stroke.
   * @example
   * ```ts
   * // Basic stroke check
   * const polygon = new Polygon([0, 0, 100, 0, 50, 100]);
   * const isOnStroke = polygon.strokeContains(25, 25, 4); // 4px line width
   *
   * // Check with different alignments
   * const innerStroke = polygon.strokeContains(25, 25, 4, 0);   // Inside
   * const centerStroke = polygon.strokeContains(25, 25, 4, 0.5); // Centered
   * const outerStroke = polygon.strokeContains(25, 25, 4, 1);   // Outside
   * ```
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @param strokeWidth - The width of the line to check
   * @param alignment - The alignment of the stroke (0 = inner, 0.5 = centered, 1 = outer)
   * @returns Whether the x/y coordinates are within this polygon's stroke
   * @see {@link Polygon.contains} For checking fill containment
   * @see {@link Polygon.getBounds} For getting stroke bounds
   */
  strokeContains(t, e, r, n = 0.5) {
    const a = r * r, l = a * (1 - n), h = a - l, { points: u } = this, f = u.length - (this.closePath ? 0 : 2);
    for (let p = 0; p < f; p += 2) {
      const m = u[p], g = u[p + 1], x = u[(p + 2) % u.length], o = u[(p + 3) % u.length], c = kv(t, e, m, g, x, o), d = Math.sign((x - m) * (e - g) - (o - g) * (t - m));
      if (c <= (d < 0 ? h : l))
        return !0;
    }
    return !1;
  }
  /**
   * Returns the framing rectangle of the polygon as a Rectangle object.
   * @example
   * ```ts
   * // Basic bounds calculation
   * const polygon = new Polygon([0, 0, 100, 0, 50, 100]);
   * const bounds = polygon.getBounds();
   * // bounds: x=0, y=0, width=100, height=100
   *
   * // Reuse existing rectangle
   * const rect = new Rectangle();
   * polygon.getBounds(rect);
   * ```
   * @param out - Optional rectangle to store the result
   * @returns The framing rectangle
   * @see {@link Rectangle} For rectangle properties
   * @see {@link Polygon.contains} For checking if a point is inside
   */
  getBounds(t) {
    t || (t = new Z());
    const e = this.points;
    let r = 1 / 0, n = -1 / 0, a = 1 / 0, l = -1 / 0;
    for (let h = 0, u = e.length; h < u; h += 2) {
      const f = e[h], p = e[h + 1];
      r = f < r ? f : r, n = f > n ? f : n, a = p < a ? p : a, l = p > l ? p : l;
    }
    return t.x = r, t.width = n - r, t.y = a, t.height = l - a, t;
  }
  /**
   * Copies another polygon to this one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Polygon([0, 0, 100, 0, 50, 100]);
   * const target = new Polygon();
   * target.copyFrom(source);
   * ```
   * @param polygon - The polygon to copy from
   * @returns Returns itself
   * @see {@link Polygon.copyTo} For copying to another polygon
   * @see {@link Polygon.clone} For creating new polygon copy
   */
  copyFrom(t) {
    return this.points = t.points.slice(), this.closePath = t.closePath, this;
  }
  /**
   * Copies this polygon to another one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Polygon([0, 0, 100, 0, 50, 100]);
   * const target = new Polygon();
   * source.copyTo(target);
   * ```
   * @param polygon - The polygon to copy to
   * @returns Returns given parameter
   * @see {@link Polygon.copyFrom} For copying from another polygon
   * @see {@link Polygon.clone} For creating new polygon copy
   */
  copyTo(t) {
    return t.copyFrom(this), t;
  }
  toString() {
    return `[pixi.js/math:PolygoncloseStroke=${this.closePath}points=${this.points.reduce((t, e) => `${t}, ${e}`, "")}]`;
  }
  /**
   * Get the last X coordinate of the polygon.
   * @example
   * ```ts
   * // Basic coordinate access
   * const polygon = new Polygon([0, 0, 100, 200, 300, 400]);
   * console.log(polygon.lastX); // 300
   * ```
   * @readonly
   * @returns The x-coordinate of the last vertex
   * @see {@link Polygon.lastY} For last Y coordinate
   * @see {@link Polygon.points} For raw points array
   */
  get lastX() {
    return this.points[this.points.length - 2];
  }
  /**
   * Get the last Y coordinate of the polygon.
   * @example
   * ```ts
   * // Basic coordinate access
   * const polygon = new Polygon([0, 0, 100, 200, 300, 400]);
   * console.log(polygon.lastY); // 400
   * ```
   * @readonly
   * @returns The y-coordinate of the last vertex
   * @see {@link Polygon.lastX} For last X coordinate
   * @see {@link Polygon.points} For raw points array
   */
  get lastY() {
    return this.points[this.points.length - 1];
  }
  /**
   * Get the first X coordinate of the polygon
   * @readonly
   */
  get x() {
    return this.points[this.points.length - 2];
  }
  /**
   * Get the first Y coordinate of the polygon
   * @readonly
   */
  get y() {
    return this.points[this.points.length - 1];
  }
}
const Hs = (s, t, e, r, n, a, l) => {
  const h = s - e, u = t - r, f = Math.sqrt(h * h + u * u);
  return f >= n - a && f <= n + l;
};
class zh {
  /**
   * @param x - The X coordinate of the upper-left corner of the rounded rectangle
   * @param y - The Y coordinate of the upper-left corner of the rounded rectangle
   * @param width - The overall width of this rounded rectangle
   * @param height - The overall height of this rounded rectangle
   * @param radius - Controls the radius of the rounded corners
   */
  constructor(t = 0, e = 0, r = 0, n = 0, a = 20) {
    this.type = "roundedRectangle", this.x = t, this.y = e, this.width = r, this.height = n, this.radius = a;
  }
  /**
   * Returns the framing rectangle of the rounded rectangle as a Rectangle object
   * @example
   * ```ts
   * // Basic bounds calculation
   * const rect = new RoundedRectangle(100, 100, 200, 150, 20);
   * const bounds = rect.getBounds();
   * // bounds: x=100, y=100, width=200, height=150
   *
   * // Reuse existing rectangle
   * const out = new Rectangle();
   * rect.getBounds(out);
   * ```
   * @remarks
   * - Rectangle matches outer dimensions
   * - Ignores corner radius
   * @param out - Optional rectangle to store the result
   * @returns The framing rectangle
   * @see {@link Rectangle} For rectangle properties
   * @see {@link RoundedRectangle.contains} For checking if a point is inside
   */
  getBounds(t) {
    return t || (t = new Z()), t.x = this.x, t.y = this.y, t.width = this.width, t.height = this.height, t;
  }
  /**
   * Creates a clone of this Rounded Rectangle.
   * @example
   * ```ts
   * // Basic cloning
   * const original = new RoundedRectangle(100, 100, 200, 150, 20);
   * const copy = original.clone();
   *
   * // Clone and modify
   * const modified = original.clone();
   * modified.radius = 30;
   * modified.width *= 2;
   *
   * // Verify independence
   * console.log(original.radius);  // 20
   * console.log(modified.radius);  // 30
   * ```
   * @returns A copy of the rounded rectangle
   * @see {@link RoundedRectangle.copyFrom} For copying into existing rectangle
   * @see {@link RoundedRectangle.copyTo} For copying to another rectangle
   */
  clone() {
    return new zh(this.x, this.y, this.width, this.height, this.radius);
  }
  /**
   * Copies another rectangle to this one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new RoundedRectangle(100, 100, 200, 150, 20);
   * const target = new RoundedRectangle();
   * target.copyFrom(source);
   *
   * // Chain with other operations
   * const rect = new RoundedRectangle()
   *     .copyFrom(source)
   *     .getBounds(rect);
   * ```
   * @param rectangle - The rectangle to copy from
   * @returns Returns itself
   * @see {@link RoundedRectangle.copyTo} For copying to another rectangle
   * @see {@link RoundedRectangle.clone} For creating new rectangle copy
   */
  copyFrom(t) {
    return this.x = t.x, this.y = t.y, this.width = t.width, this.height = t.height, this;
  }
  /**
   * Copies this rectangle to another one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new RoundedRectangle(100, 100, 200, 150, 20);
   * const target = new RoundedRectangle();
   * source.copyTo(target);
   *
   * // Chain with other operations
   * const result = source
   *     .copyTo(new RoundedRectangle())
   *     .getBounds();
   * ```
   * @param rectangle - The rectangle to copy to
   * @returns Returns given parameter
   * @see {@link RoundedRectangle.copyFrom} For copying from another rectangle
   * @see {@link RoundedRectangle.clone} For creating new rectangle copy
   */
  copyTo(t) {
    return t.copyFrom(this), t;
  }
  /**
   * Checks whether the x and y coordinates given are contained within this Rounded Rectangle
   * @example
   * ```ts
   * // Basic containment check
   * const rect = new RoundedRectangle(100, 100, 200, 150, 20);
   * const isInside = rect.contains(150, 125); // true
   * // Check corner radius
   * const corner = rect.contains(100, 100); // false if within corner curve
   * ```
   * @remarks
   * - Returns false if width/height is 0 or negative
   * - Handles rounded corners with radius check
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coordinates are within this Rounded Rectangle
   * @see {@link RoundedRectangle.strokeContains} For checking stroke intersection
   * @see {@link RoundedRectangle.getBounds} For getting containing rectangle
   */
  contains(t, e) {
    if (this.width <= 0 || this.height <= 0)
      return !1;
    if (t >= this.x && t <= this.x + this.width && e >= this.y && e <= this.y + this.height) {
      const r = Math.max(0, Math.min(this.radius, Math.min(this.width, this.height) / 2));
      if (e >= this.y + r && e <= this.y + this.height - r || t >= this.x + r && t <= this.x + this.width - r)
        return !0;
      let n = t - (this.x + r), a = e - (this.y + r);
      const l = r * r;
      if (n * n + a * a <= l || (n = t - (this.x + this.width - r), n * n + a * a <= l) || (a = e - (this.y + this.height - r), n * n + a * a <= l) || (n = t - (this.x + r), n * n + a * a <= l))
        return !0;
    }
    return !1;
  }
  /**
   * Checks whether the x and y coordinates given are contained within this rectangle including the stroke.
   * @example
   * ```ts
   * // Basic stroke check
   * const rect = new RoundedRectangle(100, 100, 200, 150, 20);
   * const isOnStroke = rect.strokeContains(150, 100, 4); // 4px line width
   *
   * // Check with different alignments
   * const innerStroke = rect.strokeContains(150, 100, 4, 0);   // Inside
   * const centerStroke = rect.strokeContains(150, 100, 4, 0.5); // Centered
   * const outerStroke = rect.strokeContains(150, 100, 4, 1);   // Outside
   * ```
   * @param pX - The X coordinate of the point to test
   * @param pY - The Y coordinate of the point to test
   * @param strokeWidth - The width of the line to check
   * @param alignment - The alignment of the stroke (0 = inner, 0.5 = centered, 1 = outer)
   * @returns Whether the x/y coordinates are within this rectangle's stroke
   * @see {@link RoundedRectangle.contains} For checking fill containment
   * @see {@link RoundedRectangle.getBounds} For getting stroke bounds
   */
  strokeContains(t, e, r, n = 0.5) {
    const { x: a, y: l, width: h, height: u, radius: f } = this, p = r * (1 - n), m = r - p, g = a + f, x = l + f, o = h - f * 2, c = u - f * 2, d = a + h, _ = l + u;
    return (t >= a - p && t <= a + m || t >= d - m && t <= d + p) && e >= x && e <= x + c || (e >= l - p && e <= l + m || e >= _ - m && e <= _ + p) && t >= g && t <= g + o ? !0 : (
      // Top-left
      t < g && e < x && Hs(
        t,
        e,
        g,
        x,
        f,
        m,
        p
      ) || t > d - f && e < x && Hs(
        t,
        e,
        d - f,
        x,
        f,
        m,
        p
      ) || t > d - f && e > _ - f && Hs(
        t,
        e,
        d - f,
        _ - f,
        f,
        m,
        p
      ) || t < g && e > _ - f && Hs(
        t,
        e,
        g,
        _ - f,
        f,
        m,
        p
      )
    );
  }
  toString() {
    return `[pixi.js/math:RoundedRectangle x=${this.x} y=${this.y}width=${this.width} height=${this.height} radius=${this.radius}]`;
  }
}
const Fp = {};
function Nh(s, t, e) {
  let r = 2166136261;
  for (let n = 0; n < t; n++)
    r ^= s[n].uid, r = Math.imul(r, 16777619), r >>>= 0;
  return Fp[r] || Ov(s, t, r, e);
}
function Ov(s, t, e, r) {
  const n = {};
  let a = 0;
  for (let h = 0; h < r; h++) {
    const u = h < t ? s[h] : k.EMPTY.source;
    n[a++] = u.source, n[a++] = u.style;
  }
  const l = new He(n);
  return Fp[e] = l, l;
}
class ji {
  constructor(t) {
    typeof t == "number" ? this.rawBinaryData = new ArrayBuffer(t) : t instanceof Uint8Array ? this.rawBinaryData = t.buffer : this.rawBinaryData = t, this.uint32View = new Uint32Array(this.rawBinaryData), this.float32View = new Float32Array(this.rawBinaryData), this.size = this.rawBinaryData.byteLength;
  }
  /** View on the raw binary data as a `Int8Array`. */
  get int8View() {
    return this._int8View || (this._int8View = new Int8Array(this.rawBinaryData)), this._int8View;
  }
  /** View on the raw binary data as a `Uint8Array`. */
  get uint8View() {
    return this._uint8View || (this._uint8View = new Uint8Array(this.rawBinaryData)), this._uint8View;
  }
  /**  View on the raw binary data as a `Int16Array`. */
  get int16View() {
    return this._int16View || (this._int16View = new Int16Array(this.rawBinaryData)), this._int16View;
  }
  /** View on the raw binary data as a `Int32Array`. */
  get int32View() {
    return this._int32View || (this._int32View = new Int32Array(this.rawBinaryData)), this._int32View;
  }
  /** View on the raw binary data as a `Float64Array`. */
  get float64View() {
    return this._float64Array || (this._float64Array = new Float64Array(this.rawBinaryData)), this._float64Array;
  }
  /** View on the raw binary data as a `BigUint64Array`. */
  get bigUint64View() {
    return this._bigUint64Array || (this._bigUint64Array = new BigUint64Array(this.rawBinaryData)), this._bigUint64Array;
  }
  /**
   * Returns the view of the given type.
   * @param type - One of `int8`, `uint8`, `int16`,
   *    `uint16`, `int32`, `uint32`, and `float32`.
   * @returns - typed array of given type
   */
  view(t) {
    return this[`${t}View`];
  }
  /** Destroys all buffer references. Do not use after calling this. */
  destroy() {
    this.rawBinaryData = null, this._int8View = null, this._uint8View = null, this._int16View = null, this.uint16View = null, this._int32View = null, this.uint32View = null, this.float32View = null;
  }
  /**
   * Returns the size of the given type in bytes.
   * @param type - One of `int8`, `uint8`, `int16`,
   *   `uint16`, `int32`, `uint32`, and `float32`.
   * @returns - size of the type in bytes
   */
  static sizeOf(t) {
    switch (t) {
      case "int8":
      case "uint8":
        return 1;
      case "int16":
      case "uint16":
        return 2;
      case "int32":
      case "uint32":
      case "float32":
        return 4;
      default:
        throw new Error(`${t} isn't a valid view type`);
    }
  }
}
function No(s, t) {
  const e = s.byteLength / 8 | 0, r = new Float64Array(s, 0, e);
  new Float64Array(t, 0, e).set(r);
  const a = s.byteLength - e * 8;
  if (a > 0) {
    const l = new Uint8Array(s, e * 8, a);
    new Uint8Array(t, e * 8, a).set(l);
  }
}
const Lv = {
  normal: "normal-npm",
  add: "add-npm",
  screen: "screen-npm"
};
var ft = /* @__PURE__ */ ((s) => (s[s.DISABLED = 0] = "DISABLED", s[s.RENDERING_MASK_ADD = 1] = "RENDERING_MASK_ADD", s[s.MASK_ACTIVE = 2] = "MASK_ACTIVE", s[s.INVERSE_MASK_ACTIVE = 3] = "INVERSE_MASK_ACTIVE", s[s.RENDERING_MASK_REMOVE = 4] = "RENDERING_MASK_REMOVE", s[s.NONE = 5] = "NONE", s))(ft || {});
function us(s, t) {
  return t.alphaMode === "no-premultiply-alpha" && Lv[s] || s;
}
const Gv = [
  "precision mediump float;",
  "void main(void){",
  "float test = 0.1;",
  "%forloop%",
  "gl_FragColor = vec4(0.0);",
  "}"
].join(`
`);
function zv(s) {
  let t = "";
  for (let e = 0; e < s; ++e)
    e > 0 && (t += `
else `), e < s - 1 && (t += `if(test == ${e}.0){}`);
  return t;
}
function Dp(s, t) {
  if (s === 0)
    throw new Error("Invalid value of `0` passed to `checkMaxIfStatementsInShader`");
  const e = t.createShader(t.FRAGMENT_SHADER);
  try {
    for (; ; ) {
      const r = Gv.replace(/%forloop%/gi, zv(s));
      if (t.shaderSource(e, r), t.compileShader(e), !t.getShaderParameter(e, t.COMPILE_STATUS))
        s = s / 2 | 0;
      else
        break;
    }
  } finally {
    t.deleteShader(e);
  }
  return s;
}
let Gi = null;
function Nv() {
  if (Gi)
    return Gi;
  const s = pp();
  return Gi = s.getParameter(s.MAX_TEXTURE_IMAGE_UNITS), Gi = Dp(
    Gi,
    s
  ), s.getExtension("WEBGL_lose_context")?.loseContext(), Gi;
}
class Hv {
  constructor() {
    this.ids = /* @__PURE__ */ Object.create(null), this.textures = [], this.count = 0;
  }
  /** Clear the textures and their locations. */
  clear() {
    for (let t = 0; t < this.count; t++) {
      const e = this.textures[t];
      this.textures[t] = null, this.ids[e.uid] = null;
    }
    this.count = 0;
  }
}
class Wv {
  constructor() {
    this.renderPipeId = "batch", this.action = "startBatch", this.start = 0, this.size = 0, this.textures = new Hv(), this.blendMode = "normal", this.topology = "triangle-strip", this.canBundle = !0;
  }
  destroy() {
    this.textures = null, this.gpuBindGroup = null, this.bindGroup = null, this.batcher = null;
  }
}
const Op = [];
let Ho = 0;
function Qc() {
  return Ho > 0 ? Op[--Ho] : new Wv();
}
function Jc(s) {
  Op[Ho++] = s;
}
let Er = 0;
const Lp = class Gp {
  constructor(t) {
    this.uid = rt("batcher"), this.dirty = !0, this.batchIndex = 0, this.batches = [], this._elements = [], t = { ...Gp.defaultOptions, ...t }, t.maxTextures || (W("v8.8.0", "maxTextures is a required option for Batcher now, please pass it in the options"), t.maxTextures = Nv());
    const { maxTextures: e, attributesInitialSize: r, indicesInitialSize: n } = t;
    this.attributeBuffer = new ji(r * 4), this.indexBuffer = new Uint16Array(n), this.maxTextures = e;
  }
  begin() {
    this.elementSize = 0, this.elementStart = 0, this.indexSize = 0, this.attributeSize = 0;
    for (let t = 0; t < this.batchIndex; t++)
      Jc(this.batches[t]);
    this.batchIndex = 0, this._batchIndexStart = 0, this._batchIndexSize = 0, this.dirty = !0;
  }
  add(t) {
    this._elements[this.elementSize++] = t, t._indexStart = this.indexSize, t._attributeStart = this.attributeSize, t._batcher = this, this.indexSize += t.indexSize, this.attributeSize += t.attributeSize * this.vertexSize;
  }
  checkAndUpdateTexture(t, e) {
    const r = t._batch.textures.ids[e._source.uid];
    return !r && r !== 0 ? !1 : (t._textureId = r, t.texture = e, !0);
  }
  updateElement(t) {
    this.dirty = !0;
    const e = this.attributeBuffer;
    t.packAsQuad ? this.packQuadAttributes(
      t,
      e.float32View,
      e.uint32View,
      t._attributeStart,
      t._textureId
    ) : this.packAttributes(
      t,
      e.float32View,
      e.uint32View,
      t._attributeStart,
      t._textureId
    );
  }
  /**
   * breaks the batcher. This happens when a batch gets too big,
   * or we need to switch to a different type of rendering (a filter for example)
   * @param instructionSet
   */
  break(t) {
    const e = this._elements;
    if (!e[this.elementStart])
      return;
    let r = Qc(), n = r.textures;
    n.clear();
    const a = e[this.elementStart];
    let l = us(a.blendMode, a.texture._source), h = a.topology;
    this.attributeSize * 4 > this.attributeBuffer.size && this._resizeAttributeBuffer(this.attributeSize * 4), this.indexSize > this.indexBuffer.length && this._resizeIndexBuffer(this.indexSize);
    const u = this.attributeBuffer.float32View, f = this.attributeBuffer.uint32View, p = this.indexBuffer;
    let m = this._batchIndexSize, g = this._batchIndexStart, x = "startBatch";
    const o = this.maxTextures;
    for (let c = this.elementStart; c < this.elementSize; ++c) {
      const d = e[c];
      e[c] = null;
      const y = d.texture._source, v = us(d.blendMode, y), b = l !== v || h !== d.topology;
      if (y._batchTick === Er && !b) {
        d._textureId = y._textureBindLocation, m += d.indexSize, d.packAsQuad ? (this.packQuadAttributes(
          d,
          u,
          f,
          d._attributeStart,
          d._textureId
        ), this.packQuadIndex(
          p,
          d._indexStart,
          d._attributeStart / this.vertexSize
        )) : (this.packAttributes(
          d,
          u,
          f,
          d._attributeStart,
          d._textureId
        ), this.packIndex(
          d,
          p,
          d._indexStart,
          d._attributeStart / this.vertexSize
        )), d._batch = r;
        continue;
      }
      y._batchTick = Er, (n.count >= o || b) && (this._finishBatch(
        r,
        g,
        m - g,
        n,
        l,
        h,
        t,
        x
      ), x = "renderBatch", g = m, l = v, h = d.topology, r = Qc(), n = r.textures, n.clear(), ++Er), d._textureId = y._textureBindLocation = n.count, n.ids[y.uid] = n.count, n.textures[n.count++] = y, d._batch = r, m += d.indexSize, d.packAsQuad ? (this.packQuadAttributes(
        d,
        u,
        f,
        d._attributeStart,
        d._textureId
      ), this.packQuadIndex(
        p,
        d._indexStart,
        d._attributeStart / this.vertexSize
      )) : (this.packAttributes(
        d,
        u,
        f,
        d._attributeStart,
        d._textureId
      ), this.packIndex(
        d,
        p,
        d._indexStart,
        d._attributeStart / this.vertexSize
      ));
    }
    n.count > 0 && (this._finishBatch(
      r,
      g,
      m - g,
      n,
      l,
      h,
      t,
      x
    ), g = m, ++Er), this.elementStart = this.elementSize, this._batchIndexStart = g, this._batchIndexSize = m;
  }
  _finishBatch(t, e, r, n, a, l, h, u) {
    t.gpuBindGroup = null, t.bindGroup = null, t.action = u, t.batcher = this, t.textures = n, t.blendMode = a, t.topology = l, t.start = e, t.size = r, ++Er, this.batches[this.batchIndex++] = t, h.add(t);
  }
  finish(t) {
    this.break(t);
  }
  /**
   * Resizes the attribute buffer to the given size (1 = 1 float32)
   * @param size - the size in vertices to ensure (not bytes!)
   */
  ensureAttributeBuffer(t) {
    t * 4 <= this.attributeBuffer.size || this._resizeAttributeBuffer(t * 4);
  }
  /**
   * Resizes the index buffer to the given size (1 = 1 float32)
   * @param size - the size in vertices to ensure (not bytes!)
   */
  ensureIndexBuffer(t) {
    t <= this.indexBuffer.length || this._resizeIndexBuffer(t);
  }
  _resizeAttributeBuffer(t) {
    const e = Math.max(t, this.attributeBuffer.size * 2), r = new ji(e);
    No(this.attributeBuffer.rawBinaryData, r.rawBinaryData), this.attributeBuffer = r;
  }
  _resizeIndexBuffer(t) {
    const e = this.indexBuffer;
    let r = Math.max(t, e.length * 1.5);
    r += r % 2;
    const n = r > 65535 ? new Uint32Array(r) : new Uint16Array(r);
    if (n.BYTES_PER_ELEMENT !== e.BYTES_PER_ELEMENT)
      for (let a = 0; a < e.length; a++)
        n[a] = e[a];
    else
      No(e.buffer, n.buffer);
    this.indexBuffer = n;
  }
  packQuadIndex(t, e, r) {
    t[e] = r + 0, t[e + 1] = r + 1, t[e + 2] = r + 2, t[e + 3] = r + 0, t[e + 4] = r + 2, t[e + 5] = r + 3;
  }
  packIndex(t, e, r, n) {
    const a = t.indices, l = t.indexSize, h = t.indexOffset, u = t.attributeOffset;
    for (let f = 0; f < l; f++)
      e[r++] = n + a[f + h] - u;
  }
  destroy() {
    for (let t = 0; t < this.batches.length; t++)
      Jc(this.batches[t]);
    this.batches = null;
    for (let t = 0; t < this._elements.length; t++)
      this._elements[t]._batch = null;
    this._elements = null, this.indexBuffer = null, this.attributeBuffer.destroy(), this.attributeBuffer = null;
  }
};
Lp.defaultOptions = {
  maxTextures: null,
  attributesInitialSize: 4,
  indicesInitialSize: 6
};
let Vv = Lp;
var X = /* @__PURE__ */ ((s) => (s[s.MAP_READ = 1] = "MAP_READ", s[s.MAP_WRITE = 2] = "MAP_WRITE", s[s.COPY_SRC = 4] = "COPY_SRC", s[s.COPY_DST = 8] = "COPY_DST", s[s.INDEX = 16] = "INDEX", s[s.VERTEX = 32] = "VERTEX", s[s.UNIFORM = 64] = "UNIFORM", s[s.STORAGE = 128] = "STORAGE", s[s.INDIRECT = 256] = "INDIRECT", s[s.QUERY_RESOLVE = 512] = "QUERY_RESOLVE", s[s.STATIC = 1024] = "STATIC", s))(X || {});
class Zt extends te {
  /**
   * Creates a new Buffer with the given options
   * @param options - the options for the buffer
   */
  constructor(t) {
    let { data: e, size: r } = t;
    const { usage: n, label: a, shrinkToFit: l } = t;
    super(), this.uid = rt("buffer"), this._resourceType = "buffer", this._resourceId = rt("resource"), this._touched = 0, this._updateID = 1, this._dataInt32 = null, this.shrinkToFit = !0, this.destroyed = !1, e instanceof Array && (e = new Float32Array(e)), this._data = e, r ?? (r = e?.byteLength);
    const h = !!e;
    this.descriptor = {
      size: r,
      usage: n,
      mappedAtCreation: h,
      label: a
    }, this.shrinkToFit = l ?? !0;
  }
  /** the data in the buffer */
  get data() {
    return this._data;
  }
  set data(t) {
    this.setDataWithSize(t, t.length, !0);
  }
  get dataInt32() {
    return this._dataInt32 || (this._dataInt32 = new Int32Array(this.data.buffer)), this._dataInt32;
  }
  /** whether the buffer is static or not */
  get static() {
    return !!(this.descriptor.usage & X.STATIC);
  }
  set static(t) {
    t ? this.descriptor.usage |= X.STATIC : this.descriptor.usage &= ~X.STATIC;
  }
  /**
   * Sets the data in the buffer to the given value. This will immediately update the buffer on the GPU.
   * If you only want to update a subset of the buffer, you can pass in the size of the data.
   * @param value - the data to set
   * @param size - the size of the data in bytes
   * @param syncGPU - should the buffer be updated on the GPU immediately?
   */
  setDataWithSize(t, e, r) {
    if (this._updateID++, this._updateSize = e * t.BYTES_PER_ELEMENT, this._data === t) {
      r && this.emit("update", this);
      return;
    }
    const n = this._data;
    if (this._data = t, this._dataInt32 = null, !n || n.length !== t.length) {
      !this.shrinkToFit && n && t.byteLength < n.byteLength ? r && this.emit("update", this) : (this.descriptor.size = t.byteLength, this._resourceId = rt("resource"), this.emit("change", this));
      return;
    }
    r && this.emit("update", this);
  }
  /**
   * updates the buffer on the GPU to reflect the data in the buffer.
   * By default it will update the entire buffer. If you only want to update a subset of the buffer,
   * you can pass in the size of the buffer to update.
   * @param sizeInBytes - the new size of the buffer in bytes
   */
  update(t) {
    this._updateSize = t ?? this._updateSize, this._updateID++, this.emit("update", this);
  }
  /** Destroys the buffer */
  destroy() {
    this.destroyed = !0, this.emit("destroy", this), this.emit("change", this), this._data = null, this.descriptor = null, this.removeAllListeners();
  }
}
function zp(s, t) {
  if (!(s instanceof Zt)) {
    let e = t ? X.INDEX : X.VERTEX;
    s instanceof Array && (t ? (s = new Uint32Array(s), e = X.INDEX | X.COPY_DST) : (s = new Float32Array(s), e = X.VERTEX | X.COPY_DST)), s = new Zt({
      data: s,
      label: t ? "index-mesh-buffer" : "vertex-mesh-buffer",
      usage: e
    });
  }
  return s;
}
function $v(s, t, e) {
  const r = s.getAttribute(t);
  if (!r)
    return e.minX = 0, e.minY = 0, e.maxX = 0, e.maxY = 0, e;
  const n = r.buffer.data;
  let a = 1 / 0, l = 1 / 0, h = -1 / 0, u = -1 / 0;
  const f = n.BYTES_PER_ELEMENT, p = (r.offset || 0) / f, m = (r.stride || 2 * 4) / f;
  for (let g = p; g < n.length; g += m) {
    const x = n[g], o = n[g + 1];
    x > h && (h = x), o > u && (u = o), x < a && (a = x), o < l && (l = o);
  }
  return e.minX = a, e.minY = l, e.maxX = h, e.maxY = u, e;
}
function Yv(s) {
  return (s instanceof Zt || Array.isArray(s) || s.BYTES_PER_ELEMENT) && (s = {
    buffer: s
  }), s.buffer = zp(s.buffer, !1), s;
}
class ys extends te {
  /**
   * Create a new instance of a geometry
   * @param options - The options for the geometry.
   */
  constructor(t = {}) {
    super(), this.uid = rt("geometry"), this._layoutKey = 0, this.instanceCount = 1, this._bounds = new Ut(), this._boundsDirty = !0;
    const { attributes: e, indexBuffer: r, topology: n } = t;
    if (this.buffers = [], this.attributes = {}, e)
      for (const a in e)
        this.addAttribute(a, e[a]);
    this.instanceCount = t.instanceCount ?? 1, r && this.addIndex(r), this.topology = n || "triangle-list";
  }
  onBufferUpdate() {
    this._boundsDirty = !0, this.emit("update", this);
  }
  /**
   * Returns the requested attribute.
   * @param id - The name of the attribute required
   * @returns - The attribute requested.
   */
  getAttribute(t) {
    return this.attributes[t];
  }
  /**
   * Returns the index buffer
   * @returns - The index buffer.
   */
  getIndex() {
    return this.indexBuffer;
  }
  /**
   * Returns the requested buffer.
   * @param id - The name of the buffer required.
   * @returns - The buffer requested.
   */
  getBuffer(t) {
    return this.getAttribute(t).buffer;
  }
  /**
   * Used to figure out how many vertices there are in this geometry
   * @returns the number of vertices in the geometry
   */
  getSize() {
    for (const t in this.attributes) {
      const e = this.attributes[t];
      return e.buffer.data.length / (e.stride / 4 || e.size);
    }
    return 0;
  }
  /**
   * Adds an attribute to the geometry.
   * @param name - The name of the attribute to add.
   * @param attributeOption - The attribute option to add.
   */
  addAttribute(t, e) {
    const r = Yv(e);
    this.buffers.indexOf(r.buffer) === -1 && (this.buffers.push(r.buffer), r.buffer.on("update", this.onBufferUpdate, this), r.buffer.on("change", this.onBufferUpdate, this)), this.attributes[t] = r;
  }
  /**
   * Adds an index buffer to the geometry.
   * @param indexBuffer - The index buffer to add. Can be a Buffer, TypedArray, or an array of numbers.
   */
  addIndex(t) {
    this.indexBuffer = zp(t, !0), this.buffers.push(this.indexBuffer);
  }
  /** Returns the bounds of the geometry. */
  get bounds() {
    return this._boundsDirty ? (this._boundsDirty = !1, $v(this, "aPosition", this._bounds)) : this._bounds;
  }
  /**
   * destroys the geometry.
   * @param destroyBuffers - destroy the buffers associated with this geometry
   */
  destroy(t = !1) {
    this.emit("destroy", this), this.removeAllListeners(), t && this.buffers.forEach((e) => e.destroy()), this.attributes = null, this.buffers = null, this.indexBuffer = null, this._bounds = null;
  }
}
const Xv = new Float32Array(1), jv = new Uint32Array(1);
class Kv extends ys {
  constructor() {
    const e = new Zt({
      data: Xv,
      label: "attribute-batch-buffer",
      usage: X.VERTEX | X.COPY_DST,
      shrinkToFit: !1
    }), r = new Zt({
      data: jv,
      label: "index-batch-buffer",
      usage: X.INDEX | X.COPY_DST,
      // | BufferUsage.STATIC,
      shrinkToFit: !1
    }), n = 6 * 4;
    super({
      attributes: {
        aPosition: {
          buffer: e,
          format: "float32x2",
          stride: n,
          offset: 0
        },
        aUV: {
          buffer: e,
          format: "float32x2",
          stride: n,
          offset: 2 * 4
        },
        aColor: {
          buffer: e,
          format: "unorm8x4",
          stride: n,
          offset: 4 * 4
        },
        aTextureIdAndRound: {
          buffer: e,
          format: "uint16x2",
          stride: n,
          offset: 5 * 4
        }
      },
      indexBuffer: r
    });
  }
}
function tu(s, t, e) {
  if (s)
    for (const r in s) {
      const n = r.toLocaleLowerCase(), a = t[n];
      if (a) {
        let l = s[r];
        r === "header" && (l = l.replace(/@in\s+[^;]+;\s*/g, "").replace(/@out\s+[^;]+;\s*/g, "")), e && a.push(`//----${e}----//`), a.push(l);
      } else
        N(`${r} placement hook does not exist in shader`);
    }
}
const qv = /\{\{(.*?)\}\}/g;
function eu(s) {
  const t = {};
  return (s.match(qv)?.map((r) => r.replace(/[{()}]/g, "")) ?? []).forEach((r) => {
    t[r] = [];
  }), t;
}
function iu(s, t) {
  let e;
  const r = /@in\s+([^;]+);/g;
  for (; (e = r.exec(s)) !== null; )
    t.push(e[1]);
}
function ru(s, t, e = !1) {
  const r = [];
  iu(t, r), s.forEach((h) => {
    h.header && iu(h.header, r);
  });
  const n = r;
  e && n.sort();
  const a = n.map((h, u) => `       @location(${u}) ${h},`).join(`
`);
  let l = t.replace(/@in\s+[^;]+;\s*/g, "");
  return l = l.replace("{{in}}", `
${a}
`), l;
}
function su(s, t) {
  let e;
  const r = /@out\s+([^;]+);/g;
  for (; (e = r.exec(s)) !== null; )
    t.push(e[1]);
}
function Zv(s) {
  const e = /\b(\w+)\s*:/g.exec(s);
  return e ? e[1] : "";
}
function Qv(s) {
  const t = /@.*?\s+/g;
  return s.replace(t, "");
}
function Jv(s, t) {
  const e = [];
  su(t, e), s.forEach((u) => {
    u.header && su(u.header, e);
  });
  let r = 0;
  const n = e.sort().map((u) => u.indexOf("builtin") > -1 ? u : `@location(${r++}) ${u}`).join(`,
`), a = e.sort().map((u) => `       var ${Qv(u)};`).join(`
`), l = `return VSOutput(
            ${e.sort().map((u) => ` ${Zv(u)}`).join(`,
`)});`;
  let h = t.replace(/@out\s+[^;]+;\s*/g, "");
  return h = h.replace("{{struct}}", `
${n}
`), h = h.replace("{{start}}", `
${a}
`), h = h.replace("{{return}}", `
${l}
`), h;
}
function nu(s, t) {
  let e = s;
  for (const r in t) {
    const n = t[r];
    n.join(`
`).length ? e = e.replace(`{{${r}}}`, `//-----${r} START-----//
${n.join(`
`)}
//----${r} FINISH----//`) : e = e.replace(`{{${r}}}`, "");
  }
  return e;
}
const ei = /* @__PURE__ */ Object.create(null), Ra = /* @__PURE__ */ new Map();
let tw = 0;
function ew({
  template: s,
  bits: t
}) {
  const e = Np(s, t);
  if (ei[e])
    return ei[e];
  const { vertex: r, fragment: n } = rw(s, t);
  return ei[e] = Hp(r, n, t), ei[e];
}
function iw({
  template: s,
  bits: t
}) {
  const e = Np(s, t);
  return ei[e] || (ei[e] = Hp(s.vertex, s.fragment, t)), ei[e];
}
function rw(s, t) {
  const e = t.map((l) => l.vertex).filter((l) => !!l), r = t.map((l) => l.fragment).filter((l) => !!l);
  let n = ru(e, s.vertex, !0);
  n = Jv(e, n);
  const a = ru(r, s.fragment, !0);
  return {
    vertex: n,
    fragment: a
  };
}
function Np(s, t) {
  return t.map((e) => (Ra.has(e) || Ra.set(e, tw++), Ra.get(e))).sort((e, r) => e - r).join("-") + s.vertex + s.fragment;
}
function Hp(s, t, e) {
  const r = eu(s), n = eu(t);
  return e.forEach((a) => {
    tu(a.vertex, r, a.name), tu(a.fragment, n, a.name);
  }), {
    vertex: nu(s, r),
    fragment: nu(t, n)
  };
}
const sw = (
  /* wgsl */
  `
    @in aPosition: vec2<f32>;
    @in aUV: vec2<f32>;

    @out @builtin(position) vPosition: vec4<f32>;
    @out vUV : vec2<f32>;
    @out vColor : vec4<f32>;

    {{header}}

    struct VSOutput {
        {{struct}}
    };

    @vertex
    fn main( {{in}} ) -> VSOutput {

        var worldTransformMatrix = globalUniforms.uWorldTransformMatrix;
        var modelMatrix = mat3x3<f32>(
            1.0, 0.0, 0.0,
            0.0, 1.0, 0.0,
            0.0, 0.0, 1.0
          );
        var position = aPosition;
        var uv = aUV;

        {{start}}

        vColor = vec4<f32>(1., 1., 1., 1.);

        {{main}}

        vUV = uv;

        var modelViewProjectionMatrix = globalUniforms.uProjectionMatrix * worldTransformMatrix * modelMatrix;

        vPosition =  vec4<f32>((modelViewProjectionMatrix *  vec3<f32>(position, 1.0)).xy, 0.0, 1.0);

        vColor *= globalUniforms.uWorldColorAlpha;

        {{end}}

        {{return}}
    };
`
), nw = (
  /* wgsl */
  `
    @in vUV : vec2<f32>;
    @in vColor : vec4<f32>;

    {{header}}

    @fragment
    fn main(
        {{in}}
      ) -> @location(0) vec4<f32> {

        {{start}}

        var outColor:vec4<f32>;

        {{main}}

        var finalColor:vec4<f32> = outColor * vColor;

        {{end}}

        return finalColor;
      };
`
), aw = (
  /* glsl */
  `
    in vec2 aPosition;
    in vec2 aUV;

    out vec4 vColor;
    out vec2 vUV;

    {{header}}

    void main(void){

        mat3 worldTransformMatrix = uWorldTransformMatrix;
        mat3 modelMatrix = mat3(
            1.0, 0.0, 0.0,
            0.0, 1.0, 0.0,
            0.0, 0.0, 1.0
          );
        vec2 position = aPosition;
        vec2 uv = aUV;

        {{start}}

        vColor = vec4(1.);

        {{main}}

        vUV = uv;

        mat3 modelViewProjectionMatrix = uProjectionMatrix * worldTransformMatrix * modelMatrix;

        gl_Position = vec4((modelViewProjectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);

        vColor *= uWorldColorAlpha;

        {{end}}
    }
`
), ow = (
  /* glsl */
  `

    in vec4 vColor;
    in vec2 vUV;

    out vec4 finalColor;

    {{header}}

    void main(void) {

        {{start}}

        vec4 outColor;

        {{main}}

        finalColor = outColor * vColor;

        {{end}}
    }
`
), hw = {
  name: "global-uniforms-bit",
  vertex: {
    header: (
      /* wgsl */
      `
        struct GlobalUniforms {
            uProjectionMatrix:mat3x3<f32>,
            uWorldTransformMatrix:mat3x3<f32>,
            uWorldColorAlpha: vec4<f32>,
            uResolution: vec2<f32>,
        }

        @group(0) @binding(0) var<uniform> globalUniforms : GlobalUniforms;
        `
    )
  }
}, lw = {
  name: "global-uniforms-bit",
  vertex: {
    header: (
      /* glsl */
      `
          uniform mat3 uProjectionMatrix;
          uniform mat3 uWorldTransformMatrix;
          uniform vec4 uWorldColorAlpha;
          uniform vec2 uResolution;
        `
    )
  }
};
function xs({ bits: s, name: t }) {
  const e = ew({
    template: {
      fragment: nw,
      vertex: sw
    },
    bits: [
      hw,
      ...s
    ]
  });
  return Di.from({
    name: t,
    vertex: {
      source: e.vertex,
      entryPoint: "main"
    },
    fragment: {
      source: e.fragment,
      entryPoint: "main"
    }
  });
}
function bs({ bits: s, name: t }) {
  return new gr({
    name: t,
    ...iw({
      template: {
        vertex: aw,
        fragment: ow
      },
      bits: [
        lw,
        ...s
      ]
    })
  });
}
const Hh = {
  name: "color-bit",
  vertex: {
    header: (
      /* wgsl */
      `
            @in aColor: vec4<f32>;
        `
    ),
    main: (
      /* wgsl */
      `
            vColor *= vec4<f32>(aColor.rgb * aColor.a, aColor.a);
        `
    )
  }
}, Wh = {
  name: "color-bit",
  vertex: {
    header: (
      /* glsl */
      `
            in vec4 aColor;
        `
    ),
    main: (
      /* glsl */
      `
            vColor *= vec4(aColor.rgb * aColor.a, aColor.a);
        `
    )
  }
}, Ia = {};
function cw(s) {
  const t = [];
  if (s === 1)
    t.push("@group(1) @binding(0) var textureSource1: texture_2d<f32>;"), t.push("@group(1) @binding(1) var textureSampler1: sampler;");
  else {
    let e = 0;
    for (let r = 0; r < s; r++)
      t.push(`@group(1) @binding(${e++}) var textureSource${r + 1}: texture_2d<f32>;`), t.push(`@group(1) @binding(${e++}) var textureSampler${r + 1}: sampler;`);
  }
  return t.join(`
`);
}
function uw(s) {
  const t = [];
  if (s === 1)
    t.push("outColor = textureSampleGrad(textureSource1, textureSampler1, vUV, uvDx, uvDy);");
  else {
    t.push("switch vTextureId {");
    for (let e = 0; e < s; e++)
      e === s - 1 ? t.push("  default:{") : t.push(`  case ${e}:{`), t.push(`      outColor = textureSampleGrad(textureSource${e + 1}, textureSampler${e + 1}, vUV, uvDx, uvDy);`), t.push("      break;}");
    t.push("}");
  }
  return t.join(`
`);
}
function Vh(s) {
  return Ia[s] || (Ia[s] = {
    name: "texture-batch-bit",
    vertex: {
      header: `
                @in aTextureIdAndRound: vec2<u32>;
                @out @interpolate(flat) vTextureId : u32;
            `,
      main: `
                vTextureId = aTextureIdAndRound.y;
            `,
      end: `
                if(aTextureIdAndRound.x == 1)
                {
                    vPosition = vec4<f32>(roundPixels(vPosition.xy, globalUniforms.uResolution), vPosition.zw);
                }
            `
    },
    fragment: {
      header: `
                @in @interpolate(flat) vTextureId: u32;

                ${cw(s)}
            `,
      main: `
                var uvDx = dpdx(vUV);
                var uvDy = dpdy(vUV);

                ${uw(s)}
            `
    }
  }), Ia[s];
}
const ka = {};
function dw(s) {
  const t = [];
  for (let e = 0; e < s; e++)
    e > 0 && t.push("else"), e < s - 1 && t.push(`if(vTextureId < ${e}.5)`), t.push("{"), t.push(`	outColor = texture(uTextures[${e}], vUV);`), t.push("}");
  return t.join(`
`);
}
function $h(s) {
  return ka[s] || (ka[s] = {
    name: "texture-batch-bit",
    vertex: {
      header: `
                in vec2 aTextureIdAndRound;
                out float vTextureId;

            `,
      main: `
                vTextureId = aTextureIdAndRound.y;
            `,
      end: `
                if(aTextureIdAndRound.x == 1.)
                {
                    gl_Position.xy = roundPixels(gl_Position.xy, uResolution);
                }
            `
    },
    fragment: {
      header: `
                in float vTextureId;

                uniform sampler2D uTextures[${s}];

            `,
      main: `

                ${dw(s)}
            `
    }
  }), ka[s];
}
const vs = {
  name: "round-pixels-bit",
  vertex: {
    header: (
      /* wgsl */
      `
            fn roundPixels(position: vec2<f32>, targetSize: vec2<f32>) -> vec2<f32>
            {
                return (floor(((position * 0.5 + 0.5) * targetSize) + 0.5) / targetSize) * 2.0 - 1.0;
            }
        `
    )
  }
}, ws = {
  name: "round-pixels-bit",
  vertex: {
    header: (
      /* glsl */
      `
            vec2 roundPixels(vec2 position, vec2 targetSize)
            {
                return (floor(((position * 0.5 + 0.5) * targetSize) + 0.5) / targetSize) * 2.0 - 1.0;
            }
        `
    )
  }
}, au = {};
function Yh(s) {
  let t = au[s];
  if (t)
    return t;
  const e = new Int32Array(s);
  for (let r = 0; r < s; r++)
    e[r] = r;
  return t = au[s] = new kt({
    uTextures: { value: e, type: "i32", size: s }
  }, { isStatic: !0 }), t;
}
class fw extends ue {
  constructor(t) {
    const e = bs({
      name: "batch",
      bits: [
        Wh,
        $h(t),
        ws
      ]
    }), r = xs({
      name: "batch",
      bits: [
        Hh,
        Vh(t),
        vs
      ]
    });
    super({
      glProgram: e,
      gpuProgram: r,
      resources: {
        batchSamplers: Yh(t)
      }
    });
  }
}
let Fa = null;
const Wp = class Vp extends Vv {
  constructor(t) {
    super(t), this.geometry = new Kv(), this.name = Vp.extension.name, this.vertexSize = 6, Fa ?? (Fa = new fw(t.maxTextures)), this.shader = Fa;
  }
  /**
   * Packs the attributes of a DefaultBatchableMeshElement into the provided views.
   * @param element - The DefaultBatchableMeshElement to pack.
   * @param float32View - The Float32Array view to pack into.
   * @param uint32View - The Uint32Array view to pack into.
   * @param index - The starting index in the views.
   * @param textureId - The texture ID to use.
   */
  packAttributes(t, e, r, n, a) {
    const l = a << 16 | t.roundPixels & 65535, h = t.transform, u = h.a, f = h.b, p = h.c, m = h.d, g = h.tx, x = h.ty, { positions: o, uvs: c } = t, d = t.color, _ = t.attributeOffset, y = _ + t.attributeSize;
    for (let v = _; v < y; v++) {
      const b = v * 2, w = o[b], S = o[b + 1];
      e[n++] = u * w + p * S + g, e[n++] = m * S + f * w + x, e[n++] = c[b], e[n++] = c[b + 1], r[n++] = d, r[n++] = l;
    }
  }
  /**
   * Packs the attributes of a DefaultBatchableQuadElement into the provided views.
   * @param element - The DefaultBatchableQuadElement to pack.
   * @param float32View - The Float32Array view to pack into.
   * @param uint32View - The Uint32Array view to pack into.
   * @param index - The starting index in the views.
   * @param textureId - The texture ID to use.
   */
  packQuadAttributes(t, e, r, n, a) {
    const l = t.texture, h = t.transform, u = h.a, f = h.b, p = h.c, m = h.d, g = h.tx, x = h.ty, o = t.bounds, c = o.maxX, d = o.minX, _ = o.maxY, y = o.minY, v = l.uvs, b = t.color, w = a << 16 | t.roundPixels & 65535;
    e[n + 0] = u * d + p * y + g, e[n + 1] = m * y + f * d + x, e[n + 2] = v.x0, e[n + 3] = v.y0, r[n + 4] = b, r[n + 5] = w, e[n + 6] = u * c + p * y + g, e[n + 7] = m * y + f * c + x, e[n + 8] = v.x1, e[n + 9] = v.y1, r[n + 10] = b, r[n + 11] = w, e[n + 12] = u * c + p * _ + g, e[n + 13] = m * _ + f * c + x, e[n + 14] = v.x2, e[n + 15] = v.y2, r[n + 16] = b, r[n + 17] = w, e[n + 18] = u * d + p * _ + g, e[n + 19] = m * _ + f * d + x, e[n + 20] = v.x3, e[n + 21] = v.y3, r[n + 22] = b, r[n + 23] = w;
  }
};
Wp.extension = {
  type: [
    A.Batcher
  ],
  name: "default"
};
let Xh = Wp;
function pw(s, t, e, r, n, a, l, h = null) {
  let u = 0;
  e *= t, n *= a;
  const f = h.a, p = h.b, m = h.c, g = h.d, x = h.tx, o = h.ty;
  for (; u < l; ) {
    const c = s[e], d = s[e + 1];
    r[n] = f * c + m * d + x, r[n + 1] = p * c + g * d + o, n += a, e += t, u++;
  }
}
function _w(s, t, e, r) {
  let n = 0;
  for (t *= e; n < r; )
    s[t] = 0, s[t + 1] = 0, t += e, n++;
}
function $p(s, t, e, r, n) {
  const a = t.a, l = t.b, h = t.c, u = t.d, f = t.tx, p = t.ty;
  e || (e = 0), r || (r = 2), n || (n = s.length / r - e);
  let m = e * r;
  for (let g = 0; g < n; g++) {
    const x = s[m], o = s[m + 1];
    s[m] = a * x + h * o + f, s[m + 1] = l * x + u * o + p, m += r;
  }
}
const mw = new D();
class jh {
  constructor() {
    this.packAsQuad = !1, this.batcherName = "default", this.topology = "triangle-list", this.applyTransform = !0, this.roundPixels = 0, this._batcher = null, this._batch = null;
  }
  get uvs() {
    return this.geometryData.uvs;
  }
  get positions() {
    return this.geometryData.vertices;
  }
  get indices() {
    return this.geometryData.indices;
  }
  get blendMode() {
    return this.renderable && this.applyTransform ? this.renderable.groupBlendMode : "normal";
  }
  get color() {
    const t = this.baseColor, e = t >> 16 | t & 65280 | (t & 255) << 16, r = this.renderable;
    return r ? qf(e, r.groupColor) + (this.alpha * r.groupAlpha * 255 << 24) : e + (this.alpha * 255 << 24);
  }
  get transform() {
    return this.renderable?.groupTransform || mw;
  }
  copyTo(t) {
    t.indexOffset = this.indexOffset, t.indexSize = this.indexSize, t.attributeOffset = this.attributeOffset, t.attributeSize = this.attributeSize, t.baseColor = this.baseColor, t.alpha = this.alpha, t.texture = this.texture, t.geometryData = this.geometryData, t.topology = this.topology;
  }
  reset() {
    this.applyTransform = !0, this.renderable = null, this.topology = "triangle-list";
  }
}
const ds = {
  extension: {
    type: A.ShapeBuilder,
    name: "circle"
  },
  build(s, t) {
    let e, r, n, a, l, h;
    if (s.type === "circle") {
      const b = s;
      if (l = h = b.radius, l <= 0)
        return !1;
      e = b.x, r = b.y, n = a = 0;
    } else if (s.type === "ellipse") {
      const b = s;
      if (l = b.halfWidth, h = b.halfHeight, l <= 0 || h <= 0)
        return !1;
      e = b.x, r = b.y, n = a = 0;
    } else {
      const b = s, w = b.width / 2, S = b.height / 2;
      e = b.x + w, r = b.y + S, l = h = Math.max(0, Math.min(b.radius, Math.min(w, S))), n = w - l, a = S - h;
    }
    if (n < 0 || a < 0)
      return !1;
    const u = Math.ceil(2.3 * Math.sqrt(l + h)), f = u * 8 + (n ? 4 : 0) + (a ? 4 : 0);
    if (f === 0)
      return !1;
    if (u === 0)
      return t[0] = t[6] = e + n, t[1] = t[3] = r + a, t[2] = t[4] = e - n, t[5] = t[7] = r - a, !0;
    let p = 0, m = u * 4 + (n ? 2 : 0) + 2, g = m, x = f, o = n + l, c = a, d = e + o, _ = e - o, y = r + c;
    if (t[p++] = d, t[p++] = y, t[--m] = y, t[--m] = _, a) {
      const b = r - c;
      t[g++] = _, t[g++] = b, t[--x] = b, t[--x] = d;
    }
    for (let b = 1; b < u; b++) {
      const w = Math.PI / 2 * (b / u), S = n + Math.cos(w) * l, T = a + Math.sin(w) * h, E = e + S, C = e - S, M = r + T, P = r - T;
      t[p++] = E, t[p++] = M, t[--m] = M, t[--m] = C, t[g++] = C, t[g++] = P, t[--x] = P, t[--x] = E;
    }
    o = n, c = a + h, d = e + o, _ = e - o, y = r + c;
    const v = r - c;
    return t[p++] = d, t[p++] = y, t[--x] = v, t[--x] = d, n && (t[p++] = _, t[p++] = y, t[--x] = v, t[--x] = _), !0;
  },
  triangulate(s, t, e, r, n, a) {
    if (s.length === 0)
      return;
    let l = 0, h = 0;
    for (let p = 0; p < s.length; p += 2)
      l += s[p], h += s[p + 1];
    l /= s.length / 2, h /= s.length / 2;
    let u = r;
    t[u * e] = l, t[u * e + 1] = h;
    const f = u++;
    for (let p = 0; p < s.length; p += 2)
      t[u * e] = s[p], t[u * e + 1] = s[p + 1], p > 0 && (n[a++] = u, n[a++] = f, n[a++] = u - 1), u++;
    n[a++] = f + 1, n[a++] = f, n[a++] = u - 1;
  }
}, gw = { ...ds, extension: { ...ds.extension, name: "ellipse" } }, yw = { ...ds, extension: { ...ds.extension, name: "roundedRectangle" } }, Yp = 1e-4, ou = 1e-4;
function xw(s) {
  const t = s.length;
  if (t < 6)
    return 1;
  let e = 0;
  for (let r = 0, n = s[t - 2], a = s[t - 1]; r < t; r += 2) {
    const l = s[r], h = s[r + 1];
    e += (l - n) * (h + a), n = l, a = h;
  }
  return e < 0 ? -1 : 1;
}
function hu(s, t, e, r, n, a, l, h) {
  const u = s - e * n, f = t - r * n, p = s + e * a, m = t + r * a;
  let g, x;
  l ? (g = r, x = -e) : (g = -r, x = e);
  const o = u + g, c = f + x, d = p + g, _ = m + x;
  return h.push(o, c), h.push(d, _), 2;
}
function gi(s, t, e, r, n, a, l, h) {
  const u = e - s, f = r - t;
  let p = Math.atan2(u, f), m = Math.atan2(n - s, a - t);
  h && p < m ? p += Math.PI * 2 : !h && p > m && (m += Math.PI * 2);
  let g = p;
  const x = m - p, o = Math.abs(x), c = Math.sqrt(u * u + f * f), d = (15 * o * Math.sqrt(c) / Math.PI >> 0) + 1, _ = x / d;
  if (g += _, h) {
    l.push(s, t), l.push(e, r);
    for (let y = 1, v = g; y < d; y++, v += _)
      l.push(s, t), l.push(
        s + Math.sin(v) * c,
        t + Math.cos(v) * c
      );
    l.push(s, t), l.push(n, a);
  } else {
    l.push(e, r), l.push(s, t);
    for (let y = 1, v = g; y < d; y++, v += _)
      l.push(
        s + Math.sin(v) * c,
        t + Math.cos(v) * c
      ), l.push(s, t);
    l.push(n, a), l.push(s, t);
  }
  return d * 2;
}
function bw(s, t, e, r, n, a) {
  const l = Yp;
  if (s.length === 0)
    return;
  const h = t;
  let u = h.alignment;
  if (t.alignment !== 0.5) {
    let V = xw(s);
    u = (u - 0.5) * V + 0.5;
  }
  const f = new et(s[0], s[1]), p = new et(s[s.length - 2], s[s.length - 1]), m = r, g = Math.abs(f.x - p.x) < l && Math.abs(f.y - p.y) < l;
  if (m) {
    s = s.slice(), g && (s.pop(), s.pop(), p.set(s[s.length - 2], s[s.length - 1]));
    const V = (f.x + p.x) * 0.5, xt = (p.y + f.y) * 0.5;
    s.unshift(V, xt), s.push(V, xt);
  }
  const x = n, o = s.length / 2;
  let c = s.length;
  const d = x.length / 2, _ = h.width / 2, y = _ * _, v = h.miterLimit * h.miterLimit;
  let b = s[0], w = s[1], S = s[2], T = s[3], E = 0, C = 0, M = -(w - T), P = b - S, B = 0, U = 0, G = Math.sqrt(M * M + P * P);
  M /= G, P /= G, M *= _, P *= _;
  const O = u, R = (1 - O) * 2, I = O * 2;
  m || (h.cap === "round" ? c += gi(
    b - M * (R - I) * 0.5,
    w - P * (R - I) * 0.5,
    b - M * R,
    w - P * R,
    b + M * I,
    w + P * I,
    x,
    !0
  ) + 2 : h.cap === "square" && (c += hu(b, w, M, P, R, I, !0, x))), x.push(
    b - M * R,
    w - P * R
  ), x.push(
    b + M * I,
    w + P * I
  );
  for (let V = 1; V < o - 1; ++V) {
    b = s[(V - 1) * 2], w = s[(V - 1) * 2 + 1], S = s[V * 2], T = s[V * 2 + 1], E = s[(V + 1) * 2], C = s[(V + 1) * 2 + 1], M = -(w - T), P = b - S, G = Math.sqrt(M * M + P * P), M /= G, P /= G, M *= _, P *= _, B = -(T - C), U = S - E, G = Math.sqrt(B * B + U * U), B /= G, U /= G, B *= _, U *= _;
    const xt = S - b, pt = w - T, gt = S - E, H = C - T, ee = xt * gt + pt * H, ie = pt * gt - H * xt, vr = ie < 0;
    if (Math.abs(ie) < 1e-3 * Math.abs(ee)) {
      x.push(
        S - M * R,
        T - P * R
      ), x.push(
        S + M * I,
        T + P * I
      ), ee >= 0 && (h.join === "round" ? c += gi(
        S,
        T,
        S - M * R,
        T - P * R,
        S - B * R,
        T - U * R,
        x,
        !1
      ) + 4 : c += 2, x.push(
        S - B * I,
        T - U * I
      ), x.push(
        S + B * R,
        T + U * R
      ));
      continue;
    }
    const wl = (-M + b) * (-P + T) - (-M + S) * (-P + w), Sl = (-B + E) * (-U + T) - (-B + S) * (-U + C), Cs = (xt * Sl - gt * wl) / ie, Es = (H * wl - pt * Sl) / ie, Xn = (Cs - S) * (Cs - S) + (Es - T) * (Es - T), ui = S + (Cs - S) * R, di = T + (Es - T) * R, fi = S - (Cs - S) * I, pi = T - (Es - T) * I, cg = Math.min(xt * xt + pt * pt, gt * gt + H * H), Tl = vr ? R : I, ug = cg + Tl * Tl * y;
    Xn <= ug ? h.join === "bevel" || Xn / y > v ? (vr ? (x.push(ui, di), x.push(S + M * I, T + P * I), x.push(ui, di), x.push(S + B * I, T + U * I)) : (x.push(S - M * R, T - P * R), x.push(fi, pi), x.push(S - B * R, T - U * R), x.push(fi, pi)), c += 2) : h.join === "round" ? vr ? (x.push(ui, di), x.push(S + M * I, T + P * I), c += gi(
      S,
      T,
      S + M * I,
      T + P * I,
      S + B * I,
      T + U * I,
      x,
      !0
    ) + 4, x.push(ui, di), x.push(S + B * I, T + U * I)) : (x.push(S - M * R, T - P * R), x.push(fi, pi), c += gi(
      S,
      T,
      S - M * R,
      T - P * R,
      S - B * R,
      T - U * R,
      x,
      !1
    ) + 4, x.push(S - B * R, T - U * R), x.push(fi, pi)) : (x.push(ui, di), x.push(fi, pi)) : (x.push(S - M * R, T - P * R), x.push(S + M * I, T + P * I), h.join === "round" ? vr ? c += gi(
      S,
      T,
      S + M * I,
      T + P * I,
      S + B * I,
      T + U * I,
      x,
      !0
    ) + 2 : c += gi(
      S,
      T,
      S - M * R,
      T - P * R,
      S - B * R,
      T - U * R,
      x,
      !1
    ) + 2 : h.join === "miter" && Xn / y <= v && (vr ? (x.push(fi, pi), x.push(fi, pi)) : (x.push(ui, di), x.push(ui, di)), c += 2), x.push(S - B * R, T - U * R), x.push(S + B * I, T + U * I), c += 2);
  }
  b = s[(o - 2) * 2], w = s[(o - 2) * 2 + 1], S = s[(o - 1) * 2], T = s[(o - 1) * 2 + 1], M = -(w - T), P = b - S, G = Math.sqrt(M * M + P * P), M /= G, P /= G, M *= _, P *= _, x.push(S - M * R, T - P * R), x.push(S + M * I, T + P * I), m || (h.cap === "round" ? c += gi(
    S - M * (R - I) * 0.5,
    T - P * (R - I) * 0.5,
    S - M * R,
    T - P * R,
    S + M * I,
    T + P * I,
    x,
    !1
  ) + 2 : h.cap === "square" && (c += hu(S, T, M, P, R, I, !1, x)));
  const st = ou * ou;
  for (let V = d; V < c + d - 2; ++V)
    b = x[V * 2], w = x[V * 2 + 1], S = x[(V + 1) * 2], T = x[(V + 1) * 2 + 1], E = x[(V + 2) * 2], C = x[(V + 2) * 2 + 1], !(Math.abs(b * (T - C) + S * (C - w) + E * (w - T)) < st) && a.push(V, V + 1, V + 2);
}
function vw(s, t, e, r) {
  const n = Yp;
  if (s.length === 0)
    return;
  const a = s[0], l = s[1], h = s[s.length - 2], u = s[s.length - 1], f = t || Math.abs(a - h) < n && Math.abs(l - u) < n, p = e, m = s.length / 2, g = p.length / 2;
  for (let x = 0; x < m; x++)
    p.push(s[x * 2]), p.push(s[x * 2 + 1]);
  for (let x = 0; x < m - 1; x++)
    r.push(g + x, g + x + 1);
  f && r.push(g + m - 1, g);
}
function Xp(s, t, e, r, n, a, l) {
  const h = Sv(s, t, 2);
  if (!h)
    return;
  for (let f = 0; f < h.length; f += 3)
    a[l++] = h[f] + n, a[l++] = h[f + 1] + n, a[l++] = h[f + 2] + n;
  let u = n * r;
  for (let f = 0; f < s.length; f += 2)
    e[u] = s[f], e[u + 1] = s[f + 1], u += r;
}
const ww = [], Sw = {
  extension: {
    type: A.ShapeBuilder,
    name: "polygon"
  },
  build(s, t) {
    for (let e = 0; e < s.points.length; e++)
      t[e] = s.points[e];
    return !0;
  },
  triangulate(s, t, e, r, n, a) {
    Xp(s, ww, t, e, r, n, a);
  }
}, Tw = {
  extension: {
    type: A.ShapeBuilder,
    name: "rectangle"
  },
  build(s, t) {
    const e = s, r = e.x, n = e.y, a = e.width, l = e.height;
    return a > 0 && l > 0 ? (t[0] = r, t[1] = n, t[2] = r + a, t[3] = n, t[4] = r + a, t[5] = n + l, t[6] = r, t[7] = n + l, !0) : !1;
  },
  triangulate(s, t, e, r, n, a) {
    let l = 0;
    r *= e, t[r + l] = s[0], t[r + l + 1] = s[1], l += e, t[r + l] = s[2], t[r + l + 1] = s[3], l += e, t[r + l] = s[6], t[r + l + 1] = s[7], l += e, t[r + l] = s[4], t[r + l + 1] = s[5], l += e;
    const h = r / e;
    n[a++] = h, n[a++] = h + 1, n[a++] = h + 2, n[a++] = h + 1, n[a++] = h + 3, n[a++] = h + 2;
  }
}, Cw = {
  extension: {
    type: A.ShapeBuilder,
    name: "triangle"
  },
  build(s, t) {
    return t[0] = s.x, t[1] = s.y, t[2] = s.x2, t[3] = s.y2, t[4] = s.x3, t[5] = s.y3, !0;
  },
  triangulate(s, t, e, r, n, a) {
    let l = 0;
    r *= e, t[r + l] = s[0], t[r + l + 1] = s[1], l += e, t[r + l] = s[2], t[r + l + 1] = s[3], l += e, t[r + l] = s[4], t[r + l + 1] = s[5];
    const h = r / e;
    n[a++] = h, n[a++] = h + 1, n[a++] = h + 2;
  }
}, Ew = new D(), Aw = new Z();
function Pw(s, t, e, r) {
  const n = t.matrix ? s.copyFrom(t.matrix).invert() : s.identity();
  if (t.textureSpace === "local") {
    const l = e.getBounds(Aw);
    t.width && l.pad(t.width);
    const { x: h, y: u } = l, f = 1 / l.width, p = 1 / l.height, m = -h * f, g = -u * p, x = n.a, o = n.b, c = n.c, d = n.d;
    n.a *= f, n.b *= f, n.c *= p, n.d *= p, n.tx = m * x + g * c + n.tx, n.ty = m * o + g * d + n.ty;
  } else
    n.translate(t.texture.frame.x, t.texture.frame.y), n.scale(1 / t.texture.source.width, 1 / t.texture.source.height);
  const a = t.texture.source.style;
  return !(t.fill instanceof Ue) && a.addressMode === "clamp-to-edge" && (a.addressMode = "repeat", a.update()), r && n.append(Ew.copyFrom(r).invert()), n;
}
const Vn = {};
L.handleByMap(A.ShapeBuilder, Vn);
L.add(Tw, Sw, Cw, ds, gw, yw);
const Mw = new Z(), Bw = new D();
function Uw(s, t) {
  const { geometryData: e, batches: r } = t;
  r.length = 0, e.indices.length = 0, e.vertices.length = 0, e.uvs.length = 0;
  for (let n = 0; n < s.instructions.length; n++) {
    const a = s.instructions[n];
    if (a.action === "texture")
      Rw(a.data, r, e);
    else if (a.action === "fill" || a.action === "stroke") {
      const l = a.action === "stroke", h = a.data.path.shapePath, u = a.data.style, f = a.data.hole;
      l && f && lu(f.shapePath, u, !0, r, e), f && (h.shapePrimitives[h.shapePrimitives.length - 1].holes = f.shapePath.shapePrimitives), lu(h, u, l, r, e);
    }
  }
}
function Rw(s, t, e) {
  const r = [], n = Vn.rectangle, a = Mw;
  a.x = s.dx, a.y = s.dy, a.width = s.dw, a.height = s.dh;
  const l = s.transform;
  if (!n.build(a, r))
    return;
  const { vertices: h, uvs: u, indices: f } = e, p = f.length, m = h.length / 2;
  l && $p(r, l), n.triangulate(r, h, 2, m, f, p);
  const g = s.image, x = g.uvs;
  u.push(
    x.x0,
    x.y0,
    x.x1,
    x.y1,
    x.x3,
    x.y3,
    x.x2,
    x.y2
  );
  const o = Ct.get(jh);
  o.indexOffset = p, o.indexSize = f.length - p, o.attributeOffset = m, o.attributeSize = h.length / 2 - m, o.baseColor = s.style, o.alpha = s.alpha, o.texture = g, o.geometryData = e, t.push(o);
}
function lu(s, t, e, r, n) {
  const { vertices: a, uvs: l, indices: h } = n;
  s.shapePrimitives.forEach(({ shape: u, transform: f, holes: p }) => {
    const m = [], g = Vn[u.type];
    if (!g.build(u, m))
      return;
    const x = h.length, o = a.length / 2;
    let c = "triangle-list";
    if (f && $p(m, f), e) {
      const v = u.closePath ?? !0, b = t;
      b.pixelLine ? (vw(m, v, a, h), c = "line-list") : bw(m, b, !1, v, a, h);
    } else if (p) {
      const v = [], b = m.slice();
      Iw(p).forEach((S) => {
        v.push(b.length / 2), b.push(...S);
      }), Xp(b, v, a, 2, o, h, x);
    } else
      g.triangulate(m, a, 2, o, h, x);
    const d = l.length / 2, _ = t.texture;
    if (_ !== k.WHITE) {
      const v = Pw(Bw, t, u, f);
      pw(a, 2, o, l, d, 2, a.length / 2 - o, v);
    } else
      _w(l, d, 2, a.length / 2 - o);
    const y = Ct.get(jh);
    y.indexOffset = x, y.indexSize = h.length - x, y.attributeOffset = o, y.attributeSize = a.length / 2 - o, y.baseColor = t.color, y.alpha = t.alpha, y.texture = _, y.geometryData = n, y.topology = c, r.push(y);
  });
}
function Iw(s) {
  const t = [];
  for (let e = 0; e < s.length; e++) {
    const r = s[e].shape, n = [];
    Vn[r.type].build(r, n) && t.push(n);
  }
  return t;
}
class kw {
  constructor() {
    this.batches = [], this.geometryData = {
      vertices: [],
      uvs: [],
      indices: []
    };
  }
}
class Fw {
  constructor() {
    this.instructions = new Jf();
  }
  init(t) {
    this.batcher = new Xh({
      maxTextures: t
    }), this.instructions.reset();
  }
  /**
   * @deprecated since version 8.0.0
   * Use `batcher.geometry` instead.
   * @see {Batcher#geometry}
   */
  get geometry() {
    return W(H0, "GraphicsContextRenderData#geometry is deprecated, please use batcher.geometry instead."), this.batcher.geometry;
  }
}
const Kh = class Wo {
  constructor(t) {
    this._gpuContextHash = {}, this._graphicsDataContextHash = /* @__PURE__ */ Object.create(null), this._renderer = t, t.renderableGC.addManagedHash(this, "_gpuContextHash"), t.renderableGC.addManagedHash(this, "_graphicsDataContextHash");
  }
  /**
   * Runner init called, update the default options
   * @ignore
   */
  init(t) {
    Wo.defaultOptions.bezierSmoothness = t?.bezierSmoothness ?? Wo.defaultOptions.bezierSmoothness;
  }
  /**
   * Returns the render data for a given GraphicsContext.
   * @param context - The GraphicsContext to get the render data for.
   * @internal
   */
  getContextRenderData(t) {
    return this._graphicsDataContextHash[t.uid] || this._initContextRenderData(t);
  }
  /**
   * Updates the GPU context for a given GraphicsContext.
   * If the context is dirty, it will rebuild the batches and geometry data.
   * @param context - The GraphicsContext to update.
   * @returns The updated GpuGraphicsContext.
   * @internal
   */
  updateGpuContext(t) {
    let e = this._gpuContextHash[t.uid] || this._initContext(t);
    if (t.dirty) {
      e ? this._cleanGraphicsContextData(t) : e = this._initContext(t), Uw(t, e);
      const r = t.batchMode;
      t.customShader || r === "no-batch" ? e.isBatchable = !1 : r === "auto" ? e.isBatchable = e.geometryData.vertices.length < 400 : e.isBatchable = !0, t.dirty = !1;
    }
    return e;
  }
  /**
   * Returns the GpuGraphicsContext for a given GraphicsContext.
   * If it does not exist, it will initialize a new one.
   * @param context - The GraphicsContext to get the GpuGraphicsContext for.
   * @returns The GpuGraphicsContext for the given GraphicsContext.
   * @internal
   */
  getGpuContext(t) {
    return this._gpuContextHash[t.uid] || this._initContext(t);
  }
  _initContextRenderData(t) {
    const e = Ct.get(Fw, {
      maxTextures: this._renderer.limits.maxBatchableTextures
    }), { batches: r, geometryData: n } = this._gpuContextHash[t.uid], a = n.vertices.length, l = n.indices.length;
    for (let p = 0; p < r.length; p++)
      r[p].applyTransform = !1;
    const h = e.batcher;
    h.ensureAttributeBuffer(a), h.ensureIndexBuffer(l), h.begin();
    for (let p = 0; p < r.length; p++) {
      const m = r[p];
      h.add(m);
    }
    h.finish(e.instructions);
    const u = h.geometry;
    u.indexBuffer.setDataWithSize(h.indexBuffer, h.indexSize, !0), u.buffers[0].setDataWithSize(h.attributeBuffer.float32View, h.attributeSize, !0);
    const f = h.batches;
    for (let p = 0; p < f.length; p++) {
      const m = f[p];
      m.bindGroup = Nh(
        m.textures.textures,
        m.textures.count,
        this._renderer.limits.maxBatchableTextures
      );
    }
    return this._graphicsDataContextHash[t.uid] = e, e;
  }
  _initContext(t) {
    const e = new kw();
    return e.context = t, this._gpuContextHash[t.uid] = e, t.on("destroy", this.onGraphicsContextDestroy, this), this._gpuContextHash[t.uid];
  }
  onGraphicsContextDestroy(t) {
    this._cleanGraphicsContextData(t), t.off("destroy", this.onGraphicsContextDestroy, this), this._gpuContextHash[t.uid] = null;
  }
  _cleanGraphicsContextData(t) {
    const e = this._gpuContextHash[t.uid];
    e.isBatchable || this._graphicsDataContextHash[t.uid] && (Ct.return(this.getContextRenderData(t)), this._graphicsDataContextHash[t.uid] = null), e.batches && e.batches.forEach((r) => {
      Ct.return(r);
    });
  }
  destroy() {
    for (const t in this._gpuContextHash)
      this._gpuContextHash[t] && this.onGraphicsContextDestroy(this._gpuContextHash[t].context);
  }
};
Kh.extension = {
  type: [
    A.WebGLSystem,
    A.WebGPUSystem,
    A.CanvasSystem
  ],
  name: "graphicsContext"
};
Kh.defaultOptions = {
  /**
   * A value from 0 to 1 that controls the smoothness of bezier curves (the higher the smoother)
   * @default 0.5
   */
  bezierSmoothness: 0.5
};
let qh = Kh;
const Dw = 8, Ws = 11920929e-14, Ow = 1;
function jp(s, t, e, r, n, a, l, h, u, f) {
  const m = Math.min(
    0.99,
    // a value of 1.0 actually inverts smoothing, so we cap it at 0.99
    Math.max(0, f ?? qh.defaultOptions.bezierSmoothness)
  );
  let g = (Ow - m) / 1;
  return g *= g, Lw(t, e, r, n, a, l, h, u, s, g), s;
}
function Lw(s, t, e, r, n, a, l, h, u, f) {
  Vo(s, t, e, r, n, a, l, h, u, f, 0), u.push(l, h);
}
function Vo(s, t, e, r, n, a, l, h, u, f, p) {
  if (p > Dw)
    return;
  const m = (s + e) / 2, g = (t + r) / 2, x = (e + n) / 2, o = (r + a) / 2, c = (n + l) / 2, d = (a + h) / 2, _ = (m + x) / 2, y = (g + o) / 2, v = (x + c) / 2, b = (o + d) / 2, w = (_ + v) / 2, S = (y + b) / 2;
  if (p > 0) {
    let T = l - s, E = h - t;
    const C = Math.abs((e - l) * E - (r - h) * T), M = Math.abs((n - l) * E - (a - h) * T);
    if (C > Ws && M > Ws) {
      if ((C + M) * (C + M) <= f * (T * T + E * E)) {
        u.push(w, S);
        return;
      }
    } else if (C > Ws) {
      if (C * C <= f * (T * T + E * E)) {
        u.push(w, S);
        return;
      }
    } else if (M > Ws) {
      if (M * M <= f * (T * T + E * E)) {
        u.push(w, S);
        return;
      }
    } else if (T = w - (s + l) / 2, E = S - (t + h) / 2, T * T + E * E <= f) {
      u.push(w, S);
      return;
    }
  }
  Vo(s, t, m, g, _, y, w, S, u, f, p + 1), Vo(w, S, v, b, c, d, l, h, u, f, p + 1);
}
const Gw = 8, zw = 11920929e-14, Nw = 1;
function Hw(s, t, e, r, n, a, l, h) {
  const f = Math.min(
    0.99,
    // a value of 1.0 actually inverts smoothing, so we cap it at 0.99
    Math.max(0, h ?? qh.defaultOptions.bezierSmoothness)
  );
  let p = (Nw - f) / 1;
  return p *= p, Ww(t, e, r, n, a, l, s, p), s;
}
function Ww(s, t, e, r, n, a, l, h) {
  $o(l, s, t, e, r, n, a, h, 0), l.push(n, a);
}
function $o(s, t, e, r, n, a, l, h, u) {
  if (u > Gw)
    return;
  const f = (t + r) / 2, p = (e + n) / 2, m = (r + a) / 2, g = (n + l) / 2, x = (f + m) / 2, o = (p + g) / 2;
  let c = a - t, d = l - e;
  const _ = Math.abs((r - a) * d - (n - l) * c);
  if (_ > zw) {
    if (_ * _ <= h * (c * c + d * d)) {
      s.push(x, o);
      return;
    }
  } else if (c = x - (t + a) / 2, d = o - (e + l) / 2, c * c + d * d <= h) {
    s.push(x, o);
    return;
  }
  $o(s, t, e, f, p, x, o, h, u + 1), $o(s, x, o, m, g, a, l, h, u + 1);
}
function Kp(s, t, e, r, n, a, l, h) {
  let u = Math.abs(n - a);
  (!l && n > a || l && a > n) && (u = 2 * Math.PI - u), h || (h = Math.max(6, Math.floor(6 * Math.pow(r, 1 / 3) * (u / Math.PI)))), h = Math.max(h, 3);
  let f = u / h, p = n;
  f *= l ? -1 : 1;
  for (let m = 0; m < h + 1; m++) {
    const g = Math.cos(p), x = Math.sin(p), o = t + g * r, c = e + x * r;
    s.push(o, c), p += f;
  }
}
function Vw(s, t, e, r, n, a) {
  const l = s[s.length - 2], u = s[s.length - 1] - e, f = l - t, p = n - e, m = r - t, g = Math.abs(u * m - f * p);
  if (g < 1e-8 || a === 0) {
    (s[s.length - 2] !== t || s[s.length - 1] !== e) && s.push(t, e);
    return;
  }
  const x = u * u + f * f, o = p * p + m * m, c = u * p + f * m, d = a * Math.sqrt(x) / g, _ = a * Math.sqrt(o) / g, y = d * c / x, v = _ * c / o, b = d * m + _ * f, w = d * p + _ * u, S = f * (_ + y), T = u * (_ + y), E = m * (d + v), C = p * (d + v), M = Math.atan2(T - w, S - b), P = Math.atan2(C - w, E - b);
  Kp(
    s,
    b + t,
    w + e,
    a,
    M,
    P,
    f * p > m * u
  );
}
const jr = Math.PI * 2, Da = {
  centerX: 0,
  centerY: 0,
  ang1: 0,
  ang2: 0
}, Oa = ({ x: s, y: t }, e, r, n, a, l, h, u) => {
  s *= e, t *= r;
  const f = n * s - a * t, p = a * s + n * t;
  return u.x = f + l, u.y = p + h, u;
};
function $w(s, t) {
  const e = t === -1.5707963267948966 ? -0.551915024494 : 1.3333333333333333 * Math.tan(t / 4), r = t === 1.5707963267948966 ? 0.551915024494 : e, n = Math.cos(s), a = Math.sin(s), l = Math.cos(s + t), h = Math.sin(s + t);
  return [
    {
      x: n - a * r,
      y: a + n * r
    },
    {
      x: l + h * r,
      y: h - l * r
    },
    {
      x: l,
      y: h
    }
  ];
}
const cu = (s, t, e, r) => {
  const n = s * r - t * e < 0 ? -1 : 1;
  let a = s * e + t * r;
  return a > 1 && (a = 1), a < -1 && (a = -1), n * Math.acos(a);
}, Yw = (s, t, e, r, n, a, l, h, u, f, p, m, g) => {
  const x = Math.pow(n, 2), o = Math.pow(a, 2), c = Math.pow(p, 2), d = Math.pow(m, 2);
  let _ = x * o - x * d - o * c;
  _ < 0 && (_ = 0), _ /= x * d + o * c, _ = Math.sqrt(_) * (l === h ? -1 : 1);
  const y = _ * n / a * m, v = _ * -a / n * p, b = f * y - u * v + (s + e) / 2, w = u * y + f * v + (t + r) / 2, S = (p - y) / n, T = (m - v) / a, E = (-p - y) / n, C = (-m - v) / a, M = cu(1, 0, S, T);
  let P = cu(S, T, E, C);
  h === 0 && P > 0 && (P -= jr), h === 1 && P < 0 && (P += jr), g.centerX = b, g.centerY = w, g.ang1 = M, g.ang2 = P;
};
function Xw(s, t, e, r, n, a, l, h = 0, u = 0, f = 0) {
  if (a === 0 || l === 0)
    return;
  const p = Math.sin(h * jr / 360), m = Math.cos(h * jr / 360), g = m * (t - r) / 2 + p * (e - n) / 2, x = -p * (t - r) / 2 + m * (e - n) / 2;
  if (g === 0 && x === 0)
    return;
  a = Math.abs(a), l = Math.abs(l);
  const o = Math.pow(g, 2) / Math.pow(a, 2) + Math.pow(x, 2) / Math.pow(l, 2);
  o > 1 && (a *= Math.sqrt(o), l *= Math.sqrt(o)), Yw(
    t,
    e,
    r,
    n,
    a,
    l,
    u,
    f,
    p,
    m,
    g,
    x,
    Da
  );
  let { ang1: c, ang2: d } = Da;
  const { centerX: _, centerY: y } = Da;
  let v = Math.abs(d) / (jr / 4);
  Math.abs(1 - v) < 1e-7 && (v = 1);
  const b = Math.max(Math.ceil(v), 1);
  d /= b;
  let w = s[s.length - 2], S = s[s.length - 1];
  const T = { x: 0, y: 0 };
  for (let E = 0; E < b; E++) {
    const C = $w(c, d), { x: M, y: P } = Oa(C[0], a, l, m, p, _, y, T), { x: B, y: U } = Oa(C[1], a, l, m, p, _, y, T), { x: G, y: O } = Oa(C[2], a, l, m, p, _, y, T);
    jp(
      s,
      w,
      S,
      M,
      P,
      B,
      U,
      G,
      O
    ), w = G, S = O, c += d;
  }
}
function jw(s, t, e) {
  const r = (l, h) => {
    const u = h.x - l.x, f = h.y - l.y, p = Math.sqrt(u * u + f * f), m = u / p, g = f / p;
    return { len: p, nx: m, ny: g };
  }, n = (l, h) => {
    l === 0 ? s.moveTo(h.x, h.y) : s.lineTo(h.x, h.y);
  };
  let a = t[t.length - 1];
  for (let l = 0; l < t.length; l++) {
    const h = t[l % t.length], u = h.radius ?? e;
    if (u <= 0) {
      n(l, h), a = h;
      continue;
    }
    const f = t[(l + 1) % t.length], p = r(h, a), m = r(h, f);
    if (p.len < 1e-4 || m.len < 1e-4) {
      n(l, h), a = h;
      continue;
    }
    let g = Math.asin(p.nx * m.ny - p.ny * m.nx), x = 1, o = !1;
    p.nx * m.nx - p.ny * -m.ny < 0 ? g < 0 ? g = Math.PI + g : (g = Math.PI - g, x = -1, o = !0) : g > 0 && (x = -1, o = !0);
    const c = g / 2;
    let d, _ = Math.abs(
      Math.cos(c) * u / Math.sin(c)
    );
    _ > Math.min(p.len / 2, m.len / 2) ? (_ = Math.min(p.len / 2, m.len / 2), d = Math.abs(_ * Math.sin(c) / Math.cos(c))) : d = u;
    const y = h.x + m.nx * _ + -m.ny * d * x, v = h.y + m.ny * _ + m.nx * d * x, b = Math.atan2(p.ny, p.nx) + Math.PI / 2 * x, w = Math.atan2(m.ny, m.nx) - Math.PI / 2 * x;
    l === 0 && s.moveTo(
      y + Math.cos(b) * d,
      v + Math.sin(b) * d
    ), s.arc(y, v, d, b, w, o), a = h;
  }
}
function Kw(s, t, e, r) {
  const n = (h, u) => Math.sqrt((h.x - u.x) ** 2 + (h.y - u.y) ** 2), a = (h, u, f) => ({
    x: h.x + (u.x - h.x) * f,
    y: h.y + (u.y - h.y) * f
  }), l = t.length;
  for (let h = 0; h < l; h++) {
    const u = t[(h + 1) % l], f = u.radius ?? e;
    if (f <= 0) {
      h === 0 ? s.moveTo(u.x, u.y) : s.lineTo(u.x, u.y);
      continue;
    }
    const p = t[h], m = t[(h + 2) % l], g = n(p, u);
    let x;
    if (g < 1e-4)
      x = u;
    else {
      const d = Math.min(g / 2, f);
      x = a(
        u,
        p,
        d / g
      );
    }
    const o = n(m, u);
    let c;
    if (o < 1e-4)
      c = u;
    else {
      const d = Math.min(o / 2, f);
      c = a(
        u,
        m,
        d / o
      );
    }
    h === 0 ? s.moveTo(x.x, x.y) : s.lineTo(x.x, x.y), s.quadraticCurveTo(u.x, u.y, c.x, c.y, r);
  }
}
const qw = new Z();
class Zw {
  constructor(t) {
    this.shapePrimitives = [], this._currentPoly = null, this._bounds = new Ut(), this._graphicsPath2D = t, this.signed = t.checkForHoles;
  }
  /**
   * Sets the starting point for a new sub-path. Any subsequent drawing commands are considered part of this path.
   * @param x - The x-coordinate for the starting point.
   * @param y - The y-coordinate for the starting point.
   * @returns The instance of the current object for chaining.
   */
  moveTo(t, e) {
    return this.startPoly(t, e), this;
  }
  /**
   * Connects the current point to a new point with a straight line. This method updates the current path.
   * @param x - The x-coordinate of the new point to connect to.
   * @param y - The y-coordinate of the new point to connect to.
   * @returns The instance of the current object for chaining.
   */
  lineTo(t, e) {
    this._ensurePoly();
    const r = this._currentPoly.points, n = r[r.length - 2], a = r[r.length - 1];
    return (n !== t || a !== e) && r.push(t, e), this;
  }
  /**
   * Adds an arc to the path. The arc is centered at (x, y)
   *  position with radius `radius` starting at `startAngle` and ending at `endAngle`.
   * @param x - The x-coordinate of the arc's center.
   * @param y - The y-coordinate of the arc's center.
   * @param radius - The radius of the arc.
   * @param startAngle - The starting angle of the arc, in radians.
   * @param endAngle - The ending angle of the arc, in radians.
   * @param counterclockwise - Specifies whether the arc should be drawn in the anticlockwise direction. False by default.
   * @returns The instance of the current object for chaining.
   */
  arc(t, e, r, n, a, l) {
    this._ensurePoly(!1);
    const h = this._currentPoly.points;
    return Kp(h, t, e, r, n, a, l), this;
  }
  /**
   * Adds an arc to the path with the arc tangent to the line joining two specified points.
   * The arc radius is specified by `radius`.
   * @param x1 - The x-coordinate of the first point.
   * @param y1 - The y-coordinate of the first point.
   * @param x2 - The x-coordinate of the second point.
   * @param y2 - The y-coordinate of the second point.
   * @param radius - The radius of the arc.
   * @returns The instance of the current object for chaining.
   */
  arcTo(t, e, r, n, a) {
    this._ensurePoly();
    const l = this._currentPoly.points;
    return Vw(l, t, e, r, n, a), this;
  }
  /**
   * Adds an SVG-style arc to the path, allowing for elliptical arcs based on the SVG spec.
   * @param rx - The x-radius of the ellipse.
   * @param ry - The y-radius of the ellipse.
   * @param xAxisRotation - The rotation of the ellipse's x-axis relative
   * to the x-axis of the coordinate system, in degrees.
   * @param largeArcFlag - Determines if the arc should be greater than or less than 180 degrees.
   * @param sweepFlag - Determines if the arc should be swept in a positive angle direction.
   * @param x - The x-coordinate of the arc's end point.
   * @param y - The y-coordinate of the arc's end point.
   * @returns The instance of the current object for chaining.
   */
  arcToSvg(t, e, r, n, a, l, h) {
    const u = this._currentPoly.points;
    return Xw(
      u,
      this._currentPoly.lastX,
      this._currentPoly.lastY,
      l,
      h,
      t,
      e,
      r,
      n,
      a
    ), this;
  }
  /**
   * Adds a cubic Bezier curve to the path.
   * It requires three points: the first two are control points and the third one is the end point.
   * The starting point is the last point in the current path.
   * @param cp1x - The x-coordinate of the first control point.
   * @param cp1y - The y-coordinate of the first control point.
   * @param cp2x - The x-coordinate of the second control point.
   * @param cp2y - The y-coordinate of the second control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */
  bezierCurveTo(t, e, r, n, a, l, h) {
    this._ensurePoly();
    const u = this._currentPoly;
    return jp(
      this._currentPoly.points,
      u.lastX,
      u.lastY,
      t,
      e,
      r,
      n,
      a,
      l,
      h
    ), this;
  }
  /**
   * Adds a quadratic curve to the path. It requires two points: the control point and the end point.
   * The starting point is the last point in the current path.
   * @param cp1x - The x-coordinate of the control point.
   * @param cp1y - The y-coordinate of the control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothing - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */
  quadraticCurveTo(t, e, r, n, a) {
    this._ensurePoly();
    const l = this._currentPoly;
    return Hw(
      this._currentPoly.points,
      l.lastX,
      l.lastY,
      t,
      e,
      r,
      n,
      a
    ), this;
  }
  /**
   * Closes the current path by drawing a straight line back to the start.
   * If the shape is already closed or there are no points in the path, this method does nothing.
   * @returns The instance of the current object for chaining.
   */
  closePath() {
    return this.endPoly(!0), this;
  }
  /**
   * Adds another path to the current path. This method allows for the combination of multiple paths into one.
   * @param path - The `GraphicsPath` object representing the path to add.
   * @param transform - An optional `Matrix` object to apply a transformation to the path before adding it.
   * @returns The instance of the current object for chaining.
   */
  addPath(t, e) {
    this.endPoly(), e && !e.isIdentity() && (t = t.clone(!0), t.transform(e));
    const r = this.shapePrimitives, n = r.length;
    for (let a = 0; a < t.instructions.length; a++) {
      const l = t.instructions[a];
      this[l.action](...l.data);
    }
    if (t.checkForHoles && r.length - n > 1) {
      let a = null;
      for (let l = n; l < r.length; l++) {
        const h = r[l];
        if (h.shape.type === "polygon") {
          const u = h.shape, f = a?.shape;
          f && f.containsPolygon(u) ? (a.holes || (a.holes = []), a.holes.push(h), r.copyWithin(l, l + 1), r.length--, l--) : a = h;
        }
      }
    }
    return this;
  }
  /**
   * Finalizes the drawing of the current path. Optionally, it can close the path.
   * @param closePath - A boolean indicating whether to close the path after finishing. False by default.
   */
  finish(t = !1) {
    this.endPoly(t);
  }
  /**
   * Draws a rectangle shape. This method adds a new rectangle path to the current drawing.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @param transform - An optional `Matrix` object to apply a transformation to the rectangle.
   * @returns The instance of the current object for chaining.
   */
  rect(t, e, r, n, a) {
    return this.drawShape(new Z(t, e, r, n), a), this;
  }
  /**
   * Draws a circle shape. This method adds a new circle path to the current drawing.
   * @param x - The x-coordinate of the center of the circle.
   * @param y - The y-coordinate of the center of the circle.
   * @param radius - The radius of the circle.
   * @param transform - An optional `Matrix` object to apply a transformation to the circle.
   * @returns The instance of the current object for chaining.
   */
  circle(t, e, r, n) {
    return this.drawShape(new Lh(t, e, r), n), this;
  }
  /**
   * Draws a polygon shape. This method allows for the creation of complex polygons by specifying a sequence of points.
   * @param points - An array of numbers, or or an array of PointData objects eg [{x,y}, {x,y}, {x,y}]
   * representing the x and y coordinates of the polygon's vertices, in sequence.
   * @param close - A boolean indicating whether to close the polygon path. True by default.
   * @param transform - An optional `Matrix` object to apply a transformation to the polygon.
   * @returns The instance of the current object for chaining.
   */
  poly(t, e, r) {
    const n = new Xr(t);
    return n.closePath = e, this.drawShape(n, r), this;
  }
  /**
   * Draws a regular polygon with a specified number of sides. All sides and angles are equal.
   * @param x - The x-coordinate of the center of the polygon.
   * @param y - The y-coordinate of the center of the polygon.
   * @param radius - The radius of the circumscribed circle of the polygon.
   * @param sides - The number of sides of the polygon. Must be 3 or more.
   * @param rotation - The rotation angle of the polygon, in radians. Zero by default.
   * @param transform - An optional `Matrix` object to apply a transformation to the polygon.
   * @returns The instance of the current object for chaining.
   */
  regularPoly(t, e, r, n, a = 0, l) {
    n = Math.max(n | 0, 3);
    const h = -1 * Math.PI / 2 + a, u = Math.PI * 2 / n, f = [];
    for (let p = 0; p < n; p++) {
      const m = h - p * u;
      f.push(
        t + r * Math.cos(m),
        e + r * Math.sin(m)
      );
    }
    return this.poly(f, !0, l), this;
  }
  /**
   * Draws a polygon with rounded corners.
   * Similar to `regularPoly` but with the ability to round the corners of the polygon.
   * @param x - The x-coordinate of the center of the polygon.
   * @param y - The y-coordinate of the center of the polygon.
   * @param radius - The radius of the circumscribed circle of the polygon.
   * @param sides - The number of sides of the polygon. Must be 3 or more.
   * @param corner - The radius of the rounding of the corners.
   * @param rotation - The rotation angle of the polygon, in radians. Zero by default.
   * @param smoothness - Optional parameter to adjust the smoothness of the rounding.
   * @returns The instance of the current object for chaining.
   */
  roundPoly(t, e, r, n, a, l = 0, h) {
    if (n = Math.max(n | 0, 3), a <= 0)
      return this.regularPoly(t, e, r, n, l);
    const u = r * Math.sin(Math.PI / n) - 1e-3;
    a = Math.min(a, u);
    const f = -1 * Math.PI / 2 + l, p = Math.PI * 2 / n, m = (n - 2) * Math.PI / n / 2;
    for (let g = 0; g < n; g++) {
      const x = g * p + f, o = t + r * Math.cos(x), c = e + r * Math.sin(x), d = x + Math.PI + m, _ = x - Math.PI - m, y = o + a * Math.cos(d), v = c + a * Math.sin(d), b = o + a * Math.cos(_), w = c + a * Math.sin(_);
      g === 0 ? this.moveTo(y, v) : this.lineTo(y, v), this.quadraticCurveTo(o, c, b, w, h);
    }
    return this.closePath();
  }
  /**
   * Draws a shape with rounded corners. This function supports custom radius for each corner of the shape.
   * Optionally, corners can be rounded using a quadratic curve instead of an arc, providing a different aesthetic.
   * @param points - An array of `RoundedPoint` representing the corners of the shape to draw.
   * A minimum of 3 points is required.
   * @param radius - The default radius for the corners.
   * This radius is applied to all corners unless overridden in `points`.
   * @param useQuadratic - If set to true, rounded corners are drawn using a quadraticCurve
   *  method instead of an arc method. Defaults to false.
   * @param smoothness - Specifies the smoothness of the curve when `useQuadratic` is true.
   * Higher values make the curve smoother.
   * @returns The instance of the current object for chaining.
   */
  roundShape(t, e, r = !1, n) {
    return t.length < 3 ? this : (r ? Kw(this, t, e, n) : jw(this, t, e), this.closePath());
  }
  /**
   * Draw Rectangle with fillet corners. This is much like rounded rectangle
   * however it support negative numbers as well for the corner radius.
   * @param x - Upper left corner of rect
   * @param y - Upper right corner of rect
   * @param width - Width of rect
   * @param height - Height of rect
   * @param fillet - accept negative or positive values
   */
  filletRect(t, e, r, n, a) {
    if (a === 0)
      return this.rect(t, e, r, n);
    const l = Math.min(r, n) / 2, h = Math.min(l, Math.max(-l, a)), u = t + r, f = e + n, p = h < 0 ? -h : 0, m = Math.abs(h);
    return this.moveTo(t, e + m).arcTo(t + p, e + p, t + m, e, m).lineTo(u - m, e).arcTo(u - p, e + p, u, e + m, m).lineTo(u, f - m).arcTo(u - p, f - p, t + r - m, f, m).lineTo(t + m, f).arcTo(t + p, f - p, t, f - m, m).closePath();
  }
  /**
   * Draw Rectangle with chamfer corners. These are angled corners.
   * @param x - Upper left corner of rect
   * @param y - Upper right corner of rect
   * @param width - Width of rect
   * @param height - Height of rect
   * @param chamfer - non-zero real number, size of corner cutout
   * @param transform
   */
  chamferRect(t, e, r, n, a, l) {
    if (a <= 0)
      return this.rect(t, e, r, n);
    const h = Math.min(a, Math.min(r, n) / 2), u = t + r, f = e + n, p = [
      t + h,
      e,
      u - h,
      e,
      u,
      e + h,
      u,
      f - h,
      u - h,
      f,
      t + h,
      f,
      t,
      f - h,
      t,
      e + h
    ];
    for (let m = p.length - 1; m >= 2; m -= 2)
      p[m] === p[m - 2] && p[m - 1] === p[m - 3] && p.splice(m - 1, 2);
    return this.poly(p, !0, l);
  }
  /**
   * Draws an ellipse at the specified location and with the given x and y radii.
   * An optional transformation can be applied, allowing for rotation, scaling, and translation.
   * @param x - The x-coordinate of the center of the ellipse.
   * @param y - The y-coordinate of the center of the ellipse.
   * @param radiusX - The horizontal radius of the ellipse.
   * @param radiusY - The vertical radius of the ellipse.
   * @param transform - An optional `Matrix` object to apply a transformation to the ellipse. This can include rotations.
   * @returns The instance of the current object for chaining.
   */
  ellipse(t, e, r, n, a) {
    return this.drawShape(new Gh(t, e, r, n), a), this;
  }
  /**
   * Draws a rectangle with rounded corners.
   * The corner radius can be specified to determine how rounded the corners should be.
   * An optional transformation can be applied, which allows for rotation, scaling, and translation of the rectangle.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @param radius - The radius of the rectangle's corners. If not specified, corners will be sharp.
   * @param transform - An optional `Matrix` object to apply a transformation to the rectangle.
   * @returns The instance of the current object for chaining.
   */
  roundRect(t, e, r, n, a, l) {
    return this.drawShape(new zh(t, e, r, n, a), l), this;
  }
  /**
   * Draws a given shape on the canvas.
   * This is a generic method that can draw any type of shape specified by the `ShapePrimitive` parameter.
   * An optional transformation matrix can be applied to the shape, allowing for complex transformations.
   * @param shape - The shape to draw, defined as a `ShapePrimitive` object.
   * @param matrix - An optional `Matrix` for transforming the shape. This can include rotations,
   * scaling, and translations.
   * @returns The instance of the current object for chaining.
   */
  drawShape(t, e) {
    return this.endPoly(), this.shapePrimitives.push({ shape: t, transform: e }), this;
  }
  /**
   * Starts a new polygon path from the specified starting point.
   * This method initializes a new polygon or ends the current one if it exists.
   * @param x - The x-coordinate of the starting point of the new polygon.
   * @param y - The y-coordinate of the starting point of the new polygon.
   * @returns The instance of the current object for chaining.
   */
  startPoly(t, e) {
    let r = this._currentPoly;
    return r && this.endPoly(), r = new Xr(), r.points.push(t, e), this._currentPoly = r, this;
  }
  /**
   * Ends the current polygon path. If `closePath` is set to true,
   * the path is closed by connecting the last point to the first one.
   * This method finalizes the current polygon and prepares it for drawing or adding to the shape primitives.
   * @param closePath - A boolean indicating whether to close the polygon by connecting the last point
   *  back to the starting point. False by default.
   * @returns The instance of the current object for chaining.
   */
  endPoly(t = !1) {
    const e = this._currentPoly;
    return e && e.points.length > 2 && (e.closePath = t, this.shapePrimitives.push({ shape: e })), this._currentPoly = null, this;
  }
  _ensurePoly(t = !0) {
    if (!this._currentPoly && (this._currentPoly = new Xr(), t)) {
      const e = this.shapePrimitives[this.shapePrimitives.length - 1];
      if (e) {
        let r = e.shape.x, n = e.shape.y;
        if (e.transform && !e.transform.isIdentity()) {
          const a = e.transform, l = r;
          r = a.a * r + a.c * n + a.tx, n = a.b * l + a.d * n + a.ty;
        }
        this._currentPoly.points.push(r, n);
      } else
        this._currentPoly.points.push(0, 0);
    }
  }
  /** Builds the path. */
  buildPath() {
    const t = this._graphicsPath2D;
    this.shapePrimitives.length = 0, this._currentPoly = null;
    for (let e = 0; e < t.instructions.length; e++) {
      const r = t.instructions[e];
      this[r.action](...r.data);
    }
    this.finish();
  }
  /** Gets the bounds of the path. */
  get bounds() {
    const t = this._bounds;
    t.clear();
    const e = this.shapePrimitives;
    for (let r = 0; r < e.length; r++) {
      const n = e[r], a = n.shape.getBounds(qw);
      n.transform ? t.addRect(a, n.transform) : t.addRect(a);
    }
    return t;
  }
}
class ur {
  /**
   * Creates a `GraphicsPath` instance optionally from an SVG path string or an array of `PathInstruction`.
   * @param instructions - An SVG path string or an array of `PathInstruction` objects.
   * @param signed
   */
  constructor(t, e = !1) {
    this.instructions = [], this.uid = rt("graphicsPath"), this._dirty = !0, this.checkForHoles = e, typeof t == "string" ? Iv(t, this) : this.instructions = t?.slice() ?? [];
  }
  /**
   * Provides access to the internal shape path, ensuring it is up-to-date with the current instructions.
   * @returns The `ShapePath` instance associated with this `GraphicsPath`.
   */
  get shapePath() {
    return this._shapePath || (this._shapePath = new Zw(this)), this._dirty && (this._dirty = !1, this._shapePath.buildPath()), this._shapePath;
  }
  /**
   * Adds another `GraphicsPath` to this path, optionally applying a transformation.
   * @param path - The `GraphicsPath` to add.
   * @param transform - An optional transformation to apply to the added path.
   * @returns The instance of the current object for chaining.
   */
  addPath(t, e) {
    return t = t.clone(), this.instructions.push({ action: "addPath", data: [t, e] }), this._dirty = !0, this;
  }
  arc(...t) {
    return this.instructions.push({ action: "arc", data: t }), this._dirty = !0, this;
  }
  arcTo(...t) {
    return this.instructions.push({ action: "arcTo", data: t }), this._dirty = !0, this;
  }
  arcToSvg(...t) {
    return this.instructions.push({ action: "arcToSvg", data: t }), this._dirty = !0, this;
  }
  bezierCurveTo(...t) {
    return this.instructions.push({ action: "bezierCurveTo", data: t }), this._dirty = !0, this;
  }
  /**
   * Adds a cubic Bezier curve to the path.
   * It requires two points: the second control point and the end point. The first control point is assumed to be
   * The starting point is the last point in the current path.
   * @param cp2x - The x-coordinate of the second control point.
   * @param cp2y - The y-coordinate of the second control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */
  bezierCurveToShort(t, e, r, n, a) {
    const l = this.instructions[this.instructions.length - 1], h = this.getLastPoint(et.shared);
    let u = 0, f = 0;
    if (!l || l.action !== "bezierCurveTo")
      u = h.x, f = h.y;
    else {
      u = l.data[2], f = l.data[3];
      const p = h.x, m = h.y;
      u = p + (p - u), f = m + (m - f);
    }
    return this.instructions.push({ action: "bezierCurveTo", data: [u, f, t, e, r, n, a] }), this._dirty = !0, this;
  }
  /**
   * Closes the current path by drawing a straight line back to the start.
   * If the shape is already closed or there are no points in the path, this method does nothing.
   * @returns The instance of the current object for chaining.
   */
  closePath() {
    return this.instructions.push({ action: "closePath", data: [] }), this._dirty = !0, this;
  }
  ellipse(...t) {
    return this.instructions.push({ action: "ellipse", data: t }), this._dirty = !0, this;
  }
  lineTo(...t) {
    return this.instructions.push({ action: "lineTo", data: t }), this._dirty = !0, this;
  }
  moveTo(...t) {
    return this.instructions.push({ action: "moveTo", data: t }), this;
  }
  quadraticCurveTo(...t) {
    return this.instructions.push({ action: "quadraticCurveTo", data: t }), this._dirty = !0, this;
  }
  /**
   * Adds a quadratic curve to the path. It uses the previous point as the control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */
  quadraticCurveToShort(t, e, r) {
    const n = this.instructions[this.instructions.length - 1], a = this.getLastPoint(et.shared);
    let l = 0, h = 0;
    if (!n || n.action !== "quadraticCurveTo")
      l = a.x, h = a.y;
    else {
      l = n.data[0], h = n.data[1];
      const u = a.x, f = a.y;
      l = u + (u - l), h = f + (f - h);
    }
    return this.instructions.push({ action: "quadraticCurveTo", data: [l, h, t, e, r] }), this._dirty = !0, this;
  }
  /**
   * Draws a rectangle shape. This method adds a new rectangle path to the current drawing.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @param transform - An optional `Matrix` object to apply a transformation to the rectangle.
   * @returns The instance of the current object for chaining.
   */
  rect(t, e, r, n, a) {
    return this.instructions.push({ action: "rect", data: [t, e, r, n, a] }), this._dirty = !0, this;
  }
  /**
   * Draws a circle shape. This method adds a new circle path to the current drawing.
   * @param x - The x-coordinate of the center of the circle.
   * @param y - The y-coordinate of the center of the circle.
   * @param radius - The radius of the circle.
   * @param transform - An optional `Matrix` object to apply a transformation to the circle.
   * @returns The instance of the current object for chaining.
   */
  circle(t, e, r, n) {
    return this.instructions.push({ action: "circle", data: [t, e, r, n] }), this._dirty = !0, this;
  }
  roundRect(...t) {
    return this.instructions.push({ action: "roundRect", data: t }), this._dirty = !0, this;
  }
  poly(...t) {
    return this.instructions.push({ action: "poly", data: t }), this._dirty = !0, this;
  }
  regularPoly(...t) {
    return this.instructions.push({ action: "regularPoly", data: t }), this._dirty = !0, this;
  }
  roundPoly(...t) {
    return this.instructions.push({ action: "roundPoly", data: t }), this._dirty = !0, this;
  }
  roundShape(...t) {
    return this.instructions.push({ action: "roundShape", data: t }), this._dirty = !0, this;
  }
  filletRect(...t) {
    return this.instructions.push({ action: "filletRect", data: t }), this._dirty = !0, this;
  }
  chamferRect(...t) {
    return this.instructions.push({ action: "chamferRect", data: t }), this._dirty = !0, this;
  }
  /**
   * Draws a star shape centered at a specified location. This method allows for the creation
   *  of stars with a variable number of points, outer radius, optional inner radius, and rotation.
   * The star is drawn as a closed polygon with alternating outer and inner vertices to create the star's points.
   * An optional transformation can be applied to scale, rotate, or translate the star as needed.
   * @param x - The x-coordinate of the center of the star.
   * @param y - The y-coordinate of the center of the star.
   * @param points - The number of points of the star.
   * @param radius - The outer radius of the star (distance from the center to the outer points).
   * @param innerRadius - Optional. The inner radius of the star
   * (distance from the center to the inner points between the outer points).
   * If not provided, defaults to half of the `radius`.
   * @param rotation - Optional. The rotation of the star in radians, where 0 is aligned with the y-axis.
   * Defaults to 0, meaning one point is directly upward.
   * @param transform - An optional `Matrix` object to apply a transformation to the star.
   * This can include rotations, scaling, and translations.
   * @returns The instance of the current object for chaining further drawing commands.
   */
  // eslint-disable-next-line max-len
  star(t, e, r, n, a, l, h) {
    a || (a = n / 2);
    const u = -1 * Math.PI / 2 + l, f = r * 2, p = Math.PI * 2 / f, m = [];
    for (let g = 0; g < f; g++) {
      const x = g % 2 ? a : n, o = g * p + u;
      m.push(
        t + x * Math.cos(o),
        e + x * Math.sin(o)
      );
    }
    return this.poly(m, !0, h), this;
  }
  /**
   * Creates a copy of the current `GraphicsPath` instance. This method supports both shallow and deep cloning.
   * A shallow clone copies the reference of the instructions array, while a deep clone creates a new array and
   * copies each instruction individually, ensuring that modifications to the instructions of the cloned `GraphicsPath`
   * do not affect the original `GraphicsPath` and vice versa.
   * @param deep - A boolean flag indicating whether the clone should be deep.
   * @returns A new `GraphicsPath` instance that is a clone of the current instance.
   */
  clone(t = !1) {
    const e = new ur();
    if (e.checkForHoles = this.checkForHoles, !t)
      e.instructions = this.instructions.slice();
    else
      for (let r = 0; r < this.instructions.length; r++) {
        const n = this.instructions[r];
        e.instructions.push({ action: n.action, data: n.data.slice() });
      }
    return e;
  }
  clear() {
    return this.instructions.length = 0, this._dirty = !0, this;
  }
  /**
   * Applies a transformation matrix to all drawing instructions within the `GraphicsPath`.
   * This method enables the modification of the path's geometry according to the provided
   * transformation matrix, which can include translations, rotations, scaling, and skewing.
   *
   * Each drawing instruction in the path is updated to reflect the transformation,
   * ensuring the visual representation of the path is consistent with the applied matrix.
   *
   * Note: The transformation is applied directly to the coordinates and control points of the drawing instructions,
   * not to the path as a whole. This means the transformation's effects are baked into the individual instructions,
   * allowing for fine-grained control over the path's appearance.
   * @param matrix - A `Matrix` object representing the transformation to apply.
   * @returns The instance of the current object for chaining further operations.
   */
  transform(t) {
    if (t.isIdentity())
      return this;
    const e = t.a, r = t.b, n = t.c, a = t.d, l = t.tx, h = t.ty;
    let u = 0, f = 0, p = 0, m = 0, g = 0, x = 0, o = 0, c = 0;
    for (let d = 0; d < this.instructions.length; d++) {
      const _ = this.instructions[d], y = _.data;
      switch (_.action) {
        case "moveTo":
        case "lineTo":
          u = y[0], f = y[1], y[0] = e * u + n * f + l, y[1] = r * u + a * f + h;
          break;
        case "bezierCurveTo":
          p = y[0], m = y[1], g = y[2], x = y[3], u = y[4], f = y[5], y[0] = e * p + n * m + l, y[1] = r * p + a * m + h, y[2] = e * g + n * x + l, y[3] = r * g + a * x + h, y[4] = e * u + n * f + l, y[5] = r * u + a * f + h;
          break;
        case "quadraticCurveTo":
          p = y[0], m = y[1], u = y[2], f = y[3], y[0] = e * p + n * m + l, y[1] = r * p + a * m + h, y[2] = e * u + n * f + l, y[3] = r * u + a * f + h;
          break;
        case "arcToSvg":
          u = y[5], f = y[6], o = y[0], c = y[1], y[0] = e * o + n * c, y[1] = r * o + a * c, y[5] = e * u + n * f + l, y[6] = r * u + a * f + h;
          break;
        case "circle":
          y[4] = Ar(y[3], t);
          break;
        case "rect":
          y[4] = Ar(y[4], t);
          break;
        case "ellipse":
          y[8] = Ar(y[8], t);
          break;
        case "roundRect":
          y[5] = Ar(y[5], t);
          break;
        case "addPath":
          y[0].transform(t);
          break;
        case "poly":
          y[2] = Ar(y[2], t);
          break;
        default:
          N("unknown transform action", _.action);
          break;
      }
    }
    return this._dirty = !0, this;
  }
  get bounds() {
    return this.shapePath.bounds;
  }
  /**
   * Retrieves the last point from the current drawing instructions in the `GraphicsPath`.
   * This method is useful for operations that depend on the path's current endpoint,
   * such as connecting subsequent shapes or paths. It supports various drawing instructions,
   * ensuring the last point's position is accurately determined regardless of the path's complexity.
   *
   * If the last instruction is a `closePath`, the method iterates backward through the instructions
   *  until it finds an actionable instruction that defines a point (e.g., `moveTo`, `lineTo`,
   * `quadraticCurveTo`, etc.). For compound paths added via `addPath`, it recursively retrieves
   * the last point from the nested path.
   * @param out - A `Point` object where the last point's coordinates will be stored.
   * This object is modified directly to contain the result.
   * @returns The `Point` object containing the last point's coordinates.
   */
  getLastPoint(t) {
    let e = this.instructions.length - 1, r = this.instructions[e];
    if (!r)
      return t.x = 0, t.y = 0, t;
    for (; r.action === "closePath"; ) {
      if (e--, e < 0)
        return t.x = 0, t.y = 0, t;
      r = this.instructions[e];
    }
    switch (r.action) {
      case "moveTo":
      case "lineTo":
        t.x = r.data[0], t.y = r.data[1];
        break;
      case "quadraticCurveTo":
        t.x = r.data[2], t.y = r.data[3];
        break;
      case "bezierCurveTo":
        t.x = r.data[4], t.y = r.data[5];
        break;
      case "arc":
      case "arcToSvg":
        t.x = r.data[5], t.y = r.data[6];
        break;
      case "addPath":
        r.data[0].getLastPoint(t);
        break;
    }
    return t;
  }
}
function Ar(s, t) {
  return s ? s.prepend(t) : t.clone();
}
function ct(s, t, e) {
  const r = s.getAttribute(t);
  return r ? Number(r) : e;
}
function Qw(s, t) {
  const e = s.querySelectorAll("defs");
  for (let r = 0; r < e.length; r++) {
    const n = e[r];
    for (let a = 0; a < n.children.length; a++) {
      const l = n.children[a];
      switch (l.nodeName.toLowerCase()) {
        case "lineargradient":
          t.defs[l.id] = Jw(l);
          break;
        case "radialgradient":
          t.defs[l.id] = t1();
          break;
      }
    }
  }
}
function Jw(s) {
  const t = ct(s, "x1", 0), e = ct(s, "y1", 0), r = ct(s, "x2", 1), n = ct(s, "y2", 0), a = s.getAttribute("gradientUnits") || "objectBoundingBox", l = new Ue(
    t,
    e,
    r,
    n,
    a === "objectBoundingBox" ? "local" : "global"
  );
  for (let h = 0; h < s.children.length; h++) {
    const u = s.children[h], f = ct(u, "offset", 0), p = Q.shared.setValue(u.getAttribute("stop-color")).toNumber();
    l.addColorStop(f, p);
  }
  return l;
}
function t1(s) {
  return N("[SVG Parser] Radial gradients are not yet supported"), new Ue(0, 0, 1, 0);
}
function uu(s) {
  const t = s.match(/url\s*\(\s*['"]?\s*#([^'"\s)]+)\s*['"]?\s*\)/i);
  return t ? t[1] : "";
}
const du = {
  // Fill properties
  fill: { type: "paint", default: 0 },
  // Fill color/gradient
  "fill-opacity": { type: "number", default: 1 },
  // Fill transparency
  // Stroke properties
  stroke: { type: "paint", default: 0 },
  // Stroke color/gradient
  "stroke-width": { type: "number", default: 1 },
  // Width of stroke
  "stroke-opacity": { type: "number", default: 1 },
  // Stroke transparency
  "stroke-linecap": { type: "string", default: "butt" },
  // End cap style: butt, round, square
  "stroke-linejoin": { type: "string", default: "miter" },
  // Join style: miter, round, bevel
  "stroke-miterlimit": { type: "number", default: 10 },
  // Limit on miter join sharpness
  "stroke-dasharray": { type: "string", default: "none" },
  // Dash pattern
  "stroke-dashoffset": { type: "number", default: 0 },
  // Offset for dash pattern
  // Global properties
  opacity: { type: "number", default: 1 }
  // Overall opacity
};
function qp(s, t) {
  const e = s.getAttribute("style"), r = {}, n = {}, a = {
    strokeStyle: r,
    fillStyle: n,
    useFill: !1,
    useStroke: !1
  };
  for (const l in du) {
    const h = s.getAttribute(l);
    h && fu(t, a, l, h.trim());
  }
  if (e) {
    const l = e.split(";");
    for (let h = 0; h < l.length; h++) {
      const u = l[h].trim(), [f, p] = u.split(":");
      du[f] && fu(t, a, f, p.trim());
    }
  }
  return {
    strokeStyle: a.useStroke ? r : null,
    fillStyle: a.useFill ? n : null,
    useFill: a.useFill,
    useStroke: a.useStroke
  };
}
function fu(s, t, e, r) {
  switch (e) {
    case "stroke":
      if (r !== "none") {
        if (r.startsWith("url(")) {
          const n = uu(r);
          t.strokeStyle.fill = s.defs[n];
        } else
          t.strokeStyle.color = Q.shared.setValue(r).toNumber();
        t.useStroke = !0;
      }
      break;
    case "stroke-width":
      t.strokeStyle.width = Number(r);
      break;
    case "fill":
      if (r !== "none") {
        if (r.startsWith("url(")) {
          const n = uu(r);
          t.fillStyle.fill = s.defs[n];
        } else
          t.fillStyle.color = Q.shared.setValue(r).toNumber();
        t.useFill = !0;
      }
      break;
    case "fill-opacity":
      t.fillStyle.alpha = Number(r);
      break;
    case "stroke-opacity":
      t.strokeStyle.alpha = Number(r);
      break;
    case "opacity":
      t.fillStyle.alpha = Number(r), t.strokeStyle.alpha = Number(r);
      break;
  }
}
function e1(s, t) {
  if (typeof s == "string") {
    const l = document.createElement("div");
    l.innerHTML = s.trim(), s = l.querySelector("svg");
  }
  const e = {
    context: t,
    defs: {},
    path: new ur()
  };
  Qw(s, e);
  const r = s.children, { fillStyle: n, strokeStyle: a } = qp(s, e);
  for (let l = 0; l < r.length; l++) {
    const h = r[l];
    h.nodeName.toLowerCase() !== "defs" && Zp(h, e, n, a);
  }
  return t;
}
function Zp(s, t, e, r) {
  const n = s.children, { fillStyle: a, strokeStyle: l } = qp(s, t);
  a && e ? e = { ...e, ...a } : a && (e = a), l && r ? r = { ...r, ...l } : l && (r = l);
  const h = !e && !r;
  h && (e = { color: 0 });
  let u, f, p, m, g, x, o, c, d, _, y, v, b, w, S, T, E;
  switch (s.nodeName.toLowerCase()) {
    case "path":
      w = s.getAttribute("d"), s.getAttribute("fill-rule") === "evenodd" && N("SVG Evenodd fill rule not supported, your svg may render incorrectly"), S = new ur(w, !0), t.context.path(S), e && t.context.fill(e), r && t.context.stroke(r);
      break;
    case "circle":
      o = ct(s, "cx", 0), c = ct(s, "cy", 0), d = ct(s, "r", 0), t.context.ellipse(o, c, d, d), e && t.context.fill(e), r && t.context.stroke(r);
      break;
    case "rect":
      u = ct(s, "x", 0), f = ct(s, "y", 0), T = ct(s, "width", 0), E = ct(s, "height", 0), _ = ct(s, "rx", 0), y = ct(s, "ry", 0), _ || y ? t.context.roundRect(u, f, T, E, _ || y) : t.context.rect(u, f, T, E), e && t.context.fill(e), r && t.context.stroke(r);
      break;
    case "ellipse":
      o = ct(s, "cx", 0), c = ct(s, "cy", 0), _ = ct(s, "rx", 0), y = ct(s, "ry", 0), t.context.beginPath(), t.context.ellipse(o, c, _, y), e && t.context.fill(e), r && t.context.stroke(r);
      break;
    case "line":
      p = ct(s, "x1", 0), m = ct(s, "y1", 0), g = ct(s, "x2", 0), x = ct(s, "y2", 0), t.context.beginPath(), t.context.moveTo(p, m), t.context.lineTo(g, x), r && t.context.stroke(r);
      break;
    case "polygon":
      b = s.getAttribute("points"), v = b.match(/\d+/g).map((C) => parseInt(C, 10)), t.context.poly(v, !0), e && t.context.fill(e), r && t.context.stroke(r);
      break;
    case "polyline":
      b = s.getAttribute("points"), v = b.match(/\d+/g).map((C) => parseInt(C, 10)), t.context.poly(v, !1), r && t.context.stroke(r);
      break;
    case "g":
    case "svg":
      break;
    default: {
      N(`[SVG parser] <${s.nodeName}> elements unsupported`);
      break;
    }
  }
  h && (e = null);
  for (let C = 0; C < n.length; C++)
    Zp(n[C], t, e, r);
}
function i1(s) {
  return Q.isColorLike(s);
}
function pu(s) {
  return s instanceof Wn;
}
function _u(s) {
  return s instanceof Ue;
}
function r1(s) {
  return s instanceof k;
}
function s1(s, t, e) {
  const r = Q.shared.setValue(t ?? 0);
  return s.color = r.toNumber(), s.alpha = r.alpha === 1 ? e.alpha : r.alpha, s.texture = k.WHITE, { ...e, ...s };
}
function n1(s, t, e) {
  return s.texture = t, { ...e, ...s };
}
function mu(s, t, e) {
  return s.fill = t, s.color = 16777215, s.texture = t.texture, s.matrix = t.transform, { ...e, ...s };
}
function gu(s, t, e) {
  return t.buildGradient(), s.fill = t, s.color = 16777215, s.texture = t.texture, s.matrix = t.transform, s.textureSpace = t.textureSpace, { ...e, ...s };
}
function a1(s, t) {
  const e = { ...t, ...s }, r = Q.shared.setValue(e.color);
  return e.alpha *= r.alpha, e.color = r.toNumber(), e;
}
function Ci(s, t) {
  if (s == null)
    return null;
  const e = {}, r = s;
  return i1(s) ? s1(e, s, t) : r1(s) ? n1(e, s, t) : pu(s) ? mu(e, s, t) : _u(s) ? gu(e, s, t) : r.fill && pu(r.fill) ? mu(r, r.fill, t) : r.fill && _u(r.fill) ? gu(r, r.fill, t) : a1(r, t);
}
function Pn(s, t) {
  const { width: e, alignment: r, miterLimit: n, cap: a, join: l, pixelLine: h, ...u } = t, f = Ci(s, u);
  return f ? {
    width: e,
    alignment: r,
    miterLimit: n,
    cap: a,
    join: l,
    pixelLine: h,
    ...f
  } : null;
}
const o1 = new et(), yu = new D(), Zh = class we extends te {
  constructor() {
    super(...arguments), this.uid = rt("graphicsContext"), this.dirty = !0, this.batchMode = "auto", this.instructions = [], this._activePath = new ur(), this._transform = new D(), this._fillStyle = { ...we.defaultFillStyle }, this._strokeStyle = { ...we.defaultStrokeStyle }, this._stateStack = [], this._tick = 0, this._bounds = new Ut(), this._boundsDirty = !0;
  }
  /**
   * Creates a new GraphicsContext object that is a clone of this instance, copying all properties,
   * including the current drawing state, transformations, styles, and instructions.
   * @returns A new GraphicsContext instance with the same properties and state as this one.
   */
  clone() {
    const t = new we();
    return t.batchMode = this.batchMode, t.instructions = this.instructions.slice(), t._activePath = this._activePath.clone(), t._transform = this._transform.clone(), t._fillStyle = { ...this._fillStyle }, t._strokeStyle = { ...this._strokeStyle }, t._stateStack = this._stateStack.slice(), t._bounds = this._bounds.clone(), t._boundsDirty = !0, t;
  }
  /**
   * The current fill style of the graphics context. This can be a color, gradient, pattern, or a more complex style defined by a FillStyle object.
   */
  get fillStyle() {
    return this._fillStyle;
  }
  set fillStyle(t) {
    this._fillStyle = Ci(t, we.defaultFillStyle);
  }
  /**
   * The current stroke style of the graphics context. Similar to fill styles, stroke styles can encompass colors, gradients, patterns, or more detailed configurations via a StrokeStyle object.
   */
  get strokeStyle() {
    return this._strokeStyle;
  }
  set strokeStyle(t) {
    this._strokeStyle = Pn(t, we.defaultStrokeStyle);
  }
  /**
   * Sets the current fill style of the graphics context. The fill style can be a color, gradient,
   * pattern, or a more complex style defined by a FillStyle object.
   * @param style - The fill style to apply. This can be a simple color, a gradient or pattern object,
   *                or a FillStyle or ConvertedFillStyle object.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  setFillStyle(t) {
    return this._fillStyle = Ci(t, we.defaultFillStyle), this;
  }
  /**
   * Sets the current stroke style of the graphics context. Similar to fill styles, stroke styles can
   * encompass colors, gradients, patterns, or more detailed configurations via a StrokeStyle object.
   * @param style - The stroke style to apply. Can be defined as a color, a gradient or pattern,
   *                or a StrokeStyle or ConvertedStrokeStyle object.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  setStrokeStyle(t) {
    return this._strokeStyle = Ci(t, we.defaultStrokeStyle), this;
  }
  texture(t, e, r, n, a, l) {
    return this.instructions.push({
      action: "texture",
      data: {
        image: t,
        dx: r || 0,
        dy: n || 0,
        dw: a || t.frame.width,
        dh: l || t.frame.height,
        transform: this._transform.clone(),
        alpha: this._fillStyle.alpha,
        style: e ? Q.shared.setValue(e).toNumber() : 16777215
      }
    }), this.onUpdate(), this;
  }
  /**
   * Resets the current path. Any previous path and its commands are discarded and a new path is
   * started. This is typically called before beginning a new shape or series of drawing commands.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  beginPath() {
    return this._activePath = new ur(), this;
  }
  fill(t, e) {
    let r;
    const n = this.instructions[this.instructions.length - 1];
    return this._tick === 0 && n && n.action === "stroke" ? r = n.data.path : r = this._activePath.clone(), r ? (t != null && (e !== void 0 && typeof t == "number" && (W(K, "GraphicsContext.fill(color, alpha) is deprecated, use GraphicsContext.fill({ color, alpha }) instead"), t = { color: t, alpha: e }), this._fillStyle = Ci(t, we.defaultFillStyle)), this.instructions.push({
      action: "fill",
      // TODO copy fill style!
      data: { style: this.fillStyle, path: r }
    }), this.onUpdate(), this._initNextPathLocation(), this._tick = 0, this) : this;
  }
  _initNextPathLocation() {
    const { x: t, y: e } = this._activePath.getLastPoint(et.shared);
    this._activePath.clear(), this._activePath.moveTo(t, e);
  }
  /**
   * Strokes the current path with the current stroke style. This method can take an optional
   * FillInput parameter to define the stroke's appearance, including its color, width, and other properties.
   * @param style - (Optional) The stroke style to apply. Can be defined as a simple color or a more complex style object. If omitted, uses the current stroke style.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  stroke(t) {
    let e;
    const r = this.instructions[this.instructions.length - 1];
    return this._tick === 0 && r && r.action === "fill" ? e = r.data.path : e = this._activePath.clone(), e ? (t != null && (this._strokeStyle = Pn(t, we.defaultStrokeStyle)), this.instructions.push({
      action: "stroke",
      // TODO copy fill style!
      data: { style: this.strokeStyle, path: e }
    }), this.onUpdate(), this._initNextPathLocation(), this._tick = 0, this) : this;
  }
  /**
   * Applies a cutout to the last drawn shape. This is used to create holes or complex shapes by
   * subtracting a path from the previously drawn path. If a hole is not completely in a shape, it will
   * fail to cut correctly!
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  cut() {
    for (let t = 0; t < 2; t++) {
      const e = this.instructions[this.instructions.length - 1 - t], r = this._activePath.clone();
      if (e && (e.action === "stroke" || e.action === "fill"))
        if (e.data.hole)
          e.data.hole.addPath(r);
        else {
          e.data.hole = r;
          break;
        }
    }
    return this._initNextPathLocation(), this;
  }
  /**
   * Adds an arc to the current path, which is centered at (x, y) with the specified radius,
   * starting and ending angles, and direction.
   * @param x - The x-coordinate of the arc's center.
   * @param y - The y-coordinate of the arc's center.
   * @param radius - The arc's radius.
   * @param startAngle - The starting angle, in radians.
   * @param endAngle - The ending angle, in radians.
   * @param counterclockwise - (Optional) Specifies whether the arc is drawn counterclockwise (true) or clockwise (false). Defaults to false.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  arc(t, e, r, n, a, l) {
    this._tick++;
    const h = this._transform;
    return this._activePath.arc(
      h.a * t + h.c * e + h.tx,
      h.b * t + h.d * e + h.ty,
      r,
      n,
      a,
      l
    ), this;
  }
  /**
   * Adds an arc to the current path with the given control points and radius, connected to the previous point
   * by a straight line if necessary.
   * @param x1 - The x-coordinate of the first control point.
   * @param y1 - The y-coordinate of the first control point.
   * @param x2 - The x-coordinate of the second control point.
   * @param y2 - The y-coordinate of the second control point.
   * @param radius - The arc's radius.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  arcTo(t, e, r, n, a) {
    this._tick++;
    const l = this._transform;
    return this._activePath.arcTo(
      l.a * t + l.c * e + l.tx,
      l.b * t + l.d * e + l.ty,
      l.a * r + l.c * n + l.tx,
      l.b * r + l.d * n + l.ty,
      a
    ), this;
  }
  /**
   * Adds an SVG-style arc to the path, allowing for elliptical arcs based on the SVG spec.
   * @param rx - The x-radius of the ellipse.
   * @param ry - The y-radius of the ellipse.
   * @param xAxisRotation - The rotation of the ellipse's x-axis relative
   * to the x-axis of the coordinate system, in degrees.
   * @param largeArcFlag - Determines if the arc should be greater than or less than 180 degrees.
   * @param sweepFlag - Determines if the arc should be swept in a positive angle direction.
   * @param x - The x-coordinate of the arc's end point.
   * @param y - The y-coordinate of the arc's end point.
   * @returns The instance of the current object for chaining.
   */
  arcToSvg(t, e, r, n, a, l, h) {
    this._tick++;
    const u = this._transform;
    return this._activePath.arcToSvg(
      t,
      e,
      r,
      // should we rotate this with transform??
      n,
      a,
      u.a * l + u.c * h + u.tx,
      u.b * l + u.d * h + u.ty
    ), this;
  }
  /**
   * Adds a cubic Bezier curve to the path.
   * It requires three points: the first two are control points and the third one is the end point.
   * The starting point is the last point in the current path.
   * @param cp1x - The x-coordinate of the first control point.
   * @param cp1y - The y-coordinate of the first control point.
   * @param cp2x - The x-coordinate of the second control point.
   * @param cp2y - The y-coordinate of the second control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */
  bezierCurveTo(t, e, r, n, a, l, h) {
    this._tick++;
    const u = this._transform;
    return this._activePath.bezierCurveTo(
      u.a * t + u.c * e + u.tx,
      u.b * t + u.d * e + u.ty,
      u.a * r + u.c * n + u.tx,
      u.b * r + u.d * n + u.ty,
      u.a * a + u.c * l + u.tx,
      u.b * a + u.d * l + u.ty,
      h
    ), this;
  }
  /**
   * Closes the current path by drawing a straight line back to the start.
   * If the shape is already closed or there are no points in the path, this method does nothing.
   * @returns The instance of the current object for chaining.
   */
  closePath() {
    return this._tick++, this._activePath?.closePath(), this;
  }
  /**
   * Draws an ellipse at the specified location and with the given x and y radii.
   * An optional transformation can be applied, allowing for rotation, scaling, and translation.
   * @param x - The x-coordinate of the center of the ellipse.
   * @param y - The y-coordinate of the center of the ellipse.
   * @param radiusX - The horizontal radius of the ellipse.
   * @param radiusY - The vertical radius of the ellipse.
   * @returns The instance of the current object for chaining.
   */
  ellipse(t, e, r, n) {
    return this._tick++, this._activePath.ellipse(t, e, r, n, this._transform.clone()), this;
  }
  /**
   * Draws a circle shape. This method adds a new circle path to the current drawing.
   * @param x - The x-coordinate of the center of the circle.
   * @param y - The y-coordinate of the center of the circle.
   * @param radius - The radius of the circle.
   * @returns The instance of the current object for chaining.
   */
  circle(t, e, r) {
    return this._tick++, this._activePath.circle(t, e, r, this._transform.clone()), this;
  }
  /**
   * Adds another `GraphicsPath` to this path, optionally applying a transformation.
   * @param path - The `GraphicsPath` to add.
   * @returns The instance of the current object for chaining.
   */
  path(t) {
    return this._tick++, this._activePath.addPath(t, this._transform.clone()), this;
  }
  /**
   * Connects the current point to a new point with a straight line. This method updates the current path.
   * @param x - The x-coordinate of the new point to connect to.
   * @param y - The y-coordinate of the new point to connect to.
   * @returns The instance of the current object for chaining.
   */
  lineTo(t, e) {
    this._tick++;
    const r = this._transform;
    return this._activePath.lineTo(
      r.a * t + r.c * e + r.tx,
      r.b * t + r.d * e + r.ty
    ), this;
  }
  /**
   * Sets the starting point for a new sub-path. Any subsequent drawing commands are considered part of this path.
   * @param x - The x-coordinate for the starting point.
   * @param y - The y-coordinate for the starting point.
   * @returns The instance of the current object for chaining.
   */
  moveTo(t, e) {
    this._tick++;
    const r = this._transform, n = this._activePath.instructions, a = r.a * t + r.c * e + r.tx, l = r.b * t + r.d * e + r.ty;
    return n.length === 1 && n[0].action === "moveTo" ? (n[0].data[0] = a, n[0].data[1] = l, this) : (this._activePath.moveTo(
      a,
      l
    ), this);
  }
  /**
   * Adds a quadratic curve to the path. It requires two points: the control point and the end point.
   * The starting point is the last point in the current path.
   * @param cpx - The x-coordinate of the control point.
   * @param cpy - The y-coordinate of the control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */
  quadraticCurveTo(t, e, r, n, a) {
    this._tick++;
    const l = this._transform;
    return this._activePath.quadraticCurveTo(
      l.a * t + l.c * e + l.tx,
      l.b * t + l.d * e + l.ty,
      l.a * r + l.c * n + l.tx,
      l.b * r + l.d * n + l.ty,
      a
    ), this;
  }
  /**
   * Draws a rectangle shape. This method adds a new rectangle path to the current drawing.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @returns The instance of the current object for chaining.
   */
  rect(t, e, r, n) {
    return this._tick++, this._activePath.rect(t, e, r, n, this._transform.clone()), this;
  }
  /**
   * Draws a rectangle with rounded corners.
   * The corner radius can be specified to determine how rounded the corners should be.
   * An optional transformation can be applied, which allows for rotation, scaling, and translation of the rectangle.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @param radius - The radius of the rectangle's corners. If not specified, corners will be sharp.
   * @returns The instance of the current object for chaining.
   */
  roundRect(t, e, r, n, a) {
    return this._tick++, this._activePath.roundRect(t, e, r, n, a, this._transform.clone()), this;
  }
  /**
   * Draws a polygon shape by specifying a sequence of points. This method allows for the creation of complex polygons,
   * which can be both open and closed. An optional transformation can be applied, enabling the polygon to be scaled,
   * rotated, or translated as needed.
   * @param points - An array of numbers, or an array of PointData objects eg [{x,y}, {x,y}, {x,y}]
   * representing the x and y coordinates, of the polygon's vertices, in sequence.
   * @param close - A boolean indicating whether to close the polygon path. True by default.
   */
  poly(t, e) {
    return this._tick++, this._activePath.poly(t, e, this._transform.clone()), this;
  }
  /**
   * Draws a regular polygon with a specified number of sides. All sides and angles are equal.
   * @param x - The x-coordinate of the center of the polygon.
   * @param y - The y-coordinate of the center of the polygon.
   * @param radius - The radius of the circumscribed circle of the polygon.
   * @param sides - The number of sides of the polygon. Must be 3 or more.
   * @param rotation - The rotation angle of the polygon, in radians. Zero by default.
   * @param transform - An optional `Matrix` object to apply a transformation to the polygon.
   * @returns The instance of the current object for chaining.
   */
  regularPoly(t, e, r, n, a = 0, l) {
    return this._tick++, this._activePath.regularPoly(t, e, r, n, a, l), this;
  }
  /**
   * Draws a polygon with rounded corners.
   * Similar to `regularPoly` but with the ability to round the corners of the polygon.
   * @param x - The x-coordinate of the center of the polygon.
   * @param y - The y-coordinate of the center of the polygon.
   * @param radius - The radius of the circumscribed circle of the polygon.
   * @param sides - The number of sides of the polygon. Must be 3 or more.
   * @param corner - The radius of the rounding of the corners.
   * @param rotation - The rotation angle of the polygon, in radians. Zero by default.
   * @returns The instance of the current object for chaining.
   */
  roundPoly(t, e, r, n, a, l) {
    return this._tick++, this._activePath.roundPoly(t, e, r, n, a, l), this;
  }
  /**
   * Draws a shape with rounded corners. This function supports custom radius for each corner of the shape.
   * Optionally, corners can be rounded using a quadratic curve instead of an arc, providing a different aesthetic.
   * @param points - An array of `RoundedPoint` representing the corners of the shape to draw.
   * A minimum of 3 points is required.
   * @param radius - The default radius for the corners.
   * This radius is applied to all corners unless overridden in `points`.
   * @param useQuadratic - If set to true, rounded corners are drawn using a quadraticCurve
   *  method instead of an arc method. Defaults to false.
   * @param smoothness - Specifies the smoothness of the curve when `useQuadratic` is true.
   * Higher values make the curve smoother.
   * @returns The instance of the current object for chaining.
   */
  roundShape(t, e, r, n) {
    return this._tick++, this._activePath.roundShape(t, e, r, n), this;
  }
  /**
   * Draw Rectangle with fillet corners. This is much like rounded rectangle
   * however it support negative numbers as well for the corner radius.
   * @param x - Upper left corner of rect
   * @param y - Upper right corner of rect
   * @param width - Width of rect
   * @param height - Height of rect
   * @param fillet - accept negative or positive values
   */
  filletRect(t, e, r, n, a) {
    return this._tick++, this._activePath.filletRect(t, e, r, n, a), this;
  }
  /**
   * Draw Rectangle with chamfer corners. These are angled corners.
   * @param x - Upper left corner of rect
   * @param y - Upper right corner of rect
   * @param width - Width of rect
   * @param height - Height of rect
   * @param chamfer - non-zero real number, size of corner cutout
   * @param transform
   */
  chamferRect(t, e, r, n, a, l) {
    return this._tick++, this._activePath.chamferRect(t, e, r, n, a, l), this;
  }
  /**
   * Draws a star shape centered at a specified location. This method allows for the creation
   *  of stars with a variable number of points, outer radius, optional inner radius, and rotation.
   * The star is drawn as a closed polygon with alternating outer and inner vertices to create the star's points.
   * An optional transformation can be applied to scale, rotate, or translate the star as needed.
   * @param x - The x-coordinate of the center of the star.
   * @param y - The y-coordinate of the center of the star.
   * @param points - The number of points of the star.
   * @param radius - The outer radius of the star (distance from the center to the outer points).
   * @param innerRadius - Optional. The inner radius of the star
   * (distance from the center to the inner points between the outer points).
   * If not provided, defaults to half of the `radius`.
   * @param rotation - Optional. The rotation of the star in radians, where 0 is aligned with the y-axis.
   * Defaults to 0, meaning one point is directly upward.
   * @returns The instance of the current object for chaining further drawing commands.
   */
  star(t, e, r, n, a = 0, l = 0) {
    return this._tick++, this._activePath.star(t, e, r, n, a, l, this._transform.clone()), this;
  }
  /**
   * Parses and renders an SVG string into the graphics context. This allows for complex shapes and paths
   * defined in SVG format to be drawn within the graphics context.
   * @param svg - The SVG string to be parsed and rendered.
   */
  svg(t) {
    return this._tick++, e1(t, this), this;
  }
  /**
   * Restores the most recently saved graphics state by popping the top of the graphics state stack.
   * This includes transformations, fill styles, and stroke styles.
   */
  restore() {
    const t = this._stateStack.pop();
    return t && (this._transform = t.transform, this._fillStyle = t.fillStyle, this._strokeStyle = t.strokeStyle), this;
  }
  /** Saves the current graphics state, including transformations, fill styles, and stroke styles, onto a stack. */
  save() {
    return this._stateStack.push({
      transform: this._transform.clone(),
      fillStyle: { ...this._fillStyle },
      strokeStyle: { ...this._strokeStyle }
    }), this;
  }
  /**
   * Returns the current transformation matrix of the graphics context.
   * @returns The current transformation matrix.
   */
  getTransform() {
    return this._transform;
  }
  /**
   * Resets the current transformation matrix to the identity matrix, effectively removing any transformations (rotation, scaling, translation) previously applied.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  resetTransform() {
    return this._transform.identity(), this;
  }
  /**
   * Applies a rotation transformation to the graphics context around the current origin.
   * @param angle - The angle of rotation in radians.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  rotate(t) {
    return this._transform.rotate(t), this;
  }
  /**
   * Applies a scaling transformation to the graphics context, scaling drawings by x horizontally and by y vertically.
   * @param x - The scale factor in the horizontal direction.
   * @param y - (Optional) The scale factor in the vertical direction. If not specified, the x value is used for both directions.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  scale(t, e = t) {
    return this._transform.scale(t, e), this;
  }
  setTransform(t, e, r, n, a, l) {
    return t instanceof D ? (this._transform.set(t.a, t.b, t.c, t.d, t.tx, t.ty), this) : (this._transform.set(t, e, r, n, a, l), this);
  }
  transform(t, e, r, n, a, l) {
    return t instanceof D ? (this._transform.append(t), this) : (yu.set(t, e, r, n, a, l), this._transform.append(yu), this);
  }
  /**
   * Applies a translation transformation to the graphics context, moving the origin by the specified amounts.
   * @param x - The amount to translate in the horizontal direction.
   * @param y - (Optional) The amount to translate in the vertical direction. If not specified, the x value is used for both directions.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  translate(t, e = t) {
    return this._transform.translate(t, e), this;
  }
  /**
   * Clears all drawing commands from the graphics context, effectively resetting it. This includes clearing the path,
   * and optionally resetting transformations to the identity matrix.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  clear() {
    return this._activePath.clear(), this.instructions.length = 0, this.resetTransform(), this.onUpdate(), this;
  }
  onUpdate() {
    this.dirty || (this.emit("update", this, 16), this.dirty = !0, this._boundsDirty = !0);
  }
  /** The bounds of the graphic shape. */
  get bounds() {
    if (!this._boundsDirty)
      return this._bounds;
    const t = this._bounds;
    t.clear();
    for (let e = 0; e < this.instructions.length; e++) {
      const r = this.instructions[e], n = r.action;
      if (n === "fill") {
        const a = r.data;
        t.addBounds(a.path.bounds);
      } else if (n === "texture") {
        const a = r.data;
        t.addFrame(a.dx, a.dy, a.dx + a.dw, a.dy + a.dh, a.transform);
      }
      if (n === "stroke") {
        const a = r.data, l = a.style.alignment, h = a.style.width * (1 - l), u = a.path.bounds;
        t.addFrame(
          u.minX - h,
          u.minY - h,
          u.maxX + h,
          u.maxY + h
        );
      }
    }
    return t;
  }
  /**
   * Check to see if a point is contained within this geometry.
   * @param point - Point to check if it's contained.
   * @returns {boolean} `true` if the point is contained within geometry.
   */
  containsPoint(t) {
    if (!this.bounds.containsPoint(t.x, t.y))
      return !1;
    const e = this.instructions;
    let r = !1;
    for (let n = 0; n < e.length; n++) {
      const a = e[n], l = a.data, h = l.path;
      if (!a.action || !h)
        continue;
      const u = l.style, f = h.shapePath.shapePrimitives;
      for (let p = 0; p < f.length; p++) {
        const m = f[p].shape;
        if (!u || !m)
          continue;
        const g = f[p].transform, x = g ? g.applyInverse(t, o1) : t;
        if (a.action === "fill")
          r = m.contains(x.x, x.y);
        else {
          const c = u;
          r = m.strokeContains(x.x, x.y, c.width, c.alignment);
        }
        const o = l.hole;
        if (o) {
          const c = o.shapePath?.shapePrimitives;
          if (c)
            for (let d = 0; d < c.length; d++)
              c[d].shape.contains(x.x, x.y) && (r = !1);
        }
        if (r)
          return !0;
      }
    }
    return r;
  }
  /**
   * Destroys the GraphicsData object.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @example
   * context.destroy();
   * context.destroy(true);
   * context.destroy({ texture: true, textureSource: true });
   */
  destroy(t = !1) {
    if (this._stateStack.length = 0, this._transform = null, this.emit("destroy", this), this.removeAllListeners(), typeof t == "boolean" ? t : t?.texture) {
      const r = typeof t == "boolean" ? t : t?.textureSource;
      this._fillStyle.texture && this._fillStyle.texture.destroy(r), this._strokeStyle.texture && this._strokeStyle.texture.destroy(r);
    }
    this._fillStyle = null, this._strokeStyle = null, this.instructions = null, this._activePath = null, this._bounds = null, this._stateStack = null, this.customShader = null, this._transform = null;
  }
};
Zh.defaultFillStyle = {
  /** The color to use for the fill. */
  color: 16777215,
  /** The alpha value to use for the fill. */
  alpha: 1,
  /** The texture to use for the fill. */
  texture: k.WHITE,
  /** The matrix to apply. */
  matrix: null,
  /** The fill pattern to use. */
  fill: null,
  /** Whether coordinates are 'global' or 'local' */
  textureSpace: "local"
};
Zh.defaultStrokeStyle = {
  /** The width of the stroke. */
  width: 1,
  /** The color to use for the stroke. */
  color: 16777215,
  /** The alpha value to use for the stroke. */
  alpha: 1,
  /** The alignment of the stroke. */
  alignment: 0.5,
  /** The miter limit to use. */
  miterLimit: 10,
  /** The line cap style to use. */
  cap: "butt",
  /** The line join style to use. */
  join: "miter",
  /** The texture to use for the fill. */
  texture: k.WHITE,
  /** The matrix to apply. */
  matrix: null,
  /** The fill pattern to use. */
  fill: null,
  /** Whether coordinates are 'global' or 'local' */
  textureSpace: "local",
  /** If the stroke is a pixel line. */
  pixelLine: !1
};
let ne = Zh;
const xu = [
  "align",
  "breakWords",
  "cssOverrides",
  "fontVariant",
  "fontWeight",
  "leading",
  "letterSpacing",
  "lineHeight",
  "padding",
  "textBaseline",
  "trim",
  "whiteSpace",
  "wordWrap",
  "wordWrapWidth",
  "fontFamily",
  "fontStyle",
  "fontSize"
];
function h1(s) {
  const t = [];
  let e = 0;
  for (let r = 0; r < xu.length; r++) {
    const n = `_${xu[r]}`;
    t[e++] = s[n];
  }
  return e = Qp(s._fill, t, e), e = c1(s._stroke, t, e), e = u1(s.dropShadow, t, e), e = l1(s.filters, t, e), t.join("-");
}
function l1(s, t, e) {
  if (!s)
    return e;
  for (const r of s)
    t[e++] = r.uid;
  return e;
}
function Qp(s, t, e) {
  return s && (t[e++] = s.color, t[e++] = s.alpha, t[e++] = s.fill?.styleKey), e;
}
function c1(s, t, e) {
  return s && (e = Qp(s, t, e), t[e++] = s.width, t[e++] = s.alignment, t[e++] = s.cap, t[e++] = s.join, t[e++] = s.miterLimit), e;
}
function u1(s, t, e) {
  return s && (t[e++] = s.alpha, t[e++] = s.angle, t[e++] = s.blur, t[e++] = s.distance, t[e++] = Q.shared.setValue(s.color).toNumber()), e;
}
const Qh = class Vi extends te {
  constructor(t = {}) {
    super(), d1(t);
    const e = { ...Vi.defaultTextStyle, ...t };
    for (const r in e) {
      const n = r;
      this[n] = e[r];
    }
    this.update();
  }
  /**
   * Alignment for multiline text, does not affect single line text.
   * @type {'left'|'center'|'right'|'justify'}
   */
  get align() {
    return this._align;
  }
  set align(t) {
    this._align = t, this.update();
  }
  /** Indicates if lines can be wrapped within words, it needs wordWrap to be set to true. */
  get breakWords() {
    return this._breakWords;
  }
  set breakWords(t) {
    this._breakWords = t, this.update();
  }
  /** Set a drop shadow for the text. */
  get dropShadow() {
    return this._dropShadow;
  }
  set dropShadow(t) {
    t !== null && typeof t == "object" ? this._dropShadow = this._createProxy({ ...Vi.defaultDropShadow, ...t }) : this._dropShadow = t ? this._createProxy({ ...Vi.defaultDropShadow }) : null, this.update();
  }
  /** The font family, can be a single font name, or a list of names where the first is the preferred font. */
  get fontFamily() {
    return this._fontFamily;
  }
  set fontFamily(t) {
    this._fontFamily = t, this.update();
  }
  /** The font size (as a number it converts to px, but as a string, equivalents are '26px','20pt','160%' or '1.6em') */
  get fontSize() {
    return this._fontSize;
  }
  set fontSize(t) {
    typeof t == "string" ? this._fontSize = parseInt(t, 10) : this._fontSize = t, this.update();
  }
  /**
   * The font style.
   * @type {'normal'|'italic'|'oblique'}
   */
  get fontStyle() {
    return this._fontStyle;
  }
  set fontStyle(t) {
    this._fontStyle = t.toLowerCase(), this.update();
  }
  /**
   * The font variant.
   * @type {'normal'|'small-caps'}
   */
  get fontVariant() {
    return this._fontVariant;
  }
  set fontVariant(t) {
    this._fontVariant = t, this.update();
  }
  /**
   * The font weight.
   * @type {'normal'|'bold'|'bolder'|'lighter'|'100'|'200'|'300'|'400'|'500'|'600'|'700'|'800'|'900'}
   */
  get fontWeight() {
    return this._fontWeight;
  }
  set fontWeight(t) {
    this._fontWeight = t, this.update();
  }
  /** The space between lines. */
  get leading() {
    return this._leading;
  }
  set leading(t) {
    this._leading = t, this.update();
  }
  /** The amount of spacing between letters, default is 0. */
  get letterSpacing() {
    return this._letterSpacing;
  }
  set letterSpacing(t) {
    this._letterSpacing = t, this.update();
  }
  /** The line height, a number that represents the vertical space that a letter uses. */
  get lineHeight() {
    return this._lineHeight;
  }
  set lineHeight(t) {
    this._lineHeight = t, this.update();
  }
  /**
   * Occasionally some fonts are cropped. Adding some padding will prevent this from happening
   * by adding padding to all sides of the text.
   * > [!NOTE] This will NOT affect the positioning or bounds of the text.
   */
  get padding() {
    return this._padding;
  }
  set padding(t) {
    this._padding = t, this.update();
  }
  /**
   * An optional filter or array of filters to apply to the text, allowing for advanced visual effects.
   * These filters will be applied to the text as it is created, resulting in faster rendering for static text
   * compared to applying the filter directly to the text object (which would be applied at run time).
   * @default null
   */
  get filters() {
    return this._filters;
  }
  set filters(t) {
    this._filters = t, this.update();
  }
  /**
   * Trim transparent borders from the text texture.
   * > [!IMPORTANT] PERFORMANCE WARNING:
   * > This is a costly operation as it requires scanning pixel alpha values.
   * > Avoid using `trim: true` for dynamic text, as it could significantly impact performance.
   */
  get trim() {
    return this._trim;
  }
  set trim(t) {
    this._trim = t, this.update();
  }
  /**
   * The baseline of the text that is rendered.
   * @type {'alphabetic'|'top'|'hanging'|'middle'|'ideographic'|'bottom'}
   */
  get textBaseline() {
    return this._textBaseline;
  }
  set textBaseline(t) {
    this._textBaseline = t, this.update();
  }
  /**
   * How newlines and spaces should be handled.
   * Default is 'pre' (preserve, preserve).
   *
   *  value       | New lines     |   Spaces
   *  ---         | ---           |   ---
   * 'normal'     | Collapse      |   Collapse
   * 'pre'        | Preserve      |   Preserve
   * 'pre-line'   | Preserve      |   Collapse
   * @type {'normal'|'pre'|'pre-line'}
   */
  get whiteSpace() {
    return this._whiteSpace;
  }
  set whiteSpace(t) {
    this._whiteSpace = t, this.update();
  }
  /** Indicates if word wrap should be used. */
  get wordWrap() {
    return this._wordWrap;
  }
  set wordWrap(t) {
    this._wordWrap = t, this.update();
  }
  /** The width at which text will wrap, it needs wordWrap to be set to true. */
  get wordWrapWidth() {
    return this._wordWrapWidth;
  }
  set wordWrapWidth(t) {
    this._wordWrapWidth = t, this.update();
  }
  /**
   * The fill style that will be used to color the text.
   * This can be:
   * - A color string like 'red', '#00FF00', or 'rgba(255,0,0,0.5)'
   * - A hex number like 0xff0000 for red
   * - A FillStyle object with properties like { color: 0xff0000, alpha: 0.5 }
   * - A FillGradient for gradient fills
   * - A FillPattern for pattern/texture fills
   *
   * When using a FillGradient, vertical gradients (angle of 90 degrees) are applied per line of text,
   * while gradients at any other angle are spread across the entire text body as a whole.
   * @example
   * // Vertical gradient applied per line
   * const verticalGradient = new FillGradient(0, 0, 0, 1)
   *     .addColorStop(0, 0xff0000)
   *     .addColorStop(1, 0x0000ff);
   *
   * const text = new Text({
   *     text: 'Line 1\nLine 2',
   *     style: { fill: verticalGradient }
   * });
   *
   * To manage the gradient in a global scope, set the textureSpace property of the FillGradient to 'global'.
   * @type {string|number|FillStyle|FillGradient|FillPattern}
   */
  get fill() {
    return this._originalFill;
  }
  set fill(t) {
    t !== this._originalFill && (this._originalFill = t, this._isFillStyle(t) && (this._originalFill = this._createProxy({ ...ne.defaultFillStyle, ...t }, () => {
      this._fill = Ci(
        { ...this._originalFill },
        ne.defaultFillStyle
      );
    })), this._fill = Ci(
      t === 0 ? "black" : t,
      ne.defaultFillStyle
    ), this.update());
  }
  /** A fillstyle that will be used on the text stroke, e.g., 'blue', '#FCFF00'. */
  get stroke() {
    return this._originalStroke;
  }
  set stroke(t) {
    t !== this._originalStroke && (this._originalStroke = t, this._isFillStyle(t) && (this._originalStroke = this._createProxy({ ...ne.defaultStrokeStyle, ...t }, () => {
      this._stroke = Pn(
        { ...this._originalStroke },
        ne.defaultStrokeStyle
      );
    })), this._stroke = Pn(t, ne.defaultStrokeStyle), this.update());
  }
  _generateKey() {
    return this._styleKey = h1(this), this._styleKey;
  }
  update() {
    this._styleKey = null, this.emit("update", this);
  }
  /** Resets all properties to the default values */
  reset() {
    const t = Vi.defaultTextStyle;
    for (const e in t)
      this[e] = t[e];
  }
  /** @internal */
  get styleKey() {
    return this._styleKey || this._generateKey();
  }
  /**
   * Creates a new TextStyle object with the same values as this one.
   * @returns New cloned TextStyle object
   */
  clone() {
    return new Vi({
      align: this.align,
      breakWords: this.breakWords,
      dropShadow: this._dropShadow ? { ...this._dropShadow } : null,
      fill: this._fill,
      fontFamily: this.fontFamily,
      fontSize: this.fontSize,
      fontStyle: this.fontStyle,
      fontVariant: this.fontVariant,
      fontWeight: this.fontWeight,
      leading: this.leading,
      letterSpacing: this.letterSpacing,
      lineHeight: this.lineHeight,
      padding: this.padding,
      stroke: this._stroke,
      textBaseline: this.textBaseline,
      whiteSpace: this.whiteSpace,
      wordWrap: this.wordWrap,
      wordWrapWidth: this.wordWrapWidth,
      filters: this._filters ? [...this._filters] : void 0
    });
  }
  /**
   * Returns the final padding for the text style, taking into account any filters applied.
   * Used internally for correct measurements
   * @internal
   * @returns {number} The final padding for the text style.
   */
  _getFinalPadding() {
    let t = 0;
    if (this._filters)
      for (let e = 0; e < this._filters.length; e++)
        t += this._filters[e].padding;
    return Math.max(this._padding, t);
  }
  /**
   * Destroys this text style.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @example
   * // Destroy the text style and its textures
   * textStyle.destroy({ texture: true, textureSource: true });
   * textStyle.destroy(true);
   */
  destroy(t = !1) {
    if (this.removeAllListeners(), typeof t == "boolean" ? t : t?.texture) {
      const r = typeof t == "boolean" ? t : t?.textureSource;
      this._fill?.texture && this._fill.texture.destroy(r), this._originalFill?.texture && this._originalFill.texture.destroy(r), this._stroke?.texture && this._stroke.texture.destroy(r), this._originalStroke?.texture && this._originalStroke.texture.destroy(r);
    }
    this._fill = null, this._stroke = null, this.dropShadow = null, this._originalStroke = null, this._originalFill = null;
  }
  _createProxy(t, e) {
    return new Proxy(t, {
      set: (r, n, a) => (r[n] = a, e?.(n, a), this.update(), !0)
    });
  }
  _isFillStyle(t) {
    return (t ?? null) !== null && !(Q.isColorLike(t) || t instanceof Ue || t instanceof Wn);
  }
};
Qh.defaultDropShadow = {
  alpha: 1,
  angle: Math.PI / 6,
  blur: 0,
  color: "black",
  distance: 5
};
Qh.defaultTextStyle = {
  align: "left",
  breakWords: !1,
  dropShadow: null,
  fill: "black",
  fontFamily: "Arial",
  fontSize: 26,
  fontStyle: "normal",
  fontVariant: "normal",
  fontWeight: "normal",
  leading: 0,
  letterSpacing: 0,
  lineHeight: 0,
  padding: 0,
  stroke: null,
  textBaseline: "alphabetic",
  trim: !1,
  whiteSpace: "pre",
  wordWrap: !1,
  wordWrapWidth: 100
};
let ce = Qh;
function d1(s) {
  const t = s;
  if (typeof t.dropShadow == "boolean" && t.dropShadow) {
    const e = ce.defaultDropShadow;
    s.dropShadow = {
      alpha: t.dropShadowAlpha ?? e.alpha,
      angle: t.dropShadowAngle ?? e.angle,
      blur: t.dropShadowBlur ?? e.blur,
      color: t.dropShadowColor ?? e.color,
      distance: t.dropShadowDistance ?? e.distance
    };
  }
  if (t.strokeThickness !== void 0) {
    W(K, "strokeThickness is now a part of stroke");
    const e = t.stroke;
    let r = {};
    if (Q.isColorLike(e))
      r.color = e;
    else if (e instanceof Ue || e instanceof Wn)
      r.fill = e;
    else if (Object.hasOwnProperty.call(e, "color") || Object.hasOwnProperty.call(e, "fill"))
      r = e;
    else
      throw new Error("Invalid stroke value.");
    s.stroke = {
      ...r,
      width: t.strokeThickness
    };
  }
  if (Array.isArray(t.fillGradientStops)) {
    W(K, "gradient fill is now a fill pattern: `new FillGradient(...)`");
    let e;
    s.fontSize == null ? s.fontSize = ce.defaultTextStyle.fontSize : typeof s.fontSize == "string" ? e = parseInt(s.fontSize, 10) : e = s.fontSize;
    const r = new Ue({
      start: { x: 0, y: 0 },
      end: { x: 0, y: (e || 0) * 1.7 }
    }), n = t.fillGradientStops.map((a) => Q.shared.setValue(a).toNumber());
    n.forEach((a, l) => {
      const h = l / (n.length - 1);
      r.addColorStop(h, a);
    }), s.fill = {
      fill: r
    };
  }
}
class f1 {
  constructor(t) {
    this._canvasPool = /* @__PURE__ */ Object.create(null), this.canvasOptions = t || {}, this.enableFullScreen = !1;
  }
  /**
   * Creates texture with params that were specified in pool constructor.
   * @param pixelWidth - Width of texture in pixels.
   * @param pixelHeight - Height of texture in pixels.
   */
  _createCanvasAndContext(t, e) {
    const r = Y.get().createCanvas();
    r.width = t, r.height = e;
    const n = r.getContext("2d");
    return { canvas: r, context: n };
  }
  /**
   * Gets a Power-of-Two render texture or fullScreen texture
   * @param minWidth - The minimum width of the render texture.
   * @param minHeight - The minimum height of the render texture.
   * @param resolution - The resolution of the render texture.
   * @returns The new render texture.
   */
  getOptimalCanvasAndContext(t, e, r = 1) {
    t = Math.ceil(t * r - 1e-6), e = Math.ceil(e * r - 1e-6), t = hr(t), e = hr(e);
    const n = (t << 17) + (e << 1);
    this._canvasPool[n] || (this._canvasPool[n] = []);
    let a = this._canvasPool[n].pop();
    return a || (a = this._createCanvasAndContext(t, e)), a;
  }
  /**
   * Place a render texture back into the pool.
   * @param canvasAndContext
   */
  returnCanvasAndContext(t) {
    const e = t.canvas, { width: r, height: n } = e, a = (r << 17) + (n << 1);
    t.context.clearRect(0, 0, r, n), this._canvasPool[a].push(t);
  }
  clear() {
    this._canvasPool = {};
  }
}
const oi = new f1(), bu = 1e5;
function Mn(s, t, e, r = 0) {
  if (s.texture === k.WHITE && !s.fill)
    return Q.shared.setValue(s.color).setAlpha(s.alpha ?? 1).toHexa();
  if (s.fill) {
    if (s.fill instanceof Wn) {
      const n = s.fill, a = t.createPattern(n.texture.source.resource, "repeat"), l = n.transform.copyTo(D.shared);
      return l.scale(
        n.texture.frame.width,
        n.texture.frame.height
      ), a.setTransform(l), a;
    } else if (s.fill instanceof Ue) {
      const n = s.fill, a = n.type === "linear", l = n.textureSpace === "local";
      let h = 1, u = 1;
      l && e && (h = e.width + r, u = e.height + r);
      let f, p = !1;
      if (a) {
        const { start: m, end: g } = n;
        f = t.createLinearGradient(
          m.x * h,
          m.y * u,
          g.x * h,
          g.y * u
        ), p = Math.abs(g.x - m.x) < Math.abs((g.y - m.y) * 0.1);
      } else {
        const { center: m, innerRadius: g, outerCenter: x, outerRadius: o } = n;
        f = t.createRadialGradient(
          m.x * h,
          m.y * u,
          g * h,
          x.x * h,
          x.y * u,
          o * h
        );
      }
      if (p && l && e) {
        const m = e.lineHeight / u;
        for (let g = 0; g < e.lines.length; g++) {
          const x = (g * e.lineHeight + r / 2) / u;
          n.colorStops.forEach((o) => {
            const c = x + o.offset * m;
            f.addColorStop(
              // fix to 5 decimal places to avoid floating point precision issues
              Math.floor(c * bu) / bu,
              Q.shared.setValue(o.color).toHex()
            );
          });
        }
      } else
        n.colorStops.forEach((m) => {
          f.addColorStop(m.offset, Q.shared.setValue(m.color).toHex());
        });
      return f;
    }
  } else {
    const n = t.createPattern(s.texture.source.resource, "repeat"), a = s.matrix.copyTo(D.shared);
    return a.scale(s.texture.frame.width, s.texture.frame.height), n.setTransform(a), n;
  }
  return N("FillStyle not recognised", s), "red";
}
const Jp = class t_ extends kp {
  /**
   * @param options - The options for the dynamic bitmap font.
   */
  constructor(t) {
    super(), this.resolution = 1, this.pages = [], this._padding = 0, this._measureCache = /* @__PURE__ */ Object.create(null), this._currentChars = [], this._currentX = 0, this._currentY = 0, this._currentMaxCharHeight = 0, this._currentPageIndex = -1, this._skipKerning = !1;
    const e = { ...t_.defaultOptions, ...t };
    this._textureSize = e.textureSize, this._mipmap = e.mipmap;
    const r = e.style.clone();
    e.overrideFill && (r._fill.color = 16777215, r._fill.alpha = 1, r._fill.texture = k.WHITE, r._fill.fill = null), this.applyFillAsTint = e.overrideFill;
    const n = r.fontSize;
    r.fontSize = this.baseMeasurementFontSize;
    const a = An(r);
    e.overrideSize ? r._stroke && (r._stroke.width *= this.baseRenderedFontSize / n) : r.fontSize = this.baseRenderedFontSize = n, this._style = r, this._skipKerning = e.skipKerning ?? !1, this.resolution = e.resolution ?? 1, this._padding = e.padding ?? 4, e.textureStyle && (this._textureStyle = e.textureStyle instanceof $e ? e.textureStyle : new $e(e.textureStyle)), this.fontMetrics = me.measureFont(a), this.lineHeight = r.lineHeight || this.fontMetrics.fontSize || r.fontSize;
  }
  ensureCharacters(t) {
    const e = me.graphemeSegmenter(t).filter((d) => !this._currentChars.includes(d)).filter((d, _, y) => y.indexOf(d) === _);
    if (!e.length)
      return;
    this._currentChars = [...this._currentChars, ...e];
    let r;
    this._currentPageIndex === -1 ? r = this._nextPage() : r = this.pages[this._currentPageIndex];
    let { canvas: n, context: a } = r.canvasAndContext, l = r.texture.source;
    const h = this._style;
    let u = this._currentX, f = this._currentY, p = this._currentMaxCharHeight;
    const m = this.baseRenderedFontSize / this.baseMeasurementFontSize, g = this._padding * m;
    let x = !1;
    const o = n.width / this.resolution, c = n.height / this.resolution;
    for (let d = 0; d < e.length; d++) {
      const _ = e[d], y = me.measureText(_, h, n, !1);
      y.lineHeight = y.height;
      const v = y.width * m, b = Math.ceil((h.fontStyle === "italic" ? 2 : 1) * v), w = y.height * m, S = b + g * 2, T = w + g * 2;
      if (x = !1, _ !== `
` && _ !== "\r" && _ !== "	" && _ !== " " && (x = !0, p = Math.ceil(Math.max(T, p))), u + S > o && (f += p, p = T, u = 0, f + p > c)) {
        l.update();
        const C = this._nextPage();
        n = C.canvasAndContext.canvas, a = C.canvasAndContext.context, l = C.texture.source, u = 0, f = 0, p = 0;
      }
      const E = v / m - (h.dropShadow?.distance ?? 0) - (h._stroke?.width ?? 0);
      if (this.chars[_] = {
        id: _.codePointAt(0),
        xOffset: -this._padding,
        yOffset: -this._padding,
        xAdvance: E,
        kerning: {}
      }, x) {
        this._drawGlyph(
          a,
          y,
          u + g,
          f + g,
          m,
          h
        );
        const C = l.width * m, M = l.height * m, P = new Z(
          u / C * l.width,
          f / M * l.height,
          S / C * l.width,
          T / M * l.height
        );
        this.chars[_].texture = new k({
          source: l,
          frame: P
        }), u += Math.ceil(S);
      }
    }
    l.update(), this._currentX = u, this._currentY = f, this._currentMaxCharHeight = p, this._skipKerning && this._applyKerning(e, a);
  }
  /**
   * @deprecated since 8.0.0
   * The map of base page textures (i.e., sheets of glyphs).
   */
  get pageTextures() {
    return W(K, "BitmapFont.pageTextures is deprecated, please use BitmapFont.pages instead."), this.pages;
  }
  _applyKerning(t, e) {
    const r = this._measureCache;
    for (let n = 0; n < t.length; n++) {
      const a = t[n];
      for (let l = 0; l < this._currentChars.length; l++) {
        const h = this._currentChars[l];
        let u = r[a];
        u || (u = r[a] = e.measureText(a).width);
        let f = r[h];
        f || (f = r[h] = e.measureText(h).width);
        let p = e.measureText(a + h).width, m = p - (u + f);
        m && (this.chars[a].kerning[h] = m), p = e.measureText(a + h).width, m = p - (u + f), m && (this.chars[h].kerning[a] = m);
      }
    }
  }
  _nextPage() {
    this._currentPageIndex++;
    const t = this.resolution, e = oi.getOptimalCanvasAndContext(
      this._textureSize,
      this._textureSize,
      t
    );
    this._setupContext(e.context, this._style, t);
    const r = t * (this.baseRenderedFontSize / this.baseMeasurementFontSize), n = new k({
      source: new Ii({
        resource: e.canvas,
        resolution: r,
        alphaMode: "premultiply-alpha-on-upload",
        autoGenerateMipmaps: this._mipmap
      })
    });
    this._textureStyle && (n.source.style = this._textureStyle);
    const a = {
      canvasAndContext: e,
      texture: n
    };
    return this.pages[this._currentPageIndex] = a, a;
  }
  // canvas style!
  _setupContext(t, e, r) {
    e.fontSize = this.baseRenderedFontSize, t.scale(r, r), t.font = An(e), e.fontSize = this.baseMeasurementFontSize, t.textBaseline = e.textBaseline;
    const n = e._stroke, a = n?.width ?? 0;
    if (n && (t.lineWidth = a, t.lineJoin = n.join, t.miterLimit = n.miterLimit, t.strokeStyle = Mn(n, t)), e._fill && (t.fillStyle = Mn(e._fill, t)), e.dropShadow) {
      const l = e.dropShadow, h = Q.shared.setValue(l.color).toArray(), u = l.blur * r, f = l.distance * r;
      t.shadowColor = `rgba(${h[0] * 255},${h[1] * 255},${h[2] * 255},${l.alpha})`, t.shadowBlur = u, t.shadowOffsetX = Math.cos(l.angle) * f, t.shadowOffsetY = Math.sin(l.angle) * f;
    } else
      t.shadowColor = "black", t.shadowBlur = 0, t.shadowOffsetX = 0, t.shadowOffsetY = 0;
  }
  _drawGlyph(t, e, r, n, a, l) {
    const h = e.text, u = e.fontProperties, p = (l._stroke?.width ?? 0) * a, m = r + p / 2, g = n - p / 2, x = u.descent * a, o = e.lineHeight * a;
    l.stroke && p && t.strokeText(h, m, g + o - x), l._fill && t.fillText(h, m, g + o - x);
  }
  destroy() {
    super.destroy();
    for (let t = 0; t < this.pages.length; t++) {
      const { canvasAndContext: e, texture: r } = this.pages[t];
      oi.returnCanvasAndContext(e), r.destroy(!0);
    }
    this.pages = null;
  }
};
Jp.defaultOptions = {
  textureSize: 512,
  style: new ce(),
  mipmap: !0
};
let vu = Jp;
function e_(s, t, e, r) {
  const n = {
    width: 0,
    height: 0,
    offsetY: 0,
    scale: t.fontSize / e.baseMeasurementFontSize,
    lines: [{
      width: 0,
      charPositions: [],
      spaceWidth: 0,
      spacesIndex: [],
      chars: []
    }]
  };
  n.offsetY = e.baseLineOffset;
  let a = n.lines[0], l = null, h = !0;
  const u = {
    width: 0,
    start: 0,
    index: 0,
    // use index to not modify the array as we use it a lot!
    positions: [],
    chars: []
  }, f = (o) => {
    const c = a.width;
    for (let d = 0; d < u.index; d++) {
      const _ = o.positions[d];
      a.chars.push(o.chars[d]), a.charPositions.push(_ + c);
    }
    a.width += o.width, h = !1, u.width = 0, u.index = 0, u.chars.length = 0;
  }, p = () => {
    let o = a.chars.length - 1;
    if (r) {
      let c = a.chars[o];
      for (; c === " "; )
        a.width -= e.chars[c].xAdvance, c = a.chars[--o];
    }
    n.width = Math.max(n.width, a.width), a = {
      width: 0,
      charPositions: [],
      chars: [],
      spaceWidth: 0,
      spacesIndex: []
    }, h = !0, n.lines.push(a), n.height += e.lineHeight;
  }, m = e.baseMeasurementFontSize / t.fontSize, g = t.letterSpacing * m, x = t.wordWrapWidth * m;
  for (let o = 0; o < s.length + 1; o++) {
    let c;
    const d = o === s.length;
    d || (c = s[o]);
    const _ = e.chars[c] || e.chars[" "];
    if (/(?:\s)/.test(c) || c === "\r" || c === `
` || d) {
      if (!h && t.wordWrap && a.width + u.width - g > x ? (p(), f(u), d || a.charPositions.push(0)) : (u.start = a.width, f(u), d || a.charPositions.push(0)), c === "\r" || c === `
`)
        a.width !== 0 && p();
      else if (!d) {
        const w = _.xAdvance + (_.kerning[l] || 0) + g;
        a.width += w, a.spaceWidth = w, a.spacesIndex.push(a.charPositions.length), a.chars.push(c);
      }
    } else {
      const b = _.kerning[l] || 0, w = _.xAdvance + b + g;
      u.positions[u.index++] = u.width + b, u.chars.push(c), u.width += w;
    }
    l = c;
  }
  return p(), t.align === "center" ? p1(n) : t.align === "right" ? _1(n) : t.align === "justify" && m1(n), n;
}
function p1(s) {
  for (let t = 0; t < s.lines.length; t++) {
    const e = s.lines[t], r = s.width / 2 - e.width / 2;
    for (let n = 0; n < e.charPositions.length; n++)
      e.charPositions[n] += r;
  }
}
function _1(s) {
  for (let t = 0; t < s.lines.length; t++) {
    const e = s.lines[t], r = s.width - e.width;
    for (let n = 0; n < e.charPositions.length; n++)
      e.charPositions[n] += r;
  }
}
function m1(s) {
  const t = s.width;
  for (let e = 0; e < s.lines.length; e++) {
    const r = s.lines[e];
    let n = 0, a = r.spacesIndex[n++], l = 0;
    const h = r.spacesIndex.length, f = (t - r.width) / h;
    for (let p = 0; p < r.charPositions.length; p++)
      p === a && (a = r.spacesIndex[n++], l += f), r.charPositions[p] += l;
  }
}
function g1(s) {
  if (s === "")
    return [];
  typeof s == "string" && (s = [s]);
  const t = [];
  for (let e = 0, r = s.length; e < r; e++) {
    const n = s[e];
    if (Array.isArray(n)) {
      if (n.length !== 2)
        throw new Error(`[BitmapFont]: Invalid character range length, expecting 2 got ${n.length}.`);
      if (n[0].length === 0 || n[1].length === 0)
        throw new Error("[BitmapFont]: Invalid character delimiter.");
      const a = n[0].charCodeAt(0), l = n[1].charCodeAt(0);
      if (l < a)
        throw new Error("[BitmapFont]: Invalid character range.");
      for (let h = a, u = l; h <= u; h++)
        t.push(String.fromCharCode(h));
    } else
      t.push(...Array.from(n));
  }
  if (t.length === 0)
    throw new Error("[BitmapFont]: Empty set when resolving characters.");
  return t;
}
let Vs = 0;
class y1 {
  constructor() {
    this.ALPHA = [["a", "z"], ["A", "Z"], " "], this.NUMERIC = [["0", "9"]], this.ALPHANUMERIC = [["a", "z"], ["A", "Z"], ["0", "9"], " "], this.ASCII = [[" ", "~"]], this.defaultOptions = {
      chars: this.ALPHANUMERIC,
      resolution: 1,
      padding: 4,
      skipKerning: !1,
      textureStyle: null
    };
  }
  /**
   * Get a font for the specified text and style.
   * @param text - The text to get the font for
   * @param style - The style to use
   */
  getFont(t, e) {
    let r = `${e.fontFamily}-bitmap`, n = !0;
    if (e._fill.fill && !e._stroke)
      r += e._fill.fill.styleKey, n = !1;
    else if (e._stroke || e.dropShadow) {
      let l = e.styleKey;
      l = l.substring(0, l.lastIndexOf("-")), r = `${l}-bitmap`, n = !1;
    }
    if (!it.has(r)) {
      const l = new vu({
        style: e,
        overrideFill: n,
        overrideSize: !0,
        ...this.defaultOptions
      });
      Vs++, Vs > 50 && N("BitmapText", `You have dynamically created ${Vs} bitmap fonts, this can be inefficient. Try pre installing your font styles using \`BitmapFont.install({name:"style1", style})\``), l.once("destroy", () => {
        Vs--, it.remove(r);
      }), it.set(
        r,
        l
      );
    }
    const a = it.get(r);
    return a.ensureCharacters?.(t), a;
  }
  /**
   * Get the layout of a text for the specified style.
   * @param text - The text to get the layout for
   * @param style - The style to use
   * @param trimEnd - Whether to ignore whitespaces at the end of each line
   */
  getLayout(t, e, r = !0) {
    const n = this.getFont(t, e), a = me.graphemeSegmenter(t);
    return e_(a, e, n, r);
  }
  /**
   * Measure the text using the specified style.
   * @param text - The text to measure
   * @param style - The style to use
   * @param trimEnd - Whether to ignore whitespaces at the end of each line
   */
  measureText(t, e, r = !0) {
    return this.getLayout(t, e, r);
  }
  // eslint-disable-next-line max-len
  install(...t) {
    let e = t[0];
    typeof e == "string" && (e = {
      name: e,
      style: t[1],
      chars: t[2]?.chars,
      resolution: t[2]?.resolution,
      padding: t[2]?.padding,
      skipKerning: t[2]?.skipKerning
    }, W(K, "BitmapFontManager.install(name, style, options) is deprecated, use BitmapFontManager.install({name, style, ...options})"));
    const r = e?.name;
    if (!r)
      throw new Error("[BitmapFontManager] Property `name` is required.");
    e = { ...this.defaultOptions, ...e };
    const n = e.style, a = n instanceof ce ? n : new ce(n), l = a._fill.fill !== null && a._fill.fill !== void 0, h = new vu({
      style: a,
      overrideFill: l,
      skipKerning: e.skipKerning,
      padding: e.padding,
      resolution: e.resolution,
      overrideSize: !1,
      textureStyle: e.textureStyle
    }), u = g1(e.chars);
    return h.ensureCharacters(u.join("")), it.set(`${r}-bitmap`, h), h.once("destroy", () => it.remove(`${r}-bitmap`)), h;
  }
  /**
   * Uninstalls a bitmap font from the cache.
   * @param {string} name - The name of the bitmap font to uninstall.
   */
  uninstall(t) {
    const e = `${t}-bitmap`, r = it.get(e);
    r && r.destroy();
  }
}
const Yo = new y1();
class i_ extends kp {
  constructor(t, e) {
    super();
    const { textures: r, data: n } = t;
    Object.keys(n.pages).forEach((a) => {
      const l = n.pages[parseInt(a, 10)], h = r[l.id];
      this.pages.push({ texture: h });
    }), Object.keys(n.chars).forEach((a) => {
      const l = n.chars[a], {
        frame: h,
        source: u
      } = r[l.page], f = new Z(
        l.x + h.x,
        l.y + h.y,
        l.width,
        l.height
      ), p = new k({
        source: u,
        frame: f
      });
      this.chars[a] = {
        id: a.codePointAt(0),
        xOffset: l.xOffset,
        yOffset: l.yOffset,
        xAdvance: l.xAdvance,
        kerning: l.kerning ?? {},
        texture: p
      };
    }), this.baseRenderedFontSize = n.fontSize, this.baseMeasurementFontSize = n.fontSize, this.fontMetrics = {
      ascent: 0,
      descent: 0,
      fontSize: n.fontSize
    }, this.baseLineOffset = n.baseLineOffset, this.lineHeight = n.lineHeight, this.fontFamily = n.fontFamily, this.distanceField = n.distanceField ?? {
      type: "none",
      range: 0
    }, this.url = e;
  }
  /** Destroys the BitmapFont object. */
  destroy() {
    super.destroy();
    for (let t = 0; t < this.pages.length; t++) {
      const { texture: e } = this.pages[t];
      e.destroy(!0);
    }
    this.pages = null;
  }
  /**
   * Generates and installs a bitmap font with the specified options.
   * The font will be cached and available for use in BitmapText objects.
   * @param options - Setup options for font generation
   * @returns Installed font instance
   * @example
   * ```ts
   * // Install a basic font
   * BitmapFont.install({
   *     name: 'Title',
   *     style: {
   *         fontFamily: 'Arial',
   *         fontSize: 32,
   *         fill: '#ffffff'
   *     }
   * });
   *
   * // Install with advanced options
   * BitmapFont.install({
   *     name: 'Custom',
   *     style: {
   *         fontFamily: 'Arial',
   *         fontSize: 24,
   *         fill: '#00ff00',
   *         stroke: { color: '#000000', width: 2 }
   *     },
   *     chars: [['a', 'z'], ['A', 'Z'], ['0', '9']],
   *     resolution: 2,
   *     padding: 4,
   *     textureStyle: {
   *         scaleMode: 'nearest'
   *     }
   * });
   * ```
   */
  static install(t) {
    Yo.install(t);
  }
  /**
   * Uninstalls a bitmap font from the cache.
   * This frees up memory and resources associated with the font.
   * @param name - The name of the bitmap font to uninstall
   * @example
   * ```ts
   * // Remove a font when it's no longer needed
   * BitmapFont.uninstall('MyCustomFont');
   *
   * // Clear multiple fonts
   * ['Title', 'Heading', 'Body'].forEach(BitmapFont.uninstall);
   * ```
   */
  static uninstall(t) {
    Yo.uninstall(t);
  }
}
const La = {
  test(s) {
    return typeof s == "string" && s.startsWith("info face=");
  },
  parse(s) {
    const t = s.match(/^[a-z]+\s+.+$/gm), e = {
      info: [],
      common: [],
      page: [],
      char: [],
      chars: [],
      kerning: [],
      kernings: [],
      distanceField: []
    };
    for (const m in t) {
      const g = t[m].match(/^[a-z]+/gm)[0], x = t[m].match(/[a-zA-Z]+=([^\s"']+|"([^"]*)")/gm), o = {};
      for (const c in x) {
        const d = x[c].split("="), _ = d[0], y = d[1].replace(/"/gm, ""), v = parseFloat(y), b = isNaN(v) ? y : v;
        o[_] = b;
      }
      e[g].push(o);
    }
    const r = {
      chars: {},
      pages: [],
      lineHeight: 0,
      fontSize: 0,
      fontFamily: "",
      distanceField: null,
      baseLineOffset: 0
    }, [n] = e.info, [a] = e.common, [l] = e.distanceField ?? [];
    l && (r.distanceField = {
      range: parseInt(l.distanceRange, 10),
      type: l.fieldType
    }), r.fontSize = parseInt(n.size, 10), r.fontFamily = n.face, r.lineHeight = parseInt(a.lineHeight, 10);
    const h = e.page;
    for (let m = 0; m < h.length; m++)
      r.pages.push({
        id: parseInt(h[m].id, 10) || 0,
        file: h[m].file
      });
    const u = {};
    r.baseLineOffset = r.lineHeight - parseInt(a.base, 10);
    const f = e.char;
    for (let m = 0; m < f.length; m++) {
      const g = f[m], x = parseInt(g.id, 10);
      let o = g.letter ?? g.char ?? String.fromCharCode(x);
      o === "space" && (o = " "), u[x] = o, r.chars[o] = {
        id: x,
        // texture deets..
        page: parseInt(g.page, 10) || 0,
        x: parseInt(g.x, 10),
        y: parseInt(g.y, 10),
        width: parseInt(g.width, 10),
        height: parseInt(g.height, 10),
        xOffset: parseInt(g.xoffset, 10),
        yOffset: parseInt(g.yoffset, 10),
        xAdvance: parseInt(g.xadvance, 10),
        kerning: {}
      };
    }
    const p = e.kerning || [];
    for (let m = 0; m < p.length; m++) {
      const g = parseInt(p[m].first, 10), x = parseInt(p[m].second, 10), o = parseInt(p[m].amount, 10);
      r.chars[u[x]].kerning[u[g]] = o;
    }
    return r;
  }
}, wu = {
  test(s) {
    const t = s;
    return typeof t != "string" && "getElementsByTagName" in t && t.getElementsByTagName("page").length && t.getElementsByTagName("info")[0].getAttribute("face") !== null;
  },
  parse(s) {
    const t = {
      chars: {},
      pages: [],
      lineHeight: 0,
      fontSize: 0,
      fontFamily: "",
      distanceField: null,
      baseLineOffset: 0
    }, e = s.getElementsByTagName("info")[0], r = s.getElementsByTagName("common")[0], n = s.getElementsByTagName("distanceField")[0];
    n && (t.distanceField = {
      type: n.getAttribute("fieldType"),
      range: parseInt(n.getAttribute("distanceRange"), 10)
    });
    const a = s.getElementsByTagName("page"), l = s.getElementsByTagName("char"), h = s.getElementsByTagName("kerning");
    t.fontSize = parseInt(e.getAttribute("size"), 10), t.fontFamily = e.getAttribute("face"), t.lineHeight = parseInt(r.getAttribute("lineHeight"), 10);
    for (let f = 0; f < a.length; f++)
      t.pages.push({
        id: parseInt(a[f].getAttribute("id"), 10) || 0,
        file: a[f].getAttribute("file")
      });
    const u = {};
    t.baseLineOffset = t.lineHeight - parseInt(r.getAttribute("base"), 10);
    for (let f = 0; f < l.length; f++) {
      const p = l[f], m = parseInt(p.getAttribute("id"), 10);
      let g = p.getAttribute("letter") ?? p.getAttribute("char") ?? String.fromCharCode(m);
      g === "space" && (g = " "), u[m] = g, t.chars[g] = {
        id: m,
        // texture deets..
        page: parseInt(p.getAttribute("page"), 10) || 0,
        x: parseInt(p.getAttribute("x"), 10),
        y: parseInt(p.getAttribute("y"), 10),
        width: parseInt(p.getAttribute("width"), 10),
        height: parseInt(p.getAttribute("height"), 10),
        // render deets..
        xOffset: parseInt(p.getAttribute("xoffset"), 10),
        yOffset: parseInt(p.getAttribute("yoffset"), 10),
        // + baseLineOffset,
        xAdvance: parseInt(p.getAttribute("xadvance"), 10),
        kerning: {}
      };
    }
    for (let f = 0; f < h.length; f++) {
      const p = parseInt(h[f].getAttribute("first"), 10), m = parseInt(h[f].getAttribute("second"), 10), g = parseInt(h[f].getAttribute("amount"), 10);
      t.chars[u[m]].kerning[u[p]] = g;
    }
    return t;
  }
}, Su = {
  test(s) {
    return typeof s == "string" && s.includes("<font>") ? wu.test(Y.get().parseXML(s)) : !1;
  },
  parse(s) {
    return wu.parse(Y.get().parseXML(s));
  }
}, x1 = [".xml", ".fnt"], b1 = {
  extension: {
    type: A.CacheParser,
    name: "cacheBitmapFont"
  },
  test: (s) => s instanceof i_,
  getCacheableAssets(s, t) {
    const e = {};
    return s.forEach((r) => {
      e[r] = t, e[`${r}-bitmap`] = t;
    }), e[`${t.fontFamily}-bitmap`] = t, e;
  }
}, v1 = {
  extension: {
    type: A.LoadParser,
    priority: li.Normal
  },
  name: "loadBitmapFont",
  test(s) {
    return x1.includes(qt.extname(s).toLowerCase());
  },
  async testParse(s) {
    return La.test(s) || Su.test(s);
  },
  async parse(s, t, e) {
    const r = La.test(s) ? La.parse(s) : Su.parse(s), { src: n } = t, { pages: a } = r, l = [], h = r.distanceField ? {
      scaleMode: "linear",
      alphaMode: "premultiply-alpha-on-upload",
      autoGenerateMipmaps: !1,
      resolution: 1
    } : {};
    for (let m = 0; m < a.length; ++m) {
      const g = a[m].file;
      let x = qt.join(qt.dirname(n), g);
      x = Ro(x, n), l.push({
        src: x,
        data: h
      });
    }
    const u = await e.load(l), f = l.map((m) => u[m.src]);
    return new i_({
      data: r,
      textures: f
    }, n);
  },
  async load(s, t) {
    return await (await Y.get().fetch(s)).text();
  },
  async unload(s, t, e) {
    await Promise.all(s.pages.map((r) => e.unload(r.texture.source._sourceOrigin))), s.destroy();
  }
};
class w1 {
  /**
   * @param loader
   * @param verbose - should the loader log to the console
   */
  constructor(t, e = !1) {
    this._loader = t, this._assetList = [], this._isLoading = !1, this._maxConcurrent = 1, this.verbose = e;
  }
  /**
   * Adds assets to the background loading queue. Assets are loaded one at a time to minimize
   * performance impact.
   * @param assetUrls - Array of resolved assets to load in the background
   * @example
   * ```ts
   * // Add assets to background load queue
   * backgroundLoader.add([
   *     { src: 'images/level1/bg.png' },
   *     { src: 'images/level1/characters.json' }
   * ]);
   *
   * // Assets will load sequentially in the background
   * // The loader automatically pauses when high-priority loads occur
   * // e.g. Assets.load() is called
   * ```
   * @remarks
   * - Assets are loaded one at a time to minimize performance impact
   * - Loading automatically pauses when Assets.load() is called
   * - No progress tracking is available for background loading
   * - Assets are cached as they complete loading
   * @internal
   */
  add(t) {
    t.forEach((e) => {
      this._assetList.push(e);
    }), this.verbose && console.log("[BackgroundLoader] assets: ", this._assetList), this._isActive && !this._isLoading && this._next();
  }
  /**
   * Loads the next set of assets. Will try to load as many assets as it can at the same time.
   *
   * The max assets it will try to load at one time will be 4.
   */
  async _next() {
    if (this._assetList.length && this._isActive) {
      this._isLoading = !0;
      const t = [], e = Math.min(this._assetList.length, this._maxConcurrent);
      for (let r = 0; r < e; r++)
        t.push(this._assetList.pop());
      await this._loader.load(t), this._isLoading = !1, this._next();
    }
  }
  /**
   * Controls the active state of the background loader. When active, the loader will
   * continue processing its queue. When inactive, loading is paused.
   * @returns Whether the background loader is currently active
   * @example
   * ```ts
   * // Pause background loading
   * backgroundLoader.active = false;
   *
   * // Resume background loading
   * backgroundLoader.active = true;
   *
   * // Check current state
   * console.log(backgroundLoader.active); // true/false
   *
   * // Common use case: Pause during intensive operations
   * backgroundLoader.active = false;  // Pause background loading
   * ... // Perform high-priority tasks
   * backgroundLoader.active = true;   // Resume background loading
   * ```
   * @remarks
   * - Setting to true resumes loading immediately
   * - Setting to false pauses after current asset completes
   * - Background loading is automatically paused during `Assets.load()`
   * - Assets already being loaded will complete even when set to false
   */
  get active() {
    return this._isActive;
  }
  set active(t) {
    this._isActive !== t && (this._isActive = t, t && !this._isLoading && this._next());
  }
}
const S1 = {
  extension: {
    type: A.CacheParser,
    name: "cacheTextureArray"
  },
  test: (s) => Array.isArray(s) && s.every((t) => t instanceof k),
  getCacheableAssets: (s, t) => {
    const e = {};
    return s.forEach((r) => {
      t.forEach((n, a) => {
        e[r + (a === 0 ? "" : a + 1)] = n;
      });
    }), e;
  }
};
async function r_(s) {
  if ("Image" in globalThis)
    return new Promise((t) => {
      const e = new Image();
      e.onload = () => {
        t(!0);
      }, e.onerror = () => {
        t(!1);
      }, e.src = s;
    });
  if ("createImageBitmap" in globalThis && "fetch" in globalThis) {
    try {
      const t = await (await fetch(s)).blob();
      await createImageBitmap(t);
    } catch {
      return !1;
    }
    return !0;
  }
  return !1;
}
const T1 = {
  extension: {
    type: A.DetectionParser,
    priority: 1
  },
  test: async () => r_(
    // eslint-disable-next-line max-len
    "data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAAB0AAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAIAAAACAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQ0MAAAAABNjb2xybmNseAACAAIAAYAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAACVtZGF0EgAKCBgANogQEAwgMg8f8D///8WfhwB8+ErK42A="
  ),
  add: async (s) => [...s, "avif"],
  remove: async (s) => s.filter((t) => t !== "avif")
}, Tu = ["png", "jpg", "jpeg"], C1 = {
  extension: {
    type: A.DetectionParser,
    priority: -1
  },
  test: () => Promise.resolve(!0),
  add: async (s) => [...s, ...Tu],
  remove: async (s) => s.filter((t) => !Tu.includes(t))
}, E1 = "WorkerGlobalScope" in globalThis && globalThis instanceof globalThis.WorkerGlobalScope;
function Jh(s) {
  return E1 ? !1 : document.createElement("video").canPlayType(s) !== "";
}
const A1 = {
  extension: {
    type: A.DetectionParser,
    priority: 0
  },
  test: async () => Jh("video/mp4"),
  add: async (s) => [...s, "mp4", "m4v"],
  remove: async (s) => s.filter((t) => t !== "mp4" && t !== "m4v")
}, P1 = {
  extension: {
    type: A.DetectionParser,
    priority: 0
  },
  test: async () => Jh("video/ogg"),
  add: async (s) => [...s, "ogv"],
  remove: async (s) => s.filter((t) => t !== "ogv")
}, M1 = {
  extension: {
    type: A.DetectionParser,
    priority: 0
  },
  test: async () => Jh("video/webm"),
  add: async (s) => [...s, "webm"],
  remove: async (s) => s.filter((t) => t !== "webm")
}, B1 = {
  extension: {
    type: A.DetectionParser,
    priority: 0
  },
  test: async () => r_(
    "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA="
  ),
  add: async (s) => [...s, "webp"],
  remove: async (s) => s.filter((t) => t !== "webp")
};
class U1 {
  constructor() {
    this._parsers = [], this._parsersValidated = !1, this.parsers = new Proxy(this._parsers, {
      set: (t, e, r) => (this._parsersValidated = !1, t[e] = r, !0)
    }), this.promiseCache = {};
  }
  /** function used for testing */
  reset() {
    this._parsersValidated = !1, this.promiseCache = {};
  }
  /**
   * Used internally to generate a promise for the asset to be loaded.
   * @param url - The URL to be loaded
   * @param data - any custom additional information relevant to the asset being loaded
   * @returns - a promise that will resolve to an Asset for example a Texture of a JSON object
   */
  _getLoadPromiseAndParser(t, e) {
    const r = {
      promise: null,
      parser: null
    };
    return r.promise = (async () => {
      let n = null, a = null;
      if (e.loadParser && (a = this._parserHash[e.loadParser], a || N(`[Assets] specified load parser "${e.loadParser}" not found while loading ${t}`)), !a) {
        for (let l = 0; l < this.parsers.length; l++) {
          const h = this.parsers[l];
          if (h.load && h.test?.(t, e, this)) {
            a = h;
            break;
          }
        }
        if (!a)
          return N(`[Assets] ${t} could not be loaded as we don't know how to parse it, ensure the correct parser has been added`), null;
      }
      n = await a.load(t, e, this), r.parser = a;
      for (let l = 0; l < this.parsers.length; l++) {
        const h = this.parsers[l];
        h.parse && h.parse && await h.testParse?.(n, e, this) && (n = await h.parse(n, e, this) || n, r.parser = h);
      }
      return n;
    })(), r;
  }
  async load(t, e) {
    this._parsersValidated || this._validateParsers();
    let r = 0;
    const n = {}, a = Cn(t), l = _e(t, (f) => ({
      alias: [f],
      src: f,
      data: {}
    })), h = l.length, u = l.map(async (f) => {
      const p = qt.toAbsolute(f.src);
      if (!n[f.src])
        try {
          this.promiseCache[p] || (this.promiseCache[p] = this._getLoadPromiseAndParser(p, f)), n[f.src] = await this.promiseCache[p].promise, e && e(++r / h);
        } catch (m) {
          throw delete this.promiseCache[p], delete n[f.src], new Error(`[Loader.load] Failed to load ${p}.
${m}`);
        }
    });
    return await Promise.all(u), a ? n[l[0].src] : n;
  }
  /**
   * Unloads one or more assets. Any unloaded assets will be destroyed, freeing up memory for your app.
   * The parser that created the asset, will be the one that unloads it.
   * @example
   * // Single asset:
   * const asset = await Loader.load('cool.png');
   *
   * await Loader.unload('cool.png');
   *
   * console.log(asset.destroyed); // true
   * @param assetsToUnloadIn - urls that you want to unload, or a single one!
   */
  async unload(t) {
    const r = _e(t, (n) => ({
      alias: [n],
      src: n
    })).map(async (n) => {
      const a = qt.toAbsolute(n.src), l = this.promiseCache[a];
      if (l) {
        const h = await l.promise;
        delete this.promiseCache[a], await l.parser?.unload?.(h, n, this);
      }
    });
    await Promise.all(r);
  }
  /** validates our parsers, right now it only checks for name conflicts but we can add more here as required! */
  _validateParsers() {
    this._parsersValidated = !0, this._parserHash = this._parsers.filter((t) => t.name).reduce((t, e) => (e.name ? t[e.name] && N(`[Assets] loadParser name conflict "${e.name}"`) : N("[Assets] loadParser should have a name"), { ...t, [e.name]: e }), {});
  }
}
function xr(s, t) {
  if (Array.isArray(t)) {
    for (const e of t)
      if (s.startsWith(`data:${e}`))
        return !0;
    return !1;
  }
  return s.startsWith(`data:${t}`);
}
function br(s, t) {
  const e = s.split("?")[0], r = qt.extname(e).toLowerCase();
  return Array.isArray(t) ? t.includes(r) : r === t;
}
const R1 = ".json", I1 = "application/json", k1 = {
  extension: {
    type: A.LoadParser,
    priority: li.Low
  },
  name: "loadJson",
  test(s) {
    return xr(s, I1) || br(s, R1);
  },
  async load(s) {
    return await (await Y.get().fetch(s)).json();
  }
}, F1 = ".txt", D1 = "text/plain", O1 = {
  name: "loadTxt",
  extension: {
    type: A.LoadParser,
    priority: li.Low,
    name: "loadTxt"
  },
  test(s) {
    return xr(s, D1) || br(s, F1);
  },
  async load(s) {
    return await (await Y.get().fetch(s)).text();
  }
}, L1 = [
  "normal",
  "bold",
  "100",
  "200",
  "300",
  "400",
  "500",
  "600",
  "700",
  "800",
  "900"
], G1 = [".ttf", ".otf", ".woff", ".woff2"], z1 = [
  "font/ttf",
  "font/otf",
  "font/woff",
  "font/woff2"
], N1 = /^(--|-?[A-Z_])[0-9A-Z_-]*$/i;
function H1(s) {
  const t = qt.extname(s), n = qt.basename(s, t).replace(/(-|_)/g, " ").toLowerCase().split(" ").map((h) => h.charAt(0).toUpperCase() + h.slice(1));
  let a = n.length > 0;
  for (const h of n)
    if (!h.match(N1)) {
      a = !1;
      break;
    }
  let l = n.join(" ");
  return a || (l = `"${l.replace(/[\\"]/g, "\\$&")}"`), l;
}
const W1 = /^[0-9A-Za-z%:/?#\[\]@!\$&'()\*\+,;=\-._~]*$/;
function V1(s) {
  return W1.test(s) ? s : encodeURI(s);
}
const $1 = {
  extension: {
    type: A.LoadParser,
    priority: li.Low
  },
  name: "loadWebFont",
  test(s) {
    return xr(s, z1) || br(s, G1);
  },
  async load(s, t) {
    const e = Y.get().getFontFaceSet();
    if (e) {
      const r = [], n = t.data?.family ?? H1(s), a = t.data?.weights?.filter((h) => L1.includes(h)) ?? ["normal"], l = t.data ?? {};
      for (let h = 0; h < a.length; h++) {
        const u = a[h], f = new FontFace(n, `url(${V1(s)})`, {
          ...l,
          weight: u
        });
        await f.load(), e.add(f), r.push(f);
      }
      return it.set(`${n}-and-url`, {
        url: s,
        fontFaces: r
      }), r.length === 1 ? r[0] : r;
    }
    return N("[loadWebFont] FontFace API is not supported. Skipping loading font"), null;
  },
  unload(s) {
    (Array.isArray(s) ? s : [s]).forEach((t) => {
      it.remove(`${t.family}-and-url`), Y.get().getFontFaceSet().delete(t);
    });
  }
};
function tl(s, t = 1) {
  const e = mr.RETINA_PREFIX?.exec(s);
  return e ? parseFloat(e[1]) : t;
}
function el(s, t, e) {
  s.label = e, s._sourceOrigin = e;
  const r = new k({
    source: s,
    label: e
  }), n = () => {
    delete t.promiseCache[e], it.has(e) && it.remove(e);
  };
  return r.source.once("destroy", () => {
    t.promiseCache[e] && (N("[Assets] A TextureSource managed by Assets was destroyed instead of unloaded! Use Assets.unload() instead of destroying the TextureSource."), n());
  }), r.once("destroy", () => {
    s.destroyed || (N("[Assets] A Texture managed by Assets was destroyed instead of unloaded! Use Assets.unload() instead of destroying the Texture."), n());
  }), r;
}
const Y1 = ".svg", X1 = "image/svg+xml", j1 = {
  extension: {
    type: A.LoadParser,
    priority: li.Low,
    name: "loadSVG"
  },
  name: "loadSVG",
  config: {
    crossOrigin: "anonymous",
    parseAsGraphicsContext: !1
  },
  test(s) {
    return xr(s, X1) || br(s, Y1);
  },
  async load(s, t, e) {
    return t.data?.parseAsGraphicsContext ?? this.config.parseAsGraphicsContext ? q1(s) : K1(s, t, e, this.config.crossOrigin);
  },
  unload(s) {
    s.destroy(!0);
  }
};
async function K1(s, t, e, r) {
  const a = await (await Y.get().fetch(s)).blob(), l = URL.createObjectURL(a), h = new Image();
  h.src = l, h.crossOrigin = r, await h.decode(), URL.revokeObjectURL(l);
  const u = document.createElement("canvas"), f = u.getContext("2d"), p = t.data?.resolution || tl(s), m = t.data?.width ?? h.width, g = t.data?.height ?? h.height;
  u.width = m * p, u.height = g * p, f.drawImage(h, 0, 0, m * p, g * p);
  const { parseAsGraphicsContext: x, ...o } = t.data ?? {}, c = new Ii({
    resource: u,
    alphaMode: "premultiply-alpha-on-upload",
    resolution: p,
    ...o
  });
  return el(c, e, s);
}
async function q1(s) {
  const e = await (await Y.get().fetch(s)).text(), r = new ne();
  return r.svg(e), r;
}
const Z1 = `(function () {
    'use strict';

    const WHITE_PNG = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+ip1sAAAAASUVORK5CYII=";
    async function checkImageBitmap() {
      try {
        if (typeof createImageBitmap !== "function")
          return false;
        const response = await fetch(WHITE_PNG);
        const imageBlob = await response.blob();
        const imageBitmap = await createImageBitmap(imageBlob);
        return imageBitmap.width === 1 && imageBitmap.height === 1;
      } catch (_e) {
        return false;
      }
    }
    void checkImageBitmap().then((result) => {
      self.postMessage(result);
    });

})();
`;
let Ji = null, Xo = class {
  constructor() {
    Ji || (Ji = URL.createObjectURL(new Blob([Z1], { type: "application/javascript" }))), this.worker = new Worker(Ji);
  }
};
Xo.revokeObjectURL = function() {
  Ji && (URL.revokeObjectURL(Ji), Ji = null);
};
const Q1 = `(function () {
    'use strict';

    async function loadImageBitmap(url, alphaMode) {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(\`[WorkerManager.loadImageBitmap] Failed to fetch \${url}: \${response.status} \${response.statusText}\`);
      }
      const imageBlob = await response.blob();
      return alphaMode === "premultiplied-alpha" ? createImageBitmap(imageBlob, { premultiplyAlpha: "none" }) : createImageBitmap(imageBlob);
    }
    self.onmessage = async (event) => {
      try {
        const imageBitmap = await loadImageBitmap(event.data.data[0], event.data.data[1]);
        self.postMessage({
          data: imageBitmap,
          uuid: event.data.uuid,
          id: event.data.id
        }, [imageBitmap]);
      } catch (e) {
        self.postMessage({
          error: e,
          uuid: event.data.uuid,
          id: event.data.id
        });
      }
    };

})();
`;
let tr = null;
class s_ {
  constructor() {
    tr || (tr = URL.createObjectURL(new Blob([Q1], { type: "application/javascript" }))), this.worker = new Worker(tr);
  }
}
s_.revokeObjectURL = function() {
  tr && (URL.revokeObjectURL(tr), tr = null);
};
let Cu = 0, Ga;
class J1 {
  constructor() {
    this._initialized = !1, this._createdWorkers = 0, this._workerPool = [], this._queue = [], this._resolveHash = {};
  }
  isImageBitmapSupported() {
    return this._isImageBitmapSupported !== void 0 ? this._isImageBitmapSupported : (this._isImageBitmapSupported = new Promise((t) => {
      const { worker: e } = new Xo();
      e.addEventListener("message", (r) => {
        e.terminate(), Xo.revokeObjectURL(), t(r.data);
      });
    }), this._isImageBitmapSupported);
  }
  loadImageBitmap(t, e) {
    return this._run("loadImageBitmap", [t, e?.data?.alphaMode]);
  }
  async _initWorkers() {
    this._initialized || (this._initialized = !0);
  }
  _getWorker() {
    Ga === void 0 && (Ga = navigator.hardwareConcurrency || 4);
    let t = this._workerPool.pop();
    return !t && this._createdWorkers < Ga && (this._createdWorkers++, t = new s_().worker, t.addEventListener("message", (e) => {
      this._complete(e.data), this._returnWorker(e.target), this._next();
    })), t;
  }
  _returnWorker(t) {
    this._workerPool.push(t);
  }
  _complete(t) {
    t.error !== void 0 ? this._resolveHash[t.uuid].reject(t.error) : this._resolveHash[t.uuid].resolve(t.data), this._resolveHash[t.uuid] = null;
  }
  async _run(t, e) {
    await this._initWorkers();
    const r = new Promise((n, a) => {
      this._queue.push({ id: t, arguments: e, resolve: n, reject: a });
    });
    return this._next(), r;
  }
  _next() {
    if (!this._queue.length)
      return;
    const t = this._getWorker();
    if (!t)
      return;
    const e = this._queue.pop(), r = e.id;
    this._resolveHash[Cu] = { resolve: e.resolve, reject: e.reject }, t.postMessage({
      data: e.arguments,
      uuid: Cu++,
      id: r
    });
  }
}
const Eu = new J1(), tS = [".jpeg", ".jpg", ".png", ".webp", ".avif"], eS = [
  "image/jpeg",
  "image/png",
  "image/webp",
  "image/avif"
];
async function iS(s, t) {
  const e = await Y.get().fetch(s);
  if (!e.ok)
    throw new Error(`[loadImageBitmap] Failed to fetch ${s}: ${e.status} ${e.statusText}`);
  const r = await e.blob();
  return t?.data?.alphaMode === "premultiplied-alpha" ? createImageBitmap(r, { premultiplyAlpha: "none" }) : createImageBitmap(r);
}
const n_ = {
  name: "loadTextures",
  extension: {
    type: A.LoadParser,
    priority: li.High,
    name: "loadTextures"
  },
  config: {
    preferWorkers: !0,
    preferCreateImageBitmap: !0,
    crossOrigin: "anonymous"
  },
  test(s) {
    return xr(s, eS) || br(s, tS);
  },
  async load(s, t, e) {
    let r = null;
    globalThis.createImageBitmap && this.config.preferCreateImageBitmap ? this.config.preferWorkers && await Eu.isImageBitmapSupported() ? r = await Eu.loadImageBitmap(s, t) : r = await iS(s, t) : r = await new Promise((a, l) => {
      r = new Image(), r.crossOrigin = this.config.crossOrigin, r.src = s, r.complete ? a(r) : (r.onload = () => {
        a(r);
      }, r.onerror = l);
    });
    const n = new Ii({
      resource: r,
      alphaMode: "premultiply-alpha-on-upload",
      resolution: t.data?.resolution || tl(s),
      ...t.data
    });
    return el(n, e, s);
  },
  unload(s) {
    s.destroy(!0);
  }
}, a_ = [".mp4", ".m4v", ".webm", ".ogg", ".ogv", ".h264", ".avi", ".mov"], rS = a_.map((s) => `video/${s.substring(1)}`);
function sS(s, t, e) {
  e === void 0 && !t.startsWith("data:") ? s.crossOrigin = aS(t) : e !== !1 && (s.crossOrigin = typeof e == "string" ? e : "anonymous");
}
function nS(s) {
  return new Promise((t, e) => {
    s.addEventListener("canplaythrough", r), s.addEventListener("error", n), s.load();
    function r() {
      a(), t();
    }
    function n(l) {
      a(), e(l);
    }
    function a() {
      s.removeEventListener("canplaythrough", r), s.removeEventListener("error", n);
    }
  });
}
function aS(s, t = globalThis.location) {
  if (s.startsWith("data:"))
    return "";
  t || (t = globalThis.location);
  const e = new URL(s, document.baseURI);
  return e.hostname !== t.hostname || e.port !== t.port || e.protocol !== t.protocol ? "anonymous" : "";
}
const oS = {
  name: "loadVideo",
  extension: {
    type: A.LoadParser,
    name: "loadVideo"
  },
  test(s) {
    const t = xr(s, rS), e = br(s, a_);
    return t || e;
  },
  async load(s, t, e) {
    const r = {
      ...an.defaultOptions,
      resolution: t.data?.resolution || tl(s),
      alphaMode: t.data?.alphaMode || await op(),
      ...t.data
    }, n = document.createElement("video"), a = {
      preload: r.autoLoad !== !1 ? "auto" : void 0,
      "webkit-playsinline": r.playsinline !== !1 ? "" : void 0,
      playsinline: r.playsinline !== !1 ? "" : void 0,
      muted: r.muted === !0 ? "" : void 0,
      loop: r.loop === !0 ? "" : void 0,
      autoplay: r.autoPlay !== !1 ? "" : void 0
    };
    Object.keys(a).forEach((u) => {
      const f = a[u];
      f !== void 0 && n.setAttribute(u, f);
    }), r.muted === !0 && (n.muted = !0), sS(n, s, r.crossorigin);
    const l = document.createElement("source");
    let h;
    if (s.startsWith("data:"))
      h = s.slice(5, s.indexOf(";"));
    else if (!s.startsWith("blob:")) {
      const u = s.split("?")[0].slice(s.lastIndexOf(".") + 1).toLowerCase();
      h = an.MIME_TYPES[u] || `video/${u}`;
    }
    return l.src = s, h && (l.type = h), new Promise((u) => {
      const f = async () => {
        const p = new an({ ...r, resource: n });
        n.removeEventListener("canplay", f), t.data.preload && await nS(n), u(el(p, e, s));
      };
      r.preload && !r.autoPlay && n.load(), n.addEventListener("canplay", f), n.appendChild(l);
    });
  },
  unload(s) {
    s.destroy(!0);
  }
}, o_ = {
  extension: {
    type: A.ResolveParser,
    name: "resolveTexture"
  },
  test: n_.test,
  parse: (s) => ({
    resolution: parseFloat(mr.RETINA_PREFIX.exec(s)?.[1] ?? "1"),
    format: s.split(".").pop(),
    src: s
  })
}, hS = {
  extension: {
    type: A.ResolveParser,
    priority: -2,
    name: "resolveJson"
  },
  test: (s) => mr.RETINA_PREFIX.test(s) && s.endsWith(".json"),
  parse: o_.parse
};
class lS {
  constructor() {
    this._detections = [], this._initialized = !1, this.resolver = new mr(), this.loader = new U1(), this.cache = it, this._backgroundLoader = new w1(this.loader), this._backgroundLoader.active = !0, this.reset();
  }
  /**
   * Initializes the Assets class with configuration options. While not required,
   * calling this before loading assets is recommended to set up default behaviors.
   * @param options - Configuration options for the Assets system
   * @example
   * ```ts
   * // Basic initialization (optional as Assets.load will call this automatically)
   * await Assets.init();
   *
   * // With CDN configuration
   * await Assets.init({
   *     basePath: 'https://my-cdn.com/assets/',
   *     defaultSearchParams: { version: '1.0.0' }
   * });
   *
   * // With manifest and preferences
   * await Assets.init({
   *     manifest: {
   *         bundles: [{
   *             name: 'game-screen',
   *             assets: [
   *                 {
   *                     alias: 'hero',
   *                     src: 'hero.{png,webp}',
   *                     data: { scaleMode: SCALE_MODES.NEAREST }
   *                 },
   *                 {
   *                     alias: 'map',
   *                     src: 'map.json'
   *                 }
   *             ]
   *         }]
   *     },
   *     // Optimize for device capabilities
   *     texturePreference: {
   *         resolution: window.devicePixelRatio,
   *         format: ['webp', 'png']
   *     },
   *     // Set global preferences
   *     preferences: {
   *         crossOrigin: 'anonymous',
   *     }
   * });
   *
   * // Load assets after initialization
   * const heroTexture = await Assets.load('hero');
   * ```
   * @remarks
   * - Can be called only once; subsequent calls will be ignored with a warning
   * - Format detection runs automatically unless `skipDetections` is true
   * - The manifest can be a URL to a JSON file or an inline object
   * @see {@link AssetInitOptions} For all available initialization options
   * @see {@link AssetsManifest} For manifest format details
   */
  async init(t = {}) {
    if (this._initialized) {
      N("[Assets]AssetManager already initialized, did you load before calling this Assets.init()?");
      return;
    }
    if (this._initialized = !0, t.defaultSearchParams && this.resolver.setDefaultSearchParams(t.defaultSearchParams), t.basePath && (this.resolver.basePath = t.basePath), t.bundleIdentifier && this.resolver.setBundleIdentifier(t.bundleIdentifier), t.manifest) {
      let a = t.manifest;
      typeof a == "string" && (a = await this.load(a)), this.resolver.addManifest(a);
    }
    const e = t.texturePreference?.resolution ?? 1, r = typeof e == "number" ? [e] : e, n = await this._detectFormats({
      preferredFormats: t.texturePreference?.format,
      skipDetections: t.skipDetections,
      detections: this._detections
    });
    this.resolver.prefer({
      params: {
        format: n,
        resolution: r
      }
    }), t.preferences && this.setPreferences(t.preferences);
  }
  /**
   * Registers assets with the Assets resolver. This method maps keys (aliases) to asset sources,
   * allowing you to load assets using friendly names instead of direct URLs.
   * @param assets - The unresolved assets to add to the resolver
   * @example
   * ```ts
   * // Basic usage - single asset
   * Assets.add({
   *     alias: 'myTexture',
   *     src: 'assets/texture.png'
   * });
   * const texture = await Assets.load('myTexture');
   *
   * // Multiple aliases for the same asset
   * Assets.add({
   *     alias: ['hero', 'player'],
   *     src: 'hero.png'
   * });
   * const hero1 = await Assets.load('hero');
   * const hero2 = await Assets.load('player'); // Same texture
   *
   * // Multiple format support
   * Assets.add({
   *     alias: 'character',
   *     src: 'character.{webp,png}' // Will choose best format
   * });
   * Assets.add({
   *     alias: 'character',
   *     src: ['character.webp', 'character.png'], // Explicitly specify formats
   * });
   *
   * // With texture options
   * Assets.add({
   *     alias: 'sprite',
   *     src: 'sprite.png',
   *     data: { scaleMode: 'nearest' }
   * });
   *
   * // Multiple assets at once
   * Assets.add([
   *     { alias: 'bg', src: 'background.png' },
   *     { alias: 'music', src: 'music.mp3' },
   *     { alias: 'spritesheet', src: 'sheet.json', data: { ignoreMultiPack: false } }
   * ]);
   * ```
   * @remarks
   * - Assets are resolved when loaded, not when added
   * - Multiple formats use the best available format for the browser
   * - Adding with same alias overwrites previous definition
   * - The `data` property is passed to the asset loader
   * @see {@link Resolver} For details on asset resolution
   * @see {@link LoaderParser} For asset-specific data options
   * @advanced
   */
  add(t) {
    this.resolver.add(t);
  }
  async load(t, e) {
    this._initialized || await this.init();
    const r = Cn(t), n = _e(t).map((h) => {
      if (typeof h != "string") {
        const u = this.resolver.getAlias(h);
        return u.some((f) => !this.resolver.hasKey(f)) && this.add(h), Array.isArray(u) ? u[0] : u;
      }
      return this.resolver.hasKey(h) || this.add({ alias: h, src: h }), h;
    }), a = this.resolver.resolve(n), l = await this._mapLoadToResolve(a, e);
    return r ? l[n[0]] : l;
  }
  /**
   * Registers a bundle of assets that can be loaded as a group. Bundles are useful for organizing
   * assets into logical groups, such as game levels or UI screens.
   * @param bundleId - Unique identifier for the bundle
   * @param assets - Assets to include in the bundle
   * @example
   * ```ts
   * // Add a bundle using array format
   * Assets.addBundle('animals', [
   *     { alias: 'bunny', src: 'bunny.png' },
   *     { alias: 'chicken', src: 'chicken.png' },
   *     { alias: 'thumper', src: 'thumper.png' },
   * ]);
   *
   * // Add a bundle using object format
   * Assets.addBundle('animals', {
   *     bunny: 'bunny.png',
   *     chicken: 'chicken.png',
   *     thumper: 'thumper.png',
   * });
   *
   * // Add a bundle with advanced options
   * Assets.addBundle('ui', [
   *     {
   *         alias: 'button',
   *         src: 'button.{webp,png}',
   *         data: { scaleMode: 'nearest' }
   *     },
   *     {
   *         alias: ['logo', 'brand'],  // Multiple aliases
   *         src: 'logo.svg',
   *         data: { resolution: 2 }
   *     }
   * ]);
   *
   * // Load the bundle
   * await Assets.loadBundle('animals');
   *
   * // Use the loaded assets
   * const bunny = Sprite.from('bunny');
   * const chicken = Sprite.from('chicken');
   * ```
   * @remarks
   * - Bundle IDs must be unique
   * - Assets in bundles are not loaded until `loadBundle` is called
   * - Bundles can be background loaded using `backgroundLoadBundle`
   * - Assets in bundles can be loaded individually using their aliases
   * @see {@link Assets.loadBundle} For loading bundles
   * @see {@link Assets.backgroundLoadBundle} For background loading bundles
   * @see {@link Assets.unloadBundle} For unloading bundles
   * @see {@link AssetsManifest} For manifest format details
   */
  addBundle(t, e) {
    this.resolver.addBundle(t, e);
  }
  /**
   * Loads a bundle or multiple bundles of assets. Bundles are collections of related assets
   * that can be loaded together.
   * @param bundleIds - Single bundle ID or array of bundle IDs to load
   * @param onProgress - Optional callback for load progress (0.0 to 1.0)
   * @returns Promise that resolves with the loaded bundle assets
   * @example
   * ```ts
   * // Define bundles in your manifest
   * const manifest = {
   *     bundles: [
   *         {
   *             name: 'load-screen',
   *             assets: [
   *                 {
   *                     alias: 'background',
   *                     src: 'sunset.png',
   *                 },
   *                 {
   *                     alias: 'bar',
   *                     src: 'load-bar.{png,webp}', // use an array of individual assets
   *                 },
   *             ],
   *         },
   *         {
   *             name: 'game-screen',
   *             assets: [
   *                 {
   *                     alias: 'character',
   *                     src: 'robot.png',
   *                 },
   *                 {
   *                     alias: 'enemy',
   *                     src: 'bad-guy.png',
   *                 },
   *             ],
   *         },
   *     ]
   * };
   *
   * // Initialize with manifest
   * await Assets.init({ manifest });
   *
   * // Or add bundles programmatically
   * Assets.addBundle('load-screen', [...]);
   * Assets.loadBundle('load-screen');
   *
   * // Load a single bundle
   * await Assets.loadBundle('load-screen');
   * const bg = Sprite.from('background'); // Uses alias from bundle
   *
   * // Load multiple bundles
   * await Assets.loadBundle([
   *     'load-screen',
   *     'game-screen'
   * ]);
   *
   * // Load with progress tracking
   * await Assets.loadBundle('game-screen', (progress) => {
   *     console.log(`Loading: ${Math.round(progress * 100)}%`);
   * });
   * ```
   * @remarks
   * - Bundle assets are cached automatically
   * - Bundles can be pre-loaded using `backgroundLoadBundle`
   * - Assets in bundles can be accessed by their aliases
   * - Progress callback receives values from 0.0 to 1.0
   * @throws {Error} If the bundle ID doesn't exist in the manifest
   * @see {@link Assets.addBundle} For adding bundles programmatically
   * @see {@link Assets.backgroundLoadBundle} For background loading bundles
   * @see {@link Assets.unloadBundle} For unloading bundles
   * @see {@link AssetsManifest} For manifest format details
   */
  async loadBundle(t, e) {
    this._initialized || await this.init();
    let r = !1;
    typeof t == "string" && (r = !0, t = [t]);
    const n = this.resolver.resolveBundle(t), a = {}, l = Object.keys(n);
    let h = 0, u = 0;
    const f = () => {
      e?.(++h / u);
    }, p = l.map((m) => {
      const g = n[m];
      return u += Object.keys(g).length, this._mapLoadToResolve(g, f).then((x) => {
        a[m] = x;
      });
    });
    return await Promise.all(p), r ? a[t[0]] : a;
  }
  /**
   * Initiates background loading of assets. This allows assets to be loaded passively while other operations
   * continue, making them instantly available when needed later.
   *
   * Background loading is useful for:
   * - Preloading game levels while in a menu
   * - Loading non-critical assets during gameplay
   * - Reducing visible loading screens
   * @param urls - Single URL/alias or array of URLs/aliases to load in the background
   * @example
   * ```ts
   * // Basic background loading
   * Assets.backgroundLoad('images/level2-assets.png');
   *
   * // Background load multiple assets
   * Assets.backgroundLoad([
   *     'images/sprite1.png',
   *     'images/sprite2.png',
   *     'images/background.png'
   * ]);
   *
   * // Later, when you need the assets
   * const textures = await Assets.load([
   *     'images/sprite1.png',
   *     'images/sprite2.png'
   * ]); // Resolves immediately if background loading completed
   * ```
   * @remarks
   * - Background loading happens one asset at a time to avoid blocking the main thread
   * - Loading can be interrupted safely by calling `Assets.load()`
   * - Assets are cached as they complete loading
   * - No progress tracking is available for background loading
   */
  async backgroundLoad(t) {
    this._initialized || await this.init(), typeof t == "string" && (t = [t]);
    const e = this.resolver.resolve(t);
    this._backgroundLoader.add(Object.values(e));
  }
  /**
   * Initiates background loading of asset bundles. Similar to backgroundLoad but works with
   * predefined bundles of assets.
   *
   * Perfect for:
   * - Preloading level bundles during gameplay
   * - Loading UI assets during splash screens
   * - Preparing assets for upcoming game states
   * @param bundleIds - Single bundle ID or array of bundle IDs to load in the background
   * @example
   * ```ts
   * // Define bundles in your manifest
   * await Assets.init({
   *     manifest: {
   *         bundles: [
   *             {
   *               name: 'home',
   *               assets: [
   *                 {
   *                     alias: 'background',
   *                     src: 'images/home-bg.png',
   *                 },
   *                 {
   *                     alias: 'logo',
   *                     src: 'images/logo.png',
   *                 }
   *              ]
   *            },
   *            {
   *             name: 'level-1',
   *             assets: [
   *                 {
   *                     alias: 'background',
   *                     src: 'images/level1/bg.png',
   *                 },
   *                 {
   *                     alias: 'sprites',
   *                     src: 'images/level1/sprites.json'
   *                 }
   *             ]
   *         }]
   *     }
   * });
   *
   * // Load the home screen assets right away
   * await Assets.loadBundle('home');
   * showHomeScreen();
   *
   * // Start background loading while showing home screen
   * Assets.backgroundLoadBundle('level-1');
   *
   * // When player starts level, load completes faster
   * await Assets.loadBundle('level-1');
   * hideHomeScreen();
   * startLevel();
   * ```
   * @remarks
   * - Bundle assets are loaded one at a time
   * - Loading can be interrupted safely by calling `Assets.loadBundle()`
   * - Assets are cached as they complete loading
   * - Requires bundles to be registered via manifest or `addBundle`
   * @see {@link Assets.addBundle} For adding bundles programmatically
   * @see {@link Assets.loadBundle} For immediate bundle loading
   * @see {@link AssetsManifest} For manifest format details
   */
  async backgroundLoadBundle(t) {
    this._initialized || await this.init(), typeof t == "string" && (t = [t]);
    const e = this.resolver.resolveBundle(t);
    Object.values(e).forEach((r) => {
      this._backgroundLoader.add(Object.values(r));
    });
  }
  /**
   * Only intended for development purposes.
   * This will wipe the resolver and caches.
   * You will need to reinitialize the Asset
   * @internal
   */
  reset() {
    this.resolver.reset(), this.loader.reset(), this.cache.reset(), this._initialized = !1;
  }
  get(t) {
    if (typeof t == "string")
      return it.get(t);
    const e = {};
    for (let r = 0; r < t.length; r++)
      e[r] = it.get(t[r]);
    return e;
  }
  /**
   * helper function to map resolved assets back to loaded assets
   * @param resolveResults - the resolve results from the resolver
   * @param onProgress - the progress callback
   */
  async _mapLoadToResolve(t, e) {
    const r = [...new Set(Object.values(t))];
    this._backgroundLoader.active = !1;
    const n = await this.loader.load(r, e);
    this._backgroundLoader.active = !0;
    const a = {};
    return r.forEach((l) => {
      const h = n[l.src], u = [l.src];
      l.alias && u.push(...l.alias), u.forEach((f) => {
        a[f] = h;
      }), it.set(u, h);
    }), a;
  }
  /**
   * Unloads assets and releases them from memory. This method ensures proper cleanup of
   * loaded assets when they're no longer needed.
   * @param urls - Single URL/alias or array of URLs/aliases to unload
   * @example
   * ```ts
   * // Unload a single asset
   * await Assets.unload('images/sprite.png');
   *
   * // Unload using an alias
   * await Assets.unload('hero'); // Unloads the asset registered with 'hero' alias
   *
   * // Unload multiple assets
   * await Assets.unload([
   *     'images/background.png',
   *     'images/character.png',
   *     'hero'
   * ]);
   *
   * // Unload and handle creation of new instances
   * await Assets.unload('hero');
   * const newHero = await Assets.load('hero'); // Will load fresh from source
   * ```
   * @remarks
   * > [!WARNING]
   * > Make sure assets aren't being used before unloading:
   * > - Remove sprites using the texture
   * > - Clear any references to the asset
   * > - Textures will be destroyed and can't be used after unloading
   * @throws {Error} If the asset is not found in cache
   */
  async unload(t) {
    this._initialized || await this.init();
    const e = _e(t).map((n) => typeof n != "string" ? n.src : n), r = this.resolver.resolve(e);
    await this._unloadFromResolved(r);
  }
  /**
   * Unloads all assets in a bundle. Use this to free memory when a bundle's assets
   * are no longer needed, such as when switching game levels.
   * @param bundleIds - Single bundle ID or array of bundle IDs to unload
   * @example
   * ```ts
   * // Define and load a bundle
   * Assets.addBundle('level-1', {
   *     background: 'level1/bg.png',
   *     sprites: 'level1/sprites.json',
   *     music: 'level1/music.mp3'
   * });
   *
   * // Load the bundle
   * const level1 = await Assets.loadBundle('level-1');
   *
   * // Use the assets
   * const background = Sprite.from(level1.background);
   *
   * // When done with the level, unload everything
   * await Assets.unloadBundle('level-1');
   * // background sprite is now invalid!
   *
   * // Unload multiple bundles
   * await Assets.unloadBundle([
   *     'level-1',
   *     'level-2',
   *     'ui-elements'
   * ]);
   * ```
   * @remarks
   * > [!WARNING]
   * > - All assets in the bundle will be destroyed
   * > - Bundle needs to be reloaded to use assets again
   * > - Make sure no sprites or other objects are using the assets
   * @throws {Error} If the bundle is not found
   * @see {@link Assets.addBundle} For adding bundles
   * @see {@link Assets.loadBundle} For loading bundles
   */
  async unloadBundle(t) {
    this._initialized || await this.init(), t = _e(t);
    const e = this.resolver.resolveBundle(t), r = Object.keys(e).map((n) => this._unloadFromResolved(e[n]));
    await Promise.all(r);
  }
  async _unloadFromResolved(t) {
    const e = Object.values(t);
    e.forEach((r) => {
      it.remove(r.src);
    }), await this.loader.unload(e);
  }
  /**
   * Detects the supported formats for the browser, and returns an array of supported formats, respecting
   * the users preferred formats order.
   * @param options - the options to use when detecting formats
   * @param options.preferredFormats - the preferred formats to use
   * @param options.skipDetections - if we should skip the detections altogether
   * @param options.detections - the detections to use
   * @returns - the detected formats
   */
  async _detectFormats(t) {
    let e = [];
    t.preferredFormats && (e = Array.isArray(t.preferredFormats) ? t.preferredFormats : [t.preferredFormats]);
    for (const r of t.detections)
      t.skipDetections || await r.test() ? e = await r.add(e) : t.skipDetections || (e = await r.remove(e));
    return e = e.filter((r, n) => e.indexOf(r) === n), e;
  }
  /**
   * All the detection parsers currently added to the Assets class.
   * @advanced
   */
  get detections() {
    return this._detections;
  }
  /**
   * Sets global preferences for asset loading behavior. This method configures how assets
   * are loaded and processed across all parsers.
   * @param preferences - Asset loading preferences
   * @example
   * ```ts
   * // Basic preferences
   * Assets.setPreferences({
   *     crossOrigin: 'anonymous',
   *     parseAsGraphicsContext: false
   * });
   * ```
   * @remarks
   * Preferences are applied to all compatible parsers and affect future asset loading.
   * Common preferences include:
   * - `crossOrigin`: CORS setting for loaded assets
   * - `preferWorkers`: Whether to use web workers for loading textures
   * - `preferCreateImageBitmap`: Use `createImageBitmap` for texture creation. Turning this off will use the `Image` constructor instead.
   * @see {@link AssetsPreferences} For all available preferences
   */
  setPreferences(t) {
    this.loader.parsers.forEach((e) => {
      e.config && Object.keys(e.config).filter((r) => r in t).forEach((r) => {
        e.config[r] = t[r];
      });
    });
  }
}
const Ki = new lS();
L.handleByList(A.LoadParser, Ki.loader.parsers).handleByList(A.ResolveParser, Ki.resolver.parsers).handleByList(A.CacheParser, Ki.cache.parsers).handleByList(A.DetectionParser, Ki.detections);
L.add(
  S1,
  C1,
  T1,
  B1,
  A1,
  P1,
  M1,
  k1,
  O1,
  $1,
  j1,
  n_,
  oS,
  v1,
  b1,
  o_,
  hS
);
const Au = {
  loader: A.LoadParser,
  resolver: A.ResolveParser,
  cache: A.CacheParser,
  detection: A.DetectionParser
};
L.handle(A.Asset, (s) => {
  const t = s.ref;
  Object.entries(Au).filter(([e]) => !!t[e]).forEach(([e, r]) => L.add(Object.assign(
    t[e],
    // Allow the function to optionally define it's own
    // ExtensionMetadata, the use cases here is priority for LoaderParsers
    { extension: t[e].extension ?? r }
  )));
}, (s) => {
  const t = s.ref;
  Object.keys(Au).filter((e) => !!t[e]).forEach((e) => L.remove(t[e]));
});
class h_ {
  /**
   * Constructor for the DOMPipe class.
   * @param renderer - The renderer instance that this DOMPipe will be associated with.
   */
  constructor(t) {
    this._attachedDomElements = [], this._renderer = t, this._renderer.runners.postrender.add(this), this._domElement = document.createElement("div"), this._domElement.style.position = "absolute", this._domElement.style.top = "0", this._domElement.style.left = "0", this._domElement.style.pointerEvents = "none", this._domElement.style.zIndex = "1000";
  }
  /**
   * Adds a renderable DOM container to the list of attached elements.
   * @param domContainer - The DOM container to be added.
   * @param _instructionSet - The instruction set (unused).
   */
  addRenderable(t, e) {
    this._attachedDomElements.includes(t) || this._attachedDomElements.push(t);
  }
  /**
   * Updates a renderable DOM container.
   * @param _domContainer - The DOM container to be updated (unused).
   */
  updateRenderable(t) {
  }
  /**
   * Validates a renderable DOM container.
   * @param _domContainer - The DOM container to be validated (unused).
   * @returns Always returns true as validation is not required.
   */
  validateRenderable(t) {
    return !0;
  }
  /** Handles the post-rendering process, ensuring DOM elements are correctly positioned and visible. */
  postrender() {
    const t = this._attachedDomElements;
    if (t.length === 0) {
      this._domElement.remove();
      return;
    }
    const e = this._renderer.view.canvas;
    this._domElement.parentNode !== e.parentNode && e.parentNode?.appendChild(this._domElement);
    const r = parseFloat(e.style.width) / e.width * this._renderer.resolution, n = parseFloat(e.style.height) / e.height * this._renderer.resolution;
    this._domElement.style.transform = `translate(${e.offsetLeft}px, ${e.offsetTop}px) scale(${r}, ${n})`;
    for (let a = 0; a < t.length; a++) {
      const l = t[a], h = l.element;
      if (!l.parent || l.globalDisplayStatus < 7)
        h?.remove(), t.splice(a, 1), a--;
      else {
        this._domElement.contains(h) || (h.style.position = "absolute", h.style.pointerEvents = "auto", this._domElement.appendChild(h));
        const u = l.worldTransform, f = l._anchor, p = l.width * f.x, m = l.height * f.y;
        h.style.transformOrigin = `${p}px ${m}px`, h.style.transform = `matrix(${u.a}, ${u.b}, ${u.c}, ${u.d}, ${u.tx - p}, ${u.ty - m})`, h.style.opacity = l.groupAlpha.toString();
      }
    }
  }
  /** Destroys the DOMPipe, removing all attached DOM elements and cleaning up resources. */
  destroy() {
    this._renderer.runners.postrender.remove(this);
    for (let t = 0; t < this._attachedDomElements.length; t++)
      this._attachedDomElements[t].element?.remove();
    this._attachedDomElements.length = 0, this._domElement.remove(), this._renderer = null;
  }
}
h_.extension = {
  type: [
    A.WebGLPipes,
    A.WebGPUPipes,
    A.CanvasPipes
  ],
  name: "dom"
};
class cS {
  constructor() {
    this.interactionFrequency = 10, this._deltaTime = 0, this._didMove = !1, this._tickerAdded = !1, this._pauseUpdate = !0;
  }
  /**
   * Initializes the event ticker.
   * @param events - The event system.
   */
  init(t) {
    this.removeTickerListener(), this.events = t, this.interactionFrequency = 10, this._deltaTime = 0, this._didMove = !1, this._tickerAdded = !1, this._pauseUpdate = !0;
  }
  /** Whether to pause the update checks or not. */
  get pauseUpdate() {
    return this._pauseUpdate;
  }
  set pauseUpdate(t) {
    this._pauseUpdate = t;
  }
  /** Adds the ticker listener. */
  addTickerListener() {
    this._tickerAdded || !this.domElement || (Ae.system.add(this._tickerUpdate, this, as.INTERACTION), this._tickerAdded = !0);
  }
  /** Removes the ticker listener. */
  removeTickerListener() {
    this._tickerAdded && (Ae.system.remove(this._tickerUpdate, this), this._tickerAdded = !1);
  }
  /** Sets flag to not fire extra events when the user has already moved there mouse */
  pointerMoved() {
    this._didMove = !0;
  }
  /** Updates the state of interactive objects. */
  _update() {
    if (!this.domElement || this._pauseUpdate)
      return;
    if (this._didMove) {
      this._didMove = !1;
      return;
    }
    const t = this.events._rootPointerEvent;
    this.events.supportsTouchEvents && t.pointerType === "touch" || globalThis.document.dispatchEvent(this.events.supportsPointerEvents ? new PointerEvent("pointermove", {
      clientX: t.clientX,
      clientY: t.clientY,
      pointerType: t.pointerType,
      pointerId: t.pointerId
    }) : new MouseEvent("mousemove", {
      clientX: t.clientX,
      clientY: t.clientY
    }));
  }
  /**
   * Updates the state of interactive objects if at least {@link interactionFrequency}
   * milliseconds have passed since the last invocation.
   *
   * Invoked by a throttled ticker update from {@link Ticker.system}.
   * @param ticker - The throttled ticker.
   */
  _tickerUpdate(t) {
    this._deltaTime += t.deltaTime, !(this._deltaTime < this.interactionFrequency) && (this._deltaTime = 0, this._update());
  }
}
const je = new cS();
class Bn extends gs {
  constructor() {
    super(...arguments), this.client = new et(), this.movement = new et(), this.offset = new et(), this.global = new et(), this.screen = new et();
  }
  /** @readonly */
  get clientX() {
    return this.client.x;
  }
  /** @readonly */
  get clientY() {
    return this.client.y;
  }
  /**
   * Alias for {@link FederatedMouseEvent.clientX this.clientX}.
   * @readonly
   */
  get x() {
    return this.clientX;
  }
  /**
   * Alias for {@link FederatedMouseEvent.clientY this.clientY}.
   * @readonly
   */
  get y() {
    return this.clientY;
  }
  /** @readonly */
  get movementX() {
    return this.movement.x;
  }
  /** @readonly */
  get movementY() {
    return this.movement.y;
  }
  /** @readonly */
  get offsetX() {
    return this.offset.x;
  }
  /** @readonly */
  get offsetY() {
    return this.offset.y;
  }
  /** @readonly */
  get globalX() {
    return this.global.x;
  }
  /** @readonly */
  get globalY() {
    return this.global.y;
  }
  /**
   * The pointer coordinates in the renderer's screen. Alias for `screen.x`.
   * @readonly
   */
  get screenX() {
    return this.screen.x;
  }
  /**
   * The pointer coordinates in the renderer's screen. Alias for `screen.y`.
   * @readonly
   */
  get screenY() {
    return this.screen.y;
  }
  /**
   * Converts global coordinates into container-local coordinates.
   *
   * This method transforms coordinates from world space to a container's local space,
   * useful for precise positioning and hit testing.
   * @param container - The Container to get local coordinates for
   * @param point - Optional Point object to store the result. If not provided, a new Point will be created
   * @param globalPos - Optional custom global coordinates. If not provided, the event's global position is used
   * @returns The local coordinates as a Point object
   * @example
   * ```ts
   * // Basic usage - get local coordinates relative to a container
   * sprite.on('pointermove', (event: FederatedMouseEvent) => {
   *     // Get position relative to the sprite
   *     const localPos = event.getLocalPosition(sprite);
   *     console.log('Local position:', localPos.x, localPos.y);
   * });
   * // Using custom global coordinates
   * const customGlobal = new Point(100, 100);
   * sprite.on('pointermove', (event: FederatedMouseEvent) => {
   *     // Transform custom coordinates
   *     const localPos = event.getLocalPosition(sprite, undefined, customGlobal);
   *     console.log('Custom local position:', localPos.x, localPos.y);
   * });
   * ```
   * @see {@link Container.worldTransform} For the transformation matrix
   * @see {@link Point} For the point class used to store coordinates
   */
  getLocalPosition(t, e, r) {
    return t.worldTransform.applyInverse(r || this.global, e);
  }
  /**
   * Whether the modifier key was pressed when this event natively occurred.
   * @param key - The modifier key.
   */
  getModifierState(t) {
    return "getModifierState" in this.nativeEvent && this.nativeEvent.getModifierState(t);
  }
  /**
   * Not supported.
   * @param _typeArg
   * @param _canBubbleArg
   * @param _cancelableArg
   * @param _viewArg
   * @param _detailArg
   * @param _screenXArg
   * @param _screenYArg
   * @param _clientXArg
   * @param _clientYArg
   * @param _ctrlKeyArg
   * @param _altKeyArg
   * @param _shiftKeyArg
   * @param _metaKeyArg
   * @param _buttonArg
   * @param _relatedTargetArg
   * @deprecated since 7.0.0
   * @ignore
   */
  // eslint-disable-next-line max-params
  initMouseEvent(t, e, r, n, a, l, h, u, f, p, m, g, x, o, c) {
    throw new Error("Method not implemented.");
  }
}
class fe extends Bn {
  constructor() {
    super(...arguments), this.width = 0, this.height = 0, this.isPrimary = !1;
  }
  /**
   * Only included for completeness for now
   * @ignore
   */
  getCoalescedEvents() {
    return this.type === "pointermove" || this.type === "mousemove" || this.type === "touchmove" ? [this] : [];
  }
  /**
   * Only included for completeness for now
   * @ignore
   */
  getPredictedEvents() {
    throw new Error("getPredictedEvents is not supported!");
  }
}
class dr extends Bn {
  constructor() {
    super(...arguments), this.DOM_DELTA_PIXEL = 0, this.DOM_DELTA_LINE = 1, this.DOM_DELTA_PAGE = 2;
  }
}
dr.DOM_DELTA_PIXEL = 0;
dr.DOM_DELTA_LINE = 1;
dr.DOM_DELTA_PAGE = 2;
const uS = 2048, dS = new et(), Pr = new et();
class fS {
  /**
   * @param rootTarget - The holder of the event boundary.
   */
  constructor(t) {
    this.dispatch = new te(), this.moveOnAll = !1, this.enableGlobalMoveEvents = !0, this.mappingState = {
      trackingData: {}
    }, this.eventPool = /* @__PURE__ */ new Map(), this._allInteractiveElements = [], this._hitElements = [], this._isPointerMoveEvent = !1, this.rootTarget = t, this.hitPruneFn = this.hitPruneFn.bind(this), this.hitTestFn = this.hitTestFn.bind(this), this.mapPointerDown = this.mapPointerDown.bind(this), this.mapPointerMove = this.mapPointerMove.bind(this), this.mapPointerOut = this.mapPointerOut.bind(this), this.mapPointerOver = this.mapPointerOver.bind(this), this.mapPointerUp = this.mapPointerUp.bind(this), this.mapPointerUpOutside = this.mapPointerUpOutside.bind(this), this.mapWheel = this.mapWheel.bind(this), this.mappingTable = {}, this.addEventMapping("pointerdown", this.mapPointerDown), this.addEventMapping("pointermove", this.mapPointerMove), this.addEventMapping("pointerout", this.mapPointerOut), this.addEventMapping("pointerleave", this.mapPointerOut), this.addEventMapping("pointerover", this.mapPointerOver), this.addEventMapping("pointerup", this.mapPointerUp), this.addEventMapping("pointerupoutside", this.mapPointerUpOutside), this.addEventMapping("wheel", this.mapWheel);
  }
  /**
   * Adds an event mapping for the event `type` handled by `fn`.
   *
   * Event mappings can be used to implement additional or custom events. They take an event
   * coming from the upstream scene (or directly from the {@link EventSystem}) and dispatch new downstream events
   * generally trickling down and bubbling up to {@link EventBoundary.rootTarget this.rootTarget}.
   *
   * To modify the semantics of existing events, the built-in mapping methods of EventBoundary should be overridden
   * instead.
   * @param type - The type of upstream event to map.
   * @param fn - The mapping method. The context of this function must be bound manually, if desired.
   */
  addEventMapping(t, e) {
    this.mappingTable[t] || (this.mappingTable[t] = []), this.mappingTable[t].push({
      fn: e,
      priority: 0
    }), this.mappingTable[t].sort((r, n) => r.priority - n.priority);
  }
  /**
   * Dispatches the given event
   * @param e - The event to dispatch.
   * @param type - The type of event to dispatch. Defaults to `e.type`.
   */
  dispatchEvent(t, e) {
    t.propagationStopped = !1, t.propagationImmediatelyStopped = !1, this.propagate(t, e), this.dispatch.emit(e || t.type, t);
  }
  /**
   * Maps the given upstream event through the event boundary and propagates it downstream.
   * @param e - The event to map.
   */
  mapEvent(t) {
    if (!this.rootTarget)
      return;
    const e = this.mappingTable[t.type];
    if (e)
      for (let r = 0, n = e.length; r < n; r++)
        e[r].fn(t);
    else
      N(`[EventBoundary]: Event mapping not defined for ${t.type}`);
  }
  /**
   * Finds the Container that is the target of a event at the given coordinates.
   *
   * The passed (x,y) coordinates are in the world space above this event boundary.
   * @param x - The x coordinate of the event.
   * @param y - The y coordinate of the event.
   */
  hitTest(t, e) {
    je.pauseUpdate = !0;
    const n = this._isPointerMoveEvent && this.enableGlobalMoveEvents ? "hitTestMoveRecursive" : "hitTestRecursive", a = this[n](
      this.rootTarget,
      this.rootTarget.eventMode,
      dS.set(t, e),
      this.hitTestFn,
      this.hitPruneFn
    );
    return a && a[0];
  }
  /**
   * Propagate the passed event from from {@link EventBoundary.rootTarget this.rootTarget} to its
   * target `e.target`.
   * @param e - The event to propagate.
   * @param type - The type of event to propagate. Defaults to `e.type`.
   */
  propagate(t, e) {
    if (!t.target)
      return;
    const r = t.composedPath();
    t.eventPhase = t.CAPTURING_PHASE;
    for (let n = 0, a = r.length - 1; n < a; n++)
      if (t.currentTarget = r[n], this.notifyTarget(t, e), t.propagationStopped || t.propagationImmediatelyStopped)
        return;
    if (t.eventPhase = t.AT_TARGET, t.currentTarget = t.target, this.notifyTarget(t, e), !(t.propagationStopped || t.propagationImmediatelyStopped)) {
      t.eventPhase = t.BUBBLING_PHASE;
      for (let n = r.length - 2; n >= 0; n--)
        if (t.currentTarget = r[n], this.notifyTarget(t, e), t.propagationStopped || t.propagationImmediatelyStopped)
          return;
    }
  }
  /**
   * Emits the event `e` to all interactive containers. The event is propagated in the bubbling phase always.
   *
   * This is used in the `globalpointermove` event.
   * @param e - The emitted event.
   * @param type - The listeners to notify.
   * @param targets - The targets to notify.
   */
  all(t, e, r = this._allInteractiveElements) {
    if (r.length === 0)
      return;
    t.eventPhase = t.BUBBLING_PHASE;
    const n = Array.isArray(e) ? e : [e];
    for (let a = r.length - 1; a >= 0; a--)
      n.forEach((l) => {
        t.currentTarget = r[a], this.notifyTarget(t, l);
      });
  }
  /**
   * Finds the propagation path from {@link EventBoundary.rootTarget rootTarget} to the passed
   * `target`. The last element in the path is `target`.
   * @param target - The target to find the propagation path to.
   */
  propagationPath(t) {
    const e = [t];
    for (let r = 0; r < uS && t !== this.rootTarget && t.parent; r++) {
      if (!t.parent)
        throw new Error("Cannot find propagation path to disconnected target");
      e.push(t.parent), t = t.parent;
    }
    return e.reverse(), e;
  }
  hitTestMoveRecursive(t, e, r, n, a, l = !1) {
    let h = !1;
    if (this._interactivePrune(t))
      return null;
    if ((t.eventMode === "dynamic" || e === "dynamic") && (je.pauseUpdate = !1), t.interactiveChildren && t.children) {
      const p = t.children;
      for (let m = p.length - 1; m >= 0; m--) {
        const g = p[m], x = this.hitTestMoveRecursive(
          g,
          this._isInteractive(e) ? e : g.eventMode,
          r,
          n,
          a,
          l || a(t, r)
        );
        if (x) {
          if (x.length > 0 && !x[x.length - 1].parent)
            continue;
          const o = t.isInteractive();
          (x.length > 0 || o) && (o && this._allInteractiveElements.push(t), x.push(t)), this._hitElements.length === 0 && (this._hitElements = x), h = !0;
        }
      }
    }
    const u = this._isInteractive(e), f = t.isInteractive();
    return f && f && this._allInteractiveElements.push(t), l || this._hitElements.length > 0 ? null : h ? this._hitElements : u && !a(t, r) && n(t, r) ? f ? [t] : [] : null;
  }
  /**
   * Recursive implementation for {@link EventBoundary.hitTest hitTest}.
   * @param currentTarget - The Container that is to be hit tested.
   * @param eventMode - The event mode for the `currentTarget` or one of its parents.
   * @param location - The location that is being tested for overlap.
   * @param testFn - Callback that determines whether the target passes hit testing. This callback
   *  can assume that `pruneFn` failed to prune the container.
   * @param pruneFn - Callback that determiness whether the target and all of its children
   *  cannot pass the hit test. It is used as a preliminary optimization to prune entire subtrees
   *  of the scene graph.
   * @returns An array holding the hit testing target and all its ancestors in order. The first element
   *  is the target itself and the last is {@link EventBoundary.rootTarget rootTarget}. This is the opposite
   *  order w.r.t. the propagation path. If no hit testing target is found, null is returned.
   */
  hitTestRecursive(t, e, r, n, a) {
    if (this._interactivePrune(t) || a(t, r))
      return null;
    if ((t.eventMode === "dynamic" || e === "dynamic") && (je.pauseUpdate = !1), t.interactiveChildren && t.children) {
      const u = t.children, f = r;
      for (let p = u.length - 1; p >= 0; p--) {
        const m = u[p], g = this.hitTestRecursive(
          m,
          this._isInteractive(e) ? e : m.eventMode,
          f,
          n,
          a
        );
        if (g) {
          if (g.length > 0 && !g[g.length - 1].parent)
            continue;
          const x = t.isInteractive();
          return (g.length > 0 || x) && g.push(t), g;
        }
      }
    }
    const l = this._isInteractive(e), h = t.isInteractive();
    return l && n(t, r) ? h ? [t] : [] : null;
  }
  _isInteractive(t) {
    return t === "static" || t === "dynamic";
  }
  _interactivePrune(t) {
    return !t || !t.visible || !t.renderable || !t.measurable || t.eventMode === "none" || t.eventMode === "passive" && !t.interactiveChildren;
  }
  /**
   * Checks whether the container or any of its children cannot pass the hit test at all.
   *
   * {@link EventBoundary}'s implementation uses the {@link Container.hitArea hitArea}
   * and {@link Container._maskEffect} for pruning.
   * @param container - The container to prune.
   * @param location - The location to test for overlap.
   */
  hitPruneFn(t, e) {
    if (t.hitArea && (t.worldTransform.applyInverse(e, Pr), !t.hitArea.contains(Pr.x, Pr.y)))
      return !0;
    if (t.effects && t.effects.length)
      for (let r = 0; r < t.effects.length; r++) {
        const n = t.effects[r];
        if (n.containsPoint && !n.containsPoint(e, this.hitTestFn))
          return !0;
      }
    return !1;
  }
  /**
   * Checks whether the container passes hit testing for the given location.
   * @param container - The container to test.
   * @param location - The location to test for overlap.
   * @returns - Whether `container` passes hit testing for `location`.
   */
  hitTestFn(t, e) {
    return t.hitArea ? !0 : t?.containsPoint ? (t.worldTransform.applyInverse(e, Pr), t.containsPoint(Pr)) : !1;
  }
  /**
   * Notify all the listeners to the event's `currentTarget`.
   *
   * If the `currentTarget` contains the property `on<type>`, then it is called here,
   * simulating the behavior from version 6.x and prior.
   * @param e - The event passed to the target.
   * @param type - The type of event to notify. Defaults to `e.type`.
   */
  notifyTarget(t, e) {
    if (!t.currentTarget.isInteractive())
      return;
    e ?? (e = t.type);
    const r = `on${e}`;
    t.currentTarget[r]?.(t);
    const n = t.eventPhase === t.CAPTURING_PHASE || t.eventPhase === t.AT_TARGET ? `${e}capture` : e;
    this._notifyListeners(t, n), t.eventPhase === t.AT_TARGET && this._notifyListeners(t, e);
  }
  /**
   * Maps the upstream `pointerdown` events to a downstream `pointerdown` event.
   *
   * `touchstart`, `rightdown`, `mousedown` events are also dispatched for specific pointer types.
   * @param from - The upstream `pointerdown` event.
   */
  mapPointerDown(t) {
    if (!(t instanceof fe)) {
      N("EventBoundary cannot map a non-pointer event as a pointer event");
      return;
    }
    const e = this.createPointerEvent(t);
    if (this.dispatchEvent(e, "pointerdown"), e.pointerType === "touch")
      this.dispatchEvent(e, "touchstart");
    else if (e.pointerType === "mouse" || e.pointerType === "pen") {
      const n = e.button === 2;
      this.dispatchEvent(e, n ? "rightdown" : "mousedown");
    }
    const r = this.trackingData(t.pointerId);
    r.pressTargetsByButton[t.button] = e.composedPath(), this.freeEvent(e);
  }
  /**
   * Maps the upstream `pointermove` to downstream `pointerout`, `pointerover`, and `pointermove` events, in that order.
   *
   * The tracking data for the specific pointer has an updated `overTarget`. `mouseout`, `mouseover`,
   * `mousemove`, and `touchmove` events are fired as well for specific pointer types.
   * @param from - The upstream `pointermove` event.
   */
  mapPointerMove(t) {
    if (!(t instanceof fe)) {
      N("EventBoundary cannot map a non-pointer event as a pointer event");
      return;
    }
    this._allInteractiveElements.length = 0, this._hitElements.length = 0, this._isPointerMoveEvent = !0;
    const e = this.createPointerEvent(t);
    this._isPointerMoveEvent = !1;
    const r = e.pointerType === "mouse" || e.pointerType === "pen", n = this.trackingData(t.pointerId), a = this.findMountedTarget(n.overTargets);
    if (n.overTargets?.length > 0 && a !== e.target) {
      const u = t.type === "mousemove" ? "mouseout" : "pointerout", f = this.createPointerEvent(t, u, a);
      if (this.dispatchEvent(f, "pointerout"), r && this.dispatchEvent(f, "mouseout"), !e.composedPath().includes(a)) {
        const p = this.createPointerEvent(t, "pointerleave", a);
        for (p.eventPhase = p.AT_TARGET; p.target && !e.composedPath().includes(p.target); )
          p.currentTarget = p.target, this.notifyTarget(p), r && this.notifyTarget(p, "mouseleave"), p.target = p.target.parent;
        this.freeEvent(p);
      }
      this.freeEvent(f);
    }
    if (a !== e.target) {
      const u = t.type === "mousemove" ? "mouseover" : "pointerover", f = this.clonePointerEvent(e, u);
      this.dispatchEvent(f, "pointerover"), r && this.dispatchEvent(f, "mouseover");
      let p = a?.parent;
      for (; p && p !== this.rootTarget.parent && p !== e.target; )
        p = p.parent;
      if (!p || p === this.rootTarget.parent) {
        const g = this.clonePointerEvent(e, "pointerenter");
        for (g.eventPhase = g.AT_TARGET; g.target && g.target !== a && g.target !== this.rootTarget.parent; )
          g.currentTarget = g.target, this.notifyTarget(g), r && this.notifyTarget(g, "mouseenter"), g.target = g.target.parent;
        this.freeEvent(g);
      }
      this.freeEvent(f);
    }
    const l = [], h = this.enableGlobalMoveEvents ?? !0;
    this.moveOnAll ? l.push("pointermove") : this.dispatchEvent(e, "pointermove"), h && l.push("globalpointermove"), e.pointerType === "touch" && (this.moveOnAll ? l.splice(1, 0, "touchmove") : this.dispatchEvent(e, "touchmove"), h && l.push("globaltouchmove")), r && (this.moveOnAll ? l.splice(1, 0, "mousemove") : this.dispatchEvent(e, "mousemove"), h && l.push("globalmousemove"), this.cursor = e.target?.cursor), l.length > 0 && this.all(e, l), this._allInteractiveElements.length = 0, this._hitElements.length = 0, n.overTargets = e.composedPath(), this.freeEvent(e);
  }
  /**
   * Maps the upstream `pointerover` to downstream `pointerover` and `pointerenter` events, in that order.
   *
   * The tracking data for the specific pointer gets a new `overTarget`.
   * @param from - The upstream `pointerover` event.
   */
  mapPointerOver(t) {
    if (!(t instanceof fe)) {
      N("EventBoundary cannot map a non-pointer event as a pointer event");
      return;
    }
    const e = this.trackingData(t.pointerId), r = this.createPointerEvent(t), n = r.pointerType === "mouse" || r.pointerType === "pen";
    this.dispatchEvent(r, "pointerover"), n && this.dispatchEvent(r, "mouseover"), r.pointerType === "mouse" && (this.cursor = r.target?.cursor);
    const a = this.clonePointerEvent(r, "pointerenter");
    for (a.eventPhase = a.AT_TARGET; a.target && a.target !== this.rootTarget.parent; )
      a.currentTarget = a.target, this.notifyTarget(a), n && this.notifyTarget(a, "mouseenter"), a.target = a.target.parent;
    e.overTargets = r.composedPath(), this.freeEvent(r), this.freeEvent(a);
  }
  /**
   * Maps the upstream `pointerout` to downstream `pointerout`, `pointerleave` events, in that order.
   *
   * The tracking data for the specific pointer is cleared of a `overTarget`.
   * @param from - The upstream `pointerout` event.
   */
  mapPointerOut(t) {
    if (!(t instanceof fe)) {
      N("EventBoundary cannot map a non-pointer event as a pointer event");
      return;
    }
    const e = this.trackingData(t.pointerId);
    if (e.overTargets) {
      const r = t.pointerType === "mouse" || t.pointerType === "pen", n = this.findMountedTarget(e.overTargets), a = this.createPointerEvent(t, "pointerout", n);
      this.dispatchEvent(a), r && this.dispatchEvent(a, "mouseout");
      const l = this.createPointerEvent(t, "pointerleave", n);
      for (l.eventPhase = l.AT_TARGET; l.target && l.target !== this.rootTarget.parent; )
        l.currentTarget = l.target, this.notifyTarget(l), r && this.notifyTarget(l, "mouseleave"), l.target = l.target.parent;
      e.overTargets = null, this.freeEvent(a), this.freeEvent(l);
    }
    this.cursor = null;
  }
  /**
   * Maps the upstream `pointerup` event to downstream `pointerup`, `pointerupoutside`,
   * and `click`/`rightclick`/`pointertap` events, in that order.
   *
   * The `pointerupoutside` event bubbles from the original `pointerdown` target to the most specific
   * ancestor of the `pointerdown` and `pointerup` targets, which is also the `click` event's target. `touchend`,
   * `rightup`, `mouseup`, `touchendoutside`, `rightupoutside`, `mouseupoutside`, and `tap` are fired as well for
   * specific pointer types.
   * @param from - The upstream `pointerup` event.
   */
  mapPointerUp(t) {
    if (!(t instanceof fe)) {
      N("EventBoundary cannot map a non-pointer event as a pointer event");
      return;
    }
    const e = performance.now(), r = this.createPointerEvent(t);
    if (this.dispatchEvent(r, "pointerup"), r.pointerType === "touch")
      this.dispatchEvent(r, "touchend");
    else if (r.pointerType === "mouse" || r.pointerType === "pen") {
      const h = r.button === 2;
      this.dispatchEvent(r, h ? "rightup" : "mouseup");
    }
    const n = this.trackingData(t.pointerId), a = this.findMountedTarget(n.pressTargetsByButton[t.button]);
    let l = a;
    if (a && !r.composedPath().includes(a)) {
      let h = a;
      for (; h && !r.composedPath().includes(h); ) {
        if (r.currentTarget = h, this.notifyTarget(r, "pointerupoutside"), r.pointerType === "touch")
          this.notifyTarget(r, "touchendoutside");
        else if (r.pointerType === "mouse" || r.pointerType === "pen") {
          const u = r.button === 2;
          this.notifyTarget(r, u ? "rightupoutside" : "mouseupoutside");
        }
        h = h.parent;
      }
      delete n.pressTargetsByButton[t.button], l = h;
    }
    if (l) {
      const h = this.clonePointerEvent(r, "click");
      h.target = l, h.path = null, n.clicksByButton[t.button] || (n.clicksByButton[t.button] = {
        clickCount: 0,
        target: h.target,
        timeStamp: e
      });
      const u = n.clicksByButton[t.button];
      if (u.target === h.target && e - u.timeStamp < 200 ? ++u.clickCount : u.clickCount = 1, u.target = h.target, u.timeStamp = e, h.detail = u.clickCount, h.pointerType === "mouse") {
        const f = h.button === 2;
        this.dispatchEvent(h, f ? "rightclick" : "click");
      } else h.pointerType === "touch" && this.dispatchEvent(h, "tap");
      this.dispatchEvent(h, "pointertap"), this.freeEvent(h);
    }
    this.freeEvent(r);
  }
  /**
   * Maps the upstream `pointerupoutside` event to a downstream `pointerupoutside` event, bubbling from the original
   * `pointerdown` target to `rootTarget`.
   *
   * (The most specific ancestor of the `pointerdown` event and the `pointerup` event must the
   * `{@link EventBoundary}'s root because the `pointerup` event occurred outside of the boundary.)
   *
   * `touchendoutside`, `mouseupoutside`, and `rightupoutside` events are fired as well for specific pointer
   * types. The tracking data for the specific pointer is cleared of a `pressTarget`.
   * @param from - The upstream `pointerupoutside` event.
   */
  mapPointerUpOutside(t) {
    if (!(t instanceof fe)) {
      N("EventBoundary cannot map a non-pointer event as a pointer event");
      return;
    }
    const e = this.trackingData(t.pointerId), r = this.findMountedTarget(e.pressTargetsByButton[t.button]), n = this.createPointerEvent(t);
    if (r) {
      let a = r;
      for (; a; )
        n.currentTarget = a, this.notifyTarget(n, "pointerupoutside"), n.pointerType === "touch" ? this.notifyTarget(n, "touchendoutside") : (n.pointerType === "mouse" || n.pointerType === "pen") && this.notifyTarget(n, n.button === 2 ? "rightupoutside" : "mouseupoutside"), a = a.parent;
      delete e.pressTargetsByButton[t.button];
    }
    this.freeEvent(n);
  }
  /**
   * Maps the upstream `wheel` event to a downstream `wheel` event.
   * @param from - The upstream `wheel` event.
   */
  mapWheel(t) {
    if (!(t instanceof dr)) {
      N("EventBoundary cannot map a non-wheel event as a wheel event");
      return;
    }
    const e = this.createWheelEvent(t);
    this.dispatchEvent(e), this.freeEvent(e);
  }
  /**
   * Finds the most specific event-target in the given propagation path that is still mounted in the scene graph.
   *
   * This is used to find the correct `pointerup` and `pointerout` target in the case that the original `pointerdown`
   * or `pointerover` target was unmounted from the scene graph.
   * @param propagationPath - The propagation path was valid in the past.
   * @returns - The most specific event-target still mounted at the same location in the scene graph.
   */
  findMountedTarget(t) {
    if (!t)
      return null;
    let e = t[0];
    for (let r = 1; r < t.length && t[r].parent === e; r++)
      e = t[r];
    return e;
  }
  /**
   * Creates an event whose `originalEvent` is `from`, with an optional `type` and `target` override.
   *
   * The event is allocated using {@link EventBoundary#allocateEvent this.allocateEvent}.
   * @param from - The `originalEvent` for the returned event.
   * @param [type=from.type] - The type of the returned event.
   * @param target - The target of the returned event.
   */
  createPointerEvent(t, e, r) {
    const n = this.allocateEvent(fe);
    return this.copyPointerData(t, n), this.copyMouseData(t, n), this.copyData(t, n), n.nativeEvent = t.nativeEvent, n.originalEvent = t, n.target = r ?? this.hitTest(n.global.x, n.global.y) ?? this._hitElements[0], typeof e == "string" && (n.type = e), n;
  }
  /**
   * Creates a wheel event whose `originalEvent` is `from`.
   *
   * The event is allocated using {@link EventBoundary#allocateEvent this.allocateEvent}.
   * @param from - The upstream wheel event.
   */
  createWheelEvent(t) {
    const e = this.allocateEvent(dr);
    return this.copyWheelData(t, e), this.copyMouseData(t, e), this.copyData(t, e), e.nativeEvent = t.nativeEvent, e.originalEvent = t, e.target = this.hitTest(e.global.x, e.global.y), e;
  }
  /**
   * Clones the event `from`, with an optional `type` override.
   *
   * The event is allocated using {@link EventBoundary#allocateEvent this.allocateEvent}.
   * @param from - The event to clone.
   * @param [type=from.type] - The type of the returned event.
   */
  clonePointerEvent(t, e) {
    const r = this.allocateEvent(fe);
    return r.nativeEvent = t.nativeEvent, r.originalEvent = t.originalEvent, this.copyPointerData(t, r), this.copyMouseData(t, r), this.copyData(t, r), r.target = t.target, r.path = t.composedPath().slice(), r.type = e ?? r.type, r;
  }
  /**
   * Copies wheel {@link FederatedWheelEvent} data from `from` into `to`.
   *
   * The following properties are copied:
   * + deltaMode
   * + deltaX
   * + deltaY
   * + deltaZ
   * @param from - The event to copy data from.
   * @param to - The event to copy data into.
   */
  copyWheelData(t, e) {
    e.deltaMode = t.deltaMode, e.deltaX = t.deltaX, e.deltaY = t.deltaY, e.deltaZ = t.deltaZ;
  }
  /**
   * Copies pointer {@link FederatedPointerEvent} data from `from` into `to`.
   *
   * The following properties are copied:
   * + pointerId
   * + width
   * + height
   * + isPrimary
   * + pointerType
   * + pressure
   * + tangentialPressure
   * + tiltX
   * + tiltY
   * @param from - The event to copy data from.
   * @param to - The event to copy data into.
   */
  copyPointerData(t, e) {
    t instanceof fe && e instanceof fe && (e.pointerId = t.pointerId, e.width = t.width, e.height = t.height, e.isPrimary = t.isPrimary, e.pointerType = t.pointerType, e.pressure = t.pressure, e.tangentialPressure = t.tangentialPressure, e.tiltX = t.tiltX, e.tiltY = t.tiltY, e.twist = t.twist);
  }
  /**
   * Copies mouse {@link FederatedMouseEvent} data from `from` to `to`.
   *
   * The following properties are copied:
   * + altKey
   * + button
   * + buttons
   * + clientX
   * + clientY
   * + metaKey
   * + movementX
   * + movementY
   * + pageX
   * + pageY
   * + x
   * + y
   * + screen
   * + shiftKey
   * + global
   * @param from - The event to copy data from.
   * @param to - The event to copy data into.
   */
  copyMouseData(t, e) {
    t instanceof Bn && e instanceof Bn && (e.altKey = t.altKey, e.button = t.button, e.buttons = t.buttons, e.client.copyFrom(t.client), e.ctrlKey = t.ctrlKey, e.metaKey = t.metaKey, e.movement.copyFrom(t.movement), e.screen.copyFrom(t.screen), e.shiftKey = t.shiftKey, e.global.copyFrom(t.global));
  }
  /**
   * Copies base {@link FederatedEvent} data from `from` into `to`.
   *
   * The following properties are copied:
   * + isTrusted
   * + srcElement
   * + timeStamp
   * + type
   * @param from - The event to copy data from.
   * @param to - The event to copy data into.
   */
  copyData(t, e) {
    e.isTrusted = t.isTrusted, e.srcElement = t.srcElement, e.timeStamp = performance.now(), e.type = t.type, e.detail = t.detail, e.view = t.view, e.which = t.which, e.layer.copyFrom(t.layer), e.page.copyFrom(t.page);
  }
  /**
   * @param id - The pointer ID.
   * @returns The tracking data stored for the given pointer. If no data exists, a blank
   *  state will be created.
   */
  trackingData(t) {
    return this.mappingState.trackingData[t] || (this.mappingState.trackingData[t] = {
      pressTargetsByButton: {},
      clicksByButton: {},
      overTarget: null
    }), this.mappingState.trackingData[t];
  }
  /**
   * Allocate a specific type of event from {@link EventBoundary#eventPool this.eventPool}.
   *
   * This allocation is constructor-agnostic, as long as it only takes one argument - this event
   * boundary.
   * @param constructor - The event's constructor.
   */
  allocateEvent(t) {
    this.eventPool.has(t) || this.eventPool.set(t, []);
    const e = this.eventPool.get(t).pop() || new t(this);
    return e.eventPhase = e.NONE, e.currentTarget = null, e.defaultPrevented = !1, e.path = null, e.target = null, e;
  }
  /**
   * Frees the event and puts it back into the event pool.
   *
   * It is illegal to reuse the event until it is allocated again, using `this.allocateEvent`.
   *
   * It is also advised that events not allocated from {@link EventBoundary#allocateEvent this.allocateEvent}
   * not be freed. This is because of the possibility that the same event is freed twice, which can cause
   * it to be allocated twice & result in overwriting.
   * @param event - The event to be freed.
   * @throws Error if the event is managed by another event boundary.
   */
  freeEvent(t) {
    if (t.manager !== this)
      throw new Error("It is illegal to free an event not managed by this EventBoundary!");
    const e = t.constructor;
    this.eventPool.has(e) || this.eventPool.set(e, []), this.eventPool.get(e).push(t);
  }
  /**
   * Similar to {@link EventEmitter.emit}, except it stops if the `propagationImmediatelyStopped` flag
   * is set on the event.
   * @param e - The event to call each listener with.
   * @param type - The event key.
   */
  _notifyListeners(t, e) {
    const r = t.currentTarget._events[e];
    if (r)
      if ("fn" in r)
        r.once && t.currentTarget.removeListener(e, r.fn, void 0, !0), r.fn.call(r.context, t);
      else
        for (let n = 0, a = r.length; n < a && !t.propagationImmediatelyStopped; n++)
          r[n].once && t.currentTarget.removeListener(e, r[n].fn, void 0, !0), r[n].fn.call(r[n].context, t);
  }
}
const pS = 1, _S = {
  touchstart: "pointerdown",
  touchend: "pointerup",
  touchendoutside: "pointerupoutside",
  touchmove: "pointermove",
  touchcancel: "pointercancel"
}, il = class jo {
  /**
   * @param {Renderer} renderer
   */
  constructor(t) {
    this.supportsTouchEvents = "ontouchstart" in globalThis, this.supportsPointerEvents = !!globalThis.PointerEvent, this.domElement = null, this.resolution = 1, this.renderer = t, this.rootBoundary = new fS(null), je.init(this), this.autoPreventDefault = !0, this._eventsAdded = !1, this._rootPointerEvent = new fe(null), this._rootWheelEvent = new dr(null), this.cursorStyles = {
      default: "inherit",
      pointer: "pointer"
    }, this.features = new Proxy({ ...jo.defaultEventFeatures }, {
      set: (e, r, n) => (r === "globalMove" && (this.rootBoundary.enableGlobalMoveEvents = n), e[r] = n, !0)
    }), this._onPointerDown = this._onPointerDown.bind(this), this._onPointerMove = this._onPointerMove.bind(this), this._onPointerUp = this._onPointerUp.bind(this), this._onPointerOverOut = this._onPointerOverOut.bind(this), this.onWheel = this.onWheel.bind(this);
  }
  /**
   * The default interaction mode for all display objects.
   * @see Container.eventMode
   * @type {EventMode}
   * @readonly
   * @since 7.2.0
   */
  static get defaultEventMode() {
    return this._defaultEventMode;
  }
  /**
   * Runner init called, view is available at this point.
   * @ignore
   */
  init(t) {
    const { canvas: e, resolution: r } = this.renderer;
    this.setTargetElement(e), this.resolution = r, jo._defaultEventMode = t.eventMode ?? "passive", Object.assign(this.features, t.eventFeatures ?? {}), this.rootBoundary.enableGlobalMoveEvents = this.features.globalMove;
  }
  /**
   * Handle changing resolution.
   * @ignore
   */
  resolutionChange(t) {
    this.resolution = t;
  }
  /** Destroys all event listeners and detaches the renderer. */
  destroy() {
    this.setTargetElement(null), this.renderer = null, this._currentCursor = null;
  }
  /**
   * Sets the current cursor mode, handling any callbacks or CSS style changes.
   * The cursor can be a CSS cursor string, a custom callback function, or a key from the cursorStyles dictionary.
   * @param mode - Cursor mode to set. Can be:
   * - A CSS cursor string (e.g., 'pointer', 'grab')
   * - A key from the cursorStyles dictionary
   * - null/undefined to reset to default
   * @example
   * ```ts
   * // Using predefined cursor styles
   * app.renderer.events.setCursor('pointer');    // Set standard pointer cursor
   * app.renderer.events.setCursor('grab');       // Set grab cursor
   * app.renderer.events.setCursor(null);         // Reset to default
   *
   * // Using custom cursor styles
   * app.renderer.events.cursorStyles.custom = 'url("cursor.png"), auto';
   * app.renderer.events.setCursor('custom');     // Apply custom cursor
   *
   * // Using callback-based cursor
   * app.renderer.events.cursorStyles.dynamic = (mode) => {
   *     document.body.style.cursor = mode === 'hover' ? 'pointer' : 'default';
   * };
   * app.renderer.events.setCursor('dynamic');    // Trigger cursor callback
   * ```
   * @remarks
   * - Has no effect on OffscreenCanvas except for callback-based cursors
   * - Caches current cursor to avoid unnecessary DOM updates
   * - Supports CSS cursor values, style objects, and callback functions
   * @see {@link EventSystem.cursorStyles} For defining custom cursor styles
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/CSS/cursor} MDN Cursor Reference
   */
  setCursor(t) {
    t || (t = "default");
    let e = !0;
    if (globalThis.OffscreenCanvas && this.domElement instanceof OffscreenCanvas && (e = !1), this._currentCursor === t)
      return;
    this._currentCursor = t;
    const r = this.cursorStyles[t];
    if (r)
      switch (typeof r) {
        case "string":
          e && (this.domElement.style.cursor = r);
          break;
        case "function":
          r(t);
          break;
        case "object":
          e && Object.assign(this.domElement.style, r);
          break;
      }
    else e && typeof t == "string" && !Object.prototype.hasOwnProperty.call(this.cursorStyles, t) && (this.domElement.style.cursor = t);
  }
  /**
   * The global pointer event instance containing the most recent pointer state.
   * This is useful for accessing pointer information without listening to events.
   * @example
   * ```ts
   * // Access current pointer position at any time
   * const eventSystem = app.renderer.events;
   * const pointer = eventSystem.pointer;
   *
   * // Get global coordinates
   * console.log('Position:', pointer.global.x, pointer.global.y);
   *
   * // Check button state
   * console.log('Buttons pressed:', pointer.buttons);
   *
   * // Get pointer type and pressure
   * console.log('Type:', pointer.pointerType);
   * console.log('Pressure:', pointer.pressure);
   * ```
   * @readonly
   * @since 7.2.0
   * @see {@link FederatedPointerEvent} For all available pointer properties
   */
  get pointer() {
    return this._rootPointerEvent;
  }
  /**
   * Event handler for pointer down events on {@link EventSystem#domElement this.domElement}.
   * @param nativeEvent - The native mouse/pointer/touch event.
   */
  _onPointerDown(t) {
    if (!this.features.click)
      return;
    this.rootBoundary.rootTarget = this.renderer.lastObjectRendered;
    const e = this._normalizeToPointerData(t);
    this.autoPreventDefault && e[0].isNormalized && (t.cancelable || !("cancelable" in t)) && t.preventDefault();
    for (let r = 0, n = e.length; r < n; r++) {
      const a = e[r], l = this._bootstrapEvent(this._rootPointerEvent, a);
      this.rootBoundary.mapEvent(l);
    }
    this.setCursor(this.rootBoundary.cursor);
  }
  /**
   * Event handler for pointer move events on on {@link EventSystem#domElement this.domElement}.
   * @param nativeEvent - The native mouse/pointer/touch events.
   */
  _onPointerMove(t) {
    if (!this.features.move)
      return;
    this.rootBoundary.rootTarget = this.renderer.lastObjectRendered, je.pointerMoved();
    const e = this._normalizeToPointerData(t);
    for (let r = 0, n = e.length; r < n; r++) {
      const a = this._bootstrapEvent(this._rootPointerEvent, e[r]);
      this.rootBoundary.mapEvent(a);
    }
    this.setCursor(this.rootBoundary.cursor);
  }
  /**
   * Event handler for pointer up events on {@link EventSystem#domElement this.domElement}.
   * @param nativeEvent - The native mouse/pointer/touch event.
   */
  _onPointerUp(t) {
    if (!this.features.click)
      return;
    this.rootBoundary.rootTarget = this.renderer.lastObjectRendered;
    let e = t.target;
    t.composedPath && t.composedPath().length > 0 && (e = t.composedPath()[0]);
    const r = e !== this.domElement ? "outside" : "", n = this._normalizeToPointerData(t);
    for (let a = 0, l = n.length; a < l; a++) {
      const h = this._bootstrapEvent(this._rootPointerEvent, n[a]);
      h.type += r, this.rootBoundary.mapEvent(h);
    }
    this.setCursor(this.rootBoundary.cursor);
  }
  /**
   * Event handler for pointer over & out events on {@link EventSystem#domElement this.domElement}.
   * @param nativeEvent - The native mouse/pointer/touch event.
   */
  _onPointerOverOut(t) {
    if (!this.features.click)
      return;
    this.rootBoundary.rootTarget = this.renderer.lastObjectRendered;
    const e = this._normalizeToPointerData(t);
    for (let r = 0, n = e.length; r < n; r++) {
      const a = this._bootstrapEvent(this._rootPointerEvent, e[r]);
      this.rootBoundary.mapEvent(a);
    }
    this.setCursor(this.rootBoundary.cursor);
  }
  /**
   * Passive handler for `wheel` events on {@link EventSystem.domElement this.domElement}.
   * @param nativeEvent - The native wheel event.
   */
  onWheel(t) {
    if (!this.features.wheel)
      return;
    const e = this.normalizeWheelEvent(t);
    this.rootBoundary.rootTarget = this.renderer.lastObjectRendered, this.rootBoundary.mapEvent(e);
  }
  /**
   * Sets the {@link EventSystem#domElement domElement} and binds event listeners.
   * This method manages the DOM event bindings for the event system, allowing you to
   * change or remove the target element that receives input events.
   * > [!IMPORTANT] This will default to the canvas element of the renderer, so you
   * > should not need to call this unless you are using a custom element.
   * @param element - The new DOM element to bind events to, or null to remove all event bindings
   * @example
   * ```ts
   * // Set a new canvas element as the target
   * const canvas = document.createElement('canvas');
   * app.renderer.events.setTargetElement(canvas);
   *
   * // Remove all event bindings
   * app.renderer.events.setTargetElement(null);
   *
   * // Switch to a different canvas
   * const newCanvas = document.querySelector('#game-canvas');
   * app.renderer.events.setTargetElement(newCanvas);
   * ```
   * @remarks
   * - Automatically removes event listeners from previous element
   * - Required for the event system to function
   * - Safe to call multiple times
   * @see {@link EventSystem#domElement} The current DOM element
   * @see {@link EventsTicker} For the ticker system that tracks pointer movement
   */
  setTargetElement(t) {
    this._removeEvents(), this.domElement = t, je.domElement = t, this._addEvents();
  }
  /** Register event listeners on {@link Renderer#domElement this.domElement}. */
  _addEvents() {
    if (this._eventsAdded || !this.domElement)
      return;
    je.addTickerListener();
    const t = this.domElement.style;
    t && (globalThis.navigator.msPointerEnabled ? (t.msContentZooming = "none", t.msTouchAction = "none") : this.supportsPointerEvents && (t.touchAction = "none")), this.supportsPointerEvents ? (globalThis.document.addEventListener("pointermove", this._onPointerMove, !0), this.domElement.addEventListener("pointerdown", this._onPointerDown, !0), this.domElement.addEventListener("pointerleave", this._onPointerOverOut, !0), this.domElement.addEventListener("pointerover", this._onPointerOverOut, !0), globalThis.addEventListener("pointerup", this._onPointerUp, !0)) : (globalThis.document.addEventListener("mousemove", this._onPointerMove, !0), this.domElement.addEventListener("mousedown", this._onPointerDown, !0), this.domElement.addEventListener("mouseout", this._onPointerOverOut, !0), this.domElement.addEventListener("mouseover", this._onPointerOverOut, !0), globalThis.addEventListener("mouseup", this._onPointerUp, !0), this.supportsTouchEvents && (this.domElement.addEventListener("touchstart", this._onPointerDown, !0), this.domElement.addEventListener("touchend", this._onPointerUp, !0), this.domElement.addEventListener("touchmove", this._onPointerMove, !0))), this.domElement.addEventListener("wheel", this.onWheel, {
      passive: !0,
      capture: !0
    }), this._eventsAdded = !0;
  }
  /** Unregister event listeners on {@link EventSystem#domElement this.domElement}. */
  _removeEvents() {
    if (!this._eventsAdded || !this.domElement)
      return;
    je.removeTickerListener();
    const t = this.domElement.style;
    t && (globalThis.navigator.msPointerEnabled ? (t.msContentZooming = "", t.msTouchAction = "") : this.supportsPointerEvents && (t.touchAction = "")), this.supportsPointerEvents ? (globalThis.document.removeEventListener("pointermove", this._onPointerMove, !0), this.domElement.removeEventListener("pointerdown", this._onPointerDown, !0), this.domElement.removeEventListener("pointerleave", this._onPointerOverOut, !0), this.domElement.removeEventListener("pointerover", this._onPointerOverOut, !0), globalThis.removeEventListener("pointerup", this._onPointerUp, !0)) : (globalThis.document.removeEventListener("mousemove", this._onPointerMove, !0), this.domElement.removeEventListener("mousedown", this._onPointerDown, !0), this.domElement.removeEventListener("mouseout", this._onPointerOverOut, !0), this.domElement.removeEventListener("mouseover", this._onPointerOverOut, !0), globalThis.removeEventListener("mouseup", this._onPointerUp, !0), this.supportsTouchEvents && (this.domElement.removeEventListener("touchstart", this._onPointerDown, !0), this.domElement.removeEventListener("touchend", this._onPointerUp, !0), this.domElement.removeEventListener("touchmove", this._onPointerMove, !0))), this.domElement.removeEventListener("wheel", this.onWheel, !0), this.domElement = null, this._eventsAdded = !1;
  }
  /**
   * Maps coordinates from DOM/screen space into PixiJS normalized coordinates.
   * This takes into account the current scale, position, and resolution of the DOM element.
   * @param point - The point to store the mapped coordinates in
   * @param x - The x coordinate in DOM/client space
   * @param y - The y coordinate in DOM/client space
   * @example
   * ```ts
   * // Map mouse coordinates to PixiJS space
   * const point = new Point();
   * app.renderer.events.mapPositionToPoint(
   *     point,
   *     event.clientX,
   *     event.clientY
   * );
   * console.log('Mapped position:', point.x, point.y);
   *
   * // Using with pointer events
   * sprite.on('pointermove', (event) => {
   *     // event.global already contains mapped coordinates
   *     console.log('Global:', event.global.x, event.global.y);
   *
   *     // Map to local coordinates
   *     const local = event.getLocalPosition(sprite);
   *     console.log('Local:', local.x, local.y);
   * });
   * ```
   * @remarks
   * - Accounts for element scaling and positioning
   * - Adjusts for device pixel ratio/resolution
   */
  mapPositionToPoint(t, e, r) {
    const n = this.domElement.isConnected ? this.domElement.getBoundingClientRect() : {
      width: this.domElement.width,
      height: this.domElement.height,
      left: 0,
      top: 0
    }, a = 1 / this.resolution;
    t.x = (e - n.left) * (this.domElement.width / n.width) * a, t.y = (r - n.top) * (this.domElement.height / n.height) * a;
  }
  /**
   * Ensures that the original event object contains all data that a regular pointer event would have
   * @param event - The original event data from a touch or mouse event
   * @returns An array containing a single normalized pointer event, in the case of a pointer
   *  or mouse event, or a multiple normalized pointer events if there are multiple changed touches
   */
  _normalizeToPointerData(t) {
    const e = [];
    if (this.supportsTouchEvents && t instanceof TouchEvent)
      for (let r = 0, n = t.changedTouches.length; r < n; r++) {
        const a = t.changedTouches[r];
        typeof a.button > "u" && (a.button = 0), typeof a.buttons > "u" && (a.buttons = 1), typeof a.isPrimary > "u" && (a.isPrimary = t.touches.length === 1 && t.type === "touchstart"), typeof a.width > "u" && (a.width = a.radiusX || 1), typeof a.height > "u" && (a.height = a.radiusY || 1), typeof a.tiltX > "u" && (a.tiltX = 0), typeof a.tiltY > "u" && (a.tiltY = 0), typeof a.pointerType > "u" && (a.pointerType = "touch"), typeof a.pointerId > "u" && (a.pointerId = a.identifier || 0), typeof a.pressure > "u" && (a.pressure = a.force || 0.5), typeof a.twist > "u" && (a.twist = 0), typeof a.tangentialPressure > "u" && (a.tangentialPressure = 0), typeof a.layerX > "u" && (a.layerX = a.offsetX = a.clientX), typeof a.layerY > "u" && (a.layerY = a.offsetY = a.clientY), a.isNormalized = !0, a.type = t.type, e.push(a);
      }
    else if (!globalThis.MouseEvent || t instanceof MouseEvent && (!this.supportsPointerEvents || !(t instanceof globalThis.PointerEvent))) {
      const r = t;
      typeof r.isPrimary > "u" && (r.isPrimary = !0), typeof r.width > "u" && (r.width = 1), typeof r.height > "u" && (r.height = 1), typeof r.tiltX > "u" && (r.tiltX = 0), typeof r.tiltY > "u" && (r.tiltY = 0), typeof r.pointerType > "u" && (r.pointerType = "mouse"), typeof r.pointerId > "u" && (r.pointerId = pS), typeof r.pressure > "u" && (r.pressure = 0.5), typeof r.twist > "u" && (r.twist = 0), typeof r.tangentialPressure > "u" && (r.tangentialPressure = 0), r.isNormalized = !0, e.push(r);
    } else
      e.push(t);
    return e;
  }
  /**
   * Normalizes the native {@link https://w3c.github.io/uievents/#interface-wheelevent WheelEvent}.
   *
   * The returned {@link FederatedWheelEvent} is a shared instance. It will not persist across
   * multiple native wheel events.
   * @param nativeEvent - The native wheel event that occurred on the canvas.
   * @returns A federated wheel event.
   */
  normalizeWheelEvent(t) {
    const e = this._rootWheelEvent;
    return this._transferMouseData(e, t), e.deltaX = t.deltaX, e.deltaY = t.deltaY, e.deltaZ = t.deltaZ, e.deltaMode = t.deltaMode, this.mapPositionToPoint(e.screen, t.clientX, t.clientY), e.global.copyFrom(e.screen), e.offset.copyFrom(e.screen), e.nativeEvent = t, e.type = t.type, e;
  }
  /**
   * Normalizes the `nativeEvent` into a federateed {@link FederatedPointerEvent}.
   * @param event
   * @param nativeEvent
   */
  _bootstrapEvent(t, e) {
    return t.originalEvent = null, t.nativeEvent = e, t.pointerId = e.pointerId, t.width = e.width, t.height = e.height, t.isPrimary = e.isPrimary, t.pointerType = e.pointerType, t.pressure = e.pressure, t.tangentialPressure = e.tangentialPressure, t.tiltX = e.tiltX, t.tiltY = e.tiltY, t.twist = e.twist, this._transferMouseData(t, e), this.mapPositionToPoint(t.screen, e.clientX, e.clientY), t.global.copyFrom(t.screen), t.offset.copyFrom(t.screen), t.isTrusted = e.isTrusted, t.type === "pointerleave" && (t.type = "pointerout"), t.type.startsWith("mouse") && (t.type = t.type.replace("mouse", "pointer")), t.type.startsWith("touch") && (t.type = _S[t.type] || t.type), t;
  }
  /**
   * Transfers base & mouse event data from the `nativeEvent` to the federated event.
   * @param event
   * @param nativeEvent
   */
  _transferMouseData(t, e) {
    t.isTrusted = e.isTrusted, t.srcElement = e.srcElement, t.timeStamp = performance.now(), t.type = e.type, t.altKey = e.altKey, t.button = e.button, t.buttons = e.buttons, t.client.x = e.clientX, t.client.y = e.clientY, t.ctrlKey = e.ctrlKey, t.metaKey = e.metaKey, t.movement.x = e.movementX, t.movement.y = e.movementY, t.page.x = e.pageX, t.page.y = e.pageY, t.relatedTarget = null, t.shiftKey = e.shiftKey;
  }
};
il.extension = {
  name: "events",
  type: [
    A.WebGLSystem,
    A.CanvasSystem,
    A.WebGPUSystem
  ],
  priority: -1
};
il.defaultEventFeatures = {
  /** Enables pointer events associated with pointer movement. */
  move: !0,
  /** Enables global pointer move events. */
  globalMove: !0,
  /** Enables pointer events associated with clicking. */
  click: !0,
  /** Enables wheel events. */
  wheel: !0
};
let l_ = il;
const mS = {
  onclick: null,
  onmousedown: null,
  onmouseenter: null,
  onmouseleave: null,
  onmousemove: null,
  onglobalmousemove: null,
  onmouseout: null,
  onmouseover: null,
  onmouseup: null,
  onmouseupoutside: null,
  onpointercancel: null,
  onpointerdown: null,
  onpointerenter: null,
  onpointerleave: null,
  onpointermove: null,
  onglobalpointermove: null,
  onpointerout: null,
  onpointerover: null,
  onpointertap: null,
  onpointerup: null,
  onpointerupoutside: null,
  onrightclick: null,
  onrightdown: null,
  onrightup: null,
  onrightupoutside: null,
  ontap: null,
  ontouchcancel: null,
  ontouchend: null,
  ontouchendoutside: null,
  ontouchmove: null,
  onglobaltouchmove: null,
  ontouchstart: null,
  onwheel: null,
  get interactive() {
    return this.eventMode === "dynamic" || this.eventMode === "static";
  },
  set interactive(s) {
    this.eventMode = s ? "static" : "passive";
  },
  _internalEventMode: void 0,
  get eventMode() {
    return this._internalEventMode ?? l_.defaultEventMode;
  },
  set eventMode(s) {
    this._internalEventMode = s;
  },
  isInteractive() {
    return this.eventMode === "static" || this.eventMode === "dynamic";
  },
  interactiveChildren: !0,
  hitArea: null,
  addEventListener(s, t, e) {
    const r = typeof e == "boolean" && e || typeof e == "object" && e.capture, n = typeof e == "object" ? e.signal : void 0, a = typeof e == "object" ? e.once === !0 : !1, l = typeof t == "function" ? void 0 : t;
    s = r ? `${s}capture` : s;
    const h = typeof t == "function" ? t : t.handleEvent, u = this;
    n && n.addEventListener("abort", () => {
      u.off(s, h, l);
    }), a ? u.once(s, h, l) : u.on(s, h, l);
  },
  removeEventListener(s, t, e) {
    const r = typeof e == "boolean" && e || typeof e == "object" && e.capture, n = typeof t == "function" ? void 0 : t;
    s = r ? `${s}capture` : s, t = typeof t == "function" ? t : t.handleEvent, this.off(s, t, n);
  },
  dispatchEvent(s) {
    if (!(s instanceof gs))
      throw new Error("Container cannot propagate events outside of the Federated Events API");
    return s.defaultPrevented = !1, s.path = null, s.target = this, s.manager.dispatchEvent(s), !s.defaultPrevented;
  }
};
class c_ {
  constructor(t) {
    this._renderer = t;
  }
  push(t, e, r) {
    this._renderer.renderPipes.batch.break(r), r.add({
      renderPipeId: "filter",
      canBundle: !1,
      action: "pushFilter",
      container: e,
      filterEffect: t
    });
  }
  pop(t, e, r) {
    this._renderer.renderPipes.batch.break(r), r.add({
      renderPipeId: "filter",
      action: "popFilter",
      canBundle: !1
    });
  }
  execute(t) {
    t.action === "pushFilter" ? this._renderer.filter.push(t) : t.action === "popFilter" && this._renderer.filter.pop();
  }
  destroy() {
    this._renderer = null;
  }
}
c_.extension = {
  type: [
    A.WebGLPipes,
    A.WebGPUPipes,
    A.CanvasPipes
  ],
  name: "filter"
};
function gS(s, t) {
  t.clear();
  const e = t.matrix;
  for (let r = 0; r < s.length; r++) {
    const n = s[r];
    n.globalDisplayStatus < 7 || (t.matrix = n.worldTransform, t.addBounds(n.bounds));
  }
  return t.matrix = e, t;
}
const yS = new ys({
  attributes: {
    aPosition: {
      buffer: new Float32Array([0, 0, 1, 0, 1, 1, 0, 1]),
      format: "float32x2",
      stride: 2 * 4,
      offset: 0
    }
  },
  indexBuffer: new Uint32Array([0, 1, 2, 0, 2, 3])
});
class xS {
  constructor() {
    this.skip = !1, this.inputTexture = null, this.backTexture = null, this.filters = null, this.bounds = new Ut(), this.container = null, this.blendRequired = !1, this.outputRenderSurface = null, this.globalFrame = { x: 0, y: 0, width: 0, height: 0 };
  }
}
class u_ {
  constructor(t) {
    this._filterStackIndex = 0, this._filterStack = [], this._filterGlobalUniforms = new kt({
      uInputSize: { value: new Float32Array(4), type: "vec4<f32>" },
      uInputPixel: { value: new Float32Array(4), type: "vec4<f32>" },
      uInputClamp: { value: new Float32Array(4), type: "vec4<f32>" },
      uOutputFrame: { value: new Float32Array(4), type: "vec4<f32>" },
      uGlobalFrame: { value: new Float32Array(4), type: "vec4<f32>" },
      uOutputTexture: { value: new Float32Array(4), type: "vec4<f32>" }
    }), this._globalFilterBindGroup = new He({}), this.renderer = t;
  }
  /**
   * The back texture of the currently active filter. Requires the filter to have `blendRequired` set to true.
   * @readonly
   */
  get activeBackTexture() {
    return this._activeFilterData?.backTexture;
  }
  /**
   * Pushes a filter instruction onto the filter stack.
   * @param instruction - The instruction containing the filter effect and container.
   * @internal
   */
  push(t) {
    const e = this.renderer, r = t.filterEffect.filters, n = this._pushFilterData();
    n.skip = !1, n.filters = r, n.container = t.container, n.outputRenderSurface = e.renderTarget.renderSurface;
    const a = e.renderTarget.renderTarget.colorTexture.source, l = a.resolution, h = a.antialias;
    if (r.length === 0) {
      n.skip = !0;
      return;
    }
    const u = n.bounds;
    if (this._calculateFilterArea(t, u), this._calculateFilterBounds(n, e.renderTarget.rootViewPort, h, l, 1), n.skip)
      return;
    const f = this._getPreviousFilterData(), p = this._findFilterResolution(l);
    let m = 0, g = 0;
    f && (m = f.bounds.minX, g = f.bounds.minY), this._calculateGlobalFrame(
      n,
      m,
      g,
      p,
      a.width,
      a.height
    ), this._setupFilterTextures(n, u, e, f);
  }
  /**
   * Applies filters to a texture.
   *
   * This method takes a texture and a list of filters, applies the filters to the texture,
   * and returns the resulting texture.
   * @param {object} params - The parameters for applying filters.
   * @param {Texture} params.texture - The texture to apply filters to.
   * @param {Filter[]} params.filters - The filters to apply.
   * @returns {Texture} The resulting texture after all filters have been applied.
   * @example
   *
   * ```ts
   * // Create a texture and a list of filters
   * const texture = new Texture(...);
   * const filters = [new BlurFilter(), new ColorMatrixFilter()];
   *
   * // Apply the filters to the texture
   * const resultTexture = filterSystem.applyToTexture({ texture, filters });
   *
   * // Use the resulting texture
   * sprite.texture = resultTexture;
   * ```
   *
   * Key Points:
   * 1. padding is not currently supported here - so clipping may occur with filters that use padding.
   * 2. If all filters are disabled or skipped, the original texture is returned.
   */
  generateFilteredTexture({ texture: t, filters: e }) {
    const r = this._pushFilterData();
    this._activeFilterData = r, r.skip = !1, r.filters = e;
    const n = t.source, a = n.resolution, l = n.antialias;
    if (e.length === 0)
      return r.skip = !0, t;
    const h = r.bounds;
    if (h.addRect(t.frame), this._calculateFilterBounds(r, h.rectangle, l, a, 0), r.skip)
      return t;
    const u = a;
    this._calculateGlobalFrame(
      r,
      0,
      0,
      u,
      n.width,
      n.height
    ), r.outputRenderSurface = At.getOptimalTexture(
      h.width,
      h.height,
      r.resolution,
      r.antialias
    ), r.backTexture = k.EMPTY, r.inputTexture = t, this.renderer.renderTarget.finishRenderPass(), this._applyFiltersToTexture(r, !0);
    const g = r.outputRenderSurface;
    return g.source.alphaMode = "premultiplied-alpha", g;
  }
  /** @internal */
  pop() {
    const t = this.renderer, e = this._popFilterData();
    e.skip || (t.globalUniforms.pop(), t.renderTarget.finishRenderPass(), this._activeFilterData = e, this._applyFiltersToTexture(e, !1), e.blendRequired && At.returnTexture(e.backTexture), At.returnTexture(e.inputTexture));
  }
  /**
   * Copies the last render surface to a texture.
   * @param lastRenderSurface - The last render surface to copy from.
   * @param bounds - The bounds of the area to copy.
   * @param previousBounds - The previous bounds to use for offsetting the copy.
   */
  getBackTexture(t, e, r) {
    const n = t.colorTexture.source._resolution, a = At.getOptimalTexture(
      e.width,
      e.height,
      n,
      !1
    );
    let l = e.minX, h = e.minY;
    r && (l -= r.minX, h -= r.minY), l = Math.floor(l * n), h = Math.floor(h * n);
    const u = Math.ceil(e.width * n), f = Math.ceil(e.height * n);
    return this.renderer.renderTarget.copyToTexture(
      t,
      a,
      { x: l, y: h },
      { width: u, height: f },
      { x: 0, y: 0 }
    ), a;
  }
  /**
   * Applies a filter to a texture.
   * @param filter - The filter to apply.
   * @param input - The input texture.
   * @param output - The output render surface.
   * @param clear - Whether to clear the output surface before applying the filter.
   */
  applyFilter(t, e, r, n) {
    const a = this.renderer, l = this._activeFilterData, u = l.outputRenderSurface === r, f = a.renderTarget.rootRenderTarget.colorTexture.source._resolution, p = this._findFilterResolution(f);
    let m = 0, g = 0;
    if (u) {
      const x = this._findPreviousFilterOffset();
      m = x.x, g = x.y;
    }
    this._updateFilterUniforms(e, r, l, m, g, p, u, n), this._setupBindGroupsAndRender(t, e, a);
  }
  /**
   * Multiply _input normalized coordinates_ to this matrix to get _sprite texture normalized coordinates_.
   *
   * Use `outputMatrix * vTextureCoord` in the shader.
   * @param outputMatrix - The matrix to output to.
   * @param {Sprite} sprite - The sprite to map to.
   * @returns The mapped matrix.
   */
  calculateSpriteMatrix(t, e) {
    const r = this._activeFilterData, n = t.set(
      r.inputTexture._source.width,
      0,
      0,
      r.inputTexture._source.height,
      r.bounds.minX,
      r.bounds.minY
    ), a = e.worldTransform.copyTo(D.shared), l = e.renderGroup || e.parentRenderGroup;
    return l && l.cacheToLocalTransform && a.prepend(l.cacheToLocalTransform), a.invert(), n.prepend(a), n.scale(
      1 / e.texture.frame.width,
      1 / e.texture.frame.height
    ), n.translate(e.anchor.x, e.anchor.y), n;
  }
  destroy() {
  }
  /**
   * Sets up the bind groups and renders the filter.
   * @param filter - The filter to apply
   * @param input - The input texture
   * @param renderer - The renderer instance
   */
  _setupBindGroupsAndRender(t, e, r) {
    if (r.renderPipes.uniformBatch) {
      const n = r.renderPipes.uniformBatch.getUboResource(this._filterGlobalUniforms);
      this._globalFilterBindGroup.setResource(n, 0);
    } else
      this._globalFilterBindGroup.setResource(this._filterGlobalUniforms, 0);
    this._globalFilterBindGroup.setResource(e.source, 1), this._globalFilterBindGroup.setResource(e.source.style, 2), t.groups[0] = this._globalFilterBindGroup, r.encoder.draw({
      geometry: yS,
      shader: t,
      state: t._state,
      topology: "triangle-list"
    }), r.type === ge.WEBGL && r.renderTarget.finishRenderPass();
  }
  /**
   * Sets up the filter textures including input texture and back texture if needed.
   * @param filterData - The filter data to update
   * @param bounds - The bounds for the texture
   * @param renderer - The renderer instance
   * @param previousFilterData - The previous filter data for back texture calculation
   */
  _setupFilterTextures(t, e, r, n) {
    if (t.backTexture = k.EMPTY, t.blendRequired) {
      r.renderTarget.finishRenderPass();
      const a = r.renderTarget.getRenderTarget(t.outputRenderSurface);
      t.backTexture = this.getBackTexture(a, e, n?.bounds);
    }
    t.inputTexture = At.getOptimalTexture(
      e.width,
      e.height,
      t.resolution,
      t.antialias
    ), r.renderTarget.bind(t.inputTexture, !0), r.globalUniforms.push({
      offset: e
    });
  }
  /**
   * Calculates and sets the global frame for the filter.
   * @param filterData - The filter data to update
   * @param offsetX - The X offset
   * @param offsetY - The Y offset
   * @param globalResolution - The global resolution
   * @param sourceWidth - The source texture width
   * @param sourceHeight - The source texture height
   */
  _calculateGlobalFrame(t, e, r, n, a, l) {
    const h = t.globalFrame;
    h.x = e * n, h.y = r * n, h.width = a * n, h.height = l * n;
  }
  /**
   * Updates the filter uniforms with the current filter state.
   * @param input - The input texture
   * @param output - The output render surface
   * @param filterData - The current filter data
   * @param offsetX - The X offset for positioning
   * @param offsetY - The Y offset for positioning
   * @param resolution - The current resolution
   * @param isFinalTarget - Whether this is the final render target
   * @param clear - Whether to clear the output surface
   */
  _updateFilterUniforms(t, e, r, n, a, l, h, u) {
    const f = this._filterGlobalUniforms.uniforms, p = f.uOutputFrame, m = f.uInputSize, g = f.uInputPixel, x = f.uInputClamp, o = f.uGlobalFrame, c = f.uOutputTexture;
    h ? (p[0] = r.bounds.minX - n, p[1] = r.bounds.minY - a) : (p[0] = 0, p[1] = 0), p[2] = t.frame.width, p[3] = t.frame.height, m[0] = t.source.width, m[1] = t.source.height, m[2] = 1 / m[0], m[3] = 1 / m[1], g[0] = t.source.pixelWidth, g[1] = t.source.pixelHeight, g[2] = 1 / g[0], g[3] = 1 / g[1], x[0] = 0.5 * g[2], x[1] = 0.5 * g[3], x[2] = t.frame.width * m[2] - 0.5 * g[2], x[3] = t.frame.height * m[3] - 0.5 * g[3];
    const d = this.renderer.renderTarget.rootRenderTarget.colorTexture;
    o[0] = n * l, o[1] = a * l, o[2] = d.source.width * l, o[3] = d.source.height * l, e instanceof k && (e.source.resource = null);
    const _ = this.renderer.renderTarget.getRenderTarget(e);
    this.renderer.renderTarget.bind(e, !!u), e instanceof k ? (c[0] = e.frame.width, c[1] = e.frame.height) : (c[0] = _.width, c[1] = _.height), c[2] = _.isRoot ? -1 : 1, this._filterGlobalUniforms.update();
  }
  /**
   * Finds the correct resolution by looking back through the filter stack.
   * @param rootResolution - The fallback root resolution to use
   * @returns The resolution from the previous filter or root resolution
   */
  _findFilterResolution(t) {
    let e = this._filterStackIndex - 1;
    for (; e > 0 && this._filterStack[e].skip; )
      --e;
    return e > 0 && this._filterStack[e].inputTexture ? this._filterStack[e].inputTexture.source._resolution : t;
  }
  /**
   * Finds the offset from the previous non-skipped filter in the stack.
   * @returns The offset coordinates from the previous filter
   */
  _findPreviousFilterOffset() {
    let t = 0, e = 0, r = this._filterStackIndex;
    for (; r > 0; ) {
      r--;
      const n = this._filterStack[r];
      if (!n.skip) {
        t = n.bounds.minX, e = n.bounds.minY;
        break;
      }
    }
    return { x: t, y: e };
  }
  /**
   * Calculates the filter area bounds based on the instruction type.
   * @param instruction - The filter instruction
   * @param bounds - The bounds object to populate
   */
  _calculateFilterArea(t, e) {
    if (t.renderables ? gS(t.renderables, e) : t.filterEffect.filterArea ? (e.clear(), e.addRect(t.filterEffect.filterArea), e.applyMatrix(t.container.worldTransform)) : t.container.getFastGlobalBounds(!0, e), t.container) {
      const n = (t.container.renderGroup || t.container.parentRenderGroup).cacheToLocalTransform;
      n && e.applyMatrix(n);
    }
  }
  _applyFiltersToTexture(t, e) {
    const r = t.inputTexture, n = t.bounds, a = t.filters;
    if (this._globalFilterBindGroup.setResource(r.source.style, 2), this._globalFilterBindGroup.setResource(t.backTexture.source, 3), a.length === 1)
      a[0].apply(this, r, t.outputRenderSurface, e);
    else {
      let l = t.inputTexture;
      const h = At.getOptimalTexture(
        n.width,
        n.height,
        l.source._resolution,
        !1
      );
      let u = h, f = 0;
      for (f = 0; f < a.length - 1; ++f) {
        a[f].apply(this, l, u, !0);
        const m = l;
        l = u, u = m;
      }
      a[f].apply(this, l, t.outputRenderSurface, e), At.returnTexture(h);
    }
  }
  _calculateFilterBounds(t, e, r, n, a) {
    const l = this.renderer, h = t.bounds, u = t.filters;
    let f = 1 / 0, p = 0, m = !0, g = !1, x = !1, o = !0;
    for (let c = 0; c < u.length; c++) {
      const d = u[c];
      if (f = Math.min(f, d.resolution === "inherit" ? n : d.resolution), p += d.padding, d.antialias === "off" ? m = !1 : d.antialias === "inherit" && m && (m = r), d.clipToViewport || (o = !1), !!!(d.compatibleRenderers & l.type)) {
        x = !1;
        break;
      }
      if (d.blendRequired && !(l.backBuffer?.useBackBuffer ?? !0)) {
        N("Blend filter requires backBuffer on WebGL renderer to be enabled. Set `useBackBuffer: true` in the renderer options."), x = !1;
        break;
      }
      x = d.enabled || x, g || (g = d.blendRequired);
    }
    if (!x) {
      t.skip = !0;
      return;
    }
    if (o && h.fitBounds(0, e.width / n, 0, e.height / n), h.scale(f).ceil().scale(1 / f).pad((p | 0) * a), !h.isPositive) {
      t.skip = !0;
      return;
    }
    t.antialias = m, t.resolution = f, t.blendRequired = g;
  }
  _popFilterData() {
    return this._filterStackIndex--, this._filterStack[this._filterStackIndex];
  }
  _getPreviousFilterData() {
    let t, e = this._filterStackIndex - 1;
    for (; e > 1 && (e--, t = this._filterStack[e], !!t.skip); )
      ;
    return t;
  }
  _pushFilterData() {
    let t = this._filterStack[this._filterStackIndex];
    return t || (t = this._filterStack[this._filterStackIndex] = new xS()), this._filterStackIndex++, t;
  }
}
u_.extension = {
  type: [
    A.WebGLSystem,
    A.WebGPUSystem
  ],
  name: "filter"
};
var bS = `in vec2 vMaskCoord;
in vec2 vTextureCoord;

uniform sampler2D uTexture;
uniform sampler2D uMaskTexture;

uniform float uAlpha;
uniform vec4 uMaskClamp;
uniform float uInverse;

out vec4 finalColor;

void main(void)
{
    float clip = step(3.5,
        step(uMaskClamp.x, vMaskCoord.x) +
        step(uMaskClamp.y, vMaskCoord.y) +
        step(vMaskCoord.x, uMaskClamp.z) +
        step(vMaskCoord.y, uMaskClamp.w));

    // TODO look into why this is needed
    float npmAlpha = uAlpha;
    vec4 original = texture(uTexture, vTextureCoord);
    vec4 masky = texture(uMaskTexture, vMaskCoord);
    float alphaMul = 1.0 - npmAlpha * (1.0 - masky.a);

    float a = alphaMul * masky.r * npmAlpha * clip;

    if (uInverse == 1.0) {
        a = 1.0 - a;
    }

    finalColor = original * a;
}
`, vS = `in vec2 aPosition;

out vec2 vTextureCoord;
out vec2 vMaskCoord;


uniform vec4 uInputSize;
uniform vec4 uOutputFrame;
uniform vec4 uOutputTexture;
uniform mat3 uFilterMatrix;

vec4 filterVertexPosition(  vec2 aPosition )
{
    vec2 position = aPosition * uOutputFrame.zw + uOutputFrame.xy;
       
    position.x = position.x * (2.0 / uOutputTexture.x) - 1.0;
    position.y = position.y * (2.0*uOutputTexture.z / uOutputTexture.y) - uOutputTexture.z;

    return vec4(position, 0.0, 1.0);
}

vec2 filterTextureCoord(  vec2 aPosition )
{
    return aPosition * (uOutputFrame.zw * uInputSize.zw);
}

vec2 getFilterCoord( vec2 aPosition )
{
    return  ( uFilterMatrix * vec3( filterTextureCoord(aPosition), 1.0)  ).xy;
}   

void main(void)
{
    gl_Position = filterVertexPosition(aPosition);
    vTextureCoord = filterTextureCoord(aPosition);
    vMaskCoord = getFilterCoord(aPosition);
}
`, Pu = `struct GlobalFilterUniforms {
  uInputSize:vec4<f32>,
  uInputPixel:vec4<f32>,
  uInputClamp:vec4<f32>,
  uOutputFrame:vec4<f32>,
  uGlobalFrame:vec4<f32>,
  uOutputTexture:vec4<f32>,
};

struct MaskUniforms {
  uFilterMatrix:mat3x3<f32>,
  uMaskClamp:vec4<f32>,
  uAlpha:f32,
  uInverse:f32,
};

@group(0) @binding(0) var<uniform> gfu: GlobalFilterUniforms;
@group(0) @binding(1) var uTexture: texture_2d<f32>;
@group(0) @binding(2) var uSampler : sampler;

@group(1) @binding(0) var<uniform> filterUniforms : MaskUniforms;
@group(1) @binding(1) var uMaskTexture: texture_2d<f32>;

struct VSOutput {
    @builtin(position) position: vec4<f32>,
    @location(0) uv : vec2<f32>,
    @location(1) filterUv : vec2<f32>,
};

fn filterVertexPosition(aPosition:vec2<f32>) -> vec4<f32>
{
    var position = aPosition * gfu.uOutputFrame.zw + gfu.uOutputFrame.xy;

    position.x = position.x * (2.0 / gfu.uOutputTexture.x) - 1.0;
    position.y = position.y * (2.0*gfu.uOutputTexture.z / gfu.uOutputTexture.y) - gfu.uOutputTexture.z;

    return vec4(position, 0.0, 1.0);
}

fn filterTextureCoord( aPosition:vec2<f32> ) -> vec2<f32>
{
    return aPosition * (gfu.uOutputFrame.zw * gfu.uInputSize.zw);
}

fn globalTextureCoord( aPosition:vec2<f32> ) -> vec2<f32>
{
  return  (aPosition.xy / gfu.uGlobalFrame.zw) + (gfu.uGlobalFrame.xy / gfu.uGlobalFrame.zw);
}

fn getFilterCoord(aPosition:vec2<f32> ) -> vec2<f32>
{
  return ( filterUniforms.uFilterMatrix * vec3( filterTextureCoord(aPosition), 1.0)  ).xy;
}

fn getSize() -> vec2<f32>
{
  return gfu.uGlobalFrame.zw;
}

@vertex
fn mainVertex(
  @location(0) aPosition : vec2<f32>,
) -> VSOutput {
  return VSOutput(
   filterVertexPosition(aPosition),
   filterTextureCoord(aPosition),
   getFilterCoord(aPosition)
  );
}

@fragment
fn mainFragment(
  @location(0) uv: vec2<f32>,
  @location(1) filterUv: vec2<f32>,
  @builtin(position) position: vec4<f32>
) -> @location(0) vec4<f32> {

    var maskClamp = filterUniforms.uMaskClamp;
    var uAlpha = filterUniforms.uAlpha;

    var clip = step(3.5,
      step(maskClamp.x, filterUv.x) +
      step(maskClamp.y, filterUv.y) +
      step(filterUv.x, maskClamp.z) +
      step(filterUv.y, maskClamp.w));

    var mask = textureSample(uMaskTexture, uSampler, filterUv);
    var source = textureSample(uTexture, uSampler, uv);
    var alphaMul = 1.0 - uAlpha * (1.0 - mask.a);

    var a: f32 = alphaMul * mask.r * uAlpha * clip;

    if (filterUniforms.uInverse == 1.0) {
        a = 1.0 - a;
    }

    return source * a;
}
`;
class wS extends nv {
  constructor(t) {
    const { sprite: e, ...r } = t, n = new Wf(e.texture), a = new kt({
      uFilterMatrix: { value: new D(), type: "mat3x3<f32>" },
      uMaskClamp: { value: n.uClampFrame, type: "vec4<f32>" },
      uAlpha: { value: 1, type: "f32" },
      uInverse: { value: t.inverse ? 1 : 0, type: "f32" }
    }), l = Di.from({
      vertex: {
        source: Pu,
        entryPoint: "mainVertex"
      },
      fragment: {
        source: Pu,
        entryPoint: "mainFragment"
      }
    }), h = gr.from({
      vertex: vS,
      fragment: bS,
      name: "mask-filter"
    });
    super({
      ...r,
      gpuProgram: l,
      glProgram: h,
      resources: {
        filterUniforms: a,
        uMaskTexture: e.texture.source
      }
    }), this.sprite = e, this._textureMatrix = n;
  }
  set inverse(t) {
    this.resources.filterUniforms.uniforms.uInverse = t ? 1 : 0;
  }
  get inverse() {
    return this.resources.filterUniforms.uniforms.uInverse === 1;
  }
  apply(t, e, r, n) {
    this._textureMatrix.texture = this.sprite.texture, t.calculateSpriteMatrix(
      this.resources.filterUniforms.uniforms.uFilterMatrix,
      this.sprite
    ).prepend(this._textureMatrix.mapCoord), this.resources.uMaskTexture = this.sprite.texture.source, t.applyFilter(this, e, r, n);
  }
}
class fr extends Fh {
  /**
   * Creates a new Graphics object.
   * @param options - Options for the Graphics.
   */
  constructor(t) {
    t instanceof ne && (t = { context: t });
    const { context: e, roundPixels: r, ...n } = t || {};
    super({
      label: "Graphics",
      ...n
    }), this.renderPipeId = "graphics", e ? this._context = e : this._context = this._ownedContext = new ne(), this._context.on("update", this.onViewUpdate, this), this.didViewUpdate = !0, this.allowChildren = !1, this.roundPixels = r ?? !1;
  }
  set context(t) {
    t !== this._context && (this._context.off("update", this.onViewUpdate, this), this._context = t, this._context.on("update", this.onViewUpdate, this), this.onViewUpdate());
  }
  /**
   * The underlying graphics context used for drawing operations.
   * Controls how shapes and paths are rendered.
   * @example
   * ```ts
   * // Create a shared context
   * const sharedContext = new GraphicsContext();
   *
   * // Create graphics objects sharing the same context
   * const graphics1 = new Graphics();
   * const graphics2 = new Graphics();
   *
   * // Assign shared context
   * graphics1.context = sharedContext;
   * graphics2.context = sharedContext;
   *
   * // Both graphics will show the same shapes
   * sharedContext
   *     .rect(0, 0, 100, 100)
   *     .fill({ color: 0xff0000 });
   * ```
   * @see {@link GraphicsContext} For drawing operations
   * @see {@link GraphicsOptions} For context configuration
   */
  get context() {
    return this._context;
  }
  /**
   * The local bounds of the graphics object.
   * Returns the boundaries after all graphical operations but before any transforms.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Draw a shape
   * graphics
   *     .rect(0, 0, 100, 100)
   *     .fill({ color: 0xff0000 });
   *
   * // Get bounds information
   * const bounds = graphics.bounds;
   * console.log(bounds.width);  // 100
   * console.log(bounds.height); // 100
   * ```
   * @readonly
   * @see {@link Bounds} For bounds operations
   * @see {@link Container#getBounds} For transformed bounds
   */
  get bounds() {
    return this._context.bounds;
  }
  /**
   * Graphics objects do not need to update their bounds as the context handles this.
   * @private
   */
  updateBounds() {
  }
  /**
   * Checks if the object contains the given point.
   * Returns true if the point lies within the Graphics object's rendered area.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Draw a shape
   * graphics
   *     .rect(0, 0, 100, 100)
   *     .fill({ color: 0xff0000 });
   *
   * // Check point intersection
   * if (graphics.containsPoint({ x: 50, y: 50 })) {
   *     console.log('Point is inside rectangle!');
   * }
   * ```
   * @param point - The point to check in local coordinates
   * @returns True if the point is inside the Graphics object
   * @see {@link Graphics#bounds} For bounding box checks
   * @see {@link PointData} For point data structure
   */
  containsPoint(t) {
    return this._context.containsPoint(t);
  }
  /**
   * Destroys this graphics renderable and optionally its context.
   * @param options - Options parameter. A boolean will act as if all options
   *
   * If the context was created by this graphics and `destroy(false)` or `destroy()` is called
   * then the context will still be destroyed.
   *
   * If you want to explicitly not destroy this context that this graphics created,
   * then you should pass destroy({ context: false })
   *
   * If the context was passed in as an argument to the constructor then it will not be destroyed
   * @example
   * ```ts
   * // Destroy the graphics and its context
   * graphics.destroy();
   * graphics.destroy(true);
   * graphics.destroy({ context: true, texture: true, textureSource: true });
   * ```
   */
  destroy(t) {
    this._ownedContext && !t ? this._ownedContext.destroy(t) : (t === !0 || t?.context === !0) && this._context.destroy(t), this._ownedContext = null, this._context = null, super.destroy(t);
  }
  _callContextMethod(t, e) {
    return this.context[t](...e), this;
  }
  // --------------------------------------- GraphicsContext methods ---------------------------------------
  /**
   * Sets the current fill style of the graphics context.
   * The fill style can be a color, gradient, pattern, or a complex style object.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Basic color fill
   * graphics
   *     .setFillStyle({ color: 0xff0000 }) // Red fill
   *     .rect(0, 0, 100, 100)
   *     .fill();
   *
   * // Gradient fill
   * const gradient = new FillGradient({
   *    end: { x: 1, y: 0 },
   *    colorStops: [
   *         { offset: 0, color: 0xff0000 }, // Red at start
   *         { offset: 0.5, color: 0x00ff00 }, // Green at middle
   *         { offset: 1, color: 0x0000ff }, // Blue at end
   *    ],
   * });
   *
   * graphics
   *     .setFillStyle(gradient)
   *     .circle(100, 100, 50)
   *     .fill();
   *
   * // Pattern fill
   * const pattern = new FillPattern(texture);
   * graphics
   *     .setFillStyle({
   *         fill: pattern,
   *         alpha: 0.5
   *     })
   *     .rect(0, 0, 200, 200)
   *     .fill();
   * ```
   * @param {FillInput} args - The fill style to apply
   * @returns The Graphics instance for chaining
   * @see {@link FillStyle} For fill style options
   * @see {@link FillGradient} For gradient fills
   * @see {@link FillPattern} For pattern fills
   */
  setFillStyle(...t) {
    return this._callContextMethod("setFillStyle", t);
  }
  /**
   * Sets the current stroke style of the graphics context.
   * Similar to fill styles, stroke styles can encompass colors, gradients, patterns, or more detailed configurations.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Basic color stroke
   * graphics
   *     .setStrokeStyle({
   *         width: 2,
   *         color: 0x000000
   *     })
   *     .rect(0, 0, 100, 100)
   *     .stroke();
   *
   * // Complex stroke style
   * graphics
   *     .setStrokeStyle({
   *         width: 4,
   *         color: 0xff0000,
   *         alpha: 0.5,
   *         join: 'round',
   *         cap: 'round',
   *         alignment: 0.5
   *     })
   *     .circle(100, 100, 50)
   *     .stroke();
   *
   * // Gradient stroke
   * const gradient = new FillGradient({
   *    end: { x: 1, y: 0 },
   *    colorStops: [
   *         { offset: 0, color: 0xff0000 }, // Red at start
   *         { offset: 0.5, color: 0x00ff00 }, // Green at middle
   *         { offset: 1, color: 0x0000ff }, // Blue at end
   *    ],
   * });
   *
   * graphics
   *     .setStrokeStyle({
   *         width: 10,
   *         fill: gradient
   *     })
   *     .poly([0,0, 100,50, 0,100])
   *     .stroke();
   * ```
   * @param {StrokeInput} args - The stroke style to apply
   * @returns The Graphics instance for chaining
   * @see {@link StrokeStyle} For stroke style options
   * @see {@link FillGradient} For gradient strokes
   * @see {@link FillPattern} For pattern strokes
   */
  setStrokeStyle(...t) {
    return this._callContextMethod("setStrokeStyle", t);
  }
  fill(...t) {
    return this._callContextMethod("fill", t);
  }
  /**
   * Strokes the current path with the current stroke style or specified style.
   * Outlines the shape using the stroke settings.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Stroke with direct color
   * graphics
   *     .circle(50, 50, 25)
   *     .stroke({
   *         width: 2,
   *         color: 0xff0000
   *     }); // 2px red stroke
   *
   * // Fill with texture
   * graphics
   *    .rect(0, 0, 100, 100)
   *    .stroke(myTexture); // Fill with texture
   *
   * // Stroke with gradient
   * const gradient = new FillGradient({
   *     end: { x: 1, y: 0 },
   *     colorStops: [
   *         { offset: 0, color: 0xff0000 },
   *         { offset: 0.5, color: 0x00ff00 },
   *         { offset: 1, color: 0x0000ff },
   *     ],
   * });
   *
   * graphics
   *     .rect(0, 0, 100, 100)
   *     .stroke({
   *         width: 4,
   *         fill: gradient,
   *         alignment: 0.5,
   *         join: 'round'
   *     });
   * ```
   * @param {StrokeStyle} args - Optional stroke style to apply. Can be:
   * - A stroke style object with width, color, etc.
   * - A gradient
   * - A pattern
   * If omitted, uses current stroke style.
   * @returns The Graphics instance for chaining
   * @see {@link StrokeStyle} For stroke style options
   * @see {@link FillGradient} For gradient strokes
   * @see {@link setStrokeStyle} For setting default stroke style
   */
  stroke(...t) {
    return this._callContextMethod("stroke", t);
  }
  texture(...t) {
    return this._callContextMethod("texture", t);
  }
  /**
   * Resets the current path. Any previous path and its commands are discarded and a new path is
   * started. This is typically called before beginning a new shape or series of drawing commands.
   * @example
   * ```ts
   * const graphics = new Graphics();
   * graphics
   *     .circle(150, 150, 50)
   *     .fill({ color: 0x00ff00 })
   *     .beginPath() // Starts a new path
   *     .circle(250, 150, 50)
   *     .fill({ color: 0x0000ff });
   * ```
   * @returns The Graphics instance for chaining
   * @see {@link Graphics#moveTo} For starting a new subpath
   * @see {@link Graphics#closePath} For closing the current path
   */
  beginPath() {
    return this._callContextMethod("beginPath", []);
  }
  /**
   * Applies a cutout to the last drawn shape. This is used to create holes or complex shapes by
   * subtracting a path from the previously drawn path.
   *
   * If a hole is not completely in a shape, it will fail to cut correctly.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Draw outer circle
   * graphics
   *     .circle(100, 100, 50)
   *     .fill({ color: 0xff0000 });
   *     .circle(100, 100, 25) // Inner circle
   *     .cut() // Cuts out the inner circle from the outer circle
   * ```
   */
  cut() {
    return this._callContextMethod("cut", []);
  }
  arc(...t) {
    return this._callContextMethod("arc", t);
  }
  arcTo(...t) {
    return this._callContextMethod("arcTo", t);
  }
  arcToSvg(...t) {
    return this._callContextMethod("arcToSvg", t);
  }
  bezierCurveTo(...t) {
    return this._callContextMethod("bezierCurveTo", t);
  }
  /**
   * Closes the current path by drawing a straight line back to the start point.
   *
   * This is useful for completing shapes and ensuring they are properly closed for fills.
   * @example
   * ```ts
   * // Create a triangle with closed path
   * const graphics = new Graphics();
   * graphics
   *     .moveTo(50, 50)
   *     .lineTo(100, 100)
   *     .lineTo(0, 100)
   *     .closePath()
   * ```
   * @returns The Graphics instance for method chaining
   * @see {@link Graphics#beginPath} For starting a new path
   * @see {@link Graphics#fill} For filling closed paths
   * @see {@link Graphics#stroke} For stroking paths
   */
  closePath() {
    return this._callContextMethod("closePath", []);
  }
  ellipse(...t) {
    return this._callContextMethod("ellipse", t);
  }
  circle(...t) {
    return this._callContextMethod("circle", t);
  }
  path(...t) {
    return this._callContextMethod("path", t);
  }
  lineTo(...t) {
    return this._callContextMethod("lineTo", t);
  }
  moveTo(...t) {
    return this._callContextMethod("moveTo", t);
  }
  quadraticCurveTo(...t) {
    return this._callContextMethod("quadraticCurveTo", t);
  }
  rect(...t) {
    return this._callContextMethod("rect", t);
  }
  roundRect(...t) {
    return this._callContextMethod("roundRect", t);
  }
  poly(...t) {
    return this._callContextMethod("poly", t);
  }
  regularPoly(...t) {
    return this._callContextMethod("regularPoly", t);
  }
  roundPoly(...t) {
    return this._callContextMethod("roundPoly", t);
  }
  roundShape(...t) {
    return this._callContextMethod("roundShape", t);
  }
  filletRect(...t) {
    return this._callContextMethod("filletRect", t);
  }
  chamferRect(...t) {
    return this._callContextMethod("chamferRect", t);
  }
  star(...t) {
    return this._callContextMethod("star", t);
  }
  svg(...t) {
    return this._callContextMethod("svg", t);
  }
  restore(...t) {
    return this._callContextMethod("restore", t);
  }
  /**
   * Saves the current graphics state onto a stack. The state includes:
   * - Current transformation matrix
   * - Current fill style
   * - Current stroke style
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Save state before complex operations
   * graphics.save();
   *
   * // Create transformed and styled shape
   * graphics
   *     .translateTransform(100, 100)
   *     .rotateTransform(Math.PI / 4)
   *     .setFillStyle({
   *         color: 0xff0000,
   *         alpha: 0.5
   *     })
   *     .rect(-25, -25, 50, 50)
   *     .fill();
   *
   * // Restore to original state
   * graphics.restore();
   *
   * // Continue drawing with previous state
   * graphics
   *     .circle(50, 50, 25)
   *     .fill();
   * ```
   * @returns The Graphics instance for method chaining
   * @see {@link Graphics#restore} For restoring the saved state
   * @see {@link Graphics#setTransform} For setting transformations
   */
  save() {
    return this._callContextMethod("save", []);
  }
  /**
   * Returns the current transformation matrix of the graphics context.
   * This matrix represents all accumulated transformations including translate, scale, and rotate.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Apply some transformations
   * graphics
   *     .translateTransform(100, 100)
   *     .rotateTransform(Math.PI / 4);
   *
   * // Get the current transform matrix
   * const matrix = graphics.getTransform();
   * console.log(matrix.tx, matrix.ty); // 100, 100
   *
   * // Use the matrix for other operations
   * graphics
   *     .setTransform(matrix)
   *     .circle(0, 0, 50)
   *     .fill({ color: 0xff0000 });
   * ```
   * @returns The current transformation matrix.
   * @see {@link Graphics#setTransform} For setting the transform matrix
   * @see {@link Matrix} For matrix operations
   */
  getTransform() {
    return this.context.getTransform();
  }
  /**
   * Resets the current transformation matrix to the identity matrix, effectively removing
   * any transformations (rotation, scaling, translation) previously applied.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Apply transformations
   * graphics
   *     .translateTransform(100, 100)
   *     .scaleTransform(2, 2)
   *     .circle(0, 0, 25)
   *     .fill({ color: 0xff0000 });
   * // Reset transform to default state
   * graphics
   *     .resetTransform()
   *     .circle(50, 50, 25) // Will draw at actual coordinates
   *     .fill({ color: 0x00ff00 });
   * ```
   * @returns The Graphics instance for method chaining
   * @see {@link Graphics#getTransform} For getting the current transform
   * @see {@link Graphics#setTransform} For setting a specific transform
   * @see {@link Graphics#save} For saving the current transform state
   * @see {@link Graphics#restore} For restoring a previous transform state
   */
  resetTransform() {
    return this._callContextMethod("resetTransform", []);
  }
  rotateTransform(...t) {
    return this._callContextMethod("rotate", t);
  }
  scaleTransform(...t) {
    return this._callContextMethod("scale", t);
  }
  setTransform(...t) {
    return this._callContextMethod("setTransform", t);
  }
  transform(...t) {
    return this._callContextMethod("transform", t);
  }
  translateTransform(...t) {
    return this._callContextMethod("translate", t);
  }
  /**
   * Clears all drawing commands from the graphics context, effectively resetting it.
   * This includes clearing the current path, fill style, stroke style, and transformations.
   *
   * > [!NOTE] Graphics objects are not designed to be continuously cleared and redrawn.
   * > Instead, they are intended to be used for static or semi-static graphics that
   * > can be redrawn as needed. Frequent clearing and redrawing may lead to performance issues.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Draw some shapes
   * graphics
   *     .circle(100, 100, 50)
   *     .fill({ color: 0xff0000 })
   *     .rect(200, 100, 100, 50)
   *     .fill({ color: 0x00ff00 });
   *
   * // Clear all graphics
   * graphics.clear();
   *
   * // Start fresh with new shapes
   * graphics
   *     .circle(150, 150, 30)
   *     .fill({ color: 0x0000ff });
   * ```
   * @returns The Graphics instance for method chaining
   * @see {@link Graphics#beginPath} For starting a new path without clearing styles
   * @see {@link Graphics#save} For saving the current state
   * @see {@link Graphics#restore} For restoring a previous state
   */
  clear() {
    return this._callContextMethod("clear", []);
  }
  /**
   * Gets or sets the current fill style for the graphics context. The fill style determines
   * how shapes are filled when using the fill() method.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Basic color fill
   * graphics.fillStyle = {
   *     color: 0xff0000,  // Red
   *     alpha: 1
   * };
   *
   * // Using gradients
   * const gradient = new FillGradient({
   *     end: { x: 0, y: 1 }, // Vertical gradient
   *     stops: [
   *         { offset: 0, color: 0xff0000, alpha: 1 }, // Start color
   *         { offset: 1, color: 0x0000ff, alpha: 1 }  // End color
   *     ]
   * });
   *
   * graphics.fillStyle = {
   *     fill: gradient,
   *     alpha: 0.8
   * };
   *
   * // Using patterns
   * graphics.fillStyle = {
   *     texture: myTexture,
   *     alpha: 1,
   *     matrix: new Matrix()
   *         .scale(0.5, 0.5)
   *         .rotate(Math.PI / 4)
   * };
   * ```
   * @type {ConvertedFillStyle}
   * @see {@link FillStyle} For all available fill style options
   * @see {@link FillGradient} For creating gradient fills
   * @see {@link Graphics#fill} For applying the fill to paths
   */
  get fillStyle() {
    return this._context.fillStyle;
  }
  set fillStyle(t) {
    this._context.fillStyle = t;
  }
  /**
   * Gets or sets the current stroke style for the graphics context. The stroke style determines
   * how paths are outlined when using the stroke() method.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Basic stroke style
   * graphics.strokeStyle = {
   *     width: 2,
   *     color: 0xff0000,
   *     alpha: 1
   * };
   *
   * // Using with gradients
   * const gradient = new FillGradient({
   *   end: { x: 0, y: 1 },
   *   stops: [
   *       { offset: 0, color: 0xff0000, alpha: 1 },
   *       { offset: 1, color: 0x0000ff, alpha: 1 }
   *   ]
   * });
   *
   * graphics.strokeStyle = {
   *     width: 4,
   *     fill: gradient,
   *     alignment: 0.5,
   *     join: 'round',
   *     cap: 'round'
   * };
   *
   * // Complex stroke settings
   * graphics.strokeStyle = {
   *     width: 6,
   *     color: 0x00ff00,
   *     alpha: 0.5,
   *     join: 'miter',
   *     miterLimit: 10,
   * };
   * ```
   * @see {@link StrokeStyle} For all available stroke style options
   * @see {@link Graphics#stroke} For applying the stroke to paths
   */
  get strokeStyle() {
    return this._context.strokeStyle;
  }
  set strokeStyle(t) {
    this._context.strokeStyle = t;
  }
  /**
   * Creates a new Graphics object that copies the current graphics content.
   * The clone can either share the same context (shallow clone) or have its own independent
   * context (deep clone).
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Create original graphics content
   * graphics
   *     .circle(100, 100, 50)
   *     .fill({ color: 0xff0000 });
   *
   * // Create a shallow clone (shared context)
   * const shallowClone = graphics.clone();
   *
   * // Changes to original affect the clone
   * graphics
   *     .circle(200, 100, 30)
   *     .fill({ color: 0x00ff00 });
   *
   * // Create a deep clone (independent context)
   * const deepClone = graphics.clone(true);
   *
   * // Modify deep clone independently
   * deepClone
   *     .translateTransform(100, 100)
   *     .circle(0, 0, 40)
   *     .fill({ color: 0x0000ff });
   * ```
   * @param deep - Whether to create a deep clone of the graphics object.
   *              If false (default), the context will be shared between objects.
   *              If true, creates an independent copy of the context.
   * @returns A new Graphics instance with either shared or copied context
   * @see {@link Graphics#context} For accessing the underlying graphics context
   * @see {@link GraphicsContext} For understanding the shared context behavior
   */
  clone(t = !1) {
    return t ? new fr(this._context.clone()) : (this._ownedContext = null, new fr(this._context));
  }
  // -------- v7 deprecations ---------
  /**
   * @param width
   * @param color
   * @param alpha
   * @deprecated since 8.0.0 Use {@link Graphics#setStrokeStyle} instead
   */
  lineStyle(t, e, r) {
    W(K, "Graphics#lineStyle is no longer needed. Use Graphics#setStrokeStyle to set the stroke style.");
    const n = {};
    return t && (n.width = t), e && (n.color = e), r && (n.alpha = r), this.context.strokeStyle = n, this;
  }
  /**
   * @param color
   * @param alpha
   * @deprecated since 8.0.0 Use {@link Graphics#fill} instead
   */
  beginFill(t, e) {
    W(K, "Graphics#beginFill is no longer needed. Use Graphics#fill to fill the shape with the desired style.");
    const r = {};
    return t !== void 0 && (r.color = t), e !== void 0 && (r.alpha = e), this.context.fillStyle = r, this;
  }
  /**
   * @deprecated since 8.0.0 Use {@link Graphics#fill} instead
   */
  endFill() {
    W(K, "Graphics#endFill is no longer needed. Use Graphics#fill to fill the shape with the desired style."), this.context.fill();
    const t = this.context.strokeStyle;
    return (t.width !== ne.defaultStrokeStyle.width || t.color !== ne.defaultStrokeStyle.color || t.alpha !== ne.defaultStrokeStyle.alpha) && this.context.stroke(), this;
  }
  /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#circle} instead
   */
  drawCircle(...t) {
    return W(K, "Graphics#drawCircle has been renamed to Graphics#circle"), this._callContextMethod("circle", t);
  }
  /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#ellipse} instead
   */
  drawEllipse(...t) {
    return W(K, "Graphics#drawEllipse has been renamed to Graphics#ellipse"), this._callContextMethod("ellipse", t);
  }
  /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#poly} instead
   */
  drawPolygon(...t) {
    return W(K, "Graphics#drawPolygon has been renamed to Graphics#poly"), this._callContextMethod("poly", t);
  }
  /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#rect} instead
   */
  drawRect(...t) {
    return W(K, "Graphics#drawRect has been renamed to Graphics#rect"), this._callContextMethod("rect", t);
  }
  /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#roundRect} instead
   */
  drawRoundedRect(...t) {
    return W(K, "Graphics#drawRoundedRect has been renamed to Graphics#roundRect"), this._callContextMethod("roundRect", t);
  }
  /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#star} instead
   */
  drawStar(...t) {
    return W(K, "Graphics#drawStar has been renamed to Graphics#star"), this._callContextMethod("star", t);
  }
}
const d_ = class f_ extends ys {
  constructor(...t) {
    let e = t[0] ?? {};
    e instanceof Float32Array && (W(K, "use new MeshGeometry({ positions, uvs, indices }) instead"), e = {
      positions: e,
      uvs: t[1],
      indices: t[2]
    }), e = { ...f_.defaultOptions, ...e };
    const r = e.positions || new Float32Array([0, 0, 1, 0, 1, 1, 0, 1]);
    let n = e.uvs;
    n || (e.positions ? n = new Float32Array(r.length) : n = new Float32Array([0, 0, 1, 0, 1, 1, 0, 1]));
    const a = e.indices || new Uint32Array([0, 1, 2, 0, 2, 3]), l = e.shrinkBuffersToFit, h = new Zt({
      data: r,
      label: "attribute-mesh-positions",
      shrinkToFit: l,
      usage: X.VERTEX | X.COPY_DST
    }), u = new Zt({
      data: n,
      label: "attribute-mesh-uvs",
      shrinkToFit: l,
      usage: X.VERTEX | X.COPY_DST
    }), f = new Zt({
      data: a,
      label: "index-mesh-buffer",
      shrinkToFit: l,
      usage: X.INDEX | X.COPY_DST
    });
    super({
      attributes: {
        aPosition: {
          buffer: h,
          format: "float32x2",
          stride: 2 * 4,
          offset: 0
        },
        aUV: {
          buffer: u,
          format: "float32x2",
          stride: 2 * 4,
          offset: 0
        }
      },
      indexBuffer: f,
      topology: e.topology
    }), this.batchMode = "auto";
  }
  /** The positions of the mesh. */
  get positions() {
    return this.attributes.aPosition.buffer.data;
  }
  /**
   * Set the positions of the mesh.
   * When setting the positions, its important that the uvs array is at least as long as the positions array.
   * otherwise the geometry will not be valid.
   * @param {Float32Array} value - The positions of the mesh.
   */
  set positions(t) {
    this.attributes.aPosition.buffer.data = t;
  }
  /** The UVs of the mesh. */
  get uvs() {
    return this.attributes.aUV.buffer.data;
  }
  /**
   * Set the UVs of the mesh.
   * Its important that the uvs array you set is at least as long as the positions array.
   * otherwise the geometry will not be valid.
   * @param {Float32Array} value - The UVs of the mesh.
   */
  set uvs(t) {
    this.attributes.aUV.buffer.data = t;
  }
  /** The indices of the mesh. */
  get indices() {
    return this.indexBuffer.data;
  }
  set indices(t) {
    this.indexBuffer.data = t;
  }
};
d_.defaultOptions = {
  topology: "triangle-list",
  shrinkBuffersToFit: !1
};
let rl = d_;
class SS extends Fh {
  constructor(t, e) {
    const { text: r, resolution: n, style: a, anchor: l, width: h, height: u, roundPixels: f, ...p } = t;
    super({
      ...p
    }), this.batched = !0, this._resolution = null, this._autoResolution = !0, this._didTextUpdate = !0, this._styleClass = e, this.text = r ?? "", this.style = a, this.resolution = n ?? null, this.allowChildren = !1, this._anchor = new Ft(
      {
        _onUpdate: () => {
          this.onViewUpdate();
        }
      }
    ), l && (this.anchor = l), this.roundPixels = f ?? !1, h !== void 0 && (this.width = h), u !== void 0 && (this.height = u);
  }
  /**
   * The anchor point of the text that controls the origin point for positioning and rotation.
   * Can be a number (same value for x/y) or a PointData object.
   * - (0,0) is top-left
   * - (0.5,0.5) is center
   * - (1,1) is bottom-right
   * ```ts
   * // Set anchor to center
   * const text = new Text({
   *     text: 'Hello Pixi!',
   *     anchor: 0.5 // Same as { x: 0.5, y: 0.5 }
   * });
   * // Set anchor to top-left
   * const text2 = new Text({
   *     text: 'Hello Pixi!',
   *     anchor: { x: 0, y: 0 } // Top-left corner
   * });
   * // Set anchor to bottom-right
   * const text3 = new Text({
   *     text: 'Hello Pixi!',
   *     anchor: { x: 1, y: 1 } // Bottom-right corner
   * });
   * ```
   * @default { x: 0, y: 0 }
   */
  get anchor() {
    return this._anchor;
  }
  set anchor(t) {
    typeof t == "number" ? this._anchor.set(t) : this._anchor.copyFrom(t);
  }
  /**
   * The text content to display. Use '\n' for line breaks.
   * Accepts strings, numbers, or objects with toString() method.
   * @example
   * ```ts
   * const text = new Text({
   *     text: 'Hello Pixi!',
   * });
   * const multilineText = new Text({
   *     text: 'Line 1\nLine 2\nLine 3',
   * });
   * const numberText = new Text({
   *     text: 12345, // Will be converted to '12345'
   * });
   * const objectText = new Text({
   *     text: { toString: () => 'Object Text' }, // Custom toString
   * });
   *
   * // Update text dynamically
   * text.text = 'Updated Text'; // Re-renders with new text
   * text.text = 67890; // Updates to '67890'
   * text.text = { toString: () => 'Dynamic Text' }; // Uses custom toString method
   * // Clear text
   * text.text = ''; // Clears the text
   * ```
   * @default ''
   */
  set text(t) {
    t = t.toString(), this._text !== t && (this._text = t, this.onViewUpdate());
  }
  get text() {
    return this._text;
  }
  /**
   * The resolution/device pixel ratio for rendering.
   * Higher values result in sharper text at the cost of performance.
   * Set to null for auto-resolution based on device.
   * @example
   * ```ts
   * const text = new Text({
   *     text: 'Hello Pixi!',
   *     resolution: 2 // High DPI for sharper text
   * });
   * const autoResText = new Text({
   *     text: 'Auto Resolution',
   *     resolution: null // Use device's pixel ratio
   * });
   * ```
   * @default null
   */
  set resolution(t) {
    this._autoResolution = t === null, this._resolution = t, this.onViewUpdate();
  }
  get resolution() {
    return this._resolution;
  }
  get style() {
    return this._style;
  }
  /**
   * The style configuration for the text.
   * Can be a TextStyle instance or a configuration object.
   * Supports canvas text styles, HTML text styles, and bitmap text styles.
   * @example
   * ```ts
   * const text = new Text({
   *     text: 'Styled Text',
   *     style: {
   *         fontSize: 24,
   *         fill: 0xff1010, // Red color
   *         fontFamily: 'Arial',
   *         align: 'center', // Center alignment
   *         stroke: { color: '#4a1850', width: 5 }, // Purple stroke
   *         dropShadow: {
   *             color: '#000000', // Black shadow
   *             blur: 4, // Shadow blur
   *             distance: 6 // Shadow distance
   *         }
   *     }
   * });
   * const htmlText = new HTMLText({
   *     text: 'HTML Styled Text',
   *     style: {
   *         fontSize: '20px',
   *         fill: 'blue',
   *         fontFamily: 'Verdana',
   *     }
   * });
   * const bitmapText = new BitmapText({
   *     text: 'Bitmap Styled Text',
   *     style: {
   *         fontName: 'Arial',
   *         fontSize: 32,
   *     }
   * })
   *
   * // Update style dynamically
   * text.style = {
   *     fontSize: 30, // Change font size
   *     fill: 0x00ff00, // Change color to green
   *     align: 'right', // Change alignment to right
   *     stroke: { color: '#000000', width: 2 }, // Add black stroke
   * }
   */
  set style(t) {
    t || (t = {}), this._style?.off("update", this.onViewUpdate, this), t instanceof this._styleClass ? this._style = t : this._style = new this._styleClass(t), this._style.on("update", this.onViewUpdate, this), this.onViewUpdate();
  }
  /**
   * The width of the sprite, setting this will actually modify the scale to achieve the value set.
   * @example
   * ```ts
   * // Set width directly
   * texture.width = 200;
   * console.log(texture.scale.x); // Scale adjusted to match width
   *
   * // For better performance when setting both width and height
   * texture.setSize(300, 400); // Avoids recalculating bounds twice
   * ```
   */
  get width() {
    return Math.abs(this.scale.x) * this.bounds.width;
  }
  set width(t) {
    this._setWidth(t, this.bounds.width);
  }
  /**
   * The height of the sprite, setting this will actually modify the scale to achieve the value set.
   * @example
   * ```ts
   * // Set height directly
   * texture.height = 200;
   * console.log(texture.scale.y); // Scale adjusted to match height
   *
   * // For better performance when setting both width and height
   * texture.setSize(300, 400); // Avoids recalculating bounds twice
   * ```
   */
  get height() {
    return Math.abs(this.scale.y) * this.bounds.height;
  }
  set height(t) {
    this._setHeight(t, this.bounds.height);
  }
  /**
   * Retrieves the size of the Text as a [Size]{@link Size} object based on the texture dimensions and scale.
   * This is faster than getting width and height separately as it only calculates the bounds once.
   * @example
   * ```ts
   * // Basic size retrieval
   * const text = new Text({
   *     text: 'Hello Pixi!',
   *     style: { fontSize: 24 }
   * });
   * const size = text.getSize();
   * console.log(`Size: ${size.width}x${size.height}`);
   *
   * // Reuse existing size object
   * const reuseSize = { width: 0, height: 0 };
   * text.getSize(reuseSize);
   * ```
   * @param out - Optional object to store the size in, to avoid allocating a new object
   * @returns The size of the Sprite
   * @see {@link Text#width} For getting just the width
   * @see {@link Text#height} For getting just the height
   * @see {@link Text#setSize} For setting both width and height
   */
  getSize(t) {
    return t || (t = {}), t.width = Math.abs(this.scale.x) * this.bounds.width, t.height = Math.abs(this.scale.y) * this.bounds.height, t;
  }
  /**
   * Sets the size of the Text to the specified width and height.
   * This is faster than setting width and height separately as it only recalculates bounds once.
   * @example
   * ```ts
   * // Basic size setting
   * const text = new Text({
   *    text: 'Hello Pixi!',
   *    style: { fontSize: 24 }
   * });
   * text.setSize(100, 200); // Width: 100, Height: 200
   *
   * // Set uniform size
   * text.setSize(100); // Sets both width and height to 100
   *
   * // Set size with object
   * text.setSize({
   *     width: 200,
   *     height: 300
   * });
   * ```
   * @param value - This can be either a number or a {@link Size} object
   * @param height - The height to set. Defaults to the value of `width` if not provided
   * @see {@link Text#width} For setting width only
   * @see {@link Text#height} For setting height only
   */
  setSize(t, e) {
    typeof t == "object" ? (e = t.height ?? t.width, t = t.width) : e ?? (e = t), t !== void 0 && this._setWidth(t, this.bounds.width), e !== void 0 && this._setHeight(e, this.bounds.height);
  }
  /**
   * Checks if the object contains the given point in local coordinates.
   * Uses the text's bounds for hit testing.
   * @example
   * ```ts
   * // Basic point check
   * const localPoint = { x: 50, y: 25 };
   * const contains = text.containsPoint(localPoint);
   * console.log('Point is inside:', contains);
   * ```
   * @param point - The point to check in local coordinates
   * @returns True if the point is within the text's bounds
   * @see {@link Container#toLocal} For converting global coordinates to local
   */
  containsPoint(t) {
    const e = this.bounds.width, r = this.bounds.height, n = -e * this.anchor.x;
    let a = 0;
    return t.x >= n && t.x <= n + e && (a = -r * this.anchor.y, t.y >= a && t.y <= a + r);
  }
  /** @internal */
  onViewUpdate() {
    this.didViewUpdate || (this._didTextUpdate = !0), super.onViewUpdate();
  }
  /**
   * Destroys this text renderable and optionally its style texture.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @example
   * // Destroys the text and its style
   * text.destroy({ style: true, texture: true, textureSource: true });
   * text.destroy(true);
   * text.destroy() // Destroys the text, but not its style
   */
  destroy(t = !1) {
    super.destroy(t), this.owner = null, this._bounds = null, this._anchor = null, (typeof t == "boolean" ? t : t?.style) && this._style.destroy(t), this._style = null, this._text = null;
  }
}
function TS(s, t) {
  let e = s[0] ?? {};
  return (typeof e == "string" || s[1]) && (W(K, `use new ${t}({ text: "hi!", style }) instead`), e = {
    text: e,
    style: s[1]
  }), e;
}
let yi = null, Le = null;
function CS(s, t) {
  yi || (yi = Y.get().createCanvas(256, 128), Le = yi.getContext("2d", { willReadFrequently: !0 }), Le.globalCompositeOperation = "copy", Le.globalAlpha = 1), (yi.width < s || yi.height < t) && (yi.width = hr(s), yi.height = hr(t));
}
function Mu(s, t, e) {
  for (let r = 0, n = 4 * e * t; r < t; ++r, n += 4)
    if (s[n + 3] !== 0)
      return !1;
  return !0;
}
function Bu(s, t, e, r, n) {
  const a = 4 * t;
  for (let l = r, h = r * a + 4 * e; l <= n; ++l, h += a)
    if (s[h + 3] !== 0)
      return !1;
  return !0;
}
function ES(...s) {
  let t = s[0];
  t.canvas || (t = { canvas: s[0], resolution: s[1] });
  const { canvas: e } = t, r = Math.min(t.resolution ?? 1, 1), n = t.width ?? e.width, a = t.height ?? e.height;
  let l = t.output;
  if (CS(n, a), !Le)
    throw new TypeError("Failed to get canvas 2D context");
  Le.drawImage(
    e,
    0,
    0,
    n,
    a,
    0,
    0,
    n * r,
    a * r
  );
  const u = Le.getImageData(0, 0, n, a).data;
  let f = 0, p = 0, m = n - 1, g = a - 1;
  for (; p < a && Mu(u, n, p); )
    ++p;
  if (p === a)
    return Z.EMPTY;
  for (; Mu(u, n, g); )
    --g;
  for (; Bu(u, n, f, p, g); )
    ++f;
  for (; Bu(u, n, m, p, g); )
    --m;
  return ++m, ++g, Le.globalCompositeOperation = "source-over", Le.strokeRect(f, p, m - f, g - p), Le.globalCompositeOperation = "copy", l ?? (l = new Z()), l.set(f / r, p / r, (m - f) / r, (g - p) / r), l;
}
const Uu = new Z();
class AS {
  /**
   * Creates a canvas with the specified text rendered to it.
   *
   * Generates a canvas of appropriate size, renders the text with the provided style,
   * and returns both the canvas/context and a Rectangle representing the text bounds.
   *
   * When trim is enabled in the style, the frame will represent the bounds of the
   * non-transparent pixels, which can be smaller than the full canvas.
   * @param options - The options for generating the text canvas
   * @param options.text - The text to render
   * @param options.style - The style to apply to the text
   * @param options.resolution - The resolution of the canvas (defaults to 1)
   * @param options.padding
   * @returns An object containing the canvas/context and the frame (bounds) of the text
   */
  getCanvasAndContext(t) {
    const { text: e, style: r, resolution: n = 1 } = t, a = r._getFinalPadding(), l = me.measureText(e || " ", r), h = Math.ceil(Math.ceil(Math.max(1, l.width) + a * 2) * n), u = Math.ceil(Math.ceil(Math.max(1, l.height) + a * 2) * n), f = oi.getOptimalCanvasAndContext(h, u);
    this._renderTextToCanvas(e, r, a, n, f);
    const p = r.trim ? ES({ canvas: f.canvas, width: h, height: u, resolution: 1, output: Uu }) : Uu.set(0, 0, h, u);
    return {
      canvasAndContext: f,
      frame: p
    };
  }
  /**
   * Returns a canvas and context to the pool.
   *
   * This should be called when you're done with the canvas to allow reuse
   * and prevent memory leaks.
   * @param canvasAndContext - The canvas and context to return to the pool
   */
  returnCanvasAndContext(t) {
    oi.returnCanvasAndContext(t);
  }
  /**
   * Renders text to its canvas, and updates its texture.
   * @param text - The text to render
   * @param style - The style of the text
   * @param padding - The padding of the text
   * @param resolution - The resolution of the text
   * @param canvasAndContext - The canvas and context to render the text to
   */
  _renderTextToCanvas(t, e, r, n, a) {
    const { canvas: l, context: h } = a, u = An(e), f = me.measureText(t || " ", e), p = f.lines, m = f.lineHeight, g = f.lineWidths, x = f.maxLineWidth, o = f.fontProperties, c = l.height;
    if (h.resetTransform(), h.scale(n, n), h.textBaseline = e.textBaseline, e._stroke?.width) {
      const v = e._stroke;
      h.lineWidth = v.width, h.miterLimit = v.miterLimit, h.lineJoin = v.join, h.lineCap = v.cap;
    }
    h.font = u;
    let d, _;
    const y = e.dropShadow ? 2 : 1;
    for (let v = 0; v < y; ++v) {
      const b = e.dropShadow && v === 0, w = b ? Math.ceil(Math.max(1, c) + r * 2) : 0, S = w * n;
      if (b) {
        h.fillStyle = "black", h.strokeStyle = "black";
        const C = e.dropShadow, M = C.color, P = C.alpha;
        h.shadowColor = Q.shared.setValue(M).setAlpha(P).toRgbaString();
        const B = C.blur * n, U = C.distance * n;
        h.shadowBlur = B, h.shadowOffsetX = Math.cos(C.angle) * U, h.shadowOffsetY = Math.sin(C.angle) * U + S;
      } else {
        if (h.fillStyle = e._fill ? Mn(e._fill, h, f) : null, e._stroke?.width) {
          const C = e._stroke.width * e._stroke.alignment;
          h.strokeStyle = Mn(e._stroke, h, f, C);
        }
        h.shadowColor = "black";
      }
      let T = (m - o.fontSize) / 2;
      m - o.fontSize < 0 && (T = 0);
      const E = e._stroke?.width ?? 0;
      for (let C = 0; C < p.length; C++)
        d = E / 2, _ = E / 2 + C * m + o.ascent + T, e.align === "right" ? d += x - g[C] : e.align === "center" && (d += (x - g[C]) / 2), e._stroke?.width && this._drawLetterSpacing(
          p[C],
          e,
          a,
          d + r,
          _ + r - w,
          !0
        ), e._fill !== void 0 && this._drawLetterSpacing(
          p[C],
          e,
          a,
          d + r,
          _ + r - w
        );
    }
  }
  /**
   * Render the text with letter-spacing.
   *
   * This method handles rendering text with the correct letter spacing, using either:
   * 1. Native letter spacing if supported by the browser
   * 2. Manual letter spacing calculation if not natively supported
   *
   * For manual letter spacing, it calculates the position of each character
   * based on its width and the desired spacing.
   * @param text - The text to draw
   * @param style - The text style to apply
   * @param canvasAndContext - The canvas and context to draw to
   * @param x - Horizontal position to draw the text
   * @param y - Vertical position to draw the text
   * @param isStroke - Whether to render the stroke (true) or fill (false)
   * @private
   */
  _drawLetterSpacing(t, e, r, n, a, l = !1) {
    const { context: h } = r, u = e.letterSpacing;
    let f = !1;
    if (me.experimentalLetterSpacingSupported && (me.experimentalLetterSpacing ? (h.letterSpacing = `${u}px`, h.textLetterSpacing = `${u}px`, f = !0) : (h.letterSpacing = "0px", h.textLetterSpacing = "0px")), u === 0 || f) {
      l ? h.strokeText(t, n, a) : h.fillText(t, n, a);
      return;
    }
    let p = n;
    const m = me.graphemeSegmenter(t);
    let g = h.measureText(t).width, x = 0;
    for (let o = 0; o < m.length; ++o) {
      const c = m[o];
      l ? h.strokeText(c, p, a) : h.fillText(c, p, a);
      let d = "";
      for (let _ = o + 1; _ < m.length; ++_)
        d += m[_];
      x = h.measureText(d).width, p += g - x + u, g = x;
    }
  }
}
const Kr = new AS();
class $n extends SS {
  constructor(...t) {
    const e = TS(t, "Text");
    super(e, ce), this.renderPipeId = "text", e.textureStyle && (this.textureStyle = e.textureStyle instanceof $e ? e.textureStyle : new $e(e.textureStyle));
  }
  /** @private */
  updateBounds() {
    const t = this._bounds, e = this._anchor;
    let r = 0, n = 0;
    if (this._style.trim) {
      const { frame: a, canvasAndContext: l } = Kr.getCanvasAndContext({
        text: this.text,
        style: this._style,
        resolution: 1
      });
      Kr.returnCanvasAndContext(l), r = a.width, n = a.height;
    } else {
      const a = me.measureText(
        this._text,
        this._style
      );
      r = a.width, n = a.height;
    }
    t.minX = -e._x * r, t.maxX = t.minX + r, t.minY = -e._y * n, t.maxY = t.minY + n;
  }
}
function PS(s) {
  const t = s._stroke, e = s._fill, n = [`div { ${[
    `color: ${Q.shared.setValue(e.color).toHex()}`,
    `font-size: ${s.fontSize}px`,
    `font-family: ${s.fontFamily}`,
    `font-weight: ${s.fontWeight}`,
    `font-style: ${s.fontStyle}`,
    `font-variant: ${s.fontVariant}`,
    `letter-spacing: ${s.letterSpacing}px`,
    `text-align: ${s.align}`,
    `padding: ${s.padding}px`,
    `white-space: ${s.whiteSpace === "pre" && s.wordWrap ? "pre-wrap" : s.whiteSpace}`,
    ...s.lineHeight ? [`line-height: ${s.lineHeight}px`] : [],
    ...s.wordWrap ? [
      `word-wrap: ${s.breakWords ? "break-all" : "break-word"}`,
      `max-width: ${s.wordWrapWidth}px`
    ] : [],
    ...t ? [__(t)] : [],
    ...s.dropShadow ? [p_(s.dropShadow)] : [],
    ...s.cssOverrides
  ].join(";")} }`];
  return MS(s.tagStyles, n), n.join(" ");
}
function p_(s) {
  const t = Q.shared.setValue(s.color).setAlpha(s.alpha).toHexa(), e = Math.round(Math.cos(s.angle) * s.distance), r = Math.round(Math.sin(s.angle) * s.distance), n = `${e}px ${r}px`;
  return s.blur > 0 ? `text-shadow: ${n} ${s.blur}px ${t}` : `text-shadow: ${n} ${t}`;
}
function __(s) {
  return [
    `-webkit-text-stroke-width: ${s.width}px`,
    `-webkit-text-stroke-color: ${Q.shared.setValue(s.color).toHex()}`,
    `text-stroke-width: ${s.width}px`,
    `text-stroke-color: ${Q.shared.setValue(s.color).toHex()}`,
    "paint-order: stroke"
  ].join(";");
}
const Ru = {
  fontSize: "font-size: {{VALUE}}px",
  fontFamily: "font-family: {{VALUE}}",
  fontWeight: "font-weight: {{VALUE}}",
  fontStyle: "font-style: {{VALUE}}",
  fontVariant: "font-variant: {{VALUE}}",
  letterSpacing: "letter-spacing: {{VALUE}}px",
  align: "text-align: {{VALUE}}",
  padding: "padding: {{VALUE}}px",
  whiteSpace: "white-space: {{VALUE}}",
  lineHeight: "line-height: {{VALUE}}px",
  wordWrapWidth: "max-width: {{VALUE}}px"
}, Iu = {
  fill: (s) => `color: ${Q.shared.setValue(s).toHex()}`,
  breakWords: (s) => `word-wrap: ${s ? "break-all" : "break-word"}`,
  stroke: __,
  dropShadow: p_
};
function MS(s, t) {
  for (const e in s) {
    const r = s[e], n = [];
    for (const a in r)
      Iu[a] ? n.push(Iu[a](r[a])) : Ru[a] && n.push(Ru[a].replace("{{VALUE}}", r[a]));
    t.push(`${e} { ${n.join(";")} }`);
  }
}
class sl extends ce {
  constructor(t = {}) {
    super(t), this._cssOverrides = [], this.cssOverrides = t.cssOverrides ?? [], this.tagStyles = t.tagStyles ?? {};
  }
  /**
   * List of CSS style overrides to apply to the HTML text.
   * These styles are added after the built-in styles and can override any default styling.
   * @advanced
   */
  set cssOverrides(t) {
    this._cssOverrides = t instanceof Array ? t : [t], this.update();
  }
  /** @advanced */
  get cssOverrides() {
    return this._cssOverrides;
  }
  /**
   * Updates the text style and triggers a refresh of the CSS style cache.
   * This method is called automatically when style properties are changed.
   * @example
   * ```ts
   * // Update after multiple changes
   * const text = new HTMLText({
   *     text: 'Hello World',
   *     style
   * });
   *
   * style.fontSize = 32;
   * style.fill = '#00ff00';
   * style.fontFamily = 'Arial';
   * style.update(); // Apply all changes at once
   * ```
   * @advanced
   * @see {@link HTMLTextStyle#cssStyle} For accessing the generated CSS
   * @see {@link HTMLTextStyle#cssOverrides} For managing CSS overrides
   */
  update() {
    this._cssStyle = null, super.update();
  }
  /**
   * Creates a new HTMLTextStyle object with the same values as this one.
   * This creates a deep copy of all style properties, including dropShadow and tag styles.
   * @example
   * ```ts
   * // Create original style
   * const originalStyle = new HTMLTextStyle({
   *     fontSize: 24,
   *     fill: '#ff0000',
   *     tagStyles: {
   *         header: { fontSize: 32, fill: '#00ff00' }
   *     }
   * });
   *
   * // Clone the style
   * const clonedStyle = originalStyle.clone();
   *
   * // Modify cloned style independently
   * clonedStyle.fontSize = 36;
   * clonedStyle.fill = '#0000ff';
   *
   * // Original style remains unchanged
   * console.log(originalStyle.fontSize); // Still 24
   * console.log(originalStyle.fill); // Still '#ff0000'
   * ```
   *
   * Properties that are cloned:
   * - Basic text properties (fontSize, fontFamily, etc.)
   * - Fill and stroke styles
   * - Drop shadow configuration
   * - CSS overrides
   * - Tag styles (deep copied)
   * - Word wrap settings
   * - Alignment and spacing
   * @returns {HTMLTextStyle} A new HTMLTextStyle instance with the same properties
   * @see {@link HTMLTextStyle} For available style properties
   * @see {@link HTMLTextStyle#cssOverrides} For CSS override handling
   * @see {@link HTMLTextStyle#tagStyles} For tag style configuration
   * @standard
   */
  clone() {
    return new sl({
      align: this.align,
      breakWords: this.breakWords,
      dropShadow: this.dropShadow ? { ...this.dropShadow } : null,
      fill: this._fill,
      fontFamily: this.fontFamily,
      fontSize: this.fontSize,
      fontStyle: this.fontStyle,
      fontVariant: this.fontVariant,
      fontWeight: this.fontWeight,
      letterSpacing: this.letterSpacing,
      lineHeight: this.lineHeight,
      padding: this.padding,
      stroke: this._stroke,
      whiteSpace: this.whiteSpace,
      wordWrap: this.wordWrap,
      wordWrapWidth: this.wordWrapWidth,
      cssOverrides: this.cssOverrides,
      tagStyles: { ...this.tagStyles }
    });
  }
  /**
   * The CSS style string that will be applied to the HTML text.
   * @advanced
   */
  get cssStyle() {
    return this._cssStyle || (this._cssStyle = PS(this)), this._cssStyle;
  }
  /**
   * Add a style override, this can be any CSS property
   * it will override any built-in style. This is the
   * property and the value as a string (e.g., `color: red`).
   * This will override any other internal style.
   * @param {string} value - CSS style(s) to add.
   * @example
   * style.addOverride('background-color: red');
   * @advanced
   */
  addOverride(...t) {
    const e = t.filter((r) => !this.cssOverrides.includes(r));
    e.length > 0 && (this.cssOverrides.push(...e), this.update());
  }
  /**
   * Remove any overrides that match the value.
   * @param {string} value - CSS style to remove.
   * @example
   * style.removeOverride('background-color: red');
   * @advanced
   */
  removeOverride(...t) {
    const e = t.filter((r) => this.cssOverrides.includes(r));
    e.length > 0 && (this.cssOverrides = this.cssOverrides.filter((r) => !e.includes(r)), this.update());
  }
  /**
   * Sets the fill style for the text. HTML text only supports color fills (string or number values).
   * Texture fills are not supported and will trigger a warning in debug mode.
   * @example
   * ```ts
   * // Using hex colors
   * const text = new HTMLText({
   *     text: 'Colored Text',
   *     style: {
   *         fill: 0xff0000 // Red color
   *     }
   * });
   *
   * // Using CSS color strings
   * text.style.fill = '#00ff00';     // Hex string (Green)
   * text.style.fill = 'blue';        // Named color
   * text.style.fill = 'rgb(255,0,0)' // RGB
   * text.style.fill = '#f0f';        // Short hex
   *
   * // Invalid usage (will trigger warning in debug)
   * text.style.fill = {
   *     type: 'pattern',
   *     texture: Texture.from('pattern.png')
   * }; // Not supported, falls back to default
   * ```
   * @param value - The fill color to use. Must be a string or number.
   * @throws {Warning} In debug mode when attempting to use unsupported fill types
   * @see {@link TextStyle#fill} For full fill options in canvas text
   * @standard
   */
  set fill(t) {
    typeof t != "string" && typeof t != "number" && N("[HTMLTextStyle] only color fill is not supported by HTMLText"), super.fill = t;
  }
  /**
   * Sets the stroke style for the text. HTML text only supports color strokes (string or number values).
   * Texture strokes are not supported and will trigger a warning in debug mode.
   * @example
   * ```ts
   * // Using hex colors
   * const text = new HTMLText({
   *     text: 'Outlined Text',
   *     style: {
   *         stroke: 0xff0000 // Red outline
   *     }
   * });
   *
   * // Using CSS color strings
   * text.style.stroke = '#00ff00';     // Hex string (Green)
   * text.style.stroke = 'blue';        // Named color
   * text.style.stroke = 'rgb(255,0,0)' // RGB
   * text.style.stroke = '#f0f';        // Short hex
   *
   * // Using stroke width
   * text.style = {
   *     stroke: {
   *         color: '#ff0000',
   *         width: 2
   *     }
   * };
   *
   * // Remove stroke
   * text.style.stroke = null;
   *
   * // Invalid usage (will trigger warning in debug)
   * text.style.stroke = {
   *     type: 'pattern',
   *     texture: Texture.from('pattern.png')
   * }; // Not supported, falls back to default
   * ```
   * @param value - The stroke style to use. Must be a string, number, or stroke configuration object
   * @throws {Warning} In debug mode when attempting to use unsupported stroke types
   * @see {@link TextStyle#stroke} For full stroke options in canvas text
   * @standard
   */
  set stroke(t) {
    t && typeof t != "string" && typeof t != "number" && N("[HTMLTextStyle] only color stroke is not supported by HTMLText"), super.stroke = t;
  }
}
const ku = "http://www.w3.org/2000/svg", Fu = "http://www.w3.org/1999/xhtml";
class m_ {
  constructor() {
    this.svgRoot = document.createElementNS(ku, "svg"), this.foreignObject = document.createElementNS(ku, "foreignObject"), this.domElement = document.createElementNS(Fu, "div"), this.styleElement = document.createElementNS(Fu, "style"), this.image = new Image();
    const { foreignObject: t, svgRoot: e, styleElement: r, domElement: n } = this;
    t.setAttribute("width", "10000"), t.setAttribute("height", "10000"), t.style.overflow = "hidden", e.appendChild(t), t.appendChild(r), t.appendChild(n);
  }
}
let Du;
function BS(s, t, e, r) {
  r || (r = Du || (Du = new m_()));
  const { domElement: n, styleElement: a, svgRoot: l } = r;
  n.innerHTML = `<style>${t.cssStyle};</style><div style='padding:0'>${s}</div>`, n.setAttribute("style", "transform-origin: top left; display: inline-block"), e && (a.textContent = e), document.body.appendChild(l);
  const h = n.getBoundingClientRect();
  l.remove();
  const u = t.padding * 2;
  return {
    width: h.width - u,
    height: h.height - u
  };
}
class g_ {
  constructor() {
    this._tempState = ye.for2d(), this._didUploadHash = {};
  }
  init(t) {
    t.renderer.runners.contextChange.add(this);
  }
  contextChange() {
    this._didUploadHash = {};
  }
  start(t, e, r) {
    const n = t.renderer, a = this._didUploadHash[r.uid];
    n.shader.bind(r, a), a || (this._didUploadHash[r.uid] = !0), n.shader.updateUniformGroup(n.globalUniforms.uniformGroup), n.geometry.bind(e, r.glProgram);
  }
  execute(t, e) {
    const r = t.renderer;
    this._tempState.blendMode = e.blendMode, r.state.set(this._tempState);
    const n = e.textures.textures;
    for (let a = 0; a < e.textures.count; a++)
      r.texture.bind(n[a], a);
    r.geometry.draw(e.topology, e.size, e.start);
  }
}
g_.extension = {
  type: [
    A.WebGLPipesAdaptor
  ],
  name: "batch"
};
const $s = ye.for2d();
class y_ {
  start(t, e, r) {
    const n = t.renderer, a = n.encoder, l = r.gpuProgram;
    this._shader = r, this._geometry = e, a.setGeometry(e, l), $s.blendMode = "normal", n.pipeline.getPipeline(
      e,
      l,
      $s
    );
    const h = n.globalUniforms.bindGroup;
    a.resetBindGroup(1), a.setBindGroup(0, h, l);
  }
  execute(t, e) {
    const r = this._shader.gpuProgram, n = t.renderer, a = n.encoder;
    if (!e.bindGroup) {
      const u = e.textures;
      e.bindGroup = Nh(
        u.textures,
        u.count,
        n.limits.maxBatchableTextures
      );
    }
    $s.blendMode = e.blendMode;
    const l = n.bindGroup.getBindGroup(
      e.bindGroup,
      r,
      1
    ), h = n.pipeline.getPipeline(
      this._geometry,
      r,
      $s,
      e.topology
    );
    e.bindGroup._touch(n.textureGC.count), a.setPipeline(h), a.renderPassEncoder.setBindGroup(1, l), a.renderPassEncoder.drawIndexed(e.size, 1, e.start);
  }
}
y_.extension = {
  type: [
    A.WebGPUPipesAdaptor
  ],
  name: "batch"
};
const nl = class x_ {
  constructor(t, e) {
    this.state = ye.for2d(), this._batchersByInstructionSet = /* @__PURE__ */ Object.create(null), this._activeBatches = /* @__PURE__ */ Object.create(null), this.renderer = t, this._adaptor = e, this._adaptor.init?.(this);
  }
  static getBatcher(t) {
    return new this._availableBatchers[t]();
  }
  buildStart(t) {
    let e = this._batchersByInstructionSet[t.uid];
    e || (e = this._batchersByInstructionSet[t.uid] = /* @__PURE__ */ Object.create(null), e.default || (e.default = new Xh({
      maxTextures: this.renderer.limits.maxBatchableTextures
    }))), this._activeBatches = e, this._activeBatch = this._activeBatches.default;
    for (const r in this._activeBatches)
      this._activeBatches[r].begin();
  }
  addToBatch(t, e) {
    if (this._activeBatch.name !== t.batcherName) {
      this._activeBatch.break(e);
      let r = this._activeBatches[t.batcherName];
      r || (r = this._activeBatches[t.batcherName] = x_.getBatcher(t.batcherName), r.begin()), this._activeBatch = r;
    }
    this._activeBatch.add(t);
  }
  break(t) {
    this._activeBatch.break(t);
  }
  buildEnd(t) {
    this._activeBatch.break(t);
    const e = this._activeBatches;
    for (const r in e) {
      const n = e[r], a = n.geometry;
      a.indexBuffer.setDataWithSize(n.indexBuffer, n.indexSize, !0), a.buffers[0].setDataWithSize(n.attributeBuffer.float32View, n.attributeSize, !1);
    }
  }
  upload(t) {
    const e = this._batchersByInstructionSet[t.uid];
    for (const r in e) {
      const n = e[r], a = n.geometry;
      n.dirty && (n.dirty = !1, a.buffers[0].update(n.attributeSize * 4));
    }
  }
  execute(t) {
    if (t.action === "startBatch") {
      const e = t.batcher, r = e.geometry, n = e.shader;
      this._adaptor.start(this, r, n);
    }
    this._adaptor.execute(this, t);
  }
  destroy() {
    this.state = null, this.renderer = null, this._adaptor = null;
    for (const t in this._activeBatches)
      this._activeBatches[t].destroy();
    this._activeBatches = null;
  }
};
nl.extension = {
  type: [
    A.WebGLPipes,
    A.WebGPUPipes,
    A.CanvasPipes
  ],
  name: "batch"
};
nl._availableBatchers = /* @__PURE__ */ Object.create(null);
let b_ = nl;
L.handleByMap(A.Batcher, b_._availableBatchers);
L.add(Xh);
const qr = {
  name: "local-uniform-bit",
  vertex: {
    header: (
      /* wgsl */
      `

            struct LocalUniforms {
                uTransformMatrix:mat3x3<f32>,
                uColor:vec4<f32>,
                uRound:f32,
            }

            @group(1) @binding(0) var<uniform> localUniforms : LocalUniforms;
        `
    ),
    main: (
      /* wgsl */
      `
            vColor *= localUniforms.uColor;
            modelMatrix *= localUniforms.uTransformMatrix;
        `
    ),
    end: (
      /* wgsl */
      `
            if(localUniforms.uRound == 1)
            {
                vPosition = vec4(roundPixels(vPosition.xy, globalUniforms.uResolution), vPosition.zw);
            }
        `
    )
  }
}, US = {
  ...qr,
  vertex: {
    ...qr.vertex,
    // replace the group!
    header: qr.vertex.header.replace("group(1)", "group(2)")
  }
}, al = {
  name: "local-uniform-bit",
  vertex: {
    header: (
      /* glsl */
      `

            uniform mat3 uTransformMatrix;
            uniform vec4 uColor;
            uniform float uRound;
        `
    ),
    main: (
      /* glsl */
      `
            vColor *= uColor;
            modelMatrix = uTransformMatrix;
        `
    ),
    end: (
      /* glsl */
      `
            if(uRound == 1.)
            {
                gl_Position.xy = roundPixels(gl_Position.xy, uResolution);
            }
        `
    )
  }
}, RS = {
  name: "texture-bit",
  vertex: {
    header: (
      /* wgsl */
      `

        struct TextureUniforms {
            uTextureMatrix:mat3x3<f32>,
        }

        @group(2) @binding(2) var<uniform> textureUniforms : TextureUniforms;
        `
    ),
    main: (
      /* wgsl */
      `
            uv = (textureUniforms.uTextureMatrix * vec3(uv, 1.0)).xy;
        `
    )
  },
  fragment: {
    header: (
      /* wgsl */
      `
            @group(2) @binding(0) var uTexture: texture_2d<f32>;
            @group(2) @binding(1) var uSampler: sampler;


        `
    ),
    main: (
      /* wgsl */
      `
            outColor = textureSample(uTexture, uSampler, vUV);
        `
    )
  }
}, IS = {
  name: "texture-bit",
  vertex: {
    header: (
      /* glsl */
      `
            uniform mat3 uTextureMatrix;
        `
    ),
    main: (
      /* glsl */
      `
            uv = (uTextureMatrix * vec3(uv, 1.0)).xy;
        `
    )
  },
  fragment: {
    header: (
      /* glsl */
      `
        uniform sampler2D uTexture;


        `
    ),
    main: (
      /* glsl */
      `
            outColor = texture(uTexture, vUV);
        `
    )
  }
}, kS = new Ut();
class FS extends wn {
  constructor() {
    super(), this.filters = [new wS({
      sprite: new Be(k.EMPTY),
      inverse: !1,
      resolution: "inherit",
      antialias: "inherit"
    })];
  }
  get sprite() {
    return this.filters[0].sprite;
  }
  set sprite(t) {
    this.filters[0].sprite = t;
  }
  get inverse() {
    return this.filters[0].inverse;
  }
  set inverse(t) {
    this.filters[0].inverse = t;
  }
}
class v_ {
  constructor(t) {
    this._activeMaskStage = [], this._renderer = t;
  }
  push(t, e, r) {
    const n = this._renderer;
    if (n.renderPipes.batch.break(r), r.add({
      renderPipeId: "alphaMask",
      action: "pushMaskBegin",
      mask: t,
      inverse: e._maskOptions.inverse,
      canBundle: !1,
      maskedContainer: e
    }), t.inverse = e._maskOptions.inverse, t.renderMaskToTexture) {
      const a = t.mask;
      a.includeInBuild = !0, a.collectRenderables(
        r,
        n,
        null
      ), a.includeInBuild = !1;
    }
    n.renderPipes.batch.break(r), r.add({
      renderPipeId: "alphaMask",
      action: "pushMaskEnd",
      mask: t,
      maskedContainer: e,
      inverse: e._maskOptions.inverse,
      canBundle: !1
    });
  }
  pop(t, e, r) {
    this._renderer.renderPipes.batch.break(r), r.add({
      renderPipeId: "alphaMask",
      action: "popMaskEnd",
      mask: t,
      inverse: e._maskOptions.inverse,
      canBundle: !1
    });
  }
  execute(t) {
    const e = this._renderer, r = t.mask.renderMaskToTexture;
    if (t.action === "pushMaskBegin") {
      const n = Ct.get(FS);
      if (n.inverse = t.inverse, r) {
        t.mask.mask.measurable = !0;
        const a = Uh(t.mask.mask, !0, kS);
        t.mask.mask.measurable = !1, a.ceil();
        const l = e.renderTarget.renderTarget.colorTexture.source, h = At.getOptimalTexture(
          a.width,
          a.height,
          l._resolution,
          l.antialias
        );
        e.renderTarget.push(h, !0), e.globalUniforms.push({
          offset: a,
          worldColor: 4294967295
        });
        const u = n.sprite;
        u.texture = h, u.worldTransform.tx = a.minX, u.worldTransform.ty = a.minY, this._activeMaskStage.push({
          filterEffect: n,
          maskedContainer: t.maskedContainer,
          filterTexture: h
        });
      } else
        n.sprite = t.mask.mask, this._activeMaskStage.push({
          filterEffect: n,
          maskedContainer: t.maskedContainer
        });
    } else if (t.action === "pushMaskEnd") {
      const n = this._activeMaskStage[this._activeMaskStage.length - 1];
      r && (e.type === ge.WEBGL && e.renderTarget.finishRenderPass(), e.renderTarget.pop(), e.globalUniforms.pop()), e.filter.push({
        renderPipeId: "filter",
        action: "pushFilter",
        container: n.maskedContainer,
        filterEffect: n.filterEffect,
        canBundle: !1
      });
    } else if (t.action === "popMaskEnd") {
      e.filter.pop();
      const n = this._activeMaskStage.pop();
      r && At.returnTexture(n.filterTexture), Ct.return(n.filterEffect);
    }
  }
  destroy() {
    this._renderer = null, this._activeMaskStage = null;
  }
}
v_.extension = {
  type: [
    A.WebGLPipes,
    A.WebGPUPipes,
    A.CanvasPipes
  ],
  name: "alphaMask"
};
class w_ {
  constructor(t) {
    this._colorStack = [], this._colorStackIndex = 0, this._currentColor = 0, this._renderer = t;
  }
  buildStart() {
    this._colorStack[0] = 15, this._colorStackIndex = 1, this._currentColor = 15;
  }
  push(t, e, r) {
    this._renderer.renderPipes.batch.break(r);
    const a = this._colorStack;
    a[this._colorStackIndex] = a[this._colorStackIndex - 1] & t.mask;
    const l = this._colorStack[this._colorStackIndex];
    l !== this._currentColor && (this._currentColor = l, r.add({
      renderPipeId: "colorMask",
      colorMask: l,
      canBundle: !1
    })), this._colorStackIndex++;
  }
  pop(t, e, r) {
    this._renderer.renderPipes.batch.break(r);
    const a = this._colorStack;
    this._colorStackIndex--;
    const l = a[this._colorStackIndex - 1];
    l !== this._currentColor && (this._currentColor = l, r.add({
      renderPipeId: "colorMask",
      colorMask: l,
      canBundle: !1
    }));
  }
  execute(t) {
    this._renderer.colorMask.setMask(t.colorMask);
  }
  destroy() {
    this._colorStack = null;
  }
}
w_.extension = {
  type: [
    A.WebGLPipes,
    A.WebGPUPipes,
    A.CanvasPipes
  ],
  name: "colorMask"
};
class S_ {
  constructor(t) {
    this._maskStackHash = {}, this._maskHash = /* @__PURE__ */ new WeakMap(), this._renderer = t;
  }
  push(t, e, r) {
    var n;
    const a = t, l = this._renderer;
    l.renderPipes.batch.break(r), l.renderPipes.blendMode.setBlendMode(a.mask, "none", r), r.add({
      renderPipeId: "stencilMask",
      action: "pushMaskBegin",
      mask: t,
      inverse: e._maskOptions.inverse,
      canBundle: !1
    });
    const h = a.mask;
    h.includeInBuild = !0, this._maskHash.has(a) || this._maskHash.set(a, {
      instructionsStart: 0,
      instructionsLength: 0
    });
    const u = this._maskHash.get(a);
    u.instructionsStart = r.instructionSize, h.collectRenderables(
      r,
      l,
      null
    ), h.includeInBuild = !1, l.renderPipes.batch.break(r), r.add({
      renderPipeId: "stencilMask",
      action: "pushMaskEnd",
      mask: t,
      inverse: e._maskOptions.inverse,
      canBundle: !1
    });
    const f = r.instructionSize - u.instructionsStart - 1;
    u.instructionsLength = f;
    const p = l.renderTarget.renderTarget.uid;
    (n = this._maskStackHash)[p] ?? (n[p] = 0);
  }
  pop(t, e, r) {
    const n = t, a = this._renderer;
    a.renderPipes.batch.break(r), a.renderPipes.blendMode.setBlendMode(n.mask, "none", r), r.add({
      renderPipeId: "stencilMask",
      action: "popMaskBegin",
      inverse: e._maskOptions.inverse,
      canBundle: !1
    });
    const l = this._maskHash.get(t);
    for (let h = 0; h < l.instructionsLength; h++)
      r.instructions[r.instructionSize++] = r.instructions[l.instructionsStart++];
    r.add({
      renderPipeId: "stencilMask",
      action: "popMaskEnd",
      canBundle: !1
    });
  }
  execute(t) {
    var e;
    const r = this._renderer, n = r.renderTarget.renderTarget.uid;
    let a = (e = this._maskStackHash)[n] ?? (e[n] = 0);
    t.action === "pushMaskBegin" ? (r.renderTarget.ensureDepthStencil(), r.stencil.setStencilMode(ft.RENDERING_MASK_ADD, a), a++, r.colorMask.setMask(0)) : t.action === "pushMaskEnd" ? (t.inverse ? r.stencil.setStencilMode(ft.INVERSE_MASK_ACTIVE, a) : r.stencil.setStencilMode(ft.MASK_ACTIVE, a), r.colorMask.setMask(15)) : t.action === "popMaskBegin" ? (r.colorMask.setMask(0), a !== 0 ? r.stencil.setStencilMode(ft.RENDERING_MASK_REMOVE, a) : (r.renderTarget.clear(null, Xt.STENCIL), r.stencil.setStencilMode(ft.DISABLED, a)), a--) : t.action === "popMaskEnd" && (t.inverse ? r.stencil.setStencilMode(ft.INVERSE_MASK_ACTIVE, a) : r.stencil.setStencilMode(ft.MASK_ACTIVE, a), r.colorMask.setMask(15)), this._maskStackHash[n] = a;
  }
  destroy() {
    this._renderer = null, this._maskStackHash = null, this._maskHash = null;
  }
}
S_.extension = {
  type: [
    A.WebGLPipes,
    A.WebGPUPipes,
    A.CanvasPipes
  ],
  name: "stencilMask"
};
var on = /* @__PURE__ */ ((s) => (s[s.ELEMENT_ARRAY_BUFFER = 34963] = "ELEMENT_ARRAY_BUFFER", s[s.ARRAY_BUFFER = 34962] = "ARRAY_BUFFER", s[s.UNIFORM_BUFFER = 35345] = "UNIFORM_BUFFER", s))(on || {});
class DS {
  constructor(t, e) {
    this._lastBindBaseLocation = -1, this._lastBindCallId = -1, this.buffer = t || null, this.updateID = -1, this.byteLength = -1, this.type = e;
  }
}
class T_ {
  /**
   * @param {Renderer} renderer - The renderer this System works for.
   */
  constructor(t) {
    this._gpuBuffers = /* @__PURE__ */ Object.create(null), this._boundBufferBases = /* @__PURE__ */ Object.create(null), this._minBaseLocation = 0, this._nextBindBaseIndex = this._minBaseLocation, this._bindCallId = 0, this._renderer = t, this._renderer.renderableGC.addManagedHash(this, "_gpuBuffers");
  }
  /** @ignore */
  destroy() {
    this._renderer = null, this._gl = null, this._gpuBuffers = null, this._boundBufferBases = null;
  }
  /** Sets up the renderer context and necessary buffers. */
  contextChange() {
    this._gl = this._renderer.gl, this._gpuBuffers = /* @__PURE__ */ Object.create(null), this._maxBindings = this._renderer.limits.maxUniformBindings;
  }
  getGlBuffer(t) {
    return this._gpuBuffers[t.uid] || this.createGLBuffer(t);
  }
  /**
   * This binds specified buffer. On first run, it will create the webGL buffers for the context too
   * @param buffer - the buffer to bind to the renderer
   */
  bind(t) {
    const { _gl: e } = this, r = this.getGlBuffer(t);
    e.bindBuffer(r.type, r.buffer);
  }
  /**
   * Binds an uniform buffer to at the given index.
   *
   * A cache is used so a buffer will not be bound again if already bound.
   * @param glBuffer - the buffer to bind
   * @param index - the base index to bind it to.
   */
  bindBufferBase(t, e) {
    const { _gl: r } = this;
    this._boundBufferBases[e] !== t && (this._boundBufferBases[e] = t, t._lastBindBaseLocation = e, r.bindBufferBase(r.UNIFORM_BUFFER, e, t.buffer));
  }
  nextBindBase(t) {
    this._bindCallId++, this._minBaseLocation = 0, t && (this._boundBufferBases[0] = null, this._minBaseLocation = 1, this._nextBindBaseIndex < 1 && (this._nextBindBaseIndex = 1));
  }
  freeLocationForBufferBase(t) {
    let e = this.getLastBindBaseLocation(t);
    if (e >= this._minBaseLocation)
      return t._lastBindCallId = this._bindCallId, e;
    let r = 0, n = this._nextBindBaseIndex;
    for (; r < 2; ) {
      n >= this._maxBindings && (n = this._minBaseLocation, r++);
      const a = this._boundBufferBases[n];
      if (a && a._lastBindCallId === this._bindCallId) {
        n++;
        continue;
      }
      break;
    }
    return e = n, this._nextBindBaseIndex = n + 1, r >= 2 ? -1 : (t._lastBindCallId = this._bindCallId, this._boundBufferBases[e] = null, e);
  }
  getLastBindBaseLocation(t) {
    const e = t._lastBindBaseLocation;
    return this._boundBufferBases[e] === t ? e : -1;
  }
  /**
   * Binds a buffer whilst also binding its range.
   * This will make the buffer start from the offset supplied rather than 0 when it is read.
   * @param glBuffer - the buffer to bind
   * @param index - the base index to bind at, defaults to 0
   * @param offset - the offset to bind at (this is blocks of 256). 0 = 0, 1 = 256, 2 = 512 etc
   * @param size - the size to bind at (this is blocks of 256).
   */
  bindBufferRange(t, e, r, n) {
    const { _gl: a } = this;
    r || (r = 0), e || (e = 0), this._boundBufferBases[e] = null, a.bindBufferRange(a.UNIFORM_BUFFER, e || 0, t.buffer, r * 256, n || 256);
  }
  /**
   * Will ensure the data in the buffer is uploaded to the GPU.
   * @param {Buffer} buffer - the buffer to update
   */
  updateBuffer(t) {
    const { _gl: e } = this, r = this.getGlBuffer(t);
    if (t._updateID === r.updateID)
      return r;
    r.updateID = t._updateID, e.bindBuffer(r.type, r.buffer);
    const n = t.data, a = t.descriptor.usage & X.STATIC ? e.STATIC_DRAW : e.DYNAMIC_DRAW;
    return n ? r.byteLength >= n.byteLength ? e.bufferSubData(r.type, 0, n, 0, t._updateSize / n.BYTES_PER_ELEMENT) : (r.byteLength = n.byteLength, e.bufferData(r.type, n, a)) : (r.byteLength = t.descriptor.size, e.bufferData(r.type, r.byteLength, a)), r;
  }
  /** dispose all WebGL resources of all managed buffers */
  destroyAll() {
    const t = this._gl;
    for (const e in this._gpuBuffers)
      t.deleteBuffer(this._gpuBuffers[e].buffer);
    this._gpuBuffers = /* @__PURE__ */ Object.create(null);
  }
  /**
   * Disposes buffer
   * @param {Buffer} buffer - buffer with data
   * @param {boolean} [contextLost=false] - If context was lost, we suppress deleteVertexArray
   */
  onBufferDestroy(t, e) {
    const r = this._gpuBuffers[t.uid], n = this._gl;
    e || n.deleteBuffer(r.buffer), this._gpuBuffers[t.uid] = null;
  }
  /**
   * creates and attaches a GLBuffer object tied to the current context.
   * @param buffer
   * @protected
   */
  createGLBuffer(t) {
    const { _gl: e } = this;
    let r = on.ARRAY_BUFFER;
    t.descriptor.usage & X.INDEX ? r = on.ELEMENT_ARRAY_BUFFER : t.descriptor.usage & X.UNIFORM && (r = on.UNIFORM_BUFFER);
    const n = new DS(e.createBuffer(), r);
    return this._gpuBuffers[t.uid] = n, t.on("destroy", this.onBufferDestroy, this), n;
  }
  resetState() {
    this._boundBufferBases = /* @__PURE__ */ Object.create(null);
  }
}
T_.extension = {
  type: [
    A.WebGLSystem
  ],
  name: "buffer"
};
const ol = class C_ {
  /** @param renderer - The renderer this System works for. */
  constructor(t) {
    this.supports = {
      /** Support for 32-bit indices buffer. */
      uint32Indices: !0,
      /** Support for UniformBufferObjects */
      uniformBufferObject: !0,
      /** Support for VertexArrayObjects */
      vertexArrayObject: !0,
      /** Support for SRGB texture format */
      srgbTextures: !0,
      /** Support for wrapping modes if a texture is non-power of two */
      nonPowOf2wrapping: !0,
      /** Support for MSAA (antialiasing of dynamic textures) */
      msaa: !0,
      /** Support for mipmaps if a texture is non-power of two */
      nonPowOf2mipmaps: !0
    }, this._renderer = t, this.extensions = /* @__PURE__ */ Object.create(null), this.handleContextLost = this.handleContextLost.bind(this), this.handleContextRestored = this.handleContextRestored.bind(this);
  }
  /**
   * `true` if the context is lost
   * @readonly
   */
  get isLost() {
    return !this.gl || this.gl.isContextLost();
  }
  /**
   * Handles the context change event.
   * @param {WebGLRenderingContext} gl - New WebGL context.
   */
  contextChange(t) {
    this.gl = t, this._renderer.gl = t;
  }
  init(t) {
    t = { ...C_.defaultOptions, ...t };
    let e = this.multiView = t.multiView;
    if (t.context && e && (N("Renderer created with both a context and multiview enabled. Disabling multiView as both cannot work together."), e = !1), e ? this.canvas = Y.get().createCanvas(this._renderer.canvas.width, this._renderer.canvas.height) : this.canvas = this._renderer.view.canvas, t.context)
      this.initFromContext(t.context);
    else {
      const r = this._renderer.background.alpha < 1, n = t.premultipliedAlpha ?? !0, a = t.antialias && !this._renderer.backBuffer.useBackBuffer;
      this.createContext(t.preferWebGLVersion, {
        alpha: r,
        premultipliedAlpha: n,
        antialias: a,
        stencil: !0,
        preserveDrawingBuffer: t.preserveDrawingBuffer,
        powerPreference: t.powerPreference ?? "default"
      });
    }
  }
  ensureCanvasSize(t) {
    if (!this.multiView) {
      t !== this.canvas && N("multiView is disabled, but targetCanvas is not the main canvas");
      return;
    }
    const { canvas: e } = this;
    (e.width < t.width || e.height < t.height) && (e.width = Math.max(t.width, t.width), e.height = Math.max(t.height, t.height));
  }
  /**
   * Initializes the context.
   * @protected
   * @param {WebGLRenderingContext} gl - WebGL context
   */
  initFromContext(t) {
    this.gl = t, this.webGLVersion = t instanceof Y.get().getWebGLRenderingContext() ? 1 : 2, this.getExtensions(), this.validateContext(t), this._renderer.runners.contextChange.emit(t);
    const e = this._renderer.view.canvas;
    e.addEventListener("webglcontextlost", this.handleContextLost, !1), e.addEventListener("webglcontextrestored", this.handleContextRestored, !1);
  }
  /**
   * Initialize from context options
   * @protected
   * @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/getContext
   * @param preferWebGLVersion
   * @param {object} options - context attributes
   */
  createContext(t, e) {
    let r;
    const n = this.canvas;
    if (t === 2 && (r = n.getContext("webgl2", e)), !r && (r = n.getContext("webgl", e), !r))
      throw new Error("This browser does not support WebGL. Try using the canvas renderer");
    this.gl = r, this.initFromContext(this.gl);
  }
  /** Auto-populate the {@link GlContextSystem.extensions extensions}. */
  getExtensions() {
    const { gl: t } = this, e = {
      anisotropicFiltering: t.getExtension("EXT_texture_filter_anisotropic"),
      floatTextureLinear: t.getExtension("OES_texture_float_linear"),
      s3tc: t.getExtension("WEBGL_compressed_texture_s3tc"),
      s3tc_sRGB: t.getExtension("WEBGL_compressed_texture_s3tc_srgb"),
      // eslint-disable-line camelcase
      etc: t.getExtension("WEBGL_compressed_texture_etc"),
      etc1: t.getExtension("WEBGL_compressed_texture_etc1"),
      pvrtc: t.getExtension("WEBGL_compressed_texture_pvrtc") || t.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc"),
      atc: t.getExtension("WEBGL_compressed_texture_atc"),
      astc: t.getExtension("WEBGL_compressed_texture_astc"),
      bptc: t.getExtension("EXT_texture_compression_bptc"),
      rgtc: t.getExtension("EXT_texture_compression_rgtc"),
      loseContext: t.getExtension("WEBGL_lose_context")
    };
    if (this.webGLVersion === 1)
      this.extensions = {
        ...e,
        drawBuffers: t.getExtension("WEBGL_draw_buffers"),
        depthTexture: t.getExtension("WEBGL_depth_texture"),
        vertexArrayObject: t.getExtension("OES_vertex_array_object") || t.getExtension("MOZ_OES_vertex_array_object") || t.getExtension("WEBKIT_OES_vertex_array_object"),
        uint32ElementIndex: t.getExtension("OES_element_index_uint"),
        // Floats and half-floats
        floatTexture: t.getExtension("OES_texture_float"),
        floatTextureLinear: t.getExtension("OES_texture_float_linear"),
        textureHalfFloat: t.getExtension("OES_texture_half_float"),
        textureHalfFloatLinear: t.getExtension("OES_texture_half_float_linear"),
        vertexAttribDivisorANGLE: t.getExtension("ANGLE_instanced_arrays"),
        srgb: t.getExtension("EXT_sRGB")
      };
    else {
      this.extensions = {
        ...e,
        colorBufferFloat: t.getExtension("EXT_color_buffer_float")
      };
      const r = t.getExtension("WEBGL_provoking_vertex");
      r && r.provokingVertexWEBGL(r.FIRST_VERTEX_CONVENTION_WEBGL);
    }
  }
  /**
   * Handles a lost webgl context
   * @param {WebGLContextEvent} event - The context lost event.
   */
  handleContextLost(t) {
    t.preventDefault(), this._contextLossForced && (this._contextLossForced = !1, setTimeout(() => {
      this.gl.isContextLost() && this.extensions.loseContext?.restoreContext();
    }, 0));
  }
  /** Handles a restored webgl context. */
  handleContextRestored() {
    this.getExtensions(), this._renderer.runners.contextChange.emit(this.gl);
  }
  destroy() {
    const t = this._renderer.view.canvas;
    this._renderer = null, t.removeEventListener("webglcontextlost", this.handleContextLost), t.removeEventListener("webglcontextrestored", this.handleContextRestored), this.gl.useProgram(null), this.extensions.loseContext?.loseContext();
  }
  /**
   * this function can be called to force a webGL context loss
   * this will release all resources on the GPU.
   * Useful if you need to put Pixi to sleep, and save some GPU memory
   *
   * As soon as render is called - all resources will be created again.
   */
  forceContextLoss() {
    this.extensions.loseContext?.loseContext(), this._contextLossForced = !0;
  }
  /**
   * Validate context.
   * @param {WebGLRenderingContext} gl - Render context.
   */
  validateContext(t) {
    const e = t.getContextAttributes();
    e && !e.stencil && N("Provided WebGL context does not have a stencil buffer, masks may not render correctly");
    const r = this.supports, n = this.webGLVersion === 2, a = this.extensions;
    r.uint32Indices = n || !!a.uint32ElementIndex, r.uniformBufferObject = n, r.vertexArrayObject = n || !!a.vertexArrayObject, r.srgbTextures = n || !!a.srgb, r.nonPowOf2wrapping = n, r.nonPowOf2mipmaps = n, r.msaa = n, r.uint32Indices || N("Provided WebGL context does not support 32 index buffer, large scenes may not render correctly");
  }
};
ol.extension = {
  type: [
    A.WebGLSystem
  ],
  name: "context"
};
ol.defaultOptions = {
  /**
   * {@link WebGLOptions.context}
   * @default null
   */
  context: null,
  /**
   * {@link WebGLOptions.premultipliedAlpha}
   * @default true
   */
  premultipliedAlpha: !0,
  /**
   * {@link WebGLOptions.preserveDrawingBuffer}
   * @default false
   */
  preserveDrawingBuffer: !1,
  /**
   * {@link WebGLOptions.powerPreference}
   * @default default
   */
  powerPreference: void 0,
  /**
   * {@link WebGLOptions.webGLVersion}
   * @default 2
   */
  preferWebGLVersion: 2,
  /**
   * {@link WebGLOptions.multiView}
   * @default false
   */
  multiView: !1
};
let OS = ol;
function E_(s, t) {
  for (const e in s.attributes) {
    const r = s.attributes[e], n = t[e];
    n ? (r.format ?? (r.format = n.format), r.offset ?? (r.offset = n.offset), r.instance ?? (r.instance = n.instance)) : N(`Attribute ${e} is not present in the shader, but is present in the geometry. Unable to infer attribute details.`);
  }
  LS(s);
}
function LS(s) {
  const { buffers: t, attributes: e } = s, r = {}, n = {};
  for (const a in t) {
    const l = t[a];
    r[l.uid] = 0, n[l.uid] = 0;
  }
  for (const a in e) {
    const l = e[a];
    r[l.buffer.uid] += ai(l.format).stride;
  }
  for (const a in e) {
    const l = e[a];
    l.stride ?? (l.stride = r[l.buffer.uid]), l.start ?? (l.start = n[l.buffer.uid]), n[l.buffer.uid] += ai(l.format).stride;
  }
}
var Ko = /* @__PURE__ */ ((s) => (s[s.RGBA = 6408] = "RGBA", s[s.RGB = 6407] = "RGB", s[s.RG = 33319] = "RG", s[s.RED = 6403] = "RED", s[s.RGBA_INTEGER = 36249] = "RGBA_INTEGER", s[s.RGB_INTEGER = 36248] = "RGB_INTEGER", s[s.RG_INTEGER = 33320] = "RG_INTEGER", s[s.RED_INTEGER = 36244] = "RED_INTEGER", s[s.ALPHA = 6406] = "ALPHA", s[s.LUMINANCE = 6409] = "LUMINANCE", s[s.LUMINANCE_ALPHA = 6410] = "LUMINANCE_ALPHA", s[s.DEPTH_COMPONENT = 6402] = "DEPTH_COMPONENT", s[s.DEPTH_STENCIL = 34041] = "DEPTH_STENCIL", s))(Ko || {}), A_ = /* @__PURE__ */ ((s) => (s[s.TEXTURE_2D = 3553] = "TEXTURE_2D", s[s.TEXTURE_CUBE_MAP = 34067] = "TEXTURE_CUBE_MAP", s[s.TEXTURE_2D_ARRAY = 35866] = "TEXTURE_2D_ARRAY", s[s.TEXTURE_CUBE_MAP_POSITIVE_X = 34069] = "TEXTURE_CUBE_MAP_POSITIVE_X", s[s.TEXTURE_CUBE_MAP_NEGATIVE_X = 34070] = "TEXTURE_CUBE_MAP_NEGATIVE_X", s[s.TEXTURE_CUBE_MAP_POSITIVE_Y = 34071] = "TEXTURE_CUBE_MAP_POSITIVE_Y", s[s.TEXTURE_CUBE_MAP_NEGATIVE_Y = 34072] = "TEXTURE_CUBE_MAP_NEGATIVE_Y", s[s.TEXTURE_CUBE_MAP_POSITIVE_Z = 34073] = "TEXTURE_CUBE_MAP_POSITIVE_Z", s[s.TEXTURE_CUBE_MAP_NEGATIVE_Z = 34074] = "TEXTURE_CUBE_MAP_NEGATIVE_Z", s))(A_ || {}), j = /* @__PURE__ */ ((s) => (s[s.UNSIGNED_BYTE = 5121] = "UNSIGNED_BYTE", s[s.UNSIGNED_SHORT = 5123] = "UNSIGNED_SHORT", s[s.UNSIGNED_SHORT_5_6_5 = 33635] = "UNSIGNED_SHORT_5_6_5", s[s.UNSIGNED_SHORT_4_4_4_4 = 32819] = "UNSIGNED_SHORT_4_4_4_4", s[s.UNSIGNED_SHORT_5_5_5_1 = 32820] = "UNSIGNED_SHORT_5_5_5_1", s[s.UNSIGNED_INT = 5125] = "UNSIGNED_INT", s[s.UNSIGNED_INT_10F_11F_11F_REV = 35899] = "UNSIGNED_INT_10F_11F_11F_REV", s[s.UNSIGNED_INT_2_10_10_10_REV = 33640] = "UNSIGNED_INT_2_10_10_10_REV", s[s.UNSIGNED_INT_24_8 = 34042] = "UNSIGNED_INT_24_8", s[s.UNSIGNED_INT_5_9_9_9_REV = 35902] = "UNSIGNED_INT_5_9_9_9_REV", s[s.BYTE = 5120] = "BYTE", s[s.SHORT = 5122] = "SHORT", s[s.INT = 5124] = "INT", s[s.FLOAT = 5126] = "FLOAT", s[s.FLOAT_32_UNSIGNED_INT_24_8_REV = 36269] = "FLOAT_32_UNSIGNED_INT_24_8_REV", s[s.HALF_FLOAT = 36193] = "HALF_FLOAT", s))(j || {});
const Ou = {
  uint8x2: j.UNSIGNED_BYTE,
  uint8x4: j.UNSIGNED_BYTE,
  sint8x2: j.BYTE,
  sint8x4: j.BYTE,
  unorm8x2: j.UNSIGNED_BYTE,
  unorm8x4: j.UNSIGNED_BYTE,
  snorm8x2: j.BYTE,
  snorm8x4: j.BYTE,
  uint16x2: j.UNSIGNED_SHORT,
  uint16x4: j.UNSIGNED_SHORT,
  sint16x2: j.SHORT,
  sint16x4: j.SHORT,
  unorm16x2: j.UNSIGNED_SHORT,
  unorm16x4: j.UNSIGNED_SHORT,
  snorm16x2: j.SHORT,
  snorm16x4: j.SHORT,
  float16x2: j.HALF_FLOAT,
  float16x4: j.HALF_FLOAT,
  float32: j.FLOAT,
  float32x2: j.FLOAT,
  float32x3: j.FLOAT,
  float32x4: j.FLOAT,
  uint32: j.UNSIGNED_INT,
  uint32x2: j.UNSIGNED_INT,
  uint32x3: j.UNSIGNED_INT,
  uint32x4: j.UNSIGNED_INT,
  sint32: j.INT,
  sint32x2: j.INT,
  sint32x3: j.INT,
  sint32x4: j.INT
};
function GS(s) {
  return Ou[s] ?? Ou.float32;
}
const zS = {
  "point-list": 0,
  "line-list": 1,
  "line-strip": 3,
  "triangle-list": 4,
  "triangle-strip": 5
};
class P_ {
  /** @param renderer - The renderer this System works for. */
  constructor(t) {
    this._geometryVaoHash = /* @__PURE__ */ Object.create(null), this._renderer = t, this._activeGeometry = null, this._activeVao = null, this.hasVao = !0, this.hasInstance = !0, this._renderer.renderableGC.addManagedHash(this, "_geometryVaoHash");
  }
  /** Sets up the renderer context and necessary buffers. */
  contextChange() {
    const t = this.gl = this._renderer.gl;
    if (!this._renderer.context.supports.vertexArrayObject)
      throw new Error("[PixiJS] Vertex Array Objects are not supported on this device");
    const e = this._renderer.context.extensions.vertexArrayObject;
    e && (t.createVertexArray = () => e.createVertexArrayOES(), t.bindVertexArray = (n) => e.bindVertexArrayOES(n), t.deleteVertexArray = (n) => e.deleteVertexArrayOES(n));
    const r = this._renderer.context.extensions.vertexAttribDivisorANGLE;
    r && (t.drawArraysInstanced = (n, a, l, h) => {
      r.drawArraysInstancedANGLE(n, a, l, h);
    }, t.drawElementsInstanced = (n, a, l, h, u) => {
      r.drawElementsInstancedANGLE(n, a, l, h, u);
    }, t.vertexAttribDivisor = (n, a) => r.vertexAttribDivisorANGLE(n, a)), this._activeGeometry = null, this._activeVao = null, this._geometryVaoHash = /* @__PURE__ */ Object.create(null);
  }
  /**
   * Binds geometry so that is can be drawn. Creating a Vao if required
   * @param geometry - Instance of geometry to bind.
   * @param program - Instance of program to use vao for.
   */
  bind(t, e) {
    const r = this.gl;
    this._activeGeometry = t;
    const n = this.getVao(t, e);
    this._activeVao !== n && (this._activeVao = n, r.bindVertexArray(n)), this.updateBuffers();
  }
  /** Reset and unbind any active VAO and geometry. */
  resetState() {
    this.unbind();
  }
  /** Update buffers of the currently bound geometry. */
  updateBuffers() {
    const t = this._activeGeometry, e = this._renderer.buffer;
    for (let r = 0; r < t.buffers.length; r++) {
      const n = t.buffers[r];
      e.updateBuffer(n);
    }
  }
  /**
   * Check compatibility between a geometry and a program
   * @param geometry - Geometry instance.
   * @param program - Program instance.
   */
  checkCompatibility(t, e) {
    const r = t.attributes, n = e._attributeData;
    for (const a in n)
      if (!r[a])
        throw new Error(`shader and geometry incompatible, geometry missing the "${a}" attribute`);
  }
  /**
   * Takes a geometry and program and generates a unique signature for them.
   * @param geometry - To get signature from.
   * @param program - To test geometry against.
   * @returns - Unique signature of the geometry and program
   */
  getSignature(t, e) {
    const r = t.attributes, n = e._attributeData, a = ["g", t.uid];
    for (const l in r)
      n[l] && a.push(l, n[l].location);
    return a.join("-");
  }
  getVao(t, e) {
    return this._geometryVaoHash[t.uid]?.[e._key] || this.initGeometryVao(t, e);
  }
  /**
   * Creates or gets Vao with the same structure as the geometry and stores it on the geometry.
   * If vao is created, it is bound automatically. We use a shader to infer what and how to set up the
   * attribute locations.
   * @param geometry - Instance of geometry to to generate Vao for.
   * @param program
   * @param _incRefCount - Increment refCount of all geometry buffers.
   */
  initGeometryVao(t, e, r = !0) {
    const n = this._renderer.gl, a = this._renderer.buffer;
    this._renderer.shader._getProgramData(e), this.checkCompatibility(t, e);
    const l = this.getSignature(t, e);
    this._geometryVaoHash[t.uid] || (this._geometryVaoHash[t.uid] = /* @__PURE__ */ Object.create(null), t.on("destroy", this.onGeometryDestroy, this));
    const h = this._geometryVaoHash[t.uid];
    let u = h[l];
    if (u)
      return h[e._key] = u, u;
    E_(t, e._attributeData);
    const f = t.buffers;
    u = n.createVertexArray(), n.bindVertexArray(u);
    for (let p = 0; p < f.length; p++) {
      const m = f[p];
      a.bind(m);
    }
    return this.activateVao(t, e), h[e._key] = u, h[l] = u, n.bindVertexArray(null), u;
  }
  /**
   * Disposes geometry.
   * @param geometry - Geometry with buffers. Only VAO will be disposed
   * @param [contextLost=false] - If context was lost, we suppress deleteVertexArray
   */
  onGeometryDestroy(t, e) {
    const r = this._geometryVaoHash[t.uid], n = this.gl;
    if (r) {
      if (e)
        for (const a in r)
          this._activeVao !== r[a] && this.unbind(), n.deleteVertexArray(r[a]);
      this._geometryVaoHash[t.uid] = null;
    }
  }
  /**
   * Dispose all WebGL resources of all managed geometries.
   * @param [contextLost=false] - If context was lost, we suppress `gl.delete` calls
   */
  destroyAll(t = !1) {
    const e = this.gl;
    for (const r in this._geometryVaoHash) {
      if (t)
        for (const n in this._geometryVaoHash[r]) {
          const a = this._geometryVaoHash[r];
          this._activeVao !== a && this.unbind(), e.deleteVertexArray(a[n]);
        }
      this._geometryVaoHash[r] = null;
    }
  }
  /**
   * Activate vertex array object.
   * @param geometry - Geometry instance.
   * @param program - Shader program instance.
   */
  activateVao(t, e) {
    const r = this._renderer.gl, n = this._renderer.buffer, a = t.attributes;
    t.indexBuffer && n.bind(t.indexBuffer);
    let l = null;
    for (const h in a) {
      const u = a[h], f = u.buffer, p = n.getGlBuffer(f), m = e._attributeData[h];
      if (m) {
        l !== p && (n.bind(f), l = p);
        const g = m.location;
        r.enableVertexAttribArray(g);
        const x = ai(u.format), o = GS(u.format);
        if (m.format?.substring(1, 4) === "int" ? r.vertexAttribIPointer(
          g,
          x.size,
          o,
          u.stride,
          u.offset
        ) : r.vertexAttribPointer(
          g,
          x.size,
          o,
          x.normalised,
          u.stride,
          u.offset
        ), u.instance)
          if (this.hasInstance) {
            const c = u.divisor ?? 1;
            r.vertexAttribDivisor(g, c);
          } else
            throw new Error("geometry error, GPU Instancing is not supported on this device");
      }
    }
  }
  /**
   * Draws the currently bound geometry.
   * @param topology - The type primitive to render.
   * @param size - The number of elements to be rendered. If not specified, all vertices after the
   *  starting vertex will be drawn.
   * @param start - The starting vertex in the geometry to start drawing from. If not specified,
   *  drawing will start from the first vertex.
   * @param instanceCount - The number of instances of the set of elements to execute. If not specified,
   *  all instances will be drawn.
   */
  draw(t, e, r, n) {
    const { gl: a } = this._renderer, l = this._activeGeometry, h = zS[t || l.topology];
    if (n ?? (n = l.instanceCount), l.indexBuffer) {
      const u = l.indexBuffer.data.BYTES_PER_ELEMENT, f = u === 2 ? a.UNSIGNED_SHORT : a.UNSIGNED_INT;
      n > 1 ? a.drawElementsInstanced(h, e || l.indexBuffer.data.length, f, (r || 0) * u, n) : a.drawElements(h, e || l.indexBuffer.data.length, f, (r || 0) * u);
    } else n > 1 ? a.drawArraysInstanced(h, r || 0, e || l.getSize(), n) : a.drawArrays(h, r || 0, e || l.getSize());
    return this;
  }
  /** Unbind/reset everything. */
  unbind() {
    this.gl.bindVertexArray(null), this._activeVao = null, this._activeGeometry = null;
  }
  destroy() {
    this._renderer = null, this.gl = null, this._activeVao = null, this._activeGeometry = null;
  }
}
P_.extension = {
  type: [
    A.WebGLSystem
  ],
  name: "geometry"
};
const NS = new ys({
  attributes: {
    aPosition: [
      -1,
      -1,
      // Bottom left corner
      3,
      -1,
      // Bottom right corner, extending beyond right edge
      -1,
      3
      // Top left corner, extending beyond top edge
    ]
  }
}), hl = class M_ {
  constructor(t) {
    this.useBackBuffer = !1, this._useBackBufferThisRender = !1, this._renderer = t;
  }
  init(t = {}) {
    const { useBackBuffer: e, antialias: r } = { ...M_.defaultOptions, ...t };
    this.useBackBuffer = e, this._antialias = r, this._renderer.context.supports.msaa || (N("antialiasing, is not supported on when using the back buffer"), this._antialias = !1), this._state = ye.for2d();
    const n = new gr({
      vertex: `
                attribute vec2 aPosition;
                out vec2 vUv;

                void main() {
                    gl_Position = vec4(aPosition, 0.0, 1.0);

                    vUv = (aPosition + 1.0) / 2.0;

                    // flip dem UVs
                    vUv.y = 1.0 - vUv.y;
                }`,
      fragment: `
                in vec2 vUv;
                out vec4 finalColor;

                uniform sampler2D uTexture;

                void main() {
                    finalColor = texture(uTexture, vUv);
                }`,
      name: "big-triangle"
    });
    this._bigTriangleShader = new ue({
      glProgram: n,
      resources: {
        uTexture: k.WHITE.source
      }
    });
  }
  /**
   * This is called before the RenderTargetSystem is started. This is where
   * we replace the target with the back buffer if required.
   * @param options - The options for this render.
   */
  renderStart(t) {
    const e = this._renderer.renderTarget.getRenderTarget(t.target);
    if (this._useBackBufferThisRender = this.useBackBuffer && !!e.isRoot, this._useBackBufferThisRender) {
      const r = this._renderer.renderTarget.getRenderTarget(t.target);
      this._targetTexture = r.colorTexture, t.target = this._getBackBufferTexture(r.colorTexture);
    }
  }
  renderEnd() {
    this._presentBackBuffer();
  }
  _presentBackBuffer() {
    const t = this._renderer;
    t.renderTarget.finishRenderPass(), this._useBackBufferThisRender && (t.renderTarget.bind(this._targetTexture, !1), this._bigTriangleShader.resources.uTexture = this._backBufferTexture.source, t.encoder.draw({
      geometry: NS,
      shader: this._bigTriangleShader,
      state: this._state
    }));
  }
  _getBackBufferTexture(t) {
    return this._backBufferTexture = this._backBufferTexture || new k({
      source: new yt({
        width: t.width,
        height: t.height,
        resolution: t._resolution,
        antialias: this._antialias
      })
    }), this._backBufferTexture.source.resize(
      t.width,
      t.height,
      t._resolution
    ), this._backBufferTexture;
  }
  /** destroys the back buffer */
  destroy() {
    this._backBufferTexture && (this._backBufferTexture.destroy(), this._backBufferTexture = null);
  }
};
hl.extension = {
  type: [
    A.WebGLSystem
  ],
  name: "backBuffer",
  priority: 1
};
hl.defaultOptions = {
  /** if true will use the back buffer where required */
  useBackBuffer: !1
};
let HS = hl;
class B_ {
  constructor(t) {
    this._colorMaskCache = 15, this._renderer = t;
  }
  setMask(t) {
    this._colorMaskCache !== t && (this._colorMaskCache = t, this._renderer.gl.colorMask(
      !!(t & 8),
      !!(t & 4),
      !!(t & 2),
      !!(t & 1)
    ));
  }
}
B_.extension = {
  type: [
    A.WebGLSystem
  ],
  name: "colorMask"
};
class U_ {
  constructor(t) {
    this.commandFinished = Promise.resolve(), this._renderer = t;
  }
  setGeometry(t, e) {
    this._renderer.geometry.bind(t, e.glProgram);
  }
  finishRenderPass() {
  }
  draw(t) {
    const e = this._renderer, { geometry: r, shader: n, state: a, skipSync: l, topology: h, size: u, start: f, instanceCount: p } = t;
    e.shader.bind(n, l), e.geometry.bind(r, e.shader._activeProgram), a && e.state.set(a), e.geometry.draw(h, u, f, p ?? r.instanceCount);
  }
  destroy() {
    this._renderer = null;
  }
}
U_.extension = {
  type: [
    A.WebGLSystem
  ],
  name: "encoder"
};
class R_ {
  constructor(t) {
    this._renderer = t;
  }
  contextChange() {
    const t = this._renderer.gl;
    this.maxTextures = t.getParameter(t.MAX_TEXTURE_IMAGE_UNITS), this.maxBatchableTextures = Dp(this.maxTextures, t), this.maxUniformBindings = t.getParameter(t.MAX_UNIFORM_BUFFER_BINDINGS);
  }
  destroy() {
  }
}
R_.extension = {
  type: [
    A.WebGLSystem
  ],
  name: "limits"
};
class WS {
  constructor() {
    this.width = -1, this.height = -1, this.msaa = !1, this.msaaRenderBuffer = [];
  }
}
const ci = [];
ci[ft.NONE] = void 0;
ci[ft.DISABLED] = {
  stencilWriteMask: 0,
  stencilReadMask: 0
};
ci[ft.RENDERING_MASK_ADD] = {
  stencilFront: {
    compare: "equal",
    passOp: "increment-clamp"
  },
  stencilBack: {
    compare: "equal",
    passOp: "increment-clamp"
  }
};
ci[ft.RENDERING_MASK_REMOVE] = {
  stencilFront: {
    compare: "equal",
    passOp: "decrement-clamp"
  },
  stencilBack: {
    compare: "equal",
    passOp: "decrement-clamp"
  }
};
ci[ft.MASK_ACTIVE] = {
  stencilWriteMask: 0,
  stencilFront: {
    compare: "equal",
    passOp: "keep"
  },
  stencilBack: {
    compare: "equal",
    passOp: "keep"
  }
};
ci[ft.INVERSE_MASK_ACTIVE] = {
  stencilWriteMask: 0,
  stencilFront: {
    compare: "not-equal",
    passOp: "keep"
  },
  stencilBack: {
    compare: "not-equal",
    passOp: "keep"
  }
};
class I_ {
  constructor(t) {
    this._stencilCache = {
      enabled: !1,
      stencilReference: 0,
      stencilMode: ft.NONE
    }, this._renderTargetStencilState = /* @__PURE__ */ Object.create(null), t.renderTarget.onRenderTargetChange.add(this);
  }
  contextChange(t) {
    this._gl = t, this._comparisonFuncMapping = {
      always: t.ALWAYS,
      never: t.NEVER,
      equal: t.EQUAL,
      "not-equal": t.NOTEQUAL,
      less: t.LESS,
      "less-equal": t.LEQUAL,
      greater: t.GREATER,
      "greater-equal": t.GEQUAL
    }, this._stencilOpsMapping = {
      keep: t.KEEP,
      zero: t.ZERO,
      replace: t.REPLACE,
      invert: t.INVERT,
      "increment-clamp": t.INCR,
      "decrement-clamp": t.DECR,
      "increment-wrap": t.INCR_WRAP,
      "decrement-wrap": t.DECR_WRAP
    }, this.resetState();
  }
  onRenderTargetChange(t) {
    if (this._activeRenderTarget === t)
      return;
    this._activeRenderTarget = t;
    let e = this._renderTargetStencilState[t.uid];
    e || (e = this._renderTargetStencilState[t.uid] = {
      stencilMode: ft.DISABLED,
      stencilReference: 0
    }), this.setStencilMode(e.stencilMode, e.stencilReference);
  }
  resetState() {
    this._stencilCache.enabled = !1, this._stencilCache.stencilMode = ft.NONE, this._stencilCache.stencilReference = 0;
  }
  setStencilMode(t, e) {
    const r = this._renderTargetStencilState[this._activeRenderTarget.uid], n = this._gl, a = ci[t], l = this._stencilCache;
    if (r.stencilMode = t, r.stencilReference = e, t === ft.DISABLED) {
      this._stencilCache.enabled && (this._stencilCache.enabled = !1, n.disable(n.STENCIL_TEST));
      return;
    }
    this._stencilCache.enabled || (this._stencilCache.enabled = !0, n.enable(n.STENCIL_TEST)), (t !== l.stencilMode || l.stencilReference !== e) && (l.stencilMode = t, l.stencilReference = e, n.stencilFunc(this._comparisonFuncMapping[a.stencilBack.compare], e, 255), n.stencilOp(n.KEEP, n.KEEP, this._stencilOpsMapping[a.stencilBack.passOp]));
  }
}
I_.extension = {
  type: [
    A.WebGLSystem
  ],
  name: "stencil"
};
class k_ {
  constructor(t) {
    this._syncFunctionHash = /* @__PURE__ */ Object.create(null), this._adaptor = t, this._systemCheck();
  }
  /**
   * Overridable function by `pixi.js/unsafe-eval` to silence
   * throwing an error if platform doesn't support unsafe-evals.
   * @private
   */
  _systemCheck() {
    if (!vp())
      throw new Error("Current environment does not allow unsafe-eval, please use pixi.js/unsafe-eval module to enable support.");
  }
  ensureUniformGroup(t) {
    const e = this.getUniformGroupData(t);
    t.buffer || (t.buffer = new Zt({
      data: new Float32Array(e.layout.size / 4),
      usage: X.UNIFORM | X.COPY_DST
    }));
  }
  getUniformGroupData(t) {
    return this._syncFunctionHash[t._signature] || this._initUniformGroup(t);
  }
  _initUniformGroup(t) {
    const e = t._signature;
    let r = this._syncFunctionHash[e];
    if (!r) {
      const n = Object.keys(t.uniformStructures).map((h) => t.uniformStructures[h]), a = this._adaptor.createUboElements(n), l = this._generateUboSync(a.uboElements);
      r = this._syncFunctionHash[e] = {
        layout: a,
        syncFunction: l
      };
    }
    return this._syncFunctionHash[e];
  }
  _generateUboSync(t) {
    return this._adaptor.generateUboSync(t);
  }
  syncUniformGroup(t, e, r) {
    const n = this.getUniformGroupData(t);
    t.buffer || (t.buffer = new Zt({
      data: new Float32Array(n.layout.size / 4),
      usage: X.UNIFORM | X.COPY_DST
    }));
    let a = null;
    return e || (e = t.buffer.data, a = t.buffer.dataInt32), r || (r = 0), n.syncFunction(t.uniforms, e, a, r), !0;
  }
  updateUniformGroup(t) {
    if (t.isStatic && !t._dirtyId)
      return !1;
    t._dirtyId = 0;
    const e = this.syncUniformGroup(t);
    return t.buffer.update(), e;
  }
  destroy() {
    this._syncFunctionHash = null;
  }
}
const F_ = {
  f32: 4,
  i32: 4,
  "vec2<f32>": 8,
  "vec3<f32>": 12,
  "vec4<f32>": 16,
  "vec2<i32>": 8,
  "vec3<i32>": 12,
  "vec4<i32>": 16,
  "mat2x2<f32>": 16 * 2,
  "mat3x3<f32>": 16 * 3,
  "mat4x4<f32>": 16 * 4
  // TODO - not essential for now but support these in the future
  // int:      4,
  // ivec2:    8,
  // ivec3:    12,
  // ivec4:    16,
  // uint:     4,
  // uvec2:    8,
  // uvec3:    12,
  // uvec4:    16,
  // bool:     4,
  // bvec2:    8,
  // bvec3:    12,
  // bvec4:    16,
  // mat2:     16 * 2,
  // mat3:     16 * 3,
  // mat4:     16 * 4,
};
function VS(s) {
  const t = s.map((a) => ({
    data: a,
    offset: 0,
    size: 0
  })), e = 16;
  let r = 0, n = 0;
  for (let a = 0; a < t.length; a++) {
    const l = t[a];
    if (r = F_[l.data.type], !r)
      throw new Error(`Unknown type ${l.data.type}`);
    l.data.size > 1 && (r = Math.max(r, e) * l.data.size);
    const h = r === 12 ? 16 : r;
    l.size = r;
    const u = n % e;
    u > 0 && e - u < h ? n += (e - u) % 16 : n += (r - u % r) % r, l.offset = n, n += r;
  }
  return n = Math.ceil(n / 16) * 16, { uboElements: t, size: n };
}
const Ei = [
  // uploading pixi matrix object to mat3
  {
    type: "mat3x3<f32>",
    test: (s) => s.value.a !== void 0,
    ubo: `
            var matrix = uv[name].toArray(true);
            data[offset] = matrix[0];
            data[offset + 1] = matrix[1];
            data[offset + 2] = matrix[2];
            data[offset + 4] = matrix[3];
            data[offset + 5] = matrix[4];
            data[offset + 6] = matrix[5];
            data[offset + 8] = matrix[6];
            data[offset + 9] = matrix[7];
            data[offset + 10] = matrix[8];
        `,
    uniform: `
            gl.uniformMatrix3fv(ud[name].location, false, uv[name].toArray(true));
        `
  },
  // uploading a pixi rectangle as a vec4
  {
    type: "vec4<f32>",
    test: (s) => s.type === "vec4<f32>" && s.size === 1 && s.value.width !== void 0,
    ubo: `
            v = uv[name];
            data[offset] = v.x;
            data[offset + 1] = v.y;
            data[offset + 2] = v.width;
            data[offset + 3] = v.height;
        `,
    uniform: `
            cv = ud[name].value;
            v = uv[name];
            if (cv[0] !== v.x || cv[1] !== v.y || cv[2] !== v.width || cv[3] !== v.height) {
                cv[0] = v.x;
                cv[1] = v.y;
                cv[2] = v.width;
                cv[3] = v.height;
                gl.uniform4f(ud[name].location, v.x, v.y, v.width, v.height);
            }
        `
  },
  // uploading a pixi point as a vec2
  {
    type: "vec2<f32>",
    test: (s) => s.type === "vec2<f32>" && s.size === 1 && s.value.x !== void 0,
    ubo: `
            v = uv[name];
            data[offset] = v.x;
            data[offset + 1] = v.y;
        `,
    uniform: `
            cv = ud[name].value;
            v = uv[name];
            if (cv[0] !== v.x || cv[1] !== v.y) {
                cv[0] = v.x;
                cv[1] = v.y;
                gl.uniform2f(ud[name].location, v.x, v.y);
            }
        `
  },
  // uploading a pixi color as a vec4
  {
    type: "vec4<f32>",
    test: (s) => s.type === "vec4<f32>" && s.size === 1 && s.value.red !== void 0,
    ubo: `
            v = uv[name];
            data[offset] = v.red;
            data[offset + 1] = v.green;
            data[offset + 2] = v.blue;
            data[offset + 3] = v.alpha;
        `,
    uniform: `
            cv = ud[name].value;
            v = uv[name];
            if (cv[0] !== v.red || cv[1] !== v.green || cv[2] !== v.blue || cv[3] !== v.alpha) {
                cv[0] = v.red;
                cv[1] = v.green;
                cv[2] = v.blue;
                cv[3] = v.alpha;
                gl.uniform4f(ud[name].location, v.red, v.green, v.blue, v.alpha);
            }
        `
  },
  // uploading a pixi color as a vec3
  {
    type: "vec3<f32>",
    test: (s) => s.type === "vec3<f32>" && s.size === 1 && s.value.red !== void 0,
    ubo: `
            v = uv[name];
            data[offset] = v.red;
            data[offset + 1] = v.green;
            data[offset + 2] = v.blue;
        `,
    uniform: `
            cv = ud[name].value;
            v = uv[name];
            if (cv[0] !== v.red || cv[1] !== v.green || cv[2] !== v.blue) {
                cv[0] = v.red;
                cv[1] = v.green;
                cv[2] = v.blue;
                gl.uniform3f(ud[name].location, v.red, v.green, v.blue);
            }
        `
  }
];
function D_(s, t, e, r) {
  const n = [`
        var v = null;
        var v2 = null;
        var t = 0;
        var index = 0;
        var name = null;
        var arrayOffset = null;
    `];
  let a = 0;
  for (let h = 0; h < s.length; h++) {
    const u = s[h], f = u.data.name;
    let p = !1, m = 0;
    for (let g = 0; g < Ei.length; g++)
      if (Ei[g].test(u.data)) {
        m = u.offset / 4, n.push(
          `name = "${f}";`,
          `offset += ${m - a};`,
          Ei[g][t] || Ei[g].ubo
        ), p = !0;
        break;
      }
    if (!p)
      if (u.data.size > 1)
        m = u.offset / 4, n.push(e(u, m - a));
      else {
        const g = r[u.data.type];
        m = u.offset / 4, n.push(
          /* wgsl */
          `
                    v = uv.${f};
                    offset += ${m - a};
                    ${g};
                `
        );
      }
    a = m;
  }
  const l = n.join(`
`);
  return new Function(
    "uv",
    "data",
    "dataInt32",
    "offset",
    l
  );
}
function zi(s, t) {
  return `
        for (let i = 0; i < ${s * t}; i++) {
            data[offset + (((i / ${s})|0) * 4) + (i % ${s})] = v[i];
        }
    `;
}
const O_ = {
  f32: `
        data[offset] = v;`,
  i32: `
        dataInt32[offset] = v;`,
  "vec2<f32>": `
        data[offset] = v[0];
        data[offset + 1] = v[1];`,
  "vec3<f32>": `
        data[offset] = v[0];
        data[offset + 1] = v[1];
        data[offset + 2] = v[2];`,
  "vec4<f32>": `
        data[offset] = v[0];
        data[offset + 1] = v[1];
        data[offset + 2] = v[2];
        data[offset + 3] = v[3];`,
  "vec2<i32>": `
        dataInt32[offset] = v[0];
        dataInt32[offset + 1] = v[1];`,
  "vec3<i32>": `
        dataInt32[offset] = v[0];
        dataInt32[offset + 1] = v[1];
        dataInt32[offset + 2] = v[2];`,
  "vec4<i32>": `
        dataInt32[offset] = v[0];
        dataInt32[offset + 1] = v[1];
        dataInt32[offset + 2] = v[2];
        dataInt32[offset + 3] = v[3];`,
  "mat2x2<f32>": `
        data[offset] = v[0];
        data[offset + 1] = v[1];
        data[offset + 4] = v[2];
        data[offset + 5] = v[3];`,
  "mat3x3<f32>": `
        data[offset] = v[0];
        data[offset + 1] = v[1];
        data[offset + 2] = v[2];
        data[offset + 4] = v[3];
        data[offset + 5] = v[4];
        data[offset + 6] = v[5];
        data[offset + 8] = v[6];
        data[offset + 9] = v[7];
        data[offset + 10] = v[8];`,
  "mat4x4<f32>": `
        for (let i = 0; i < 16; i++) {
            data[offset + i] = v[i];
        }`,
  "mat3x2<f32>": zi(3, 2),
  "mat4x2<f32>": zi(4, 2),
  "mat2x3<f32>": zi(2, 3),
  "mat4x3<f32>": zi(4, 3),
  "mat2x4<f32>": zi(2, 4),
  "mat3x4<f32>": zi(3, 4)
}, $S = {
  ...O_,
  "mat2x2<f32>": `
        data[offset] = v[0];
        data[offset + 1] = v[1];
        data[offset + 2] = v[2];
        data[offset + 3] = v[3];
    `
};
function YS(s, t) {
  const e = Math.max(F_[s.data.type] / 16, 1), r = s.data.value.length / s.data.size, n = (4 - r % 4) % 4, a = s.data.type.indexOf("i32") >= 0 ? "dataInt32" : "data";
  return `
        v = uv.${s.data.name};
        offset += ${t};

        arrayOffset = offset;

        t = 0;

        for(var i=0; i < ${s.data.size * e}; i++)
        {
            for(var j = 0; j < ${r}; j++)
            {
                ${a}[arrayOffset++] = v[t++];
            }
            ${n !== 0 ? `arrayOffset += ${n};` : ""}
        }
    `;
}
function XS(s) {
  return D_(
    s,
    "uboStd40",
    YS,
    O_
  );
}
class L_ extends k_ {
  constructor() {
    super({
      createUboElements: VS,
      generateUboSync: XS
    });
  }
}
L_.extension = {
  type: [A.WebGLSystem],
  name: "ubo"
};
class jS {
  constructor() {
    this._clearColorCache = [0, 0, 0, 0], this._viewPortCache = new Z();
  }
  init(t, e) {
    this._renderer = t, this._renderTargetSystem = e, t.runners.contextChange.add(this);
  }
  contextChange() {
    this._clearColorCache = [0, 0, 0, 0], this._viewPortCache = new Z();
  }
  copyToTexture(t, e, r, n, a) {
    const l = this._renderTargetSystem, h = this._renderer, u = l.getGpuRenderTarget(t), f = h.gl;
    return this.finishRenderPass(t), f.bindFramebuffer(f.FRAMEBUFFER, u.resolveTargetFramebuffer), h.texture.bind(e, 0), f.copyTexSubImage2D(
      f.TEXTURE_2D,
      0,
      a.x,
      a.y,
      r.x,
      r.y,
      n.width,
      n.height
    ), e;
  }
  startRenderPass(t, e = !0, r, n) {
    const a = this._renderTargetSystem, l = t.colorTexture, h = a.getGpuRenderTarget(t);
    let u = n.y;
    t.isRoot && (u = l.pixelHeight - n.height), t.colorTextures.forEach((m) => {
      this._renderer.texture.unbind(m);
    });
    const f = this._renderer.gl;
    f.bindFramebuffer(f.FRAMEBUFFER, h.framebuffer);
    const p = this._viewPortCache;
    (p.x !== n.x || p.y !== u || p.width !== n.width || p.height !== n.height) && (p.x = n.x, p.y = u, p.width = n.width, p.height = n.height, f.viewport(
      n.x,
      u,
      n.width,
      n.height
    )), !h.depthStencilRenderBuffer && (t.stencil || t.depth) && this._initStencil(h), this.clear(t, e, r);
  }
  finishRenderPass(t) {
    const r = this._renderTargetSystem.getGpuRenderTarget(t);
    if (!r.msaa)
      return;
    const n = this._renderer.gl;
    n.bindFramebuffer(n.FRAMEBUFFER, r.resolveTargetFramebuffer), n.bindFramebuffer(n.READ_FRAMEBUFFER, r.framebuffer), n.blitFramebuffer(
      0,
      0,
      r.width,
      r.height,
      0,
      0,
      r.width,
      r.height,
      n.COLOR_BUFFER_BIT,
      n.NEAREST
    ), n.bindFramebuffer(n.FRAMEBUFFER, r.framebuffer);
  }
  initGpuRenderTarget(t) {
    const r = this._renderer.gl, n = new WS();
    return t.colorTexture instanceof Ne ? (this._renderer.context.ensureCanvasSize(t.colorTexture.resource), n.framebuffer = null, n) : (this._initColor(t, n), r.bindFramebuffer(r.FRAMEBUFFER, null), n);
  }
  destroyGpuRenderTarget(t) {
    const e = this._renderer.gl;
    t.framebuffer && (e.deleteFramebuffer(t.framebuffer), t.framebuffer = null), t.resolveTargetFramebuffer && (e.deleteFramebuffer(t.resolveTargetFramebuffer), t.resolveTargetFramebuffer = null), t.depthStencilRenderBuffer && (e.deleteRenderbuffer(t.depthStencilRenderBuffer), t.depthStencilRenderBuffer = null), t.msaaRenderBuffer.forEach((r) => {
      e.deleteRenderbuffer(r);
    }), t.msaaRenderBuffer = null;
  }
  clear(t, e, r) {
    if (!e)
      return;
    const n = this._renderTargetSystem;
    typeof e == "boolean" && (e = e ? Xt.ALL : Xt.NONE);
    const a = this._renderer.gl;
    if (e & Xt.COLOR) {
      r ?? (r = n.defaultClearColor);
      const l = this._clearColorCache, h = r;
      (l[0] !== h[0] || l[1] !== h[1] || l[2] !== h[2] || l[3] !== h[3]) && (l[0] = h[0], l[1] = h[1], l[2] = h[2], l[3] = h[3], a.clearColor(h[0], h[1], h[2], h[3]));
    }
    a.clear(e);
  }
  resizeGpuRenderTarget(t) {
    if (t.isRoot)
      return;
    const r = this._renderTargetSystem.getGpuRenderTarget(t);
    this._resizeColor(t, r), (t.stencil || t.depth) && this._resizeStencil(r);
  }
  _initColor(t, e) {
    const r = this._renderer, n = r.gl, a = n.createFramebuffer();
    if (e.resolveTargetFramebuffer = a, n.bindFramebuffer(n.FRAMEBUFFER, a), e.width = t.colorTexture.source.pixelWidth, e.height = t.colorTexture.source.pixelHeight, t.colorTextures.forEach((l, h) => {
      const u = l.source;
      u.antialias && (r.context.supports.msaa ? e.msaa = !0 : N("[RenderTexture] Antialiasing on textures is not supported in WebGL1")), r.texture.bindSource(u, 0);
      const p = r.texture.getGlSource(u).texture;
      n.framebufferTexture2D(
        n.FRAMEBUFFER,
        n.COLOR_ATTACHMENT0 + h,
        3553,
        // texture.target,
        p,
        0
      );
    }), e.msaa) {
      const l = n.createFramebuffer();
      e.framebuffer = l, n.bindFramebuffer(n.FRAMEBUFFER, l), t.colorTextures.forEach((h, u) => {
        const f = n.createRenderbuffer();
        e.msaaRenderBuffer[u] = f;
      });
    } else
      e.framebuffer = a;
    this._resizeColor(t, e);
  }
  _resizeColor(t, e) {
    const r = t.colorTexture.source;
    if (e.width = r.pixelWidth, e.height = r.pixelHeight, t.colorTextures.forEach((n, a) => {
      a !== 0 && n.source.resize(r.width, r.height, r._resolution);
    }), e.msaa) {
      const n = this._renderer, a = n.gl, l = e.framebuffer;
      a.bindFramebuffer(a.FRAMEBUFFER, l), t.colorTextures.forEach((h, u) => {
        const f = h.source;
        n.texture.bindSource(f, 0);
        const m = n.texture.getGlSource(f).internalFormat, g = e.msaaRenderBuffer[u];
        a.bindRenderbuffer(
          a.RENDERBUFFER,
          g
        ), a.renderbufferStorageMultisample(
          a.RENDERBUFFER,
          4,
          m,
          f.pixelWidth,
          f.pixelHeight
        ), a.framebufferRenderbuffer(
          a.FRAMEBUFFER,
          a.COLOR_ATTACHMENT0 + u,
          a.RENDERBUFFER,
          g
        );
      });
    }
  }
  _initStencil(t) {
    if (t.framebuffer === null)
      return;
    const e = this._renderer.gl, r = e.createRenderbuffer();
    t.depthStencilRenderBuffer = r, e.bindRenderbuffer(
      e.RENDERBUFFER,
      r
    ), e.framebufferRenderbuffer(
      e.FRAMEBUFFER,
      e.DEPTH_STENCIL_ATTACHMENT,
      e.RENDERBUFFER,
      r
    ), this._resizeStencil(t);
  }
  _resizeStencil(t) {
    const e = this._renderer.gl;
    e.bindRenderbuffer(
      e.RENDERBUFFER,
      t.depthStencilRenderBuffer
    ), t.msaa ? e.renderbufferStorageMultisample(
      e.RENDERBUFFER,
      4,
      e.DEPTH24_STENCIL8,
      t.width,
      t.height
    ) : e.renderbufferStorage(
      e.RENDERBUFFER,
      this._renderer.context.webGLVersion === 2 ? e.DEPTH24_STENCIL8 : e.DEPTH_STENCIL,
      t.width,
      t.height
    );
  }
  prerender(t) {
    const e = t.colorTexture.resource;
    this._renderer.context.multiView && Ne.test(e) && this._renderer.context.ensureCanvasSize(e);
  }
  postrender(t) {
    if (this._renderer.context.multiView && Ne.test(t.colorTexture.resource)) {
      const e = this._renderer.context.canvas, r = t.colorTexture;
      r.context2D.drawImage(
        e,
        0,
        r.pixelHeight - e.height
      );
    }
  }
}
function KS(s, t, e, r, n, a) {
  const l = a ? 1 : -1;
  return s.identity(), s.a = 1 / r * 2, s.d = l * (1 / n * 2), s.tx = -1 - t * s.a, s.ty = -l - e * s.d, s;
}
const Mr = /* @__PURE__ */ new Map();
function G_(s, t) {
  if (!Mr.has(s)) {
    const e = new k({
      source: new Ne({
        resource: s,
        ...t
      })
    }), r = () => {
      Mr.get(s) === e && Mr.delete(s);
    };
    e.once("destroy", r), e.source.once("destroy", r), Mr.set(s, e);
  }
  return Mr.get(s);
}
function qS(s) {
  const t = s.colorTexture.source.resource;
  return globalThis.HTMLCanvasElement && t instanceof HTMLCanvasElement && document.body.contains(t);
}
const z_ = class N_ {
  /**
   * @param [descriptor] - Options for creating a render target.
   */
  constructor(t = {}) {
    if (this.uid = rt("renderTarget"), this.colorTextures = [], this.dirtyId = 0, this.isRoot = !1, this._size = new Float32Array(2), this._managedColorTextures = !1, t = { ...N_.defaultOptions, ...t }, this.stencil = t.stencil, this.depth = t.depth, this.isRoot = t.isRoot, typeof t.colorTextures == "number") {
      this._managedColorTextures = !0;
      for (let e = 0; e < t.colorTextures; e++)
        this.colorTextures.push(
          new yt({
            width: t.width,
            height: t.height,
            resolution: t.resolution,
            antialias: t.antialias
          })
        );
    } else {
      this.colorTextures = [...t.colorTextures.map((r) => r.source)];
      const e = this.colorTexture.source;
      this.resize(e.width, e.height, e._resolution);
    }
    this.colorTexture.source.on("resize", this.onSourceResize, this), (t.depthStencilTexture || this.stencil) && (t.depthStencilTexture instanceof k || t.depthStencilTexture instanceof yt ? this.depthStencilTexture = t.depthStencilTexture.source : this.ensureDepthStencilTexture());
  }
  get size() {
    const t = this._size;
    return t[0] = this.pixelWidth, t[1] = this.pixelHeight, t;
  }
  get width() {
    return this.colorTexture.source.width;
  }
  get height() {
    return this.colorTexture.source.height;
  }
  get pixelWidth() {
    return this.colorTexture.source.pixelWidth;
  }
  get pixelHeight() {
    return this.colorTexture.source.pixelHeight;
  }
  get resolution() {
    return this.colorTexture.source._resolution;
  }
  get colorTexture() {
    return this.colorTextures[0];
  }
  onSourceResize(t) {
    this.resize(t.width, t.height, t._resolution, !0);
  }
  /**
   * This will ensure a depthStencil texture is created for this render target.
   * Most likely called by the mask system to make sure we have stencil buffer added.
   * @internal
   */
  ensureDepthStencilTexture() {
    this.depthStencilTexture || (this.depthStencilTexture = new yt({
      width: this.width,
      height: this.height,
      resolution: this.resolution,
      format: "depth24plus-stencil8",
      autoGenerateMipmaps: !1,
      antialias: !1,
      mipLevelCount: 1
      // sampleCount: handled by the render target system..
    }));
  }
  resize(t, e, r = this.resolution, n = !1) {
    this.dirtyId++, this.colorTextures.forEach((a, l) => {
      n && l === 0 || a.source.resize(t, e, r);
    }), this.depthStencilTexture && this.depthStencilTexture.source.resize(t, e, r);
  }
  destroy() {
    this.colorTexture.source.off("resize", this.onSourceResize, this), this._managedColorTextures && this.colorTextures.forEach((t) => {
      t.destroy();
    }), this.depthStencilTexture && (this.depthStencilTexture.destroy(), delete this.depthStencilTexture);
  }
};
z_.defaultOptions = {
  /** the width of the RenderTarget */
  width: 0,
  /** the height of the RenderTarget */
  height: 0,
  /** the resolution of the RenderTarget */
  resolution: 1,
  /** an array of textures, or a number indicating how many color textures there should be */
  colorTextures: 1,
  /** should this render target have a stencil buffer? */
  stencil: !1,
  /** should this render target have a depth buffer? */
  depth: !1,
  /** should this render target be antialiased? */
  antialias: !1,
  // save on perf by default!
  /** is this a root element, true if this is gl context owners render target */
  isRoot: !1
};
let qo = z_;
class H_ {
  constructor(t) {
    this.rootViewPort = new Z(), this.viewport = new Z(), this.onRenderTargetChange = new Ep("onRenderTargetChange"), this.projectionMatrix = new D(), this.defaultClearColor = [0, 0, 0, 0], this._renderSurfaceToRenderTargetHash = /* @__PURE__ */ new Map(), this._gpuRenderTargetHash = /* @__PURE__ */ Object.create(null), this._renderTargetStack = [], this._renderer = t, t.renderableGC.addManagedHash(this, "_gpuRenderTargetHash");
  }
  /** called when dev wants to finish a render pass */
  finishRenderPass() {
    this.adaptor.finishRenderPass(this.renderTarget);
  }
  /**
   * called when the renderer starts to render a scene.
   * @param options
   * @param options.target - the render target to render to
   * @param options.clear - the clear mode to use. Can be true or a CLEAR number 'COLOR | DEPTH | STENCIL' 0b111
   * @param options.clearColor - the color to clear to
   * @param options.frame - the frame to render to
   */
  renderStart({
    target: t,
    clear: e,
    clearColor: r,
    frame: n
  }) {
    this._renderTargetStack.length = 0, this.push(
      t,
      e,
      r,
      n
    ), this.rootViewPort.copyFrom(this.viewport), this.rootRenderTarget = this.renderTarget, this.renderingToScreen = qS(this.rootRenderTarget), this.adaptor.prerender?.(this.rootRenderTarget);
  }
  postrender() {
    this.adaptor.postrender?.(this.rootRenderTarget);
  }
  /**
   * Binding a render surface! This is the main function of the render target system.
   * It will take the RenderSurface (which can be a texture, canvas, or render target) and bind it to the renderer.
   * Once bound all draw calls will be rendered to the render surface.
   *
   * If a frame is not provide and the render surface is a texture, the frame of the texture will be used.
   * @param renderSurface - the render surface to bind
   * @param clear - the clear mode to use. Can be true or a CLEAR number 'COLOR | DEPTH | STENCIL' 0b111
   * @param clearColor - the color to clear to
   * @param frame - the frame to render to
   * @returns the render target that was bound
   */
  bind(t, e = !0, r, n) {
    const a = this.getRenderTarget(t), l = this.renderTarget !== a;
    this.renderTarget = a, this.renderSurface = t;
    const h = this.getGpuRenderTarget(a);
    (a.pixelWidth !== h.width || a.pixelHeight !== h.height) && (this.adaptor.resizeGpuRenderTarget(a), h.width = a.pixelWidth, h.height = a.pixelHeight);
    const u = a.colorTexture, f = this.viewport, p = u.pixelWidth, m = u.pixelHeight;
    if (!n && t instanceof k && (n = t.frame), n) {
      const g = u._resolution;
      f.x = n.x * g + 0.5 | 0, f.y = n.y * g + 0.5 | 0, f.width = n.width * g + 0.5 | 0, f.height = n.height * g + 0.5 | 0;
    } else
      f.x = 0, f.y = 0, f.width = p, f.height = m;
    return KS(
      this.projectionMatrix,
      0,
      0,
      f.width / u.resolution,
      f.height / u.resolution,
      !a.isRoot
    ), this.adaptor.startRenderPass(a, e, r, f), l && this.onRenderTargetChange.emit(a), a;
  }
  clear(t, e = Xt.ALL, r) {
    e && (t && (t = this.getRenderTarget(t)), this.adaptor.clear(
      t || this.renderTarget,
      e,
      r,
      this.viewport
    ));
  }
  contextChange() {
    this._gpuRenderTargetHash = /* @__PURE__ */ Object.create(null);
  }
  /**
   * Push a render surface to the renderer. This will bind the render surface to the renderer,
   * @param renderSurface - the render surface to push
   * @param clear - the clear mode to use. Can be true or a CLEAR number 'COLOR | DEPTH | STENCIL' 0b111
   * @param clearColor - the color to clear to
   * @param frame - the frame to use when rendering to the render surface
   */
  push(t, e = Xt.ALL, r, n) {
    const a = this.bind(t, e, r, n);
    return this._renderTargetStack.push({
      renderTarget: a,
      frame: n
    }), a;
  }
  /** Pops the current render target from the renderer and restores the previous render target. */
  pop() {
    this._renderTargetStack.pop();
    const t = this._renderTargetStack[this._renderTargetStack.length - 1];
    this.bind(t.renderTarget, !1, null, t.frame);
  }
  /**
   * Gets the render target from the provide render surface. Eg if its a texture,
   * it will return the render target for the texture.
   * If its a render target, it will return the same render target.
   * @param renderSurface - the render surface to get the render target for
   * @returns the render target for the render surface
   */
  getRenderTarget(t) {
    return t.isTexture && (t = t.source), this._renderSurfaceToRenderTargetHash.get(t) ?? this._initRenderTarget(t);
  }
  /**
   * Copies a render surface to another texture.
   *
   * NOTE:
   * for sourceRenderSurfaceTexture, The render target must be something that is written too by the renderer
   *
   * The following is not valid:
   * @example
   * const canvas = document.createElement('canvas')
   * canvas.width = 200;
   * canvas.height = 200;
   *
   * const ctx = canvas2.getContext('2d')!
   * ctx.fillStyle = 'red'
   * ctx.fillRect(0, 0, 200, 200);
   *
   * const texture = RenderTexture.create({
   *   width: 200,
   *   height: 200,
   * })
   * const renderTarget = renderer.renderTarget.getRenderTarget(canvas2);
   *
   * renderer.renderTarget.copyToTexture(renderTarget,texture, {x:0,y:0},{width:200,height:200},{x:0,y:0});
   *
   * The best way to copy a canvas is to create a texture from it. Then render with that.
   *
   * Parsing in a RenderTarget canvas context (with a 2d context)
   * @param sourceRenderSurfaceTexture - the render surface to copy from
   * @param destinationTexture - the texture to copy to
   * @param originSrc - the origin of the copy
   * @param originSrc.x - the x origin of the copy
   * @param originSrc.y - the y origin of the copy
   * @param size - the size of the copy
   * @param size.width - the width of the copy
   * @param size.height - the height of the copy
   * @param originDest - the destination origin (top left to paste from!)
   * @param originDest.x - the x origin of the paste
   * @param originDest.y - the y origin of the paste
   */
  copyToTexture(t, e, r, n, a) {
    r.x < 0 && (n.width += r.x, a.x -= r.x, r.x = 0), r.y < 0 && (n.height += r.y, a.y -= r.y, r.y = 0);
    const { pixelWidth: l, pixelHeight: h } = t;
    return n.width = Math.min(n.width, l - r.x), n.height = Math.min(n.height, h - r.y), this.adaptor.copyToTexture(
      t,
      e,
      r,
      n,
      a
    );
  }
  /**
   * ensures that we have a depth stencil buffer available to render to
   * This is used by the mask system to make sure we have a stencil buffer.
   */
  ensureDepthStencil() {
    this.renderTarget.stencil || (this.renderTarget.stencil = !0, this.adaptor.startRenderPass(this.renderTarget, !1, null, this.viewport));
  }
  /** nukes the render target system */
  destroy() {
    this._renderer = null, this._renderSurfaceToRenderTargetHash.forEach((t, e) => {
      t !== e && t.destroy();
    }), this._renderSurfaceToRenderTargetHash.clear(), this._gpuRenderTargetHash = /* @__PURE__ */ Object.create(null);
  }
  _initRenderTarget(t) {
    let e = null;
    return Ne.test(t) && (t = G_(t).source), t instanceof qo ? e = t : t instanceof yt && (e = new qo({
      colorTextures: [t]
    }), t.source instanceof Ne && (e.isRoot = !0), t.once("destroy", () => {
      e.destroy(), this._renderSurfaceToRenderTargetHash.delete(t);
      const r = this._gpuRenderTargetHash[e.uid];
      r && (this._gpuRenderTargetHash[e.uid] = null, this.adaptor.destroyGpuRenderTarget(r));
    })), this._renderSurfaceToRenderTargetHash.set(t, e), e;
  }
  getGpuRenderTarget(t) {
    return this._gpuRenderTargetHash[t.uid] || (this._gpuRenderTargetHash[t.uid] = this.adaptor.initGpuRenderTarget(t));
  }
  resetState() {
    this.renderTarget = null, this.renderSurface = null;
  }
}
class W_ extends H_ {
  constructor(t) {
    super(t), this.adaptor = new jS(), this.adaptor.init(t, this);
  }
}
W_.extension = {
  type: [A.WebGLSystem],
  name: "renderTarget"
};
class ll extends te {
  /**
   * Create a new Buffer Resource.
   * @param options - The options for the buffer resource
   * @param options.buffer - The underlying buffer that this resource is using
   * @param options.offset - The offset of the buffer this resource is using.
   * If not provided, then it will use the offset of the buffer.
   * @param options.size - The size of the buffer this resource is using.
   * If not provided, then it will use the size of the buffer.
   */
  constructor({ buffer: t, offset: e, size: r }) {
    super(), this.uid = rt("buffer"), this._resourceType = "bufferResource", this._touched = 0, this._resourceId = rt("resource"), this._bufferResource = !0, this.destroyed = !1, this.buffer = t, this.offset = e | 0, this.size = r, this.buffer.on("change", this.onBufferChange, this);
  }
  onBufferChange() {
    this._resourceId = rt("resource"), this.emit("change", this);
  }
  /**
   * Destroys this resource. Make sure the underlying buffer is not used anywhere else
   * if you want to destroy it as well, or code will explode
   * @param destroyBuffer - Should the underlying buffer be destroyed as well?
   */
  destroy(t = !1) {
    this.destroyed = !0, t && this.buffer.destroy(), this.emit("change", this), this.buffer = null;
  }
}
function ZS(s, t) {
  const e = [], r = [`
        var g = s.groups;
        var sS = r.shader;
        var p = s.glProgram;
        var ugS = r.uniformGroup;
        var resources;
    `];
  let n = !1, a = 0;
  const l = t._getProgramData(s.glProgram);
  for (const u in s.groups) {
    const f = s.groups[u];
    e.push(`
            resources = g[${u}].resources;
        `);
    for (const p in f.resources) {
      const m = f.resources[p];
      if (m instanceof kt)
        if (m.ubo) {
          const g = s._uniformBindMap[u][Number(p)];
          e.push(`
                        sS.bindUniformBlock(
                            resources[${p}],
                            '${g}',
                            ${s.glProgram._uniformBlockData[g].index}
                        );
                    `);
        } else
          e.push(`
                        ugS.updateUniformGroup(resources[${p}], p, sD);
                    `);
      else if (m instanceof ll) {
        const g = s._uniformBindMap[u][Number(p)];
        e.push(`
                    sS.bindUniformBlock(
                        resources[${p}],
                        '${g}',
                        ${s.glProgram._uniformBlockData[g].index}
                    );
                `);
      } else if (m instanceof yt) {
        const g = s._uniformBindMap[u][p], x = l.uniformData[g];
        x && (n || (n = !0, r.push(`
                        var tS = r.texture;
                        `)), t._gl.uniform1i(x.location, a), e.push(`
                        tS.bind(resources[${p}], ${a});
                    `), a++);
      }
    }
  }
  const h = [...r, ...e].join(`
`);
  return new Function("r", "s", "sD", h);
}
class QS {
  /**
   * Makes a new Pixi program.
   * @param program - webgl program
   * @param uniformData - uniforms
   */
  constructor(t, e) {
    this.program = t, this.uniformData = e, this.uniformGroups = {}, this.uniformDirtyGroups = {}, this.uniformBlockBindings = {};
  }
  /** Destroys this program. */
  destroy() {
    this.uniformData = null, this.uniformGroups = null, this.uniformDirtyGroups = null, this.uniformBlockBindings = null, this.program = null;
  }
}
function Lu(s, t, e) {
  const r = s.createShader(t);
  return s.shaderSource(r, e), s.compileShader(r), r;
}
function za(s) {
  const t = new Array(s);
  for (let e = 0; e < t.length; e++)
    t[e] = !1;
  return t;
}
function V_(s, t) {
  switch (s) {
    case "float":
      return 0;
    case "vec2":
      return new Float32Array(2 * t);
    case "vec3":
      return new Float32Array(3 * t);
    case "vec4":
      return new Float32Array(4 * t);
    case "int":
    case "uint":
    case "sampler2D":
    case "sampler2DArray":
      return 0;
    case "ivec2":
      return new Int32Array(2 * t);
    case "ivec3":
      return new Int32Array(3 * t);
    case "ivec4":
      return new Int32Array(4 * t);
    case "uvec2":
      return new Uint32Array(2 * t);
    case "uvec3":
      return new Uint32Array(3 * t);
    case "uvec4":
      return new Uint32Array(4 * t);
    case "bool":
      return !1;
    case "bvec2":
      return za(2 * t);
    case "bvec3":
      return za(3 * t);
    case "bvec4":
      return za(4 * t);
    case "mat2":
      return new Float32Array([
        1,
        0,
        0,
        1
      ]);
    case "mat3":
      return new Float32Array([
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1
      ]);
    case "mat4":
      return new Float32Array([
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1
      ]);
  }
  return null;
}
let Ys = null;
const Gu = {
  FLOAT: "float",
  FLOAT_VEC2: "vec2",
  FLOAT_VEC3: "vec3",
  FLOAT_VEC4: "vec4",
  INT: "int",
  INT_VEC2: "ivec2",
  INT_VEC3: "ivec3",
  INT_VEC4: "ivec4",
  UNSIGNED_INT: "uint",
  UNSIGNED_INT_VEC2: "uvec2",
  UNSIGNED_INT_VEC3: "uvec3",
  UNSIGNED_INT_VEC4: "uvec4",
  BOOL: "bool",
  BOOL_VEC2: "bvec2",
  BOOL_VEC3: "bvec3",
  BOOL_VEC4: "bvec4",
  FLOAT_MAT2: "mat2",
  FLOAT_MAT3: "mat3",
  FLOAT_MAT4: "mat4",
  SAMPLER_2D: "sampler2D",
  INT_SAMPLER_2D: "sampler2D",
  UNSIGNED_INT_SAMPLER_2D: "sampler2D",
  SAMPLER_CUBE: "samplerCube",
  INT_SAMPLER_CUBE: "samplerCube",
  UNSIGNED_INT_SAMPLER_CUBE: "samplerCube",
  SAMPLER_2D_ARRAY: "sampler2DArray",
  INT_SAMPLER_2D_ARRAY: "sampler2DArray",
  UNSIGNED_INT_SAMPLER_2D_ARRAY: "sampler2DArray"
}, JS = {
  float: "float32",
  vec2: "float32x2",
  vec3: "float32x3",
  vec4: "float32x4",
  int: "sint32",
  ivec2: "sint32x2",
  ivec3: "sint32x3",
  ivec4: "sint32x4",
  uint: "uint32",
  uvec2: "uint32x2",
  uvec3: "uint32x3",
  uvec4: "uint32x4",
  bool: "uint32",
  bvec2: "uint32x2",
  bvec3: "uint32x3",
  bvec4: "uint32x4"
};
function $_(s, t) {
  if (!Ys) {
    const e = Object.keys(Gu);
    Ys = {};
    for (let r = 0; r < e.length; ++r) {
      const n = e[r];
      Ys[s[n]] = Gu[n];
    }
  }
  return Ys[t];
}
function tT(s, t) {
  const e = $_(s, t);
  return JS[e] || "float32";
}
function eT(s, t, e = !1) {
  const r = {}, n = t.getProgramParameter(s, t.ACTIVE_ATTRIBUTES);
  for (let l = 0; l < n; l++) {
    const h = t.getActiveAttrib(s, l);
    if (h.name.startsWith("gl_"))
      continue;
    const u = tT(t, h.type);
    r[h.name] = {
      location: 0,
      // set further down..
      format: u,
      stride: ai(u).stride,
      offset: 0,
      instance: !1,
      start: 0
    };
  }
  const a = Object.keys(r);
  if (e) {
    a.sort((l, h) => l > h ? 1 : -1);
    for (let l = 0; l < a.length; l++)
      r[a[l]].location = l, t.bindAttribLocation(s, l, a[l]);
    t.linkProgram(s);
  } else
    for (let l = 0; l < a.length; l++)
      r[a[l]].location = t.getAttribLocation(s, a[l]);
  return r;
}
function iT(s, t) {
  if (!t.ACTIVE_UNIFORM_BLOCKS)
    return {};
  const e = {}, r = t.getProgramParameter(s, t.ACTIVE_UNIFORM_BLOCKS);
  for (let n = 0; n < r; n++) {
    const a = t.getActiveUniformBlockName(s, n), l = t.getUniformBlockIndex(s, a), h = t.getActiveUniformBlockParameter(s, n, t.UNIFORM_BLOCK_DATA_SIZE);
    e[a] = {
      name: a,
      index: l,
      size: h
    };
  }
  return e;
}
function rT(s, t) {
  const e = {}, r = t.getProgramParameter(s, t.ACTIVE_UNIFORMS);
  for (let n = 0; n < r; n++) {
    const a = t.getActiveUniform(s, n), l = a.name.replace(/\[.*?\]$/, ""), h = !!a.name.match(/\[.*?\]$/), u = $_(t, a.type);
    e[l] = {
      name: l,
      index: n,
      type: u,
      size: a.size,
      isArray: h,
      value: V_(u, a.size)
    };
  }
  return e;
}
function zu(s, t) {
  const e = s.getShaderSource(t).split(`
`).map((f, p) => `${p}: ${f}`), r = s.getShaderInfoLog(t), n = r.split(`
`), a = {}, l = n.map((f) => parseFloat(f.replace(/^ERROR\: 0\:([\d]+)\:.*$/, "$1"))).filter((f) => f && !a[f] ? (a[f] = !0, !0) : !1), h = [""];
  l.forEach((f) => {
    e[f - 1] = `%c${e[f - 1]}%c`, h.push("background: #FF0000; color:#FFFFFF; font-size: 10px", "font-size: 10px");
  });
  const u = e.join(`
`);
  h[0] = u, console.error(r), console.groupCollapsed("click to view full shader code"), console.warn(...h), console.groupEnd();
}
function sT(s, t, e, r) {
  s.getProgramParameter(t, s.LINK_STATUS) || (s.getShaderParameter(e, s.COMPILE_STATUS) || zu(s, e), s.getShaderParameter(r, s.COMPILE_STATUS) || zu(s, r), console.error("PixiJS Error: Could not initialize shader."), s.getProgramInfoLog(t) !== "" && console.warn("PixiJS Warning: gl.getProgramInfoLog()", s.getProgramInfoLog(t)));
}
function nT(s, t) {
  const e = Lu(s, s.VERTEX_SHADER, t.vertex), r = Lu(s, s.FRAGMENT_SHADER, t.fragment), n = s.createProgram();
  s.attachShader(n, e), s.attachShader(n, r);
  const a = t.transformFeedbackVaryings;
  a && (typeof s.transformFeedbackVaryings != "function" ? N("TransformFeedback is not supported but TransformFeedbackVaryings are given.") : s.transformFeedbackVaryings(
    n,
    a.names,
    a.bufferMode === "separate" ? s.SEPARATE_ATTRIBS : s.INTERLEAVED_ATTRIBS
  )), s.linkProgram(n), s.getProgramParameter(n, s.LINK_STATUS) || sT(s, n, e, r), t._attributeData = eT(
    n,
    s,
    !/^[ \t]*#[ \t]*version[ \t]+300[ \t]+es[ \t]*$/m.test(t.vertex)
  ), t._uniformData = rT(n, s), t._uniformBlockData = iT(n, s), s.deleteShader(e), s.deleteShader(r);
  const l = {};
  for (const u in t._uniformData) {
    const f = t._uniformData[u];
    l[u] = {
      location: s.getUniformLocation(n, u),
      value: V_(f.type, f.size)
    };
  }
  return new QS(n, l);
}
const Xs = {
  textureCount: 0,
  blockIndex: 0
};
class Y_ {
  constructor(t) {
    this._activeProgram = null, this._programDataHash = /* @__PURE__ */ Object.create(null), this._shaderSyncFunctions = /* @__PURE__ */ Object.create(null), this._renderer = t, this._renderer.renderableGC.addManagedHash(this, "_programDataHash");
  }
  contextChange(t) {
    this._gl = t, this._programDataHash = /* @__PURE__ */ Object.create(null), this._shaderSyncFunctions = /* @__PURE__ */ Object.create(null), this._activeProgram = null;
  }
  /**
   * Changes the current shader to the one given in parameter.
   * @param shader - the new shader
   * @param skipSync - false if the shader should automatically sync its uniforms.
   * @returns the glProgram that belongs to the shader.
   */
  bind(t, e) {
    if (this._setProgram(t.glProgram), e)
      return;
    Xs.textureCount = 0, Xs.blockIndex = 0;
    let r = this._shaderSyncFunctions[t.glProgram._key];
    r || (r = this._shaderSyncFunctions[t.glProgram._key] = this._generateShaderSync(t, this)), this._renderer.buffer.nextBindBase(!!t.glProgram.transformFeedbackVaryings), r(this._renderer, t, Xs);
  }
  /**
   * Updates the uniform group.
   * @param uniformGroup - the uniform group to update
   */
  updateUniformGroup(t) {
    this._renderer.uniformGroup.updateUniformGroup(t, this._activeProgram, Xs);
  }
  /**
   * Binds a uniform block to the shader.
   * @param uniformGroup - the uniform group to bind
   * @param name - the name of the uniform block
   * @param index - the index of the uniform block
   */
  bindUniformBlock(t, e, r = 0) {
    const n = this._renderer.buffer, a = this._getProgramData(this._activeProgram), l = t._bufferResource;
    l || this._renderer.ubo.updateUniformGroup(t);
    const h = t.buffer, u = n.updateBuffer(h), f = n.freeLocationForBufferBase(u);
    if (l) {
      const { offset: m, size: g } = t;
      m === 0 && g === h.data.byteLength ? n.bindBufferBase(u, f) : n.bindBufferRange(u, f, m);
    } else n.getLastBindBaseLocation(u) !== f && n.bindBufferBase(u, f);
    const p = this._activeProgram._uniformBlockData[e].index;
    a.uniformBlockBindings[r] !== f && (a.uniformBlockBindings[r] = f, this._renderer.gl.uniformBlockBinding(a.program, p, f));
  }
  _setProgram(t) {
    if (this._activeProgram === t)
      return;
    this._activeProgram = t;
    const e = this._getProgramData(t);
    this._gl.useProgram(e.program);
  }
  /**
   * @param program - the program to get the data for
   * @internal
   */
  _getProgramData(t) {
    return this._programDataHash[t._key] || this._createProgramData(t);
  }
  _createProgramData(t) {
    const e = t._key;
    return this._programDataHash[e] = nT(this._gl, t), this._programDataHash[e];
  }
  destroy() {
    for (const t of Object.keys(this._programDataHash))
      this._programDataHash[t].destroy(), this._programDataHash[t] = null;
    this._programDataHash = null;
  }
  /**
   * Creates a function that can be executed that will sync the shader as efficiently as possible.
   * Overridden by the unsafe eval package if you don't want eval used in your project.
   * @param shader - the shader to generate the sync function for
   * @param shaderSystem - the shader system to use
   * @returns - the generated sync function
   * @ignore
   */
  _generateShaderSync(t, e) {
    return ZS(t, e);
  }
  resetState() {
    this._activeProgram = null;
  }
}
Y_.extension = {
  type: [
    A.WebGLSystem
  ],
  name: "shader"
};
const aT = {
  f32: `if (cv !== v) {
            cu.value = v;
            gl.uniform1f(location, v);
        }`,
  "vec2<f32>": `if (cv[0] !== v[0] || cv[1] !== v[1]) {
            cv[0] = v[0];
            cv[1] = v[1];
            gl.uniform2f(location, v[0], v[1]);
        }`,
  "vec3<f32>": `if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2]) {
            cv[0] = v[0];
            cv[1] = v[1];
            cv[2] = v[2];
            gl.uniform3f(location, v[0], v[1], v[2]);
        }`,
  "vec4<f32>": `if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3]) {
            cv[0] = v[0];
            cv[1] = v[1];
            cv[2] = v[2];
            cv[3] = v[3];
            gl.uniform4f(location, v[0], v[1], v[2], v[3]);
        }`,
  i32: `if (cv !== v) {
            cu.value = v;
            gl.uniform1i(location, v);
        }`,
  "vec2<i32>": `if (cv[0] !== v[0] || cv[1] !== v[1]) {
            cv[0] = v[0];
            cv[1] = v[1];
            gl.uniform2i(location, v[0], v[1]);
        }`,
  "vec3<i32>": `if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2]) {
            cv[0] = v[0];
            cv[1] = v[1];
            cv[2] = v[2];
            gl.uniform3i(location, v[0], v[1], v[2]);
        }`,
  "vec4<i32>": `if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3]) {
            cv[0] = v[0];
            cv[1] = v[1];
            cv[2] = v[2];
            cv[3] = v[3];
            gl.uniform4i(location, v[0], v[1], v[2], v[3]);
        }`,
  u32: `if (cv !== v) {
            cu.value = v;
            gl.uniform1ui(location, v);
        }`,
  "vec2<u32>": `if (cv[0] !== v[0] || cv[1] !== v[1]) {
            cv[0] = v[0];
            cv[1] = v[1];
            gl.uniform2ui(location, v[0], v[1]);
        }`,
  "vec3<u32>": `if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2]) {
            cv[0] = v[0];
            cv[1] = v[1];
            cv[2] = v[2];
            gl.uniform3ui(location, v[0], v[1], v[2]);
        }`,
  "vec4<u32>": `if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3]) {
            cv[0] = v[0];
            cv[1] = v[1];
            cv[2] = v[2];
            cv[3] = v[3];
            gl.uniform4ui(location, v[0], v[1], v[2], v[3]);
        }`,
  bool: `if (cv !== v) {
            cu.value = v;
            gl.uniform1i(location, v);
        }`,
  "vec2<bool>": `if (cv[0] !== v[0] || cv[1] !== v[1]) {
            cv[0] = v[0];
            cv[1] = v[1];
            gl.uniform2i(location, v[0], v[1]);
        }`,
  "vec3<bool>": `if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2]) {
            cv[0] = v[0];
            cv[1] = v[1];
            cv[2] = v[2];
            gl.uniform3i(location, v[0], v[1], v[2]);
        }`,
  "vec4<bool>": `if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3]) {
            cv[0] = v[0];
            cv[1] = v[1];
            cv[2] = v[2];
            cv[3] = v[3];
            gl.uniform4i(location, v[0], v[1], v[2], v[3]);
        }`,
  "mat2x2<f32>": "gl.uniformMatrix2fv(location, false, v);",
  "mat3x3<f32>": "gl.uniformMatrix3fv(location, false, v);",
  "mat4x4<f32>": "gl.uniformMatrix4fv(location, false, v);"
}, oT = {
  f32: "gl.uniform1fv(location, v);",
  "vec2<f32>": "gl.uniform2fv(location, v);",
  "vec3<f32>": "gl.uniform3fv(location, v);",
  "vec4<f32>": "gl.uniform4fv(location, v);",
  "mat2x2<f32>": "gl.uniformMatrix2fv(location, false, v);",
  "mat3x3<f32>": "gl.uniformMatrix3fv(location, false, v);",
  "mat4x4<f32>": "gl.uniformMatrix4fv(location, false, v);",
  i32: "gl.uniform1iv(location, v);",
  "vec2<i32>": "gl.uniform2iv(location, v);",
  "vec3<i32>": "gl.uniform3iv(location, v);",
  "vec4<i32>": "gl.uniform4iv(location, v);",
  u32: "gl.uniform1iv(location, v);",
  "vec2<u32>": "gl.uniform2iv(location, v);",
  "vec3<u32>": "gl.uniform3iv(location, v);",
  "vec4<u32>": "gl.uniform4iv(location, v);",
  bool: "gl.uniform1iv(location, v);",
  "vec2<bool>": "gl.uniform2iv(location, v);",
  "vec3<bool>": "gl.uniform3iv(location, v);",
  "vec4<bool>": "gl.uniform4iv(location, v);"
};
function hT(s, t) {
  const e = [`
        var v = null;
        var cv = null;
        var cu = null;
        var t = 0;
        var gl = renderer.gl;
        var name = null;
    `];
  for (const r in s.uniforms) {
    if (!t[r]) {
      s.uniforms[r] instanceof kt ? s.uniforms[r].ubo ? e.push(`
                        renderer.shader.bindUniformBlock(uv.${r}, "${r}");
                    `) : e.push(`
                        renderer.shader.updateUniformGroup(uv.${r});
                    `) : s.uniforms[r] instanceof ll && e.push(`
                        renderer.shader.bindBufferResource(uv.${r}, "${r}");
                    `);
      continue;
    }
    const n = s.uniformStructures[r];
    let a = !1;
    for (let l = 0; l < Ei.length; l++) {
      const h = Ei[l];
      if (n.type === h.type && h.test(n)) {
        e.push(`name = "${r}";`, Ei[l].uniform), a = !0;
        break;
      }
    }
    if (!a) {
      const h = (n.size === 1 ? aT : oT)[n.type].replace("location", `ud["${r}"].location`);
      e.push(`
            cu = ud["${r}"];
            cv = cu.value;
            v = uv["${r}"];
            ${h};`);
    }
  }
  return new Function("ud", "uv", "renderer", "syncData", e.join(`
`));
}
class X_ {
  /** @param renderer - The renderer this System works for. */
  constructor(t) {
    this._cache = {}, this._uniformGroupSyncHash = {}, this._renderer = t, this.gl = null, this._cache = {};
  }
  contextChange(t) {
    this.gl = t;
  }
  /**
   * Uploads the uniforms values to the currently bound shader.
   * @param group - the uniforms values that be applied to the current shader
   * @param program
   * @param syncData
   * @param syncData.textureCount
   */
  updateUniformGroup(t, e, r) {
    const n = this._renderer.shader._getProgramData(e);
    (!t.isStatic || t._dirtyId !== n.uniformDirtyGroups[t.uid]) && (n.uniformDirtyGroups[t.uid] = t._dirtyId, this._getUniformSyncFunction(t, e)(n.uniformData, t.uniforms, this._renderer, r));
  }
  /**
   * Overridable by the pixi.js/unsafe-eval package to use static syncUniforms instead.
   * @param group
   * @param program
   */
  _getUniformSyncFunction(t, e) {
    return this._uniformGroupSyncHash[t._signature]?.[e._key] || this._createUniformSyncFunction(t, e);
  }
  _createUniformSyncFunction(t, e) {
    const r = this._uniformGroupSyncHash[t._signature] || (this._uniformGroupSyncHash[t._signature] = {}), n = this._getSignature(t, e._uniformData, "u");
    return this._cache[n] || (this._cache[n] = this._generateUniformsSync(t, e._uniformData)), r[e._key] = this._cache[n], r[e._key];
  }
  _generateUniformsSync(t, e) {
    return hT(t, e);
  }
  /**
   * Takes a uniform group and data and generates a unique signature for them.
   * @param group - The uniform group to get signature of
   * @param group.uniforms
   * @param uniformData - Uniform information generated by the shader
   * @param preFix
   * @returns Unique signature of the uniform group
   */
  _getSignature(t, e, r) {
    const n = t.uniforms, a = [`${r}-`];
    for (const l in n)
      a.push(l), e[l] && a.push(e[l].type);
    return a.join("-");
  }
  /** Destroys this System and removes all its textures. */
  destroy() {
    this._renderer = null, this._cache = null;
  }
}
X_.extension = {
  type: [
    A.WebGLSystem
  ],
  name: "uniformGroup"
};
function lT(s) {
  const t = {};
  if (t.normal = [s.ONE, s.ONE_MINUS_SRC_ALPHA], t.add = [s.ONE, s.ONE], t.multiply = [s.DST_COLOR, s.ONE_MINUS_SRC_ALPHA, s.ONE, s.ONE_MINUS_SRC_ALPHA], t.screen = [s.ONE, s.ONE_MINUS_SRC_COLOR, s.ONE, s.ONE_MINUS_SRC_ALPHA], t.none = [0, 0], t["normal-npm"] = [s.SRC_ALPHA, s.ONE_MINUS_SRC_ALPHA, s.ONE, s.ONE_MINUS_SRC_ALPHA], t["add-npm"] = [s.SRC_ALPHA, s.ONE, s.ONE, s.ONE], t["screen-npm"] = [s.SRC_ALPHA, s.ONE_MINUS_SRC_COLOR, s.ONE, s.ONE_MINUS_SRC_ALPHA], t.erase = [s.ZERO, s.ONE_MINUS_SRC_ALPHA], !(s instanceof Y.get().getWebGLRenderingContext()))
    t.min = [s.ONE, s.ONE, s.ONE, s.ONE, s.MIN, s.MIN], t.max = [s.ONE, s.ONE, s.ONE, s.ONE, s.MAX, s.MAX];
  else {
    const r = s.getExtension("EXT_blend_minmax");
    r && (t.min = [s.ONE, s.ONE, s.ONE, s.ONE, r.MIN_EXT, r.MIN_EXT], t.max = [s.ONE, s.ONE, s.ONE, s.ONE, r.MAX_EXT, r.MAX_EXT]);
  }
  return t;
}
const cT = 0, uT = 1, dT = 2, fT = 3, pT = 4, _T = 5, j_ = class Zo {
  constructor(t) {
    this._invertFrontFace = !1, this.gl = null, this.stateId = 0, this.polygonOffset = 0, this.blendMode = "none", this._blendEq = !1, this.map = [], this.map[cT] = this.setBlend, this.map[uT] = this.setOffset, this.map[dT] = this.setCullFace, this.map[fT] = this.setDepthTest, this.map[pT] = this.setFrontFace, this.map[_T] = this.setDepthMask, this.checks = [], this.defaultState = ye.for2d(), t.renderTarget.onRenderTargetChange.add(this);
  }
  onRenderTargetChange(t) {
    this._invertFrontFace = !t.isRoot, this._cullFace ? this.setFrontFace(this._frontFace) : this._frontFaceDirty = !0;
  }
  contextChange(t) {
    this.gl = t, this.blendModesMap = lT(t), this.resetState();
  }
  /**
   * Sets the current state
   * @param {*} state - The state to set.
   */
  set(t) {
    if (t || (t = this.defaultState), this.stateId !== t.data) {
      let e = this.stateId ^ t.data, r = 0;
      for (; e; )
        e & 1 && this.map[r].call(this, !!(t.data & 1 << r)), e >>= 1, r++;
      this.stateId = t.data;
    }
    for (let e = 0; e < this.checks.length; e++)
      this.checks[e](this, t);
  }
  /**
   * Sets the state, when previous state is unknown.
   * @param {*} state - The state to set
   */
  forceState(t) {
    t || (t = this.defaultState);
    for (let e = 0; e < this.map.length; e++)
      this.map[e].call(this, !!(t.data & 1 << e));
    for (let e = 0; e < this.checks.length; e++)
      this.checks[e](this, t);
    this.stateId = t.data;
  }
  /**
   * Sets whether to enable or disable blending.
   * @param value - Turn on or off WebGl blending.
   */
  setBlend(t) {
    this._updateCheck(Zo._checkBlendMode, t), this.gl[t ? "enable" : "disable"](this.gl.BLEND);
  }
  /**
   * Sets whether to enable or disable polygon offset fill.
   * @param value - Turn on or off webgl polygon offset testing.
   */
  setOffset(t) {
    this._updateCheck(Zo._checkPolygonOffset, t), this.gl[t ? "enable" : "disable"](this.gl.POLYGON_OFFSET_FILL);
  }
  /**
   * Sets whether to enable or disable depth test.
   * @param value - Turn on or off webgl depth testing.
   */
  setDepthTest(t) {
    this.gl[t ? "enable" : "disable"](this.gl.DEPTH_TEST);
  }
  /**
   * Sets whether to enable or disable depth mask.
   * @param value - Turn on or off webgl depth mask.
   */
  setDepthMask(t) {
    this.gl.depthMask(t);
  }
  /**
   * Sets whether to enable or disable cull face.
   * @param {boolean} value - Turn on or off webgl cull face.
   */
  setCullFace(t) {
    this._cullFace = t, this.gl[t ? "enable" : "disable"](this.gl.CULL_FACE), this._cullFace && this._frontFaceDirty && this.setFrontFace(this._frontFace);
  }
  /**
   * Sets the gl front face.
   * @param {boolean} value - true is clockwise and false is counter-clockwise
   */
  setFrontFace(t) {
    this._frontFace = t, this._frontFaceDirty = !1;
    const e = this._invertFrontFace ? !t : t;
    this._glFrontFace !== e && (this._glFrontFace = e, this.gl.frontFace(this.gl[e ? "CW" : "CCW"]));
  }
  /**
   * Sets the blend mode.
   * @param {number} value - The blend mode to set to.
   */
  setBlendMode(t) {
    if (this.blendModesMap[t] || (t = "normal"), t === this.blendMode)
      return;
    this.blendMode = t;
    const e = this.blendModesMap[t], r = this.gl;
    e.length === 2 ? r.blendFunc(e[0], e[1]) : r.blendFuncSeparate(e[0], e[1], e[2], e[3]), e.length === 6 ? (this._blendEq = !0, r.blendEquationSeparate(e[4], e[5])) : this._blendEq && (this._blendEq = !1, r.blendEquationSeparate(r.FUNC_ADD, r.FUNC_ADD));
  }
  /**
   * Sets the polygon offset.
   * @param {number} value - the polygon offset
   * @param {number} scale - the polygon offset scale
   */
  setPolygonOffset(t, e) {
    this.gl.polygonOffset(t, e);
  }
  /** Resets all the logic and disables the VAOs. */
  resetState() {
    this._glFrontFace = !1, this._frontFace = !1, this._cullFace = !1, this._frontFaceDirty = !1, this._invertFrontFace = !1, this.gl.frontFace(this.gl.CCW), this.gl.pixelStorei(this.gl.UNPACK_FLIP_Y_WEBGL, !1), this.forceState(this.defaultState), this._blendEq = !0, this.blendMode = "", this.setBlendMode("normal");
  }
  /**
   * Checks to see which updates should be checked based on which settings have been activated.
   *
   * For example, if blend is enabled then we should check the blend modes each time the state is changed
   * or if polygon fill is activated then we need to check if the polygon offset changes.
   * The idea is that we only check what we have too.
   * @param func - the checking function to add or remove
   * @param value - should the check function be added or removed.
   */
  _updateCheck(t, e) {
    const r = this.checks.indexOf(t);
    e && r === -1 ? this.checks.push(t) : !e && r !== -1 && this.checks.splice(r, 1);
  }
  /**
   * A private little wrapper function that we call to check the blend mode.
   * @param system - the System to perform the state check on
   * @param state - the state that the blendMode will pulled from
   */
  static _checkBlendMode(t, e) {
    t.setBlendMode(e.blendMode);
  }
  /**
   * A private little wrapper function that we call to check the polygon offset.
   * @param system - the System to perform the state check on
   * @param state - the state that the blendMode will pulled from
   */
  static _checkPolygonOffset(t, e) {
    t.setPolygonOffset(1, e.polygonOffset);
  }
  /** @ignore */
  destroy() {
    this.gl = null, this.checks.length = 0;
  }
};
j_.extension = {
  type: [
    A.WebGLSystem
  ],
  name: "state"
};
let mT = j_;
class gT {
  constructor(t) {
    this.target = A_.TEXTURE_2D, this.texture = t, this.width = -1, this.height = -1, this.type = j.UNSIGNED_BYTE, this.internalFormat = Ko.RGBA, this.format = Ko.RGBA, this.samplerType = 0;
  }
}
const yT = {
  id: "buffer",
  upload(s, t, e) {
    t.width === s.width || t.height === s.height ? e.texSubImage2D(
      e.TEXTURE_2D,
      0,
      0,
      0,
      s.width,
      s.height,
      t.format,
      t.type,
      s.resource
    ) : e.texImage2D(
      t.target,
      0,
      t.internalFormat,
      s.width,
      s.height,
      0,
      t.format,
      t.type,
      s.resource
    ), t.width = s.width, t.height = s.height;
  }
}, xT = {
  "bc1-rgba-unorm": !0,
  "bc1-rgba-unorm-srgb": !0,
  "bc2-rgba-unorm": !0,
  "bc2-rgba-unorm-srgb": !0,
  "bc3-rgba-unorm": !0,
  "bc3-rgba-unorm-srgb": !0,
  "bc4-r-unorm": !0,
  "bc4-r-snorm": !0,
  "bc5-rg-unorm": !0,
  "bc5-rg-snorm": !0,
  "bc6h-rgb-ufloat": !0,
  "bc6h-rgb-float": !0,
  "bc7-rgba-unorm": !0,
  "bc7-rgba-unorm-srgb": !0,
  // ETC2 compressed formats usable if "texture-compression-etc2" is both
  // supported by the device/user agent and enabled in requestDevice.
  "etc2-rgb8unorm": !0,
  "etc2-rgb8unorm-srgb": !0,
  "etc2-rgb8a1unorm": !0,
  "etc2-rgb8a1unorm-srgb": !0,
  "etc2-rgba8unorm": !0,
  "etc2-rgba8unorm-srgb": !0,
  "eac-r11unorm": !0,
  "eac-r11snorm": !0,
  "eac-rg11unorm": !0,
  "eac-rg11snorm": !0,
  // ASTC compressed formats usable if "texture-compression-astc" is both
  // supported by the device/user agent and enabled in requestDevice.
  "astc-4x4-unorm": !0,
  "astc-4x4-unorm-srgb": !0,
  "astc-5x4-unorm": !0,
  "astc-5x4-unorm-srgb": !0,
  "astc-5x5-unorm": !0,
  "astc-5x5-unorm-srgb": !0,
  "astc-6x5-unorm": !0,
  "astc-6x5-unorm-srgb": !0,
  "astc-6x6-unorm": !0,
  "astc-6x6-unorm-srgb": !0,
  "astc-8x5-unorm": !0,
  "astc-8x5-unorm-srgb": !0,
  "astc-8x6-unorm": !0,
  "astc-8x6-unorm-srgb": !0,
  "astc-8x8-unorm": !0,
  "astc-8x8-unorm-srgb": !0,
  "astc-10x5-unorm": !0,
  "astc-10x5-unorm-srgb": !0,
  "astc-10x6-unorm": !0,
  "astc-10x6-unorm-srgb": !0,
  "astc-10x8-unorm": !0,
  "astc-10x8-unorm-srgb": !0,
  "astc-10x10-unorm": !0,
  "astc-10x10-unorm-srgb": !0,
  "astc-12x10-unorm": !0,
  "astc-12x10-unorm-srgb": !0,
  "astc-12x12-unorm": !0,
  "astc-12x12-unorm-srgb": !0
}, bT = {
  id: "compressed",
  upload(s, t, e) {
    e.pixelStorei(e.UNPACK_ALIGNMENT, 4);
    let r = s.pixelWidth, n = s.pixelHeight;
    const a = !!xT[s.format];
    for (let l = 0; l < s.resource.length; l++) {
      const h = s.resource[l];
      a ? e.compressedTexImage2D(
        e.TEXTURE_2D,
        l,
        t.internalFormat,
        r,
        n,
        0,
        h
      ) : e.texImage2D(
        e.TEXTURE_2D,
        l,
        t.internalFormat,
        r,
        n,
        0,
        t.format,
        t.type,
        h
      ), r = Math.max(r >> 1, 1), n = Math.max(n >> 1, 1);
    }
  }
}, K_ = {
  id: "image",
  upload(s, t, e, r) {
    const n = t.width, a = t.height, l = s.pixelWidth, h = s.pixelHeight, u = s.resourceWidth, f = s.resourceHeight;
    u < l || f < h ? ((n !== l || a !== h) && e.texImage2D(
      t.target,
      0,
      t.internalFormat,
      l,
      h,
      0,
      t.format,
      t.type,
      null
    ), r === 2 ? e.texSubImage2D(
      e.TEXTURE_2D,
      0,
      0,
      0,
      u,
      f,
      t.format,
      t.type,
      s.resource
    ) : e.texSubImage2D(
      e.TEXTURE_2D,
      0,
      0,
      0,
      t.format,
      t.type,
      s.resource
    )) : n === l && a === h ? e.texSubImage2D(
      e.TEXTURE_2D,
      0,
      0,
      0,
      t.format,
      t.type,
      s.resource
    ) : r === 2 ? e.texImage2D(
      t.target,
      0,
      t.internalFormat,
      l,
      h,
      0,
      t.format,
      t.type,
      s.resource
    ) : e.texImage2D(
      t.target,
      0,
      t.internalFormat,
      t.format,
      t.type,
      s.resource
    ), t.width = l, t.height = h;
  }
}, vT = {
  id: "video",
  upload(s, t, e, r) {
    if (!s.isValid) {
      e.texImage2D(
        t.target,
        0,
        t.internalFormat,
        1,
        1,
        0,
        t.format,
        t.type,
        null
      );
      return;
    }
    K_.upload(s, t, e, r);
  }
}, Nu = {
  linear: 9729,
  nearest: 9728
}, wT = {
  linear: {
    linear: 9987,
    nearest: 9985
  },
  nearest: {
    linear: 9986,
    nearest: 9984
  }
}, Na = {
  "clamp-to-edge": 33071,
  repeat: 10497,
  "mirror-repeat": 33648
}, ST = {
  never: 512,
  less: 513,
  equal: 514,
  "less-equal": 515,
  greater: 516,
  "not-equal": 517,
  "greater-equal": 518,
  always: 519
};
function Hu(s, t, e, r, n, a, l, h) {
  const u = a;
  if (!h || s.addressModeU !== "repeat" || s.addressModeV !== "repeat" || s.addressModeW !== "repeat") {
    const f = Na[l ? "clamp-to-edge" : s.addressModeU], p = Na[l ? "clamp-to-edge" : s.addressModeV], m = Na[l ? "clamp-to-edge" : s.addressModeW];
    t[n](u, t.TEXTURE_WRAP_S, f), t[n](u, t.TEXTURE_WRAP_T, p), t.TEXTURE_WRAP_R && t[n](u, t.TEXTURE_WRAP_R, m);
  }
  if ((!h || s.magFilter !== "linear") && t[n](u, t.TEXTURE_MAG_FILTER, Nu[s.magFilter]), e) {
    if (!h || s.mipmapFilter !== "linear") {
      const f = wT[s.minFilter][s.mipmapFilter];
      t[n](u, t.TEXTURE_MIN_FILTER, f);
    }
  } else
    t[n](u, t.TEXTURE_MIN_FILTER, Nu[s.minFilter]);
  if (r && s.maxAnisotropy > 1) {
    const f = Math.min(s.maxAnisotropy, t.getParameter(r.MAX_TEXTURE_MAX_ANISOTROPY_EXT));
    t[n](u, r.TEXTURE_MAX_ANISOTROPY_EXT, f);
  }
  s.compare && t[n](u, t.TEXTURE_COMPARE_FUNC, ST[s.compare]);
}
function TT(s) {
  return {
    // 8-bit formats
    r8unorm: s.RED,
    r8snorm: s.RED,
    r8uint: s.RED,
    r8sint: s.RED,
    // 16-bit formats
    r16uint: s.RED,
    r16sint: s.RED,
    r16float: s.RED,
    rg8unorm: s.RG,
    rg8snorm: s.RG,
    rg8uint: s.RG,
    rg8sint: s.RG,
    // 32-bit formats
    r32uint: s.RED,
    r32sint: s.RED,
    r32float: s.RED,
    rg16uint: s.RG,
    rg16sint: s.RG,
    rg16float: s.RG,
    rgba8unorm: s.RGBA,
    "rgba8unorm-srgb": s.RGBA,
    // Packed 32-bit formats
    rgba8snorm: s.RGBA,
    rgba8uint: s.RGBA,
    rgba8sint: s.RGBA,
    bgra8unorm: s.RGBA,
    "bgra8unorm-srgb": s.RGBA,
    rgb9e5ufloat: s.RGB,
    rgb10a2unorm: s.RGBA,
    rg11b10ufloat: s.RGB,
    // 64-bit formats
    rg32uint: s.RG,
    rg32sint: s.RG,
    rg32float: s.RG,
    rgba16uint: s.RGBA,
    rgba16sint: s.RGBA,
    rgba16float: s.RGBA,
    // 128-bit formats
    rgba32uint: s.RGBA,
    rgba32sint: s.RGBA,
    rgba32float: s.RGBA,
    // Depth/stencil formats
    stencil8: s.STENCIL_INDEX8,
    depth16unorm: s.DEPTH_COMPONENT,
    depth24plus: s.DEPTH_COMPONENT,
    "depth24plus-stencil8": s.DEPTH_STENCIL,
    depth32float: s.DEPTH_COMPONENT,
    "depth32float-stencil8": s.DEPTH_STENCIL
  };
}
function CT(s, t) {
  let e = {}, r = s.RGBA;
  return s instanceof Y.get().getWebGLRenderingContext() ? t.srgb && (e = {
    "rgba8unorm-srgb": t.srgb.SRGB8_ALPHA8_EXT,
    "bgra8unorm-srgb": t.srgb.SRGB8_ALPHA8_EXT
  }) : (e = {
    "rgba8unorm-srgb": s.SRGB8_ALPHA8,
    "bgra8unorm-srgb": s.SRGB8_ALPHA8
  }, r = s.RGBA8), {
    // 8-bit formats
    r8unorm: s.R8,
    r8snorm: s.R8_SNORM,
    r8uint: s.R8UI,
    r8sint: s.R8I,
    // 16-bit formats
    r16uint: s.R16UI,
    r16sint: s.R16I,
    r16float: s.R16F,
    rg8unorm: s.RG8,
    rg8snorm: s.RG8_SNORM,
    rg8uint: s.RG8UI,
    rg8sint: s.RG8I,
    // 32-bit formats
    r32uint: s.R32UI,
    r32sint: s.R32I,
    r32float: s.R32F,
    rg16uint: s.RG16UI,
    rg16sint: s.RG16I,
    rg16float: s.RG16F,
    rgba8unorm: s.RGBA,
    ...e,
    // Packed 32-bit formats
    rgba8snorm: s.RGBA8_SNORM,
    rgba8uint: s.RGBA8UI,
    rgba8sint: s.RGBA8I,
    bgra8unorm: r,
    rgb9e5ufloat: s.RGB9_E5,
    rgb10a2unorm: s.RGB10_A2,
    rg11b10ufloat: s.R11F_G11F_B10F,
    // 64-bit formats
    rg32uint: s.RG32UI,
    rg32sint: s.RG32I,
    rg32float: s.RG32F,
    rgba16uint: s.RGBA16UI,
    rgba16sint: s.RGBA16I,
    rgba16float: s.RGBA16F,
    // 128-bit formats
    rgba32uint: s.RGBA32UI,
    rgba32sint: s.RGBA32I,
    rgba32float: s.RGBA32F,
    // Depth/stencil formats
    stencil8: s.STENCIL_INDEX8,
    depth16unorm: s.DEPTH_COMPONENT16,
    depth24plus: s.DEPTH_COMPONENT24,
    "depth24plus-stencil8": s.DEPTH24_STENCIL8,
    depth32float: s.DEPTH_COMPONENT32F,
    "depth32float-stencil8": s.DEPTH32F_STENCIL8,
    // Compressed formats
    ...t.s3tc ? {
      "bc1-rgba-unorm": t.s3tc.COMPRESSED_RGBA_S3TC_DXT1_EXT,
      "bc2-rgba-unorm": t.s3tc.COMPRESSED_RGBA_S3TC_DXT3_EXT,
      "bc3-rgba-unorm": t.s3tc.COMPRESSED_RGBA_S3TC_DXT5_EXT
    } : {},
    ...t.s3tc_sRGB ? {
      "bc1-rgba-unorm-srgb": t.s3tc_sRGB.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT,
      "bc2-rgba-unorm-srgb": t.s3tc_sRGB.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT,
      "bc3-rgba-unorm-srgb": t.s3tc_sRGB.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT
    } : {},
    ...t.rgtc ? {
      "bc4-r-unorm": t.rgtc.COMPRESSED_RED_RGTC1_EXT,
      "bc4-r-snorm": t.rgtc.COMPRESSED_SIGNED_RED_RGTC1_EXT,
      "bc5-rg-unorm": t.rgtc.COMPRESSED_RED_GREEN_RGTC2_EXT,
      "bc5-rg-snorm": t.rgtc.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT
    } : {},
    ...t.bptc ? {
      "bc6h-rgb-float": t.bptc.COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT,
      "bc6h-rgb-ufloat": t.bptc.COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT,
      "bc7-rgba-unorm": t.bptc.COMPRESSED_RGBA_BPTC_UNORM_EXT,
      "bc7-rgba-unorm-srgb": t.bptc.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT
    } : {},
    ...t.etc ? {
      "etc2-rgb8unorm": t.etc.COMPRESSED_RGB8_ETC2,
      "etc2-rgb8unorm-srgb": t.etc.COMPRESSED_SRGB8_ETC2,
      "etc2-rgb8a1unorm": t.etc.COMPRESSED_RGB8_PUNCHTHROUGH_ALPHA1_ETC2,
      "etc2-rgb8a1unorm-srgb": t.etc.COMPRESSED_SRGB8_PUNCHTHROUGH_ALPHA1_ETC2,
      "etc2-rgba8unorm": t.etc.COMPRESSED_RGBA8_ETC2_EAC,
      "etc2-rgba8unorm-srgb": t.etc.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC,
      "eac-r11unorm": t.etc.COMPRESSED_R11_EAC,
      // 'eac-r11snorm'
      "eac-rg11unorm": t.etc.COMPRESSED_SIGNED_RG11_EAC
      // 'eac-rg11snorm'
    } : {},
    ...t.astc ? {
      "astc-4x4-unorm": t.astc.COMPRESSED_RGBA_ASTC_4x4_KHR,
      "astc-4x4-unorm-srgb": t.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR,
      "astc-5x4-unorm": t.astc.COMPRESSED_RGBA_ASTC_5x4_KHR,
      "astc-5x4-unorm-srgb": t.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR,
      "astc-5x5-unorm": t.astc.COMPRESSED_RGBA_ASTC_5x5_KHR,
      "astc-5x5-unorm-srgb": t.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR,
      "astc-6x5-unorm": t.astc.COMPRESSED_RGBA_ASTC_6x5_KHR,
      "astc-6x5-unorm-srgb": t.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR,
      "astc-6x6-unorm": t.astc.COMPRESSED_RGBA_ASTC_6x6_KHR,
      "astc-6x6-unorm-srgb": t.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR,
      "astc-8x5-unorm": t.astc.COMPRESSED_RGBA_ASTC_8x5_KHR,
      "astc-8x5-unorm-srgb": t.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR,
      "astc-8x6-unorm": t.astc.COMPRESSED_RGBA_ASTC_8x6_KHR,
      "astc-8x6-unorm-srgb": t.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR,
      "astc-8x8-unorm": t.astc.COMPRESSED_RGBA_ASTC_8x8_KHR,
      "astc-8x8-unorm-srgb": t.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR,
      "astc-10x5-unorm": t.astc.COMPRESSED_RGBA_ASTC_10x5_KHR,
      "astc-10x5-unorm-srgb": t.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR,
      "astc-10x6-unorm": t.astc.COMPRESSED_RGBA_ASTC_10x6_KHR,
      "astc-10x6-unorm-srgb": t.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR,
      "astc-10x8-unorm": t.astc.COMPRESSED_RGBA_ASTC_10x8_KHR,
      "astc-10x8-unorm-srgb": t.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR,
      "astc-10x10-unorm": t.astc.COMPRESSED_RGBA_ASTC_10x10_KHR,
      "astc-10x10-unorm-srgb": t.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR,
      "astc-12x10-unorm": t.astc.COMPRESSED_RGBA_ASTC_12x10_KHR,
      "astc-12x10-unorm-srgb": t.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR,
      "astc-12x12-unorm": t.astc.COMPRESSED_RGBA_ASTC_12x12_KHR,
      "astc-12x12-unorm-srgb": t.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR
    } : {}
  };
}
function ET(s) {
  return {
    // 8-bit formats
    r8unorm: s.UNSIGNED_BYTE,
    r8snorm: s.BYTE,
    r8uint: s.UNSIGNED_BYTE,
    r8sint: s.BYTE,
    // 16-bit formats
    r16uint: s.UNSIGNED_SHORT,
    r16sint: s.SHORT,
    r16float: s.HALF_FLOAT,
    rg8unorm: s.UNSIGNED_BYTE,
    rg8snorm: s.BYTE,
    rg8uint: s.UNSIGNED_BYTE,
    rg8sint: s.BYTE,
    // 32-bit formats
    r32uint: s.UNSIGNED_INT,
    r32sint: s.INT,
    r32float: s.FLOAT,
    rg16uint: s.UNSIGNED_SHORT,
    rg16sint: s.SHORT,
    rg16float: s.HALF_FLOAT,
    rgba8unorm: s.UNSIGNED_BYTE,
    "rgba8unorm-srgb": s.UNSIGNED_BYTE,
    // Packed 32-bit formats
    rgba8snorm: s.BYTE,
    rgba8uint: s.UNSIGNED_BYTE,
    rgba8sint: s.BYTE,
    bgra8unorm: s.UNSIGNED_BYTE,
    "bgra8unorm-srgb": s.UNSIGNED_BYTE,
    rgb9e5ufloat: s.UNSIGNED_INT_5_9_9_9_REV,
    rgb10a2unorm: s.UNSIGNED_INT_2_10_10_10_REV,
    rg11b10ufloat: s.UNSIGNED_INT_10F_11F_11F_REV,
    // 64-bit formats
    rg32uint: s.UNSIGNED_INT,
    rg32sint: s.INT,
    rg32float: s.FLOAT,
    rgba16uint: s.UNSIGNED_SHORT,
    rgba16sint: s.SHORT,
    rgba16float: s.HALF_FLOAT,
    // 128-bit formats
    rgba32uint: s.UNSIGNED_INT,
    rgba32sint: s.INT,
    rgba32float: s.FLOAT,
    // Depth/stencil formats
    stencil8: s.UNSIGNED_BYTE,
    depth16unorm: s.UNSIGNED_SHORT,
    depth24plus: s.UNSIGNED_INT,
    "depth24plus-stencil8": s.UNSIGNED_INT_24_8,
    depth32float: s.FLOAT,
    "depth32float-stencil8": s.FLOAT_32_UNSIGNED_INT_24_8_REV
  };
}
const AT = 4;
class q_ {
  constructor(t) {
    this.managedTextures = [], this._glTextures = /* @__PURE__ */ Object.create(null), this._glSamplers = /* @__PURE__ */ Object.create(null), this._boundTextures = [], this._activeTextureLocation = -1, this._boundSamplers = /* @__PURE__ */ Object.create(null), this._uploads = {
      image: K_,
      buffer: yT,
      video: vT,
      compressed: bT
    }, this._premultiplyAlpha = !1, this._useSeparateSamplers = !1, this._renderer = t, this._renderer.renderableGC.addManagedHash(this, "_glTextures"), this._renderer.renderableGC.addManagedHash(this, "_glSamplers");
  }
  contextChange(t) {
    this._gl = t, this._mapFormatToInternalFormat || (this._mapFormatToInternalFormat = CT(t, this._renderer.context.extensions), this._mapFormatToType = ET(t), this._mapFormatToFormat = TT(t)), this._glTextures = /* @__PURE__ */ Object.create(null), this._glSamplers = /* @__PURE__ */ Object.create(null), this._boundSamplers = /* @__PURE__ */ Object.create(null), this._premultiplyAlpha = !1;
    for (let e = 0; e < 16; e++)
      this.bind(k.EMPTY, e);
  }
  initSource(t) {
    this.bind(t);
  }
  bind(t, e = 0) {
    const r = t.source;
    t ? (this.bindSource(r, e), this._useSeparateSamplers && this._bindSampler(r.style, e)) : (this.bindSource(null, e), this._useSeparateSamplers && this._bindSampler(null, e));
  }
  bindSource(t, e = 0) {
    const r = this._gl;
    if (t._touched = this._renderer.textureGC.count, this._boundTextures[e] !== t) {
      this._boundTextures[e] = t, this._activateLocation(e), t || (t = k.EMPTY.source);
      const n = this.getGlSource(t);
      r.bindTexture(n.target, n.texture);
    }
  }
  _bindSampler(t, e = 0) {
    const r = this._gl;
    if (!t) {
      this._boundSamplers[e] = null, r.bindSampler(e, null);
      return;
    }
    const n = this._getGlSampler(t);
    this._boundSamplers[e] !== n && (this._boundSamplers[e] = n, r.bindSampler(e, n));
  }
  unbind(t) {
    const e = t.source, r = this._boundTextures, n = this._gl;
    for (let a = 0; a < r.length; a++)
      if (r[a] === e) {
        this._activateLocation(a);
        const l = this.getGlSource(e);
        n.bindTexture(l.target, null), r[a] = null;
      }
  }
  _activateLocation(t) {
    this._activeTextureLocation !== t && (this._activeTextureLocation = t, this._gl.activeTexture(this._gl.TEXTURE0 + t));
  }
  _initSource(t) {
    const e = this._gl, r = new gT(e.createTexture());
    if (r.type = this._mapFormatToType[t.format], r.internalFormat = this._mapFormatToInternalFormat[t.format], r.format = this._mapFormatToFormat[t.format], t.autoGenerateMipmaps && (this._renderer.context.supports.nonPowOf2mipmaps || t.isPowerOfTwo)) {
      const n = Math.max(t.width, t.height);
      t.mipLevelCount = Math.floor(Math.log2(n)) + 1;
    }
    return this._glTextures[t.uid] = r, this.managedTextures.includes(t) || (t.on("update", this.onSourceUpdate, this), t.on("resize", this.onSourceUpdate, this), t.on("styleChange", this.onStyleChange, this), t.on("destroy", this.onSourceDestroy, this), t.on("unload", this.onSourceUnload, this), t.on("updateMipmaps", this.onUpdateMipmaps, this), this.managedTextures.push(t)), this.onSourceUpdate(t), this.updateStyle(t, !1), r;
  }
  onStyleChange(t) {
    this.updateStyle(t, !1);
  }
  updateStyle(t, e) {
    const r = this._gl, n = this.getGlSource(t);
    r.bindTexture(r.TEXTURE_2D, n.texture), this._boundTextures[this._activeTextureLocation] = t, Hu(
      t.style,
      r,
      t.mipLevelCount > 1,
      this._renderer.context.extensions.anisotropicFiltering,
      "texParameteri",
      r.TEXTURE_2D,
      // will force a clamp to edge if the texture is not a power of two
      !this._renderer.context.supports.nonPowOf2wrapping && !t.isPowerOfTwo,
      e
    );
  }
  onSourceUnload(t) {
    const e = this._glTextures[t.uid];
    e && (this.unbind(t), this._glTextures[t.uid] = null, this._gl.deleteTexture(e.texture));
  }
  onSourceUpdate(t) {
    const e = this._gl, r = this.getGlSource(t);
    e.bindTexture(e.TEXTURE_2D, r.texture), this._boundTextures[this._activeTextureLocation] = t;
    const n = t.alphaMode === "premultiply-alpha-on-upload";
    this._premultiplyAlpha !== n && (this._premultiplyAlpha = n, e.pixelStorei(e.UNPACK_PREMULTIPLY_ALPHA_WEBGL, n)), this._uploads[t.uploadMethodId] ? this._uploads[t.uploadMethodId].upload(t, r, e, this._renderer.context.webGLVersion) : e.texImage2D(e.TEXTURE_2D, 0, e.RGBA, t.pixelWidth, t.pixelHeight, 0, e.RGBA, e.UNSIGNED_BYTE, null), t.autoGenerateMipmaps && t.mipLevelCount > 1 && this.onUpdateMipmaps(t, !1);
  }
  onUpdateMipmaps(t, e = !0) {
    e && this.bindSource(t, 0);
    const r = this.getGlSource(t);
    this._gl.generateMipmap(r.target);
  }
  onSourceDestroy(t) {
    t.off("destroy", this.onSourceDestroy, this), t.off("update", this.onSourceUpdate, this), t.off("resize", this.onSourceUpdate, this), t.off("unload", this.onSourceUnload, this), t.off("styleChange", this.onStyleChange, this), t.off("updateMipmaps", this.onUpdateMipmaps, this), this.managedTextures.splice(this.managedTextures.indexOf(t), 1), this.onSourceUnload(t);
  }
  _initSampler(t) {
    const e = this._gl, r = this._gl.createSampler();
    return this._glSamplers[t._resourceId] = r, Hu(
      t,
      e,
      this._boundTextures[this._activeTextureLocation].mipLevelCount > 1,
      this._renderer.context.extensions.anisotropicFiltering,
      "samplerParameteri",
      r,
      !1,
      !0
    ), this._glSamplers[t._resourceId];
  }
  _getGlSampler(t) {
    return this._glSamplers[t._resourceId] || this._initSampler(t);
  }
  getGlSource(t) {
    return this._glTextures[t.uid] || this._initSource(t);
  }
  generateCanvas(t) {
    const { pixels: e, width: r, height: n } = this.getPixels(t), a = Y.get().createCanvas();
    a.width = r, a.height = n;
    const l = a.getContext("2d");
    if (l) {
      const h = l.createImageData(r, n);
      h.data.set(e), l.putImageData(h, 0, 0);
    }
    return a;
  }
  getPixels(t) {
    const e = t.source.resolution, r = t.frame, n = Math.max(Math.round(r.width * e), 1), a = Math.max(Math.round(r.height * e), 1), l = new Uint8Array(AT * n * a), h = this._renderer, u = h.renderTarget.getRenderTarget(t), f = h.renderTarget.getGpuRenderTarget(u), p = h.gl;
    return p.bindFramebuffer(p.FRAMEBUFFER, f.resolveTargetFramebuffer), p.readPixels(
      Math.round(r.x * e),
      Math.round(r.y * e),
      n,
      a,
      p.RGBA,
      p.UNSIGNED_BYTE,
      l
    ), { pixels: new Uint8ClampedArray(l.buffer), width: n, height: a };
  }
  destroy() {
    this.managedTextures.slice().forEach((t) => this.onSourceDestroy(t)), this.managedTextures = null, this._renderer = null;
  }
  resetState() {
    this._activeTextureLocation = -1, this._boundTextures.fill(k.EMPTY.source), this._boundSamplers = /* @__PURE__ */ Object.create(null);
    const t = this._gl;
    this._premultiplyAlpha = !1, t.pixelStorei(t.UNPACK_PREMULTIPLY_ALPHA_WEBGL, this._premultiplyAlpha);
  }
}
q_.extension = {
  type: [
    A.WebGLSystem
  ],
  name: "texture"
};
class Z_ {
  contextChange(t) {
    const e = new kt({
      uColor: { value: new Float32Array([1, 1, 1, 1]), type: "vec4<f32>" },
      uTransformMatrix: { value: new D(), type: "mat3x3<f32>" },
      uRound: { value: 0, type: "f32" }
    }), r = t.limits.maxBatchableTextures, n = bs({
      name: "graphics",
      bits: [
        Wh,
        $h(r),
        al,
        ws
      ]
    });
    this.shader = new ue({
      glProgram: n,
      resources: {
        localUniforms: e,
        batchSamplers: Yh(r)
      }
    });
  }
  execute(t, e) {
    const r = e.context, n = r.customShader || this.shader, a = t.renderer, l = a.graphicsContext, {
      batcher: h,
      instructions: u
    } = l.getContextRenderData(r);
    n.groups[0] = a.globalUniforms.bindGroup, a.state.set(t.state), a.shader.bind(n), a.geometry.bind(h.geometry, n.glProgram);
    const f = u.instructions;
    for (let p = 0; p < u.instructionSize; p++) {
      const m = f[p];
      if (m.size) {
        for (let g = 0; g < m.textures.count; g++)
          a.texture.bind(m.textures.textures[g], g);
        a.geometry.draw(m.topology, m.size, m.start);
      }
    }
  }
  destroy() {
    this.shader.destroy(!0), this.shader = null;
  }
}
Z_.extension = {
  type: [
    A.WebGLPipesAdaptor
  ],
  name: "graphics"
};
class Q_ {
  init() {
    const t = bs({
      name: "mesh",
      bits: [
        al,
        IS,
        ws
      ]
    });
    this._shader = new ue({
      glProgram: t,
      resources: {
        uTexture: k.EMPTY.source,
        textureUniforms: {
          uTextureMatrix: { type: "mat3x3<f32>", value: new D() }
        }
      }
    });
  }
  execute(t, e) {
    const r = t.renderer;
    let n = e._shader;
    if (n) {
      if (!n.glProgram) {
        N("Mesh shader has no glProgram", e.shader);
        return;
      }
    } else {
      n = this._shader;
      const a = e.texture, l = a.source;
      n.resources.uTexture = l, n.resources.uSampler = l.style, n.resources.textureUniforms.uniforms.uTextureMatrix = a.textureMatrix.mapCoord;
    }
    n.groups[100] = r.globalUniforms.bindGroup, n.groups[101] = t.localUniformsBindGroup, r.encoder.draw({
      geometry: e._geometry,
      shader: n,
      state: e.state
    });
  }
  destroy() {
    this._shader.destroy(!0), this._shader = null;
  }
}
Q_.extension = {
  type: [
    A.WebGLPipesAdaptor
  ],
  name: "mesh"
};
class J_ {
  constructor(t) {
    this._renderer = t;
  }
  updateRenderable() {
  }
  destroyRenderable() {
  }
  validateRenderable() {
    return !1;
  }
  addRenderable(t, e) {
    this._renderer.renderPipes.batch.break(e), e.add(t);
  }
  execute(t) {
    t.isRenderable && t.render(this._renderer);
  }
  destroy() {
    this._renderer = null;
  }
}
J_.extension = {
  type: [
    A.WebGLPipes,
    A.WebGPUPipes,
    A.CanvasPipes
  ],
  name: "customRender"
};
class Yn {
  constructor() {
    this.batcherName = "default", this.topology = "triangle-list", this.attributeSize = 4, this.indexSize = 6, this.packAsQuad = !0, this.roundPixels = 0, this._attributeStart = 0, this._batcher = null, this._batch = null;
  }
  get blendMode() {
    return this.renderable.groupBlendMode;
  }
  get color() {
    return this.renderable.groupColorAlpha;
  }
  reset() {
    this.renderable = null, this.texture = null, this._batcher = null, this._batch = null, this.bounds = null;
  }
  destroy() {
  }
}
function Qo(s, t) {
  const e = s.instructionSet, r = e.instructions;
  for (let n = 0; n < e.instructionSize; n++) {
    const a = r[n];
    t[a.renderPipeId].execute(a);
  }
}
const PT = new D();
class tm {
  constructor(t) {
    this._renderer = t;
  }
  addRenderGroup(t, e) {
    t.isCachedAsTexture ? this._addRenderableCacheAsTexture(t, e) : this._addRenderableDirect(t, e);
  }
  execute(t) {
    t.isRenderable && (t.isCachedAsTexture ? this._executeCacheAsTexture(t) : this._executeDirect(t));
  }
  destroy() {
    this._renderer = null;
  }
  _addRenderableDirect(t, e) {
    this._renderer.renderPipes.batch.break(e), t._batchableRenderGroup && (Ct.return(t._batchableRenderGroup), t._batchableRenderGroup = null), e.add(t);
  }
  _addRenderableCacheAsTexture(t, e) {
    const r = t._batchableRenderGroup ?? (t._batchableRenderGroup = Ct.get(Yn));
    r.renderable = t.root, r.transform = t.root.relativeGroupTransform, r.texture = t.texture, r.bounds = t._textureBounds, e.add(t), this._renderer.renderPipes.batch.addToBatch(r, e);
  }
  _executeCacheAsTexture(t) {
    if (t.textureNeedsUpdate) {
      t.textureNeedsUpdate = !1;
      const e = PT.identity().translate(
        -t._textureBounds.x,
        -t._textureBounds.y
      );
      this._renderer.renderTarget.push(t.texture, !0, null, t.texture.frame), this._renderer.globalUniforms.push({
        worldTransformMatrix: e,
        worldColor: 4294967295
      }), Qo(t, this._renderer.renderPipes), this._renderer.renderTarget.finishRenderPass(), this._renderer.renderTarget.pop(), this._renderer.globalUniforms.pop();
    }
    t._batchableRenderGroup._batcher.updateElement(t._batchableRenderGroup), t._batchableRenderGroup._batcher.geometry.buffers[0].update();
  }
  _executeDirect(t) {
    this._renderer.globalUniforms.push({
      worldTransformMatrix: t.inverseParentTextureTransform,
      worldColor: t.worldColorAlpha
    }), Qo(t, this._renderer.renderPipes), this._renderer.globalUniforms.pop();
  }
}
tm.extension = {
  type: [
    A.WebGLPipes,
    A.WebGPUPipes,
    A.CanvasPipes
  ],
  name: "renderGroup"
};
function Jo(s, t) {
  t || (t = 0);
  for (let e = t; e < s.length && s[e]; e++)
    s[e] = null;
}
const MT = new St(), Wu = Yr | Tn | kh;
function em(s, t = !1) {
  BT(s);
  const e = s.childrenToUpdate, r = s.updateTick++;
  for (const n in e) {
    const a = Number(n), l = e[n], h = l.list, u = l.index;
    for (let f = 0; f < u; f++) {
      const p = h[f];
      p.parentRenderGroup === s && p.relativeRenderGroupDepth === a && im(p, r, 0);
    }
    Jo(h, u), l.index = 0;
  }
  if (t)
    for (let n = 0; n < s.renderGroupChildren.length; n++)
      em(s.renderGroupChildren[n], t);
}
function BT(s) {
  const t = s.root;
  let e;
  if (s.renderGroupParent) {
    const r = s.renderGroupParent;
    s.worldTransform.appendFrom(
      t.relativeGroupTransform,
      r.worldTransform
    ), s.worldColor = Sn(
      t.groupColor,
      r.worldColor
    ), e = t.groupAlpha * r.worldAlpha;
  } else
    s.worldTransform.copyFrom(t.localTransform), s.worldColor = t.localColor, e = t.localAlpha;
  e = e < 0 ? 0 : e > 1 ? 1 : e, s.worldAlpha = e, s.worldColorAlpha = s.worldColor + ((e * 255 | 0) << 24);
}
function im(s, t, e) {
  if (t === s.updateTick)
    return;
  s.updateTick = t, s.didChange = !1;
  const r = s.localTransform;
  s.updateLocalTransform();
  const n = s.parent;
  if (n && !n.renderGroup ? (e |= s._updateFlags, s.relativeGroupTransform.appendFrom(
    r,
    n.relativeGroupTransform
  ), e & Wu && Vu(s, n, e)) : (e = s._updateFlags, s.relativeGroupTransform.copyFrom(r), e & Wu && Vu(s, MT, e)), !s.renderGroup) {
    const a = s.children, l = a.length;
    for (let f = 0; f < l; f++)
      im(a[f], t, e);
    const h = s.parentRenderGroup, u = s;
    u.renderPipeId && !h.structureDidChange && h.updateRenderable(u);
  }
}
function Vu(s, t, e) {
  if (e & Tn) {
    s.groupColor = Sn(
      s.localColor,
      t.groupColor
    );
    let r = s.localAlpha * t.groupAlpha;
    r = r < 0 ? 0 : r > 1 ? 1 : r, s.groupAlpha = r, s.groupColorAlpha = s.groupColor + ((r * 255 | 0) << 24);
  }
  e & kh && (s.groupBlendMode = s.localBlendMode === "inherit" ? t.groupBlendMode : s.localBlendMode), e & Yr && (s.globalDisplayStatus = s.localDisplayStatus & t.globalDisplayStatus), s._updateFlags = 0;
}
function UT(s, t) {
  const { list: e, index: r } = s.childrenRenderablesToUpdate;
  let n = !1;
  for (let a = 0; a < r; a++) {
    const l = e[a];
    if (n = t[l.renderPipeId].validateRenderable(l), n)
      break;
  }
  return s.structureDidChange = n, n;
}
const RT = new D();
class rm {
  constructor(t) {
    this._renderer = t;
  }
  render({ container: t, transform: e }) {
    const r = t.parent, n = t.renderGroup.renderGroupParent;
    t.parent = null, t.renderGroup.renderGroupParent = null;
    const a = this._renderer;
    let l = RT;
    e && (l = l.copyFrom(t.renderGroup.localTransform), t.renderGroup.localTransform.copyFrom(e));
    const h = a.renderPipes;
    this._updateCachedRenderGroups(t.renderGroup, null), this._updateRenderGroups(t.renderGroup), a.globalUniforms.start({
      worldTransformMatrix: e ? t.renderGroup.localTransform : t.renderGroup.worldTransform,
      worldColor: t.renderGroup.worldColorAlpha
    }), Qo(t.renderGroup, h), h.uniformBatch && h.uniformBatch.renderEnd(), e && t.renderGroup.localTransform.copyFrom(l), t.parent = r, t.renderGroup.renderGroupParent = n;
  }
  destroy() {
    this._renderer = null;
  }
  _updateCachedRenderGroups(t, e) {
    if (t.isCachedAsTexture) {
      if (!t.updateCacheTexture)
        return;
      e = t;
    }
    t._parentCacheAsTextureRenderGroup = e;
    for (let r = t.renderGroupChildren.length - 1; r >= 0; r--)
      this._updateCachedRenderGroups(t.renderGroupChildren[r], e);
    if (t.invalidateMatrices(), t.isCachedAsTexture) {
      if (t.textureNeedsUpdate) {
        const r = t.root.getLocalBounds();
        r.ceil();
        const n = t.texture;
        t.texture && At.returnTexture(t.texture);
        const a = this._renderer, l = t.textureOptions.resolution || a.view.resolution, h = t.textureOptions.antialias ?? a.view.antialias;
        t.texture = At.getOptimalTexture(
          r.width,
          r.height,
          l,
          h
        ), t._textureBounds || (t._textureBounds = new Ut()), t._textureBounds.copyFrom(r), n !== t.texture && t.renderGroupParent && (t.renderGroupParent.structureDidChange = !0);
      }
    } else t.texture && (At.returnTexture(t.texture), t.texture = null);
  }
  _updateRenderGroups(t) {
    const e = this._renderer, r = e.renderPipes;
    if (t.runOnRender(e), t.instructionSet.renderPipes = r, t.structureDidChange ? Jo(t.childrenRenderablesToUpdate.list, 0) : UT(t, r), em(t), t.structureDidChange ? (t.structureDidChange = !1, this._buildInstructions(t, e)) : this._updateRenderables(t), t.childrenRenderablesToUpdate.index = 0, e.renderPipes.batch.upload(t.instructionSet), !(t.isCachedAsTexture && !t.textureNeedsUpdate))
      for (let n = 0; n < t.renderGroupChildren.length; n++)
        this._updateRenderGroups(t.renderGroupChildren[n]);
  }
  _updateRenderables(t) {
    const { list: e, index: r } = t.childrenRenderablesToUpdate;
    for (let n = 0; n < r; n++) {
      const a = e[n];
      a.didViewUpdate && t.updateRenderable(a);
    }
    Jo(e, r);
  }
  _buildInstructions(t, e) {
    const r = t.root, n = t.instructionSet;
    n.reset();
    const a = e.renderPipes ? e : e.batch.renderer, l = a.renderPipes;
    l.batch.buildStart(n), l.blendMode.buildStart(), l.colorMask.buildStart(), r.sortableChildren && r.sortChildren(), r.collectRenderablesWithEffects(n, a, null), l.batch.buildEnd(n), l.blendMode.buildEnd(n);
  }
}
rm.extension = {
  type: [
    A.WebGLSystem,
    A.WebGPUSystem,
    A.CanvasSystem
  ],
  name: "renderGroup"
};
class sm {
  constructor(t) {
    this._renderer = t;
  }
  addRenderable(t, e) {
    const r = this._getGpuSprite(t);
    t.didViewUpdate && this._updateBatchableSprite(t, r), this._renderer.renderPipes.batch.addToBatch(r, e);
  }
  updateRenderable(t) {
    const e = this._getGpuSprite(t);
    t.didViewUpdate && this._updateBatchableSprite(t, e), e._batcher.updateElement(e);
  }
  validateRenderable(t) {
    const e = this._getGpuSprite(t);
    return !e._batcher.checkAndUpdateTexture(
      e,
      t._texture
    );
  }
  _updateBatchableSprite(t, e) {
    e.bounds = t.visualBounds, e.texture = t._texture;
  }
  _getGpuSprite(t) {
    return t._gpuData[this._renderer.uid] || this._initGPUSprite(t);
  }
  _initGPUSprite(t) {
    const e = new Yn();
    return e.renderable = t, e.transform = t.groupTransform, e.texture = t._texture, e.bounds = t.visualBounds, e.roundPixels = this._renderer._roundPixels | t._roundPixels, t._gpuData[this._renderer.uid] = e, e;
  }
  destroy() {
    this._renderer = null;
  }
}
sm.extension = {
  type: [
    A.WebGLPipes,
    A.WebGPUPipes,
    A.CanvasPipes
  ],
  name: "sprite"
};
const cl = class nm {
  constructor() {
    this.clearBeforeRender = !0, this._backgroundColor = new Q(0), this.color = this._backgroundColor, this.alpha = 1;
  }
  /**
   * initiates the background system
   * @param options - the options for the background colors
   */
  init(t) {
    t = { ...nm.defaultOptions, ...t }, this.clearBeforeRender = t.clearBeforeRender, this.color = t.background || t.backgroundColor || this._backgroundColor, this.alpha = t.backgroundAlpha, this._backgroundColor.setAlpha(t.backgroundAlpha);
  }
  /** The background color to fill if not transparent */
  get color() {
    return this._backgroundColor;
  }
  set color(t) {
    this._backgroundColor.setValue(t);
  }
  /** The background color alpha. Setting this to 0 will make the canvas transparent. */
  get alpha() {
    return this._backgroundColor.alpha;
  }
  set alpha(t) {
    this._backgroundColor.setAlpha(t);
  }
  /** The background color as an [R, G, B, A] array. */
  get colorRgba() {
    return this._backgroundColor.toArray();
  }
  /**
   * destroys the background system
   * @internal
   */
  destroy() {
  }
};
cl.extension = {
  type: [
    A.WebGLSystem,
    A.WebGPUSystem,
    A.CanvasSystem
  ],
  name: "background",
  priority: 0
};
cl.defaultOptions = {
  /**
   * {@link WebGLOptions.backgroundAlpha}
   * @default 1
   */
  backgroundAlpha: 1,
  /**
   * {@link WebGLOptions.backgroundColor}
   * @default 0x000000
   */
  backgroundColor: 0,
  /**
   * {@link WebGLOptions.clearBeforeRender}
   * @default true
   */
  clearBeforeRender: !0
};
let IT = cl;
const Zr = {};
L.handle(A.BlendMode, (s) => {
  if (!s.name)
    throw new Error("BlendMode extension must have a name property");
  Zr[s.name] = s.ref;
}, (s) => {
  delete Zr[s.name];
});
class am {
  constructor(t) {
    this._isAdvanced = !1, this._filterHash = /* @__PURE__ */ Object.create(null), this._renderer = t, this._renderer.runners.prerender.add(this);
  }
  prerender() {
    this._activeBlendMode = "normal", this._isAdvanced = !1;
  }
  /**
   * This ensures that a blendMode switch is added to the instruction set if the blend mode has changed.
   * @param renderable - The renderable we are adding to the instruction set
   * @param blendMode - The blend mode of the renderable
   * @param instructionSet - The instruction set we are adding to
   */
  setBlendMode(t, e, r) {
    if (this._activeBlendMode === e) {
      this._isAdvanced && this._renderableList.push(t);
      return;
    }
    this._activeBlendMode = e, this._isAdvanced && this._endAdvancedBlendMode(r), this._isAdvanced = !!Zr[e], this._isAdvanced && (this._beginAdvancedBlendMode(r), this._renderableList.push(t));
  }
  _beginAdvancedBlendMode(t) {
    this._renderer.renderPipes.batch.break(t);
    const e = this._activeBlendMode;
    if (!Zr[e]) {
      N(`Unable to assign BlendMode: '${e}'. You may want to include: import 'pixi.js/advanced-blend-modes'`);
      return;
    }
    let r = this._filterHash[e];
    r || (r = this._filterHash[e] = new wn(), r.filters = [new Zr[e]()]);
    const n = {
      renderPipeId: "filter",
      action: "pushFilter",
      renderables: [],
      filterEffect: r,
      canBundle: !1
    };
    this._renderableList = n.renderables, t.add(n);
  }
  _endAdvancedBlendMode(t) {
    this._renderableList = null, this._renderer.renderPipes.batch.break(t), t.add({
      renderPipeId: "filter",
      action: "popFilter",
      canBundle: !1
    });
  }
  /**
   * called when the instruction build process is starting this will reset internally to the default blend mode
   * @internal
   */
  buildStart() {
    this._isAdvanced = !1;
  }
  /**
   * called when the instruction build process is finished, ensuring that if there is an advanced blend mode
   * active, we add the final render instructions added to the instruction set
   * @param instructionSet - The instruction set we are adding to
   * @internal
   */
  buildEnd(t) {
    this._isAdvanced && this._endAdvancedBlendMode(t);
  }
  /** @internal */
  destroy() {
    this._renderer = null, this._renderableList = null;
    for (const t in this._filterHash)
      this._filterHash[t].destroy();
    this._filterHash = null;
  }
}
am.extension = {
  type: [
    A.WebGLPipes,
    A.WebGPUPipes,
    A.CanvasPipes
  ],
  name: "blendMode"
};
const Ha = {
  png: "image/png",
  jpg: "image/jpeg",
  webp: "image/webp"
}, ul = class om {
  /** @param renderer - The renderer this System works for. */
  constructor(t) {
    this._renderer = t;
  }
  _normalizeOptions(t, e = {}) {
    return t instanceof St || t instanceof k ? {
      target: t,
      ...e
    } : {
      ...e,
      ...t
    };
  }
  /**
   * Creates an HTMLImageElement from a display object or texture.
   * @param options - Options for creating the image, or the target to extract
   * @returns Promise that resolves with the generated HTMLImageElement
   * @example
   * ```ts
   * // Basic usage with a sprite
   * const sprite = new Sprite(texture);
   * const image = await renderer.extract.image(sprite);
   * document.body.appendChild(image);
   *
   * // Advanced usage with options
   * const image = await renderer.extract.image({
   *     target: container,
   *     format: 'webp',
   *     quality: 0.8,
   *     frame: new Rectangle(0, 0, 100, 100),
   *     resolution: 2,
   *     clearColor: '#ff0000',
   *     antialias: true
   * });
   *
   * // Extract directly from a texture
   * const texture = Texture.from('myTexture.png');
   * const image = await renderer.extract.image(texture);
   * ```
   * @see {@link ExtractImageOptions} For detailed options
   * @see {@link ExtractSystem.base64} For base64 string output
   * @see {@link ExtractSystem.canvas} For canvas output
   * @category rendering
   */
  async image(t) {
    const e = new Image();
    return e.src = await this.base64(t), e;
  }
  /**
   * Converts the target into a base64 encoded string.
   *
   * This method works by first creating
   * a canvas using `Extract.canvas` and then converting it to a base64 string.
   * @param options - The options for creating the base64 string, or the target to extract
   * @returns Promise that resolves with the base64 encoded string
   * @example
   * ```ts
   * // Basic usage with a sprite
   * const sprite = new Sprite(texture);
   * const base64 = await renderer.extract.base64(sprite);
   * console.log(base64); // data:image/png;base64,...
   *
   * // Advanced usage with options
   * const base64 = await renderer.extract.base64({
   *     target: container,
   *     format: 'webp',
   *     quality: 0.8,
   *     frame: new Rectangle(0, 0, 100, 100),
   *     resolution: 2
   * });
   * ```
   * @throws Will throw an error if the platform doesn't support any of:
   * - ICanvas.toDataURL
   * - ICanvas.toBlob
   * - ICanvas.convertToBlob
   * @see {@link ExtractImageOptions} For detailed options
   * @see {@link ExtractSystem.canvas} For canvas output
   * @see {@link ExtractSystem.image} For HTMLImage output
   * @category rendering
   */
  async base64(t) {
    t = this._normalizeOptions(
      t,
      om.defaultImageOptions
    );
    const { format: e, quality: r } = t, n = this.canvas(t);
    if (n.toBlob !== void 0)
      return new Promise((a, l) => {
        n.toBlob((h) => {
          if (!h) {
            l(new Error("ICanvas.toBlob failed!"));
            return;
          }
          const u = new FileReader();
          u.onload = () => a(u.result), u.onerror = l, u.readAsDataURL(h);
        }, Ha[e], r);
      });
    if (n.toDataURL !== void 0)
      return n.toDataURL(Ha[e], r);
    if (n.convertToBlob !== void 0) {
      const a = await n.convertToBlob({ type: Ha[e], quality: r });
      return new Promise((l, h) => {
        const u = new FileReader();
        u.onload = () => l(u.result), u.onerror = h, u.readAsDataURL(a);
      });
    }
    throw new Error("Extract.base64() requires ICanvas.toDataURL, ICanvas.toBlob, or ICanvas.convertToBlob to be implemented");
  }
  /**
   * Creates a Canvas element, renders the target to it and returns it.
   * This method is useful for creating static images or when you need direct canvas access.
   * @param options - The options for creating the canvas, or the target to extract
   * @returns A Canvas element with the texture rendered on
   * @example
   * ```ts
   * // Basic canvas extraction from a sprite
   * const sprite = new Sprite(texture);
   * const canvas = renderer.extract.canvas(sprite);
   * document.body.appendChild(canvas);
   *
   * // Extract with custom region
   * const canvas = renderer.extract.canvas({
   *     target: container,
   *     frame: new Rectangle(0, 0, 100, 100)
   * });
   *
   * // Extract with high resolution
   * const canvas = renderer.extract.canvas({
   *     target: sprite,
   *     resolution: 2,
   *     clearColor: '#ff0000'
   * });
   *
   * // Extract directly from a texture
   * const texture = Texture.from('myTexture.png');
   * const canvas = renderer.extract.canvas(texture);
   *
   * // Extract with anti-aliasing
   * const canvas = renderer.extract.canvas({
   *     target: graphics,
   *     antialias: true
   * });
   * ```
   * @see {@link ExtractOptions} For detailed options
   * @see {@link ExtractSystem.image} For HTMLImage output
   * @see {@link ExtractSystem.pixels} For raw pixel data
   * @category rendering
   */
  canvas(t) {
    t = this._normalizeOptions(t);
    const e = t.target, r = this._renderer;
    if (e instanceof k)
      return r.texture.generateCanvas(e);
    const n = r.textureGenerator.generateTexture(t), a = r.texture.generateCanvas(n);
    return n.destroy(!0), a;
  }
  /**
   * Returns a one-dimensional array containing the pixel data of the entire texture in RGBA order,
   * with integer values between 0 and 255 (inclusive).
   * > [!NOE] The returned array is a flat Uint8Array where every 4 values represent RGBA
   * @param options - The options for extracting the image, or the target to extract
   * @returns One-dimensional Uint8Array containing the pixel data in RGBA format
   * @example
   * ```ts
   * // Basic pixel extraction
   * const sprite = new Sprite(texture);
   * const pixels = renderer.extract.pixels(sprite);
   * console.log(pixels[0], pixels[1], pixels[2], pixels[3]); // R,G,B,A values
   *
   * // Extract with custom region
   * const pixels = renderer.extract.pixels({
   *     target: sprite,
   *     frame: new Rectangle(0, 0, 100, 100)
   * });
   *
   * // Extract with high resolution
   * const pixels = renderer.extract.pixels({
   *     target: sprite,
   *     resolution: 2
   * });
   * ```
   * @see {@link ExtractOptions} For detailed options
   * @see {@link ExtractSystem.canvas} For canvas output
   * @see {@link ExtractSystem.image} For image output
   * @category rendering
   */
  pixels(t) {
    t = this._normalizeOptions(t);
    const e = t.target, r = this._renderer, n = e instanceof k ? e : r.textureGenerator.generateTexture(t), a = r.texture.getPixels(n);
    return e instanceof St && n.destroy(!0), a;
  }
  /**
   * Creates a texture from a display object or existing texture.
   *
   * This is useful for creating
   * reusable textures from rendered content or making copies of existing textures.
   * > [!NOTE] The returned texture should be destroyed when no longer needed
   * @param options - The options for creating the texture, or the target to extract
   * @returns A new texture containing the extracted content
   * @example
   * ```ts
   * // Basic texture extraction from a sprite
   * const sprite = new Sprite(texture);
   * const extractedTexture = renderer.extract.texture(sprite);
   *
   * // Extract with custom region
   * const regionTexture = renderer.extract.texture({
   *     target: container,
   *     frame: new Rectangle(0, 0, 100, 100)
   * });
   *
   * // Extract with high resolution
   * const hiResTexture = renderer.extract.texture({
   *     target: sprite,
   *     resolution: 2,
   *     clearColor: '#ff0000'
   * });
   *
   * // Create a new sprite from extracted texture
   * const newSprite = new Sprite(
   *     renderer.extract.texture({
   *         target: graphics,
   *         antialias: true
   *     })
   * );
   *
   * // Clean up when done
   * extractedTexture.destroy(true);
   * ```
   * @see {@link ExtractOptions} For detailed options
   * @see {@link Texture} For texture management
   * @see {@link GenerateTextureSystem} For texture generation
   * @category rendering
   */
  texture(t) {
    return t = this._normalizeOptions(t), t.target instanceof k ? t.target : this._renderer.textureGenerator.generateTexture(t);
  }
  /**
   * Extracts and downloads content from the renderer as an image file.
   * This is a convenient way to save screenshots or export rendered content.
   * > [!NOTE] The download will use PNG format regardless of the filename extension
   * @param options - The options for downloading and extracting the image, or the target to extract
   * @example
   * ```ts
   * // Basic download with default filename
   * const sprite = new Sprite(texture);
   * renderer.extract.download(sprite); // Downloads as 'image.png'
   *
   * // Download with custom filename
   * renderer.extract.download({
   *     target: sprite,
   *     filename: 'screenshot.png'
   * });
   *
   * // Download with custom region
   * renderer.extract.download({
   *     target: container,
   *     filename: 'region.png',
   *     frame: new Rectangle(0, 0, 100, 100)
   * });
   *
   * // Download with high resolution and background
   * renderer.extract.download({
   *     target: stage,
   *     filename: 'hd-screenshot.png',
   *     resolution: 2,
   *     clearColor: '#ff0000'
   * });
   *
   * // Download with anti-aliasing
   * renderer.extract.download({
   *     target: graphics,
   *     filename: 'smooth.png',
   *     antialias: true
   * });
   * ```
   * @see {@link ExtractDownloadOptions} For detailed options
   * @see {@link ExtractSystem.image} For creating images without download
   * @see {@link ExtractSystem.canvas} For canvas output
   * @category rendering
   */
  download(t) {
    t = this._normalizeOptions(t);
    const e = this.canvas(t), r = document.createElement("a");
    r.download = t.filename ?? "image.png", r.href = e.toDataURL("image/png"), document.body.appendChild(r), r.click(), document.body.removeChild(r);
  }
  /**
   * Logs the target to the console as an image. This is a useful way to debug what's happening in the renderer.
   * The image will be displayed in the browser's console using CSS background images.
   * @param options - The options for logging the image, or the target to log
   * @param options.width - The width of the logged image preview in the console (in pixels)
   * @example
   * ```ts
   * // Basic usage
   * const sprite = new Sprite(texture);
   * renderer.extract.log(sprite);
   * ```
   * @see {@link ExtractSystem.canvas} For getting raw canvas output
   * @see {@link ExtractSystem.pixels} For raw pixel data
   * @category rendering
   * @advanced
   */
  log(t) {
    const e = t.width ?? 200;
    t = this._normalizeOptions(t);
    const r = this.canvas(t), n = r.toDataURL();
    console.log(`[Pixi Texture] ${r.width}px ${r.height}px`);
    const a = [
      "font-size: 1px;",
      `padding: ${e}px 300px;`,
      `background: url(${n}) no-repeat;`,
      "background-size: contain;"
    ].join(" ");
    console.log("%c ", a);
  }
  destroy() {
    this._renderer = null;
  }
};
ul.extension = {
  type: [
    A.WebGLSystem,
    A.WebGPUSystem
  ],
  name: "extract"
};
ul.defaultImageOptions = {
  format: "png",
  quality: 1
};
let kT = ul;
class dl extends k {
  static create(t) {
    return new dl({
      source: new yt(t)
    });
  }
  /**
   * Resizes the render texture.
   * @param width - The new width of the render texture.
   * @param height - The new height of the render texture.
   * @param resolution - The new resolution of the render texture.
   * @returns This texture.
   */
  resize(t, e, r) {
    return this.source.resize(t, e, r), this;
  }
}
const FT = new Z(), DT = new Ut(), OT = [0, 0, 0, 0];
class hm {
  constructor(t) {
    this._renderer = t;
  }
  /**
   * Creates a texture from a display object that can be used for creating sprites and other textures.
   * This is particularly useful for optimizing performance when a complex container needs to be reused.
   * @param options - Generate texture options or a container to convert to texture
   * @returns A new RenderTexture containing the rendered display object
   * @example
   * ```ts
   * // Basic usage with a container
   * const container = new Container();
   * container.addChild(
   *     new Graphics()
   *         .circle(0, 0, 50)
   *         .fill('red')
   * );
   *
   * const texture = renderer.textureGenerator.generateTexture(container);
   *
   * // Advanced usage with options
   * const texture = renderer.textureGenerator.generateTexture({
   *     target: container,
   *     frame: new Rectangle(0, 0, 100, 100), // Specific region
   *     resolution: 2,                        // High DPI
   *     clearColor: '#ff0000',               // Red background
   *     antialias: true                      // Smooth edges
   * });
   *
   * // Create a sprite from the generated texture
   * const sprite = new Sprite(texture);
   *
   * // Clean up when done
   * texture.destroy(true);
   * ```
   * @see {@link GenerateTextureOptions} For detailed texture generation options
   * @see {@link RenderTexture} For the type of texture created
   * @category rendering
   */
  generateTexture(t) {
    t instanceof St && (t = {
      target: t,
      frame: void 0,
      textureSourceOptions: {},
      resolution: void 0
    });
    const e = t.resolution || this._renderer.resolution, r = t.antialias || this._renderer.view.antialias, n = t.target;
    let a = t.clearColor;
    a ? a = Array.isArray(a) && a.length === 4 ? a : Q.shared.setValue(a).toArray() : a = OT;
    const l = t.frame?.copyTo(FT) || Ih(n, DT).rectangle;
    l.width = Math.max(l.width, 1 / e) | 0, l.height = Math.max(l.height, 1 / e) | 0;
    const h = dl.create({
      ...t.textureSourceOptions,
      width: l.width,
      height: l.height,
      resolution: e,
      antialias: r
    }), u = D.shared.translate(-l.x, -l.y);
    return this._renderer.render({
      container: n,
      transform: u,
      target: h,
      clearColor: a
    }), h.source.updateMipmaps(), h;
  }
  destroy() {
    this._renderer = null;
  }
}
hm.extension = {
  type: [
    A.WebGLSystem,
    A.WebGPUSystem
  ],
  name: "textureGenerator"
};
function Ss(s, t, e) {
  const r = (s >> 24 & 255) / 255;
  t[e++] = (s & 255) / 255 * r, t[e++] = (s >> 8 & 255) / 255 * r, t[e++] = (s >> 16 & 255) / 255 * r, t[e++] = r;
}
class lm {
  constructor(t) {
    this._stackIndex = 0, this._globalUniformDataStack = [], this._uniformsPool = [], this._activeUniforms = [], this._bindGroupPool = [], this._activeBindGroups = [], this._renderer = t;
  }
  reset() {
    this._stackIndex = 0;
    for (let t = 0; t < this._activeUniforms.length; t++)
      this._uniformsPool.push(this._activeUniforms[t]);
    for (let t = 0; t < this._activeBindGroups.length; t++)
      this._bindGroupPool.push(this._activeBindGroups[t]);
    this._activeUniforms.length = 0, this._activeBindGroups.length = 0;
  }
  start(t) {
    this.reset(), this.push(t);
  }
  bind({
    size: t,
    projectionMatrix: e,
    worldTransformMatrix: r,
    worldColor: n,
    offset: a
  }) {
    const l = this._renderer.renderTarget.renderTarget, h = this._stackIndex ? this._globalUniformDataStack[this._stackIndex - 1] : {
      worldTransformMatrix: new D(),
      worldColor: 4294967295,
      offset: new et()
    }, u = {
      projectionMatrix: e || this._renderer.renderTarget.projectionMatrix,
      resolution: t || l.size,
      worldTransformMatrix: r || h.worldTransformMatrix,
      worldColor: n || h.worldColor,
      offset: a || h.offset,
      bindGroup: null
    }, f = this._uniformsPool.pop() || this._createUniforms();
    this._activeUniforms.push(f);
    const p = f.uniforms;
    p.uProjectionMatrix = u.projectionMatrix, p.uResolution = u.resolution, p.uWorldTransformMatrix.copyFrom(u.worldTransformMatrix), p.uWorldTransformMatrix.tx -= u.offset.x, p.uWorldTransformMatrix.ty -= u.offset.y, Ss(
      u.worldColor,
      p.uWorldColorAlpha,
      0
    ), f.update();
    let m;
    this._renderer.renderPipes.uniformBatch ? m = this._renderer.renderPipes.uniformBatch.getUniformBindGroup(f, !1) : (m = this._bindGroupPool.pop() || new He(), this._activeBindGroups.push(m), m.setResource(f, 0)), u.bindGroup = m, this._currentGlobalUniformData = u;
  }
  push(t) {
    this.bind(t), this._globalUniformDataStack[this._stackIndex++] = this._currentGlobalUniformData;
  }
  pop() {
    this._currentGlobalUniformData = this._globalUniformDataStack[--this._stackIndex - 1], this._renderer.type === ge.WEBGL && this._currentGlobalUniformData.bindGroup.resources[0].update();
  }
  get bindGroup() {
    return this._currentGlobalUniformData.bindGroup;
  }
  get globalUniformData() {
    return this._currentGlobalUniformData;
  }
  get uniformGroup() {
    return this._currentGlobalUniformData.bindGroup.resources[0];
  }
  _createUniforms() {
    return new kt({
      uProjectionMatrix: { value: new D(), type: "mat3x3<f32>" },
      uWorldTransformMatrix: { value: new D(), type: "mat3x3<f32>" },
      // TODO - someone smart - set this to be a unorm8x4 rather than a vec4<f32>
      uWorldColorAlpha: { value: new Float32Array(4), type: "vec4<f32>" },
      uResolution: { value: [0, 0], type: "vec2<f32>" }
    }, {
      isStatic: !0
    });
  }
  destroy() {
    this._renderer = null;
  }
}
lm.extension = {
  type: [
    A.WebGLSystem,
    A.WebGPUSystem,
    A.CanvasSystem
  ],
  name: "globalUniforms"
};
let LT = 1;
class cm {
  constructor() {
    this._tasks = [], this._offset = 0;
  }
  /** Initializes the scheduler system and starts the ticker. */
  init() {
    Ae.system.add(this._update, this);
  }
  /**
   * Schedules a repeating task.
   * @param func - The function to execute.
   * @param duration - The interval duration in milliseconds.
   * @param useOffset - this will spread out tasks so that they do not all run at the same time
   * @returns The unique identifier for the scheduled task.
   */
  repeat(t, e, r = !0) {
    const n = LT++;
    let a = 0;
    return r && (this._offset += 1e3, a = this._offset), this._tasks.push({
      func: t,
      duration: e,
      start: performance.now(),
      offset: a,
      last: performance.now(),
      repeat: !0,
      id: n
    }), n;
  }
  /**
   * Cancels a scheduled task.
   * @param id - The unique identifier of the task to cancel.
   */
  cancel(t) {
    for (let e = 0; e < this._tasks.length; e++)
      if (this._tasks[e].id === t) {
        this._tasks.splice(e, 1);
        return;
      }
  }
  /**
   * Updates and executes the scheduled tasks.
   * @private
   */
  _update() {
    const t = performance.now();
    for (let e = 0; e < this._tasks.length; e++) {
      const r = this._tasks[e];
      if (t - r.offset - r.last >= r.duration) {
        const n = t - r.start;
        r.func(n), r.last = t;
      }
    }
  }
  /**
   * Destroys the scheduler system and removes all tasks.
   * @internal
   */
  destroy() {
    Ae.system.remove(this._update, this), this._tasks.length = 0;
  }
}
cm.extension = {
  type: [
    A.WebGLSystem,
    A.WebGPUSystem,
    A.CanvasSystem
  ],
  name: "scheduler",
  priority: 0
};
let $u = !1;
function GT(s) {
  if (!$u) {
    if (Y.get().getNavigator().userAgent.toLowerCase().indexOf("chrome") > -1) {
      const t = [
        `%c  %c  %c  %c  %c PixiJS %c v${En} (${s}) http://www.pixijs.com/

`,
        "background: #E72264; padding:5px 0;",
        "background: #6CA2EA; padding:5px 0;",
        "background: #B5D33D; padding:5px 0;",
        "background: #FED23F; padding:5px 0;",
        "color: #FFFFFF; background: #E72264; padding:5px 0;",
        "color: #E72264; background: #FFFFFF; padding:5px 0;"
      ];
      globalThis.console.log(...t);
    } else globalThis.console && globalThis.console.log(`PixiJS ${En} - ${s} - http://www.pixijs.com/`);
    $u = !0;
  }
}
class fl {
  constructor(t) {
    this._renderer = t;
  }
  /**
   * It all starts here! This initiates every system, passing in the options for any system by name.
   * @param options - the config for the renderer and all its systems
   */
  init(t) {
    if (t.hello) {
      let e = this._renderer.name;
      this._renderer.type === ge.WEBGL && (e += ` ${this._renderer.context.webGLVersion}`), GT(e);
    }
  }
}
fl.extension = {
  type: [
    A.WebGLSystem,
    A.WebGPUSystem,
    A.CanvasSystem
  ],
  name: "hello",
  priority: -2
};
fl.defaultOptions = {
  /** {@link WebGLOptions.hello} */
  hello: !1
};
function zT(s) {
  let t = !1;
  for (const r in s)
    if (s[r] == null) {
      t = !0;
      break;
    }
  if (!t)
    return s;
  const e = /* @__PURE__ */ Object.create(null);
  for (const r in s) {
    const n = s[r];
    n && (e[r] = n);
  }
  return e;
}
function NT(s) {
  let t = 0;
  for (let e = 0; e < s.length; e++)
    s[e] == null ? t++ : s[e - t] = s[e];
  return s.length -= t, s;
}
let HT = 0;
const pl = class um {
  /**
   * Creates a new RenderableGCSystem instance.
   * @param renderer - The renderer this garbage collection system works for
   */
  constructor(t) {
    this._managedRenderables = [], this._managedHashes = [], this._managedArrays = [], this._renderer = t;
  }
  /**
   * Initializes the garbage collection system with the provided options.
   * @param options - Configuration options for the renderer
   */
  init(t) {
    t = { ...um.defaultOptions, ...t }, this.maxUnusedTime = t.renderableGCMaxUnusedTime, this._frequency = t.renderableGCFrequency, this.enabled = t.renderableGCActive;
  }
  /**
   * Gets whether the garbage collection system is currently enabled.
   * @returns True if GC is enabled, false otherwise
   */
  get enabled() {
    return !!this._handler;
  }
  /**
   * Enables or disables the garbage collection system.
   * When enabled, schedules periodic cleanup of resources.
   * When disabled, cancels all scheduled cleanups.
   */
  set enabled(t) {
    this.enabled !== t && (t ? (this._handler = this._renderer.scheduler.repeat(
      () => this.run(),
      this._frequency,
      !1
    ), this._hashHandler = this._renderer.scheduler.repeat(
      () => {
        for (const e of this._managedHashes)
          e.context[e.hash] = zT(e.context[e.hash]);
      },
      this._frequency
    ), this._arrayHandler = this._renderer.scheduler.repeat(
      () => {
        for (const e of this._managedArrays)
          NT(e.context[e.hash]);
      },
      this._frequency
    )) : (this._renderer.scheduler.cancel(this._handler), this._renderer.scheduler.cancel(this._hashHandler), this._renderer.scheduler.cancel(this._arrayHandler)));
  }
  /**
   * Adds a hash table to be managed by the garbage collector.
   * @param context - The object containing the hash table
   * @param hash - The property name of the hash table
   */
  addManagedHash(t, e) {
    this._managedHashes.push({ context: t, hash: e });
  }
  /**
   * Adds an array to be managed by the garbage collector.
   * @param context - The object containing the array
   * @param hash - The property name of the array
   */
  addManagedArray(t, e) {
    this._managedArrays.push({ context: t, hash: e });
  }
  /**
   * Updates the GC timestamp and tracking before rendering.
   * @param options - The render options
   * @param options.container - The container to render
   */
  prerender({
    container: t
  }) {
    this._now = performance.now(), t.renderGroup.gcTick = HT++, this._updateInstructionGCTick(t.renderGroup, t.renderGroup.gcTick);
  }
  /**
   * Starts tracking a renderable for garbage collection.
   * @param renderable - The renderable to track
   */
  addRenderable(t) {
    this.enabled && (t._lastUsed === -1 && (this._managedRenderables.push(t), t.once("destroyed", this._removeRenderable, this)), t._lastUsed = this._now);
  }
  /**
   * Performs garbage collection by cleaning up unused renderables.
   * Removes renderables that haven't been used for longer than maxUnusedTime.
   */
  run() {
    const t = this._now, e = this._managedRenderables, r = this._renderer.renderPipes;
    let n = 0;
    for (let a = 0; a < e.length; a++) {
      const l = e[a];
      if (l === null) {
        n++;
        continue;
      }
      const h = l.renderGroup ?? l.parentRenderGroup, u = h?.instructionSet?.gcTick ?? -1;
      if ((h?.gcTick ?? 0) === u && (l._lastUsed = t), t - l._lastUsed > this.maxUnusedTime) {
        if (!l.destroyed) {
          const f = r;
          h && (h.structureDidChange = !0), f[l.renderPipeId].destroyRenderable(l);
        }
        l._lastUsed = -1, n++, l.off("destroyed", this._removeRenderable, this);
      } else
        e[a - n] = l;
    }
    e.length -= n;
  }
  /** Cleans up the garbage collection system. Disables GC and removes all tracked resources. */
  destroy() {
    this.enabled = !1, this._renderer = null, this._managedRenderables.length = 0, this._managedHashes.length = 0, this._managedArrays.length = 0;
  }
  /**
   * Removes a renderable from being tracked when it's destroyed.
   * @param renderable - The renderable to stop tracking
   */
  _removeRenderable(t) {
    const e = this._managedRenderables.indexOf(t);
    e >= 0 && (t.off("destroyed", this._removeRenderable, this), this._managedRenderables[e] = null);
  }
  /**
   * Updates the GC tick counter for a render group and its children.
   * @param renderGroup - The render group to update
   * @param gcTick - The new tick value
   */
  _updateInstructionGCTick(t, e) {
    t.instructionSet.gcTick = e;
    for (const r of t.renderGroupChildren)
      this._updateInstructionGCTick(r, e);
  }
};
pl.extension = {
  type: [
    A.WebGLSystem,
    A.WebGPUSystem
  ],
  name: "renderableGC",
  priority: 0
};
pl.defaultOptions = {
  /** Enable/disable the garbage collector */
  renderableGCActive: !0,
  /** Time in ms before an unused resource is collected (default 1 minute) */
  renderableGCMaxUnusedTime: 6e4,
  /** How often to run garbage collection in ms (default 30 seconds) */
  renderableGCFrequency: 3e4
};
let WT = pl;
const _l = class dm {
  /** @param renderer - The renderer this System works for. */
  constructor(t) {
    this._renderer = t, this.count = 0, this.checkCount = 0;
  }
  init(t) {
    t = { ...dm.defaultOptions, ...t }, this.checkCountMax = t.textureGCCheckCountMax, this.maxIdle = t.textureGCAMaxIdle ?? t.textureGCMaxIdle, this.active = t.textureGCActive;
  }
  /**
   * Checks to see when the last time a texture was used.
   * If the texture has not been used for a specified amount of time, it will be removed from the GPU.
   */
  postrender() {
    this._renderer.renderingToScreen && (this.count++, this.active && (this.checkCount++, this.checkCount > this.checkCountMax && (this.checkCount = 0, this.run())));
  }
  /**
   * Checks to see when the last time a texture was used.
   * If the texture has not been used for a specified amount of time, it will be removed from the GPU.
   */
  run() {
    const t = this._renderer.texture.managedTextures;
    for (let e = 0; e < t.length; e++) {
      const r = t[e];
      r.autoGarbageCollect && r.resource && r._touched > -1 && this.count - r._touched > this.maxIdle && (r._touched = -1, r.unload());
    }
  }
  destroy() {
    this._renderer = null;
  }
};
_l.extension = {
  type: [
    A.WebGLSystem,
    A.WebGPUSystem
  ],
  name: "textureGC"
};
_l.defaultOptions = {
  /**
   * If set to true, this will enable the garbage collector on the GPU.
   * @default true
   */
  textureGCActive: !0,
  /**
   * @deprecated since 8.3.0
   * @see {@link TextureGCSystemOptions.textureGCMaxIdle}
   */
  textureGCAMaxIdle: null,
  /**
   * The maximum idle frames before a texture is destroyed by garbage collection.
   * @default 60 * 60
   */
  textureGCMaxIdle: 60 * 60,
  /**
   * Frames between two garbage collections.
   * @default 600
   */
  textureGCCheckCountMax: 600
};
let VT = _l;
const ml = class fm {
  /**
   * Whether CSS dimensions of canvas view should be resized to screen dimensions automatically.
   * This is only supported for HTMLCanvasElement and will be ignored if the canvas is an OffscreenCanvas.
   * @type {boolean}
   */
  get autoDensity() {
    return this.texture.source.autoDensity;
  }
  set autoDensity(t) {
    this.texture.source.autoDensity = t;
  }
  /** The resolution / device pixel ratio of the renderer. */
  get resolution() {
    return this.texture.source._resolution;
  }
  set resolution(t) {
    this.texture.source.resize(
      this.texture.source.width,
      this.texture.source.height,
      t
    );
  }
  /**
   * initiates the view system
   * @param options - the options for the view
   */
  init(t) {
    t = {
      ...fm.defaultOptions,
      ...t
    }, t.view && (W(K, "ViewSystem.view has been renamed to ViewSystem.canvas"), t.canvas = t.view), this.screen = new Z(0, 0, t.width, t.height), this.canvas = t.canvas || Y.get().createCanvas(), this.antialias = !!t.antialias, this.texture = G_(this.canvas, t), this.renderTarget = new qo({
      colorTextures: [this.texture],
      depth: !!t.depth,
      isRoot: !0
    }), this.texture.source.transparent = t.backgroundAlpha < 1, this.resolution = t.resolution;
  }
  /**
   * Resizes the screen and canvas to the specified dimensions.
   * @param desiredScreenWidth - The new width of the screen.
   * @param desiredScreenHeight - The new height of the screen.
   * @param resolution
   */
  resize(t, e, r) {
    this.texture.source.resize(t, e, r), this.screen.width = this.texture.frame.width, this.screen.height = this.texture.frame.height;
  }
  /**
   * Destroys this System and optionally removes the canvas from the dom.
   * @param {options | false} options - The options for destroying the view, or "false".
   * @example
   * viewSystem.destroy();
   * viewSystem.destroy(true);
   * viewSystem.destroy({ removeView: true });
   */
  destroy(t = !1) {
    (typeof t == "boolean" ? t : !!t?.removeView) && this.canvas.parentNode && this.canvas.parentNode.removeChild(this.canvas);
  }
};
ml.extension = {
  type: [
    A.WebGLSystem,
    A.WebGPUSystem,
    A.CanvasSystem
  ],
  name: "view",
  priority: 0
};
ml.defaultOptions = {
  /**
   * {@link WebGLOptions.width}
   * @default 800
   */
  width: 800,
  /**
   * {@link WebGLOptions.height}
   * @default 600
   */
  height: 600,
  /**
   * {@link WebGLOptions.autoDensity}
   * @default false
   */
  autoDensity: !1,
  /**
   * {@link WebGLOptions.antialias}
   * @default false
   */
  antialias: !1
};
let $T = ml;
const pm = [
  IT,
  lm,
  fl,
  $T,
  rm,
  VT,
  hm,
  kT,
  Bp,
  WT,
  cm
], _m = [
  am,
  b_,
  sm,
  tm,
  v_,
  S_,
  w_,
  J_
], YT = [
  ...pm,
  L_,
  HS,
  OS,
  R_,
  T_,
  q_,
  W_,
  P_,
  X_,
  Y_,
  U_,
  mT,
  I_,
  B_
], XT = [..._m], jT = [g_, Q_, Z_], mm = [], gm = [], ym = [];
L.handleByNamedList(A.WebGLSystem, mm);
L.handleByNamedList(A.WebGLPipes, gm);
L.handleByNamedList(A.WebGLPipesAdaptor, ym);
L.add(...YT, ...XT, ...jT);
class KT extends Hn {
  constructor() {
    const t = {
      name: "webgl",
      type: ge.WEBGL,
      systems: mm,
      renderPipes: gm,
      renderPipeAdaptors: ym
    };
    super(t);
  }
}
const qT = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  WebGLRenderer: KT
}, Symbol.toStringTag, { value: "Module" }));
class xm {
  constructor(t) {
    this._hash = /* @__PURE__ */ Object.create(null), this._renderer = t, this._renderer.renderableGC.addManagedHash(this, "_hash");
  }
  contextChange(t) {
    this._gpu = t;
  }
  getBindGroup(t, e, r) {
    return t._updateKey(), this._hash[t._key] || this._createBindGroup(t, e, r);
  }
  _createBindGroup(t, e, r) {
    const n = this._gpu.device, a = e.layout[r], l = [], h = this._renderer;
    for (const p in a) {
      const m = t.resources[p] ?? t.resources[a[p]];
      let g;
      if (m._resourceType === "uniformGroup") {
        const x = m;
        h.ubo.updateUniformGroup(x);
        const o = x.buffer;
        g = {
          buffer: h.buffer.getGPUBuffer(o),
          offset: 0,
          size: o.descriptor.size
        };
      } else if (m._resourceType === "buffer") {
        const x = m;
        g = {
          buffer: h.buffer.getGPUBuffer(x),
          offset: 0,
          size: x.descriptor.size
        };
      } else if (m._resourceType === "bufferResource") {
        const x = m;
        g = {
          buffer: h.buffer.getGPUBuffer(x.buffer),
          offset: x.offset,
          size: x.size
        };
      } else if (m._resourceType === "textureSampler") {
        const x = m;
        g = h.texture.getGpuSampler(x);
      } else if (m._resourceType === "textureSource") {
        const x = m;
        g = h.texture.getGpuSource(x).createView({});
      }
      l.push({
        binding: a[p],
        resource: g
      });
    }
    const u = h.shader.getProgramData(e).bindGroups[r], f = n.createBindGroup({
      layout: u,
      entries: l
    });
    return this._hash[t._key] = f, f;
  }
  destroy() {
    for (const t of Object.keys(this._hash))
      this._hash[t] = null;
    this._hash = null, this._renderer = null;
  }
}
xm.extension = {
  type: [
    A.WebGPUSystem
  ],
  name: "bindGroup"
};
class bm {
  constructor(t) {
    this._gpuBuffers = /* @__PURE__ */ Object.create(null), this._managedBuffers = [], t.renderableGC.addManagedHash(this, "_gpuBuffers");
  }
  contextChange(t) {
    this._gpu = t;
  }
  getGPUBuffer(t) {
    return this._gpuBuffers[t.uid] || this.createGPUBuffer(t);
  }
  updateBuffer(t) {
    const e = this._gpuBuffers[t.uid] || this.createGPUBuffer(t), r = t.data;
    return t._updateID && r && (t._updateID = 0, this._gpu.device.queue.writeBuffer(
      e,
      0,
      r.buffer,
      0,
      // round to the nearest 4 bytes
      (t._updateSize || r.byteLength) + 3 & -4
    )), e;
  }
  /** dispose all WebGL resources of all managed buffers */
  destroyAll() {
    for (const t in this._gpuBuffers)
      this._gpuBuffers[t].destroy();
    this._gpuBuffers = {};
  }
  createGPUBuffer(t) {
    this._gpuBuffers[t.uid] || (t.on("update", this.updateBuffer, this), t.on("change", this.onBufferChange, this), t.on("destroy", this.onBufferDestroy, this), this._managedBuffers.push(t));
    const e = this._gpu.device.createBuffer(t.descriptor);
    return t._updateID = 0, t.data && (No(t.data.buffer, e.getMappedRange()), e.unmap()), this._gpuBuffers[t.uid] = e, e;
  }
  onBufferChange(t) {
    this._gpuBuffers[t.uid].destroy(), t._updateID = 0, this._gpuBuffers[t.uid] = this.createGPUBuffer(t);
  }
  /**
   * Disposes buffer
   * @param buffer - buffer with data
   */
  onBufferDestroy(t) {
    this._managedBuffers.splice(this._managedBuffers.indexOf(t), 1), this._destroyBuffer(t);
  }
  destroy() {
    this._managedBuffers.forEach((t) => this._destroyBuffer(t)), this._managedBuffers = null, this._gpuBuffers = null;
  }
  _destroyBuffer(t) {
    this._gpuBuffers[t.uid].destroy(), t.off("update", this.updateBuffer, this), t.off("change", this.onBufferChange, this), t.off("destroy", this.onBufferDestroy, this), this._gpuBuffers[t.uid] = null;
  }
}
bm.extension = {
  type: [
    A.WebGPUSystem
  ],
  name: "buffer"
};
class ZT {
  constructor({ minUniformOffsetAlignment: t }) {
    this._minUniformOffsetAlignment = 256, this.byteIndex = 0, this._minUniformOffsetAlignment = t, this.data = new Float32Array(65535);
  }
  clear() {
    this.byteIndex = 0;
  }
  addEmptyGroup(t) {
    if (t > this._minUniformOffsetAlignment / 4)
      throw new Error(`UniformBufferBatch: array is too large: ${t * 4}`);
    const e = this.byteIndex;
    let r = e + t * 4;
    if (r = Math.ceil(r / this._minUniformOffsetAlignment) * this._minUniformOffsetAlignment, r > this.data.length * 4)
      throw new Error("UniformBufferBatch: ubo batch got too big");
    return this.byteIndex = r, e;
  }
  addGroup(t) {
    const e = this.addEmptyGroup(t.length);
    for (let r = 0; r < t.length; r++)
      this.data[e / 4 + r] = t[r];
    return e;
  }
  destroy() {
    this.data = null;
  }
}
class vm {
  constructor(t) {
    this._colorMaskCache = 15, this._renderer = t;
  }
  setMask(t) {
    this._colorMaskCache !== t && (this._colorMaskCache = t, this._renderer.pipeline.setColorMask(t));
  }
  destroy() {
    this._renderer = null, this._colorMaskCache = null;
  }
}
vm.extension = {
  type: [
    A.WebGPUSystem
  ],
  name: "colorMask"
};
class gl {
  /**
   * @param {WebGPURenderer} renderer - The renderer this System works for.
   */
  constructor(t) {
    this._renderer = t;
  }
  async init(t) {
    return this._initPromise ? this._initPromise : (this._initPromise = this._createDeviceAndAdaptor(t).then((e) => {
      this.gpu = e, this._renderer.runners.contextChange.emit(this.gpu);
    }), this._initPromise);
  }
  /**
   * Handle the context change event
   * @param gpu
   */
  contextChange(t) {
    this._renderer.gpu = t;
  }
  /**
   * Helper class to create a WebGL Context
   * @param {object} options - An options object that gets passed in to the canvas element containing the
   *    context attributes
   * @see https://developer.mozilla.org/en/docs/Web/API/HTMLCanvasElement/getContext
   * @returns {WebGLRenderingContext} the WebGL context
   */
  async _createDeviceAndAdaptor(t) {
    const e = await Y.get().getNavigator().gpu.requestAdapter({
      powerPreference: t.powerPreference,
      forceFallbackAdapter: t.forceFallbackAdapter
    }), r = [
      "texture-compression-bc",
      "texture-compression-astc",
      "texture-compression-etc2"
    ].filter((a) => e.features.has(a)), n = await e.requestDevice({
      requiredFeatures: r
    });
    return { adapter: e, device: n };
  }
  destroy() {
    this.gpu = null, this._renderer = null;
  }
}
gl.extension = {
  type: [
    A.WebGPUSystem
  ],
  name: "device"
};
gl.defaultOptions = {
  /**
   * {@link WebGPUOptions.powerPreference}
   * @default default
   */
  powerPreference: void 0,
  /**
   * Force the use of the fallback adapter
   * @default false
   */
  forceFallbackAdapter: !1
};
class wm {
  constructor(t) {
    this._boundBindGroup = /* @__PURE__ */ Object.create(null), this._boundVertexBuffer = /* @__PURE__ */ Object.create(null), this._renderer = t;
  }
  renderStart() {
    this.commandFinished = new Promise((t) => {
      this._resolveCommandFinished = t;
    }), this.commandEncoder = this._renderer.gpu.device.createCommandEncoder();
  }
  beginRenderPass(t) {
    this.endRenderPass(), this._clearCache(), this.renderPassEncoder = this.commandEncoder.beginRenderPass(t.descriptor);
  }
  endRenderPass() {
    this.renderPassEncoder && this.renderPassEncoder.end(), this.renderPassEncoder = null;
  }
  setViewport(t) {
    this.renderPassEncoder.setViewport(t.x, t.y, t.width, t.height, 0, 1);
  }
  setPipelineFromGeometryProgramAndState(t, e, r, n) {
    const a = this._renderer.pipeline.getPipeline(t, e, r, n);
    this.setPipeline(a);
  }
  setPipeline(t) {
    this._boundPipeline !== t && (this._boundPipeline = t, this.renderPassEncoder.setPipeline(t));
  }
  _setVertexBuffer(t, e) {
    this._boundVertexBuffer[t] !== e && (this._boundVertexBuffer[t] = e, this.renderPassEncoder.setVertexBuffer(t, this._renderer.buffer.updateBuffer(e)));
  }
  _setIndexBuffer(t) {
    if (this._boundIndexBuffer === t)
      return;
    this._boundIndexBuffer = t;
    const e = t.data.BYTES_PER_ELEMENT === 2 ? "uint16" : "uint32";
    this.renderPassEncoder.setIndexBuffer(this._renderer.buffer.updateBuffer(t), e);
  }
  resetBindGroup(t) {
    this._boundBindGroup[t] = null;
  }
  setBindGroup(t, e, r) {
    if (this._boundBindGroup[t] === e)
      return;
    this._boundBindGroup[t] = e, e._touch(this._renderer.textureGC.count);
    const n = this._renderer.bindGroup.getBindGroup(e, r, t);
    this.renderPassEncoder.setBindGroup(t, n);
  }
  setGeometry(t, e) {
    const r = this._renderer.pipeline.getBufferNamesToBind(t, e);
    for (const n in r)
      this._setVertexBuffer(n, t.attributes[r[n]].buffer);
    t.indexBuffer && this._setIndexBuffer(t.indexBuffer);
  }
  _setShaderBindGroups(t, e) {
    for (const r in t.groups) {
      const n = t.groups[r];
      e || this._syncBindGroup(n), this.setBindGroup(r, n, t.gpuProgram);
    }
  }
  _syncBindGroup(t) {
    for (const e in t.resources) {
      const r = t.resources[e];
      r.isUniformGroup && this._renderer.ubo.updateUniformGroup(r);
    }
  }
  draw(t) {
    const { geometry: e, shader: r, state: n, topology: a, size: l, start: h, instanceCount: u, skipSync: f } = t;
    this.setPipelineFromGeometryProgramAndState(e, r.gpuProgram, n, a), this.setGeometry(e, r.gpuProgram), this._setShaderBindGroups(r, f), e.indexBuffer ? this.renderPassEncoder.drawIndexed(
      l || e.indexBuffer.data.length,
      u ?? e.instanceCount,
      h || 0
    ) : this.renderPassEncoder.draw(l || e.getSize(), u ?? e.instanceCount, h || 0);
  }
  finishRenderPass() {
    this.renderPassEncoder && (this.renderPassEncoder.end(), this.renderPassEncoder = null);
  }
  postrender() {
    this.finishRenderPass(), this._gpu.device.queue.submit([this.commandEncoder.finish()]), this._resolveCommandFinished(), this.commandEncoder = null;
  }
  // restores a render pass if finishRenderPass was called
  // not optimised as really used for debugging!
  // used when we want to stop drawing and log a texture..
  restoreRenderPass() {
    const t = this._renderer.renderTarget.adaptor.getDescriptor(
      this._renderer.renderTarget.renderTarget,
      !1,
      [0, 0, 0, 1]
    );
    this.renderPassEncoder = this.commandEncoder.beginRenderPass(t);
    const e = this._boundPipeline, r = { ...this._boundVertexBuffer }, n = this._boundIndexBuffer, a = { ...this._boundBindGroup };
    this._clearCache();
    const l = this._renderer.renderTarget.viewport;
    this.renderPassEncoder.setViewport(l.x, l.y, l.width, l.height, 0, 1), this.setPipeline(e);
    for (const h in r)
      this._setVertexBuffer(h, r[h]);
    for (const h in a)
      this.setBindGroup(h, a[h], null);
    this._setIndexBuffer(n);
  }
  _clearCache() {
    for (let t = 0; t < 16; t++)
      this._boundBindGroup[t] = null, this._boundVertexBuffer[t] = null;
    this._boundIndexBuffer = null, this._boundPipeline = null;
  }
  destroy() {
    this._renderer = null, this._gpu = null, this._boundBindGroup = null, this._boundVertexBuffer = null, this._boundIndexBuffer = null, this._boundPipeline = null;
  }
  contextChange(t) {
    this._gpu = t;
  }
}
wm.extension = {
  type: [A.WebGPUSystem],
  name: "encoder",
  priority: 1
};
class Sm {
  constructor(t) {
    this._renderer = t;
  }
  contextChange() {
    this.maxTextures = this._renderer.device.gpu.device.limits.maxSampledTexturesPerShaderStage, this.maxBatchableTextures = this.maxTextures;
  }
  destroy() {
  }
}
Sm.extension = {
  type: [
    A.WebGPUSystem
  ],
  name: "limits"
};
class Tm {
  constructor(t) {
    this._renderTargetStencilState = /* @__PURE__ */ Object.create(null), this._renderer = t, t.renderTarget.onRenderTargetChange.add(this);
  }
  onRenderTargetChange(t) {
    let e = this._renderTargetStencilState[t.uid];
    e || (e = this._renderTargetStencilState[t.uid] = {
      stencilMode: ft.DISABLED,
      stencilReference: 0
    }), this._activeRenderTarget = t, this.setStencilMode(e.stencilMode, e.stencilReference);
  }
  setStencilMode(t, e) {
    const r = this._renderTargetStencilState[this._activeRenderTarget.uid];
    r.stencilMode = t, r.stencilReference = e;
    const n = this._renderer;
    n.pipeline.setStencilMode(t), n.encoder.renderPassEncoder.setStencilReference(e);
  }
  destroy() {
    this._renderer.renderTarget.onRenderTargetChange.remove(this), this._renderer = null, this._activeRenderTarget = null, this._renderTargetStencilState = null;
  }
}
Tm.extension = {
  type: [
    A.WebGPUSystem
  ],
  name: "stencil"
};
const hn = {
  i32: { align: 4, size: 4 },
  u32: { align: 4, size: 4 },
  f32: { align: 4, size: 4 },
  f16: { align: 2, size: 2 },
  "vec2<i32>": { align: 8, size: 8 },
  "vec2<u32>": { align: 8, size: 8 },
  "vec2<f32>": { align: 8, size: 8 },
  "vec2<f16>": { align: 4, size: 4 },
  "vec3<i32>": { align: 16, size: 12 },
  "vec3<u32>": { align: 16, size: 12 },
  "vec3<f32>": { align: 16, size: 12 },
  "vec3<f16>": { align: 8, size: 6 },
  "vec4<i32>": { align: 16, size: 16 },
  "vec4<u32>": { align: 16, size: 16 },
  "vec4<f32>": { align: 16, size: 16 },
  "vec4<f16>": { align: 8, size: 8 },
  "mat2x2<f32>": { align: 8, size: 16 },
  "mat2x2<f16>": { align: 4, size: 8 },
  "mat3x2<f32>": { align: 8, size: 24 },
  "mat3x2<f16>": { align: 4, size: 12 },
  "mat4x2<f32>": { align: 8, size: 32 },
  "mat4x2<f16>": { align: 4, size: 16 },
  "mat2x3<f32>": { align: 16, size: 32 },
  "mat2x3<f16>": { align: 8, size: 16 },
  "mat3x3<f32>": { align: 16, size: 48 },
  "mat3x3<f16>": { align: 8, size: 24 },
  "mat4x3<f32>": { align: 16, size: 64 },
  "mat4x3<f16>": { align: 8, size: 32 },
  "mat2x4<f32>": { align: 16, size: 32 },
  "mat2x4<f16>": { align: 8, size: 16 },
  "mat3x4<f32>": { align: 16, size: 48 },
  "mat3x4<f16>": { align: 8, size: 24 },
  "mat4x4<f32>": { align: 16, size: 64 },
  "mat4x4<f16>": { align: 8, size: 32 }
};
function QT(s) {
  const t = s.map((r) => ({
    data: r,
    offset: 0,
    size: 0
  }));
  let e = 0;
  for (let r = 0; r < t.length; r++) {
    const n = t[r];
    let a = hn[n.data.type].size;
    const l = hn[n.data.type].align;
    if (!hn[n.data.type])
      throw new Error(`[Pixi.js] WebGPU UniformBuffer: Unknown type ${n.data.type}`);
    n.data.size > 1 && (a = Math.max(a, l) * n.data.size), e = Math.ceil(e / l) * l, n.size = a, n.offset = e, e += a;
  }
  return e = Math.ceil(e / 16) * 16, { uboElements: t, size: e };
}
function JT(s, t) {
  const { size: e, align: r } = hn[s.data.type], n = (r - e) / 4, a = s.data.type.indexOf("i32") >= 0 ? "dataInt32" : "data";
  return `
         v = uv.${s.data.name};
         ${t !== 0 ? `offset += ${t};` : ""}

         arrayOffset = offset;

         t = 0;

         for(var i=0; i < ${s.data.size * (e / 4)}; i++)
         {
             for(var j = 0; j < ${e / 4}; j++)
             {
                 ${a}[arrayOffset++] = v[t++];
             }
             ${n !== 0 ? `arrayOffset += ${n};` : ""}
         }
     `;
}
function tC(s) {
  return D_(
    s,
    "uboWgsl",
    JT,
    $S
  );
}
class Cm extends k_ {
  constructor() {
    super({
      createUboElements: QT,
      generateUboSync: tC
    });
  }
}
Cm.extension = {
  type: [A.WebGPUSystem],
  name: "ubo"
};
const Ye = 128;
class Em {
  constructor(t) {
    this._bindGroupHash = /* @__PURE__ */ Object.create(null), this._buffers = [], this._bindGroups = [], this._bufferResources = [], this._renderer = t, this._renderer.renderableGC.addManagedHash(this, "_bindGroupHash"), this._batchBuffer = new ZT({ minUniformOffsetAlignment: Ye });
    const e = 256 / Ye;
    for (let r = 0; r < e; r++) {
      let n = X.UNIFORM | X.COPY_DST;
      r === 0 && (n |= X.COPY_SRC), this._buffers.push(new Zt({
        data: this._batchBuffer.data,
        usage: n
      }));
    }
  }
  renderEnd() {
    this._uploadBindGroups(), this._resetBindGroups();
  }
  _resetBindGroups() {
    for (const t in this._bindGroupHash)
      this._bindGroupHash[t] = null;
    this._batchBuffer.clear();
  }
  // just works for single bind groups for now
  getUniformBindGroup(t, e) {
    if (!e && this._bindGroupHash[t.uid])
      return this._bindGroupHash[t.uid];
    this._renderer.ubo.ensureUniformGroup(t);
    const r = t.buffer.data, n = this._batchBuffer.addEmptyGroup(r.length);
    return this._renderer.ubo.syncUniformGroup(t, this._batchBuffer.data, n / 4), this._bindGroupHash[t.uid] = this._getBindGroup(n / Ye), this._bindGroupHash[t.uid];
  }
  getUboResource(t) {
    this._renderer.ubo.updateUniformGroup(t);
    const e = t.buffer.data, r = this._batchBuffer.addGroup(e);
    return this._getBufferResource(r / Ye);
  }
  getArrayBindGroup(t) {
    const e = this._batchBuffer.addGroup(t);
    return this._getBindGroup(e / Ye);
  }
  getArrayBufferResource(t) {
    const r = this._batchBuffer.addGroup(t) / Ye;
    return this._getBufferResource(r);
  }
  _getBufferResource(t) {
    if (!this._bufferResources[t]) {
      const e = this._buffers[t % 2];
      this._bufferResources[t] = new ll({
        buffer: e,
        offset: (t / 2 | 0) * 256,
        size: Ye
      });
    }
    return this._bufferResources[t];
  }
  _getBindGroup(t) {
    if (!this._bindGroups[t]) {
      const e = new He({
        0: this._getBufferResource(t)
      });
      this._bindGroups[t] = e;
    }
    return this._bindGroups[t];
  }
  _uploadBindGroups() {
    const t = this._renderer.buffer, e = this._buffers[0];
    e.update(this._batchBuffer.byteIndex), t.updateBuffer(e);
    const r = this._renderer.gpu.device.createCommandEncoder();
    for (let n = 1; n < this._buffers.length; n++) {
      const a = this._buffers[n];
      r.copyBufferToBuffer(
        t.getGPUBuffer(e),
        Ye,
        t.getGPUBuffer(a),
        0,
        this._batchBuffer.byteIndex
      );
    }
    this._renderer.gpu.device.queue.submit([r.finish()]);
  }
  destroy() {
    for (let t = 0; t < this._bindGroups.length; t++)
      this._bindGroups[t].destroy();
    this._bindGroups = null, this._bindGroupHash = null;
    for (let t = 0; t < this._buffers.length; t++)
      this._buffers[t].destroy();
    this._buffers = null;
    for (let t = 0; t < this._bufferResources.length; t++)
      this._bufferResources[t].destroy();
    this._bufferResources = null, this._batchBuffer.destroy(), this._bindGroupHash = null, this._renderer = null;
  }
}
Em.extension = {
  type: [
    A.WebGPUPipes
  ],
  name: "uniformBatch"
};
const eC = {
  "point-list": 0,
  "line-list": 1,
  "line-strip": 2,
  "triangle-list": 3,
  "triangle-strip": 4
};
function iC(s, t, e, r, n) {
  return s << 24 | t << 16 | e << 10 | r << 5 | n;
}
function rC(s, t, e, r) {
  return e << 6 | s << 3 | r << 1 | t;
}
class Am {
  constructor(t) {
    this._moduleCache = /* @__PURE__ */ Object.create(null), this._bufferLayoutsCache = /* @__PURE__ */ Object.create(null), this._bindingNamesCache = /* @__PURE__ */ Object.create(null), this._pipeCache = /* @__PURE__ */ Object.create(null), this._pipeStateCaches = /* @__PURE__ */ Object.create(null), this._colorMask = 15, this._multisampleCount = 1, this._renderer = t;
  }
  contextChange(t) {
    this._gpu = t, this.setStencilMode(ft.DISABLED), this._updatePipeHash();
  }
  setMultisampleCount(t) {
    this._multisampleCount !== t && (this._multisampleCount = t, this._updatePipeHash());
  }
  setRenderTarget(t) {
    this._multisampleCount = t.msaaSamples, this._depthStencilAttachment = t.descriptor.depthStencilAttachment ? 1 : 0, this._updatePipeHash();
  }
  setColorMask(t) {
    this._colorMask !== t && (this._colorMask = t, this._updatePipeHash());
  }
  setStencilMode(t) {
    this._stencilMode !== t && (this._stencilMode = t, this._stencilState = ci[t], this._updatePipeHash());
  }
  setPipeline(t, e, r, n) {
    const a = this.getPipeline(t, e, r);
    n.setPipeline(a);
  }
  getPipeline(t, e, r, n) {
    t._layoutKey || (E_(t, e.attributeData), this._generateBufferKey(t)), n || (n = t.topology);
    const a = iC(
      t._layoutKey,
      e._layoutKey,
      r.data,
      r._blendModeId,
      eC[n]
    );
    return this._pipeCache[a] ? this._pipeCache[a] : (this._pipeCache[a] = this._createPipeline(t, e, r, n), this._pipeCache[a]);
  }
  _createPipeline(t, e, r, n) {
    const a = this._gpu.device, l = this._createVertexBufferLayouts(t, e), h = this._renderer.state.getColorTargets(r);
    h[0].writeMask = this._stencilMode === ft.RENDERING_MASK_ADD ? 0 : this._colorMask;
    const u = this._renderer.shader.getProgramData(e).pipeline, f = {
      // TODO later check if its helpful to create..
      // layout,
      vertex: {
        module: this._getModule(e.vertex.source),
        entryPoint: e.vertex.entryPoint,
        // geometry..
        buffers: l
      },
      fragment: {
        module: this._getModule(e.fragment.source),
        entryPoint: e.fragment.entryPoint,
        targets: h
      },
      primitive: {
        topology: n,
        cullMode: r.cullMode
      },
      layout: u,
      multisample: {
        count: this._multisampleCount
      },
      // depthStencil,
      label: "PIXI Pipeline"
    };
    return this._depthStencilAttachment && (f.depthStencil = {
      ...this._stencilState,
      format: "depth24plus-stencil8",
      depthWriteEnabled: r.depthTest,
      depthCompare: r.depthTest ? "less" : "always"
    }), a.createRenderPipeline(f);
  }
  _getModule(t) {
    return this._moduleCache[t] || this._createModule(t);
  }
  _createModule(t) {
    const e = this._gpu.device;
    return this._moduleCache[t] = e.createShaderModule({
      code: t
    }), this._moduleCache[t];
  }
  _generateBufferKey(t) {
    const e = [];
    let r = 0;
    const n = Object.keys(t.attributes).sort();
    for (let l = 0; l < n.length; l++) {
      const h = t.attributes[n[l]];
      e[r++] = h.offset, e[r++] = h.format, e[r++] = h.stride, e[r++] = h.instance;
    }
    const a = e.join("|");
    return t._layoutKey = os(a, "geometry"), t._layoutKey;
  }
  _generateAttributeLocationsKey(t) {
    const e = [];
    let r = 0;
    const n = Object.keys(t.attributeData).sort();
    for (let l = 0; l < n.length; l++) {
      const h = t.attributeData[n[l]];
      e[r++] = h.location;
    }
    const a = e.join("|");
    return t._attributeLocationsKey = os(a, "programAttributes"), t._attributeLocationsKey;
  }
  /**
   * Returns a hash of buffer names mapped to bind locations.
   * This is used to bind the correct buffer to the correct location in the shader.
   * @param geometry - The geometry where to get the buffer names
   * @param program - The program where to get the buffer names
   * @returns An object of buffer names mapped to the bind location.
   */
  getBufferNamesToBind(t, e) {
    const r = t._layoutKey << 16 | e._attributeLocationsKey;
    if (this._bindingNamesCache[r])
      return this._bindingNamesCache[r];
    const n = this._createVertexBufferLayouts(t, e), a = /* @__PURE__ */ Object.create(null), l = e.attributeData;
    for (let h = 0; h < n.length; h++) {
      const f = Object.values(n[h].attributes)[0].shaderLocation;
      for (const p in l)
        if (l[p].location === f) {
          a[h] = p;
          break;
        }
    }
    return this._bindingNamesCache[r] = a, a;
  }
  _createVertexBufferLayouts(t, e) {
    e._attributeLocationsKey || this._generateAttributeLocationsKey(e);
    const r = t._layoutKey << 16 | e._attributeLocationsKey;
    if (this._bufferLayoutsCache[r])
      return this._bufferLayoutsCache[r];
    const n = [];
    return t.buffers.forEach((a) => {
      const l = {
        arrayStride: 0,
        stepMode: "vertex",
        attributes: []
      }, h = l.attributes;
      for (const u in e.attributeData) {
        const f = t.attributes[u];
        (f.divisor ?? 1) !== 1 && N(`Attribute ${u} has an invalid divisor value of '${f.divisor}'. WebGPU only supports a divisor value of 1`), f.buffer === a && (l.arrayStride = f.stride, l.stepMode = f.instance ? "instance" : "vertex", h.push({
          shaderLocation: e.attributeData[u].location,
          offset: f.offset,
          format: f.format
        }));
      }
      h.length && n.push(l);
    }), this._bufferLayoutsCache[r] = n, n;
  }
  _updatePipeHash() {
    const t = rC(
      this._stencilMode,
      this._multisampleCount,
      this._colorMask,
      this._depthStencilAttachment
    );
    this._pipeStateCaches[t] || (this._pipeStateCaches[t] = /* @__PURE__ */ Object.create(null)), this._pipeCache = this._pipeStateCaches[t];
  }
  destroy() {
    this._renderer = null, this._bufferLayoutsCache = null;
  }
}
Am.extension = {
  type: [A.WebGPUSystem],
  name: "pipeline"
};
class sC {
  constructor() {
    this.contexts = [], this.msaaTextures = [], this.msaaSamples = 1;
  }
}
class nC {
  init(t, e) {
    this._renderer = t, this._renderTargetSystem = e;
  }
  copyToTexture(t, e, r, n, a) {
    const l = this._renderer, h = this._getGpuColorTexture(
      t
    ), u = l.texture.getGpuSource(
      e.source
    );
    return l.encoder.commandEncoder.copyTextureToTexture(
      {
        texture: h,
        origin: r
      },
      {
        texture: u,
        origin: a
      },
      n
    ), e;
  }
  startRenderPass(t, e = !0, r, n) {
    const l = this._renderTargetSystem.getGpuRenderTarget(t), h = this.getDescriptor(t, e, r);
    l.descriptor = h, this._renderer.pipeline.setRenderTarget(l), this._renderer.encoder.beginRenderPass(l), this._renderer.encoder.setViewport(n);
  }
  finishRenderPass() {
    this._renderer.encoder.endRenderPass();
  }
  /**
   * returns the gpu texture for the first color texture in the render target
   * mainly used by the filter manager to get copy the texture for blending
   * @param renderTarget
   * @returns a gpu texture
   */
  _getGpuColorTexture(t) {
    const e = this._renderTargetSystem.getGpuRenderTarget(t);
    return e.contexts[0] ? e.contexts[0].getCurrentTexture() : this._renderer.texture.getGpuSource(
      t.colorTextures[0].source
    );
  }
  getDescriptor(t, e, r) {
    typeof e == "boolean" && (e = e ? Xt.ALL : Xt.NONE);
    const n = this._renderTargetSystem, a = n.getGpuRenderTarget(t), l = t.colorTextures.map(
      (f, p) => {
        const m = a.contexts[p];
        let g, x;
        m ? g = m.getCurrentTexture().createView() : g = this._renderer.texture.getGpuSource(f).createView({
          mipLevelCount: 1
        }), a.msaaTextures[p] && (x = g, g = this._renderer.texture.getTextureView(
          a.msaaTextures[p]
        ));
        const o = e & Xt.COLOR ? "clear" : "load";
        return r ?? (r = n.defaultClearColor), {
          view: g,
          resolveTarget: x,
          clearValue: r,
          storeOp: "store",
          loadOp: o
        };
      }
    );
    let h;
    if ((t.stencil || t.depth) && !t.depthStencilTexture && (t.ensureDepthStencilTexture(), t.depthStencilTexture.source.sampleCount = a.msaa ? 4 : 1), t.depthStencilTexture) {
      const f = e & Xt.STENCIL ? "clear" : "load", p = e & Xt.DEPTH ? "clear" : "load";
      h = {
        view: this._renderer.texture.getGpuSource(t.depthStencilTexture.source).createView(),
        stencilStoreOp: "store",
        stencilLoadOp: f,
        depthClearValue: 1,
        depthLoadOp: p,
        depthStoreOp: "store"
      };
    }
    return {
      colorAttachments: l,
      depthStencilAttachment: h
    };
  }
  clear(t, e = !0, r, n) {
    if (!e)
      return;
    const { gpu: a, encoder: l } = this._renderer, h = a.device;
    if (l.commandEncoder === null) {
      const f = h.createCommandEncoder(), p = this.getDescriptor(t, e, r), m = f.beginRenderPass(p);
      m.setViewport(n.x, n.y, n.width, n.height, 0, 1), m.end();
      const g = f.finish();
      h.queue.submit([g]);
    } else
      this.startRenderPass(t, e, r, n);
  }
  initGpuRenderTarget(t) {
    t.isRoot = !0;
    const e = new sC();
    return t.colorTextures.forEach((r, n) => {
      if (r instanceof Ne) {
        const a = r.resource.getContext(
          "webgpu"
        ), l = r.transparent ? "premultiplied" : "opaque";
        try {
          a.configure({
            device: this._renderer.gpu.device,
            usage: GPUTextureUsage.TEXTURE_BINDING | GPUTextureUsage.COPY_DST | GPUTextureUsage.RENDER_ATTACHMENT | GPUTextureUsage.COPY_SRC,
            format: "bgra8unorm",
            alphaMode: l
          });
        } catch (h) {
          console.error(h);
        }
        e.contexts[n] = a;
      }
      if (e.msaa = r.source.antialias, r.source.antialias) {
        const a = new yt({
          width: 0,
          height: 0,
          sampleCount: 4
        });
        e.msaaTextures[n] = a;
      }
    }), e.msaa && (e.msaaSamples = 4, t.depthStencilTexture && (t.depthStencilTexture.source.sampleCount = 4)), e;
  }
  destroyGpuRenderTarget(t) {
    t.contexts.forEach((e) => {
      e.unconfigure();
    }), t.msaaTextures.forEach((e) => {
      e.destroy();
    }), t.msaaTextures.length = 0, t.contexts.length = 0;
  }
  ensureDepthStencilTexture(t) {
    const e = this._renderTargetSystem.getGpuRenderTarget(t);
    t.depthStencilTexture && e.msaa && (t.depthStencilTexture.source.sampleCount = 4);
  }
  resizeGpuRenderTarget(t) {
    const e = this._renderTargetSystem.getGpuRenderTarget(t);
    e.width = t.width, e.height = t.height, e.msaa && t.colorTextures.forEach((r, n) => {
      e.msaaTextures[n]?.resize(
        r.source.width,
        r.source.height,
        r.source._resolution
      );
    });
  }
}
class Pm extends H_ {
  constructor(t) {
    super(t), this.adaptor = new nC(), this.adaptor.init(t, this);
  }
}
Pm.extension = {
  type: [A.WebGPUSystem],
  name: "renderTarget"
};
class Mm {
  constructor() {
    this._gpuProgramData = /* @__PURE__ */ Object.create(null);
  }
  contextChange(t) {
    this._gpu = t;
  }
  getProgramData(t) {
    return this._gpuProgramData[t._layoutKey] || this._createGPUProgramData(t);
  }
  _createGPUProgramData(t) {
    const e = this._gpu.device, r = t.gpuLayout.map((a) => e.createBindGroupLayout({ entries: a })), n = { bindGroupLayouts: r };
    return this._gpuProgramData[t._layoutKey] = {
      bindGroups: r,
      pipeline: e.createPipelineLayout(n)
    }, this._gpuProgramData[t._layoutKey];
  }
  destroy() {
    this._gpu = null, this._gpuProgramData = null;
  }
}
Mm.extension = {
  type: [
    A.WebGPUSystem
  ],
  name: "shader"
};
const Ht = {};
Ht.normal = {
  alpha: {
    srcFactor: "one",
    dstFactor: "one-minus-src-alpha",
    operation: "add"
  },
  color: {
    srcFactor: "one",
    dstFactor: "one-minus-src-alpha",
    operation: "add"
  }
};
Ht.add = {
  alpha: {
    srcFactor: "src-alpha",
    dstFactor: "one-minus-src-alpha",
    operation: "add"
  },
  color: {
    srcFactor: "one",
    dstFactor: "one",
    operation: "add"
  }
};
Ht.multiply = {
  alpha: {
    srcFactor: "one",
    dstFactor: "one-minus-src-alpha",
    operation: "add"
  },
  color: {
    srcFactor: "dst",
    dstFactor: "one-minus-src-alpha",
    operation: "add"
  }
};
Ht.screen = {
  alpha: {
    srcFactor: "one",
    dstFactor: "one-minus-src-alpha",
    operation: "add"
  },
  color: {
    srcFactor: "one",
    dstFactor: "one-minus-src",
    operation: "add"
  }
};
Ht.overlay = {
  alpha: {
    srcFactor: "one",
    dstFactor: "one-minus-src-alpha",
    operation: "add"
  },
  color: {
    srcFactor: "one",
    dstFactor: "one-minus-src",
    operation: "add"
  }
};
Ht.none = {
  alpha: {
    srcFactor: "one",
    dstFactor: "one-minus-src-alpha",
    operation: "add"
  },
  color: {
    srcFactor: "zero",
    dstFactor: "zero",
    operation: "add"
  }
};
Ht["normal-npm"] = {
  alpha: {
    srcFactor: "one",
    dstFactor: "one-minus-src-alpha",
    operation: "add"
  },
  color: {
    srcFactor: "src-alpha",
    dstFactor: "one-minus-src-alpha",
    operation: "add"
  }
};
Ht["add-npm"] = {
  alpha: {
    srcFactor: "one",
    dstFactor: "one",
    operation: "add"
  },
  color: {
    srcFactor: "src-alpha",
    dstFactor: "one",
    operation: "add"
  }
};
Ht["screen-npm"] = {
  alpha: {
    srcFactor: "one",
    dstFactor: "one-minus-src-alpha",
    operation: "add"
  },
  color: {
    srcFactor: "src-alpha",
    dstFactor: "one-minus-src",
    operation: "add"
  }
};
Ht.erase = {
  alpha: {
    srcFactor: "zero",
    dstFactor: "one-minus-src-alpha",
    operation: "add"
  },
  color: {
    srcFactor: "zero",
    dstFactor: "one-minus-src",
    operation: "add"
  }
};
Ht.min = {
  alpha: {
    srcFactor: "one",
    dstFactor: "one",
    operation: "min"
  },
  color: {
    srcFactor: "one",
    dstFactor: "one",
    operation: "min"
  }
};
Ht.max = {
  alpha: {
    srcFactor: "one",
    dstFactor: "one",
    operation: "max"
  },
  color: {
    srcFactor: "one",
    dstFactor: "one",
    operation: "max"
  }
};
class Bm {
  constructor() {
    this.defaultState = new ye(), this.defaultState.blend = !0;
  }
  contextChange(t) {
    this.gpu = t;
  }
  /**
   * Gets the blend mode data for the current state
   * @param state - The state to get the blend mode from
   */
  getColorTargets(t) {
    return [
      {
        format: "bgra8unorm",
        writeMask: 0,
        blend: Ht[t.blendMode] || Ht.normal
      }
    ];
  }
  destroy() {
    this.gpu = null;
  }
}
Bm.extension = {
  type: [
    A.WebGPUSystem
  ],
  name: "state"
};
const aC = {
  type: "image",
  upload(s, t, e) {
    const r = s.resource, n = (s.pixelWidth | 0) * (s.pixelHeight | 0), a = r.byteLength / n;
    e.device.queue.writeTexture(
      { texture: t },
      r,
      {
        offset: 0,
        rowsPerImage: s.pixelHeight,
        bytesPerRow: s.pixelHeight * a
      },
      {
        width: s.pixelWidth,
        height: s.pixelHeight,
        depthOrArrayLayers: 1
      }
    );
  }
}, Um = {
  "bc1-rgba-unorm": { blockBytes: 8, blockWidth: 4, blockHeight: 4 },
  "bc2-rgba-unorm": { blockBytes: 16, blockWidth: 4, blockHeight: 4 },
  "bc3-rgba-unorm": { blockBytes: 16, blockWidth: 4, blockHeight: 4 },
  "bc7-rgba-unorm": { blockBytes: 16, blockWidth: 4, blockHeight: 4 },
  "etc1-rgb-unorm": { blockBytes: 8, blockWidth: 4, blockHeight: 4 },
  "etc2-rgba8unorm": { blockBytes: 16, blockWidth: 4, blockHeight: 4 },
  "astc-4x4-unorm": { blockBytes: 16, blockWidth: 4, blockHeight: 4 }
}, oC = { blockBytes: 4, blockWidth: 1, blockHeight: 1 }, hC = {
  type: "compressed",
  upload(s, t, e) {
    let r = s.pixelWidth, n = s.pixelHeight;
    const a = Um[s.format] || oC;
    for (let l = 0; l < s.resource.length; l++) {
      const h = s.resource[l], u = Math.ceil(r / a.blockWidth) * a.blockBytes;
      e.device.queue.writeTexture(
        {
          texture: t,
          mipLevel: l
        },
        h,
        {
          offset: 0,
          bytesPerRow: u
        },
        {
          width: Math.ceil(r / a.blockWidth) * a.blockWidth,
          height: Math.ceil(n / a.blockHeight) * a.blockHeight,
          depthOrArrayLayers: 1
        }
      ), r = Math.max(r >> 1, 1), n = Math.max(n >> 1, 1);
    }
  }
}, Rm = {
  type: "image",
  upload(s, t, e) {
    const r = s.resource;
    if (!r)
      return;
    if (globalThis.HTMLImageElement && r instanceof HTMLImageElement) {
      const h = Y.get().createCanvas(r.width, r.height);
      h.getContext("2d").drawImage(r, 0, 0, r.width, r.height), s.resource = h, N("ImageSource: Image element passed, converting to canvas and replacing resource.");
    }
    const n = Math.min(t.width, s.resourceWidth || s.pixelWidth), a = Math.min(t.height, s.resourceHeight || s.pixelHeight), l = s.alphaMode === "premultiply-alpha-on-upload";
    e.device.queue.copyExternalImageToTexture(
      { source: r },
      { texture: t, premultipliedAlpha: l },
      {
        width: n,
        height: a
      }
    );
  }
}, lC = {
  type: "video",
  upload(s, t, e) {
    Rm.upload(s, t, e);
  }
};
class cC {
  constructor(t) {
    this.device = t, this.sampler = t.createSampler({ minFilter: "linear" }), this.pipelines = {};
  }
  _getMipmapPipeline(t) {
    let e = this.pipelines[t];
    return e || (this.mipmapShaderModule || (this.mipmapShaderModule = this.device.createShaderModule({
      code: (
        /* wgsl */
        `
                        var<private> pos : array<vec2<f32>, 3> = array<vec2<f32>, 3>(
                        vec2<f32>(-1.0, -1.0), vec2<f32>(-1.0, 3.0), vec2<f32>(3.0, -1.0));

                        struct VertexOutput {
                        @builtin(position) position : vec4<f32>,
                        @location(0) texCoord : vec2<f32>,
                        };

                        @vertex
                        fn vertexMain(@builtin(vertex_index) vertexIndex : u32) -> VertexOutput {
                        var output : VertexOutput;
                        output.texCoord = pos[vertexIndex] * vec2<f32>(0.5, -0.5) + vec2<f32>(0.5);
                        output.position = vec4<f32>(pos[vertexIndex], 0.0, 1.0);
                        return output;
                        }

                        @group(0) @binding(0) var imgSampler : sampler;
                        @group(0) @binding(1) var img : texture_2d<f32>;

                        @fragment
                        fn fragmentMain(@location(0) texCoord : vec2<f32>) -> @location(0) vec4<f32> {
                        return textureSample(img, imgSampler, texCoord);
                        }
                    `
      )
    })), e = this.device.createRenderPipeline({
      layout: "auto",
      vertex: {
        module: this.mipmapShaderModule,
        entryPoint: "vertexMain"
      },
      fragment: {
        module: this.mipmapShaderModule,
        entryPoint: "fragmentMain",
        targets: [{ format: t }]
      }
    }), this.pipelines[t] = e), e;
  }
  /**
   * Generates mipmaps for the given GPUTexture from the data in level 0.
   * @param {module:External.GPUTexture} texture - Texture to generate mipmaps for.
   * @returns {module:External.GPUTexture} - The originally passed texture
   */
  generateMipmap(t) {
    const e = this._getMipmapPipeline(t.format);
    if (t.dimension === "3d" || t.dimension === "1d")
      throw new Error("Generating mipmaps for non-2d textures is currently unsupported!");
    let r = t;
    const n = t.depthOrArrayLayers || 1, a = t.usage & GPUTextureUsage.RENDER_ATTACHMENT;
    if (!a) {
      const u = {
        size: {
          width: Math.ceil(t.width / 2),
          height: Math.ceil(t.height / 2),
          depthOrArrayLayers: n
        },
        format: t.format,
        usage: GPUTextureUsage.TEXTURE_BINDING | GPUTextureUsage.COPY_SRC | GPUTextureUsage.RENDER_ATTACHMENT,
        mipLevelCount: t.mipLevelCount - 1
      };
      r = this.device.createTexture(u);
    }
    const l = this.device.createCommandEncoder({}), h = e.getBindGroupLayout(0);
    for (let u = 0; u < n; ++u) {
      let f = t.createView({
        baseMipLevel: 0,
        mipLevelCount: 1,
        dimension: "2d",
        baseArrayLayer: u,
        arrayLayerCount: 1
      }), p = a ? 1 : 0;
      for (let m = 1; m < t.mipLevelCount; ++m) {
        const g = r.createView({
          baseMipLevel: p++,
          mipLevelCount: 1,
          dimension: "2d",
          baseArrayLayer: u,
          arrayLayerCount: 1
        }), x = l.beginRenderPass({
          colorAttachments: [{
            view: g,
            storeOp: "store",
            loadOp: "clear",
            clearValue: { r: 0, g: 0, b: 0, a: 0 }
          }]
        }), o = this.device.createBindGroup({
          layout: h,
          entries: [{
            binding: 0,
            resource: this.sampler
          }, {
            binding: 1,
            resource: f
          }]
        });
        x.setPipeline(e), x.setBindGroup(0, o), x.draw(3, 1, 0, 0), x.end(), f = g;
      }
    }
    if (!a) {
      const u = {
        width: Math.ceil(t.width / 2),
        height: Math.ceil(t.height / 2),
        depthOrArrayLayers: n
      };
      for (let f = 1; f < t.mipLevelCount; ++f)
        l.copyTextureToTexture({
          texture: r,
          mipLevel: f - 1
        }, {
          texture: t,
          mipLevel: f
        }, u), u.width = Math.ceil(u.width / 2), u.height = Math.ceil(u.height / 2);
    }
    return this.device.queue.submit([l.finish()]), a || r.destroy(), t;
  }
}
class Im {
  constructor(t) {
    this.managedTextures = [], this._gpuSources = /* @__PURE__ */ Object.create(null), this._gpuSamplers = /* @__PURE__ */ Object.create(null), this._bindGroupHash = /* @__PURE__ */ Object.create(null), this._textureViewHash = /* @__PURE__ */ Object.create(null), this._uploads = {
      image: Rm,
      buffer: aC,
      video: lC,
      compressed: hC
    }, this._renderer = t, t.renderableGC.addManagedHash(this, "_gpuSources"), t.renderableGC.addManagedHash(this, "_gpuSamplers"), t.renderableGC.addManagedHash(this, "_bindGroupHash"), t.renderableGC.addManagedHash(this, "_textureViewHash");
  }
  contextChange(t) {
    this._gpu = t;
  }
  initSource(t) {
    if (t.autoGenerateMipmaps) {
      const u = Math.max(t.pixelWidth, t.pixelHeight);
      t.mipLevelCount = Math.floor(Math.log2(u)) + 1;
    }
    let e = GPUTextureUsage.TEXTURE_BINDING | GPUTextureUsage.COPY_DST;
    t.uploadMethodId !== "compressed" && (e |= GPUTextureUsage.RENDER_ATTACHMENT, e |= GPUTextureUsage.COPY_SRC);
    const r = Um[t.format] || { blockWidth: 1, blockHeight: 1 }, n = Math.ceil(t.pixelWidth / r.blockWidth) * r.blockWidth, a = Math.ceil(t.pixelHeight / r.blockHeight) * r.blockHeight, l = {
      label: t.label,
      size: { width: n, height: a },
      format: t.format,
      sampleCount: t.sampleCount,
      mipLevelCount: t.mipLevelCount,
      dimension: t.dimension,
      usage: e
    }, h = this._gpu.device.createTexture(l);
    return this._gpuSources[t.uid] = h, this.managedTextures.includes(t) || (t.on("update", this.onSourceUpdate, this), t.on("resize", this.onSourceResize, this), t.on("destroy", this.onSourceDestroy, this), t.on("unload", this.onSourceUnload, this), t.on("updateMipmaps", this.onUpdateMipmaps, this), this.managedTextures.push(t)), this.onSourceUpdate(t), h;
  }
  onSourceUpdate(t) {
    const e = this.getGpuSource(t);
    e && (this._uploads[t.uploadMethodId] && this._uploads[t.uploadMethodId].upload(t, e, this._gpu), t.autoGenerateMipmaps && t.mipLevelCount > 1 && this.onUpdateMipmaps(t));
  }
  onSourceUnload(t) {
    const e = this._gpuSources[t.uid];
    e && (this._gpuSources[t.uid] = null, e.destroy());
  }
  onUpdateMipmaps(t) {
    this._mipmapGenerator || (this._mipmapGenerator = new cC(this._gpu.device));
    const e = this.getGpuSource(t);
    this._mipmapGenerator.generateMipmap(e);
  }
  onSourceDestroy(t) {
    t.off("update", this.onSourceUpdate, this), t.off("unload", this.onSourceUnload, this), t.off("destroy", this.onSourceDestroy, this), t.off("resize", this.onSourceResize, this), t.off("updateMipmaps", this.onUpdateMipmaps, this), this.managedTextures.splice(this.managedTextures.indexOf(t), 1), this.onSourceUnload(t);
  }
  onSourceResize(t) {
    const e = this._gpuSources[t.uid];
    e ? (e.width !== t.pixelWidth || e.height !== t.pixelHeight) && (this._textureViewHash[t.uid] = null, this._bindGroupHash[t.uid] = null, this.onSourceUnload(t), this.initSource(t)) : this.initSource(t);
  }
  _initSampler(t) {
    return this._gpuSamplers[t._resourceId] = this._gpu.device.createSampler(t), this._gpuSamplers[t._resourceId];
  }
  getGpuSampler(t) {
    return this._gpuSamplers[t._resourceId] || this._initSampler(t);
  }
  getGpuSource(t) {
    return this._gpuSources[t.uid] || this.initSource(t);
  }
  /**
   * this returns s bind group for a specific texture, the bind group contains
   * - the texture source
   * - the texture style
   * - the texture matrix
   * This is cached so the bind group should only be created once per texture
   * @param texture - the texture you want the bindgroup for
   * @returns the bind group for the texture
   */
  getTextureBindGroup(t) {
    return this._bindGroupHash[t.uid] ?? this._createTextureBindGroup(t);
  }
  _createTextureBindGroup(t) {
    const e = t.source;
    return this._bindGroupHash[t.uid] = new He({
      0: e,
      1: e.style,
      2: new kt({
        uTextureMatrix: { type: "mat3x3<f32>", value: t.textureMatrix.mapCoord }
      })
    }), this._bindGroupHash[t.uid];
  }
  getTextureView(t) {
    const e = t.source;
    return this._textureViewHash[e.uid] ?? this._createTextureView(e);
  }
  _createTextureView(t) {
    return this._textureViewHash[t.uid] = this.getGpuSource(t).createView(), this._textureViewHash[t.uid];
  }
  generateCanvas(t) {
    const e = this._renderer, r = e.gpu.device.createCommandEncoder(), n = Y.get().createCanvas();
    n.width = t.source.pixelWidth, n.height = t.source.pixelHeight;
    const a = n.getContext("webgpu");
    return a.configure({
      device: e.gpu.device,
      usage: GPUTextureUsage.COPY_DST | GPUTextureUsage.COPY_SRC,
      format: Y.get().getNavigator().gpu.getPreferredCanvasFormat(),
      alphaMode: "premultiplied"
    }), r.copyTextureToTexture({
      texture: e.texture.getGpuSource(t.source),
      origin: {
        x: 0,
        y: 0
      }
    }, {
      texture: a.getCurrentTexture()
    }, {
      width: n.width,
      height: n.height
    }), e.gpu.device.queue.submit([r.finish()]), n;
  }
  getPixels(t) {
    const e = this.generateCanvas(t), r = oi.getOptimalCanvasAndContext(e.width, e.height), n = r.context;
    n.drawImage(e, 0, 0);
    const { width: a, height: l } = e, h = n.getImageData(0, 0, a, l), u = new Uint8ClampedArray(h.data.buffer);
    return oi.returnCanvasAndContext(r), { pixels: u, width: a, height: l };
  }
  destroy() {
    this.managedTextures.slice().forEach((t) => this.onSourceDestroy(t)), this.managedTextures = null;
    for (const t of Object.keys(this._bindGroupHash)) {
      const e = Number(t);
      this._bindGroupHash[e]?.destroy(), this._bindGroupHash[e] = null;
    }
    this._gpu = null, this._mipmapGenerator = null, this._gpuSources = null, this._bindGroupHash = null, this._textureViewHash = null, this._gpuSamplers = null;
  }
}
Im.extension = {
  type: [
    A.WebGPUSystem
  ],
  name: "texture"
};
class km {
  constructor() {
    this._maxTextures = 0;
  }
  contextChange(t) {
    const e = new kt({
      uTransformMatrix: { value: new D(), type: "mat3x3<f32>" },
      uColor: { value: new Float32Array([1, 1, 1, 1]), type: "vec4<f32>" },
      uRound: { value: 0, type: "f32" }
    });
    this._maxTextures = t.limits.maxBatchableTextures;
    const r = xs({
      name: "graphics",
      bits: [
        Hh,
        Vh(this._maxTextures),
        US,
        vs
      ]
    });
    this.shader = new ue({
      gpuProgram: r,
      resources: {
        // added on the fly!
        localUniforms: e
      }
    });
  }
  execute(t, e) {
    const r = e.context, n = r.customShader || this.shader, a = t.renderer, l = a.graphicsContext, {
      batcher: h,
      instructions: u
    } = l.getContextRenderData(r), f = a.encoder;
    f.setGeometry(h.geometry, n.gpuProgram);
    const p = a.globalUniforms.bindGroup;
    f.setBindGroup(0, p, n.gpuProgram);
    const m = a.renderPipes.uniformBatch.getUniformBindGroup(n.resources.localUniforms, !0);
    f.setBindGroup(2, m, n.gpuProgram);
    const g = u.instructions;
    let x = null;
    for (let o = 0; o < u.instructionSize; o++) {
      const c = g[o];
      if (c.topology !== x && (x = c.topology, f.setPipelineFromGeometryProgramAndState(
        h.geometry,
        n.gpuProgram,
        t.state,
        c.topology
      )), n.groups[1] = c.bindGroup, !c.gpuBindGroup) {
        const d = c.textures;
        c.bindGroup = Nh(
          d.textures,
          d.count,
          this._maxTextures
        ), c.gpuBindGroup = a.bindGroup.getBindGroup(
          c.bindGroup,
          n.gpuProgram,
          1
        );
      }
      f.setBindGroup(1, c.bindGroup, n.gpuProgram), f.renderPassEncoder.drawIndexed(c.size, 1, c.start);
    }
  }
  destroy() {
    this.shader.destroy(!0), this.shader = null;
  }
}
km.extension = {
  type: [
    A.WebGPUPipesAdaptor
  ],
  name: "graphics"
};
class Fm {
  init() {
    const t = xs({
      name: "mesh",
      bits: [
        qr,
        RS,
        vs
      ]
    });
    this._shader = new ue({
      gpuProgram: t,
      resources: {
        uTexture: k.EMPTY._source,
        uSampler: k.EMPTY._source.style,
        textureUniforms: {
          uTextureMatrix: { type: "mat3x3<f32>", value: new D() }
        }
      }
    });
  }
  execute(t, e) {
    const r = t.renderer;
    let n = e._shader;
    if (!n)
      n = this._shader, n.groups[2] = r.texture.getTextureBindGroup(e.texture);
    else if (!n.gpuProgram) {
      N("Mesh shader has no gpuProgram", e.shader);
      return;
    }
    const a = n.gpuProgram;
    if (a.autoAssignGlobalUniforms && (n.groups[0] = r.globalUniforms.bindGroup), a.autoAssignLocalUniforms) {
      const l = t.localUniforms;
      n.groups[1] = r.renderPipes.uniformBatch.getUniformBindGroup(l, !0);
    }
    r.encoder.draw({
      geometry: e._geometry,
      shader: n,
      state: e.state
    });
  }
  destroy() {
    this._shader.destroy(!0), this._shader = null;
  }
}
Fm.extension = {
  type: [
    A.WebGPUPipesAdaptor
  ],
  name: "mesh"
};
const uC = [
  ...pm,
  Cm,
  wm,
  gl,
  Sm,
  bm,
  Im,
  Pm,
  Mm,
  Bm,
  Am,
  vm,
  Tm,
  xm
], dC = [..._m, Em], fC = [y_, Fm, km], Dm = [], Om = [], Lm = [];
L.handleByNamedList(A.WebGPUSystem, Dm);
L.handleByNamedList(A.WebGPUPipes, Om);
L.handleByNamedList(A.WebGPUPipesAdaptor, Lm);
L.add(...uC, ...dC, ...fC);
class pC extends Hn {
  constructor() {
    const t = {
      name: "webgpu",
      type: ge.WEBGPU,
      systems: Dm,
      renderPipes: Om,
      renderPipeAdaptors: Lm
    };
    super(t);
  }
}
const _C = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  WebGPURenderer: pC
}, Symbol.toStringTag, { value: "Module" }));
class mC {
  constructor() {
    this.batches = [], this.batched = !1;
  }
  destroy() {
    this.batches.forEach((t) => {
      Ct.return(t);
    }), this.batches.length = 0;
  }
}
class Gm {
  constructor(t, e) {
    this.state = ye.for2d(), this.renderer = t, this._adaptor = e, this.renderer.runners.contextChange.add(this);
  }
  contextChange() {
    this._adaptor.contextChange(this.renderer);
  }
  validateRenderable(t) {
    const e = t.context, r = !!t._gpuData, n = this.renderer.graphicsContext.updateGpuContext(e);
    return !!(n.isBatchable || r !== n.isBatchable);
  }
  addRenderable(t, e) {
    const r = this.renderer.graphicsContext.updateGpuContext(t.context);
    t.didViewUpdate && this._rebuild(t), r.isBatchable ? this._addToBatcher(t, e) : (this.renderer.renderPipes.batch.break(e), e.add(t));
  }
  updateRenderable(t) {
    const r = this._getGpuDataForRenderable(t).batches;
    for (let n = 0; n < r.length; n++) {
      const a = r[n];
      a._batcher.updateElement(a);
    }
  }
  execute(t) {
    if (!t.isRenderable)
      return;
    const e = this.renderer, r = t.context;
    if (!e.graphicsContext.getGpuContext(r).batches.length)
      return;
    const a = r.customShader || this._adaptor.shader;
    this.state.blendMode = t.groupBlendMode;
    const l = a.resources.localUniforms.uniforms;
    l.uTransformMatrix = t.groupTransform, l.uRound = e._roundPixels | t._roundPixels, Ss(
      t.groupColorAlpha,
      l.uColor,
      0
    ), this._adaptor.execute(this, t);
  }
  _rebuild(t) {
    const e = this._getGpuDataForRenderable(t), r = this.renderer.graphicsContext.updateGpuContext(t.context);
    e.destroy(), r.isBatchable && this._updateBatchesForRenderable(t, e);
  }
  _addToBatcher(t, e) {
    const r = this.renderer.renderPipes.batch, n = this._getGpuDataForRenderable(t).batches;
    for (let a = 0; a < n.length; a++) {
      const l = n[a];
      r.addToBatch(l, e);
    }
  }
  _getGpuDataForRenderable(t) {
    return t._gpuData[this.renderer.uid] || this._initGpuDataForRenderable(t);
  }
  _initGpuDataForRenderable(t) {
    const e = new mC();
    return t._gpuData[this.renderer.uid] = e, e;
  }
  _updateBatchesForRenderable(t, e) {
    const r = t.context, n = this.renderer.graphicsContext.getGpuContext(r), a = this.renderer._roundPixels | t._roundPixels;
    e.batches = n.batches.map((l) => {
      const h = Ct.get(jh);
      return l.copyTo(h), h.renderable = t, h.roundPixels = a, h;
    });
  }
  destroy() {
    this.renderer = null, this._adaptor.destroy(), this._adaptor = null, this.state = null;
  }
}
Gm.extension = {
  type: [
    A.WebGLPipes,
    A.WebGPUPipes,
    A.CanvasPipes
  ],
  name: "graphics"
};
const zm = class Nm extends rl {
  constructor(...t) {
    super({});
    let e = t[0] ?? {};
    typeof e == "number" && (W(K, "PlaneGeometry constructor changed please use { width, height, verticesX, verticesY } instead"), e = {
      width: e,
      height: t[1],
      verticesX: t[2],
      verticesY: t[3]
    }), this.build(e);
  }
  /**
   * Refreshes plane coordinates
   * @param options - Options to be applied to plane geometry
   */
  build(t) {
    t = { ...Nm.defaultOptions, ...t }, this.verticesX = this.verticesX ?? t.verticesX, this.verticesY = this.verticesY ?? t.verticesY, this.width = this.width ?? t.width, this.height = this.height ?? t.height;
    const e = this.verticesX * this.verticesY, r = [], n = [], a = [], l = this.verticesX - 1, h = this.verticesY - 1, u = this.width / l, f = this.height / h;
    for (let m = 0; m < e; m++) {
      const g = m % this.verticesX, x = m / this.verticesX | 0;
      r.push(g * u, x * f), n.push(g / l, x / h);
    }
    const p = l * h;
    for (let m = 0; m < p; m++) {
      const g = m % l, x = m / l | 0, o = x * this.verticesX + g, c = x * this.verticesX + g + 1, d = (x + 1) * this.verticesX + g, _ = (x + 1) * this.verticesX + g + 1;
      a.push(
        o,
        c,
        d,
        c,
        _,
        d
      );
    }
    this.buffers[0].data = new Float32Array(r), this.buffers[1].data = new Float32Array(n), this.indexBuffer.data = new Uint32Array(a), this.buffers[0].update(), this.buffers[1].update(), this.indexBuffer.update();
  }
};
zm.defaultOptions = {
  width: 100,
  height: 100,
  verticesX: 10,
  verticesY: 10
};
let gC = zm;
class yl {
  constructor() {
    this.batcherName = "default", this.packAsQuad = !1, this.indexOffset = 0, this.attributeOffset = 0, this.roundPixels = 0, this._batcher = null, this._batch = null, this._textureMatrixUpdateId = -1, this._uvUpdateId = -1;
  }
  get blendMode() {
    return this.renderable.groupBlendMode;
  }
  get topology() {
    return this._topology || this.geometry.topology;
  }
  set topology(t) {
    this._topology = t;
  }
  reset() {
    this.renderable = null, this.texture = null, this._batcher = null, this._batch = null, this.geometry = null, this._uvUpdateId = -1, this._textureMatrixUpdateId = -1;
  }
  /**
   * Sets the texture for the batchable mesh.
   * As it does so, it resets the texture matrix update ID.
   * this is to ensure that the texture matrix is recalculated when the uvs are referenced
   * @param value - The texture to set.
   */
  setTexture(t) {
    this.texture !== t && (this.texture = t, this._textureMatrixUpdateId = -1);
  }
  get uvs() {
    const e = this.geometry.getBuffer("aUV"), r = e.data;
    let n = r;
    const a = this.texture.textureMatrix;
    return a.isSimple || (n = this._transformedUvs, (this._textureMatrixUpdateId !== a._updateID || this._uvUpdateId !== e._updateID) && ((!n || n.length < r.length) && (n = this._transformedUvs = new Float32Array(r.length)), this._textureMatrixUpdateId = a._updateID, this._uvUpdateId = e._updateID, a.multiplyUvs(r, n))), n;
  }
  get positions() {
    return this.geometry.positions;
  }
  get indices() {
    return this.geometry.indices;
  }
  get color() {
    return this.renderable.groupColorAlpha;
  }
  get groupTransform() {
    return this.renderable.groupTransform;
  }
  get attributeSize() {
    return this.geometry.positions.length / 2;
  }
  get indexSize() {
    return this.geometry.indices.length;
  }
}
class Yu {
  destroy() {
  }
}
class Hm {
  constructor(t, e) {
    this.localUniforms = new kt({
      uTransformMatrix: { value: new D(), type: "mat3x3<f32>" },
      uColor: { value: new Float32Array([1, 1, 1, 1]), type: "vec4<f32>" },
      uRound: { value: 0, type: "f32" }
    }), this.localUniformsBindGroup = new He({
      0: this.localUniforms
    }), this.renderer = t, this._adaptor = e, this._adaptor.init();
  }
  validateRenderable(t) {
    const e = this._getMeshData(t), r = e.batched, n = t.batched;
    if (e.batched = n, r !== n)
      return !0;
    if (n) {
      const a = t._geometry;
      if (a.indices.length !== e.indexSize || a.positions.length !== e.vertexSize)
        return e.indexSize = a.indices.length, e.vertexSize = a.positions.length, !0;
      const l = this._getBatchableMesh(t);
      return l.texture.uid !== t._texture.uid && (l._textureMatrixUpdateId = -1), !l._batcher.checkAndUpdateTexture(
        l,
        t._texture
      );
    }
    return !1;
  }
  addRenderable(t, e) {
    const r = this.renderer.renderPipes.batch, { batched: n } = this._getMeshData(t);
    if (n) {
      const a = this._getBatchableMesh(t);
      a.setTexture(t._texture), a.geometry = t._geometry, r.addToBatch(a, e);
    } else
      r.break(e), e.add(t);
  }
  updateRenderable(t) {
    if (t.batched) {
      const e = this._getBatchableMesh(t);
      e.setTexture(t._texture), e.geometry = t._geometry, e._batcher.updateElement(e);
    }
  }
  execute(t) {
    if (!t.isRenderable)
      return;
    t.state.blendMode = us(t.groupBlendMode, t.texture._source);
    const e = this.localUniforms;
    e.uniforms.uTransformMatrix = t.groupTransform, e.uniforms.uRound = this.renderer._roundPixels | t._roundPixels, e.update(), Ss(
      t.groupColorAlpha,
      e.uniforms.uColor,
      0
    ), this._adaptor.execute(this, t);
  }
  _getMeshData(t) {
    var e, r;
    return (e = t._gpuData)[r = this.renderer.uid] || (e[r] = new Yu()), t._gpuData[this.renderer.uid].meshData || this._initMeshData(t);
  }
  _initMeshData(t) {
    return t._gpuData[this.renderer.uid].meshData = {
      batched: t.batched,
      indexSize: t._geometry.indices?.length,
      vertexSize: t._geometry.positions?.length
    }, t._gpuData[this.renderer.uid].meshData;
  }
  _getBatchableMesh(t) {
    var e, r;
    return (e = t._gpuData)[r = this.renderer.uid] || (e[r] = new Yu()), t._gpuData[this.renderer.uid].batchableMesh || this._initBatchableMesh(t);
  }
  _initBatchableMesh(t) {
    const e = new yl();
    return e.renderable = t, e.setTexture(t._texture), e.transform = t.groupTransform, e.roundPixels = this.renderer._roundPixels | t._roundPixels, t._gpuData[this.renderer.uid].batchableMesh = e, e;
  }
  destroy() {
    this.localUniforms = null, this.localUniformsBindGroup = null, this._adaptor.destroy(), this._adaptor = null, this.renderer = null;
  }
}
Hm.extension = {
  type: [
    A.WebGLPipes,
    A.WebGPUPipes,
    A.CanvasPipes
  ],
  name: "mesh"
};
class yC {
  execute(t, e) {
    const r = t.state, n = t.renderer, a = e.shader || t.defaultShader;
    a.resources.uTexture = e.texture._source, a.resources.uniforms = t.localUniforms;
    const l = n.gl, h = t.getBuffers(e);
    n.shader.bind(a), n.state.set(r), n.geometry.bind(h.geometry, a.glProgram);
    const f = h.geometry.indexBuffer.data.BYTES_PER_ELEMENT === 2 ? l.UNSIGNED_SHORT : l.UNSIGNED_INT;
    l.drawElements(l.TRIANGLES, e.particleChildren.length * 6, f, 0);
  }
}
class xC {
  execute(t, e) {
    const r = t.renderer, n = e.shader || t.defaultShader;
    n.groups[0] = r.renderPipes.uniformBatch.getUniformBindGroup(t.localUniforms, !0), n.groups[1] = r.texture.getTextureBindGroup(e.texture);
    const a = t.state, l = t.getBuffers(e);
    r.encoder.draw({
      geometry: l.geometry,
      shader: e.shader || t.defaultShader,
      state: a,
      size: e.particleChildren.length * 6
    });
  }
}
function Xu(s, t = null) {
  const e = s * 6;
  if (e > 65535 ? t || (t = new Uint32Array(e)) : t || (t = new Uint16Array(e)), t.length !== e)
    throw new Error(`Out buffer length is incorrect, got ${t.length} and expected ${e}`);
  for (let r = 0, n = 0; r < e; r += 6, n += 4)
    t[r + 0] = n + 0, t[r + 1] = n + 1, t[r + 2] = n + 2, t[r + 3] = n + 0, t[r + 4] = n + 2, t[r + 5] = n + 3;
  return t;
}
function bC(s) {
  return {
    dynamicUpdate: ju(s, !0),
    staticUpdate: ju(s, !1)
  };
}
function ju(s, t) {
  const e = [];
  e.push(`

        var index = 0;

        for (let i = 0; i < ps.length; ++i)
        {
            const p = ps[i];

            `);
  let r = 0;
  for (const a in s) {
    const l = s[a];
    if (t !== l.dynamic)
      continue;
    e.push(`offset = index + ${r}`), e.push(l.code);
    const h = ai(l.format);
    r += h.stride / 4;
  }
  e.push(`
            index += stride * 4;
        }
    `), e.unshift(`
        var stride = ${r};
    `);
  const n = e.join(`
`);
  return new Function("ps", "f32v", "u32v", n);
}
class vC {
  constructor(t) {
    this._size = 0, this._generateParticleUpdateCache = {};
    const e = this._size = t.size ?? 1e3, r = t.properties;
    let n = 0, a = 0;
    for (const p in r) {
      const m = r[p], g = ai(m.format);
      m.dynamic ? a += g.stride : n += g.stride;
    }
    this._dynamicStride = a / 4, this._staticStride = n / 4, this.staticAttributeBuffer = new ji(e * 4 * n), this.dynamicAttributeBuffer = new ji(e * 4 * a), this.indexBuffer = Xu(e);
    const l = new ys();
    let h = 0, u = 0;
    this._staticBuffer = new Zt({
      data: new Float32Array(1),
      label: "static-particle-buffer",
      shrinkToFit: !1,
      usage: X.VERTEX | X.COPY_DST
    }), this._dynamicBuffer = new Zt({
      data: new Float32Array(1),
      label: "dynamic-particle-buffer",
      shrinkToFit: !1,
      usage: X.VERTEX | X.COPY_DST
    });
    for (const p in r) {
      const m = r[p], g = ai(m.format);
      m.dynamic ? (l.addAttribute(m.attributeName, {
        buffer: this._dynamicBuffer,
        stride: this._dynamicStride * 4,
        offset: h * 4,
        format: m.format
      }), h += g.size) : (l.addAttribute(m.attributeName, {
        buffer: this._staticBuffer,
        stride: this._staticStride * 4,
        offset: u * 4,
        format: m.format
      }), u += g.size);
    }
    l.addIndex(this.indexBuffer);
    const f = this.getParticleUpdate(r);
    this._dynamicUpload = f.dynamicUpdate, this._staticUpload = f.staticUpdate, this.geometry = l;
  }
  getParticleUpdate(t) {
    const e = wC(t);
    return this._generateParticleUpdateCache[e] ? this._generateParticleUpdateCache[e] : (this._generateParticleUpdateCache[e] = this.generateParticleUpdate(t), this._generateParticleUpdateCache[e]);
  }
  generateParticleUpdate(t) {
    return bC(t);
  }
  update(t, e) {
    t.length > this._size && (e = !0, this._size = Math.max(t.length, this._size * 1.5 | 0), this.staticAttributeBuffer = new ji(this._size * this._staticStride * 4 * 4), this.dynamicAttributeBuffer = new ji(this._size * this._dynamicStride * 4 * 4), this.indexBuffer = Xu(this._size), this.geometry.indexBuffer.setDataWithSize(
      this.indexBuffer,
      this.indexBuffer.byteLength,
      !0
    ));
    const r = this.dynamicAttributeBuffer;
    if (this._dynamicUpload(t, r.float32View, r.uint32View), this._dynamicBuffer.setDataWithSize(
      this.dynamicAttributeBuffer.float32View,
      t.length * this._dynamicStride * 4,
      !0
    ), e) {
      const n = this.staticAttributeBuffer;
      this._staticUpload(t, n.float32View, n.uint32View), this._staticBuffer.setDataWithSize(
        n.float32View,
        t.length * this._staticStride * 4,
        !0
      );
    }
  }
  destroy() {
    this._staticBuffer.destroy(), this._dynamicBuffer.destroy(), this.geometry.destroy();
  }
}
function wC(s) {
  const t = [];
  for (const e in s) {
    const r = s[e];
    t.push(e, r.code, r.dynamic ? "d" : "s");
  }
  return t.join("_");
}
var SC = `varying vec2 vUV;
varying vec4 vColor;

uniform sampler2D uTexture;

void main(void){
    vec4 color = texture2D(uTexture, vUV) * vColor;
    gl_FragColor = color;
}`, TC = `attribute vec2 aVertex;
attribute vec2 aUV;
attribute vec4 aColor;

attribute vec2 aPosition;
attribute float aRotation;

uniform mat3 uTranslationMatrix;
uniform float uRound;
uniform vec2 uResolution;
uniform vec4 uColor;

varying vec2 vUV;
varying vec4 vColor;

vec2 roundPixels(vec2 position, vec2 targetSize)
{       
    return (floor(((position * 0.5 + 0.5) * targetSize) + 0.5) / targetSize) * 2.0 - 1.0;
}

void main(void){
    float cosRotation = cos(aRotation);
    float sinRotation = sin(aRotation);
    float x = aVertex.x * cosRotation - aVertex.y * sinRotation;
    float y = aVertex.x * sinRotation + aVertex.y * cosRotation;

    vec2 v = vec2(x, y);
    v = v + aPosition;

    gl_Position = vec4((uTranslationMatrix * vec3(v, 1.0)).xy, 0.0, 1.0);

    if(uRound == 1.0)
    {
        gl_Position.xy = roundPixels(gl_Position.xy, uResolution);
    }

    vUV = aUV;
    vColor = vec4(aColor.rgb * aColor.a, aColor.a) * uColor;
}
`, Ku = `
struct ParticleUniforms {
  uProjectionMatrix:mat3x3<f32>,
  uColor:vec4<f32>,
  uResolution:vec2<f32>,
  uRoundPixels:f32,
};

@group(0) @binding(0) var<uniform> uniforms: ParticleUniforms;

@group(1) @binding(0) var uTexture: texture_2d<f32>;
@group(1) @binding(1) var uSampler : sampler;

struct VSOutput {
    @builtin(position) position: vec4<f32>,
    @location(0) uv : vec2<f32>,
    @location(1) color : vec4<f32>,
  };
@vertex
fn mainVertex(
  @location(0) aVertex: vec2<f32>,
  @location(1) aPosition: vec2<f32>,
  @location(2) aUV: vec2<f32>,
  @location(3) aColor: vec4<f32>,
  @location(4) aRotation: f32,
) -> VSOutput {
  
   let v = vec2(
       aVertex.x * cos(aRotation) - aVertex.y * sin(aRotation),
       aVertex.x * sin(aRotation) + aVertex.y * cos(aRotation)
   ) + aPosition;

   let position = vec4((uniforms.uProjectionMatrix * vec3(v, 1.0)).xy, 0.0, 1.0);

    let vColor = vec4(aColor.rgb * aColor.a, aColor.a) * uniforms.uColor;

  return VSOutput(
   position,
   aUV,
   vColor,
  );
}

@fragment
fn mainFragment(
  @location(0) uv: vec2<f32>,
  @location(1) color: vec4<f32>,
  @builtin(position) position: vec4<f32>,
) -> @location(0) vec4<f32> {

    var sample = textureSample(uTexture, uSampler, uv) * color;
   
    return sample;
}`;
class CC extends ue {
  constructor() {
    const t = gr.from({
      vertex: TC,
      fragment: SC
    }), e = Di.from({
      fragment: {
        source: Ku,
        entryPoint: "mainFragment"
      },
      vertex: {
        source: Ku,
        entryPoint: "mainVertex"
      }
    });
    super({
      glProgram: t,
      gpuProgram: e,
      resources: {
        // this will be replaced with the texture from the particle container
        uTexture: k.WHITE.source,
        // this will be replaced with the texture style from the particle container
        uSampler: new $e({}),
        // this will be replaced with the local uniforms from the particle container
        uniforms: {
          uTranslationMatrix: { value: new D(), type: "mat3x3<f32>" },
          uColor: { value: new Q(16777215), type: "vec4<f32>" },
          uRound: { value: 1, type: "f32" },
          uResolution: { value: [0, 0], type: "vec2<f32>" }
        }
      }
    });
  }
}
class Wm {
  /**
   * @param renderer - The renderer this sprite batch works for.
   * @param adaptor
   */
  constructor(t, e) {
    this.state = ye.for2d(), this.localUniforms = new kt({
      uTranslationMatrix: { value: new D(), type: "mat3x3<f32>" },
      uColor: { value: new Float32Array(4), type: "vec4<f32>" },
      uRound: { value: 1, type: "f32" },
      uResolution: { value: [0, 0], type: "vec2<f32>" }
    }), this.renderer = t, this.adaptor = e, this.defaultShader = new CC(), this.state = ye.for2d();
  }
  validateRenderable(t) {
    return !1;
  }
  addRenderable(t, e) {
    this.renderer.renderPipes.batch.break(e), e.add(t);
  }
  getBuffers(t) {
    return t._gpuData[this.renderer.uid] || this._initBuffer(t);
  }
  _initBuffer(t) {
    return t._gpuData[this.renderer.uid] = new vC({
      size: t.particleChildren.length,
      properties: t._properties
    }), t._gpuData[this.renderer.uid];
  }
  updateRenderable(t) {
  }
  execute(t) {
    const e = t.particleChildren;
    if (e.length === 0)
      return;
    const r = this.renderer, n = this.getBuffers(t);
    t.texture || (t.texture = e[0].texture);
    const a = this.state;
    n.update(e, t._childrenDirty), t._childrenDirty = !1, a.blendMode = us(t.blendMode, t.texture._source);
    const l = this.localUniforms.uniforms, h = l.uTranslationMatrix;
    t.worldTransform.copyTo(h), h.prepend(r.globalUniforms.globalUniformData.projectionMatrix), l.uResolution = r.globalUniforms.globalUniformData.resolution, l.uRound = r._roundPixels | t._roundPixels, Ss(
      t.groupColorAlpha,
      l.uColor,
      0
    ), this.adaptor.execute(this, t);
  }
  /** Destroys the ParticleRenderer. */
  destroy() {
    this.defaultShader && (this.defaultShader.destroy(), this.defaultShader = null);
  }
}
class Vm extends Wm {
  constructor(t) {
    super(t, new yC());
  }
}
Vm.extension = {
  type: [
    A.WebGLPipes
  ],
  name: "particle"
};
class $m extends Wm {
  constructor(t) {
    super(t, new xC());
  }
}
$m.extension = {
  type: [
    A.WebGPUPipes
  ],
  name: "particle"
};
const Ym = class Xm extends gC {
  constructor(t = {}) {
    t = { ...Xm.defaultOptions, ...t }, super({
      width: t.width,
      height: t.height,
      verticesX: 4,
      verticesY: 4
    }), this.update(t);
  }
  /**
   * Updates the NineSliceGeometry with the options.
   * @param options - The options of the NineSliceGeometry.
   */
  update(t) {
    this.width = t.width ?? this.width, this.height = t.height ?? this.height, this._originalWidth = t.originalWidth ?? this._originalWidth, this._originalHeight = t.originalHeight ?? this._originalHeight, this._leftWidth = t.leftWidth ?? this._leftWidth, this._rightWidth = t.rightWidth ?? this._rightWidth, this._topHeight = t.topHeight ?? this._topHeight, this._bottomHeight = t.bottomHeight ?? this._bottomHeight, this._anchorX = t.anchor?.x, this._anchorY = t.anchor?.y, this.updateUvs(), this.updatePositions();
  }
  /** Updates the positions of the vertices. */
  updatePositions() {
    const t = this.positions, {
      width: e,
      height: r,
      _leftWidth: n,
      _rightWidth: a,
      _topHeight: l,
      _bottomHeight: h,
      _anchorX: u,
      _anchorY: f
    } = this, p = n + a, m = e > p ? 1 : e / p, g = l + h, x = r > g ? 1 : r / g, o = Math.min(m, x), c = u * e, d = f * r;
    t[0] = t[8] = t[16] = t[24] = -c, t[2] = t[10] = t[18] = t[26] = n * o - c, t[4] = t[12] = t[20] = t[28] = e - a * o - c, t[6] = t[14] = t[22] = t[30] = e - c, t[1] = t[3] = t[5] = t[7] = -d, t[9] = t[11] = t[13] = t[15] = l * o - d, t[17] = t[19] = t[21] = t[23] = r - h * o - d, t[25] = t[27] = t[29] = t[31] = r - d, this.getBuffer("aPosition").update();
  }
  /** Updates the UVs of the vertices. */
  updateUvs() {
    const t = this.uvs;
    t[0] = t[8] = t[16] = t[24] = 0, t[1] = t[3] = t[5] = t[7] = 0, t[6] = t[14] = t[22] = t[30] = 1, t[25] = t[27] = t[29] = t[31] = 1;
    const e = 1 / this._originalWidth, r = 1 / this._originalHeight;
    t[2] = t[10] = t[18] = t[26] = e * this._leftWidth, t[9] = t[11] = t[13] = t[15] = r * this._topHeight, t[4] = t[12] = t[20] = t[28] = 1 - e * this._rightWidth, t[17] = t[19] = t[21] = t[23] = 1 - r * this._bottomHeight, this.getBuffer("aUV").update();
  }
};
Ym.defaultOptions = {
  /** The width of the NineSlicePlane, setting this will actually modify the vertices and UV's of this plane. */
  width: 100,
  /** The height of the NineSlicePlane, setting this will actually modify the vertices and UV's of this plane. */
  height: 100,
  /** The width of the left column. */
  leftWidth: 10,
  /** The height of the top row. */
  topHeight: 10,
  /** The width of the right column. */
  rightWidth: 10,
  /** The height of the bottom row. */
  bottomHeight: 10,
  /** The original width of the texture */
  originalWidth: 100,
  /** The original height of the texture */
  originalHeight: 100
};
let EC = Ym;
class AC extends yl {
  constructor() {
    super(), this.geometry = new EC();
  }
  destroy() {
    this.geometry.destroy();
  }
}
class jm {
  constructor(t) {
    this._renderer = t;
  }
  addRenderable(t, e) {
    const r = this._getGpuSprite(t);
    t.didViewUpdate && this._updateBatchableSprite(t, r), this._renderer.renderPipes.batch.addToBatch(r, e);
  }
  updateRenderable(t) {
    const e = this._getGpuSprite(t);
    t.didViewUpdate && this._updateBatchableSprite(t, e), e._batcher.updateElement(e);
  }
  validateRenderable(t) {
    const e = this._getGpuSprite(t);
    return !e._batcher.checkAndUpdateTexture(
      e,
      t._texture
    );
  }
  _updateBatchableSprite(t, e) {
    e.geometry.update(t), e.setTexture(t._texture);
  }
  _getGpuSprite(t) {
    return t._gpuData[this._renderer.uid] || this._initGPUSprite(t);
  }
  _initGPUSprite(t) {
    const e = t._gpuData[this._renderer.uid] = new AC(), r = e;
    return r.renderable = t, r.transform = t.groupTransform, r.texture = t._texture, r.roundPixels = this._renderer._roundPixels | t._roundPixels, t.didViewUpdate || this._updateBatchableSprite(t, r), e;
  }
  destroy() {
    this._renderer = null;
  }
}
jm.extension = {
  type: [
    A.WebGLPipes,
    A.WebGPUPipes,
    A.CanvasPipes
  ],
  name: "nineSliceSprite"
};
const PC = {
  name: "tiling-bit",
  vertex: {
    header: (
      /* wgsl */
      `
            struct TilingUniforms {
                uMapCoord:mat3x3<f32>,
                uClampFrame:vec4<f32>,
                uClampOffset:vec2<f32>,
                uTextureTransform:mat3x3<f32>,
                uSizeAnchor:vec4<f32>
            };

            @group(2) @binding(0) var<uniform> tilingUniforms: TilingUniforms;
            @group(2) @binding(1) var uTexture: texture_2d<f32>;
            @group(2) @binding(2) var uSampler: sampler;
        `
    ),
    main: (
      /* wgsl */
      `
            uv = (tilingUniforms.uTextureTransform * vec3(uv, 1.0)).xy;

            position = (position - tilingUniforms.uSizeAnchor.zw) * tilingUniforms.uSizeAnchor.xy;
        `
    )
  },
  fragment: {
    header: (
      /* wgsl */
      `
            struct TilingUniforms {
                uMapCoord:mat3x3<f32>,
                uClampFrame:vec4<f32>,
                uClampOffset:vec2<f32>,
                uTextureTransform:mat3x3<f32>,
                uSizeAnchor:vec4<f32>
            };

            @group(2) @binding(0) var<uniform> tilingUniforms: TilingUniforms;
            @group(2) @binding(1) var uTexture: texture_2d<f32>;
            @group(2) @binding(2) var uSampler: sampler;
        `
    ),
    main: (
      /* wgsl */
      `

            var coord = vUV + ceil(tilingUniforms.uClampOffset - vUV);
            coord = (tilingUniforms.uMapCoord * vec3(coord, 1.0)).xy;
            var unclamped = coord;
            coord = clamp(coord, tilingUniforms.uClampFrame.xy, tilingUniforms.uClampFrame.zw);

            var bias = 0.;

            if(unclamped.x == coord.x && unclamped.y == coord.y)
            {
                bias = -32.;
            }

            outColor = textureSampleBias(uTexture, uSampler, coord, bias);
        `
    )
  }
}, MC = {
  name: "tiling-bit",
  vertex: {
    header: (
      /* glsl */
      `
            uniform mat3 uTextureTransform;
            uniform vec4 uSizeAnchor;

        `
    ),
    main: (
      /* glsl */
      `
            uv = (uTextureTransform * vec3(aUV, 1.0)).xy;

            position = (position - uSizeAnchor.zw) * uSizeAnchor.xy;
        `
    )
  },
  fragment: {
    header: (
      /* glsl */
      `
            uniform sampler2D uTexture;
            uniform mat3 uMapCoord;
            uniform vec4 uClampFrame;
            uniform vec2 uClampOffset;
        `
    ),
    main: (
      /* glsl */
      `

        vec2 coord = vUV + ceil(uClampOffset - vUV);
        coord = (uMapCoord * vec3(coord, 1.0)).xy;
        vec2 unclamped = coord;
        coord = clamp(coord, uClampFrame.xy, uClampFrame.zw);

        outColor = texture(uTexture, coord, unclamped == coord ? 0.0 : -32.0);// lod-bias very negative to force lod 0

        `
    )
  }
};
let Wa, Va;
class BC extends ue {
  constructor() {
    Wa ?? (Wa = xs({
      name: "tiling-sprite-shader",
      bits: [
        qr,
        PC,
        vs
      ]
    })), Va ?? (Va = bs({
      name: "tiling-sprite-shader",
      bits: [
        al,
        MC,
        ws
      ]
    }));
    const t = new kt({
      uMapCoord: { value: new D(), type: "mat3x3<f32>" },
      uClampFrame: { value: new Float32Array([0, 0, 1, 1]), type: "vec4<f32>" },
      uClampOffset: { value: new Float32Array([0, 0]), type: "vec2<f32>" },
      uTextureTransform: { value: new D(), type: "mat3x3<f32>" },
      uSizeAnchor: { value: new Float32Array([100, 100, 0.5, 0.5]), type: "vec4<f32>" }
    });
    super({
      glProgram: Va,
      gpuProgram: Wa,
      resources: {
        localUniforms: new kt({
          uTransformMatrix: { value: new D(), type: "mat3x3<f32>" },
          uColor: { value: new Float32Array([1, 1, 1, 1]), type: "vec4<f32>" },
          uRound: { value: 0, type: "f32" }
        }),
        tilingUniforms: t,
        uTexture: k.EMPTY.source,
        uSampler: k.EMPTY.source.style
      }
    });
  }
  updateUniforms(t, e, r, n, a, l) {
    const h = this.resources.tilingUniforms, u = l.width, f = l.height, p = l.textureMatrix, m = h.uniforms.uTextureTransform;
    m.set(
      r.a * u / t,
      r.b * u / e,
      r.c * f / t,
      r.d * f / e,
      r.tx / t,
      r.ty / e
    ), m.invert(), h.uniforms.uMapCoord = p.mapCoord, h.uniforms.uClampFrame = p.uClampFrame, h.uniforms.uClampOffset = p.uClampOffset, h.uniforms.uTextureTransform = m, h.uniforms.uSizeAnchor[0] = t, h.uniforms.uSizeAnchor[1] = e, h.uniforms.uSizeAnchor[2] = n, h.uniforms.uSizeAnchor[3] = a, l && (this.resources.uTexture = l.source, this.resources.uSampler = l.source.style);
  }
}
class UC extends rl {
  constructor() {
    super({
      positions: new Float32Array([0, 0, 1, 0, 1, 1, 0, 1]),
      uvs: new Float32Array([0, 0, 1, 0, 1, 1, 0, 1]),
      indices: new Uint32Array([0, 1, 2, 0, 2, 3])
    });
  }
}
function RC(s, t) {
  const e = s.anchor.x, r = s.anchor.y;
  t[0] = -e * s.width, t[1] = -r * s.height, t[2] = (1 - e) * s.width, t[3] = -r * s.height, t[4] = (1 - e) * s.width, t[5] = (1 - r) * s.height, t[6] = -e * s.width, t[7] = (1 - r) * s.height;
}
function IC(s, t, e, r) {
  let n = 0;
  const a = s.length / t, l = r.a, h = r.b, u = r.c, f = r.d, p = r.tx, m = r.ty;
  for (e *= t; n < a; ) {
    const g = s[e], x = s[e + 1];
    s[e] = l * g + u * x + p, s[e + 1] = h * g + f * x + m, e += t, n++;
  }
}
function kC(s, t) {
  const e = s.texture, r = e.frame.width, n = e.frame.height;
  let a = 0, l = 0;
  s.applyAnchorToTexture && (a = s.anchor.x, l = s.anchor.y), t[0] = t[6] = -a, t[2] = t[4] = 1 - a, t[1] = t[3] = -l, t[5] = t[7] = 1 - l;
  const h = D.shared;
  h.copyFrom(s._tileTransform.matrix), h.tx /= s.width, h.ty /= s.height, h.invert(), h.scale(s.width / r, s.height / n), IC(t, 2, 0, h);
}
const ln = new UC();
class FC {
  constructor() {
    this.canBatch = !0, this.geometry = new rl({
      indices: ln.indices.slice(),
      positions: ln.positions.slice(),
      uvs: ln.uvs.slice()
    });
  }
  destroy() {
    this.geometry.destroy(), this.shader?.destroy();
  }
}
class Km {
  constructor(t) {
    this._state = ye.default2d, this._renderer = t;
  }
  validateRenderable(t) {
    const e = this._getTilingSpriteData(t), r = e.canBatch;
    this._updateCanBatch(t);
    const n = e.canBatch;
    if (n && n === r) {
      const { batchableMesh: a } = e;
      return !a._batcher.checkAndUpdateTexture(
        a,
        t.texture
      );
    }
    return r !== n;
  }
  addRenderable(t, e) {
    const r = this._renderer.renderPipes.batch;
    this._updateCanBatch(t);
    const n = this._getTilingSpriteData(t), { geometry: a, canBatch: l } = n;
    if (l) {
      n.batchableMesh || (n.batchableMesh = new yl());
      const h = n.batchableMesh;
      t.didViewUpdate && (this._updateBatchableMesh(t), h.geometry = a, h.renderable = t, h.transform = t.groupTransform, h.setTexture(t._texture)), h.roundPixels = this._renderer._roundPixels | t._roundPixels, r.addToBatch(h, e);
    } else
      r.break(e), n.shader || (n.shader = new BC()), this.updateRenderable(t), e.add(t);
  }
  execute(t) {
    const { shader: e } = this._getTilingSpriteData(t);
    e.groups[0] = this._renderer.globalUniforms.bindGroup;
    const r = e.resources.localUniforms.uniforms;
    r.uTransformMatrix = t.groupTransform, r.uRound = this._renderer._roundPixels | t._roundPixels, Ss(
      t.groupColorAlpha,
      r.uColor,
      0
    ), this._state.blendMode = us(t.groupBlendMode, t.texture._source), this._renderer.encoder.draw({
      geometry: ln,
      shader: e,
      state: this._state
    });
  }
  updateRenderable(t) {
    const e = this._getTilingSpriteData(t), { canBatch: r } = e;
    if (r) {
      const { batchableMesh: n } = e;
      t.didViewUpdate && this._updateBatchableMesh(t), n._batcher.updateElement(n);
    } else if (t.didViewUpdate) {
      const { shader: n } = e;
      n.updateUniforms(
        t.width,
        t.height,
        t._tileTransform.matrix,
        t.anchor.x,
        t.anchor.y,
        t.texture
      );
    }
  }
  _getTilingSpriteData(t) {
    return t._gpuData[this._renderer.uid] || this._initTilingSpriteData(t);
  }
  _initTilingSpriteData(t) {
    const e = new FC();
    return e.renderable = t, t._gpuData[this._renderer.uid] = e, e;
  }
  _updateBatchableMesh(t) {
    const e = this._getTilingSpriteData(t), { geometry: r } = e, n = t.texture.source.style;
    n.addressMode !== "repeat" && (n.addressMode = "repeat", n.update()), kC(t, r.uvs), RC(t, r.positions);
  }
  destroy() {
    this._renderer = null;
  }
  _updateCanBatch(t) {
    const e = this._getTilingSpriteData(t), r = t.texture;
    let n = !0;
    return this._renderer.type === ge.WEBGL && (n = this._renderer.context.supports.nonPowOf2wrapping), e.canBatch = r.textureMatrix.isSimple && (n || r.source.isPowerOfTwo), e.canBatch;
  }
}
Km.extension = {
  type: [
    A.WebGLPipes,
    A.WebGPUPipes,
    A.CanvasPipes
  ],
  name: "tilingSprite"
};
const DC = {
  name: "local-uniform-msdf-bit",
  vertex: {
    header: (
      /* wgsl */
      `
            struct LocalUniforms {
                uColor:vec4<f32>,
                uTransformMatrix:mat3x3<f32>,
                uDistance: f32,
                uRound:f32,
            }

            @group(2) @binding(0) var<uniform> localUniforms : LocalUniforms;
        `
    ),
    main: (
      /* wgsl */
      `
            vColor *= localUniforms.uColor;
            modelMatrix *= localUniforms.uTransformMatrix;
        `
    ),
    end: (
      /* wgsl */
      `
            if(localUniforms.uRound == 1)
            {
                vPosition = vec4(roundPixels(vPosition.xy, globalUniforms.uResolution), vPosition.zw);
            }
        `
    )
  },
  fragment: {
    header: (
      /* wgsl */
      `
            struct LocalUniforms {
                uColor:vec4<f32>,
                uTransformMatrix:mat3x3<f32>,
                uDistance: f32
            }

            @group(2) @binding(0) var<uniform> localUniforms : LocalUniforms;
         `
    ),
    main: (
      /* wgsl */
      `
            outColor = vec4<f32>(calculateMSDFAlpha(outColor, localUniforms.uColor, localUniforms.uDistance));
        `
    )
  }
}, OC = {
  name: "local-uniform-msdf-bit",
  vertex: {
    header: (
      /* glsl */
      `
            uniform mat3 uTransformMatrix;
            uniform vec4 uColor;
            uniform float uRound;
        `
    ),
    main: (
      /* glsl */
      `
            vColor *= uColor;
            modelMatrix *= uTransformMatrix;
        `
    ),
    end: (
      /* glsl */
      `
            if(uRound == 1.)
            {
                gl_Position.xy = roundPixels(gl_Position.xy, uResolution);
            }
        `
    )
  },
  fragment: {
    header: (
      /* glsl */
      `
            uniform float uDistance;
         `
    ),
    main: (
      /* glsl */
      `
            outColor = vec4(calculateMSDFAlpha(outColor, vColor, uDistance));
        `
    )
  }
}, LC = {
  name: "msdf-bit",
  fragment: {
    header: (
      /* wgsl */
      `
            fn calculateMSDFAlpha(msdfColor:vec4<f32>, shapeColor:vec4<f32>, distance:f32) -> f32 {

                // MSDF
                var median = msdfColor.r + msdfColor.g + msdfColor.b -
                    min(msdfColor.r, min(msdfColor.g, msdfColor.b)) -
                    max(msdfColor.r, max(msdfColor.g, msdfColor.b));

                // SDF
                median = min(median, msdfColor.a);

                var screenPxDistance = distance * (median - 0.5);
                var alpha = clamp(screenPxDistance + 0.5, 0.0, 1.0);
                if (median < 0.01) {
                    alpha = 0.0;
                } else if (median > 0.99) {
                    alpha = 1.0;
                }

                // Gamma correction for coverage-like alpha
                var luma: f32 = dot(shapeColor.rgb, vec3<f32>(0.299, 0.587, 0.114));
                var gamma: f32 = mix(1.0, 1.0 / 2.2, luma);
                var coverage: f32 = pow(shapeColor.a * alpha, gamma);

                return coverage;

            }
        `
    )
  }
}, GC = {
  name: "msdf-bit",
  fragment: {
    header: (
      /* glsl */
      `
            float calculateMSDFAlpha(vec4 msdfColor, vec4 shapeColor, float distance) {

                // MSDF
                float median = msdfColor.r + msdfColor.g + msdfColor.b -
                                min(msdfColor.r, min(msdfColor.g, msdfColor.b)) -
                                max(msdfColor.r, max(msdfColor.g, msdfColor.b));

                // SDF
                median = min(median, msdfColor.a);

                float screenPxDistance = distance * (median - 0.5);
                float alpha = clamp(screenPxDistance + 0.5, 0.0, 1.0);

                if (median < 0.01) {
                    alpha = 0.0;
                } else if (median > 0.99) {
                    alpha = 1.0;
                }

                // Gamma correction for coverage-like alpha
                float luma = dot(shapeColor.rgb, vec3(0.299, 0.587, 0.114));
                float gamma = mix(1.0, 1.0 / 2.2, luma);
                float coverage = pow(shapeColor.a * alpha, gamma);

                return coverage;
            }
        `
    )
  }
};
let $a, Ya;
class zC extends ue {
  constructor(t) {
    const e = new kt({
      uColor: { value: new Float32Array([1, 1, 1, 1]), type: "vec4<f32>" },
      uTransformMatrix: { value: new D(), type: "mat3x3<f32>" },
      uDistance: { value: 4, type: "f32" },
      uRound: { value: 0, type: "f32" }
    });
    $a ?? ($a = xs({
      name: "sdf-shader",
      bits: [
        Hh,
        Vh(t),
        DC,
        LC,
        vs
      ]
    })), Ya ?? (Ya = bs({
      name: "sdf-shader",
      bits: [
        Wh,
        $h(t),
        OC,
        GC,
        ws
      ]
    })), super({
      glProgram: Ya,
      gpuProgram: $a,
      resources: {
        localUniforms: e,
        batchSamplers: Yh(t)
      }
    });
  }
}
class NC extends fr {
  destroy() {
    this.context.customShader && this.context.customShader.destroy(), super.destroy();
  }
}
class qm {
  constructor(t) {
    this._renderer = t, this._renderer.renderableGC.addManagedHash(this, "_gpuBitmapText");
  }
  validateRenderable(t) {
    const e = this._getGpuBitmapText(t);
    return t._didTextUpdate && (t._didTextUpdate = !1, this._updateContext(t, e)), this._renderer.renderPipes.graphics.validateRenderable(e);
  }
  addRenderable(t, e) {
    const r = this._getGpuBitmapText(t);
    qu(t, r), t._didTextUpdate && (t._didTextUpdate = !1, this._updateContext(t, r)), this._renderer.renderPipes.graphics.addRenderable(r, e), r.context.customShader && this._updateDistanceField(t);
  }
  updateRenderable(t) {
    const e = this._getGpuBitmapText(t);
    qu(t, e), this._renderer.renderPipes.graphics.updateRenderable(e), e.context.customShader && this._updateDistanceField(t);
  }
  _updateContext(t, e) {
    const { context: r } = e, n = Yo.getFont(t.text, t._style);
    r.clear(), n.distanceField.type !== "none" && (r.customShader || (r.customShader = new zC(this._renderer.limits.maxBatchableTextures)));
    const a = me.graphemeSegmenter(t.text), l = t._style;
    let h = n.baseLineOffset;
    const u = e_(a, l, n, !0);
    let f = 0;
    const p = l.padding, m = u.scale;
    let g = u.width, x = u.height + u.offsetY;
    l._stroke && (g += l._stroke.width / m, x += l._stroke.width / m), r.translate(-t._anchor._x * g - p, -t._anchor._y * x - p).scale(m, m);
    const o = n.applyFillAsTint ? l._fill.color : 16777215;
    for (let c = 0; c < u.lines.length; c++) {
      const d = u.lines[c];
      for (let _ = 0; _ < d.charPositions.length; _++) {
        const y = a[f++], v = n.chars[y];
        v?.texture && r.texture(
          v.texture,
          o || "black",
          Math.round(d.charPositions[_] + v.xOffset),
          Math.round(h + v.yOffset)
        );
      }
      h += n.lineHeight;
    }
  }
  _getGpuBitmapText(t) {
    return t._gpuData[this._renderer.uid] || this.initGpuText(t);
  }
  initGpuText(t) {
    const e = new NC();
    return t._gpuData[this._renderer.uid] = e, this._updateContext(t, e), e;
  }
  _updateDistanceField(t) {
    const e = this._getGpuBitmapText(t).context, r = t._style.fontFamily, n = it.get(`${r}-bitmap`), { a, b: l, c: h, d: u } = t.groupTransform, f = Math.sqrt(a * a + l * l), p = Math.sqrt(h * h + u * u), m = (Math.abs(f) + Math.abs(p)) / 2, g = n.baseRenderedFontSize / t._style.fontSize, x = m * n.distanceField.range * (1 / g);
    e.customShader.resources.localUniforms.uniforms.uDistance = x;
  }
  destroy() {
    this._renderer = null;
  }
}
qm.extension = {
  type: [
    A.WebGLPipes,
    A.WebGPUPipes,
    A.CanvasPipes
  ],
  name: "bitmapText"
};
function qu(s, t) {
  t.groupTransform = s.groupTransform, t.groupColorAlpha = s.groupColorAlpha, t.groupColor = s.groupColor, t.groupBlendMode = s.groupBlendMode, t.globalDisplayStatus = s.globalDisplayStatus, t.groupTransform = s.groupTransform, t.localDisplayStatus = s.localDisplayStatus, t.groupAlpha = s.groupAlpha, t._roundPixels = s._roundPixels;
}
class HC extends Yn {
  /**
   * Creates an instance of BatchableHTMLText.
   * @param renderer - The renderer instance to be used.
   */
  constructor(t) {
    super(), this.generatingTexture = !1, this._renderer = t, t.runners.resolutionChange.add(this);
  }
  /** Handles resolution changes for the HTML text. If the text has auto resolution enabled, it triggers a view update. */
  resolutionChange() {
    const t = this.renderable;
    t._autoResolution && t.onViewUpdate();
  }
  /** Destroys the BatchableHTMLText instance. Returns the texture promise to the renderer and cleans up references. */
  destroy() {
    this._renderer.htmlText.returnTexturePromise(this.texturePromise), this.texturePromise = null, this._renderer = null;
  }
}
function th(s, t) {
  const { texture: e, bounds: r } = s;
  Vf(r, t._anchor, e);
  const n = t._style._getFinalPadding();
  r.minX -= n, r.minY -= n, r.maxX -= n, r.maxY -= n;
}
class Zm {
  constructor(t) {
    this._renderer = t;
  }
  validateRenderable(t) {
    return t._didTextUpdate;
  }
  addRenderable(t, e) {
    const r = this._getGpuText(t);
    t._didTextUpdate && (this._updateGpuText(t).catch((n) => {
      console.error(n);
    }), t._didTextUpdate = !1, th(r, t)), this._renderer.renderPipes.batch.addToBatch(r, e);
  }
  updateRenderable(t) {
    const e = this._getGpuText(t);
    e._batcher.updateElement(e);
  }
  async _updateGpuText(t) {
    t._didTextUpdate = !1;
    const e = this._getGpuText(t);
    if (e.generatingTexture)
      return;
    e.texturePromise && (this._renderer.htmlText.returnTexturePromise(e.texturePromise), e.texturePromise = null), e.generatingTexture = !0, t._resolution = t._autoResolution ? this._renderer.resolution : t.resolution;
    const r = this._renderer.htmlText.getTexturePromise(t);
    e.texturePromise = r, e.texture = await r;
    const n = t.renderGroup || t.parentRenderGroup;
    n && (n.structureDidChange = !0), e.generatingTexture = !1, th(e, t);
  }
  _getGpuText(t) {
    return t._gpuData[this._renderer.uid] || this.initGpuText(t);
  }
  initGpuText(t) {
    const e = new HC(this._renderer);
    return e.renderable = t, e.transform = t.groupTransform, e.texture = k.EMPTY, e.bounds = { minX: 0, maxX: 1, minY: 0, maxY: 0 }, e.roundPixels = this._renderer._roundPixels | t._roundPixels, t._resolution = t._autoResolution ? this._renderer.resolution : t.resolution, t._gpuData[this._renderer.uid] = e, e;
  }
  destroy() {
    this._renderer = null;
  }
}
Zm.extension = {
  type: [
    A.WebGLPipes,
    A.WebGPUPipes,
    A.CanvasPipes
  ],
  name: "htmlText"
};
function WC() {
  const { userAgent: s } = Y.get().getNavigator();
  return /^((?!chrome|android).)*safari/i.test(s);
}
const VC = new Ut();
function Qm(s, t, e, r) {
  const n = VC;
  n.minX = 0, n.minY = 0, n.maxX = s.width / r | 0, n.maxY = s.height / r | 0;
  const a = At.getOptimalTexture(
    n.width,
    n.height,
    r,
    !1
  );
  return a.source.uploadMethodId = "image", a.source.resource = s, a.source.alphaMode = "premultiply-alpha-on-upload", a.frame.width = t / r, a.frame.height = e / r, a.source.emit("update", a.source), a.updateUvs(), a;
}
function $C(s, t) {
  const e = t.fontFamily, r = [], n = {}, a = /font-family:([^;"\s]+)/g, l = s.match(a);
  function h(u) {
    n[u] || (r.push(u), n[u] = !0);
  }
  if (Array.isArray(e))
    for (let u = 0; u < e.length; u++)
      h(e[u]);
  else
    h(e);
  l && l.forEach((u) => {
    const f = u.split(":")[1].trim();
    h(f);
  });
  for (const u in t.tagStyles) {
    const f = t.tagStyles[u].fontFamily;
    h(f);
  }
  return r;
}
async function YC(s) {
  const e = await (await Y.get().fetch(s)).blob(), r = new FileReader();
  return await new Promise((a, l) => {
    r.onloadend = () => a(r.result), r.onerror = l, r.readAsDataURL(e);
  });
}
async function Zu(s, t) {
  const e = await YC(t);
  return `@font-face {
        font-family: "${s.fontFamily}";
        src: url('${e}');
        font-weight: ${s.fontWeight};
        font-style: ${s.fontStyle};
    }`;
}
const js = /* @__PURE__ */ new Map();
async function XC(s, t, e) {
  const r = s.filter((n) => it.has(`${n}-and-url`)).map((n, a) => {
    if (!js.has(n)) {
      const { url: l } = it.get(`${n}-and-url`);
      a === 0 ? js.set(n, Zu({
        fontWeight: t.fontWeight,
        fontStyle: t.fontStyle,
        fontFamily: n
      }, l)) : js.set(n, Zu({
        fontWeight: e.fontWeight,
        fontStyle: e.fontStyle,
        fontFamily: n
      }, l));
    }
    return js.get(n);
  });
  return (await Promise.all(r)).join(`
`);
}
function jC(s, t, e, r, n) {
  const { domElement: a, styleElement: l, svgRoot: h } = n;
  a.innerHTML = `<style>${t.cssStyle}</style><div style='padding:0;'>${s}</div>`, a.setAttribute("style", `transform: scale(${e});transform-origin: top left; display: inline-block`), l.textContent = r;
  const { width: u, height: f } = n.image;
  return h.setAttribute("width", u.toString()), h.setAttribute("height", f.toString()), new XMLSerializer().serializeToString(h);
}
function KC(s, t) {
  const e = oi.getOptimalCanvasAndContext(
    s.width,
    s.height,
    t
  ), { context: r } = e;
  return r.clearRect(0, 0, s.width, s.height), r.drawImage(s, 0, 0), e;
}
function qC(s, t, e) {
  return new Promise(async (r) => {
    e && await new Promise((n) => setTimeout(n, 100)), s.onload = () => {
      r();
    }, s.src = `data:image/svg+xml;charset=utf8,${encodeURIComponent(t)}`, s.crossOrigin = "anonymous";
  });
}
class Jm {
  constructor(t) {
    this._renderer = t, this._createCanvas = t.type === ge.WEBGPU;
  }
  /**
   * @param options
   * @deprecated Use getTexturePromise instead
   */
  getTexture(t) {
    return this.getTexturePromise(t);
  }
  getTexturePromise(t) {
    return this._buildTexturePromise(t);
  }
  async _buildTexturePromise(t) {
    const { text: e, style: r, resolution: n, textureStyle: a } = t, l = Ct.get(m_), h = $C(e, r), u = await XC(
      h,
      r,
      sl.defaultTextStyle
    ), f = BS(e, r, u, l), p = Math.ceil(Math.ceil(Math.max(1, f.width) + r.padding * 2) * n), m = Math.ceil(Math.ceil(Math.max(1, f.height) + r.padding * 2) * n), g = l.image, x = 2;
    g.width = (p | 0) + x, g.height = (m | 0) + x;
    const o = jC(e, r, n, u, l);
    await qC(g, o, WC() && h.length > 0);
    const c = g;
    let d;
    this._createCanvas && (d = KC(g, n));
    const _ = Qm(
      d ? d.canvas : c,
      g.width - x,
      g.height - x,
      n
    );
    return a && (_.source.style = a), this._createCanvas && (this._renderer.texture.initSource(_.source), oi.returnCanvasAndContext(d)), Ct.return(l), _;
  }
  returnTexturePromise(t) {
    t.then((e) => {
      this._cleanUp(e);
    }).catch(() => {
      N("HTMLTextSystem: Failed to clean texture");
    });
  }
  _cleanUp(t) {
    At.returnTexture(t, !0), t.source.resource = null, t.source.uploadMethodId = "unknown";
  }
  destroy() {
    this._renderer = null;
  }
}
Jm.extension = {
  type: [
    A.WebGLSystem,
    A.WebGPUSystem,
    A.CanvasSystem
  ],
  name: "htmlText"
};
class ZC extends Yn {
  constructor(t) {
    super(), this._renderer = t, t.runners.resolutionChange.add(this);
  }
  resolutionChange() {
    const t = this.renderable;
    t._autoResolution && t.onViewUpdate();
  }
  destroy() {
    this._renderer.canvasText.returnTexture(this.texture), this._renderer = null;
  }
}
class tg {
  constructor(t) {
    this._renderer = t;
  }
  validateRenderable(t) {
    return t._didTextUpdate;
  }
  addRenderable(t, e) {
    const r = this._getGpuText(t);
    t._didTextUpdate && (this._updateGpuText(t), t._didTextUpdate = !1), this._renderer.renderPipes.batch.addToBatch(r, e);
  }
  updateRenderable(t) {
    const e = this._getGpuText(t);
    e._batcher.updateElement(e);
  }
  _updateGpuText(t) {
    const e = this._getGpuText(t);
    e.texture && this._renderer.canvasText.returnTexture(e.texture), t._resolution = t._autoResolution ? this._renderer.resolution : t.resolution, e.texture = e.texture = this._renderer.canvasText.getTexture(t), th(e, t);
  }
  _getGpuText(t) {
    return t._gpuData[this._renderer.uid] || this.initGpuText(t);
  }
  initGpuText(t) {
    const e = new ZC(this._renderer);
    return e.renderable = t, e.transform = t.groupTransform, e.bounds = { minX: 0, maxX: 1, minY: 0, maxY: 0 }, e.roundPixels = this._renderer._roundPixels | t._roundPixels, t._gpuData[this._renderer.uid] = e, e;
  }
  destroy() {
    this._renderer = null;
  }
}
tg.extension = {
  type: [
    A.WebGLPipes,
    A.WebGPUPipes,
    A.CanvasPipes
  ],
  name: "text"
};
class eg {
  constructor(t) {
    this._renderer = t;
  }
  getTexture(t, e, r, n) {
    typeof t == "string" && (W("8.0.0", "CanvasTextSystem.getTexture: Use object TextOptions instead of separate arguments"), t = {
      text: t,
      style: r,
      resolution: e
    }), t.style instanceof ce || (t.style = new ce(t.style)), t.textureStyle instanceof $e || (t.textureStyle = new $e(t.textureStyle)), typeof t.text != "string" && (t.text = t.text.toString());
    const { text: a, style: l, textureStyle: h } = t, u = t.resolution ?? this._renderer.resolution, { frame: f, canvasAndContext: p } = Kr.getCanvasAndContext({
      text: a,
      style: l,
      resolution: u
    }), m = Qm(p.canvas, f.width, f.height, u);
    if (h && (m.source.style = h), l.trim && (f.pad(l.padding), m.frame.copyFrom(f), m.updateUvs()), l.filters) {
      const g = this._applyFilters(m, l.filters);
      return this.returnTexture(m), Kr.returnCanvasAndContext(p), g;
    }
    return this._renderer.texture.initSource(m._source), Kr.returnCanvasAndContext(p), m;
  }
  /**
   * Returns a texture that was created wit the above `getTexture` function.
   * Handy if you are done with a texture and want to return it to the pool.
   * @param texture - The texture to be returned.
   */
  returnTexture(t) {
    const e = t.source;
    e.resource = null, e.uploadMethodId = "unknown", e.alphaMode = "no-premultiply-alpha", At.returnTexture(t, !0);
  }
  /**
   * Renders text to its canvas, and updates its texture.
   * @deprecated since 8.10.0
   */
  renderTextToCanvas() {
    W(
      "8.10.0",
      "CanvasTextSystem.renderTextToCanvas: no longer supported, use CanvasTextSystem.getTexture instead"
    );
  }
  /**
   * Applies the specified filters to the given texture.
   *
   * This method takes a texture and a list of filters, applies the filters to the texture,
   * and returns the resulting texture. It also ensures that the alpha mode of the resulting
   * texture is set to 'premultiplied-alpha'.
   * @param {Texture} texture - The texture to which the filters will be applied.
   * @param {Filter[]} filters - The filters to apply to the texture.
   * @returns {Texture} The resulting texture after all filters have been applied.
   */
  _applyFilters(t, e) {
    const r = this._renderer.renderTarget.renderTarget, n = this._renderer.filter.generateFilteredTexture({
      texture: t,
      filters: e
    });
    return this._renderer.renderTarget.bind(r, !1), n;
  }
  destroy() {
    this._renderer = null;
  }
}
eg.extension = {
  type: [
    A.WebGLSystem,
    A.WebGPUSystem,
    A.CanvasSystem
  ],
  name: "canvasText"
};
L.add(R0, I0);
function Xa(s, t = 0.5, e = 0.5) {
  s.pivot.set(s.width * t, s.height * e), s.position.set(s.x + s.width * t, s.y + s.height * e);
}
const Un = {
  fadeIn: (s, { container: t }, { duration: e }) => {
    t.alpha = 0, s.to(t, {
      duration: e,
      pixi: {
        alpha: 1
      },
      ease: "power1.inOut"
    });
  },
  zoomFadeInGrow: (s, { container: t }, { duration: e }) => {
    Xa(t), t.alpha = 0, t.scale.set(0.5, 0.5), s.to(t, {
      duration: e,
      pixi: {
        alpha: 1,
        scaleX: 1,
        scaleY: 1
      },
      ease: "power1.inOut"
    });
  },
  zoomFadeInShrink: (s, { container: t }, { duration: e }) => {
    Xa(t), t.alpha = 0, t.scale.set(1.5, 1.5), s.to(t, {
      duration: e,
      pixi: {
        alpha: 1,
        scaleX: 1,
        scaleY: 1
      },
      ease: "power1.inOut"
    });
  },
  slideFadeInUp: (s, { container: t }, { duration: e }) => {
    t.alpha = 0, t.y += t.height, s.to(t, {
      duration: e,
      pixi: {
        alpha: 1,
        y: t.y - t.height
      },
      ease: "power1.inOut"
    });
  },
  slideFadeInDown: (s, { container: t }, { duration: e }) => {
    t.alpha = 0, t.y -= t.height, s.to(t, {
      duration: e,
      pixi: {
        alpha: 1,
        y: t.y + t.height
      },
      ease: "power1.inOut"
    });
  },
  slideInLeft: (s, { container: t }, { duration: e }) => {
    const r = t.x;
    t.x -= t.width, t.mask = new fr().rect(r, t.y, t.width, t.height).fill(), s.to(t, {
      duration: e,
      pixi: { x: r },
      ease: "power1.inOut"
    });
  },
  slideInRight: (s, { container: t }, { duration: e }) => {
    const r = t.x;
    t.x += t.width, t.mask = new fr().rect(r, t.y, t.width, t.height).fill(), s.to(t, {
      duration: e,
      pixi: { x: r },
      ease: "power1.inOut"
    });
  },
  /**
   * 文字强调动画，读到当前文字时，文字会放大
   */
  wordEmphasize: (s, { words: t }) => {
    t.forEach(({ pixiText: e, ts: r }) => {
      const n = (r[1] - r[0]) / 2;
      Xa(e, 0.5, 1), s.to(
        e,
        {
          duration: n * 2,
          pixi: {
            scaleX: 1.2,
            scaleY: 1.2
          },
          ease: "power1.inOut"
        },
        r[0]
      ), s.to(
        e,
        {
          duration: n * 2,
          pixi: {
            scaleX: 1,
            scaleY: 1
          },
          ease: "power1.inOut"
        },
        r[0] + n * 2
      );
    });
  },
  wordTyping: (s, { words: t }, { duration: e }) => {
    const r = e / t.length;
    for (let n = 0; n < t.length; n++) {
      const { pixiText: a } = t[n];
      a.alpha = 0, s.to(
        a,
        {
          duration: r,
          pixi: {
            alpha: 1
          },
          ease: "steps(1)"
        },
        r * n
      );
    }
  }
}, Rn = {
  fadeOut: (s, { container: t }, { duration: e, delay: r }) => {
    s.to(
      t,
      {
        duration: e,
        pixi: {
          alpha: 0
        },
        ease: "power1.inOut"
      },
      r
    );
  },
  zoomFadeOutGrow: (s, { container: t }, { duration: e, delay: r }) => {
    s.to(
      t,
      {
        duration: e,
        pixi: {
          alpha: 0,
          scaleX: 1.2,
          scaleY: 1.2
        },
        ease: "power1.inOut"
      },
      r
    );
  },
  zoomFadeOutShrink: (s, { container: t }, { duration: e, delay: r }) => {
    s.to(
      t,
      {
        duration: e,
        pixi: {
          alpha: 0,
          scaleX: 0.8,
          scaleY: 0.8
        },
        ease: "power1.inOut"
      },
      r
    );
  },
  slideFadeOutUp: (s, { container: t, originCtnrRect: e }, { duration: r, delay: n }) => {
    s.to(
      t,
      {
        duration: r,
        pixi: {
          alpha: 0,
          y: e.y - e.h
        },
        ease: "power1.inOut"
      },
      n
    );
  },
  slideFadeOutDown: (s, { container: t, originCtnrRect: e }, { duration: r, delay: n }) => {
    s.to(
      t,
      {
        duration: r,
        pixi: {
          alpha: 0,
          y: e.y + e.h
        },
        ease: "power1.inOut"
      },
      n
    );
  },
  slideOutLeft: (s, { container: t, originCtnrRect: e }, { duration: r, delay: n }) => {
    s.to(
      t,
      {
        duration: r,
        pixi: {
          x: e.x - e.w
        },
        ease: "power1.inOut"
      },
      n
    );
  },
  slideOutRight: (s, { container: t, originCtnrRect: e }, { duration: r, delay: n }) => {
    s.to(
      t,
      {
        duration: r,
        pixi: {
          x: e.x + e.w
        },
        ease: "power1.inOut"
      },
      n
    );
  }
};
_r.registerPlugin(ms);
ms.registerPIXI({ Application: yr, Assets: Ki, Container: St, Sprite: Be, Text: $n });
class xl {
  #t;
  ready;
  #i = {
    // 微秒
    duration: 0,
    width: 0,
    height: 0
  };
  #e = [];
  #s;
  #r;
  // 预构建并缓存每条字幕的容器与文字，避免每帧创建
  #n = /* @__PURE__ */ new Map();
  get meta() {
    return { ...this.#i };
  }
  constructor(t, e) {
    this.#s = e, this.#e = t, this.#t = new OffscreenCanvas(e.videoWidth, e.videoHeight), this.#r = new yr(), this.ready = this.#r.init({
      view: this.#t,
      width: e.videoWidth,
      height: e.videoHeight,
      backgroundAlpha: 0
    }).then(() => (this.#i.width = e.videoWidth, this.#i.height = e.videoHeight, this.#i.duration = t[t.length - 1].endTime, this.buildScene(), this.meta));
  }
  async tick(t) {
    if (t > this.#i.duration)
      return {
        state: "done",
        video: await createImageBitmap(this.#t)
      };
    const e = {}, r = [];
    for (const n of this.#e) {
      const a = this.#n.get(n.id);
      if (!a) continue;
      const l = t >= n.startTime && t <= n.endTime;
      if (a.container.visible = l, !l) continue;
      a.container.scale = { x: 1, y: 1 };
      let h = 0;
      for (const p of a.words)
        p.pixiText.scale = { x: 1, y: 1 }, p.pixiText.x = h, p.pixiText.y = 0, h += p.pixiText.width;
      a.container.x = n.x == null ? (this.#t.width - a.container.width) / 2 : n.x, a.container.y = n.y == null ? this.#t.height * 0.8 : n.y;
      const u = a.container.height * 0.1 + a.maxEffectWidth;
      e[n.id] = new Et(
        a.container.x - u,
        a.container.y - u,
        a.container.width + u * 2,
        a.container.height + u * 2
      );
      const f = _r.timeline();
      QC(f, a.container, n, a.words, t), r.push(f);
    }
    this.#r.render();
    for (const n of r) n.kill();
    return {
      state: "success",
      video: await createImageBitmap(this.#t),
      contentRects: e
    };
  }
  async clone() {
    return new xl(this.#e, this.#s);
  }
  // 预构建场景节点，缓存每条字幕的 Container 和 Text，避免在 tick() 中重复创建
  buildScene() {
    this.#e.forEach((t) => {
      const e = new St(), r = new ce(t.defaultStyle);
      let n = 0;
      const a = t.words.map((l) => {
        const h = new $n({
          text: l.word,
          style: l.style != null ? new ce(l.style) : r
        });
        e.addChild(h);
        const u = h.style;
        return n = Math.max(
          n,
          // @ts-ignore
          u.stroke?.width ?? 0,
          // @ts-ignore
          u.dropShadow?.distance ?? 0,
          // @ts-ignore
          u.dropShadow?.blur ?? 0
        ), { ts: l.ts, pixiText: h };
      });
      e.visible = !1, this.#r.stage.addChild(e), this.#n.set(t.id, {
        container: e,
        words: a,
        defStyle: r,
        maxEffectWidth: n
      });
    });
  }
  destroy() {
    this.#r.destroy(!0, !0), this.#n.forEach((t) => {
      t.container.destroy({ children: !0, texture: !0 });
    }), this.#n.clear();
  }
}
function QC(s, t, e, r, n) {
  const { in: a, out: l } = e.animation ?? {}, h = r.map((p) => ({
    ...p,
    ts: [
      (p.ts[0] - e.startTime) / 1e6,
      (p.ts[1] - e.startTime) / 1e6
    ]
  })), u = {
    x: t.x,
    y: t.y,
    w: t.width,
    h: t.height
  };
  a != null && Un[a.type] && Un[a.type](
    s,
    { container: t, words: h, originCtnrRect: u },
    { duration: (a.duration ?? 1e6) / 1e6 }
  ), l != null && Rn[l.type] && Rn[l.type](
    s,
    { container: t, words: h, originCtnrRect: u },
    {
      duration: (l.duration ?? 1e6) / 1e6,
      delay: (e.endTime - (l.duration ?? 1e6)) / 1e6
    }
  );
  const f = e.endTime - e.startTime;
  s.to({}, { duration: f / 1e6 }, 0), s.progress(Math.min((n - e.startTime) / f, 1));
}
_r.registerPlugin(ms);
ms.registerPIXI({ Application: yr, Assets: Ki, Container: St, Sprite: Be, Text: $n });
function JC(s) {
  const t = s.trim().match(/^linear-gradient\s*\(\s*(.+)\s*\)$/);
  if (!t)
    return null;
  const r = t[1].split(",").map((n) => n.trim());
  if (r.length < 6)
    return null;
  try {
    const n = parseFloat(r[0]), a = parseFloat(r[1]), l = parseFloat(r[2]), h = parseFloat(r[3]), u = [];
    for (let p = 4; p < r.length; p++) {
      const g = r[p].trim().match(/^(.+)\s+([0-9.]+)$/);
      if (g) {
        const x = g[1].trim(), o = parseFloat(g[2]);
        u.push({ color: x, stop: o });
      }
    }
    if (u.length < 2)
      return null;
    const f = new Ue({
      type: "linear",
      start: { x: n, y: a },
      end: { x: l, y: h }
    });
    return u.forEach((p) => {
      f.addColorStop(p.stop, p.color);
    }), f;
  } catch (n) {
    return console.warn("Failed to parse linear gradient:", s, n), null;
  }
}
function ig(s, t) {
  const e = new OffscreenCanvas(1, 1).getContext("2d");
  e.textBaseline = "top";
  const r = t.letterSpacing || 0;
  let n = 0, a = 0;
  const l = t.layers.find((w) => w.type === "fillText"), h = t.layers.find(
    (w) => w.type === "strokeText"
  );
  if (e.font = l?.font || h?.font || "24px Arial", r !== 0)
    for (let w = 0; w < s.length; w++) {
      const S = e.measureText(s[w]);
      n += S.width;
      const T = S.actualBoundingBoxAscent + S.actualBoundingBoxDescent;
      a = Math.max(a, T), w < s.length - 1 && (n += r);
    }
  else {
    const w = e.measureText(s);
    n = w.width, a = w.actualBoundingBoxAscent + w.actualBoundingBoxDescent;
  }
  const u = Number((/(\d+)px/.exec(e.font) ?? [24, 24])[1]);
  a = Math.max(a, u), a += a * 0.1;
  let f = 0, p = 0, m = 0, g = 0, x = 0, o = 0, c = 0, d = 0;
  for (const w of t.layers) {
    const S = w.x || 0, T = w.y || 0;
    if (x = Math.min(x, S), o = Math.min(o, T), c = Math.max(c, S), d = Math.max(d, T), w.type === "strokeText" && (g = Math.max(g, w.lineWidth)), (w.type === "fillText" || w.type === "strokeText") && w.shadow) {
      const E = w.shadow.split(" ");
      if (E.length >= 4) {
        const [C, M, P] = E;
        f = Math.max(f, Math.abs(parseFloat(C))), p = Math.max(p, Math.abs(parseFloat(M))), m = Math.max(m, parseFloat(P));
      }
    }
  }
  const _ = Math.max(
    f + m,
    g / 2
  ), y = Math.max(
    p + m,
    g / 2
  ), v = n + _ * 2 + (c - x), b = a + y * 2 + a * 0.1 + // 顶部留出 10% 的空间，字体顶部对齐的线有点问题
  (d - o);
  return {
    textWidth: n,
    textHeight: a,
    finalWidth: v,
    finalHeight: b
  };
}
async function tE(s, t) {
  const { textWidth: e, textHeight: r, finalWidth: n, finalHeight: a } = ig(
    s,
    t
  ), l = new OffscreenCanvas(n, a), h = new yr();
  await h.init({
    canvas: l,
    width: n,
    height: a,
    backgroundAlpha: 0
  });
  const u = new St();
  h.stage.addChild(u);
  const f = (l.width - e) / 2, p = (l.height - r) / 2;
  for (const g of t.layers)
    await rg(u, s, g, {
      x: f,
      y: p,
      letterSpacing: t.letterSpacing ?? 0,
      layers: t.layers
    });
  h.render();
  const m = await createImageBitmap(l);
  return h.destroy(!0, !0), m;
}
async function rg(s, t, e, r) {
  const n = r.x + (e.x ?? 0), a = r.y + (e.y ?? 0);
  if (e.type === "img") {
    const l = ig(t, {
      letterSpacing: r.letterSpacing,
      layers: r.layers
    }), h = l.textWidth, u = l.textHeight;
    if (e.style === "stretch") {
      const f = Be.from(e.data);
      f.x = n, f.y = a, f.width = e.w ?? h, f.height = e.h ?? u, s.addChild(f);
    } else if (e.style === "perChar") {
      const f = h / t.length;
      for (let p = 0; p < t.length; p++) {
        const m = Be.from(e.data);
        m.x = p * f + n, m.y = a, m.width = e.w ?? f, m.height = e.h ?? u, s.addChild(m);
      }
    }
  } else if (e.type === "fillText" || e.type === "strokeText") {
    const l = eE(e), h = new $n({
      text: t,
      style: new ce({
        ...l,
        letterSpacing: r.letterSpacing
      })
    });
    h.x = n, h.y = a, s.addChild(h);
  }
}
function eE(s) {
  const t = {};
  if ("font" in s) {
    const e = s.font.split(" ");
    e.length >= 2 && (t.fontFamily = e[e.length - 1], t.fontSize = parseInt(e[e.length - 2]), e.includes("bold") && (t.fontWeight = "bold"), e.includes("italic") && (t.fontStyle = "italic"));
  }
  if (s.type === "fillText") {
    if (typeof s.style == "string")
      if (s.style.startsWith("linear-gradient")) {
        const e = JC(s.style);
        e && (t.fill = e);
      } else
        t.fill = { color: s.style };
  } else s.type === "strokeText" && (t.stroke = {
    join: "round",
    cap: "round",
    width: s.lineWidth
  }, typeof s.style == "string" && (t.stroke.color = s.style, t.fill = s.style));
  if ("shadow" in s && s.shadow) {
    const e = s.shadow.split(" ");
    e.length >= 4 && (t.dropShadow = {
      alpha: 1,
      angle: Math.atan2(parseInt(e[1]), parseInt(e[0])),
      blur: parseInt(e[2]),
      color: e.slice(3).join(" "),
      distance: Math.sqrt(
        parseInt(e[0]) ** 2 + parseInt(e[1]) ** 2
      )
    });
  }
  return t;
}
class bl {
  #t;
  #i = [];
  #e = {
    width: 0,
    height: 0,
    duration: 0
  };
  #s;
  #r;
  #n = _r.timeline();
  get meta() {
    return { ...this.#e };
  }
  ready;
  constructor(t, e) {
    this.#t = e, this.#i = t, this.#s = new OffscreenCanvas(e.videoWidth, e.videoHeight), this.#r = new yr(), this.ready = this.#r.init({
      view: this.#s,
      width: e.videoWidth,
      height: e.videoHeight,
      backgroundAlpha: 0,
      preference: "webgl",
      failIfMajorPerformanceCaveat: !1
    }).then(() => (this.#e.width = e.videoWidth, this.#e.height = e.videoHeight, this.#e.duration = t.length > 0 ? Math.max(...t.map((r) => r.endTime)) : 0, this.meta)).catch((r) => (console.warn(
      "PIXI Application init failed, falling back to canvas rendering:",
      r
    ), this.#e.width = e.videoWidth, this.#e.height = e.videoHeight, this.#e.duration = t.length > 0 ? Math.max(...t.map((n) => n.endTime)) : 0, this.meta));
  }
  async tick(t) {
    const e = this.#i.filter(
      (a) => t >= a.startTime && t <= a.endTime
    );
    if (e.length === 0)
      return { state: "done" };
    this.#r.stage.removeChildren(), this.#n.clear();
    const r = {};
    for (const a of e) {
      const l = new St();
      this.#r.stage.addChild(l);
      for (const h of a.conf.layers)
        await rg(l, a.text, h, {
          x: 0,
          y: 0,
          letterSpacing: a.conf.letterSpacing ?? 0,
          layers: a.conf.layers
        });
      l.x = a.x ?? (this.#s.width - l.width) / 2, l.y = a.y ?? (this.#s.height - l.height) / 2, r[a.id] = new Et(
        l.x,
        l.y,
        l.width,
        l.height
      ), a.conf.animation && this.#a(l, a, t);
    }
    return this.#r.render(), {
      state: "success",
      video: await createImageBitmap(this.#s),
      contentRects: r
    };
  }
  async clone() {
    return new bl(this.#i, this.#t);
  }
  destroy() {
    this.#n.kill(), this.#r.destroy(!0, !0);
  }
  #a(t, e, r) {
    const { animation: n } = e.conf;
    if (!n) return;
    const { in: a, out: l } = n, h = {
      x: t.x,
      y: t.y,
      w: t.width,
      h: t.height
    };
    a && Un[a.type] && Un[a.type](
      this.#n,
      { container: t, words: [], originCtnrRect: h },
      { duration: (a.duration ?? 1e6) / 1e6 }
    ), l && Rn[l.type] && Rn[l.type](
      this.#n,
      { container: t, words: [], originCtnrRect: h },
      {
        duration: (l.duration ?? 1e6) / 1e6,
        delay: (e.endTime - (l.duration ?? 1e6)) / 1e6
      }
    );
    const u = e.endTime - e.startTime;
    this.#n.to({}, { duration: u / 1e6 }, 0), this.#n.progress(
      Math.min((r - e.startTime) / u, 1)
    );
  }
}
const sg = (s) => {
  const t = atob(s), e = new Uint8Array(t.length);
  for (let r = 0; r < t.length; r++)
    e[r] = t.charCodeAt(r);
  return e.buffer;
}, iE = (s) => {
  const t = atob(s), e = new Uint8Array(t.length);
  for (let r = 0; r < t.length; r++) e[r] = t.charCodeAt(r);
  return new TextDecoder().decode(e);
}, eh = (s) => {
  let t = s.replace(/-/g, "+").replace(/_/g, "/");
  const e = t.length % 4;
  return e === 2 ? t += "==" : e === 3 ? t += "=" : e !== 0 && (t += "==="), t;
};
async function rE(s) {
  const t = s.replace(/-----BEGIN PUBLIC KEY-----/, "").replace(/-----END PUBLIC KEY-----/, "").replace(/\s+/g, ""), e = sg(t);
  return crypto.subtle.importKey(
    "spki",
    e,
    {
      name: "RSASSA-PKCS1-v1_5",
      hash: "SHA-256"
    },
    !1,
    ["verify"]
  );
}
async function sE(s, t, e) {
  const r = await rE(s), a = new TextEncoder().encode(t), l = sg(eh(e));
  return await crypto.subtle.verify(
    "RSASSA-PKCS1-v1_5",
    r,
    l,
    a
  );
}
async function nE(s, t) {
  const e = t.indexOf(".");
  if (e <= 0) return { ok: !1 };
  const r = t.slice(0, e), n = t.slice(e + 1), a = eh(r), l = eh(n);
  let h;
  try {
    h = iE(a);
  } catch {
    return { ok: !1 };
  }
  if (!await sE(s, h, l)) return { ok: !1 };
  try {
    return { ok: !0, payload: JSON.parse(h) };
  } catch {
    return { ok: !1 };
  }
}
const aE = `
-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAvGkH/R1YaaYnCtqLxYF1
qw+X6JhrBWonDhUrxdX+nMK7po4ZALbiAWoxSnDl1hcGJ6y8O043K1ivQEjqSAy+
Tf3BBH8pI1Y1PmuIRhym0T5O+FKSLjAGDuDf4UzwFqtxiNFTytKIpsvoRxUQdgqI
eikrEnBwng1UNiIQRLZ0QvBDJvcwntICnHUmEg8ECP88LKheroTO5gld5Vd2vrqu
Tl47QBdW5k3bLJMZ2jE6VMq7vUvM9thLzCWeb4qYxL9Vn8Q/k1TQeTsJ6WjWsOnV
mh0GEqmn97+DfQ/UnQjKbl17u5Q8r8344xsKDoN+MdLpuxG8Q72L4MToIkkgrXWA
CQIDAQAB
-----END PUBLIC KEY-----
`, oE = (s, t) => {
  const e = (l) => l.split(":")[0].toLowerCase(), r = (l) => e(l).split(".").filter(Boolean), n = r(s), a = r(t);
  if (a.length === 0 || n.length < a.length) return !1;
  for (let l = 1; l <= a.length; l++)
    if (n[n.length - l] !== a[a.length - l]) return !1;
  return !0;
};
async function hE(s, t) {
  const e = await nE(aE, s);
  return !(!e.ok || !e.payload || !oE(t ?? location.host, e.payload.host) || typeof e.payload.exp != "number" || Math.floor(Date.now() / 1e3) > e.payload.exp);
}
function lE(s, [t, e]) {
  t.setAnimation(
    {
      from: { opacity: 1 },
      to: { opacity: 0 }
    },
    {
      duration: s,
      iterCount: 1,
      delay: t.time.duration - s
    }
  ), e.time.offset = t.time.offset + s - s, t.zIndex = e.zIndex + 1;
}
function cE(s, [t, e]) {
  const r = s / 2;
  In(
    t.getClip(),
    t.time.duration - r,
    r,
    kn({
      width: t.rect.w,
      height: t.rect.h,
      color: {
        from: { r: 0, g: 0, b: 0, a: 0 },
        to: { r: 0, g: 0, b: 0, a: 255 }
      }
    })
  ), In(
    e.getClip(),
    0,
    r,
    kn({
      width: e.rect.w,
      height: e.rect.h,
      color: {
        from: { r: 0, g: 0, b: 0, a: 255 },
        to: { r: 0, g: 0, b: 0, a: 0 }
      }
    })
  );
}
function uE(s, [t, e]) {
  const r = s / 2;
  In(
    t.getClip(),
    t.time.duration - r,
    r,
    kn({
      width: t.rect.w,
      height: t.rect.h,
      color: {
        from: { r: 255, g: 255, b: 255, a: 0 },
        to: { r: 255, g: 255, b: 255, a: 255 }
      }
    })
  ), In(
    e.getClip(),
    0,
    r,
    kn({
      width: e.rect.w,
      height: e.rect.h,
      color: {
        from: { r: 255, g: 255, b: 255, a: 255 },
        to: { r: 255, g: 255, b: 255, a: 0 }
      }
    })
  );
}
function In(s, t, e, r) {
  if (!(s instanceof _f)) return;
  t < 0 && (t = 0);
  const n = s.tickInterceptor;
  s.tickInterceptor = async (a, l) => {
    const h = await n(a, l);
    if (h.video == null || a < t) return h;
    const u = r(h.video, (a - t) / e);
    return h.video.close(), {
      ...h,
      video: u
    };
  };
}
function kn(s) {
  const { width: t, height: e } = s, r = new OffscreenCanvas(t, e), n = r.getContext("2d"), { from: a, to: l } = s.color;
  function h(u) {
    const f = a.r + (l.r - a.r) * u, p = a.g + (l.g - a.g) * u, m = a.b + (l.b - a.b) * u, g = a.a + (l.a - a.a) * u;
    return { r: f, g: p, b: m, a: g };
  }
  return (u, f) => {
    if (f < 0 || f > 1) return new VideoFrame(u);
    n.globalAlpha = 1, n.clearRect(0, 0, t, e), n.drawImage(u, 0, 0, t, e);
    const { r: p, g: m, b: g, a: x } = h(f);
    return n.fillStyle = `rgb(${p} ${m} ${g})`, n.globalAlpha = x / 255, n.fillRect(0, 0, t, e), new VideoFrame(r, {
      timestamp: u.timestamp,
      duration: u.duration ?? 0
    });
  };
}
function Ks(s, t, [e, r]) {
  const n = {
    left: {
      pre: {
        from: { x: e.rect.x },
        to: { x: e.rect.w * -1 }
      },
      post: {
        from: { x: r.rect.x + r.rect.w },
        to: { x: r.rect.x }
      }
    },
    right: {
      pre: {
        from: { x: e.rect.x },
        to: { x: e.rect.w }
      },
      post: {
        from: { x: r.rect.x - r.rect.w },
        to: { x: r.rect.x }
      }
    },
    up: {
      pre: {
        from: { y: e.rect.y },
        to: { y: e.rect.h * -1 }
      },
      post: {
        from: { y: r.rect.y + r.rect.h },
        to: { y: r.rect.y }
      }
    },
    down: {
      pre: {
        from: { y: e.rect.y },
        to: { y: e.rect.h }
      },
      post: {
        from: { y: r.rect.y - r.rect.h },
        to: { y: r.rect.y }
      }
    }
  };
  e.setAnimation(n[s].pre, {
    duration: t,
    iterCount: 1,
    delay: e.time.duration - t
  }), r.setAnimation(n[s].post, {
    duration: t,
    iterCount: 1,
    delay: 0
  }), r.time.offset = e.time.offset + e.time.duration - t;
}
function qs(s, t, [e, r]) {
  const n = {
    left: {
      from: { x: r.rect.x + r.rect.w },
      to: { x: r.rect.x }
    },
    right: {
      from: { x: r.rect.x - r.rect.w },
      to: { x: r.rect.x }
    },
    up: {
      from: { y: r.rect.y + r.rect.h },
      to: { y: r.rect.y }
    },
    down: {
      from: { y: r.rect.y - r.rect.h },
      to: { y: r.rect.y }
    }
  };
  r.setAnimation(n[s], {
    duration: t,
    iterCount: 1,
    delay: 0
  }), r.time.offset = e.time.offset + e.time.duration - t;
}
async function dE(s, t, e) {
  switch (await Promise.all(e.map((r) => r.ready)), s) {
    case "fade":
      lE(t, e);
      return;
    case "fadeblack":
      cE(t, e);
      return;
    case "fadewhite":
      uE(t, e);
      return;
    case "wipeleft":
      qs("left", t, e);
      return;
    case "wiperight":
      qs("right", t, e);
      return;
    case "wipeup":
      qs("up", t, e);
      return;
    case "wipedown":
      qs("down", t, e);
      return;
    case "slideleft":
      Ks("left", t, e);
      return;
    case "slideright":
      Ks("right", t, e);
      return;
    case "slideup":
      Ks("up", t, e);
      return;
    case "slidedown":
      Ks("down", t, e);
      return;
    default:
      throw Error("Invalid transition name");
  }
}
var ja = {}, Qu;
function fE() {
  return Qu || (Qu = 1, function(s) {
    (function() {
      var t = {
        direction: "horizontal",
        snapToLines: !0,
        linePosition: "auto",
        lineAlign: "start",
        textPosition: "auto",
        positionAlign: "auto",
        size: 100,
        alignment: "center"
      }, e = function(h) {
        h || (h = {
          "&amp": "&",
          "&lt": "<",
          "&gt": ">",
          "&lrm": "‎",
          "&rlm": "‏",
          "&nbsp": " "
        }), this.entities = h, this.parse = function(u, f) {
          u = u.replace(/\0/g, "�");
          var p = /\r\n|\r|\n/, m = Date.now(), g = 0, x = u.split(p), o = !1, c = [], d = [], _ = [];
          function y(O, R) {
            _.push({ message: O, line: g + 1, col: R });
          }
          var v = x[g], b = v.length, w = "WEBVTT", S = 0, T = w.length;
          for (v[0] === "\uFEFF" && (S = 1, T += 1), (b < T || v.indexOf(w) !== 0 + S || b > T && v[T] !== " " && v[T] !== "	") && y('No valid signature. (File needs to start with "WEBVTT".)'), g++; x[g] != "" && x[g] != null; ) {
            if (y("No blank line after the signature."), x[g].indexOf("-->") != -1) {
              o = !0;
              break;
            }
            g++;
          }
          for (; x[g] != null; ) {
            for (var E; !o && x[g] == ""; )
              g++;
            if (!o && x[g] == null)
              break;
            E = Object.assign({}, t, {
              id: "",
              startTime: 0,
              endTime: 0,
              pauseOnExit: !1,
              direction: "horizontal",
              snapToLines: !0,
              linePosition: "auto",
              lineAlign: "start",
              textPosition: "auto",
              positionAlign: "auto",
              size: 100,
              alignment: "center",
              text: "",
              tree: null
            });
            var C = !0;
            if (x[g].indexOf("-->") == -1) {
              if (E.id = x[g], /^NOTE($|[ \t])/.test(E.id)) {
                for (g++; x[g] != "" && x[g] != null; )
                  x[g].indexOf("-->") != -1 && y("Cannot have timestamp in a comment."), g++;
                continue;
              }
              if (/^STYLE($|[ \t])/.test(E.id)) {
                var M = [], P = !1;
                for (g++; x[g] != "" && x[g] != null; )
                  x[g].indexOf("-->") != -1 && (y("Cannot have timestamp in a style block."), P = !0), M.push(x[g]), g++;
                if (d.length) {
                  y("Style blocks cannot appear after the first cue.");
                  continue;
                }
                P || c.push(M.join(`
`));
                continue;
              }
              if (g++, x[g] == "" || x[g] == null) {
                y("Cue identifier cannot be standalone.");
                continue;
              }
              if (x[g].indexOf("-->") == -1) {
                C = !1, y("Cue identifier needs to be followed by timestamp.");
                continue;
              }
            }
            o = !1;
            var B = new r(x[g], y), U = 0;
            if (d.length > 0 && (U = d[d.length - 1].startTime), C && !B.parse(E, U)) {
              for (E = null, g++; x[g] != "" && x[g] != null; ) {
                if (x[g].indexOf("-->") != -1) {
                  o = !0;
                  break;
                }
                g++;
              }
              continue;
            }
            for (g++; x[g] != "" && x[g] != null; ) {
              if (x[g].indexOf("-->") != -1) {
                y("Blank line missing before cue."), o = !0;
                break;
              }
              E.text != "" && (E.text += `
`), E.text += x[g], g++;
            }
            var G = new n(E.text, y, f, h);
            E.tree = G.parse(E.startTime, E.endTime), d.push(E);
          }
          return d.sort(function(O, R) {
            return O.startTime < R.startTime ? -1 : O.startTime > R.startTime ? 1 : O.endTime > R.endTime ? -1 : O.endTime < R.endTime ? 1 : 0;
          }), { cues: d, errors: _, time: Date.now() - m, styles: c };
        };
      }, r = function(m, u) {
        var f = /[\u0020\t\f]/, p = /[^\u0020\t\f]/, m = m, g = 0, x = function(y) {
          u(y, g + 1);
        };
        function o(y) {
          for (; m[g] != null && y.test(m[g]); )
            g++;
        }
        function c(y) {
          for (var v = ""; m[g] != null && y.test(m[g]); )
            v += m[g], g++;
          return v;
        }
        function d() {
          var y = "minutes", v, b, w, S;
          if (m[g] == null) {
            x("No timestamp found.");
            return;
          }
          if (!/\d/.test(m[g])) {
            x("Timestamp must start with a character in the range 0-9.");
            return;
          }
          if (v = c(/\d/), (v.length > 2 || parseInt(v, 10) > 59) && (y = "hours"), m[g] != ":") {
            x("No time unit separator found.");
            return;
          }
          if (g++, b = c(/\d/), b.length != 2) {
            x("Must be exactly two digits.");
            return;
          }
          if (y == "hours" || m[g] == ":") {
            if (m[g] != ":") {
              x("No seconds found or minutes is greater than 59.");
              return;
            }
            if (g++, w = c(/\d/), w.length != 2) {
              x("Must be exactly two digits.");
              return;
            }
          } else {
            if (v.length != 2) {
              x("Must be exactly two digits.");
              return;
            }
            w = b, b = v, v = "0";
          }
          if (m[g] != ".") {
            x('No decimal separator (".") found.');
            return;
          }
          if (g++, S = c(/\d/), S.length != 3) {
            x("Milliseconds must be given in three digits.");
            return;
          }
          if (parseInt(b, 10) > 59) {
            x("You cannot have more than 59 minutes.");
            return;
          }
          if (parseInt(w, 10) > 59) {
            x("You cannot have more than 59 seconds.");
            return;
          }
          return parseInt(v, 10) * 60 * 60 + parseInt(b, 10) * 60 + parseInt(w, 10) + parseInt(S, 10) / 1e3;
        }
        function _(y, v) {
          for (var b = y.split(f), w = [], S = 0; S < b.length; S++)
            if (b[S] != "") {
              var T = b[S].indexOf(":"), E = b[S].slice(0, T), C = b[S].slice(T + 1);
              if (w.indexOf(E) != -1 && x("Duplicate setting."), w.push(E), C == "") {
                x("No value for setting defined.");
                return;
              }
              if (E == "vertical") {
                if (C != "rl" && C != "lr") {
                  x("Writing direction can only be set to 'rl' or 'rl'.");
                  continue;
                }
                v.direction = C;
              } else if (E == "line") {
                if (/,/.test(C)) {
                  var M = C.split(",");
                  C = M[0];
                  var P = M[1];
                }
                if (!/^[-\d](\d*)(\.\d+)?%?$/.test(C)) {
                  x("Line position takes a number or percentage.");
                  continue;
                }
                if (C.indexOf("-", 1) != -1) {
                  x("Line position can only have '-' at the start.");
                  continue;
                }
                if (C.indexOf("%") != -1 && C.indexOf("%") != C.length - 1) {
                  x("Line position can only have '%' at the end.");
                  continue;
                }
                if (C[0] == "-" && C[C.length - 1] == "%") {
                  x("Line position cannot be a negative percentage.");
                  continue;
                }
                var B = C, U = !1;
                if (C[C.length - 1] == "%" && (U = !0, B = C.slice(0, C.length - 1), parseInt(C, 10) > 100)) {
                  x("Line position cannot be >100%.");
                  continue;
                }
                if (B === "" || isNaN(B) || !isFinite(B)) {
                  x("Line position needs to be a number");
                  continue;
                }
                if (P !== void 0) {
                  if (!["start", "center", "end"].includes(P)) {
                    x("Line alignment needs to be one of start, center or end");
                    continue;
                  }
                  v.lineAlign = P;
                }
                v.snapToLines = !U, v.linePosition = parseFloat(B), parseFloat(B).toString() !== B && (v.nonSerializable = !0);
              } else if (E == "position") {
                if (/,/.test(C)) {
                  var M = C.split(",");
                  C = M[0];
                  var G = M[1];
                }
                if (C[C.length - 1] != "%") {
                  x("Text position must be a percentage.");
                  continue;
                }
                if (parseInt(C, 10) > 100 || parseInt(C, 10) < 0) {
                  x("Text position needs to be between 0 and 100%.");
                  continue;
                }
                if (B = C.slice(0, C.length - 1), B === "" || isNaN(B) || !isFinite(B)) {
                  x("Line position needs to be a number");
                  continue;
                }
                if (G !== void 0) {
                  if (!["line-left", "center", "line-right"].includes(G)) {
                    x("Position alignment needs to be one of line-left, center or line-right");
                    continue;
                  }
                  v.positionAlign = G;
                }
                v.textPosition = parseFloat(B);
              } else if (E == "size") {
                if (C[C.length - 1] != "%") {
                  x("Size must be a percentage.");
                  continue;
                }
                if (parseInt(C, 10) > 100) {
                  x("Size cannot be >100%.");
                  continue;
                }
                var O = C.slice(0, C.length - 1);
                if (O === void 0 || O === "" || isNaN(O)) {
                  x("Size needs to be a number"), O = 100;
                  continue;
                } else if (O = parseFloat(O), O < 0 || O > 100) {
                  x("Size needs to be between 0 and 100%.");
                  continue;
                }
                v.size = O;
              } else if (E == "align") {
                var R = ["start", "center", "end", "left", "right"];
                if (R.indexOf(C) == -1) {
                  x("Alignment can only be set to one of " + R.join(", ") + ".");
                  continue;
                }
                v.alignment = C;
              } else
                x("Invalid setting.");
            }
        }
        this.parse = function(y, v) {
          if (o(f), y.startTime = d(), y.startTime != null) {
            if (y.startTime < v && x("Start timestamp is not greater than or equal to start timestamp of previous cue."), p.test(m[g]) && x("Timestamp not separated from '-->' by whitespace."), o(f), m[g] != "-") {
              x("No valid timestamp separator found.");
              return;
            }
            if (g++, m[g] != "-") {
              x("No valid timestamp separator found.");
              return;
            }
            if (g++, m[g] != ">") {
              x("No valid timestamp separator found.");
              return;
            }
            if (g++, p.test(m[g]) && x("'-->' not separated from timestamp by whitespace."), o(f), y.endTime = d(), y.endTime != null)
              return y.endTime <= y.startTime && x("End timestamp is not greater than start timestamp."), p.test(m[g]), o(f), _(m.substring(g), y), !0;
          }
        }, this.parseTimestamp = function() {
          var y = d();
          if (m[g] != null) {
            x("Timestamp must not have trailing characters.");
            return;
          }
          return y;
        };
      }, n = function(g, u, f, p) {
        this.entities = p;
        var m = this, g = g, x = 0, o = function(d) {
          f != "metadata" && u(d, x + 1);
        };
        this.parse = function(d, _) {
          function y(B) {
            const U = { ...B };
            return B.children && (U.children = B.children.map(y)), U.parent && delete U.parent, U;
          }
          var v = { children: [] }, b = v, w = [];
          function S(B) {
            b.children.push({ type: "object", name: B[1], classes: B[2], children: [], parent: b }), b = b.children[b.children.length - 1];
          }
          function T(B) {
            for (var U = b; U; ) {
              if (U.name == B)
                return !0;
              U = U.parent;
            }
          }
          for (; g[x] != null; ) {
            var E = c();
            if (E[0] == "text")
              b.children.push({ type: "text", value: E[1], parent: b });
            else if (E[0] == "start tag") {
              f == "chapters" && o("Start tags not allowed in chapter title text.");
              var C = E[1];
              C != "v" && C != "lang" && E[3] != "" && o("Only <v> and <lang> can have an annotation."), C == "c" || C == "i" || C == "b" || C == "u" || C == "ruby" || C == "rt" && b.name == "ruby" ? S(E) : C == "v" ? (T("v") && o("<v> cannot be nested inside itself."), S(E), b.value = E[3], E[3] || o("<v> requires an annotation.")) : C == "lang" ? (S(E), b.value = E[3]) : o("Incorrect start tag.");
            } else if (E[0] == "end tag")
              f == "chapters" && o("End tags not allowed in chapter title text."), E[1] == b.name ? b = b.parent : E[1] == "ruby" && b.name == "rt" ? b = b.parent.parent : o("Incorrect end tag.");
            else if (E[0] == "timestamp") {
              f == "chapters" && o("Timestamp not allowed in chapter title text.");
              var M = new r(E[1], o), P = M.parseTimestamp();
              P != null && ((P <= d || P >= _) && o("Timestamp must be between start timestamp and end timestamp."), w.length > 0 && w[w.length - 1] >= P && o("Timestamp must be greater than any previous timestamp."), b.children.push({ type: "timestamp", value: P, parent: b }), w.push(P));
            }
          }
          for (; b.parent; )
            b.name != "v" && o("Required end tag missing."), b = b.parent;
          return y(v);
        };
        function c() {
          for (var d = "data", _ = "", y = "", v = []; g[x - 1] != null || x == 0; ) {
            var b = g[x];
            if (d == "data")
              if (b == "&")
                y = b, d = "escape";
              else if (b == "<" && _ == "")
                d = "tag";
              else {
                if (b == "<" || b == null)
                  return ["text", _];
                _ += b;
              }
            else if (d == "escape")
              if (b == "<" || b == null) {
                o("Incorrect escape.");
                let w;
                return (w = y.match(/^&#([0-9]+)$/)) ? _ += String.fromCharCode(w[1]) : m.entities[y] ? _ += m.entities[y] : _ += y, ["text", _];
              } else if (b == "&")
                o("Incorrect escape."), _ += y, y = b;
              else if (/[a-z#0-9]/i.test(b))
                y += b;
              else if (b == ";") {
                let w;
                (w = y.match(/^&#(x?[0-9]+)$/)) ? _ += String.fromCharCode("0" + w[1]) : m.entities[y + b] ? _ += m.entities[y + b] : (w = Object.keys(p).find((S) => y.startsWith(S))) ? _ += m.entities[w] + y.slice(w.length) + b : (o("Incorrect escape."), _ += y + ";"), d = "data";
              } else
                o("Incorrect escape."), _ += y + b, d = "data";
            else if (d == "tag")
              if (b == "	" || b == `
` || b == "\f" || b == " ")
                d = "start tag annotation";
              else if (b == ".")
                d = "start tag class";
              else if (b == "/")
                d = "end tag";
              else if (/\d/.test(b))
                _ = b, d = "timestamp tag";
              else {
                if (b == ">" || b == null)
                  return b == ">" && x++, ["start tag", "", [], ""];
                _ = b, d = "start tag";
              }
            else if (d == "start tag")
              if (b == "	" || b == "\f" || b == " ")
                d = "start tag annotation";
              else if (b == `
`)
                y = b, d = "start tag annotation";
              else if (b == ".")
                d = "start tag class";
              else {
                if (b == ">" || b == null)
                  return b == ">" && x++, ["start tag", _, [], ""];
                _ += b;
              }
            else if (d == "start tag class")
              if (b == "	" || b == "\f" || b == " ")
                y && v.push(y), y = "", d = "start tag annotation";
              else if (b == `
`)
                y && v.push(y), y = b, d = "start tag annotation";
              else if (b == ".")
                y && v.push(y), y = "";
              else {
                if (b == ">" || b == null)
                  return b == ">" && x++, y && v.push(y), ["start tag", _, v, ""];
                y += b;
              }
            else if (d == "start tag annotation") {
              if (b == ">" || b == null)
                return b == ">" && x++, y = y.split(/[\u0020\t\f\r\n]+/).filter(function(w) {
                  if (w) return !0;
                }).join(" "), ["start tag", _, v, y];
              y += b;
            } else if (d == "end tag") {
              if (b == ">" || b == null)
                return b == ">" && x++, ["end tag", _];
              _ += b;
            } else if (d == "timestamp tag") {
              if (b == ">" || b == null)
                return b == ">" && x++, ["timestamp", _];
              _ += b;
            } else
              o("Never happens.");
            x++;
          }
        }
      }, a = function() {
        function h(g) {
          const x = ("00" + (g - Math.floor(g)).toFixed(3) * 1e3).slice(-3);
          let o = 0, c = 0, d = 0;
          return g >= 3600 && (o = Math.floor(g / 3600)), c = Math.floor((g - 3600 * o) / 60), d = Math.floor(g - 3600 * o - 60 * c), (o ? o + ":" : "") + ("" + c).padStart(2, "0") + ":" + ("" + d).padStart(2, "0") + "." + x;
        }
        function u(g) {
          var x = "";
          const o = Object.keys(t).filter((c) => g[c] !== t[c]);
          return o.includes("direction") && (x += " vertical:" + g.direction), o.includes("alignment") && (x += " align:" + g.alignment), o.includes("size") && (x += " size:" + g.size + "%"), (o.includes("lineAlign") || o.includes("linePosition")) && (x += " line:" + g.linePosition + (g.snapToLines ? "" : "%") + (g.lineAlign && g.lineAlign != t.lineAlign ? "," + g.lineAlign : "")), (o.includes("textPosition") || o.includes("positionAlign")) && (x += " position:" + g.textPosition + "%" + (g.positionAlign && g.positionAlign !== t.positionAlign ? "," + g.positionAlign : "")), x;
        }
        function f(g) {
          for (var x = "", o = 0; o < g.length; o++) {
            var c = g[o];
            if (c.type == "text")
              x += c.value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
            else if (c.type == "object") {
              if (x += "<" + c.name, c.classes)
                for (var d = 0; d < c.classes.length; d++)
                  x += "." + c.classes[d];
              c.value && (x += " " + c.value), x += ">", c.children && (x += f(c.children)), x += "</" + c.name + ">";
            } else c.type == "timestamp" ? x += "<" + h(c.value) + ">" : x += "<" + c.value + ">";
          }
          return x;
        }
        function p(g) {
          return (g.id !== void 0 ? g.id + `
` : "") + h(g.startTime) + " --> " + h(g.endTime) + u(g) + `
` + f(g.tree.children) + `

`;
        }
        function m(g) {
          return `STYLE
` + g + `

`;
        }
        this.serialize = function(g, x) {
          var o = `WEBVTT

`;
          if (x)
            for (var c = 0; c < x.length; c++)
              o += m(x[c]);
          for (var c = 0; c < g.length; c++)
            o += p(g[c]);
          return o;
        };
      };
      function l(h) {
        h.WebVTTParser = e, h.WebVTTCueTimingsAndSettingsParser = r, h.WebVTTCueTextParser = n, h.WebVTTSerializer = a;
      }
      typeof window < "u" && l(window), l(s);
    })();
  }(ja)), ja;
}
var pE = fE();
const Ju = {
  color: "white",
  fontWeight: "normal",
  fontStyle: "normal",
  fontSize: "24px",
  fontFamily: "Arial"
}, Ka = {
  DEFAULT: 1,
  // video::cue
  TAG: 10,
  // video::cue(tag)
  CLASS: 100
  // video::cue(.class)
}, _E = [
  "color",
  "fontWeight",
  "fontStyle",
  "fontSize",
  "fontFamily"
];
function mE(s) {
  if (!s || s.length === 0)
    return [];
  const t = [];
  for (const e of s) {
    const r = e.match(/([^{]+)\s*{\s*([^}]+)\s*}/g);
    if (r)
      for (const n of r) {
        const [, a, l] = n.match(/([^{]+)\s*{\s*([^}]+)\s*}/) || [];
        if (!a || !l) continue;
        const h = a.trim().replace(/^video::cue/, "::cue");
        let u = Ka.DEFAULT;
        h.includes(".") ? u = Ka.CLASS : h.includes("(") && h.includes(")") && (u = Ka.TAG);
        const f = {}, p = l.match(/([^:;]+)\s*:\s*([^;]+)/g);
        if (p)
          for (const m of p) {
            const [, g, x] = m.match(/([^:]+)\s*:\s*([^;]+)/) || [];
            if (g && x) {
              const c = g.trim().replace(/-([a-z])/g, (d, _) => _.toUpperCase());
              if (c === "padding") {
                const d = x.trim().split(/\s+/).map((_) => _.trim());
                switch (d.length) {
                  case 1:
                    f.paddingTop = d[0], f.paddingRight = d[0], f.paddingBottom = d[0], f.paddingLeft = d[0];
                    break;
                  case 2:
                    f.paddingTop = d[0], f.paddingBottom = d[0], f.paddingRight = d[1], f.paddingLeft = d[1];
                    break;
                  case 3:
                    f.paddingTop = d[0], f.paddingRight = d[1], f.paddingLeft = d[1], f.paddingBottom = d[2];
                    break;
                  case 4:
                    f.paddingTop = d[0], f.paddingRight = d[1], f.paddingBottom = d[2], f.paddingLeft = d[3];
                    break;
                }
              } else if (c === "backgroundImage") {
                const d = x.trim().match(/url\(['"]?(.*?)['"]?\)/);
                d && d[1] ? f[c] = d[1].trim() : f[c] = x.trim();
              } else
                f[c] = x.trim();
            }
          }
        t.push({
          selector: h,
          specificity: u,
          properties: f
        });
      }
  }
  return t;
}
function gE(s, t, e, r) {
  const n = (l, h, u) => {
    let f = h;
    for (const p of l)
      if (r.save(), !!p.computedStyle) {
        if (p.type === "text") {
          const { fontSize: m, fontWeight: g, fontStyle: x, fontFamily: o, color: c } = p.computedStyle;
          r.font = `${x} ${g} ${m} ${o}`, c && (r.fillStyle = c);
          const d = r.measureText(p.value).width;
          r.fillText(
            p.value,
            f,
            u + parseFloat(m ?? "0") * 0.2
          ), f += d;
        } else if (p.type === "object") {
          const {
            width: m,
            height: g,
            borderRadius: x,
            paddingLeft: o,
            paddingTop: c,
            backgroundColor: d
          } = p.computedStyle, _ = parseFloat(g || "0"), y = parseFloat(x || "0"), v = parseFloat(o || "0"), b = parseFloat(c || "0"), w = parseFloat(m || "0");
          d && (r.fillStyle = d, y > 0 ? (r.beginPath(), r.roundRect(f, u, w, _, y), r.fill()) : r.fillRect(f, u, w, _));
          const S = p;
          p.type === "object" && S.bgImg && a(
            r,
            S.bgImg,
            f,
            u,
            w,
            _,
            10
          ), f = n(
            p.children,
            f + v,
            u + b
          );
        }
        r.restore();
      }
    return f;
  };
  s.tree && s.tree.children && n([s.tree], t, e);
  function a(l, h, u, f, p, m, g) {
    const x = h.width, o = h.height, c = Math.min(g, x / 3), d = Math.min(g, o / 3), _ = Math.min(g, p / 3), y = Math.min(g, m / 3);
    l.drawImage(
      h,
      0,
      0,
      c,
      d,
      u,
      f,
      _,
      y
    ), l.drawImage(
      h,
      x - c,
      0,
      c,
      d,
      u + p - _,
      f,
      _,
      y
    ), l.drawImage(
      h,
      0,
      o - d,
      c,
      d,
      u,
      f + m - y,
      _,
      y
    ), l.drawImage(
      h,
      x - c,
      o - d,
      c,
      d,
      u + p - _,
      f + m - y,
      _,
      y
    ), l.drawImage(
      h,
      c,
      0,
      x - 2 * c,
      d,
      u + _,
      f,
      p - 2 * _,
      y
    ), l.drawImage(
      h,
      c,
      o - d,
      x - 2 * c,
      d,
      u + _,
      f + m - y,
      p - 2 * _,
      y
    ), l.drawImage(
      h,
      0,
      d,
      c,
      o - 2 * d,
      u,
      f + y,
      _,
      m - 2 * y
    ), l.drawImage(
      h,
      x - c,
      d,
      c,
      o - 2 * d,
      u + p - _,
      f + y,
      _,
      m - 2 * y
    ), l.drawImage(
      h,
      c,
      d,
      x - 2 * c,
      o - 2 * d,
      u + _,
      f + y,
      p - 2 * _,
      m - 2 * y
    );
  }
}
const ng = z.create("[@webav WebVTTClip]");
class vl {
  #t;
  #i;
  ready;
  #e = {
    // 微秒
    duration: 0,
    width: 0,
    height: 0
  };
  #s;
  #r;
  get meta() {
    return { ...this.#e };
  }
  #n;
  // 解析后的样式规则
  #a = [];
  constructor(t, e) {
    this.#s = t, this.#r = e, this.#t = new OffscreenCanvas(e.videoWidth, e.videoHeight), this.#i = this.#t.getContext("2d"), this.#i.textBaseline = "top";
    const r = new pE.WebVTTParser();
    this.#n = r.parse(t, "metadata"), this.#n.cues.forEach((n) => {
      n.tree.type = "object", n.tree.name = "cue", n.tree.classes = [], n.tree.computedStyle = {}, n.startTime *= 1e6, n.endTime *= 1e6;
    }), ng.debug("vtt parsedData", this.#n), this.#a = mE(this.#n.styles), this.#e = {
      width: e.videoWidth,
      height: e.videoHeight,
      duration: this.#n.cues[this.#n.cues.length - 1].endTime
    }, this.ready = yE(this.#n.cues, this.#a).then(
      () => Promise.resolve(this.meta)
    );
  }
  async tick(t) {
    if (this.#i.clearRect(0, 0, this.#e.width, this.#e.height), t > this.#e.duration)
      return {
        state: "done",
        video: await createImageBitmap(this.#t)
      };
    const e = this.#n.cues.filter(
      (l) => t >= l.startTime && t <= l.endTime
    ), { width: r, height: n } = this.#e, a = new Et(r, n, 0, 0);
    if (e.length > 0)
      for (const l of e) {
        let h;
        l.linePosition === "auto" ? h = n * 0.8 : h = n * l.linePosition / 100;
        const { width: u, height: f } = l.tree.computedStyle;
        let p;
        l.textPosition === "auto" ? p = r / 2 - parseFloat(u) / 2 : p = r * l.textPosition / 100, a.x = Math.min(a.x, p) - 10, a.y = Math.min(a.y, h) - 10, a.w = Math.max(a.w, parseFloat(u)) + 20, a.h = Math.max(a.h, parseFloat(f)) + 20, gE(l, p, h, this.#i);
      }
    return {
      state: "success",
      video: await createImageBitmap(this.#t),
      contentRects: {
        0: a
      }
    };
  }
  async clone() {
    return new vl(this.#s, { ...this.#r });
  }
  destroy() {
  }
}
async function yE(s, t) {
  const r = new OffscreenCanvas(900, 500).getContext("2d");
  for (const n of s)
    await ag([n.tree], t), og(n.tree, r);
}
async function ag(s, t, e) {
  for (const r of s) {
    r.computedStyle = {}, r.type === "object" && r.name === "cue" && Object.assign(r.computedStyle, Ju);
    const n = {
      default: [],
      tag: [],
      class: []
    };
    for (const a of t)
      if (r.type === "object" && r.name === "cue" && a.selector === "::cue")
        n.default.push(a);
      else if (r.type === "object" && a.selector === `::cue(${r.name})`)
        n.tag.push(a);
      else if (r.type === "object" && r.classes && r.classes.length > 0) {
        for (const l of r.classes)
          if (a.selector === `::cue(.${l})`) {
            n.class.push(a);
            break;
          }
      }
    for (const a of n.default)
      Object.assign(r.computedStyle, a.properties);
    if (e)
      for (const a of _E) {
        const l = a;
        e[l] !== void 0 && (r.computedStyle[l] = e[l]);
      }
    for (const a of n.tag)
      Object.assign(r.computedStyle, a.properties);
    for (const a of n.class)
      Object.assign(r.computedStyle, a.properties);
    if (r.type === "object") {
      if (r.name === "cue") {
        const a = r;
        if (r.computedStyle.backgroundImage && !a.bgImg)
          try {
            const l = await fetch(r.computedStyle.backgroundImage), h = await createImageBitmap(await l.blob());
            a.bgImg = h;
          } catch (l) {
            ng.warn("backgroundImage load error", l);
          }
      }
      r.name === "b" && r.computedStyle.fontWeight === "normal" ? r.computedStyle.fontWeight = "bold" : r.name === "i" && r.computedStyle.fontStyle === "normal" ? r.computedStyle.fontStyle = "italic" : r.name === "v" && r.computedStyle.color === Ju.color && (r.computedStyle.color = "yellow");
    }
    r.type === "object" && r.children.length > 0 && ag(r.children, t, r.computedStyle);
  }
}
function og(s, t) {
  if (!s.computedStyle) throw new Error("node.computedStyle is undefined");
  const { computedStyle: e } = s;
  if (e.width && e.height)
    return {
      width: e.width,
      height: e.height
    };
  const {
    fontStyle: r,
    fontWeight: n,
    fontSize: a,
    fontFamily: l,
    paddingLeft: h,
    paddingRight: u,
    paddingTop: f,
    paddingBottom: p
  } = e;
  if (t.font = `${r} ${n} ${a} ${l}`, s.type === "text") {
    const x = t.measureText(s.value), o = parseInt(a || "24");
    return e.width = `${x.width}px`, e.height = `${o * 1.2}px`, {
      width: e.width,
      height: e.height
    };
  }
  let m = 0, g = 0;
  for (const x of s.children) {
    const { width: o, height: c } = og(x, t);
    m += parseFloat(o), g = Math.max(g, parseFloat(c));
  }
  return e.width = m + parseFloat(h ?? "0") + parseFloat(u ?? "0") + "px", e.height = g + parseFloat(f ?? "0") + parseFloat(p ?? "0") + "px", {
    width: e.width,
    height: e.height
  };
}
const cn = [
  "t",
  "b",
  "l",
  "r",
  "lt",
  "lb",
  "rt",
  "rb",
  "rotate"
];
function pr(s) {
  return document.createElement(s);
}
const qa = /* @__PURE__ */ new WeakMap();
function hg(s, t) {
  if (qa.has(s))
    return qa.get(s)(t);
  let e = 10;
  new ResizeObserver((n) => {
    const a = n[0];
    a != null && (e = 10 / (a.contentRect.width / s.width));
  }).observe(s);
  function r(n) {
    const { w: a, h: l } = n, h = e, u = h / 2, f = a / 2, p = l / 2, m = h * 1.5, g = m / 2;
    return {
      ...n.fixedAspectRatio ? {} : {
        t: new Et(-u, -p - u, h, h, n),
        b: new Et(-u, p - u, h, h, n),
        l: new Et(-f - u, -u, h, h, n),
        r: new Et(f - u, -u, h, h, n)
      },
      lt: new Et(-f - u, -p - u, h, h, n),
      lb: new Et(-f - u, p - u, h, h, n),
      rt: new Et(f - u, -p - u, h, h, n),
      rb: new Et(f - u, p - u, h, h, n),
      rotate: new Et(-g, -p - h * 2 - g, m, m, n)
    };
  }
  return qa.set(s, r), r(t);
}
const Za = /* @__PURE__ */ new WeakMap();
function Ts(s) {
  if (Za.has(s))
    return Za.get(s);
  const t = {
    w: s.clientWidth / s.width,
    h: s.clientHeight / s.height
  };
  return new ResizeObserver(() => {
    t.w = s.clientWidth / s.width, t.h = s.clientHeight / s.height;
  }).observe(s), Za.set(s, t), t;
}
var fs = /* @__PURE__ */ ((s) => (s.ActiveSpriteChange = "activeSpriteChange", s.AddSprite = "addSprite", s))(fs || {});
class xE {
  #t = [];
  #i = null;
  #e = new Ui();
  on = this.#e.on;
  get activeSprite() {
    return this.#i;
  }
  set activeSprite(t) {
    t === this.#i || t?.interactable === "disabled" || (this.#i = t, this.#e.emit("activeSpriteChange", t));
  }
  activeSpriteByCoord(t, e) {
    this.activeSprite = this.getSprites().reverse().find(
      (r) => r.visible && r.interactable !== "disabled" && r.rect.checkHit(t, e)
    ) ?? null;
  }
  async addSprite(t) {
    await t.ready, this.#t.push(t), this.#t = this.#t.sort((e, r) => e.zIndex - r.zIndex), t.on("propsChange", (e) => {
      e.zIndex != null && (this.#t = this.#t.sort((r, n) => r.zIndex - n.zIndex));
    }), this.#e.emit("addSprite", t);
  }
  removeSprite(t) {
    this.#i === t && (this.activeSprite = null), this.#t = this.#t.filter((e) => e !== t), t.destroy();
  }
  getSprites(t = { time: !0 }) {
    return this.#t.filter(
      (e) => e.visible && (t.time ? this.#s >= e.time.offset && this.#s <= e.time.offset + e.time.duration : !0)
    );
  }
  #s = 0;
  updateRenderTime(t) {
    this.#s = t;
    const e = this.activeSprite;
    e != null && (t < e.time.offset || t > e.time.offset + e.time.duration) && (this.activeSprite = null);
  }
  destroy() {
    this.#e.destroy(), this.#t.forEach((t) => t.destroy()), this.#t = [];
  }
}
const bE = `
<svg t="1756779136804" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1456" width="16" height="16">
<path d="M1022.793875 170.063604L852.730271 0 511.396938 341.333333 170.063604 0 0 170.063604l341.333333 341.333334L0 852.730271l170.063604 170.063604 341.333334-340.127208 341.333333 340.127208 170.063604-170.063604-340.127208-341.333333 340.127208-341.333334z" fill="#bfbfbf" p-id="1457"></path>
</svg>
`;
function vE(s, t, e) {
  const r = Ts(t), n = new ResizeObserver(() => {
    e.activeSprite != null && Qa(e.activeSprite, t, l, h);
  });
  n.observe(t);
  let a = () => {
  };
  const { rectEl: l, ctrlsEl: h } = wE(s);
  l.addEventListener("pointerdown", (f) => {
    if (Object.values(h).includes(f.target))
      return;
    const p = t.getBoundingClientRect(), m = (f.clientX - p.left) / r.w, g = (f.clientY - p.top) / r.h;
    e.activeSpriteByCoord(m, g);
  });
  const u = e.on(fs.ActiveSpriteChange, (f) => {
    if (a(), f == null) {
      l.style.display = "none";
      return;
    }
    Qa(f, t, l, h), a = f.on("propsChange", () => {
      Qa(f, t, l, h);
    });
  });
  return () => {
    n.disconnect(), u(), l.remove(), a();
  };
}
function wE(s) {
  const t = pr("div");
  t.classList.add("sprite-rect"), t.style.cssText = `
    position: absolute;
    z-index: 3;
    pointer-events: auto;
    border: 1px solid #eee;
    box-sizing: border-box;
    display: none;
    cursor: move;
  `;
  const e = Object.fromEntries(
    cn.map((r) => {
      const n = pr("div");
      return n.classList.add(`ctrl-key-${r}`), n.style.cssText = `
        display: none;
        position: absolute;
        border: 1px solid #3ee;
        border-radius: 50%;
        box-sizing: border-box;
        background-color: #fff;
        pointer-events: auto;
        cursor: ${r === "rotate" ? "crosshair" : "default"};
        user-select: none;
      `, [r, n];
    })
  );
  return Object.values(e).forEach((r) => t.appendChild(r)), s.appendChild(t), {
    rectEl: t,
    ctrlsEl: e
  };
}
function Qa(s, t, e, r) {
  if (s.interactable === "disabled") {
    e.style.display = "none";
    return;
  }
  e.style.display = "";
  const n = Ts(t), { x: a, y: l, w: h, h: u, angle: f } = s.rect;
  Object.assign(e.style, {
    left: `${a * n.w}px`,
    top: `${l * n.h}px`,
    width: `${h * n.w}px`,
    height: `${u * n.h}px`,
    transform: `rotate(${f}rad)`
  });
  const p = hg(t, s.rect);
  for (const m in r) {
    const g = m, x = r[g], o = p[g];
    if (o == null) {
      x.style.display = "none";
      continue;
    }
    const c = {
      width: `${o.w * n.w}px`,
      height: `${o.h * n.h}px`,
      transform: `translate(${o.x * n.w}px, ${o.y * n.h}px)`,
      left: "50%",
      top: "50%"
    };
    let d = { display: "none" };
    switch (x.innerHTML = "", s.interactable) {
      case "interactive":
        d = {
          display: "block",
          backgroundColor: "#fff",
          border: "1px solid #3ee"
        };
        break;
      case "selectable":
        g !== "rotate" && (d = {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "transparent",
          border: "none"
        }, x.innerHTML = bE);
        break;
    }
    Object.assign(x.style, c, d);
  }
}
function SE(s, t) {
  const e = (r) => {
    if (r.button !== 0 || r.target !== s) return;
    const n = Ts(s), { offsetX: a, offsetY: l } = r, h = a / n.w, u = l / n.h;
    t.activeSpriteByCoord(h, u);
  };
  return s.addEventListener("pointerdown", e), () => {
    s.removeEventListener("pointerdown", e);
  };
}
function TE(s, t, e) {
  let r = 0, n = 0, a = null;
  const l = UE(s, e), h = e.querySelector(".sprite-rect");
  if (!h) throw Error("sprite-rect DOM Node not found");
  const u = (x) => {
    const o = t.activeSprite;
    if (x.button !== 0 || o == null || o.interactable !== "interactive")
      return;
    const { clientX: c, clientY: d } = x;
    a = o.rect.clone(), l.magneticEffect(o.rect.x, o.rect.y, o.rect), r = c, n = d, window.addEventListener("pointermove", p), window.addEventListener("pointerup", m), x.stopPropagation();
  }, f = Ts(s), p = (x) => {
    const o = t.activeSprite;
    if (o == null || o.interactable !== "interactive" || a == null)
      return;
    const { clientX: c, clientY: d } = x;
    let _ = a.x + (c - r) / f.w, y = a.y + (d - n) / f.h;
    lg(
      o.rect,
      s,
      l.magneticEffect(_, y, o.rect)
    );
  }, m = () => {
    l.hide(), window.removeEventListener("pointermove", p), window.removeEventListener("pointerup", m);
  };
  h.addEventListener("pointerdown", u), s.addEventListener("pointerdown", u);
  const g = CE(s, h, t);
  return () => {
    l.destroy(), m(), h.removeEventListener("pointerdown", u), s.removeEventListener("pointerdown", u), g();
  };
}
function CE(s, t, e) {
  const r = Array.from(t.children), n = Ts(s);
  r.forEach((f, p) => {
    const m = cn[p];
    f.addEventListener("pointerdown", (g) => {
      const x = e.activeSprite;
      if (g.button !== 0 || x == null || x.interactable !== "interactive")
        return;
      const { clientX: o, clientY: c } = g;
      m === "rotate" ? ME(
        x.rect,
        BE(x.rect.center, n, s)
      ) : EE({
        sprRect: x.rect,
        ctrlKey: m,
        startX: o,
        startY: c,
        cvsRatio: n,
        cvsEl: s
      }), g.stopPropagation();
    });
  }), r[cn.indexOf("rotate")].style.cursor = "crosshair";
  const a = [
    "ns-resize",
    "nesw-resize",
    "ew-resize",
    "nwse-resize",
    "ns-resize",
    "nesw-resize",
    "ew-resize",
    "nwse-resize"
  ], l = {
    t: 0,
    rt: 1,
    r: 2,
    rb: 3,
    b: 4,
    lb: 5,
    l: 6,
    lt: 7
  };
  let h = () => {
  };
  const u = e.on(fs.ActiveSpriteChange, (f) => {
    if (h(), f == null) return;
    const p = Bg(function() {
      const { angle: m } = f.rect, g = m < 0 ? m + 2 * Math.PI : m;
      r.forEach((x, o) => {
        const c = cn[o];
        if (c === "rotate") return;
        const d = (l[c] + Math.floor((g + Math.PI / 8) / (Math.PI / 4))) % 8;
        x.style.cursor = a[d];
      });
    }, 300);
    h = f.on("propsChange", (m) => {
      m.rect?.angle != null && p();
    }), p();
  });
  return () => {
    h(), u();
  };
}
function EE({
  sprRect: s,
  startX: t,
  startY: e,
  ctrlKey: r,
  cvsRatio: n,
  cvsEl: a
}) {
  const l = s.clone(), h = (f) => {
    const { clientX: p, clientY: m } = f, g = (p - t) / n.w, x = (m - e) / n.h, o = r.length === 1 ? AE : PE, { x: c, y: d, w: _, h: y } = l, v = Math.atan2(y, _), { incW: b, incH: w, incS: S, rotateAngle: T } = o({
      deltaX: g,
      deltaY: x,
      angle: s.angle,
      ctrlKey: r,
      diagonalAngle: v
    }), E = 10;
    let C = _, M = y, P = l.fixedScaleCenter ? b * 2 : b, B = l.fixedScaleCenter ? w * 2 : w, U = S;
    const G = Math.sqrt(y ** 2 + _ ** 2), O = Math.sqrt((E * (y / _)) ** 2 + E ** 2);
    switch (r) {
      // 非等比例缩放时，变化的增量范围 由原宽高跟 minSize 的差值决定
      // 非等比例缩放时，根据ctrlKey的不同，固定宽高中的一个，另一个根据增量计算，并考虑最小值限定
      case "l":
        C = Math.max(_ + P, E), U = Math.min(S, _ - E);
        break;
      case "r":
        C = Math.max(_ + P, E), U = Math.max(S, E - _);
        break;
      case "b":
        M = Math.max(y + B, E), U = Math.min(S, y - E);
        break;
      case "t":
        M = Math.max(y + B, E), U = Math.max(S, E - y);
        break;
      // 等比例缩放时，变化（对角线长度）的增量范围由原对角线长度跟 minSize 对角线的差值决定
      // 等比例缩放时，某一边达到最小值时保持宽高比例不变
      case "lt":
      case "lb":
        C = Math.max(_ + P, E), M = C === E ? y / _ * C : y + B, U = Math.min(S, G - O);
        break;
      case "rt":
      case "rb":
        C = Math.max(_ + P, E), M = C === E ? y / _ * C : y + B, U = Math.max(S, O - G);
        break;
    }
    let R = c, I = d;
    if (l.fixedScaleCenter)
      R = c + _ / 2 - C / 2, I = d + y / 2 - M / 2;
    else {
      const st = U / 2 * Math.cos(T) + c + _ / 2, V = U / 2 * Math.sin(T) + d + y / 2;
      R = st - C / 2, I = V - M / 2;
    }
    lg(s, a, {
      x: R,
      y: I,
      w: C,
      h: M
    });
  }, u = () => {
    window.removeEventListener("pointermove", h), window.removeEventListener("pointerup", u);
  };
  window.addEventListener("pointermove", h), window.addEventListener("pointerup", u);
}
function AE({
  deltaX: s,
  deltaY: t,
  angle: e,
  ctrlKey: r
}) {
  let n = 0, a = 0, l = 0, h = e;
  return r === "l" || r === "r" ? (n = s * Math.cos(e) + t * Math.sin(e), a = n * (r === "l" ? -1 : 1)) : (r === "t" || r === "b") && (h = e - Math.PI / 2, n = s * Math.cos(h) + t * Math.sin(h), l = n * (r === "b" ? -1 : 1)), { incW: a, incH: l, incS: n, rotateAngle: h };
}
function PE({
  deltaX: s,
  deltaY: t,
  angle: e,
  ctrlKey: r,
  diagonalAngle: n
}) {
  const a = (r === "lt" || r === "rb" ? 1 : -1) * n + e, l = s * Math.cos(a) + t * Math.sin(a), h = r === "lt" || r === "lb" ? -1 : 1, u = l * Math.cos(n) * h, f = l * Math.sin(n) * h;
  return { incW: u, incH: f, incS: l, rotateAngle: a };
}
function ME(s, t) {
  const e = ({ clientX: n, clientY: a }) => {
    const l = n - t.x, h = a - t.y, u = Math.atan2(h, l) + Math.PI / 2;
    s.angle = u;
  }, r = () => {
    window.removeEventListener("pointermove", e), window.removeEventListener("pointerup", r);
  };
  window.addEventListener("pointermove", e), window.addEventListener("pointerup", r);
}
function BE(s, t, e) {
  const r = s.x * t.w, n = s.y * t.h, { left: a, top: l } = e.getBoundingClientRect();
  return {
    x: r + a,
    y: n + l
  };
}
function lg(s, t, e) {
  const r = { x: s.x, y: s.y, w: s.w, h: s.h, ...e }, n = t.width * 0.05, a = t.height * 0.05;
  r.x < -r.w + n ? r.x = -r.w + n : r.x > t.width - n && (r.x = t.width - n), r.y < -r.h + a ? r.y = -r.h + a : r.y > t.height - a && (r.y = t.height - a), s.x = r.x, s.y = r.y, s.w = r.w, s.h = r.h;
}
function UE(s, t) {
  const e = "display: none; position: absolute;", r = { w: 0, h: 0, x: 0, y: 0 }, n = {
    vertMiddle: {
      ...r,
      h: 100,
      x: 50,
      ref: { prop: "x", val: ({ w: u }) => (s.width - u) / 2 }
    },
    horMiddle: {
      ...r,
      w: 100,
      y: 50,
      ref: { prop: "y", val: ({ h: u }) => (s.height - u) / 2 }
    },
    top: {
      ...r,
      w: 100,
      ref: { prop: "y", val: () => 0 }
    },
    bottom: {
      ...r,
      w: 100,
      y: 100,
      ref: { prop: "y", val: ({ h: u }) => s.height - u }
    },
    left: {
      ...r,
      h: 100,
      ref: { prop: "x", val: () => 0 }
    },
    right: {
      ...r,
      h: 100,
      x: 100,
      ref: { prop: "x", val: ({ w: u }) => s.width - u }
    }
  }, a = pr("div");
  a.style.cssText = `
    position: absolute;
    z-index: 4;
    top: 0; left: 0;
    width: 100%; height: 100%;
    pointer-events: none;
    box-sizing: border-box;
  `;
  const l = Object.fromEntries(
    Object.entries(n).map(([u, { w: f, h: p, x: m, y: g }]) => {
      const x = pr("div");
      return x.style.cssText = `
        ${e}
        border-${f > 0 ? "top" : "left"}: 1px solid #3ee;
        top: ${g}%; left: ${m}%;
        ${m === 100 ? "margin-left: -1px" : ""};
        ${g === 100 ? "margin-top: -1px" : ""};
        width: ${f}%; height: ${p}%;
      `, a.appendChild(x), [u, x];
    })
  );
  t.appendChild(a);
  const h = 6 / (900 / s.width);
  return {
    magneticEffect(u, f, p) {
      const m = { x: u, y: f }, g = { x: h, y: h }, x = { x: "", y: "" };
      Object.values(l).forEach((o) => o.style.display = "none");
      for (const o in n) {
        const { prop: c, val: d } = n[o].ref, _ = d(p), y = Math.abs((c === "x" ? u : f) - _);
        y <= h && y < g[c] && (g[c] = y, m[c] = _, x[c] = o);
      }
      return x.x && (l[x.x].style.display = "block"), x.y && (l[x.y].style.display = "block"), m;
    },
    hide() {
      Object.values(l).forEach((u) => u.style.display = "none");
    },
    destroy() {
      a.remove();
    }
  };
}
const RE = {
  sampleRate: 48e3
};
function IE(s) {
  const t = pr("canvas");
  return t.style.cssText = `
    width: 100%;
    height: 100%;
    display: block;
    touch-action: none;
  `, t.width = s.width, t.height = s.height, t;
}
class $E {
  #t;
  #i;
  #e;
  #s = !1;
  #r = [];
  #n;
  #a = new Ui();
  on = this.#a.on;
  #o;
  /**
   * 预览帧生成中
   */
  #c = !1;
  /**
   * 创建 `AVCanvas` 类的实例。
   * @param attchEl - 要添加画布的元素。
   * @param opts - 画布的选项
   * @param opts.bgColor - 画布的背景颜色。
   * @param opts.width - 画布的宽度。
   * @param opts.height - 画布的高度。
   */
  constructor(t, e) {
    this.#o = e, this.#t = IE(e);
    const r = this.#t.getContext("2d", { alpha: !1 });
    if (r == null) throw Error("canvas context is null");
    this.#e = r;
    const n = pr("div");
    n.style.cssText = "width: 100%; height: 100%; position: relative;", n.appendChild(this.#t), t.appendChild(n), FE(this.#l).connect(this.#f), hg(this.#t, { x: 0, y: 0, w: 0, h: 0 }), this.#i = new xE(), this.#r.push(
      // 鼠标样式、控制 sprite 依赖 activeSprite，
      // activeSprite 需要在他们之前监听到 mousedown 事件 (代码顺序需要靠前)
      SE(this.#t, this.#i),
      vE(n, this.#t, this.#i),
      TE(this.#t, this.#i, n),
      this.#i.on(fs.AddSprite, (f) => {
        const { rect: p } = f;
        p.x === 0 && p.y === 0 && (p.x = (this.#t.width - p.w) / 2, p.y = (this.#t.height - p.h) / 2);
      }),
      Ui.forwardEvent(this.#i, this.#a, [
        fs.ActiveSpriteChange
      ])
    );
    let a = this.#h, l = performance.now(), h = 0;
    const u = 1e3 / 30;
    this.#n = sh(() => {
      (performance.now() - l) / (u * h) < 1 || this.#c || (h += 1, this.#e.fillStyle = e.bgColor, this.#e.fillRect(0, 0, this.#t.width, this.#t.height), this.#m(), a !== this.#h && (a = this.#h, this.#a.emit("timeupdate", Math.round(a))));
    }, u);
  }
  #h = 0;
  #d(t) {
    this.#h = t, this.#i.updateRenderTime(t), this.#g.updateTime(t);
  }
  #p() {
    if (this.#_.step !== 0) {
      this.#_.step = 0, this.#a.emit("paused"), this.#l.suspend();
      for (const t of this.#u)
        t.stop(), t.disconnect();
      this.#u.clear(), this.#g.reset();
    }
  }
  #l = new AudioContext();
  #f = this.#l.createMediaStreamDestination();
  #u = /* @__PURE__ */ new Set();
  #m() {
    const t = this.#e;
    let e = this.#h;
    const { start: r, end: n, step: a, audioPlayAt: l } = this.#_;
    e += a, a !== 0 && e >= r && e < n ? this.#d(e) : this.#p();
    const h = [];
    for (const u of this.#i.getSprites()) {
      t.save();
      const { audio: f } = u.render(t, e - u.time.offset);
      t.restore(), h.push(f);
    }
    if (t.resetTransform(), a !== 0) {
      const u = Math.max(this.#l.currentTime, l), f = kE(
        h,
        this.#l
      );
      let p = 0;
      for (const m of f)
        m.start(u), m.connect(this.#l.destination), m.connect(this.#f), this.#u.add(m), m.onended = () => {
          m.disconnect(), this.#u.delete(m);
        }, p = Math.max(p, m.buffer?.duration ?? 0);
      this.#_.audioPlayAt = u + p;
    }
  }
  #_ = {
    start: 0,
    end: 0,
    // paused state when step equal 0
    step: 0,
    // step: (1000 / 30) * 1000,
    audioPlayAt: 0
  };
  /**
   * 每 33ms 更新一次画布，绘制已添加的 Sprite
   * @param opts - 播放选项
   * @param opts.start - 开始播放的时间（单位：微秒）
   * @param [opts.end] - 结束播放的时间（单位：微秒）。如果未指定，则播放到最后一个 Sprite 的结束时间
   * @param [opts.playbackRate] - 播放速率。1 表示正常速度，2 表示两倍速度，0.5 表示半速等。如果未指定，则默认为 1
   * @throws 如果开始时间大于等于结束时间或小于 0，则抛出错误
   */
  play(t) {
    const e = this.#i.getSprites({ time: !1 }).map((n) => n.time.offset + n.time.duration), r = t.end ?? (e.length > 0 ? Math.max(...e) : 1 / 0);
    if (t.start >= r || t.start < 0)
      throw Error(
        `Invalid time parameter, ${JSON.stringify({ start: t.start, end: r })}`
      );
    this.#d(t.start), this.#g.reset(), this.#_.start = t.start, this.#_.end = r, this.#_.step = (t.playbackRate ?? 1) * (1e3 / 30) * 1e3, this.#l.resume(), this.#_.audioPlayAt = 0, this.#a.emit("playing"), z.info("AVCanvs play by:", this.#_);
  }
  #g = (() => {
    const t = /* @__PURE__ */ new Set();
    return {
      reset() {
        t.clear();
      },
      updateTime: Mg((e) => {
        const r = this.#i.getSprites({ time: !1 }).filter((n) => {
          const { offset: a } = n.time;
          return a > e && a - 1e6 <= e;
        });
        for (const n of r)
          t.has(n) || n.preFrame(0), t.add(n);
      }, 500)
    };
  })();
  /**
   * 暂停播放，画布内容不再更新
   */
  pause() {
    this.#p();
  }
  /**
   * 预览 `AVCanvas` 指定时间的图像帧
   */
  async previewFrame(t) {
    this.#p(), this.#d(t), this.#c = !0;
    try {
      await Promise.all(
        this.#i.getSprites({ time: !1 }).map((e) => t >= e.time.offset && t <= e.time.offset + e.time.duration ? e.preFrame(t - e.time.offset) : null)
      );
    } finally {
      this.#c = !1;
    }
  }
  /**
   * 获取当前帧的截图图像 返回的是一个base64
   */
  captureImage() {
    return this.#t.toDataURL();
  }
  get activeSprite() {
    return this.#i.activeSprite;
  }
  set activeSprite(t) {
    this.#i.activeSprite = t;
  }
  #y = /* @__PURE__ */ new WeakMap();
  /**
   * 添加 {@link VisibleSprite}
   * @param args {@link VisibleSprite}
   * @example
   * const sprite = new VisibleSprite(
   *   new ImgClip({
   *     type: 'image/gif',
   *     stream: (await fetch('https://xx.gif')).body!,
   *   }),
   * );
   */
  addSprite = async (t) => {
    this.#l.state === "suspended" && this.#l.resume().catch(z.error);
    const e = t.getClip();
    if (e instanceof xf && e.audioTrack != null) {
      const r = this.#l.createMediaStreamSource(
        new MediaStream([e.audioTrack])
      );
      r.connect(this.#f), this.#y.set(t, r);
    }
    await this.#i.addSprite(t);
  };
  /**
   * 删除 {@link VisibleSprite}
   * @param args
   * @returns
   * @example
   * const sprite = new VisibleSprite();
   * avCvs.removeSprite(sprite);
   */
  removeSprite = (t) => {
    this.#y.get(t)?.disconnect(), this.#i.removeSprite(t);
  };
  /**
   * 销毁实例
   */
  destroy() {
    this.#s || (this.#s = !0, this.#l.close(), this.#f.disconnect(), this.#a.destroy(), this.#n(), this.#t.parentElement?.remove(), this.#r.forEach((t) => t()), this.#u.clear(), this.#i.destroy());
  }
  /**
   * 合成所有素材的图像与音频，返回实时媒体流 `MediaStream`
   *
   * 可用于 WebRTC 推流，或由 {@link [AVRecorder](../../av-recorder/classes/AVRecorder.html)} 录制生成视频文件
   *
   * @see [直播录制](https://webav-tech.github.io/WebAV/demo/4_2-recorder-avcanvas)
   *
   */
  captureStream() {
    this.#l.state === "suspended" && this.#l.resume().catch(z.error);
    const t = new MediaStream(
      this.#t.captureStream().getTracks().concat(this.#f.stream.getTracks())
    );
    return z.info(
      "AVCanvas.captureStream, tracks:",
      t.getTracks().map((e) => e.kind)
    ), t;
  }
  /**
   * 创建一个视频合成器 {@link [Combinator](../../av-cliper/classes/Combinator.html)} 实例，用于将当前画布添加的 Sprite 导出为视频文件流
   *
   * @param opts - 创建 Combinator 的可选参数
   * @throws 如果没有添加素材，会抛出错误
   *
   * @example
   * avCvs.createCombinator().output() // => ReadableStream
   *
   * @see [视频剪辑](https://webav-tech.github.io/WebAV/demo/6_4-video-editor)
   */
  async createCombinator(t = {}) {
    z.info("AVCanvas.createCombinator, opts:", t);
    const e = new Tf({ ...this.#o, ...t }), r = this.#i.getSprites({ time: !1 });
    if (r.length === 0) throw Error("No sprite added");
    for (const n of r) {
      const a = new Ef(n.getClip());
      a.time = { ...n.time }, n.copyStateTo(a), await e.addSprite(a);
    }
    return e;
  }
}
function kE(s, t) {
  const e = [];
  if (s.length === 0) return e;
  for (const [r, n] of s) {
    if (r == null || r.length <= 0) continue;
    const a = t.createBuffer(
      2,
      r.length,
      RE.sampleRate
    );
    a.copyToChannel(r, 0), a.copyToChannel(n ?? r, 1);
    const l = t.createBufferSource();
    l.buffer = a, e.push(l);
  }
  return e;
}
function FE(s) {
  const t = s.createOscillator(), e = new Float32Array([0, 0]), r = new Float32Array([0, 0]), n = s.createPeriodicWave(e, r, {
    disableNormalization: !0
  });
  return t.setPeriodicWave(n), t.start(), t;
}
const YE = async ({
  licenseV2: s,
  name: t
}) => {
  if (!await hE(s, t))
    throw Error("license is invalid");
  return {
    setTransition: dE,
    createCanvasFilter: y0,
    cropClip: b0,
    WebVTTClip: vl,
    renderFancyText: tE,
    FancyCaptionClip: xl,
    FancyTextClip: bl
  };
};
L.add(Nb);
L.mixin(St, Hb);
L.add(Rp);
L.add(Ip);
L.add(l_);
L.mixin(St, mS);
L.add(h_);
L.add(Gm);
L.add(qh);
L.add(Hm);
L.add(Vm);
L.add($m);
L.add(eg);
L.add(tg);
L.add(qm);
L.add(Jm);
L.add(Zm);
L.add(Km);
L.add(jm);
L.add(u_);
L.add(c_);
const DE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" })), OE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" }));
export {
  $E as AVCanvas,
  WE as AVCliper,
  YE as AVProRegister
};
